var N4 = Object.defineProperty;
var L4 = (a, t, r) => t in a ? N4(a, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : a[t] = r;
var _e = (a, t, r) => (L4(a, typeof t != "symbol" ? t + "" : t, r), r);
var ki = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ro(a) {
  return a && a.__esModule && Object.prototype.hasOwnProperty.call(a, "default") ? a.default : a;
}
var Ev = { exports: {} };
(function(a, t) {
  var r = (() => {
    var o = typeof document < "u" && document.currentScript ? document.currentScript.src : void 0;
    return function(d) {
      d = d || {};
      var d = typeof d < "u" ? d : {}, u, l;
      d.ready = new Promise(function(N, q) {
        u = N, l = q;
      }), Object.getOwnPropertyDescriptor(d.ready, "_decode") || (Object.defineProperty(d.ready, "_decode", { configurable: !0, get: function() {
        yt("You are getting _decode on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js");
      } }), Object.defineProperty(d.ready, "_decode", { configurable: !0, set: function() {
        yt("You are setting _decode on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js");
      } })), Object.getOwnPropertyDescriptor(d.ready, "_main") || (Object.defineProperty(d.ready, "_main", { configurable: !0, get: function() {
        yt("You are getting _main on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js");
      } }), Object.defineProperty(d.ready, "_main", { configurable: !0, set: function() {
        yt("You are setting _main on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js");
      } })), Object.getOwnPropertyDescriptor(d.ready, "_new_convert") || (Object.defineProperty(d.ready, "_new_convert", { configurable: !0, get: function() {
        yt("You are getting _new_convert on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js");
      } }), Object.defineProperty(d.ready, "_new_convert", { configurable: !0, set: function() {
        yt("You are setting _new_convert on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js");
      } })), Object.getOwnPropertyDescriptor(d.ready, "_rust_eh_personality") || (Object.defineProperty(d.ready, "_rust_eh_personality", { configurable: !0, get: function() {
        yt("You are getting _rust_eh_personality on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js");
      } }), Object.defineProperty(d.ready, "_rust_eh_personality", { configurable: !0, set: function() {
        yt("You are setting _rust_eh_personality on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js");
      } })), Object.getOwnPropertyDescriptor(d.ready, "_fflush") || (Object.defineProperty(d.ready, "_fflush", { configurable: !0, get: function() {
        yt("You are getting _fflush on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js");
      } }), Object.defineProperty(d.ready, "_fflush", { configurable: !0, set: function() {
        yt("You are setting _fflush on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js");
      } })), Object.getOwnPropertyDescriptor(d.ready, "onRuntimeInitialized") || (Object.defineProperty(d.ready, "onRuntimeInitialized", { configurable: !0, get: function() {
        yt("You are getting onRuntimeInitialized on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js");
      } }), Object.defineProperty(d.ready, "onRuntimeInitialized", { configurable: !0, set: function() {
        yt("You are setting onRuntimeInitialized on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js");
      } }));
      var e = Object.assign({}, d), s = [], i = "./this.program", f = (N, q) => {
        throw q;
      }, h = !0, v = !1, p = !1, m = !1;
      if (d.ENVIRONMENT)
        throw new Error("Module.ENVIRONMENT has been deprecated. To force the environment, use the ENVIRONMENT compile-time option (for example, -sENVIRONMENT=web or -sENVIRONMENT=node)");
      var x = "";
      function g(N) {
        return d.locateFile ? d.locateFile(N, x) : x + N;
      }
      var S, y, b;
      {
        if (typeof document < "u" && document.currentScript && (x = document.currentScript.src), o && (x = o), x.indexOf("blob:") !== 0 ? x = x.substr(0, x.replace(/[?#].*/, "").lastIndexOf("/") + 1) : x = "", !(typeof window == "object" || typeof importScripts == "function"))
          throw new Error("not compiled for this environment (did you build to HTML and try to run it not on the web, or set ENVIRONMENT to something - like node - and run it someplace else - like on the web?)");
        S = (N) => {
          var q = new XMLHttpRequest();
          return q.open("GET", N, !1), q.send(null), q.responseText;
        }, y = (N, q, pt) => {
          var Ot = new XMLHttpRequest();
          Ot.open("GET", N, !0), Ot.responseType = "arraybuffer", Ot.onload = () => {
            if (Ot.status == 200 || Ot.status == 0 && Ot.response) {
              q(Ot.response);
              return;
            }
            pt();
          }, Ot.onerror = pt, Ot.send(null);
        };
      }
      var n = d.print || console.log.bind(console), w = d.printErr || console.warn.bind(console);
      Object.assign(d, e), e = null, Gr(), d.arguments && (s = d.arguments), A("arguments", "arguments_"), d.thisProgram && (i = d.thisProgram), A("thisProgram", "thisProgram"), d.quit && (f = d.quit), A("quit", "quit_"), Q(typeof d.memoryInitializerPrefixURL > "u", "Module.memoryInitializerPrefixURL option was removed, use Module.locateFile instead"), Q(typeof d.pthreadMainPrefixURL > "u", "Module.pthreadMainPrefixURL option was removed, use Module.locateFile instead"), Q(typeof d.cdInitializerPrefixURL > "u", "Module.cdInitializerPrefixURL option was removed, use Module.locateFile instead"), Q(typeof d.filePackagePrefixURL > "u", "Module.filePackagePrefixURL option was removed, use Module.locateFile instead"), Q(typeof d.read > "u", "Module.read option was removed (modify read_ in JS)"), Q(typeof d.readAsync > "u", "Module.readAsync option was removed (modify readAsync in JS)"), Q(typeof d.readBinary > "u", "Module.readBinary option was removed (modify readBinary in JS)"), Q(typeof d.setWindowTitle > "u", "Module.setWindowTitle option was removed (modify setWindowTitle in JS)"), Q(typeof d.TOTAL_MEMORY > "u", "Module.TOTAL_MEMORY has been renamed Module.INITIAL_MEMORY"), A("read", "read_"), A("readAsync", "readAsync"), A("readBinary", "readBinary"), A("setWindowTitle", "setWindowTitle"), Q(!v, "worker environment detected but not enabled at build time.  Add 'worker' to `-sENVIRONMENT` to enable."), Q(!p, "node environment detected but not enabled at build time.  Add 'node' to `-sENVIRONMENT` to enable."), Q(!m, "shell environment detected but not enabled at build time.  Add 'shell' to `-sENVIRONMENT` to enable.");
      function E(N) {
        E.shown || (E.shown = {}), E.shown[N] || (E.shown[N] = 1, w(N));
      }
      function A(N, q) {
        Object.getOwnPropertyDescriptor(d, N) || Object.defineProperty(d, N, { configurable: !0, get: function() {
          yt("Module." + N + " has been replaced with plain " + q + " (the initial value can be provided on Module, but after startup the value is only looked for on a local variable of that name)");
        } });
      }
      function O(N) {
        Object.getOwnPropertyDescriptor(d, N) && yt("`Module." + N + "` was supplied but `" + N + "` not included in INCOMING_MODULE_JS_API");
      }
      function C(N, q) {
        var pt = "'" + N + "' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)";
        return q && (pt += ". Alternatively, forcing filesystem support (-sFORCE_FILESYSTEM) can export this for you"), pt;
      }
      function T(N, q) {
        Object.getOwnPropertyDescriptor(d, N) || Object.defineProperty(d, N, { configurable: !0, get: function() {
          yt(C(N, q));
        } });
      }
      function P(N, q) {
        Object.getOwnPropertyDescriptor(d, N) || (d[N] = () => yt(C(N, q)));
      }
      var I = 0, F = (N) => {
        I = N;
      }, B = () => I, M;
      d.wasmBinary && (M = d.wasmBinary), A("wasmBinary", "wasmBinary");
      var z = d.noExitRuntime || !0;
      A("noExitRuntime", "noExitRuntime"), typeof WebAssembly != "object" && yt("no native wasm support detected");
      var L, J = !1, ft;
      function Q(N, q) {
        N || yt("Assertion failed" + (q ? ": " + q : ""));
      }
      function xt(N) {
        var q = d["_" + N];
        return Q(q, "Cannot call unknown function " + N + ", make sure it is exported"), q;
      }
      function St(N, q, pt, Ot, Wt) {
        var le = { string: function(ur) {
          var rn = 0;
          if (ur != null && ur !== 0) {
            var Pn = (ur.length << 2) + 1;
            rn = pn(Pn), X(ur, rn, Pn);
          }
          return rn;
        }, array: function(ur) {
          var rn = pn(ur.length);
          return rt(ur, rn), rn;
        } };
        function ce(ur) {
          return q === "string" ? bt(ur) : q === "boolean" ? !!ur : ur;
        }
        var be = xt(N), Ge = [], er = 0;
        if (Q(q !== "array", 'Return type should not be "array".'), Ot)
          for (var br = 0; br < Ot.length; br++) {
            var Nr = le[pt[br]];
            Nr ? (er === 0 && (er = $r()), Ge[br] = Nr(Ot[br])) : Ge[br] = Ot[br];
          }
        var hr = be.apply(null, Ge);
        function ir(ur) {
          return er !== 0 && ln(er), ce(ur);
        }
        return hr = ir(hr), hr;
      }
      function Pt(N, q, pt, Ot) {
        return function() {
          return St(N, q, pt, arguments);
        };
      }
      var Gt = typeof TextDecoder < "u" ? new TextDecoder("utf8") : void 0;
      function Rt(N, q, pt) {
        for (var Ot = q + pt, Wt = q; N[Wt] && !(Wt >= Ot); )
          ++Wt;
        if (Wt - q > 16 && N.buffer && Gt)
          return Gt.decode(N.subarray(q, Wt));
        for (var le = ""; q < Wt; ) {
          var ce = N[q++];
          if (!(ce & 128)) {
            le += String.fromCharCode(ce);
            continue;
          }
          var be = N[q++] & 63;
          if ((ce & 224) == 192) {
            le += String.fromCharCode((ce & 31) << 6 | be);
            continue;
          }
          var Ge = N[q++] & 63;
          if ((ce & 240) == 224 ? ce = (ce & 15) << 12 | be << 6 | Ge : ((ce & 248) != 240 && E("Invalid UTF-8 leading byte 0x" + ce.toString(16) + " encountered when deserializing a UTF-8 string in wasm memory to a JS string!"), ce = (ce & 7) << 18 | be << 12 | Ge << 6 | N[q++] & 63), ce < 65536)
            le += String.fromCharCode(ce);
          else {
            var er = ce - 65536;
            le += String.fromCharCode(55296 | er >> 10, 56320 | er & 1023);
          }
        }
        return le;
      }
      function bt(N, q) {
        return N ? Rt(G, N, q) : "";
      }
      function Dt(N, q, pt, Ot) {
        if (!(Ot > 0))
          return 0;
        for (var Wt = pt, le = pt + Ot - 1, ce = 0; ce < N.length; ++ce) {
          var be = N.charCodeAt(ce);
          if (be >= 55296 && be <= 57343) {
            var Ge = N.charCodeAt(++ce);
            be = 65536 + ((be & 1023) << 10) | Ge & 1023;
          }
          if (be <= 127) {
            if (pt >= le)
              break;
            q[pt++] = be;
          } else if (be <= 2047) {
            if (pt + 1 >= le)
              break;
            q[pt++] = 192 | be >> 6, q[pt++] = 128 | be & 63;
          } else if (be <= 65535) {
            if (pt + 2 >= le)
              break;
            q[pt++] = 224 | be >> 12, q[pt++] = 128 | be >> 6 & 63, q[pt++] = 128 | be & 63;
          } else {
            if (pt + 3 >= le)
              break;
            be > 1114111 && E("Invalid Unicode code point 0x" + be.toString(16) + " encountered when serializing a JS string to a UTF-8 string in wasm memory! (Valid unicode code points should be in range 0-0x10FFFF)."), q[pt++] = 240 | be >> 18, q[pt++] = 128 | be >> 12 & 63, q[pt++] = 128 | be >> 6 & 63, q[pt++] = 128 | be & 63;
          }
        }
        return q[pt] = 0, pt - Wt;
      }
      function X(N, q, pt) {
        return Q(typeof pt == "number", "stringToUTF8(str, outPtr, maxBytesToWrite) is missing the third parameter that specifies the length of the output buffer!"), Dt(N, G, q, pt);
      }
      function gt(N) {
        for (var q = 0, pt = 0; pt < N.length; ++pt) {
          var Ot = N.charCodeAt(pt);
          Ot >= 55296 && Ot <= 57343 && (Ot = 65536 + ((Ot & 1023) << 10) | N.charCodeAt(++pt) & 1023), Ot <= 127 ? ++q : Ot <= 2047 ? q += 2 : Ot <= 65535 ? q += 3 : q += 4;
        }
        return q;
      }
      typeof TextDecoder < "u" && new TextDecoder("utf-16le");
      function st(N) {
        var q = gt(N) + 1, pt = pn(q);
        return Dt(N, zt, pt, q), pt;
      }
      function rt(N, q) {
        Q(N.length >= 0, "writeArrayToMemory array must have a length (should be an array or typed array)"), zt.set(N, q);
      }
      function wt(N, q, pt) {
        for (var Ot = 0; Ot < N.length; ++Ot)
          Q(N.charCodeAt(Ot) === (N.charCodeAt(Ot) & 255)), zt[q++ >> 0] = N.charCodeAt(Ot);
        pt || (zt[q >> 0] = 0);
      }
      var Ft, zt, G, D, Z;
      function et(N) {
        Ft = N, d.HEAP8 = zt = new Int8Array(N), d.HEAP16 = new Int16Array(N), d.HEAP32 = D = new Int32Array(N), d.HEAPU8 = G = new Uint8Array(N), d.HEAPU16 = new Uint16Array(N), d.HEAPU32 = Z = new Uint32Array(N), d.HEAPF32 = new Float32Array(N), d.HEAPF64 = new Float64Array(N);
      }
      var vt = 5242880;
      d.TOTAL_STACK && Q(vt === d.TOTAL_STACK, "the stack size can no longer be determined at runtime");
      var lt = d.INITIAL_MEMORY || 16777216;
      A("INITIAL_MEMORY", "INITIAL_MEMORY"), Q(lt >= vt, "INITIAL_MEMORY should be larger than TOTAL_STACK, was " + lt + "! (TOTAL_STACK=" + vt + ")"), Q(typeof Int32Array < "u" && typeof Float64Array < "u" && Int32Array.prototype.subarray != null && Int32Array.prototype.set != null, "JS engine does not provide full typed array support"), Q(!d.wasmMemory, "Use of `wasmMemory` detected.  Use -sIMPORTED_MEMORY to define wasmMemory externally"), Q(lt == 16777216, "Detected runtime INITIAL_MEMORY setting.  Use -sIMPORTED_MEMORY to define wasmMemory dynamically");
      var dt;
      function kt() {
        var N = Sn();
        Q((N & 3) == 0), D[N >> 2] = 34821223, D[N + 4 >> 2] = 2310721022, Z[0] = 1668509029;
      }
      function jt() {
        if (!J) {
          var N = Sn(), q = Z[N >> 2], pt = Z[N + 4 >> 2];
          (q != 34821223 || pt != 2310721022) && yt("Stack overflow! Stack cookie has been overwritten at 0x" + N.toString(16) + ", expected hex dwords 0x89BACDFE and 0x2135467, but received 0x" + pt.toString(16) + " 0x" + q.toString(16)), Z[0] !== 1668509029 && yt("Runtime error: The application has corrupted its heap memory area (address zero)!");
        }
      }
      (function() {
        var N = new Int16Array(1), q = new Int8Array(N.buffer);
        if (N[0] = 25459, q[0] !== 115 || q[1] !== 99)
          throw "Runtime error: expected the system to be little-endian! (Run with -sSUPPORT_BIG_ENDIAN to bypass)";
      })();
      var me = [], se = [], Bt = [], ge = [], Re = !1;
      function Te() {
        return z;
      }
      function xe() {
        if (d.preRun)
          for (typeof d.preRun == "function" && (d.preRun = [d.preRun]); d.preRun.length; )
            ve(d.preRun.shift());
        ke(me);
      }
      function Fe() {
        Q(!Re), Re = !0, jt(), !d.noFSInit && !Ct.init.initialized && Ct.init(), Ct.ignorePermissions = !1, ke(se);
      }
      function Zt() {
        jt(), ke(Bt);
      }
      function qt() {
        if (jt(), d.postRun)
          for (typeof d.postRun == "function" && (d.postRun = [d.postRun]); d.postRun.length; )
            Pe(d.postRun.shift());
        ke(ge);
      }
      function ve(N) {
        me.unshift(N);
      }
      function Se(N) {
        se.unshift(N);
      }
      function Pe(N) {
        ge.unshift(N);
      }
      Q(Math.imul, "This browser does not support Math.imul(), build with LEGACY_VM_SUPPORT or POLYFILL_OLD_MATH_FUNCTIONS to add in a polyfill"), Q(Math.fround, "This browser does not support Math.fround(), build with LEGACY_VM_SUPPORT or POLYFILL_OLD_MATH_FUNCTIONS to add in a polyfill"), Q(Math.clz32, "This browser does not support Math.clz32(), build with LEGACY_VM_SUPPORT or POLYFILL_OLD_MATH_FUNCTIONS to add in a polyfill"), Q(Math.trunc, "This browser does not support Math.trunc(), build with LEGACY_VM_SUPPORT or POLYFILL_OLD_MATH_FUNCTIONS to add in a polyfill");
      var Be = 0, De = null, It = null, he = {};
      function nt(N) {
        for (var q = N; ; ) {
          if (!he[N])
            return N;
          N = q + Math.random();
        }
      }
      function j(N) {
        Be++, d.monitorRunDependencies && d.monitorRunDependencies(Be), N ? (Q(!he[N]), he[N] = 1, De === null && typeof setInterval < "u" && (De = setInterval(function() {
          if (J) {
            clearInterval(De), De = null;
            return;
          }
          var q = !1;
          for (var pt in he)
            q || (q = !0, w("still waiting on run dependencies:")), w("dependency: " + pt);
          q && w("(end of list)");
        }, 1e4))) : w("warning: run dependency added without ID");
      }
      function V(N) {
        if (Be--, d.monitorRunDependencies && d.monitorRunDependencies(Be), N ? (Q(he[N]), delete he[N]) : w("warning: run dependency removed without ID"), Be == 0 && (De !== null && (clearInterval(De), De = null), It)) {
          var q = It;
          It = null, q();
        }
      }
      function yt(N) {
        d.onAbort && d.onAbort(N), N = "Aborted(" + N + ")", w(N), J = !0, ft = 1;
        var q = new WebAssembly.RuntimeError(N);
        throw l(q), q;
      }
      var it = "data:application/octet-stream;base64,";
      function _t(N) {
        return N.startsWith(it);
      }
      function ne(N) {
        return N.startsWith("file://");
      }
      function Y(N, q) {
        return function() {
          var pt = N, Ot = q;
          return q || (Ot = d.asm), Q(Re, "native function `" + pt + "` called before runtime initialization"), Ot[N] || Q(Ot[N], "exported native function `" + pt + "` not found"), Ot[N].apply(null, arguments);
        };
      }
      var Jt;
      Jt = "mozjpeg_wasm.wasm", _t(Jt) || (Jt = g(Jt));
      function ie(N) {
        try {
          if (N == Jt && M)
            return new Uint8Array(M);
          if (!b)
            throw "both async and sync fetching of the wasm failed";
        } catch (q) {
          yt(q);
        }
      }
      function Tt() {
        return !M && h && typeof fetch == "function" ? fetch(Jt, { credentials: "same-origin" }).then(function(N) {
          if (!N.ok)
            throw "failed to load wasm binary file at '" + Jt + "'";
          return N.arrayBuffer();
        }).catch(function() {
          return ie(Jt);
        }) : Promise.resolve().then(function() {
          return ie(Jt);
        });
      }
      function Xt() {
        var N = { env: tn, wasi_snapshot_preview1: tn };
        function q(be, Ge) {
          var er = be.exports;
          d.asm = er, L = d.asm.memory, Q(L, "memory not found in wasm exports"), et(L.buffer), dt = d.asm.__indirect_function_table, Q(dt, "table not found in wasm exports"), Se(d.asm.__wasm_call_ctors), V("wasm-instantiate");
        }
        j("wasm-instantiate");
        var pt = d;
        function Ot(be) {
          Q(d === pt, "the Module object should not be replaced during async compilation - perhaps the order of HTML elements is wrong?"), pt = null, q(be.instance);
        }
        function Wt(be) {
          return Tt().then(function(Ge) {
            return WebAssembly.instantiate(Ge, N);
          }).then(function(Ge) {
            return Ge;
          }).then(be, function(Ge) {
            w("failed to asynchronously prepare wasm: " + Ge), ne(Jt) && w("warning: Loading from a file URI (" + Jt + ") is not supported in most browsers. See https://emscripten.org/docs/getting_started/FAQ.html#how-do-i-run-a-local-webserver-for-testing-why-does-my-program-stall-in-downloading-or-preparing"), yt(Ge);
          });
        }
        function le() {
          return !M && typeof WebAssembly.instantiateStreaming == "function" && !_t(Jt) && typeof fetch == "function" ? fetch(Jt, { credentials: "same-origin" }).then(function(be) {
            var Ge = WebAssembly.instantiateStreaming(be, N);
            return Ge.then(Ot, function(er) {
              return w("wasm streaming compile failed: " + er), w("falling back to ArrayBuffer instantiation"), Wt(Ot);
            });
          }) : Wt(Ot);
        }
        if (d.instantiateWasm)
          try {
            var ce = d.instantiateWasm(N, q);
            return ce;
          } catch (be) {
            return w("Module.instantiateWasm callback failed with error: " + be), !1;
          }
        return le().catch(l), {};
      }
      var ue, Ve;
      function ke(N) {
        for (; N.length > 0; )
          N.shift()(d);
      }
      function Xe(N) {
        return E("warning: build with -sDEMANGLE_SUPPORT to link in libcxxabi demangling"), N;
      }
      function je(N) {
        var q = /\b_Z[\w\d_]+/g;
        return N.replace(q, function(pt) {
          var Ot = Xe(pt);
          return pt === Ot ? pt : Ot + " [" + pt + "]";
        });
      }
      function Wr(N) {
        return dt.get(N);
      }
      function vr(N) {
        if (N instanceof ye || N == "unwind")
          return ft;
        f(1, N);
      }
      function nr(N) {
        return Qr(N + 24) + 24;
      }
      var Fr = [];
      function Jr(N) {
        N.add_ref();
      }
      function dn(N) {
        var q = new Yn(N);
        return q.get_caught() || q.set_caught(!0), q.set_rethrown(!1), Fr.push(q), Jr(q), q.get_exception_ptr();
      }
      var kn = 0;
      function Yn(N) {
        this.excPtr = N, this.ptr = N - 24, this.set_type = function(q) {
          Z[this.ptr + 4 >> 2] = q;
        }, this.get_type = function() {
          return Z[this.ptr + 4 >> 2];
        }, this.set_destructor = function(q) {
          Z[this.ptr + 8 >> 2] = q;
        }, this.get_destructor = function() {
          return Z[this.ptr + 8 >> 2];
        }, this.set_refcount = function(q) {
          D[this.ptr >> 2] = q;
        }, this.set_caught = function(q) {
          q = q ? 1 : 0, zt[this.ptr + 12 >> 0] = q;
        }, this.get_caught = function() {
          return zt[this.ptr + 12 >> 0] != 0;
        }, this.set_rethrown = function(q) {
          q = q ? 1 : 0, zt[this.ptr + 13 >> 0] = q;
        }, this.get_rethrown = function() {
          return zt[this.ptr + 13 >> 0] != 0;
        }, this.init = function(q, pt) {
          this.set_adjusted_ptr(0), this.set_type(q), this.set_destructor(pt), this.set_refcount(0), this.set_caught(!1), this.set_rethrown(!1);
        }, this.add_ref = function() {
          var q = D[this.ptr >> 2];
          D[this.ptr >> 2] = q + 1;
        }, this.release_ref = function() {
          var q = D[this.ptr >> 2];
          return D[this.ptr >> 2] = q - 1, Q(q > 0), q === 1;
        }, this.set_adjusted_ptr = function(q) {
          Z[this.ptr + 16 >> 2] = q;
        }, this.get_adjusted_ptr = function() {
          return Z[this.ptr + 16 >> 2];
        }, this.get_exception_ptr = function() {
          var q = Rn(this.get_type());
          if (q)
            return Z[this.excPtr >> 2];
          var pt = this.get_adjusted_ptr();
          return pt !== 0 ? pt : this.excPtr;
        };
      }
      function yr(N) {
        try {
          return _r(new Yn(N).ptr);
        } catch (q) {
          w("exception during __cxa_free_exception: " + q);
        }
      }
      function Tn(N) {
        if (N.release_ref() && !N.get_rethrown()) {
          var q = N.get_destructor();
          q && Wr(q)(N.excPtr), yr(N.excPtr);
        }
      }
      function qr() {
        Rr(0), Q(Fr.length > 0);
        var N = Fr.pop();
        Tn(N), kn = 0;
      }
      function gn(N) {
        throw kn || (kn = N), N;
      }
      function un() {
        var N = kn;
        if (!N)
          return F(0), 0;
        var q = new Yn(N);
        q.set_adjusted_ptr(N);
        var pt = q.get_type();
        if (!pt)
          return F(0), N;
        for (var Ot = Array.prototype.slice.call(arguments), Wt = 0; Wt < Ot.length; Wt++) {
          var le = Ot[Wt];
          if (le === 0 || le === pt)
            break;
          var ce = q.ptr + 16;
          if (Nn(le, pt, ce))
            return F(le), N;
        }
        return F(pt), N;
      }
      function wi() {
        var N = kn;
        if (!N)
          return F(0), 0;
        var q = new Yn(N);
        q.set_adjusted_ptr(N);
        var pt = q.get_type();
        if (!pt)
          return F(0), N;
        for (var Ot = Array.prototype.slice.call(arguments), Wt = 0; Wt < Ot.length; Wt++) {
          var le = Ot[Wt];
          if (le === 0 || le === pt)
            break;
          var ce = q.ptr + 16;
          if (Nn(le, pt, ce))
            return F(le), N;
        }
        return F(pt), N;
      }
      function Si(N, q, pt) {
        var Ot = new Yn(N);
        throw Ot.init(q, pt), kn = N, N;
      }
      var Me = { isAbs: (N) => N.charAt(0) === "/", splitPath: (N) => {
        var q = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
        return q.exec(N).slice(1);
      }, normalizeArray: (N, q) => {
        for (var pt = 0, Ot = N.length - 1; Ot >= 0; Ot--) {
          var Wt = N[Ot];
          Wt === "." ? N.splice(Ot, 1) : Wt === ".." ? (N.splice(Ot, 1), pt++) : pt && (N.splice(Ot, 1), pt--);
        }
        if (q)
          for (; pt; pt--)
            N.unshift("..");
        return N;
      }, normalize: (N) => {
        var q = Me.isAbs(N), pt = N.substr(-1) === "/";
        return N = Me.normalizeArray(N.split("/").filter((Ot) => !!Ot), !q).join("/"), !N && !q && (N = "."), N && pt && (N += "/"), (q ? "/" : "") + N;
      }, dirname: (N) => {
        var q = Me.splitPath(N), pt = q[0], Ot = q[1];
        return !pt && !Ot ? "." : (Ot && (Ot = Ot.substr(0, Ot.length - 1)), pt + Ot);
      }, basename: (N) => {
        if (N === "/")
          return "/";
        N = Me.normalize(N), N = N.replace(/\/$/, "");
        var q = N.lastIndexOf("/");
        return q === -1 ? N : N.substr(q + 1);
      }, join: function() {
        var N = Array.prototype.slice.call(arguments, 0);
        return Me.normalize(N.join("/"));
      }, join2: (N, q) => Me.normalize(N + "/" + q) };
      function Ze() {
        if (typeof crypto == "object" && typeof crypto.getRandomValues == "function") {
          var N = new Uint8Array(1);
          return function() {
            return crypto.getRandomValues(N), N[0];
          };
        } else
          return function() {
            yt("no cryptographic support found for randomDevice. consider polyfilling it if you want to use something insecure like Math.random(), e.g. put this in a --pre-js: var crypto = { getRandomValues: function(array) { for (var i = 0; i < array.length; i++) array[i] = (Math.random()*256)|0 } };");
          };
      }
      var qe = { resolve: function() {
        for (var N = "", q = !1, pt = arguments.length - 1; pt >= -1 && !q; pt--) {
          var Ot = pt >= 0 ? arguments[pt] : Ct.cwd();
          if (typeof Ot != "string")
            throw new TypeError("Arguments to path.resolve must be strings");
          if (!Ot)
            return "";
          N = Ot + "/" + N, q = Me.isAbs(Ot);
        }
        return N = Me.normalizeArray(N.split("/").filter((Wt) => !!Wt), !q).join("/"), (q ? "/" : "") + N || ".";
      }, relative: (N, q) => {
        N = qe.resolve(N).substr(1), q = qe.resolve(q).substr(1);
        function pt(er) {
          for (var br = 0; br < er.length && er[br] === ""; br++)
            ;
          for (var Nr = er.length - 1; Nr >= 0 && er[Nr] === ""; Nr--)
            ;
          return br > Nr ? [] : er.slice(br, Nr - br + 1);
        }
        for (var Ot = pt(N.split("/")), Wt = pt(q.split("/")), le = Math.min(Ot.length, Wt.length), ce = le, be = 0; be < le; be++)
          if (Ot[be] !== Wt[be]) {
            ce = be;
            break;
          }
        for (var Ge = [], be = ce; be < Ot.length; be++)
          Ge.push("..");
        return Ge = Ge.concat(Wt.slice(ce)), Ge.join("/");
      } }, gr = { ttys: [], init: function() {
      }, shutdown: function() {
      }, register: function(N, q) {
        gr.ttys[N] = { input: [], output: [], ops: q }, Ct.registerDevice(N, gr.stream_ops);
      }, stream_ops: { open: function(N) {
        var q = gr.ttys[N.node.rdev];
        if (!q)
          throw new Ct.ErrnoError(43);
        N.tty = q, N.seekable = !1;
      }, close: function(N) {
        N.tty.ops.flush(N.tty);
      }, flush: function(N) {
        N.tty.ops.flush(N.tty);
      }, read: function(N, q, pt, Ot, Wt) {
        if (!N.tty || !N.tty.ops.get_char)
          throw new Ct.ErrnoError(60);
        for (var le = 0, ce = 0; ce < Ot; ce++) {
          var be;
          try {
            be = N.tty.ops.get_char(N.tty);
          } catch {
            throw new Ct.ErrnoError(29);
          }
          if (be === void 0 && le === 0)
            throw new Ct.ErrnoError(6);
          if (be == null)
            break;
          le++, q[pt + ce] = be;
        }
        return le && (N.node.timestamp = Date.now()), le;
      }, write: function(N, q, pt, Ot, Wt) {
        if (!N.tty || !N.tty.ops.put_char)
          throw new Ct.ErrnoError(60);
        try {
          for (var le = 0; le < Ot; le++)
            N.tty.ops.put_char(N.tty, q[pt + le]);
        } catch {
          throw new Ct.ErrnoError(29);
        }
        return Ot && (N.node.timestamp = Date.now()), le;
      } }, default_tty_ops: { get_char: function(N) {
        if (!N.input.length) {
          var q = null;
          if (typeof window < "u" && typeof window.prompt == "function" ? (q = window.prompt("Input: "), q !== null && (q += `
`)) : typeof readline == "function" && (q = readline(), q !== null && (q += `
`)), !q)
            return null;
          N.input = xr(q, !0);
        }
        return N.input.shift();
      }, put_char: function(N, q) {
        q === null || q === 10 ? (n(Rt(N.output, 0)), N.output = []) : q != 0 && N.output.push(q);
      }, flush: function(N) {
        N.output && N.output.length > 0 && (n(Rt(N.output, 0)), N.output = []);
      } }, default_tty1_ops: { put_char: function(N, q) {
        q === null || q === 10 ? (w(Rt(N.output, 0)), N.output = []) : q != 0 && N.output.push(q);
      }, flush: function(N) {
        N.output && N.output.length > 0 && (w(Rt(N.output, 0)), N.output = []);
      } } };
      function Wn(N) {
        yt("internal error: mmapAlloc called but `emscripten_builtin_memalign` native symbol not exported");
      }
      var sr = { ops_table: null, mount: function(N) {
        return sr.createNode(null, "/", 16895, 0);
      }, createNode: function(N, q, pt, Ot) {
        if (Ct.isBlkdev(pt) || Ct.isFIFO(pt))
          throw new Ct.ErrnoError(63);
        sr.ops_table || (sr.ops_table = { dir: { node: { getattr: sr.node_ops.getattr, setattr: sr.node_ops.setattr, lookup: sr.node_ops.lookup, mknod: sr.node_ops.mknod, rename: sr.node_ops.rename, unlink: sr.node_ops.unlink, rmdir: sr.node_ops.rmdir, readdir: sr.node_ops.readdir, symlink: sr.node_ops.symlink }, stream: { llseek: sr.stream_ops.llseek } }, file: { node: { getattr: sr.node_ops.getattr, setattr: sr.node_ops.setattr }, stream: { llseek: sr.stream_ops.llseek, read: sr.stream_ops.read, write: sr.stream_ops.write, allocate: sr.stream_ops.allocate, mmap: sr.stream_ops.mmap, msync: sr.stream_ops.msync } }, link: { node: { getattr: sr.node_ops.getattr, setattr: sr.node_ops.setattr, readlink: sr.node_ops.readlink }, stream: {} }, chrdev: { node: { getattr: sr.node_ops.getattr, setattr: sr.node_ops.setattr }, stream: Ct.chrdev_stream_ops } });
        var Wt = Ct.createNode(N, q, pt, Ot);
        return Ct.isDir(Wt.mode) ? (Wt.node_ops = sr.ops_table.dir.node, Wt.stream_ops = sr.ops_table.dir.stream, Wt.contents = {}) : Ct.isFile(Wt.mode) ? (Wt.node_ops = sr.ops_table.file.node, Wt.stream_ops = sr.ops_table.file.stream, Wt.usedBytes = 0, Wt.contents = null) : Ct.isLink(Wt.mode) ? (Wt.node_ops = sr.ops_table.link.node, Wt.stream_ops = sr.ops_table.link.stream) : Ct.isChrdev(Wt.mode) && (Wt.node_ops = sr.ops_table.chrdev.node, Wt.stream_ops = sr.ops_table.chrdev.stream), Wt.timestamp = Date.now(), N && (N.contents[q] = Wt, N.timestamp = Wt.timestamp), Wt;
      }, getFileDataAsTypedArray: function(N) {
        return N.contents ? N.contents.subarray ? N.contents.subarray(0, N.usedBytes) : new Uint8Array(N.contents) : new Uint8Array(0);
      }, expandFileStorage: function(N, q) {
        var pt = N.contents ? N.contents.length : 0;
        if (!(pt >= q)) {
          var Ot = 1024 * 1024;
          q = Math.max(q, pt * (pt < Ot ? 2 : 1.125) >>> 0), pt != 0 && (q = Math.max(q, 256));
          var Wt = N.contents;
          N.contents = new Uint8Array(q), N.usedBytes > 0 && N.contents.set(Wt.subarray(0, N.usedBytes), 0);
        }
      }, resizeFileStorage: function(N, q) {
        if (N.usedBytes != q)
          if (q == 0)
            N.contents = null, N.usedBytes = 0;
          else {
            var pt = N.contents;
            N.contents = new Uint8Array(q), pt && N.contents.set(pt.subarray(0, Math.min(q, N.usedBytes))), N.usedBytes = q;
          }
      }, node_ops: { getattr: function(N) {
        var q = {};
        return q.dev = Ct.isChrdev(N.mode) ? N.id : 1, q.ino = N.id, q.mode = N.mode, q.nlink = 1, q.uid = 0, q.gid = 0, q.rdev = N.rdev, Ct.isDir(N.mode) ? q.size = 4096 : Ct.isFile(N.mode) ? q.size = N.usedBytes : Ct.isLink(N.mode) ? q.size = N.link.length : q.size = 0, q.atime = new Date(N.timestamp), q.mtime = new Date(N.timestamp), q.ctime = new Date(N.timestamp), q.blksize = 4096, q.blocks = Math.ceil(q.size / q.blksize), q;
      }, setattr: function(N, q) {
        q.mode !== void 0 && (N.mode = q.mode), q.timestamp !== void 0 && (N.timestamp = q.timestamp), q.size !== void 0 && sr.resizeFileStorage(N, q.size);
      }, lookup: function(N, q) {
        throw Ct.genericErrors[44];
      }, mknod: function(N, q, pt, Ot) {
        return sr.createNode(N, q, pt, Ot);
      }, rename: function(N, q, pt) {
        if (Ct.isDir(N.mode)) {
          var Ot;
          try {
            Ot = Ct.lookupNode(q, pt);
          } catch {
          }
          if (Ot)
            for (var Wt in Ot.contents)
              throw new Ct.ErrnoError(55);
        }
        delete N.parent.contents[N.name], N.parent.timestamp = Date.now(), N.name = pt, q.contents[pt] = N, q.timestamp = N.parent.timestamp, N.parent = q;
      }, unlink: function(N, q) {
        delete N.contents[q], N.timestamp = Date.now();
      }, rmdir: function(N, q) {
        var pt = Ct.lookupNode(N, q);
        for (var Ot in pt.contents)
          throw new Ct.ErrnoError(55);
        delete N.contents[q], N.timestamp = Date.now();
      }, readdir: function(N) {
        var q = [".", ".."];
        for (var pt in N.contents)
          N.contents.hasOwnProperty(pt) && q.push(pt);
        return q;
      }, symlink: function(N, q, pt) {
        var Ot = sr.createNode(N, q, 41471, 0);
        return Ot.link = pt, Ot;
      }, readlink: function(N) {
        if (!Ct.isLink(N.mode))
          throw new Ct.ErrnoError(28);
        return N.link;
      } }, stream_ops: { read: function(N, q, pt, Ot, Wt) {
        var le = N.node.contents;
        if (Wt >= N.node.usedBytes)
          return 0;
        var ce = Math.min(N.node.usedBytes - Wt, Ot);
        if (Q(ce >= 0), ce > 8 && le.subarray)
          q.set(le.subarray(Wt, Wt + ce), pt);
        else
          for (var be = 0; be < ce; be++)
            q[pt + be] = le[Wt + be];
        return ce;
      }, write: function(N, q, pt, Ot, Wt, le) {
        if (Q(!(q instanceof ArrayBuffer)), q.buffer === zt.buffer && (le = !1), !Ot)
          return 0;
        var ce = N.node;
        if (ce.timestamp = Date.now(), q.subarray && (!ce.contents || ce.contents.subarray)) {
          if (le)
            return Q(Wt === 0, "canOwn must imply no weird position inside the file"), ce.contents = q.subarray(pt, pt + Ot), ce.usedBytes = Ot, Ot;
          if (ce.usedBytes === 0 && Wt === 0)
            return ce.contents = q.slice(pt, pt + Ot), ce.usedBytes = Ot, Ot;
          if (Wt + Ot <= ce.usedBytes)
            return ce.contents.set(q.subarray(pt, pt + Ot), Wt), Ot;
        }
        if (sr.expandFileStorage(ce, Wt + Ot), ce.contents.subarray && q.subarray)
          ce.contents.set(q.subarray(pt, pt + Ot), Wt);
        else
          for (var be = 0; be < Ot; be++)
            ce.contents[Wt + be] = q[pt + be];
        return ce.usedBytes = Math.max(ce.usedBytes, Wt + Ot), Ot;
      }, llseek: function(N, q, pt) {
        var Ot = q;
        if (pt === 1 ? Ot += N.position : pt === 2 && Ct.isFile(N.node.mode) && (Ot += N.node.usedBytes), Ot < 0)
          throw new Ct.ErrnoError(28);
        return Ot;
      }, allocate: function(N, q, pt) {
        sr.expandFileStorage(N.node, q + pt), N.node.usedBytes = Math.max(N.node.usedBytes, q + pt);
      }, mmap: function(N, q, pt, Ot, Wt) {
        if (!Ct.isFile(N.node.mode))
          throw new Ct.ErrnoError(43);
        var le, ce, be = N.node.contents;
        if (!(Wt & 2) && be.buffer === Ft)
          ce = !1, le = be.byteOffset;
        else {
          if ((pt > 0 || pt + q < be.length) && (be.subarray ? be = be.subarray(pt, pt + q) : be = Array.prototype.slice.call(be, pt, pt + q)), ce = !0, le = Wn(), !le)
            throw new Ct.ErrnoError(48);
          zt.set(be, le);
        }
        return { ptr: le, allocated: ce };
      }, msync: function(N, q, pt, Ot, Wt) {
        if (!Ct.isFile(N.node.mode))
          throw new Ct.ErrnoError(43);
        return Wt & 2 || sr.stream_ops.write(N, q, 0, Ot, pt, !1), 0;
      } } };
      function Oi(N, q, pt, Ot) {
        var Wt = Ot ? "" : nt("al " + N);
        y(N, function(le) {
          Q(le, 'Loading data file "' + N + '" failed (no arrayBuffer).'), q(new Uint8Array(le)), Wt && V(Wt);
        }, function(le) {
          if (pt)
            pt();
          else
            throw 'Loading data file "' + N + '" failed.';
        }), Wt && j(Wt);
      }
      var Yi = { 0: "Success", 1: "Arg list too long", 2: "Permission denied", 3: "Address already in use", 4: "Address not available", 5: "Address family not supported by protocol family", 6: "No more processes", 7: "Socket already connected", 8: "Bad file number", 9: "Trying to read unreadable message", 10: "Mount device busy", 11: "Operation canceled", 12: "No children", 13: "Connection aborted", 14: "Connection refused", 15: "Connection reset by peer", 16: "File locking deadlock error", 17: "Destination address required", 18: "Math arg out of domain of func", 19: "Quota exceeded", 20: "File exists", 21: "Bad address", 22: "File too large", 23: "Host is unreachable", 24: "Identifier removed", 25: "Illegal byte sequence", 26: "Connection already in progress", 27: "Interrupted system call", 28: "Invalid argument", 29: "I/O error", 30: "Socket is already connected", 31: "Is a directory", 32: "Too many symbolic links", 33: "Too many open files", 34: "Too many links", 35: "Message too long", 36: "Multihop attempted", 37: "File or path name too long", 38: "Network interface is not configured", 39: "Connection reset by network", 40: "Network is unreachable", 41: "Too many open files in system", 42: "No buffer space available", 43: "No such device", 44: "No such file or directory", 45: "Exec format error", 46: "No record locks available", 47: "The link has been severed", 48: "Not enough core", 49: "No message of desired type", 50: "Protocol not available", 51: "No space left on device", 52: "Function not implemented", 53: "Socket is not connected", 54: "Not a directory", 55: "Directory not empty", 56: "State not recoverable", 57: "Socket operation on non-socket", 59: "Not a typewriter", 60: "No such device or address", 61: "Value too large for defined data type", 62: "Previous owner died", 63: "Not super-user", 64: "Broken pipe", 65: "Protocol error", 66: "Unknown protocol", 67: "Protocol wrong type for socket", 68: "Math result not representable", 69: "Read only file system", 70: "Illegal seek", 71: "No such process", 72: "Stale file handle", 73: "Connection timed out", 74: "Text file busy", 75: "Cross-device link", 100: "Device not a stream", 101: "Bad font file fmt", 102: "Invalid slot", 103: "Invalid request code", 104: "No anode", 105: "Block device required", 106: "Channel number out of range", 107: "Level 3 halted", 108: "Level 3 reset", 109: "Link number out of range", 110: "Protocol driver not attached", 111: "No CSI structure available", 112: "Level 2 halted", 113: "Invalid exchange", 114: "Invalid request descriptor", 115: "Exchange full", 116: "No data (for no delay io)", 117: "Timer expired", 118: "Out of streams resources", 119: "Machine is not on the network", 120: "Package not installed", 121: "The object is remote", 122: "Advertise error", 123: "Srmount error", 124: "Communication error on send", 125: "Cross mount point (not really error)", 126: "Given log. name not unique", 127: "f.d. invalid for this operation", 128: "Remote address changed", 129: "Can   access a needed shared lib", 130: "Accessing a corrupted shared lib", 131: ".lib section in a.out corrupted", 132: "Attempting to link in too many libs", 133: "Attempting to exec a shared library", 135: "Streams pipe error", 136: "Too many users", 137: "Socket type not supported", 138: "Not supported", 139: "Protocol family not supported", 140: "Can't send after socket shutdown", 141: "Too many references", 142: "Host is down", 148: "No medium (in tape drive)", 156: "Level 2 not synchronized" }, vi = {}, Ct = { root: null, mounts: [], devices: {}, streams: [], nextInode: 1, nameTable: null, currentPath: "/", initialized: !1, ignorePermissions: !0, ErrnoError: null, genericErrors: {}, filesystems: null, syncFSRequests: 0, lookupPath: (N, q = {}) => {
        if (N = qe.resolve(Ct.cwd(), N), !N)
          return { path: "", node: null };
        var pt = { follow_mount: !0, recurse_count: 0 };
        if (q = Object.assign(pt, q), q.recurse_count > 8)
          throw new Ct.ErrnoError(32);
        for (var Ot = Me.normalizeArray(N.split("/").filter((Nr) => !!Nr), !1), Wt = Ct.root, le = "/", ce = 0; ce < Ot.length; ce++) {
          var be = ce === Ot.length - 1;
          if (be && q.parent)
            break;
          if (Wt = Ct.lookupNode(Wt, Ot[ce]), le = Me.join2(le, Ot[ce]), Ct.isMountpoint(Wt) && (!be || be && q.follow_mount) && (Wt = Wt.mounted.root), !be || q.follow)
            for (var Ge = 0; Ct.isLink(Wt.mode); ) {
              var er = Ct.readlink(le);
              le = qe.resolve(Me.dirname(le), er);
              var br = Ct.lookupPath(le, { recurse_count: q.recurse_count + 1 });
              if (Wt = br.node, Ge++ > 40)
                throw new Ct.ErrnoError(32);
            }
        }
        return { path: le, node: Wt };
      }, getPath: (N) => {
        for (var q; ; ) {
          if (Ct.isRoot(N)) {
            var pt = N.mount.mountpoint;
            return q ? pt[pt.length - 1] !== "/" ? pt + "/" + q : pt + q : pt;
          }
          q = q ? N.name + "/" + q : N.name, N = N.parent;
        }
      }, hashName: (N, q) => {
        for (var pt = 0, Ot = 0; Ot < q.length; Ot++)
          pt = (pt << 5) - pt + q.charCodeAt(Ot) | 0;
        return (N + pt >>> 0) % Ct.nameTable.length;
      }, hashAddNode: (N) => {
        var q = Ct.hashName(N.parent.id, N.name);
        N.name_next = Ct.nameTable[q], Ct.nameTable[q] = N;
      }, hashRemoveNode: (N) => {
        var q = Ct.hashName(N.parent.id, N.name);
        if (Ct.nameTable[q] === N)
          Ct.nameTable[q] = N.name_next;
        else
          for (var pt = Ct.nameTable[q]; pt; ) {
            if (pt.name_next === N) {
              pt.name_next = N.name_next;
              break;
            }
            pt = pt.name_next;
          }
      }, lookupNode: (N, q) => {
        var pt = Ct.mayLookup(N);
        if (pt)
          throw new Ct.ErrnoError(pt, N);
        for (var Ot = Ct.hashName(N.id, q), Wt = Ct.nameTable[Ot]; Wt; Wt = Wt.name_next) {
          var le = Wt.name;
          if (Wt.parent.id === N.id && le === q)
            return Wt;
        }
        return Ct.lookup(N, q);
      }, createNode: (N, q, pt, Ot) => {
        Q(typeof N == "object");
        var Wt = new Ct.FSNode(N, q, pt, Ot);
        return Ct.hashAddNode(Wt), Wt;
      }, destroyNode: (N) => {
        Ct.hashRemoveNode(N);
      }, isRoot: (N) => N === N.parent, isMountpoint: (N) => !!N.mounted, isFile: (N) => (N & 61440) === 32768, isDir: (N) => (N & 61440) === 16384, isLink: (N) => (N & 61440) === 40960, isChrdev: (N) => (N & 61440) === 8192, isBlkdev: (N) => (N & 61440) === 24576, isFIFO: (N) => (N & 61440) === 4096, isSocket: (N) => (N & 49152) === 49152, flagModes: { r: 0, "r+": 2, w: 577, "w+": 578, a: 1089, "a+": 1090 }, modeStringToFlags: (N) => {
        var q = Ct.flagModes[N];
        if (typeof q > "u")
          throw new Error("Unknown file open mode: " + N);
        return q;
      }, flagsToPermissionString: (N) => {
        var q = ["r", "w", "rw"][N & 3];
        return N & 512 && (q += "w"), q;
      }, nodePermissions: (N, q) => Ct.ignorePermissions ? 0 : q.includes("r") && !(N.mode & 292) || q.includes("w") && !(N.mode & 146) || q.includes("x") && !(N.mode & 73) ? 2 : 0, mayLookup: (N) => {
        var q = Ct.nodePermissions(N, "x");
        return q || (N.node_ops.lookup ? 0 : 2);
      }, mayCreate: (N, q) => {
        try {
          var pt = Ct.lookupNode(N, q);
          return 20;
        } catch {
        }
        return Ct.nodePermissions(N, "wx");
      }, mayDelete: (N, q, pt) => {
        var Ot;
        try {
          Ot = Ct.lookupNode(N, q);
        } catch (le) {
          return le.errno;
        }
        var Wt = Ct.nodePermissions(N, "wx");
        if (Wt)
          return Wt;
        if (pt) {
          if (!Ct.isDir(Ot.mode))
            return 54;
          if (Ct.isRoot(Ot) || Ct.getPath(Ot) === Ct.cwd())
            return 10;
        } else if (Ct.isDir(Ot.mode))
          return 31;
        return 0;
      }, mayOpen: (N, q) => N ? Ct.isLink(N.mode) ? 32 : Ct.isDir(N.mode) && (Ct.flagsToPermissionString(q) !== "r" || q & 512) ? 31 : Ct.nodePermissions(N, Ct.flagsToPermissionString(q)) : 44, MAX_OPEN_FDS: 4096, nextfd: (N = 0, q = Ct.MAX_OPEN_FDS) => {
        for (var pt = N; pt <= q; pt++)
          if (!Ct.streams[pt])
            return pt;
        throw new Ct.ErrnoError(33);
      }, getStream: (N) => Ct.streams[N], createStream: (N, q, pt) => {
        Ct.FSStream || (Ct.FSStream = function() {
          this.shared = {};
        }, Ct.FSStream.prototype = {}, Object.defineProperties(Ct.FSStream.prototype, { object: { get: function() {
          return this.node;
        }, set: function(Wt) {
          this.node = Wt;
        } }, isRead: { get: function() {
          return (this.flags & 2097155) !== 1;
        } }, isWrite: { get: function() {
          return (this.flags & 2097155) !== 0;
        } }, isAppend: { get: function() {
          return this.flags & 1024;
        } }, flags: { get: function() {
          return this.shared.flags;
        }, set: function(Wt) {
          this.shared.flags = Wt;
        } }, position: { get: function() {
          return this.shared.position;
        }, set: function(Wt) {
          this.shared.position = Wt;
        } } })), N = Object.assign(new Ct.FSStream(), N);
        var Ot = Ct.nextfd(q, pt);
        return N.fd = Ot, Ct.streams[Ot] = N, N;
      }, closeStream: (N) => {
        Ct.streams[N] = null;
      }, chrdev_stream_ops: { open: (N) => {
        var q = Ct.getDevice(N.node.rdev);
        N.stream_ops = q.stream_ops, N.stream_ops.open && N.stream_ops.open(N);
      }, llseek: () => {
        throw new Ct.ErrnoError(70);
      } }, major: (N) => N >> 8, minor: (N) => N & 255, makedev: (N, q) => N << 8 | q, registerDevice: (N, q) => {
        Ct.devices[N] = { stream_ops: q };
      }, getDevice: (N) => Ct.devices[N], getMounts: (N) => {
        for (var q = [], pt = [N]; pt.length; ) {
          var Ot = pt.pop();
          q.push(Ot), pt.push.apply(pt, Ot.mounts);
        }
        return q;
      }, syncfs: (N, q) => {
        typeof N == "function" && (q = N, N = !1), Ct.syncFSRequests++, Ct.syncFSRequests > 1 && w("warning: " + Ct.syncFSRequests + " FS.syncfs operations in flight at once, probably just doing extra work");
        var pt = Ct.getMounts(Ct.root.mount), Ot = 0;
        function Wt(ce) {
          return Q(Ct.syncFSRequests > 0), Ct.syncFSRequests--, q(ce);
        }
        function le(ce) {
          if (ce)
            return le.errored ? void 0 : (le.errored = !0, Wt(ce));
          ++Ot >= pt.length && Wt(null);
        }
        pt.forEach((ce) => {
          if (!ce.type.syncfs)
            return le(null);
          ce.type.syncfs(ce, N, le);
        });
      }, mount: (N, q, pt) => {
        if (typeof N == "string")
          throw N;
        var Ot = pt === "/", Wt = !pt, le;
        if (Ot && Ct.root)
          throw new Ct.ErrnoError(10);
        if (!Ot && !Wt) {
          var ce = Ct.lookupPath(pt, { follow_mount: !1 });
          if (pt = ce.path, le = ce.node, Ct.isMountpoint(le))
            throw new Ct.ErrnoError(10);
          if (!Ct.isDir(le.mode))
            throw new Ct.ErrnoError(54);
        }
        var be = { type: N, opts: q, mountpoint: pt, mounts: [] }, Ge = N.mount(be);
        return Ge.mount = be, be.root = Ge, Ot ? Ct.root = Ge : le && (le.mounted = be, le.mount && le.mount.mounts.push(be)), Ge;
      }, unmount: (N) => {
        var q = Ct.lookupPath(N, { follow_mount: !1 });
        if (!Ct.isMountpoint(q.node))
          throw new Ct.ErrnoError(28);
        var pt = q.node, Ot = pt.mounted, Wt = Ct.getMounts(Ot);
        Object.keys(Ct.nameTable).forEach((ce) => {
          for (var be = Ct.nameTable[ce]; be; ) {
            var Ge = be.name_next;
            Wt.includes(be.mount) && Ct.destroyNode(be), be = Ge;
          }
        }), pt.mounted = null;
        var le = pt.mount.mounts.indexOf(Ot);
        Q(le !== -1), pt.mount.mounts.splice(le, 1);
      }, lookup: (N, q) => N.node_ops.lookup(N, q), mknod: (N, q, pt) => {
        var Ot = Ct.lookupPath(N, { parent: !0 }), Wt = Ot.node, le = Me.basename(N);
        if (!le || le === "." || le === "..")
          throw new Ct.ErrnoError(28);
        var ce = Ct.mayCreate(Wt, le);
        if (ce)
          throw new Ct.ErrnoError(ce);
        if (!Wt.node_ops.mknod)
          throw new Ct.ErrnoError(63);
        return Wt.node_ops.mknod(Wt, le, q, pt);
      }, create: (N, q) => (q = q !== void 0 ? q : 438, q &= 4095, q |= 32768, Ct.mknod(N, q, 0)), mkdir: (N, q) => (q = q !== void 0 ? q : 511, q &= 1023, q |= 16384, Ct.mknod(N, q, 0)), mkdirTree: (N, q) => {
        for (var pt = N.split("/"), Ot = "", Wt = 0; Wt < pt.length; ++Wt)
          if (pt[Wt]) {
            Ot += "/" + pt[Wt];
            try {
              Ct.mkdir(Ot, q);
            } catch (le) {
              if (le.errno != 20)
                throw le;
            }
          }
      }, mkdev: (N, q, pt) => (typeof pt > "u" && (pt = q, q = 438), q |= 8192, Ct.mknod(N, q, pt)), symlink: (N, q) => {
        if (!qe.resolve(N))
          throw new Ct.ErrnoError(44);
        var pt = Ct.lookupPath(q, { parent: !0 }), Ot = pt.node;
        if (!Ot)
          throw new Ct.ErrnoError(44);
        var Wt = Me.basename(q), le = Ct.mayCreate(Ot, Wt);
        if (le)
          throw new Ct.ErrnoError(le);
        if (!Ot.node_ops.symlink)
          throw new Ct.ErrnoError(63);
        return Ot.node_ops.symlink(Ot, Wt, N);
      }, rename: (N, q) => {
        var pt = Me.dirname(N), Ot = Me.dirname(q), Wt = Me.basename(N), le = Me.basename(q), ce, be, Ge;
        if (ce = Ct.lookupPath(N, { parent: !0 }), be = ce.node, ce = Ct.lookupPath(q, { parent: !0 }), Ge = ce.node, !be || !Ge)
          throw new Ct.ErrnoError(44);
        if (be.mount !== Ge.mount)
          throw new Ct.ErrnoError(75);
        var er = Ct.lookupNode(be, Wt), br = qe.relative(N, Ot);
        if (br.charAt(0) !== ".")
          throw new Ct.ErrnoError(28);
        if (br = qe.relative(q, pt), br.charAt(0) !== ".")
          throw new Ct.ErrnoError(55);
        var Nr;
        try {
          Nr = Ct.lookupNode(Ge, le);
        } catch {
        }
        if (er !== Nr) {
          var hr = Ct.isDir(er.mode), ir = Ct.mayDelete(be, Wt, hr);
          if (ir)
            throw new Ct.ErrnoError(ir);
          if (ir = Nr ? Ct.mayDelete(Ge, le, hr) : Ct.mayCreate(Ge, le), ir)
            throw new Ct.ErrnoError(ir);
          if (!be.node_ops.rename)
            throw new Ct.ErrnoError(63);
          if (Ct.isMountpoint(er) || Nr && Ct.isMountpoint(Nr))
            throw new Ct.ErrnoError(10);
          if (Ge !== be && (ir = Ct.nodePermissions(be, "w"), ir))
            throw new Ct.ErrnoError(ir);
          Ct.hashRemoveNode(er);
          try {
            be.node_ops.rename(er, Ge, le);
          } catch (ur) {
            throw ur;
          } finally {
            Ct.hashAddNode(er);
          }
        }
      }, rmdir: (N) => {
        var q = Ct.lookupPath(N, { parent: !0 }), pt = q.node, Ot = Me.basename(N), Wt = Ct.lookupNode(pt, Ot), le = Ct.mayDelete(pt, Ot, !0);
        if (le)
          throw new Ct.ErrnoError(le);
        if (!pt.node_ops.rmdir)
          throw new Ct.ErrnoError(63);
        if (Ct.isMountpoint(Wt))
          throw new Ct.ErrnoError(10);
        pt.node_ops.rmdir(pt, Ot), Ct.destroyNode(Wt);
      }, readdir: (N) => {
        var q = Ct.lookupPath(N, { follow: !0 }), pt = q.node;
        if (!pt.node_ops.readdir)
          throw new Ct.ErrnoError(54);
        return pt.node_ops.readdir(pt);
      }, unlink: (N) => {
        var q = Ct.lookupPath(N, { parent: !0 }), pt = q.node;
        if (!pt)
          throw new Ct.ErrnoError(44);
        var Ot = Me.basename(N), Wt = Ct.lookupNode(pt, Ot), le = Ct.mayDelete(pt, Ot, !1);
        if (le)
          throw new Ct.ErrnoError(le);
        if (!pt.node_ops.unlink)
          throw new Ct.ErrnoError(63);
        if (Ct.isMountpoint(Wt))
          throw new Ct.ErrnoError(10);
        pt.node_ops.unlink(pt, Ot), Ct.destroyNode(Wt);
      }, readlink: (N) => {
        var q = Ct.lookupPath(N), pt = q.node;
        if (!pt)
          throw new Ct.ErrnoError(44);
        if (!pt.node_ops.readlink)
          throw new Ct.ErrnoError(28);
        return qe.resolve(Ct.getPath(pt.parent), pt.node_ops.readlink(pt));
      }, stat: (N, q) => {
        var pt = Ct.lookupPath(N, { follow: !q }), Ot = pt.node;
        if (!Ot)
          throw new Ct.ErrnoError(44);
        if (!Ot.node_ops.getattr)
          throw new Ct.ErrnoError(63);
        return Ot.node_ops.getattr(Ot);
      }, lstat: (N) => Ct.stat(N, !0), chmod: (N, q, pt) => {
        var Ot;
        if (typeof N == "string") {
          var Wt = Ct.lookupPath(N, { follow: !pt });
          Ot = Wt.node;
        } else
          Ot = N;
        if (!Ot.node_ops.setattr)
          throw new Ct.ErrnoError(63);
        Ot.node_ops.setattr(Ot, { mode: q & 4095 | Ot.mode & -4096, timestamp: Date.now() });
      }, lchmod: (N, q) => {
        Ct.chmod(N, q, !0);
      }, fchmod: (N, q) => {
        var pt = Ct.getStream(N);
        if (!pt)
          throw new Ct.ErrnoError(8);
        Ct.chmod(pt.node, q);
      }, chown: (N, q, pt, Ot) => {
        var Wt;
        if (typeof N == "string") {
          var le = Ct.lookupPath(N, { follow: !Ot });
          Wt = le.node;
        } else
          Wt = N;
        if (!Wt.node_ops.setattr)
          throw new Ct.ErrnoError(63);
        Wt.node_ops.setattr(Wt, { timestamp: Date.now() });
      }, lchown: (N, q, pt) => {
        Ct.chown(N, q, pt, !0);
      }, fchown: (N, q, pt) => {
        var Ot = Ct.getStream(N);
        if (!Ot)
          throw new Ct.ErrnoError(8);
        Ct.chown(Ot.node, q, pt);
      }, truncate: (N, q) => {
        if (q < 0)
          throw new Ct.ErrnoError(28);
        var pt;
        if (typeof N == "string") {
          var Ot = Ct.lookupPath(N, { follow: !0 });
          pt = Ot.node;
        } else
          pt = N;
        if (!pt.node_ops.setattr)
          throw new Ct.ErrnoError(63);
        if (Ct.isDir(pt.mode))
          throw new Ct.ErrnoError(31);
        if (!Ct.isFile(pt.mode))
          throw new Ct.ErrnoError(28);
        var Wt = Ct.nodePermissions(pt, "w");
        if (Wt)
          throw new Ct.ErrnoError(Wt);
        pt.node_ops.setattr(pt, { size: q, timestamp: Date.now() });
      }, ftruncate: (N, q) => {
        var pt = Ct.getStream(N);
        if (!pt)
          throw new Ct.ErrnoError(8);
        if (!(pt.flags & 2097155))
          throw new Ct.ErrnoError(28);
        Ct.truncate(pt.node, q);
      }, utime: (N, q, pt) => {
        var Ot = Ct.lookupPath(N, { follow: !0 }), Wt = Ot.node;
        Wt.node_ops.setattr(Wt, { timestamp: Math.max(q, pt) });
      }, open: (N, q, pt) => {
        if (N === "")
          throw new Ct.ErrnoError(44);
        q = typeof q == "string" ? Ct.modeStringToFlags(q) : q, pt = typeof pt > "u" ? 438 : pt, q & 64 ? pt = pt & 4095 | 32768 : pt = 0;
        var Ot;
        if (typeof N == "object")
          Ot = N;
        else {
          N = Me.normalize(N);
          try {
            var Wt = Ct.lookupPath(N, { follow: !(q & 131072) });
            Ot = Wt.node;
          } catch {
          }
        }
        var le = !1;
        if (q & 64)
          if (Ot) {
            if (q & 128)
              throw new Ct.ErrnoError(20);
          } else
            Ot = Ct.mknod(N, pt, 0), le = !0;
        if (!Ot)
          throw new Ct.ErrnoError(44);
        if (Ct.isChrdev(Ot.mode) && (q &= -513), q & 65536 && !Ct.isDir(Ot.mode))
          throw new Ct.ErrnoError(54);
        if (!le) {
          var ce = Ct.mayOpen(Ot, q);
          if (ce)
            throw new Ct.ErrnoError(ce);
        }
        q & 512 && !le && Ct.truncate(Ot, 0), q &= -131713;
        var be = Ct.createStream({ node: Ot, path: Ct.getPath(Ot), flags: q, seekable: !0, position: 0, stream_ops: Ot.stream_ops, ungotten: [], error: !1 });
        return be.stream_ops.open && be.stream_ops.open(be), d.logReadFiles && !(q & 1) && (Ct.readFiles || (Ct.readFiles = {}), N in Ct.readFiles || (Ct.readFiles[N] = 1)), be;
      }, close: (N) => {
        if (Ct.isClosed(N))
          throw new Ct.ErrnoError(8);
        N.getdents && (N.getdents = null);
        try {
          N.stream_ops.close && N.stream_ops.close(N);
        } catch (q) {
          throw q;
        } finally {
          Ct.closeStream(N.fd);
        }
        N.fd = null;
      }, isClosed: (N) => N.fd === null, llseek: (N, q, pt) => {
        if (Ct.isClosed(N))
          throw new Ct.ErrnoError(8);
        if (!N.seekable || !N.stream_ops.llseek)
          throw new Ct.ErrnoError(70);
        if (pt != 0 && pt != 1 && pt != 2)
          throw new Ct.ErrnoError(28);
        return N.position = N.stream_ops.llseek(N, q, pt), N.ungotten = [], N.position;
      }, read: (N, q, pt, Ot, Wt) => {
        if (Ot < 0 || Wt < 0)
          throw new Ct.ErrnoError(28);
        if (Ct.isClosed(N))
          throw new Ct.ErrnoError(8);
        if ((N.flags & 2097155) === 1)
          throw new Ct.ErrnoError(8);
        if (Ct.isDir(N.node.mode))
          throw new Ct.ErrnoError(31);
        if (!N.stream_ops.read)
          throw new Ct.ErrnoError(28);
        var le = typeof Wt < "u";
        if (!le)
          Wt = N.position;
        else if (!N.seekable)
          throw new Ct.ErrnoError(70);
        var ce = N.stream_ops.read(N, q, pt, Ot, Wt);
        return le || (N.position += ce), ce;
      }, write: (N, q, pt, Ot, Wt, le) => {
        if (Ot < 0 || Wt < 0)
          throw new Ct.ErrnoError(28);
        if (Ct.isClosed(N))
          throw new Ct.ErrnoError(8);
        if (!(N.flags & 2097155))
          throw new Ct.ErrnoError(8);
        if (Ct.isDir(N.node.mode))
          throw new Ct.ErrnoError(31);
        if (!N.stream_ops.write)
          throw new Ct.ErrnoError(28);
        N.seekable && N.flags & 1024 && Ct.llseek(N, 0, 2);
        var ce = typeof Wt < "u";
        if (!ce)
          Wt = N.position;
        else if (!N.seekable)
          throw new Ct.ErrnoError(70);
        var be = N.stream_ops.write(N, q, pt, Ot, Wt, le);
        return ce || (N.position += be), be;
      }, allocate: (N, q, pt) => {
        if (Ct.isClosed(N))
          throw new Ct.ErrnoError(8);
        if (q < 0 || pt <= 0)
          throw new Ct.ErrnoError(28);
        if (!(N.flags & 2097155))
          throw new Ct.ErrnoError(8);
        if (!Ct.isFile(N.node.mode) && !Ct.isDir(N.node.mode))
          throw new Ct.ErrnoError(43);
        if (!N.stream_ops.allocate)
          throw new Ct.ErrnoError(138);
        N.stream_ops.allocate(N, q, pt);
      }, mmap: (N, q, pt, Ot, Wt) => {
        if (Ot & 2 && !(Wt & 2) && (N.flags & 2097155) !== 2)
          throw new Ct.ErrnoError(2);
        if ((N.flags & 2097155) === 1)
          throw new Ct.ErrnoError(2);
        if (!N.stream_ops.mmap)
          throw new Ct.ErrnoError(43);
        return N.stream_ops.mmap(N, q, pt, Ot, Wt);
      }, msync: (N, q, pt, Ot, Wt) => !N || !N.stream_ops.msync ? 0 : N.stream_ops.msync(N, q, pt, Ot, Wt), munmap: (N) => 0, ioctl: (N, q, pt) => {
        if (!N.stream_ops.ioctl)
          throw new Ct.ErrnoError(59);
        return N.stream_ops.ioctl(N, q, pt);
      }, readFile: (N, q = {}) => {
        if (q.flags = q.flags || 0, q.encoding = q.encoding || "binary", q.encoding !== "utf8" && q.encoding !== "binary")
          throw new Error('Invalid encoding type "' + q.encoding + '"');
        var pt, Ot = Ct.open(N, q.flags), Wt = Ct.stat(N), le = Wt.size, ce = new Uint8Array(le);
        return Ct.read(Ot, ce, 0, le, 0), q.encoding === "utf8" ? pt = Rt(ce, 0) : q.encoding === "binary" && (pt = ce), Ct.close(Ot), pt;
      }, writeFile: (N, q, pt = {}) => {
        pt.flags = pt.flags || 577;
        var Ot = Ct.open(N, pt.flags, pt.mode);
        if (typeof q == "string") {
          var Wt = new Uint8Array(gt(q) + 1), le = Dt(q, Wt, 0, Wt.length);
          Ct.write(Ot, Wt, 0, le, void 0, pt.canOwn);
        } else if (ArrayBuffer.isView(q))
          Ct.write(Ot, q, 0, q.byteLength, void 0, pt.canOwn);
        else
          throw new Error("Unsupported data type");
        Ct.close(Ot);
      }, cwd: () => Ct.currentPath, chdir: (N) => {
        var q = Ct.lookupPath(N, { follow: !0 });
        if (q.node === null)
          throw new Ct.ErrnoError(44);
        if (!Ct.isDir(q.node.mode))
          throw new Ct.ErrnoError(54);
        var pt = Ct.nodePermissions(q.node, "x");
        if (pt)
          throw new Ct.ErrnoError(pt);
        Ct.currentPath = q.path;
      }, createDefaultDirectories: () => {
        Ct.mkdir("/tmp"), Ct.mkdir("/home"), Ct.mkdir("/home/web_user");
      }, createDefaultDevices: () => {
        Ct.mkdir("/dev"), Ct.registerDevice(Ct.makedev(1, 3), { read: () => 0, write: (q, pt, Ot, Wt, le) => Wt }), Ct.mkdev("/dev/null", Ct.makedev(1, 3)), gr.register(Ct.makedev(5, 0), gr.default_tty_ops), gr.register(Ct.makedev(6, 0), gr.default_tty1_ops), Ct.mkdev("/dev/tty", Ct.makedev(5, 0)), Ct.mkdev("/dev/tty1", Ct.makedev(6, 0));
        var N = Ze();
        Ct.createDevice("/dev", "random", N), Ct.createDevice("/dev", "urandom", N), Ct.mkdir("/dev/shm"), Ct.mkdir("/dev/shm/tmp");
      }, createSpecialDirectories: () => {
        Ct.mkdir("/proc");
        var N = Ct.mkdir("/proc/self");
        Ct.mkdir("/proc/self/fd"), Ct.mount({ mount: () => {
          var q = Ct.createNode(N, "fd", 16895, 73);
          return q.node_ops = { lookup: (pt, Ot) => {
            var Wt = +Ot, le = Ct.getStream(Wt);
            if (!le)
              throw new Ct.ErrnoError(8);
            var ce = { parent: null, mount: { mountpoint: "fake" }, node_ops: { readlink: () => le.path } };
            return ce.parent = ce, ce;
          } }, q;
        } }, {}, "/proc/self/fd");
      }, createStandardStreams: () => {
        d.stdin ? Ct.createDevice("/dev", "stdin", d.stdin) : Ct.symlink("/dev/tty", "/dev/stdin"), d.stdout ? Ct.createDevice("/dev", "stdout", null, d.stdout) : Ct.symlink("/dev/tty", "/dev/stdout"), d.stderr ? Ct.createDevice("/dev", "stderr", null, d.stderr) : Ct.symlink("/dev/tty1", "/dev/stderr");
        var N = Ct.open("/dev/stdin", 0), q = Ct.open("/dev/stdout", 1), pt = Ct.open("/dev/stderr", 1);
        Q(N.fd === 0, "invalid handle for stdin (" + N.fd + ")"), Q(q.fd === 1, "invalid handle for stdout (" + q.fd + ")"), Q(pt.fd === 2, "invalid handle for stderr (" + pt.fd + ")");
      }, ensureErrnoError: () => {
        Ct.ErrnoError || (Ct.ErrnoError = function(q, pt) {
          this.node = pt, this.setErrno = function(Ot) {
            this.errno = Ot;
            for (var Wt in vi)
              if (vi[Wt] === Ot) {
                this.code = Wt;
                break;
              }
          }, this.setErrno(q), this.message = Yi[q], this.stack && (Object.defineProperty(this, "stack", { value: new Error().stack, writable: !0 }), this.stack = je(this.stack));
        }, Ct.ErrnoError.prototype = new Error(), Ct.ErrnoError.prototype.constructor = Ct.ErrnoError, [44].forEach((N) => {
          Ct.genericErrors[N] = new Ct.ErrnoError(N), Ct.genericErrors[N].stack = "<generic error, no stack>";
        }));
      }, staticInit: () => {
        Ct.ensureErrnoError(), Ct.nameTable = new Array(4096), Ct.mount(sr, {}, "/"), Ct.createDefaultDirectories(), Ct.createDefaultDevices(), Ct.createSpecialDirectories(), Ct.filesystems = { MEMFS: sr };
      }, init: (N, q, pt) => {
        Q(!Ct.init.initialized, "FS.init was previously called. If you want to initialize later with custom parameters, remove any earlier calls (note that one is automatically added to the generated code)"), Ct.init.initialized = !0, Ct.ensureErrnoError(), d.stdin = N || d.stdin, d.stdout = q || d.stdout, d.stderr = pt || d.stderr, Ct.createStandardStreams();
      }, quit: () => {
        Ct.init.initialized = !1, Yr(0);
        for (var N = 0; N < Ct.streams.length; N++) {
          var q = Ct.streams[N];
          q && Ct.close(q);
        }
      }, getMode: (N, q) => {
        var pt = 0;
        return N && (pt |= 365), q && (pt |= 146), pt;
      }, findObject: (N, q) => {
        var pt = Ct.analyzePath(N, q);
        return pt.exists ? pt.object : null;
      }, analyzePath: (N, q) => {
        try {
          var pt = Ct.lookupPath(N, { follow: !q });
          N = pt.path;
        } catch {
        }
        var Ot = { isRoot: !1, exists: !1, error: 0, name: null, path: null, object: null, parentExists: !1, parentPath: null, parentObject: null };
        try {
          var pt = Ct.lookupPath(N, { parent: !0 });
          Ot.parentExists = !0, Ot.parentPath = pt.path, Ot.parentObject = pt.node, Ot.name = Me.basename(N), pt = Ct.lookupPath(N, { follow: !q }), Ot.exists = !0, Ot.path = pt.path, Ot.object = pt.node, Ot.name = pt.node.name, Ot.isRoot = pt.path === "/";
        } catch (Wt) {
          Ot.error = Wt.errno;
        }
        return Ot;
      }, createPath: (N, q, pt, Ot) => {
        N = typeof N == "string" ? N : Ct.getPath(N);
        for (var Wt = q.split("/").reverse(); Wt.length; ) {
          var le = Wt.pop();
          if (le) {
            var ce = Me.join2(N, le);
            try {
              Ct.mkdir(ce);
            } catch {
            }
            N = ce;
          }
        }
        return ce;
      }, createFile: (N, q, pt, Ot, Wt) => {
        var le = Me.join2(typeof N == "string" ? N : Ct.getPath(N), q), ce = Ct.getMode(Ot, Wt);
        return Ct.create(le, ce);
      }, createDataFile: (N, q, pt, Ot, Wt, le) => {
        var ce = q;
        N && (N = typeof N == "string" ? N : Ct.getPath(N), ce = q ? Me.join2(N, q) : N);
        var be = Ct.getMode(Ot, Wt), Ge = Ct.create(ce, be);
        if (pt) {
          if (typeof pt == "string") {
            for (var er = new Array(pt.length), br = 0, Nr = pt.length; br < Nr; ++br)
              er[br] = pt.charCodeAt(br);
            pt = er;
          }
          Ct.chmod(Ge, be | 146);
          var hr = Ct.open(Ge, 577);
          Ct.write(hr, pt, 0, pt.length, 0, le), Ct.close(hr), Ct.chmod(Ge, be);
        }
        return Ge;
      }, createDevice: (N, q, pt, Ot) => {
        var Wt = Me.join2(typeof N == "string" ? N : Ct.getPath(N), q), le = Ct.getMode(!!pt, !!Ot);
        Ct.createDevice.major || (Ct.createDevice.major = 64);
        var ce = Ct.makedev(Ct.createDevice.major++, 0);
        return Ct.registerDevice(ce, { open: (be) => {
          be.seekable = !1;
        }, close: (be) => {
          Ot && Ot.buffer && Ot.buffer.length && Ot(10);
        }, read: (be, Ge, er, br, Nr) => {
          for (var hr = 0, ir = 0; ir < br; ir++) {
            var ur;
            try {
              ur = pt();
            } catch {
              throw new Ct.ErrnoError(29);
            }
            if (ur === void 0 && hr === 0)
              throw new Ct.ErrnoError(6);
            if (ur == null)
              break;
            hr++, Ge[er + ir] = ur;
          }
          return hr && (be.node.timestamp = Date.now()), hr;
        }, write: (be, Ge, er, br, Nr) => {
          for (var hr = 0; hr < br; hr++)
            try {
              Ot(Ge[er + hr]);
            } catch {
              throw new Ct.ErrnoError(29);
            }
          return br && (be.node.timestamp = Date.now()), hr;
        } }), Ct.mkdev(Wt, le, ce);
      }, forceLoadFile: (N) => {
        if (N.isDevice || N.isFolder || N.link || N.contents)
          return !0;
        if (typeof XMLHttpRequest < "u")
          throw new Error("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.");
        if (S)
          try {
            N.contents = xr(S(N.url), !0), N.usedBytes = N.contents.length;
          } catch {
            throw new Ct.ErrnoError(29);
          }
        else
          throw new Error("Cannot load without read() or XMLHttpRequest.");
      }, createLazyFile: (N, q, pt, Ot, Wt) => {
        function le() {
          this.lengthKnown = !1, this.chunks = [];
        }
        if (le.prototype.get = function(ir) {
          if (!(ir > this.length - 1 || ir < 0)) {
            var ur = ir % this.chunkSize, rn = ir / this.chunkSize | 0;
            return this.getter(rn)[ur];
          }
        }, le.prototype.setDataGetter = function(ir) {
          this.getter = ir;
        }, le.prototype.cacheLength = function() {
          var ir = new XMLHttpRequest();
          if (ir.open("HEAD", pt, !1), ir.send(null), !(ir.status >= 200 && ir.status < 300 || ir.status === 304))
            throw new Error("Couldn't load " + pt + ". Status: " + ir.status);
          var ur = Number(ir.getResponseHeader("Content-length")), rn, Pn = (rn = ir.getResponseHeader("Accept-Ranges")) && rn === "bytes", li = (rn = ir.getResponseHeader("Content-Encoding")) && rn === "gzip", ii = 1024 * 1024;
          Pn || (ii = ur);
          var fi = (gi, Hi) => {
            if (gi > Hi)
              throw new Error("invalid range (" + gi + ", " + Hi + ") or no bytes requested!");
            if (Hi > ur - 1)
              throw new Error("only " + ur + " bytes available! programmer error!");
            var Gn = new XMLHttpRequest();
            if (Gn.open("GET", pt, !1), ur !== ii && Gn.setRequestHeader("Range", "bytes=" + gi + "-" + Hi), Gn.responseType = "arraybuffer", Gn.overrideMimeType && Gn.overrideMimeType("text/plain; charset=x-user-defined"), Gn.send(null), !(Gn.status >= 200 && Gn.status < 300 || Gn.status === 304))
              throw new Error("Couldn't load " + pt + ". Status: " + Gn.status);
            return Gn.response !== void 0 ? new Uint8Array(Gn.response || []) : xr(Gn.responseText || "", !0);
          }, Vi = this;
          Vi.setDataGetter((gi) => {
            var Hi = gi * ii, Gn = (gi + 1) * ii - 1;
            if (Gn = Math.min(Gn, ur - 1), typeof Vi.chunks[gi] > "u" && (Vi.chunks[gi] = fi(Hi, Gn)), typeof Vi.chunks[gi] > "u")
              throw new Error("doXHR failed!");
            return Vi.chunks[gi];
          }), (li || !ur) && (ii = ur = 1, ur = this.getter(0).length, ii = ur, n("LazyFiles on gzip forces download of the whole file when length is accessed")), this._length = ur, this._chunkSize = ii, this.lengthKnown = !0;
        }, typeof XMLHttpRequest < "u") {
          throw "Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc";
          var ce, be;
        } else
          var be = { isDevice: !1, url: pt };
        var Ge = Ct.createFile(N, q, be, Ot, Wt);
        be.contents ? Ge.contents = be.contents : be.url && (Ge.contents = null, Ge.url = be.url), Object.defineProperties(Ge, { usedBytes: { get: function() {
          return this.contents.length;
        } } });
        var er = {}, br = Object.keys(Ge.stream_ops);
        br.forEach((hr) => {
          var ir = Ge.stream_ops[hr];
          er[hr] = function() {
            return Ct.forceLoadFile(Ge), ir.apply(null, arguments);
          };
        });
        function Nr(hr, ir, ur, rn, Pn) {
          var li = hr.node.contents;
          if (Pn >= li.length)
            return 0;
          var ii = Math.min(li.length - Pn, rn);
          if (Q(ii >= 0), li.slice)
            for (var fi = 0; fi < ii; fi++)
              ir[ur + fi] = li[Pn + fi];
          else
            for (var fi = 0; fi < ii; fi++)
              ir[ur + fi] = li.get(Pn + fi);
          return ii;
        }
        return er.read = (hr, ir, ur, rn, Pn) => (Ct.forceLoadFile(Ge), Nr(hr, ir, ur, rn, Pn)), er.mmap = (hr, ir, ur, rn, Pn) => {
          Ct.forceLoadFile(Ge);
          var li = Wn();
          if (!li)
            throw new Ct.ErrnoError(48);
          return Nr(hr, zt, li, ir, ur), { ptr: li, allocated: !0 };
        }, Ge.stream_ops = er, Ge;
      }, createPreloadedFile: (N, q, pt, Ot, Wt, le, ce, be, Ge, er) => {
        var br = q ? qe.resolve(Me.join2(N, q)) : N, Nr = nt("cp " + br);
        function hr(ir) {
          function ur(rn) {
            er && er(), be || Ct.createDataFile(N, q, rn, Ot, Wt, Ge), le && le(), V(Nr);
          }
          Browser.handledByPreloadPlugin(ir, br, ur, () => {
            ce && ce(), V(Nr);
          }) || ur(ir);
        }
        j(Nr), typeof pt == "string" ? Oi(pt, (ir) => hr(ir), ce) : hr(pt);
      }, indexedDB: () => window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB, DB_NAME: () => "EM_FS_" + window.location.pathname, DB_VERSION: 20, DB_STORE_NAME: "FILE_DATA", saveFilesToDB: (N, q, pt) => {
        q = q || (() => {
        }), pt = pt || (() => {
        });
        var Ot = Ct.indexedDB();
        try {
          var Wt = Ot.open(Ct.DB_NAME(), Ct.DB_VERSION);
        } catch (le) {
          return pt(le);
        }
        Wt.onupgradeneeded = () => {
          n("creating db");
          var le = Wt.result;
          le.createObjectStore(Ct.DB_STORE_NAME);
        }, Wt.onsuccess = () => {
          var le = Wt.result, ce = le.transaction([Ct.DB_STORE_NAME], "readwrite"), be = ce.objectStore(Ct.DB_STORE_NAME), Ge = 0, er = 0, br = N.length;
          function Nr() {
            er == 0 ? q() : pt();
          }
          N.forEach((hr) => {
            var ir = be.put(Ct.analyzePath(hr).object.contents, hr);
            ir.onsuccess = () => {
              Ge++, Ge + er == br && Nr();
            }, ir.onerror = () => {
              er++, Ge + er == br && Nr();
            };
          }), ce.onerror = pt;
        }, Wt.onerror = pt;
      }, loadFilesFromDB: (N, q, pt) => {
        q = q || (() => {
        }), pt = pt || (() => {
        });
        var Ot = Ct.indexedDB();
        try {
          var Wt = Ot.open(Ct.DB_NAME(), Ct.DB_VERSION);
        } catch (le) {
          return pt(le);
        }
        Wt.onupgradeneeded = pt, Wt.onsuccess = () => {
          var le = Wt.result;
          try {
            var ce = le.transaction([Ct.DB_STORE_NAME], "readonly");
          } catch (hr) {
            pt(hr);
            return;
          }
          var be = ce.objectStore(Ct.DB_STORE_NAME), Ge = 0, er = 0, br = N.length;
          function Nr() {
            er == 0 ? q() : pt();
          }
          N.forEach((hr) => {
            var ir = be.get(hr);
            ir.onsuccess = () => {
              Ct.analyzePath(hr).exists && Ct.unlink(hr), Ct.createDataFile(Me.dirname(hr), Me.basename(hr), ir.result, !0, !0, !0), Ge++, Ge + er == br && Nr();
            }, ir.onerror = () => {
              er++, Ge + er == br && Nr();
            };
          }), ce.onerror = pt;
        }, Wt.onerror = pt;
      }, absolutePath: () => {
        yt("FS.absolutePath has been removed; use PATH_FS.resolve instead");
      }, createFolder: () => {
        yt("FS.createFolder has been removed; use FS.mkdir instead");
      }, createLink: () => {
        yt("FS.createLink has been removed; use FS.symlink instead");
      }, joinPath: () => {
        yt("FS.joinPath has been removed; use PATH.join instead");
      }, mmapAlloc: () => {
        yt("FS.mmapAlloc has been replaced by the top level function mmapAlloc");
      }, standardizePath: () => {
        yt("FS.standardizePath has been removed; use PATH.normalize instead");
      } }, $t = { DEFAULT_POLLMASK: 5, calculateAt: function(N, q, pt) {
        if (Me.isAbs(q))
          return q;
        var Ot;
        if (N === -100)
          Ot = Ct.cwd();
        else {
          var Wt = Ct.getStream(N);
          if (!Wt)
            throw new Ct.ErrnoError(8);
          Ot = Wt.path;
        }
        if (q.length == 0) {
          if (!pt)
            throw new Ct.ErrnoError(44);
          return Ot;
        }
        return Me.join2(Ot, q);
      }, doStat: function(N, q, pt) {
        try {
          var Ot = N(q);
        } catch (Wt) {
          if (Wt && Wt.node && Me.normalize(q) !== Me.normalize(Ct.getPath(Wt.node)))
            return -54;
          throw Wt;
        }
        return D[pt >> 2] = Ot.dev, D[pt + 4 >> 2] = 0, D[pt + 8 >> 2] = Ot.ino, D[pt + 12 >> 2] = Ot.mode, D[pt + 16 >> 2] = Ot.nlink, D[pt + 20 >> 2] = Ot.uid, D[pt + 24 >> 2] = Ot.gid, D[pt + 28 >> 2] = Ot.rdev, D[pt + 32 >> 2] = 0, Ve = [Ot.size >>> 0, (ue = Ot.size, +Math.abs(ue) >= 1 ? ue > 0 ? (Math.min(+Math.floor(ue / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((ue - +(~~ue >>> 0)) / 4294967296) >>> 0 : 0)], D[pt + 40 >> 2] = Ve[0], D[pt + 44 >> 2] = Ve[1], D[pt + 48 >> 2] = 4096, D[pt + 52 >> 2] = Ot.blocks, D[pt + 56 >> 2] = Ot.atime.getTime() / 1e3 | 0, D[pt + 60 >> 2] = 0, D[pt + 64 >> 2] = Ot.mtime.getTime() / 1e3 | 0, D[pt + 68 >> 2] = 0, D[pt + 72 >> 2] = Ot.ctime.getTime() / 1e3 | 0, D[pt + 76 >> 2] = 0, Ve = [Ot.ino >>> 0, (ue = Ot.ino, +Math.abs(ue) >= 1 ? ue > 0 ? (Math.min(+Math.floor(ue / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((ue - +(~~ue >>> 0)) / 4294967296) >>> 0 : 0)], D[pt + 80 >> 2] = Ve[0], D[pt + 84 >> 2] = Ve[1], 0;
      }, doMsync: function(N, q, pt, Ot, Wt) {
        var le = G.slice(N, N + pt);
        Ct.msync(q, le, Wt, pt, Ot);
      }, varargs: void 0, get: function() {
        Q($t.varargs != null), $t.varargs += 4;
        var N = D[$t.varargs - 4 >> 2];
        return N;
      }, getStr: function(N) {
        var q = bt(N);
        return q;
      }, getStreamFromFD: function(N) {
        var q = Ct.getStream(N);
        if (!q)
          throw new Ct.ErrnoError(8);
        return q;
      } };
      function Mt(N, q) {
        try {
          if (q === 0)
            return -28;
          var pt = Ct.cwd(), Ot = gt(pt) + 1;
          return q < Ot ? -68 : (X(pt, N, q), Ot);
        } catch (Wt) {
          if (typeof Ct > "u" || !(Wt instanceof Ct.ErrnoError))
            throw Wt;
          return -Wt.errno;
        }
      }
      function oe() {
        yt("native code called abort()");
      }
      function Lt(N, q, pt) {
        G.copyWithin(N, q, q + pt);
      }
      function Ut() {
        return 2147483648;
      }
      function Vt(N) {
        try {
          return L.grow(N - Ft.byteLength + 65535 >>> 16), et(L.buffer), 1;
        } catch (q) {
          w("emscripten_realloc_buffer: Attempted to grow heap from " + Ft.byteLength + " bytes to " + N + " bytes, but got error: " + q);
        }
      }
      function Yt(N) {
        var q = G.length;
        N = N >>> 0, Q(N > q);
        var pt = Ut();
        if (N > pt)
          return w("Cannot enlarge memory, asked to go up to " + N + " bytes, but the limit is " + pt + " bytes!"), !1;
        let Ot = (Ge, er) => Ge + (er - Ge % er) % er;
        for (var Wt = 1; Wt <= 4; Wt *= 2) {
          var le = q * (1 + 0.2 / Wt);
          le = Math.min(le, N + 100663296);
          var ce = Math.min(pt, Ot(Math.max(N, le), 65536)), be = Vt(ce);
          if (be)
            return !0;
        }
        return w("Failed to grow the heap from " + q + " bytes to " + ce + " bytes, not enough memory!"), !1;
      }
      var re = {};
      function Ht() {
        return i || "./this.program";
      }
      function fe() {
        if (!fe.strings) {
          var N = (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8", q = { USER: "web_user", LOGNAME: "web_user", PATH: "/", PWD: "/", HOME: "/home/web_user", LANG: N, _: Ht() };
          for (var pt in re)
            re[pt] === void 0 ? delete q[pt] : q[pt] = re[pt];
          var Ot = [];
          for (var pt in q)
            Ot.push(pt + "=" + q[pt]);
          fe.strings = Ot;
        }
        return fe.strings;
      }
      function Qt(N, q) {
        var pt = 0;
        return fe().forEach(function(Ot, Wt) {
          var le = q + pt;
          Z[N + Wt * 4 >> 2] = le, wt(Ot, le), pt += Ot.length + 1;
        }), 0;
      }
      function Ce(N, q) {
        var pt = fe();
        Z[N >> 2] = pt.length;
        var Ot = 0;
        return pt.forEach(function(Wt) {
          Ot += Wt.length + 1;
        }), Z[q >> 2] = Ot, 0;
      }
      function ze(N) {
        Qe(N);
      }
      function He(N) {
        try {
          var q = $t.getStreamFromFD(N);
          return Ct.close(q), 0;
        } catch (pt) {
          if (typeof Ct > "u" || !(pt instanceof Ct.ErrnoError))
            throw pt;
          return pt.errno;
        }
      }
      function Je(N, q) {
        return Q(N == N >>> 0 || N == (N | 0)), Q(q === (q | 0)), q + 2097152 >>> 0 < 4194305 - !!N ? (N >>> 0) + q * 4294967296 : NaN;
      }
      function ar(N, q, pt, Ot, Wt) {
        try {
          var le = Je(q, pt);
          if (isNaN(le))
            return 61;
          var ce = $t.getStreamFromFD(N);
          return Ct.llseek(ce, le, Ot), Ve = [ce.position >>> 0, (ue = ce.position, +Math.abs(ue) >= 1 ? ue > 0 ? (Math.min(+Math.floor(ue / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((ue - +(~~ue >>> 0)) / 4294967296) >>> 0 : 0)], D[Wt >> 2] = Ve[0], D[Wt + 4 >> 2] = Ve[1], ce.getdents && le === 0 && Ot === 0 && (ce.getdents = null), 0;
        } catch (be) {
          if (typeof Ct > "u" || !(be instanceof Ct.ErrnoError))
            throw be;
          return be.errno;
        }
      }
      function mr(N, q, pt, Ot) {
        for (var Wt = 0, le = 0; le < pt; le++) {
          var ce = Z[q >> 2], be = Z[q + 4 >> 2];
          q += 8;
          var Ge = Ct.write(N, zt, ce, be, Ot);
          if (Ge < 0)
            return -1;
          Wt += Ge;
        }
        return Wt;
      }
      function we(N, q, pt, Ot) {
        try {
          var Wt = $t.getStreamFromFD(N), le = mr(Wt, q, pt);
          return Z[Ot >> 2] = le, 0;
        } catch (ce) {
          if (typeof Ct > "u" || !(ce instanceof Ct.ErrnoError))
            throw ce;
          return ce.errno;
        }
      }
      function We() {
        return B();
      }
      function fr(N) {
        return N;
      }
      function Ke(N) {
        F(N);
      }
      var pr = function(N, q, pt, Ot) {
        N || (N = this), this.parent = N, this.mount = N.mount, this.mounted = null, this.id = Ct.nextInode++, this.name = q, this.mode = pt, this.node_ops = {}, this.stream_ops = {}, this.rdev = Ot;
      }, tr = 365, Er = 146;
      Object.defineProperties(pr.prototype, { read: { get: function() {
        return (this.mode & tr) === tr;
      }, set: function(N) {
        N ? this.mode |= tr : this.mode &= ~tr;
      } }, write: { get: function() {
        return (this.mode & Er) === Er;
      }, set: function(N) {
        N ? this.mode |= Er : this.mode &= ~Er;
      } }, isFolder: { get: function() {
        return Ct.isDir(this.mode);
      } }, isDevice: { get: function() {
        return Ct.isChrdev(this.mode);
      } } }), Ct.FSNode = pr, Ct.staticInit(), vi = { EPERM: 63, ENOENT: 44, ESRCH: 71, EINTR: 27, EIO: 29, ENXIO: 60, E2BIG: 1, ENOEXEC: 45, EBADF: 8, ECHILD: 12, EAGAIN: 6, EWOULDBLOCK: 6, ENOMEM: 48, EACCES: 2, EFAULT: 21, ENOTBLK: 105, EBUSY: 10, EEXIST: 20, EXDEV: 75, ENODEV: 43, ENOTDIR: 54, EISDIR: 31, EINVAL: 28, ENFILE: 41, EMFILE: 33, ENOTTY: 59, ETXTBSY: 74, EFBIG: 22, ENOSPC: 51, ESPIPE: 70, EROFS: 69, EMLINK: 34, EPIPE: 64, EDOM: 18, ERANGE: 68, ENOMSG: 49, EIDRM: 24, ECHRNG: 106, EL2NSYNC: 156, EL3HLT: 107, EL3RST: 108, ELNRNG: 109, EUNATCH: 110, ENOCSI: 111, EL2HLT: 112, EDEADLK: 16, ENOLCK: 46, EBADE: 113, EBADR: 114, EXFULL: 115, ENOANO: 104, EBADRQC: 103, EBADSLT: 102, EDEADLOCK: 16, EBFONT: 101, ENOSTR: 100, ENODATA: 116, ETIME: 117, ENOSR: 118, ENONET: 119, ENOPKG: 120, EREMOTE: 121, ENOLINK: 47, EADV: 122, ESRMNT: 123, ECOMM: 124, EPROTO: 65, EMULTIHOP: 36, EDOTDOT: 125, EBADMSG: 9, ENOTUNIQ: 126, EBADFD: 127, EREMCHG: 128, ELIBACC: 129, ELIBBAD: 130, ELIBSCN: 131, ELIBMAX: 132, ELIBEXEC: 133, ENOSYS: 52, ENOTEMPTY: 55, ENAMETOOLONG: 37, ELOOP: 32, EOPNOTSUPP: 138, EPFNOSUPPORT: 139, ECONNRESET: 15, ENOBUFS: 42, EAFNOSUPPORT: 5, EPROTOTYPE: 67, ENOTSOCK: 57, ENOPROTOOPT: 50, ESHUTDOWN: 140, ECONNREFUSED: 14, EADDRINUSE: 3, ECONNABORTED: 13, ENETUNREACH: 40, ENETDOWN: 38, ETIMEDOUT: 73, EHOSTDOWN: 142, EHOSTUNREACH: 23, EINPROGRESS: 26, EALREADY: 7, EDESTADDRREQ: 17, EMSGSIZE: 35, EPROTONOSUPPORT: 66, ESOCKTNOSUPPORT: 137, EADDRNOTAVAIL: 4, ENETRESET: 39, EISCONN: 30, ENOTCONN: 53, ETOOMANYREFS: 141, EUSERS: 136, EDQUOT: 19, ESTALE: 72, ENOTSUP: 138, ENOMEDIUM: 148, EILSEQ: 25, EOVERFLOW: 61, ECANCELED: 11, ENOTRECOVERABLE: 56, EOWNERDEAD: 62, ESTRPIPE: 135 };
      function xr(N, q, pt) {
        var Ot = pt > 0 ? pt : gt(N) + 1, Wt = new Array(Ot), le = Dt(N, Wt, 0, Wt.length);
        return q && (Wt.length = le), Wt;
      }
      function Gr() {
        O("fetchSettings");
      }
      var tn = { __cxa_allocate_exception: nr, __cxa_begin_catch: dn, __cxa_end_catch: qr, __cxa_find_matching_catch_2: un, __cxa_find_matching_catch_4: wi, __cxa_throw: Si, __resumeException: gn, __syscall_getcwd: Mt, abort: oe, emscripten_memcpy_big: Lt, emscripten_resize_heap: Yt, environ_get: Qt, environ_sizes_get: Ce, exit: ze, fd_close: He, fd_seek: ar, fd_write: we, getTempRet0: We, invoke_i: Et, invoke_ii: Ua, invoke_iii: _, invoke_iiii: Zi, invoke_iiiiii: K, invoke_j: mt, invoke_ji: At, invoke_jii: ee, invoke_v: tt, invoke_vi: va, invoke_vii: ga, invoke_viii: Gi, invoke_viiii: si, invoke_viiiii: U, llvm_eh_typeid_for: fr, setTempRet0: Ke };
      Xt(), d.___wasm_call_ctors = Y("__wasm_call_ctors"), d._new_convert = Y("new_convert"), d._decode = Y("decode"), d._main = Y("main");
      var Qr = d._malloc = Y("malloc"), _r = d._free = Y("free"), Yr = d._fflush = Y("fflush");
      d.___errno_location = Y("__errno_location"), d._rust_eh_personality = Y("rust_eh_personality"), d._htonl = Y("htonl"), d._htons = Y("htons"), d._ntohs = Y("ntohs");
      var Rr = d._setThrew = Y("setThrew"), qn = d._emscripten_stack_init = function() {
        return (qn = d._emscripten_stack_init = d.asm.emscripten_stack_init).apply(null, arguments);
      };
      d._emscripten_stack_get_free = function() {
        return (d._emscripten_stack_get_free = d.asm.emscripten_stack_get_free).apply(null, arguments);
      }, d._emscripten_stack_get_base = function() {
        return (d._emscripten_stack_get_base = d.asm.emscripten_stack_get_base).apply(null, arguments);
      };
      var Sn = d._emscripten_stack_get_end = function() {
        return (Sn = d._emscripten_stack_get_end = d.asm.emscripten_stack_get_end).apply(null, arguments);
      }, $r = d.stackSave = Y("stackSave"), ln = d.stackRestore = Y("stackRestore"), pn = d.stackAlloc = Y("stackAlloc"), Nn = d.___cxa_can_catch = Y("__cxa_can_catch"), Rn = d.___cxa_is_pointer_type = Y("__cxa_is_pointer_type"), Na = d.dynCall_ji = Y("dynCall_ji"), zi = d.dynCall_j = Y("dynCall_j");
      d.dynCall_jiii = Y("dynCall_jiii");
      var La = d.dynCall_jii = Y("dynCall_jii");
      d.dynCall_jiji = Y("dynCall_jiji");
      function Ua(N, q) {
        var pt = $r();
        try {
          return Wr(N)(q);
        } catch (Ot) {
          if (ln(pt), Ot !== Ot + 0)
            throw Ot;
          Rr(1, 0);
        }
      }
      function va(N, q) {
        var pt = $r();
        try {
          Wr(N)(q);
        } catch (Ot) {
          if (ln(pt), Ot !== Ot + 0)
            throw Ot;
          Rr(1, 0);
        }
      }
      function Gi(N, q, pt, Ot) {
        var Wt = $r();
        try {
          Wr(N)(q, pt, Ot);
        } catch (le) {
          if (ln(Wt), le !== le + 0)
            throw le;
          Rr(1, 0);
        }
      }
      function ga(N, q, pt) {
        var Ot = $r();
        try {
          Wr(N)(q, pt);
        } catch (Wt) {
          if (ln(Ot), Wt !== Wt + 0)
            throw Wt;
          Rr(1, 0);
        }
      }
      function Zi(N, q, pt, Ot) {
        var Wt = $r();
        try {
          return Wr(N)(q, pt, Ot);
        } catch (le) {
          if (ln(Wt), le !== le + 0)
            throw le;
          Rr(1, 0);
        }
      }
      function si(N, q, pt, Ot, Wt) {
        var le = $r();
        try {
          Wr(N)(q, pt, Ot, Wt);
        } catch (ce) {
          if (ln(le), ce !== ce + 0)
            throw ce;
          Rr(1, 0);
        }
      }
      function Et(N) {
        var q = $r();
        try {
          return Wr(N)();
        } catch (pt) {
          if (ln(q), pt !== pt + 0)
            throw pt;
          Rr(1, 0);
        }
      }
      function _(N, q, pt) {
        var Ot = $r();
        try {
          return Wr(N)(q, pt);
        } catch (Wt) {
          if (ln(Ot), Wt !== Wt + 0)
            throw Wt;
          Rr(1, 0);
        }
      }
      function U(N, q, pt, Ot, Wt, le) {
        var ce = $r();
        try {
          Wr(N)(q, pt, Ot, Wt, le);
        } catch (be) {
          if (ln(ce), be !== be + 0)
            throw be;
          Rr(1, 0);
        }
      }
      function tt(N) {
        var q = $r();
        try {
          Wr(N)();
        } catch (pt) {
          if (ln(q), pt !== pt + 0)
            throw pt;
          Rr(1, 0);
        }
      }
      function K(N, q, pt, Ot, Wt, le) {
        var ce = $r();
        try {
          return Wr(N)(q, pt, Ot, Wt, le);
        } catch (be) {
          if (ln(ce), be !== be + 0)
            throw be;
          Rr(1, 0);
        }
      }
      function mt(N) {
        var q = $r();
        try {
          return zi(N);
        } catch (pt) {
          if (ln(q), pt !== pt + 0)
            throw pt;
          Rr(1, 0);
        }
      }
      function At(N, q) {
        var pt = $r();
        try {
          return Na(N, q);
        } catch (Ot) {
          if (ln(pt), Ot !== Ot + 0)
            throw Ot;
          Rr(1, 0);
        }
      }
      function ee(N, q, pt) {
        var Ot = $r();
        try {
          return La(N, q, pt);
        } catch (Wt) {
          if (ln(Ot), Wt !== Wt + 0)
            throw Wt;
          Rr(1, 0);
        }
      }
      d.ccall = St, d.cwrap = Pt, P("allocate", !1), P("UTF8ArrayToString", !1), P("UTF8ToString", !1), P("stringToUTF8Array", !1), P("stringToUTF8", !1), P("lengthBytesUTF8", !1), P("addOnPreRun", !1), P("addOnInit", !1), P("addOnPreMain", !1), P("addOnExit", !1), P("addOnPostRun", !1), P("addRunDependency", !0), P("removeRunDependency", !0), P("FS_createFolder", !1), P("FS_createPath", !0), P("FS_createDataFile", !0), P("FS_createPreloadedFile", !0), P("FS_createLazyFile", !0), P("FS_createLink", !1), P("FS_createDevice", !0), P("FS_unlink", !0), P("getLEB", !1), P("getFunctionTables", !1), P("alignFunctionTables", !1), P("registerFunctions", !1), P("addFunction", !1), P("removeFunction", !1), P("prettyPrint", !1), P("getCompilerSetting", !1), P("print", !1), P("printErr", !1), P("getTempRet0", !1), P("setTempRet0", !1), P("callMain", !1), P("abort", !1), P("keepRuntimeAlive", !1), P("wasmMemory", !1), P("warnOnce", !1), P("stackSave", !1), P("stackRestore", !1), P("stackAlloc", !1), P("AsciiToString", !1), P("stringToAscii", !1), P("UTF16ToString", !1), P("stringToUTF16", !1), P("lengthBytesUTF16", !1), P("UTF32ToString", !1), P("stringToUTF32", !1), P("lengthBytesUTF32", !1), P("allocateUTF8", !1), P("allocateUTF8OnStack", !1), P("ExitStatus", !1), P("intArrayFromString", !1), P("intArrayToString", !1), P("writeStringToMemory", !1), P("writeArrayToMemory", !1), P("writeAsciiToMemory", !1), d.writeStackCookie = kt, d.checkStackCookie = jt, P("ptrToString", !1), P("zeroMemory", !1), P("stringToNewUTF8", !1), P("getHeapMax", !1), P("emscripten_realloc_buffer", !1), P("ENV", !1), P("ERRNO_CODES", !1), P("ERRNO_MESSAGES", !1), P("setErrNo", !1), P("inetPton4", !1), P("inetNtop4", !1), P("inetPton6", !1), P("inetNtop6", !1), P("readSockaddr", !1), P("writeSockaddr", !1), P("DNS", !1), P("getHostByName", !1), P("Protocols", !1), P("Sockets", !1), P("getRandomDevice", !1), P("traverseStack", !1), P("UNWIND_CACHE", !1), P("convertPCtoSourceLocation", !1), P("readAsmConstArgsArray", !1), P("readAsmConstArgs", !1), P("mainThreadEM_ASM", !1), P("jstoi_q", !1), P("jstoi_s", !1), P("getExecutableName", !1), P("listenOnce", !1), P("autoResumeAudioContext", !1), P("dynCallLegacy", !1), P("getDynCaller", !1), P("dynCall", !1), P("setWasmTableEntry", !1), P("getWasmTableEntry", !1), P("handleException", !1), P("runtimeKeepalivePush", !1), P("runtimeKeepalivePop", !1), P("callUserCallback", !1), P("maybeExit", !1), P("safeSetTimeout", !1), P("asmjsMangle", !1), P("asyncLoad", !1), P("alignMemory", !1), P("mmapAlloc", !1), P("writeI53ToI64", !1), P("writeI53ToI64Clamped", !1), P("writeI53ToI64Signaling", !1), P("writeI53ToU64Clamped", !1), P("writeI53ToU64Signaling", !1), P("readI53FromI64", !1), P("readI53FromU64", !1), P("convertI32PairToI53", !1), P("convertI32PairToI53Checked", !1), P("convertU32PairToI53", !1), P("reallyNegative", !1), P("unSign", !1), P("strLen", !1), P("reSign", !1), P("formatString", !1), P("setValue", !1), P("getValue", !1), P("PATH", !1), P("PATH_FS", !1), P("SYSCALLS", !1), P("getSocketFromFD", !1), P("getSocketAddress", !1), P("JSEvents", !1), P("registerKeyEventCallback", !1), P("specialHTMLTargets", !1), P("maybeCStringToJsString", !1), P("findEventTarget", !1), P("findCanvasEventTarget", !1), P("getBoundingClientRect", !1), P("fillMouseEventData", !1), P("registerMouseEventCallback", !1), P("registerWheelEventCallback", !1), P("registerUiEventCallback", !1), P("registerFocusEventCallback", !1), P("fillDeviceOrientationEventData", !1), P("registerDeviceOrientationEventCallback", !1), P("fillDeviceMotionEventData", !1), P("registerDeviceMotionEventCallback", !1), P("screenOrientation", !1), P("fillOrientationChangeEventData", !1), P("registerOrientationChangeEventCallback", !1), P("fillFullscreenChangeEventData", !1), P("registerFullscreenChangeEventCallback", !1), P("JSEvents_requestFullscreen", !1), P("JSEvents_resizeCanvasForFullscreen", !1), P("registerRestoreOldStyle", !1), P("hideEverythingExceptGivenElement", !1), P("restoreHiddenElements", !1), P("setLetterbox", !1), P("currentFullscreenStrategy", !1), P("restoreOldWindowedStyle", !1), P("softFullscreenResizeWebGLRenderTarget", !1), P("doRequestFullscreen", !1), P("fillPointerlockChangeEventData", !1), P("registerPointerlockChangeEventCallback", !1), P("registerPointerlockErrorEventCallback", !1), P("requestPointerLock", !1), P("fillVisibilityChangeEventData", !1), P("registerVisibilityChangeEventCallback", !1), P("registerTouchEventCallback", !1), P("fillGamepadEventData", !1), P("registerGamepadEventCallback", !1), P("registerBeforeUnloadEventCallback", !1), P("fillBatteryEventData", !1), P("battery", !1), P("registerBatteryEventCallback", !1), P("setCanvasElementSize", !1), P("getCanvasElementSize", !1), P("demangle", !1), P("demangleAll", !1), P("jsStackTrace", !1), P("stackTrace", !1), P("getEnvStrings", !1), P("checkWasiClock", !1), P("doReadv", !1), P("doWritev", !1), P("dlopenMissingError", !1), P("setImmediateWrapped", !1), P("clearImmediateWrapped", !1), P("polyfillSetImmediate", !1), P("uncaughtExceptionCount", !1), P("exceptionLast", !1), P("exceptionCaught", !1), P("ExceptionInfo", !1), P("exception_addRef", !1), P("exception_decRef", !1), P("incrementExceptionRefcount", !1), P("decrementExceptionRefcount", !1), P("getExceptionMessage", !1), P("Browser", !1), P("setMainLoop", !1), P("wget", !1), P("FS", !1), P("MEMFS", !1), P("TTY", !1), P("PIPEFS", !1), P("SOCKFS", !1), P("_setNetworkCallback", !1), P("tempFixedLengthArray", !1), P("miniTempWebGLFloatBuffers", !1), P("heapObjectForWebGLType", !1), P("heapAccessShiftForWebGLHeap", !1), P("GL", !1), P("emscriptenWebGLGet", !1), P("computeUnpackAlignedImageSize", !1), P("emscriptenWebGLGetTexPixelData", !1), P("emscriptenWebGLGetUniform", !1), P("webglGetUniformLocation", !1), P("webglPrepareUniformLocationsBeforeFirstUse", !1), P("webglGetLeftBracePos", !1), P("emscriptenWebGLGetVertexAttrib", !1), P("writeGLArray", !1), P("AL", !1), P("SDL_unicode", !1), P("SDL_ttfContext", !1), P("SDL_audio", !1), P("SDL", !1), P("SDL_gfx", !1), P("GLUT", !1), P("EGL", !1), P("GLFW_Window", !1), P("GLFW", !1), P("GLEW", !1), P("IDBStore", !1), P("runAndAbortIfError", !1), T("ALLOC_NORMAL", !1), T("ALLOC_STACK", !1);
      var ae;
      function ye(N) {
        this.name = "ExitStatus", this.message = "Program terminated with exit(" + N + ")", this.status = N;
      }
      It = function N() {
        ae || Ie(), ae || (It = N);
      };
      function Ae(N) {
        Q(Be == 0, 'cannot call main when async dependencies remain! (listen on Module["onRuntimeInitialized"])'), Q(me.length == 0, "cannot call main when preRun functions remain to be called");
        var q = d._main;
        N = N || [], N.unshift(i);
        var pt = N.length, Ot = pn((pt + 1) * 4), Wt = Ot >> 2;
        N.forEach((ce) => {
          D[Wt++] = st(ce);
        }), D[Wt] = 0;
        try {
          var le = q(pt, Ot);
          return Qe(le, !0), le;
        } catch (ce) {
          return vr(ce);
        } finally {
        }
      }
      function Oe() {
        qn(), kt();
      }
      function Ie(N) {
        if (N = N || s, Be > 0 || (Oe(), xe(), Be > 0))
          return;
        function q() {
          ae || (ae = !0, d.calledRun = !0, !J && (Fe(), Zt(), u(d), d.onRuntimeInitialized && d.onRuntimeInitialized(), cr && Ae(N), qt()));
        }
        d.setStatus ? (d.setStatus("Running..."), setTimeout(function() {
          setTimeout(function() {
            d.setStatus("");
          }, 1), q();
        }, 1)) : q(), jt();
      }
      d.run = Ie;
      function Ne() {
        var N = n, q = w, pt = !1;
        n = w = (Ot) => {
          pt = !0;
        };
        try {
          Yr(0), ["stdout", "stderr"].forEach(function(Ot) {
            var Wt = Ct.analyzePath("/dev/" + Ot);
            if (Wt) {
              var le = Wt.object, ce = le.rdev, be = gr.ttys[ce];
              be && be.output && be.output.length && (pt = !0);
            }
          });
        } catch {
        }
        n = N, w = q, pt && E("stdio streams had content in them that was not flushed. you should set EXIT_RUNTIME to 1 (see the FAQ), or make sure to emit a newline when you printf etc.");
      }
      function Qe(N, q) {
        if (ft = N, Ne(), Te() && !q) {
          var pt = "program exited (with status: " + N + "), but EXIT_RUNTIME is not set, so halting execution but not exiting the runtime or preventing further async execution (build with EXIT_RUNTIME=1, if you want a true shutdown)";
          l(pt), w(pt);
        }
        rr(N);
      }
      function rr(N) {
        ft = N, Te() || (d.onExit && d.onExit(N), J = !0), f(N, new ye(N));
      }
      if (d.preInit)
        for (typeof d.preInit == "function" && (d.preInit = [d.preInit]); d.preInit.length > 0; )
          d.preInit.pop()();
      var cr = !0;
      return d.noInitialRun && (cr = !1), Ie(), d.ready;
    };
  })();
  a.exports = r;
})(Ev);
var U4 = Ev.exports;
const z4 = /* @__PURE__ */ Ro(U4);
class G4 {
  constructor() {
    this.Module = null, this.initialized = !1;
  }
  async init() {
    if (!this.initialized) {
      const t = await z4();
      this.Module = t, this.initialized = !0;
    }
  }
  async convert(t, r, o) {
    const c = new Uint8Array(t), d = this.Module._malloc(c.length * c.BYTES_PER_ELEMENT);
    this.Module.HEAPU8.set(c, d);
    const l = this.Module.cwrap("new_convert", "number", ["number", "number", "number", "number"])(d, c.length, o, r), e = this.Module.HEAPU32[l / 4], s = this.Module.HEAPU32[l / 4 + 1], i = new Uint8Array(this.Module.HEAPU8.subarray(e, e + s));
    return this.Module._free(d), this.Module._free(e), { resultData: i, resultSize: s };
  }
}
let rh = null;
async function V4() {
  if (rh === null) {
    const a = await new G4();
    await a.init(), rh = a;
  }
}
async function H4(a, { orientation: t, quality: r }) {
  return await rh.convert(a, t, r);
}
let ta, Av = new TextDecoder("utf-8", { ignoreBOM: !0, fatal: !0 });
Av.decode();
let sl = null;
function Bh() {
  return (sl === null || sl.buffer !== ta.memory.buffer) && (sl = new Uint8Array(ta.memory.buffer)), sl;
}
function W4(a, t) {
  return Av.decode(Bh().subarray(a, a + t));
}
let Cv = 0;
function _4(a, t) {
  const r = t(a.length * 1);
  return Bh().set(a, r / 1), Cv = a.length, r;
}
let ll = null;
function pd() {
  return (ll === null || ll.buffer !== ta.memory.buffer) && (ll = new Int32Array(ta.memory.buffer)), ll;
}
function j4(a, t) {
  return Bh().subarray(a / 1, a / 1 + t);
}
function X4(a, t, r) {
  try {
    const e = ta.__wbindgen_add_to_stack_pointer(-16);
    var o = _4(a, ta.__wbindgen_malloc), c = Cv;
    ta.optimise(e, o, c, t, r);
    var d = pd()[e / 4 + 0], u = pd()[e / 4 + 1], l = j4(d, u).slice();
    return ta.__wbindgen_free(d, u * 1), l;
  } catch (e) {
    console.error("error", e), ta.__wbindgen_add_to_stack_pointer(16);
  }
}
async function Y4(a, t) {
  if (typeof Response == "function" && a instanceof Response) {
    if (typeof WebAssembly.instantiateStreaming == "function")
      try {
        return await WebAssembly.instantiateStreaming(a, t);
      } catch (o) {
        if (a.headers.get("Content-Type") != "application/wasm")
          console.warn(
            "`WebAssembly.instantiateStreaming` failed because your server does not serve wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n",
            o
          );
        else
          throw o;
      }
    const r = await a.arrayBuffer();
    return await WebAssembly.instantiate(r, t);
  } else {
    const r = await WebAssembly.instantiate(a, t);
    return r instanceof WebAssembly.Instance ? { instance: r, module: a } : r;
  }
}
async function Tv() {
  const a = {};
  a.wbg = {}, a.wbg.__wbindgen_throw = function(c, d) {
    throw new Error(W4(c, d));
  };
  const t = fetch("/js/oxipng.wasm"), { instance: r, module: o } = await Y4(await t, a);
  return ta = r.exports, Tv.__wbindgen_wasm_module = o, ta;
}
class Z4 {
  constructor() {
    this.Module = null, this.initialized = !1;
  }
  async init() {
    this.initialized || (await Tv(), this.initialized = !0);
  }
  // eslint-disable-next-line no-unused-vars
  async convert(t, r, o) {
    const c = new Uint8Array(t);
    return { resultData: X4(c, 1, !1), resultSize: void 0 };
  }
}
let nh = null;
async function K4() {
  if (nh === null) {
    const a = await new Z4();
    await a.init(), nh = a;
  }
}
async function J4(a, t, r) {
  return await nh.convert(a, t, r);
}
const Q4 = "image/jpeg", $4 = "image/png", Jo = {};
function q4(a) {
  const t = atob(a.split(",")[1]), r = a.split(",")[0].split(":")[1].split(";")[0], o = new ArrayBuffer(t.length), c = new Uint8Array(o);
  for (let u = 0; u < t.length; u++)
    c[u] = t.charCodeAt(u);
  return new Blob([o], { type: r });
}
function t3(a) {
  return new Promise((t) => {
    if (Jo[a] !== void 0 && t(Jo[a]), a === Q4)
      V4().then(() => {
        Jo[a] = H4, t(Jo[a]);
      });
    else if (a === $4)
      K4().then(() => {
        Jo[a] = J4, t(Jo[a]);
      });
    else
      throw new Error(`Undefined converters for ${a}`);
  });
}
async function e3(a, t, r) {
  return new Promise((o, c) => {
    t3(t).then((d) => {
      q4(a).arrayBuffer().then((u) => {
        d(u, { orientations: -2, quality: r }).then((l) => {
          o(l);
        }).catch((l) => {
          c(l);
        });
      });
    }).catch((d) => {
      c(d);
    });
  });
}
let fl;
const r3 = new Uint8Array(16);
function n3() {
  if (!fl && (fl = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !fl))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return fl(r3);
}
const ci = [];
for (let a = 0; a < 256; ++a)
  ci.push((a + 256).toString(16).slice(1));
function i3(a, t = 0) {
  return ci[a[t + 0]] + ci[a[t + 1]] + ci[a[t + 2]] + ci[a[t + 3]] + "-" + ci[a[t + 4]] + ci[a[t + 5]] + "-" + ci[a[t + 6]] + ci[a[t + 7]] + "-" + ci[a[t + 8]] + ci[a[t + 9]] + "-" + ci[a[t + 10]] + ci[a[t + 11]] + ci[a[t + 12]] + ci[a[t + 13]] + ci[a[t + 14]] + ci[a[t + 15]];
}
const a3 = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), yd = {
  randomUUID: a3
};
function o3(a, t, r) {
  if (yd.randomUUID && !t && !a)
    return yd.randomUUID();
  a = a || {};
  const o = a.random || (a.rng || n3)();
  if (o[6] = o[6] & 15 | 64, o[8] = o[8] & 63 | 128, t) {
    r = r || 0;
    for (let c = 0; c < 16; ++c)
      t[r + c] = o[c];
    return t;
  }
  return i3(o);
}
class jn extends Error {
  constructor(t) {
    super(t), this.name = "InvalidDataError";
  }
}
function mu() {
  return o3().slice(0, 8);
}
function s3(a) {
  return encodeURIComponent(JSON.stringify(a));
}
const l3 = /[!'()*]/g, f3 = (a) => "%" + a.charCodeAt(0).toString(16), u3 = /%2C/g, Qo = (a) => encodeURIComponent(a).replace(l3, f3).replace(u3, ",");
function md(a) {
  return a.replace("&", "&#38;").replace("<", "&#60;").replace(">", "&#62;");
}
function h3(a) {
  const t = a ? Object.keys(a).map((r) => {
    const o = a[r];
    if (o === void 0)
      return "";
    if (o === null)
      return Qo(r);
    if (Array.isArray(o)) {
      const c = [];
      return o.forEach((d) => {
        d !== void 0 && (d === null ? c.push(Qo(r)) : c.push(Qo(r) + "=" + Qo(d)));
      }), c.join("&");
    }
    return Qo(r) + "=" + Qo(o);
  }).filter((r) => r.length > 0).join("&") : null;
  return t ? `?${t}` : "";
}
function c3(a) {
  if (a.endsWith(".jpeg") || a.endsWith(".jpg"))
    return "image/jpeg";
  if (a.endsWith(".png"))
    return "image/png";
  if (a.endsWith(".svg") || a.endsWith(".svgz"))
    return "image/svg+xml";
  throw new jn(`Unknown mimetype for filename ${a}`);
}
const kh = (a) => {
  for (const t in a)
    a[t] === void 0 ? delete a[t] : typeof a[t] == "object" && kh(a[t]);
}, Fn = (a, t, r) => {
  for (const o in t)
    t[o] === null ? r !== void 0 ? a[o] = r[o] : a[o] = void 0 : typeof t[o] != "object" || Array.isArray(t[o]) ? a[o] = t[o] : (a[o] || (a[o] = {}), Fn(a[o], t[o], r ? r[o] : void 0));
}, ns = (a, t) => {
  for (const r in t)
    a[r] !== void 0 && (t[r] === null ? a[r] = void 0 : typeof t[r] != "object" || Array.isArray(t[r]) ? a[r] = t[r] : (a[r] || (a[r] = {}), ns(a[r], t[r])));
}, Pv = (a, t, r, o) => {
  let c, d, u, l, e, s, i, f = parseInt, h = Math.round, v = typeof r == "string";
  if (typeof a != "number" || a < -1 || a > 1 || typeof t != "string" || t[0] != "r" && t[0] != "#" || r && !v)
    return null;
  const p = (m) => {
    let x = m.length, g = {};
    if (x > 9) {
      if ([c, d, u, v] = m = m.split(","), x = m.length, x < 3 || x > 4)
        return null;
      g.r = f(c[3] == "a" ? c.slice(5) : c.slice(4)), g.g = f(d), g.b = f(u), g.a = v ? parseFloat(v) : -1;
    } else {
      if (x == 8 || x == 6 || x < 4)
        return null;
      x < 6 && (m = "#" + m[1] + m[1] + m[2] + m[2] + m[3] + m[3] + (x > 4 ? m[4] + m[4] : "")), m = f(m.slice(1), 16), x == 9 || x == 5 ? (g.r = m >> 24 & 255, g.g = m >> 16 & 255, g.b = m >> 8 & 255, g.a = h((m & 255) / 0.255) / 1e3) : (g.r = m >> 16, g.g = m >> 8 & 255, g.b = m & 255, g.a = -1);
    }
    return g;
  };
  return i = t.length > 9, i = v ? r.length > 9 ? !0 : r == "c" ? !i : !1 : i, e = p(t), l = a < 0, s = r && r != "c" ? p(r) : l ? { r: 0, g: 0, b: 0, a: -1 } : { r: 255, g: 255, b: 255, a: -1 }, a = l ? a * -1 : a, l = 1 - a, !e || !s ? null : (o ? (c = h(l * e.r + a * s.r), d = h(l * e.g + a * s.g), u = h(l * e.b + a * s.b)) : (c = h((l * e.r ** 2 + a * s.r ** 2) ** 0.5), d = h((l * e.g ** 2 + a * s.g ** 2) ** 0.5), u = h((l * e.b ** 2 + a * s.b ** 2) ** 0.5)), v = e.a, s = s.a, e = v >= 0 || s >= 0, v = e ? v < 0 ? s : s < 0 ? v : v * l + s * a : 0, i ? "rgb" + (e ? "a(" : "(") + c + "," + d + "," + u + (e ? "," + h(v * 1e3) / 1e3 : "") + ")" : "#" + (4294967296 + c * 16777216 + d * 65536 + u * 256 + (e ? h(v * 255) : 0)).toString(16).slice(1, e ? void 0 : -2));
}, d3 = (a, t, r) => {
  if (a !== void 0)
    return a[t] !== void 0 ? a[t] : a[r] !== void 0 ? a[r] : a[Object.keys(a)[0]];
};
var Nh = { exports: {} };
Nh.exports;
(function(a) {
  var t = function() {
    var r = String.fromCharCode, o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", c = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$", d = {};
    function u(e, s) {
      if (!d[e]) {
        d[e] = {};
        for (var i = 0; i < e.length; i++)
          d[e][e.charAt(i)] = i;
      }
      return d[e][s];
    }
    var l = {
      compressToBase64: function(e) {
        if (e == null)
          return "";
        var s = l._compress(e, 6, function(i) {
          return o.charAt(i);
        });
        switch (s.length % 4) {
          default:
          case 0:
            return s;
          case 1:
            return s + "===";
          case 2:
            return s + "==";
          case 3:
            return s + "=";
        }
      },
      decompressFromBase64: function(e) {
        return e == null ? "" : e == "" ? null : l._decompress(e.length, 32, function(s) {
          return u(o, e.charAt(s));
        });
      },
      compressToUTF16: function(e) {
        return e == null ? "" : l._compress(e, 15, function(s) {
          return r(s + 32);
        }) + " ";
      },
      decompressFromUTF16: function(e) {
        return e == null ? "" : e == "" ? null : l._decompress(e.length, 16384, function(s) {
          return e.charCodeAt(s) - 32;
        });
      },
      //compress into uint8array (UCS-2 big endian format)
      compressToUint8Array: function(e) {
        for (var s = l.compress(e), i = new Uint8Array(s.length * 2), f = 0, h = s.length; f < h; f++) {
          var v = s.charCodeAt(f);
          i[f * 2] = v >>> 8, i[f * 2 + 1] = v % 256;
        }
        return i;
      },
      //decompress from uint8array (UCS-2 big endian format)
      decompressFromUint8Array: function(e) {
        if (e == null)
          return l.decompress(e);
        for (var s = new Array(e.length / 2), i = 0, f = s.length; i < f; i++)
          s[i] = e[i * 2] * 256 + e[i * 2 + 1];
        var h = [];
        return s.forEach(function(v) {
          h.push(r(v));
        }), l.decompress(h.join(""));
      },
      //compress into a string that is already URI encoded
      compressToEncodedURIComponent: function(e) {
        return e == null ? "" : l._compress(e, 6, function(s) {
          return c.charAt(s);
        });
      },
      //decompress from an output of compressToEncodedURIComponent
      decompressFromEncodedURIComponent: function(e) {
        return e == null ? "" : e == "" ? null : (e = e.replace(/ /g, "+"), l._decompress(e.length, 32, function(s) {
          return u(c, e.charAt(s));
        }));
      },
      compress: function(e) {
        return l._compress(e, 16, function(s) {
          return r(s);
        });
      },
      _compress: function(e, s, i) {
        if (e == null)
          return "";
        var f, h, v = {}, p = {}, m = "", x = "", g = "", S = 2, y = 3, b = 2, n = [], w = 0, E = 0, A;
        for (A = 0; A < e.length; A += 1)
          if (m = e.charAt(A), Object.prototype.hasOwnProperty.call(v, m) || (v[m] = y++, p[m] = !0), x = g + m, Object.prototype.hasOwnProperty.call(v, x))
            g = x;
          else {
            if (Object.prototype.hasOwnProperty.call(p, g)) {
              if (g.charCodeAt(0) < 256) {
                for (f = 0; f < b; f++)
                  w = w << 1, E == s - 1 ? (E = 0, n.push(i(w)), w = 0) : E++;
                for (h = g.charCodeAt(0), f = 0; f < 8; f++)
                  w = w << 1 | h & 1, E == s - 1 ? (E = 0, n.push(i(w)), w = 0) : E++, h = h >> 1;
              } else {
                for (h = 1, f = 0; f < b; f++)
                  w = w << 1 | h, E == s - 1 ? (E = 0, n.push(i(w)), w = 0) : E++, h = 0;
                for (h = g.charCodeAt(0), f = 0; f < 16; f++)
                  w = w << 1 | h & 1, E == s - 1 ? (E = 0, n.push(i(w)), w = 0) : E++, h = h >> 1;
              }
              S--, S == 0 && (S = Math.pow(2, b), b++), delete p[g];
            } else
              for (h = v[g], f = 0; f < b; f++)
                w = w << 1 | h & 1, E == s - 1 ? (E = 0, n.push(i(w)), w = 0) : E++, h = h >> 1;
            S--, S == 0 && (S = Math.pow(2, b), b++), v[x] = y++, g = String(m);
          }
        if (g !== "") {
          if (Object.prototype.hasOwnProperty.call(p, g)) {
            if (g.charCodeAt(0) < 256) {
              for (f = 0; f < b; f++)
                w = w << 1, E == s - 1 ? (E = 0, n.push(i(w)), w = 0) : E++;
              for (h = g.charCodeAt(0), f = 0; f < 8; f++)
                w = w << 1 | h & 1, E == s - 1 ? (E = 0, n.push(i(w)), w = 0) : E++, h = h >> 1;
            } else {
              for (h = 1, f = 0; f < b; f++)
                w = w << 1 | h, E == s - 1 ? (E = 0, n.push(i(w)), w = 0) : E++, h = 0;
              for (h = g.charCodeAt(0), f = 0; f < 16; f++)
                w = w << 1 | h & 1, E == s - 1 ? (E = 0, n.push(i(w)), w = 0) : E++, h = h >> 1;
            }
            S--, S == 0 && (S = Math.pow(2, b), b++), delete p[g];
          } else
            for (h = v[g], f = 0; f < b; f++)
              w = w << 1 | h & 1, E == s - 1 ? (E = 0, n.push(i(w)), w = 0) : E++, h = h >> 1;
          S--, S == 0 && (S = Math.pow(2, b), b++);
        }
        for (h = 2, f = 0; f < b; f++)
          w = w << 1 | h & 1, E == s - 1 ? (E = 0, n.push(i(w)), w = 0) : E++, h = h >> 1;
        for (; ; )
          if (w = w << 1, E == s - 1) {
            n.push(i(w));
            break;
          } else
            E++;
        return n.join("");
      },
      decompress: function(e) {
        return e == null ? "" : e == "" ? null : l._decompress(e.length, 32768, function(s) {
          return e.charCodeAt(s);
        });
      },
      _decompress: function(e, s, i) {
        var f = [], h = 4, v = 4, p = 3, m = "", x = [], g, S, y, b, n, w, E, A = { val: i(0), position: s, index: 1 };
        for (g = 0; g < 3; g += 1)
          f[g] = g;
        for (y = 0, n = Math.pow(2, 2), w = 1; w != n; )
          b = A.val & A.position, A.position >>= 1, A.position == 0 && (A.position = s, A.val = i(A.index++)), y |= (b > 0 ? 1 : 0) * w, w <<= 1;
        switch (y) {
          case 0:
            for (y = 0, n = Math.pow(2, 8), w = 1; w != n; )
              b = A.val & A.position, A.position >>= 1, A.position == 0 && (A.position = s, A.val = i(A.index++)), y |= (b > 0 ? 1 : 0) * w, w <<= 1;
            E = r(y);
            break;
          case 1:
            for (y = 0, n = Math.pow(2, 16), w = 1; w != n; )
              b = A.val & A.position, A.position >>= 1, A.position == 0 && (A.position = s, A.val = i(A.index++)), y |= (b > 0 ? 1 : 0) * w, w <<= 1;
            E = r(y);
            break;
          case 2:
            return "";
        }
        for (f[3] = E, S = E, x.push(E); ; ) {
          if (A.index > e)
            return "";
          for (y = 0, n = Math.pow(2, p), w = 1; w != n; )
            b = A.val & A.position, A.position >>= 1, A.position == 0 && (A.position = s, A.val = i(A.index++)), y |= (b > 0 ? 1 : 0) * w, w <<= 1;
          switch (E = y) {
            case 0:
              for (y = 0, n = Math.pow(2, 8), w = 1; w != n; )
                b = A.val & A.position, A.position >>= 1, A.position == 0 && (A.position = s, A.val = i(A.index++)), y |= (b > 0 ? 1 : 0) * w, w <<= 1;
              f[v++] = r(y), E = v - 1, h--;
              break;
            case 1:
              for (y = 0, n = Math.pow(2, 16), w = 1; w != n; )
                b = A.val & A.position, A.position >>= 1, A.position == 0 && (A.position = s, A.val = i(A.index++)), y |= (b > 0 ? 1 : 0) * w, w <<= 1;
              f[v++] = r(y), E = v - 1, h--;
              break;
            case 2:
              return x.join("");
          }
          if (h == 0 && (h = Math.pow(2, p), p++), f[E])
            m = f[E];
          else if (E === v)
            m = S + S.charAt(0);
          else
            return null;
          x.push(m), f[v++] = S + m.charAt(0), h--, S = m, h == 0 && (h = Math.pow(2, p), p++);
        }
      }
    };
    return l;
  }();
  a != null ? a.exports = t : typeof angular < "u" && angular != null && angular.module("LZString", []).factory("LZString", function() {
    return t;
  });
})(Nh);
var v3 = Nh.exports;
const g3 = /* @__PURE__ */ Ro(v3);
function Ov(a, t) {
  return (a - 0.5) * t;
}
function xd(a, t) {
  return a / t + 0.5;
}
function p3(a, t) {
  const r = Ov(a, t);
  return t / 2 + r;
}
function y3(a, t) {
  const r = Ov(a, t);
  return t / 2 + r;
}
function Eo(a, t) {
  return { x: p3(a.x, t.width), y: y3(a.y, t.height) };
}
function Rl(a, t) {
  const r = { x: t.width / 2, y: t.height / 2 }, o = a.x - r.x, c = a.y - r.y;
  return { x: xd(o, t.width), y: xd(c, t.height) };
}
function oi(a) {
  return a / 0.75;
}
var m3 = "Expected a function", Fv = "__lodash_hash_undefined__", Iv = 1 / 0, x3 = "[object Function]", b3 = "[object GeneratorFunction]", w3 = "[object Symbol]", S3 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, E3 = /^\w*$/, A3 = /^\./, C3 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, T3 = /[\\^$.*+?()[\]{}|]/g, P3 = /\\(\\)?/g, O3 = /^\[object .+?Constructor\]$/, F3 = typeof ki == "object" && ki && ki.Object === Object && ki, I3 = typeof self == "object" && self && self.Object === Object && self, Lh = F3 || I3 || Function("return this")();
function R3(a, t) {
  return a == null ? void 0 : a[t];
}
function D3(a) {
  var t = !1;
  if (a != null && typeof a.toString != "function")
    try {
      t = !!(a + "");
    } catch {
    }
  return t;
}
var M3 = Array.prototype, B3 = Function.prototype, Rv = Object.prototype, xu = Lh["__core-js_shared__"], bd = function() {
  var a = /[^.]+$/.exec(xu && xu.keys && xu.keys.IE_PROTO || "");
  return a ? "Symbol(src)_1." + a : "";
}(), Dv = B3.toString, Uh = Rv.hasOwnProperty, Mv = Rv.toString, k3 = RegExp(
  "^" + Dv.call(Uh).replace(T3, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
), wd = Lh.Symbol, N3 = M3.splice, L3 = Bv(Lh, "Map"), s0 = Bv(Object, "create"), Sd = wd ? wd.prototype : void 0, Ed = Sd ? Sd.toString : void 0;
function Ao(a) {
  var t = -1, r = a ? a.length : 0;
  for (this.clear(); ++t < r; ) {
    var o = a[t];
    this.set(o[0], o[1]);
  }
}
function U3() {
  this.__data__ = s0 ? s0(null) : {};
}
function z3(a) {
  return this.has(a) && delete this.__data__[a];
}
function G3(a) {
  var t = this.__data__;
  if (s0) {
    var r = t[a];
    return r === Fv ? void 0 : r;
  }
  return Uh.call(t, a) ? t[a] : void 0;
}
function V3(a) {
  var t = this.__data__;
  return s0 ? t[a] !== void 0 : Uh.call(t, a);
}
function H3(a, t) {
  var r = this.__data__;
  return r[a] = s0 && t === void 0 ? Fv : t, this;
}
Ao.prototype.clear = U3;
Ao.prototype.delete = z3;
Ao.prototype.get = G3;
Ao.prototype.has = V3;
Ao.prototype.set = H3;
function ms(a) {
  var t = -1, r = a ? a.length : 0;
  for (this.clear(); ++t < r; ) {
    var o = a[t];
    this.set(o[0], o[1]);
  }
}
function W3() {
  this.__data__ = [];
}
function _3(a) {
  var t = this.__data__, r = Wl(t, a);
  if (r < 0)
    return !1;
  var o = t.length - 1;
  return r == o ? t.pop() : N3.call(t, r, 1), !0;
}
function j3(a) {
  var t = this.__data__, r = Wl(t, a);
  return r < 0 ? void 0 : t[r][1];
}
function X3(a) {
  return Wl(this.__data__, a) > -1;
}
function Y3(a, t) {
  var r = this.__data__, o = Wl(r, a);
  return o < 0 ? r.push([a, t]) : r[o][1] = t, this;
}
ms.prototype.clear = W3;
ms.prototype.delete = _3;
ms.prototype.get = j3;
ms.prototype.has = X3;
ms.prototype.set = Y3;
function Do(a) {
  var t = -1, r = a ? a.length : 0;
  for (this.clear(); ++t < r; ) {
    var o = a[t];
    this.set(o[0], o[1]);
  }
}
function Z3() {
  this.__data__ = {
    hash: new Ao(),
    map: new (L3 || ms)(),
    string: new Ao()
  };
}
function K3(a) {
  return _l(this, a).delete(a);
}
function J3(a) {
  return _l(this, a).get(a);
}
function Q3(a) {
  return _l(this, a).has(a);
}
function $3(a, t) {
  return _l(this, a).set(a, t), this;
}
Do.prototype.clear = Z3;
Do.prototype.delete = K3;
Do.prototype.get = J3;
Do.prototype.has = Q3;
Do.prototype.set = $3;
function Wl(a, t) {
  for (var r = a.length; r--; )
    if (f8(a[r][0], t))
      return r;
  return -1;
}
function q3(a, t) {
  t = n8(t, a) ? [t] : r8(t);
  for (var r = 0, o = t.length; a != null && r < o; )
    a = a[s8(t[r++])];
  return r && r == o ? a : void 0;
}
function t8(a) {
  if (!Nv(a) || a8(a))
    return !1;
  var t = u8(a) || D3(a) ? k3 : O3;
  return t.test(l8(a));
}
function e8(a) {
  if (typeof a == "string")
    return a;
  if (Gh(a))
    return Ed ? Ed.call(a) : "";
  var t = a + "";
  return t == "0" && 1 / a == -Iv ? "-0" : t;
}
function r8(a) {
  return kv(a) ? a : o8(a);
}
function _l(a, t) {
  var r = a.__data__;
  return i8(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
function Bv(a, t) {
  var r = R3(a, t);
  return t8(r) ? r : void 0;
}
function n8(a, t) {
  if (kv(a))
    return !1;
  var r = typeof a;
  return r == "number" || r == "symbol" || r == "boolean" || a == null || Gh(a) ? !0 : E3.test(a) || !S3.test(a) || t != null && a in Object(t);
}
function i8(a) {
  var t = typeof a;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? a !== "__proto__" : a === null;
}
function a8(a) {
  return !!bd && bd in a;
}
var o8 = zh(function(a) {
  a = c8(a);
  var t = [];
  return A3.test(a) && t.push(""), a.replace(C3, function(r, o, c, d) {
    t.push(c ? d.replace(P3, "$1") : o || r);
  }), t;
});
function s8(a) {
  if (typeof a == "string" || Gh(a))
    return a;
  var t = a + "";
  return t == "0" && 1 / a == -Iv ? "-0" : t;
}
function l8(a) {
  if (a != null) {
    try {
      return Dv.call(a);
    } catch {
    }
    try {
      return a + "";
    } catch {
    }
  }
  return "";
}
function zh(a, t) {
  if (typeof a != "function" || t && typeof t != "function")
    throw new TypeError(m3);
  var r = function() {
    var o = arguments, c = t ? t.apply(this, o) : o[0], d = r.cache;
    if (d.has(c))
      return d.get(c);
    var u = a.apply(this, o);
    return r.cache = d.set(c, u), u;
  };
  return r.cache = new (zh.Cache || Do)(), r;
}
zh.Cache = Do;
function f8(a, t) {
  return a === t || a !== a && t !== t;
}
var kv = Array.isArray;
function u8(a) {
  var t = Nv(a) ? Mv.call(a) : "";
  return t == x3 || t == b3;
}
function Nv(a) {
  var t = typeof a;
  return !!a && (t == "object" || t == "function");
}
function h8(a) {
  return !!a && typeof a == "object";
}
function Gh(a) {
  return typeof a == "symbol" || h8(a) && Mv.call(a) == w3;
}
function c8(a) {
  return a == null ? "" : e8(a);
}
function d8(a, t, r) {
  var o = a == null ? void 0 : q3(a, t);
  return o === void 0 ? r : o;
}
var v8 = d8;
const Or = /* @__PURE__ */ Ro(v8);
var g8 = "Expected a function", Lv = "__lodash_hash_undefined__", Uv = 1 / 0, p8 = 9007199254740991, y8 = "[object Function]", m8 = "[object GeneratorFunction]", x8 = "[object Symbol]", b8 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, w8 = /^\w*$/, S8 = /^\./, E8 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, A8 = /[\\^$.*+?()[\]{}|]/g, C8 = /\\(\\)?/g, T8 = /^\[object .+?Constructor\]$/, P8 = /^(?:0|[1-9]\d*)$/, O8 = typeof ki == "object" && ki && ki.Object === Object && ki, F8 = typeof self == "object" && self && self.Object === Object && self, Vh = O8 || F8 || Function("return this")();
function I8(a, t) {
  return a == null ? void 0 : a[t];
}
function R8(a) {
  var t = !1;
  if (a != null && typeof a.toString != "function")
    try {
      t = !!(a + "");
    } catch {
    }
  return t;
}
var D8 = Array.prototype, M8 = Function.prototype, zv = Object.prototype, bu = Vh["__core-js_shared__"], Ad = function() {
  var a = /[^.]+$/.exec(bu && bu.keys && bu.keys.IE_PROTO || "");
  return a ? "Symbol(src)_1." + a : "";
}(), Gv = M8.toString, jl = zv.hasOwnProperty, Vv = zv.toString, B8 = RegExp(
  "^" + Gv.call(jl).replace(A8, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
), Cd = Vh.Symbol, k8 = D8.splice, N8 = Hv(Vh, "Map"), l0 = Hv(Object, "create"), Td = Cd ? Cd.prototype : void 0, Pd = Td ? Td.toString : void 0;
function Co(a) {
  var t = -1, r = a ? a.length : 0;
  for (this.clear(); ++t < r; ) {
    var o = a[t];
    this.set(o[0], o[1]);
  }
}
function L8() {
  this.__data__ = l0 ? l0(null) : {};
}
function U8(a) {
  return this.has(a) && delete this.__data__[a];
}
function z8(a) {
  var t = this.__data__;
  if (l0) {
    var r = t[a];
    return r === Lv ? void 0 : r;
  }
  return jl.call(t, a) ? t[a] : void 0;
}
function G8(a) {
  var t = this.__data__;
  return l0 ? t[a] !== void 0 : jl.call(t, a);
}
function V8(a, t) {
  var r = this.__data__;
  return r[a] = l0 && t === void 0 ? Lv : t, this;
}
Co.prototype.clear = L8;
Co.prototype.delete = U8;
Co.prototype.get = z8;
Co.prototype.has = G8;
Co.prototype.set = V8;
function xs(a) {
  var t = -1, r = a ? a.length : 0;
  for (this.clear(); ++t < r; ) {
    var o = a[t];
    this.set(o[0], o[1]);
  }
}
function H8() {
  this.__data__ = [];
}
function W8(a) {
  var t = this.__data__, r = Xl(t, a);
  if (r < 0)
    return !1;
  var o = t.length - 1;
  return r == o ? t.pop() : k8.call(t, r, 1), !0;
}
function _8(a) {
  var t = this.__data__, r = Xl(t, a);
  return r < 0 ? void 0 : t[r][1];
}
function j8(a) {
  return Xl(this.__data__, a) > -1;
}
function X8(a, t) {
  var r = this.__data__, o = Xl(r, a);
  return o < 0 ? r.push([a, t]) : r[o][1] = t, this;
}
xs.prototype.clear = H8;
xs.prototype.delete = W8;
xs.prototype.get = _8;
xs.prototype.has = j8;
xs.prototype.set = X8;
function Mo(a) {
  var t = -1, r = a ? a.length : 0;
  for (this.clear(); ++t < r; ) {
    var o = a[t];
    this.set(o[0], o[1]);
  }
}
function Y8() {
  this.__data__ = {
    hash: new Co(),
    map: new (N8 || xs)(),
    string: new Co()
  };
}
function Z8(a) {
  return Yl(this, a).delete(a);
}
function K8(a) {
  return Yl(this, a).get(a);
}
function J8(a) {
  return Yl(this, a).has(a);
}
function Q8(a, t) {
  return Yl(this, a).set(a, t), this;
}
Mo.prototype.clear = Y8;
Mo.prototype.delete = Z8;
Mo.prototype.get = K8;
Mo.prototype.has = J8;
Mo.prototype.set = Q8;
function $8(a, t, r) {
  var o = a[t];
  (!(jl.call(a, t) && Wv(o, r)) || r === void 0 && !(t in a)) && (a[t] = r);
}
function Xl(a, t) {
  for (var r = a.length; r--; )
    if (Wv(a[r][0], t))
      return r;
  return -1;
}
function q8(a) {
  if (!Dl(a) || ox(a))
    return !1;
  var t = ux(a) || R8(a) ? B8 : T8;
  return t.test(fx(a));
}
function tx(a, t, r, o) {
  if (!Dl(a))
    return a;
  t = ix(t, a) ? [t] : rx(t);
  for (var c = -1, d = t.length, u = d - 1, l = a; l != null && ++c < d; ) {
    var e = lx(t[c]), s = r;
    if (c != u) {
      var i = l[e];
      s = o ? o(i, e, l) : void 0, s === void 0 && (s = Dl(i) ? i : nx(t[c + 1]) ? [] : {});
    }
    $8(l, e, s), l = l[e];
  }
  return a;
}
function ex(a) {
  if (typeof a == "string")
    return a;
  if (Wh(a))
    return Pd ? Pd.call(a) : "";
  var t = a + "";
  return t == "0" && 1 / a == -Uv ? "-0" : t;
}
function rx(a) {
  return _v(a) ? a : sx(a);
}
function Yl(a, t) {
  var r = a.__data__;
  return ax(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
function Hv(a, t) {
  var r = I8(a, t);
  return q8(r) ? r : void 0;
}
function nx(a, t) {
  return t = t ?? p8, !!t && (typeof a == "number" || P8.test(a)) && a > -1 && a % 1 == 0 && a < t;
}
function ix(a, t) {
  if (_v(a))
    return !1;
  var r = typeof a;
  return r == "number" || r == "symbol" || r == "boolean" || a == null || Wh(a) ? !0 : w8.test(a) || !b8.test(a) || t != null && a in Object(t);
}
function ax(a) {
  var t = typeof a;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? a !== "__proto__" : a === null;
}
function ox(a) {
  return !!Ad && Ad in a;
}
var sx = Hh(function(a) {
  a = cx(a);
  var t = [];
  return S8.test(a) && t.push(""), a.replace(E8, function(r, o, c, d) {
    t.push(c ? d.replace(C8, "$1") : o || r);
  }), t;
});
function lx(a) {
  if (typeof a == "string" || Wh(a))
    return a;
  var t = a + "";
  return t == "0" && 1 / a == -Uv ? "-0" : t;
}
function fx(a) {
  if (a != null) {
    try {
      return Gv.call(a);
    } catch {
    }
    try {
      return a + "";
    } catch {
    }
  }
  return "";
}
function Hh(a, t) {
  if (typeof a != "function" || t && typeof t != "function")
    throw new TypeError(g8);
  var r = function() {
    var o = arguments, c = t ? t.apply(this, o) : o[0], d = r.cache;
    if (d.has(c))
      return d.get(c);
    var u = a.apply(this, o);
    return r.cache = d.set(c, u), u;
  };
  return r.cache = new (Hh.Cache || Mo)(), r;
}
Hh.Cache = Mo;
function Wv(a, t) {
  return a === t || a !== a && t !== t;
}
var _v = Array.isArray;
function ux(a) {
  var t = Dl(a) ? Vv.call(a) : "";
  return t == y8 || t == m8;
}
function Dl(a) {
  var t = typeof a;
  return !!a && (t == "object" || t == "function");
}
function hx(a) {
  return !!a && typeof a == "object";
}
function Wh(a) {
  return typeof a == "symbol" || hx(a) && Vv.call(a) == x8;
}
function cx(a) {
  return a == null ? "" : ex(a);
}
function dx(a, t, r) {
  return a == null ? a : tx(a, t, r);
}
var vx = dx;
const $s = /* @__PURE__ */ Ro(vx);
class Zl {
  constructor(t, r) {
    _e(this, "vida");
    _e(this, "_undoHistory", []);
    _e(this, "_redoHistory", []);
    _e(this, "konvaTransformer");
    _e(this, "konvaElement");
    _e(this, "options");
    _e(this, "editingLocale");
    _e(this, "displayedLocale");
    _e(this, "displayedPosition");
    _e(this, "documentSize");
    this.vida = t, this.vida.draw(), this.options = {
      id: r,
      i18n: {}
    }, this.editingLocale = null, this.displayedLocale = null, this.displayedPosition = { x: 0, y: 0 }, this.documentSize = { width: 0, height: 0 };
  }
  id() {
    return this.options.id;
  }
  /**
   * WARNING, zIndex is not supported on i18n
   * @returns
   */
  zIndex() {
    return this.options.zIndex;
  }
  select() {
    console.warn("select should be overriden");
  }
  unselect() {
    console.warn("unselect should be overriden");
  }
  /**
   * Backup current state to allow undo
   * Currently does not check if the options
   * really change something
   *
   * @param options
   */
  _oppositOption(t) {
    const r = {};
    return Fn(r, t, void 0), ns(r, this.options), r;
  }
  /**
   * While backupcurrentstate creates a new entry in undohistory,
   * appendtocurrentbackup adds the options args to the last
   * entry in undohistory
   *
   * @param options
   */
  _appendToCurrentBackup(t) {
    const r = this._undoHistory[this._undoHistory.length - 1];
    this._undoHistory[this._undoHistory.length - 1] = {
      ...this._oppositOption(t),
      ...r
    };
  }
  /**
   *
   * Sometimes the combination of backupCurrentState({}) and
   * appendtocurrentbackup build empty entris in undohistory
   * This is the case when movements are constrained by rules for ex
   *
   * @returns Boolean { true if a clean was done, false elsewhere }
   */
  _cleanUndoHistory() {
    if (this._undoHistory.length <= 1)
      return;
    const t = this._undoHistory[this._undoHistory.length - 1];
    return Object.keys(t).length === 0 ? (this._undoHistory.pop(), !0) : !1;
  }
  _backupCurrentState(t) {
    this._undoHistory.push(this._oppositOption(t)), this._redoHistory = [];
  }
  /**
   * This function makes an undo to the component.
   * It means it reverts the last changes made.
   * Nothing done if no undo is possible.
   *
   * This method calls the vida.onComponentUpdated hook.
   *
   * @returns
   */
  undo() {
    if (!this.canUndo())
      return;
    const t = this._undoHistory.pop();
    return this._redoHistory.push(this._oppositOption(t)), new Promise((r, o) => {
      this._update(t, this.documentSize).then((c) => {
        this.vida.onComponentUpdated(this.id()), r(c);
      }).catch((c) => o(c));
    });
  }
  /**
   * This functions makes a redo to the component.
   * Redo are currently very simple: if you undo, you can redo,
   * as long as you need it.
   * BUT if you edit by hand your component, you cannot redo anymore.
   * (adding something to your undohistory erases your redohistory)
   *
   * @returns
   */
  redo() {
    if (!this.canRedo())
      return;
    const t = this._redoHistory.pop();
    return this._undoHistory.push(this._oppositOption(t)), new Promise((r, o) => {
      this._update(t, this.documentSize).then((c) => {
        this.vida.onComponentUpdated(this.id()), r(c);
      }).catch((c) => o(c));
    });
  }
  canUndo() {
    return this._undoHistory.length > 1;
  }
  canRedo() {
    return this._redoHistory.length > 0;
  }
  update(t, r) {
    return Object.keys(t).length > 0 && this._backupCurrentState(t), this._update(t, r);
  }
  // Check sur les options possibles.
  // Mise à jour de l'objet selon les options avec l'utilisation d'un cache.
  _update(t, r) {
    if (Fn(this.options, t, void 0), r !== void 0 && r.i18n !== void 0 && r.i18n.editingLocale !== void 0 && r.i18n.editingLocale !== this.editingLocale) {
      delete t.i18n;
      const o = {};
      return Fn(o, t, void 0), this.editingLocale !== void 0 && this.editingLocale !== null && (Fn(o, this.options.i18n[this.editingLocale], void 0), ns(o, this.options)), r.i18n.editingLocale && Fn(o, this.options.i18n[r.i18n.editingLocale], void 0), this.editingLocale = r.i18n.editingLocale, this.internalUpdate(o, r);
    }
    if (r !== void 0 && r.i18n !== void 0 && r.i18n.displayedLocale !== null && // first time
    r.i18n.displayedLocale !== this.displayedLocale) {
      const o = this.vida.document.i18n.defaultLocale, c = {};
      return Fn(c, t, void 0), Fn(c, this.options.i18n[o], void 0), Fn(this.options, this.options.i18n[o], void 0), delete this.options.i18n[o], this.options.i18n[o] = {}, r.i18n.displayedLocale !== o && (Fn(this.options.i18n[o], this.options.i18n[r.i18n.displayedLocale], void 0), Or(this.options.i18n[r.i18n.displayedLocale], "image.id") !== void 0 && $s(this.options.i18n[o], "image", { id: null, colors: this.options.image.colors, type: null }), ns(this.options.i18n[o], this.options), Fn(c, this.options.i18n[r.i18n.displayedLocale], void 0)), Fn(this.options, c, void 0), this.displayedLocale = r.i18n.displayedLocale, this.internalUpdate(c, r);
    }
    return this.editingLocale !== void 0 && (t.i18n !== void 0 && Fn(t, t.i18n[this.editingLocale], this.options), delete t.i18n), this.internalUpdate(t, r);
  }
  internalUpdate(t, r) {
    return console.warn("Internal update should be overriden"), new Promise((o) => o());
  }
  /**
   * RandomInit computes random options for the component
   * and initializes the item
   */
  randomInit(t, r) {
    const o = this.randomOptions(t);
    return o.zIndex = this.vida.components.length + 1, this.update(o, r);
  }
  randomOptions(t) {
    return console.warn("Destroy should be overriden"), {};
  }
  destroy() {
    console.warn("Destroy should be overriden");
  }
  remove() {
    this.konvaTransformer && this.konvaTransformer.destroy(), this.konvaElement && this.konvaElement.destroy(), this.vida.draw();
  }
  // Export des options. Utilisable pour un composant d'input par ex. ou pour la sauvegarde des données
  toJson() {
    return { ...this.options };
  }
  async toPdf() {
    return console.warn("toPdf should be overriden"), {
      content: [],
      status: "unsupported_option"
    };
  }
  /**
   *
   * This function should be called anytime the position of the
   * konva element changed thanks to Konva drag feature
   *
   * It synchronizes the konva position to the options.values
   * AND backup the previous values to the current backup state
   * YOU HAVE TO CALL this._backupCurrentState({}) BEFORE
   * IF YOU WANT TO BACKUP VALUES IN A NEW UNDO STATE
   *
   * @returns
   */
  _adjustPosition() {
    if (!this.konvaElement)
      return;
    (Or(this.options.rules, "position.fixed") || Or(this.options.rules, "self.fixed")) && this.konvaElement.setAttrs(Eo(this.displayedPosition, this.documentSize));
    const t = Rl({ x: this.konvaElement.x(), y: this.konvaElement.y() }, this.documentSize);
    let r = !1, o = Or(this.options.rules, "position.properties.x", {});
    o.fixed !== void 0 && o.fixed ? (t.x = this.displayedPosition.x, r = !0) : (o.min !== void 0 && t.x < o.min && (t.x = o.min, r = !0), o.max !== void 0 && t.x > o.max && (t.x = o.max, r = !0));
    let c = Or(this.options.rules, "position.properties.y", {});
    c.fixed !== void 0 && c.fixed ? (t.y = this.displayedPosition.y, r = !0) : (c.min !== void 0 && t.y < c.min && (t.y = c.min, r = !0), c.max !== void 0 && t.y > c.max && (t.y = c.max, r = !0));
    const d = {};
    Math.abs(this.displayedPosition.x - t.x) > 1e-4 && (d.x = t.x), Math.abs(this.displayedPosition.y - t.y) > 1e-4 && (d.y = t.y), r && this.konvaElement.setAttrs(Eo(t, this.documentSize)), !(d.x === void 0 && d.y === void 0) && (Fn(this.displayedPosition, d, void 0), this.editingLocale !== null ? (this._appendToCurrentBackup({ i18n: { [this.editingLocale]: { position: d } } }), Fn(this.options.i18n, { [this.editingLocale]: { position: d } }, void 0)) : (this._appendToCurrentBackup({ position: d }), Fn(this.options.position, d, void 0)));
  }
  _adjustAngle() {
    var c;
    if (!this.konvaElement)
      return;
    let t = this.currentAngle(), r = !1;
    const o = Or(this.options.rules, "angle", {});
    if (o.fixed !== void 0 && o.fixed ? (t = this.optionsValue("angle"), r = !0) : (o.min !== void 0 && t < o.min && (t = o.min, r = !0), o.max !== void 0 && t > o.max && (t = o.max, r = !0)), r && ((c = this.konvaElement) == null || c.rotation(t)), this.editingLocale !== null) {
      let d = Or(this.options.i18n, `${this.editingLocale}.angle`);
      d === void 0 && (d = this.options.angle), Math.abs(d - t) > 0.1 && (this._appendToCurrentBackup({ i18n: { [this.editingLocale]: { angle: t } } }), Fn(this.options.i18n, { [this.editingLocale]: { angle: t } }, void 0));
    } else {
      const d = this.options.angle;
      Math.abs(d - t) > 0.1 && (this._appendToCurrentBackup({ angle: t }), this.options.angle = t);
    }
  }
  currentAngle() {
    if (this.konvaElement)
      return this.konvaElement.rotation();
  }
  optionsValue(t) {
    return this.editingLocale !== null && Or(this.options.i18n, `${this.editingLocale}.${t}`) !== void 0 ? Or(this.options.i18n, `${this.editingLocale}.${t}`) : Or(this.options, t);
  }
  allowedActions() {
    if (Or(this.options.rules, "self.fixed"))
      return /* @__PURE__ */ new Set();
    const t = /* @__PURE__ */ new Set(["remove", "duplicate", "forward", "backward"]);
    return Or(this.options.rules, "presence.fixed") && t.delete("remove"), Or(this.options.rules, "unicity.fixed") && t.delete("duplicate"), Or(this.options.rules, "zIndex.fixed") && (t.delete("forward"), t.delete("backward")), t;
  }
}
/*! pako 2.1.0 https://github.com/nodeca/pako @license (MIT AND Zlib) */
const gx = 4, Od = 0, Fd = 1, px = 2;
function bs(a) {
  let t = a.length;
  for (; --t >= 0; )
    a[t] = 0;
}
const yx = 0, jv = 1, mx = 2, xx = 3, bx = 258, _h = 29, S0 = 256, f0 = S0 + 1 + _h, is = 30, jh = 19, Xv = 2 * f0 + 1, xo = 15, wu = 16, wx = 7, Xh = 256, Yv = 16, Zv = 17, Kv = 18, ih = (
  /* extra bits for each length code */
  new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0])
), Pl = (
  /* extra bits for each distance code */
  new Uint8Array([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13])
), Sx = (
  /* extra bits for each bit length code */
  new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7])
), Jv = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), Ex = 512, Pa = new Array((f0 + 2) * 2);
bs(Pa);
const n0 = new Array(is * 2);
bs(n0);
const u0 = new Array(Ex);
bs(u0);
const h0 = new Array(bx - xx + 1);
bs(h0);
const Yh = new Array(_h);
bs(Yh);
const Ml = new Array(is);
bs(Ml);
function Su(a, t, r, o, c) {
  this.static_tree = a, this.extra_bits = t, this.extra_base = r, this.elems = o, this.max_length = c, this.has_stree = a && a.length;
}
let Qv, $v, qv;
function Eu(a, t) {
  this.dyn_tree = a, this.max_code = 0, this.stat_desc = t;
}
const tg = (a) => a < 256 ? u0[a] : u0[256 + (a >>> 7)], c0 = (a, t) => {
  a.pending_buf[a.pending++] = t & 255, a.pending_buf[a.pending++] = t >>> 8 & 255;
}, Di = (a, t, r) => {
  a.bi_valid > wu - r ? (a.bi_buf |= t << a.bi_valid & 65535, c0(a, a.bi_buf), a.bi_buf = t >> wu - a.bi_valid, a.bi_valid += r - wu) : (a.bi_buf |= t << a.bi_valid & 65535, a.bi_valid += r);
}, la = (a, t, r) => {
  Di(
    a,
    r[t * 2],
    r[t * 2 + 1]
    /*.Len*/
  );
}, eg = (a, t) => {
  let r = 0;
  do
    r |= a & 1, a >>>= 1, r <<= 1;
  while (--t > 0);
  return r >>> 1;
}, Ax = (a) => {
  a.bi_valid === 16 ? (c0(a, a.bi_buf), a.bi_buf = 0, a.bi_valid = 0) : a.bi_valid >= 8 && (a.pending_buf[a.pending++] = a.bi_buf & 255, a.bi_buf >>= 8, a.bi_valid -= 8);
}, Cx = (a, t) => {
  const r = t.dyn_tree, o = t.max_code, c = t.stat_desc.static_tree, d = t.stat_desc.has_stree, u = t.stat_desc.extra_bits, l = t.stat_desc.extra_base, e = t.stat_desc.max_length;
  let s, i, f, h, v, p, m = 0;
  for (h = 0; h <= xo; h++)
    a.bl_count[h] = 0;
  for (r[a.heap[a.heap_max] * 2 + 1] = 0, s = a.heap_max + 1; s < Xv; s++)
    i = a.heap[s], h = r[r[i * 2 + 1] * 2 + 1] + 1, h > e && (h = e, m++), r[i * 2 + 1] = h, !(i > o) && (a.bl_count[h]++, v = 0, i >= l && (v = u[i - l]), p = r[i * 2], a.opt_len += p * (h + v), d && (a.static_len += p * (c[i * 2 + 1] + v)));
  if (m !== 0) {
    do {
      for (h = e - 1; a.bl_count[h] === 0; )
        h--;
      a.bl_count[h]--, a.bl_count[h + 1] += 2, a.bl_count[e]--, m -= 2;
    } while (m > 0);
    for (h = e; h !== 0; h--)
      for (i = a.bl_count[h]; i !== 0; )
        f = a.heap[--s], !(f > o) && (r[f * 2 + 1] !== h && (a.opt_len += (h - r[f * 2 + 1]) * r[f * 2], r[f * 2 + 1] = h), i--);
  }
}, rg = (a, t, r) => {
  const o = new Array(xo + 1);
  let c = 0, d, u;
  for (d = 1; d <= xo; d++)
    c = c + r[d - 1] << 1, o[d] = c;
  for (u = 0; u <= t; u++) {
    let l = a[u * 2 + 1];
    l !== 0 && (a[u * 2] = eg(o[l]++, l));
  }
}, Tx = () => {
  let a, t, r, o, c;
  const d = new Array(xo + 1);
  for (r = 0, o = 0; o < _h - 1; o++)
    for (Yh[o] = r, a = 0; a < 1 << ih[o]; a++)
      h0[r++] = o;
  for (h0[r - 1] = o, c = 0, o = 0; o < 16; o++)
    for (Ml[o] = c, a = 0; a < 1 << Pl[o]; a++)
      u0[c++] = o;
  for (c >>= 7; o < is; o++)
    for (Ml[o] = c << 7, a = 0; a < 1 << Pl[o] - 7; a++)
      u0[256 + c++] = o;
  for (t = 0; t <= xo; t++)
    d[t] = 0;
  for (a = 0; a <= 143; )
    Pa[a * 2 + 1] = 8, a++, d[8]++;
  for (; a <= 255; )
    Pa[a * 2 + 1] = 9, a++, d[9]++;
  for (; a <= 279; )
    Pa[a * 2 + 1] = 7, a++, d[7]++;
  for (; a <= 287; )
    Pa[a * 2 + 1] = 8, a++, d[8]++;
  for (rg(Pa, f0 + 1, d), a = 0; a < is; a++)
    n0[a * 2 + 1] = 5, n0[a * 2] = eg(a, 5);
  Qv = new Su(Pa, ih, S0 + 1, f0, xo), $v = new Su(n0, Pl, 0, is, xo), qv = new Su(new Array(0), Sx, 0, jh, wx);
}, ng = (a) => {
  let t;
  for (t = 0; t < f0; t++)
    a.dyn_ltree[t * 2] = 0;
  for (t = 0; t < is; t++)
    a.dyn_dtree[t * 2] = 0;
  for (t = 0; t < jh; t++)
    a.bl_tree[t * 2] = 0;
  a.dyn_ltree[Xh * 2] = 1, a.opt_len = a.static_len = 0, a.sym_next = a.matches = 0;
}, ig = (a) => {
  a.bi_valid > 8 ? c0(a, a.bi_buf) : a.bi_valid > 0 && (a.pending_buf[a.pending++] = a.bi_buf), a.bi_buf = 0, a.bi_valid = 0;
}, Id = (a, t, r, o) => {
  const c = t * 2, d = r * 2;
  return a[c] < a[d] || a[c] === a[d] && o[t] <= o[r];
}, Au = (a, t, r) => {
  const o = a.heap[r];
  let c = r << 1;
  for (; c <= a.heap_len && (c < a.heap_len && Id(t, a.heap[c + 1], a.heap[c], a.depth) && c++, !Id(t, o, a.heap[c], a.depth)); )
    a.heap[r] = a.heap[c], r = c, c <<= 1;
  a.heap[r] = o;
}, Rd = (a, t, r) => {
  let o, c, d = 0, u, l;
  if (a.sym_next !== 0)
    do
      o = a.pending_buf[a.sym_buf + d++] & 255, o += (a.pending_buf[a.sym_buf + d++] & 255) << 8, c = a.pending_buf[a.sym_buf + d++], o === 0 ? la(a, c, t) : (u = h0[c], la(a, u + S0 + 1, t), l = ih[u], l !== 0 && (c -= Yh[u], Di(a, c, l)), o--, u = tg(o), la(a, u, r), l = Pl[u], l !== 0 && (o -= Ml[u], Di(a, o, l)));
    while (d < a.sym_next);
  la(a, Xh, t);
}, ah = (a, t) => {
  const r = t.dyn_tree, o = t.stat_desc.static_tree, c = t.stat_desc.has_stree, d = t.stat_desc.elems;
  let u, l, e = -1, s;
  for (a.heap_len = 0, a.heap_max = Xv, u = 0; u < d; u++)
    r[u * 2] !== 0 ? (a.heap[++a.heap_len] = e = u, a.depth[u] = 0) : r[u * 2 + 1] = 0;
  for (; a.heap_len < 2; )
    s = a.heap[++a.heap_len] = e < 2 ? ++e : 0, r[s * 2] = 1, a.depth[s] = 0, a.opt_len--, c && (a.static_len -= o[s * 2 + 1]);
  for (t.max_code = e, u = a.heap_len >> 1; u >= 1; u--)
    Au(a, r, u);
  s = d;
  do
    u = a.heap[
      1
      /*SMALLEST*/
    ], a.heap[
      1
      /*SMALLEST*/
    ] = a.heap[a.heap_len--], Au(
      a,
      r,
      1
      /*SMALLEST*/
    ), l = a.heap[
      1
      /*SMALLEST*/
    ], a.heap[--a.heap_max] = u, a.heap[--a.heap_max] = l, r[s * 2] = r[u * 2] + r[l * 2], a.depth[s] = (a.depth[u] >= a.depth[l] ? a.depth[u] : a.depth[l]) + 1, r[u * 2 + 1] = r[l * 2 + 1] = s, a.heap[
      1
      /*SMALLEST*/
    ] = s++, Au(
      a,
      r,
      1
      /*SMALLEST*/
    );
  while (a.heap_len >= 2);
  a.heap[--a.heap_max] = a.heap[
    1
    /*SMALLEST*/
  ], Cx(a, t), rg(r, e, a.bl_count);
}, Dd = (a, t, r) => {
  let o, c = -1, d, u = t[0 * 2 + 1], l = 0, e = 7, s = 4;
  for (u === 0 && (e = 138, s = 3), t[(r + 1) * 2 + 1] = 65535, o = 0; o <= r; o++)
    d = u, u = t[(o + 1) * 2 + 1], !(++l < e && d === u) && (l < s ? a.bl_tree[d * 2] += l : d !== 0 ? (d !== c && a.bl_tree[d * 2]++, a.bl_tree[Yv * 2]++) : l <= 10 ? a.bl_tree[Zv * 2]++ : a.bl_tree[Kv * 2]++, l = 0, c = d, u === 0 ? (e = 138, s = 3) : d === u ? (e = 6, s = 3) : (e = 7, s = 4));
}, Md = (a, t, r) => {
  let o, c = -1, d, u = t[0 * 2 + 1], l = 0, e = 7, s = 4;
  for (u === 0 && (e = 138, s = 3), o = 0; o <= r; o++)
    if (d = u, u = t[(o + 1) * 2 + 1], !(++l < e && d === u)) {
      if (l < s)
        do
          la(a, d, a.bl_tree);
        while (--l !== 0);
      else
        d !== 0 ? (d !== c && (la(a, d, a.bl_tree), l--), la(a, Yv, a.bl_tree), Di(a, l - 3, 2)) : l <= 10 ? (la(a, Zv, a.bl_tree), Di(a, l - 3, 3)) : (la(a, Kv, a.bl_tree), Di(a, l - 11, 7));
      l = 0, c = d, u === 0 ? (e = 138, s = 3) : d === u ? (e = 6, s = 3) : (e = 7, s = 4);
    }
}, Px = (a) => {
  let t;
  for (Dd(a, a.dyn_ltree, a.l_desc.max_code), Dd(a, a.dyn_dtree, a.d_desc.max_code), ah(a, a.bl_desc), t = jh - 1; t >= 3 && a.bl_tree[Jv[t] * 2 + 1] === 0; t--)
    ;
  return a.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
}, Ox = (a, t, r, o) => {
  let c;
  for (Di(a, t - 257, 5), Di(a, r - 1, 5), Di(a, o - 4, 4), c = 0; c < o; c++)
    Di(a, a.bl_tree[Jv[c] * 2 + 1], 3);
  Md(a, a.dyn_ltree, t - 1), Md(a, a.dyn_dtree, r - 1);
}, Fx = (a) => {
  let t = 4093624447, r;
  for (r = 0; r <= 31; r++, t >>>= 1)
    if (t & 1 && a.dyn_ltree[r * 2] !== 0)
      return Od;
  if (a.dyn_ltree[9 * 2] !== 0 || a.dyn_ltree[10 * 2] !== 0 || a.dyn_ltree[13 * 2] !== 0)
    return Fd;
  for (r = 32; r < S0; r++)
    if (a.dyn_ltree[r * 2] !== 0)
      return Fd;
  return Od;
};
let Bd = !1;
const Ix = (a) => {
  Bd || (Tx(), Bd = !0), a.l_desc = new Eu(a.dyn_ltree, Qv), a.d_desc = new Eu(a.dyn_dtree, $v), a.bl_desc = new Eu(a.bl_tree, qv), a.bi_buf = 0, a.bi_valid = 0, ng(a);
}, ag = (a, t, r, o) => {
  Di(a, (yx << 1) + (o ? 1 : 0), 3), ig(a), c0(a, r), c0(a, ~r), r && a.pending_buf.set(a.window.subarray(t, t + r), a.pending), a.pending += r;
}, Rx = (a) => {
  Di(a, jv << 1, 3), la(a, Xh, Pa), Ax(a);
}, Dx = (a, t, r, o) => {
  let c, d, u = 0;
  a.level > 0 ? (a.strm.data_type === px && (a.strm.data_type = Fx(a)), ah(a, a.l_desc), ah(a, a.d_desc), u = Px(a), c = a.opt_len + 3 + 7 >>> 3, d = a.static_len + 3 + 7 >>> 3, d <= c && (c = d)) : c = d = r + 5, r + 4 <= c && t !== -1 ? ag(a, t, r, o) : a.strategy === gx || d === c ? (Di(a, (jv << 1) + (o ? 1 : 0), 3), Rd(a, Pa, n0)) : (Di(a, (mx << 1) + (o ? 1 : 0), 3), Ox(a, a.l_desc.max_code + 1, a.d_desc.max_code + 1, u + 1), Rd(a, a.dyn_ltree, a.dyn_dtree)), ng(a), o && ig(a);
}, Mx = (a, t, r) => (a.pending_buf[a.sym_buf + a.sym_next++] = t, a.pending_buf[a.sym_buf + a.sym_next++] = t >> 8, a.pending_buf[a.sym_buf + a.sym_next++] = r, t === 0 ? a.dyn_ltree[r * 2]++ : (a.matches++, t--, a.dyn_ltree[(h0[r] + S0 + 1) * 2]++, a.dyn_dtree[tg(t) * 2]++), a.sym_next === a.sym_end);
var Bx = Ix, kx = ag, Nx = Dx, Lx = Mx, Ux = Rx, zx = {
  _tr_init: Bx,
  _tr_stored_block: kx,
  _tr_flush_block: Nx,
  _tr_tally: Lx,
  _tr_align: Ux
};
const Gx = (a, t, r, o) => {
  let c = a & 65535 | 0, d = a >>> 16 & 65535 | 0, u = 0;
  for (; r !== 0; ) {
    u = r > 2e3 ? 2e3 : r, r -= u;
    do
      c = c + t[o++] | 0, d = d + c | 0;
    while (--u);
    c %= 65521, d %= 65521;
  }
  return c | d << 16 | 0;
};
var d0 = Gx;
const Vx = () => {
  let a, t = [];
  for (var r = 0; r < 256; r++) {
    a = r;
    for (var o = 0; o < 8; o++)
      a = a & 1 ? 3988292384 ^ a >>> 1 : a >>> 1;
    t[r] = a;
  }
  return t;
}, Hx = new Uint32Array(Vx()), Wx = (a, t, r, o) => {
  const c = Hx, d = o + r;
  a ^= -1;
  for (let u = o; u < d; u++)
    a = a >>> 8 ^ c[(a ^ t[u]) & 255];
  return a ^ -1;
};
var ai = Wx, To = {
  2: "need dictionary",
  /* Z_NEED_DICT       2  */
  1: "stream end",
  /* Z_STREAM_END      1  */
  0: "",
  /* Z_OK              0  */
  "-1": "file error",
  /* Z_ERRNO         (-1) */
  "-2": "stream error",
  /* Z_STREAM_ERROR  (-2) */
  "-3": "data error",
  /* Z_DATA_ERROR    (-3) */
  "-4": "insufficient memory",
  /* Z_MEM_ERROR     (-4) */
  "-5": "buffer error",
  /* Z_BUF_ERROR     (-5) */
  "-6": "incompatible version"
  /* Z_VERSION_ERROR (-6) */
}, Bo = {
  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH: 0,
  Z_PARTIAL_FLUSH: 1,
  Z_SYNC_FLUSH: 2,
  Z_FULL_FLUSH: 3,
  Z_FINISH: 4,
  Z_BLOCK: 5,
  Z_TREES: 6,
  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK: 0,
  Z_STREAM_END: 1,
  Z_NEED_DICT: 2,
  Z_ERRNO: -1,
  Z_STREAM_ERROR: -2,
  Z_DATA_ERROR: -3,
  Z_MEM_ERROR: -4,
  Z_BUF_ERROR: -5,
  //Z_VERSION_ERROR: -6,
  /* compression levels */
  Z_NO_COMPRESSION: 0,
  Z_BEST_SPEED: 1,
  Z_BEST_COMPRESSION: 9,
  Z_DEFAULT_COMPRESSION: -1,
  Z_FILTERED: 1,
  Z_HUFFMAN_ONLY: 2,
  Z_RLE: 3,
  Z_FIXED: 4,
  Z_DEFAULT_STRATEGY: 0,
  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY: 0,
  Z_TEXT: 1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN: 2,
  /* The deflate compression method */
  Z_DEFLATED: 8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};
const { _tr_init: _x, _tr_stored_block: oh, _tr_flush_block: jx, _tr_tally: Ja, _tr_align: Xx } = zx, {
  Z_NO_FLUSH: Qa,
  Z_PARTIAL_FLUSH: Yx,
  Z_FULL_FLUSH: Zx,
  Z_FINISH: _i,
  Z_BLOCK: kd,
  Z_OK: di,
  Z_STREAM_END: Nd,
  Z_STREAM_ERROR: ua,
  Z_DATA_ERROR: Kx,
  Z_BUF_ERROR: Cu,
  Z_DEFAULT_COMPRESSION: Jx,
  Z_FILTERED: Qx,
  Z_HUFFMAN_ONLY: ul,
  Z_RLE: $x,
  Z_FIXED: qx,
  Z_DEFAULT_STRATEGY: t6,
  Z_UNKNOWN: e6,
  Z_DEFLATED: Kl
} = Bo, r6 = 9, n6 = 15, i6 = 8, a6 = 29, o6 = 256, sh = o6 + 1 + a6, s6 = 30, l6 = 19, f6 = 2 * sh + 1, u6 = 15, Kr = 3, Za = 258, ha = Za + Kr + 1, h6 = 32, ls = 42, Zh = 57, lh = 69, fh = 73, uh = 91, hh = 103, bo = 113, qs = 666, Pi = 1, ws = 2, Po = 3, Ss = 4, c6 = 3, wo = (a, t) => (a.msg = To[t], t), Ld = (a) => a * 2 - (a > 4 ? 9 : 0), Ya = (a) => {
  let t = a.length;
  for (; --t >= 0; )
    a[t] = 0;
}, d6 = (a) => {
  let t, r, o, c = a.w_size;
  t = a.hash_size, o = t;
  do
    r = a.head[--o], a.head[o] = r >= c ? r - c : 0;
  while (--t);
  t = c, o = t;
  do
    r = a.prev[--o], a.prev[o] = r >= c ? r - c : 0;
  while (--t);
};
let v6 = (a, t, r) => (t << a.hash_shift ^ r) & a.hash_mask, $a = v6;
const Mi = (a) => {
  const t = a.state;
  let r = t.pending;
  r > a.avail_out && (r = a.avail_out), r !== 0 && (a.output.set(t.pending_buf.subarray(t.pending_out, t.pending_out + r), a.next_out), a.next_out += r, t.pending_out += r, a.total_out += r, a.avail_out -= r, t.pending -= r, t.pending === 0 && (t.pending_out = 0));
}, Ni = (a, t) => {
  jx(a, a.block_start >= 0 ? a.block_start : -1, a.strstart - a.block_start, t), a.block_start = a.strstart, Mi(a.strm);
}, fn = (a, t) => {
  a.pending_buf[a.pending++] = t;
}, Ys = (a, t) => {
  a.pending_buf[a.pending++] = t >>> 8 & 255, a.pending_buf[a.pending++] = t & 255;
}, ch = (a, t, r, o) => {
  let c = a.avail_in;
  return c > o && (c = o), c === 0 ? 0 : (a.avail_in -= c, t.set(a.input.subarray(a.next_in, a.next_in + c), r), a.state.wrap === 1 ? a.adler = d0(a.adler, t, c, r) : a.state.wrap === 2 && (a.adler = ai(a.adler, t, c, r)), a.next_in += c, a.total_in += c, c);
}, og = (a, t) => {
  let r = a.max_chain_length, o = a.strstart, c, d, u = a.prev_length, l = a.nice_match;
  const e = a.strstart > a.w_size - ha ? a.strstart - (a.w_size - ha) : 0, s = a.window, i = a.w_mask, f = a.prev, h = a.strstart + Za;
  let v = s[o + u - 1], p = s[o + u];
  a.prev_length >= a.good_match && (r >>= 2), l > a.lookahead && (l = a.lookahead);
  do
    if (c = t, !(s[c + u] !== p || s[c + u - 1] !== v || s[c] !== s[o] || s[++c] !== s[o + 1])) {
      o += 2, c++;
      do
        ;
      while (s[++o] === s[++c] && s[++o] === s[++c] && s[++o] === s[++c] && s[++o] === s[++c] && s[++o] === s[++c] && s[++o] === s[++c] && s[++o] === s[++c] && s[++o] === s[++c] && o < h);
      if (d = Za - (h - o), o = h - Za, d > u) {
        if (a.match_start = t, u = d, d >= l)
          break;
        v = s[o + u - 1], p = s[o + u];
      }
    }
  while ((t = f[t & i]) > e && --r !== 0);
  return u <= a.lookahead ? u : a.lookahead;
}, fs = (a) => {
  const t = a.w_size;
  let r, o, c;
  do {
    if (o = a.window_size - a.lookahead - a.strstart, a.strstart >= t + (t - ha) && (a.window.set(a.window.subarray(t, t + t - o), 0), a.match_start -= t, a.strstart -= t, a.block_start -= t, a.insert > a.strstart && (a.insert = a.strstart), d6(a), o += t), a.strm.avail_in === 0)
      break;
    if (r = ch(a.strm, a.window, a.strstart + a.lookahead, o), a.lookahead += r, a.lookahead + a.insert >= Kr)
      for (c = a.strstart - a.insert, a.ins_h = a.window[c], a.ins_h = $a(a, a.ins_h, a.window[c + 1]); a.insert && (a.ins_h = $a(a, a.ins_h, a.window[c + Kr - 1]), a.prev[c & a.w_mask] = a.head[a.ins_h], a.head[a.ins_h] = c, c++, a.insert--, !(a.lookahead + a.insert < Kr)); )
        ;
  } while (a.lookahead < ha && a.strm.avail_in !== 0);
}, sg = (a, t) => {
  let r = a.pending_buf_size - 5 > a.w_size ? a.w_size : a.pending_buf_size - 5, o, c, d, u = 0, l = a.strm.avail_in;
  do {
    if (o = 65535, d = a.bi_valid + 42 >> 3, a.strm.avail_out < d || (d = a.strm.avail_out - d, c = a.strstart - a.block_start, o > c + a.strm.avail_in && (o = c + a.strm.avail_in), o > d && (o = d), o < r && (o === 0 && t !== _i || t === Qa || o !== c + a.strm.avail_in)))
      break;
    u = t === _i && o === c + a.strm.avail_in ? 1 : 0, oh(a, 0, 0, u), a.pending_buf[a.pending - 4] = o, a.pending_buf[a.pending - 3] = o >> 8, a.pending_buf[a.pending - 2] = ~o, a.pending_buf[a.pending - 1] = ~o >> 8, Mi(a.strm), c && (c > o && (c = o), a.strm.output.set(a.window.subarray(a.block_start, a.block_start + c), a.strm.next_out), a.strm.next_out += c, a.strm.avail_out -= c, a.strm.total_out += c, a.block_start += c, o -= c), o && (ch(a.strm, a.strm.output, a.strm.next_out, o), a.strm.next_out += o, a.strm.avail_out -= o, a.strm.total_out += o);
  } while (u === 0);
  return l -= a.strm.avail_in, l && (l >= a.w_size ? (a.matches = 2, a.window.set(a.strm.input.subarray(a.strm.next_in - a.w_size, a.strm.next_in), 0), a.strstart = a.w_size, a.insert = a.strstart) : (a.window_size - a.strstart <= l && (a.strstart -= a.w_size, a.window.set(a.window.subarray(a.w_size, a.w_size + a.strstart), 0), a.matches < 2 && a.matches++, a.insert > a.strstart && (a.insert = a.strstart)), a.window.set(a.strm.input.subarray(a.strm.next_in - l, a.strm.next_in), a.strstart), a.strstart += l, a.insert += l > a.w_size - a.insert ? a.w_size - a.insert : l), a.block_start = a.strstart), a.high_water < a.strstart && (a.high_water = a.strstart), u ? Ss : t !== Qa && t !== _i && a.strm.avail_in === 0 && a.strstart === a.block_start ? ws : (d = a.window_size - a.strstart, a.strm.avail_in > d && a.block_start >= a.w_size && (a.block_start -= a.w_size, a.strstart -= a.w_size, a.window.set(a.window.subarray(a.w_size, a.w_size + a.strstart), 0), a.matches < 2 && a.matches++, d += a.w_size, a.insert > a.strstart && (a.insert = a.strstart)), d > a.strm.avail_in && (d = a.strm.avail_in), d && (ch(a.strm, a.window, a.strstart, d), a.strstart += d, a.insert += d > a.w_size - a.insert ? a.w_size - a.insert : d), a.high_water < a.strstart && (a.high_water = a.strstart), d = a.bi_valid + 42 >> 3, d = a.pending_buf_size - d > 65535 ? 65535 : a.pending_buf_size - d, r = d > a.w_size ? a.w_size : d, c = a.strstart - a.block_start, (c >= r || (c || t === _i) && t !== Qa && a.strm.avail_in === 0 && c <= d) && (o = c > d ? d : c, u = t === _i && a.strm.avail_in === 0 && o === c ? 1 : 0, oh(a, a.block_start, o, u), a.block_start += o, Mi(a.strm)), u ? Po : Pi);
}, Tu = (a, t) => {
  let r, o;
  for (; ; ) {
    if (a.lookahead < ha) {
      if (fs(a), a.lookahead < ha && t === Qa)
        return Pi;
      if (a.lookahead === 0)
        break;
    }
    if (r = 0, a.lookahead >= Kr && (a.ins_h = $a(a, a.ins_h, a.window[a.strstart + Kr - 1]), r = a.prev[a.strstart & a.w_mask] = a.head[a.ins_h], a.head[a.ins_h] = a.strstart), r !== 0 && a.strstart - r <= a.w_size - ha && (a.match_length = og(a, r)), a.match_length >= Kr)
      if (o = Ja(a, a.strstart - a.match_start, a.match_length - Kr), a.lookahead -= a.match_length, a.match_length <= a.max_lazy_match && a.lookahead >= Kr) {
        a.match_length--;
        do
          a.strstart++, a.ins_h = $a(a, a.ins_h, a.window[a.strstart + Kr - 1]), r = a.prev[a.strstart & a.w_mask] = a.head[a.ins_h], a.head[a.ins_h] = a.strstart;
        while (--a.match_length !== 0);
        a.strstart++;
      } else
        a.strstart += a.match_length, a.match_length = 0, a.ins_h = a.window[a.strstart], a.ins_h = $a(a, a.ins_h, a.window[a.strstart + 1]);
    else
      o = Ja(a, 0, a.window[a.strstart]), a.lookahead--, a.strstart++;
    if (o && (Ni(a, !1), a.strm.avail_out === 0))
      return Pi;
  }
  return a.insert = a.strstart < Kr - 1 ? a.strstart : Kr - 1, t === _i ? (Ni(a, !0), a.strm.avail_out === 0 ? Po : Ss) : a.sym_next && (Ni(a, !1), a.strm.avail_out === 0) ? Pi : ws;
}, $o = (a, t) => {
  let r, o, c;
  for (; ; ) {
    if (a.lookahead < ha) {
      if (fs(a), a.lookahead < ha && t === Qa)
        return Pi;
      if (a.lookahead === 0)
        break;
    }
    if (r = 0, a.lookahead >= Kr && (a.ins_h = $a(a, a.ins_h, a.window[a.strstart + Kr - 1]), r = a.prev[a.strstart & a.w_mask] = a.head[a.ins_h], a.head[a.ins_h] = a.strstart), a.prev_length = a.match_length, a.prev_match = a.match_start, a.match_length = Kr - 1, r !== 0 && a.prev_length < a.max_lazy_match && a.strstart - r <= a.w_size - ha && (a.match_length = og(a, r), a.match_length <= 5 && (a.strategy === Qx || a.match_length === Kr && a.strstart - a.match_start > 4096) && (a.match_length = Kr - 1)), a.prev_length >= Kr && a.match_length <= a.prev_length) {
      c = a.strstart + a.lookahead - Kr, o = Ja(a, a.strstart - 1 - a.prev_match, a.prev_length - Kr), a.lookahead -= a.prev_length - 1, a.prev_length -= 2;
      do
        ++a.strstart <= c && (a.ins_h = $a(a, a.ins_h, a.window[a.strstart + Kr - 1]), r = a.prev[a.strstart & a.w_mask] = a.head[a.ins_h], a.head[a.ins_h] = a.strstart);
      while (--a.prev_length !== 0);
      if (a.match_available = 0, a.match_length = Kr - 1, a.strstart++, o && (Ni(a, !1), a.strm.avail_out === 0))
        return Pi;
    } else if (a.match_available) {
      if (o = Ja(a, 0, a.window[a.strstart - 1]), o && Ni(a, !1), a.strstart++, a.lookahead--, a.strm.avail_out === 0)
        return Pi;
    } else
      a.match_available = 1, a.strstart++, a.lookahead--;
  }
  return a.match_available && (o = Ja(a, 0, a.window[a.strstart - 1]), a.match_available = 0), a.insert = a.strstart < Kr - 1 ? a.strstart : Kr - 1, t === _i ? (Ni(a, !0), a.strm.avail_out === 0 ? Po : Ss) : a.sym_next && (Ni(a, !1), a.strm.avail_out === 0) ? Pi : ws;
}, g6 = (a, t) => {
  let r, o, c, d;
  const u = a.window;
  for (; ; ) {
    if (a.lookahead <= Za) {
      if (fs(a), a.lookahead <= Za && t === Qa)
        return Pi;
      if (a.lookahead === 0)
        break;
    }
    if (a.match_length = 0, a.lookahead >= Kr && a.strstart > 0 && (c = a.strstart - 1, o = u[c], o === u[++c] && o === u[++c] && o === u[++c])) {
      d = a.strstart + Za;
      do
        ;
      while (o === u[++c] && o === u[++c] && o === u[++c] && o === u[++c] && o === u[++c] && o === u[++c] && o === u[++c] && o === u[++c] && c < d);
      a.match_length = Za - (d - c), a.match_length > a.lookahead && (a.match_length = a.lookahead);
    }
    if (a.match_length >= Kr ? (r = Ja(a, 1, a.match_length - Kr), a.lookahead -= a.match_length, a.strstart += a.match_length, a.match_length = 0) : (r = Ja(a, 0, a.window[a.strstart]), a.lookahead--, a.strstart++), r && (Ni(a, !1), a.strm.avail_out === 0))
      return Pi;
  }
  return a.insert = 0, t === _i ? (Ni(a, !0), a.strm.avail_out === 0 ? Po : Ss) : a.sym_next && (Ni(a, !1), a.strm.avail_out === 0) ? Pi : ws;
}, p6 = (a, t) => {
  let r;
  for (; ; ) {
    if (a.lookahead === 0 && (fs(a), a.lookahead === 0)) {
      if (t === Qa)
        return Pi;
      break;
    }
    if (a.match_length = 0, r = Ja(a, 0, a.window[a.strstart]), a.lookahead--, a.strstart++, r && (Ni(a, !1), a.strm.avail_out === 0))
      return Pi;
  }
  return a.insert = 0, t === _i ? (Ni(a, !0), a.strm.avail_out === 0 ? Po : Ss) : a.sym_next && (Ni(a, !1), a.strm.avail_out === 0) ? Pi : ws;
};
function sa(a, t, r, o, c) {
  this.good_length = a, this.max_lazy = t, this.nice_length = r, this.max_chain = o, this.func = c;
}
const t0 = [
  /*      good lazy nice chain */
  new sa(0, 0, 0, 0, sg),
  /* 0 store only */
  new sa(4, 4, 8, 4, Tu),
  /* 1 max speed, no lazy matches */
  new sa(4, 5, 16, 8, Tu),
  /* 2 */
  new sa(4, 6, 32, 32, Tu),
  /* 3 */
  new sa(4, 4, 16, 16, $o),
  /* 4 lazy matches */
  new sa(8, 16, 32, 32, $o),
  /* 5 */
  new sa(8, 16, 128, 128, $o),
  /* 6 */
  new sa(8, 32, 128, 256, $o),
  /* 7 */
  new sa(32, 128, 258, 1024, $o),
  /* 8 */
  new sa(32, 258, 258, 4096, $o)
  /* 9 max compression */
], y6 = (a) => {
  a.window_size = 2 * a.w_size, Ya(a.head), a.max_lazy_match = t0[a.level].max_lazy, a.good_match = t0[a.level].good_length, a.nice_match = t0[a.level].nice_length, a.max_chain_length = t0[a.level].max_chain, a.strstart = 0, a.block_start = 0, a.lookahead = 0, a.insert = 0, a.match_length = a.prev_length = Kr - 1, a.match_available = 0, a.ins_h = 0;
};
function m6() {
  this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = Kl, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new Uint16Array(f6 * 2), this.dyn_dtree = new Uint16Array((2 * s6 + 1) * 2), this.bl_tree = new Uint16Array((2 * l6 + 1) * 2), Ya(this.dyn_ltree), Ya(this.dyn_dtree), Ya(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new Uint16Array(u6 + 1), this.heap = new Uint16Array(2 * sh + 1), Ya(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new Uint16Array(2 * sh + 1), Ya(this.depth), this.sym_buf = 0, this.lit_bufsize = 0, this.sym_next = 0, this.sym_end = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
}
const E0 = (a) => {
  if (!a)
    return 1;
  const t = a.state;
  return !t || t.strm !== a || t.status !== ls && //#ifdef GZIP
  t.status !== Zh && //#endif
  t.status !== lh && t.status !== fh && t.status !== uh && t.status !== hh && t.status !== bo && t.status !== qs ? 1 : 0;
}, lg = (a) => {
  if (E0(a))
    return wo(a, ua);
  a.total_in = a.total_out = 0, a.data_type = e6;
  const t = a.state;
  return t.pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = //#ifdef GZIP
  t.wrap === 2 ? Zh : (
    //#endif
    t.wrap ? ls : bo
  ), a.adler = t.wrap === 2 ? 0 : 1, t.last_flush = -2, _x(t), di;
}, fg = (a) => {
  const t = lg(a);
  return t === di && y6(a.state), t;
}, x6 = (a, t) => E0(a) || a.state.wrap !== 2 ? ua : (a.state.gzhead = t, di), ug = (a, t, r, o, c, d) => {
  if (!a)
    return ua;
  let u = 1;
  if (t === Jx && (t = 6), o < 0 ? (u = 0, o = -o) : o > 15 && (u = 2, o -= 16), c < 1 || c > r6 || r !== Kl || o < 8 || o > 15 || t < 0 || t > 9 || d < 0 || d > qx || o === 8 && u !== 1)
    return wo(a, ua);
  o === 8 && (o = 9);
  const l = new m6();
  return a.state = l, l.strm = a, l.status = ls, l.wrap = u, l.gzhead = null, l.w_bits = o, l.w_size = 1 << l.w_bits, l.w_mask = l.w_size - 1, l.hash_bits = c + 7, l.hash_size = 1 << l.hash_bits, l.hash_mask = l.hash_size - 1, l.hash_shift = ~~((l.hash_bits + Kr - 1) / Kr), l.window = new Uint8Array(l.w_size * 2), l.head = new Uint16Array(l.hash_size), l.prev = new Uint16Array(l.w_size), l.lit_bufsize = 1 << c + 6, l.pending_buf_size = l.lit_bufsize * 4, l.pending_buf = new Uint8Array(l.pending_buf_size), l.sym_buf = l.lit_bufsize, l.sym_end = (l.lit_bufsize - 1) * 3, l.level = t, l.strategy = d, l.method = r, fg(a);
}, b6 = (a, t) => ug(a, t, Kl, n6, i6, t6), w6 = (a, t) => {
  if (E0(a) || t > kd || t < 0)
    return a ? wo(a, ua) : ua;
  const r = a.state;
  if (!a.output || a.avail_in !== 0 && !a.input || r.status === qs && t !== _i)
    return wo(a, a.avail_out === 0 ? Cu : ua);
  const o = r.last_flush;
  if (r.last_flush = t, r.pending !== 0) {
    if (Mi(a), a.avail_out === 0)
      return r.last_flush = -1, di;
  } else if (a.avail_in === 0 && Ld(t) <= Ld(o) && t !== _i)
    return wo(a, Cu);
  if (r.status === qs && a.avail_in !== 0)
    return wo(a, Cu);
  if (r.status === ls && r.wrap === 0 && (r.status = bo), r.status === ls) {
    let c = Kl + (r.w_bits - 8 << 4) << 8, d = -1;
    if (r.strategy >= ul || r.level < 2 ? d = 0 : r.level < 6 ? d = 1 : r.level === 6 ? d = 2 : d = 3, c |= d << 6, r.strstart !== 0 && (c |= h6), c += 31 - c % 31, Ys(r, c), r.strstart !== 0 && (Ys(r, a.adler >>> 16), Ys(r, a.adler & 65535)), a.adler = 1, r.status = bo, Mi(a), r.pending !== 0)
      return r.last_flush = -1, di;
  }
  if (r.status === Zh) {
    if (a.adler = 0, fn(r, 31), fn(r, 139), fn(r, 8), r.gzhead)
      fn(
        r,
        (r.gzhead.text ? 1 : 0) + (r.gzhead.hcrc ? 2 : 0) + (r.gzhead.extra ? 4 : 0) + (r.gzhead.name ? 8 : 0) + (r.gzhead.comment ? 16 : 0)
      ), fn(r, r.gzhead.time & 255), fn(r, r.gzhead.time >> 8 & 255), fn(r, r.gzhead.time >> 16 & 255), fn(r, r.gzhead.time >> 24 & 255), fn(r, r.level === 9 ? 2 : r.strategy >= ul || r.level < 2 ? 4 : 0), fn(r, r.gzhead.os & 255), r.gzhead.extra && r.gzhead.extra.length && (fn(r, r.gzhead.extra.length & 255), fn(r, r.gzhead.extra.length >> 8 & 255)), r.gzhead.hcrc && (a.adler = ai(a.adler, r.pending_buf, r.pending, 0)), r.gzindex = 0, r.status = lh;
    else if (fn(r, 0), fn(r, 0), fn(r, 0), fn(r, 0), fn(r, 0), fn(r, r.level === 9 ? 2 : r.strategy >= ul || r.level < 2 ? 4 : 0), fn(r, c6), r.status = bo, Mi(a), r.pending !== 0)
      return r.last_flush = -1, di;
  }
  if (r.status === lh) {
    if (r.gzhead.extra) {
      let c = r.pending, d = (r.gzhead.extra.length & 65535) - r.gzindex;
      for (; r.pending + d > r.pending_buf_size; ) {
        let l = r.pending_buf_size - r.pending;
        if (r.pending_buf.set(r.gzhead.extra.subarray(r.gzindex, r.gzindex + l), r.pending), r.pending = r.pending_buf_size, r.gzhead.hcrc && r.pending > c && (a.adler = ai(a.adler, r.pending_buf, r.pending - c, c)), r.gzindex += l, Mi(a), r.pending !== 0)
          return r.last_flush = -1, di;
        c = 0, d -= l;
      }
      let u = new Uint8Array(r.gzhead.extra);
      r.pending_buf.set(u.subarray(r.gzindex, r.gzindex + d), r.pending), r.pending += d, r.gzhead.hcrc && r.pending > c && (a.adler = ai(a.adler, r.pending_buf, r.pending - c, c)), r.gzindex = 0;
    }
    r.status = fh;
  }
  if (r.status === fh) {
    if (r.gzhead.name) {
      let c = r.pending, d;
      do {
        if (r.pending === r.pending_buf_size) {
          if (r.gzhead.hcrc && r.pending > c && (a.adler = ai(a.adler, r.pending_buf, r.pending - c, c)), Mi(a), r.pending !== 0)
            return r.last_flush = -1, di;
          c = 0;
        }
        r.gzindex < r.gzhead.name.length ? d = r.gzhead.name.charCodeAt(r.gzindex++) & 255 : d = 0, fn(r, d);
      } while (d !== 0);
      r.gzhead.hcrc && r.pending > c && (a.adler = ai(a.adler, r.pending_buf, r.pending - c, c)), r.gzindex = 0;
    }
    r.status = uh;
  }
  if (r.status === uh) {
    if (r.gzhead.comment) {
      let c = r.pending, d;
      do {
        if (r.pending === r.pending_buf_size) {
          if (r.gzhead.hcrc && r.pending > c && (a.adler = ai(a.adler, r.pending_buf, r.pending - c, c)), Mi(a), r.pending !== 0)
            return r.last_flush = -1, di;
          c = 0;
        }
        r.gzindex < r.gzhead.comment.length ? d = r.gzhead.comment.charCodeAt(r.gzindex++) & 255 : d = 0, fn(r, d);
      } while (d !== 0);
      r.gzhead.hcrc && r.pending > c && (a.adler = ai(a.adler, r.pending_buf, r.pending - c, c));
    }
    r.status = hh;
  }
  if (r.status === hh) {
    if (r.gzhead.hcrc) {
      if (r.pending + 2 > r.pending_buf_size && (Mi(a), r.pending !== 0))
        return r.last_flush = -1, di;
      fn(r, a.adler & 255), fn(r, a.adler >> 8 & 255), a.adler = 0;
    }
    if (r.status = bo, Mi(a), r.pending !== 0)
      return r.last_flush = -1, di;
  }
  if (a.avail_in !== 0 || r.lookahead !== 0 || t !== Qa && r.status !== qs) {
    let c = r.level === 0 ? sg(r, t) : r.strategy === ul ? p6(r, t) : r.strategy === $x ? g6(r, t) : t0[r.level].func(r, t);
    if ((c === Po || c === Ss) && (r.status = qs), c === Pi || c === Po)
      return a.avail_out === 0 && (r.last_flush = -1), di;
    if (c === ws && (t === Yx ? Xx(r) : t !== kd && (oh(r, 0, 0, !1), t === Zx && (Ya(r.head), r.lookahead === 0 && (r.strstart = 0, r.block_start = 0, r.insert = 0))), Mi(a), a.avail_out === 0))
      return r.last_flush = -1, di;
  }
  return t !== _i ? di : r.wrap <= 0 ? Nd : (r.wrap === 2 ? (fn(r, a.adler & 255), fn(r, a.adler >> 8 & 255), fn(r, a.adler >> 16 & 255), fn(r, a.adler >> 24 & 255), fn(r, a.total_in & 255), fn(r, a.total_in >> 8 & 255), fn(r, a.total_in >> 16 & 255), fn(r, a.total_in >> 24 & 255)) : (Ys(r, a.adler >>> 16), Ys(r, a.adler & 65535)), Mi(a), r.wrap > 0 && (r.wrap = -r.wrap), r.pending !== 0 ? di : Nd);
}, S6 = (a) => {
  if (E0(a))
    return ua;
  const t = a.state.status;
  return a.state = null, t === bo ? wo(a, Kx) : di;
}, E6 = (a, t) => {
  let r = t.length;
  if (E0(a))
    return ua;
  const o = a.state, c = o.wrap;
  if (c === 2 || c === 1 && o.status !== ls || o.lookahead)
    return ua;
  if (c === 1 && (a.adler = d0(a.adler, t, r, 0)), o.wrap = 0, r >= o.w_size) {
    c === 0 && (Ya(o.head), o.strstart = 0, o.block_start = 0, o.insert = 0);
    let e = new Uint8Array(o.w_size);
    e.set(t.subarray(r - o.w_size, r), 0), t = e, r = o.w_size;
  }
  const d = a.avail_in, u = a.next_in, l = a.input;
  for (a.avail_in = r, a.next_in = 0, a.input = t, fs(o); o.lookahead >= Kr; ) {
    let e = o.strstart, s = o.lookahead - (Kr - 1);
    do
      o.ins_h = $a(o, o.ins_h, o.window[e + Kr - 1]), o.prev[e & o.w_mask] = o.head[o.ins_h], o.head[o.ins_h] = e, e++;
    while (--s);
    o.strstart = e, o.lookahead = Kr - 1, fs(o);
  }
  return o.strstart += o.lookahead, o.block_start = o.strstart, o.insert = o.lookahead, o.lookahead = 0, o.match_length = o.prev_length = Kr - 1, o.match_available = 0, a.next_in = u, a.input = l, a.avail_in = d, o.wrap = c, di;
};
var A6 = b6, C6 = ug, T6 = fg, P6 = lg, O6 = x6, F6 = w6, I6 = S6, R6 = E6, D6 = "pako deflate (from Nodeca project)", i0 = {
  deflateInit: A6,
  deflateInit2: C6,
  deflateReset: T6,
  deflateResetKeep: P6,
  deflateSetHeader: O6,
  deflate: F6,
  deflateEnd: I6,
  deflateSetDictionary: R6,
  deflateInfo: D6
};
const M6 = (a, t) => Object.prototype.hasOwnProperty.call(a, t);
var B6 = function(a) {
  const t = Array.prototype.slice.call(arguments, 1);
  for (; t.length; ) {
    const r = t.shift();
    if (r) {
      if (typeof r != "object")
        throw new TypeError(r + "must be non-object");
      for (const o in r)
        M6(r, o) && (a[o] = r[o]);
    }
  }
  return a;
}, k6 = (a) => {
  let t = 0;
  for (let o = 0, c = a.length; o < c; o++)
    t += a[o].length;
  const r = new Uint8Array(t);
  for (let o = 0, c = 0, d = a.length; o < d; o++) {
    let u = a[o];
    r.set(u, c), c += u.length;
  }
  return r;
}, Jl = {
  assign: B6,
  flattenChunks: k6
};
let hg = !0;
try {
  String.fromCharCode.apply(null, new Uint8Array(1));
} catch {
  hg = !1;
}
const v0 = new Uint8Array(256);
for (let a = 0; a < 256; a++)
  v0[a] = a >= 252 ? 6 : a >= 248 ? 5 : a >= 240 ? 4 : a >= 224 ? 3 : a >= 192 ? 2 : 1;
v0[254] = v0[254] = 1;
var N6 = (a) => {
  if (typeof TextEncoder == "function" && TextEncoder.prototype.encode)
    return new TextEncoder().encode(a);
  let t, r, o, c, d, u = a.length, l = 0;
  for (c = 0; c < u; c++)
    r = a.charCodeAt(c), (r & 64512) === 55296 && c + 1 < u && (o = a.charCodeAt(c + 1), (o & 64512) === 56320 && (r = 65536 + (r - 55296 << 10) + (o - 56320), c++)), l += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
  for (t = new Uint8Array(l), d = 0, c = 0; d < l; c++)
    r = a.charCodeAt(c), (r & 64512) === 55296 && c + 1 < u && (o = a.charCodeAt(c + 1), (o & 64512) === 56320 && (r = 65536 + (r - 55296 << 10) + (o - 56320), c++)), r < 128 ? t[d++] = r : r < 2048 ? (t[d++] = 192 | r >>> 6, t[d++] = 128 | r & 63) : r < 65536 ? (t[d++] = 224 | r >>> 12, t[d++] = 128 | r >>> 6 & 63, t[d++] = 128 | r & 63) : (t[d++] = 240 | r >>> 18, t[d++] = 128 | r >>> 12 & 63, t[d++] = 128 | r >>> 6 & 63, t[d++] = 128 | r & 63);
  return t;
};
const L6 = (a, t) => {
  if (t < 65534 && a.subarray && hg)
    return String.fromCharCode.apply(null, a.length === t ? a : a.subarray(0, t));
  let r = "";
  for (let o = 0; o < t; o++)
    r += String.fromCharCode(a[o]);
  return r;
};
var U6 = (a, t) => {
  const r = t || a.length;
  if (typeof TextDecoder == "function" && TextDecoder.prototype.decode)
    return new TextDecoder().decode(a.subarray(0, t));
  let o, c;
  const d = new Array(r * 2);
  for (c = 0, o = 0; o < r; ) {
    let u = a[o++];
    if (u < 128) {
      d[c++] = u;
      continue;
    }
    let l = v0[u];
    if (l > 4) {
      d[c++] = 65533, o += l - 1;
      continue;
    }
    for (u &= l === 2 ? 31 : l === 3 ? 15 : 7; l > 1 && o < r; )
      u = u << 6 | a[o++] & 63, l--;
    if (l > 1) {
      d[c++] = 65533;
      continue;
    }
    u < 65536 ? d[c++] = u : (u -= 65536, d[c++] = 55296 | u >> 10 & 1023, d[c++] = 56320 | u & 1023);
  }
  return L6(d, c);
}, z6 = (a, t) => {
  t = t || a.length, t > a.length && (t = a.length);
  let r = t - 1;
  for (; r >= 0 && (a[r] & 192) === 128; )
    r--;
  return r < 0 || r === 0 ? t : r + v0[a[r]] > t ? r : t;
}, g0 = {
  string2buf: N6,
  buf2string: U6,
  utf8border: z6
};
function G6() {
  this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
}
var cg = G6;
const dg = Object.prototype.toString, {
  Z_NO_FLUSH: V6,
  Z_SYNC_FLUSH: H6,
  Z_FULL_FLUSH: W6,
  Z_FINISH: _6,
  Z_OK: Bl,
  Z_STREAM_END: j6,
  Z_DEFAULT_COMPRESSION: X6,
  Z_DEFAULT_STRATEGY: Y6,
  Z_DEFLATED: Z6
} = Bo;
function A0(a) {
  this.options = Jl.assign({
    level: X6,
    method: Z6,
    chunkSize: 16384,
    windowBits: 15,
    memLevel: 8,
    strategy: Y6
  }, a || {});
  let t = this.options;
  t.raw && t.windowBits > 0 ? t.windowBits = -t.windowBits : t.gzip && t.windowBits > 0 && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new cg(), this.strm.avail_out = 0;
  let r = i0.deflateInit2(
    this.strm,
    t.level,
    t.method,
    t.windowBits,
    t.memLevel,
    t.strategy
  );
  if (r !== Bl)
    throw new Error(To[r]);
  if (t.header && i0.deflateSetHeader(this.strm, t.header), t.dictionary) {
    let o;
    if (typeof t.dictionary == "string" ? o = g0.string2buf(t.dictionary) : dg.call(t.dictionary) === "[object ArrayBuffer]" ? o = new Uint8Array(t.dictionary) : o = t.dictionary, r = i0.deflateSetDictionary(this.strm, o), r !== Bl)
      throw new Error(To[r]);
    this._dict_set = !0;
  }
}
A0.prototype.push = function(a, t) {
  const r = this.strm, o = this.options.chunkSize;
  let c, d;
  if (this.ended)
    return !1;
  for (t === ~~t ? d = t : d = t === !0 ? _6 : V6, typeof a == "string" ? r.input = g0.string2buf(a) : dg.call(a) === "[object ArrayBuffer]" ? r.input = new Uint8Array(a) : r.input = a, r.next_in = 0, r.avail_in = r.input.length; ; ) {
    if (r.avail_out === 0 && (r.output = new Uint8Array(o), r.next_out = 0, r.avail_out = o), (d === H6 || d === W6) && r.avail_out <= 6) {
      this.onData(r.output.subarray(0, r.next_out)), r.avail_out = 0;
      continue;
    }
    if (c = i0.deflate(r, d), c === j6)
      return r.next_out > 0 && this.onData(r.output.subarray(0, r.next_out)), c = i0.deflateEnd(this.strm), this.onEnd(c), this.ended = !0, c === Bl;
    if (r.avail_out === 0) {
      this.onData(r.output);
      continue;
    }
    if (d > 0 && r.next_out > 0) {
      this.onData(r.output.subarray(0, r.next_out)), r.avail_out = 0;
      continue;
    }
    if (r.avail_in === 0)
      break;
  }
  return !0;
};
A0.prototype.onData = function(a) {
  this.chunks.push(a);
};
A0.prototype.onEnd = function(a) {
  a === Bl && (this.result = Jl.flattenChunks(this.chunks)), this.chunks = [], this.err = a, this.msg = this.strm.msg;
};
function Kh(a, t) {
  const r = new A0(t);
  if (r.push(a, !0), r.err)
    throw r.msg || To[r.err];
  return r.result;
}
function K6(a, t) {
  return t = t || {}, t.raw = !0, Kh(a, t);
}
function J6(a, t) {
  return t = t || {}, t.gzip = !0, Kh(a, t);
}
var Q6 = A0, $6 = Kh, q6 = K6, t5 = J6, e5 = Bo, r5 = {
  Deflate: Q6,
  deflate: $6,
  deflateRaw: q6,
  gzip: t5,
  constants: e5
};
const hl = 16209, n5 = 16191;
var i5 = function(t, r) {
  let o, c, d, u, l, e, s, i, f, h, v, p, m, x, g, S, y, b, n, w, E, A, O, C;
  const T = t.state;
  o = t.next_in, O = t.input, c = o + (t.avail_in - 5), d = t.next_out, C = t.output, u = d - (r - t.avail_out), l = d + (t.avail_out - 257), e = T.dmax, s = T.wsize, i = T.whave, f = T.wnext, h = T.window, v = T.hold, p = T.bits, m = T.lencode, x = T.distcode, g = (1 << T.lenbits) - 1, S = (1 << T.distbits) - 1;
  t:
    do {
      p < 15 && (v += O[o++] << p, p += 8, v += O[o++] << p, p += 8), y = m[v & g];
      e:
        for (; ; ) {
          if (b = y >>> 24, v >>>= b, p -= b, b = y >>> 16 & 255, b === 0)
            C[d++] = y & 65535;
          else if (b & 16) {
            n = y & 65535, b &= 15, b && (p < b && (v += O[o++] << p, p += 8), n += v & (1 << b) - 1, v >>>= b, p -= b), p < 15 && (v += O[o++] << p, p += 8, v += O[o++] << p, p += 8), y = x[v & S];
            r:
              for (; ; ) {
                if (b = y >>> 24, v >>>= b, p -= b, b = y >>> 16 & 255, b & 16) {
                  if (w = y & 65535, b &= 15, p < b && (v += O[o++] << p, p += 8, p < b && (v += O[o++] << p, p += 8)), w += v & (1 << b) - 1, w > e) {
                    t.msg = "invalid distance too far back", T.mode = hl;
                    break t;
                  }
                  if (v >>>= b, p -= b, b = d - u, w > b) {
                    if (b = w - b, b > i && T.sane) {
                      t.msg = "invalid distance too far back", T.mode = hl;
                      break t;
                    }
                    if (E = 0, A = h, f === 0) {
                      if (E += s - b, b < n) {
                        n -= b;
                        do
                          C[d++] = h[E++];
                        while (--b);
                        E = d - w, A = C;
                      }
                    } else if (f < b) {
                      if (E += s + f - b, b -= f, b < n) {
                        n -= b;
                        do
                          C[d++] = h[E++];
                        while (--b);
                        if (E = 0, f < n) {
                          b = f, n -= b;
                          do
                            C[d++] = h[E++];
                          while (--b);
                          E = d - w, A = C;
                        }
                      }
                    } else if (E += f - b, b < n) {
                      n -= b;
                      do
                        C[d++] = h[E++];
                      while (--b);
                      E = d - w, A = C;
                    }
                    for (; n > 2; )
                      C[d++] = A[E++], C[d++] = A[E++], C[d++] = A[E++], n -= 3;
                    n && (C[d++] = A[E++], n > 1 && (C[d++] = A[E++]));
                  } else {
                    E = d - w;
                    do
                      C[d++] = C[E++], C[d++] = C[E++], C[d++] = C[E++], n -= 3;
                    while (n > 2);
                    n && (C[d++] = C[E++], n > 1 && (C[d++] = C[E++]));
                  }
                } else if (b & 64) {
                  t.msg = "invalid distance code", T.mode = hl;
                  break t;
                } else {
                  y = x[(y & 65535) + (v & (1 << b) - 1)];
                  continue r;
                }
                break;
              }
          } else if (b & 64)
            if (b & 32) {
              T.mode = n5;
              break t;
            } else {
              t.msg = "invalid literal/length code", T.mode = hl;
              break t;
            }
          else {
            y = m[(y & 65535) + (v & (1 << b) - 1)];
            continue e;
          }
          break;
        }
    } while (o < c && d < l);
  n = p >> 3, o -= n, p -= n << 3, v &= (1 << p) - 1, t.next_in = o, t.next_out = d, t.avail_in = o < c ? 5 + (c - o) : 5 - (o - c), t.avail_out = d < l ? 257 + (l - d) : 257 - (d - l), T.hold = v, T.bits = p;
};
const qo = 15, Ud = 852, zd = 592, Gd = 0, Pu = 1, Vd = 2, a5 = new Uint16Array([
  /* Length codes 257..285 base */
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  13,
  15,
  17,
  19,
  23,
  27,
  31,
  35,
  43,
  51,
  59,
  67,
  83,
  99,
  115,
  131,
  163,
  195,
  227,
  258,
  0,
  0
]), o5 = new Uint8Array([
  /* Length codes 257..285 extra */
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  17,
  17,
  17,
  17,
  18,
  18,
  18,
  18,
  19,
  19,
  19,
  19,
  20,
  20,
  20,
  20,
  21,
  21,
  21,
  21,
  16,
  72,
  78
]), s5 = new Uint16Array([
  /* Distance codes 0..29 base */
  1,
  2,
  3,
  4,
  5,
  7,
  9,
  13,
  17,
  25,
  33,
  49,
  65,
  97,
  129,
  193,
  257,
  385,
  513,
  769,
  1025,
  1537,
  2049,
  3073,
  4097,
  6145,
  8193,
  12289,
  16385,
  24577,
  0,
  0
]), l5 = new Uint8Array([
  /* Distance codes 0..29 extra */
  16,
  16,
  16,
  16,
  17,
  17,
  18,
  18,
  19,
  19,
  20,
  20,
  21,
  21,
  22,
  22,
  23,
  23,
  24,
  24,
  25,
  25,
  26,
  26,
  27,
  27,
  28,
  28,
  29,
  29,
  64,
  64
]), f5 = (a, t, r, o, c, d, u, l) => {
  const e = l.bits;
  let s = 0, i = 0, f = 0, h = 0, v = 0, p = 0, m = 0, x = 0, g = 0, S = 0, y, b, n, w, E, A = null, O;
  const C = new Uint16Array(qo + 1), T = new Uint16Array(qo + 1);
  let P = null, I, F, B;
  for (s = 0; s <= qo; s++)
    C[s] = 0;
  for (i = 0; i < o; i++)
    C[t[r + i]]++;
  for (v = e, h = qo; h >= 1 && C[h] === 0; h--)
    ;
  if (v > h && (v = h), h === 0)
    return c[d++] = 1 << 24 | 64 << 16 | 0, c[d++] = 1 << 24 | 64 << 16 | 0, l.bits = 1, 0;
  for (f = 1; f < h && C[f] === 0; f++)
    ;
  for (v < f && (v = f), x = 1, s = 1; s <= qo; s++)
    if (x <<= 1, x -= C[s], x < 0)
      return -1;
  if (x > 0 && (a === Gd || h !== 1))
    return -1;
  for (T[1] = 0, s = 1; s < qo; s++)
    T[s + 1] = T[s] + C[s];
  for (i = 0; i < o; i++)
    t[r + i] !== 0 && (u[T[t[r + i]]++] = i);
  if (a === Gd ? (A = P = u, O = 20) : a === Pu ? (A = a5, P = o5, O = 257) : (A = s5, P = l5, O = 0), S = 0, i = 0, s = f, E = d, p = v, m = 0, n = -1, g = 1 << v, w = g - 1, a === Pu && g > Ud || a === Vd && g > zd)
    return 1;
  for (; ; ) {
    I = s - m, u[i] + 1 < O ? (F = 0, B = u[i]) : u[i] >= O ? (F = P[u[i] - O], B = A[u[i] - O]) : (F = 32 + 64, B = 0), y = 1 << s - m, b = 1 << p, f = b;
    do
      b -= y, c[E + (S >> m) + b] = I << 24 | F << 16 | B | 0;
    while (b !== 0);
    for (y = 1 << s - 1; S & y; )
      y >>= 1;
    if (y !== 0 ? (S &= y - 1, S += y) : S = 0, i++, --C[s] === 0) {
      if (s === h)
        break;
      s = t[r + u[i]];
    }
    if (s > v && (S & w) !== n) {
      for (m === 0 && (m = v), E += f, p = s - m, x = 1 << p; p + m < h && (x -= C[p + m], !(x <= 0)); )
        p++, x <<= 1;
      if (g += 1 << p, a === Pu && g > Ud || a === Vd && g > zd)
        return 1;
      n = S & w, c[n] = v << 24 | p << 16 | E - d | 0;
    }
  }
  return S !== 0 && (c[E + S] = s - m << 24 | 64 << 16 | 0), l.bits = v, 0;
};
var a0 = f5;
const u5 = 0, vg = 1, gg = 2, {
  Z_FINISH: Hd,
  Z_BLOCK: h5,
  Z_TREES: cl,
  Z_OK: Oo,
  Z_STREAM_END: c5,
  Z_NEED_DICT: d5,
  Z_STREAM_ERROR: ji,
  Z_DATA_ERROR: pg,
  Z_MEM_ERROR: yg,
  Z_BUF_ERROR: v5,
  Z_DEFLATED: Wd
} = Bo, Ql = 16180, _d = 16181, jd = 16182, Xd = 16183, Yd = 16184, Zd = 16185, Kd = 16186, Jd = 16187, Qd = 16188, $d = 16189, kl = 16190, Sa = 16191, Ou = 16192, qd = 16193, Fu = 16194, t1 = 16195, e1 = 16196, r1 = 16197, n1 = 16198, dl = 16199, vl = 16200, i1 = 16201, a1 = 16202, o1 = 16203, s1 = 16204, l1 = 16205, Iu = 16206, f1 = 16207, u1 = 16208, Dn = 16209, mg = 16210, xg = 16211, g5 = 852, p5 = 592, y5 = 15, m5 = y5, h1 = (a) => (a >>> 24 & 255) + (a >>> 8 & 65280) + ((a & 65280) << 8) + ((a & 255) << 24);
function x5() {
  this.strm = null, this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new Uint16Array(320), this.work = new Uint16Array(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
}
const ko = (a) => {
  if (!a)
    return 1;
  const t = a.state;
  return !t || t.strm !== a || t.mode < Ql || t.mode > xg ? 1 : 0;
}, bg = (a) => {
  if (ko(a))
    return ji;
  const t = a.state;
  return a.total_in = a.total_out = t.total = 0, a.msg = "", t.wrap && (a.adler = t.wrap & 1), t.mode = Ql, t.last = 0, t.havedict = 0, t.flags = -1, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new Int32Array(g5), t.distcode = t.distdyn = new Int32Array(p5), t.sane = 1, t.back = -1, Oo;
}, wg = (a) => {
  if (ko(a))
    return ji;
  const t = a.state;
  return t.wsize = 0, t.whave = 0, t.wnext = 0, bg(a);
}, Sg = (a, t) => {
  let r;
  if (ko(a))
    return ji;
  const o = a.state;
  return t < 0 ? (r = 0, t = -t) : (r = (t >> 4) + 5, t < 48 && (t &= 15)), t && (t < 8 || t > 15) ? ji : (o.window !== null && o.wbits !== t && (o.window = null), o.wrap = r, o.wbits = t, wg(a));
}, Eg = (a, t) => {
  if (!a)
    return ji;
  const r = new x5();
  a.state = r, r.strm = a, r.window = null, r.mode = Ql;
  const o = Sg(a, t);
  return o !== Oo && (a.state = null), o;
}, b5 = (a) => Eg(a, m5);
let c1 = !0, Ru, Du;
const w5 = (a) => {
  if (c1) {
    Ru = new Int32Array(512), Du = new Int32Array(32);
    let t = 0;
    for (; t < 144; )
      a.lens[t++] = 8;
    for (; t < 256; )
      a.lens[t++] = 9;
    for (; t < 280; )
      a.lens[t++] = 7;
    for (; t < 288; )
      a.lens[t++] = 8;
    for (a0(vg, a.lens, 0, 288, Ru, 0, a.work, { bits: 9 }), t = 0; t < 32; )
      a.lens[t++] = 5;
    a0(gg, a.lens, 0, 32, Du, 0, a.work, { bits: 5 }), c1 = !1;
  }
  a.lencode = Ru, a.lenbits = 9, a.distcode = Du, a.distbits = 5;
}, Ag = (a, t, r, o) => {
  let c;
  const d = a.state;
  return d.window === null && (d.wsize = 1 << d.wbits, d.wnext = 0, d.whave = 0, d.window = new Uint8Array(d.wsize)), o >= d.wsize ? (d.window.set(t.subarray(r - d.wsize, r), 0), d.wnext = 0, d.whave = d.wsize) : (c = d.wsize - d.wnext, c > o && (c = o), d.window.set(t.subarray(r - o, r - o + c), d.wnext), o -= c, o ? (d.window.set(t.subarray(r - o, r), 0), d.wnext = o, d.whave = d.wsize) : (d.wnext += c, d.wnext === d.wsize && (d.wnext = 0), d.whave < d.wsize && (d.whave += c))), 0;
}, S5 = (a, t) => {
  let r, o, c, d, u, l, e, s, i, f, h, v, p, m, x = 0, g, S, y, b, n, w, E, A;
  const O = new Uint8Array(4);
  let C, T;
  const P = (
    /* permutation of code lengths */
    new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15])
  );
  if (ko(a) || !a.output || !a.input && a.avail_in !== 0)
    return ji;
  r = a.state, r.mode === Sa && (r.mode = Ou), u = a.next_out, c = a.output, e = a.avail_out, d = a.next_in, o = a.input, l = a.avail_in, s = r.hold, i = r.bits, f = l, h = e, A = Oo;
  t:
    for (; ; )
      switch (r.mode) {
        case Ql:
          if (r.wrap === 0) {
            r.mode = Ou;
            break;
          }
          for (; i < 16; ) {
            if (l === 0)
              break t;
            l--, s += o[d++] << i, i += 8;
          }
          if (r.wrap & 2 && s === 35615) {
            r.wbits === 0 && (r.wbits = 15), r.check = 0, O[0] = s & 255, O[1] = s >>> 8 & 255, r.check = ai(r.check, O, 2, 0), s = 0, i = 0, r.mode = _d;
            break;
          }
          if (r.head && (r.head.done = !1), !(r.wrap & 1) || /* check if zlib header allowed */
          (((s & 255) << 8) + (s >> 8)) % 31) {
            a.msg = "incorrect header check", r.mode = Dn;
            break;
          }
          if ((s & 15) !== Wd) {
            a.msg = "unknown compression method", r.mode = Dn;
            break;
          }
          if (s >>>= 4, i -= 4, E = (s & 15) + 8, r.wbits === 0 && (r.wbits = E), E > 15 || E > r.wbits) {
            a.msg = "invalid window size", r.mode = Dn;
            break;
          }
          r.dmax = 1 << r.wbits, r.flags = 0, a.adler = r.check = 1, r.mode = s & 512 ? $d : Sa, s = 0, i = 0;
          break;
        case _d:
          for (; i < 16; ) {
            if (l === 0)
              break t;
            l--, s += o[d++] << i, i += 8;
          }
          if (r.flags = s, (r.flags & 255) !== Wd) {
            a.msg = "unknown compression method", r.mode = Dn;
            break;
          }
          if (r.flags & 57344) {
            a.msg = "unknown header flags set", r.mode = Dn;
            break;
          }
          r.head && (r.head.text = s >> 8 & 1), r.flags & 512 && r.wrap & 4 && (O[0] = s & 255, O[1] = s >>> 8 & 255, r.check = ai(r.check, O, 2, 0)), s = 0, i = 0, r.mode = jd;
        case jd:
          for (; i < 32; ) {
            if (l === 0)
              break t;
            l--, s += o[d++] << i, i += 8;
          }
          r.head && (r.head.time = s), r.flags & 512 && r.wrap & 4 && (O[0] = s & 255, O[1] = s >>> 8 & 255, O[2] = s >>> 16 & 255, O[3] = s >>> 24 & 255, r.check = ai(r.check, O, 4, 0)), s = 0, i = 0, r.mode = Xd;
        case Xd:
          for (; i < 16; ) {
            if (l === 0)
              break t;
            l--, s += o[d++] << i, i += 8;
          }
          r.head && (r.head.xflags = s & 255, r.head.os = s >> 8), r.flags & 512 && r.wrap & 4 && (O[0] = s & 255, O[1] = s >>> 8 & 255, r.check = ai(r.check, O, 2, 0)), s = 0, i = 0, r.mode = Yd;
        case Yd:
          if (r.flags & 1024) {
            for (; i < 16; ) {
              if (l === 0)
                break t;
              l--, s += o[d++] << i, i += 8;
            }
            r.length = s, r.head && (r.head.extra_len = s), r.flags & 512 && r.wrap & 4 && (O[0] = s & 255, O[1] = s >>> 8 & 255, r.check = ai(r.check, O, 2, 0)), s = 0, i = 0;
          } else
            r.head && (r.head.extra = null);
          r.mode = Zd;
        case Zd:
          if (r.flags & 1024 && (v = r.length, v > l && (v = l), v && (r.head && (E = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Uint8Array(r.head.extra_len)), r.head.extra.set(
            o.subarray(
              d,
              // extra field is limited to 65536 bytes
              // - no need for additional size check
              d + v
            ),
            /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
            E
          )), r.flags & 512 && r.wrap & 4 && (r.check = ai(r.check, o, v, d)), l -= v, d += v, r.length -= v), r.length))
            break t;
          r.length = 0, r.mode = Kd;
        case Kd:
          if (r.flags & 2048) {
            if (l === 0)
              break t;
            v = 0;
            do
              E = o[d + v++], r.head && E && r.length < 65536 && (r.head.name += String.fromCharCode(E));
            while (E && v < l);
            if (r.flags & 512 && r.wrap & 4 && (r.check = ai(r.check, o, v, d)), l -= v, d += v, E)
              break t;
          } else
            r.head && (r.head.name = null);
          r.length = 0, r.mode = Jd;
        case Jd:
          if (r.flags & 4096) {
            if (l === 0)
              break t;
            v = 0;
            do
              E = o[d + v++], r.head && E && r.length < 65536 && (r.head.comment += String.fromCharCode(E));
            while (E && v < l);
            if (r.flags & 512 && r.wrap & 4 && (r.check = ai(r.check, o, v, d)), l -= v, d += v, E)
              break t;
          } else
            r.head && (r.head.comment = null);
          r.mode = Qd;
        case Qd:
          if (r.flags & 512) {
            for (; i < 16; ) {
              if (l === 0)
                break t;
              l--, s += o[d++] << i, i += 8;
            }
            if (r.wrap & 4 && s !== (r.check & 65535)) {
              a.msg = "header crc mismatch", r.mode = Dn;
              break;
            }
            s = 0, i = 0;
          }
          r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), a.adler = r.check = 0, r.mode = Sa;
          break;
        case $d:
          for (; i < 32; ) {
            if (l === 0)
              break t;
            l--, s += o[d++] << i, i += 8;
          }
          a.adler = r.check = h1(s), s = 0, i = 0, r.mode = kl;
        case kl:
          if (r.havedict === 0)
            return a.next_out = u, a.avail_out = e, a.next_in = d, a.avail_in = l, r.hold = s, r.bits = i, d5;
          a.adler = r.check = 1, r.mode = Sa;
        case Sa:
          if (t === h5 || t === cl)
            break t;
        case Ou:
          if (r.last) {
            s >>>= i & 7, i -= i & 7, r.mode = Iu;
            break;
          }
          for (; i < 3; ) {
            if (l === 0)
              break t;
            l--, s += o[d++] << i, i += 8;
          }
          switch (r.last = s & 1, s >>>= 1, i -= 1, s & 3) {
            case 0:
              r.mode = qd;
              break;
            case 1:
              if (w5(r), r.mode = dl, t === cl) {
                s >>>= 2, i -= 2;
                break t;
              }
              break;
            case 2:
              r.mode = e1;
              break;
            case 3:
              a.msg = "invalid block type", r.mode = Dn;
          }
          s >>>= 2, i -= 2;
          break;
        case qd:
          for (s >>>= i & 7, i -= i & 7; i < 32; ) {
            if (l === 0)
              break t;
            l--, s += o[d++] << i, i += 8;
          }
          if ((s & 65535) !== (s >>> 16 ^ 65535)) {
            a.msg = "invalid stored block lengths", r.mode = Dn;
            break;
          }
          if (r.length = s & 65535, s = 0, i = 0, r.mode = Fu, t === cl)
            break t;
        case Fu:
          r.mode = t1;
        case t1:
          if (v = r.length, v) {
            if (v > l && (v = l), v > e && (v = e), v === 0)
              break t;
            c.set(o.subarray(d, d + v), u), l -= v, d += v, e -= v, u += v, r.length -= v;
            break;
          }
          r.mode = Sa;
          break;
        case e1:
          for (; i < 14; ) {
            if (l === 0)
              break t;
            l--, s += o[d++] << i, i += 8;
          }
          if (r.nlen = (s & 31) + 257, s >>>= 5, i -= 5, r.ndist = (s & 31) + 1, s >>>= 5, i -= 5, r.ncode = (s & 15) + 4, s >>>= 4, i -= 4, r.nlen > 286 || r.ndist > 30) {
            a.msg = "too many length or distance symbols", r.mode = Dn;
            break;
          }
          r.have = 0, r.mode = r1;
        case r1:
          for (; r.have < r.ncode; ) {
            for (; i < 3; ) {
              if (l === 0)
                break t;
              l--, s += o[d++] << i, i += 8;
            }
            r.lens[P[r.have++]] = s & 7, s >>>= 3, i -= 3;
          }
          for (; r.have < 19; )
            r.lens[P[r.have++]] = 0;
          if (r.lencode = r.lendyn, r.lenbits = 7, C = { bits: r.lenbits }, A = a0(u5, r.lens, 0, 19, r.lencode, 0, r.work, C), r.lenbits = C.bits, A) {
            a.msg = "invalid code lengths set", r.mode = Dn;
            break;
          }
          r.have = 0, r.mode = n1;
        case n1:
          for (; r.have < r.nlen + r.ndist; ) {
            for (; x = r.lencode[s & (1 << r.lenbits) - 1], g = x >>> 24, S = x >>> 16 & 255, y = x & 65535, !(g <= i); ) {
              if (l === 0)
                break t;
              l--, s += o[d++] << i, i += 8;
            }
            if (y < 16)
              s >>>= g, i -= g, r.lens[r.have++] = y;
            else {
              if (y === 16) {
                for (T = g + 2; i < T; ) {
                  if (l === 0)
                    break t;
                  l--, s += o[d++] << i, i += 8;
                }
                if (s >>>= g, i -= g, r.have === 0) {
                  a.msg = "invalid bit length repeat", r.mode = Dn;
                  break;
                }
                E = r.lens[r.have - 1], v = 3 + (s & 3), s >>>= 2, i -= 2;
              } else if (y === 17) {
                for (T = g + 3; i < T; ) {
                  if (l === 0)
                    break t;
                  l--, s += o[d++] << i, i += 8;
                }
                s >>>= g, i -= g, E = 0, v = 3 + (s & 7), s >>>= 3, i -= 3;
              } else {
                for (T = g + 7; i < T; ) {
                  if (l === 0)
                    break t;
                  l--, s += o[d++] << i, i += 8;
                }
                s >>>= g, i -= g, E = 0, v = 11 + (s & 127), s >>>= 7, i -= 7;
              }
              if (r.have + v > r.nlen + r.ndist) {
                a.msg = "invalid bit length repeat", r.mode = Dn;
                break;
              }
              for (; v--; )
                r.lens[r.have++] = E;
            }
          }
          if (r.mode === Dn)
            break;
          if (r.lens[256] === 0) {
            a.msg = "invalid code -- missing end-of-block", r.mode = Dn;
            break;
          }
          if (r.lenbits = 9, C = { bits: r.lenbits }, A = a0(vg, r.lens, 0, r.nlen, r.lencode, 0, r.work, C), r.lenbits = C.bits, A) {
            a.msg = "invalid literal/lengths set", r.mode = Dn;
            break;
          }
          if (r.distbits = 6, r.distcode = r.distdyn, C = { bits: r.distbits }, A = a0(gg, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, C), r.distbits = C.bits, A) {
            a.msg = "invalid distances set", r.mode = Dn;
            break;
          }
          if (r.mode = dl, t === cl)
            break t;
        case dl:
          r.mode = vl;
        case vl:
          if (l >= 6 && e >= 258) {
            a.next_out = u, a.avail_out = e, a.next_in = d, a.avail_in = l, r.hold = s, r.bits = i, i5(a, h), u = a.next_out, c = a.output, e = a.avail_out, d = a.next_in, o = a.input, l = a.avail_in, s = r.hold, i = r.bits, r.mode === Sa && (r.back = -1);
            break;
          }
          for (r.back = 0; x = r.lencode[s & (1 << r.lenbits) - 1], g = x >>> 24, S = x >>> 16 & 255, y = x & 65535, !(g <= i); ) {
            if (l === 0)
              break t;
            l--, s += o[d++] << i, i += 8;
          }
          if (S && !(S & 240)) {
            for (b = g, n = S, w = y; x = r.lencode[w + ((s & (1 << b + n) - 1) >> b)], g = x >>> 24, S = x >>> 16 & 255, y = x & 65535, !(b + g <= i); ) {
              if (l === 0)
                break t;
              l--, s += o[d++] << i, i += 8;
            }
            s >>>= b, i -= b, r.back += b;
          }
          if (s >>>= g, i -= g, r.back += g, r.length = y, S === 0) {
            r.mode = l1;
            break;
          }
          if (S & 32) {
            r.back = -1, r.mode = Sa;
            break;
          }
          if (S & 64) {
            a.msg = "invalid literal/length code", r.mode = Dn;
            break;
          }
          r.extra = S & 15, r.mode = i1;
        case i1:
          if (r.extra) {
            for (T = r.extra; i < T; ) {
              if (l === 0)
                break t;
              l--, s += o[d++] << i, i += 8;
            }
            r.length += s & (1 << r.extra) - 1, s >>>= r.extra, i -= r.extra, r.back += r.extra;
          }
          r.was = r.length, r.mode = a1;
        case a1:
          for (; x = r.distcode[s & (1 << r.distbits) - 1], g = x >>> 24, S = x >>> 16 & 255, y = x & 65535, !(g <= i); ) {
            if (l === 0)
              break t;
            l--, s += o[d++] << i, i += 8;
          }
          if (!(S & 240)) {
            for (b = g, n = S, w = y; x = r.distcode[w + ((s & (1 << b + n) - 1) >> b)], g = x >>> 24, S = x >>> 16 & 255, y = x & 65535, !(b + g <= i); ) {
              if (l === 0)
                break t;
              l--, s += o[d++] << i, i += 8;
            }
            s >>>= b, i -= b, r.back += b;
          }
          if (s >>>= g, i -= g, r.back += g, S & 64) {
            a.msg = "invalid distance code", r.mode = Dn;
            break;
          }
          r.offset = y, r.extra = S & 15, r.mode = o1;
        case o1:
          if (r.extra) {
            for (T = r.extra; i < T; ) {
              if (l === 0)
                break t;
              l--, s += o[d++] << i, i += 8;
            }
            r.offset += s & (1 << r.extra) - 1, s >>>= r.extra, i -= r.extra, r.back += r.extra;
          }
          if (r.offset > r.dmax) {
            a.msg = "invalid distance too far back", r.mode = Dn;
            break;
          }
          r.mode = s1;
        case s1:
          if (e === 0)
            break t;
          if (v = h - e, r.offset > v) {
            if (v = r.offset - v, v > r.whave && r.sane) {
              a.msg = "invalid distance too far back", r.mode = Dn;
              break;
            }
            v > r.wnext ? (v -= r.wnext, p = r.wsize - v) : p = r.wnext - v, v > r.length && (v = r.length), m = r.window;
          } else
            m = c, p = u - r.offset, v = r.length;
          v > e && (v = e), e -= v, r.length -= v;
          do
            c[u++] = m[p++];
          while (--v);
          r.length === 0 && (r.mode = vl);
          break;
        case l1:
          if (e === 0)
            break t;
          c[u++] = r.length, e--, r.mode = vl;
          break;
        case Iu:
          if (r.wrap) {
            for (; i < 32; ) {
              if (l === 0)
                break t;
              l--, s |= o[d++] << i, i += 8;
            }
            if (h -= e, a.total_out += h, r.total += h, r.wrap & 4 && h && (a.adler = r.check = /*UPDATE_CHECK(state.check, put - _out, _out);*/
            r.flags ? ai(r.check, c, h, u - h) : d0(r.check, c, h, u - h)), h = e, r.wrap & 4 && (r.flags ? s : h1(s)) !== r.check) {
              a.msg = "incorrect data check", r.mode = Dn;
              break;
            }
            s = 0, i = 0;
          }
          r.mode = f1;
        case f1:
          if (r.wrap && r.flags) {
            for (; i < 32; ) {
              if (l === 0)
                break t;
              l--, s += o[d++] << i, i += 8;
            }
            if (r.wrap & 4 && s !== (r.total & 4294967295)) {
              a.msg = "incorrect length check", r.mode = Dn;
              break;
            }
            s = 0, i = 0;
          }
          r.mode = u1;
        case u1:
          A = c5;
          break t;
        case Dn:
          A = pg;
          break t;
        case mg:
          return yg;
        case xg:
        default:
          return ji;
      }
  return a.next_out = u, a.avail_out = e, a.next_in = d, a.avail_in = l, r.hold = s, r.bits = i, (r.wsize || h !== a.avail_out && r.mode < Dn && (r.mode < Iu || t !== Hd)) && Ag(a, a.output, a.next_out, h - a.avail_out), f -= a.avail_in, h -= a.avail_out, a.total_in += f, a.total_out += h, r.total += h, r.wrap & 4 && h && (a.adler = r.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/
  r.flags ? ai(r.check, c, h, a.next_out - h) : d0(r.check, c, h, a.next_out - h)), a.data_type = r.bits + (r.last ? 64 : 0) + (r.mode === Sa ? 128 : 0) + (r.mode === dl || r.mode === Fu ? 256 : 0), (f === 0 && h === 0 || t === Hd) && A === Oo && (A = v5), A;
}, E5 = (a) => {
  if (ko(a))
    return ji;
  let t = a.state;
  return t.window && (t.window = null), a.state = null, Oo;
}, A5 = (a, t) => {
  if (ko(a))
    return ji;
  const r = a.state;
  return r.wrap & 2 ? (r.head = t, t.done = !1, Oo) : ji;
}, C5 = (a, t) => {
  const r = t.length;
  let o, c, d;
  return ko(a) || (o = a.state, o.wrap !== 0 && o.mode !== kl) ? ji : o.mode === kl && (c = 1, c = d0(c, t, r, 0), c !== o.check) ? pg : (d = Ag(a, t, r, r), d ? (o.mode = mg, yg) : (o.havedict = 1, Oo));
};
var T5 = wg, P5 = Sg, O5 = bg, F5 = b5, I5 = Eg, R5 = S5, D5 = E5, M5 = A5, B5 = C5, k5 = "pako inflate (from Nodeca project)", Oa = {
  inflateReset: T5,
  inflateReset2: P5,
  inflateResetKeep: O5,
  inflateInit: F5,
  inflateInit2: I5,
  inflate: R5,
  inflateEnd: D5,
  inflateGetHeader: M5,
  inflateSetDictionary: B5,
  inflateInfo: k5
};
function N5() {
  this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
}
var L5 = N5;
const Cg = Object.prototype.toString, {
  Z_NO_FLUSH: U5,
  Z_FINISH: z5,
  Z_OK: p0,
  Z_STREAM_END: Mu,
  Z_NEED_DICT: Bu,
  Z_STREAM_ERROR: G5,
  Z_DATA_ERROR: d1,
  Z_MEM_ERROR: V5
} = Bo;
function C0(a) {
  this.options = Jl.assign({
    chunkSize: 1024 * 64,
    windowBits: 15,
    to: ""
  }, a || {});
  const t = this.options;
  t.raw && t.windowBits >= 0 && t.windowBits < 16 && (t.windowBits = -t.windowBits, t.windowBits === 0 && (t.windowBits = -15)), t.windowBits >= 0 && t.windowBits < 16 && !(a && a.windowBits) && (t.windowBits += 32), t.windowBits > 15 && t.windowBits < 48 && (t.windowBits & 15 || (t.windowBits |= 15)), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new cg(), this.strm.avail_out = 0;
  let r = Oa.inflateInit2(
    this.strm,
    t.windowBits
  );
  if (r !== p0)
    throw new Error(To[r]);
  if (this.header = new L5(), Oa.inflateGetHeader(this.strm, this.header), t.dictionary && (typeof t.dictionary == "string" ? t.dictionary = g0.string2buf(t.dictionary) : Cg.call(t.dictionary) === "[object ArrayBuffer]" && (t.dictionary = new Uint8Array(t.dictionary)), t.raw && (r = Oa.inflateSetDictionary(this.strm, t.dictionary), r !== p0)))
    throw new Error(To[r]);
}
C0.prototype.push = function(a, t) {
  const r = this.strm, o = this.options.chunkSize, c = this.options.dictionary;
  let d, u, l;
  if (this.ended)
    return !1;
  for (t === ~~t ? u = t : u = t === !0 ? z5 : U5, Cg.call(a) === "[object ArrayBuffer]" ? r.input = new Uint8Array(a) : r.input = a, r.next_in = 0, r.avail_in = r.input.length; ; ) {
    for (r.avail_out === 0 && (r.output = new Uint8Array(o), r.next_out = 0, r.avail_out = o), d = Oa.inflate(r, u), d === Bu && c && (d = Oa.inflateSetDictionary(r, c), d === p0 ? d = Oa.inflate(r, u) : d === d1 && (d = Bu)); r.avail_in > 0 && d === Mu && r.state.wrap > 0 && a[r.next_in] !== 0; )
      Oa.inflateReset(r), d = Oa.inflate(r, u);
    switch (d) {
      case G5:
      case d1:
      case Bu:
      case V5:
        return this.onEnd(d), this.ended = !0, !1;
    }
    if (l = r.avail_out, r.next_out && (r.avail_out === 0 || d === Mu))
      if (this.options.to === "string") {
        let e = g0.utf8border(r.output, r.next_out), s = r.next_out - e, i = g0.buf2string(r.output, e);
        r.next_out = s, r.avail_out = o - s, s && r.output.set(r.output.subarray(e, e + s), 0), this.onData(i);
      } else
        this.onData(r.output.length === r.next_out ? r.output : r.output.subarray(0, r.next_out));
    if (!(d === p0 && l === 0)) {
      if (d === Mu)
        return d = Oa.inflateEnd(this.strm), this.onEnd(d), this.ended = !0, !0;
      if (r.avail_in === 0)
        break;
    }
  }
  return !0;
};
C0.prototype.onData = function(a) {
  this.chunks.push(a);
};
C0.prototype.onEnd = function(a) {
  a === p0 && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = Jl.flattenChunks(this.chunks)), this.chunks = [], this.err = a, this.msg = this.strm.msg;
};
function Jh(a, t) {
  const r = new C0(t);
  if (r.push(a), r.err)
    throw r.msg || To[r.err];
  return r.result;
}
function H5(a, t) {
  return t = t || {}, t.raw = !0, Jh(a, t);
}
var W5 = C0, _5 = Jh, j5 = H5, X5 = Jh, Y5 = Bo, Z5 = {
  Inflate: W5,
  inflate: _5,
  inflateRaw: j5,
  ungzip: X5,
  constants: Y5
};
const { Deflate: K5, deflate: J5, deflateRaw: Q5, gzip: $5 } = r5, { Inflate: q5, inflate: tb, inflateRaw: eb, ungzip: rb } = Z5;
var nb = K5, ib = J5, ab = Q5, ob = $5, sb = q5, lb = tb, fb = eb, ub = rb, hb = Bo, cb = {
  Deflate: nb,
  deflate: ib,
  deflateRaw: ab,
  gzip: ob,
  Inflate: sb,
  inflate: lb,
  inflateRaw: fb,
  ungzip: ub,
  constants: hb
};
function Tg(a, t) {
  if (!t)
    return !1;
  if (!a && t)
    return !0;
  for (let r in a)
    if (a[r] != t[r])
      return !0;
  return !1;
}
function dh(a, t) {
  if (a === void 0)
    throw new jn("A defined svg string is required in preparecolors");
  let r = a;
  for (const d in t) {
    const u = new RegExp("CC" + d.slice(1), "g");
    r = r.replace(u, t[d]);
  }
  const o = new Blob([r], { type: "image/svg+xml" });
  return { url: URL.createObjectURL(o), string: r };
}
function v1(a) {
  return a = a.replace(/"#([0-9a-fA-F]{3})"/g, '"#$1$1"'), a = a.replace(/#([0-9a-fA-F]{6})/g, "CC$1"), a;
}
function aC(a) {
  a = a.replace(/(page|border|desk)color="#([a-f]|\d)*/g, "");
  const t = a.match(/#([0-9a-fA-F]{6})/g);
  return new Set(t);
}
function oC(a) {
  const t = a.match(/width="(\d*(.\d+)?(pt)?)"/), r = a.match(/height="(\d*(.\d+)?(pt)?)"/);
  if (t != null && r != null)
    return { width: parseFloat(t[1]), height: parseFloat(r[1]) };
  const o = a.match(/viewBox="0 0 (\d*\.?\d+) (\d*\.?\d+)"/);
  if (o === null)
    throw new Error("Exitract dimensions view box is null");
  return { width: parseFloat(o[1]), height: parseFloat(o[2]) };
}
function Pg(a, t) {
  return new Promise((r, o) => {
    fetch(a).then((c) => {
      c.blob().then((d) => {
        a.endsWith(".svgz") ? d.arrayBuffer().then((u) => {
          const l = new Uint8Array(u);
          let e = cb.inflate(l, { to: "string" });
          t.prepareColors && (e = v1(e)), r(e);
        }).catch((u) => {
          o(u);
        }) : d.text().then((u) => {
          t.prepareColors && (u = v1(u)), r(u);
        }).catch((u) => o(u));
      });
    });
  });
}
function vh(a) {
  if (a === void 0)
    throw new Error("svg to dom error");
  return new DOMParser().parseFromString(a, "image/svg+xml");
}
function sC(a, t, r, o) {
  const c = r / a, d = o / t, u = Math.max(c, d), l = Math.round(u * a), e = Math.round(u * t);
  return { width: l, height: e };
}
function Og(a, t) {
  if (a === void 0)
    return;
  const r = [...a.matchAll(/(m|M|v|V|h|H|z|Z|l|L|c|C)(( |,)-?\d*(\.\d+)?)*/g)].map((o) => o[0]);
  return function(o) {
    o.beginPath();
    let c = 0, d = 0;
    for (let u = 0; u < r.length; ++u) {
      const l = r[u][0];
      if (l === "z" || l === "Z") {
        o.closePath();
        continue;
      }
      const e = [...r[u].matchAll(/-?\d+\.?\d*e?-?\d*?/g)].map((i) => parseFloat(i[0]));
      let s = 0;
      for (; s < e.length; )
        switch (l) {
          case "M": {
            c = e[s], ++s, d = e[s], ++s, o.moveTo(t * c, t * d);
            break;
          }
          case "m": {
            const i = e[s];
            ++s;
            const f = e[s];
            ++s, c += i, d += f, o.moveTo(t * c, t * d);
            break;
          }
          case "L": {
            c = e[s], ++s, d = e[s], ++s, o.lineTo(t * c, t * d);
            break;
          }
          case "l": {
            const i = e[s];
            ++s;
            const f = e[s];
            ++s, c += i, d += f, o.lineTo(t * c, t * d);
            break;
          }
          case "C": {
            const i = e[s];
            ++s;
            const f = e[s];
            ++s;
            const h = e[s];
            ++s;
            const v = e[s];
            ++s, c = e[s], ++s, d = e[s], ++s, o.bezierCurveTo(t * i, t * f, t * h, t * v, t * c, t * d);
            break;
          }
          case "c": {
            const i = e[s];
            ++s;
            const f = e[s];
            ++s;
            const h = e[s];
            ++s;
            const v = e[s];
            ++s;
            const p = e[s];
            ++s;
            const m = e[s];
            ++s, o.bezierCurveTo(
              t * (c + i),
              t * (d + f),
              t * (c + h),
              t * (d + v),
              t * (c + p),
              t * (d + m)
            ), c += p, d += m;
            break;
          }
          case "v": {
            const i = e[s];
            ++s, d += i, o.lineTo(t * c, t * d);
            break;
          }
          case "h": {
            const i = e[s];
            ++s, c += i, o.lineTo(t * c, t * d);
            break;
          }
          case "V": {
            d = e[s], ++s, o.lineTo(t * c, t * d);
            break;
          }
          case "H": {
            c = e[s], ++s, o.lineTo(t * c, t * d);
            break;
          }
        }
    }
    o.fillStrokeShape(this);
  };
}
class Qh {
  constructor(t) {
    _e(this, "type");
    _e(this, "id");
    _e(this, "mimeType");
    _e(this, "recomputeImage");
    _e(this, "recomputePosition");
    _e(this, "inResize");
    _e(this, "originalSize");
    _e(this, "vida");
    this.recomputeImage = !1, this.inResize = !1, this.recomputePosition = !1, this.originalSize = { width: 0, height: 0 }, this.type = "", this.id = "", this.vida = t;
  }
  randomOptions() {
    throw Error("Not implemented");
  }
  toJson() {
    return console.error("toJson should be overriden"), {};
  }
  async imageToSvg() {
    return console.error("toPdf should be overriden"), "";
  }
  makeImage(t, r) {
    return console.error("make image should be overriden"), new Promise((o) => o());
  }
  update(t) {
    return console.error("update should be overriden"), new Promise((r) => r());
  }
  image() {
    console.error("image() should be overriden");
  }
  makeHitformFunction(t) {
    console.error("ImageVidaSubComponent::makeHitformFuction() should be overriden");
  }
}
var $l = { exports: {} }, e0 = { exports: {} };
(function() {
  var a, t, r, o, c, d;
  typeof performance < "u" && performance !== null && performance.now ? e0.exports = function() {
    return performance.now();
  } : typeof process < "u" && process !== null && process.hrtime ? (e0.exports = function() {
    return (a() - c) / 1e6;
  }, t = process.hrtime, a = function() {
    var u;
    return u = t(), u[0] * 1e9 + u[1];
  }, o = a(), d = process.uptime() * 1e9, c = o - d) : Date.now ? (e0.exports = function() {
    return Date.now() - r;
  }, r = Date.now()) : (e0.exports = function() {
    return (/* @__PURE__ */ new Date()).getTime() - r;
  }, r = (/* @__PURE__ */ new Date()).getTime());
}).call(ki);
var db = e0.exports, vb = db, Fa = typeof window > "u" ? ki : window, gl = ["moz", "webkit"], as = "AnimationFrame", us = Fa["request" + as], y0 = Fa["cancel" + as] || Fa["cancelRequest" + as];
for (var Zs = 0; !us && Zs < gl.length; Zs++)
  us = Fa[gl[Zs] + "Request" + as], y0 = Fa[gl[Zs] + "Cancel" + as] || Fa[gl[Zs] + "CancelRequest" + as];
if (!us || !y0) {
  var ku = 0, g1 = 0, go = [], gb = 1e3 / 60;
  us = function(a) {
    if (go.length === 0) {
      var t = vb(), r = Math.max(0, gb - (t - ku));
      ku = r + t, setTimeout(function() {
        var o = go.slice(0);
        go.length = 0;
        for (var c = 0; c < o.length; c++)
          if (!o[c].cancelled)
            try {
              o[c].callback(ku);
            } catch (d) {
              setTimeout(function() {
                throw d;
              }, 0);
            }
      }, Math.round(r));
    }
    return go.push({
      handle: ++g1,
      callback: a,
      cancelled: !1
    }), g1;
  }, y0 = function(a) {
    for (var t = 0; t < go.length; t++)
      go[t].handle === a && (go[t].cancelled = !0);
  };
}
$l.exports = function(a) {
  return us.call(Fa, a);
};
$l.exports.cancel = function() {
  y0.apply(Fa, arguments);
};
$l.exports.polyfill = function(a) {
  a || (a = Fa), a.requestAnimationFrame = us, a.cancelAnimationFrame = y0;
};
var pb = $l.exports;
const Nu = /* @__PURE__ */ Ro(pb);
var yb = function(a) {
  this.ok = !1, this.alpha = 1, a.charAt(0) == "#" && (a = a.substr(1, 6)), a = a.replace(/ /g, ""), a = a.toLowerCase();
  var t = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "00ffff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000000",
    blanchedalmond: "ffebcd",
    blue: "0000ff",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "00ffff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dodgerblue: "1e90ff",
    feldspar: "d19275",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "ff00ff",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgrey: "d3d3d3",
    lightgreen: "90ee90",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslateblue: "8470ff",
    lightslategray: "778899",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "00ff00",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "ff00ff",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370d8",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "d87093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "ff0000",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    violetred: "d02090",
    wheat: "f5deb3",
    white: "ffffff",
    whitesmoke: "f5f5f5",
    yellow: "ffff00",
    yellowgreen: "9acd32"
  };
  a = t[a] || a;
  for (var r = [
    {
      re: /^rgba\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3}),\s*((?:\d?\.)?\d)\)$/,
      example: ["rgba(123, 234, 45, 0.8)", "rgba(255,234,245,1.0)"],
      process: function(e) {
        return [
          parseInt(e[1]),
          parseInt(e[2]),
          parseInt(e[3]),
          parseFloat(e[4])
        ];
      }
    },
    {
      re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
      example: ["rgb(123, 234, 45)", "rgb(255,234,245)"],
      process: function(e) {
        return [
          parseInt(e[1]),
          parseInt(e[2]),
          parseInt(e[3])
        ];
      }
    },
    {
      re: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
      example: ["#00ff00", "336699"],
      process: function(e) {
        return [
          parseInt(e[1], 16),
          parseInt(e[2], 16),
          parseInt(e[3], 16)
        ];
      }
    },
    {
      re: /^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
      example: ["#fb0", "f0f"],
      process: function(e) {
        return [
          parseInt(e[1] + e[1], 16),
          parseInt(e[2] + e[2], 16),
          parseInt(e[3] + e[3], 16)
        ];
      }
    }
  ], o = 0; o < r.length; o++) {
    var c = r[o].re, d = r[o].process, u = c.exec(a);
    if (u) {
      var l = d(u);
      this.r = l[0], this.g = l[1], this.b = l[2], l.length > 3 && (this.alpha = l[3]), this.ok = !0;
    }
  }
  this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b, this.alpha = this.alpha < 0 ? 0 : this.alpha > 1 || isNaN(this.alpha) ? 1 : this.alpha, this.toRGB = function() {
    return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
  }, this.toRGBA = function() {
    return "rgba(" + this.r + ", " + this.g + ", " + this.b + ", " + this.alpha + ")";
  }, this.toHex = function() {
    var e = this.r.toString(16), s = this.g.toString(16), i = this.b.toString(16);
    return e.length == 1 && (e = "0" + e), s.length == 1 && (s = "0" + s), i.length == 1 && (i = "0" + i), "#" + e + s + i;
  }, this.getHelpXML = function() {
    for (var e = new Array(), s = 0; s < r.length; s++)
      for (var i = r[s].example, f = 0; f < i.length; f++)
        e[e.length] = i[f];
    for (var h in t)
      e[e.length] = h;
    var v = document.createElement("ul");
    v.setAttribute("id", "rgbcolor-examples");
    for (var s = 0; s < e.length; s++)
      try {
        var p = document.createElement("li"), m = new RGBColor(e[s]), x = document.createElement("div");
        x.style.cssText = "margin: 3px; border: 1px solid black; background:" + m.toHex() + "; color:" + m.toHex(), x.appendChild(document.createTextNode("test"));
        var g = document.createTextNode(
          " " + e[s] + " -> " + m.toRGB() + " -> " + m.toHex()
        );
        p.appendChild(x), p.appendChild(g), v.appendChild(p);
      } catch {
      }
    return v;
  };
};
const gh = /* @__PURE__ */ Ro(yb);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var Fg = function(a, t) {
  return (Fg = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
    r.__proto__ = o;
  } || function(r, o) {
    for (var c in o)
      Object.prototype.hasOwnProperty.call(o, c) && (r[c] = o[c]);
  })(a, t);
};
function Ig(a, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  function r() {
    this.constructor = a;
  }
  Fg(a, t), a.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
function mb(a) {
  var t = "";
  Array.isArray(a) || (a = [a]);
  for (var r = 0; r < a.length; r++) {
    var o = a[r];
    if (o.type === Ue.CLOSE_PATH)
      t += "z";
    else if (o.type === Ue.HORIZ_LINE_TO)
      t += (o.relative ? "h" : "H") + o.x;
    else if (o.type === Ue.VERT_LINE_TO)
      t += (o.relative ? "v" : "V") + o.y;
    else if (o.type === Ue.MOVE_TO)
      t += (o.relative ? "m" : "M") + o.x + " " + o.y;
    else if (o.type === Ue.LINE_TO)
      t += (o.relative ? "l" : "L") + o.x + " " + o.y;
    else if (o.type === Ue.CURVE_TO)
      t += (o.relative ? "c" : "C") + o.x1 + " " + o.y1 + " " + o.x2 + " " + o.y2 + " " + o.x + " " + o.y;
    else if (o.type === Ue.SMOOTH_CURVE_TO)
      t += (o.relative ? "s" : "S") + o.x2 + " " + o.y2 + " " + o.x + " " + o.y;
    else if (o.type === Ue.QUAD_TO)
      t += (o.relative ? "q" : "Q") + o.x1 + " " + o.y1 + " " + o.x + " " + o.y;
    else if (o.type === Ue.SMOOTH_QUAD_TO)
      t += (o.relative ? "t" : "T") + o.x + " " + o.y;
    else {
      if (o.type !== Ue.ARC)
        throw new Error('Unexpected command type "' + o.type + '" at index ' + r + ".");
      t += (o.relative ? "a" : "A") + o.rX + " " + o.rY + " " + o.xRot + " " + +o.lArcFlag + " " + +o.sweepFlag + " " + o.x + " " + o.y;
    }
  }
  return t;
}
function ph(a, t) {
  var r = a[0], o = a[1];
  return [r * Math.cos(t) - o * Math.sin(t), r * Math.sin(t) + o * Math.cos(t)];
}
function $i() {
  for (var a = [], t = 0; t < arguments.length; t++)
    a[t] = arguments[t];
  for (var r = 0; r < a.length; r++)
    if (typeof a[r] != "number")
      throw new Error("assertNumbers arguments[" + r + "] is not a number. " + typeof a[r] + " == typeof " + a[r]);
  return !0;
}
var Xa = Math.PI;
function Lu(a, t, r) {
  a.lArcFlag = a.lArcFlag === 0 ? 0 : 1, a.sweepFlag = a.sweepFlag === 0 ? 0 : 1;
  var o = a.rX, c = a.rY, d = a.x, u = a.y;
  o = Math.abs(a.rX), c = Math.abs(a.rY);
  var l = ph([(t - d) / 2, (r - u) / 2], -a.xRot / 180 * Xa), e = l[0], s = l[1], i = Math.pow(e, 2) / Math.pow(o, 2) + Math.pow(s, 2) / Math.pow(c, 2);
  1 < i && (o *= Math.sqrt(i), c *= Math.sqrt(i)), a.rX = o, a.rY = c;
  var f = Math.pow(o, 2) * Math.pow(s, 2) + Math.pow(c, 2) * Math.pow(e, 2), h = (a.lArcFlag !== a.sweepFlag ? 1 : -1) * Math.sqrt(Math.max(0, (Math.pow(o, 2) * Math.pow(c, 2) - f) / f)), v = o * s / c * h, p = -c * e / o * h, m = ph([v, p], a.xRot / 180 * Xa);
  a.cX = m[0] + (t + d) / 2, a.cY = m[1] + (r + u) / 2, a.phi1 = Math.atan2((s - p) / c, (e - v) / o), a.phi2 = Math.atan2((-s - p) / c, (-e - v) / o), a.sweepFlag === 0 && a.phi2 > a.phi1 && (a.phi2 -= 2 * Xa), a.sweepFlag === 1 && a.phi2 < a.phi1 && (a.phi2 += 2 * Xa), a.phi1 *= 180 / Xa, a.phi2 *= 180 / Xa;
}
function p1(a, t, r) {
  $i(a, t, r);
  var o = a * a + t * t - r * r;
  if (0 > o)
    return [];
  if (o === 0)
    return [[a * r / (a * a + t * t), t * r / (a * a + t * t)]];
  var c = Math.sqrt(o);
  return [[(a * r + t * c) / (a * a + t * t), (t * r - a * c) / (a * a + t * t)], [(a * r - t * c) / (a * a + t * t), (t * r + a * c) / (a * a + t * t)]];
}
var $n, Ea = Math.PI / 180;
function y1(a, t, r) {
  return (1 - r) * a + r * t;
}
function m1(a, t, r, o) {
  return a + Math.cos(o / 180 * Xa) * t + Math.sin(o / 180 * Xa) * r;
}
function x1(a, t, r, o) {
  var c = 1e-6, d = t - a, u = r - t, l = 3 * d + 3 * (o - r) - 6 * u, e = 6 * (u - d), s = 3 * d;
  return Math.abs(l) < c ? [-s / e] : function(i, f, h) {
    h === void 0 && (h = 1e-6);
    var v = i * i / 4 - f;
    if (v < -h)
      return [];
    if (v <= h)
      return [-i / 2];
    var p = Math.sqrt(v);
    return [-i / 2 - p, -i / 2 + p];
  }(e / l, s / l, c);
}
function b1(a, t, r, o, c) {
  var d = 1 - c;
  return a * (d * d * d) + t * (3 * d * d * c) + r * (3 * d * c * c) + o * (c * c * c);
}
(function(a) {
  function t() {
    return c(function(l, e, s) {
      return l.relative && (l.x1 !== void 0 && (l.x1 += e), l.y1 !== void 0 && (l.y1 += s), l.x2 !== void 0 && (l.x2 += e), l.y2 !== void 0 && (l.y2 += s), l.x !== void 0 && (l.x += e), l.y !== void 0 && (l.y += s), l.relative = !1), l;
    });
  }
  function r() {
    var l = NaN, e = NaN, s = NaN, i = NaN;
    return c(function(f, h, v) {
      return f.type & Ue.SMOOTH_CURVE_TO && (f.type = Ue.CURVE_TO, l = isNaN(l) ? h : l, e = isNaN(e) ? v : e, f.x1 = f.relative ? h - l : 2 * h - l, f.y1 = f.relative ? v - e : 2 * v - e), f.type & Ue.CURVE_TO ? (l = f.relative ? h + f.x2 : f.x2, e = f.relative ? v + f.y2 : f.y2) : (l = NaN, e = NaN), f.type & Ue.SMOOTH_QUAD_TO && (f.type = Ue.QUAD_TO, s = isNaN(s) ? h : s, i = isNaN(i) ? v : i, f.x1 = f.relative ? h - s : 2 * h - s, f.y1 = f.relative ? v - i : 2 * v - i), f.type & Ue.QUAD_TO ? (s = f.relative ? h + f.x1 : f.x1, i = f.relative ? v + f.y1 : f.y1) : (s = NaN, i = NaN), f;
    });
  }
  function o() {
    var l = NaN, e = NaN;
    return c(function(s, i, f) {
      if (s.type & Ue.SMOOTH_QUAD_TO && (s.type = Ue.QUAD_TO, l = isNaN(l) ? i : l, e = isNaN(e) ? f : e, s.x1 = s.relative ? i - l : 2 * i - l, s.y1 = s.relative ? f - e : 2 * f - e), s.type & Ue.QUAD_TO) {
        l = s.relative ? i + s.x1 : s.x1, e = s.relative ? f + s.y1 : s.y1;
        var h = s.x1, v = s.y1;
        s.type = Ue.CURVE_TO, s.x1 = ((s.relative ? 0 : i) + 2 * h) / 3, s.y1 = ((s.relative ? 0 : f) + 2 * v) / 3, s.x2 = (s.x + 2 * h) / 3, s.y2 = (s.y + 2 * v) / 3;
      } else
        l = NaN, e = NaN;
      return s;
    });
  }
  function c(l) {
    var e = 0, s = 0, i = NaN, f = NaN;
    return function(h) {
      if (isNaN(i) && !(h.type & Ue.MOVE_TO))
        throw new Error("path must start with moveto");
      var v = l(h, e, s, i, f);
      return h.type & Ue.CLOSE_PATH && (e = i, s = f), h.x !== void 0 && (e = h.relative ? e + h.x : h.x), h.y !== void 0 && (s = h.relative ? s + h.y : h.y), h.type & Ue.MOVE_TO && (i = e, f = s), v;
    };
  }
  function d(l, e, s, i, f, h) {
    return $i(l, e, s, i, f, h), c(function(v, p, m, x) {
      var g = v.x1, S = v.x2, y = v.relative && !isNaN(x), b = v.x !== void 0 ? v.x : y ? 0 : p, n = v.y !== void 0 ? v.y : y ? 0 : m;
      function w(xt) {
        return xt * xt;
      }
      v.type & Ue.HORIZ_LINE_TO && e !== 0 && (v.type = Ue.LINE_TO, v.y = v.relative ? 0 : m), v.type & Ue.VERT_LINE_TO && s !== 0 && (v.type = Ue.LINE_TO, v.x = v.relative ? 0 : p), v.x !== void 0 && (v.x = v.x * l + n * s + (y ? 0 : f)), v.y !== void 0 && (v.y = b * e + v.y * i + (y ? 0 : h)), v.x1 !== void 0 && (v.x1 = v.x1 * l + v.y1 * s + (y ? 0 : f)), v.y1 !== void 0 && (v.y1 = g * e + v.y1 * i + (y ? 0 : h)), v.x2 !== void 0 && (v.x2 = v.x2 * l + v.y2 * s + (y ? 0 : f)), v.y2 !== void 0 && (v.y2 = S * e + v.y2 * i + (y ? 0 : h));
      var E = l * i - e * s;
      if (v.xRot !== void 0 && (l !== 1 || e !== 0 || s !== 0 || i !== 1))
        if (E === 0)
          delete v.rX, delete v.rY, delete v.xRot, delete v.lArcFlag, delete v.sweepFlag, v.type = Ue.LINE_TO;
        else {
          var A = v.xRot * Math.PI / 180, O = Math.sin(A), C = Math.cos(A), T = 1 / w(v.rX), P = 1 / w(v.rY), I = w(C) * T + w(O) * P, F = 2 * O * C * (T - P), B = w(O) * T + w(C) * P, M = I * i * i - F * e * i + B * e * e, z = F * (l * i + e * s) - 2 * (I * s * i + B * l * e), L = I * s * s - F * l * s + B * l * l, J = (Math.atan2(z, M - L) + Math.PI) % Math.PI / 2, ft = Math.sin(J), Q = Math.cos(J);
          v.rX = Math.abs(E) / Math.sqrt(M * w(Q) + z * ft * Q + L * w(ft)), v.rY = Math.abs(E) / Math.sqrt(M * w(ft) - z * ft * Q + L * w(Q)), v.xRot = 180 * J / Math.PI;
        }
      return v.sweepFlag !== void 0 && 0 > E && (v.sweepFlag = +!v.sweepFlag), v;
    });
  }
  function u() {
    return function(l) {
      var e = {};
      for (var s in l)
        e[s] = l[s];
      return e;
    };
  }
  a.ROUND = function(l) {
    function e(s) {
      return Math.round(s * l) / l;
    }
    return l === void 0 && (l = 1e13), $i(l), function(s) {
      return s.x1 !== void 0 && (s.x1 = e(s.x1)), s.y1 !== void 0 && (s.y1 = e(s.y1)), s.x2 !== void 0 && (s.x2 = e(s.x2)), s.y2 !== void 0 && (s.y2 = e(s.y2)), s.x !== void 0 && (s.x = e(s.x)), s.y !== void 0 && (s.y = e(s.y)), s.rX !== void 0 && (s.rX = e(s.rX)), s.rY !== void 0 && (s.rY = e(s.rY)), s;
    };
  }, a.TO_ABS = t, a.TO_REL = function() {
    return c(function(l, e, s) {
      return l.relative || (l.x1 !== void 0 && (l.x1 -= e), l.y1 !== void 0 && (l.y1 -= s), l.x2 !== void 0 && (l.x2 -= e), l.y2 !== void 0 && (l.y2 -= s), l.x !== void 0 && (l.x -= e), l.y !== void 0 && (l.y -= s), l.relative = !0), l;
    });
  }, a.NORMALIZE_HVZ = function(l, e, s) {
    return l === void 0 && (l = !0), e === void 0 && (e = !0), s === void 0 && (s = !0), c(function(i, f, h, v, p) {
      if (isNaN(v) && !(i.type & Ue.MOVE_TO))
        throw new Error("path must start with moveto");
      return e && i.type & Ue.HORIZ_LINE_TO && (i.type = Ue.LINE_TO, i.y = i.relative ? 0 : h), s && i.type & Ue.VERT_LINE_TO && (i.type = Ue.LINE_TO, i.x = i.relative ? 0 : f), l && i.type & Ue.CLOSE_PATH && (i.type = Ue.LINE_TO, i.x = i.relative ? v - f : v, i.y = i.relative ? p - h : p), i.type & Ue.ARC && (i.rX === 0 || i.rY === 0) && (i.type = Ue.LINE_TO, delete i.rX, delete i.rY, delete i.xRot, delete i.lArcFlag, delete i.sweepFlag), i;
    });
  }, a.NORMALIZE_ST = r, a.QT_TO_C = o, a.INFO = c, a.SANITIZE = function(l) {
    l === void 0 && (l = 0), $i(l);
    var e = NaN, s = NaN, i = NaN, f = NaN;
    return c(function(h, v, p, m, x) {
      var g = Math.abs, S = !1, y = 0, b = 0;
      if (h.type & Ue.SMOOTH_CURVE_TO && (y = isNaN(e) ? 0 : v - e, b = isNaN(s) ? 0 : p - s), h.type & (Ue.CURVE_TO | Ue.SMOOTH_CURVE_TO) ? (e = h.relative ? v + h.x2 : h.x2, s = h.relative ? p + h.y2 : h.y2) : (e = NaN, s = NaN), h.type & Ue.SMOOTH_QUAD_TO ? (i = isNaN(i) ? v : 2 * v - i, f = isNaN(f) ? p : 2 * p - f) : h.type & Ue.QUAD_TO ? (i = h.relative ? v + h.x1 : h.x1, f = h.relative ? p + h.y1 : h.y2) : (i = NaN, f = NaN), h.type & Ue.LINE_COMMANDS || h.type & Ue.ARC && (h.rX === 0 || h.rY === 0 || !h.lArcFlag) || h.type & Ue.CURVE_TO || h.type & Ue.SMOOTH_CURVE_TO || h.type & Ue.QUAD_TO || h.type & Ue.SMOOTH_QUAD_TO) {
        var n = h.x === void 0 ? 0 : h.relative ? h.x : h.x - v, w = h.y === void 0 ? 0 : h.relative ? h.y : h.y - p;
        y = isNaN(i) ? h.x1 === void 0 ? y : h.relative ? h.x : h.x1 - v : i - v, b = isNaN(f) ? h.y1 === void 0 ? b : h.relative ? h.y : h.y1 - p : f - p;
        var E = h.x2 === void 0 ? 0 : h.relative ? h.x : h.x2 - v, A = h.y2 === void 0 ? 0 : h.relative ? h.y : h.y2 - p;
        g(n) <= l && g(w) <= l && g(y) <= l && g(b) <= l && g(E) <= l && g(A) <= l && (S = !0);
      }
      return h.type & Ue.CLOSE_PATH && g(v - m) <= l && g(p - x) <= l && (S = !0), S ? [] : h;
    });
  }, a.MATRIX = d, a.ROTATE = function(l, e, s) {
    e === void 0 && (e = 0), s === void 0 && (s = 0), $i(l, e, s);
    var i = Math.sin(l), f = Math.cos(l);
    return d(f, i, -i, f, e - e * f + s * i, s - e * i - s * f);
  }, a.TRANSLATE = function(l, e) {
    return e === void 0 && (e = 0), $i(l, e), d(1, 0, 0, 1, l, e);
  }, a.SCALE = function(l, e) {
    return e === void 0 && (e = l), $i(l, e), d(l, 0, 0, e, 0, 0);
  }, a.SKEW_X = function(l) {
    return $i(l), d(1, 0, Math.atan(l), 1, 0, 0);
  }, a.SKEW_Y = function(l) {
    return $i(l), d(1, Math.atan(l), 0, 1, 0, 0);
  }, a.X_AXIS_SYMMETRY = function(l) {
    return l === void 0 && (l = 0), $i(l), d(-1, 0, 0, 1, l, 0);
  }, a.Y_AXIS_SYMMETRY = function(l) {
    return l === void 0 && (l = 0), $i(l), d(1, 0, 0, -1, 0, l);
  }, a.A_TO_C = function() {
    return c(function(l, e, s) {
      return Ue.ARC === l.type ? function(i, f, h) {
        var v, p, m, x;
        i.cX || Lu(i, f, h);
        for (var g = Math.min(i.phi1, i.phi2), S = Math.max(i.phi1, i.phi2) - g, y = Math.ceil(S / 90), b = new Array(y), n = f, w = h, E = 0; E < y; E++) {
          var A = y1(i.phi1, i.phi2, E / y), O = y1(i.phi1, i.phi2, (E + 1) / y), C = O - A, T = 4 / 3 * Math.tan(C * Ea / 4), P = [Math.cos(A * Ea) - T * Math.sin(A * Ea), Math.sin(A * Ea) + T * Math.cos(A * Ea)], I = P[0], F = P[1], B = [Math.cos(O * Ea), Math.sin(O * Ea)], M = B[0], z = B[1], L = [M + T * Math.sin(O * Ea), z - T * Math.cos(O * Ea)], J = L[0], ft = L[1];
          b[E] = { relative: i.relative, type: Ue.CURVE_TO };
          var Q = function(xt, St) {
            var Pt = ph([xt * i.rX, St * i.rY], i.xRot), Gt = Pt[0], Rt = Pt[1];
            return [i.cX + Gt, i.cY + Rt];
          };
          v = Q(I, F), b[E].x1 = v[0], b[E].y1 = v[1], p = Q(J, ft), b[E].x2 = p[0], b[E].y2 = p[1], m = Q(M, z), b[E].x = m[0], b[E].y = m[1], i.relative && (b[E].x1 -= n, b[E].y1 -= w, b[E].x2 -= n, b[E].y2 -= w, b[E].x -= n, b[E].y -= w), n = (x = [b[E].x, b[E].y])[0], w = x[1];
        }
        return b;
      }(l, l.relative ? 0 : e, l.relative ? 0 : s) : l;
    });
  }, a.ANNOTATE_ARCS = function() {
    return c(function(l, e, s) {
      return l.relative && (e = 0, s = 0), Ue.ARC === l.type && Lu(l, e, s), l;
    });
  }, a.CLONE = u, a.CALCULATE_BOUNDS = function() {
    var l = function(h) {
      var v = {};
      for (var p in h)
        v[p] = h[p];
      return v;
    }, e = t(), s = o(), i = r(), f = c(function(h, v, p) {
      var m = i(s(e(l(h))));
      function x(ft) {
        ft > f.maxX && (f.maxX = ft), ft < f.minX && (f.minX = ft);
      }
      function g(ft) {
        ft > f.maxY && (f.maxY = ft), ft < f.minY && (f.minY = ft);
      }
      if (m.type & Ue.DRAWING_COMMANDS && (x(v), g(p)), m.type & Ue.HORIZ_LINE_TO && x(m.x), m.type & Ue.VERT_LINE_TO && g(m.y), m.type & Ue.LINE_TO && (x(m.x), g(m.y)), m.type & Ue.CURVE_TO) {
        x(m.x), g(m.y);
        for (var S = 0, y = x1(v, m.x1, m.x2, m.x); S < y.length; S++)
          0 < (J = y[S]) && 1 > J && x(b1(v, m.x1, m.x2, m.x, J));
        for (var b = 0, n = x1(p, m.y1, m.y2, m.y); b < n.length; b++)
          0 < (J = n[b]) && 1 > J && g(b1(p, m.y1, m.y2, m.y, J));
      }
      if (m.type & Ue.ARC) {
        x(m.x), g(m.y), Lu(m, v, p);
        for (var w = m.xRot / 180 * Math.PI, E = Math.cos(w) * m.rX, A = Math.sin(w) * m.rX, O = -Math.sin(w) * m.rY, C = Math.cos(w) * m.rY, T = m.phi1 < m.phi2 ? [m.phi1, m.phi2] : -180 > m.phi2 ? [m.phi2 + 360, m.phi1 + 360] : [m.phi2, m.phi1], P = T[0], I = T[1], F = function(ft) {
          var Q = ft[0], xt = ft[1], St = 180 * Math.atan2(xt, Q) / Math.PI;
          return St < P ? St + 360 : St;
        }, B = 0, M = p1(O, -E, 0).map(F); B < M.length; B++)
          (J = M[B]) > P && J < I && x(m1(m.cX, E, O, J));
        for (var z = 0, L = p1(C, -A, 0).map(F); z < L.length; z++) {
          var J;
          (J = L[z]) > P && J < I && g(m1(m.cY, A, C, J));
        }
      }
      return h;
    });
    return f.minX = 1 / 0, f.maxX = -1 / 0, f.minY = 1 / 0, f.maxY = -1 / 0, f;
  };
})($n || ($n = {}));
var Qi, Rg = function() {
  function a() {
  }
  return a.prototype.round = function(t) {
    return this.transform($n.ROUND(t));
  }, a.prototype.toAbs = function() {
    return this.transform($n.TO_ABS());
  }, a.prototype.toRel = function() {
    return this.transform($n.TO_REL());
  }, a.prototype.normalizeHVZ = function(t, r, o) {
    return this.transform($n.NORMALIZE_HVZ(t, r, o));
  }, a.prototype.normalizeST = function() {
    return this.transform($n.NORMALIZE_ST());
  }, a.prototype.qtToC = function() {
    return this.transform($n.QT_TO_C());
  }, a.prototype.aToC = function() {
    return this.transform($n.A_TO_C());
  }, a.prototype.sanitize = function(t) {
    return this.transform($n.SANITIZE(t));
  }, a.prototype.translate = function(t, r) {
    return this.transform($n.TRANSLATE(t, r));
  }, a.prototype.scale = function(t, r) {
    return this.transform($n.SCALE(t, r));
  }, a.prototype.rotate = function(t, r, o) {
    return this.transform($n.ROTATE(t, r, o));
  }, a.prototype.matrix = function(t, r, o, c, d, u) {
    return this.transform($n.MATRIX(t, r, o, c, d, u));
  }, a.prototype.skewX = function(t) {
    return this.transform($n.SKEW_X(t));
  }, a.prototype.skewY = function(t) {
    return this.transform($n.SKEW_Y(t));
  }, a.prototype.xSymmetry = function(t) {
    return this.transform($n.X_AXIS_SYMMETRY(t));
  }, a.prototype.ySymmetry = function(t) {
    return this.transform($n.Y_AXIS_SYMMETRY(t));
  }, a.prototype.annotateArcs = function() {
    return this.transform($n.ANNOTATE_ARCS());
  }, a;
}(), xb = function(a) {
  return a === " " || a === "	" || a === "\r" || a === `
`;
}, w1 = function(a) {
  return "0".charCodeAt(0) <= a.charCodeAt(0) && a.charCodeAt(0) <= "9".charCodeAt(0);
}, bb = function(a) {
  function t() {
    var r = a.call(this) || this;
    return r.curNumber = "", r.curCommandType = -1, r.curCommandRelative = !1, r.canParseCommandOrComma = !0, r.curNumberHasExp = !1, r.curNumberHasExpDigits = !1, r.curNumberHasDecimal = !1, r.curArgs = [], r;
  }
  return Ig(t, a), t.prototype.finish = function(r) {
    if (r === void 0 && (r = []), this.parse(" ", r), this.curArgs.length !== 0 || !this.canParseCommandOrComma)
      throw new SyntaxError("Unterminated command at the path end.");
    return r;
  }, t.prototype.parse = function(r, o) {
    var c = this;
    o === void 0 && (o = []);
    for (var d = function(f) {
      o.push(f), c.curArgs.length = 0, c.canParseCommandOrComma = !0;
    }, u = 0; u < r.length; u++) {
      var l = r[u], e = !(this.curCommandType !== Ue.ARC || this.curArgs.length !== 3 && this.curArgs.length !== 4 || this.curNumber.length !== 1 || this.curNumber !== "0" && this.curNumber !== "1"), s = w1(l) && (this.curNumber === "0" && l === "0" || e);
      if (!w1(l) || s)
        if (l !== "e" && l !== "E")
          if (l !== "-" && l !== "+" || !this.curNumberHasExp || this.curNumberHasExpDigits)
            if (l !== "." || this.curNumberHasExp || this.curNumberHasDecimal || e) {
              if (this.curNumber && this.curCommandType !== -1) {
                var i = Number(this.curNumber);
                if (isNaN(i))
                  throw new SyntaxError("Invalid number ending at " + u);
                if (this.curCommandType === Ue.ARC) {
                  if (this.curArgs.length === 0 || this.curArgs.length === 1) {
                    if (0 > i)
                      throw new SyntaxError('Expected positive number, got "' + i + '" at index "' + u + '"');
                  } else if ((this.curArgs.length === 3 || this.curArgs.length === 4) && this.curNumber !== "0" && this.curNumber !== "1")
                    throw new SyntaxError('Expected a flag, got "' + this.curNumber + '" at index "' + u + '"');
                }
                this.curArgs.push(i), this.curArgs.length === wb[this.curCommandType] && (Ue.HORIZ_LINE_TO === this.curCommandType ? d({ type: Ue.HORIZ_LINE_TO, relative: this.curCommandRelative, x: i }) : Ue.VERT_LINE_TO === this.curCommandType ? d({ type: Ue.VERT_LINE_TO, relative: this.curCommandRelative, y: i }) : this.curCommandType === Ue.MOVE_TO || this.curCommandType === Ue.LINE_TO || this.curCommandType === Ue.SMOOTH_QUAD_TO ? (d({ type: this.curCommandType, relative: this.curCommandRelative, x: this.curArgs[0], y: this.curArgs[1] }), Ue.MOVE_TO === this.curCommandType && (this.curCommandType = Ue.LINE_TO)) : this.curCommandType === Ue.CURVE_TO ? d({ type: Ue.CURVE_TO, relative: this.curCommandRelative, x1: this.curArgs[0], y1: this.curArgs[1], x2: this.curArgs[2], y2: this.curArgs[3], x: this.curArgs[4], y: this.curArgs[5] }) : this.curCommandType === Ue.SMOOTH_CURVE_TO ? d({ type: Ue.SMOOTH_CURVE_TO, relative: this.curCommandRelative, x2: this.curArgs[0], y2: this.curArgs[1], x: this.curArgs[2], y: this.curArgs[3] }) : this.curCommandType === Ue.QUAD_TO ? d({ type: Ue.QUAD_TO, relative: this.curCommandRelative, x1: this.curArgs[0], y1: this.curArgs[1], x: this.curArgs[2], y: this.curArgs[3] }) : this.curCommandType === Ue.ARC && d({ type: Ue.ARC, relative: this.curCommandRelative, rX: this.curArgs[0], rY: this.curArgs[1], xRot: this.curArgs[2], lArcFlag: this.curArgs[3], sweepFlag: this.curArgs[4], x: this.curArgs[5], y: this.curArgs[6] })), this.curNumber = "", this.curNumberHasExpDigits = !1, this.curNumberHasExp = !1, this.curNumberHasDecimal = !1, this.canParseCommandOrComma = !0;
              }
              if (!xb(l))
                if (l === "," && this.canParseCommandOrComma)
                  this.canParseCommandOrComma = !1;
                else if (l !== "+" && l !== "-" && l !== ".")
                  if (s)
                    this.curNumber = l, this.curNumberHasDecimal = !1;
                  else {
                    if (this.curArgs.length !== 0)
                      throw new SyntaxError("Unterminated command at index " + u + ".");
                    if (!this.canParseCommandOrComma)
                      throw new SyntaxError('Unexpected character "' + l + '" at index ' + u + ". Command cannot follow comma");
                    if (this.canParseCommandOrComma = !1, l !== "z" && l !== "Z")
                      if (l === "h" || l === "H")
                        this.curCommandType = Ue.HORIZ_LINE_TO, this.curCommandRelative = l === "h";
                      else if (l === "v" || l === "V")
                        this.curCommandType = Ue.VERT_LINE_TO, this.curCommandRelative = l === "v";
                      else if (l === "m" || l === "M")
                        this.curCommandType = Ue.MOVE_TO, this.curCommandRelative = l === "m";
                      else if (l === "l" || l === "L")
                        this.curCommandType = Ue.LINE_TO, this.curCommandRelative = l === "l";
                      else if (l === "c" || l === "C")
                        this.curCommandType = Ue.CURVE_TO, this.curCommandRelative = l === "c";
                      else if (l === "s" || l === "S")
                        this.curCommandType = Ue.SMOOTH_CURVE_TO, this.curCommandRelative = l === "s";
                      else if (l === "q" || l === "Q")
                        this.curCommandType = Ue.QUAD_TO, this.curCommandRelative = l === "q";
                      else if (l === "t" || l === "T")
                        this.curCommandType = Ue.SMOOTH_QUAD_TO, this.curCommandRelative = l === "t";
                      else {
                        if (l !== "a" && l !== "A")
                          throw new SyntaxError('Unexpected character "' + l + '" at index ' + u + ".");
                        this.curCommandType = Ue.ARC, this.curCommandRelative = l === "a";
                      }
                    else
                      o.push({ type: Ue.CLOSE_PATH }), this.canParseCommandOrComma = !0, this.curCommandType = -1;
                  }
                else
                  this.curNumber = l, this.curNumberHasDecimal = l === ".";
            } else
              this.curNumber += l, this.curNumberHasDecimal = !0;
          else
            this.curNumber += l;
        else
          this.curNumber += l, this.curNumberHasExp = !0;
      else
        this.curNumber += l, this.curNumberHasExpDigits = this.curNumberHasExp;
    }
    return o;
  }, t.prototype.transform = function(r) {
    return Object.create(this, { parse: { value: function(o, c) {
      c === void 0 && (c = []);
      for (var d = 0, u = Object.getPrototypeOf(this).parse.call(this, o); d < u.length; d++) {
        var l = u[d], e = r(l);
        Array.isArray(e) ? c.push.apply(c, e) : c.push(e);
      }
      return c;
    } } });
  }, t;
}(Rg), Ue = function(a) {
  function t(r) {
    var o = a.call(this) || this;
    return o.commands = typeof r == "string" ? t.parse(r) : r, o;
  }
  return Ig(t, a), t.prototype.encode = function() {
    return t.encode(this.commands);
  }, t.prototype.getBounds = function() {
    var r = $n.CALCULATE_BOUNDS();
    return this.transform(r), r;
  }, t.prototype.transform = function(r) {
    for (var o = [], c = 0, d = this.commands; c < d.length; c++) {
      var u = r(d[c]);
      Array.isArray(u) ? o.push.apply(o, u) : o.push(u);
    }
    return this.commands = o, this;
  }, t.encode = function(r) {
    return mb(r);
  }, t.parse = function(r) {
    var o = new bb(), c = [];
    return o.parse(r, c), o.finish(c), c;
  }, t.CLOSE_PATH = 1, t.MOVE_TO = 2, t.HORIZ_LINE_TO = 4, t.VERT_LINE_TO = 8, t.LINE_TO = 16, t.CURVE_TO = 32, t.SMOOTH_CURVE_TO = 64, t.QUAD_TO = 128, t.SMOOTH_QUAD_TO = 256, t.ARC = 512, t.LINE_COMMANDS = t.LINE_TO | t.HORIZ_LINE_TO | t.VERT_LINE_TO, t.DRAWING_COMMANDS = t.HORIZ_LINE_TO | t.VERT_LINE_TO | t.LINE_TO | t.CURVE_TO | t.SMOOTH_CURVE_TO | t.QUAD_TO | t.SMOOTH_QUAD_TO | t.ARC, t;
}(Rg), wb = ((Qi = {})[Ue.MOVE_TO] = 2, Qi[Ue.LINE_TO] = 2, Qi[Ue.HORIZ_LINE_TO] = 1, Qi[Ue.VERT_LINE_TO] = 1, Qi[Ue.CLOSE_PATH] = 0, Qi[Ue.QUAD_TO] = 4, Qi[Ue.SMOOTH_QUAD_TO] = 2, Qi[Ue.CURVE_TO] = 6, Qi[Ue.SMOOTH_CURVE_TO] = 4, Qi[Ue.ARC] = 7, Qi);
function Ol(a) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ol = function(t) {
    return typeof t;
  } : Ol = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ol(a);
}
function Sb(a, t) {
  if (!(a instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
var Eb = [512, 512, 456, 512, 328, 456, 335, 512, 405, 328, 271, 456, 388, 335, 292, 512, 454, 405, 364, 328, 298, 271, 496, 456, 420, 388, 360, 335, 312, 292, 273, 512, 482, 454, 428, 405, 383, 364, 345, 328, 312, 298, 284, 271, 259, 496, 475, 456, 437, 420, 404, 388, 374, 360, 347, 335, 323, 312, 302, 292, 282, 273, 265, 512, 497, 482, 468, 454, 441, 428, 417, 405, 394, 383, 373, 364, 354, 345, 337, 328, 320, 312, 305, 298, 291, 284, 278, 271, 265, 259, 507, 496, 485, 475, 465, 456, 446, 437, 428, 420, 412, 404, 396, 388, 381, 374, 367, 360, 354, 347, 341, 335, 329, 323, 318, 312, 307, 302, 297, 292, 287, 282, 278, 273, 269, 265, 261, 512, 505, 497, 489, 482, 475, 468, 461, 454, 447, 441, 435, 428, 422, 417, 411, 405, 399, 394, 389, 383, 378, 373, 368, 364, 359, 354, 350, 345, 341, 337, 332, 328, 324, 320, 316, 312, 309, 305, 301, 298, 294, 291, 287, 284, 281, 278, 274, 271, 268, 265, 262, 259, 257, 507, 501, 496, 491, 485, 480, 475, 470, 465, 460, 456, 451, 446, 442, 437, 433, 428, 424, 420, 416, 412, 408, 404, 400, 396, 392, 388, 385, 381, 377, 374, 370, 367, 363, 360, 357, 354, 350, 347, 344, 341, 338, 335, 332, 329, 326, 323, 320, 318, 315, 312, 310, 307, 304, 302, 299, 297, 294, 292, 289, 287, 285, 282, 280, 278, 275, 273, 271, 269, 267, 265, 263, 261, 259], Ab = [9, 11, 12, 13, 13, 14, 14, 15, 15, 15, 15, 16, 16, 16, 16, 17, 17, 17, 17, 17, 17, 17, 18, 18, 18, 18, 18, 18, 18, 18, 18, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24];
function Cb(a, t, r, o, c) {
  if (typeof a == "string" && (a = document.getElementById(a)), !a || Ol(a) !== "object" || !("getContext" in a))
    throw new TypeError("Expecting canvas with `getContext` method in processCanvasRGB(A) calls!");
  var d = a.getContext("2d");
  try {
    return d.getImageData(t, r, o, c);
  } catch (u) {
    throw new Error("unable to access image data: " + u);
  }
}
function Tb(a, t, r, o, c, d) {
  if (!(isNaN(d) || d < 1)) {
    d |= 0;
    var u = Cb(a, t, r, o, c);
    u = Pb(u, t, r, o, c, d), a.getContext("2d").putImageData(u, t, r);
  }
}
function Pb(a, t, r, o, c, d) {
  for (var u = a.data, l = 2 * d + 1, e = o - 1, s = c - 1, i = d + 1, f = i * (i + 1) / 2, h = new S1(), v = h, p, m = 1; m < l; m++)
    v = v.next = new S1(), m === i && (p = v);
  v.next = h;
  for (var x = null, g = null, S = 0, y = 0, b = Eb[d], n = Ab[d], w = 0; w < c; w++) {
    v = h;
    for (var E = u[y], A = u[y + 1], O = u[y + 2], C = u[y + 3], T = 0; T < i; T++)
      v.r = E, v.g = A, v.b = O, v.a = C, v = v.next;
    for (var P = 0, I = 0, F = 0, B = 0, M = i * E, z = i * A, L = i * O, J = i * C, ft = f * E, Q = f * A, xt = f * O, St = f * C, Pt = 1; Pt < i; Pt++) {
      var Gt = y + ((e < Pt ? e : Pt) << 2), Rt = u[Gt], bt = u[Gt + 1], Dt = u[Gt + 2], X = u[Gt + 3], gt = i - Pt;
      ft += (v.r = Rt) * gt, Q += (v.g = bt) * gt, xt += (v.b = Dt) * gt, St += (v.a = X) * gt, P += Rt, I += bt, F += Dt, B += X, v = v.next;
    }
    x = h, g = p;
    for (var st = 0; st < o; st++) {
      var rt = St * b >>> n;
      if (u[y + 3] = rt, rt !== 0) {
        var wt = 255 / rt;
        u[y] = (ft * b >>> n) * wt, u[y + 1] = (Q * b >>> n) * wt, u[y + 2] = (xt * b >>> n) * wt;
      } else
        u[y] = u[y + 1] = u[y + 2] = 0;
      ft -= M, Q -= z, xt -= L, St -= J, M -= x.r, z -= x.g, L -= x.b, J -= x.a;
      var Ft = st + d + 1;
      Ft = S + (Ft < e ? Ft : e) << 2, P += x.r = u[Ft], I += x.g = u[Ft + 1], F += x.b = u[Ft + 2], B += x.a = u[Ft + 3], ft += P, Q += I, xt += F, St += B, x = x.next;
      var zt = g, G = zt.r, D = zt.g, Z = zt.b, et = zt.a;
      M += G, z += D, L += Z, J += et, P -= G, I -= D, F -= Z, B -= et, g = g.next, y += 4;
    }
    S += o;
  }
  for (var vt = 0; vt < o; vt++) {
    y = vt << 2;
    var lt = u[y], dt = u[y + 1], kt = u[y + 2], jt = u[y + 3], me = i * lt, se = i * dt, Bt = i * kt, ge = i * jt, Re = f * lt, Te = f * dt, xe = f * kt, Fe = f * jt;
    v = h;
    for (var Zt = 0; Zt < i; Zt++)
      v.r = lt, v.g = dt, v.b = kt, v.a = jt, v = v.next;
    for (var qt = o, ve = 0, Se = 0, Pe = 0, Be = 0, De = 1; De <= d; De++) {
      y = qt + vt << 2;
      var It = i - De;
      Re += (v.r = lt = u[y]) * It, Te += (v.g = dt = u[y + 1]) * It, xe += (v.b = kt = u[y + 2]) * It, Fe += (v.a = jt = u[y + 3]) * It, Be += lt, ve += dt, Se += kt, Pe += jt, v = v.next, De < s && (qt += o);
    }
    y = vt, x = h, g = p;
    for (var he = 0; he < c; he++) {
      var nt = y << 2;
      u[nt + 3] = jt = Fe * b >>> n, jt > 0 ? (jt = 255 / jt, u[nt] = (Re * b >>> n) * jt, u[nt + 1] = (Te * b >>> n) * jt, u[nt + 2] = (xe * b >>> n) * jt) : u[nt] = u[nt + 1] = u[nt + 2] = 0, Re -= me, Te -= se, xe -= Bt, Fe -= ge, me -= x.r, se -= x.g, Bt -= x.b, ge -= x.a, nt = vt + ((nt = he + i) < s ? nt : s) * o << 2, Re += Be += x.r = u[nt], Te += ve += x.g = u[nt + 1], xe += Se += x.b = u[nt + 2], Fe += Pe += x.a = u[nt + 3], x = x.next, me += lt = g.r, se += dt = g.g, Bt += kt = g.b, ge += jt = g.a, Be -= lt, ve -= dt, Se -= kt, Pe -= jt, g = g.next, y += o;
    }
  }
  return a;
}
var S1 = (
  /**
   * Set properties.
   */
  function a() {
    Sb(this, a), this.r = 0, this.g = 0, this.b = 0, this.a = 0, this.next = null;
  }
);
function Es(a) {
  return a.replace(/(?!\u3000)\s+/gm, " ");
}
function Ob(a) {
  return a.replace(/^[\n \t]+/, "");
}
function Fb(a) {
  return a.replace(/[\n \t]+$/, "");
}
function Li(a) {
  const t = a.match(/-?(\d+(?:\.\d*(?:[eE][+-]?\d+)?)?|\.\d+)(?=\D|$)/gm);
  return t ? t.map(parseFloat) : [];
}
function Ib(a) {
  const t = Li(a);
  return [
    t[0] || 0,
    t[1] || 0,
    t[2] || 0,
    t[3] || 0,
    t[4] || 0,
    t[5] || 0
  ];
}
const Rb = /^[A-Z-]+$/;
function Db(a) {
  return Rb.test(a) ? a.toLowerCase() : a;
}
function Dg(a) {
  const t = /url\(('([^']+)'|"([^"]+)"|([^'")]+))\)/.exec(a);
  return t && (t[2] || t[3] || t[4]) || "";
}
function Mb(a) {
  if (!a.startsWith("rgb"))
    return a;
  let t = 3;
  return a.replace(
    /\d+(\.\d+)?/g,
    (o, c) => t-- && c ? String(Math.round(parseFloat(o))) : o
  );
}
const Bb = /(\[[^\]]+\])/g, kb = /(#[^\s+>~.[:]+)/g, Nb = /(\.[^\s+>~.[:]+)/g, Lb = /(::[^\s+>~.[:]+|:first-line|:first-letter|:before|:after)/gi, Ub = /(:[\w-]+\([^)]*\))/gi, zb = /(:[^\s+>~.[:]+)/g, Gb = /([^\s+>~.[:]+)/g;
function po(a, t) {
  const r = t.exec(a);
  return r ? [
    a.replace(t, " "),
    r.length
  ] : [
    a,
    0
  ];
}
function Vb(a) {
  const t = [
    0,
    0,
    0
  ];
  let r = a.replace(/:not\(([^)]*)\)/g, "     $1 ").replace(/{[\s\S]*/gm, " "), o = 0;
  return [r, o] = po(r, Bb), t[1] += o, [r, o] = po(r, kb), t[0] += o, [r, o] = po(r, Nb), t[1] += o, [r, o] = po(r, Lb), t[2] += o, [r, o] = po(r, Ub), t[1] += o, [r, o] = po(r, zb), t[1] += o, r = r.replace(/[*\s+>~]/g, " ").replace(/[#.]/g, " "), [r, o] = po(r, Gb), t[2] += o, t.join("");
}
const os = 1e-8;
function E1(a) {
  return Math.sqrt(Math.pow(a[0], 2) + Math.pow(a[1], 2));
}
function yh(a, t) {
  return (a[0] * t[0] + a[1] * t[1]) / (E1(a) * E1(t));
}
function A1(a, t) {
  return (a[0] * t[1] < a[1] * t[0] ? -1 : 1) * Math.acos(yh(a, t));
}
function C1(a) {
  return a * a * a;
}
function T1(a) {
  return 3 * a * a * (1 - a);
}
function P1(a) {
  return 3 * a * (1 - a) * (1 - a);
}
function O1(a) {
  return (1 - a) * (1 - a) * (1 - a);
}
function F1(a) {
  return a * a;
}
function I1(a) {
  return 2 * a * (1 - a);
}
function R1(a) {
  return (1 - a) * (1 - a);
}
class dr {
  static empty(t) {
    return new dr(t, "EMPTY", "");
  }
  split() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : " ";
    const { document: r, name: o } = this;
    return Es(this.getString()).trim().split(t).map(
      (c) => new dr(r, o, c)
    );
  }
  hasValue(t) {
    const r = this.value;
    return r !== null && r !== "" && (t || r !== 0) && typeof r < "u";
  }
  isString(t) {
    const { value: r } = this, o = typeof r == "string";
    return !o || !t ? o : t.test(r);
  }
  isUrlDefinition() {
    return this.isString(/^url\(/);
  }
  isPixels() {
    if (!this.hasValue())
      return !1;
    const t = this.getString();
    switch (!0) {
      case t.endsWith("px"):
      case /^[0-9]+$/.test(t):
        return !0;
      default:
        return !1;
    }
  }
  setValue(t) {
    return this.value = t, this;
  }
  getValue(t) {
    return typeof t > "u" || this.hasValue() ? this.value : t;
  }
  getNumber(t) {
    if (!this.hasValue())
      return typeof t > "u" ? 0 : parseFloat(t);
    const { value: r } = this;
    let o = parseFloat(r);
    return this.isString(/%$/) && (o /= 100), o;
  }
  getString(t) {
    return typeof t > "u" || this.hasValue() ? typeof this.value > "u" ? "" : String(this.value) : String(t);
  }
  getColor(t) {
    let r = this.getString(t);
    return this.isNormalizedColor || (this.isNormalizedColor = !0, r = Mb(r), this.value = r), r;
  }
  getDpi() {
    return 96;
  }
  getRem() {
    return this.document.rootEmSize;
  }
  getEm() {
    return this.document.emSize;
  }
  getUnits() {
    return this.getString().replace(/[0-9.-]/g, "");
  }
  getPixels(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    if (!this.hasValue())
      return 0;
    const [o, c] = typeof t == "boolean" ? [
      void 0,
      t
    ] : [
      t
    ], { viewPort: d } = this.document.screen;
    switch (!0) {
      case this.isString(/vmin$/):
        return this.getNumber() / 100 * Math.min(d.computeSize("x"), d.computeSize("y"));
      case this.isString(/vmax$/):
        return this.getNumber() / 100 * Math.max(d.computeSize("x"), d.computeSize("y"));
      case this.isString(/vw$/):
        return this.getNumber() / 100 * d.computeSize("x");
      case this.isString(/vh$/):
        return this.getNumber() / 100 * d.computeSize("y");
      case this.isString(/rem$/):
        return this.getNumber() * this.getRem();
      case this.isString(/em$/):
        return this.getNumber() * this.getEm();
      case this.isString(/ex$/):
        return this.getNumber() * this.getEm() / 2;
      case this.isString(/px$/):
        return this.getNumber();
      case this.isString(/pt$/):
        return this.getNumber() * this.getDpi() * (1 / 72);
      case this.isString(/pc$/):
        return this.getNumber() * 15;
      case this.isString(/cm$/):
        return this.getNumber() * this.getDpi() / 2.54;
      case this.isString(/mm$/):
        return this.getNumber() * this.getDpi() / 25.4;
      case this.isString(/in$/):
        return this.getNumber() * this.getDpi();
      case (this.isString(/%$/) && c):
        return this.getNumber() * this.getEm();
      case this.isString(/%$/):
        return this.getNumber() * d.computeSize(o);
      default: {
        const u = this.getNumber();
        return r && u < 1 ? u * d.computeSize(o) : u;
      }
    }
  }
  getMilliseconds() {
    return this.hasValue() ? this.isString(/ms$/) ? this.getNumber() : this.getNumber() * 1e3 : 0;
  }
  getRadians() {
    if (!this.hasValue())
      return 0;
    switch (!0) {
      case this.isString(/deg$/):
        return this.getNumber() * (Math.PI / 180);
      case this.isString(/grad$/):
        return this.getNumber() * (Math.PI / 200);
      case this.isString(/rad$/):
        return this.getNumber();
      default:
        return this.getNumber() * (Math.PI / 180);
    }
  }
  getDefinition() {
    const t = this.getString(), r = /#([^)'"]+)/.exec(t), o = (r == null ? void 0 : r[1]) || t;
    return this.document.definitions[o];
  }
  getFillStyleDefinition(t, r) {
    let o = this.getDefinition();
    if (!o)
      return null;
    if (typeof o.createGradient == "function" && "getBoundingBox" in t)
      return o.createGradient(this.document.ctx, t, r);
    if (typeof o.createPattern == "function") {
      if (o.getHrefAttribute().hasValue()) {
        const c = o.getAttribute("patternTransform");
        o = o.getHrefAttribute().getDefinition(), o && c.hasValue() && o.getAttribute("patternTransform", !0).setValue(c.value);
      }
      if (o)
        return o.createPattern(this.document.ctx, t, r);
    }
    return null;
  }
  getTextBaseline() {
    if (!this.hasValue())
      return null;
    const t = this.getString();
    return dr.textBaselineMapping[t] || null;
  }
  addOpacity(t) {
    let r = this.getColor();
    const o = r.length;
    let c = 0;
    for (let d = 0; d < o && (r[d] === "," && c++, c !== 3); d++)
      ;
    if (t.hasValue() && this.isString() && c !== 3) {
      const d = new gh(r);
      d.ok && (d.alpha = t.getNumber(), r = d.toRGBA());
    }
    return new dr(this.document, this.name, r);
  }
  constructor(t, r, o) {
    this.document = t, this.name = r, this.value = o, this.isNormalizedColor = !1;
  }
}
dr.textBaselineMapping = {
  baseline: "alphabetic",
  "before-edge": "top",
  "text-before-edge": "top",
  middle: "middle",
  central: "middle",
  "after-edge": "bottom",
  "text-after-edge": "bottom",
  ideographic: "ideographic",
  alphabetic: "alphabetic",
  hanging: "hanging",
  mathematical: "alphabetic"
};
class m0 {
  clear() {
    this.viewPorts = [];
  }
  setCurrent(t, r) {
    this.viewPorts.push({
      width: t,
      height: r
    });
  }
  removeCurrent() {
    this.viewPorts.pop();
  }
  getRoot() {
    const [t] = this.viewPorts;
    return t || D1();
  }
  getCurrent() {
    const { viewPorts: t } = this, r = t[t.length - 1];
    return r || D1();
  }
  get width() {
    return this.getCurrent().width;
  }
  get height() {
    return this.getCurrent().height;
  }
  computeSize(t) {
    return typeof t == "number" ? t : t === "x" ? this.width : t === "y" ? this.height : Math.sqrt(Math.pow(this.width, 2) + Math.pow(this.height, 2)) / Math.sqrt(2);
  }
  constructor() {
    this.viewPorts = [];
  }
}
m0.DEFAULT_VIEWPORT_WIDTH = 800;
m0.DEFAULT_VIEWPORT_HEIGHT = 600;
function D1() {
  return {
    width: m0.DEFAULT_VIEWPORT_WIDTH,
    height: m0.DEFAULT_VIEWPORT_HEIGHT
  };
}
class Mn {
  static parse(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    const [o = r, c = r] = Li(t);
    return new Mn(o, c);
  }
  static parseScale(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    const [o = r, c = o] = Li(t);
    return new Mn(o, c);
  }
  static parsePath(t) {
    const r = Li(t), o = r.length, c = [];
    for (let d = 0; d < o; d += 2)
      c.push(new Mn(r[d], r[d + 1]));
    return c;
  }
  angleTo(t) {
    return Math.atan2(t.y - this.y, t.x - this.x);
  }
  applyTransform(t) {
    const { x: r, y: o } = this, c = r * t[0] + o * t[2] + t[4], d = r * t[1] + o * t[3] + t[5];
    this.x = c, this.y = d;
  }
  constructor(t, r) {
    this.x = t, this.y = r;
  }
}
class Hb {
  isWorking() {
    return this.working;
  }
  start() {
    if (this.working)
      return;
    const { screen: t, onClick: r, onMouseMove: o } = this, c = t.ctx.canvas;
    c.onclick = r, c.onmousemove = o, this.working = !0;
  }
  stop() {
    if (!this.working)
      return;
    const t = this.screen.ctx.canvas;
    this.working = !1, t.onclick = null, t.onmousemove = null;
  }
  hasEvents() {
    return this.working && this.events.length > 0;
  }
  runEvents() {
    if (!this.working)
      return;
    const { screen: t, events: r, eventElements: o } = this, { style: c } = t.ctx.canvas;
    let d;
    c && (c.cursor = ""), r.forEach((u, l) => {
      let { run: e } = u;
      for (d = o[l]; d; )
        e(d), d = d.parent;
    }), this.events = [], this.eventElements = [];
  }
  checkPath(t, r) {
    if (!this.working || !r)
      return;
    const { events: o, eventElements: c } = this;
    o.forEach((d, u) => {
      let { x: l, y: e } = d;
      !c[u] && r.isPointInPath && r.isPointInPath(l, e) && (c[u] = t);
    });
  }
  checkBoundingBox(t, r) {
    if (!this.working || !r)
      return;
    const { events: o, eventElements: c } = this;
    o.forEach((d, u) => {
      let { x: l, y: e } = d;
      !c[u] && r.isPointInBox(l, e) && (c[u] = t);
    });
  }
  mapXY(t, r) {
    const { window: o, ctx: c } = this.screen, d = new Mn(t, r);
    let u = c.canvas;
    for (; u; )
      d.x -= u.offsetLeft, d.y -= u.offsetTop, u = u.offsetParent;
    return o != null && o.scrollX && (d.x += o.scrollX), o != null && o.scrollY && (d.y += o.scrollY), d;
  }
  onClick(t) {
    const { x: r, y: o } = this.mapXY(t.clientX, t.clientY);
    this.events.push({
      type: "onclick",
      x: r,
      y: o,
      run(c) {
        c.onClick && c.onClick();
      }
    });
  }
  onMouseMove(t) {
    const { x: r, y: o } = this.mapXY(t.clientX, t.clientY);
    this.events.push({
      type: "onmousemove",
      x: r,
      y: o,
      run(c) {
        c.onMouseMove && c.onMouseMove();
      }
    });
  }
  constructor(t) {
    this.screen = t, this.working = !1, this.events = [], this.eventElements = [], this.onClick = this.onClick.bind(this), this.onMouseMove = this.onMouseMove.bind(this);
  }
}
const Mg = typeof window < "u" ? window : null, Bg = typeof fetch < "u" ? fetch.bind(void 0) : void 0;
class Ra {
  wait(t) {
    this.waits.push(t);
  }
  ready() {
    return this.readyPromise ? this.readyPromise : Promise.resolve();
  }
  isReady() {
    if (this.isReadyLock)
      return !0;
    const t = this.waits.every(
      (r) => r()
    );
    return t && (this.waits = [], this.resolveReady && this.resolveReady()), this.isReadyLock = t, t;
  }
  setDefaults(t) {
    t.strokeStyle = "rgba(0,0,0,0)", t.lineCap = "butt", t.lineJoin = "miter", t.miterLimit = 4;
  }
  setViewBox(t) {
    let { document: r, ctx: o, aspectRatio: c, width: d, desiredWidth: u, height: l, desiredHeight: e, minX: s = 0, minY: i = 0, refX: f, refY: h, clip: v = !1, clipX: p = 0, clipY: m = 0 } = t;
    const x = Es(c).replace(/^defer\s/, ""), [g, S] = x.split(" "), y = g || "xMidYMid", b = S || "meet", n = d / u, w = l / e, E = Math.min(n, w), A = Math.max(n, w);
    let O = u, C = e;
    b === "meet" && (O *= E, C *= E), b === "slice" && (O *= A, C *= A);
    const T = new dr(r, "refX", f), P = new dr(r, "refY", h), I = T.hasValue() && P.hasValue();
    if (I && o.translate(-E * T.getPixels("x"), -E * P.getPixels("y")), v) {
      const F = E * p, B = E * m;
      o.beginPath(), o.moveTo(F, B), o.lineTo(d, B), o.lineTo(d, l), o.lineTo(F, l), o.closePath(), o.clip();
    }
    if (!I) {
      const F = b === "meet" && E === w, B = b === "slice" && A === w, M = b === "meet" && E === n, z = b === "slice" && A === n;
      y.startsWith("xMid") && (F || B) && o.translate(d / 2 - O / 2, 0), y.endsWith("YMid") && (M || z) && o.translate(0, l / 2 - C / 2), y.startsWith("xMax") && (F || B) && o.translate(d - O, 0), y.endsWith("YMax") && (M || z) && o.translate(0, l - C);
    }
    switch (!0) {
      case y === "none":
        o.scale(n, w);
        break;
      case b === "meet":
        o.scale(E, E);
        break;
      case b === "slice":
        o.scale(A, A);
        break;
    }
    o.translate(-s, -i);
  }
  start(t) {
    let { enableRedraw: r = !1, ignoreMouse: o = !1, ignoreAnimation: c = !1, ignoreDimensions: d = !1, ignoreClear: u = !1, forceRedraw: l, scaleWidth: e, scaleHeight: s, offsetX: i, offsetY: f } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { mouse: h } = this, v = 1e3 / Ra.FRAMERATE;
    if (this.isReadyLock = !1, this.frameDuration = v, this.readyPromise = new Promise((S) => {
      this.resolveReady = S;
    }), this.isReady() && this.render(t, d, u, e, s, i, f), !r)
      return;
    let p = Date.now(), m = p, x = 0;
    const g = () => {
      p = Date.now(), x = p - m, x >= v && (m = p - x % v, this.shouldUpdate(c, l) && (this.render(t, d, u, e, s, i, f), h.runEvents())), this.intervalId = Nu(g);
    };
    o || h.start(), this.intervalId = Nu(g);
  }
  stop() {
    this.intervalId && (Nu.cancel(this.intervalId), this.intervalId = null), this.mouse.stop();
  }
  shouldUpdate(t, r) {
    if (!t) {
      const { frameDuration: o } = this;
      if (this.animations.reduce(
        (d, u) => u.update(o) || d,
        !1
      ))
        return !0;
    }
    return !!(typeof r == "function" && r() || !this.isReadyLock && this.isReady() || this.mouse.hasEvents());
  }
  render(t, r, o, c, d, u, l) {
    const { viewPort: e, ctx: s, isFirstRender: i } = this, f = s.canvas;
    e.clear(), f.width && f.height && e.setCurrent(f.width, f.height);
    const h = t.getStyle("width"), v = t.getStyle("height");
    !r && (i || typeof c != "number" && typeof d != "number") && (h.hasValue() && (f.width = h.getPixels("x"), f.style && (f.style.width = "".concat(f.width, "px"))), v.hasValue() && (f.height = v.getPixels("y"), f.style && (f.style.height = "".concat(f.height, "px"))));
    let p = f.clientWidth || f.width, m = f.clientHeight || f.height;
    if (r && h.hasValue() && v.hasValue() && (p = h.getPixels("x"), m = v.getPixels("y")), e.setCurrent(p, m), typeof u == "number" && t.getAttribute("x", !0).setValue(u), typeof l == "number" && t.getAttribute("y", !0).setValue(l), typeof c == "number" || typeof d == "number") {
      const x = Li(t.getAttribute("viewBox").getString());
      let g = 0, S = 0;
      if (typeof c == "number") {
        const b = t.getStyle("width");
        b.hasValue() ? g = b.getPixels("x") / c : x[2] && !isNaN(x[2]) && (g = x[2] / c);
      }
      if (typeof d == "number") {
        const b = t.getStyle("height");
        b.hasValue() ? S = b.getPixels("y") / d : x[3] && !isNaN(x[3]) && (S = x[3] / d);
      }
      g || (g = S), S || (S = g), t.getAttribute("width", !0).setValue(c), t.getAttribute("height", !0).setValue(d);
      const y = t.getStyle("transform", !0, !0);
      y.setValue("".concat(y.getString(), " scale(").concat(1 / g, ", ").concat(1 / S, ")"));
    }
    o || s.clearRect(0, 0, p, m), t.render(s), i && (this.isFirstRender = !1);
  }
  constructor(t, { fetch: r = Bg, window: o = Mg } = {}) {
    if (this.ctx = t, this.viewPort = new m0(), this.mouse = new Hb(this), this.animations = [], this.waits = [], this.frameDuration = 0, this.isReadyLock = !1, this.isFirstRender = !0, this.intervalId = null, this.window = o, !r)
      throw new Error("Can't find 'fetch' in 'globalThis', please provide it via options");
    this.fetch = r;
  }
}
Ra.defaultWindow = Mg;
Ra.defaultFetch = Bg;
Ra.FRAMERATE = 30;
Ra.MAX_VIRTUAL_PIXELS = 3e4;
const { defaultFetch: Wb } = Ra, _b = typeof DOMParser < "u" ? DOMParser : void 0;
class Uu {
  async parse(t) {
    return t.startsWith("<") ? this.parseFromString(t) : this.load(t);
  }
  parseFromString(t) {
    const r = new this.DOMParser();
    try {
      return this.checkDocument(r.parseFromString(t, "image/svg+xml"));
    } catch {
      return this.checkDocument(r.parseFromString(t, "text/xml"));
    }
  }
  checkDocument(t) {
    const r = t.getElementsByTagName("parsererror")[0];
    if (r)
      throw new Error(r.textContent || "Unknown parse error");
    return t;
  }
  async load(t) {
    const o = await (await this.fetch(t)).text();
    return this.parseFromString(o);
  }
  constructor({ fetch: t = Wb, DOMParser: r = _b } = {}) {
    if (!t)
      throw new Error("Can't find 'fetch' in 'globalThis', please provide it via options");
    if (!r)
      throw new Error("Can't find 'DOMParser' in 'globalThis', please provide it via options");
    this.fetch = t, this.DOMParser = r;
  }
}
class jb {
  apply(t) {
    const { x: r, y: o } = this.point;
    t.translate(r || 0, o || 0);
  }
  unapply(t) {
    const { x: r, y: o } = this.point;
    t.translate(-1 * r || 0, -1 * o || 0);
  }
  applyToPoint(t) {
    const { x: r, y: o } = this.point;
    t.applyTransform([
      1,
      0,
      0,
      1,
      r || 0,
      o || 0
    ]);
  }
  constructor(t, r) {
    this.type = "translate", this.point = Mn.parse(r);
  }
}
class Xb {
  apply(t) {
    const { cx: r, cy: o, originX: c, originY: d, angle: u } = this, l = r + c.getPixels("x"), e = o + d.getPixels("y");
    t.translate(l, e), t.rotate(u.getRadians()), t.translate(-l, -e);
  }
  unapply(t) {
    const { cx: r, cy: o, originX: c, originY: d, angle: u } = this, l = r + c.getPixels("x"), e = o + d.getPixels("y");
    t.translate(l, e), t.rotate(-1 * u.getRadians()), t.translate(-l, -e);
  }
  applyToPoint(t) {
    const { cx: r, cy: o, angle: c } = this, d = c.getRadians();
    t.applyTransform([
      1,
      0,
      0,
      1,
      r || 0,
      o || 0
      // this.p.y
    ]), t.applyTransform([
      Math.cos(d),
      Math.sin(d),
      -Math.sin(d),
      Math.cos(d),
      0,
      0
    ]), t.applyTransform([
      1,
      0,
      0,
      1,
      -r || 0,
      -o || 0
      // -this.p.y
    ]);
  }
  constructor(t, r, o) {
    this.type = "rotate";
    const c = Li(r);
    this.angle = new dr(t, "angle", c[0]), this.originX = o[0], this.originY = o[1], this.cx = c[1] || 0, this.cy = c[2] || 0;
  }
}
class Yb {
  apply(t) {
    const { scale: { x: r, y: o }, originX: c, originY: d } = this, u = c.getPixels("x"), l = d.getPixels("y");
    t.translate(u, l), t.scale(r, o || r), t.translate(-u, -l);
  }
  unapply(t) {
    const { scale: { x: r, y: o }, originX: c, originY: d } = this, u = c.getPixels("x"), l = d.getPixels("y");
    t.translate(u, l), t.scale(1 / r, 1 / o || r), t.translate(-u, -l);
  }
  applyToPoint(t) {
    const { x: r, y: o } = this.scale;
    t.applyTransform([
      r || 0,
      0,
      0,
      o || 0,
      0,
      0
    ]);
  }
  constructor(t, r, o) {
    this.type = "scale";
    const c = Mn.parseScale(r);
    (c.x === 0 || c.y === 0) && (c.x = os, c.y = os), this.scale = c, this.originX = o[0], this.originY = o[1];
  }
}
class kg {
  apply(t) {
    const { originX: r, originY: o, matrix: c } = this, d = r.getPixels("x"), u = o.getPixels("y");
    t.translate(d, u), t.transform(c[0], c[1], c[2], c[3], c[4], c[5]), t.translate(-d, -u);
  }
  unapply(t) {
    const { originX: r, originY: o, matrix: c } = this, d = c[0], u = c[2], l = c[4], e = c[1], s = c[3], i = c[5], f = 0, h = 0, v = 1, p = 1 / (d * (s * v - i * h) - u * (e * v - i * f) + l * (e * h - s * f)), m = r.getPixels("x"), x = o.getPixels("y");
    t.translate(m, x), t.transform(p * (s * v - i * h), p * (i * f - e * v), p * (l * h - u * v), p * (d * v - l * f), p * (u * i - l * s), p * (l * e - d * i)), t.translate(-m, -x);
  }
  applyToPoint(t) {
    t.applyTransform(this.matrix);
  }
  constructor(t, r, o) {
    this.type = "matrix", this.matrix = Ib(r), this.originX = o[0], this.originY = o[1];
  }
}
class Ng extends kg {
  constructor(t, r, o) {
    super(t, r, o), this.type = "skew", this.angle = new dr(t, "angle", r);
  }
}
class Zb extends Ng {
  constructor(t, r, o) {
    super(t, r, o), this.type = "skewX", this.matrix = [
      1,
      0,
      Math.tan(this.angle.getRadians()),
      1,
      0,
      0
    ];
  }
}
class Kb extends Ng {
  constructor(t, r, o) {
    super(t, r, o), this.type = "skewY", this.matrix = [
      1,
      Math.tan(this.angle.getRadians()),
      0,
      1,
      0,
      0
    ];
  }
}
function Jb(a) {
  return Es(a).trim().replace(/\)([a-zA-Z])/g, ") $1").replace(/\)(\s?,\s?)/g, ") ").split(/\s(?=[a-z])/);
}
function Qb(a) {
  const [t = "", r = ""] = a.split("(");
  return [
    t.trim(),
    r.trim().replace(")", "")
  ];
}
class Fo {
  static fromElement(t, r) {
    const o = r.getStyle("transform", !1, !0);
    if (o.hasValue()) {
      const [c, d = c] = r.getStyle("transform-origin", !1, !0).split();
      if (c && d) {
        const u = [
          c,
          d
        ];
        return new Fo(t, o.getString(), u);
      }
    }
    return null;
  }
  apply(t) {
    this.transforms.forEach(
      (r) => r.apply(t)
    );
  }
  unapply(t) {
    this.transforms.forEach(
      (r) => r.unapply(t)
    );
  }
  // TODO: applyToPoint unused ... remove?
  applyToPoint(t) {
    this.transforms.forEach(
      (r) => r.applyToPoint(t)
    );
  }
  constructor(t, r, o) {
    this.document = t, this.transforms = [], Jb(r).forEach((d) => {
      if (d === "none")
        return;
      const [u, l] = Qb(d), e = Fo.transformTypes[u];
      e && this.transforms.push(new e(this.document, l, o));
    });
  }
}
Fo.transformTypes = {
  translate: jb,
  rotate: Xb,
  scale: Yb,
  matrix: kg,
  skewX: Zb,
  skewY: Kb
};
class In {
  getAttribute(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    const o = this.attributes[t];
    if (!o && r) {
      const c = new dr(this.document, t, "");
      return this.attributes[t] = c, c;
    }
    return o || dr.empty(this.document);
  }
  getHrefAttribute() {
    let t;
    for (const r in this.attributes)
      if (r === "href" || r.endsWith(":href")) {
        t = this.attributes[r];
        break;
      }
    return t || dr.empty(this.document);
  }
  getStyle(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    const c = this.styles[t];
    if (c)
      return c;
    const d = this.getAttribute(t);
    if (d.hasValue())
      return this.styles[t] = d, d;
    if (!o) {
      const { parent: u } = this;
      if (u) {
        const l = u.getStyle(t);
        if (l.hasValue())
          return l;
      }
    }
    if (r) {
      const u = new dr(this.document, t, "");
      return this.styles[t] = u, u;
    }
    return dr.empty(this.document);
  }
  render(t) {
    if (!(this.getStyle("display").getString() === "none" || this.getStyle("visibility").getString() === "hidden")) {
      if (t.save(), this.getStyle("mask").hasValue()) {
        const r = this.getStyle("mask").getDefinition();
        r && (this.applyEffects(t), r.apply(t, this));
      } else if (this.getStyle("filter").getValue("none") !== "none") {
        const r = this.getStyle("filter").getDefinition();
        r && (this.applyEffects(t), r.apply(t, this));
      } else
        this.setContext(t), this.renderChildren(t), this.clearContext(t);
      t.restore();
    }
  }
  setContext(t) {
  }
  applyEffects(t) {
    const r = Fo.fromElement(this.document, this);
    r && r.apply(t);
    const o = this.getStyle("clip-path", !1, !0);
    if (o.hasValue()) {
      const c = o.getDefinition();
      c && c.apply(t);
    }
  }
  clearContext(t) {
  }
  renderChildren(t) {
    this.children.forEach((r) => {
      r.render(t);
    });
  }
  addChild(t) {
    const r = t instanceof In ? t : this.document.createElement(t);
    r.parent = this, In.ignoreChildTypes.includes(r.type) || this.children.push(r);
  }
  matchesSelector(t) {
    var r;
    const { node: o } = this;
    if (typeof o.matches == "function")
      return o.matches(t);
    const c = (r = o.getAttribute) === null || r === void 0 ? void 0 : r.call(o, "class");
    return !c || c === "" ? !1 : c.split(" ").some(
      (d) => ".".concat(d) === t
    );
  }
  addStylesFromStyleDefinition() {
    const { styles: t, stylesSpecificity: r } = this.document;
    let o;
    for (const c in t)
      if (!c.startsWith("@") && this.matchesSelector(c)) {
        const d = t[c], u = r[c];
        if (d)
          for (const l in d) {
            let e = this.stylesSpecificity[l];
            typeof e > "u" && (e = "000"), u && u >= e && (o = d[l], o && (this.styles[l] = o), this.stylesSpecificity[l] = u);
          }
      }
  }
  removeStyles(t, r) {
    return r.reduce((c, d) => {
      const u = t.getStyle(d);
      if (!u.hasValue())
        return c;
      const l = u.getString();
      return u.setValue(""), [
        ...c,
        [
          d,
          l
        ]
      ];
    }, []);
  }
  restoreStyles(t, r) {
    r.forEach((o) => {
      let [c, d] = o;
      t.getStyle(c, !0).setValue(d);
    });
  }
  isFirstChild() {
    var t;
    return ((t = this.parent) === null || t === void 0 ? void 0 : t.children.indexOf(this)) === 0;
  }
  constructor(t, r, o = !1) {
    if (this.document = t, this.node = r, this.captureTextNodes = o, this.type = "", this.attributes = {}, this.styles = {}, this.stylesSpecificity = {}, this.animationFrozen = !1, this.animationFrozenValue = "", this.parent = null, this.children = [], !r || r.nodeType !== 1)
      return;
    Array.from(r.attributes).forEach((u) => {
      const l = Db(u.nodeName);
      this.attributes[l] = new dr(t, l, u.value);
    }), this.addStylesFromStyleDefinition(), this.getAttribute("style").hasValue() && this.getAttribute("style").getString().split(";").map(
      (l) => l.trim()
    ).forEach((l) => {
      if (!l)
        return;
      const [e, s] = l.split(":").map(
        (i) => i.trim()
      );
      e && (this.styles[e] = new dr(t, e, s));
    });
    const { definitions: c } = t, d = this.getAttribute("id");
    d.hasValue() && (c[d.getString()] || (c[d.getString()] = this)), Array.from(r.childNodes).forEach((u) => {
      if (u.nodeType === 1)
        this.addChild(u);
      else if (o && (u.nodeType === 3 || u.nodeType === 4)) {
        const l = t.createTextNode(u);
        l.getText().length > 0 && this.addChild(l);
      }
    });
  }
}
In.ignoreChildTypes = [
  "title"
];
class $b extends In {
  constructor(t, r, o) {
    super(t, r, o);
  }
}
function qb(a) {
  const t = a.trim();
  return /^('|")/.test(t) ? t : '"'.concat(t, '"');
}
function t9(a) {
  return typeof process > "u" ? a : a.trim().split(",").map(qb).join(",");
}
function e9(a) {
  if (!a)
    return "";
  const t = a.trim().toLowerCase();
  switch (t) {
    case "normal":
    case "italic":
    case "oblique":
    case "inherit":
    case "initial":
    case "unset":
      return t;
    default:
      return /^oblique\s+(-|)\d+deg$/.test(t) ? t : "";
  }
}
function r9(a) {
  if (!a)
    return "";
  const t = a.trim().toLowerCase();
  switch (t) {
    case "normal":
    case "bold":
    case "lighter":
    case "bolder":
    case "inherit":
    case "initial":
    case "unset":
      return t;
    default:
      return /^[\d.]+$/.test(t) ? t : "";
  }
}
class Ti {
  static parse() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", r = arguments.length > 1 ? arguments[1] : void 0, o = "", c = "", d = "", u = "", l = "";
    const e = Es(t).trim().split(" "), s = {
      fontSize: !1,
      fontStyle: !1,
      fontWeight: !1,
      fontVariant: !1
    };
    return e.forEach((i) => {
      switch (!0) {
        case (!s.fontStyle && Ti.styles.includes(i)):
          i !== "inherit" && (o = i), s.fontStyle = !0;
          break;
        case (!s.fontVariant && Ti.variants.includes(i)):
          i !== "inherit" && (c = i), s.fontStyle = !0, s.fontVariant = !0;
          break;
        case (!s.fontWeight && Ti.weights.includes(i)):
          i !== "inherit" && (d = i), s.fontStyle = !0, s.fontVariant = !0, s.fontWeight = !0;
          break;
        case !s.fontSize:
          i !== "inherit" && (u = i.split("/")[0] || ""), s.fontStyle = !0, s.fontVariant = !0, s.fontWeight = !0, s.fontSize = !0;
          break;
        default:
          i !== "inherit" && (l += i);
      }
    }), new Ti(o, c, d, u, l, r);
  }
  toString() {
    return [
      e9(this.fontStyle),
      this.fontVariant,
      r9(this.fontWeight),
      this.fontSize,
      // Wrap fontFamily only on nodejs and only for canvas.ctx
      t9(this.fontFamily)
    ].join(" ").trim();
  }
  constructor(t, r, o, c, d, u) {
    const l = u ? typeof u == "string" ? Ti.parse(u) : u : {};
    this.fontFamily = d || l.fontFamily, this.fontSize = c || l.fontSize, this.fontStyle = t || l.fontStyle, this.fontWeight = o || l.fontWeight, this.fontVariant = r || l.fontVariant;
  }
}
Ti.styles = "normal|italic|oblique|inherit";
Ti.variants = "normal|small-caps|inherit";
Ti.weights = "normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900|inherit";
class ra {
  get x() {
    return this.x1;
  }
  get y() {
    return this.y1;
  }
  get width() {
    return this.x2 - this.x1;
  }
  get height() {
    return this.y2 - this.y1;
  }
  addPoint(t, r) {
    typeof t < "u" && ((isNaN(this.x1) || isNaN(this.x2)) && (this.x1 = t, this.x2 = t), t < this.x1 && (this.x1 = t), t > this.x2 && (this.x2 = t)), typeof r < "u" && ((isNaN(this.y1) || isNaN(this.y2)) && (this.y1 = r, this.y2 = r), r < this.y1 && (this.y1 = r), r > this.y2 && (this.y2 = r));
  }
  addX(t) {
    this.addPoint(t, 0);
  }
  addY(t) {
    this.addPoint(0, t);
  }
  addBoundingBox(t) {
    if (!t)
      return;
    const { x1: r, y1: o, x2: c, y2: d } = t;
    this.addPoint(r, o), this.addPoint(c, d);
  }
  sumCubic(t, r, o, c, d) {
    return Math.pow(1 - t, 3) * r + 3 * Math.pow(1 - t, 2) * t * o + 3 * (1 - t) * Math.pow(t, 2) * c + Math.pow(t, 3) * d;
  }
  bezierCurveAdd(t, r, o, c, d) {
    const u = 6 * r - 12 * o + 6 * c, l = -3 * r + 9 * o - 9 * c + 3 * d, e = 3 * o - 3 * r;
    if (l === 0) {
      if (u === 0)
        return;
      const h = -e / u;
      0 < h && h < 1 && (t ? this.addX(this.sumCubic(h, r, o, c, d)) : this.addY(this.sumCubic(h, r, o, c, d)));
      return;
    }
    const s = Math.pow(u, 2) - 4 * e * l;
    if (s < 0)
      return;
    const i = (-u + Math.sqrt(s)) / (2 * l);
    0 < i && i < 1 && (t ? this.addX(this.sumCubic(i, r, o, c, d)) : this.addY(this.sumCubic(i, r, o, c, d)));
    const f = (-u - Math.sqrt(s)) / (2 * l);
    0 < f && f < 1 && (t ? this.addX(this.sumCubic(f, r, o, c, d)) : this.addY(this.sumCubic(f, r, o, c, d)));
  }
  // from http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
  addBezierCurve(t, r, o, c, d, u, l, e) {
    this.addPoint(t, r), this.addPoint(l, e), this.bezierCurveAdd(!0, t, o, d, l), this.bezierCurveAdd(!1, r, c, u, e);
  }
  addQuadraticCurve(t, r, o, c, d, u) {
    const l = t + 0.6666666666666666 * (o - t), e = r + 2 / 3 * (c - r), s = l + 1 / 3 * (d - t), i = e + 1 / 3 * (u - r);
    this.addBezierCurve(t, r, l, s, e, i, d, u);
  }
  isPointInBox(t, r) {
    const { x1: o, y1: c, x2: d, y2: u } = this;
    return o <= t && t <= d && c <= r && r <= u;
  }
  constructor(t = Number.NaN, r = Number.NaN, o = Number.NaN, c = Number.NaN) {
    this.x1 = t, this.y1 = r, this.x2 = o, this.y2 = c, this.addPoint(t, r), this.addPoint(o, c);
  }
}
class No extends In {
  calculateOpacity() {
    let t = 1, r = this;
    for (; r; ) {
      const o = r.getStyle("opacity", !1, !0);
      o.hasValue(!0) && (t *= o.getNumber()), r = r.parent;
    }
    return t;
  }
  setContext(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    if (!r) {
      const o = this.getStyle("fill"), c = this.getStyle("fill-opacity"), d = this.getStyle("stroke"), u = this.getStyle("stroke-opacity");
      if (o.isUrlDefinition()) {
        const v = o.getFillStyleDefinition(this, c);
        v && (t.fillStyle = v);
      } else if (o.hasValue()) {
        o.getString() === "currentColor" && o.setValue(this.getStyle("color").getColor());
        const v = o.getColor();
        v !== "inherit" && (t.fillStyle = v === "none" ? "rgba(0,0,0,0)" : v);
      }
      if (c.hasValue()) {
        const v = new dr(this.document, "fill", t.fillStyle).addOpacity(c).getColor();
        t.fillStyle = v;
      }
      if (d.isUrlDefinition()) {
        const v = d.getFillStyleDefinition(this, u);
        v && (t.strokeStyle = v);
      } else if (d.hasValue()) {
        d.getString() === "currentColor" && d.setValue(this.getStyle("color").getColor());
        const v = d.getString();
        v !== "inherit" && (t.strokeStyle = v === "none" ? "rgba(0,0,0,0)" : v);
      }
      if (u.hasValue()) {
        const v = new dr(this.document, "stroke", t.strokeStyle).addOpacity(u).getString();
        t.strokeStyle = v;
      }
      const l = this.getStyle("stroke-width");
      if (l.hasValue()) {
        const v = l.getPixels();
        t.lineWidth = v || os;
      }
      const e = this.getStyle("stroke-linecap"), s = this.getStyle("stroke-linejoin"), i = this.getStyle("stroke-miterlimit"), f = this.getStyle("stroke-dasharray"), h = this.getStyle("stroke-dashoffset");
      if (e.hasValue() && (t.lineCap = e.getString()), s.hasValue() && (t.lineJoin = s.getString()), i.hasValue() && (t.miterLimit = i.getNumber()), f.hasValue() && f.getString() !== "none") {
        const v = Li(f.getString());
        typeof t.setLineDash < "u" ? t.setLineDash(v) : typeof t.webkitLineDash < "u" ? t.webkitLineDash = v : typeof t.mozDash < "u" && !(v.length === 1 && v[0] === 0) && (t.mozDash = v);
        const p = h.getPixels();
        typeof t.lineDashOffset < "u" ? t.lineDashOffset = p : typeof t.webkitLineDashOffset < "u" ? t.webkitLineDashOffset = p : typeof t.mozDashOffset < "u" && (t.mozDashOffset = p);
      }
    }
    if (this.modifiedEmSizeStack = !1, typeof t.font < "u") {
      const o = this.getStyle("font"), c = this.getStyle("font-style"), d = this.getStyle("font-variant"), u = this.getStyle("font-weight"), l = this.getStyle("font-size"), e = this.getStyle("font-family"), s = new Ti(c.getString(), d.getString(), u.getString(), l.hasValue() ? "".concat(l.getPixels(!0), "px") : "", e.getString(), Ti.parse(o.getString(), t.font));
      c.setValue(s.fontStyle), d.setValue(s.fontVariant), u.setValue(s.fontWeight), l.setValue(s.fontSize), e.setValue(s.fontFamily), t.font = s.toString(), l.isPixels() && (this.document.emSize = l.getPixels(), this.modifiedEmSizeStack = !0);
    }
    r || (this.applyEffects(t), t.globalAlpha = this.calculateOpacity());
  }
  clearContext(t) {
    super.clearContext(t), this.modifiedEmSizeStack && this.document.popEmSize();
  }
  constructor(...t) {
    super(...t), this.modifiedEmSizeStack = !1;
  }
}
class to extends No {
  setContext(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    super.setContext(t, r);
    const o = this.getStyle("dominant-baseline").getTextBaseline() || this.getStyle("alignment-baseline").getTextBaseline();
    o && (t.textBaseline = o);
  }
  initializeCoordinates() {
    this.x = 0, this.y = 0, this.leafTexts = [], this.textChunkStart = 0, this.minX = Number.POSITIVE_INFINITY, this.maxX = Number.NEGATIVE_INFINITY;
  }
  getBoundingBox(t) {
    if (this.type !== "text")
      return this.getTElementBoundingBox(t);
    this.initializeCoordinates(), this.adjustChildCoordinatesRecursive(t);
    let r = null;
    return this.children.forEach((o, c) => {
      const d = this.getChildBoundingBox(t, this, this, c);
      r ? r.addBoundingBox(d) : r = d;
    }), r;
  }
  getFontSize() {
    const { document: t, parent: r } = this, o = Ti.parse(t.ctx.font).fontSize;
    return r.getStyle("font-size").getNumber(o);
  }
  getTElementBoundingBox(t) {
    const r = this.getFontSize();
    return new ra(this.x, this.y - r, this.x + this.measureText(t), this.y);
  }
  getGlyph(t, r, o) {
    const c = r[o];
    let d;
    if (t.isArabic) {
      var u;
      const l = r.length, e = r[o - 1], s = r[o + 1];
      let i = "isolated";
      (o === 0 || e === " ") && o < l - 1 && s !== " " && (i = "terminal"), o > 0 && e !== " " && o < l - 1 && s !== " " && (i = "medial"), o > 0 && e !== " " && (o === l - 1 || s === " ") && (i = "initial"), d = ((u = t.arabicGlyphs[c]) === null || u === void 0 ? void 0 : u[i]) || t.glyphs[c];
    } else
      d = t.glyphs[c];
    return d || (d = t.missingGlyph), d;
  }
  getText() {
    return "";
  }
  getTextFromNode(t) {
    const r = t || this.node, o = Array.from(r.parentNode.childNodes), c = o.indexOf(r), d = o.length - 1;
    let u = Es(
      // textNode.value
      // || textNode.text
      r.textContent || ""
    );
    return c === 0 && (u = Ob(u)), c === d && (u = Fb(u)), u;
  }
  renderChildren(t) {
    if (this.type !== "text") {
      this.renderTElementChildren(t);
      return;
    }
    this.initializeCoordinates(), this.adjustChildCoordinatesRecursive(t), this.children.forEach((o, c) => {
      this.renderChild(t, this, this, c);
    });
    const { mouse: r } = this.document.screen;
    r.isWorking() && r.checkBoundingBox(this, this.getBoundingBox(t));
  }
  renderTElementChildren(t) {
    const { document: r, parent: o } = this, c = this.getText(), d = o.getStyle("font-family").getDefinition();
    if (d) {
      const { unitsPerEm: e } = d.fontFace, s = Ti.parse(r.ctx.font), i = o.getStyle("font-size").getNumber(s.fontSize), f = o.getStyle("font-style").getString(s.fontStyle), h = i / e, v = d.isRTL ? c.split("").reverse().join("") : c, p = Li(o.getAttribute("dx").getString()), m = v.length;
      for (let x = 0; x < m; x++) {
        const g = this.getGlyph(d, v, x);
        t.translate(this.x, this.y), t.scale(h, -h);
        const S = t.lineWidth;
        t.lineWidth = t.lineWidth * e / i, f === "italic" && t.transform(1, 0, 0.4, 1, 0, 0), g.render(t), f === "italic" && t.transform(1, 0, -0.4, 1, 0, 0), t.lineWidth = S, t.scale(1 / h, -1 / h), t.translate(-this.x, -this.y), this.x += i * (g.horizAdvX || d.horizAdvX) / e, typeof p[x] < "u" && !isNaN(p[x]) && (this.x += p[x]);
      }
      return;
    }
    const { x: u, y: l } = this;
    t.fillStyle && t.fillText(c, u, l), t.strokeStyle && t.strokeText(c, u, l);
  }
  applyAnchoring() {
    if (this.textChunkStart >= this.leafTexts.length)
      return;
    const t = this.leafTexts[this.textChunkStart], r = t.getStyle("text-anchor").getString("start"), o = !1;
    let c = 0;
    r === "start" && !o || r === "end" && o ? c = t.x - this.minX : r === "end" && !o || r === "start" && o ? c = t.x - this.maxX : c = t.x - (this.minX + this.maxX) / 2;
    for (let d = this.textChunkStart; d < this.leafTexts.length; d++)
      this.leafTexts[d].x += c;
    this.minX = Number.POSITIVE_INFINITY, this.maxX = Number.NEGATIVE_INFINITY, this.textChunkStart = this.leafTexts.length;
  }
  adjustChildCoordinatesRecursive(t) {
    this.children.forEach((r, o) => {
      this.adjustChildCoordinatesRecursiveCore(t, this, this, o);
    }), this.applyAnchoring();
  }
  adjustChildCoordinatesRecursiveCore(t, r, o, c) {
    const d = o.children[c];
    d.children.length > 0 ? d.children.forEach((u, l) => {
      r.adjustChildCoordinatesRecursiveCore(t, r, d, l);
    }) : this.adjustChildCoordinates(t, r, o, c);
  }
  adjustChildCoordinates(t, r, o, c) {
    const d = o.children[c];
    if (typeof d.measureText != "function")
      return d;
    t.save(), d.setContext(t, !0);
    const u = d.getAttribute("x"), l = d.getAttribute("y"), e = d.getAttribute("dx"), s = d.getAttribute("dy"), i = d.getStyle("font-family").getDefinition(), f = !!(i != null && i.isRTL);
    c === 0 && (u.hasValue() || u.setValue(d.getInheritedAttribute("x")), l.hasValue() || l.setValue(d.getInheritedAttribute("y")), e.hasValue() || e.setValue(d.getInheritedAttribute("dx")), s.hasValue() || s.setValue(d.getInheritedAttribute("dy")));
    const h = d.measureText(t);
    return f && (r.x -= h), u.hasValue() ? (r.applyAnchoring(), d.x = u.getPixels("x"), e.hasValue() && (d.x += e.getPixels("x"))) : (e.hasValue() && (r.x += e.getPixels("x")), d.x = r.x), r.x = d.x, f || (r.x += h), l.hasValue() ? (d.y = l.getPixels("y"), s.hasValue() && (d.y += s.getPixels("y"))) : (s.hasValue() && (r.y += s.getPixels("y")), d.y = r.y), r.y = d.y, r.leafTexts.push(d), r.minX = Math.min(r.minX, d.x, d.x + h), r.maxX = Math.max(r.maxX, d.x, d.x + h), d.clearContext(t), t.restore(), d;
  }
  getChildBoundingBox(t, r, o, c) {
    const d = o.children[c];
    if (typeof d.getBoundingBox != "function")
      return null;
    const u = d.getBoundingBox(t);
    return u && d.children.forEach((l, e) => {
      const s = r.getChildBoundingBox(t, r, d, e);
      u.addBoundingBox(s);
    }), u;
  }
  renderChild(t, r, o, c) {
    const d = o.children[c];
    d.render(t), d.children.forEach((u, l) => {
      r.renderChild(t, r, d, l);
    });
  }
  measureText(t) {
    const { measureCache: r } = this;
    if (~r)
      return r;
    const o = this.getText(), c = this.measureTargetText(t, o);
    return this.measureCache = c, c;
  }
  measureTargetText(t, r) {
    if (!r.length)
      return 0;
    const { parent: o } = this, c = o.getStyle("font-family").getDefinition();
    if (c) {
      const u = this.getFontSize(), l = c.isRTL ? r.split("").reverse().join("") : r, e = Li(o.getAttribute("dx").getString()), s = l.length;
      let i = 0;
      for (let f = 0; f < s; f++) {
        const h = this.getGlyph(c, l, f);
        i += (h.horizAdvX || c.horizAdvX) * u / c.fontFace.unitsPerEm, typeof e[f] < "u" && !isNaN(e[f]) && (i += e[f]);
      }
      return i;
    }
    if (!t.measureText)
      return r.length * 10;
    t.save(), this.setContext(t, !0);
    const { width: d } = t.measureText(r);
    return this.clearContext(t), t.restore(), d;
  }
  /**
  * Inherits positional attributes from {@link TextElement} parent(s). Attributes
  * are only inherited from a parent to its first child.
  * @param name - The attribute name.
  * @returns The attribute value or null.
  */
  getInheritedAttribute(t) {
    let r = this;
    for (; r instanceof to && r.isFirstChild() && r.parent; ) {
      const o = r.parent.getAttribute(t);
      if (o.hasValue(!0))
        return o.getString("0");
      r = r.parent;
    }
    return null;
  }
  constructor(t, r, o) {
    super(t, r, new.target === to ? !0 : o), this.type = "text", this.x = 0, this.y = 0, this.leafTexts = [], this.textChunkStart = 0, this.minX = Number.POSITIVE_INFINITY, this.maxX = Number.NEGATIVE_INFINITY, this.measureCache = -1;
  }
}
class ql extends to {
  getText() {
    return this.text;
  }
  constructor(t, r, o) {
    super(t, r, new.target === ql ? !0 : o), this.type = "tspan", this.text = this.children.length > 0 ? "" : this.getTextFromNode();
  }
}
class n9 extends ql {
  constructor(...t) {
    super(...t), this.type = "textNode";
  }
}
class Ir extends Ue {
  reset() {
    this.i = -1, this.command = null, this.previousCommand = null, this.start = new Mn(0, 0), this.control = new Mn(0, 0), this.current = new Mn(0, 0), this.points = [], this.angles = [];
  }
  isEnd() {
    const { i: t, commands: r } = this;
    return t >= r.length - 1;
  }
  next() {
    const t = this.commands[++this.i];
    return this.previousCommand = this.command, this.command = t, t;
  }
  getPoint() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "x", r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "y";
    const o = new Mn(this.command[t], this.command[r]);
    return this.makeAbsolute(o);
  }
  getAsControlPoint(t, r) {
    const o = this.getPoint(t, r);
    return this.control = o, o;
  }
  getAsCurrentPoint(t, r) {
    const o = this.getPoint(t, r);
    return this.current = o, o;
  }
  getReflectedControlPoint() {
    const t = this.previousCommand.type;
    if (t !== Ue.CURVE_TO && t !== Ue.SMOOTH_CURVE_TO && t !== Ue.QUAD_TO && t !== Ue.SMOOTH_QUAD_TO)
      return this.current;
    const { current: { x: r, y: o }, control: { x: c, y: d } } = this;
    return new Mn(2 * r - c, 2 * o - d);
  }
  makeAbsolute(t) {
    if (this.command.relative) {
      const { x: r, y: o } = this.current;
      t.x += r, t.y += o;
    }
    return t;
  }
  addMarker(t, r, o) {
    const { points: c, angles: d } = this;
    o && d.length > 0 && !d[d.length - 1] && (d[d.length - 1] = c[c.length - 1].angleTo(o)), this.addMarkerAngle(t, r ? r.angleTo(t) : null);
  }
  addMarkerAngle(t, r) {
    this.points.push(t), this.angles.push(r);
  }
  getMarkerPoints() {
    return this.points;
  }
  getMarkerAngles() {
    const { angles: t } = this, r = t.length;
    for (let o = 0; o < r; o++)
      if (!t[o]) {
        for (let c = o + 1; c < r; c++)
          if (t[c]) {
            t[o] = t[c];
            break;
          }
      }
    return t;
  }
  constructor(t) {
    super(t.replace(/([+\-.])\s+/gm, "$1").replace(/[^MmZzLlHhVvCcSsQqTtAae\d\s.,+-].*/g, "")), this.control = new Mn(0, 0), this.start = new Mn(0, 0), this.current = new Mn(0, 0), this.command = null, this.commands = this.commands, this.i = -1, this.previousCommand = null, this.points = [], this.angles = [];
  }
}
class wn extends No {
  path(t) {
    const { pathParser: r } = this, o = new ra();
    for (r.reset(), t && t.beginPath(); !r.isEnd(); )
      switch (r.next().type) {
        case Ir.MOVE_TO:
          this.pathM(t, o);
          break;
        case Ir.LINE_TO:
          this.pathL(t, o);
          break;
        case Ir.HORIZ_LINE_TO:
          this.pathH(t, o);
          break;
        case Ir.VERT_LINE_TO:
          this.pathV(t, o);
          break;
        case Ir.CURVE_TO:
          this.pathC(t, o);
          break;
        case Ir.SMOOTH_CURVE_TO:
          this.pathS(t, o);
          break;
        case Ir.QUAD_TO:
          this.pathQ(t, o);
          break;
        case Ir.SMOOTH_QUAD_TO:
          this.pathT(t, o);
          break;
        case Ir.ARC:
          this.pathA(t, o);
          break;
        case Ir.CLOSE_PATH:
          this.pathZ(t, o);
          break;
      }
    return o;
  }
  getBoundingBox(t) {
    return this.path();
  }
  getMarkers() {
    const { pathParser: t } = this, r = t.getMarkerPoints(), o = t.getMarkerAngles();
    return r.map(
      (d, u) => [
        d,
        o[u]
      ]
    );
  }
  renderChildren(t) {
    this.path(t), this.document.screen.mouse.checkPath(this, t);
    const r = this.getStyle("fill-rule");
    t.fillStyle !== "" && (r.getString("inherit") !== "inherit" ? t.fill(r.getString()) : t.fill()), t.strokeStyle !== "" && (this.getAttribute("vector-effect").getString() === "non-scaling-stroke" ? (t.save(), t.setTransform(1, 0, 0, 1, 0, 0), t.stroke(), t.restore()) : t.stroke());
    const o = this.getMarkers();
    if (o) {
      const c = o.length - 1, d = this.getStyle("marker-start"), u = this.getStyle("marker-mid"), l = this.getStyle("marker-end");
      if (d.isUrlDefinition()) {
        const e = d.getDefinition(), [s, i] = o[0];
        e.render(t, s, i);
      }
      if (u.isUrlDefinition()) {
        const e = u.getDefinition();
        for (let s = 1; s < c; s++) {
          const [i, f] = o[s];
          e.render(t, i, f);
        }
      }
      if (l.isUrlDefinition()) {
        const e = l.getDefinition(), [s, i] = o[c];
        e.render(t, s, i);
      }
    }
  }
  static pathM(t) {
    const r = t.getAsCurrentPoint();
    return t.start = t.current, {
      point: r
    };
  }
  pathM(t, r) {
    const { pathParser: o } = this, { point: c } = wn.pathM(o), { x: d, y: u } = c;
    o.addMarker(c), r.addPoint(d, u), t && t.moveTo(d, u);
  }
  static pathL(t) {
    const { current: r } = t, o = t.getAsCurrentPoint();
    return {
      current: r,
      point: o
    };
  }
  pathL(t, r) {
    const { pathParser: o } = this, { current: c, point: d } = wn.pathL(o), { x: u, y: l } = d;
    o.addMarker(d, c), r.addPoint(u, l), t && t.lineTo(u, l);
  }
  static pathH(t) {
    const { current: r, command: o } = t, c = new Mn((o.relative ? r.x : 0) + o.x, r.y);
    return t.current = c, {
      current: r,
      point: c
    };
  }
  pathH(t, r) {
    const { pathParser: o } = this, { current: c, point: d } = wn.pathH(o), { x: u, y: l } = d;
    o.addMarker(d, c), r.addPoint(u, l), t && t.lineTo(u, l);
  }
  static pathV(t) {
    const { current: r, command: o } = t, c = new Mn(r.x, (o.relative ? r.y : 0) + o.y);
    return t.current = c, {
      current: r,
      point: c
    };
  }
  pathV(t, r) {
    const { pathParser: o } = this, { current: c, point: d } = wn.pathV(o), { x: u, y: l } = d;
    o.addMarker(d, c), r.addPoint(u, l), t && t.lineTo(u, l);
  }
  static pathC(t) {
    const { current: r } = t, o = t.getPoint("x1", "y1"), c = t.getAsControlPoint("x2", "y2"), d = t.getAsCurrentPoint();
    return {
      current: r,
      point: o,
      controlPoint: c,
      currentPoint: d
    };
  }
  pathC(t, r) {
    const { pathParser: o } = this, { current: c, point: d, controlPoint: u, currentPoint: l } = wn.pathC(o);
    o.addMarker(l, u, d), r.addBezierCurve(c.x, c.y, d.x, d.y, u.x, u.y, l.x, l.y), t && t.bezierCurveTo(d.x, d.y, u.x, u.y, l.x, l.y);
  }
  static pathS(t) {
    const { current: r } = t, o = t.getReflectedControlPoint(), c = t.getAsControlPoint("x2", "y2"), d = t.getAsCurrentPoint();
    return {
      current: r,
      point: o,
      controlPoint: c,
      currentPoint: d
    };
  }
  pathS(t, r) {
    const { pathParser: o } = this, { current: c, point: d, controlPoint: u, currentPoint: l } = wn.pathS(o);
    o.addMarker(l, u, d), r.addBezierCurve(c.x, c.y, d.x, d.y, u.x, u.y, l.x, l.y), t && t.bezierCurveTo(d.x, d.y, u.x, u.y, l.x, l.y);
  }
  static pathQ(t) {
    const { current: r } = t, o = t.getAsControlPoint("x1", "y1"), c = t.getAsCurrentPoint();
    return {
      current: r,
      controlPoint: o,
      currentPoint: c
    };
  }
  pathQ(t, r) {
    const { pathParser: o } = this, { current: c, controlPoint: d, currentPoint: u } = wn.pathQ(o);
    o.addMarker(u, d, d), r.addQuadraticCurve(c.x, c.y, d.x, d.y, u.x, u.y), t && t.quadraticCurveTo(d.x, d.y, u.x, u.y);
  }
  static pathT(t) {
    const { current: r } = t, o = t.getReflectedControlPoint();
    t.control = o;
    const c = t.getAsCurrentPoint();
    return {
      current: r,
      controlPoint: o,
      currentPoint: c
    };
  }
  pathT(t, r) {
    const { pathParser: o } = this, { current: c, controlPoint: d, currentPoint: u } = wn.pathT(o);
    o.addMarker(u, d, d), r.addQuadraticCurve(c.x, c.y, d.x, d.y, u.x, u.y), t && t.quadraticCurveTo(d.x, d.y, u.x, u.y);
  }
  static pathA(t) {
    const { current: r, command: o } = t;
    let { rX: c, rY: d, xRot: u, lArcFlag: l, sweepFlag: e } = o;
    const s = u * (Math.PI / 180), i = t.getAsCurrentPoint(), f = new Mn(Math.cos(s) * (r.x - i.x) / 2 + Math.sin(s) * (r.y - i.y) / 2, -Math.sin(s) * (r.x - i.x) / 2 + Math.cos(s) * (r.y - i.y) / 2), h = Math.pow(f.x, 2) / Math.pow(c, 2) + Math.pow(f.y, 2) / Math.pow(d, 2);
    h > 1 && (c *= Math.sqrt(h), d *= Math.sqrt(h));
    let v = (l === e ? -1 : 1) * Math.sqrt((Math.pow(c, 2) * Math.pow(d, 2) - Math.pow(c, 2) * Math.pow(f.y, 2) - Math.pow(d, 2) * Math.pow(f.x, 2)) / (Math.pow(c, 2) * Math.pow(f.y, 2) + Math.pow(d, 2) * Math.pow(f.x, 2)));
    isNaN(v) && (v = 0);
    const p = new Mn(v * c * f.y / d, v * -d * f.x / c), m = new Mn((r.x + i.x) / 2 + Math.cos(s) * p.x - Math.sin(s) * p.y, (r.y + i.y) / 2 + Math.sin(s) * p.x + Math.cos(s) * p.y), x = A1([
      1,
      0
    ], [
      (f.x - p.x) / c,
      (f.y - p.y) / d
    ]), g = [
      (f.x - p.x) / c,
      (f.y - p.y) / d
    ], S = [
      (-f.x - p.x) / c,
      (-f.y - p.y) / d
    ];
    let y = A1(g, S);
    return yh(g, S) <= -1 && (y = Math.PI), yh(g, S) >= 1 && (y = 0), {
      currentPoint: i,
      rX: c,
      rY: d,
      sweepFlag: e,
      xAxisRotation: s,
      centp: m,
      a1: x,
      ad: y
    };
  }
  pathA(t, r) {
    const { pathParser: o } = this, { currentPoint: c, rX: d, rY: u, sweepFlag: l, xAxisRotation: e, centp: s, a1: i, ad: f } = wn.pathA(o), h = 1 - l ? 1 : -1, v = i + h * (f / 2), p = new Mn(s.x + d * Math.cos(v), s.y + u * Math.sin(v));
    if (o.addMarkerAngle(p, v - h * Math.PI / 2), o.addMarkerAngle(c, v - h * Math.PI), r.addPoint(c.x, c.y), t && !isNaN(i) && !isNaN(f)) {
      const m = d > u ? d : u, x = d > u ? 1 : d / u, g = d > u ? u / d : 1;
      t.translate(s.x, s.y), t.rotate(e), t.scale(x, g), t.arc(0, 0, m, i, i + f, !!(1 - l)), t.scale(1 / x, 1 / g), t.rotate(-e), t.translate(-s.x, -s.y);
    }
  }
  static pathZ(t) {
    t.current = t.start;
  }
  pathZ(t, r) {
    wn.pathZ(this.pathParser), t && r.x1 !== r.x2 && r.y1 !== r.y2 && t.closePath();
  }
  constructor(t, r, o) {
    super(t, r, o), this.type = "path", this.pathParser = new Ir(this.getAttribute("d").getString());
  }
}
let T0 = class extends No {
  setContext(t) {
    var r;
    const { document: o } = this, { screen: c, window: d } = o, u = t.canvas;
    if (c.setDefaults(t), "style" in u && typeof t.font < "u" && d && typeof d.getComputedStyle < "u") {
      t.font = d.getComputedStyle(u).getPropertyValue("font");
      const S = new dr(o, "fontSize", Ti.parse(t.font).fontSize);
      S.hasValue() && (o.rootEmSize = S.getPixels("y"), o.emSize = o.rootEmSize);
    }
    this.getAttribute("x").hasValue() || this.getAttribute("x", !0).setValue(0), this.getAttribute("y").hasValue() || this.getAttribute("y", !0).setValue(0);
    let { width: l, height: e } = c.viewPort;
    this.getStyle("width").hasValue() || this.getStyle("width", !0).setValue("100%"), this.getStyle("height").hasValue() || this.getStyle("height", !0).setValue("100%"), this.getStyle("color").hasValue() || this.getStyle("color", !0).setValue("black");
    const s = this.getAttribute("refX"), i = this.getAttribute("refY"), f = this.getAttribute("viewBox"), h = f.hasValue() ? Li(f.getString()) : null, v = !this.root && this.getStyle("overflow").getValue("hidden") !== "visible";
    let p = 0, m = 0, x = 0, g = 0;
    h && (p = h[0], m = h[1]), this.root || (l = this.getStyle("width").getPixels("x"), e = this.getStyle("height").getPixels("y"), this.type === "marker" && (x = p, g = m, p = 0, m = 0)), c.viewPort.setCurrent(l, e), this.node && (!this.parent || ((r = this.node.parentNode) === null || r === void 0 ? void 0 : r.nodeName) === "foreignObject") && this.getStyle("transform", !1, !0).hasValue() && !this.getStyle("transform-origin", !1, !0).hasValue() && this.getStyle("transform-origin", !0, !0).setValue("50% 50%"), super.setContext(t), t.translate(this.getAttribute("x").getPixels("x"), this.getAttribute("y").getPixels("y")), h && (l = h[2], e = h[3]), o.setViewBox({
      ctx: t,
      aspectRatio: this.getAttribute("preserveAspectRatio").getString(),
      width: c.viewPort.width,
      desiredWidth: l,
      height: c.viewPort.height,
      desiredHeight: e,
      minX: p,
      minY: m,
      refX: s.getValue(),
      refY: i.getValue(),
      clip: v,
      clipX: x,
      clipY: g
    }), h && (c.viewPort.removeCurrent(), c.viewPort.setCurrent(l, e));
  }
  clearContext(t) {
    super.clearContext(t), this.document.screen.viewPort.removeCurrent();
  }
  /**
  * Resize SVG to fit in given size.
  * @param width
  * @param height
  * @param preserveAspectRatio
  */
  resize(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : t, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    const c = this.getAttribute("width", !0), d = this.getAttribute("height", !0), u = this.getAttribute("viewBox"), l = this.getAttribute("style"), e = c.getNumber(0), s = d.getNumber(0);
    if (o)
      if (typeof o == "string")
        this.getAttribute("preserveAspectRatio", !0).setValue(o);
      else {
        const i = this.getAttribute("preserveAspectRatio");
        i.hasValue() && i.setValue(i.getString().replace(/^\s*(\S.*\S)\s*$/, "$1"));
      }
    if (c.setValue(t), d.setValue(r), u.hasValue() || u.setValue("0 0 ".concat(e || t, " ").concat(s || r)), l.hasValue()) {
      const i = this.getStyle("width"), f = this.getStyle("height");
      i.hasValue() && i.setValue("".concat(t, "px")), f.hasValue() && f.setValue("".concat(r, "px"));
    }
  }
  constructor(...t) {
    super(...t), this.type = "svg", this.root = !1;
  }
};
class Lg extends wn {
  path(t) {
    const r = this.getAttribute("x").getPixels("x"), o = this.getAttribute("y").getPixels("y"), c = this.getStyle("width", !1, !0).getPixels("x"), d = this.getStyle("height", !1, !0).getPixels("y"), u = this.getAttribute("rx"), l = this.getAttribute("ry");
    let e = u.getPixels("x"), s = l.getPixels("y");
    if (u.hasValue() && !l.hasValue() && (s = e), l.hasValue() && !u.hasValue() && (e = s), e = Math.min(e, c / 2), s = Math.min(s, d / 2), t) {
      const i = 4 * ((Math.sqrt(2) - 1) / 3);
      t.beginPath(), d > 0 && c > 0 && (t.moveTo(r + e, o), t.lineTo(r + c - e, o), t.bezierCurveTo(r + c - e + i * e, o, r + c, o + s - i * s, r + c, o + s), t.lineTo(r + c, o + d - s), t.bezierCurveTo(r + c, o + d - s + i * s, r + c - e + i * e, o + d, r + c - e, o + d), t.lineTo(r + e, o + d), t.bezierCurveTo(r + e - i * e, o + d, r, o + d - s + i * s, r, o + d - s), t.lineTo(r, o + s), t.bezierCurveTo(r, o + s - i * s, r + e - i * e, o, r + e, o), t.closePath());
    }
    return new ra(r, o, r + c, o + d);
  }
  getMarkers() {
    return null;
  }
  constructor(...t) {
    super(...t), this.type = "rect";
  }
}
class i9 extends wn {
  path(t) {
    const r = this.getAttribute("cx").getPixels("x"), o = this.getAttribute("cy").getPixels("y"), c = this.getAttribute("r").getPixels();
    return t && c > 0 && (t.beginPath(), t.arc(r, o, c, 0, Math.PI * 2, !1), t.closePath()), new ra(r - c, o - c, r + c, o + c);
  }
  getMarkers() {
    return null;
  }
  constructor(...t) {
    super(...t), this.type = "circle";
  }
}
class a9 extends wn {
  path(t) {
    const r = 4 * ((Math.sqrt(2) - 1) / 3), o = this.getAttribute("rx").getPixels("x"), c = this.getAttribute("ry").getPixels("y"), d = this.getAttribute("cx").getPixels("x"), u = this.getAttribute("cy").getPixels("y");
    return t && o > 0 && c > 0 && (t.beginPath(), t.moveTo(d + o, u), t.bezierCurveTo(d + o, u + r * c, d + r * o, u + c, d, u + c), t.bezierCurveTo(d - r * o, u + c, d - o, u + r * c, d - o, u), t.bezierCurveTo(d - o, u - r * c, d - r * o, u - c, d, u - c), t.bezierCurveTo(d + r * o, u - c, d + o, u - r * c, d + o, u), t.closePath()), new ra(d - o, u - c, d + o, u + c);
  }
  getMarkers() {
    return null;
  }
  constructor(...t) {
    super(...t), this.type = "ellipse";
  }
}
class o9 extends wn {
  getPoints() {
    return [
      new Mn(this.getAttribute("x1").getPixels("x"), this.getAttribute("y1").getPixels("y")),
      new Mn(this.getAttribute("x2").getPixels("x"), this.getAttribute("y2").getPixels("y"))
    ];
  }
  path(t) {
    const [{ x: r, y: o }, { x: c, y: d }] = this.getPoints();
    return t && (t.beginPath(), t.moveTo(r, o), t.lineTo(c, d)), new ra(r, o, c, d);
  }
  getMarkers() {
    const [t, r] = this.getPoints(), o = t.angleTo(r);
    return [
      [
        t,
        o
      ],
      [
        r,
        o
      ]
    ];
  }
  constructor(...t) {
    super(...t), this.type = "line";
  }
}
class Ug extends wn {
  path(t) {
    const { points: r } = this, [{ x: o, y: c }] = r, d = new ra(o, c);
    return t && (t.beginPath(), t.moveTo(o, c)), r.forEach((u) => {
      let { x: l, y: e } = u;
      d.addPoint(l, e), t && t.lineTo(l, e);
    }), d;
  }
  getMarkers() {
    const { points: t } = this, r = t.length - 1, o = [];
    return t.forEach((c, d) => {
      d !== r && o.push([
        c,
        c.angleTo(t[d + 1])
      ]);
    }), o.length > 0 && o.push([
      t[t.length - 1],
      o[o.length - 1][1]
    ]), o;
  }
  constructor(t, r, o) {
    super(t, r, o), this.type = "polyline", this.points = [], this.points = Mn.parsePath(this.getAttribute("points").getString());
  }
}
class s9 extends Ug {
  path(t) {
    const r = super.path(t), [{ x: o, y: c }] = this.points;
    return t && (t.lineTo(o, c), t.closePath()), r;
  }
  constructor(...t) {
    super(...t), this.type = "polygon";
  }
}
class l9 extends In {
  createPattern(t, r, o) {
    const c = this.getStyle("width").getPixels("x", !0), d = this.getStyle("height").getPixels("y", !0), u = new T0(this.document, null);
    u.attributes.viewBox = new dr(this.document, "viewBox", this.getAttribute("viewBox").getValue()), u.attributes.width = new dr(this.document, "width", "".concat(c, "px")), u.attributes.height = new dr(this.document, "height", "".concat(d, "px")), u.attributes.transform = new dr(this.document, "transform", this.getAttribute("patternTransform").getValue()), u.children = this.children;
    const l = this.document.createCanvas(c, d), e = l.getContext("2d"), s = this.getAttribute("x"), i = this.getAttribute("y");
    s.hasValue() && i.hasValue() && e.translate(s.getPixels("x", !0), i.getPixels("y", !0)), o.hasValue() ? this.styles["fill-opacity"] = o : Reflect.deleteProperty(this.styles, "fill-opacity");
    for (let h = -1; h <= 1; h++)
      for (let v = -1; v <= 1; v++)
        e.save(), u.attributes.x = new dr(this.document, "x", h * l.width), u.attributes.y = new dr(this.document, "y", v * l.height), u.render(e), e.restore();
    return t.createPattern(l, "repeat");
  }
  constructor(...t) {
    super(...t), this.type = "pattern";
  }
}
class f9 extends In {
  render(t, r, o) {
    if (!r)
      return;
    const { x: c, y: d } = r, u = this.getAttribute("orient").getString("auto"), l = this.getAttribute("markerUnits").getString("strokeWidth");
    t.translate(c, d), u === "auto" && t.rotate(o), l === "strokeWidth" && t.scale(t.lineWidth, t.lineWidth), t.save();
    const e = new T0(this.document);
    e.type = this.type, e.attributes.viewBox = new dr(this.document, "viewBox", this.getAttribute("viewBox").getValue()), e.attributes.refX = new dr(this.document, "refX", this.getAttribute("refX").getValue()), e.attributes.refY = new dr(this.document, "refY", this.getAttribute("refY").getValue()), e.attributes.width = new dr(this.document, "width", this.getAttribute("markerWidth").getValue()), e.attributes.height = new dr(this.document, "height", this.getAttribute("markerHeight").getValue()), e.attributes.overflow = new dr(this.document, "overflow", this.getAttribute("overflow").getValue()), e.attributes.fill = new dr(this.document, "fill", this.getAttribute("fill").getColor("black")), e.attributes.stroke = new dr(this.document, "stroke", this.getAttribute("stroke").getValue("none")), e.children = this.children, e.render(t), t.restore(), l === "strokeWidth" && t.scale(1 / t.lineWidth, 1 / t.lineWidth), u === "auto" && t.rotate(-o), t.translate(-c, -d);
  }
  constructor(...t) {
    super(...t), this.type = "marker";
  }
}
class u9 extends In {
  render() {
  }
  constructor(...t) {
    super(...t), this.type = "defs";
  }
}
class $h extends No {
  getBoundingBox(t) {
    const r = new ra();
    return this.children.forEach((o) => {
      r.addBoundingBox(o.getBoundingBox(t));
    }), r;
  }
  constructor(...t) {
    super(...t), this.type = "g";
  }
}
class zg extends In {
  getGradientUnits() {
    return this.getAttribute("gradientUnits").getString("objectBoundingBox");
  }
  createGradient(t, r, o) {
    let c = this;
    this.getHrefAttribute().hasValue() && (c = this.getHrefAttribute().getDefinition(), this.inheritStopContainer(c));
    const { stops: d } = c, u = this.getGradient(t, r);
    if (!u)
      return this.addParentOpacity(o, d[d.length - 1].color);
    if (d.forEach((l) => {
      u.addColorStop(l.offset, this.addParentOpacity(o, l.color));
    }), this.getAttribute("gradientTransform").hasValue()) {
      const { document: l } = this, { MAX_VIRTUAL_PIXELS: e } = Ra, { viewPort: s } = l.screen, i = s.getRoot(), f = new Lg(l);
      f.attributes.x = new dr(l, "x", -e / 3), f.attributes.y = new dr(l, "y", -e / 3), f.attributes.width = new dr(l, "width", e), f.attributes.height = new dr(l, "height", e);
      const h = new $h(l);
      h.attributes.transform = new dr(l, "transform", this.getAttribute("gradientTransform").getValue()), h.children = [
        f
      ];
      const v = new T0(l);
      v.attributes.x = new dr(l, "x", 0), v.attributes.y = new dr(l, "y", 0), v.attributes.width = new dr(l, "width", i.width), v.attributes.height = new dr(l, "height", i.height), v.children = [
        h
      ];
      const p = l.createCanvas(i.width, i.height), m = p.getContext("2d");
      return m.fillStyle = u, v.render(m), m.createPattern(p, "no-repeat");
    }
    return u;
  }
  inheritStopContainer(t) {
    this.attributesToInherit.forEach((r) => {
      !this.getAttribute(r).hasValue() && t.getAttribute(r).hasValue() && this.getAttribute(r, !0).setValue(t.getAttribute(r).getValue());
    });
  }
  addParentOpacity(t, r) {
    return t.hasValue() ? new dr(this.document, "color", r).addOpacity(t).getColor() : r;
  }
  constructor(t, r, o) {
    super(t, r, o), this.attributesToInherit = [
      "gradientUnits"
    ], this.stops = [];
    const { stops: c, children: d } = this;
    d.forEach((u) => {
      u.type === "stop" && c.push(u);
    });
  }
}
class h9 extends zg {
  getGradient(t, r) {
    const o = this.getGradientUnits() === "objectBoundingBox", c = o ? r.getBoundingBox(t) : null;
    if (o && !c)
      return null;
    !this.getAttribute("x1").hasValue() && !this.getAttribute("y1").hasValue() && !this.getAttribute("x2").hasValue() && !this.getAttribute("y2").hasValue() && (this.getAttribute("x1", !0).setValue(0), this.getAttribute("y1", !0).setValue(0), this.getAttribute("x2", !0).setValue(1), this.getAttribute("y2", !0).setValue(0));
    const d = o ? c.x + c.width * this.getAttribute("x1").getNumber() : this.getAttribute("x1").getPixels("x"), u = o ? c.y + c.height * this.getAttribute("y1").getNumber() : this.getAttribute("y1").getPixels("y"), l = o ? c.x + c.width * this.getAttribute("x2").getNumber() : this.getAttribute("x2").getPixels("x"), e = o ? c.y + c.height * this.getAttribute("y2").getNumber() : this.getAttribute("y2").getPixels("y");
    return d === l && u === e ? null : t.createLinearGradient(d, u, l, e);
  }
  constructor(t, r, o) {
    super(t, r, o), this.type = "linearGradient", this.attributesToInherit.push("x1", "y1", "x2", "y2");
  }
}
class c9 extends zg {
  getGradient(t, r) {
    const o = this.getGradientUnits() === "objectBoundingBox", c = r.getBoundingBox(t);
    if (o && !c)
      return null;
    this.getAttribute("cx").hasValue() || this.getAttribute("cx", !0).setValue("50%"), this.getAttribute("cy").hasValue() || this.getAttribute("cy", !0).setValue("50%"), this.getAttribute("r").hasValue() || this.getAttribute("r", !0).setValue("50%");
    const d = o ? c.x + c.width * this.getAttribute("cx").getNumber() : this.getAttribute("cx").getPixels("x"), u = o ? c.y + c.height * this.getAttribute("cy").getNumber() : this.getAttribute("cy").getPixels("y");
    let l = d, e = u;
    this.getAttribute("fx").hasValue() && (l = o ? c.x + c.width * this.getAttribute("fx").getNumber() : this.getAttribute("fx").getPixels("x")), this.getAttribute("fy").hasValue() && (e = o ? c.y + c.height * this.getAttribute("fy").getNumber() : this.getAttribute("fy").getPixels("y"));
    const s = o ? (c.width + c.height) / 2 * this.getAttribute("r").getNumber() : this.getAttribute("r").getPixels(), i = this.getAttribute("fr").getPixels();
    return t.createRadialGradient(l, e, i, d, u, s);
  }
  constructor(t, r, o) {
    super(t, r, o), this.type = "radialGradient", this.attributesToInherit.push("cx", "cy", "r", "fx", "fy", "fr");
  }
}
class d9 extends In {
  constructor(t, r, o) {
    super(t, r, o), this.type = "stop";
    const c = Math.max(0, Math.min(1, this.getAttribute("offset").getNumber())), d = this.getStyle("stop-opacity");
    let u = this.getStyle("stop-color", !0);
    u.getString() === "" && u.setValue("#000"), d.hasValue() && (u = u.addOpacity(d)), this.offset = c, this.color = u.getColor();
  }
}
class qh extends In {
  getProperty() {
    const t = this.getAttribute("attributeType").getString(), r = this.getAttribute("attributeName").getString();
    return t === "CSS" ? this.parent.getStyle(r, !0) : this.parent.getAttribute(r, !0);
  }
  calcValue() {
    const { initialUnits: t } = this, { progress: r, from: o, to: c } = this.getProgress();
    let d = o.getNumber() + (c.getNumber() - o.getNumber()) * r;
    return t === "%" && (d *= 100), "".concat(d).concat(t);
  }
  update(t) {
    const { parent: r } = this, o = this.getProperty();
    if (this.initialValue || (this.initialValue = o.getString(), this.initialUnits = o.getUnits()), this.duration > this.maxDuration) {
      const d = this.getAttribute("fill").getString("remove");
      if (this.getAttribute("repeatCount").getString() === "indefinite" || this.getAttribute("repeatDur").getString() === "indefinite")
        this.duration = 0;
      else if (d === "freeze" && !this.frozen)
        this.frozen = !0, r && o && (r.animationFrozen = !0, r.animationFrozenValue = o.getString());
      else if (d === "remove" && !this.removed)
        return this.removed = !0, r && o && o.setValue(r.animationFrozen ? r.animationFrozenValue : this.initialValue), !0;
      return !1;
    }
    this.duration += t;
    let c = !1;
    if (this.begin < this.duration) {
      let d = this.calcValue();
      const u = this.getAttribute("type");
      if (u.hasValue()) {
        const l = u.getString();
        d = "".concat(l, "(").concat(d, ")");
      }
      o.setValue(d), c = !0;
    }
    return c;
  }
  getProgress() {
    const { document: t, values: r } = this;
    let o = (this.duration - this.begin) / (this.maxDuration - this.begin), c, d;
    if (r.hasValue()) {
      const u = o * (r.getValue().length - 1), l = Math.floor(u), e = Math.ceil(u);
      let s;
      s = r.getValue()[l], c = new dr(t, "from", s ? parseFloat(s) : 0), s = r.getValue()[e], d = new dr(t, "to", s ? parseFloat(s) : 0), o = (u - l) / (e - l);
    } else
      c = this.from, d = this.to;
    return {
      progress: o,
      from: c,
      to: d
    };
  }
  constructor(t, r, o) {
    super(t, r, o), this.type = "animate", this.duration = 0, this.initialUnits = "", this.removed = !1, this.frozen = !1, t.screen.animations.push(this), this.begin = this.getAttribute("begin").getMilliseconds(), this.maxDuration = this.begin + this.getAttribute("dur").getMilliseconds(), this.from = this.getAttribute("from"), this.to = this.getAttribute("to"), this.values = new dr(t, "values", null);
    const c = this.getAttribute("values");
    c.hasValue() && this.values.setValue(c.getString().split(";"));
  }
}
class v9 extends qh {
  calcValue() {
    const { progress: t, from: r, to: o } = this.getProgress(), c = new gh(r.getColor()), d = new gh(o.getColor());
    if (c.ok && d.ok) {
      const u = c.r + (d.r - c.r) * t, l = c.g + (d.g - c.g) * t, e = c.b + (d.b - c.b) * t;
      return "rgb(".concat(Math.floor(u), ", ").concat(Math.floor(l), ", ").concat(Math.floor(e), ")");
    }
    return this.getAttribute("from").getColor();
  }
  constructor(...t) {
    super(...t), this.type = "animateColor";
  }
}
class g9 extends qh {
  calcValue() {
    const { progress: t, from: r, to: o } = this.getProgress(), c = Li(r.getString()), d = Li(o.getString());
    return c.map((l, e) => {
      const s = d[e];
      return l + (s - l) * t;
    }).join(" ");
  }
  constructor(...t) {
    super(...t), this.type = "animateTransform";
  }
}
class Gg extends In {
  constructor(t, r, o) {
    super(t, r, o), this.type = "font-face", this.ascent = this.getAttribute("ascent").getNumber(), this.descent = this.getAttribute("descent").getNumber(), this.unitsPerEm = this.getAttribute("units-per-em").getNumber();
  }
}
class tc extends wn {
  constructor(t, r, o) {
    super(t, r, o), this.type = "glyph", this.horizAdvX = this.getAttribute("horiz-adv-x").getNumber(), this.unicode = this.getAttribute("unicode").getString(), this.arabicForm = this.getAttribute("arabic-form").getString();
  }
}
class Vg extends tc {
  constructor(...t) {
    super(...t), this.type = "missing-glyph", this.horizAdvX = 0;
  }
}
class p9 extends In {
  render() {
  }
  constructor(t, r, o) {
    super(t, r, o), this.type = "font", this.isArabic = !1, this.glyphs = {}, this.arabicGlyphs = {}, this.isRTL = !1, this.horizAdvX = this.getAttribute("horiz-adv-x").getNumber();
    const { definitions: c } = t, { children: d } = this;
    for (const u of d)
      if (u instanceof Gg) {
        this.fontFace = u;
        const l = u.getStyle("font-family");
        l.hasValue() && (c[l.getString()] = this);
      } else if (u instanceof Vg)
        this.missingGlyph = u;
      else if (u instanceof tc)
        if (u.arabicForm) {
          this.isRTL = !0, this.isArabic = !0;
          const l = this.arabicGlyphs[u.unicode];
          typeof l > "u" ? this.arabicGlyphs[u.unicode] = {
            [u.arabicForm]: u
          } : l[u.arabicForm] = u;
        } else
          this.glyphs[u.unicode] = u;
  }
}
class y9 extends to {
  getText() {
    const t = this.getHrefAttribute().getDefinition();
    if (t) {
      const r = t.children[0];
      if (r)
        return r.getText();
    }
    return "";
  }
  constructor(...t) {
    super(...t), this.type = "tref";
  }
}
class m9 extends to {
  getText() {
    return this.text;
  }
  renderChildren(t) {
    if (this.hasText) {
      super.renderChildren(t);
      const { document: r, x: o, y: c } = this, { mouse: d } = r.screen, u = new dr(r, "fontSize", Ti.parse(r.ctx.font).fontSize);
      d.isWorking() && d.checkBoundingBox(this, new ra(o, c - u.getPixels("y"), o + this.measureText(t), c));
    } else if (this.children.length > 0) {
      const r = new $h(this.document);
      r.children = this.children, r.parent = this, r.render(t);
    }
  }
  onClick() {
    const { window: t } = this.document;
    t && t.open(this.getHrefAttribute().getString());
  }
  onMouseMove() {
    const t = this.document.ctx;
    t.canvas.style.cursor = "pointer";
  }
  constructor(t, r, o) {
    super(t, r, o), this.type = "a";
    const { childNodes: c } = r, d = c[0], u = c.length > 0 && Array.from(c).every(
      (l) => l.nodeType === 3
    );
    this.hasText = u, this.text = u ? this.getTextFromNode(d) : "";
  }
}
class x9 extends to {
  getText() {
    return this.text;
  }
  path(t) {
    const { dataArray: r } = this;
    t && t.beginPath(), r.forEach((o) => {
      let { type: c, points: d } = o;
      switch (c) {
        case Ir.LINE_TO:
          t && t.lineTo(d[0], d[1]);
          break;
        case Ir.MOVE_TO:
          t && t.moveTo(d[0], d[1]);
          break;
        case Ir.CURVE_TO:
          t && t.bezierCurveTo(d[0], d[1], d[2], d[3], d[4], d[5]);
          break;
        case Ir.QUAD_TO:
          t && t.quadraticCurveTo(d[0], d[1], d[2], d[3]);
          break;
        case Ir.ARC: {
          const [u, l, e, s, i, f, h, v] = d, p = e > s ? e : s, m = e > s ? 1 : e / s, x = e > s ? s / e : 1;
          t && (t.translate(u, l), t.rotate(h), t.scale(m, x), t.arc(0, 0, p, i, i + f, !!(1 - v)), t.scale(1 / m, 1 / x), t.rotate(-h), t.translate(-u, -l));
          break;
        }
        case Ir.CLOSE_PATH:
          t && t.closePath();
          break;
      }
    });
  }
  renderChildren(t) {
    this.setTextData(t), t.save();
    const r = this.parent.getStyle("text-decoration").getString(), o = this.getFontSize(), { glyphInfo: c } = this, d = t.fillStyle;
    r === "underline" && t.beginPath(), c.forEach((u, l) => {
      const { p0: e, p1: s, rotation: i, text: f } = u;
      t.save(), t.translate(e.x, e.y), t.rotate(i), t.fillStyle && t.fillText(f, 0, 0), t.strokeStyle && t.strokeText(f, 0, 0), t.restore(), r === "underline" && (l === 0 && t.moveTo(e.x, e.y + o / 8), t.lineTo(s.x, s.y + o / 5));
    }), r === "underline" && (t.lineWidth = o / 20, t.strokeStyle = d, t.stroke(), t.closePath()), t.restore();
  }
  getLetterSpacingAt() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return this.letterSpacingCache[t] || 0;
  }
  findSegmentToFitChar(t, r, o, c, d, u, l, e, s) {
    let i = u, f = this.measureText(t, e);
    e === " " && r === "justify" && o < c && (f += (c - o) / d), s > -1 && (i += this.getLetterSpacingAt(s));
    const h = this.textHeight / 20, v = this.getEquidistantPointOnPath(i, h, 0), p = this.getEquidistantPointOnPath(i + f, h, 0), m = {
      p0: v,
      p1: p
    }, x = v && p ? Math.atan2(p.y - v.y, p.x - v.x) : 0;
    if (l) {
      const g = Math.cos(Math.PI / 2 + x) * l, S = Math.cos(-x) * l;
      m.p0 = {
        ...v,
        x: v.x + g,
        y: v.y + S
      }, m.p1 = {
        ...p,
        x: p.x + g,
        y: p.y + S
      };
    }
    return i += f, {
      offset: i,
      segment: m,
      rotation: x
    };
  }
  measureText(t, r) {
    const { measuresCache: o } = this, c = r || this.getText();
    if (o.has(c))
      return o.get(c);
    const d = this.measureTargetText(t, c);
    return o.set(c, d), d;
  }
  // This method supposes what all custom fonts already loaded.
  // If some font will be loaded after this method call, <textPath> will not be rendered correctly.
  // You need to call this method manually to update glyphs cache.
  setTextData(t) {
    if (this.glyphInfo)
      return;
    const r = this.getText(), o = r.split(""), c = r.split(" ").length - 1, d = this.parent.getAttribute("dx").split().map(
      (y) => y.getPixels("x")
    ), u = this.parent.getAttribute("dy").getPixels("y"), l = this.parent.getStyle("text-anchor").getString("start"), e = this.getStyle("letter-spacing"), s = this.parent.getStyle("letter-spacing");
    let i = 0;
    !e.hasValue() || e.getValue() === "inherit" ? i = s.getPixels() : e.hasValue() && e.getValue() !== "initial" && e.getValue() !== "unset" && (i = e.getPixels());
    const f = [], h = r.length;
    this.letterSpacingCache = f;
    for (let y = 0; y < h; y++)
      f.push(typeof d[y] < "u" ? d[y] : i);
    const v = f.reduce(
      (y, b, n) => n === 0 ? 0 : y + b || 0,
      0
    ), p = this.measureText(t), m = Math.max(p + v, 0);
    this.textWidth = p, this.textHeight = this.getFontSize(), this.glyphInfo = [];
    const x = this.getPathLength(), g = this.getStyle("startOffset").getNumber(0) * x;
    let S = 0;
    (l === "middle" || l === "center") && (S = -m / 2), (l === "end" || l === "right") && (S = -m), S += g, o.forEach((y, b) => {
      const { offset: n, segment: w, rotation: E } = this.findSegmentToFitChar(t, l, m, x, c, S, u, y, b);
      S = n, !(!w.p0 || !w.p1) && this.glyphInfo.push({
        // transposeX: midpoint.x,
        // transposeY: midpoint.y,
        text: o[b],
        p0: w.p0,
        p1: w.p1,
        rotation: E
      });
    });
  }
  parsePathData(t) {
    if (this.pathLength = -1, !t)
      return [];
    const r = [], { pathParser: o } = t;
    for (o.reset(); !o.isEnd(); ) {
      const { current: c } = o, d = c ? c.x : 0, u = c ? c.y : 0, l = o.next();
      let e = l.type, s = [];
      switch (l.type) {
        case Ir.MOVE_TO:
          this.pathM(o, s);
          break;
        case Ir.LINE_TO:
          e = this.pathL(o, s);
          break;
        case Ir.HORIZ_LINE_TO:
          e = this.pathH(o, s);
          break;
        case Ir.VERT_LINE_TO:
          e = this.pathV(o, s);
          break;
        case Ir.CURVE_TO:
          this.pathC(o, s);
          break;
        case Ir.SMOOTH_CURVE_TO:
          e = this.pathS(o, s);
          break;
        case Ir.QUAD_TO:
          this.pathQ(o, s);
          break;
        case Ir.SMOOTH_QUAD_TO:
          e = this.pathT(o, s);
          break;
        case Ir.ARC:
          s = this.pathA(o);
          break;
        case Ir.CLOSE_PATH:
          wn.pathZ(o);
          break;
      }
      l.type !== Ir.CLOSE_PATH ? r.push({
        type: e,
        points: s,
        start: {
          x: d,
          y: u
        },
        pathLength: this.calcLength(d, u, e, s)
      }) : r.push({
        type: Ir.CLOSE_PATH,
        points: [],
        pathLength: 0
      });
    }
    return r;
  }
  pathM(t, r) {
    const { x: o, y: c } = wn.pathM(t).point;
    r.push(o, c);
  }
  pathL(t, r) {
    const { x: o, y: c } = wn.pathL(t).point;
    return r.push(o, c), Ir.LINE_TO;
  }
  pathH(t, r) {
    const { x: o, y: c } = wn.pathH(t).point;
    return r.push(o, c), Ir.LINE_TO;
  }
  pathV(t, r) {
    const { x: o, y: c } = wn.pathV(t).point;
    return r.push(o, c), Ir.LINE_TO;
  }
  pathC(t, r) {
    const { point: o, controlPoint: c, currentPoint: d } = wn.pathC(t);
    r.push(o.x, o.y, c.x, c.y, d.x, d.y);
  }
  pathS(t, r) {
    const { point: o, controlPoint: c, currentPoint: d } = wn.pathS(t);
    return r.push(o.x, o.y, c.x, c.y, d.x, d.y), Ir.CURVE_TO;
  }
  pathQ(t, r) {
    const { controlPoint: o, currentPoint: c } = wn.pathQ(t);
    r.push(o.x, o.y, c.x, c.y);
  }
  pathT(t, r) {
    const { controlPoint: o, currentPoint: c } = wn.pathT(t);
    return r.push(o.x, o.y, c.x, c.y), Ir.QUAD_TO;
  }
  pathA(t) {
    let { rX: r, rY: o, sweepFlag: c, xAxisRotation: d, centp: u, a1: l, ad: e } = wn.pathA(t);
    return c === 0 && e > 0 && (e -= 2 * Math.PI), c === 1 && e < 0 && (e += 2 * Math.PI), [
      u.x,
      u.y,
      r,
      o,
      l,
      e,
      d,
      c
    ];
  }
  calcLength(t, r, o, c) {
    let d = 0, u = null, l = null, e = 0;
    switch (o) {
      case Ir.LINE_TO:
        return this.getLineLength(t, r, c[0], c[1]);
      case Ir.CURVE_TO:
        for (d = 0, u = this.getPointOnCubicBezier(0, t, r, c[0], c[1], c[2], c[3], c[4], c[5]), e = 0.01; e <= 1; e += 0.01)
          l = this.getPointOnCubicBezier(e, t, r, c[0], c[1], c[2], c[3], c[4], c[5]), d += this.getLineLength(u.x, u.y, l.x, l.y), u = l;
        return d;
      case Ir.QUAD_TO:
        for (d = 0, u = this.getPointOnQuadraticBezier(0, t, r, c[0], c[1], c[2], c[3]), e = 0.01; e <= 1; e += 0.01)
          l = this.getPointOnQuadraticBezier(e, t, r, c[0], c[1], c[2], c[3]), d += this.getLineLength(u.x, u.y, l.x, l.y), u = l;
        return d;
      case Ir.ARC: {
        d = 0;
        const s = c[4], i = c[5], f = c[4] + i;
        let h = Math.PI / 180;
        if (Math.abs(s - f) < h && (h = Math.abs(s - f)), u = this.getPointOnEllipticalArc(c[0], c[1], c[2], c[3], s, 0), i < 0)
          for (e = s - h; e > f; e -= h)
            l = this.getPointOnEllipticalArc(c[0], c[1], c[2], c[3], e, 0), d += this.getLineLength(u.x, u.y, l.x, l.y), u = l;
        else
          for (e = s + h; e < f; e += h)
            l = this.getPointOnEllipticalArc(c[0], c[1], c[2], c[3], e, 0), d += this.getLineLength(u.x, u.y, l.x, l.y), u = l;
        return l = this.getPointOnEllipticalArc(c[0], c[1], c[2], c[3], f, 0), d += this.getLineLength(u.x, u.y, l.x, l.y), d;
      }
    }
    return 0;
  }
  getPointOnLine(t, r, o, c, d) {
    let u = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : r, l = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : o;
    const e = (d - o) / (c - r + os);
    let s = Math.sqrt(t * t / (1 + e * e));
    c < r && (s *= -1);
    let i = e * s, f = null;
    if (c === r)
      f = {
        x: u,
        y: l + i
      };
    else if ((l - o) / (u - r + os) === e)
      f = {
        x: u + s,
        y: l + i
      };
    else {
      let h = 0, v = 0;
      const p = this.getLineLength(r, o, c, d);
      if (p < os)
        return null;
      let m = (u - r) * (c - r) + (l - o) * (d - o);
      m /= p * p, h = r + m * (c - r), v = o + m * (d - o);
      const x = this.getLineLength(u, l, h, v), g = Math.sqrt(t * t - x * x);
      s = Math.sqrt(g * g / (1 + e * e)), c < r && (s *= -1), i = e * s, f = {
        x: h + s,
        y: v + i
      };
    }
    return f;
  }
  getPointOnPath(t) {
    const r = this.getPathLength();
    let o = 0, c = null;
    if (t < -5e-5 || t - 5e-5 > r)
      return null;
    const { dataArray: d } = this;
    for (const u of d) {
      if (u && (u.pathLength < 5e-5 || o + u.pathLength + 5e-5 < t)) {
        o += u.pathLength;
        continue;
      }
      const l = t - o;
      let e = 0;
      switch (u.type) {
        case Ir.LINE_TO:
          c = this.getPointOnLine(l, u.start.x, u.start.y, u.points[0], u.points[1], u.start.x, u.start.y);
          break;
        case Ir.ARC: {
          const s = u.points[4], i = u.points[5], f = u.points[4] + i;
          if (e = s + l / u.pathLength * i, i < 0 && e < f || i >= 0 && e > f)
            break;
          c = this.getPointOnEllipticalArc(u.points[0], u.points[1], u.points[2], u.points[3], e, u.points[6]);
          break;
        }
        case Ir.CURVE_TO:
          e = l / u.pathLength, e > 1 && (e = 1), c = this.getPointOnCubicBezier(e, u.start.x, u.start.y, u.points[0], u.points[1], u.points[2], u.points[3], u.points[4], u.points[5]);
          break;
        case Ir.QUAD_TO:
          e = l / u.pathLength, e > 1 && (e = 1), c = this.getPointOnQuadraticBezier(e, u.start.x, u.start.y, u.points[0], u.points[1], u.points[2], u.points[3]);
          break;
      }
      if (c)
        return c;
      break;
    }
    return null;
  }
  getLineLength(t, r, o, c) {
    return Math.sqrt((o - t) * (o - t) + (c - r) * (c - r));
  }
  getPathLength() {
    return this.pathLength === -1 && (this.pathLength = this.dataArray.reduce(
      (t, r) => r.pathLength > 0 ? t + r.pathLength : t,
      0
    )), this.pathLength;
  }
  getPointOnCubicBezier(t, r, o, c, d, u, l, e, s) {
    const i = e * C1(t) + u * T1(t) + c * P1(t) + r * O1(t), f = s * C1(t) + l * T1(t) + d * P1(t) + o * O1(t);
    return {
      x: i,
      y: f
    };
  }
  getPointOnQuadraticBezier(t, r, o, c, d, u, l) {
    const e = u * F1(t) + c * I1(t) + r * R1(t), s = l * F1(t) + d * I1(t) + o * R1(t);
    return {
      x: e,
      y: s
    };
  }
  getPointOnEllipticalArc(t, r, o, c, d, u) {
    const l = Math.cos(u), e = Math.sin(u), s = {
      x: o * Math.cos(d),
      y: c * Math.sin(d)
    };
    return {
      x: t + (s.x * l - s.y * e),
      y: r + (s.x * e + s.y * l)
    };
  }
  // TODO need some optimisations. possibly build cache only for curved segments?
  buildEquidistantCache(t, r) {
    const o = this.getPathLength(), c = r || 0.25, d = t || o / 100;
    if (!this.equidistantCache || this.equidistantCache.step !== d || this.equidistantCache.precision !== c) {
      this.equidistantCache = {
        step: d,
        precision: c,
        points: []
      };
      let u = 0;
      for (let l = 0; l <= o; l += c) {
        const e = this.getPointOnPath(l), s = this.getPointOnPath(l + c);
        !e || !s || (u += this.getLineLength(e.x, e.y, s.x, s.y), u >= d && (this.equidistantCache.points.push({
          x: e.x,
          y: e.y,
          distance: l
        }), u -= d));
      }
    }
  }
  getEquidistantPointOnPath(t, r, o) {
    if (this.buildEquidistantCache(r, o), t < 0 || t - this.getPathLength() > 5e-5)
      return null;
    const c = Math.round(t / this.getPathLength() * (this.equidistantCache.points.length - 1));
    return this.equidistantCache.points[c] || null;
  }
  constructor(t, r, o) {
    super(t, r, o), this.type = "textPath", this.textWidth = 0, this.textHeight = 0, this.pathLength = -1, this.glyphInfo = null, this.letterSpacingCache = [], this.measuresCache = /* @__PURE__ */ new Map([
      [
        "",
        0
      ]
    ]);
    const c = this.getHrefAttribute().getDefinition();
    this.text = this.getTextFromNode(), this.dataArray = this.parsePathData(c);
  }
}
const b9 = /^\s*data:(([^/,;]+\/[^/,;]+)(?:;([^,;=]+=[^,;=]+))?)?(?:;(base64))?,(.*)$/i;
class w9 extends No {
  async loadImage(t) {
    try {
      const r = await this.document.createImage(t);
      this.image = r;
    } catch (r) {
      console.error('Error while loading image "'.concat(t, '":'), r);
    }
    this.loaded = !0;
  }
  async loadSvg(t) {
    const r = b9.exec(t);
    if (r) {
      const o = r[5];
      o && (r[4] === "base64" ? this.image = atob(o) : this.image = decodeURIComponent(o));
    } else
      try {
        const c = await (await this.document.fetch(t)).text();
        this.image = c;
      } catch (o) {
        console.error('Error while loading image "'.concat(t, '":'), o);
      }
    this.loaded = !0;
  }
  renderChildren(t) {
    const { document: r, image: o, loaded: c } = this, d = this.getAttribute("x").getPixels("x"), u = this.getAttribute("y").getPixels("y"), l = this.getStyle("width").getPixels("x"), e = this.getStyle("height").getPixels("y");
    if (!(!c || !o || !l || !e)) {
      if (t.save(), t.translate(d, u), typeof o == "string") {
        const s = r.canvg.forkString(t, o, {
          ignoreMouse: !0,
          ignoreAnimation: !0,
          ignoreDimensions: !0,
          ignoreClear: !0,
          offsetX: 0,
          offsetY: 0,
          scaleWidth: l,
          scaleHeight: e
        }), { documentElement: i } = s.document;
        i && (i.parent = this), s.render();
      } else
        r.setViewBox({
          ctx: t,
          aspectRatio: this.getAttribute("preserveAspectRatio").getString(),
          width: l,
          desiredWidth: o.width,
          height: e,
          desiredHeight: o.height
        }), this.loaded && (!("complete" in o) || o.complete) && t.drawImage(o, 0, 0);
      t.restore();
    }
  }
  getBoundingBox() {
    const t = this.getAttribute("x").getPixels("x"), r = this.getAttribute("y").getPixels("y"), o = this.getStyle("width").getPixels("x"), c = this.getStyle("height").getPixels("y");
    return new ra(t, r, t + o, r + c);
  }
  constructor(t, r, o) {
    super(t, r, o), this.type = "image", this.loaded = !1;
    const c = this.getHrefAttribute().getString();
    if (!c)
      return;
    const d = c.endsWith(".svg") || /^\s*data:image\/svg\+xml/i.test(c);
    t.images.push(this), d ? this.loadSvg(c) : this.loadImage(c);
  }
}
class S9 extends No {
  render(t) {
  }
  constructor(...t) {
    super(...t), this.type = "symbol";
  }
}
class E9 {
  async load(t, r) {
    try {
      const { document: o } = this, d = (await o.canvg.parser.load(r)).getElementsByTagName("font");
      Array.from(d).forEach((u) => {
        const l = o.createElement(u);
        o.definitions[t] = l;
      });
    } catch (o) {
      console.error('Error while loading font "'.concat(r, '":'), o);
    }
    this.loaded = !0;
  }
  constructor(t) {
    this.document = t, this.loaded = !1, t.fonts.push(this);
  }
}
class Hg extends In {
  constructor(t, r, o) {
    super(t, r, o), this.type = "style", Es(
      Array.from(r.childNodes).map(
        (u) => u.textContent
      ).join("").replace(/(\/\*([^*]|[\r\n]|(\*+([^*/]|[\r\n])))*\*+\/)|(^[\s]*\/\/.*)/gm, "").replace(/@import.*;/g, "")
      // remove imports
    ).split("}").forEach((u) => {
      const l = u.trim();
      if (!l)
        return;
      const e = l.split("{"), s = e[0].split(","), i = e[1].split(";");
      s.forEach((f) => {
        const h = f.trim();
        if (!h)
          return;
        const v = t.styles[h] || {};
        if (i.forEach((p) => {
          const m = p.indexOf(":"), x = p.substr(0, m).trim(), g = p.substr(m + 1, p.length - m).trim();
          x && g && (v[x] = new dr(t, x, g));
        }), t.styles[h] = v, t.stylesSpecificity[h] = Vb(h), h === "@font-face") {
          const p = v["font-family"].getString().replace(/"|'/g, "");
          v.src.getString().split(",").forEach((x) => {
            if (x.indexOf('format("svg")') > 0) {
              const g = Dg(x);
              g && new E9(t).load(p, g);
            }
          });
        }
      });
    });
  }
}
Hg.parseExternalUrl = Dg;
class A9 extends No {
  setContext(t) {
    super.setContext(t);
    const r = this.getAttribute("x"), o = this.getAttribute("y");
    r.hasValue() && t.translate(r.getPixels("x"), 0), o.hasValue() && t.translate(0, o.getPixels("y"));
  }
  path(t) {
    const { element: r } = this;
    r && r.path(t);
  }
  renderChildren(t) {
    const { document: r, element: o } = this;
    if (o) {
      let c = o;
      if (o.type === "symbol" && (c = new T0(r), c.attributes.viewBox = new dr(r, "viewBox", o.getAttribute("viewBox").getString()), c.attributes.preserveAspectRatio = new dr(r, "preserveAspectRatio", o.getAttribute("preserveAspectRatio").getString()), c.attributes.overflow = new dr(r, "overflow", o.getAttribute("overflow").getString()), c.children = o.children, o.styles.opacity = new dr(r, "opacity", this.calculateOpacity())), c.type === "svg") {
        const u = this.getStyle("width", !1, !0), l = this.getStyle("height", !1, !0);
        u.hasValue() && (c.attributes.width = new dr(r, "width", u.getString())), l.hasValue() && (c.attributes.height = new dr(r, "height", l.getString()));
      }
      const d = c.parent;
      c.parent = this, c.render(t), c.parent = d;
    }
  }
  getBoundingBox(t) {
    const { element: r } = this;
    return r ? r.getBoundingBox(t) : null;
  }
  elementTransform() {
    const { document: t, element: r } = this;
    return r ? Fo.fromElement(t, r) : null;
  }
  get element() {
    return this.cachedElement || (this.cachedElement = this.getHrefAttribute().getDefinition()), this.cachedElement;
  }
  constructor(...t) {
    super(...t), this.type = "use";
  }
}
function pl(a, t, r, o, c, d) {
  return a[r * o * 4 + t * 4 + d];
}
function yl(a, t, r, o, c, d, u) {
  a[r * o * 4 + t * 4 + d] = u;
}
function Qn(a, t, r) {
  return a[t] * r;
}
function Aa(a, t, r, o) {
  return t + Math.cos(a) * r + Math.sin(a) * o;
}
class Wg extends In {
  apply(t, r, o, c, d) {
    const { includeOpacity: u, matrix: l } = this, e = t.getImageData(0, 0, c, d);
    for (let s = 0; s < d; s++)
      for (let i = 0; i < c; i++) {
        const f = pl(e.data, i, s, c, d, 0), h = pl(e.data, i, s, c, d, 1), v = pl(e.data, i, s, c, d, 2), p = pl(e.data, i, s, c, d, 3);
        let m = Qn(l, 0, f) + Qn(l, 1, h) + Qn(l, 2, v) + Qn(l, 3, p) + Qn(l, 4, 1), x = Qn(l, 5, f) + Qn(l, 6, h) + Qn(l, 7, v) + Qn(l, 8, p) + Qn(l, 9, 1), g = Qn(l, 10, f) + Qn(l, 11, h) + Qn(l, 12, v) + Qn(l, 13, p) + Qn(l, 14, 1), S = Qn(l, 15, f) + Qn(l, 16, h) + Qn(l, 17, v) + Qn(l, 18, p) + Qn(l, 19, 1);
        u && (m = 0, x = 0, g = 0, S *= p / 255), yl(e.data, i, s, c, d, 0, m), yl(e.data, i, s, c, d, 1, x), yl(e.data, i, s, c, d, 2, g), yl(e.data, i, s, c, d, 3, S);
      }
    t.clearRect(0, 0, c, d), t.putImageData(e, 0, 0);
  }
  constructor(t, r, o) {
    super(t, r, o), this.type = "feColorMatrix";
    let c = Li(this.getAttribute("values").getString());
    switch (this.getAttribute("type").getString("matrix")) {
      case "saturate": {
        const d = c[0];
        c = [
          0.213 + 0.787 * d,
          0.715 - 0.715 * d,
          0.072 - 0.072 * d,
          0,
          0,
          0.213 - 0.213 * d,
          0.715 + 0.285 * d,
          0.072 - 0.072 * d,
          0,
          0,
          0.213 - 0.213 * d,
          0.715 - 0.715 * d,
          0.072 + 0.928 * d,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1
        ];
        break;
      }
      case "hueRotate": {
        const d = c[0] * Math.PI / 180;
        c = [
          Aa(d, 0.213, 0.787, -0.213),
          Aa(d, 0.715, -0.715, -0.715),
          Aa(d, 0.072, -0.072, 0.928),
          0,
          0,
          Aa(d, 0.213, -0.213, 0.143),
          Aa(d, 0.715, 0.285, 0.14),
          Aa(d, 0.072, -0.072, -0.283),
          0,
          0,
          Aa(d, 0.213, -0.213, -0.787),
          Aa(d, 0.715, -0.715, 0.715),
          Aa(d, 0.072, 0.928, 0.072),
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1
        ];
        break;
      }
      case "luminanceToAlpha":
        c = [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.2125,
          0.7154,
          0.0721,
          0,
          0,
          0,
          0,
          0,
          0,
          1
        ];
        break;
    }
    this.matrix = c, this.includeOpacity = this.getAttribute("includeOpacity").hasValue();
  }
}
class tf extends In {
  apply(t, r) {
    const { document: o } = this;
    let c = this.getAttribute("x").getPixels("x"), d = this.getAttribute("y").getPixels("y"), u = this.getStyle("width").getPixels("x"), l = this.getStyle("height").getPixels("y");
    if (!u && !l) {
      const v = new ra();
      this.children.forEach((p) => {
        v.addBoundingBox(p.getBoundingBox(t));
      }), c = Math.floor(v.x1), d = Math.floor(v.y1), u = Math.floor(v.width), l = Math.floor(v.height);
    }
    const e = this.removeStyles(r, tf.ignoreStyles), s = o.createCanvas(c + u, d + l), i = s.getContext("2d");
    o.screen.setDefaults(i), this.renderChildren(i), new Wg(o, {
      nodeType: 1,
      childNodes: [],
      attributes: [
        {
          nodeName: "type",
          value: "luminanceToAlpha"
        },
        {
          nodeName: "includeOpacity",
          value: "true"
        }
      ]
    }).apply(i, 0, 0, c + u, d + l);
    const f = o.createCanvas(c + u, d + l), h = f.getContext("2d");
    o.screen.setDefaults(h), r.render(h), h.globalCompositeOperation = "destination-in", h.fillStyle = i.createPattern(s, "no-repeat"), h.fillRect(0, 0, c + u, d + l), t.fillStyle = h.createPattern(f, "no-repeat"), t.fillRect(0, 0, c + u, d + l), this.restoreStyles(r, e);
  }
  render(t) {
  }
  constructor(...t) {
    super(...t), this.type = "mask";
  }
}
tf.ignoreStyles = [
  "mask",
  "transform",
  "clip-path"
];
const M1 = () => {
};
class C9 extends In {
  apply(t) {
    const { document: r } = this, o = Reflect.getPrototypeOf(t), { beginPath: c, closePath: d } = t;
    o && (o.beginPath = M1, o.closePath = M1), Reflect.apply(c, t, []), this.children.forEach((u) => {
      if (!("path" in u))
        return;
      let l = "elementTransform" in u ? u.elementTransform() : null;
      l || (l = Fo.fromElement(r, u)), l && l.apply(t), u.path(t), o && (o.closePath = d), l && l.unapply(t);
    }), Reflect.apply(d, t, []), t.clip(), o && (o.beginPath = c, o.closePath = d);
  }
  render(t) {
  }
  constructor(...t) {
    super(...t), this.type = "clipPath";
  }
}
class ef extends In {
  apply(t, r) {
    const { document: o, children: c } = this, d = "getBoundingBox" in r ? r.getBoundingBox(t) : null;
    if (!d)
      return;
    let u = 0, l = 0;
    c.forEach((g) => {
      const S = g.extraFilterDistance || 0;
      u = Math.max(u, S), l = Math.max(l, S);
    });
    const e = Math.floor(d.width), s = Math.floor(d.height), i = e + 2 * u, f = s + 2 * l;
    if (i < 1 || f < 1)
      return;
    const h = Math.floor(d.x), v = Math.floor(d.y), p = this.removeStyles(r, ef.ignoreStyles), m = o.createCanvas(i, f), x = m.getContext("2d");
    o.screen.setDefaults(x), x.translate(-h + u, -v + l), r.render(x), c.forEach((g) => {
      typeof g.apply == "function" && g.apply(x, 0, 0, i, f);
    }), t.drawImage(m, 0, 0, i, f, h - u, v - l, i, f), this.restoreStyles(r, p);
  }
  render(t) {
  }
  constructor(...t) {
    super(...t), this.type = "filter";
  }
}
ef.ignoreStyles = [
  "filter",
  "transform",
  "clip-path"
];
class T9 extends In {
  apply(t, r, o, c, d) {
  }
  constructor(t, r, o) {
    super(t, r, o), this.type = "feDropShadow", this.addStylesFromStyleDefinition();
  }
}
class P9 extends In {
  apply(t, r, o, c, d) {
  }
  constructor(...t) {
    super(...t), this.type = "feMorphology";
  }
}
class O9 extends In {
  apply(t, r, o, c, d) {
  }
  constructor(...t) {
    super(...t), this.type = "feComposite";
  }
}
class F9 extends In {
  apply(t, r, o, c, d) {
    const { document: u, blurRadius: l } = this, e = u.window ? u.window.document.body : null, s = t.canvas;
    s.id = u.getUniqueId(), e && (s.style.display = "none", e.appendChild(s)), Tb(s, r, o, c, d, l), e && e.removeChild(s);
  }
  constructor(t, r, o) {
    super(t, r, o), this.type = "feGaussianBlur", this.blurRadius = Math.floor(this.getAttribute("stdDeviation").getNumber()), this.extraFilterDistance = this.blurRadius;
  }
}
class I9 extends In {
  constructor(...t) {
    super(...t), this.type = "title";
  }
}
class R9 extends In {
  constructor(...t) {
    super(...t), this.type = "desc";
  }
}
const D9 = {
  svg: T0,
  rect: Lg,
  circle: i9,
  ellipse: a9,
  line: o9,
  polyline: Ug,
  polygon: s9,
  path: wn,
  pattern: l9,
  marker: f9,
  defs: u9,
  linearGradient: h9,
  radialGradient: c9,
  stop: d9,
  animate: qh,
  animateColor: v9,
  animateTransform: g9,
  font: p9,
  "font-face": Gg,
  "missing-glyph": Vg,
  glyph: tc,
  text: to,
  tspan: ql,
  tref: y9,
  a: m9,
  textPath: x9,
  image: w9,
  g: $h,
  symbol: S9,
  style: Hg,
  use: A9,
  mask: tf,
  clipPath: C9,
  filter: ef,
  feDropShadow: T9,
  feMorphology: P9,
  feComposite: O9,
  feColorMatrix: Wg,
  feGaussianBlur: F9,
  title: I9,
  desc: R9
};
function M9(a, t) {
  const r = document.createElement("canvas");
  return r.width = a, r.height = t, r;
}
async function B9(a) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  const r = document.createElement("img");
  return t && (r.crossOrigin = "Anonymous"), new Promise((o, c) => {
    r.onload = () => {
      o(r);
    }, r.onerror = (d, u, l, e, s) => {
      c(s);
    }, r.src = a;
  });
}
const zu = 12;
class qa {
  bindCreateImage(t, r) {
    return typeof r == "boolean" ? (o, c) => t(o, typeof c == "boolean" ? c : r) : t;
  }
  get window() {
    return this.screen.window;
  }
  get fetch() {
    return this.screen.fetch;
  }
  get ctx() {
    return this.screen.ctx;
  }
  get emSize() {
    const { emSizeStack: t } = this;
    return t[t.length - 1] || zu;
  }
  set emSize(t) {
    const { emSizeStack: r } = this;
    r.push(t);
  }
  popEmSize() {
    const { emSizeStack: t } = this;
    t.pop();
  }
  getUniqueId() {
    return "canvg".concat(++this.uniqueId);
  }
  isImagesLoaded() {
    return this.images.every(
      (t) => t.loaded
    );
  }
  isFontsLoaded() {
    return this.fonts.every(
      (t) => t.loaded
    );
  }
  createDocumentElement(t) {
    const r = this.createElement(t.documentElement);
    return r.root = !0, r.addStylesFromStyleDefinition(), this.documentElement = r, r;
  }
  createElement(t) {
    const r = t.nodeName.replace(/^[^:]+:/, ""), o = qa.elementTypes[r];
    return o ? new o(this, t) : new $b(this, t);
  }
  createTextNode(t) {
    return new n9(this, t);
  }
  setViewBox(t) {
    this.screen.setViewBox({
      document: this,
      ...t
    });
  }
  constructor(t, { rootEmSize: r = zu, emSize: o = zu, createCanvas: c = qa.createCanvas, createImage: d = qa.createImage, anonymousCrossOrigin: u } = {}) {
    this.canvg = t, this.definitions = {}, this.styles = {}, this.stylesSpecificity = {}, this.images = [], this.fonts = [], this.emSizeStack = [], this.uniqueId = 0, this.screen = t.screen, this.rootEmSize = r, this.emSize = o, this.createCanvas = c, this.createImage = this.bindCreateImage(d, u), this.screen.wait(
      () => this.isImagesLoaded()
    ), this.screen.wait(
      () => this.isFontsLoaded()
    );
  }
}
qa.createCanvas = M9;
qa.createImage = B9;
qa.elementTypes = D9;
class So {
  /**
  * Create Canvg instance from SVG source string or URL.
  * @param ctx - Rendering context.
  * @param svg - SVG source string or URL.
  * @param options - Rendering options.
  * @returns Canvg instance.
  */
  static async from(t, r) {
    let o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const d = await new Uu(o).parse(r);
    return new So(t, d, o);
  }
  /**
  * Create Canvg instance from SVG source string.
  * @param ctx - Rendering context.
  * @param svg - SVG source string.
  * @param options - Rendering options.
  * @returns Canvg instance.
  */
  static fromString(t, r) {
    let o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const d = new Uu(o).parseFromString(r);
    return new So(t, d, o);
  }
  /**
  * Create new Canvg instance with inherited options.
  * @param ctx - Rendering context.
  * @param svg - SVG source string or URL.
  * @param options - Rendering options.
  * @returns Canvg instance.
  */
  fork(t, r) {
    let o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return So.from(t, r, {
      ...this.options,
      ...o
    });
  }
  /**
  * Create new Canvg instance with inherited options.
  * @param ctx - Rendering context.
  * @param svg - SVG source string.
  * @param options - Rendering options.
  * @returns Canvg instance.
  */
  forkString(t, r) {
    let o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return So.fromString(t, r, {
      ...this.options,
      ...o
    });
  }
  /**
  * Document is ready promise.
  * @returns Ready promise.
  */
  ready() {
    return this.screen.ready();
  }
  /**
  * Document is ready value.
  * @returns Is ready or not.
  */
  isReady() {
    return this.screen.isReady();
  }
  /**
  * Render only first frame, ignoring animations and mouse.
  * @param options - Rendering options.
  */
  async render() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.start({
      enableRedraw: !0,
      ignoreAnimation: !0,
      ignoreMouse: !0,
      ...t
    }), await this.ready(), this.stop();
  }
  /**
  * Start rendering.
  * @param options - Render options.
  */
  start() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { documentElement: r, screen: o, options: c } = this;
    o.start(r, {
      enableRedraw: !0,
      ...c,
      ...t
    });
  }
  /**
  * Stop rendering.
  */
  stop() {
    this.screen.stop();
  }
  /**
  * Resize SVG to fit in given size.
  * @param width
  * @param height
  * @param preserveAspectRatio
  */
  resize(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : t, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    this.documentElement.resize(t, r, o);
  }
  /**
  * Main constructor.
  * @param ctx - Rendering context.
  * @param svg - SVG Document.
  * @param options - Rendering options.
  */
  constructor(t, r, o = {}) {
    this.parser = new Uu(o), this.screen = new Ra(t, o), this.options = o;
    const c = new qa(this, o), d = c.createDocumentElement(r);
    this.document = c, this.documentElement = d;
  }
}
class B1 extends Qh {
  constructor(r) {
    super(r);
    _e(this, "colors");
    _e(this, "coloredString");
    _e(this, "canvas");
    _e(this, "canvgElement");
    _e(this, "svgString");
    _e(this, "hitform");
    _e(this, "inPromise");
    _e(this, "type");
    _e(this, "recomputeColorSvg");
    this.type = "internalsvg", this.colors = {}, this.inPromise = !1, this.mimeType = "image/svg+xml", this.recomputeColorSvg = !1;
  }
  randomOptions() {
    if (this.vida.gallery === void 0)
      throw new jn("Please provide a gallery if you use internalsvg!");
    const r = this.vida.gallery.randomInternalSvg();
    return {
      type: this.type,
      id: r.id,
      colors: r.colors
      // todo random colors
    };
  }
  toJson() {
    return {
      type: this.type,
      id: this.id,
      colors: this.colors,
      width: this.originalSize.width,
      height: this.originalSize.height
    };
  }
  imageToSvg() {
    return this.coloredString;
  }
  update(r) {
    return new Promise((o, c) => {
      if (r || o(), r !== void 0 && (this.id === void 0 || r.id !== void 0 && this.id != r.id)) {
        if (this.vida.gallery === void 0)
          throw new jn("Please provide a gallery if you use internalsvg!");
        const d = this.vida.gallery.elementById(r.id);
        if (d === void 0 || d.type !== "internalsvg")
          throw new jn(`Image ${r.id} does not exist or is not an internalsvg.`);
        this.hitform = d.hitform, this.originalSize = { width: d.width, height: d.height };
        const u = {};
        Fn(u, d.colors, void 0), ns(u, r.colors), r.colors = u, this.inPromise = !0, this.recomputeColorSvg = !0, this.vida.gallery.fileUrl(r.id).then((l) => {
          Pg(l, { prepareColors: !0 }).then((e) => {
            this.svgString = e, this.id = r.id, this.inPromise = !1, this.update(r).then(() => o()).catch((s) => c(s));
          }).catch((e) => c(e));
        });
        return;
      }
      (this.recomputeColorSvg || r !== void 0 && (!this.canvas || Tg(this.colors, r.colors))) && (this.recomputeImage = !0, this.recomputeColorSvg = !1, this.recomputePosition = !0, this.colors = r.colors, console.assert(this.svgString), this.coloredString = dh(this.svgString, r.colors).string), o();
    });
  }
  makeImage(r, o) {
    return new Promise((c, d) => {
      this.inResize && d(), this.inResize = !0, this.canvas || (this.canvas = window.document.createElement("canvas"));
      const u = this.canvas.getContext("2d");
      try {
        this.canvgElement = So.fromString(u, this.coloredString);
      } catch (l) {
        console.error(l), d();
        return;
      }
      this.canvgElement.resize(r, o, "xMidYMid meet"), this.canvgElement.render().then(() => {
        this.inResize = !1, c();
      }).catch((l) => {
        console.error(l), d(l);
      });
    });
  }
  image() {
    return console.assert(this.canvas), this.canvas;
  }
  makeHitformFunction(r) {
    return Og(this.hitform, r);
  }
}
var P0 = {}, k9 = function() {
  return typeof Promise == "function" && Promise.prototype && Promise.prototype.then;
}, _g = {}, Ui = {};
let ec;
const N9 = [
  0,
  // Not used
  26,
  44,
  70,
  100,
  134,
  172,
  196,
  242,
  292,
  346,
  404,
  466,
  532,
  581,
  655,
  733,
  815,
  901,
  991,
  1085,
  1156,
  1258,
  1364,
  1474,
  1588,
  1706,
  1828,
  1921,
  2051,
  2185,
  2323,
  2465,
  2611,
  2761,
  2876,
  3034,
  3196,
  3362,
  3532,
  3706
];
Ui.getSymbolSize = function(t) {
  if (!t)
    throw new Error('"version" cannot be null or undefined');
  if (t < 1 || t > 40)
    throw new Error('"version" should be in range from 1 to 40');
  return t * 4 + 17;
};
Ui.getSymbolTotalCodewords = function(t) {
  return N9[t];
};
Ui.getBCHDigit = function(a) {
  let t = 0;
  for (; a !== 0; )
    t++, a >>>= 1;
  return t;
};
Ui.setToSJISFunction = function(t) {
  if (typeof t != "function")
    throw new Error('"toSJISFunc" is not a valid function.');
  ec = t;
};
Ui.isKanjiModeEnabled = function() {
  return typeof ec < "u";
};
Ui.toSJIS = function(t) {
  return ec(t);
};
var rf = {};
(function(a) {
  a.L = { bit: 1 }, a.M = { bit: 0 }, a.Q = { bit: 3 }, a.H = { bit: 2 };
  function t(r) {
    if (typeof r != "string")
      throw new Error("Param is not a string");
    switch (r.toLowerCase()) {
      case "l":
      case "low":
        return a.L;
      case "m":
      case "medium":
        return a.M;
      case "q":
      case "quartile":
        return a.Q;
      case "h":
      case "high":
        return a.H;
      default:
        throw new Error("Unknown EC Level: " + r);
    }
  }
  a.isValid = function(o) {
    return o && typeof o.bit < "u" && o.bit >= 0 && o.bit < 4;
  }, a.from = function(o, c) {
    if (a.isValid(o))
      return o;
    try {
      return t(o);
    } catch {
      return c;
    }
  };
})(rf);
function jg() {
  this.buffer = [], this.length = 0;
}
jg.prototype = {
  get: function(a) {
    const t = Math.floor(a / 8);
    return (this.buffer[t] >>> 7 - a % 8 & 1) === 1;
  },
  put: function(a, t) {
    for (let r = 0; r < t; r++)
      this.putBit((a >>> t - r - 1 & 1) === 1);
  },
  getLengthInBits: function() {
    return this.length;
  },
  putBit: function(a) {
    const t = Math.floor(this.length / 8);
    this.buffer.length <= t && this.buffer.push(0), a && (this.buffer[t] |= 128 >>> this.length % 8), this.length++;
  }
};
var L9 = jg;
function O0(a) {
  if (!a || a < 1)
    throw new Error("BitMatrix size must be defined and greater than 0");
  this.size = a, this.data = new Uint8Array(a * a), this.reservedBit = new Uint8Array(a * a);
}
O0.prototype.set = function(a, t, r, o) {
  const c = a * this.size + t;
  this.data[c] = r, o && (this.reservedBit[c] = !0);
};
O0.prototype.get = function(a, t) {
  return this.data[a * this.size + t];
};
O0.prototype.xor = function(a, t, r) {
  this.data[a * this.size + t] ^= r;
};
O0.prototype.isReserved = function(a, t) {
  return this.reservedBit[a * this.size + t];
};
var U9 = O0, Xg = {};
(function(a) {
  const t = Ui.getSymbolSize;
  a.getRowColCoords = function(o) {
    if (o === 1)
      return [];
    const c = Math.floor(o / 7) + 2, d = t(o), u = d === 145 ? 26 : Math.ceil((d - 13) / (2 * c - 2)) * 2, l = [d - 7];
    for (let e = 1; e < c - 1; e++)
      l[e] = l[e - 1] - u;
    return l.push(6), l.reverse();
  }, a.getPositions = function(o) {
    const c = [], d = a.getRowColCoords(o), u = d.length;
    for (let l = 0; l < u; l++)
      for (let e = 0; e < u; e++)
        l === 0 && e === 0 || // top-left
        l === 0 && e === u - 1 || // bottom-left
        l === u - 1 && e === 0 || c.push([d[l], d[e]]);
    return c;
  };
})(Xg);
var Yg = {};
const z9 = Ui.getSymbolSize, k1 = 7;
Yg.getPositions = function(t) {
  const r = z9(t);
  return [
    // top-left
    [0, 0],
    // top-right
    [r - k1, 0],
    // bottom-left
    [0, r - k1]
  ];
};
var Zg = {};
(function(a) {
  a.Patterns = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
  };
  const t = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
  };
  a.isValid = function(c) {
    return c != null && c !== "" && !isNaN(c) && c >= 0 && c <= 7;
  }, a.from = function(c) {
    return a.isValid(c) ? parseInt(c, 10) : void 0;
  }, a.getPenaltyN1 = function(c) {
    const d = c.size;
    let u = 0, l = 0, e = 0, s = null, i = null;
    for (let f = 0; f < d; f++) {
      l = e = 0, s = i = null;
      for (let h = 0; h < d; h++) {
        let v = c.get(f, h);
        v === s ? l++ : (l >= 5 && (u += t.N1 + (l - 5)), s = v, l = 1), v = c.get(h, f), v === i ? e++ : (e >= 5 && (u += t.N1 + (e - 5)), i = v, e = 1);
      }
      l >= 5 && (u += t.N1 + (l - 5)), e >= 5 && (u += t.N1 + (e - 5));
    }
    return u;
  }, a.getPenaltyN2 = function(c) {
    const d = c.size;
    let u = 0;
    for (let l = 0; l < d - 1; l++)
      for (let e = 0; e < d - 1; e++) {
        const s = c.get(l, e) + c.get(l, e + 1) + c.get(l + 1, e) + c.get(l + 1, e + 1);
        (s === 4 || s === 0) && u++;
      }
    return u * t.N2;
  }, a.getPenaltyN3 = function(c) {
    const d = c.size;
    let u = 0, l = 0, e = 0;
    for (let s = 0; s < d; s++) {
      l = e = 0;
      for (let i = 0; i < d; i++)
        l = l << 1 & 2047 | c.get(s, i), i >= 10 && (l === 1488 || l === 93) && u++, e = e << 1 & 2047 | c.get(i, s), i >= 10 && (e === 1488 || e === 93) && u++;
    }
    return u * t.N3;
  }, a.getPenaltyN4 = function(c) {
    let d = 0;
    const u = c.data.length;
    for (let e = 0; e < u; e++)
      d += c.data[e];
    return Math.abs(Math.ceil(d * 100 / u / 5) - 10) * t.N4;
  };
  function r(o, c, d) {
    switch (o) {
      case a.Patterns.PATTERN000:
        return (c + d) % 2 === 0;
      case a.Patterns.PATTERN001:
        return c % 2 === 0;
      case a.Patterns.PATTERN010:
        return d % 3 === 0;
      case a.Patterns.PATTERN011:
        return (c + d) % 3 === 0;
      case a.Patterns.PATTERN100:
        return (Math.floor(c / 2) + Math.floor(d / 3)) % 2 === 0;
      case a.Patterns.PATTERN101:
        return c * d % 2 + c * d % 3 === 0;
      case a.Patterns.PATTERN110:
        return (c * d % 2 + c * d % 3) % 2 === 0;
      case a.Patterns.PATTERN111:
        return (c * d % 3 + (c + d) % 2) % 2 === 0;
      default:
        throw new Error("bad maskPattern:" + o);
    }
  }
  a.applyMask = function(c, d) {
    const u = d.size;
    for (let l = 0; l < u; l++)
      for (let e = 0; e < u; e++)
        d.isReserved(e, l) || d.xor(e, l, r(c, e, l));
  }, a.getBestMask = function(c, d) {
    const u = Object.keys(a.Patterns).length;
    let l = 0, e = 1 / 0;
    for (let s = 0; s < u; s++) {
      d(s), a.applyMask(s, c);
      const i = a.getPenaltyN1(c) + a.getPenaltyN2(c) + a.getPenaltyN3(c) + a.getPenaltyN4(c);
      a.applyMask(s, c), i < e && (e = i, l = s);
    }
    return l;
  };
})(Zg);
var nf = {};
const Ka = rf, ml = [
  // L  M  Q  H
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  2,
  2,
  1,
  2,
  2,
  4,
  1,
  2,
  4,
  4,
  2,
  4,
  4,
  4,
  2,
  4,
  6,
  5,
  2,
  4,
  6,
  6,
  2,
  5,
  8,
  8,
  4,
  5,
  8,
  8,
  4,
  5,
  8,
  11,
  4,
  8,
  10,
  11,
  4,
  9,
  12,
  16,
  4,
  9,
  16,
  16,
  6,
  10,
  12,
  18,
  6,
  10,
  17,
  16,
  6,
  11,
  16,
  19,
  6,
  13,
  18,
  21,
  7,
  14,
  21,
  25,
  8,
  16,
  20,
  25,
  8,
  17,
  23,
  25,
  9,
  17,
  23,
  34,
  9,
  18,
  25,
  30,
  10,
  20,
  27,
  32,
  12,
  21,
  29,
  35,
  12,
  23,
  34,
  37,
  12,
  25,
  34,
  40,
  13,
  26,
  35,
  42,
  14,
  28,
  38,
  45,
  15,
  29,
  40,
  48,
  16,
  31,
  43,
  51,
  17,
  33,
  45,
  54,
  18,
  35,
  48,
  57,
  19,
  37,
  51,
  60,
  19,
  38,
  53,
  63,
  20,
  40,
  56,
  66,
  21,
  43,
  59,
  70,
  22,
  45,
  62,
  74,
  24,
  47,
  65,
  77,
  25,
  49,
  68,
  81
], xl = [
  // L  M  Q  H
  7,
  10,
  13,
  17,
  10,
  16,
  22,
  28,
  15,
  26,
  36,
  44,
  20,
  36,
  52,
  64,
  26,
  48,
  72,
  88,
  36,
  64,
  96,
  112,
  40,
  72,
  108,
  130,
  48,
  88,
  132,
  156,
  60,
  110,
  160,
  192,
  72,
  130,
  192,
  224,
  80,
  150,
  224,
  264,
  96,
  176,
  260,
  308,
  104,
  198,
  288,
  352,
  120,
  216,
  320,
  384,
  132,
  240,
  360,
  432,
  144,
  280,
  408,
  480,
  168,
  308,
  448,
  532,
  180,
  338,
  504,
  588,
  196,
  364,
  546,
  650,
  224,
  416,
  600,
  700,
  224,
  442,
  644,
  750,
  252,
  476,
  690,
  816,
  270,
  504,
  750,
  900,
  300,
  560,
  810,
  960,
  312,
  588,
  870,
  1050,
  336,
  644,
  952,
  1110,
  360,
  700,
  1020,
  1200,
  390,
  728,
  1050,
  1260,
  420,
  784,
  1140,
  1350,
  450,
  812,
  1200,
  1440,
  480,
  868,
  1290,
  1530,
  510,
  924,
  1350,
  1620,
  540,
  980,
  1440,
  1710,
  570,
  1036,
  1530,
  1800,
  570,
  1064,
  1590,
  1890,
  600,
  1120,
  1680,
  1980,
  630,
  1204,
  1770,
  2100,
  660,
  1260,
  1860,
  2220,
  720,
  1316,
  1950,
  2310,
  750,
  1372,
  2040,
  2430
];
nf.getBlocksCount = function(t, r) {
  switch (r) {
    case Ka.L:
      return ml[(t - 1) * 4 + 0];
    case Ka.M:
      return ml[(t - 1) * 4 + 1];
    case Ka.Q:
      return ml[(t - 1) * 4 + 2];
    case Ka.H:
      return ml[(t - 1) * 4 + 3];
    default:
      return;
  }
};
nf.getTotalCodewordsCount = function(t, r) {
  switch (r) {
    case Ka.L:
      return xl[(t - 1) * 4 + 0];
    case Ka.M:
      return xl[(t - 1) * 4 + 1];
    case Ka.Q:
      return xl[(t - 1) * 4 + 2];
    case Ka.H:
      return xl[(t - 1) * 4 + 3];
    default:
      return;
  }
};
var Kg = {}, af = {};
const o0 = new Uint8Array(512), Nl = new Uint8Array(256);
(function() {
  let t = 1;
  for (let r = 0; r < 255; r++)
    o0[r] = t, Nl[t] = r, t <<= 1, t & 256 && (t ^= 285);
  for (let r = 255; r < 512; r++)
    o0[r] = o0[r - 255];
})();
af.log = function(t) {
  if (t < 1)
    throw new Error("log(" + t + ")");
  return Nl[t];
};
af.exp = function(t) {
  return o0[t];
};
af.mul = function(t, r) {
  return t === 0 || r === 0 ? 0 : o0[Nl[t] + Nl[r]];
};
(function(a) {
  const t = af;
  a.mul = function(o, c) {
    const d = new Uint8Array(o.length + c.length - 1);
    for (let u = 0; u < o.length; u++)
      for (let l = 0; l < c.length; l++)
        d[u + l] ^= t.mul(o[u], c[l]);
    return d;
  }, a.mod = function(o, c) {
    let d = new Uint8Array(o);
    for (; d.length - c.length >= 0; ) {
      const u = d[0];
      for (let e = 0; e < c.length; e++)
        d[e] ^= t.mul(c[e], u);
      let l = 0;
      for (; l < d.length && d[l] === 0; )
        l++;
      d = d.slice(l);
    }
    return d;
  }, a.generateECPolynomial = function(o) {
    let c = new Uint8Array([1]);
    for (let d = 0; d < o; d++)
      c = a.mul(c, new Uint8Array([1, t.exp(d)]));
    return c;
  };
})(Kg);
const Jg = Kg;
function rc(a) {
  this.genPoly = void 0, this.degree = a, this.degree && this.initialize(this.degree);
}
rc.prototype.initialize = function(t) {
  this.degree = t, this.genPoly = Jg.generateECPolynomial(this.degree);
};
rc.prototype.encode = function(t) {
  if (!this.genPoly)
    throw new Error("Encoder not initialized");
  const r = new Uint8Array(t.length + this.degree);
  r.set(t);
  const o = Jg.mod(r, this.genPoly), c = this.degree - o.length;
  if (c > 0) {
    const d = new Uint8Array(this.degree);
    return d.set(o, c), d;
  }
  return o;
};
var G9 = rc, Qg = {}, ro = {}, nc = {};
nc.isValid = function(t) {
  return !isNaN(t) && t >= 1 && t <= 40;
};
var ca = {};
const $g = "[0-9]+", V9 = "[A-Z $%*+\\-./:]+";
let x0 = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
x0 = x0.replace(/u/g, "\\u");
const H9 = "(?:(?![A-Z0-9 $%*+\\-./:]|" + x0 + `)(?:.|[\r
]))+`;
ca.KANJI = new RegExp(x0, "g");
ca.BYTE_KANJI = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
ca.BYTE = new RegExp(H9, "g");
ca.NUMERIC = new RegExp($g, "g");
ca.ALPHANUMERIC = new RegExp(V9, "g");
const W9 = new RegExp("^" + x0 + "$"), _9 = new RegExp("^" + $g + "$"), j9 = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
ca.testKanji = function(t) {
  return W9.test(t);
};
ca.testNumeric = function(t) {
  return _9.test(t);
};
ca.testAlphanumeric = function(t) {
  return j9.test(t);
};
(function(a) {
  const t = nc, r = ca;
  a.NUMERIC = {
    id: "Numeric",
    bit: 1,
    ccBits: [10, 12, 14]
  }, a.ALPHANUMERIC = {
    id: "Alphanumeric",
    bit: 2,
    ccBits: [9, 11, 13]
  }, a.BYTE = {
    id: "Byte",
    bit: 4,
    ccBits: [8, 16, 16]
  }, a.KANJI = {
    id: "Kanji",
    bit: 8,
    ccBits: [8, 10, 12]
  }, a.MIXED = {
    bit: -1
  }, a.getCharCountIndicator = function(d, u) {
    if (!d.ccBits)
      throw new Error("Invalid mode: " + d);
    if (!t.isValid(u))
      throw new Error("Invalid version: " + u);
    return u >= 1 && u < 10 ? d.ccBits[0] : u < 27 ? d.ccBits[1] : d.ccBits[2];
  }, a.getBestModeForData = function(d) {
    return r.testNumeric(d) ? a.NUMERIC : r.testAlphanumeric(d) ? a.ALPHANUMERIC : r.testKanji(d) ? a.KANJI : a.BYTE;
  }, a.toString = function(d) {
    if (d && d.id)
      return d.id;
    throw new Error("Invalid mode");
  }, a.isValid = function(d) {
    return d && d.bit && d.ccBits;
  };
  function o(c) {
    if (typeof c != "string")
      throw new Error("Param is not a string");
    switch (c.toLowerCase()) {
      case "numeric":
        return a.NUMERIC;
      case "alphanumeric":
        return a.ALPHANUMERIC;
      case "kanji":
        return a.KANJI;
      case "byte":
        return a.BYTE;
      default:
        throw new Error("Unknown mode: " + c);
    }
  }
  a.from = function(d, u) {
    if (a.isValid(d))
      return d;
    try {
      return o(d);
    } catch {
      return u;
    }
  };
})(ro);
(function(a) {
  const t = Ui, r = nf, o = rf, c = ro, d = nc, u = 7973, l = t.getBCHDigit(u);
  function e(h, v, p) {
    for (let m = 1; m <= 40; m++)
      if (v <= a.getCapacity(m, p, h))
        return m;
  }
  function s(h, v) {
    return c.getCharCountIndicator(h, v) + 4;
  }
  function i(h, v) {
    let p = 0;
    return h.forEach(function(m) {
      const x = s(m.mode, v);
      p += x + m.getBitsLength();
    }), p;
  }
  function f(h, v) {
    for (let p = 1; p <= 40; p++)
      if (i(h, p) <= a.getCapacity(p, v, c.MIXED))
        return p;
  }
  a.from = function(v, p) {
    return d.isValid(v) ? parseInt(v, 10) : p;
  }, a.getCapacity = function(v, p, m) {
    if (!d.isValid(v))
      throw new Error("Invalid QR Code version");
    typeof m > "u" && (m = c.BYTE);
    const x = t.getSymbolTotalCodewords(v), g = r.getTotalCodewordsCount(v, p), S = (x - g) * 8;
    if (m === c.MIXED)
      return S;
    const y = S - s(m, v);
    switch (m) {
      case c.NUMERIC:
        return Math.floor(y / 10 * 3);
      case c.ALPHANUMERIC:
        return Math.floor(y / 11 * 2);
      case c.KANJI:
        return Math.floor(y / 13);
      case c.BYTE:
      default:
        return Math.floor(y / 8);
    }
  }, a.getBestVersionForData = function(v, p) {
    let m;
    const x = o.from(p, o.M);
    if (Array.isArray(v)) {
      if (v.length > 1)
        return f(v, x);
      if (v.length === 0)
        return 1;
      m = v[0];
    } else
      m = v;
    return e(m.mode, m.getLength(), x);
  }, a.getEncodedBits = function(v) {
    if (!d.isValid(v) || v < 7)
      throw new Error("Invalid QR Code version");
    let p = v << 12;
    for (; t.getBCHDigit(p) - l >= 0; )
      p ^= u << t.getBCHDigit(p) - l;
    return v << 12 | p;
  };
})(Qg);
var qg = {};
const mh = Ui, t2 = 1335, X9 = 21522, N1 = mh.getBCHDigit(t2);
qg.getEncodedBits = function(t, r) {
  const o = t.bit << 3 | r;
  let c = o << 10;
  for (; mh.getBCHDigit(c) - N1 >= 0; )
    c ^= t2 << mh.getBCHDigit(c) - N1;
  return (o << 10 | c) ^ X9;
};
var e2 = {};
const Y9 = ro;
function hs(a) {
  this.mode = Y9.NUMERIC, this.data = a.toString();
}
hs.getBitsLength = function(t) {
  return 10 * Math.floor(t / 3) + (t % 3 ? t % 3 * 3 + 1 : 0);
};
hs.prototype.getLength = function() {
  return this.data.length;
};
hs.prototype.getBitsLength = function() {
  return hs.getBitsLength(this.data.length);
};
hs.prototype.write = function(t) {
  let r, o, c;
  for (r = 0; r + 3 <= this.data.length; r += 3)
    o = this.data.substr(r, 3), c = parseInt(o, 10), t.put(c, 10);
  const d = this.data.length - r;
  d > 0 && (o = this.data.substr(r), c = parseInt(o, 10), t.put(c, d * 3 + 1));
};
var Z9 = hs;
const K9 = ro, Gu = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  " ",
  "$",
  "%",
  "*",
  "+",
  "-",
  ".",
  "/",
  ":"
];
function cs(a) {
  this.mode = K9.ALPHANUMERIC, this.data = a;
}
cs.getBitsLength = function(t) {
  return 11 * Math.floor(t / 2) + 6 * (t % 2);
};
cs.prototype.getLength = function() {
  return this.data.length;
};
cs.prototype.getBitsLength = function() {
  return cs.getBitsLength(this.data.length);
};
cs.prototype.write = function(t) {
  let r;
  for (r = 0; r + 2 <= this.data.length; r += 2) {
    let o = Gu.indexOf(this.data[r]) * 45;
    o += Gu.indexOf(this.data[r + 1]), t.put(o, 11);
  }
  this.data.length % 2 && t.put(Gu.indexOf(this.data[r]), 6);
};
var J9 = cs, Q9 = function(t) {
  for (var r = [], o = t.length, c = 0; c < o; c++) {
    var d = t.charCodeAt(c);
    if (d >= 55296 && d <= 56319 && o > c + 1) {
      var u = t.charCodeAt(c + 1);
      u >= 56320 && u <= 57343 && (d = (d - 55296) * 1024 + u - 56320 + 65536, c += 1);
    }
    if (d < 128) {
      r.push(d);
      continue;
    }
    if (d < 2048) {
      r.push(d >> 6 | 192), r.push(d & 63 | 128);
      continue;
    }
    if (d < 55296 || d >= 57344 && d < 65536) {
      r.push(d >> 12 | 224), r.push(d >> 6 & 63 | 128), r.push(d & 63 | 128);
      continue;
    }
    if (d >= 65536 && d <= 1114111) {
      r.push(d >> 18 | 240), r.push(d >> 12 & 63 | 128), r.push(d >> 6 & 63 | 128), r.push(d & 63 | 128);
      continue;
    }
    r.push(239, 191, 189);
  }
  return new Uint8Array(r).buffer;
};
const $9 = Q9, q9 = ro;
function ds(a) {
  this.mode = q9.BYTE, typeof a == "string" && (a = $9(a)), this.data = new Uint8Array(a);
}
ds.getBitsLength = function(t) {
  return t * 8;
};
ds.prototype.getLength = function() {
  return this.data.length;
};
ds.prototype.getBitsLength = function() {
  return ds.getBitsLength(this.data.length);
};
ds.prototype.write = function(a) {
  for (let t = 0, r = this.data.length; t < r; t++)
    a.put(this.data[t], 8);
};
var t7 = ds;
const e7 = ro, r7 = Ui;
function vs(a) {
  this.mode = e7.KANJI, this.data = a;
}
vs.getBitsLength = function(t) {
  return t * 13;
};
vs.prototype.getLength = function() {
  return this.data.length;
};
vs.prototype.getBitsLength = function() {
  return vs.getBitsLength(this.data.length);
};
vs.prototype.write = function(a) {
  let t;
  for (t = 0; t < this.data.length; t++) {
    let r = r7.toSJIS(this.data[t]);
    if (r >= 33088 && r <= 40956)
      r -= 33088;
    else if (r >= 57408 && r <= 60351)
      r -= 49472;
    else
      throw new Error(
        "Invalid SJIS character: " + this.data[t] + `
Make sure your charset is UTF-8`
      );
    r = (r >>> 8 & 255) * 192 + (r & 255), a.put(r, 13);
  }
};
var n7 = vs, r2 = { exports: {} };
(function(a) {
  var t = {
    single_source_shortest_paths: function(r, o, c) {
      var d = {}, u = {};
      u[o] = 0;
      var l = t.PriorityQueue.make();
      l.push(o, 0);
      for (var e, s, i, f, h, v, p, m, x; !l.empty(); ) {
        e = l.pop(), s = e.value, f = e.cost, h = r[s] || {};
        for (i in h)
          h.hasOwnProperty(i) && (v = h[i], p = f + v, m = u[i], x = typeof u[i] > "u", (x || m > p) && (u[i] = p, l.push(i, p), d[i] = s));
      }
      if (typeof c < "u" && typeof u[c] > "u") {
        var g = ["Could not find a path from ", o, " to ", c, "."].join("");
        throw new Error(g);
      }
      return d;
    },
    extract_shortest_path_from_predecessor_list: function(r, o) {
      for (var c = [], d = o; d; )
        c.push(d), r[d], d = r[d];
      return c.reverse(), c;
    },
    find_path: function(r, o, c) {
      var d = t.single_source_shortest_paths(r, o, c);
      return t.extract_shortest_path_from_predecessor_list(
        d,
        c
      );
    },
    /**
     * A very naive priority queue implementation.
     */
    PriorityQueue: {
      make: function(r) {
        var o = t.PriorityQueue, c = {}, d;
        r = r || {};
        for (d in o)
          o.hasOwnProperty(d) && (c[d] = o[d]);
        return c.queue = [], c.sorter = r.sorter || o.default_sorter, c;
      },
      default_sorter: function(r, o) {
        return r.cost - o.cost;
      },
      /**
       * Add a new item to the queue and ensure the highest priority element
       * is at the front of the queue.
       */
      push: function(r, o) {
        var c = { value: r, cost: o };
        this.queue.push(c), this.queue.sort(this.sorter);
      },
      /**
       * Return the highest priority element in the queue.
       */
      pop: function() {
        return this.queue.shift();
      },
      empty: function() {
        return this.queue.length === 0;
      }
    }
  };
  a.exports = t;
})(r2);
var i7 = r2.exports;
(function(a) {
  const t = ro, r = Z9, o = J9, c = t7, d = n7, u = ca, l = Ui, e = i7;
  function s(g) {
    return unescape(encodeURIComponent(g)).length;
  }
  function i(g, S, y) {
    const b = [];
    let n;
    for (; (n = g.exec(y)) !== null; )
      b.push({
        data: n[0],
        index: n.index,
        mode: S,
        length: n[0].length
      });
    return b;
  }
  function f(g) {
    const S = i(u.NUMERIC, t.NUMERIC, g), y = i(u.ALPHANUMERIC, t.ALPHANUMERIC, g);
    let b, n;
    return l.isKanjiModeEnabled() ? (b = i(u.BYTE, t.BYTE, g), n = i(u.KANJI, t.KANJI, g)) : (b = i(u.BYTE_KANJI, t.BYTE, g), n = []), S.concat(y, b, n).sort(function(E, A) {
      return E.index - A.index;
    }).map(function(E) {
      return {
        data: E.data,
        mode: E.mode,
        length: E.length
      };
    });
  }
  function h(g, S) {
    switch (S) {
      case t.NUMERIC:
        return r.getBitsLength(g);
      case t.ALPHANUMERIC:
        return o.getBitsLength(g);
      case t.KANJI:
        return d.getBitsLength(g);
      case t.BYTE:
        return c.getBitsLength(g);
    }
  }
  function v(g) {
    return g.reduce(function(S, y) {
      const b = S.length - 1 >= 0 ? S[S.length - 1] : null;
      return b && b.mode === y.mode ? (S[S.length - 1].data += y.data, S) : (S.push(y), S);
    }, []);
  }
  function p(g) {
    const S = [];
    for (let y = 0; y < g.length; y++) {
      const b = g[y];
      switch (b.mode) {
        case t.NUMERIC:
          S.push([
            b,
            { data: b.data, mode: t.ALPHANUMERIC, length: b.length },
            { data: b.data, mode: t.BYTE, length: b.length }
          ]);
          break;
        case t.ALPHANUMERIC:
          S.push([
            b,
            { data: b.data, mode: t.BYTE, length: b.length }
          ]);
          break;
        case t.KANJI:
          S.push([
            b,
            { data: b.data, mode: t.BYTE, length: s(b.data) }
          ]);
          break;
        case t.BYTE:
          S.push([
            { data: b.data, mode: t.BYTE, length: s(b.data) }
          ]);
      }
    }
    return S;
  }
  function m(g, S) {
    const y = {}, b = { start: {} };
    let n = ["start"];
    for (let w = 0; w < g.length; w++) {
      const E = g[w], A = [];
      for (let O = 0; O < E.length; O++) {
        const C = E[O], T = "" + w + O;
        A.push(T), y[T] = { node: C, lastCount: 0 }, b[T] = {};
        for (let P = 0; P < n.length; P++) {
          const I = n[P];
          y[I] && y[I].node.mode === C.mode ? (b[I][T] = h(y[I].lastCount + C.length, C.mode) - h(y[I].lastCount, C.mode), y[I].lastCount += C.length) : (y[I] && (y[I].lastCount = C.length), b[I][T] = h(C.length, C.mode) + 4 + t.getCharCountIndicator(C.mode, S));
        }
      }
      n = A;
    }
    for (let w = 0; w < n.length; w++)
      b[n[w]].end = 0;
    return { map: b, table: y };
  }
  function x(g, S) {
    let y;
    const b = t.getBestModeForData(g);
    if (y = t.from(S, b), y !== t.BYTE && y.bit < b.bit)
      throw new Error('"' + g + '" cannot be encoded with mode ' + t.toString(y) + `.
 Suggested mode is: ` + t.toString(b));
    switch (y === t.KANJI && !l.isKanjiModeEnabled() && (y = t.BYTE), y) {
      case t.NUMERIC:
        return new r(g);
      case t.ALPHANUMERIC:
        return new o(g);
      case t.KANJI:
        return new d(g);
      case t.BYTE:
        return new c(g);
    }
  }
  a.fromArray = function(S) {
    return S.reduce(function(y, b) {
      return typeof b == "string" ? y.push(x(b, null)) : b.data && y.push(x(b.data, b.mode)), y;
    }, []);
  }, a.fromString = function(S, y) {
    const b = f(S, l.isKanjiModeEnabled()), n = p(b), w = m(n, y), E = e.find_path(w.map, "start", "end"), A = [];
    for (let O = 1; O < E.length - 1; O++)
      A.push(w.table[E[O]].node);
    return a.fromArray(v(A));
  }, a.rawSplit = function(S) {
    return a.fromArray(
      f(S, l.isKanjiModeEnabled())
    );
  };
})(e2);
const of = Ui, Vu = rf, a7 = L9, o7 = U9, s7 = Xg, l7 = Yg, xh = Zg, bh = nf, f7 = G9, Ll = Qg, u7 = qg, h7 = ro, Hu = e2;
function c7(a, t) {
  const r = a.size, o = l7.getPositions(t);
  for (let c = 0; c < o.length; c++) {
    const d = o[c][0], u = o[c][1];
    for (let l = -1; l <= 7; l++)
      if (!(d + l <= -1 || r <= d + l))
        for (let e = -1; e <= 7; e++)
          u + e <= -1 || r <= u + e || (l >= 0 && l <= 6 && (e === 0 || e === 6) || e >= 0 && e <= 6 && (l === 0 || l === 6) || l >= 2 && l <= 4 && e >= 2 && e <= 4 ? a.set(d + l, u + e, !0, !0) : a.set(d + l, u + e, !1, !0));
  }
}
function d7(a) {
  const t = a.size;
  for (let r = 8; r < t - 8; r++) {
    const o = r % 2 === 0;
    a.set(r, 6, o, !0), a.set(6, r, o, !0);
  }
}
function v7(a, t) {
  const r = s7.getPositions(t);
  for (let o = 0; o < r.length; o++) {
    const c = r[o][0], d = r[o][1];
    for (let u = -2; u <= 2; u++)
      for (let l = -2; l <= 2; l++)
        u === -2 || u === 2 || l === -2 || l === 2 || u === 0 && l === 0 ? a.set(c + u, d + l, !0, !0) : a.set(c + u, d + l, !1, !0);
  }
}
function g7(a, t) {
  const r = a.size, o = Ll.getEncodedBits(t);
  let c, d, u;
  for (let l = 0; l < 18; l++)
    c = Math.floor(l / 3), d = l % 3 + r - 8 - 3, u = (o >> l & 1) === 1, a.set(c, d, u, !0), a.set(d, c, u, !0);
}
function Wu(a, t, r) {
  const o = a.size, c = u7.getEncodedBits(t, r);
  let d, u;
  for (d = 0; d < 15; d++)
    u = (c >> d & 1) === 1, d < 6 ? a.set(d, 8, u, !0) : d < 8 ? a.set(d + 1, 8, u, !0) : a.set(o - 15 + d, 8, u, !0), d < 8 ? a.set(8, o - d - 1, u, !0) : d < 9 ? a.set(8, 15 - d - 1 + 1, u, !0) : a.set(8, 15 - d - 1, u, !0);
  a.set(o - 8, 8, 1, !0);
}
function p7(a, t) {
  const r = a.size;
  let o = -1, c = r - 1, d = 7, u = 0;
  for (let l = r - 1; l > 0; l -= 2)
    for (l === 6 && l--; ; ) {
      for (let e = 0; e < 2; e++)
        if (!a.isReserved(c, l - e)) {
          let s = !1;
          u < t.length && (s = (t[u] >>> d & 1) === 1), a.set(c, l - e, s), d--, d === -1 && (u++, d = 7);
        }
      if (c += o, c < 0 || r <= c) {
        c -= o, o = -o;
        break;
      }
    }
}
function y7(a, t, r) {
  const o = new a7();
  r.forEach(function(e) {
    o.put(e.mode.bit, 4), o.put(e.getLength(), h7.getCharCountIndicator(e.mode, a)), e.write(o);
  });
  const c = of.getSymbolTotalCodewords(a), d = bh.getTotalCodewordsCount(a, t), u = (c - d) * 8;
  for (o.getLengthInBits() + 4 <= u && o.put(0, 4); o.getLengthInBits() % 8 !== 0; )
    o.putBit(0);
  const l = (u - o.getLengthInBits()) / 8;
  for (let e = 0; e < l; e++)
    o.put(e % 2 ? 17 : 236, 8);
  return m7(o, a, t);
}
function m7(a, t, r) {
  const o = of.getSymbolTotalCodewords(t), c = bh.getTotalCodewordsCount(t, r), d = o - c, u = bh.getBlocksCount(t, r), l = o % u, e = u - l, s = Math.floor(o / u), i = Math.floor(d / u), f = i + 1, h = s - i, v = new f7(h);
  let p = 0;
  const m = new Array(u), x = new Array(u);
  let g = 0;
  const S = new Uint8Array(a.buffer);
  for (let E = 0; E < u; E++) {
    const A = E < e ? i : f;
    m[E] = S.slice(p, p + A), x[E] = v.encode(m[E]), p += A, g = Math.max(g, A);
  }
  const y = new Uint8Array(o);
  let b = 0, n, w;
  for (n = 0; n < g; n++)
    for (w = 0; w < u; w++)
      n < m[w].length && (y[b++] = m[w][n]);
  for (n = 0; n < h; n++)
    for (w = 0; w < u; w++)
      y[b++] = x[w][n];
  return y;
}
function x7(a, t, r, o) {
  let c;
  if (Array.isArray(a))
    c = Hu.fromArray(a);
  else if (typeof a == "string") {
    let s = t;
    if (!s) {
      const i = Hu.rawSplit(a);
      s = Ll.getBestVersionForData(i, r);
    }
    c = Hu.fromString(a, s || 40);
  } else
    throw new Error("Invalid data");
  const d = Ll.getBestVersionForData(c, r);
  if (!d)
    throw new Error("The amount of data is too big to be stored in a QR Code");
  if (!t)
    t = d;
  else if (t < d)
    throw new Error(
      `
The chosen QR Code version cannot contain this amount of data.
Minimum version required to store current data is: ` + d + `.
`
    );
  const u = y7(t, r, c), l = of.getSymbolSize(t), e = new o7(l);
  return c7(e, t), d7(e), v7(e, t), Wu(e, r, 0), t >= 7 && g7(e, t), p7(e, u), isNaN(o) && (o = xh.getBestMask(
    e,
    Wu.bind(null, e, r)
  )), xh.applyMask(o, e), Wu(e, r, o), {
    modules: e,
    version: t,
    errorCorrectionLevel: r,
    maskPattern: o,
    segments: c
  };
}
_g.create = function(t, r) {
  if (typeof t > "u" || t === "")
    throw new Error("No input text");
  let o = Vu.M, c, d;
  return typeof r < "u" && (o = Vu.from(r.errorCorrectionLevel, Vu.M), c = Ll.from(r.version), d = xh.from(r.maskPattern), r.toSJISFunc && of.setToSJISFunction(r.toSJISFunc)), x7(t, c, o, d);
};
var n2 = {}, ic = {};
(function(a) {
  function t(r) {
    if (typeof r == "number" && (r = r.toString()), typeof r != "string")
      throw new Error("Color should be defined as hex string");
    let o = r.slice().replace("#", "").split("");
    if (o.length < 3 || o.length === 5 || o.length > 8)
      throw new Error("Invalid hex color: " + r);
    (o.length === 3 || o.length === 4) && (o = Array.prototype.concat.apply([], o.map(function(d) {
      return [d, d];
    }))), o.length === 6 && o.push("F", "F");
    const c = parseInt(o.join(""), 16);
    return {
      r: c >> 24 & 255,
      g: c >> 16 & 255,
      b: c >> 8 & 255,
      a: c & 255,
      hex: "#" + o.slice(0, 6).join("")
    };
  }
  a.getOptions = function(o) {
    o || (o = {}), o.color || (o.color = {});
    const c = typeof o.margin > "u" || o.margin === null || o.margin < 0 ? 4 : o.margin, d = o.width && o.width >= 21 ? o.width : void 0, u = o.scale || 4;
    return {
      width: d,
      scale: d ? 4 : u,
      margin: c,
      color: {
        dark: t(o.color.dark || "#000000ff"),
        light: t(o.color.light || "#ffffffff")
      },
      type: o.type,
      rendererOpts: o.rendererOpts || {}
    };
  }, a.getScale = function(o, c) {
    return c.width && c.width >= o + c.margin * 2 ? c.width / (o + c.margin * 2) : c.scale;
  }, a.getImageWidth = function(o, c) {
    const d = a.getScale(o, c);
    return Math.floor((o + c.margin * 2) * d);
  }, a.qrToImageData = function(o, c, d) {
    const u = c.modules.size, l = c.modules.data, e = a.getScale(u, d), s = Math.floor((u + d.margin * 2) * e), i = d.margin * e, f = [d.color.light, d.color.dark];
    for (let h = 0; h < s; h++)
      for (let v = 0; v < s; v++) {
        let p = (h * s + v) * 4, m = d.color.light;
        if (h >= i && v >= i && h < s - i && v < s - i) {
          const x = Math.floor((h - i) / e), g = Math.floor((v - i) / e);
          m = f[l[x * u + g] ? 1 : 0];
        }
        o[p++] = m.r, o[p++] = m.g, o[p++] = m.b, o[p] = m.a;
      }
  };
})(ic);
(function(a) {
  const t = ic;
  function r(c, d, u) {
    c.clearRect(0, 0, d.width, d.height), d.style || (d.style = {}), d.height = u, d.width = u, d.style.height = u + "px", d.style.width = u + "px";
  }
  function o() {
    try {
      return document.createElement("canvas");
    } catch {
      throw new Error("You need to specify a canvas element");
    }
  }
  a.render = function(d, u, l) {
    let e = l, s = u;
    typeof e > "u" && (!u || !u.getContext) && (e = u, u = void 0), u || (s = o()), e = t.getOptions(e);
    const i = t.getImageWidth(d.modules.size, e), f = s.getContext("2d"), h = f.createImageData(i, i);
    return t.qrToImageData(h.data, d, e), r(f, s, i), f.putImageData(h, 0, 0), s;
  }, a.renderToDataURL = function(d, u, l) {
    let e = l;
    typeof e > "u" && (!u || !u.getContext) && (e = u, u = void 0), e || (e = {});
    const s = a.render(d, u, e), i = e.type || "image/png", f = e.rendererOpts || {};
    return s.toDataURL(i, f.quality);
  };
})(n2);
var i2 = {};
const b7 = ic;
function L1(a, t) {
  const r = a.a / 255, o = t + '="' + a.hex + '"';
  return r < 1 ? o + " " + t + '-opacity="' + r.toFixed(2).slice(1) + '"' : o;
}
function _u(a, t, r) {
  let o = a + t;
  return typeof r < "u" && (o += " " + r), o;
}
function w7(a, t, r) {
  let o = "", c = 0, d = !1, u = 0;
  for (let l = 0; l < a.length; l++) {
    const e = Math.floor(l % t), s = Math.floor(l / t);
    !e && !d && (d = !0), a[l] ? (u++, l > 0 && e > 0 && a[l - 1] || (o += d ? _u("M", e + r, 0.5 + s + r) : _u("m", c, 0), c = 0, d = !1), e + 1 < t && a[l + 1] || (o += _u("h", u), u = 0)) : c++;
  }
  return o;
}
i2.render = function(t, r, o) {
  const c = b7.getOptions(r), d = t.modules.size, u = t.modules.data, l = d + c.margin * 2, e = c.color.light.a ? "<path " + L1(c.color.light, "fill") + ' d="M0 0h' + l + "v" + l + 'H0z"/>' : "", s = "<path " + L1(c.color.dark, "stroke") + ' d="' + w7(u, d, c.margin) + '"/>', i = 'viewBox="0 0 ' + l + " " + l + '"', h = '<svg xmlns="http://www.w3.org/2000/svg" ' + (c.width ? 'width="' + c.width + '" height="' + c.width + '" ' : "") + i + ' shape-rendering="crispEdges">' + e + s + `</svg>
`;
  return typeof o == "function" && o(null, h), h;
};
const S7 = k9, wh = _g, a2 = n2, E7 = i2;
function ac(a, t, r, o, c) {
  const d = [].slice.call(arguments, 1), u = d.length, l = typeof d[u - 1] == "function";
  if (!l && !S7())
    throw new Error("Callback required as last argument");
  if (l) {
    if (u < 2)
      throw new Error("Too few arguments provided");
    u === 2 ? (c = r, r = t, t = o = void 0) : u === 3 && (t.getContext && typeof c > "u" ? (c = o, o = void 0) : (c = o, o = r, r = t, t = void 0));
  } else {
    if (u < 1)
      throw new Error("Too few arguments provided");
    return u === 1 ? (r = t, t = o = void 0) : u === 2 && !t.getContext && (o = r, r = t, t = void 0), new Promise(function(e, s) {
      try {
        const i = wh.create(r, o);
        e(a(i, t, o));
      } catch (i) {
        s(i);
      }
    });
  }
  try {
    const e = wh.create(r, o);
    c(null, a(e, t, o));
  } catch (e) {
    c(e);
  }
}
P0.create = wh.create;
P0.toCanvas = ac.bind(null, a2.render);
P0.toDataURL = ac.bind(null, a2.renderToDataURL);
P0.toString = ac.bind(null, function(a, t, r) {
  return E7.render(a, r);
});
function A7(a) {
  return new Promise((t, r) => {
    a == "" && r();
    const o = P0.create(a, {
      errorCorrectionLevel: "H",
      width: 128,
      // it does not like this option:/
      version: 100
    }), c = o.modules.size, d = o.modules.data, u = document.createElement("div"), l = document.createElement("svg");
    l.setAttribute("width", `${c}`), l.setAttribute("height", `${c}`), l.setAttribute("viewBox", `0 0 ${c} ${c}`), l.setAttribute("xmlns:dc", "http://purl.org/dc/elements/1.1/"), l.setAttribute("xmlns:cc", "http://creativecommons.org/ns#"), l.setAttribute("xmlns:rdf", "http://www.w3.org/1999/02/22-rdf-syntax-ns#"), l.setAttribute("xmlns:svg", "http://www.w3.org/2000/svg"), l.setAttribute("xmlns", "http://www.w3.org/2000/svg"), l.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink"), l.setAttribute("xmlns:sodipodi", "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"), l.setAttribute("xmlns:inkscape", "http://www.inkscape.org/namespaces/inkscape"), l.setAttribute("xml:space", "preserve"), l.setAttribute("version", "1.1"), u.appendChild(l);
    let e = 0;
    for (let i = 0; i < d.length; i++) {
      const f = Math.floor(i % c), h = Math.floor(i / c);
      if (d[i] && (e++, i > 0 && f > 0 && d[i - 1], !(f + 1 < c && d[i + 1]))) {
        const v = document.createElement("rect");
        v.setAttribute("y", String(h)), v.setAttribute("x", String(1 + f - e)), v.setAttribute("height", String(1.1)), v.setAttribute("width", String(0.1 + e)), l.appendChild(v), e = 0;
      }
    }
    let s = u.innerHTML.replace("viewbox", "viewBox");
    t(s);
  });
}
class U1 extends Qh {
  constructor(r) {
    super(r);
    _e(this, "recomputeMergeSvg");
    _e(this, "symbolSvgString");
    _e(this, "symbolColoredString");
    _e(this, "options");
    _e(this, "qrcodeResultDom");
    _e(this, "baseQrcodeString");
    _e(this, "canvas");
    _e(this, "canvgElement");
    _e(this, "hitform");
    _e(this, "type");
    this.recomputePosition = !1, this.recomputeImage = !1, this.recomputeMergeSvg = !1, this.type = "qrcode", this.options = {};
  }
  randomOptions() {
    if (this.vida.gallery === void 0)
      throw new jn("Please provide a gallery if you use internalsvg!");
    const r = this.vida.gallery.randomInternalSvg(), o = {
      type: this.type,
      url: "https://aktivisda.earth",
      color: "#000000",
      backgroundColor: "#ffffff",
      symbol: {}
    };
    return r !== void 0 && (o.symbol = {
      id: r.id,
      colors: r.colors
    }), o;
  }
  toJson() {
    const r = this.options.symbol && this.options.symbol.id ? { id: this.options.symbol.id, colors: this.options.symbol.colors } : {};
    return {
      type: this.type,
      url: this.options.url,
      color: this.options.color,
      backgroundColor: this.options.backgroundColor,
      symbol: r
    };
  }
  async imageToSvg() {
    return this.toSvg();
  }
  mergeSvg() {
    var h, v;
    if (!this.recomputeMergeSvg || this.baseQrcodeString === void 0)
      return;
    this.recomputeMergeSvg = !1, this.originalSize = { width: 300, height: 300 };
    const r = Math.min(this.originalSize.width, this.originalSize.height), o = vh(this.baseQrcodeString);
    if (o == null)
      throw new Error();
    if (o.documentElement == null)
      throw new Error();
    const d = (h = o.documentElement.getAttribute("viewBox")) == null ? void 0 : h.split(" ");
    if (d == null)
      throw new Error("Undefined viewbox");
    let u;
    if (this.symbolColoredString != null) {
      const p = vh(this.symbolColoredString), x = (v = p.documentElement.getAttribute("viewBox")) == null ? void 0 : v.split(" ").map((w) => parseFloat(w));
      if ((x == null ? void 0 : x.length) != 4)
        throw new jn("Viewbox is not a valid viewbox");
      console.assert(this.originalSize.width === this.originalSize.height);
      const S = 0.5 * r / Math.max(x[2], x[3]), y = (300 - x[2] * S) / 2, b = (300 - x[3] * S) / 2;
      u = document.createElement("g"), u.setAttribute("transform", `translate(${y}, ${b}) scale(${S})`);
      const n = document.createElement("path");
      n.setAttribute("d", this.options.symbol.backgroundHull), n.setAttribute("style", `fill:${this.options.backgroundColor}`), u.replaceChildren(n, ...p.documentElement.children);
    }
    const l = document.createElement("rect");
    l.setAttribute("style", `fill:${this.options.backgroundColor}`), l.setAttribute("width", String(this.originalSize.width)), l.setAttribute("height", String(this.originalSize.height)), l.setAttribute("x", "0"), l.setAttribute("y", "0");
    const e = document.createElement("g"), s = parseFloat(d[2]);
    e.setAttribute("transform", `scale(${r / s})`), e.setAttribute("style", `fill:${this.options.color}`), e.replaceChildren(...o.documentElement.children), this.qrcodeResultDom = document.createElement("div");
    const i = "http://www.w3.org/2000/svg", f = document.createElementNS(i, "svg");
    f.setAttribute("viewBox", `0 0 ${this.originalSize.width} ${this.originalSize.height}`), f.setAttribute("width", String(this.originalSize.width)), f.setAttribute("height", String(this.originalSize.height)), f.setAttribute("style", `background-color:${this.options.backgroundColor}`), f.setAttribute("xmlns:dc", "http://purl.org/dc/elements/1.1/"), f.setAttribute("xmlns:cc", "http://creativecommons.org/ns#"), f.setAttribute("xmlns:rdf", "http://www.w3.org/1999/02/22-rdf-syntax-ns#"), f.setAttribute("xmlns:svg", "http://www.w3.org/2000/svg"), f.setAttribute("xmlns", "http://www.w3.org/2000/svg"), f.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink"), f.setAttribute("xmlns:sodipodi", "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"), f.setAttribute("xmlns:inkscape", "http://www.inkscape.org/namespaces/inkscape"), f.setAttribute("xml:space", "preserve"), f.setAttribute("version", "1.1"), f.appendChild(l), f.appendChild(e), u && f.appendChild(u), this.qrcodeResultDom.appendChild(f);
  }
  update(r) {
    return new Promise((o) => {
      this.options.url || (this.options.url = void 0), this.options.color || (this.options.color = void 0), this.options.backgroundColor || (this.options.backgroundColor = void 0), this.options.symbol || (this.options.symbol = {});
      let c = !1;
      if (r && r.color && this.options.color !== r.color && (this.options.color = r.color, this.recomputeImage = !0, this.recomputeMergeSvg = !0), r && r.backgroundColor && this.options.backgroundColor !== r.backgroundColor && (this.options.backgroundColor = r.backgroundColor, this.recomputeImage = !0, this.recomputeMergeSvg = !0), r && r.url && r.url !== this.options.url && (this.options.url = r.url, c = !0), c) {
        A7(this.options.url).then((d) => {
          this.baseQrcodeString = d, this.update(r).then(() => {
            this.recomputeImage = !0, this.recomputeMergeSvg = !0, o();
          });
        });
        return;
      }
      if (r && r.symbol && Object.keys(r.symbol).length === 0 && (!this.options.symbol || Object.keys(this.options.symbol).length > 0) && (this.options.symbol = {}, this.recomputeMergeSvg = !0, this.symbolSvgString = void 0, this.symbolColoredString = void 0, this.recomputeImage = !0), r && r.symbol && r.symbol.id && r.symbol.id !== this.options.symbol.id) {
        if (this.options.symbol === void 0 && (this.options.symbol = {}), this.options.symbol.id = r.symbol.id, this.vida.gallery === void 0)
          throw new jn("Please provide a gallery if you use internalsvg!");
        const d = this.vida.gallery.elementById(r.symbol.id);
        this.options.symbol.backgroundHull = d.backgroundHull ? d.backgroundHull : d.hitform, this.options.symbol.colors = d.colors, this.vida.gallery.fileUrl(r.symbol.id).then((u) => {
          Pg(u, { prepareColors: !0 }).then((l) => {
            this.recomputeMergeSvg = !0, this.recomputeImage = !0, this.symbolSvgString = l, this.symbolColoredString = dh(this.symbolSvgString, d.colors).string, this.update({}).then(() => {
              o();
            });
          });
        });
        return;
      }
      r && r.symbol && r.symbol.colors && Tg(this.options.symbol.colors, r.symbol.colors) && (this.options.symbol.colors = r.symbol.colors, this.symbolColoredString = dh(this.symbolSvgString, r.symbol.colors).string, this.recomputeMergeSvg = !0, this.recomputeImage = !0), this.originalSize = { width: 300, height: 300 }, o();
    });
  }
  toSvg() {
    return this.mergeSvg(), this.qrcodeResultDom ? this.qrcodeResultDom.innerHTML : "<svg></svg>";
  }
  makeImage(r, o) {
    return new Promise((c, d) => {
      this.inResize && d(), this.inResize = !0, this.canvas || (this.canvas = window.document.createElement("canvas"));
      const u = this.canvas.getContext("2d");
      try {
        this.canvgElement = So.fromString(u, this.toSvg());
      } catch (l) {
        d(l);
        return;
      }
      this.canvgElement.resize(r, o, "xMidYMid meet"), this.canvgElement.render().then(() => {
        this.inResize = !1, c();
      }).catch((l) => d(l));
    });
  }
  image() {
    return console.assert(this.canvas), this.canvas;
  }
  makeHitformFunction(r) {
    return Og(this.hitform, r);
  }
}
class ju extends Qh {
  constructor(r, o) {
    super(r);
    _e(this, "photoUrl");
    _e(this, "_photo");
    _e(this, "mimeType");
    _e(this, "type");
    this.type = o, this.originalSize = { width: 0, height: 0 }, this.id = "", this.mimeType = "image/jpeg";
  }
  randomOptions() {
    if (this.vida.gallery === void 0)
      throw new jn("Please provide a gallery if you use internalsvg!");
    const r = this.vida.gallery.randomInternalPhoto();
    return {
      type: this.type,
      id: r.id
    };
  }
  toJson() {
    if (this.type === "internalphoto")
      return {
        type: this.type,
        id: this.id,
        width: this.originalSize.width,
        height: this.originalSize.height
      };
    if (this.type === "urlphoto")
      return {
        type: this.type,
        url: this.photoUrl,
        width: this.originalSize.width,
        height: this.originalSize.height
      };
    throw Error(`toJson not implemented for type ${this.type}`);
  }
  /**
   * Loads a base64 photoUrl locally in a HTMLImageElement.
   * Image can be accessed throug image() method
   *
   * @param photoUrl
   * @returns Promise<void>. Resolved once the image is loaded
   */
  loadPhoto(r) {
    return new Promise((o, c) => {
      this.photoUrl = r, this.recomputeImage = !0, this._photo !== void 0 && delete this._photo, this._photo = document.createElement("img"), this._photo.onload = () => {
        this.originalSize = { width: this._photo.width, height: this._photo.height }, o();
      }, this._photo.onerror = (u) => c(u), this.photoUrl.startsWith("blob:"), this._photo.src = this.photoUrl;
    });
  }
  update(r) {
    return new Promise((o) => {
      if (!r) {
        o();
        return;
      }
      if (r.id !== void 0 && this.id !== r.id) {
        if (this.vida.gallery === void 0)
          throw new jn("Please provide a gallery if you use internalphoto!");
        const c = this.vida.gallery.elementById(r.id);
        if (c === void 0 || c.type !== "internalphoto")
          throw new jn(`Image ${r.id} does not exist or is not an internalphoto.`);
        this.mimeType = c3(c.filename), this.id = r.id, this.originalSize = { width: 0, height: 0 };
        const d = this;
        this.vida.gallery.fileUrl(c.id).then((u) => {
          d.loadPhoto(u).then(() => o());
        });
        return;
      } else if (r.url !== void 0 && this.photoUrl !== r.url)
        this.mimeType = "image/jpeg", this.loadPhoto(r.url).then(() => o());
      else {
        o();
        return;
      }
    });
  }
  makeImage() {
    return new Promise((r) => {
      this.inResize = !1, r();
    });
  }
  image() {
    return this._photo;
  }
  async imageToSvg() {
    let r = "";
    if (this.type === "internalphoto") {
      if (this.vida.gallery === void 0)
        throw new jn("Please provide a gallery if you use internalphoto!");
      {
        const o = document.createElement("canvas");
        o.height = this._photo.height, o.width = this._photo.width, document.body.appendChild(o), o.getContext("2d").drawImage(this._photo, 0, 0), r = o.toDataURL(this.mimeType), document.body.removeChild(o), o.remove();
      }
    } else
      this.type === "urlphoto" && (r = this.photoUrl);
    return `<svg width="${this.originalSize.width}" height="${this.originalSize.height}" viewBox="0 0 ${this.originalSize.width} ${this.originalSize.height}">
        <image href="${r}"/></svg>`;
  }
  makeHitformFunction() {
  }
}
var oc = { exports: {} }, sf = {}, o2 = {}, Hr = {};
(function(a) {
  Object.defineProperty(a, "__esModule", { value: !0 }), a._registerNode = a.Konva = a.glob = void 0;
  const t = Math.PI / 180;
  function r() {
    return typeof window < "u" && ({}.toString.call(window) === "[object Window]" || {}.toString.call(window) === "[object global]");
  }
  a.glob = typeof ki < "u" ? ki : typeof window < "u" ? window : typeof WorkerGlobalScope < "u" ? self : {}, a.Konva = {
    _global: a.glob,
    version: "9.2.3",
    isBrowser: r(),
    isUnminified: /param/.test((function(c) {
    }).toString()),
    dblClickWindow: 400,
    getAngle(c) {
      return a.Konva.angleDeg ? c * t : c;
    },
    enableTrace: !1,
    pointerEventsEnabled: !0,
    autoDrawEnabled: !0,
    hitOnDragEnabled: !1,
    capturePointerEventsEnabled: !1,
    _mouseListenClick: !1,
    _touchListenClick: !1,
    _pointerListenClick: !1,
    _mouseInDblClickWindow: !1,
    _touchInDblClickWindow: !1,
    _pointerInDblClickWindow: !1,
    _mouseDblClickPointerId: null,
    _touchDblClickPointerId: null,
    _pointerDblClickPointerId: null,
    pixelRatio: typeof window < "u" && window.devicePixelRatio || 1,
    dragDistance: 3,
    angleDeg: !0,
    showWarnings: !0,
    dragButtons: [0, 1],
    isDragging() {
      return a.Konva.DD.isDragging;
    },
    isDragReady() {
      return !!a.Konva.DD.node;
    },
    releaseCanvasOnDestroy: !0,
    document: a.glob.document,
    _injectGlobal(c) {
      a.glob.Konva = c;
    }
  };
  const o = (c) => {
    a.Konva[c.prototype.getClassName()] = c;
  };
  a._registerNode = o, a.Konva._injectGlobal(a.Konva);
})(Hr);
var zn = {};
(function(a) {
  Object.defineProperty(a, "__esModule", { value: !0 }), a.Util = a.Transform = void 0;
  const t = Hr;
  class r {
    constructor(b = [1, 0, 0, 1, 0, 0]) {
      this.dirty = !1, this.m = b && b.slice() || [1, 0, 0, 1, 0, 0];
    }
    reset() {
      this.m[0] = 1, this.m[1] = 0, this.m[2] = 0, this.m[3] = 1, this.m[4] = 0, this.m[5] = 0;
    }
    copy() {
      return new r(this.m);
    }
    copyInto(b) {
      b.m[0] = this.m[0], b.m[1] = this.m[1], b.m[2] = this.m[2], b.m[3] = this.m[3], b.m[4] = this.m[4], b.m[5] = this.m[5];
    }
    point(b) {
      var n = this.m;
      return {
        x: n[0] * b.x + n[2] * b.y + n[4],
        y: n[1] * b.x + n[3] * b.y + n[5]
      };
    }
    translate(b, n) {
      return this.m[4] += this.m[0] * b + this.m[2] * n, this.m[5] += this.m[1] * b + this.m[3] * n, this;
    }
    scale(b, n) {
      return this.m[0] *= b, this.m[1] *= b, this.m[2] *= n, this.m[3] *= n, this;
    }
    rotate(b) {
      var n = Math.cos(b), w = Math.sin(b), E = this.m[0] * n + this.m[2] * w, A = this.m[1] * n + this.m[3] * w, O = this.m[0] * -w + this.m[2] * n, C = this.m[1] * -w + this.m[3] * n;
      return this.m[0] = E, this.m[1] = A, this.m[2] = O, this.m[3] = C, this;
    }
    getTranslation() {
      return {
        x: this.m[4],
        y: this.m[5]
      };
    }
    skew(b, n) {
      var w = this.m[0] + this.m[2] * n, E = this.m[1] + this.m[3] * n, A = this.m[2] + this.m[0] * b, O = this.m[3] + this.m[1] * b;
      return this.m[0] = w, this.m[1] = E, this.m[2] = A, this.m[3] = O, this;
    }
    multiply(b) {
      var n = this.m[0] * b.m[0] + this.m[2] * b.m[1], w = this.m[1] * b.m[0] + this.m[3] * b.m[1], E = this.m[0] * b.m[2] + this.m[2] * b.m[3], A = this.m[1] * b.m[2] + this.m[3] * b.m[3], O = this.m[0] * b.m[4] + this.m[2] * b.m[5] + this.m[4], C = this.m[1] * b.m[4] + this.m[3] * b.m[5] + this.m[5];
      return this.m[0] = n, this.m[1] = w, this.m[2] = E, this.m[3] = A, this.m[4] = O, this.m[5] = C, this;
    }
    invert() {
      var b = 1 / (this.m[0] * this.m[3] - this.m[1] * this.m[2]), n = this.m[3] * b, w = -this.m[1] * b, E = -this.m[2] * b, A = this.m[0] * b, O = b * (this.m[2] * this.m[5] - this.m[3] * this.m[4]), C = b * (this.m[1] * this.m[4] - this.m[0] * this.m[5]);
      return this.m[0] = n, this.m[1] = w, this.m[2] = E, this.m[3] = A, this.m[4] = O, this.m[5] = C, this;
    }
    getMatrix() {
      return this.m;
    }
    decompose() {
      var b = this.m[0], n = this.m[1], w = this.m[2], E = this.m[3], A = this.m[4], O = this.m[5], C = b * E - n * w;
      let T = {
        x: A,
        y: O,
        rotation: 0,
        scaleX: 0,
        scaleY: 0,
        skewX: 0,
        skewY: 0
      };
      if (b != 0 || n != 0) {
        var P = Math.sqrt(b * b + n * n);
        T.rotation = n > 0 ? Math.acos(b / P) : -Math.acos(b / P), T.scaleX = P, T.scaleY = C / P, T.skewX = (b * w + n * E) / C, T.skewY = 0;
      } else if (w != 0 || E != 0) {
        var I = Math.sqrt(w * w + E * E);
        T.rotation = Math.PI / 2 - (E > 0 ? Math.acos(-w / I) : -Math.acos(w / I)), T.scaleX = C / I, T.scaleY = I, T.skewX = 0, T.skewY = (b * w + n * E) / C;
      }
      return T.rotation = a.Util._getRotation(T.rotation), T;
    }
  }
  a.Transform = r;
  var o = "[object Array]", c = "[object Number]", d = "[object String]", u = "[object Boolean]", l = Math.PI / 180, e = 180 / Math.PI, s = "#", i = "", f = "0", h = "Konva warning: ", v = "Konva error: ", p = "rgb(", m = {
    aliceblue: [240, 248, 255],
    antiquewhite: [250, 235, 215],
    aqua: [0, 255, 255],
    aquamarine: [127, 255, 212],
    azure: [240, 255, 255],
    beige: [245, 245, 220],
    bisque: [255, 228, 196],
    black: [0, 0, 0],
    blanchedalmond: [255, 235, 205],
    blue: [0, 0, 255],
    blueviolet: [138, 43, 226],
    brown: [165, 42, 42],
    burlywood: [222, 184, 135],
    cadetblue: [95, 158, 160],
    chartreuse: [127, 255, 0],
    chocolate: [210, 105, 30],
    coral: [255, 127, 80],
    cornflowerblue: [100, 149, 237],
    cornsilk: [255, 248, 220],
    crimson: [220, 20, 60],
    cyan: [0, 255, 255],
    darkblue: [0, 0, 139],
    darkcyan: [0, 139, 139],
    darkgoldenrod: [184, 132, 11],
    darkgray: [169, 169, 169],
    darkgreen: [0, 100, 0],
    darkgrey: [169, 169, 169],
    darkkhaki: [189, 183, 107],
    darkmagenta: [139, 0, 139],
    darkolivegreen: [85, 107, 47],
    darkorange: [255, 140, 0],
    darkorchid: [153, 50, 204],
    darkred: [139, 0, 0],
    darksalmon: [233, 150, 122],
    darkseagreen: [143, 188, 143],
    darkslateblue: [72, 61, 139],
    darkslategray: [47, 79, 79],
    darkslategrey: [47, 79, 79],
    darkturquoise: [0, 206, 209],
    darkviolet: [148, 0, 211],
    deeppink: [255, 20, 147],
    deepskyblue: [0, 191, 255],
    dimgray: [105, 105, 105],
    dimgrey: [105, 105, 105],
    dodgerblue: [30, 144, 255],
    firebrick: [178, 34, 34],
    floralwhite: [255, 255, 240],
    forestgreen: [34, 139, 34],
    fuchsia: [255, 0, 255],
    gainsboro: [220, 220, 220],
    ghostwhite: [248, 248, 255],
    gold: [255, 215, 0],
    goldenrod: [218, 165, 32],
    gray: [128, 128, 128],
    green: [0, 128, 0],
    greenyellow: [173, 255, 47],
    grey: [128, 128, 128],
    honeydew: [240, 255, 240],
    hotpink: [255, 105, 180],
    indianred: [205, 92, 92],
    indigo: [75, 0, 130],
    ivory: [255, 255, 240],
    khaki: [240, 230, 140],
    lavender: [230, 230, 250],
    lavenderblush: [255, 240, 245],
    lawngreen: [124, 252, 0],
    lemonchiffon: [255, 250, 205],
    lightblue: [173, 216, 230],
    lightcoral: [240, 128, 128],
    lightcyan: [224, 255, 255],
    lightgoldenrodyellow: [250, 250, 210],
    lightgray: [211, 211, 211],
    lightgreen: [144, 238, 144],
    lightgrey: [211, 211, 211],
    lightpink: [255, 182, 193],
    lightsalmon: [255, 160, 122],
    lightseagreen: [32, 178, 170],
    lightskyblue: [135, 206, 250],
    lightslategray: [119, 136, 153],
    lightslategrey: [119, 136, 153],
    lightsteelblue: [176, 196, 222],
    lightyellow: [255, 255, 224],
    lime: [0, 255, 0],
    limegreen: [50, 205, 50],
    linen: [250, 240, 230],
    magenta: [255, 0, 255],
    maroon: [128, 0, 0],
    mediumaquamarine: [102, 205, 170],
    mediumblue: [0, 0, 205],
    mediumorchid: [186, 85, 211],
    mediumpurple: [147, 112, 219],
    mediumseagreen: [60, 179, 113],
    mediumslateblue: [123, 104, 238],
    mediumspringgreen: [0, 250, 154],
    mediumturquoise: [72, 209, 204],
    mediumvioletred: [199, 21, 133],
    midnightblue: [25, 25, 112],
    mintcream: [245, 255, 250],
    mistyrose: [255, 228, 225],
    moccasin: [255, 228, 181],
    navajowhite: [255, 222, 173],
    navy: [0, 0, 128],
    oldlace: [253, 245, 230],
    olive: [128, 128, 0],
    olivedrab: [107, 142, 35],
    orange: [255, 165, 0],
    orangered: [255, 69, 0],
    orchid: [218, 112, 214],
    palegoldenrod: [238, 232, 170],
    palegreen: [152, 251, 152],
    paleturquoise: [175, 238, 238],
    palevioletred: [219, 112, 147],
    papayawhip: [255, 239, 213],
    peachpuff: [255, 218, 185],
    peru: [205, 133, 63],
    pink: [255, 192, 203],
    plum: [221, 160, 203],
    powderblue: [176, 224, 230],
    purple: [128, 0, 128],
    rebeccapurple: [102, 51, 153],
    red: [255, 0, 0],
    rosybrown: [188, 143, 143],
    royalblue: [65, 105, 225],
    saddlebrown: [139, 69, 19],
    salmon: [250, 128, 114],
    sandybrown: [244, 164, 96],
    seagreen: [46, 139, 87],
    seashell: [255, 245, 238],
    sienna: [160, 82, 45],
    silver: [192, 192, 192],
    skyblue: [135, 206, 235],
    slateblue: [106, 90, 205],
    slategray: [119, 128, 144],
    slategrey: [119, 128, 144],
    snow: [255, 255, 250],
    springgreen: [0, 255, 127],
    steelblue: [70, 130, 180],
    tan: [210, 180, 140],
    teal: [0, 128, 128],
    thistle: [216, 191, 216],
    transparent: [255, 255, 255, 0],
    tomato: [255, 99, 71],
    turquoise: [64, 224, 208],
    violet: [238, 130, 238],
    wheat: [245, 222, 179],
    white: [255, 255, 255],
    whitesmoke: [245, 245, 245],
    yellow: [255, 255, 0],
    yellowgreen: [154, 205, 5]
  }, x = /rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/, g = [];
  const S = typeof requestAnimationFrame < "u" && requestAnimationFrame || function(y) {
    setTimeout(y, 60);
  };
  a.Util = {
    _isElement(y) {
      return !!(y && y.nodeType == 1);
    },
    _isFunction(y) {
      return !!(y && y.constructor && y.call && y.apply);
    },
    _isPlainObject(y) {
      return !!y && y.constructor === Object;
    },
    _isArray(y) {
      return Object.prototype.toString.call(y) === o;
    },
    _isNumber(y) {
      return Object.prototype.toString.call(y) === c && !isNaN(y) && isFinite(y);
    },
    _isString(y) {
      return Object.prototype.toString.call(y) === d;
    },
    _isBoolean(y) {
      return Object.prototype.toString.call(y) === u;
    },
    isObject(y) {
      return y instanceof Object;
    },
    isValidSelector(y) {
      if (typeof y != "string")
        return !1;
      var b = y[0];
      return b === "#" || b === "." || b === b.toUpperCase();
    },
    _sign(y) {
      return y === 0 || y > 0 ? 1 : -1;
    },
    requestAnimFrame(y) {
      g.push(y), g.length === 1 && S(function() {
        const b = g;
        g = [], b.forEach(function(n) {
          n();
        });
      });
    },
    createCanvasElement() {
      var y = document.createElement("canvas");
      try {
        y.style = y.style || {};
      } catch {
      }
      return y;
    },
    createImageElement() {
      return document.createElement("img");
    },
    _isInDocument(y) {
      for (; y = y.parentNode; )
        if (y == document)
          return !0;
      return !1;
    },
    _urlToImage(y, b) {
      var n = a.Util.createImageElement();
      n.onload = function() {
        b(n);
      }, n.src = y;
    },
    _rgbToHex(y, b, n) {
      return ((1 << 24) + (y << 16) + (b << 8) + n).toString(16).slice(1);
    },
    _hexToRgb(y) {
      y = y.replace(s, i);
      var b = parseInt(y, 16);
      return {
        r: b >> 16 & 255,
        g: b >> 8 & 255,
        b: b & 255
      };
    },
    getRandomColor() {
      for (var y = (Math.random() * 16777215 << 0).toString(16); y.length < 6; )
        y = f + y;
      return s + y;
    },
    getRGB(y) {
      var b;
      return y in m ? (b = m[y], {
        r: b[0],
        g: b[1],
        b: b[2]
      }) : y[0] === s ? this._hexToRgb(y.substring(1)) : y.substr(0, 4) === p ? (b = x.exec(y.replace(/ /g, "")), {
        r: parseInt(b[1], 10),
        g: parseInt(b[2], 10),
        b: parseInt(b[3], 10)
      }) : {
        r: 0,
        g: 0,
        b: 0
      };
    },
    colorToRGBA(y) {
      return y = y || "black", a.Util._namedColorToRBA(y) || a.Util._hex3ColorToRGBA(y) || a.Util._hex4ColorToRGBA(y) || a.Util._hex6ColorToRGBA(y) || a.Util._hex8ColorToRGBA(y) || a.Util._rgbColorToRGBA(y) || a.Util._rgbaColorToRGBA(y) || a.Util._hslColorToRGBA(y);
    },
    _namedColorToRBA(y) {
      var b = m[y.toLowerCase()];
      return b ? {
        r: b[0],
        g: b[1],
        b: b[2],
        a: 1
      } : null;
    },
    _rgbColorToRGBA(y) {
      if (y.indexOf("rgb(") === 0) {
        y = y.match(/rgb\(([^)]+)\)/)[1];
        var b = y.split(/ *, */).map(Number);
        return {
          r: b[0],
          g: b[1],
          b: b[2],
          a: 1
        };
      }
    },
    _rgbaColorToRGBA(y) {
      if (y.indexOf("rgba(") === 0) {
        y = y.match(/rgba\(([^)]+)\)/)[1];
        var b = y.split(/ *, */).map((n, w) => n.slice(-1) === "%" ? w === 3 ? parseInt(n) / 100 : parseInt(n) / 100 * 255 : Number(n));
        return {
          r: b[0],
          g: b[1],
          b: b[2],
          a: b[3]
        };
      }
    },
    _hex8ColorToRGBA(y) {
      if (y[0] === "#" && y.length === 9)
        return {
          r: parseInt(y.slice(1, 3), 16),
          g: parseInt(y.slice(3, 5), 16),
          b: parseInt(y.slice(5, 7), 16),
          a: parseInt(y.slice(7, 9), 16) / 255
        };
    },
    _hex6ColorToRGBA(y) {
      if (y[0] === "#" && y.length === 7)
        return {
          r: parseInt(y.slice(1, 3), 16),
          g: parseInt(y.slice(3, 5), 16),
          b: parseInt(y.slice(5, 7), 16),
          a: 1
        };
    },
    _hex4ColorToRGBA(y) {
      if (y[0] === "#" && y.length === 5)
        return {
          r: parseInt(y[1] + y[1], 16),
          g: parseInt(y[2] + y[2], 16),
          b: parseInt(y[3] + y[3], 16),
          a: parseInt(y[4] + y[4], 16) / 255
        };
    },
    _hex3ColorToRGBA(y) {
      if (y[0] === "#" && y.length === 4)
        return {
          r: parseInt(y[1] + y[1], 16),
          g: parseInt(y[2] + y[2], 16),
          b: parseInt(y[3] + y[3], 16),
          a: 1
        };
    },
    _hslColorToRGBA(y) {
      if (/hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.test(y)) {
        const [b, ...n] = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(y), w = Number(n[0]) / 360, E = Number(n[1]) / 100, A = Number(n[2]) / 100;
        let O, C, T;
        if (E === 0)
          return T = A * 255, {
            r: Math.round(T),
            g: Math.round(T),
            b: Math.round(T),
            a: 1
          };
        A < 0.5 ? O = A * (1 + E) : O = A + E - A * E;
        const P = 2 * A - O, I = [0, 0, 0];
        for (let F = 0; F < 3; F++)
          C = w + 1 / 3 * -(F - 1), C < 0 && C++, C > 1 && C--, 6 * C < 1 ? T = P + (O - P) * 6 * C : 2 * C < 1 ? T = O : 3 * C < 2 ? T = P + (O - P) * (2 / 3 - C) * 6 : T = P, I[F] = T * 255;
        return {
          r: Math.round(I[0]),
          g: Math.round(I[1]),
          b: Math.round(I[2]),
          a: 1
        };
      }
    },
    haveIntersection(y, b) {
      return !(b.x > y.x + y.width || b.x + b.width < y.x || b.y > y.y + y.height || b.y + b.height < y.y);
    },
    cloneObject(y) {
      var b = {};
      for (var n in y)
        this._isPlainObject(y[n]) ? b[n] = this.cloneObject(y[n]) : this._isArray(y[n]) ? b[n] = this.cloneArray(y[n]) : b[n] = y[n];
      return b;
    },
    cloneArray(y) {
      return y.slice(0);
    },
    degToRad(y) {
      return y * l;
    },
    radToDeg(y) {
      return y * e;
    },
    _degToRad(y) {
      return a.Util.warn("Util._degToRad is removed. Please use public Util.degToRad instead."), a.Util.degToRad(y);
    },
    _radToDeg(y) {
      return a.Util.warn("Util._radToDeg is removed. Please use public Util.radToDeg instead."), a.Util.radToDeg(y);
    },
    _getRotation(y) {
      return t.Konva.angleDeg ? a.Util.radToDeg(y) : y;
    },
    _capitalize(y) {
      return y.charAt(0).toUpperCase() + y.slice(1);
    },
    throw(y) {
      throw new Error(v + y);
    },
    error(y) {
      console.error(v + y);
    },
    warn(y) {
      t.Konva.showWarnings && console.warn(h + y);
    },
    each(y, b) {
      for (var n in y)
        b(n, y[n]);
    },
    _inRange(y, b, n) {
      return b <= y && y < n;
    },
    _getProjectionToSegment(y, b, n, w, E, A) {
      var O, C, T, P = (y - n) * (y - n) + (b - w) * (b - w);
      if (P == 0)
        O = y, C = b, T = (E - n) * (E - n) + (A - w) * (A - w);
      else {
        var I = ((E - y) * (n - y) + (A - b) * (w - b)) / P;
        I < 0 ? (O = y, C = b, T = (y - E) * (y - E) + (b - A) * (b - A)) : I > 1 ? (O = n, C = w, T = (n - E) * (n - E) + (w - A) * (w - A)) : (O = y + I * (n - y), C = b + I * (w - b), T = (O - E) * (O - E) + (C - A) * (C - A));
      }
      return [O, C, T];
    },
    _getProjectionToLine(y, b, n) {
      var w = a.Util.cloneObject(y), E = Number.MAX_VALUE;
      return b.forEach(function(A, O) {
        if (!(!n && O === b.length - 1)) {
          var C = b[(O + 1) % b.length], T = a.Util._getProjectionToSegment(A.x, A.y, C.x, C.y, y.x, y.y), P = T[0], I = T[1], F = T[2];
          F < E && (w.x = P, w.y = I, E = F);
        }
      }), w;
    },
    _prepareArrayForTween(y, b, n) {
      var w, E = [], A = [];
      if (y.length > b.length) {
        var O = b;
        b = y, y = O;
      }
      for (w = 0; w < y.length; w += 2)
        E.push({
          x: y[w],
          y: y[w + 1]
        });
      for (w = 0; w < b.length; w += 2)
        A.push({
          x: b[w],
          y: b[w + 1]
        });
      var C = [];
      return A.forEach(function(T) {
        var P = a.Util._getProjectionToLine(T, E, n);
        C.push(P.x), C.push(P.y);
      }), C;
    },
    _prepareToStringify(y) {
      var b;
      y.visitedByCircularReferenceRemoval = !0;
      for (var n in y)
        if (y.hasOwnProperty(n) && y[n] && typeof y[n] == "object") {
          if (b = Object.getOwnPropertyDescriptor(y, n), y[n].visitedByCircularReferenceRemoval || a.Util._isElement(y[n]))
            if (b.configurable)
              delete y[n];
            else
              return null;
          else if (a.Util._prepareToStringify(y[n]) === null)
            if (b.configurable)
              delete y[n];
            else
              return null;
        }
      return delete y.visitedByCircularReferenceRemoval, y;
    },
    _assign(y, b) {
      for (var n in b)
        y[n] = b[n];
      return y;
    },
    _getFirstPointerId(y) {
      return y.touches ? y.changedTouches[0].identifier : y.pointerId || 999;
    },
    releaseCanvas(...y) {
      t.Konva.releaseCanvasOnDestroy && y.forEach((b) => {
        b.width = 0, b.height = 0;
      });
    },
    drawRoundedRectPath(y, b, n, w) {
      let E = 0, A = 0, O = 0, C = 0;
      typeof w == "number" ? E = A = O = C = Math.min(w, b / 2, n / 2) : (E = Math.min(w[0] || 0, b / 2, n / 2), A = Math.min(w[1] || 0, b / 2, n / 2), C = Math.min(w[2] || 0, b / 2, n / 2), O = Math.min(w[3] || 0, b / 2, n / 2)), y.moveTo(E, 0), y.lineTo(b - A, 0), y.arc(b - A, A, A, Math.PI * 3 / 2, 0, !1), y.lineTo(b, n - C), y.arc(b - C, n - C, C, 0, Math.PI / 2, !1), y.lineTo(O, n), y.arc(O, n - O, O, Math.PI / 2, Math.PI, !1), y.lineTo(0, E), y.arc(E, E, E, Math.PI, Math.PI * 3 / 2, !1);
    }
  };
})(zn);
var Bn = {}, zr = {}, lr = {};
Object.defineProperty(lr, "__esModule", { value: !0 });
lr.getComponentValidator = lr.getBooleanValidator = lr.getNumberArrayValidator = lr.getFunctionValidator = lr.getStringOrGradientValidator = lr.getStringValidator = lr.getNumberOrAutoValidator = lr.getNumberOrArrayOfNumbersValidator = lr.getNumberValidator = lr.alphaComponent = lr.RGBComponent = void 0;
const Da = Hr, Vn = zn;
function Ma(a) {
  return Vn.Util._isString(a) ? '"' + a + '"' : Object.prototype.toString.call(a) === "[object Number]" || Vn.Util._isBoolean(a) ? a : Object.prototype.toString.call(a);
}
function C7(a) {
  return a > 255 ? 255 : a < 0 ? 0 : Math.round(a);
}
lr.RGBComponent = C7;
function T7(a) {
  return a > 1 ? 1 : a < 1e-4 ? 1e-4 : a;
}
lr.alphaComponent = T7;
function P7() {
  if (Da.Konva.isUnminified)
    return function(a, t) {
      return Vn.Util._isNumber(a) || Vn.Util.warn(Ma(a) + ' is a not valid value for "' + t + '" attribute. The value should be a number.'), a;
    };
}
lr.getNumberValidator = P7;
function O7(a) {
  if (Da.Konva.isUnminified)
    return function(t, r) {
      let o = Vn.Util._isNumber(t), c = Vn.Util._isArray(t) && t.length == a;
      return !o && !c && Vn.Util.warn(Ma(t) + ' is a not valid value for "' + r + '" attribute. The value should be a number or Array<number>(' + a + ")"), t;
    };
}
lr.getNumberOrArrayOfNumbersValidator = O7;
function F7() {
  if (Da.Konva.isUnminified)
    return function(a, t) {
      var r = Vn.Util._isNumber(a), o = a === "auto";
      return r || o || Vn.Util.warn(Ma(a) + ' is a not valid value for "' + t + '" attribute. The value should be a number or "auto".'), a;
    };
}
lr.getNumberOrAutoValidator = F7;
function I7() {
  if (Da.Konva.isUnminified)
    return function(a, t) {
      return Vn.Util._isString(a) || Vn.Util.warn(Ma(a) + ' is a not valid value for "' + t + '" attribute. The value should be a string.'), a;
    };
}
lr.getStringValidator = I7;
function R7() {
  if (Da.Konva.isUnminified)
    return function(a, t) {
      const r = Vn.Util._isString(a), o = Object.prototype.toString.call(a) === "[object CanvasGradient]" || a && a.addColorStop;
      return r || o || Vn.Util.warn(Ma(a) + ' is a not valid value for "' + t + '" attribute. The value should be a string or a native gradient.'), a;
    };
}
lr.getStringOrGradientValidator = R7;
function D7() {
  if (Da.Konva.isUnminified)
    return function(a, t) {
      return Vn.Util._isFunction(a) || Vn.Util.warn(Ma(a) + ' is a not valid value for "' + t + '" attribute. The value should be a function.'), a;
    };
}
lr.getFunctionValidator = D7;
function M7() {
  if (Da.Konva.isUnminified)
    return function(a, t) {
      const r = Int8Array ? Object.getPrototypeOf(Int8Array) : null;
      return r && a instanceof r || (Vn.Util._isArray(a) ? a.forEach(function(o) {
        Vn.Util._isNumber(o) || Vn.Util.warn('"' + t + '" attribute has non numeric element ' + o + ". Make sure that all elements are numbers.");
      }) : Vn.Util.warn(Ma(a) + ' is a not valid value for "' + t + '" attribute. The value should be a array of numbers.')), a;
    };
}
lr.getNumberArrayValidator = M7;
function B7() {
  if (Da.Konva.isUnminified)
    return function(a, t) {
      var r = a === !0 || a === !1;
      return r || Vn.Util.warn(Ma(a) + ' is a not valid value for "' + t + '" attribute. The value should be a boolean.'), a;
    };
}
lr.getBooleanValidator = B7;
function k7(a) {
  if (Da.Konva.isUnminified)
    return function(t, r) {
      return t == null || Vn.Util.isObject(t) || Vn.Util.warn(Ma(t) + ' is a not valid value for "' + r + '" attribute. The value should be an object with properties ' + a), t;
    };
}
lr.getComponentValidator = k7;
(function(a) {
  Object.defineProperty(a, "__esModule", { value: !0 }), a.Factory = void 0;
  const t = zn, r = lr;
  var o = "get", c = "set";
  a.Factory = {
    addGetterSetter(d, u, l, e, s) {
      a.Factory.addGetter(d, u, l), a.Factory.addSetter(d, u, e, s), a.Factory.addOverloadedGetterSetter(d, u);
    },
    addGetter(d, u, l) {
      var e = o + t.Util._capitalize(u);
      d.prototype[e] = d.prototype[e] || function() {
        var s = this.attrs[u];
        return s === void 0 ? l : s;
      };
    },
    addSetter(d, u, l, e) {
      var s = c + t.Util._capitalize(u);
      d.prototype[s] || a.Factory.overWriteSetter(d, u, l, e);
    },
    overWriteSetter(d, u, l, e) {
      var s = c + t.Util._capitalize(u);
      d.prototype[s] = function(i) {
        return l && i !== void 0 && i !== null && (i = l.call(this, i, u)), this._setAttr(u, i), e && e.call(this), this;
      };
    },
    addComponentsGetterSetter(d, u, l, e, s) {
      var i = l.length, f = t.Util._capitalize, h = o + f(u), v = c + f(u), p, m;
      d.prototype[h] = function() {
        var g = {};
        for (p = 0; p < i; p++)
          m = l[p], g[m] = this.getAttr(u + f(m));
        return g;
      };
      var x = (0, r.getComponentValidator)(l);
      d.prototype[v] = function(g) {
        var S = this.attrs[u], y;
        e && (g = e.call(this, g)), x && x.call(this, g, u);
        for (y in g)
          g.hasOwnProperty(y) && this._setAttr(u + f(y), g[y]);
        return g || l.forEach((b) => {
          this._setAttr(u + f(b), void 0);
        }), this._fireChangeEvent(u, S, g), s && s.call(this), this;
      }, a.Factory.addOverloadedGetterSetter(d, u);
    },
    addOverloadedGetterSetter(d, u) {
      var l = t.Util._capitalize(u), e = c + l, s = o + l;
      d.prototype[u] = function() {
        return arguments.length ? (this[e](arguments[0]), this) : this[s]();
      };
    },
    addDeprecatedGetterSetter(d, u, l, e) {
      t.Util.error("Adding deprecated " + u);
      var s = o + t.Util._capitalize(u), i = u + " property is deprecated and will be removed soon. Look at Konva change log for more information.";
      d.prototype[s] = function() {
        t.Util.error(i);
        var f = this.attrs[u];
        return f === void 0 ? l : f;
      }, a.Factory.addSetter(d, u, e, function() {
        t.Util.error(i);
      }), a.Factory.addOverloadedGetterSetter(d, u);
    },
    backCompat(d, u) {
      t.Util.each(u, function(l, e) {
        var s = d.prototype[e], i = o + t.Util._capitalize(l), f = c + t.Util._capitalize(l);
        function h() {
          s.apply(this, arguments), t.Util.error('"' + l + '" method is deprecated and will be removed soon. Use ""' + e + '" instead.');
        }
        d.prototype[l] = h, d.prototype[i] = h, d.prototype[f] = h;
      });
    },
    afterSetFilter() {
      this._filterUpToDate = !1;
    }
  };
})(zr);
var ea = {}, Ia = {};
Object.defineProperty(Ia, "__esModule", { value: !0 });
Ia.HitContext = Ia.SceneContext = Ia.Context = void 0;
const s2 = zn, N7 = Hr;
function L7(a) {
  var t = [], r = a.length, o = s2.Util, c, d;
  for (c = 0; c < r; c++)
    d = a[c], o._isNumber(d) ? d = Math.round(d * 1e3) / 1e3 : o._isString(d) || (d = d + ""), t.push(d);
  return t;
}
var z1 = ",", U7 = "(", z7 = ")", G7 = "([", V7 = "])", H7 = ";", W7 = "()", _7 = "=", G1 = [
  "arc",
  "arcTo",
  "beginPath",
  "bezierCurveTo",
  "clearRect",
  "clip",
  "closePath",
  "createLinearGradient",
  "createPattern",
  "createRadialGradient",
  "drawImage",
  "ellipse",
  "fill",
  "fillText",
  "getImageData",
  "createImageData",
  "lineTo",
  "moveTo",
  "putImageData",
  "quadraticCurveTo",
  "rect",
  "restore",
  "rotate",
  "save",
  "scale",
  "setLineDash",
  "setTransform",
  "stroke",
  "strokeText",
  "transform",
  "translate"
], j7 = [
  "fillStyle",
  "strokeStyle",
  "shadowColor",
  "shadowBlur",
  "shadowOffsetX",
  "shadowOffsetY",
  "letterSpacing",
  "lineCap",
  "lineDashOffset",
  "lineJoin",
  "lineWidth",
  "miterLimit",
  "direction",
  "font",
  "textAlign",
  "textBaseline",
  "globalAlpha",
  "globalCompositeOperation",
  "imageSmoothingEnabled"
];
const X7 = 100;
class lf {
  constructor(t) {
    this.canvas = t, N7.Konva.enableTrace && (this.traceArr = [], this._enableTrace());
  }
  fillShape(t) {
    t.fillEnabled() && this._fill(t);
  }
  _fill(t) {
  }
  strokeShape(t) {
    t.hasStroke() && this._stroke(t);
  }
  _stroke(t) {
  }
  fillStrokeShape(t) {
    t.attrs.fillAfterStrokeEnabled ? (this.strokeShape(t), this.fillShape(t)) : (this.fillShape(t), this.strokeShape(t));
  }
  getTrace(t, r) {
    var o = this.traceArr, c = o.length, d = "", u, l, e, s;
    for (u = 0; u < c; u++)
      l = o[u], e = l.method, e ? (s = l.args, d += e, t ? d += W7 : s2.Util._isArray(s[0]) ? d += G7 + s.join(z1) + V7 : (r && (s = s.map((i) => typeof i == "number" ? Math.floor(i) : i)), d += U7 + s.join(z1) + z7)) : (d += l.property, t || (d += _7 + l.val)), d += H7;
    return d;
  }
  clearTrace() {
    this.traceArr = [];
  }
  _trace(t) {
    var r = this.traceArr, o;
    r.push(t), o = r.length, o >= X7 && r.shift();
  }
  reset() {
    var t = this.getCanvas().getPixelRatio();
    this.setTransform(1 * t, 0, 0, 1 * t, 0, 0);
  }
  getCanvas() {
    return this.canvas;
  }
  clear(t) {
    var r = this.getCanvas();
    t ? this.clearRect(t.x || 0, t.y || 0, t.width || 0, t.height || 0) : this.clearRect(0, 0, r.getWidth() / r.pixelRatio, r.getHeight() / r.pixelRatio);
  }
  _applyLineCap(t) {
    const r = t.attrs.lineCap;
    r && this.setAttr("lineCap", r);
  }
  _applyOpacity(t) {
    var r = t.getAbsoluteOpacity();
    r !== 1 && this.setAttr("globalAlpha", r);
  }
  _applyLineJoin(t) {
    const r = t.attrs.lineJoin;
    r && this.setAttr("lineJoin", r);
  }
  setAttr(t, r) {
    this._context[t] = r;
  }
  arc(t, r, o, c, d, u) {
    this._context.arc(t, r, o, c, d, u);
  }
  arcTo(t, r, o, c, d) {
    this._context.arcTo(t, r, o, c, d);
  }
  beginPath() {
    this._context.beginPath();
  }
  bezierCurveTo(t, r, o, c, d, u) {
    this._context.bezierCurveTo(t, r, o, c, d, u);
  }
  clearRect(t, r, o, c) {
    this._context.clearRect(t, r, o, c);
  }
  clip(...t) {
    this._context.clip.apply(this._context, t);
  }
  closePath() {
    this._context.closePath();
  }
  createImageData(t, r) {
    var o = arguments;
    if (o.length === 2)
      return this._context.createImageData(t, r);
    if (o.length === 1)
      return this._context.createImageData(t);
  }
  createLinearGradient(t, r, o, c) {
    return this._context.createLinearGradient(t, r, o, c);
  }
  createPattern(t, r) {
    return this._context.createPattern(t, r);
  }
  createRadialGradient(t, r, o, c, d, u) {
    return this._context.createRadialGradient(t, r, o, c, d, u);
  }
  drawImage(t, r, o, c, d, u, l, e, s) {
    var i = arguments, f = this._context;
    i.length === 3 ? f.drawImage(t, r, o) : i.length === 5 ? f.drawImage(t, r, o, c, d) : i.length === 9 && f.drawImage(t, r, o, c, d, u, l, e, s);
  }
  ellipse(t, r, o, c, d, u, l, e) {
    this._context.ellipse(t, r, o, c, d, u, l, e);
  }
  isPointInPath(t, r, o, c) {
    return o ? this._context.isPointInPath(o, t, r, c) : this._context.isPointInPath(t, r, c);
  }
  fill(...t) {
    this._context.fill.apply(this._context, t);
  }
  fillRect(t, r, o, c) {
    this._context.fillRect(t, r, o, c);
  }
  strokeRect(t, r, o, c) {
    this._context.strokeRect(t, r, o, c);
  }
  fillText(t, r, o, c) {
    c ? this._context.fillText(t, r, o, c) : this._context.fillText(t, r, o);
  }
  measureText(t) {
    return this._context.measureText(t);
  }
  getImageData(t, r, o, c) {
    return this._context.getImageData(t, r, o, c);
  }
  lineTo(t, r) {
    this._context.lineTo(t, r);
  }
  moveTo(t, r) {
    this._context.moveTo(t, r);
  }
  rect(t, r, o, c) {
    this._context.rect(t, r, o, c);
  }
  putImageData(t, r, o) {
    this._context.putImageData(t, r, o);
  }
  quadraticCurveTo(t, r, o, c) {
    this._context.quadraticCurveTo(t, r, o, c);
  }
  restore() {
    this._context.restore();
  }
  rotate(t) {
    this._context.rotate(t);
  }
  save() {
    this._context.save();
  }
  scale(t, r) {
    this._context.scale(t, r);
  }
  setLineDash(t) {
    this._context.setLineDash ? this._context.setLineDash(t) : "mozDash" in this._context ? this._context.mozDash = t : "webkitLineDash" in this._context && (this._context.webkitLineDash = t);
  }
  getLineDash() {
    return this._context.getLineDash();
  }
  setTransform(t, r, o, c, d, u) {
    this._context.setTransform(t, r, o, c, d, u);
  }
  stroke(t) {
    t ? this._context.stroke(t) : this._context.stroke();
  }
  strokeText(t, r, o, c) {
    this._context.strokeText(t, r, o, c);
  }
  transform(t, r, o, c, d, u) {
    this._context.transform(t, r, o, c, d, u);
  }
  translate(t, r) {
    this._context.translate(t, r);
  }
  _enableTrace() {
    var t = this, r = G1.length, o = this.setAttr, c, d, u = function(l) {
      var e = t[l], s;
      t[l] = function() {
        return d = L7(Array.prototype.slice.call(arguments, 0)), s = e.apply(t, arguments), t._trace({
          method: l,
          args: d
        }), s;
      };
    };
    for (c = 0; c < r; c++)
      u(G1[c]);
    t.setAttr = function() {
      o.apply(t, arguments);
      var l = arguments[0], e = arguments[1];
      (l === "shadowOffsetX" || l === "shadowOffsetY" || l === "shadowBlur") && (e = e / this.canvas.getPixelRatio()), t._trace({
        property: l,
        val: e
      });
    };
  }
  _applyGlobalCompositeOperation(t) {
    const r = t.attrs.globalCompositeOperation;
    var o = !r || r === "source-over";
    o || this.setAttr("globalCompositeOperation", r);
  }
}
Ia.Context = lf;
j7.forEach(function(a) {
  Object.defineProperty(lf.prototype, a, {
    get() {
      return this._context[a];
    },
    set(t) {
      this._context[a] = t;
    }
  });
});
class Y7 extends lf {
  constructor(t, { willReadFrequently: r = !1 } = {}) {
    super(t), this._context = t._canvas.getContext("2d", {
      willReadFrequently: r
    });
  }
  _fillColor(t) {
    var r = t.fill();
    this.setAttr("fillStyle", r), t._fillFunc(this);
  }
  _fillPattern(t) {
    this.setAttr("fillStyle", t._getFillPattern()), t._fillFunc(this);
  }
  _fillLinearGradient(t) {
    var r = t._getLinearGradient();
    r && (this.setAttr("fillStyle", r), t._fillFunc(this));
  }
  _fillRadialGradient(t) {
    const r = t._getRadialGradient();
    r && (this.setAttr("fillStyle", r), t._fillFunc(this));
  }
  _fill(t) {
    const r = t.fill(), o = t.getFillPriority();
    if (r && o === "color") {
      this._fillColor(t);
      return;
    }
    const c = t.getFillPatternImage();
    if (c && o === "pattern") {
      this._fillPattern(t);
      return;
    }
    const d = t.getFillLinearGradientColorStops();
    if (d && o === "linear-gradient") {
      this._fillLinearGradient(t);
      return;
    }
    const u = t.getFillRadialGradientColorStops();
    if (u && o === "radial-gradient") {
      this._fillRadialGradient(t);
      return;
    }
    r ? this._fillColor(t) : c ? this._fillPattern(t) : d ? this._fillLinearGradient(t) : u && this._fillRadialGradient(t);
  }
  _strokeLinearGradient(t) {
    const r = t.getStrokeLinearGradientStartPoint(), o = t.getStrokeLinearGradientEndPoint(), c = t.getStrokeLinearGradientColorStops(), d = this.createLinearGradient(r.x, r.y, o.x, o.y);
    if (c) {
      for (var u = 0; u < c.length; u += 2)
        d.addColorStop(c[u], c[u + 1]);
      this.setAttr("strokeStyle", d);
    }
  }
  _stroke(t) {
    var r = t.dash(), o = t.getStrokeScaleEnabled();
    if (t.hasStroke()) {
      if (!o) {
        this.save();
        var c = this.getCanvas().getPixelRatio();
        this.setTransform(c, 0, 0, c, 0, 0);
      }
      this._applyLineCap(t), r && t.dashEnabled() && (this.setLineDash(r), this.setAttr("lineDashOffset", t.dashOffset())), this.setAttr("lineWidth", t.strokeWidth()), t.getShadowForStrokeEnabled() || this.setAttr("shadowColor", "rgba(0,0,0,0)");
      var d = t.getStrokeLinearGradientColorStops();
      d ? this._strokeLinearGradient(t) : this.setAttr("strokeStyle", t.stroke()), t._strokeFunc(this), o || this.restore();
    }
  }
  _applyShadow(t) {
    var r, o, c, d = (r = t.getShadowRGBA()) !== null && r !== void 0 ? r : "black", u = (o = t.getShadowBlur()) !== null && o !== void 0 ? o : 5, l = (c = t.getShadowOffset()) !== null && c !== void 0 ? c : {
      x: 0,
      y: 0
    }, e = t.getAbsoluteScale(), s = this.canvas.getPixelRatio(), i = e.x * s, f = e.y * s;
    this.setAttr("shadowColor", d), this.setAttr("shadowBlur", u * Math.min(Math.abs(i), Math.abs(f))), this.setAttr("shadowOffsetX", l.x * i), this.setAttr("shadowOffsetY", l.y * f);
  }
}
Ia.SceneContext = Y7;
class Z7 extends lf {
  constructor(t) {
    super(t), this._context = t._canvas.getContext("2d", {
      willReadFrequently: !0
    });
  }
  _fill(t) {
    this.save(), this.setAttr("fillStyle", t.colorKey), t._fillFuncHit(this), this.restore();
  }
  strokeShape(t) {
    t.hasHitStroke() && this._stroke(t);
  }
  _stroke(t) {
    if (t.hasHitStroke()) {
      const d = t.getStrokeScaleEnabled();
      if (!d) {
        this.save();
        var r = this.getCanvas().getPixelRatio();
        this.setTransform(r, 0, 0, r, 0, 0);
      }
      this._applyLineCap(t);
      var o = t.hitStrokeWidth(), c = o === "auto" ? t.strokeWidth() : o;
      this.setAttr("lineWidth", c), this.setAttr("strokeStyle", t.colorKey), t._strokeFuncHit(this), d || this.restore();
    }
  }
}
Ia.HitContext = Z7;
Object.defineProperty(ea, "__esModule", { value: !0 });
ea.HitCanvas = ea.SceneCanvas = ea.Canvas = void 0;
const Ul = zn, l2 = Ia, f2 = Hr, K7 = zr, J7 = lr;
var bl;
function Q7() {
  if (bl)
    return bl;
  var a = Ul.Util.createCanvasElement(), t = a.getContext("2d");
  return bl = function() {
    var r = f2.Konva._global.devicePixelRatio || 1, o = t.webkitBackingStorePixelRatio || t.mozBackingStorePixelRatio || t.msBackingStorePixelRatio || t.oBackingStorePixelRatio || t.backingStorePixelRatio || 1;
    return r / o;
  }(), Ul.Util.releaseCanvas(a), bl;
}
class ff {
  constructor(t) {
    this.pixelRatio = 1, this.width = 0, this.height = 0, this.isCache = !1;
    var r = t || {}, o = r.pixelRatio || f2.Konva.pixelRatio || Q7();
    this.pixelRatio = o, this._canvas = Ul.Util.createCanvasElement(), this._canvas.style.padding = "0", this._canvas.style.margin = "0", this._canvas.style.border = "0", this._canvas.style.background = "transparent", this._canvas.style.position = "absolute", this._canvas.style.top = "0", this._canvas.style.left = "0";
  }
  getContext() {
    return this.context;
  }
  getPixelRatio() {
    return this.pixelRatio;
  }
  setPixelRatio(t) {
    var r = this.pixelRatio;
    this.pixelRatio = t, this.setSize(this.getWidth() / r, this.getHeight() / r);
  }
  setWidth(t) {
    this.width = this._canvas.width = t * this.pixelRatio, this._canvas.style.width = t + "px";
    var r = this.pixelRatio, o = this.getContext()._context;
    o.scale(r, r);
  }
  setHeight(t) {
    this.height = this._canvas.height = t * this.pixelRatio, this._canvas.style.height = t + "px";
    var r = this.pixelRatio, o = this.getContext()._context;
    o.scale(r, r);
  }
  getWidth() {
    return this.width;
  }
  getHeight() {
    return this.height;
  }
  setSize(t, r) {
    this.setWidth(t || 0), this.setHeight(r || 0);
  }
  toDataURL(t, r) {
    try {
      return this._canvas.toDataURL(t, r);
    } catch {
      try {
        return this._canvas.toDataURL();
      } catch (c) {
        return Ul.Util.error("Unable to get data URL. " + c.message + " For more info read https://konvajs.org/docs/posts/Tainted_Canvas.html."), "";
      }
    }
  }
}
ea.Canvas = ff;
K7.Factory.addGetterSetter(ff, "pixelRatio", void 0, (0, J7.getNumberValidator)());
class $7 extends ff {
  constructor(t = { width: 0, height: 0, willReadFrequently: !1 }) {
    super(t), this.context = new l2.SceneContext(this, {
      willReadFrequently: t.willReadFrequently
    }), this.setSize(t.width, t.height);
  }
}
ea.SceneCanvas = $7;
class q7 extends ff {
  constructor(t = { width: 0, height: 0 }) {
    super(t), this.hitCanvas = !0, this.context = new l2.HitContext(this), this.setSize(t.width, t.height);
  }
}
ea.HitCanvas = q7;
var uf = {};
(function(a) {
  Object.defineProperty(a, "__esModule", { value: !0 }), a.DD = void 0;
  const t = Hr, r = zn;
  a.DD = {
    get isDragging() {
      var o = !1;
      return a.DD._dragElements.forEach((c) => {
        c.dragStatus === "dragging" && (o = !0);
      }), o;
    },
    justDragged: !1,
    get node() {
      var o;
      return a.DD._dragElements.forEach((c) => {
        o = c.node;
      }), o;
    },
    _dragElements: /* @__PURE__ */ new Map(),
    _drag(o) {
      const c = [];
      a.DD._dragElements.forEach((d, u) => {
        const { node: l } = d, e = l.getStage();
        e.setPointersPositions(o), d.pointerId === void 0 && (d.pointerId = r.Util._getFirstPointerId(o));
        const s = e._changedPointerPositions.find((h) => h.id === d.pointerId);
        if (s) {
          if (d.dragStatus !== "dragging") {
            var i = l.dragDistance(), f = Math.max(Math.abs(s.x - d.startPointerPos.x), Math.abs(s.y - d.startPointerPos.y));
            if (f < i || (l.startDrag({ evt: o }), !l.isDragging()))
              return;
          }
          l._setDragPosition(o, d), c.push(l);
        }
      }), c.forEach((d) => {
        d.fire("dragmove", {
          type: "dragmove",
          target: d,
          evt: o
        }, !0);
      });
    },
    _endDragBefore(o) {
      const c = [];
      a.DD._dragElements.forEach((d) => {
        const { node: u } = d, l = u.getStage();
        if (o && l.setPointersPositions(o), !l._changedPointerPositions.find((i) => i.id === d.pointerId))
          return;
        (d.dragStatus === "dragging" || d.dragStatus === "stopped") && (a.DD.justDragged = !0, t.Konva._mouseListenClick = !1, t.Konva._touchListenClick = !1, t.Konva._pointerListenClick = !1, d.dragStatus = "stopped");
        const s = d.node.getLayer() || d.node instanceof t.Konva.Stage && d.node;
        s && c.indexOf(s) === -1 && c.push(s);
      }), c.forEach((d) => {
        d.draw();
      });
    },
    _endDragAfter(o) {
      a.DD._dragElements.forEach((c, d) => {
        c.dragStatus === "stopped" && c.node.fire("dragend", {
          type: "dragend",
          target: c.node,
          evt: o
        }, !0), c.dragStatus !== "dragging" && a.DD._dragElements.delete(d);
      });
    }
  }, t.Konva.isBrowser && (window.addEventListener("mouseup", a.DD._endDragBefore, !0), window.addEventListener("touchend", a.DD._endDragBefore, !0), window.addEventListener("mousemove", a.DD._drag), window.addEventListener("touchmove", a.DD._drag), window.addEventListener("mouseup", a.DD._endDragAfter, !1), window.addEventListener("touchend", a.DD._endDragAfter, !1));
})(uf);
Object.defineProperty(Bn, "__esModule", { value: !0 });
Bn.Node = void 0;
const Xr = zn, F0 = zr, wl = ea, yo = Hr, Wi = uf, Xn = lr;
var Fl = "absoluteOpacity", Sl = "allEventListeners", Ta = "absoluteTransform", V1 = "absoluteScale", mo = "canvas", tw = "Change", ew = "children", rw = "konva", Sh = "listening", H1 = "mouseenter", W1 = "mouseleave", _1 = "set", j1 = "Shape", Il = " ", X1 = "stage", ja = "transform", nw = "Stage", Eh = "visible", iw = [
  "xChange.konva",
  "yChange.konva",
  "scaleXChange.konva",
  "scaleYChange.konva",
  "skewXChange.konva",
  "skewYChange.konva",
  "rotationChange.konva",
  "offsetXChange.konva",
  "offsetYChange.konva",
  "transformsEnabledChange.konva"
].join(Il);
let aw = 1;
class Tr {
  constructor(t) {
    this._id = aw++, this.eventListeners = {}, this.attrs = {}, this.index = 0, this._allEventListeners = null, this.parent = null, this._cache = /* @__PURE__ */ new Map(), this._attachedDepsListeners = /* @__PURE__ */ new Map(), this._lastPos = null, this._batchingTransformChange = !1, this._needClearTransformCache = !1, this._filterUpToDate = !1, this._isUnderCache = !1, this._dragEventId = null, this._shouldFireChangeEvents = !1, this.setAttrs(t), this._shouldFireChangeEvents = !0;
  }
  hasChildren() {
    return !1;
  }
  _clearCache(t) {
    (t === ja || t === Ta) && this._cache.get(t) ? this._cache.get(t).dirty = !0 : t ? this._cache.delete(t) : this._cache.clear();
  }
  _getCache(t, r) {
    var o = this._cache.get(t), c = t === ja || t === Ta, d = o === void 0 || c && o.dirty === !0;
    return d && (o = r.call(this), this._cache.set(t, o)), o;
  }
  _calculate(t, r, o) {
    if (!this._attachedDepsListeners.get(t)) {
      const c = r.map((d) => d + "Change.konva").join(Il);
      this.on(c, () => {
        this._clearCache(t);
      }), this._attachedDepsListeners.set(t, !0);
    }
    return this._getCache(t, o);
  }
  _getCanvasCache() {
    return this._cache.get(mo);
  }
  _clearSelfAndDescendantCache(t) {
    this._clearCache(t), t === Ta && this.fire("absoluteTransformChange");
  }
  clearCache() {
    if (this._cache.has(mo)) {
      const { scene: t, filter: r, hit: o } = this._cache.get(mo);
      Xr.Util.releaseCanvas(t, r, o), this._cache.delete(mo);
    }
    return this._clearSelfAndDescendantCache(), this._requestDraw(), this;
  }
  cache(t) {
    var r = t || {}, o = {};
    (r.x === void 0 || r.y === void 0 || r.width === void 0 || r.height === void 0) && (o = this.getClientRect({
      skipTransform: !0,
      relativeTo: this.getParent() || void 0
    }));
    var c = Math.ceil(r.width || o.width), d = Math.ceil(r.height || o.height), u = r.pixelRatio, l = r.x === void 0 ? Math.floor(o.x) : r.x, e = r.y === void 0 ? Math.floor(o.y) : r.y, s = r.offset || 0, i = r.drawBorder || !1, f = r.hitCanvasPixelRatio || 1;
    if (!c || !d) {
      Xr.Util.error("Can not cache the node. Width or height of the node equals 0. Caching is skipped.");
      return;
    }
    c += s * 2 + 1, d += s * 2 + 1, l -= s, e -= s;
    var h = new wl.SceneCanvas({
      pixelRatio: u,
      width: c,
      height: d
    }), v = new wl.SceneCanvas({
      pixelRatio: u,
      width: 0,
      height: 0,
      willReadFrequently: !0
    }), p = new wl.HitCanvas({
      pixelRatio: f,
      width: c,
      height: d
    }), m = h.getContext(), x = p.getContext();
    return p.isCache = !0, h.isCache = !0, this._cache.delete(mo), this._filterUpToDate = !1, r.imageSmoothingEnabled === !1 && (h.getContext()._context.imageSmoothingEnabled = !1, v.getContext()._context.imageSmoothingEnabled = !1), m.save(), x.save(), m.translate(-l, -e), x.translate(-l, -e), this._isUnderCache = !0, this._clearSelfAndDescendantCache(Fl), this._clearSelfAndDescendantCache(V1), this.drawScene(h, this), this.drawHit(p, this), this._isUnderCache = !1, m.restore(), x.restore(), i && (m.save(), m.beginPath(), m.rect(0, 0, c, d), m.closePath(), m.setAttr("strokeStyle", "red"), m.setAttr("lineWidth", 5), m.stroke(), m.restore()), this._cache.set(mo, {
      scene: h,
      filter: v,
      hit: p,
      x: l,
      y: e
    }), this._requestDraw(), this;
  }
  isCached() {
    return this._cache.has(mo);
  }
  getClientRect(t) {
    throw new Error('abstract "getClientRect" method call');
  }
  _transformedRect(t, r) {
    var o = [
      { x: t.x, y: t.y },
      { x: t.x + t.width, y: t.y },
      { x: t.x + t.width, y: t.y + t.height },
      { x: t.x, y: t.y + t.height }
    ], c = 1 / 0, d = 1 / 0, u = -1 / 0, l = -1 / 0, e = this.getAbsoluteTransform(r);
    return o.forEach(function(s) {
      var i = e.point(s);
      c === void 0 && (c = u = i.x, d = l = i.y), c = Math.min(c, i.x), d = Math.min(d, i.y), u = Math.max(u, i.x), l = Math.max(l, i.y);
    }), {
      x: c,
      y: d,
      width: u - c,
      height: l - d
    };
  }
  _drawCachedSceneCanvas(t) {
    t.save(), t._applyOpacity(this), t._applyGlobalCompositeOperation(this);
    const r = this._getCanvasCache();
    t.translate(r.x, r.y);
    var o = this._getCachedSceneCanvas(), c = o.pixelRatio;
    t.drawImage(o._canvas, 0, 0, o.width / c, o.height / c), t.restore();
  }
  _drawCachedHitCanvas(t) {
    var r = this._getCanvasCache(), o = r.hit;
    t.save(), t.translate(r.x, r.y), t.drawImage(o._canvas, 0, 0, o.width / o.pixelRatio, o.height / o.pixelRatio), t.restore();
  }
  _getCachedSceneCanvas() {
    var t = this.filters(), r = this._getCanvasCache(), o = r.scene, c = r.filter, d = c.getContext(), u, l, e, s;
    if (t) {
      if (!this._filterUpToDate) {
        var i = o.pixelRatio;
        c.setSize(o.width / o.pixelRatio, o.height / o.pixelRatio);
        try {
          for (u = t.length, d.clear(), d.drawImage(o._canvas, 0, 0, o.getWidth() / i, o.getHeight() / i), l = d.getImageData(0, 0, c.getWidth(), c.getHeight()), e = 0; e < u; e++) {
            if (s = t[e], typeof s != "function") {
              Xr.Util.error("Filter should be type of function, but got " + typeof s + " instead. Please check correct filters");
              continue;
            }
            s.call(this, l), d.putImageData(l, 0, 0);
          }
        } catch (f) {
          Xr.Util.error("Unable to apply filter. " + f.message + " This post my help you https://konvajs.org/docs/posts/Tainted_Canvas.html.");
        }
        this._filterUpToDate = !0;
      }
      return c;
    }
    return o;
  }
  on(t, r) {
    if (this._cache && this._cache.delete(Sl), arguments.length === 3)
      return this._delegate.apply(this, arguments);
    var o = t.split(Il), c = o.length, d, u, l, e, s;
    for (d = 0; d < c; d++)
      u = o[d], l = u.split("."), e = l[0], s = l[1] || "", this.eventListeners[e] || (this.eventListeners[e] = []), this.eventListeners[e].push({
        name: s,
        handler: r
      });
    return this;
  }
  off(t, r) {
    var o = (t || "").split(Il), c = o.length, d, u, l, e, s, i;
    if (this._cache && this._cache.delete(Sl), !t)
      for (u in this.eventListeners)
        this._off(u);
    for (d = 0; d < c; d++)
      if (l = o[d], e = l.split("."), s = e[0], i = e[1], s)
        this.eventListeners[s] && this._off(s, i, r);
      else
        for (u in this.eventListeners)
          this._off(u, i, r);
    return this;
  }
  dispatchEvent(t) {
    var r = {
      target: this,
      type: t.type,
      evt: t
    };
    return this.fire(t.type, r), this;
  }
  addEventListener(t, r) {
    return this.on(t, function(o) {
      r.call(this, o.evt);
    }), this;
  }
  removeEventListener(t) {
    return this.off(t), this;
  }
  _delegate(t, r, o) {
    var c = this;
    this.on(t, function(d) {
      for (var u = d.target.findAncestors(r, !0, c), l = 0; l < u.length; l++)
        d = Xr.Util.cloneObject(d), d.currentTarget = u[l], o.call(u[l], d);
    });
  }
  remove() {
    return this.isDragging() && this.stopDrag(), Wi.DD._dragElements.delete(this._id), this._remove(), this;
  }
  _clearCaches() {
    this._clearSelfAndDescendantCache(Ta), this._clearSelfAndDescendantCache(Fl), this._clearSelfAndDescendantCache(V1), this._clearSelfAndDescendantCache(X1), this._clearSelfAndDescendantCache(Eh), this._clearSelfAndDescendantCache(Sh);
  }
  _remove() {
    this._clearCaches();
    var t = this.getParent();
    t && t.children && (t.children.splice(this.index, 1), t._setChildrenIndices(), this.parent = null);
  }
  destroy() {
    return this.remove(), this.clearCache(), this;
  }
  getAttr(t) {
    var r = "get" + Xr.Util._capitalize(t);
    return Xr.Util._isFunction(this[r]) ? this[r]() : this.attrs[t];
  }
  getAncestors() {
    for (var t = this.getParent(), r = []; t; )
      r.push(t), t = t.getParent();
    return r;
  }
  getAttrs() {
    return this.attrs || {};
  }
  setAttrs(t) {
    return this._batchTransformChanges(() => {
      var r, o;
      if (!t)
        return this;
      for (r in t)
        r !== ew && (o = _1 + Xr.Util._capitalize(r), Xr.Util._isFunction(this[o]) ? this[o](t[r]) : this._setAttr(r, t[r]));
    }), this;
  }
  isListening() {
    return this._getCache(Sh, this._isListening);
  }
  _isListening(t) {
    if (!this.listening())
      return !1;
    const o = this.getParent();
    return o && o !== t && this !== t ? o._isListening(t) : !0;
  }
  isVisible() {
    return this._getCache(Eh, this._isVisible);
  }
  _isVisible(t) {
    if (!this.visible())
      return !1;
    const o = this.getParent();
    return o && o !== t && this !== t ? o._isVisible(t) : !0;
  }
  shouldDrawHit(t, r = !1) {
    if (t)
      return this._isVisible(t) && this._isListening(t);
    var o = this.getLayer(), c = !1;
    Wi.DD._dragElements.forEach((u) => {
      u.dragStatus === "dragging" && (u.node.nodeType === "Stage" || u.node.getLayer() === o) && (c = !0);
    });
    var d = !r && !yo.Konva.hitOnDragEnabled && c;
    return this.isListening() && this.isVisible() && !d;
  }
  show() {
    return this.visible(!0), this;
  }
  hide() {
    return this.visible(!1), this;
  }
  getZIndex() {
    return this.index || 0;
  }
  getAbsoluteZIndex() {
    var t = this.getDepth(), r = this, o = 0, c, d, u, l;
    function e(i) {
      for (c = [], d = i.length, u = 0; u < d; u++)
        l = i[u], o++, l.nodeType !== j1 && (c = c.concat(l.getChildren().slice())), l._id === r._id && (u = d);
      c.length > 0 && c[0].getDepth() <= t && e(c);
    }
    const s = this.getStage();
    return r.nodeType !== nw && s && e(s.getChildren()), o;
  }
  getDepth() {
    for (var t = 0, r = this.parent; r; )
      t++, r = r.parent;
    return t;
  }
  _batchTransformChanges(t) {
    this._batchingTransformChange = !0, t(), this._batchingTransformChange = !1, this._needClearTransformCache && (this._clearCache(ja), this._clearSelfAndDescendantCache(Ta)), this._needClearTransformCache = !1;
  }
  setPosition(t) {
    return this._batchTransformChanges(() => {
      this.x(t.x), this.y(t.y);
    }), this;
  }
  getPosition() {
    return {
      x: this.x(),
      y: this.y()
    };
  }
  getRelativePointerPosition() {
    const t = this.getStage();
    if (!t)
      return null;
    var r = t.getPointerPosition();
    if (!r)
      return null;
    var o = this.getAbsoluteTransform().copy();
    return o.invert(), o.point(r);
  }
  getAbsolutePosition(t) {
    let r = !1, o = this.parent;
    for (; o; ) {
      if (o.isCached()) {
        r = !0;
        break;
      }
      o = o.parent;
    }
    r && !t && (t = !0);
    var c = this.getAbsoluteTransform(t).getMatrix(), d = new Xr.Transform(), u = this.offset();
    return d.m = c.slice(), d.translate(u.x, u.y), d.getTranslation();
  }
  setAbsolutePosition(t) {
    const { x: r, y: o, ...c } = this._clearTransform();
    this.attrs.x = r, this.attrs.y = o, this._clearCache(ja);
    var d = this._getAbsoluteTransform().copy();
    return d.invert(), d.translate(t.x, t.y), t = {
      x: this.attrs.x + d.getTranslation().x,
      y: this.attrs.y + d.getTranslation().y
    }, this._setTransform(c), this.setPosition({ x: t.x, y: t.y }), this._clearCache(ja), this._clearSelfAndDescendantCache(Ta), this;
  }
  _setTransform(t) {
    var r;
    for (r in t)
      this.attrs[r] = t[r];
  }
  _clearTransform() {
    var t = {
      x: this.x(),
      y: this.y(),
      rotation: this.rotation(),
      scaleX: this.scaleX(),
      scaleY: this.scaleY(),
      offsetX: this.offsetX(),
      offsetY: this.offsetY(),
      skewX: this.skewX(),
      skewY: this.skewY()
    };
    return this.attrs.x = 0, this.attrs.y = 0, this.attrs.rotation = 0, this.attrs.scaleX = 1, this.attrs.scaleY = 1, this.attrs.offsetX = 0, this.attrs.offsetY = 0, this.attrs.skewX = 0, this.attrs.skewY = 0, t;
  }
  move(t) {
    var r = t.x, o = t.y, c = this.x(), d = this.y();
    return r !== void 0 && (c += r), o !== void 0 && (d += o), this.setPosition({ x: c, y: d }), this;
  }
  _eachAncestorReverse(t, r) {
    var o = [], c = this.getParent(), d, u;
    if (!(r && r._id === this._id)) {
      for (o.unshift(this); c && (!r || c._id !== r._id); )
        o.unshift(c), c = c.parent;
      for (d = o.length, u = 0; u < d; u++)
        t(o[u]);
    }
  }
  rotate(t) {
    return this.rotation(this.rotation() + t), this;
  }
  moveToTop() {
    if (!this.parent)
      return Xr.Util.warn("Node has no parent. moveToTop function is ignored."), !1;
    var t = this.index, r = this.parent.getChildren().length;
    return t < r - 1 ? (this.parent.children.splice(t, 1), this.parent.children.push(this), this.parent._setChildrenIndices(), !0) : !1;
  }
  moveUp() {
    if (!this.parent)
      return Xr.Util.warn("Node has no parent. moveUp function is ignored."), !1;
    var t = this.index, r = this.parent.getChildren().length;
    return t < r - 1 ? (this.parent.children.splice(t, 1), this.parent.children.splice(t + 1, 0, this), this.parent._setChildrenIndices(), !0) : !1;
  }
  moveDown() {
    if (!this.parent)
      return Xr.Util.warn("Node has no parent. moveDown function is ignored."), !1;
    var t = this.index;
    return t > 0 ? (this.parent.children.splice(t, 1), this.parent.children.splice(t - 1, 0, this), this.parent._setChildrenIndices(), !0) : !1;
  }
  moveToBottom() {
    if (!this.parent)
      return Xr.Util.warn("Node has no parent. moveToBottom function is ignored."), !1;
    var t = this.index;
    return t > 0 ? (this.parent.children.splice(t, 1), this.parent.children.unshift(this), this.parent._setChildrenIndices(), !0) : !1;
  }
  setZIndex(t) {
    if (!this.parent)
      return Xr.Util.warn("Node has no parent. zIndex parameter is ignored."), this;
    (t < 0 || t >= this.parent.children.length) && Xr.Util.warn("Unexpected value " + t + " for zIndex property. zIndex is just index of a node in children of its parent. Expected value is from 0 to " + (this.parent.children.length - 1) + ".");
    var r = this.index;
    return this.parent.children.splice(r, 1), this.parent.children.splice(t, 0, this), this.parent._setChildrenIndices(), this;
  }
  getAbsoluteOpacity() {
    return this._getCache(Fl, this._getAbsoluteOpacity);
  }
  _getAbsoluteOpacity() {
    var t = this.opacity(), r = this.getParent();
    return r && !r._isUnderCache && (t *= r.getAbsoluteOpacity()), t;
  }
  moveTo(t) {
    return this.getParent() !== t && (this._remove(), t.add(this)), this;
  }
  toObject() {
    var t = {}, r = this.getAttrs(), o, c, d, u, l;
    t.attrs = {};
    for (o in r)
      c = r[o], l = Xr.Util.isObject(c) && !Xr.Util._isPlainObject(c) && !Xr.Util._isArray(c), !l && (d = typeof this[o] == "function" && this[o], delete r[o], u = d ? d.call(this) : null, r[o] = c, u !== c && (t.attrs[o] = c));
    return t.className = this.getClassName(), Xr.Util._prepareToStringify(t);
  }
  toJSON() {
    return JSON.stringify(this.toObject());
  }
  getParent() {
    return this.parent;
  }
  findAncestors(t, r, o) {
    var c = [];
    r && this._isMatch(t) && c.push(this);
    for (var d = this.parent; d; ) {
      if (d === o)
        return c;
      d._isMatch(t) && c.push(d), d = d.parent;
    }
    return c;
  }
  isAncestorOf(t) {
    return !1;
  }
  findAncestor(t, r, o) {
    return this.findAncestors(t, r, o)[0];
  }
  _isMatch(t) {
    if (!t)
      return !1;
    if (typeof t == "function")
      return t(this);
    var r = t.replace(/ /g, "").split(","), o = r.length, c, d;
    for (c = 0; c < o; c++)
      if (d = r[c], Xr.Util.isValidSelector(d) || (Xr.Util.warn('Selector "' + d + '" is invalid. Allowed selectors examples are "#foo", ".bar" or "Group".'), Xr.Util.warn('If you have a custom shape with such className, please change it to start with upper letter like "Triangle".'), Xr.Util.warn("Konva is awesome, right?")), d.charAt(0) === "#") {
        if (this.id() === d.slice(1))
          return !0;
      } else if (d.charAt(0) === ".") {
        if (this.hasName(d.slice(1)))
          return !0;
      } else if (this.className === d || this.nodeType === d)
        return !0;
    return !1;
  }
  getLayer() {
    var t = this.getParent();
    return t ? t.getLayer() : null;
  }
  getStage() {
    return this._getCache(X1, this._getStage);
  }
  _getStage() {
    var t = this.getParent();
    return t ? t.getStage() : null;
  }
  fire(t, r = {}, o) {
    return r.target = r.target || this, o ? this._fireAndBubble(t, r) : this._fire(t, r), this;
  }
  getAbsoluteTransform(t) {
    return t ? this._getAbsoluteTransform(t) : this._getCache(Ta, this._getAbsoluteTransform);
  }
  _getAbsoluteTransform(t) {
    var r;
    if (t)
      return r = new Xr.Transform(), this._eachAncestorReverse(function(c) {
        var d = c.transformsEnabled();
        d === "all" ? r.multiply(c.getTransform()) : d === "position" && r.translate(c.x() - c.offsetX(), c.y() - c.offsetY());
      }, t), r;
    r = this._cache.get(Ta) || new Xr.Transform(), this.parent ? this.parent.getAbsoluteTransform().copyInto(r) : r.reset();
    var o = this.transformsEnabled();
    if (o === "all")
      r.multiply(this.getTransform());
    else if (o === "position") {
      const c = this.attrs.x || 0, d = this.attrs.y || 0, u = this.attrs.offsetX || 0, l = this.attrs.offsetY || 0;
      r.translate(c - u, d - l);
    }
    return r.dirty = !1, r;
  }
  getAbsoluteScale(t) {
    for (var r = this; r; )
      r._isUnderCache && (t = r), r = r.getParent();
    const c = this.getAbsoluteTransform(t).decompose();
    return {
      x: c.scaleX,
      y: c.scaleY
    };
  }
  getAbsoluteRotation() {
    return this.getAbsoluteTransform().decompose().rotation;
  }
  getTransform() {
    return this._getCache(ja, this._getTransform);
  }
  _getTransform() {
    var t, r, o = this._cache.get(ja) || new Xr.Transform();
    o.reset();
    var c = this.x(), d = this.y(), u = yo.Konva.getAngle(this.rotation()), l = (t = this.attrs.scaleX) !== null && t !== void 0 ? t : 1, e = (r = this.attrs.scaleY) !== null && r !== void 0 ? r : 1, s = this.attrs.skewX || 0, i = this.attrs.skewY || 0, f = this.attrs.offsetX || 0, h = this.attrs.offsetY || 0;
    return (c !== 0 || d !== 0) && o.translate(c, d), u !== 0 && o.rotate(u), (s !== 0 || i !== 0) && o.skew(s, i), (l !== 1 || e !== 1) && o.scale(l, e), (f !== 0 || h !== 0) && o.translate(-1 * f, -1 * h), o.dirty = !1, o;
  }
  clone(t) {
    var r = Xr.Util.cloneObject(this.attrs), o, c, d, u, l;
    for (o in t)
      r[o] = t[o];
    var e = new this.constructor(r);
    for (o in this.eventListeners)
      for (c = this.eventListeners[o], d = c.length, u = 0; u < d; u++)
        l = c[u], l.name.indexOf(rw) < 0 && (e.eventListeners[o] || (e.eventListeners[o] = []), e.eventListeners[o].push(l));
    return e;
  }
  _toKonvaCanvas(t) {
    t = t || {};
    var r = this.getClientRect(), o = this.getStage(), c = t.x !== void 0 ? t.x : Math.floor(r.x), d = t.y !== void 0 ? t.y : Math.floor(r.y), u = t.pixelRatio || 1, l = new wl.SceneCanvas({
      width: t.width || Math.ceil(r.width) || (o ? o.width() : 0),
      height: t.height || Math.ceil(r.height) || (o ? o.height() : 0),
      pixelRatio: u
    }), e = l.getContext();
    return t.imageSmoothingEnabled === !1 && (e._context.imageSmoothingEnabled = !1), e.save(), (c || d) && e.translate(-1 * c, -1 * d), this.drawScene(l), e.restore(), l;
  }
  toCanvas(t) {
    return this._toKonvaCanvas(t)._canvas;
  }
  toDataURL(t) {
    t = t || {};
    var r = t.mimeType || null, o = t.quality || null, c = this._toKonvaCanvas(t).toDataURL(r, o);
    return t.callback && t.callback(c), c;
  }
  toImage(t) {
    return new Promise((r, o) => {
      try {
        const c = t == null ? void 0 : t.callback;
        c && delete t.callback, Xr.Util._urlToImage(this.toDataURL(t), function(d) {
          r(d), c == null || c(d);
        });
      } catch (c) {
        o(c);
      }
    });
  }
  toBlob(t) {
    return new Promise((r, o) => {
      try {
        const c = t == null ? void 0 : t.callback;
        c && delete t.callback, this.toCanvas(t).toBlob((d) => {
          r(d), c == null || c(d);
        });
      } catch (c) {
        o(c);
      }
    });
  }
  setSize(t) {
    return this.width(t.width), this.height(t.height), this;
  }
  getSize() {
    return {
      width: this.width(),
      height: this.height()
    };
  }
  getClassName() {
    return this.className || this.nodeType;
  }
  getType() {
    return this.nodeType;
  }
  getDragDistance() {
    return this.attrs.dragDistance !== void 0 ? this.attrs.dragDistance : this.parent ? this.parent.getDragDistance() : yo.Konva.dragDistance;
  }
  _off(t, r, o) {
    var c = this.eventListeners[t], d, u, l;
    for (d = 0; d < c.length; d++)
      if (u = c[d].name, l = c[d].handler, (u !== "konva" || r === "konva") && (!r || u === r) && (!o || o === l)) {
        if (c.splice(d, 1), c.length === 0) {
          delete this.eventListeners[t];
          break;
        }
        d--;
      }
  }
  _fireChangeEvent(t, r, o) {
    this._fire(t + tw, {
      oldVal: r,
      newVal: o
    });
  }
  addName(t) {
    if (!this.hasName(t)) {
      var r = this.name(), o = r ? r + " " + t : t;
      this.name(o);
    }
    return this;
  }
  hasName(t) {
    if (!t)
      return !1;
    const r = this.name();
    if (!r)
      return !1;
    var o = (r || "").split(/\s/g);
    return o.indexOf(t) !== -1;
  }
  removeName(t) {
    var r = (this.name() || "").split(/\s/g), o = r.indexOf(t);
    return o !== -1 && (r.splice(o, 1), this.name(r.join(" "))), this;
  }
  setAttr(t, r) {
    var o = this[_1 + Xr.Util._capitalize(t)];
    return Xr.Util._isFunction(o) ? o.call(this, r) : this._setAttr(t, r), this;
  }
  _requestDraw() {
    if (yo.Konva.autoDrawEnabled) {
      const t = this.getLayer() || this.getStage();
      t == null || t.batchDraw();
    }
  }
  _setAttr(t, r) {
    var o = this.attrs[t];
    o === r && !Xr.Util.isObject(r) || (r == null ? delete this.attrs[t] : this.attrs[t] = r, this._shouldFireChangeEvents && this._fireChangeEvent(t, o, r), this._requestDraw());
  }
  _setComponentAttr(t, r, o) {
    var c;
    o !== void 0 && (c = this.attrs[t], c || (this.attrs[t] = this.getAttr(t)), this.attrs[t][r] = o, this._fireChangeEvent(t, c, o));
  }
  _fireAndBubble(t, r, o) {
    r && this.nodeType === j1 && (r.target = this);
    var c = (t === H1 || t === W1) && (o && (this === o || this.isAncestorOf && this.isAncestorOf(o)) || this.nodeType === "Stage" && !o);
    if (!c) {
      this._fire(t, r);
      var d = (t === H1 || t === W1) && o && o.isAncestorOf && o.isAncestorOf(this) && !o.isAncestorOf(this.parent);
      (r && !r.cancelBubble || !r) && this.parent && this.parent.isListening() && !d && (o && o.parent ? this._fireAndBubble.call(this.parent, t, r, o) : this._fireAndBubble.call(this.parent, t, r));
    }
  }
  _getProtoListeners(t) {
    var r, o, c;
    const d = (r = this._cache.get(Sl)) !== null && r !== void 0 ? r : {};
    let u = d == null ? void 0 : d[t];
    if (u === void 0) {
      u = [];
      let l = Object.getPrototypeOf(this);
      for (; l; ) {
        const e = (c = (o = l.eventListeners) === null || o === void 0 ? void 0 : o[t]) !== null && c !== void 0 ? c : [];
        u.push(...e), l = Object.getPrototypeOf(l);
      }
      d[t] = u, this._cache.set(Sl, d);
    }
    return u;
  }
  _fire(t, r) {
    r = r || {}, r.currentTarget = this, r.type = t;
    const o = this._getProtoListeners(t);
    if (o)
      for (var c = 0; c < o.length; c++)
        o[c].handler.call(this, r);
    const d = this.eventListeners[t];
    if (d)
      for (var c = 0; c < d.length; c++)
        d[c].handler.call(this, r);
  }
  draw() {
    return this.drawScene(), this.drawHit(), this;
  }
  _createDragElement(t) {
    var r = t ? t.pointerId : void 0, o = this.getStage(), c = this.getAbsolutePosition();
    if (o) {
      var d = o._getPointerById(r) || o._changedPointerPositions[0] || c;
      Wi.DD._dragElements.set(this._id, {
        node: this,
        startPointerPos: d,
        offset: {
          x: d.x - c.x,
          y: d.y - c.y
        },
        dragStatus: "ready",
        pointerId: r
      });
    }
  }
  startDrag(t, r = !0) {
    Wi.DD._dragElements.has(this._id) || this._createDragElement(t);
    const o = Wi.DD._dragElements.get(this._id);
    o.dragStatus = "dragging", this.fire("dragstart", {
      type: "dragstart",
      target: this,
      evt: t && t.evt
    }, r);
  }
  _setDragPosition(t, r) {
    const o = this.getStage()._getPointerById(r.pointerId);
    if (o) {
      var c = {
        x: o.x - r.offset.x,
        y: o.y - r.offset.y
      }, d = this.dragBoundFunc();
      if (d !== void 0) {
        const u = d.call(this, c, t);
        u ? c = u : Xr.Util.warn("dragBoundFunc did not return any value. That is unexpected behavior. You must return new absolute position from dragBoundFunc.");
      }
      (!this._lastPos || this._lastPos.x !== c.x || this._lastPos.y !== c.y) && (this.setAbsolutePosition(c), this._requestDraw()), this._lastPos = c;
    }
  }
  stopDrag(t) {
    const r = Wi.DD._dragElements.get(this._id);
    r && (r.dragStatus = "stopped"), Wi.DD._endDragBefore(t), Wi.DD._endDragAfter(t);
  }
  setDraggable(t) {
    this._setAttr("draggable", t), this._dragChange();
  }
  isDragging() {
    const t = Wi.DD._dragElements.get(this._id);
    return t ? t.dragStatus === "dragging" : !1;
  }
  _listenDrag() {
    this._dragCleanup(), this.on("mousedown.konva touchstart.konva", function(t) {
      var r = t.evt.button !== void 0, o = !r || yo.Konva.dragButtons.indexOf(t.evt.button) >= 0;
      if (o && !this.isDragging()) {
        var c = !1;
        Wi.DD._dragElements.forEach((d) => {
          this.isAncestorOf(d.node) && (c = !0);
        }), c || this._createDragElement(t);
      }
    });
  }
  _dragChange() {
    if (this.attrs.draggable)
      this._listenDrag();
    else {
      this._dragCleanup();
      var t = this.getStage();
      if (!t)
        return;
      const r = Wi.DD._dragElements.get(this._id), o = r && r.dragStatus === "dragging", c = r && r.dragStatus === "ready";
      o ? this.stopDrag() : c && Wi.DD._dragElements.delete(this._id);
    }
  }
  _dragCleanup() {
    this.off("mousedown.konva"), this.off("touchstart.konva");
  }
  isClientRectOnScreen(t = { x: 0, y: 0 }) {
    const r = this.getStage();
    if (!r)
      return !1;
    const o = {
      x: -t.x,
      y: -t.y,
      width: r.width() + 2 * t.x,
      height: r.height() + 2 * t.y
    };
    return Xr.Util.haveIntersection(o, this.getClientRect());
  }
  static create(t, r) {
    return Xr.Util._isString(t) && (t = JSON.parse(t)), this._createNode(t, r);
  }
  static _createNode(t, r) {
    var o = Tr.prototype.getClassName.call(t), c = t.children, d, u, l;
    r && (t.attrs.container = r), yo.Konva[o] || (Xr.Util.warn('Can not find a node with class name "' + o + '". Fallback to "Shape".'), o = "Shape");
    const e = yo.Konva[o];
    if (d = new e(t.attrs), c)
      for (u = c.length, l = 0; l < u; l++)
        d.add(Tr._createNode(c[l]));
    return d;
  }
}
Bn.Node = Tr;
Tr.prototype.nodeType = "Node";
Tr.prototype._attrsAffectingSize = [];
Tr.prototype.eventListeners = {};
Tr.prototype.on.call(Tr.prototype, iw, function() {
  if (this._batchingTransformChange) {
    this._needClearTransformCache = !0;
    return;
  }
  this._clearCache(ja), this._clearSelfAndDescendantCache(Ta);
});
Tr.prototype.on.call(Tr.prototype, "visibleChange.konva", function() {
  this._clearSelfAndDescendantCache(Eh);
});
Tr.prototype.on.call(Tr.prototype, "listeningChange.konva", function() {
  this._clearSelfAndDescendantCache(Sh);
});
Tr.prototype.on.call(Tr.prototype, "opacityChange.konva", function() {
  this._clearSelfAndDescendantCache(Fl);
});
const Cn = F0.Factory.addGetterSetter;
Cn(Tr, "zIndex");
Cn(Tr, "absolutePosition");
Cn(Tr, "position");
Cn(Tr, "x", 0, (0, Xn.getNumberValidator)());
Cn(Tr, "y", 0, (0, Xn.getNumberValidator)());
Cn(Tr, "globalCompositeOperation", "source-over", (0, Xn.getStringValidator)());
Cn(Tr, "opacity", 1, (0, Xn.getNumberValidator)());
Cn(Tr, "name", "", (0, Xn.getStringValidator)());
Cn(Tr, "id", "", (0, Xn.getStringValidator)());
Cn(Tr, "rotation", 0, (0, Xn.getNumberValidator)());
F0.Factory.addComponentsGetterSetter(Tr, "scale", ["x", "y"]);
Cn(Tr, "scaleX", 1, (0, Xn.getNumberValidator)());
Cn(Tr, "scaleY", 1, (0, Xn.getNumberValidator)());
F0.Factory.addComponentsGetterSetter(Tr, "skew", ["x", "y"]);
Cn(Tr, "skewX", 0, (0, Xn.getNumberValidator)());
Cn(Tr, "skewY", 0, (0, Xn.getNumberValidator)());
F0.Factory.addComponentsGetterSetter(Tr, "offset", ["x", "y"]);
Cn(Tr, "offsetX", 0, (0, Xn.getNumberValidator)());
Cn(Tr, "offsetY", 0, (0, Xn.getNumberValidator)());
Cn(Tr, "dragDistance", null, (0, Xn.getNumberValidator)());
Cn(Tr, "width", 0, (0, Xn.getNumberValidator)());
Cn(Tr, "height", 0, (0, Xn.getNumberValidator)());
Cn(Tr, "listening", !0, (0, Xn.getBooleanValidator)());
Cn(Tr, "preventDefault", !0, (0, Xn.getBooleanValidator)());
Cn(Tr, "filters", null, function(a) {
  return this._filterUpToDate = !1, a;
});
Cn(Tr, "visible", !0, (0, Xn.getBooleanValidator)());
Cn(Tr, "transformsEnabled", "all", (0, Xn.getStringValidator)());
Cn(Tr, "size");
Cn(Tr, "dragBoundFunc");
Cn(Tr, "draggable", !1, (0, Xn.getBooleanValidator)());
F0.Factory.backCompat(Tr, {
  rotateDeg: "rotate",
  setRotationDeg: "setRotation",
  getRotationDeg: "getRotation"
});
var Lo = {};
Object.defineProperty(Lo, "__esModule", { value: !0 });
Lo.Container = void 0;
const As = zr, Xu = Bn, hf = lr;
class Uo extends Xu.Node {
  constructor() {
    super(...arguments), this.children = [];
  }
  getChildren(t) {
    if (!t)
      return this.children || [];
    const r = this.children || [];
    var o = [];
    return r.forEach(function(c) {
      t(c) && o.push(c);
    }), o;
  }
  hasChildren() {
    return this.getChildren().length > 0;
  }
  removeChildren() {
    return this.getChildren().forEach((t) => {
      t.parent = null, t.index = 0, t.remove();
    }), this.children = [], this._requestDraw(), this;
  }
  destroyChildren() {
    return this.getChildren().forEach((t) => {
      t.parent = null, t.index = 0, t.destroy();
    }), this.children = [], this._requestDraw(), this;
  }
  add(...t) {
    if (t.length === 0)
      return this;
    if (t.length > 1) {
      for (var r = 0; r < t.length; r++)
        this.add(t[r]);
      return this;
    }
    const o = t[0];
    return o.getParent() ? (o.moveTo(this), this) : (this._validateAdd(o), o.index = this.getChildren().length, o.parent = this, o._clearCaches(), this.getChildren().push(o), this._fire("add", {
      child: o
    }), this._requestDraw(), this);
  }
  destroy() {
    return this.hasChildren() && this.destroyChildren(), super.destroy(), this;
  }
  find(t) {
    return this._generalFind(t, !1);
  }
  findOne(t) {
    var r = this._generalFind(t, !0);
    return r.length > 0 ? r[0] : void 0;
  }
  _generalFind(t, r) {
    var o = [];
    return this._descendants((c) => {
      const d = c._isMatch(t);
      return d && o.push(c), !!(d && r);
    }), o;
  }
  _descendants(t) {
    let r = !1;
    const o = this.getChildren();
    for (const c of o) {
      if (r = t(c), r)
        return !0;
      if (c.hasChildren() && (r = c._descendants(t), r))
        return !0;
    }
    return !1;
  }
  toObject() {
    var t = Xu.Node.prototype.toObject.call(this);
    return t.children = [], this.getChildren().forEach((r) => {
      t.children.push(r.toObject());
    }), t;
  }
  isAncestorOf(t) {
    for (var r = t.getParent(); r; ) {
      if (r._id === this._id)
        return !0;
      r = r.getParent();
    }
    return !1;
  }
  clone(t) {
    var r = Xu.Node.prototype.clone.call(this, t);
    return this.getChildren().forEach(function(o) {
      r.add(o.clone());
    }), r;
  }
  getAllIntersections(t) {
    var r = [];
    return this.find("Shape").forEach((o) => {
      o.isVisible() && o.intersects(t) && r.push(o);
    }), r;
  }
  _clearSelfAndDescendantCache(t) {
    var r;
    super._clearSelfAndDescendantCache(t), !this.isCached() && ((r = this.children) === null || r === void 0 || r.forEach(function(o) {
      o._clearSelfAndDescendantCache(t);
    }));
  }
  _setChildrenIndices() {
    var t;
    (t = this.children) === null || t === void 0 || t.forEach(function(r, o) {
      r.index = o;
    }), this._requestDraw();
  }
  drawScene(t, r) {
    var o = this.getLayer(), c = t || o && o.getCanvas(), d = c && c.getContext(), u = this._getCanvasCache(), l = u && u.scene, e = c && c.isCache;
    if (!this.isVisible() && !e)
      return this;
    if (l) {
      d.save();
      var s = this.getAbsoluteTransform(r).getMatrix();
      d.transform(s[0], s[1], s[2], s[3], s[4], s[5]), this._drawCachedSceneCanvas(d), d.restore();
    } else
      this._drawChildren("drawScene", c, r);
    return this;
  }
  drawHit(t, r) {
    if (!this.shouldDrawHit(r))
      return this;
    var o = this.getLayer(), c = t || o && o.hitCanvas, d = c && c.getContext(), u = this._getCanvasCache(), l = u && u.hit;
    if (l) {
      d.save();
      var e = this.getAbsoluteTransform(r).getMatrix();
      d.transform(e[0], e[1], e[2], e[3], e[4], e[5]), this._drawCachedHitCanvas(d), d.restore();
    } else
      this._drawChildren("drawHit", c, r);
    return this;
  }
  _drawChildren(t, r, o) {
    var c, d = r && r.getContext(), u = this.clipWidth(), l = this.clipHeight(), e = this.clipFunc(), s = u && l || e;
    const i = o === this;
    if (s) {
      d.save();
      var f = this.getAbsoluteTransform(o), h = f.getMatrix();
      d.transform(h[0], h[1], h[2], h[3], h[4], h[5]), d.beginPath();
      let x;
      if (e)
        x = e.call(this, d, this);
      else {
        var v = this.clipX(), p = this.clipY();
        d.rect(v, p, u, l);
      }
      d.clip.apply(d, x), h = f.copy().invert().getMatrix(), d.transform(h[0], h[1], h[2], h[3], h[4], h[5]);
    }
    var m = !i && this.globalCompositeOperation() !== "source-over" && t === "drawScene";
    m && (d.save(), d._applyGlobalCompositeOperation(this)), (c = this.children) === null || c === void 0 || c.forEach(function(x) {
      x[t](r, o);
    }), m && d.restore(), s && d.restore();
  }
  getClientRect(t = {}) {
    var r, o = t.skipTransform, c = t.relativeTo, d, u, l, e, s = {
      x: 1 / 0,
      y: 1 / 0,
      width: 0,
      height: 0
    }, i = this;
    (r = this.children) === null || r === void 0 || r.forEach(function(m) {
      if (m.visible()) {
        var x = m.getClientRect({
          relativeTo: i,
          skipShadow: t.skipShadow,
          skipStroke: t.skipStroke
        });
        x.width === 0 && x.height === 0 || (d === void 0 ? (d = x.x, u = x.y, l = x.x + x.width, e = x.y + x.height) : (d = Math.min(d, x.x), u = Math.min(u, x.y), l = Math.max(l, x.x + x.width), e = Math.max(e, x.y + x.height)));
      }
    });
    for (var f = this.find("Shape"), h = !1, v = 0; v < f.length; v++) {
      var p = f[v];
      if (p._isVisible(this)) {
        h = !0;
        break;
      }
    }
    return h && d !== void 0 ? s = {
      x: d,
      y: u,
      width: l - d,
      height: e - u
    } : s = {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    }, o ? s : this._transformedRect(s, c);
  }
}
Lo.Container = Uo;
As.Factory.addComponentsGetterSetter(Uo, "clip", [
  "x",
  "y",
  "width",
  "height"
]);
As.Factory.addGetterSetter(Uo, "clipX", void 0, (0, hf.getNumberValidator)());
As.Factory.addGetterSetter(Uo, "clipY", void 0, (0, hf.getNumberValidator)());
As.Factory.addGetterSetter(Uo, "clipWidth", void 0, (0, hf.getNumberValidator)());
As.Factory.addGetterSetter(Uo, "clipHeight", void 0, (0, hf.getNumberValidator)());
As.Factory.addGetterSetter(Uo, "clipFunc");
var u2 = {}, Bi = {};
Object.defineProperty(Bi, "__esModule", { value: !0 });
Bi.releaseCapture = Bi.setPointerCapture = Bi.hasPointerCapture = Bi.createEvent = Bi.getCapturedShape = void 0;
const ow = Hr, b0 = /* @__PURE__ */ new Map(), h2 = ow.Konva._global.PointerEvent !== void 0;
function sw(a) {
  return b0.get(a);
}
Bi.getCapturedShape = sw;
function sc(a) {
  return {
    evt: a,
    pointerId: a.pointerId
  };
}
Bi.createEvent = sc;
function lw(a, t) {
  return b0.get(a) === t;
}
Bi.hasPointerCapture = lw;
function fw(a, t) {
  c2(a), t.getStage() && (b0.set(a, t), h2 && t._fire("gotpointercapture", sc(new PointerEvent("gotpointercapture"))));
}
Bi.setPointerCapture = fw;
function c2(a, t) {
  const r = b0.get(a);
  if (!r)
    return;
  const o = r.getStage();
  o && o.content, b0.delete(a), h2 && r._fire("lostpointercapture", sc(new PointerEvent("lostpointercapture")));
}
Bi.releaseCapture = c2;
(function(a) {
  Object.defineProperty(a, "__esModule", { value: !0 }), a.Stage = a.stages = void 0;
  const t = zn, r = zr, o = Lo, c = Hr, d = ea, u = uf, l = Hr, e = Bi;
  var s = "Stage", i = "string", f = "px", h = "mouseout", v = "mouseleave", p = "mouseover", m = "mouseenter", x = "mousemove", g = "mousedown", S = "mouseup", y = "pointermove", b = "pointerdown", n = "pointerup", w = "pointercancel", E = "lostpointercapture", A = "pointerout", O = "pointerleave", C = "pointerover", T = "pointerenter", P = "contextmenu", I = "touchstart", F = "touchend", B = "touchmove", M = "touchcancel", z = "wheel", L = 5, J = [
    [m, "_pointerenter"],
    [g, "_pointerdown"],
    [x, "_pointermove"],
    [S, "_pointerup"],
    [v, "_pointerleave"],
    [I, "_pointerdown"],
    [B, "_pointermove"],
    [F, "_pointerup"],
    [M, "_pointercancel"],
    [p, "_pointerover"],
    [z, "_wheel"],
    [P, "_contextmenu"],
    [b, "_pointerdown"],
    [y, "_pointermove"],
    [n, "_pointerup"],
    [w, "_pointercancel"],
    [E, "_lostpointercapture"]
  ];
  const ft = {
    mouse: {
      [A]: h,
      [O]: v,
      [C]: p,
      [T]: m,
      [y]: x,
      [b]: g,
      [n]: S,
      [w]: "mousecancel",
      pointerclick: "click",
      pointerdblclick: "dblclick"
    },
    touch: {
      [A]: "touchout",
      [O]: "touchleave",
      [C]: "touchover",
      [T]: "touchenter",
      [y]: B,
      [b]: I,
      [n]: F,
      [w]: M,
      pointerclick: "tap",
      pointerdblclick: "dbltap"
    },
    pointer: {
      [A]: A,
      [O]: O,
      [C]: C,
      [T]: T,
      [y]: y,
      [b]: b,
      [n]: n,
      [w]: w,
      pointerclick: "pointerclick",
      pointerdblclick: "pointerdblclick"
    }
  }, Q = (Rt) => Rt.indexOf("pointer") >= 0 ? "pointer" : Rt.indexOf("touch") >= 0 ? "touch" : "mouse", xt = (Rt) => {
    const bt = Q(Rt);
    if (bt === "pointer")
      return c.Konva.pointerEventsEnabled && ft.pointer;
    if (bt === "touch")
      return ft.touch;
    if (bt === "mouse")
      return ft.mouse;
  };
  function St(Rt = {}) {
    return (Rt.clipFunc || Rt.clipWidth || Rt.clipHeight) && t.Util.warn("Stage does not support clipping. Please use clip for Layers or Groups."), Rt;
  }
  const Pt = "Pointer position is missing and not registered by the stage. Looks like it is outside of the stage container. You can set it manually from event: stage.setPointersPositions(event);";
  a.stages = [];
  class Gt extends o.Container {
    constructor(bt) {
      super(St(bt)), this._pointerPositions = [], this._changedPointerPositions = [], this._buildDOM(), this._bindContentEvents(), a.stages.push(this), this.on("widthChange.konva heightChange.konva", this._resizeDOM), this.on("visibleChange.konva", this._checkVisibility), this.on("clipWidthChange.konva clipHeightChange.konva clipFuncChange.konva", () => {
        St(this.attrs);
      }), this._checkVisibility();
    }
    _validateAdd(bt) {
      const Dt = bt.getType() === "Layer", X = bt.getType() === "FastLayer";
      Dt || X || t.Util.throw("You may only add layers to the stage.");
    }
    _checkVisibility() {
      if (!this.content)
        return;
      const bt = this.visible() ? "" : "none";
      this.content.style.display = bt;
    }
    setContainer(bt) {
      if (typeof bt === i) {
        if (bt.charAt(0) === ".") {
          var Dt = bt.slice(1);
          bt = document.getElementsByClassName(Dt)[0];
        } else {
          var X;
          bt.charAt(0) !== "#" ? X = bt : X = bt.slice(1), bt = document.getElementById(X);
        }
        if (!bt)
          throw "Can not find container in document with id " + X;
      }
      return this._setAttr("container", bt), this.content && (this.content.parentElement && this.content.parentElement.removeChild(this.content), bt.appendChild(this.content)), this;
    }
    shouldDrawHit() {
      return !0;
    }
    clear() {
      var bt = this.children, Dt = bt.length, X;
      for (X = 0; X < Dt; X++)
        bt[X].clear();
      return this;
    }
    clone(bt) {
      return bt || (bt = {}), bt.container = typeof document < "u" && document.createElement("div"), o.Container.prototype.clone.call(this, bt);
    }
    destroy() {
      super.destroy();
      var bt = this.content;
      bt && t.Util._isInDocument(bt) && this.container().removeChild(bt);
      var Dt = a.stages.indexOf(this);
      return Dt > -1 && a.stages.splice(Dt, 1), t.Util.releaseCanvas(this.bufferCanvas._canvas, this.bufferHitCanvas._canvas), this;
    }
    getPointerPosition() {
      const bt = this._pointerPositions[0] || this._changedPointerPositions[0];
      return bt ? {
        x: bt.x,
        y: bt.y
      } : (t.Util.warn(Pt), null);
    }
    _getPointerById(bt) {
      return this._pointerPositions.find((Dt) => Dt.id === bt);
    }
    getPointersPositions() {
      return this._pointerPositions;
    }
    getStage() {
      return this;
    }
    getContent() {
      return this.content;
    }
    _toKonvaCanvas(bt) {
      bt = bt || {}, bt.x = bt.x || 0, bt.y = bt.y || 0, bt.width = bt.width || this.width(), bt.height = bt.height || this.height();
      var Dt = new d.SceneCanvas({
        width: bt.width,
        height: bt.height,
        pixelRatio: bt.pixelRatio || 1
      }), X = Dt.getContext()._context, gt = this.children;
      return (bt.x || bt.y) && X.translate(-1 * bt.x, -1 * bt.y), gt.forEach(function(st) {
        if (st.isVisible()) {
          var rt = st._toKonvaCanvas(bt);
          X.drawImage(rt._canvas, bt.x, bt.y, rt.getWidth() / rt.getPixelRatio(), rt.getHeight() / rt.getPixelRatio());
        }
      }), Dt;
    }
    getIntersection(bt) {
      if (!bt)
        return null;
      var Dt = this.children, X = Dt.length, gt = X - 1, st;
      for (st = gt; st >= 0; st--) {
        const rt = Dt[st].getIntersection(bt);
        if (rt)
          return rt;
      }
      return null;
    }
    _resizeDOM() {
      var bt = this.width(), Dt = this.height();
      this.content && (this.content.style.width = bt + f, this.content.style.height = Dt + f), this.bufferCanvas.setSize(bt, Dt), this.bufferHitCanvas.setSize(bt, Dt), this.children.forEach((X) => {
        X.setSize({ width: bt, height: Dt }), X.draw();
      });
    }
    add(bt, ...Dt) {
      if (arguments.length > 1) {
        for (var X = 0; X < arguments.length; X++)
          this.add(arguments[X]);
        return this;
      }
      super.add(bt);
      var gt = this.children.length;
      return gt > L && t.Util.warn("The stage has " + gt + " layers. Recommended maximum number of layers is 3-5. Adding more layers into the stage may drop the performance. Rethink your tree structure, you can use Konva.Group."), bt.setSize({ width: this.width(), height: this.height() }), bt.draw(), c.Konva.isBrowser && this.content.appendChild(bt.canvas._canvas), this;
    }
    getParent() {
      return null;
    }
    getLayer() {
      return null;
    }
    hasPointerCapture(bt) {
      return e.hasPointerCapture(bt, this);
    }
    setPointerCapture(bt) {
      e.setPointerCapture(bt, this);
    }
    releaseCapture(bt) {
      e.releaseCapture(bt, this);
    }
    getLayers() {
      return this.children;
    }
    _bindContentEvents() {
      c.Konva.isBrowser && J.forEach(([bt, Dt]) => {
        this.content.addEventListener(bt, (X) => {
          this[Dt](X);
        }, { passive: !1 });
      });
    }
    _pointerenter(bt) {
      this.setPointersPositions(bt);
      const Dt = xt(bt.type);
      Dt && this._fire(Dt.pointerenter, {
        evt: bt,
        target: this,
        currentTarget: this
      });
    }
    _pointerover(bt) {
      this.setPointersPositions(bt);
      const Dt = xt(bt.type);
      Dt && this._fire(Dt.pointerover, {
        evt: bt,
        target: this,
        currentTarget: this
      });
    }
    _getTargetShape(bt) {
      let Dt = this[bt + "targetShape"];
      return Dt && !Dt.getStage() && (Dt = null), Dt;
    }
    _pointerleave(bt) {
      const Dt = xt(bt.type), X = Q(bt.type);
      if (Dt) {
        this.setPointersPositions(bt);
        var gt = this._getTargetShape(X), st = !u.DD.isDragging || c.Konva.hitOnDragEnabled;
        gt && st ? (gt._fireAndBubble(Dt.pointerout, { evt: bt }), gt._fireAndBubble(Dt.pointerleave, { evt: bt }), this._fire(Dt.pointerleave, {
          evt: bt,
          target: this,
          currentTarget: this
        }), this[X + "targetShape"] = null) : st && (this._fire(Dt.pointerleave, {
          evt: bt,
          target: this,
          currentTarget: this
        }), this._fire(Dt.pointerout, {
          evt: bt,
          target: this,
          currentTarget: this
        })), this.pointerPos = null, this._pointerPositions = [];
      }
    }
    _pointerdown(bt) {
      const Dt = xt(bt.type), X = Q(bt.type);
      if (Dt) {
        this.setPointersPositions(bt);
        var gt = !1;
        this._changedPointerPositions.forEach((st) => {
          var rt = this.getIntersection(st);
          if (u.DD.justDragged = !1, c.Konva["_" + X + "ListenClick"] = !0, !rt || !rt.isListening())
            return;
          c.Konva.capturePointerEventsEnabled && rt.setPointerCapture(st.id), this[X + "ClickStartShape"] = rt, rt._fireAndBubble(Dt.pointerdown, {
            evt: bt,
            pointerId: st.id
          }), gt = !0;
          const wt = bt.type.indexOf("touch") >= 0;
          rt.preventDefault() && bt.cancelable && wt && bt.preventDefault();
        }), gt || this._fire(Dt.pointerdown, {
          evt: bt,
          target: this,
          currentTarget: this,
          pointerId: this._pointerPositions[0].id
        });
      }
    }
    _pointermove(bt) {
      const Dt = xt(bt.type), X = Q(bt.type);
      if (!Dt)
        return;
      u.DD.isDragging && u.DD.node.preventDefault() && bt.cancelable && bt.preventDefault(), this.setPointersPositions(bt);
      var gt = !u.DD.isDragging || c.Konva.hitOnDragEnabled;
      if (!gt)
        return;
      var st = {};
      let rt = !1;
      var wt = this._getTargetShape(X);
      this._changedPointerPositions.forEach((Ft) => {
        const zt = e.getCapturedShape(Ft.id) || this.getIntersection(Ft), G = Ft.id, D = { evt: bt, pointerId: G };
        var Z = wt !== zt;
        if (Z && wt && (wt._fireAndBubble(Dt.pointerout, { ...D }, zt), wt._fireAndBubble(Dt.pointerleave, { ...D }, zt)), zt) {
          if (st[zt._id])
            return;
          st[zt._id] = !0;
        }
        zt && zt.isListening() ? (rt = !0, Z && (zt._fireAndBubble(Dt.pointerover, { ...D }, wt), zt._fireAndBubble(Dt.pointerenter, { ...D }, wt), this[X + "targetShape"] = zt), zt._fireAndBubble(Dt.pointermove, { ...D })) : wt && (this._fire(Dt.pointerover, {
          evt: bt,
          target: this,
          currentTarget: this,
          pointerId: G
        }), this[X + "targetShape"] = null);
      }), rt || this._fire(Dt.pointermove, {
        evt: bt,
        target: this,
        currentTarget: this,
        pointerId: this._changedPointerPositions[0].id
      });
    }
    _pointerup(bt) {
      const Dt = xt(bt.type), X = Q(bt.type);
      if (!Dt)
        return;
      this.setPointersPositions(bt);
      const gt = this[X + "ClickStartShape"], st = this[X + "ClickEndShape"];
      var rt = {};
      let wt = !1;
      this._changedPointerPositions.forEach((Ft) => {
        const zt = e.getCapturedShape(Ft.id) || this.getIntersection(Ft);
        if (zt) {
          if (zt.releaseCapture(Ft.id), rt[zt._id])
            return;
          rt[zt._id] = !0;
        }
        const G = Ft.id, D = { evt: bt, pointerId: G };
        let Z = !1;
        c.Konva["_" + X + "InDblClickWindow"] ? (Z = !0, clearTimeout(this[X + "DblTimeout"])) : u.DD.justDragged || (c.Konva["_" + X + "InDblClickWindow"] = !0, clearTimeout(this[X + "DblTimeout"])), this[X + "DblTimeout"] = setTimeout(function() {
          c.Konva["_" + X + "InDblClickWindow"] = !1;
        }, c.Konva.dblClickWindow), zt && zt.isListening() ? (wt = !0, this[X + "ClickEndShape"] = zt, zt._fireAndBubble(Dt.pointerup, { ...D }), c.Konva["_" + X + "ListenClick"] && gt && gt === zt && (zt._fireAndBubble(Dt.pointerclick, { ...D }), Z && st && st === zt && zt._fireAndBubble(Dt.pointerdblclick, { ...D }))) : (this[X + "ClickEndShape"] = null, c.Konva["_" + X + "ListenClick"] && this._fire(Dt.pointerclick, {
          evt: bt,
          target: this,
          currentTarget: this,
          pointerId: G
        }), Z && this._fire(Dt.pointerdblclick, {
          evt: bt,
          target: this,
          currentTarget: this,
          pointerId: G
        }));
      }), wt || this._fire(Dt.pointerup, {
        evt: bt,
        target: this,
        currentTarget: this,
        pointerId: this._changedPointerPositions[0].id
      }), c.Konva["_" + X + "ListenClick"] = !1, bt.cancelable && X !== "touch" && bt.preventDefault();
    }
    _contextmenu(bt) {
      this.setPointersPositions(bt);
      var Dt = this.getIntersection(this.getPointerPosition());
      Dt && Dt.isListening() ? Dt._fireAndBubble(P, { evt: bt }) : this._fire(P, {
        evt: bt,
        target: this,
        currentTarget: this
      });
    }
    _wheel(bt) {
      this.setPointersPositions(bt);
      var Dt = this.getIntersection(this.getPointerPosition());
      Dt && Dt.isListening() ? Dt._fireAndBubble(z, { evt: bt }) : this._fire(z, {
        evt: bt,
        target: this,
        currentTarget: this
      });
    }
    _pointercancel(bt) {
      this.setPointersPositions(bt);
      const Dt = e.getCapturedShape(bt.pointerId) || this.getIntersection(this.getPointerPosition());
      Dt && Dt._fireAndBubble(n, e.createEvent(bt)), e.releaseCapture(bt.pointerId);
    }
    _lostpointercapture(bt) {
      e.releaseCapture(bt.pointerId);
    }
    setPointersPositions(bt) {
      var Dt = this._getContentPosition(), X = null, gt = null;
      bt = bt || window.event, bt.touches !== void 0 ? (this._pointerPositions = [], this._changedPointerPositions = [], Array.prototype.forEach.call(bt.touches, (st) => {
        this._pointerPositions.push({
          id: st.identifier,
          x: (st.clientX - Dt.left) / Dt.scaleX,
          y: (st.clientY - Dt.top) / Dt.scaleY
        });
      }), Array.prototype.forEach.call(bt.changedTouches || bt.touches, (st) => {
        this._changedPointerPositions.push({
          id: st.identifier,
          x: (st.clientX - Dt.left) / Dt.scaleX,
          y: (st.clientY - Dt.top) / Dt.scaleY
        });
      })) : (X = (bt.clientX - Dt.left) / Dt.scaleX, gt = (bt.clientY - Dt.top) / Dt.scaleY, this.pointerPos = {
        x: X,
        y: gt
      }, this._pointerPositions = [{ x: X, y: gt, id: t.Util._getFirstPointerId(bt) }], this._changedPointerPositions = [
        { x: X, y: gt, id: t.Util._getFirstPointerId(bt) }
      ]);
    }
    _setPointerPosition(bt) {
      t.Util.warn('Method _setPointerPosition is deprecated. Use "stage.setPointersPositions(event)" instead.'), this.setPointersPositions(bt);
    }
    _getContentPosition() {
      if (!this.content || !this.content.getBoundingClientRect)
        return {
          top: 0,
          left: 0,
          scaleX: 1,
          scaleY: 1
        };
      var bt = this.content.getBoundingClientRect();
      return {
        top: bt.top,
        left: bt.left,
        scaleX: bt.width / this.content.clientWidth || 1,
        scaleY: bt.height / this.content.clientHeight || 1
      };
    }
    _buildDOM() {
      if (this.bufferCanvas = new d.SceneCanvas({
        width: this.width(),
        height: this.height()
      }), this.bufferHitCanvas = new d.HitCanvas({
        pixelRatio: 1,
        width: this.width(),
        height: this.height()
      }), !!c.Konva.isBrowser) {
        var bt = this.container();
        if (!bt)
          throw "Stage has no container. A container is required.";
        bt.innerHTML = "", this.content = document.createElement("div"), this.content.style.position = "relative", this.content.style.userSelect = "none", this.content.className = "konvajs-content", this.content.setAttribute("role", "presentation"), bt.appendChild(this.content), this._resizeDOM();
      }
    }
    cache() {
      return t.Util.warn("Cache function is not allowed for stage. You may use cache only for layers, groups and shapes."), this;
    }
    clearCache() {
      return this;
    }
    batchDraw() {
      return this.getChildren().forEach(function(bt) {
        bt.batchDraw();
      }), this;
    }
  }
  a.Stage = Gt, Gt.prototype.nodeType = s, (0, l._registerNode)(Gt), r.Factory.addGetterSetter(Gt, "container");
})(u2);
var I0 = {}, ri = {};
(function(a) {
  Object.defineProperty(a, "__esModule", { value: !0 }), a.Shape = a.shapes = void 0;
  const t = Hr, r = zn, o = zr, c = Bn, d = lr, u = Hr, l = Bi;
  var e = "hasShadow", s = "shadowRGBA", i = "patternImage", f = "linearGradient", h = "radialGradient";
  let v;
  function p() {
    return v || (v = r.Util.createCanvasElement().getContext("2d"), v);
  }
  a.shapes = {};
  function m(O) {
    const C = this.attrs.fillRule;
    C ? O.fill(C) : O.fill();
  }
  function x(O) {
    O.stroke();
  }
  function g(O) {
    O.fill();
  }
  function S(O) {
    O.stroke();
  }
  function y() {
    this._clearCache(e);
  }
  function b() {
    this._clearCache(s);
  }
  function n() {
    this._clearCache(i);
  }
  function w() {
    this._clearCache(f);
  }
  function E() {
    this._clearCache(h);
  }
  class A extends c.Node {
    constructor(C) {
      super(C);
      let T;
      for (; T = r.Util.getRandomColor(), !(T && !(T in a.shapes)); )
        ;
      this.colorKey = T, a.shapes[T] = this;
    }
    getContext() {
      return r.Util.warn("shape.getContext() method is deprecated. Please do not use it."), this.getLayer().getContext();
    }
    getCanvas() {
      return r.Util.warn("shape.getCanvas() method is deprecated. Please do not use it."), this.getLayer().getCanvas();
    }
    getSceneFunc() {
      return this.attrs.sceneFunc || this._sceneFunc;
    }
    getHitFunc() {
      return this.attrs.hitFunc || this._hitFunc;
    }
    hasShadow() {
      return this._getCache(e, this._hasShadow);
    }
    _hasShadow() {
      return this.shadowEnabled() && this.shadowOpacity() !== 0 && !!(this.shadowColor() || this.shadowBlur() || this.shadowOffsetX() || this.shadowOffsetY());
    }
    _getFillPattern() {
      return this._getCache(i, this.__getFillPattern);
    }
    __getFillPattern() {
      if (this.fillPatternImage()) {
        var C = p();
        const T = C.createPattern(this.fillPatternImage(), this.fillPatternRepeat() || "repeat");
        if (T && T.setTransform) {
          const P = new r.Transform();
          P.translate(this.fillPatternX(), this.fillPatternY()), P.rotate(t.Konva.getAngle(this.fillPatternRotation())), P.scale(this.fillPatternScaleX(), this.fillPatternScaleY()), P.translate(-1 * this.fillPatternOffsetX(), -1 * this.fillPatternOffsetY());
          const I = P.getMatrix(), F = typeof DOMMatrix > "u" ? {
            a: I[0],
            b: I[1],
            c: I[2],
            d: I[3],
            e: I[4],
            f: I[5]
          } : new DOMMatrix(I);
          T.setTransform(F);
        }
        return T;
      }
    }
    _getLinearGradient() {
      return this._getCache(f, this.__getLinearGradient);
    }
    __getLinearGradient() {
      var C = this.fillLinearGradientColorStops();
      if (C) {
        for (var T = p(), P = this.fillLinearGradientStartPoint(), I = this.fillLinearGradientEndPoint(), F = T.createLinearGradient(P.x, P.y, I.x, I.y), B = 0; B < C.length; B += 2)
          F.addColorStop(C[B], C[B + 1]);
        return F;
      }
    }
    _getRadialGradient() {
      return this._getCache(h, this.__getRadialGradient);
    }
    __getRadialGradient() {
      var C = this.fillRadialGradientColorStops();
      if (C) {
        for (var T = p(), P = this.fillRadialGradientStartPoint(), I = this.fillRadialGradientEndPoint(), F = T.createRadialGradient(P.x, P.y, this.fillRadialGradientStartRadius(), I.x, I.y, this.fillRadialGradientEndRadius()), B = 0; B < C.length; B += 2)
          F.addColorStop(C[B], C[B + 1]);
        return F;
      }
    }
    getShadowRGBA() {
      return this._getCache(s, this._getShadowRGBA);
    }
    _getShadowRGBA() {
      if (this.hasShadow()) {
        var C = r.Util.colorToRGBA(this.shadowColor());
        if (C)
          return "rgba(" + C.r + "," + C.g + "," + C.b + "," + C.a * (this.shadowOpacity() || 1) + ")";
      }
    }
    hasFill() {
      return this._calculate("hasFill", [
        "fillEnabled",
        "fill",
        "fillPatternImage",
        "fillLinearGradientColorStops",
        "fillRadialGradientColorStops"
      ], () => this.fillEnabled() && !!(this.fill() || this.fillPatternImage() || this.fillLinearGradientColorStops() || this.fillRadialGradientColorStops()));
    }
    hasStroke() {
      return this._calculate("hasStroke", [
        "strokeEnabled",
        "strokeWidth",
        "stroke",
        "strokeLinearGradientColorStops"
      ], () => this.strokeEnabled() && this.strokeWidth() && !!(this.stroke() || this.strokeLinearGradientColorStops()));
    }
    hasHitStroke() {
      const C = this.hitStrokeWidth();
      return C === "auto" ? this.hasStroke() : this.strokeEnabled() && !!C;
    }
    intersects(C) {
      var T = this.getStage();
      if (!T)
        return !1;
      const P = T.bufferHitCanvas;
      return P.getContext().clear(), this.drawHit(P, void 0, !0), P.context.getImageData(Math.round(C.x), Math.round(C.y), 1, 1).data[3] > 0;
    }
    destroy() {
      return c.Node.prototype.destroy.call(this), delete a.shapes[this.colorKey], delete this.colorKey, this;
    }
    _useBufferCanvas(C) {
      var T;
      if (!this.getStage() || !((T = this.attrs.perfectDrawEnabled) !== null && T !== void 0 ? T : !0))
        return !1;
      const I = C || this.hasFill(), F = this.hasStroke(), B = this.getAbsoluteOpacity() !== 1;
      if (I && F && B)
        return !0;
      const M = this.hasShadow(), z = this.shadowForStrokeEnabled();
      return !!(I && F && M && z);
    }
    setStrokeHitEnabled(C) {
      r.Util.warn("strokeHitEnabled property is deprecated. Please use hitStrokeWidth instead."), C ? this.hitStrokeWidth("auto") : this.hitStrokeWidth(0);
    }
    getStrokeHitEnabled() {
      return this.hitStrokeWidth() !== 0;
    }
    getSelfRect() {
      var C = this.size();
      return {
        x: this._centroid ? -C.width / 2 : 0,
        y: this._centroid ? -C.height / 2 : 0,
        width: C.width,
        height: C.height
      };
    }
    getClientRect(C = {}) {
      const T = C.skipTransform, P = C.relativeTo, I = this.getSelfRect(), B = !C.skipStroke && this.hasStroke() && this.strokeWidth() || 0, M = I.width + B, z = I.height + B, L = !C.skipShadow && this.hasShadow(), J = L ? this.shadowOffsetX() : 0, ft = L ? this.shadowOffsetY() : 0, Q = M + Math.abs(J), xt = z + Math.abs(ft), St = L && this.shadowBlur() || 0, Pt = Q + St * 2, Gt = xt + St * 2, Rt = {
        width: Pt,
        height: Gt,
        x: -(B / 2 + St) + Math.min(J, 0) + I.x,
        y: -(B / 2 + St) + Math.min(ft, 0) + I.y
      };
      return T ? Rt : this._transformedRect(Rt, P);
    }
    drawScene(C, T) {
      var P = this.getLayer(), I = C || P.getCanvas(), F = I.getContext(), B = this._getCanvasCache(), M = this.getSceneFunc(), z = this.hasShadow(), L, J, ft, Q = I.isCache, xt = T === this;
      if (!this.isVisible() && !xt)
        return this;
      if (B) {
        F.save();
        var St = this.getAbsoluteTransform(T).getMatrix();
        return F.transform(St[0], St[1], St[2], St[3], St[4], St[5]), this._drawCachedSceneCanvas(F), F.restore(), this;
      }
      if (!M)
        return this;
      if (F.save(), this._useBufferCanvas() && !Q) {
        L = this.getStage(), J = L.bufferCanvas, ft = J.getContext(), ft.clear(), ft.save(), ft._applyLineJoin(this);
        var Pt = this.getAbsoluteTransform(T).getMatrix();
        ft.transform(Pt[0], Pt[1], Pt[2], Pt[3], Pt[4], Pt[5]), M.call(this, ft, this), ft.restore();
        var Gt = J.pixelRatio;
        z && F._applyShadow(this), F._applyOpacity(this), F._applyGlobalCompositeOperation(this), F.drawImage(J._canvas, 0, 0, J.width / Gt, J.height / Gt);
      } else {
        if (F._applyLineJoin(this), !xt) {
          var Pt = this.getAbsoluteTransform(T).getMatrix();
          F.transform(Pt[0], Pt[1], Pt[2], Pt[3], Pt[4], Pt[5]), F._applyOpacity(this), F._applyGlobalCompositeOperation(this);
        }
        z && F._applyShadow(this), M.call(this, F, this);
      }
      return F.restore(), this;
    }
    drawHit(C, T, P = !1) {
      if (!this.shouldDrawHit(T, P))
        return this;
      var I = this.getLayer(), F = C || I.hitCanvas, B = F && F.getContext(), M = this.hitFunc() || this.sceneFunc(), z = this._getCanvasCache(), L = z && z.hit;
      if (this.colorKey || r.Util.warn("Looks like your canvas has a destroyed shape in it. Do not reuse shape after you destroyed it. If you want to reuse shape you should call remove() instead of destroy()"), L) {
        B.save();
        var J = this.getAbsoluteTransform(T).getMatrix();
        return B.transform(J[0], J[1], J[2], J[3], J[4], J[5]), this._drawCachedHitCanvas(B), B.restore(), this;
      }
      if (!M)
        return this;
      if (B.save(), B._applyLineJoin(this), !(this === T)) {
        var Q = this.getAbsoluteTransform(T).getMatrix();
        B.transform(Q[0], Q[1], Q[2], Q[3], Q[4], Q[5]);
      }
      return M.call(this, B, this), B.restore(), this;
    }
    drawHitFromCache(C = 0) {
      var T = this._getCanvasCache(), P = this._getCachedSceneCanvas(), I = T.hit, F = I.getContext(), B = I.getWidth(), M = I.getHeight(), z, L, J, ft, Q, xt;
      F.clear(), F.drawImage(P._canvas, 0, 0, B, M);
      try {
        for (z = F.getImageData(0, 0, B, M), L = z.data, J = L.length, ft = r.Util._hexToRgb(this.colorKey), Q = 0; Q < J; Q += 4)
          xt = L[Q + 3], xt > C ? (L[Q] = ft.r, L[Q + 1] = ft.g, L[Q + 2] = ft.b, L[Q + 3] = 255) : L[Q + 3] = 0;
        F.putImageData(z, 0, 0);
      } catch (St) {
        r.Util.error("Unable to draw hit graph from cached scene canvas. " + St.message);
      }
      return this;
    }
    hasPointerCapture(C) {
      return l.hasPointerCapture(C, this);
    }
    setPointerCapture(C) {
      l.setPointerCapture(C, this);
    }
    releaseCapture(C) {
      l.releaseCapture(C, this);
    }
  }
  a.Shape = A, A.prototype._fillFunc = m, A.prototype._strokeFunc = x, A.prototype._fillFuncHit = g, A.prototype._strokeFuncHit = S, A.prototype._centroid = !1, A.prototype.nodeType = "Shape", (0, u._registerNode)(A), A.prototype.eventListeners = {}, A.prototype.on.call(A.prototype, "shadowColorChange.konva shadowBlurChange.konva shadowOffsetChange.konva shadowOpacityChange.konva shadowEnabledChange.konva", y), A.prototype.on.call(A.prototype, "shadowColorChange.konva shadowOpacityChange.konva shadowEnabledChange.konva", b), A.prototype.on.call(A.prototype, "fillPriorityChange.konva fillPatternImageChange.konva fillPatternRepeatChange.konva fillPatternScaleXChange.konva fillPatternScaleYChange.konva fillPatternOffsetXChange.konva fillPatternOffsetYChange.konva fillPatternXChange.konva fillPatternYChange.konva fillPatternRotationChange.konva", n), A.prototype.on.call(A.prototype, "fillPriorityChange.konva fillLinearGradientColorStopsChange.konva fillLinearGradientStartPointXChange.konva fillLinearGradientStartPointYChange.konva fillLinearGradientEndPointXChange.konva fillLinearGradientEndPointYChange.konva", w), A.prototype.on.call(A.prototype, "fillPriorityChange.konva fillRadialGradientColorStopsChange.konva fillRadialGradientStartPointXChange.konva fillRadialGradientStartPointYChange.konva fillRadialGradientEndPointXChange.konva fillRadialGradientEndPointYChange.konva fillRadialGradientStartRadiusChange.konva fillRadialGradientEndRadiusChange.konva", E), o.Factory.addGetterSetter(A, "stroke", void 0, (0, d.getStringOrGradientValidator)()), o.Factory.addGetterSetter(A, "strokeWidth", 2, (0, d.getNumberValidator)()), o.Factory.addGetterSetter(A, "fillAfterStrokeEnabled", !1), o.Factory.addGetterSetter(A, "hitStrokeWidth", "auto", (0, d.getNumberOrAutoValidator)()), o.Factory.addGetterSetter(A, "strokeHitEnabled", !0, (0, d.getBooleanValidator)()), o.Factory.addGetterSetter(A, "perfectDrawEnabled", !0, (0, d.getBooleanValidator)()), o.Factory.addGetterSetter(A, "shadowForStrokeEnabled", !0, (0, d.getBooleanValidator)()), o.Factory.addGetterSetter(A, "lineJoin"), o.Factory.addGetterSetter(A, "lineCap"), o.Factory.addGetterSetter(A, "sceneFunc"), o.Factory.addGetterSetter(A, "hitFunc"), o.Factory.addGetterSetter(A, "dash"), o.Factory.addGetterSetter(A, "dashOffset", 0, (0, d.getNumberValidator)()), o.Factory.addGetterSetter(A, "shadowColor", void 0, (0, d.getStringValidator)()), o.Factory.addGetterSetter(A, "shadowBlur", 0, (0, d.getNumberValidator)()), o.Factory.addGetterSetter(A, "shadowOpacity", 1, (0, d.getNumberValidator)()), o.Factory.addComponentsGetterSetter(A, "shadowOffset", ["x", "y"]), o.Factory.addGetterSetter(A, "shadowOffsetX", 0, (0, d.getNumberValidator)()), o.Factory.addGetterSetter(A, "shadowOffsetY", 0, (0, d.getNumberValidator)()), o.Factory.addGetterSetter(A, "fillPatternImage"), o.Factory.addGetterSetter(A, "fill", void 0, (0, d.getStringOrGradientValidator)()), o.Factory.addGetterSetter(A, "fillPatternX", 0, (0, d.getNumberValidator)()), o.Factory.addGetterSetter(A, "fillPatternY", 0, (0, d.getNumberValidator)()), o.Factory.addGetterSetter(A, "fillLinearGradientColorStops"), o.Factory.addGetterSetter(A, "strokeLinearGradientColorStops"), o.Factory.addGetterSetter(A, "fillRadialGradientStartRadius", 0), o.Factory.addGetterSetter(A, "fillRadialGradientEndRadius", 0), o.Factory.addGetterSetter(A, "fillRadialGradientColorStops"), o.Factory.addGetterSetter(A, "fillPatternRepeat", "repeat"), o.Factory.addGetterSetter(A, "fillEnabled", !0), o.Factory.addGetterSetter(A, "strokeEnabled", !0), o.Factory.addGetterSetter(A, "shadowEnabled", !0), o.Factory.addGetterSetter(A, "dashEnabled", !0), o.Factory.addGetterSetter(A, "strokeScaleEnabled", !0), o.Factory.addGetterSetter(A, "fillPriority", "color"), o.Factory.addComponentsGetterSetter(A, "fillPatternOffset", ["x", "y"]), o.Factory.addGetterSetter(A, "fillPatternOffsetX", 0, (0, d.getNumberValidator)()), o.Factory.addGetterSetter(A, "fillPatternOffsetY", 0, (0, d.getNumberValidator)()), o.Factory.addComponentsGetterSetter(A, "fillPatternScale", ["x", "y"]), o.Factory.addGetterSetter(A, "fillPatternScaleX", 1, (0, d.getNumberValidator)()), o.Factory.addGetterSetter(A, "fillPatternScaleY", 1, (0, d.getNumberValidator)()), o.Factory.addComponentsGetterSetter(A, "fillLinearGradientStartPoint", [
    "x",
    "y"
  ]), o.Factory.addComponentsGetterSetter(A, "strokeLinearGradientStartPoint", [
    "x",
    "y"
  ]), o.Factory.addGetterSetter(A, "fillLinearGradientStartPointX", 0), o.Factory.addGetterSetter(A, "strokeLinearGradientStartPointX", 0), o.Factory.addGetterSetter(A, "fillLinearGradientStartPointY", 0), o.Factory.addGetterSetter(A, "strokeLinearGradientStartPointY", 0), o.Factory.addComponentsGetterSetter(A, "fillLinearGradientEndPoint", [
    "x",
    "y"
  ]), o.Factory.addComponentsGetterSetter(A, "strokeLinearGradientEndPoint", [
    "x",
    "y"
  ]), o.Factory.addGetterSetter(A, "fillLinearGradientEndPointX", 0), o.Factory.addGetterSetter(A, "strokeLinearGradientEndPointX", 0), o.Factory.addGetterSetter(A, "fillLinearGradientEndPointY", 0), o.Factory.addGetterSetter(A, "strokeLinearGradientEndPointY", 0), o.Factory.addComponentsGetterSetter(A, "fillRadialGradientStartPoint", [
    "x",
    "y"
  ]), o.Factory.addGetterSetter(A, "fillRadialGradientStartPointX", 0), o.Factory.addGetterSetter(A, "fillRadialGradientStartPointY", 0), o.Factory.addComponentsGetterSetter(A, "fillRadialGradientEndPoint", [
    "x",
    "y"
  ]), o.Factory.addGetterSetter(A, "fillRadialGradientEndPointX", 0), o.Factory.addGetterSetter(A, "fillRadialGradientEndPointY", 0), o.Factory.addGetterSetter(A, "fillPatternRotation", 0), o.Factory.addGetterSetter(A, "fillRule", void 0, (0, d.getStringValidator)()), o.Factory.backCompat(A, {
    dashArray: "dash",
    getDashArray: "getDash",
    setDashArray: "getDash",
    drawFunc: "sceneFunc",
    getDrawFunc: "getSceneFunc",
    setDrawFunc: "setSceneFunc",
    drawHitFunc: "hitFunc",
    getDrawHitFunc: "getHitFunc",
    setDrawHitFunc: "setHitFunc"
  });
})(ri);
Object.defineProperty(I0, "__esModule", { value: !0 });
I0.Layer = void 0;
const Ca = zn, Yu = Lo, ts = Bn, lc = zr, Y1 = ea, uw = lr, hw = ri, cw = Hr;
var dw = "#", vw = "beforeDraw", gw = "draw", d2 = [
  { x: 0, y: 0 },
  { x: -1, y: -1 },
  { x: 1, y: -1 },
  { x: 1, y: 1 },
  { x: -1, y: 1 }
], pw = d2.length;
class Cs extends Yu.Container {
  constructor(t) {
    super(t), this.canvas = new Y1.SceneCanvas(), this.hitCanvas = new Y1.HitCanvas({
      pixelRatio: 1
    }), this._waitingForDraw = !1, this.on("visibleChange.konva", this._checkVisibility), this._checkVisibility(), this.on("imageSmoothingEnabledChange.konva", this._setSmoothEnabled), this._setSmoothEnabled();
  }
  createPNGStream() {
    return this.canvas._canvas.createPNGStream();
  }
  getCanvas() {
    return this.canvas;
  }
  getNativeCanvasElement() {
    return this.canvas._canvas;
  }
  getHitCanvas() {
    return this.hitCanvas;
  }
  getContext() {
    return this.getCanvas().getContext();
  }
  clear(t) {
    return this.getContext().clear(t), this.getHitCanvas().getContext().clear(t), this;
  }
  setZIndex(t) {
    super.setZIndex(t);
    var r = this.getStage();
    return r && r.content && (r.content.removeChild(this.getNativeCanvasElement()), t < r.children.length - 1 ? r.content.insertBefore(this.getNativeCanvasElement(), r.children[t + 1].getCanvas()._canvas) : r.content.appendChild(this.getNativeCanvasElement())), this;
  }
  moveToTop() {
    ts.Node.prototype.moveToTop.call(this);
    var t = this.getStage();
    return t && t.content && (t.content.removeChild(this.getNativeCanvasElement()), t.content.appendChild(this.getNativeCanvasElement())), !0;
  }
  moveUp() {
    var t = ts.Node.prototype.moveUp.call(this);
    if (!t)
      return !1;
    var r = this.getStage();
    return !r || !r.content ? !1 : (r.content.removeChild(this.getNativeCanvasElement()), this.index < r.children.length - 1 ? r.content.insertBefore(this.getNativeCanvasElement(), r.children[this.index + 1].getCanvas()._canvas) : r.content.appendChild(this.getNativeCanvasElement()), !0);
  }
  moveDown() {
    if (ts.Node.prototype.moveDown.call(this)) {
      var t = this.getStage();
      if (t) {
        var r = t.children;
        t.content && (t.content.removeChild(this.getNativeCanvasElement()), t.content.insertBefore(this.getNativeCanvasElement(), r[this.index + 1].getCanvas()._canvas));
      }
      return !0;
    }
    return !1;
  }
  moveToBottom() {
    if (ts.Node.prototype.moveToBottom.call(this)) {
      var t = this.getStage();
      if (t) {
        var r = t.children;
        t.content && (t.content.removeChild(this.getNativeCanvasElement()), t.content.insertBefore(this.getNativeCanvasElement(), r[1].getCanvas()._canvas));
      }
      return !0;
    }
    return !1;
  }
  getLayer() {
    return this;
  }
  remove() {
    var t = this.getNativeCanvasElement();
    return ts.Node.prototype.remove.call(this), t && t.parentNode && Ca.Util._isInDocument(t) && t.parentNode.removeChild(t), this;
  }
  getStage() {
    return this.parent;
  }
  setSize({ width: t, height: r }) {
    return this.canvas.setSize(t, r), this.hitCanvas.setSize(t, r), this._setSmoothEnabled(), this;
  }
  _validateAdd(t) {
    var r = t.getType();
    r !== "Group" && r !== "Shape" && Ca.Util.throw("You may only add groups and shapes to a layer.");
  }
  _toKonvaCanvas(t) {
    return t = t || {}, t.width = t.width || this.getWidth(), t.height = t.height || this.getHeight(), t.x = t.x !== void 0 ? t.x : this.x(), t.y = t.y !== void 0 ? t.y : this.y(), ts.Node.prototype._toKonvaCanvas.call(this, t);
  }
  _checkVisibility() {
    this.visible() ? this.canvas._canvas.style.display = "block" : this.canvas._canvas.style.display = "none";
  }
  _setSmoothEnabled() {
    this.getContext()._context.imageSmoothingEnabled = this.imageSmoothingEnabled();
  }
  getWidth() {
    if (this.parent)
      return this.parent.width();
  }
  setWidth() {
    Ca.Util.warn('Can not change width of layer. Use "stage.width(value)" function instead.');
  }
  getHeight() {
    if (this.parent)
      return this.parent.height();
  }
  setHeight() {
    Ca.Util.warn('Can not change height of layer. Use "stage.height(value)" function instead.');
  }
  batchDraw() {
    return this._waitingForDraw || (this._waitingForDraw = !0, Ca.Util.requestAnimFrame(() => {
      this.draw(), this._waitingForDraw = !1;
    })), this;
  }
  getIntersection(t) {
    if (!this.isListening() || !this.isVisible())
      return null;
    for (var r = 1, o = !1; ; ) {
      for (let c = 0; c < pw; c++) {
        const d = d2[c], u = this._getIntersection({
          x: t.x + d.x * r,
          y: t.y + d.y * r
        }), l = u.shape;
        if (l)
          return l;
        if (o = !!u.antialiased, !u.antialiased)
          break;
      }
      if (o)
        r += 1;
      else
        return null;
    }
  }
  _getIntersection(t) {
    const r = this.hitCanvas.pixelRatio, o = this.hitCanvas.context.getImageData(Math.round(t.x * r), Math.round(t.y * r), 1, 1).data, c = o[3];
    if (c === 255) {
      const d = Ca.Util._rgbToHex(o[0], o[1], o[2]), u = hw.shapes[dw + d];
      return u ? {
        shape: u
      } : {
        antialiased: !0
      };
    } else if (c > 0)
      return {
        antialiased: !0
      };
    return {};
  }
  drawScene(t, r) {
    var o = this.getLayer(), c = t || o && o.getCanvas();
    return this._fire(vw, {
      node: this
    }), this.clearBeforeDraw() && c.getContext().clear(), Yu.Container.prototype.drawScene.call(this, c, r), this._fire(gw, {
      node: this
    }), this;
  }
  drawHit(t, r) {
    var o = this.getLayer(), c = t || o && o.hitCanvas;
    return o && o.clearBeforeDraw() && o.getHitCanvas().getContext().clear(), Yu.Container.prototype.drawHit.call(this, c, r), this;
  }
  enableHitGraph() {
    return this.hitGraphEnabled(!0), this;
  }
  disableHitGraph() {
    return this.hitGraphEnabled(!1), this;
  }
  setHitGraphEnabled(t) {
    Ca.Util.warn("hitGraphEnabled method is deprecated. Please use layer.listening() instead."), this.listening(t);
  }
  getHitGraphEnabled(t) {
    return Ca.Util.warn("hitGraphEnabled method is deprecated. Please use layer.listening() instead."), this.listening();
  }
  toggleHitCanvas() {
    if (!(!this.parent || !this.parent.content)) {
      var t = this.parent, r = !!this.hitCanvas._canvas.parentNode;
      r ? t.content.removeChild(this.hitCanvas._canvas) : t.content.appendChild(this.hitCanvas._canvas);
    }
  }
  destroy() {
    return Ca.Util.releaseCanvas(this.getNativeCanvasElement(), this.getHitCanvas()._canvas), super.destroy();
  }
}
I0.Layer = Cs;
Cs.prototype.nodeType = "Layer";
(0, cw._registerNode)(Cs);
lc.Factory.addGetterSetter(Cs, "imageSmoothingEnabled", !0);
lc.Factory.addGetterSetter(Cs, "clearBeforeDraw", !0);
lc.Factory.addGetterSetter(Cs, "hitGraphEnabled", !0, (0, uw.getBooleanValidator)());
var cf = {};
Object.defineProperty(cf, "__esModule", { value: !0 });
cf.FastLayer = void 0;
const yw = zn, mw = I0, xw = Hr;
class fc extends mw.Layer {
  constructor(t) {
    super(t), this.listening(!1), yw.Util.warn('Konva.Fast layer is deprecated. Please use "new Konva.Layer({ listening: false })" instead.');
  }
}
cf.FastLayer = fc;
fc.prototype.nodeType = "FastLayer";
(0, xw._registerNode)(fc);
var Ts = {};
Object.defineProperty(Ts, "__esModule", { value: !0 });
Ts.Group = void 0;
const bw = zn, ww = Lo, Sw = Hr;
class uc extends ww.Container {
  _validateAdd(t) {
    var r = t.getType();
    r !== "Group" && r !== "Shape" && bw.Util.throw("You may only add groups and shapes to groups.");
  }
}
Ts.Group = uc;
uc.prototype.nodeType = "Group";
(0, Sw._registerNode)(uc);
var Ps = {};
Object.defineProperty(Ps, "__esModule", { value: !0 });
Ps.Animation = void 0;
const Zu = Hr, Z1 = zn, Ku = function() {
  return Zu.glob.performance && Zu.glob.performance.now ? function() {
    return Zu.glob.performance.now();
  } : function() {
    return (/* @__PURE__ */ new Date()).getTime();
  };
}();
class fa {
  constructor(t, r) {
    this.id = fa.animIdCounter++, this.frame = {
      time: 0,
      timeDiff: 0,
      lastTime: Ku(),
      frameRate: 0
    }, this.func = t, this.setLayers(r);
  }
  setLayers(t) {
    let r = [];
    return t && (r = Array.isArray(t) ? t : [t]), this.layers = r, this;
  }
  getLayers() {
    return this.layers;
  }
  addLayer(t) {
    const r = this.layers, o = r.length;
    for (let c = 0; c < o; c++)
      if (r[c]._id === t._id)
        return !1;
    return this.layers.push(t), !0;
  }
  isRunning() {
    const r = fa.animations, o = r.length;
    for (let c = 0; c < o; c++)
      if (r[c].id === this.id)
        return !0;
    return !1;
  }
  start() {
    return this.stop(), this.frame.timeDiff = 0, this.frame.lastTime = Ku(), fa._addAnimation(this), this;
  }
  stop() {
    return fa._removeAnimation(this), this;
  }
  _updateFrameObject(t) {
    this.frame.timeDiff = t - this.frame.lastTime, this.frame.lastTime = t, this.frame.time += this.frame.timeDiff, this.frame.frameRate = 1e3 / this.frame.timeDiff;
  }
  static _addAnimation(t) {
    this.animations.push(t), this._handleAnimation();
  }
  static _removeAnimation(t) {
    const r = t.id, o = this.animations, c = o.length;
    for (let d = 0; d < c; d++)
      if (o[d].id === r) {
        this.animations.splice(d, 1);
        break;
      }
  }
  static _runFrames() {
    const t = {}, r = this.animations;
    for (let o = 0; o < r.length; o++) {
      const c = r[o], d = c.layers, u = c.func;
      c._updateFrameObject(Ku());
      const l = d.length;
      let e;
      if (u ? e = u.call(c, c.frame) !== !1 : e = !0, !!e)
        for (let s = 0; s < l; s++) {
          const i = d[s];
          i._id !== void 0 && (t[i._id] = i);
        }
    }
    for (let o in t)
      t.hasOwnProperty(o) && t[o].batchDraw();
  }
  static _animationLoop() {
    const t = fa;
    t.animations.length ? (t._runFrames(), Z1.Util.requestAnimFrame(t._animationLoop)) : t.animRunning = !1;
  }
  static _handleAnimation() {
    this.animRunning || (this.animRunning = !0, Z1.Util.requestAnimFrame(this._animationLoop));
  }
}
Ps.Animation = fa;
fa.animations = [];
fa.animIdCounter = 0;
fa.animRunning = !1;
var v2 = {};
(function(a) {
  Object.defineProperty(a, "__esModule", { value: !0 }), a.Easings = a.Tween = void 0;
  const t = zn, r = Ps, o = Bn, c = Hr;
  var d = {
    node: 1,
    duration: 1,
    easing: 1,
    onFinish: 1,
    yoyo: 1
  }, u = 1, l = 2, e = 3, s = 0, i = ["fill", "stroke", "shadowColor"];
  class f {
    constructor(p, m, x, g, S, y, b) {
      this.prop = p, this.propFunc = m, this.begin = g, this._pos = g, this.duration = y, this._change = 0, this.prevPos = 0, this.yoyo = b, this._time = 0, this._position = 0, this._startTime = 0, this._finish = 0, this.func = x, this._change = S - this.begin, this.pause();
    }
    fire(p) {
      var m = this[p];
      m && m();
    }
    setTime(p) {
      p > this.duration ? this.yoyo ? (this._time = this.duration, this.reverse()) : this.finish() : p < 0 ? this.yoyo ? (this._time = 0, this.play()) : this.reset() : (this._time = p, this.update());
    }
    getTime() {
      return this._time;
    }
    setPosition(p) {
      this.prevPos = this._pos, this.propFunc(p), this._pos = p;
    }
    getPosition(p) {
      return p === void 0 && (p = this._time), this.func(p, this.begin, this._change, this.duration);
    }
    play() {
      this.state = l, this._startTime = this.getTimer() - this._time, this.onEnterFrame(), this.fire("onPlay");
    }
    reverse() {
      this.state = e, this._time = this.duration - this._time, this._startTime = this.getTimer() - this._time, this.onEnterFrame(), this.fire("onReverse");
    }
    seek(p) {
      this.pause(), this._time = p, this.update(), this.fire("onSeek");
    }
    reset() {
      this.pause(), this._time = 0, this.update(), this.fire("onReset");
    }
    finish() {
      this.pause(), this._time = this.duration, this.update(), this.fire("onFinish");
    }
    update() {
      this.setPosition(this.getPosition(this._time)), this.fire("onUpdate");
    }
    onEnterFrame() {
      var p = this.getTimer() - this._startTime;
      this.state === l ? this.setTime(p) : this.state === e && this.setTime(this.duration - p);
    }
    pause() {
      this.state = u, this.fire("onPause");
    }
    getTimer() {
      return (/* @__PURE__ */ new Date()).getTime();
    }
  }
  class h {
    constructor(p) {
      var m = this, x = p.node, g = x._id, S, y = p.easing || a.Easings.Linear, b = !!p.yoyo, n;
      typeof p.duration > "u" ? S = 0.3 : p.duration === 0 ? S = 1e-3 : S = p.duration, this.node = x, this._id = s++;
      var w = x.getLayer() || (x instanceof c.Konva.Stage ? x.getLayers() : null);
      w || t.Util.error("Tween constructor have `node` that is not in a layer. Please add node into layer first."), this.anim = new r.Animation(function() {
        m.tween.onEnterFrame();
      }, w), this.tween = new f(n, function(E) {
        m._tweenFunc(E);
      }, y, 0, 1, S * 1e3, b), this._addListeners(), h.attrs[g] || (h.attrs[g] = {}), h.attrs[g][this._id] || (h.attrs[g][this._id] = {}), h.tweens[g] || (h.tweens[g] = {});
      for (n in p)
        d[n] === void 0 && this._addAttr(n, p[n]);
      this.reset(), this.onFinish = p.onFinish, this.onReset = p.onReset, this.onUpdate = p.onUpdate;
    }
    _addAttr(p, m) {
      var x = this.node, g = x._id, S, y, b, n, w, E, A, O;
      if (b = h.tweens[g][p], b && delete h.attrs[g][b][p], S = x.getAttr(p), t.Util._isArray(m))
        if (y = [], w = Math.max(m.length, S.length), p === "points" && m.length !== S.length && (m.length > S.length ? (A = S, S = t.Util._prepareArrayForTween(S, m, x.closed())) : (E = m, m = t.Util._prepareArrayForTween(m, S, x.closed()))), p.indexOf("fill") === 0)
          for (n = 0; n < w; n++)
            if (n % 2 === 0)
              y.push(m[n] - S[n]);
            else {
              var C = t.Util.colorToRGBA(S[n]);
              O = t.Util.colorToRGBA(m[n]), S[n] = C, y.push({
                r: O.r - C.r,
                g: O.g - C.g,
                b: O.b - C.b,
                a: O.a - C.a
              });
            }
        else
          for (n = 0; n < w; n++)
            y.push(m[n] - S[n]);
      else
        i.indexOf(p) !== -1 ? (S = t.Util.colorToRGBA(S), O = t.Util.colorToRGBA(m), y = {
          r: O.r - S.r,
          g: O.g - S.g,
          b: O.b - S.b,
          a: O.a - S.a
        }) : y = m - S;
      h.attrs[g][this._id][p] = {
        start: S,
        diff: y,
        end: m,
        trueEnd: E,
        trueStart: A
      }, h.tweens[g][p] = this._id;
    }
    _tweenFunc(p) {
      var m = this.node, x = h.attrs[m._id][this._id], g, S, y, b, n, w, E, A;
      for (g in x) {
        if (S = x[g], y = S.start, b = S.diff, A = S.end, t.Util._isArray(y))
          if (n = [], E = Math.max(y.length, A.length), g.indexOf("fill") === 0)
            for (w = 0; w < E; w++)
              w % 2 === 0 ? n.push((y[w] || 0) + b[w] * p) : n.push("rgba(" + Math.round(y[w].r + b[w].r * p) + "," + Math.round(y[w].g + b[w].g * p) + "," + Math.round(y[w].b + b[w].b * p) + "," + (y[w].a + b[w].a * p) + ")");
          else
            for (w = 0; w < E; w++)
              n.push((y[w] || 0) + b[w] * p);
        else
          i.indexOf(g) !== -1 ? n = "rgba(" + Math.round(y.r + b.r * p) + "," + Math.round(y.g + b.g * p) + "," + Math.round(y.b + b.b * p) + "," + (y.a + b.a * p) + ")" : n = y + b * p;
        m.setAttr(g, n);
      }
    }
    _addListeners() {
      this.tween.onPlay = () => {
        this.anim.start();
      }, this.tween.onReverse = () => {
        this.anim.start();
      }, this.tween.onPause = () => {
        this.anim.stop();
      }, this.tween.onFinish = () => {
        var p = this.node, m = h.attrs[p._id][this._id];
        m.points && m.points.trueEnd && p.setAttr("points", m.points.trueEnd), this.onFinish && this.onFinish.call(this);
      }, this.tween.onReset = () => {
        var p = this.node, m = h.attrs[p._id][this._id];
        m.points && m.points.trueStart && p.points(m.points.trueStart), this.onReset && this.onReset();
      }, this.tween.onUpdate = () => {
        this.onUpdate && this.onUpdate.call(this);
      };
    }
    play() {
      return this.tween.play(), this;
    }
    reverse() {
      return this.tween.reverse(), this;
    }
    reset() {
      return this.tween.reset(), this;
    }
    seek(p) {
      return this.tween.seek(p * 1e3), this;
    }
    pause() {
      return this.tween.pause(), this;
    }
    finish() {
      return this.tween.finish(), this;
    }
    destroy() {
      var p = this.node._id, m = this._id, x = h.tweens[p], g;
      this.pause();
      for (g in x)
        delete h.tweens[p][g];
      delete h.attrs[p][m];
    }
  }
  a.Tween = h, h.attrs = {}, h.tweens = {}, o.Node.prototype.to = function(v) {
    var p = v.onFinish;
    v.node = this, v.onFinish = function() {
      this.destroy(), p && p();
    };
    var m = new h(v);
    m.play();
  }, a.Easings = {
    BackEaseIn(v, p, m, x) {
      var g = 1.70158;
      return m * (v /= x) * v * ((g + 1) * v - g) + p;
    },
    BackEaseOut(v, p, m, x) {
      var g = 1.70158;
      return m * ((v = v / x - 1) * v * ((g + 1) * v + g) + 1) + p;
    },
    BackEaseInOut(v, p, m, x) {
      var g = 1.70158;
      return (v /= x / 2) < 1 ? m / 2 * (v * v * (((g *= 1.525) + 1) * v - g)) + p : m / 2 * ((v -= 2) * v * (((g *= 1.525) + 1) * v + g) + 2) + p;
    },
    ElasticEaseIn(v, p, m, x, g, S) {
      var y = 0;
      return v === 0 ? p : (v /= x) === 1 ? p + m : (S || (S = x * 0.3), !g || g < Math.abs(m) ? (g = m, y = S / 4) : y = S / (2 * Math.PI) * Math.asin(m / g), -(g * Math.pow(2, 10 * (v -= 1)) * Math.sin((v * x - y) * (2 * Math.PI) / S)) + p);
    },
    ElasticEaseOut(v, p, m, x, g, S) {
      var y = 0;
      return v === 0 ? p : (v /= x) === 1 ? p + m : (S || (S = x * 0.3), !g || g < Math.abs(m) ? (g = m, y = S / 4) : y = S / (2 * Math.PI) * Math.asin(m / g), g * Math.pow(2, -10 * v) * Math.sin((v * x - y) * (2 * Math.PI) / S) + m + p);
    },
    ElasticEaseInOut(v, p, m, x, g, S) {
      var y = 0;
      return v === 0 ? p : (v /= x / 2) === 2 ? p + m : (S || (S = x * (0.3 * 1.5)), !g || g < Math.abs(m) ? (g = m, y = S / 4) : y = S / (2 * Math.PI) * Math.asin(m / g), v < 1 ? -0.5 * (g * Math.pow(2, 10 * (v -= 1)) * Math.sin((v * x - y) * (2 * Math.PI) / S)) + p : g * Math.pow(2, -10 * (v -= 1)) * Math.sin((v * x - y) * (2 * Math.PI) / S) * 0.5 + m + p);
    },
    BounceEaseOut(v, p, m, x) {
      return (v /= x) < 1 / 2.75 ? m * (7.5625 * v * v) + p : v < 2 / 2.75 ? m * (7.5625 * (v -= 1.5 / 2.75) * v + 0.75) + p : v < 2.5 / 2.75 ? m * (7.5625 * (v -= 2.25 / 2.75) * v + 0.9375) + p : m * (7.5625 * (v -= 2.625 / 2.75) * v + 0.984375) + p;
    },
    BounceEaseIn(v, p, m, x) {
      return m - a.Easings.BounceEaseOut(x - v, 0, m, x) + p;
    },
    BounceEaseInOut(v, p, m, x) {
      return v < x / 2 ? a.Easings.BounceEaseIn(v * 2, 0, m, x) * 0.5 + p : a.Easings.BounceEaseOut(v * 2 - x, 0, m, x) * 0.5 + m * 0.5 + p;
    },
    EaseIn(v, p, m, x) {
      return m * (v /= x) * v + p;
    },
    EaseOut(v, p, m, x) {
      return -m * (v /= x) * (v - 2) + p;
    },
    EaseInOut(v, p, m, x) {
      return (v /= x / 2) < 1 ? m / 2 * v * v + p : -m / 2 * (--v * (v - 2) - 1) + p;
    },
    StrongEaseIn(v, p, m, x) {
      return m * (v /= x) * v * v * v * v + p;
    },
    StrongEaseOut(v, p, m, x) {
      return m * ((v = v / x - 1) * v * v * v * v + 1) + p;
    },
    StrongEaseInOut(v, p, m, x) {
      return (v /= x / 2) < 1 ? m / 2 * v * v * v * v * v + p : m / 2 * ((v -= 2) * v * v * v * v + 2) + p;
    },
    Linear(v, p, m, x) {
      return m * v / x + p;
    }
  };
})(v2);
(function(a) {
  Object.defineProperty(a, "__esModule", { value: !0 }), a.Konva = void 0;
  const t = Hr, r = zn, o = Bn, c = Lo, d = u2, u = I0, l = cf, e = Ts, s = uf, i = ri, f = Ps, h = v2, v = Ia, p = ea;
  a.Konva = r.Util._assign(t.Konva, {
    Util: r.Util,
    Transform: r.Transform,
    Node: o.Node,
    Container: c.Container,
    Stage: d.Stage,
    stages: d.stages,
    Layer: u.Layer,
    FastLayer: l.FastLayer,
    Group: e.Group,
    DD: s.DD,
    Shape: i.Shape,
    shapes: i.shapes,
    Animation: f.Animation,
    Tween: h.Tween,
    Easings: h.Easings,
    Context: v.Context,
    Canvas: p.Canvas
  }), a.default = a.Konva;
})(o2);
var df = {};
Object.defineProperty(df, "__esModule", { value: !0 });
df.Arc = void 0;
const vf = zr, Ew = ri, K1 = Hr, gf = lr, Aw = Hr;
class Ba extends Ew.Shape {
  _sceneFunc(t) {
    var r = K1.Konva.getAngle(this.angle()), o = this.clockwise();
    t.beginPath(), t.arc(0, 0, this.outerRadius(), 0, r, o), t.arc(0, 0, this.innerRadius(), r, 0, !o), t.closePath(), t.fillStrokeShape(this);
  }
  getWidth() {
    return this.outerRadius() * 2;
  }
  getHeight() {
    return this.outerRadius() * 2;
  }
  setWidth(t) {
    this.outerRadius(t / 2);
  }
  setHeight(t) {
    this.outerRadius(t / 2);
  }
  getSelfRect() {
    const t = this.innerRadius(), r = this.outerRadius(), o = this.clockwise(), c = K1.Konva.getAngle(o ? 360 - this.angle() : this.angle()), d = Math.cos(Math.min(c, Math.PI)), u = 1, l = Math.sin(Math.min(Math.max(Math.PI, c), 3 * Math.PI / 2)), e = Math.sin(Math.min(c, Math.PI / 2)), s = d * (d > 0 ? t : r), i = u * r, f = l * (l > 0 ? t : r), h = e * (e > 0 ? r : t);
    return {
      x: s,
      y: o ? -1 * h : f,
      width: i - s,
      height: h - f
    };
  }
}
df.Arc = Ba;
Ba.prototype._centroid = !0;
Ba.prototype.className = "Arc";
Ba.prototype._attrsAffectingSize = ["innerRadius", "outerRadius"];
(0, Aw._registerNode)(Ba);
vf.Factory.addGetterSetter(Ba, "innerRadius", 0, (0, gf.getNumberValidator)());
vf.Factory.addGetterSetter(Ba, "outerRadius", 0, (0, gf.getNumberValidator)());
vf.Factory.addGetterSetter(Ba, "angle", 0, (0, gf.getNumberValidator)());
vf.Factory.addGetterSetter(Ba, "clockwise", !1, (0, gf.getBooleanValidator)());
var pf = {}, R0 = {};
Object.defineProperty(R0, "__esModule", { value: !0 });
R0.Line = void 0;
const yf = zr, Cw = ri, g2 = lr, Tw = Hr;
function Ah(a, t, r, o, c, d, u) {
  var l = Math.sqrt(Math.pow(r - a, 2) + Math.pow(o - t, 2)), e = Math.sqrt(Math.pow(c - r, 2) + Math.pow(d - o, 2)), s = u * l / (l + e), i = u * e / (l + e), f = r - s * (c - a), h = o - s * (d - t), v = r + i * (c - a), p = o + i * (d - t);
  return [f, h, v, p];
}
function J1(a, t) {
  var r = a.length, o = [], c, d;
  for (c = 2; c < r - 2; c += 2)
    d = Ah(a[c - 2], a[c - 1], a[c], a[c + 1], a[c + 2], a[c + 3], t), !isNaN(d[0]) && (o.push(d[0]), o.push(d[1]), o.push(a[c]), o.push(a[c + 1]), o.push(d[2]), o.push(d[3]));
  return o;
}
class no extends Cw.Shape {
  constructor(t) {
    super(t), this.on("pointsChange.konva tensionChange.konva closedChange.konva bezierChange.konva", function() {
      this._clearCache("tensionPoints");
    });
  }
  _sceneFunc(t) {
    var r = this.points(), o = r.length, c = this.tension(), d = this.closed(), u = this.bezier(), l, e, s;
    if (o) {
      if (t.beginPath(), t.moveTo(r[0], r[1]), c !== 0 && o > 4) {
        for (l = this.getTensionPoints(), e = l.length, s = d ? 0 : 4, d || t.quadraticCurveTo(l[0], l[1], l[2], l[3]); s < e - 2; )
          t.bezierCurveTo(l[s++], l[s++], l[s++], l[s++], l[s++], l[s++]);
        d || t.quadraticCurveTo(l[e - 2], l[e - 1], r[o - 2], r[o - 1]);
      } else if (u)
        for (s = 2; s < o; )
          t.bezierCurveTo(r[s++], r[s++], r[s++], r[s++], r[s++], r[s++]);
      else
        for (s = 2; s < o; s += 2)
          t.lineTo(r[s], r[s + 1]);
      d ? (t.closePath(), t.fillStrokeShape(this)) : t.strokeShape(this);
    }
  }
  getTensionPoints() {
    return this._getCache("tensionPoints", this._getTensionPoints);
  }
  _getTensionPoints() {
    return this.closed() ? this._getTensionPointsClosed() : J1(this.points(), this.tension());
  }
  _getTensionPointsClosed() {
    var t = this.points(), r = t.length, o = this.tension(), c = Ah(t[r - 2], t[r - 1], t[0], t[1], t[2], t[3], o), d = Ah(t[r - 4], t[r - 3], t[r - 2], t[r - 1], t[0], t[1], o), u = J1(t, o), l = [c[2], c[3]].concat(u).concat([
      d[0],
      d[1],
      t[r - 2],
      t[r - 1],
      d[2],
      d[3],
      c[0],
      c[1],
      t[0],
      t[1]
    ]);
    return l;
  }
  getWidth() {
    return this.getSelfRect().width;
  }
  getHeight() {
    return this.getSelfRect().height;
  }
  getSelfRect() {
    var t = this.points();
    if (t.length < 4)
      return {
        x: t[0] || 0,
        y: t[1] || 0,
        width: 0,
        height: 0
      };
    this.tension() !== 0 ? t = [
      t[0],
      t[1],
      ...this._getTensionPoints(),
      t[t.length - 2],
      t[t.length - 1]
    ] : t = this.points();
    for (var r = t[0], o = t[0], c = t[1], d = t[1], u, l, e = 0; e < t.length / 2; e++)
      u = t[e * 2], l = t[e * 2 + 1], r = Math.min(r, u), o = Math.max(o, u), c = Math.min(c, l), d = Math.max(d, l);
    return {
      x: r,
      y: c,
      width: o - r,
      height: d - c
    };
  }
}
R0.Line = no;
no.prototype.className = "Line";
no.prototype._attrsAffectingSize = ["points", "bezier", "tension"];
(0, Tw._registerNode)(no);
yf.Factory.addGetterSetter(no, "closed", !1);
yf.Factory.addGetterSetter(no, "bezier", !1);
yf.Factory.addGetterSetter(no, "tension", 0, (0, g2.getNumberValidator)());
yf.Factory.addGetterSetter(no, "points", [], (0, g2.getNumberArrayValidator)());
var Os = {}, p2 = {};
(function(a) {
  Object.defineProperty(a, "__esModule", { value: !0 }), a.t2length = a.getQuadraticArcLength = a.getCubicArcLength = a.binomialCoefficients = a.cValues = a.tValues = void 0, a.tValues = [
    [],
    [],
    [
      -0.5773502691896257,
      0.5773502691896257
    ],
    [
      0,
      -0.7745966692414834,
      0.7745966692414834
    ],
    [
      -0.33998104358485626,
      0.33998104358485626,
      -0.8611363115940526,
      0.8611363115940526
    ],
    [
      0,
      -0.5384693101056831,
      0.5384693101056831,
      -0.906179845938664,
      0.906179845938664
    ],
    [
      0.6612093864662645,
      -0.6612093864662645,
      -0.2386191860831969,
      0.2386191860831969,
      -0.932469514203152,
      0.932469514203152
    ],
    [
      0,
      0.4058451513773972,
      -0.4058451513773972,
      -0.7415311855993945,
      0.7415311855993945,
      -0.9491079123427585,
      0.9491079123427585
    ],
    [
      -0.1834346424956498,
      0.1834346424956498,
      -0.525532409916329,
      0.525532409916329,
      -0.7966664774136267,
      0.7966664774136267,
      -0.9602898564975363,
      0.9602898564975363
    ],
    [
      0,
      -0.8360311073266358,
      0.8360311073266358,
      -0.9681602395076261,
      0.9681602395076261,
      -0.3242534234038089,
      0.3242534234038089,
      -0.6133714327005904,
      0.6133714327005904
    ],
    [
      -0.14887433898163122,
      0.14887433898163122,
      -0.4333953941292472,
      0.4333953941292472,
      -0.6794095682990244,
      0.6794095682990244,
      -0.8650633666889845,
      0.8650633666889845,
      -0.9739065285171717,
      0.9739065285171717
    ],
    [
      0,
      -0.26954315595234496,
      0.26954315595234496,
      -0.5190961292068118,
      0.5190961292068118,
      -0.7301520055740494,
      0.7301520055740494,
      -0.8870625997680953,
      0.8870625997680953,
      -0.978228658146057,
      0.978228658146057
    ],
    [
      -0.1252334085114689,
      0.1252334085114689,
      -0.3678314989981802,
      0.3678314989981802,
      -0.5873179542866175,
      0.5873179542866175,
      -0.7699026741943047,
      0.7699026741943047,
      -0.9041172563704749,
      0.9041172563704749,
      -0.9815606342467192,
      0.9815606342467192
    ],
    [
      0,
      -0.2304583159551348,
      0.2304583159551348,
      -0.44849275103644687,
      0.44849275103644687,
      -0.6423493394403402,
      0.6423493394403402,
      -0.8015780907333099,
      0.8015780907333099,
      -0.9175983992229779,
      0.9175983992229779,
      -0.9841830547185881,
      0.9841830547185881
    ],
    [
      -0.10805494870734367,
      0.10805494870734367,
      -0.31911236892788974,
      0.31911236892788974,
      -0.5152486363581541,
      0.5152486363581541,
      -0.6872929048116855,
      0.6872929048116855,
      -0.827201315069765,
      0.827201315069765,
      -0.9284348836635735,
      0.9284348836635735,
      -0.9862838086968123,
      0.9862838086968123
    ],
    [
      0,
      -0.20119409399743451,
      0.20119409399743451,
      -0.3941513470775634,
      0.3941513470775634,
      -0.5709721726085388,
      0.5709721726085388,
      -0.7244177313601701,
      0.7244177313601701,
      -0.8482065834104272,
      0.8482065834104272,
      -0.937273392400706,
      0.937273392400706,
      -0.9879925180204854,
      0.9879925180204854
    ],
    [
      -0.09501250983763744,
      0.09501250983763744,
      -0.2816035507792589,
      0.2816035507792589,
      -0.45801677765722737,
      0.45801677765722737,
      -0.6178762444026438,
      0.6178762444026438,
      -0.755404408355003,
      0.755404408355003,
      -0.8656312023878318,
      0.8656312023878318,
      -0.9445750230732326,
      0.9445750230732326,
      -0.9894009349916499,
      0.9894009349916499
    ],
    [
      0,
      -0.17848418149584785,
      0.17848418149584785,
      -0.3512317634538763,
      0.3512317634538763,
      -0.5126905370864769,
      0.5126905370864769,
      -0.6576711592166907,
      0.6576711592166907,
      -0.7815140038968014,
      0.7815140038968014,
      -0.8802391537269859,
      0.8802391537269859,
      -0.9506755217687678,
      0.9506755217687678,
      -0.9905754753144174,
      0.9905754753144174
    ],
    [
      -0.0847750130417353,
      0.0847750130417353,
      -0.2518862256915055,
      0.2518862256915055,
      -0.41175116146284263,
      0.41175116146284263,
      -0.5597708310739475,
      0.5597708310739475,
      -0.6916870430603532,
      0.6916870430603532,
      -0.8037049589725231,
      0.8037049589725231,
      -0.8926024664975557,
      0.8926024664975557,
      -0.9558239495713977,
      0.9558239495713977,
      -0.9915651684209309,
      0.9915651684209309
    ],
    [
      0,
      -0.16035864564022537,
      0.16035864564022537,
      -0.31656409996362983,
      0.31656409996362983,
      -0.46457074137596094,
      0.46457074137596094,
      -0.600545304661681,
      0.600545304661681,
      -0.7209661773352294,
      0.7209661773352294,
      -0.8227146565371428,
      0.8227146565371428,
      -0.9031559036148179,
      0.9031559036148179,
      -0.96020815213483,
      0.96020815213483,
      -0.9924068438435844,
      0.9924068438435844
    ],
    [
      -0.07652652113349734,
      0.07652652113349734,
      -0.22778585114164507,
      0.22778585114164507,
      -0.37370608871541955,
      0.37370608871541955,
      -0.5108670019508271,
      0.5108670019508271,
      -0.636053680726515,
      0.636053680726515,
      -0.7463319064601508,
      0.7463319064601508,
      -0.8391169718222188,
      0.8391169718222188,
      -0.912234428251326,
      0.912234428251326,
      -0.9639719272779138,
      0.9639719272779138,
      -0.9931285991850949,
      0.9931285991850949
    ],
    [
      0,
      -0.1455618541608951,
      0.1455618541608951,
      -0.2880213168024011,
      0.2880213168024011,
      -0.4243421202074388,
      0.4243421202074388,
      -0.5516188358872198,
      0.5516188358872198,
      -0.6671388041974123,
      0.6671388041974123,
      -0.7684399634756779,
      0.7684399634756779,
      -0.8533633645833173,
      0.8533633645833173,
      -0.9200993341504008,
      0.9200993341504008,
      -0.9672268385663063,
      0.9672268385663063,
      -0.9937521706203895,
      0.9937521706203895
    ],
    [
      -0.06973927331972223,
      0.06973927331972223,
      -0.20786042668822127,
      0.20786042668822127,
      -0.34193582089208424,
      0.34193582089208424,
      -0.469355837986757,
      0.469355837986757,
      -0.5876404035069116,
      0.5876404035069116,
      -0.6944872631866827,
      0.6944872631866827,
      -0.7878168059792081,
      0.7878168059792081,
      -0.8658125777203002,
      0.8658125777203002,
      -0.926956772187174,
      0.926956772187174,
      -0.9700604978354287,
      0.9700604978354287,
      -0.9942945854823992,
      0.9942945854823992
    ],
    [
      0,
      -0.1332568242984661,
      0.1332568242984661,
      -0.26413568097034495,
      0.26413568097034495,
      -0.3903010380302908,
      0.3903010380302908,
      -0.5095014778460075,
      0.5095014778460075,
      -0.6196098757636461,
      0.6196098757636461,
      -0.7186613631319502,
      0.7186613631319502,
      -0.8048884016188399,
      0.8048884016188399,
      -0.8767523582704416,
      0.8767523582704416,
      -0.9329710868260161,
      0.9329710868260161,
      -0.9725424712181152,
      0.9725424712181152,
      -0.9947693349975522,
      0.9947693349975522
    ],
    [
      -0.06405689286260563,
      0.06405689286260563,
      -0.1911188674736163,
      0.1911188674736163,
      -0.3150426796961634,
      0.3150426796961634,
      -0.4337935076260451,
      0.4337935076260451,
      -0.5454214713888396,
      0.5454214713888396,
      -0.6480936519369755,
      0.6480936519369755,
      -0.7401241915785544,
      0.7401241915785544,
      -0.820001985973903,
      0.820001985973903,
      -0.8864155270044011,
      0.8864155270044011,
      -0.9382745520027328,
      0.9382745520027328,
      -0.9747285559713095,
      0.9747285559713095,
      -0.9951872199970213,
      0.9951872199970213
    ]
  ], a.cValues = [
    [],
    [],
    [1, 1],
    [
      0.8888888888888888,
      0.5555555555555556,
      0.5555555555555556
    ],
    [
      0.6521451548625461,
      0.6521451548625461,
      0.34785484513745385,
      0.34785484513745385
    ],
    [
      0.5688888888888889,
      0.47862867049936647,
      0.47862867049936647,
      0.23692688505618908,
      0.23692688505618908
    ],
    [
      0.3607615730481386,
      0.3607615730481386,
      0.46791393457269104,
      0.46791393457269104,
      0.17132449237917036,
      0.17132449237917036
    ],
    [
      0.4179591836734694,
      0.3818300505051189,
      0.3818300505051189,
      0.27970539148927664,
      0.27970539148927664,
      0.1294849661688697,
      0.1294849661688697
    ],
    [
      0.362683783378362,
      0.362683783378362,
      0.31370664587788727,
      0.31370664587788727,
      0.22238103445337448,
      0.22238103445337448,
      0.10122853629037626,
      0.10122853629037626
    ],
    [
      0.3302393550012598,
      0.1806481606948574,
      0.1806481606948574,
      0.08127438836157441,
      0.08127438836157441,
      0.31234707704000286,
      0.31234707704000286,
      0.26061069640293544,
      0.26061069640293544
    ],
    [
      0.29552422471475287,
      0.29552422471475287,
      0.26926671930999635,
      0.26926671930999635,
      0.21908636251598204,
      0.21908636251598204,
      0.1494513491505806,
      0.1494513491505806,
      0.06667134430868814,
      0.06667134430868814
    ],
    [
      0.2729250867779006,
      0.26280454451024665,
      0.26280454451024665,
      0.23319376459199048,
      0.23319376459199048,
      0.18629021092773426,
      0.18629021092773426,
      0.1255803694649046,
      0.1255803694649046,
      0.05566856711617366,
      0.05566856711617366
    ],
    [
      0.24914704581340277,
      0.24914704581340277,
      0.2334925365383548,
      0.2334925365383548,
      0.20316742672306592,
      0.20316742672306592,
      0.16007832854334622,
      0.16007832854334622,
      0.10693932599531843,
      0.10693932599531843,
      0.04717533638651183,
      0.04717533638651183
    ],
    [
      0.2325515532308739,
      0.22628318026289723,
      0.22628318026289723,
      0.2078160475368885,
      0.2078160475368885,
      0.17814598076194574,
      0.17814598076194574,
      0.13887351021978725,
      0.13887351021978725,
      0.09212149983772845,
      0.09212149983772845,
      0.04048400476531588,
      0.04048400476531588
    ],
    [
      0.2152638534631578,
      0.2152638534631578,
      0.2051984637212956,
      0.2051984637212956,
      0.18553839747793782,
      0.18553839747793782,
      0.15720316715819355,
      0.15720316715819355,
      0.12151857068790319,
      0.12151857068790319,
      0.08015808715976021,
      0.08015808715976021,
      0.03511946033175186,
      0.03511946033175186
    ],
    [
      0.2025782419255613,
      0.19843148532711158,
      0.19843148532711158,
      0.1861610000155622,
      0.1861610000155622,
      0.16626920581699392,
      0.16626920581699392,
      0.13957067792615432,
      0.13957067792615432,
      0.10715922046717194,
      0.10715922046717194,
      0.07036604748810812,
      0.07036604748810812,
      0.03075324199611727,
      0.03075324199611727
    ],
    [
      0.1894506104550685,
      0.1894506104550685,
      0.18260341504492358,
      0.18260341504492358,
      0.16915651939500254,
      0.16915651939500254,
      0.14959598881657674,
      0.14959598881657674,
      0.12462897125553388,
      0.12462897125553388,
      0.09515851168249279,
      0.09515851168249279,
      0.062253523938647894,
      0.062253523938647894,
      0.027152459411754096,
      0.027152459411754096
    ],
    [
      0.17944647035620653,
      0.17656270536699264,
      0.17656270536699264,
      0.16800410215645004,
      0.16800410215645004,
      0.15404576107681028,
      0.15404576107681028,
      0.13513636846852548,
      0.13513636846852548,
      0.11188384719340397,
      0.11188384719340397,
      0.08503614831717918,
      0.08503614831717918,
      0.0554595293739872,
      0.0554595293739872,
      0.02414830286854793,
      0.02414830286854793
    ],
    [
      0.1691423829631436,
      0.1691423829631436,
      0.16427648374583273,
      0.16427648374583273,
      0.15468467512626524,
      0.15468467512626524,
      0.14064291467065065,
      0.14064291467065065,
      0.12255520671147846,
      0.12255520671147846,
      0.10094204410628717,
      0.10094204410628717,
      0.07642573025488905,
      0.07642573025488905,
      0.0497145488949698,
      0.0497145488949698,
      0.02161601352648331,
      0.02161601352648331
    ],
    [
      0.1610544498487837,
      0.15896884339395434,
      0.15896884339395434,
      0.15276604206585967,
      0.15276604206585967,
      0.1426067021736066,
      0.1426067021736066,
      0.12875396253933621,
      0.12875396253933621,
      0.11156664554733399,
      0.11156664554733399,
      0.09149002162245,
      0.09149002162245,
      0.06904454273764123,
      0.06904454273764123,
      0.0448142267656996,
      0.0448142267656996,
      0.019461788229726478,
      0.019461788229726478
    ],
    [
      0.15275338713072584,
      0.15275338713072584,
      0.14917298647260374,
      0.14917298647260374,
      0.14209610931838204,
      0.14209610931838204,
      0.13168863844917664,
      0.13168863844917664,
      0.11819453196151841,
      0.11819453196151841,
      0.10193011981724044,
      0.10193011981724044,
      0.08327674157670475,
      0.08327674157670475,
      0.06267204833410907,
      0.06267204833410907,
      0.04060142980038694,
      0.04060142980038694,
      0.017614007139152118,
      0.017614007139152118
    ],
    [
      0.14608113364969041,
      0.14452440398997005,
      0.14452440398997005,
      0.13988739479107315,
      0.13988739479107315,
      0.13226893863333747,
      0.13226893863333747,
      0.12183141605372853,
      0.12183141605372853,
      0.10879729916714838,
      0.10879729916714838,
      0.09344442345603386,
      0.09344442345603386,
      0.0761001136283793,
      0.0761001136283793,
      0.057134425426857205,
      0.057134425426857205,
      0.036953789770852494,
      0.036953789770852494,
      0.016017228257774335,
      0.016017228257774335
    ],
    [
      0.13925187285563198,
      0.13925187285563198,
      0.13654149834601517,
      0.13654149834601517,
      0.13117350478706238,
      0.13117350478706238,
      0.12325237681051242,
      0.12325237681051242,
      0.11293229608053922,
      0.11293229608053922,
      0.10041414444288096,
      0.10041414444288096,
      0.08594160621706773,
      0.08594160621706773,
      0.06979646842452049,
      0.06979646842452049,
      0.052293335152683286,
      0.052293335152683286,
      0.03377490158481415,
      0.03377490158481415,
      0.0146279952982722,
      0.0146279952982722
    ],
    [
      0.13365457218610619,
      0.1324620394046966,
      0.1324620394046966,
      0.12890572218808216,
      0.12890572218808216,
      0.12304908430672953,
      0.12304908430672953,
      0.11499664022241136,
      0.11499664022241136,
      0.10489209146454141,
      0.10489209146454141,
      0.09291576606003515,
      0.09291576606003515,
      0.07928141177671895,
      0.07928141177671895,
      0.06423242140852585,
      0.06423242140852585,
      0.04803767173108467,
      0.04803767173108467,
      0.030988005856979445,
      0.030988005856979445,
      0.013411859487141771,
      0.013411859487141771
    ],
    [
      0.12793819534675216,
      0.12793819534675216,
      0.1258374563468283,
      0.1258374563468283,
      0.12167047292780339,
      0.12167047292780339,
      0.1155056680537256,
      0.1155056680537256,
      0.10744427011596563,
      0.10744427011596563,
      0.09761865210411388,
      0.09761865210411388,
      0.08619016153195327,
      0.08619016153195327,
      0.0733464814110803,
      0.0733464814110803,
      0.05929858491543678,
      0.05929858491543678,
      0.04427743881741981,
      0.04427743881741981,
      0.028531388628933663,
      0.028531388628933663,
      0.0123412297999872,
      0.0123412297999872
    ]
  ], a.binomialCoefficients = [[1], [1, 1], [1, 2, 1], [1, 3, 3, 1]];
  const t = (u, l, e) => {
    let s, i, f;
    s = e / 2, i = 0;
    for (let v = 0; v < 20; v++)
      f = s * a.tValues[20][v] + s, i += a.cValues[20][v] * o(u, l, f);
    return s * i;
  };
  a.getCubicArcLength = t;
  const r = (u, l, e) => {
    e === void 0 && (e = 1);
    const s = u[0] - 2 * u[1] + u[2], i = l[0] - 2 * l[1] + l[2], f = 2 * u[1] - 2 * u[0], h = 2 * l[1] - 2 * l[0], v = 4 * (s * s + i * i), p = 4 * (s * f + i * h), m = f * f + h * h;
    if (v === 0)
      return e * Math.sqrt(Math.pow(u[2] - u[0], 2) + Math.pow(l[2] - l[0], 2));
    const x = p / (2 * v), g = m / v, S = e + x, y = g - x * x, b = S * S + y > 0 ? Math.sqrt(S * S + y) : 0, n = x * x + y > 0 ? Math.sqrt(x * x + y) : 0, w = x + Math.sqrt(x * x + y) !== 0 ? y * Math.log(Math.abs((S + b) / (x + n))) : 0;
    return Math.sqrt(v) / 2 * (S * b - x * n + w);
  };
  a.getQuadraticArcLength = r;
  function o(u, l, e) {
    const s = c(1, e, u), i = c(1, e, l), f = s * s + i * i;
    return Math.sqrt(f);
  }
  const c = (u, l, e) => {
    const s = e.length - 1;
    let i, f;
    if (s === 0)
      return 0;
    if (u === 0) {
      f = 0;
      for (let h = 0; h <= s; h++)
        f += a.binomialCoefficients[s][h] * Math.pow(1 - l, s - h) * Math.pow(l, h) * e[h];
      return f;
    } else {
      i = new Array(s);
      for (let h = 0; h < s; h++)
        i[h] = s * (e[h + 1] - e[h]);
      return c(u - 1, l, i);
    }
  }, d = (u, l, e) => {
    let s = 1, i = u / l, f = (u - e(i)) / l, h = 0;
    for (; s > 1e-3; ) {
      const v = e(i + f), p = Math.abs(u - v) / l;
      if (p < s)
        s = p, i += f;
      else {
        const m = e(i - f), x = Math.abs(u - m) / l;
        x < s ? (s = x, i -= f) : f /= 2;
      }
      if (h++, h > 500)
        break;
    }
    return i;
  };
  a.t2length = d;
})(p2);
Object.defineProperty(Os, "__esModule", { value: !0 });
Os.Path = void 0;
const Pw = zr, Ow = ri, Fw = Hr, es = p2;
class ei extends Ow.Shape {
  constructor(t) {
    super(t), this.dataArray = [], this.pathLength = 0, this._readDataAttribute(), this.on("dataChange.konva", function() {
      this._readDataAttribute();
    });
  }
  _readDataAttribute() {
    this.dataArray = ei.parsePathData(this.data()), this.pathLength = ei.getPathLength(this.dataArray);
  }
  _sceneFunc(t) {
    var r = this.dataArray;
    t.beginPath();
    for (var o = !1, c = 0; c < r.length; c++) {
      var d = r[c].command, u = r[c].points;
      switch (d) {
        case "L":
          t.lineTo(u[0], u[1]);
          break;
        case "M":
          t.moveTo(u[0], u[1]);
          break;
        case "C":
          t.bezierCurveTo(u[0], u[1], u[2], u[3], u[4], u[5]);
          break;
        case "Q":
          t.quadraticCurveTo(u[0], u[1], u[2], u[3]);
          break;
        case "A":
          var l = u[0], e = u[1], s = u[2], i = u[3], f = u[4], h = u[5], v = u[6], p = u[7], m = s > i ? s : i, x = s > i ? 1 : s / i, g = s > i ? i / s : 1;
          t.translate(l, e), t.rotate(v), t.scale(x, g), t.arc(0, 0, m, f, f + h, 1 - p), t.scale(1 / x, 1 / g), t.rotate(-v), t.translate(-l, -e);
          break;
        case "z":
          o = !0, t.closePath();
          break;
      }
    }
    !o && !this.hasFill() ? t.strokeShape(this) : t.fillStrokeShape(this);
  }
  getSelfRect() {
    var t = [];
    this.dataArray.forEach(function(s) {
      if (s.command === "A") {
        var i = s.points[4], f = s.points[5], h = s.points[4] + f, v = Math.PI / 180;
        if (Math.abs(i - h) < v && (v = Math.abs(i - h)), f < 0)
          for (let p = i - v; p > h; p -= v) {
            const m = ei.getPointOnEllipticalArc(s.points[0], s.points[1], s.points[2], s.points[3], p, 0);
            t.push(m.x, m.y);
          }
        else
          for (let p = i + v; p < h; p += v) {
            const m = ei.getPointOnEllipticalArc(s.points[0], s.points[1], s.points[2], s.points[3], p, 0);
            t.push(m.x, m.y);
          }
      } else if (s.command === "C")
        for (let p = 0; p <= 1; p += 0.01) {
          const m = ei.getPointOnCubicBezier(p, s.start.x, s.start.y, s.points[0], s.points[1], s.points[2], s.points[3], s.points[4], s.points[5]);
          t.push(m.x, m.y);
        }
      else
        t = t.concat(s.points);
    });
    for (var r = t[0], o = t[0], c = t[1], d = t[1], u, l, e = 0; e < t.length / 2; e++)
      u = t[e * 2], l = t[e * 2 + 1], isNaN(u) || (r = Math.min(r, u), o = Math.max(o, u)), isNaN(l) || (c = Math.min(c, l), d = Math.max(d, l));
    return {
      x: r,
      y: c,
      width: o - r,
      height: d - c
    };
  }
  getLength() {
    return this.pathLength;
  }
  getPointAtLength(t) {
    return ei.getPointAtLengthOfDataArray(t, this.dataArray);
  }
  static getLineLength(t, r, o, c) {
    return Math.sqrt((o - t) * (o - t) + (c - r) * (c - r));
  }
  static getPathLength(t) {
    let r = 0;
    for (var o = 0; o < t.length; ++o)
      r += t[o].pathLength;
    return r;
  }
  static getPointAtLengthOfDataArray(t, r) {
    var o, c = 0, d = r.length;
    if (!d)
      return null;
    for (; c < d && t > r[c].pathLength; )
      t -= r[c].pathLength, ++c;
    if (c === d)
      return o = r[c - 1].points.slice(-2), {
        x: o[0],
        y: o[1]
      };
    if (t < 0.01)
      return o = r[c].points.slice(0, 2), {
        x: o[0],
        y: o[1]
      };
    var u = r[c], l = u.points;
    switch (u.command) {
      case "L":
        return ei.getPointOnLine(t, u.start.x, u.start.y, l[0], l[1]);
      case "C":
        return ei.getPointOnCubicBezier((0, es.t2length)(t, ei.getPathLength(r), (m) => (0, es.getCubicArcLength)([u.start.x, l[0], l[2], l[4]], [u.start.y, l[1], l[3], l[5]], m)), u.start.x, u.start.y, l[0], l[1], l[2], l[3], l[4], l[5]);
      case "Q":
        return ei.getPointOnQuadraticBezier((0, es.t2length)(t, ei.getPathLength(r), (m) => (0, es.getQuadraticArcLength)([u.start.x, l[0], l[2]], [u.start.y, l[1], l[3]], m)), u.start.x, u.start.y, l[0], l[1], l[2], l[3]);
      case "A":
        var e = l[0], s = l[1], i = l[2], f = l[3], h = l[4], v = l[5], p = l[6];
        return h += v * t / u.pathLength, ei.getPointOnEllipticalArc(e, s, i, f, h, p);
    }
    return null;
  }
  static getPointOnLine(t, r, o, c, d, u, l) {
    u === void 0 && (u = r), l === void 0 && (l = o);
    var e = (d - o) / (c - r + 1e-8), s = Math.sqrt(t * t / (1 + e * e));
    c < r && (s *= -1);
    var i = e * s, f;
    if (c === r)
      f = {
        x: u,
        y: l + i
      };
    else if ((l - o) / (u - r + 1e-8) === e)
      f = {
        x: u + s,
        y: l + i
      };
    else {
      var h, v, p = this.getLineLength(r, o, c, d), m = (u - r) * (c - r) + (l - o) * (d - o);
      m = m / (p * p), h = r + m * (c - r), v = o + m * (d - o);
      var x = this.getLineLength(u, l, h, v), g = Math.sqrt(t * t - x * x);
      s = Math.sqrt(g * g / (1 + e * e)), c < r && (s *= -1), i = e * s, f = {
        x: h + s,
        y: v + i
      };
    }
    return f;
  }
  static getPointOnCubicBezier(t, r, o, c, d, u, l, e, s) {
    function i(x) {
      return x * x * x;
    }
    function f(x) {
      return 3 * x * x * (1 - x);
    }
    function h(x) {
      return 3 * x * (1 - x) * (1 - x);
    }
    function v(x) {
      return (1 - x) * (1 - x) * (1 - x);
    }
    var p = e * i(t) + u * f(t) + c * h(t) + r * v(t), m = s * i(t) + l * f(t) + d * h(t) + o * v(t);
    return {
      x: p,
      y: m
    };
  }
  static getPointOnQuadraticBezier(t, r, o, c, d, u, l) {
    function e(v) {
      return v * v;
    }
    function s(v) {
      return 2 * v * (1 - v);
    }
    function i(v) {
      return (1 - v) * (1 - v);
    }
    var f = u * e(t) + c * s(t) + r * i(t), h = l * e(t) + d * s(t) + o * i(t);
    return {
      x: f,
      y: h
    };
  }
  static getPointOnEllipticalArc(t, r, o, c, d, u) {
    var l = Math.cos(u), e = Math.sin(u), s = {
      x: o * Math.cos(d),
      y: c * Math.sin(d)
    };
    return {
      x: t + (s.x * l - s.y * e),
      y: r + (s.x * e + s.y * l)
    };
  }
  static parsePathData(t) {
    if (!t)
      return [];
    var r = t, o = [
      "m",
      "M",
      "l",
      "L",
      "v",
      "V",
      "h",
      "H",
      "z",
      "Z",
      "c",
      "C",
      "q",
      "Q",
      "t",
      "T",
      "s",
      "S",
      "a",
      "A"
    ];
    r = r.replace(new RegExp(" ", "g"), ",");
    for (var c = 0; c < o.length; c++)
      r = r.replace(new RegExp(o[c], "g"), "|" + o[c]);
    var d = r.split("|"), u = [], l = [], e = 0, s = 0, i = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:e[-+]?\d+)?)/gi, f;
    for (c = 1; c < d.length; c++) {
      var h = d[c], v = h.charAt(0);
      for (h = h.slice(1), l.length = 0; f = i.exec(h); )
        l.push(f[0]);
      for (var p = [], m = 0, x = l.length; m < x; m++) {
        if (l[m] === "00") {
          p.push(0, 0);
          continue;
        }
        var g = parseFloat(l[m]);
        isNaN(g) ? p.push(0) : p.push(g);
      }
      for (; p.length > 0 && !isNaN(p[0]); ) {
        var S = "", y = [], b = e, n = s, w, E, A, O, C, T, P, I, F, B;
        switch (v) {
          case "l":
            e += p.shift(), s += p.shift(), S = "L", y.push(e, s);
            break;
          case "L":
            e = p.shift(), s = p.shift(), y.push(e, s);
            break;
          case "m":
            var M = p.shift(), z = p.shift();
            if (e += M, s += z, S = "M", u.length > 2 && u[u.length - 1].command === "z") {
              for (var L = u.length - 2; L >= 0; L--)
                if (u[L].command === "M") {
                  e = u[L].points[0] + M, s = u[L].points[1] + z;
                  break;
                }
            }
            y.push(e, s), v = "l";
            break;
          case "M":
            e = p.shift(), s = p.shift(), S = "M", y.push(e, s), v = "L";
            break;
          case "h":
            e += p.shift(), S = "L", y.push(e, s);
            break;
          case "H":
            e = p.shift(), S = "L", y.push(e, s);
            break;
          case "v":
            s += p.shift(), S = "L", y.push(e, s);
            break;
          case "V":
            s = p.shift(), S = "L", y.push(e, s);
            break;
          case "C":
            y.push(p.shift(), p.shift(), p.shift(), p.shift()), e = p.shift(), s = p.shift(), y.push(e, s);
            break;
          case "c":
            y.push(e + p.shift(), s + p.shift(), e + p.shift(), s + p.shift()), e += p.shift(), s += p.shift(), S = "C", y.push(e, s);
            break;
          case "S":
            E = e, A = s, w = u[u.length - 1], w.command === "C" && (E = e + (e - w.points[2]), A = s + (s - w.points[3])), y.push(E, A, p.shift(), p.shift()), e = p.shift(), s = p.shift(), S = "C", y.push(e, s);
            break;
          case "s":
            E = e, A = s, w = u[u.length - 1], w.command === "C" && (E = e + (e - w.points[2]), A = s + (s - w.points[3])), y.push(E, A, e + p.shift(), s + p.shift()), e += p.shift(), s += p.shift(), S = "C", y.push(e, s);
            break;
          case "Q":
            y.push(p.shift(), p.shift()), e = p.shift(), s = p.shift(), y.push(e, s);
            break;
          case "q":
            y.push(e + p.shift(), s + p.shift()), e += p.shift(), s += p.shift(), S = "Q", y.push(e, s);
            break;
          case "T":
            E = e, A = s, w = u[u.length - 1], w.command === "Q" && (E = e + (e - w.points[0]), A = s + (s - w.points[1])), e = p.shift(), s = p.shift(), S = "Q", y.push(E, A, e, s);
            break;
          case "t":
            E = e, A = s, w = u[u.length - 1], w.command === "Q" && (E = e + (e - w.points[0]), A = s + (s - w.points[1])), e += p.shift(), s += p.shift(), S = "Q", y.push(E, A, e, s);
            break;
          case "A":
            O = p.shift(), C = p.shift(), T = p.shift(), P = p.shift(), I = p.shift(), F = e, B = s, e = p.shift(), s = p.shift(), S = "A", y = this.convertEndpointToCenterParameterization(F, B, e, s, P, I, O, C, T);
            break;
          case "a":
            O = p.shift(), C = p.shift(), T = p.shift(), P = p.shift(), I = p.shift(), F = e, B = s, e += p.shift(), s += p.shift(), S = "A", y = this.convertEndpointToCenterParameterization(F, B, e, s, P, I, O, C, T);
            break;
        }
        u.push({
          command: S || v,
          points: y,
          start: {
            x: b,
            y: n
          },
          pathLength: this.calcLength(b, n, S || v, y)
        });
      }
      (v === "z" || v === "Z") && u.push({
        command: "z",
        points: [],
        start: void 0,
        pathLength: 0
      });
    }
    return u;
  }
  static calcLength(t, r, o, c) {
    var d, u, l, e, s = ei;
    switch (o) {
      case "L":
        return s.getLineLength(t, r, c[0], c[1]);
      case "C":
        return (0, es.getCubicArcLength)([t, c[0], c[2], c[4]], [r, c[1], c[3], c[5]], 1);
      case "Q":
        return (0, es.getQuadraticArcLength)([t, c[0], c[2]], [r, c[1], c[3]], 1);
      case "A":
        d = 0;
        var i = c[4], f = c[5], h = c[4] + f, v = Math.PI / 180;
        if (Math.abs(i - h) < v && (v = Math.abs(i - h)), u = s.getPointOnEllipticalArc(c[0], c[1], c[2], c[3], i, 0), f < 0)
          for (e = i - v; e > h; e -= v)
            l = s.getPointOnEllipticalArc(c[0], c[1], c[2], c[3], e, 0), d += s.getLineLength(u.x, u.y, l.x, l.y), u = l;
        else
          for (e = i + v; e < h; e += v)
            l = s.getPointOnEllipticalArc(c[0], c[1], c[2], c[3], e, 0), d += s.getLineLength(u.x, u.y, l.x, l.y), u = l;
        return l = s.getPointOnEllipticalArc(c[0], c[1], c[2], c[3], h, 0), d += s.getLineLength(u.x, u.y, l.x, l.y), d;
    }
    return 0;
  }
  static convertEndpointToCenterParameterization(t, r, o, c, d, u, l, e, s) {
    var i = s * (Math.PI / 180), f = Math.cos(i) * (t - o) / 2 + Math.sin(i) * (r - c) / 2, h = -1 * Math.sin(i) * (t - o) / 2 + Math.cos(i) * (r - c) / 2, v = f * f / (l * l) + h * h / (e * e);
    v > 1 && (l *= Math.sqrt(v), e *= Math.sqrt(v));
    var p = Math.sqrt((l * l * (e * e) - l * l * (h * h) - e * e * (f * f)) / (l * l * (h * h) + e * e * (f * f)));
    d === u && (p *= -1), isNaN(p) && (p = 0);
    var m = p * l * h / e, x = p * -e * f / l, g = (t + o) / 2 + Math.cos(i) * m - Math.sin(i) * x, S = (r + c) / 2 + Math.sin(i) * m + Math.cos(i) * x, y = function(C) {
      return Math.sqrt(C[0] * C[0] + C[1] * C[1]);
    }, b = function(C, T) {
      return (C[0] * T[0] + C[1] * T[1]) / (y(C) * y(T));
    }, n = function(C, T) {
      return (C[0] * T[1] < C[1] * T[0] ? -1 : 1) * Math.acos(b(C, T));
    }, w = n([1, 0], [(f - m) / l, (h - x) / e]), E = [(f - m) / l, (h - x) / e], A = [(-1 * f - m) / l, (-1 * h - x) / e], O = n(E, A);
    return b(E, A) <= -1 && (O = Math.PI), b(E, A) >= 1 && (O = 0), u === 0 && O > 0 && (O = O - 2 * Math.PI), u === 1 && O < 0 && (O = O + 2 * Math.PI), [g, S, l, e, w, O, i, u];
  }
}
Os.Path = ei;
ei.prototype.className = "Path";
ei.prototype._attrsAffectingSize = ["data"];
(0, Fw._registerNode)(ei);
Pw.Factory.addGetterSetter(ei, "data");
Object.defineProperty(pf, "__esModule", { value: !0 });
pf.Arrow = void 0;
const mf = zr, Iw = R0, y2 = lr, Rw = Hr, Q1 = Os;
class zo extends Iw.Line {
  _sceneFunc(t) {
    super._sceneFunc(t);
    var r = Math.PI * 2, o = this.points(), c = o, d = this.tension() !== 0 && o.length > 4;
    d && (c = this.getTensionPoints());
    var u = this.pointerLength(), l = o.length, e, s;
    if (d) {
      const h = [
        c[c.length - 4],
        c[c.length - 3],
        c[c.length - 2],
        c[c.length - 1],
        o[l - 2],
        o[l - 1]
      ], v = Q1.Path.calcLength(c[c.length - 4], c[c.length - 3], "C", h), p = Q1.Path.getPointOnQuadraticBezier(Math.min(1, 1 - u / v), h[0], h[1], h[2], h[3], h[4], h[5]);
      e = o[l - 2] - p.x, s = o[l - 1] - p.y;
    } else
      e = o[l - 2] - o[l - 4], s = o[l - 1] - o[l - 3];
    var i = (Math.atan2(s, e) + r) % r, f = this.pointerWidth();
    this.pointerAtEnding() && (t.save(), t.beginPath(), t.translate(o[l - 2], o[l - 1]), t.rotate(i), t.moveTo(0, 0), t.lineTo(-u, f / 2), t.lineTo(-u, -f / 2), t.closePath(), t.restore(), this.__fillStroke(t)), this.pointerAtBeginning() && (t.save(), t.beginPath(), t.translate(o[0], o[1]), d ? (e = (c[0] + c[2]) / 2 - o[0], s = (c[1] + c[3]) / 2 - o[1]) : (e = o[2] - o[0], s = o[3] - o[1]), t.rotate((Math.atan2(-s, -e) + r) % r), t.moveTo(0, 0), t.lineTo(-u, f / 2), t.lineTo(-u, -f / 2), t.closePath(), t.restore(), this.__fillStroke(t));
  }
  __fillStroke(t) {
    var r = this.dashEnabled();
    r && (this.attrs.dashEnabled = !1, t.setLineDash([])), t.fillStrokeShape(this), r && (this.attrs.dashEnabled = !0);
  }
  getSelfRect() {
    const t = super.getSelfRect(), r = this.pointerWidth() / 2;
    return {
      x: t.x - r,
      y: t.y - r,
      width: t.width + r * 2,
      height: t.height + r * 2
    };
  }
}
pf.Arrow = zo;
zo.prototype.className = "Arrow";
(0, Rw._registerNode)(zo);
mf.Factory.addGetterSetter(zo, "pointerLength", 10, (0, y2.getNumberValidator)());
mf.Factory.addGetterSetter(zo, "pointerWidth", 10, (0, y2.getNumberValidator)());
mf.Factory.addGetterSetter(zo, "pointerAtBeginning", !1);
mf.Factory.addGetterSetter(zo, "pointerAtEnding", !0);
var xf = {};
Object.defineProperty(xf, "__esModule", { value: !0 });
xf.Circle = void 0;
const Dw = zr, Mw = ri, Bw = lr, kw = Hr;
class Fs extends Mw.Shape {
  _sceneFunc(t) {
    t.beginPath(), t.arc(0, 0, this.attrs.radius || 0, 0, Math.PI * 2, !1), t.closePath(), t.fillStrokeShape(this);
  }
  getWidth() {
    return this.radius() * 2;
  }
  getHeight() {
    return this.radius() * 2;
  }
  setWidth(t) {
    this.radius() !== t / 2 && this.radius(t / 2);
  }
  setHeight(t) {
    this.radius() !== t / 2 && this.radius(t / 2);
  }
}
xf.Circle = Fs;
Fs.prototype._centroid = !0;
Fs.prototype.className = "Circle";
Fs.prototype._attrsAffectingSize = ["radius"];
(0, kw._registerNode)(Fs);
Dw.Factory.addGetterSetter(Fs, "radius", 0, (0, Bw.getNumberValidator)());
var bf = {};
Object.defineProperty(bf, "__esModule", { value: !0 });
bf.Ellipse = void 0;
const hc = zr, Nw = ri, m2 = lr, Lw = Hr;
class io extends Nw.Shape {
  _sceneFunc(t) {
    var r = this.radiusX(), o = this.radiusY();
    t.beginPath(), t.save(), r !== o && t.scale(1, o / r), t.arc(0, 0, r, 0, Math.PI * 2, !1), t.restore(), t.closePath(), t.fillStrokeShape(this);
  }
  getWidth() {
    return this.radiusX() * 2;
  }
  getHeight() {
    return this.radiusY() * 2;
  }
  setWidth(t) {
    this.radiusX(t / 2);
  }
  setHeight(t) {
    this.radiusY(t / 2);
  }
}
bf.Ellipse = io;
io.prototype.className = "Ellipse";
io.prototype._centroid = !0;
io.prototype._attrsAffectingSize = ["radiusX", "radiusY"];
(0, Lw._registerNode)(io);
hc.Factory.addComponentsGetterSetter(io, "radius", ["x", "y"]);
hc.Factory.addGetterSetter(io, "radiusX", 0, (0, m2.getNumberValidator)());
hc.Factory.addGetterSetter(io, "radiusY", 0, (0, m2.getNumberValidator)());
var wf = {};
Object.defineProperty(wf, "__esModule", { value: !0 });
wf.Image = void 0;
const Ju = zn, Go = zr, Uw = ri, zw = Hr, D0 = lr;
class Xi extends Uw.Shape {
  constructor(t) {
    super(t), this.on("imageChange.konva", () => {
      this._setImageLoad();
    }), this._setImageLoad();
  }
  _setImageLoad() {
    const t = this.image();
    t && t.complete || t && t.readyState === 4 || t && t.addEventListener && t.addEventListener("load", () => {
      this._requestDraw();
    });
  }
  _useBufferCanvas() {
    return super._useBufferCanvas(!0);
  }
  _sceneFunc(t) {
    const r = this.getWidth(), o = this.getHeight(), c = this.cornerRadius(), d = this.attrs.image;
    let u;
    if (d) {
      const l = this.attrs.cropWidth, e = this.attrs.cropHeight;
      l && e ? u = [
        d,
        this.cropX(),
        this.cropY(),
        l,
        e,
        0,
        0,
        r,
        o
      ] : u = [d, 0, 0, r, o];
    }
    (this.hasFill() || this.hasStroke() || c) && (t.beginPath(), c ? Ju.Util.drawRoundedRectPath(t, r, o, c) : t.rect(0, 0, r, o), t.closePath(), t.fillStrokeShape(this)), d && (c && t.clip(), t.drawImage.apply(t, u));
  }
  _hitFunc(t) {
    var r = this.width(), o = this.height(), c = this.cornerRadius();
    t.beginPath(), c ? Ju.Util.drawRoundedRectPath(t, r, o, c) : t.rect(0, 0, r, o), t.closePath(), t.fillStrokeShape(this);
  }
  getWidth() {
    var t, r;
    return (t = this.attrs.width) !== null && t !== void 0 ? t : (r = this.image()) === null || r === void 0 ? void 0 : r.width;
  }
  getHeight() {
    var t, r;
    return (t = this.attrs.height) !== null && t !== void 0 ? t : (r = this.image()) === null || r === void 0 ? void 0 : r.height;
  }
  static fromURL(t, r, o = null) {
    var c = Ju.Util.createImageElement();
    c.onload = function() {
      var d = new Xi({
        image: c
      });
      r(d);
    }, c.onerror = o, c.crossOrigin = "Anonymous", c.src = t;
  }
}
wf.Image = Xi;
Xi.prototype.className = "Image";
(0, zw._registerNode)(Xi);
Go.Factory.addGetterSetter(Xi, "cornerRadius", 0, (0, D0.getNumberOrArrayOfNumbersValidator)(4));
Go.Factory.addGetterSetter(Xi, "image");
Go.Factory.addComponentsGetterSetter(Xi, "crop", ["x", "y", "width", "height"]);
Go.Factory.addGetterSetter(Xi, "cropX", 0, (0, D0.getNumberValidator)());
Go.Factory.addGetterSetter(Xi, "cropY", 0, (0, D0.getNumberValidator)());
Go.Factory.addGetterSetter(Xi, "cropWidth", 0, (0, D0.getNumberValidator)());
Go.Factory.addGetterSetter(Xi, "cropHeight", 0, (0, D0.getNumberValidator)());
var gs = {};
Object.defineProperty(gs, "__esModule", { value: !0 });
gs.Tag = gs.Label = void 0;
const Sf = zr, Gw = ri, Vw = Ts, cc = lr, x2 = Hr;
var b2 = [
  "fontFamily",
  "fontSize",
  "fontStyle",
  "padding",
  "lineHeight",
  "text",
  "width",
  "height",
  "pointerDirection",
  "pointerWidth",
  "pointerHeight"
], Hw = "Change.konva", Ww = "none", Ch = "up", Th = "right", Ph = "down", Oh = "left", _w = b2.length;
class dc extends Vw.Group {
  constructor(t) {
    super(t), this.on("add.konva", function(r) {
      this._addListeners(r.child), this._sync();
    });
  }
  getText() {
    return this.find("Text")[0];
  }
  getTag() {
    return this.find("Tag")[0];
  }
  _addListeners(t) {
    var r = this, o, c = function() {
      r._sync();
    };
    for (o = 0; o < _w; o++)
      t.on(b2[o] + Hw, c);
  }
  getWidth() {
    return this.getText().width();
  }
  getHeight() {
    return this.getText().height();
  }
  _sync() {
    var t = this.getText(), r = this.getTag(), o, c, d, u, l, e, s;
    if (t && r) {
      switch (o = t.width(), c = t.height(), d = r.pointerDirection(), u = r.pointerWidth(), s = r.pointerHeight(), l = 0, e = 0, d) {
        case Ch:
          l = o / 2, e = -1 * s;
          break;
        case Th:
          l = o + u, e = c / 2;
          break;
        case Ph:
          l = o / 2, e = c + s;
          break;
        case Oh:
          l = -1 * u, e = c / 2;
          break;
      }
      r.setAttrs({
        x: -1 * l,
        y: -1 * e,
        width: o,
        height: c
      }), t.setAttrs({
        x: -1 * l,
        y: -1 * e
      });
    }
  }
}
gs.Label = dc;
dc.prototype.className = "Label";
(0, x2._registerNode)(dc);
class Vo extends Gw.Shape {
  _sceneFunc(t) {
    var r = this.width(), o = this.height(), c = this.pointerDirection(), d = this.pointerWidth(), u = this.pointerHeight(), l = this.cornerRadius();
    let e = 0, s = 0, i = 0, f = 0;
    typeof l == "number" ? e = s = i = f = Math.min(l, r / 2, o / 2) : (e = Math.min(l[0] || 0, r / 2, o / 2), s = Math.min(l[1] || 0, r / 2, o / 2), f = Math.min(l[2] || 0, r / 2, o / 2), i = Math.min(l[3] || 0, r / 2, o / 2)), t.beginPath(), t.moveTo(e, 0), c === Ch && (t.lineTo((r - d) / 2, 0), t.lineTo(r / 2, -1 * u), t.lineTo((r + d) / 2, 0)), t.lineTo(r - s, 0), t.arc(r - s, s, s, Math.PI * 3 / 2, 0, !1), c === Th && (t.lineTo(r, (o - u) / 2), t.lineTo(r + d, o / 2), t.lineTo(r, (o + u) / 2)), t.lineTo(r, o - f), t.arc(r - f, o - f, f, 0, Math.PI / 2, !1), c === Ph && (t.lineTo((r + d) / 2, o), t.lineTo(r / 2, o + u), t.lineTo((r - d) / 2, o)), t.lineTo(i, o), t.arc(i, o - i, i, Math.PI / 2, Math.PI, !1), c === Oh && (t.lineTo(0, (o + u) / 2), t.lineTo(-1 * d, o / 2), t.lineTo(0, (o - u) / 2)), t.lineTo(0, e), t.arc(e, e, e, Math.PI, Math.PI * 3 / 2, !1), t.closePath(), t.fillStrokeShape(this);
  }
  getSelfRect() {
    var t = 0, r = 0, o = this.pointerWidth(), c = this.pointerHeight(), d = this.pointerDirection(), u = this.width(), l = this.height();
    return d === Ch ? (r -= c, l += c) : d === Ph ? l += c : d === Oh ? (t -= o * 1.5, u += o) : d === Th && (u += o * 1.5), {
      x: t,
      y: r,
      width: u,
      height: l
    };
  }
}
gs.Tag = Vo;
Vo.prototype.className = "Tag";
(0, x2._registerNode)(Vo);
Sf.Factory.addGetterSetter(Vo, "pointerDirection", Ww);
Sf.Factory.addGetterSetter(Vo, "pointerWidth", 0, (0, cc.getNumberValidator)());
Sf.Factory.addGetterSetter(Vo, "pointerHeight", 0, (0, cc.getNumberValidator)());
Sf.Factory.addGetterSetter(Vo, "cornerRadius", 0, (0, cc.getNumberOrArrayOfNumbersValidator)(4));
var M0 = {};
Object.defineProperty(M0, "__esModule", { value: !0 });
M0.Rect = void 0;
const jw = zr, Xw = ri, Yw = Hr, Zw = zn, Kw = lr;
class Ef extends Xw.Shape {
  _sceneFunc(t) {
    var r = this.cornerRadius(), o = this.width(), c = this.height();
    t.beginPath(), r ? Zw.Util.drawRoundedRectPath(t, o, c, r) : t.rect(0, 0, o, c), t.closePath(), t.fillStrokeShape(this);
  }
}
M0.Rect = Ef;
Ef.prototype.className = "Rect";
(0, Yw._registerNode)(Ef);
jw.Factory.addGetterSetter(Ef, "cornerRadius", 0, (0, Kw.getNumberOrArrayOfNumbersValidator)(4));
var Af = {};
Object.defineProperty(Af, "__esModule", { value: !0 });
Af.RegularPolygon = void 0;
const w2 = zr, Jw = ri, S2 = lr, Qw = Hr;
class Ho extends Jw.Shape {
  _sceneFunc(t) {
    const r = this._getPoints();
    t.beginPath(), t.moveTo(r[0].x, r[0].y);
    for (var o = 1; o < r.length; o++)
      t.lineTo(r[o].x, r[o].y);
    t.closePath(), t.fillStrokeShape(this);
  }
  _getPoints() {
    const t = this.attrs.sides, r = this.attrs.radius || 0, o = [];
    for (var c = 0; c < t; c++)
      o.push({
        x: r * Math.sin(c * 2 * Math.PI / t),
        y: -1 * r * Math.cos(c * 2 * Math.PI / t)
      });
    return o;
  }
  getSelfRect() {
    const t = this._getPoints();
    var r = t[0].x, o = t[0].y, c = t[0].x, d = t[0].y;
    return t.forEach((u) => {
      r = Math.min(r, u.x), o = Math.max(o, u.x), c = Math.min(c, u.y), d = Math.max(d, u.y);
    }), {
      x: r,
      y: c,
      width: o - r,
      height: d - c
    };
  }
  getWidth() {
    return this.radius() * 2;
  }
  getHeight() {
    return this.radius() * 2;
  }
  setWidth(t) {
    this.radius(t / 2);
  }
  setHeight(t) {
    this.radius(t / 2);
  }
}
Af.RegularPolygon = Ho;
Ho.prototype.className = "RegularPolygon";
Ho.prototype._centroid = !0;
Ho.prototype._attrsAffectingSize = ["radius"];
(0, Qw._registerNode)(Ho);
w2.Factory.addGetterSetter(Ho, "radius", 0, (0, S2.getNumberValidator)());
w2.Factory.addGetterSetter(Ho, "sides", 0, (0, S2.getNumberValidator)());
var Cf = {};
Object.defineProperty(Cf, "__esModule", { value: !0 });
Cf.Ring = void 0;
const E2 = zr, $w = ri, A2 = lr, qw = Hr;
var $1 = Math.PI * 2;
class Wo extends $w.Shape {
  _sceneFunc(t) {
    t.beginPath(), t.arc(0, 0, this.innerRadius(), 0, $1, !1), t.moveTo(this.outerRadius(), 0), t.arc(0, 0, this.outerRadius(), $1, 0, !0), t.closePath(), t.fillStrokeShape(this);
  }
  getWidth() {
    return this.outerRadius() * 2;
  }
  getHeight() {
    return this.outerRadius() * 2;
  }
  setWidth(t) {
    this.outerRadius(t / 2);
  }
  setHeight(t) {
    this.outerRadius(t / 2);
  }
}
Cf.Ring = Wo;
Wo.prototype.className = "Ring";
Wo.prototype._centroid = !0;
Wo.prototype._attrsAffectingSize = ["innerRadius", "outerRadius"];
(0, qw._registerNode)(Wo);
E2.Factory.addGetterSetter(Wo, "innerRadius", 0, (0, A2.getNumberValidator)());
E2.Factory.addGetterSetter(Wo, "outerRadius", 0, (0, A2.getNumberValidator)());
var Tf = {};
Object.defineProperty(Tf, "__esModule", { value: !0 });
Tf.Sprite = void 0;
const _o = zr, tS = ri, eS = Ps, C2 = lr, rS = Hr;
class da extends tS.Shape {
  constructor(t) {
    super(t), this._updated = !0, this.anim = new eS.Animation(() => {
      var r = this._updated;
      return this._updated = !1, r;
    }), this.on("animationChange.konva", function() {
      this.frameIndex(0);
    }), this.on("frameIndexChange.konva", function() {
      this._updated = !0;
    }), this.on("frameRateChange.konva", function() {
      this.anim.isRunning() && (clearInterval(this.interval), this._setInterval());
    });
  }
  _sceneFunc(t) {
    var r = this.animation(), o = this.frameIndex(), c = o * 4, d = this.animations()[r], u = this.frameOffsets(), l = d[c + 0], e = d[c + 1], s = d[c + 2], i = d[c + 3], f = this.image();
    if ((this.hasFill() || this.hasStroke()) && (t.beginPath(), t.rect(0, 0, s, i), t.closePath(), t.fillStrokeShape(this)), f)
      if (u) {
        var h = u[r], v = o * 2;
        t.drawImage(f, l, e, s, i, h[v + 0], h[v + 1], s, i);
      } else
        t.drawImage(f, l, e, s, i, 0, 0, s, i);
  }
  _hitFunc(t) {
    var r = this.animation(), o = this.frameIndex(), c = o * 4, d = this.animations()[r], u = this.frameOffsets(), l = d[c + 2], e = d[c + 3];
    if (t.beginPath(), u) {
      var s = u[r], i = o * 2;
      t.rect(s[i + 0], s[i + 1], l, e);
    } else
      t.rect(0, 0, l, e);
    t.closePath(), t.fillShape(this);
  }
  _useBufferCanvas() {
    return super._useBufferCanvas(!0);
  }
  _setInterval() {
    var t = this;
    this.interval = setInterval(function() {
      t._updateIndex();
    }, 1e3 / this.frameRate());
  }
  start() {
    if (!this.isRunning()) {
      var t = this.getLayer();
      this.anim.setLayers(t), this._setInterval(), this.anim.start();
    }
  }
  stop() {
    this.anim.stop(), clearInterval(this.interval);
  }
  isRunning() {
    return this.anim.isRunning();
  }
  _updateIndex() {
    var t = this.frameIndex(), r = this.animation(), o = this.animations(), c = o[r], d = c.length / 4;
    t < d - 1 ? this.frameIndex(t + 1) : this.frameIndex(0);
  }
}
Tf.Sprite = da;
da.prototype.className = "Sprite";
(0, rS._registerNode)(da);
_o.Factory.addGetterSetter(da, "animation");
_o.Factory.addGetterSetter(da, "animations");
_o.Factory.addGetterSetter(da, "frameOffsets");
_o.Factory.addGetterSetter(da, "image");
_o.Factory.addGetterSetter(da, "frameIndex", 0, (0, C2.getNumberValidator)());
_o.Factory.addGetterSetter(da, "frameRate", 17, (0, C2.getNumberValidator)());
_o.Factory.backCompat(da, {
  index: "frameIndex",
  getIndex: "getFrameIndex",
  setIndex: "setFrameIndex"
});
var Pf = {};
Object.defineProperty(Pf, "__esModule", { value: !0 });
Pf.Star = void 0;
const vc = zr, nS = ri, gc = lr, iS = Hr;
class ao extends nS.Shape {
  _sceneFunc(t) {
    var r = this.innerRadius(), o = this.outerRadius(), c = this.numPoints();
    t.beginPath(), t.moveTo(0, 0 - o);
    for (var d = 1; d < c * 2; d++) {
      var u = d % 2 === 0 ? o : r, l = u * Math.sin(d * Math.PI / c), e = -1 * u * Math.cos(d * Math.PI / c);
      t.lineTo(l, e);
    }
    t.closePath(), t.fillStrokeShape(this);
  }
  getWidth() {
    return this.outerRadius() * 2;
  }
  getHeight() {
    return this.outerRadius() * 2;
  }
  setWidth(t) {
    this.outerRadius(t / 2);
  }
  setHeight(t) {
    this.outerRadius(t / 2);
  }
}
Pf.Star = ao;
ao.prototype.className = "Star";
ao.prototype._centroid = !0;
ao.prototype._attrsAffectingSize = ["innerRadius", "outerRadius"];
(0, iS._registerNode)(ao);
vc.Factory.addGetterSetter(ao, "numPoints", 5, (0, gc.getNumberValidator)());
vc.Factory.addGetterSetter(ao, "innerRadius", 0, (0, gc.getNumberValidator)());
vc.Factory.addGetterSetter(ao, "outerRadius", 0, (0, gc.getNumberValidator)());
var Io = {};
Object.defineProperty(Io, "__esModule", { value: !0 });
Io.Text = Io.stringToArray = void 0;
const Fh = zn, bi = zr, aS = ri, oo = lr, oS = Hr;
function T2(a) {
  return Array.from(a);
}
Io.stringToArray = T2;
var rs = "auto", sS = "center", P2 = "inherit", Ks = "justify", lS = "Change.konva", fS = "2d", q1 = "-", O2 = "left", uS = "text", hS = "Text", cS = "top", dS = "bottom", tv = "middle", F2 = "normal", vS = "px ", El = " ", gS = "right", ev = "rtl", pS = "word", yS = "char", rv = "none", Qu = "…", I2 = [
  "direction",
  "fontFamily",
  "fontSize",
  "fontStyle",
  "fontVariant",
  "padding",
  "align",
  "verticalAlign",
  "lineHeight",
  "text",
  "width",
  "height",
  "wrap",
  "ellipsis",
  "letterSpacing"
], mS = I2.length;
function xS(a) {
  return a.split(",").map((t) => {
    t = t.trim();
    const r = t.indexOf(" ") >= 0, o = t.indexOf('"') >= 0 || t.indexOf("'") >= 0;
    return r && !o && (t = `"${t}"`), t;
  }).join(", ");
}
var Al;
function $u() {
  return Al || (Al = Fh.Util.createCanvasElement().getContext(fS), Al);
}
function bS(a) {
  a.fillText(this._partialText, this._partialTextX, this._partialTextY);
}
function wS(a) {
  a.setAttr("miterLimit", 2), a.strokeText(this._partialText, this._partialTextX, this._partialTextY);
}
function SS(a) {
  return a = a || {}, !a.fillLinearGradientColorStops && !a.fillRadialGradientColorStops && !a.fillPatternImage && (a.fill = a.fill || "black"), a;
}
class Hn extends aS.Shape {
  constructor(t) {
    super(SS(t)), this._partialTextX = 0, this._partialTextY = 0;
    for (var r = 0; r < mS; r++)
      this.on(I2[r] + lS, this._setTextData);
    this._setTextData();
  }
  _sceneFunc(t) {
    var r = this.textArr, o = r.length;
    if (this.text()) {
      var c = this.padding(), d = this.fontSize(), u = this.lineHeight() * d, l = this.verticalAlign(), e = this.direction(), s = 0, i = this.align(), f = this.getWidth(), h = this.letterSpacing(), v = this.fill(), p = this.textDecoration(), m = p.indexOf("underline") !== -1, x = p.indexOf("line-through") !== -1, g;
      e = e === P2 ? t.direction : e;
      var S = 0, S = u / 2, y = 0, b = 0;
      for (e === ev && t.setAttr("direction", e), t.setAttr("font", this._getContextFont()), t.setAttr("textBaseline", tv), t.setAttr("textAlign", O2), l === tv ? s = (this.getHeight() - o * u - c * 2) / 2 : l === dS && (s = this.getHeight() - o * u - c * 2), t.translate(c, s + c), g = 0; g < o; g++) {
        var y = 0, b = 0, n = r[g], w = n.text, E = n.width, A = n.lastInParagraph, O, C, T;
        if (t.save(), i === gS ? y += f - E - c * 2 : i === sS && (y += (f - E - c * 2) / 2), m) {
          t.save(), t.beginPath(), t.moveTo(y, S + b + Math.round(d / 2)), O = w.split(" ").length - 1, C = O === 0, T = i === Ks && !A ? f - c * 2 : E, t.lineTo(y + Math.round(T), S + b + Math.round(d / 2)), t.lineWidth = d / 15;
          const z = this._getLinearGradient();
          t.strokeStyle = z || v, t.stroke(), t.restore();
        }
        if (x) {
          t.save(), t.beginPath(), t.moveTo(y, S + b), O = w.split(" ").length - 1, C = O === 0, T = i === Ks && A && !C ? f - c * 2 : E, t.lineTo(y + Math.round(T), S + b), t.lineWidth = d / 15;
          const z = this._getLinearGradient();
          t.strokeStyle = z || v, t.stroke(), t.restore();
        }
        if (e !== ev && (h !== 0 || i === Ks)) {
          O = w.split(" ").length - 1;
          for (var P = T2(w), I = 0; I < P.length; I++) {
            var F = P[I];
            F === " " && !A && i === Ks && (y += (f - c * 2 - E) / O), this._partialTextX = y, this._partialTextY = S + b, this._partialText = F, t.fillStrokeShape(this), y += this.measureSize(F).width + h;
          }
        } else
          h !== 0 && t.setAttr("letterSpacing", `${h}px`), this._partialTextX = y, this._partialTextY = S + b, this._partialText = w, t.fillStrokeShape(this);
        t.restore(), o > 1 && (S += u);
      }
    }
  }
  _hitFunc(t) {
    var r = this.getWidth(), o = this.getHeight();
    t.beginPath(), t.rect(0, 0, r, o), t.closePath(), t.fillStrokeShape(this);
  }
  setText(t) {
    var r = Fh.Util._isString(t) ? t : t == null ? "" : t + "";
    return this._setAttr(uS, r), this;
  }
  getWidth() {
    var t = this.attrs.width === rs || this.attrs.width === void 0;
    return t ? this.getTextWidth() + this.padding() * 2 : this.attrs.width;
  }
  getHeight() {
    var t = this.attrs.height === rs || this.attrs.height === void 0;
    return t ? this.fontSize() * this.textArr.length * this.lineHeight() + this.padding() * 2 : this.attrs.height;
  }
  getTextWidth() {
    return this.textWidth;
  }
  getTextHeight() {
    return Fh.Util.warn("text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height."), this.textHeight;
  }
  measureSize(t) {
    var r = $u(), o = this.fontSize(), c;
    return r.save(), r.font = this._getContextFont(), c = r.measureText(t), r.restore(), {
      width: c.width,
      height: o
    };
  }
  _getContextFont() {
    return this.fontStyle() + El + this.fontVariant() + El + (this.fontSize() + vS) + xS(this.fontFamily());
  }
  _addTextLine(t) {
    this.align() === Ks && (t = t.trim());
    var o = this._getTextWidth(t);
    return this.textArr.push({
      text: t,
      width: o,
      lastInParagraph: !1
    });
  }
  _getTextWidth(t) {
    var r = this.letterSpacing(), o = t.length;
    return $u().measureText(t).width + (o ? r * (o - 1) : 0);
  }
  _setTextData() {
    var t = this.text().split(`
`), r = +this.fontSize(), o = 0, c = this.lineHeight() * r, d = this.attrs.width, u = this.attrs.height, l = d !== rs && d !== void 0, e = u !== rs && u !== void 0, s = this.padding(), i = d - s * 2, f = u - s * 2, h = 0, v = this.wrap(), p = v !== rv, m = v !== yS && p, x = this.ellipsis();
    this.textArr = [], $u().font = this._getContextFont();
    for (var g = x ? this._getTextWidth(Qu) : 0, S = 0, y = t.length; S < y; ++S) {
      var b = t[S], n = this._getTextWidth(b);
      if (l && n > i)
        for (; b.length > 0; ) {
          for (var w = 0, E = b.length, A = "", O = 0; w < E; ) {
            var C = w + E >>> 1, T = b.slice(0, C + 1), P = this._getTextWidth(T) + g;
            P <= i ? (w = C + 1, A = T, O = P) : E = C;
          }
          if (A) {
            if (m) {
              var I, F = b[A.length], B = F === El || F === q1;
              B && O <= i ? I = A.length : I = Math.max(A.lastIndexOf(El), A.lastIndexOf(q1)) + 1, I > 0 && (w = I, A = A.slice(0, w), O = this._getTextWidth(A));
            }
            A = A.trimRight(), this._addTextLine(A), o = Math.max(o, O), h += c;
            var M = this._shouldHandleEllipsis(h);
            if (M) {
              this._tryToAddEllipsisToLastLine();
              break;
            }
            if (b = b.slice(w), b = b.trimLeft(), b.length > 0 && (n = this._getTextWidth(b), n <= i)) {
              this._addTextLine(b), h += c, o = Math.max(o, n);
              break;
            }
          } else
            break;
        }
      else
        this._addTextLine(b), h += c, o = Math.max(o, n), this._shouldHandleEllipsis(h) && S < y - 1 && this._tryToAddEllipsisToLastLine();
      if (this.textArr[this.textArr.length - 1] && (this.textArr[this.textArr.length - 1].lastInParagraph = !0), e && h + c > f)
        break;
    }
    this.textHeight = r, this.textWidth = o;
  }
  _shouldHandleEllipsis(t) {
    var r = +this.fontSize(), o = this.lineHeight() * r, c = this.attrs.height, d = c !== rs && c !== void 0, u = this.padding(), l = c - u * 2, e = this.wrap(), s = e !== rv;
    return !s || d && t + o > l;
  }
  _tryToAddEllipsisToLastLine() {
    var t = this.attrs.width, r = t !== rs && t !== void 0, o = this.padding(), c = t - o * 2, d = this.ellipsis(), u = this.textArr[this.textArr.length - 1];
    if (!(!u || !d)) {
      if (r) {
        var l = this._getTextWidth(u.text + Qu) < c;
        l || (u.text = u.text.slice(0, u.text.length - 3));
      }
      this.textArr.splice(this.textArr.length - 1, 1), this._addTextLine(u.text + Qu);
    }
  }
  getStrokeScaleEnabled() {
    return !0;
  }
  _useBufferCanvas() {
    const t = this.textDecoration().indexOf("underline") !== -1 || this.textDecoration().indexOf("line-through") !== -1, r = this.hasShadow();
    return t && r ? !0 : super._useBufferCanvas();
  }
}
Io.Text = Hn;
Hn.prototype._fillFunc = bS;
Hn.prototype._strokeFunc = wS;
Hn.prototype.className = hS;
Hn.prototype._attrsAffectingSize = [
  "text",
  "fontSize",
  "padding",
  "wrap",
  "lineHeight",
  "letterSpacing"
];
(0, oS._registerNode)(Hn);
bi.Factory.overWriteSetter(Hn, "width", (0, oo.getNumberOrAutoValidator)());
bi.Factory.overWriteSetter(Hn, "height", (0, oo.getNumberOrAutoValidator)());
bi.Factory.addGetterSetter(Hn, "direction", P2);
bi.Factory.addGetterSetter(Hn, "fontFamily", "Arial");
bi.Factory.addGetterSetter(Hn, "fontSize", 12, (0, oo.getNumberValidator)());
bi.Factory.addGetterSetter(Hn, "fontStyle", F2);
bi.Factory.addGetterSetter(Hn, "fontVariant", F2);
bi.Factory.addGetterSetter(Hn, "padding", 0, (0, oo.getNumberValidator)());
bi.Factory.addGetterSetter(Hn, "align", O2);
bi.Factory.addGetterSetter(Hn, "verticalAlign", cS);
bi.Factory.addGetterSetter(Hn, "lineHeight", 1, (0, oo.getNumberValidator)());
bi.Factory.addGetterSetter(Hn, "wrap", pS);
bi.Factory.addGetterSetter(Hn, "ellipsis", !1, (0, oo.getBooleanValidator)());
bi.Factory.addGetterSetter(Hn, "letterSpacing", 0, (0, oo.getNumberValidator)());
bi.Factory.addGetterSetter(Hn, "text", "", (0, oo.getStringValidator)());
bi.Factory.addGetterSetter(Hn, "textDecoration", "");
var Of = {};
Object.defineProperty(Of, "__esModule", { value: !0 });
Of.TextPath = void 0;
const qu = zn, na = zr, ES = ri, Js = Os, th = Io, R2 = lr, AS = Hr;
var CS = "", D2 = "normal";
function M2(a) {
  a.fillText(this.partialText, 0, 0);
}
function B2(a) {
  a.strokeText(this.partialText, 0, 0);
}
class ni extends ES.Shape {
  constructor(t) {
    super(t), this.dummyCanvas = qu.Util.createCanvasElement(), this.dataArray = [], this._readDataAttribute(), this.on("dataChange.konva", function() {
      this._readDataAttribute(), this._setTextData();
    }), this.on("textChange.konva alignChange.konva letterSpacingChange.konva kerningFuncChange.konva fontSizeChange.konva fontFamilyChange.konva", this._setTextData), this._setTextData();
  }
  _getTextPathLength() {
    return Js.Path.getPathLength(this.dataArray);
  }
  _getPointAtLength(t) {
    if (!this.attrs.data)
      return null;
    const r = this.pathLength;
    return t - 1 > r ? null : Js.Path.getPointAtLengthOfDataArray(t, this.dataArray);
  }
  _readDataAttribute() {
    this.dataArray = Js.Path.parsePathData(this.attrs.data), this.pathLength = this._getTextPathLength();
  }
  _sceneFunc(t) {
    t.setAttr("font", this._getContextFont()), t.setAttr("textBaseline", this.textBaseline()), t.setAttr("textAlign", "left"), t.save();
    var r = this.textDecoration(), o = this.fill(), c = this.fontSize(), d = this.glyphInfo;
    r === "underline" && t.beginPath();
    for (var u = 0; u < d.length; u++) {
      t.save();
      var l = d[u].p0;
      t.translate(l.x, l.y), t.rotate(d[u].rotation), this.partialText = d[u].text, t.fillStrokeShape(this), r === "underline" && (u === 0 && t.moveTo(0, c / 2 + 1), t.lineTo(c, c / 2 + 1)), t.restore();
    }
    r === "underline" && (t.strokeStyle = o, t.lineWidth = c / 20, t.stroke()), t.restore();
  }
  _hitFunc(t) {
    t.beginPath();
    var r = this.glyphInfo;
    if (r.length >= 1) {
      var o = r[0].p0;
      t.moveTo(o.x, o.y);
    }
    for (var c = 0; c < r.length; c++) {
      var d = r[c].p1;
      t.lineTo(d.x, d.y);
    }
    t.setAttr("lineWidth", this.fontSize()), t.setAttr("strokeStyle", this.colorKey), t.stroke();
  }
  getTextWidth() {
    return this.textWidth;
  }
  getTextHeight() {
    return qu.Util.warn("text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height."), this.textHeight;
  }
  setText(t) {
    return th.Text.prototype.setText.call(this, t);
  }
  _getContextFont() {
    return th.Text.prototype._getContextFont.call(this);
  }
  _getTextSize(t) {
    var r = this.dummyCanvas, o = r.getContext("2d");
    o.save(), o.font = this._getContextFont();
    var c = o.measureText(t);
    return o.restore(), {
      width: c.width,
      height: parseInt(`${this.fontSize()}`, 10)
    };
  }
  _setTextData() {
    const { width: t, height: r } = this._getTextSize(this.attrs.text);
    if (this.textWidth = t, this.textHeight = r, this.glyphInfo = [], !this.attrs.data)
      return null;
    const o = this.letterSpacing(), c = this.align(), d = this.kerningFunc(), u = Math.max(this.textWidth + ((this.attrs.text || "").length - 1) * o, 0);
    let l = 0;
    c === "center" && (l = Math.max(0, this.pathLength / 2 - u / 2)), c === "right" && (l = Math.max(0, this.pathLength - u));
    const e = (0, th.stringToArray)(this.text());
    let s = l;
    for (var i = 0; i < e.length; i++) {
      const f = this._getPointAtLength(s);
      if (!f)
        return;
      let h = this._getTextSize(e[i]).width + o;
      if (e[i] === " " && c === "justify") {
        const S = this.text().split(" ").length - 1;
        h += (this.pathLength - u) / S;
      }
      const v = this._getPointAtLength(s + h);
      if (!v)
        return;
      const p = Js.Path.getLineLength(f.x, f.y, v.x, v.y);
      let m = 0;
      if (d)
        try {
          m = d(e[i - 1], e[i]) * this.fontSize();
        } catch {
          m = 0;
        }
      f.x += m, v.x += m, this.textWidth += m;
      const x = Js.Path.getPointOnLine(m + p / 2, f.x, f.y, v.x, v.y), g = Math.atan2(v.y - f.y, v.x - f.x);
      this.glyphInfo.push({
        transposeX: x.x,
        transposeY: x.y,
        text: e[i],
        rotation: g,
        p0: f,
        p1: v
      }), s += h;
    }
  }
  getSelfRect() {
    if (!this.glyphInfo.length)
      return {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      };
    var t = [];
    this.glyphInfo.forEach(function(i) {
      t.push(i.p0.x), t.push(i.p0.y), t.push(i.p1.x), t.push(i.p1.y);
    });
    for (var r = t[0] || 0, o = t[0] || 0, c = t[1] || 0, d = t[1] || 0, u, l, e = 0; e < t.length / 2; e++)
      u = t[e * 2], l = t[e * 2 + 1], r = Math.min(r, u), o = Math.max(o, u), c = Math.min(c, l), d = Math.max(d, l);
    var s = this.fontSize();
    return {
      x: r - s / 2,
      y: c - s / 2,
      width: o - r + s,
      height: d - c + s
    };
  }
  destroy() {
    return qu.Util.releaseCanvas(this.dummyCanvas), super.destroy();
  }
}
Of.TextPath = ni;
ni.prototype._fillFunc = M2;
ni.prototype._strokeFunc = B2;
ni.prototype._fillFuncHit = M2;
ni.prototype._strokeFuncHit = B2;
ni.prototype.className = "TextPath";
ni.prototype._attrsAffectingSize = ["text", "fontSize", "data"];
(0, AS._registerNode)(ni);
na.Factory.addGetterSetter(ni, "data");
na.Factory.addGetterSetter(ni, "fontFamily", "Arial");
na.Factory.addGetterSetter(ni, "fontSize", 12, (0, R2.getNumberValidator)());
na.Factory.addGetterSetter(ni, "fontStyle", D2);
na.Factory.addGetterSetter(ni, "align", "left");
na.Factory.addGetterSetter(ni, "letterSpacing", 0, (0, R2.getNumberValidator)());
na.Factory.addGetterSetter(ni, "textBaseline", "middle");
na.Factory.addGetterSetter(ni, "fontVariant", D2);
na.Factory.addGetterSetter(ni, "text", CS);
na.Factory.addGetterSetter(ni, "textDecoration", null);
na.Factory.addGetterSetter(ni, "kerningFunc", null);
var Ff = {};
Object.defineProperty(Ff, "__esModule", { value: !0 });
Ff.Transformer = void 0;
const bn = zn, cn = zr, nv = Bn, TS = ri, PS = M0, iv = Ts, qi = Hr, so = lr, OS = Hr;
var k2 = "tr-konva", FS = [
  "resizeEnabledChange",
  "rotateAnchorOffsetChange",
  "rotateEnabledChange",
  "enabledAnchorsChange",
  "anchorSizeChange",
  "borderEnabledChange",
  "borderStrokeChange",
  "borderStrokeWidthChange",
  "borderDashChange",
  "anchorStrokeChange",
  "anchorStrokeWidthChange",
  "anchorFillChange",
  "anchorCornerRadiusChange",
  "ignoreStrokeChange",
  "anchorStyleFuncChange"
].map((a) => a + `.${k2}`).join(" "), av = "nodesRect", IS = [
  "widthChange",
  "heightChange",
  "scaleXChange",
  "scaleYChange",
  "skewXChange",
  "skewYChange",
  "rotationChange",
  "offsetXChange",
  "offsetYChange",
  "transformsEnabledChange",
  "strokeWidthChange"
], RS = {
  "top-left": -45,
  "top-center": 0,
  "top-right": 45,
  "middle-right": -90,
  "middle-left": 90,
  "bottom-left": -135,
  "bottom-center": 180,
  "bottom-right": 135
};
const DS = "ontouchstart" in qi.Konva._global;
function MS(a, t, r) {
  if (a === "rotater")
    return r;
  t += bn.Util.degToRad(RS[a] || 0);
  var o = (bn.Util.radToDeg(t) % 360 + 360) % 360;
  return bn.Util._inRange(o, 315 + 22.5, 360) || bn.Util._inRange(o, 0, 22.5) ? "ns-resize" : bn.Util._inRange(o, 45 - 22.5, 45 + 22.5) ? "nesw-resize" : bn.Util._inRange(o, 90 - 22.5, 90 + 22.5) ? "ew-resize" : bn.Util._inRange(o, 135 - 22.5, 135 + 22.5) ? "nwse-resize" : bn.Util._inRange(o, 180 - 22.5, 180 + 22.5) ? "ns-resize" : bn.Util._inRange(o, 225 - 22.5, 225 + 22.5) ? "nesw-resize" : bn.Util._inRange(o, 270 - 22.5, 270 + 22.5) ? "ew-resize" : bn.Util._inRange(o, 315 - 22.5, 315 + 22.5) ? "nwse-resize" : (bn.Util.error("Transformer has unknown angle for cursor detection: " + o), "pointer");
}
var zl = [
  "top-left",
  "top-center",
  "top-right",
  "middle-right",
  "middle-left",
  "bottom-left",
  "bottom-center",
  "bottom-right"
], ov = 1e8;
function BS(a) {
  return {
    x: a.x + a.width / 2 * Math.cos(a.rotation) + a.height / 2 * Math.sin(-a.rotation),
    y: a.y + a.height / 2 * Math.cos(a.rotation) + a.width / 2 * Math.sin(a.rotation)
  };
}
function N2(a, t, r) {
  const o = r.x + (a.x - r.x) * Math.cos(t) - (a.y - r.y) * Math.sin(t), c = r.y + (a.x - r.x) * Math.sin(t) + (a.y - r.y) * Math.cos(t);
  return {
    ...a,
    rotation: a.rotation + t,
    x: o,
    y: c
  };
}
function kS(a, t) {
  const r = BS(a);
  return N2(a, t, r);
}
function NS(a, t, r) {
  let o = t;
  for (let c = 0; c < a.length; c++) {
    const d = qi.Konva.getAngle(a[c]), u = Math.abs(d - t) % (Math.PI * 2);
    Math.min(u, Math.PI * 2 - u) < r && (o = d);
  }
  return o;
}
class en extends iv.Group {
  constructor(t) {
    super(t), this._movingAnchorName = null, this._transforming = !1, this._createElements(), this._handleMouseMove = this._handleMouseMove.bind(this), this._handleMouseUp = this._handleMouseUp.bind(this), this.update = this.update.bind(this), this.on(FS, this.update), this.getNode() && this.update();
  }
  attachTo(t) {
    return this.setNode(t), this;
  }
  setNode(t) {
    return bn.Util.warn("tr.setNode(shape), tr.node(shape) and tr.attachTo(shape) methods are deprecated. Please use tr.nodes(nodesArray) instead."), this.setNodes([t]);
  }
  getNode() {
    return this._nodes && this._nodes[0];
  }
  _getEventNamespace() {
    return k2 + this._id;
  }
  setNodes(t = []) {
    this._nodes && this._nodes.length && this.detach();
    const r = t.filter((c) => c.isAncestorOf(this) ? (bn.Util.error("Konva.Transformer cannot be an a child of the node you are trying to attach"), !1) : !0);
    this._nodes = t = r, t.length === 1 && this.useSingleNodeRotation() ? this.rotation(t[0].getAbsoluteRotation()) : this.rotation(0), this._nodes.forEach((c) => {
      const d = () => {
        this.nodes().length === 1 && this.useSingleNodeRotation() && this.rotation(this.nodes()[0].getAbsoluteRotation()), this._resetTransformCache(), !this._transforming && !this.isDragging() && this.update();
      }, u = c._attrsAffectingSize.map((l) => l + "Change." + this._getEventNamespace()).join(" ");
      c.on(u, d), c.on(IS.map((l) => l + `.${this._getEventNamespace()}`).join(" "), d), c.on(`absoluteTransformChange.${this._getEventNamespace()}`, d), this._proxyDrag(c);
    }), this._resetTransformCache();
    var o = !!this.findOne(".top-left");
    return o && this.update(), this;
  }
  _proxyDrag(t) {
    let r;
    t.on(`dragstart.${this._getEventNamespace()}`, (o) => {
      r = t.getAbsolutePosition(), !this.isDragging() && t !== this.findOne(".back") && this.startDrag(o, !1);
    }), t.on(`dragmove.${this._getEventNamespace()}`, (o) => {
      if (!r)
        return;
      const c = t.getAbsolutePosition(), d = c.x - r.x, u = c.y - r.y;
      this.nodes().forEach((l) => {
        if (l === t || l.isDragging())
          return;
        const e = l.getAbsolutePosition();
        l.setAbsolutePosition({
          x: e.x + d,
          y: e.y + u
        }), l.startDrag(o);
      }), r = null;
    });
  }
  getNodes() {
    return this._nodes || [];
  }
  getActiveAnchor() {
    return this._movingAnchorName;
  }
  detach() {
    this._nodes && this._nodes.forEach((t) => {
      t.off("." + this._getEventNamespace());
    }), this._nodes = [], this._resetTransformCache();
  }
  _resetTransformCache() {
    this._clearCache(av), this._clearCache("transform"), this._clearSelfAndDescendantCache("absoluteTransform");
  }
  _getNodeRect() {
    return this._getCache(av, this.__getNodeRect);
  }
  __getNodeShape(t, r = this.rotation(), o) {
    var c = t.getClientRect({
      skipTransform: !0,
      skipShadow: !0,
      skipStroke: this.ignoreStroke()
    }), d = t.getAbsoluteScale(o), u = t.getAbsolutePosition(o), l = c.x * d.x - t.offsetX() * d.x, e = c.y * d.y - t.offsetY() * d.y;
    const s = (qi.Konva.getAngle(t.getAbsoluteRotation()) + Math.PI * 2) % (Math.PI * 2), i = {
      x: u.x + l * Math.cos(s) + e * Math.sin(-s),
      y: u.y + e * Math.cos(s) + l * Math.sin(s),
      width: c.width * d.x,
      height: c.height * d.y,
      rotation: s
    };
    return N2(i, -qi.Konva.getAngle(r), {
      x: 0,
      y: 0
    });
  }
  __getNodeRect() {
    var t = this.getNode();
    if (!t)
      return {
        x: -ov,
        y: -ov,
        width: 0,
        height: 0,
        rotation: 0
      };
    const r = [];
    this.nodes().map((s) => {
      const i = s.getClientRect({
        skipTransform: !0,
        skipShadow: !0,
        skipStroke: this.ignoreStroke()
      });
      var f = [
        { x: i.x, y: i.y },
        { x: i.x + i.width, y: i.y },
        { x: i.x + i.width, y: i.y + i.height },
        { x: i.x, y: i.y + i.height }
      ], h = s.getAbsoluteTransform();
      f.forEach(function(v) {
        var p = h.point(v);
        r.push(p);
      });
    });
    const o = new bn.Transform();
    o.rotate(-qi.Konva.getAngle(this.rotation()));
    var c = 1 / 0, d = 1 / 0, u = -1 / 0, l = -1 / 0;
    r.forEach(function(s) {
      var i = o.point(s);
      c === void 0 && (c = u = i.x, d = l = i.y), c = Math.min(c, i.x), d = Math.min(d, i.y), u = Math.max(u, i.x), l = Math.max(l, i.y);
    }), o.invert();
    const e = o.point({ x: c, y: d });
    return {
      x: e.x,
      y: e.y,
      width: u - c,
      height: l - d,
      rotation: qi.Konva.getAngle(this.rotation())
    };
  }
  getX() {
    return this._getNodeRect().x;
  }
  getY() {
    return this._getNodeRect().y;
  }
  getWidth() {
    return this._getNodeRect().width;
  }
  getHeight() {
    return this._getNodeRect().height;
  }
  _createElements() {
    this._createBack(), zl.forEach((t) => {
      this._createAnchor(t);
    }), this._createAnchor("rotater");
  }
  _createAnchor(t) {
    var r = new PS.Rect({
      stroke: "rgb(0, 161, 255)",
      fill: "white",
      strokeWidth: 1,
      name: t + " _anchor",
      dragDistance: 0,
      draggable: !0,
      hitStrokeWidth: DS ? 10 : "auto"
    }), o = this;
    r.on("mousedown touchstart", function(c) {
      o._handleMouseDown(c);
    }), r.on("dragstart", (c) => {
      r.stopDrag(), c.cancelBubble = !0;
    }), r.on("dragend", (c) => {
      c.cancelBubble = !0;
    }), r.on("mouseenter", () => {
      var c = qi.Konva.getAngle(this.rotation()), d = this.rotateAnchorCursor(), u = MS(t, c, d);
      r.getStage().content && (r.getStage().content.style.cursor = u), this._cursorChange = !0;
    }), r.on("mouseout", () => {
      r.getStage().content && (r.getStage().content.style.cursor = ""), this._cursorChange = !1;
    }), this.add(r);
  }
  _createBack() {
    var t = new TS.Shape({
      name: "back",
      width: 0,
      height: 0,
      draggable: !0,
      sceneFunc(r, o) {
        var c = o.getParent(), d = c.padding();
        r.beginPath(), r.rect(-d, -d, o.width() + d * 2, o.height() + d * 2), r.moveTo(o.width() / 2, -d), c.rotateEnabled() && r.lineTo(o.width() / 2, -c.rotateAnchorOffset() * bn.Util._sign(o.height()) - d), r.fillStrokeShape(o);
      },
      hitFunc: (r, o) => {
        if (this.shouldOverdrawWholeArea()) {
          var c = this.padding();
          r.beginPath(), r.rect(-c, -c, o.width() + c * 2, o.height() + c * 2), r.fillStrokeShape(o);
        }
      }
    });
    this.add(t), this._proxyDrag(t), t.on("dragstart", (r) => {
      r.cancelBubble = !0;
    }), t.on("dragmove", (r) => {
      r.cancelBubble = !0;
    }), t.on("dragend", (r) => {
      r.cancelBubble = !0;
    }), this.on("dragmove", (r) => {
      this.update();
    });
  }
  _handleMouseDown(t) {
    this._movingAnchorName = t.target.name().split(" ")[0];
    var r = this._getNodeRect(), o = r.width, c = r.height, d = Math.sqrt(Math.pow(o, 2) + Math.pow(c, 2));
    this.sin = Math.abs(c / d), this.cos = Math.abs(o / d), typeof window < "u" && (window.addEventListener("mousemove", this._handleMouseMove), window.addEventListener("touchmove", this._handleMouseMove), window.addEventListener("mouseup", this._handleMouseUp, !0), window.addEventListener("touchend", this._handleMouseUp, !0)), this._transforming = !0;
    var u = t.target.getAbsolutePosition(), l = t.target.getStage().getPointerPosition();
    this._anchorDragOffset = {
      x: l.x - u.x,
      y: l.y - u.y
    }, this._fire("transformstart", { evt: t.evt, target: this.getNode() }), this._nodes.forEach((e) => {
      e._fire("transformstart", { evt: t.evt, target: e });
    });
  }
  _handleMouseMove(t) {
    var r, o, c, d = this.findOne("." + this._movingAnchorName), u = d.getStage();
    u.setPointersPositions(t);
    const l = u.getPointerPosition();
    let e = {
      x: l.x - this._anchorDragOffset.x,
      y: l.y - this._anchorDragOffset.y
    };
    const s = d.getAbsolutePosition();
    this.anchorDragBoundFunc() && (e = this.anchorDragBoundFunc()(s, e, t)), d.setAbsolutePosition(e);
    const i = d.getAbsolutePosition();
    if (!(s.x === i.x && s.y === i.y)) {
      if (this._movingAnchorName === "rotater") {
        var f = this._getNodeRect();
        r = d.x() - f.width / 2, o = -d.y() + f.height / 2;
        let I = Math.atan2(-o, r) + Math.PI / 2;
        f.height < 0 && (I -= Math.PI);
        var h = qi.Konva.getAngle(this.rotation());
        const F = h + I, B = qi.Konva.getAngle(this.rotationSnapTolerance()), z = NS(this.rotationSnaps(), F, B) - f.rotation, L = kS(f, z);
        this._fitNodesInto(L, t);
        return;
      }
      var v = this.shiftBehavior(), p;
      v === "inverted" ? p = this.keepRatio() && !t.shiftKey : v === "none" ? p = this.keepRatio() : p = this.keepRatio() || t.shiftKey;
      var y = this.centeredScaling() || t.altKey;
      if (this._movingAnchorName === "top-left") {
        if (p) {
          var m = y ? {
            x: this.width() / 2,
            y: this.height() / 2
          } : {
            x: this.findOne(".bottom-right").x(),
            y: this.findOne(".bottom-right").y()
          };
          c = Math.sqrt(Math.pow(m.x - d.x(), 2) + Math.pow(m.y - d.y(), 2));
          var x = this.findOne(".top-left").x() > m.x ? -1 : 1, g = this.findOne(".top-left").y() > m.y ? -1 : 1;
          r = c * this.cos * x, o = c * this.sin * g, this.findOne(".top-left").x(m.x - r), this.findOne(".top-left").y(m.y - o);
        }
      } else if (this._movingAnchorName === "top-center")
        this.findOne(".top-left").y(d.y());
      else if (this._movingAnchorName === "top-right") {
        if (p) {
          var m = y ? {
            x: this.width() / 2,
            y: this.height() / 2
          } : {
            x: this.findOne(".bottom-left").x(),
            y: this.findOne(".bottom-left").y()
          };
          c = Math.sqrt(Math.pow(d.x() - m.x, 2) + Math.pow(m.y - d.y(), 2));
          var x = this.findOne(".top-right").x() < m.x ? -1 : 1, g = this.findOne(".top-right").y() > m.y ? -1 : 1;
          r = c * this.cos * x, o = c * this.sin * g, this.findOne(".top-right").x(m.x + r), this.findOne(".top-right").y(m.y - o);
        }
        var S = d.position();
        this.findOne(".top-left").y(S.y), this.findOne(".bottom-right").x(S.x);
      } else if (this._movingAnchorName === "middle-left")
        this.findOne(".top-left").x(d.x());
      else if (this._movingAnchorName === "middle-right")
        this.findOne(".bottom-right").x(d.x());
      else if (this._movingAnchorName === "bottom-left") {
        if (p) {
          var m = y ? {
            x: this.width() / 2,
            y: this.height() / 2
          } : {
            x: this.findOne(".top-right").x(),
            y: this.findOne(".top-right").y()
          };
          c = Math.sqrt(Math.pow(m.x - d.x(), 2) + Math.pow(d.y() - m.y, 2));
          var x = m.x < d.x() ? -1 : 1, g = d.y() < m.y ? -1 : 1;
          r = c * this.cos * x, o = c * this.sin * g, d.x(m.x - r), d.y(m.y + o);
        }
        S = d.position(), this.findOne(".top-left").x(S.x), this.findOne(".bottom-right").y(S.y);
      } else if (this._movingAnchorName === "bottom-center")
        this.findOne(".bottom-right").y(d.y());
      else if (this._movingAnchorName === "bottom-right") {
        if (p) {
          var m = y ? {
            x: this.width() / 2,
            y: this.height() / 2
          } : {
            x: this.findOne(".top-left").x(),
            y: this.findOne(".top-left").y()
          };
          c = Math.sqrt(Math.pow(d.x() - m.x, 2) + Math.pow(d.y() - m.y, 2));
          var x = this.findOne(".bottom-right").x() < m.x ? -1 : 1, g = this.findOne(".bottom-right").y() < m.y ? -1 : 1;
          r = c * this.cos * x, o = c * this.sin * g, this.findOne(".bottom-right").x(m.x + r), this.findOne(".bottom-right").y(m.y + o);
        }
      } else
        console.error(new Error("Wrong position argument of selection resizer: " + this._movingAnchorName));
      var y = this.centeredScaling() || t.altKey;
      if (y) {
        var b = this.findOne(".top-left"), n = this.findOne(".bottom-right"), w = b.x(), E = b.y(), A = this.getWidth() - n.x(), O = this.getHeight() - n.y();
        n.move({
          x: -w,
          y: -E
        }), b.move({
          x: A,
          y: O
        });
      }
      var C = this.findOne(".top-left").getAbsolutePosition();
      r = C.x, o = C.y;
      var T = this.findOne(".bottom-right").x() - this.findOne(".top-left").x(), P = this.findOne(".bottom-right").y() - this.findOne(".top-left").y();
      this._fitNodesInto({
        x: r,
        y: o,
        width: T,
        height: P,
        rotation: qi.Konva.getAngle(this.rotation())
      }, t);
    }
  }
  _handleMouseUp(t) {
    this._removeEvents(t);
  }
  getAbsoluteTransform() {
    return this.getTransform();
  }
  _removeEvents(t) {
    if (this._transforming) {
      this._transforming = !1, typeof window < "u" && (window.removeEventListener("mousemove", this._handleMouseMove), window.removeEventListener("touchmove", this._handleMouseMove), window.removeEventListener("mouseup", this._handleMouseUp, !0), window.removeEventListener("touchend", this._handleMouseUp, !0));
      var r = this.getNode();
      this._fire("transformend", { evt: t, target: r }), r && this._nodes.forEach((o) => {
        o._fire("transformend", { evt: t, target: o });
      }), this._movingAnchorName = null;
    }
  }
  _fitNodesInto(t, r) {
    var o = this._getNodeRect();
    const c = 1;
    if (bn.Util._inRange(t.width, -this.padding() * 2 - c, c)) {
      this.update();
      return;
    }
    if (bn.Util._inRange(t.height, -this.padding() * 2 - c, c)) {
      this.update();
      return;
    }
    var d = new bn.Transform();
    if (d.rotate(qi.Konva.getAngle(this.rotation())), this._movingAnchorName && t.width < 0 && this._movingAnchorName.indexOf("left") >= 0) {
      const h = d.point({
        x: -this.padding() * 2,
        y: 0
      });
      t.x += h.x, t.y += h.y, t.width += this.padding() * 2, this._movingAnchorName = this._movingAnchorName.replace("left", "right"), this._anchorDragOffset.x -= h.x, this._anchorDragOffset.y -= h.y;
    } else if (this._movingAnchorName && t.width < 0 && this._movingAnchorName.indexOf("right") >= 0) {
      const h = d.point({
        x: this.padding() * 2,
        y: 0
      });
      this._movingAnchorName = this._movingAnchorName.replace("right", "left"), this._anchorDragOffset.x -= h.x, this._anchorDragOffset.y -= h.y, t.width += this.padding() * 2;
    }
    if (this._movingAnchorName && t.height < 0 && this._movingAnchorName.indexOf("top") >= 0) {
      const h = d.point({
        x: 0,
        y: -this.padding() * 2
      });
      t.x += h.x, t.y += h.y, this._movingAnchorName = this._movingAnchorName.replace("top", "bottom"), this._anchorDragOffset.x -= h.x, this._anchorDragOffset.y -= h.y, t.height += this.padding() * 2;
    } else if (this._movingAnchorName && t.height < 0 && this._movingAnchorName.indexOf("bottom") >= 0) {
      const h = d.point({
        x: 0,
        y: this.padding() * 2
      });
      this._movingAnchorName = this._movingAnchorName.replace("bottom", "top"), this._anchorDragOffset.x -= h.x, this._anchorDragOffset.y -= h.y, t.height += this.padding() * 2;
    }
    if (this.boundBoxFunc()) {
      const h = this.boundBoxFunc()(o, t);
      h ? t = h : bn.Util.warn("boundBoxFunc returned falsy. You should return new bound rect from it!");
    }
    const u = 1e7, l = new bn.Transform();
    l.translate(o.x, o.y), l.rotate(o.rotation), l.scale(o.width / u, o.height / u);
    const e = new bn.Transform(), s = t.width / u, i = t.height / u;
    this.flipEnabled() === !1 ? (e.translate(t.x, t.y), e.rotate(t.rotation), e.translate(t.width < 0 ? t.width : 0, t.height < 0 ? t.height : 0), e.scale(Math.abs(s), Math.abs(i))) : (e.translate(t.x, t.y), e.rotate(t.rotation), e.scale(s, i));
    const f = e.multiply(l.invert());
    this._nodes.forEach((h) => {
      var v;
      const p = h.getParent().getAbsoluteTransform(), m = h.getTransform().copy();
      m.translate(h.offsetX(), h.offsetY());
      const x = new bn.Transform();
      x.multiply(p.copy().invert()).multiply(f).multiply(p).multiply(m);
      const g = x.decompose();
      h.setAttrs(g), this._fire("transform", { evt: r, target: h }), h._fire("transform", { evt: r, target: h }), (v = h.getLayer()) === null || v === void 0 || v.batchDraw();
    }), this.rotation(bn.Util._getRotation(t.rotation)), this._resetTransformCache(), this.update(), this.getLayer().batchDraw();
  }
  forceUpdate() {
    this._resetTransformCache(), this.update();
  }
  _batchChangeChild(t, r) {
    this.findOne(t).setAttrs(r);
  }
  update() {
    var t, r = this._getNodeRect();
    this.rotation(bn.Util._getRotation(r.rotation));
    var o = r.width, c = r.height, d = this.enabledAnchors(), u = this.resizeEnabled(), l = this.padding(), e = this.anchorSize();
    const s = this.find("._anchor");
    s.forEach((f) => {
      f.setAttrs({
        width: e,
        height: e,
        offsetX: e / 2,
        offsetY: e / 2,
        stroke: this.anchorStroke(),
        strokeWidth: this.anchorStrokeWidth(),
        fill: this.anchorFill(),
        cornerRadius: this.anchorCornerRadius()
      });
    }), this._batchChangeChild(".top-left", {
      x: 0,
      y: 0,
      offsetX: e / 2 + l,
      offsetY: e / 2 + l,
      visible: u && d.indexOf("top-left") >= 0
    }), this._batchChangeChild(".top-center", {
      x: o / 2,
      y: 0,
      offsetY: e / 2 + l,
      visible: u && d.indexOf("top-center") >= 0
    }), this._batchChangeChild(".top-right", {
      x: o,
      y: 0,
      offsetX: e / 2 - l,
      offsetY: e / 2 + l,
      visible: u && d.indexOf("top-right") >= 0
    }), this._batchChangeChild(".middle-left", {
      x: 0,
      y: c / 2,
      offsetX: e / 2 + l,
      visible: u && d.indexOf("middle-left") >= 0
    }), this._batchChangeChild(".middle-right", {
      x: o,
      y: c / 2,
      offsetX: e / 2 - l,
      visible: u && d.indexOf("middle-right") >= 0
    }), this._batchChangeChild(".bottom-left", {
      x: 0,
      y: c,
      offsetX: e / 2 + l,
      offsetY: e / 2 - l,
      visible: u && d.indexOf("bottom-left") >= 0
    }), this._batchChangeChild(".bottom-center", {
      x: o / 2,
      y: c,
      offsetY: e / 2 - l,
      visible: u && d.indexOf("bottom-center") >= 0
    }), this._batchChangeChild(".bottom-right", {
      x: o,
      y: c,
      offsetX: e / 2 - l,
      offsetY: e / 2 - l,
      visible: u && d.indexOf("bottom-right") >= 0
    }), this._batchChangeChild(".rotater", {
      x: o / 2,
      y: -this.rotateAnchorOffset() * bn.Util._sign(c) - l,
      visible: this.rotateEnabled()
    }), this._batchChangeChild(".back", {
      width: o,
      height: c,
      visible: this.borderEnabled(),
      stroke: this.borderStroke(),
      strokeWidth: this.borderStrokeWidth(),
      dash: this.borderDash(),
      x: 0,
      y: 0
    });
    const i = this.anchorStyleFunc();
    i && s.forEach((f) => {
      i(f);
    }), (t = this.getLayer()) === null || t === void 0 || t.batchDraw();
  }
  isTransforming() {
    return this._transforming;
  }
  stopTransform() {
    if (this._transforming) {
      this._removeEvents();
      var t = this.findOne("." + this._movingAnchorName);
      t && t.stopDrag();
    }
  }
  destroy() {
    return this.getStage() && this._cursorChange && this.getStage().content && (this.getStage().content.style.cursor = ""), iv.Group.prototype.destroy.call(this), this.detach(), this._removeEvents(), this;
  }
  toObject() {
    return nv.Node.prototype.toObject.call(this);
  }
  clone(t) {
    var r = nv.Node.prototype.clone.call(this, t);
    return r;
  }
  getClientRect() {
    return this.nodes().length > 0 ? super.getClientRect() : { x: 0, y: 0, width: 0, height: 0 };
  }
}
Ff.Transformer = en;
function LS(a) {
  return a instanceof Array || bn.Util.warn("enabledAnchors value should be an array"), a instanceof Array && a.forEach(function(t) {
    zl.indexOf(t) === -1 && bn.Util.warn("Unknown anchor name: " + t + ". Available names are: " + zl.join(", "));
  }), a || [];
}
en.prototype.className = "Transformer";
(0, OS._registerNode)(en);
cn.Factory.addGetterSetter(en, "enabledAnchors", zl, LS);
cn.Factory.addGetterSetter(en, "flipEnabled", !0, (0, so.getBooleanValidator)());
cn.Factory.addGetterSetter(en, "resizeEnabled", !0);
cn.Factory.addGetterSetter(en, "anchorSize", 10, (0, so.getNumberValidator)());
cn.Factory.addGetterSetter(en, "rotateEnabled", !0);
cn.Factory.addGetterSetter(en, "rotationSnaps", []);
cn.Factory.addGetterSetter(en, "rotateAnchorOffset", 50, (0, so.getNumberValidator)());
cn.Factory.addGetterSetter(en, "rotateAnchorCursor", "crosshair");
cn.Factory.addGetterSetter(en, "rotationSnapTolerance", 5, (0, so.getNumberValidator)());
cn.Factory.addGetterSetter(en, "borderEnabled", !0);
cn.Factory.addGetterSetter(en, "anchorStroke", "rgb(0, 161, 255)");
cn.Factory.addGetterSetter(en, "anchorStrokeWidth", 1, (0, so.getNumberValidator)());
cn.Factory.addGetterSetter(en, "anchorFill", "white");
cn.Factory.addGetterSetter(en, "anchorCornerRadius", 0, (0, so.getNumberValidator)());
cn.Factory.addGetterSetter(en, "borderStroke", "rgb(0, 161, 255)");
cn.Factory.addGetterSetter(en, "borderStrokeWidth", 1, (0, so.getNumberValidator)());
cn.Factory.addGetterSetter(en, "borderDash");
cn.Factory.addGetterSetter(en, "keepRatio", !0);
cn.Factory.addGetterSetter(en, "shiftBehavior", "default");
cn.Factory.addGetterSetter(en, "centeredScaling", !1);
cn.Factory.addGetterSetter(en, "ignoreStroke", !1);
cn.Factory.addGetterSetter(en, "padding", 0, (0, so.getNumberValidator)());
cn.Factory.addGetterSetter(en, "node");
cn.Factory.addGetterSetter(en, "nodes");
cn.Factory.addGetterSetter(en, "boundBoxFunc");
cn.Factory.addGetterSetter(en, "anchorDragBoundFunc");
cn.Factory.addGetterSetter(en, "anchorStyleFunc");
cn.Factory.addGetterSetter(en, "shouldOverdrawWholeArea", !1);
cn.Factory.addGetterSetter(en, "useSingleNodeRotation", !0);
cn.Factory.backCompat(en, {
  lineEnabled: "borderEnabled",
  rotateHandlerOffset: "rotateAnchorOffset",
  enabledHandlers: "enabledAnchors"
});
var If = {};
Object.defineProperty(If, "__esModule", { value: !0 });
If.Wedge = void 0;
const Rf = zr, US = ri, zS = Hr, L2 = lr, GS = Hr;
class ka extends US.Shape {
  _sceneFunc(t) {
    t.beginPath(), t.arc(0, 0, this.radius(), 0, zS.Konva.getAngle(this.angle()), this.clockwise()), t.lineTo(0, 0), t.closePath(), t.fillStrokeShape(this);
  }
  getWidth() {
    return this.radius() * 2;
  }
  getHeight() {
    return this.radius() * 2;
  }
  setWidth(t) {
    this.radius(t / 2);
  }
  setHeight(t) {
    this.radius(t / 2);
  }
}
If.Wedge = ka;
ka.prototype.className = "Wedge";
ka.prototype._centroid = !0;
ka.prototype._attrsAffectingSize = ["radius"];
(0, GS._registerNode)(ka);
Rf.Factory.addGetterSetter(ka, "radius", 0, (0, L2.getNumberValidator)());
Rf.Factory.addGetterSetter(ka, "angle", 0, (0, L2.getNumberValidator)());
Rf.Factory.addGetterSetter(ka, "clockwise", !1);
Rf.Factory.backCompat(ka, {
  angleDeg: "angle",
  getAngleDeg: "getAngle",
  setAngleDeg: "setAngle"
});
var Df = {};
Object.defineProperty(Df, "__esModule", { value: !0 });
Df.Blur = void 0;
const sv = zr, VS = Bn, HS = lr;
function lv() {
  this.r = 0, this.g = 0, this.b = 0, this.a = 0, this.next = null;
}
var WS = [
  512,
  512,
  456,
  512,
  328,
  456,
  335,
  512,
  405,
  328,
  271,
  456,
  388,
  335,
  292,
  512,
  454,
  405,
  364,
  328,
  298,
  271,
  496,
  456,
  420,
  388,
  360,
  335,
  312,
  292,
  273,
  512,
  482,
  454,
  428,
  405,
  383,
  364,
  345,
  328,
  312,
  298,
  284,
  271,
  259,
  496,
  475,
  456,
  437,
  420,
  404,
  388,
  374,
  360,
  347,
  335,
  323,
  312,
  302,
  292,
  282,
  273,
  265,
  512,
  497,
  482,
  468,
  454,
  441,
  428,
  417,
  405,
  394,
  383,
  373,
  364,
  354,
  345,
  337,
  328,
  320,
  312,
  305,
  298,
  291,
  284,
  278,
  271,
  265,
  259,
  507,
  496,
  485,
  475,
  465,
  456,
  446,
  437,
  428,
  420,
  412,
  404,
  396,
  388,
  381,
  374,
  367,
  360,
  354,
  347,
  341,
  335,
  329,
  323,
  318,
  312,
  307,
  302,
  297,
  292,
  287,
  282,
  278,
  273,
  269,
  265,
  261,
  512,
  505,
  497,
  489,
  482,
  475,
  468,
  461,
  454,
  447,
  441,
  435,
  428,
  422,
  417,
  411,
  405,
  399,
  394,
  389,
  383,
  378,
  373,
  368,
  364,
  359,
  354,
  350,
  345,
  341,
  337,
  332,
  328,
  324,
  320,
  316,
  312,
  309,
  305,
  301,
  298,
  294,
  291,
  287,
  284,
  281,
  278,
  274,
  271,
  268,
  265,
  262,
  259,
  257,
  507,
  501,
  496,
  491,
  485,
  480,
  475,
  470,
  465,
  460,
  456,
  451,
  446,
  442,
  437,
  433,
  428,
  424,
  420,
  416,
  412,
  408,
  404,
  400,
  396,
  392,
  388,
  385,
  381,
  377,
  374,
  370,
  367,
  363,
  360,
  357,
  354,
  350,
  347,
  344,
  341,
  338,
  335,
  332,
  329,
  326,
  323,
  320,
  318,
  315,
  312,
  310,
  307,
  304,
  302,
  299,
  297,
  294,
  292,
  289,
  287,
  285,
  282,
  280,
  278,
  275,
  273,
  271,
  269,
  267,
  265,
  263,
  261,
  259
], _S = [
  9,
  11,
  12,
  13,
  13,
  14,
  14,
  15,
  15,
  15,
  15,
  16,
  16,
  16,
  16,
  17,
  17,
  17,
  17,
  17,
  17,
  17,
  18,
  18,
  18,
  18,
  18,
  18,
  18,
  18,
  18,
  19,
  19,
  19,
  19,
  19,
  19,
  19,
  19,
  19,
  19,
  19,
  19,
  19,
  19,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24
];
function jS(a, t) {
  var r = a.data, o = a.width, c = a.height, d, u, l, e, s, i, f, h, v, p, m, x, g, S, y, b, n, w, E, A, O, C, T, P, I = t + t + 1, F = o - 1, B = c - 1, M = t + 1, z = M * (M + 1) / 2, L = new lv(), J = null, ft = L, Q = null, xt = null, St = WS[t], Pt = _S[t];
  for (l = 1; l < I; l++)
    ft = ft.next = new lv(), l === M && (J = ft);
  for (ft.next = L, f = i = 0, u = 0; u < c; u++) {
    for (b = n = w = E = h = v = p = m = 0, x = M * (A = r[i]), g = M * (O = r[i + 1]), S = M * (C = r[i + 2]), y = M * (T = r[i + 3]), h += z * A, v += z * O, p += z * C, m += z * T, ft = L, l = 0; l < M; l++)
      ft.r = A, ft.g = O, ft.b = C, ft.a = T, ft = ft.next;
    for (l = 1; l < M; l++)
      e = i + ((F < l ? F : l) << 2), h += (ft.r = A = r[e]) * (P = M - l), v += (ft.g = O = r[e + 1]) * P, p += (ft.b = C = r[e + 2]) * P, m += (ft.a = T = r[e + 3]) * P, b += A, n += O, w += C, E += T, ft = ft.next;
    for (Q = L, xt = J, d = 0; d < o; d++)
      r[i + 3] = T = m * St >> Pt, T !== 0 ? (T = 255 / T, r[i] = (h * St >> Pt) * T, r[i + 1] = (v * St >> Pt) * T, r[i + 2] = (p * St >> Pt) * T) : r[i] = r[i + 1] = r[i + 2] = 0, h -= x, v -= g, p -= S, m -= y, x -= Q.r, g -= Q.g, S -= Q.b, y -= Q.a, e = f + ((e = d + t + 1) < F ? e : F) << 2, b += Q.r = r[e], n += Q.g = r[e + 1], w += Q.b = r[e + 2], E += Q.a = r[e + 3], h += b, v += n, p += w, m += E, Q = Q.next, x += A = xt.r, g += O = xt.g, S += C = xt.b, y += T = xt.a, b -= A, n -= O, w -= C, E -= T, xt = xt.next, i += 4;
    f += o;
  }
  for (d = 0; d < o; d++) {
    for (n = w = E = b = v = p = m = h = 0, i = d << 2, x = M * (A = r[i]), g = M * (O = r[i + 1]), S = M * (C = r[i + 2]), y = M * (T = r[i + 3]), h += z * A, v += z * O, p += z * C, m += z * T, ft = L, l = 0; l < M; l++)
      ft.r = A, ft.g = O, ft.b = C, ft.a = T, ft = ft.next;
    for (s = o, l = 1; l <= t; l++)
      i = s + d << 2, h += (ft.r = A = r[i]) * (P = M - l), v += (ft.g = O = r[i + 1]) * P, p += (ft.b = C = r[i + 2]) * P, m += (ft.a = T = r[i + 3]) * P, b += A, n += O, w += C, E += T, ft = ft.next, l < B && (s += o);
    for (i = d, Q = L, xt = J, u = 0; u < c; u++)
      e = i << 2, r[e + 3] = T = m * St >> Pt, T > 0 ? (T = 255 / T, r[e] = (h * St >> Pt) * T, r[e + 1] = (v * St >> Pt) * T, r[e + 2] = (p * St >> Pt) * T) : r[e] = r[e + 1] = r[e + 2] = 0, h -= x, v -= g, p -= S, m -= y, x -= Q.r, g -= Q.g, S -= Q.b, y -= Q.a, e = d + ((e = u + M) < B ? e : B) * o << 2, h += b += Q.r = r[e], v += n += Q.g = r[e + 1], p += w += Q.b = r[e + 2], m += E += Q.a = r[e + 3], Q = Q.next, x += A = xt.r, g += O = xt.g, S += C = xt.b, y += T = xt.a, b -= A, n -= O, w -= C, E -= T, xt = xt.next, i += o;
  }
}
const XS = function(t) {
  var r = Math.round(this.blurRadius());
  r > 0 && jS(t, r);
};
Df.Blur = XS;
sv.Factory.addGetterSetter(VS.Node, "blurRadius", 0, (0, HS.getNumberValidator)(), sv.Factory.afterSetFilter);
var Mf = {};
Object.defineProperty(Mf, "__esModule", { value: !0 });
Mf.Brighten = void 0;
const fv = zr, YS = Bn, ZS = lr, KS = function(a) {
  var t = this.brightness() * 255, r = a.data, o = r.length, c;
  for (c = 0; c < o; c += 4)
    r[c] += t, r[c + 1] += t, r[c + 2] += t;
};
Mf.Brighten = KS;
fv.Factory.addGetterSetter(YS.Node, "brightness", 0, (0, ZS.getNumberValidator)(), fv.Factory.afterSetFilter);
var Bf = {};
Object.defineProperty(Bf, "__esModule", { value: !0 });
Bf.Contrast = void 0;
const uv = zr, JS = Bn, QS = lr, $S = function(a) {
  var t = Math.pow((this.contrast() + 100) / 100, 2), r = a.data, o = r.length, c = 150, d = 150, u = 150, l;
  for (l = 0; l < o; l += 4)
    c = r[l], d = r[l + 1], u = r[l + 2], c /= 255, c -= 0.5, c *= t, c += 0.5, c *= 255, d /= 255, d -= 0.5, d *= t, d += 0.5, d *= 255, u /= 255, u -= 0.5, u *= t, u += 0.5, u *= 255, c = c < 0 ? 0 : c > 255 ? 255 : c, d = d < 0 ? 0 : d > 255 ? 255 : d, u = u < 0 ? 0 : u > 255 ? 255 : u, r[l] = c, r[l + 1] = d, r[l + 2] = u;
};
Bf.Contrast = $S;
uv.Factory.addGetterSetter(JS.Node, "contrast", 0, (0, QS.getNumberValidator)(), uv.Factory.afterSetFilter);
var kf = {};
Object.defineProperty(kf, "__esModule", { value: !0 });
kf.Emboss = void 0;
const eo = zr, Nf = Bn, qS = zn, U2 = lr, tE = function(a) {
  var t = this.embossStrength() * 10, r = this.embossWhiteLevel() * 255, o = this.embossDirection(), c = this.embossBlend(), d = 0, u = 0, l = a.data, e = a.width, s = a.height, i = e * 4, f = s;
  switch (o) {
    case "top-left":
      d = -1, u = -1;
      break;
    case "top":
      d = -1, u = 0;
      break;
    case "top-right":
      d = -1, u = 1;
      break;
    case "right":
      d = 0, u = 1;
      break;
    case "bottom-right":
      d = 1, u = 1;
      break;
    case "bottom":
      d = 1, u = 0;
      break;
    case "bottom-left":
      d = 1, u = -1;
      break;
    case "left":
      d = 0, u = -1;
      break;
    default:
      qS.Util.error("Unknown emboss direction: " + o);
  }
  do {
    var h = (f - 1) * i, v = d;
    f + v < 1 && (v = 0), f + v > s && (v = 0);
    var p = (f - 1 + v) * e * 4, m = e;
    do {
      var x = h + (m - 1) * 4, g = u;
      m + g < 1 && (g = 0), m + g > e && (g = 0);
      var S = p + (m - 1 + g) * 4, y = l[x] - l[S], b = l[x + 1] - l[S + 1], n = l[x + 2] - l[S + 2], w = y, E = w > 0 ? w : -w, A = b > 0 ? b : -b, O = n > 0 ? n : -n;
      if (A > E && (w = b), O > E && (w = n), w *= t, c) {
        var C = l[x] + w, T = l[x + 1] + w, P = l[x + 2] + w;
        l[x] = C > 255 ? 255 : C < 0 ? 0 : C, l[x + 1] = T > 255 ? 255 : T < 0 ? 0 : T, l[x + 2] = P > 255 ? 255 : P < 0 ? 0 : P;
      } else {
        var I = r - w;
        I < 0 ? I = 0 : I > 255 && (I = 255), l[x] = l[x + 1] = l[x + 2] = I;
      }
    } while (--m);
  } while (--f);
};
kf.Emboss = tE;
eo.Factory.addGetterSetter(Nf.Node, "embossStrength", 0.5, (0, U2.getNumberValidator)(), eo.Factory.afterSetFilter);
eo.Factory.addGetterSetter(Nf.Node, "embossWhiteLevel", 0.5, (0, U2.getNumberValidator)(), eo.Factory.afterSetFilter);
eo.Factory.addGetterSetter(Nf.Node, "embossDirection", "top-left", null, eo.Factory.afterSetFilter);
eo.Factory.addGetterSetter(Nf.Node, "embossBlend", !1, null, eo.Factory.afterSetFilter);
var Lf = {};
Object.defineProperty(Lf, "__esModule", { value: !0 });
Lf.Enhance = void 0;
const hv = zr, eE = Bn, rE = lr;
function eh(a, t, r, o, c) {
  var d = r - t, u = c - o, l;
  return d === 0 ? o + u / 2 : u === 0 ? o : (l = (a - t) / d, l = u * l + o, l);
}
const nE = function(a) {
  var t = a.data, r = t.length, o = t[0], c = o, d, u = t[1], l = u, e, s = t[2], i = s, f, h, v = this.enhance();
  if (v !== 0) {
    for (h = 0; h < r; h += 4)
      d = t[h + 0], d < o ? o = d : d > c && (c = d), e = t[h + 1], e < u ? u = e : e > l && (l = e), f = t[h + 2], f < s ? s = f : f > i && (i = f);
    c === o && (c = 255, o = 0), l === u && (l = 255, u = 0), i === s && (i = 255, s = 0);
    var p, m, x, g, S, y, b, n, w;
    for (v > 0 ? (m = c + v * (255 - c), x = o - v * (o - 0), S = l + v * (255 - l), y = u - v * (u - 0), n = i + v * (255 - i), w = s - v * (s - 0)) : (p = (c + o) * 0.5, m = c + v * (c - p), x = o + v * (o - p), g = (l + u) * 0.5, S = l + v * (l - g), y = u + v * (u - g), b = (i + s) * 0.5, n = i + v * (i - b), w = s + v * (s - b)), h = 0; h < r; h += 4)
      t[h + 0] = eh(t[h + 0], o, c, x, m), t[h + 1] = eh(t[h + 1], u, l, y, S), t[h + 2] = eh(t[h + 2], s, i, w, n);
  }
};
Lf.Enhance = nE;
hv.Factory.addGetterSetter(eE.Node, "enhance", 0, (0, rE.getNumberValidator)(), hv.Factory.afterSetFilter);
var Uf = {};
Object.defineProperty(Uf, "__esModule", { value: !0 });
Uf.Grayscale = void 0;
const iE = function(a) {
  var t = a.data, r = t.length, o, c;
  for (o = 0; o < r; o += 4)
    c = 0.34 * t[o] + 0.5 * t[o + 1] + 0.16 * t[o + 2], t[o] = c, t[o + 1] = c, t[o + 2] = c;
};
Uf.Grayscale = iE;
var zf = {};
Object.defineProperty(zf, "__esModule", { value: !0 });
zf.HSL = void 0;
const ps = zr, pc = Bn, yc = lr;
ps.Factory.addGetterSetter(pc.Node, "hue", 0, (0, yc.getNumberValidator)(), ps.Factory.afterSetFilter);
ps.Factory.addGetterSetter(pc.Node, "saturation", 0, (0, yc.getNumberValidator)(), ps.Factory.afterSetFilter);
ps.Factory.addGetterSetter(pc.Node, "luminance", 0, (0, yc.getNumberValidator)(), ps.Factory.afterSetFilter);
const aE = function(a) {
  var t = a.data, r = t.length, o = 1, c = Math.pow(2, this.saturation()), d = Math.abs(this.hue() + 360) % 360, u = this.luminance() * 127, l, e = o * c * Math.cos(d * Math.PI / 180), s = o * c * Math.sin(d * Math.PI / 180), i = 0.299 * o + 0.701 * e + 0.167 * s, f = 0.587 * o - 0.587 * e + 0.33 * s, h = 0.114 * o - 0.114 * e - 0.497 * s, v = 0.299 * o - 0.299 * e - 0.328 * s, p = 0.587 * o + 0.413 * e + 0.035 * s, m = 0.114 * o - 0.114 * e + 0.293 * s, x = 0.299 * o - 0.3 * e + 1.25 * s, g = 0.587 * o - 0.586 * e - 1.05 * s, S = 0.114 * o + 0.886 * e - 0.2 * s, y, b, n, w;
  for (l = 0; l < r; l += 4)
    y = t[l + 0], b = t[l + 1], n = t[l + 2], w = t[l + 3], t[l + 0] = i * y + f * b + h * n + u, t[l + 1] = v * y + p * b + m * n + u, t[l + 2] = x * y + g * b + S * n + u, t[l + 3] = w;
};
zf.HSL = aE;
var Gf = {};
Object.defineProperty(Gf, "__esModule", { value: !0 });
Gf.HSV = void 0;
const ys = zr, mc = Bn, xc = lr, oE = function(a) {
  var t = a.data, r = t.length, o = Math.pow(2, this.value()), c = Math.pow(2, this.saturation()), d = Math.abs(this.hue() + 360) % 360, u, l = o * c * Math.cos(d * Math.PI / 180), e = o * c * Math.sin(d * Math.PI / 180), s = 0.299 * o + 0.701 * l + 0.167 * e, i = 0.587 * o - 0.587 * l + 0.33 * e, f = 0.114 * o - 0.114 * l - 0.497 * e, h = 0.299 * o - 0.299 * l - 0.328 * e, v = 0.587 * o + 0.413 * l + 0.035 * e, p = 0.114 * o - 0.114 * l + 0.293 * e, m = 0.299 * o - 0.3 * l + 1.25 * e, x = 0.587 * o - 0.586 * l - 1.05 * e, g = 0.114 * o + 0.886 * l - 0.2 * e, S, y, b, n;
  for (u = 0; u < r; u += 4)
    S = t[u + 0], y = t[u + 1], b = t[u + 2], n = t[u + 3], t[u + 0] = s * S + i * y + f * b, t[u + 1] = h * S + v * y + p * b, t[u + 2] = m * S + x * y + g * b, t[u + 3] = n;
};
Gf.HSV = oE;
ys.Factory.addGetterSetter(mc.Node, "hue", 0, (0, xc.getNumberValidator)(), ys.Factory.afterSetFilter);
ys.Factory.addGetterSetter(mc.Node, "saturation", 0, (0, xc.getNumberValidator)(), ys.Factory.afterSetFilter);
ys.Factory.addGetterSetter(mc.Node, "value", 0, (0, xc.getNumberValidator)(), ys.Factory.afterSetFilter);
var Vf = {};
Object.defineProperty(Vf, "__esModule", { value: !0 });
Vf.Invert = void 0;
const sE = function(a) {
  var t = a.data, r = t.length, o;
  for (o = 0; o < r; o += 4)
    t[o] = 255 - t[o], t[o + 1] = 255 - t[o + 1], t[o + 2] = 255 - t[o + 2];
};
Vf.Invert = sE;
var Hf = {};
Object.defineProperty(Hf, "__esModule", { value: !0 });
Hf.Kaleidoscope = void 0;
const Gl = zr, z2 = Bn, cv = zn, G2 = lr;
var lE = function(a, t, r) {
  var o = a.data, c = t.data, d = a.width, u = a.height, l = r.polarCenterX || d / 2, e = r.polarCenterY || u / 2, s, i, f, h = 0, v = 0, p = 0, m = 0, x, g = Math.sqrt(l * l + e * e);
  i = d - l, f = u - e, x = Math.sqrt(i * i + f * f), g = x > g ? x : g;
  var S = u, y = d, b, n, w = 360 / y * Math.PI / 180, E, A;
  for (n = 0; n < y; n += 1)
    for (E = Math.sin(n * w), A = Math.cos(n * w), b = 0; b < S; b += 1)
      i = Math.floor(l + g * b / S * A), f = Math.floor(e + g * b / S * E), s = (f * d + i) * 4, h = o[s + 0], v = o[s + 1], p = o[s + 2], m = o[s + 3], s = (n + b * d) * 4, c[s + 0] = h, c[s + 1] = v, c[s + 2] = p, c[s + 3] = m;
}, fE = function(a, t, r) {
  var o = a.data, c = t.data, d = a.width, u = a.height, l = r.polarCenterX || d / 2, e = r.polarCenterY || u / 2, s, i, f, h, v, p = 0, m = 0, x = 0, g = 0, S, y = Math.sqrt(l * l + e * e);
  i = d - l, f = u - e, S = Math.sqrt(i * i + f * f), y = S > y ? S : y;
  var b = u, n = d, w, E, A = r.polarRotation || 0, O, C;
  for (i = 0; i < d; i += 1)
    for (f = 0; f < u; f += 1)
      h = i - l, v = f - e, w = Math.sqrt(h * h + v * v) * b / y, E = (Math.atan2(v, h) * 180 / Math.PI + 360 + A) % 360, E = E * n / 360, O = Math.floor(E), C = Math.floor(w), s = (C * d + O) * 4, p = o[s + 0], m = o[s + 1], x = o[s + 2], g = o[s + 3], s = (f * d + i) * 4, c[s + 0] = p, c[s + 1] = m, c[s + 2] = x, c[s + 3] = g;
};
const uE = function(a) {
  var t = a.width, r = a.height, o, c, d, u, l, e, s, i, f, h, v = Math.round(this.kaleidoscopePower()), p = Math.round(this.kaleidoscopeAngle()), m = Math.floor(t * (p % 360) / 360);
  if (!(v < 1)) {
    var x = cv.Util.createCanvasElement();
    x.width = t, x.height = r;
    var g = x.getContext("2d").getImageData(0, 0, t, r);
    cv.Util.releaseCanvas(x), lE(a, g, {
      polarCenterX: t / 2,
      polarCenterY: r / 2
    });
    for (var S = t / Math.pow(2, v); S <= 8; )
      S = S * 2, v -= 1;
    S = Math.ceil(S);
    var y = S, b = 0, n = y, w = 1;
    for (m + S > t && (b = y, n = 0, w = -1), c = 0; c < r; c += 1)
      for (o = b; o !== n; o += w)
        d = Math.round(o + m) % t, f = (t * c + d) * 4, l = g.data[f + 0], e = g.data[f + 1], s = g.data[f + 2], i = g.data[f + 3], h = (t * c + o) * 4, g.data[h + 0] = l, g.data[h + 1] = e, g.data[h + 2] = s, g.data[h + 3] = i;
    for (c = 0; c < r; c += 1)
      for (y = Math.floor(S), u = 0; u < v; u += 1) {
        for (o = 0; o < y + 1; o += 1)
          f = (t * c + o) * 4, l = g.data[f + 0], e = g.data[f + 1], s = g.data[f + 2], i = g.data[f + 3], h = (t * c + y * 2 - o - 1) * 4, g.data[h + 0] = l, g.data[h + 1] = e, g.data[h + 2] = s, g.data[h + 3] = i;
        y *= 2;
      }
    fE(g, a, { polarRotation: 0 });
  }
};
Hf.Kaleidoscope = uE;
Gl.Factory.addGetterSetter(z2.Node, "kaleidoscopePower", 2, (0, G2.getNumberValidator)(), Gl.Factory.afterSetFilter);
Gl.Factory.addGetterSetter(z2.Node, "kaleidoscopeAngle", 0, (0, G2.getNumberValidator)(), Gl.Factory.afterSetFilter);
var Wf = {};
Object.defineProperty(Wf, "__esModule", { value: !0 });
Wf.Mask = void 0;
const dv = zr, hE = Bn, cE = lr;
function Cl(a, t, r) {
  var o = (r * a.width + t) * 4, c = [];
  return c.push(a.data[o++], a.data[o++], a.data[o++], a.data[o++]), c;
}
function Qs(a, t) {
  return Math.sqrt(Math.pow(a[0] - t[0], 2) + Math.pow(a[1] - t[1], 2) + Math.pow(a[2] - t[2], 2));
}
function dE(a) {
  for (var t = [0, 0, 0], r = 0; r < a.length; r++)
    t[0] += a[r][0], t[1] += a[r][1], t[2] += a[r][2];
  return t[0] /= a.length, t[1] /= a.length, t[2] /= a.length, t;
}
function vE(a, t) {
  var r = Cl(a, 0, 0), o = Cl(a, a.width - 1, 0), c = Cl(a, 0, a.height - 1), d = Cl(a, a.width - 1, a.height - 1), u = t || 10;
  if (Qs(r, o) < u && Qs(o, d) < u && Qs(d, c) < u && Qs(c, r) < u) {
    for (var l = dE([o, r, d, c]), e = [], s = 0; s < a.width * a.height; s++) {
      var i = Qs(l, [
        a.data[s * 4],
        a.data[s * 4 + 1],
        a.data[s * 4 + 2]
      ]);
      e[s] = i < u ? 0 : 255;
    }
    return e;
  }
}
function gE(a, t) {
  for (var r = 0; r < a.width * a.height; r++)
    a.data[4 * r + 3] = t[r];
}
function pE(a, t, r) {
  for (var o = [1, 1, 1, 1, 0, 1, 1, 1, 1], c = Math.round(Math.sqrt(o.length)), d = Math.floor(c / 2), u = [], l = 0; l < r; l++)
    for (var e = 0; e < t; e++) {
      for (var s = l * t + e, i = 0, f = 0; f < c; f++)
        for (var h = 0; h < c; h++) {
          var v = l + f - d, p = e + h - d;
          if (v >= 0 && v < r && p >= 0 && p < t) {
            var m = v * t + p, x = o[f * c + h];
            i += a[m] * x;
          }
        }
      u[s] = i === 255 * 8 ? 255 : 0;
    }
  return u;
}
function yE(a, t, r) {
  for (var o = [1, 1, 1, 1, 1, 1, 1, 1, 1], c = Math.round(Math.sqrt(o.length)), d = Math.floor(c / 2), u = [], l = 0; l < r; l++)
    for (var e = 0; e < t; e++) {
      for (var s = l * t + e, i = 0, f = 0; f < c; f++)
        for (var h = 0; h < c; h++) {
          var v = l + f - d, p = e + h - d;
          if (v >= 0 && v < r && p >= 0 && p < t) {
            var m = v * t + p, x = o[f * c + h];
            i += a[m] * x;
          }
        }
      u[s] = i >= 255 * 4 ? 255 : 0;
    }
  return u;
}
function mE(a, t, r) {
  for (var o = [0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111], c = Math.round(Math.sqrt(o.length)), d = Math.floor(c / 2), u = [], l = 0; l < r; l++)
    for (var e = 0; e < t; e++) {
      for (var s = l * t + e, i = 0, f = 0; f < c; f++)
        for (var h = 0; h < c; h++) {
          var v = l + f - d, p = e + h - d;
          if (v >= 0 && v < r && p >= 0 && p < t) {
            var m = v * t + p, x = o[f * c + h];
            i += a[m] * x;
          }
        }
      u[s] = i;
    }
  return u;
}
const xE = function(a) {
  var t = this.threshold(), r = vE(a, t);
  return r && (r = pE(r, a.width, a.height), r = yE(r, a.width, a.height), r = mE(r, a.width, a.height), gE(a, r)), a;
};
Wf.Mask = xE;
dv.Factory.addGetterSetter(hE.Node, "threshold", 0, (0, cE.getNumberValidator)(), dv.Factory.afterSetFilter);
var _f = {};
Object.defineProperty(_f, "__esModule", { value: !0 });
_f.Noise = void 0;
const vv = zr, bE = Bn, wE = lr, SE = function(a) {
  var t = this.noise() * 255, r = a.data, o = r.length, c = t / 2, d;
  for (d = 0; d < o; d += 4)
    r[d + 0] += c - 2 * c * Math.random(), r[d + 1] += c - 2 * c * Math.random(), r[d + 2] += c - 2 * c * Math.random();
};
_f.Noise = SE;
vv.Factory.addGetterSetter(bE.Node, "noise", 0.2, (0, wE.getNumberValidator)(), vv.Factory.afterSetFilter);
var jf = {};
Object.defineProperty(jf, "__esModule", { value: !0 });
jf.Pixelate = void 0;
const gv = zr, EE = zn, AE = Bn, CE = lr, TE = function(a) {
  var t = Math.ceil(this.pixelSize()), r = a.width, o = a.height, c, d, u, l, e, s, i, f = Math.ceil(r / t), h = Math.ceil(o / t), v, p, m, x, g, S, y, b = a.data;
  if (t <= 0) {
    EE.Util.error("pixelSize value can not be <= 0");
    return;
  }
  for (g = 0; g < f; g += 1)
    for (S = 0; S < h; S += 1) {
      for (l = 0, e = 0, s = 0, i = 0, v = g * t, p = v + t, m = S * t, x = m + t, y = 0, c = v; c < p; c += 1)
        if (!(c >= r))
          for (d = m; d < x; d += 1)
            d >= o || (u = (r * d + c) * 4, l += b[u + 0], e += b[u + 1], s += b[u + 2], i += b[u + 3], y += 1);
      for (l = l / y, e = e / y, s = s / y, i = i / y, c = v; c < p; c += 1)
        if (!(c >= r))
          for (d = m; d < x; d += 1)
            d >= o || (u = (r * d + c) * 4, b[u + 0] = l, b[u + 1] = e, b[u + 2] = s, b[u + 3] = i);
    }
};
jf.Pixelate = TE;
gv.Factory.addGetterSetter(AE.Node, "pixelSize", 8, (0, CE.getNumberValidator)(), gv.Factory.afterSetFilter);
var Xf = {};
Object.defineProperty(Xf, "__esModule", { value: !0 });
Xf.Posterize = void 0;
const pv = zr, PE = Bn, OE = lr, FE = function(a) {
  var t = Math.round(this.levels() * 254) + 1, r = a.data, o = r.length, c = 255 / t, d;
  for (d = 0; d < o; d += 1)
    r[d] = Math.floor(r[d] / c) * c;
};
Xf.Posterize = FE;
pv.Factory.addGetterSetter(PE.Node, "levels", 0.5, (0, OE.getNumberValidator)(), pv.Factory.afterSetFilter);
var Yf = {};
Object.defineProperty(Yf, "__esModule", { value: !0 });
Yf.RGB = void 0;
const Vl = zr, bc = Bn, IE = lr, RE = function(a) {
  var t = a.data, r = t.length, o = this.red(), c = this.green(), d = this.blue(), u, l;
  for (u = 0; u < r; u += 4)
    l = (0.34 * t[u] + 0.5 * t[u + 1] + 0.16 * t[u + 2]) / 255, t[u] = l * o, t[u + 1] = l * c, t[u + 2] = l * d, t[u + 3] = t[u + 3];
};
Yf.RGB = RE;
Vl.Factory.addGetterSetter(bc.Node, "red", 0, function(a) {
  return this._filterUpToDate = !1, a > 255 ? 255 : a < 0 ? 0 : Math.round(a);
});
Vl.Factory.addGetterSetter(bc.Node, "green", 0, function(a) {
  return this._filterUpToDate = !1, a > 255 ? 255 : a < 0 ? 0 : Math.round(a);
});
Vl.Factory.addGetterSetter(bc.Node, "blue", 0, IE.RGBComponent, Vl.Factory.afterSetFilter);
var Zf = {};
Object.defineProperty(Zf, "__esModule", { value: !0 });
Zf.RGBA = void 0;
const w0 = zr, Kf = Bn, DE = lr, ME = function(a) {
  var t = a.data, r = t.length, o = this.red(), c = this.green(), d = this.blue(), u = this.alpha(), l, e;
  for (l = 0; l < r; l += 4)
    e = 1 - u, t[l] = o * u + t[l] * e, t[l + 1] = c * u + t[l + 1] * e, t[l + 2] = d * u + t[l + 2] * e;
};
Zf.RGBA = ME;
w0.Factory.addGetterSetter(Kf.Node, "red", 0, function(a) {
  return this._filterUpToDate = !1, a > 255 ? 255 : a < 0 ? 0 : Math.round(a);
});
w0.Factory.addGetterSetter(Kf.Node, "green", 0, function(a) {
  return this._filterUpToDate = !1, a > 255 ? 255 : a < 0 ? 0 : Math.round(a);
});
w0.Factory.addGetterSetter(Kf.Node, "blue", 0, DE.RGBComponent, w0.Factory.afterSetFilter);
w0.Factory.addGetterSetter(Kf.Node, "alpha", 1, function(a) {
  return this._filterUpToDate = !1, a > 1 ? 1 : a < 0 ? 0 : a;
});
var Jf = {};
Object.defineProperty(Jf, "__esModule", { value: !0 });
Jf.Sepia = void 0;
const BE = function(a) {
  var t = a.data, r = t.length, o, c, d, u;
  for (o = 0; o < r; o += 4)
    c = t[o + 0], d = t[o + 1], u = t[o + 2], t[o + 0] = Math.min(255, c * 0.393 + d * 0.769 + u * 0.189), t[o + 1] = Math.min(255, c * 0.349 + d * 0.686 + u * 0.168), t[o + 2] = Math.min(255, c * 0.272 + d * 0.534 + u * 0.131);
};
Jf.Sepia = BE;
var Qf = {};
Object.defineProperty(Qf, "__esModule", { value: !0 });
Qf.Solarize = void 0;
const kE = function(a) {
  var t = a.data, r = a.width, o = a.height, c = r * 4, d = o;
  do {
    var u = (d - 1) * c, l = r;
    do {
      var e = u + (l - 1) * 4, s = t[e], i = t[e + 1], f = t[e + 2];
      s > 127 && (s = 255 - s), i > 127 && (i = 255 - i), f > 127 && (f = 255 - f), t[e] = s, t[e + 1] = i, t[e + 2] = f;
    } while (--l);
  } while (--d);
};
Qf.Solarize = kE;
var $f = {};
Object.defineProperty($f, "__esModule", { value: !0 });
$f.Threshold = void 0;
const yv = zr, NE = Bn, LE = lr, UE = function(a) {
  var t = this.threshold() * 255, r = a.data, o = r.length, c;
  for (c = 0; c < o; c += 1)
    r[c] = r[c] < t ? 0 : 255;
};
$f.Threshold = UE;
yv.Factory.addGetterSetter(NE.Node, "threshold", 0.5, (0, LE.getNumberValidator)(), yv.Factory.afterSetFilter);
Object.defineProperty(sf, "__esModule", { value: !0 });
sf.Konva = void 0;
const mv = o2, zE = df, GE = pf, VE = xf, HE = bf, WE = wf, xv = gs, _E = R0, jE = Os, XE = M0, YE = Af, ZE = Cf, KE = Tf, JE = Pf, QE = Io, $E = Of, qE = Ff, tA = If, eA = Df, rA = Mf, nA = Bf, iA = kf, aA = Lf, oA = Uf, sA = zf, lA = Gf, fA = Vf, uA = Hf, hA = Wf, cA = _f, dA = jf, vA = Xf, gA = Yf, pA = Zf, yA = Jf, mA = Qf, xA = $f;
sf.Konva = mv.Konva.Util._assign(mv.Konva, {
  Arc: zE.Arc,
  Arrow: GE.Arrow,
  Circle: VE.Circle,
  Ellipse: HE.Ellipse,
  Image: WE.Image,
  Label: xv.Label,
  Tag: xv.Tag,
  Line: _E.Line,
  Path: jE.Path,
  Rect: XE.Rect,
  RegularPolygon: YE.RegularPolygon,
  Ring: ZE.Ring,
  Sprite: KE.Sprite,
  Star: JE.Star,
  Text: QE.Text,
  TextPath: $E.TextPath,
  Transformer: qE.Transformer,
  Wedge: tA.Wedge,
  Filters: {
    Blur: eA.Blur,
    Brighten: rA.Brighten,
    Contrast: nA.Contrast,
    Emboss: iA.Emboss,
    Enhance: aA.Enhance,
    Grayscale: oA.Grayscale,
    HSL: sA.HSL,
    HSV: lA.HSV,
    Invert: fA.Invert,
    Kaleidoscope: uA.Kaleidoscope,
    Mask: hA.Mask,
    Noise: cA.Noise,
    Pixelate: dA.Pixelate,
    Posterize: vA.Posterize,
    RGB: gA.RGB,
    RGBA: pA.RGBA,
    Sepia: yA.Sepia,
    Solarize: mA.Solarize,
    Threshold: xA.Threshold
  }
});
var bA = oc.exports;
Object.defineProperty(bA, "__esModule", { value: !0 });
const wA = sf;
oc.exports = wA.Konva;
var SA = oc.exports;
const xi = /* @__PURE__ */ Ro(SA);
function ss(a) {
  return a * Math.PI / 180;
}
function r0(a, t, r, o) {
  const c = r[0] * a[1] - r[1] * a[0];
  if (Math.abs(c) < 0.01)
    return;
  const d = (a[0] * (o[1] - t[1]) - a[1] * (o[0] - t[0])) / c, u = -(r[0] * (t[1] - o[1]) - r[1] * (t[0] - o[0])) / c;
  return { point: [d * r[0] + o[0], d * r[1] + o[1]], t: d, s: u };
}
function Ih(a, t, r) {
  for (let o = 0; o < a.length; ++o)
    a[o][0] *= t, a[o][1] *= r;
}
function Tl(a, t, r) {
  const o = [];
  let c = a.length - 1;
  for (let d = 0; d < a.length; ++d) {
    const u = a[c], l = a[d], e = r0(t, r, [l[0] - u[0], l[1] - u[1]], u);
    c = d, e !== void 0 && (e.t < 0 || e.t > 1 || e.s < 0 || o.push(e.point));
  }
  return o;
}
function qf(a) {
  const t = a[0], r = [t[0], t[1]], o = [t[0], t[1]];
  for (const u of a)
    r[0] = Math.min(r[0], u[0]), r[1] = Math.min(r[1], u[1]), o[0] = Math.max(o[0], u[0]), o[1] = Math.max(o[1], u[1]);
  const c = o[0] - r[0], d = o[1] - r[1];
  return { bottom_left: r, top_right: o, width: c, height: d };
}
function bv(a) {
  const { bottom_left: t, top_right: r } = qf(a), o = [-(r[0] + t[0]) / 2, -(r[1] + t[1]) / 2];
  V2(a, o);
}
function Rh(a, t, r, o, c) {
  const d = [
    [a, t],
    [r, o],
    [a, o],
    [r, t]
  ];
  return Dh(d, c), qf(d);
}
function Dh(a, t) {
  const r = [
    [Math.cos(t), -Math.sin(t)],
    [Math.sin(t), Math.cos(t)]
  ];
  EA(a, r);
}
function EA(a, t) {
  for (let r = 0; r < a.length; ++r) {
    const o = a[r][0], c = a[r][1];
    a[r][0] = t[0][0] * o + t[0][1] * c, a[r][1] = t[1][0] * o + t[1][1] * c;
  }
}
function V2(a, t) {
  for (let r = 0; r < a.length; ++r)
    a[r] = [a[r][0] + t[0], a[r][1] + t[1]];
}
function AA(a, t) {
  const r = [];
  for (let o = 0; o < t; ++o)
    r.push(ss(a / 2 - a * Math.random()));
  return r;
}
function CA(a) {
  let [t, r, o, c] = AA(a, 4);
  return t *= 1.2, o *= 1.2, TA(t, r, o, c);
}
function TA(a, t, r, o) {
  const c = [-1, 1], d = [1, 1], u = [1, -1], l = [-1, -1], e = [Math.cos(a), Math.sin(a)], s = [Math.cos(t + Math.PI / 2), Math.sin(t + Math.PI / 2)], i = [Math.cos(r + Math.PI), Math.sin(r + Math.PI)], f = [Math.cos(o + 3 * Math.PI / 2), Math.sin(o + 3 * Math.PI / 2)], h = r0(e, c, s, d).point, v = r0(s, d, i, u).point, p = r0(i, u, f, l).point, x = [r0(f, l, e, c).point, h, v, p];
  bv(x);
  const { width: g, height: S } = qf(x);
  Ih(x, 2 / g, 2 / S);
  const y = Tl(x, [1, 1], [0, 0]), b = 1 / y[0][0], n = 1 / y[0][1], w = Tl(x, [1, -1], [0, 0]), E = 1 / w[0][0], A = 1 / w[0][1], O = Tl(x, [-1, -1], [0, 0]), C = 1 / O[0][0], T = 1 / O[0][1], P = Tl(x, [-1, 1], [0, 0]), I = 1 / P[0][0], F = 1 / P[0][1], B = Math.max(E, b, C, I), M = Math.min(E, b, C, I), z = Math.max(A, n, T, F), L = Math.min(A, n, T, F);
  for (let J = 0; J < x.length; ++J)
    x[J][0] > 0 ? x[J][0] *= B : x[J][0] *= -M, x[J][1] > 0 ? x[J][1] *= z : x[J][1] *= -L;
  return bv(x), x;
}
class Mh extends Zl {
  constructor(r, o) {
    super(r, o);
    _e(this, "selected");
    _e(this, "image");
    _e(this, "type");
    _e(this, "inPromise");
    this.selected = !1, this.image = void 0, this.type = "image", this.options.type = "image", this.inPromise = !1;
  }
  randomOptions(r) {
    if (this.image !== void 0 && this.image.type !== r && delete this.image, this.image === void 0)
      switch (r) {
        case "internalsvg": {
          this.image = new B1(this.vida);
          break;
        }
        case "qrcode": {
          this.image = new U1(this.vida);
          break;
        }
        case "internalphoto": {
          this.image = new ju(this.vida, "internalphoto");
          break;
        }
        default:
          throw Error("Not implemented");
      }
    return {
      type: "image",
      image: this.image.randomOptions(),
      scale: 20,
      position: { x: 0.5, y: 0.5 },
      angle: 0
    };
  }
  toJson() {
    return this.konvaElement ? {
      id: this.id(),
      type: "image",
      scale: this.options.scale,
      image: this.image === void 0 ? void 0 : this.image.toJson(),
      position: this.options.position,
      angle: this.options.angle,
      zIndex: this.zIndex(),
      i18n: this.options.i18n,
      rules: this.options.rules !== void 0 ? this.options.rules : {}
    } : {};
  }
  async toPdf() {
    var u;
    if (!this.konvaElement)
      return;
    const { x: r, y: o } = Eo(this.displayedPosition, this.documentSize), c = {
      absolutePosition: {
        x: oi(r - this.konvaElement.width() / 2),
        y: oi(o - this.konvaElement.height() / 2)
      },
      width: oi(this.konvaElement.width()),
      height: oi(this.konvaElement.height()),
      svg: ""
    }, d = this.currentAngle();
    if (d != 0) {
      const { width: l, height: e } = Rh(0, 0, this.konvaElement.width(), this.konvaElement.height(), ss(d));
      c.width = oi(l), c.height = oi(e), c.absolutePosition.x = oi(r - l / 2), c.absolutePosition.y = oi(o - e / 2);
    }
    if (c.svg = await this.image.imageToSvg(), d != 0) {
      const e = vh(c.svg).documentElement, s = (u = e.getAttribute("viewBox")) == null ? void 0 : u.split(" ").map((v) => parseInt(v));
      if (s === void 0 || s.length !== 4)
        throw new jn("Undefined viewbox while rotating svg inside toPdf");
      const { bottom_left: i, width: f, height: h } = Rh(
        s[0],
        s[1],
        s[2],
        s[3],
        ss(d)
      );
      e.setAttribute("width", f.toString()), e.setAttribute("height", h.toString()), e.setAttribute("viewBox", `${i[0]} ${i[1]} ${f} ${h}`), c.svg = `
            <svg width="${f}" height="${h}" viewBox="${i[0]} ${i[1]} ${f} ${h}">
                <g transform="rotate(${d})">
                    ${e.innerHTML}
                </g>
                </svg>
                `;
    }
    return {
      content: [c],
      status: "ok"
    };
  }
  select() {
    Or(this.options.rules, "self.fixed") !== !0 && this.konvaElement && (this.selected = !0, this.konvaTransformer || (this.konvaTransformer = new xi.Transformer({
      resizeEnabled: !0,
      rotateEnabled: !0,
      enabledAnchors: ["top-left", "top-right", "bottom-left", "bottom-right"],
      keepRatio: !0
    })), this.konvaTransformer.nodes([this.konvaElement]), this.vida.registerTransformer(this.konvaTransformer), this.konvaTransformer.resizeEnabled(Or(this.options.rules, "size.fixed") !== !0), this.konvaTransformer.rotateEnabled(Or(this.options.rules, "angle.fixed") !== !0), this.konvaElement.setDraggable(Or(this.options.rules, "position.fixed") !== !0 && (Or(this.options.rules, "position.properties.x.fixed") !== !0 || Or(this.options.rules, "position.properties.y.fixed") !== !0)), this.vida.draw());
  }
  unselect() {
    this.selected = !1, this.konvaElement && this.konvaElement.setDraggable(!1), this.konvaTransformer && this.konvaTransformer.detach();
  }
  destroy() {
    this.konvaElement && this.konvaElement.destroy();
  }
  internalUpdate(r, o) {
    return new Promise((c, d) => {
      if (this.inPromise) {
        c(!1);
        return;
      }
      if (!r) {
        c(!1);
        return;
      }
      if (console.assert(this.image || r.image && r.image.type), !this.image || r.image && r.image.type && this.image.type !== r.image.type) {
        if (r.image === void 0)
          throw new Error("options.image should be defined in the first run of update");
        if (this.image && (delete this.image, this.image = void 0), r.image.type === "internalsvg")
          this.image = new B1(this.vida);
        else if (r.image.type === "qrcode")
          this.image = new U1(this.vida);
        else if (r.image.type === "urlphoto")
          this.image = new ju(this.vida, "urlphoto");
        else if (r.image.type === "internalphoto")
          this.image = new ju(this.vida, "internalphoto");
        else
          throw new Error(`Unknown option ${r.image.type}`);
      }
      this.inPromise = !0, this.image.update(r.image).then(() => {
        const u = !this.documentSize || o && (this.documentSize.width !== o.width && o.width !== void 0 || this.documentSize.height !== o.height && o.height !== void 0);
        if (u || this.image.recomputeImage || r.scale !== void 0 && Math.abs(r.scale - this.currentScale()) > 0.05) {
          this.image.recomputePosition = !0, this.documentSize === void 0 && ((o.width === void 0 || o.height === void 0) && (o.width === void 0 && (o.width = 0), o.height === void 0 && (o.height = 0), console.warn("Please provide valid document dimensions for while documentisize is not setup")), this.documentSize = { width: o.width, height: o.height }), o && o.width && (this.documentSize.width = o.width), o && o.height && (this.documentSize.height = o.height);
          const e = this.documentSize.width / this.image.originalSize.width, s = this.documentSize.height / this.image.originalSize.height, i = this.optionsScale() / 100 * Math.max(e, s);
          this.image.recomputeImage = !1;
          const f = i * this.image.originalSize.width, h = i * this.image.originalSize.height;
          this.inPromise = !0, this.image.makeImage(f, h).then(() => {
            const v = this.currentAngle();
            this.konvaElement && this.konvaElement.destroy(), this.konvaElement = new xi.Image({ draggable: !1, image: this.image.image() }), this.konvaElement.on("pointerclick", (m) => {
              this.vida.isSelected(this.id()) || (m.cancelBubble = !0, this.vida.selectComponent(this.id()));
            }), this.konvaElement.on("dragend", () => {
              this.adjustPosition();
            }), this.konvaElement.on("transformend", () => {
              this.adjustSizeAndAngle();
            }), this.vida.registerComponent(this.konvaElement), this.selected && (this.unselect(), this.select()), this.konvaElement.setAttrs({
              width: f,
              height: h,
              scaleX: 1,
              scaleY: 1,
              zIndex: this.zIndex(),
              hitFunc: this.image.makeHitformFunction(i),
              rotation: r.angle !== void 0 ? r.angle : v
            }), this.inPromise = !1;
            const p = {};
            Fn(p, r, void 0), p.scale !== void 0 && delete p.scale, this.internalUpdate(p, o).then(() => c(!0)).catch((m) => d(m));
          });
          return;
        }
        (o !== null && o.i18n !== void 0 && o.i18n.editingLocale !== void 0 || r.rules !== void 0) && this.konvaTransformer && (this.konvaTransformer.resizeEnabled(Or(this.options.rules, "size.fixed") !== !0), this.konvaTransformer.rotateEnabled(Or(this.options.rules, "angle.fixed") !== !0), this.konvaElement.setDraggable(Or(this.options.rules, "position.fixed") !== !0 && (Or(this.options.rules, "position.properties.x.fixed") !== !0 || Or(this.options.rules, "position.properties.y.fixed") !== !0))), r.angle !== void 0 && r.angle !== this.currentAngle() && this.konvaElement.rotation(r.angle);
        const l = this.displayedPosition === void 0 || r.position !== void 0 && (r.position.x !== void 0 && this.displayedPosition.x !== r.position.x || r.position.y !== void 0 && this.displayedPosition.y !== r.position.y);
        if (!this.displayedPosition && !r.position && (this.displayedPosition = { x: 0, y: 0 }), this.image.recomputePosition || l || u) {
          this.image.recomputePosition = !1, o && o.width && (this.documentSize.width = o.width), o && o.height && (this.documentSize.height = o.height), r.position && (r.position.x && (this.displayedPosition.x = r.position.x), r.position.y && (this.displayedPosition.y = r.position.y));
          const { x: e, y: s } = Eo(this.displayedPosition, this.documentSize);
          this.konvaElement.setAttrs({
            x: e,
            y: s,
            offsetX: this.konvaElement.width() / 2,
            offsetY: this.konvaElement.height() / 2,
            zIndex: this.zIndex()
          }), this.vida.draw();
        }
        this.zIndex() !== this.konvaElement.zIndex() && (this.konvaElement.zIndex(this.zIndex()), this.vida.draw()), this.inPromise = !1, c(!1);
      }).catch((u) => d(u));
    });
  }
  adjustPosition() {
    this.konvaElement && (this._backupCurrentState({}), this._adjustPosition(), !this._cleanUndoHistory() && this.vida.onComponentUpdated(this.id()));
  }
  adjustSizeAndAngle() {
    if (!this.konvaElement)
      return;
    this._backupCurrentState({}), this._adjustAngle();
    let r = this.currentScale();
    const o = Or(this.options.rules, "scale", {});
    let c = !1;
    o.fixed !== void 0 && o.fixed ? (r = this.optionsScale(), c = !0) : (o.min !== void 0 && r < o.min && (r = o.min, c = !0), o.max !== void 0 && r > o.max && (r = o.max, c = !0)), c && this.konvaElement.setAttrs({
      scaleX: r * this.konvaElement.scaleX() / this.currentScale(),
      scaleY: r * this.konvaElement.scaleY() / this.currentScale()
    }), Math.abs(r - this.optionsScale()) > 0.1 && (this.editingLocale !== null ? (this._appendToCurrentBackup({ i18n: { [this.editingLocale]: { scale: r } } }), Fn(this.options.i18n, { [this.editingLocale]: { scale: r } }, void 0)) : (this._appendToCurrentBackup({ scale: r }), this.options.scale = this.currentScale()), r > this.optionsScale() && this.internalUpdate({ scale: this.currentScale() }, this.documentSize)), this._adjustPosition(), !this._cleanUndoHistory() && this.vida.onComponentUpdated(this.id());
  }
  currentScale() {
    if (!this.konvaElement)
      return 0;
    const o = this.konvaElement.getWidth() * this.konvaElement.scaleX() / this.image.originalSize.width, c = this.documentSize.width / this.image.originalSize.width, d = this.documentSize.height / this.image.originalSize.height;
    return 100 * o / Math.max(c, d);
  }
  optionsScale() {
    return this.editingLocale !== null && Or(this.options.i18n, `${this.editingLocale}.scale`) !== void 0 ? Or(this.options.i18n, `${this.editingLocale}.scale`) : this.options.scale;
  }
}
const mi = 1e6;
class PA extends Zl {
  constructor(r, o) {
    super(r, o);
    _e(this, "inPromise");
    _e(this, "backgroundComponent");
    _e(this, "konvaGroup");
    _e(this, "konvaClipper");
    _e(this, "konvaClipperRect");
    _e(this, "width");
    _e(this, "height");
    this.backgroundComponent = new Mh(r, o), this.inPromise = !1, this.width = 0, this.height = 0;
  }
  randomOptions() {
    return { background: this.backgroundComponent.randomOptions("internalsvg").image };
  }
  select() {
  }
  unselect() {
  }
  bringClipperForward() {
    !this.konvaClipper || !this.konvaClipper.parent || this.konvaClipper.setZIndex(this.konvaClipper.parent.children.length - 1);
  }
  toJson() {
    return !this.backgroundComponent || !this.backgroundComponent.image ? {} : this.backgroundComponent.image.toJson();
  }
  async toPdf() {
    if (this.backgroundComponent)
      return await this.backgroundComponent.toPdf();
  }
  destroy() {
    this.konvaGroup && this.konvaGroup.destroy(), this.konvaClipper && this.konvaClipper.destroy();
  }
  sendBackward() {
    this.backgroundComponent.konvaElement && this.konvaGroup && (this.backgroundComponent.update({ zIndex: 0 }, {}), this.konvaGroup.setAttrs({ zIndex: 0 }), this.vida.draw());
  }
  internalUpdate(r, o) {
    return new Promise((c) => {
      if (this.inPromise) {
        c();
        return;
      }
      this.konvaGroup || (this.konvaGroup = new xi.Group(), this.vida.registerTransformer(this.konvaGroup), this.konvaGroup.on("pointerclick", (d) => {
        this.vida.isSelected(this.id()) || (d.cancelBubble = !0, this.vida.selectComponent(this.id()));
      }), this.vida.registerComponent(this.konvaGroup)), this.konvaClipper || (this.konvaClipper = new xi.Group(), this.konvaClipperRect = new xi.Rect({
        x: -mi,
        y: -mi,
        width: 2 * mi,
        height: 2 * mi,
        fill: "#aeaeae",
        listening: !1,
        opacity: 0.8
      }), this.konvaClipper.add(this.konvaClipperRect), this.vida.registerTransformer(this.konvaClipper)), this.backgroundComponent.update(
        // WARNING HERE!!
        { id: this.options.id, zIndex: 0, scale: 100, position: { x: 0.5, y: 0.5 }, image: r.background },
        o
      ).then((d) => {
        if (d && this.konvaGroup.add(this.backgroundComponent.konvaElement), d || r.width && (!this.width || this.width !== r.width) || r.height && (!this.height || this.height !== r.height)) {
          r.width && (this.width = r.width), r.height && (this.height = r.height), this.konvaGroup.setAttrs({
            clipX: 0,
            clipY: 0,
            zIndex: 0,
            clipWidth: this.width,
            clipHeight: this.height
          });
          const { x: u, y: l } = this.konvaGroup.getPosition();
          this.konvaClipper.clipFunc((e) => {
            e.rect(-mi, -mi, 2 * mi, mi - l), e.rect(-mi, -mi, mi - u, 2 * mi), e.rect(u, l + this.height, 2 * mi, 2 * mi), e.rect(u + this.width, l, 2 * mi, 2 * mi);
          });
        }
        this.bringClipperForward(), this.vida.draw(), c();
      });
    });
  }
}
const OA = [[-1, 1], [1, 1], [1, -1], [-1, -1]];
class Hl extends Zl {
  constructor(r, o, c) {
    super(r, o);
    _e(this, "type");
    _e(this, "backgroundDistortion");
    _e(this, "backgroundDistortionAngle");
    _e(this, "backgroundPadding");
    _e(this, "backgroundMode");
    _e(this, "draw");
    _e(this, "text");
    _e(this, "textChoices", {});
    // We don't use directly konvaElementText.shadowX() because these
    // values are incorrect if angle != 0
    _e(this, "shadowX", 0);
    _e(this, "shadowY", 0);
    _e(this, "_recomputePosition");
    _e(this, "_inPromise");
    Fn(this.options, Hl.internalDefaultOptions(), void 0), this.type = c, this.backgroundDistortionAngle = void 0, this.backgroundDistortion = void 0, this.backgroundPadding = 0, this.backgroundMode = "disabled", this._recomputePosition = !1, this._inPromise = !1, this.draw = !1;
  }
  /**
   *
   * Many text attributes should be randomnized directly from the
   * calling lib.
   *
   * @param {'text' | 'emoji'} type
   * @returns {ComponentOptions}
   * @example
   *
   * await componentId = vida.createRandomComponent('text');
   * const randomText = 'blabla'; // randomly generated ;)
   * await vida.updateComponent(componentId, { text: randomText })
   */
  randomOptions(r) {
    const o = {
      type: r,
      angle: 0,
      size: Math.floor(20 + Math.random() * 180),
      position: { x: 0.5, y: 0.5 }
    };
    switch (r) {
      case "textchoice":
      case "text": {
        const c = Math.floor(Math.random() * 40);
        o.color = "#ffffff";
        const d = Pv(0.4, o.color, void 0, void 0);
        o.justification = "left", o.background = {
          color: "#000000",
          padding: 5,
          // @ts-ignore
          mode: ["normal", "distorted", "rounded", "disabled"][Math.floor(Math.random() * 4)],
          angleDistortion: c,
          distortion: CA(c),
          radius: 30
        }, o.shadow = {
          enabled: Math.random() > 0.9,
          color: d,
          offsetX: 5,
          offsetY: 5
        }, o.font = "Arial", o.text = "Aktivisda", o.angle = 0;
        break;
      }
      case "emoji": {
        o.angle = 15 * (Math.random() - 0.5), o.text = "🐘";
        break;
      }
      default:
        throw new jn(`Type ${r} is not yet supported by randomoptions`);
    }
    return o;
  }
  async toPdf() {
    if (!this.konvaElement || !this.konvaElementText || !this.konvaElementBackground)
      return;
    let r = "ok";
    const { x: o, y: c } = Eo(this.displayedPosition, this.documentSize), d = Math.max(this.konvaElementText.fontSize(), this.konvaElement.height() * 0.1), u = [], l = Rh(
      0,
      0,
      this.konvaElement.width() + 2 * d,
      this.konvaElement.height() + 2 * d,
      ss(this.konvaElement.rotation())
    );
    if (this.backgroundMode !== "disabled") {
      const x = Math.ceil(this.konvaElementText.fontSize() * this.backgroundPadding / 100), g = this.konvaElementBackground.fill(), S = this.konvaElementText.height() + 2 * x, y = this.konvaElementText.width() + 2 * x, b = this.backgroundMode === "distorted" ? this.backgroundDistortion : [
        [-1, 1],
        [1, 1],
        [1, -1],
        [-1, -1]
      ];
      Ih(b, y / 2, S / 2), Dh(b, ss(this.konvaElement.rotation()));
      let n = "";
      const { bottom_left: w, width: E, height: A } = qf(b);
      if (this.backgroundMode === "rounded") {
        const O = Or(this.options, "background.radius") || 0;
        n = `<svg width="${E}" height="${A}"
                viewBox="${w[0]} ${w[1]} ${E} ${A}">
                    <rect transform="rotate(${this.konvaElement.rotation()})"
                        x="${-y / 2}" y="${-S / 2}"
                        width="${y}" height="${S}" rx="${O}" ry="${O}" fill="${g}"/>
                </svg>`;
      } else {
        const O = `M${b[0][0]}, ${b[0][1]}                 L${b[1][0]}, ${b[1][1]}                ${b[2][0]}, ${b[2][1]}                ${b[3][0]}, ${b[3][1]}                ${b[0][0]}, ${b[0][1]}Z`;
        n = `<svg width="${E}" height="${A}"
                viewBox="${w[0]} ${w[1]} ${E} ${A}">
                    <path fill="${g}" d="${O}"/>
                </svg>`;
      }
      u.push({
        svg: n,
        absolutePosition: {
          x: oi(o + w[0]),
          y: oi(c + w[1])
        },
        width: oi(E),
        height: oi(A)
      });
    }
    const e = this.konvaElementText.text().split(`
`), s = this.konvaElementText.fontSize() * this.konvaElementText.lineHeight(), i = d + s / 2 + this.konvaElementText.y();
    let f = (x, g) => {
      if (!this.konvaElementText)
        return 0;
      if (g === "left")
        return this.konvaElementText.x();
      let S = this.vida.layer.getCanvas().getContext(), y = S.font;
      S.font = this.konvaElementText._getContextFont();
      let b = S.measureText(x);
      if (S.font = y, g === "right")
        return this.konvaElementText.width() - b.width + this.konvaElementText.x();
      if (g === "center")
        return this.konvaElementText.x() + (this.konvaElementText.width() - b.width) / 2;
    };
    const h = this.konvaElementText.align();
    let v = 0.355;
    this.konvaElementText.fontFamily() === "Raleway Thin" ? v = 0.355 : this.konvaElementText.fontFamily() === "Roboto Medium" && (v = 0.34);
    let p = "";
    this.konvaElementText.hasShadow() && (p = `
                <text
                    transform="rotate(${this.konvaElement.rotation()})"
                    font-size="${this.konvaElementText.fontSize()}"
                    fill="${this.konvaElementText.shadowColor()}"
                    style="font-family: ${this.konvaElementText.fontFamily()};fill-opacity:0.5"
                    alignment-baseline="alphabetic"
                    y="${i + this.shadowY}">
                    ${e.map(
      (x, g) => `<tspan x="${d + this.shadowX + f(x, h)}"
                                dy="${g == 0 ? +v * s : s}">${md(x)}</tspan>`
    ).join("")}
                </text>`);
    const m = `
        <svg width="${l.width}" height="${l.height}" viewBox="${l.bottom_left[0]} ${l.bottom_left[1]} ${l.width} ${l.height}">
        ${p}
        <text
            transform="rotate(${this.konvaElement.rotation()})"
            font-size="${this.konvaElementText.fontSize()}"
            fill="${this.konvaElementText.fill()}"
            style="font-family: ${this.konvaElementText.fontFamily()}"
            alignment-baseline="alphabetic"
            y="${i}">
            ${e.map(
      (x, g) => `<tspan x="${d + f(x, h)}" dy="${g == 0 ? +v * s : s}">${md(x)}</tspan>`
    ).join("")}
        </text>
         </svg>`;
    return u.push({
      svg: m,
      absolutePosition: {
        x: oi(o - l.width / 2),
        y: oi(c - l.height / 2)
      },
      width: oi(l.width),
      height: oi(l.height)
    }), { content: u, status: r };
  }
  static internalDefaultOptions() {
    return {
      textChoices: {}
    };
  }
  select() {
    Or(this.options.rules, "self.fixed") !== !0 && this.konvaElement && (this.konvaTransformer || (this.konvaTransformer = new xi.Transformer({
      rotateEnabled: !0,
      draggable: !0,
      enabledAnchors: ["top-left", "top-right", "bottom-left", "bottom-right"],
      boundBoxFunc: function(r, o) {
        return o.width = Math.max(1, o.width), o;
      },
      keepRatio: !0
    })), this.konvaTransformer.nodes([this.konvaElement]), this.vida.registerTransformer(this.konvaTransformer), this.konvaTransformer.resizeEnabled(Or(this.options.rules, "size.fixed") !== !0), this.konvaTransformer.rotateEnabled(Or(this.options.rules, "angle.fixed") !== !0), this.konvaElement.setDraggable(
      Or(this.options.rules, "position.fixed") !== !0 && (Or(this.options.rules, "position.properties.x.fixed") !== !0 || Or(this.options.rules, "position.properties.y.fixed") !== !0)
    ), this.vida.draw());
  }
  showTextEditor() {
    if (Or(this.options.rules, "self.fixed") === !0 || Or(this.options.rules, "text.fixed") === !0 || this.type !== "text" || !this.konvaElementText)
      return;
    this.konvaElementText.hide(), this.konvaTransformer && this.konvaTransformer.hide();
    const r = this.konvaElementText.absolutePosition(), o = this.vida.stage.scaleX(), c = {
      x: this.vida.stage.container().offsetLeft + r.x - this.konvaElementText.offsetX() * o,
      y: this.vida.stage.container().offsetTop + r.y + this.konvaElementText.offsetY() * o
    }, d = document.createElement("textarea");
    document.body.appendChild(d);
    const u = this.konvaElementText.fontSize() * o;
    d.value = this.konvaElementText.text(), d.style.position = "absolute", d.style.top = c.y + "px", d.style.left = c.x + "px", d.style.width = (this.konvaElementText.width() - this.konvaElementText.padding() * 2 + 10) * o + "px", d.style.height = (this.konvaElementText.height() - this.konvaElementText.padding() * 2) * o + 5 + "px", d.style.fontSize = u + "px", d.style.border = "1px solid red", d.style.padding = "0px", d.style.margin = "0px", d.style.overflow = "hidden", d.style.background = "none", d.style.resize = "none", d.style.outline = "none", d.style.lineHeight = this.konvaElementText.lineHeight().toString(), d.style.fontFamily = this.konvaElementText.fontFamily(), d.style.transformOrigin = "center", d.style.textAlign = this.konvaElementText.align(), d.style.color = this.konvaElementText.fill();
    const l = this.konvaElementText.rotation();
    let e = "";
    l && (e += "rotateZ(" + l + "deg)");
    let s = 0;
    var i = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
    i && (s += 2 + Math.round(this.konvaElementText.fontSize() * o / 20)), e += "translateY(-" + s + "px)", d.style.transform = e, d.style.height = "auto", d.style.height = d.scrollHeight + 3 + "px", d.focus();
    const f = () => {
      d.parentNode.removeChild(d), window.removeEventListener("click", v), this.konvaElementText.show(), this.konvaTransformer && (this.konvaTransformer.show(), this.konvaTransformer.forceUpdate());
    }, h = (p) => {
      var m = /^((?!chrome|android).)*safari/i.test(navigator.userAgent), x = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
      (m || x) && (p = Math.ceil(p));
      var g = document.DOCUMENT_NODE || /Edge/.test(navigator.userAgent);
      g && (p += 1), d.style.width = p + "px";
    };
    d.addEventListener("keydown", (p) => {
      if (p.key === "Enter" && !p.shiftKey) {
        const m = this.editingLocale !== null ? { i18n: { [this.editingLocale]: { text: d.value } } } : { text: d.value };
        this.update(m, {}).then(() => this.vida.onComponentUpdated(this.id())), f();
      }
      p.key === "Esc" && f();
    }), d.addEventListener("keydown", () => {
      const p = this.konvaElementText.getAbsoluteScale().x;
      h(this.konvaElementText.width() * p), d.style.height = "auto", d.style.height = d.scrollHeight + this.konvaElementText.fontSize() + "px";
    });
    const v = (p) => {
      if (p.target !== d) {
        const m = this.editingLocale !== null ? { i18n: { [this.editingLocale]: { text: d.value } } } : { text: d.value };
        this.update(m, {}).then(() => this.vida.onComponentUpdated(this.id())), f();
      }
    };
    setTimeout(() => {
      window.addEventListener("click", v);
    });
  }
  unselect() {
    this.konvaTransformer && this.konvaTransformer.detach();
  }
  destroy() {
    this.konvaElement && (this.konvaElementText && this.konvaElementText.destroy(), this.konvaElementBackground && this.konvaElementBackground.destroy(), this.konvaElement.destroy());
  }
  textValue() {
    switch (this.type) {
      case "textchoice": {
        if (this.text === void 0)
          return "";
        const r = this.textChoices[this.text], o = this.vida.document.i18n, c = o.editingLocale ? o.editingLocale : o.displayedLocale;
        return d3(r, c, this.vida.document.i18n.defaultLocale) || "";
      }
      case "text":
        return this.text === void 0 ? this.konvaElementText.text() : this.text;
    }
    return "";
  }
  toJson() {
    const r = { ...this.options };
    return this.type === "text" && delete r.textChoices, r;
  }
  internalUpdate(r, o) {
    return new Promise((c) => {
      var i, f, h, v;
      if (this._inPromise) {
        c();
        return;
      }
      this._inPromise = !0;
      let d = !1, u = !1;
      if (r.textChoices !== void 0 && this.textChoices !== r.textChoices && (Fn(this.textChoices, r.textChoices, void 0), kh(this.textChoices)), r.type !== void 0 && this.type !== r.type && (r.text === void 0 && (r.type === "text" ? r.text = this.textValue() : r.type === "textchoice" && (r.text = Object.keys(this.textChoices)[0] || ""), this.editingLocale ? $s(this.options.i18n[this.editingLocale], "text", r.text) : $s(this.options, "text", r.text), u = !0), this.type = r.type), r.background !== void 0 && r.background.distortion !== void 0 && (!this.backgroundDistortion || this.backgroundDistortion !== r.background.distortion) && (this.backgroundDistortion = r.background.distortion, this.backgroundDistortionAngle = r.background.angleDistortion, d = !0), r.text !== void 0 && this.text !== r.text && (this.text = r.text), (r.text !== void 0 || r.textChoices !== void 0) && this.type === "textchoice" && this.textValue() === "" && (this.text = Object.keys(this.textChoices)[0], this.editingLocale ? $s(this.options.i18n[this.editingLocale], "text", this.text) : $s(this.options, "text", this.text), u = !0), !this.konvaElement) {
        switch (this.konvaElement = new xi.Group(), this.type) {
          case "textchoice":
          case "text": {
            this.konvaElementText = new xi.Text({
              draggable: !1,
              text: this.textValue(),
              fill: r.color,
              align: r.justification,
              fontSize: r.size,
              fontFamily: r.font,
              padding: 0,
              hasShadow: (i = r.shadow) == null ? void 0 : i.enabled,
              shadowColor: (f = r.shadow) == null ? void 0 : f.color,
              shadowOffsetX: (h = r.shadow) == null ? void 0 : h.offsetX,
              shadowOffsetY: (v = r.shadow) == null ? void 0 : v.offsetY,
              shadowOpacity: 0.5
            });
            break;
          }
          case "emoji":
            this.konvaElementText = new xi.Text({
              draggable: !1,
              text: r.text,
              fontSize: 1,
              padding: 0,
              verticalAlign: "top"
            }), this.konvaElement.setAttrs({
              scaleX: r.scale,
              scaleY: r.scale
            });
        }
        this.konvaElement.on("pointerclick", (p) => {
          p.cancelBubble = !0, !this.vida.isSelected(this.id()) && this.vida.selectComponent(this.id());
        }), this.supportBackground() && this.konvaElementText.on("dblclick dbltap", () => {
          this.showTextEditor();
        }), this.konvaElement.on("dragend", () => {
          this.adjustPosition();
        }), this.konvaElement.on("transformend", () => {
          this.adjustSizeAndAngle();
        }), this.konvaElementBackground = new xi.Shape(), r.background !== void 0 && (r.background.color !== void 0 && this.konvaElementBackground.fill(r.background.color), r.background.padding !== void 0 && (this.backgroundPadding = r.background.padding)), this.konvaElement.add(this.konvaElementBackground), this.konvaElement.add(this.konvaElementText), this._recomputePosition = !0, this.vida.registerComponent(this.konvaElement);
      }
      if (!this.konvaElementText)
        throw new jn("KonvaElementText does not exist");
      if (!this.konvaElementBackground)
        throw new jn("KonvaElementBackground does not exist");
      (o !== null && o.i18n !== void 0 && o.i18n.editingLocale !== void 0 || r.rules !== void 0) && (Or(r.rules, "self.fixed") === !1 && this.select(), this.konvaTransformer && (this.konvaTransformer.resizeEnabled(Or(this.options.rules, "size.fixed") !== !0), this.konvaTransformer.rotateEnabled(Or(this.options.rules, "angle.fixed") !== !0), this.konvaElement.setDraggable(
        Or(this.options.rules, "position.fixed") !== !0 && (Or(this.options.rules, "position.properties.x.fixed") !== !0 || Or(this.options.rules, "position.properties.y.fixed") !== !0)
      ))), this.konvaElementText.text() !== this.textValue() && (this.konvaElementText.setText(this.textValue()), this._recomputePosition = !0, this.supportBackground() && (d = !0)), r.font !== void 0 && this.konvaElementText.fontFamily() !== r.font && (this.konvaElementText.fontFamily(r.font), this._recomputePosition = !0, this.supportBackground() && (d = !0)), r.size !== void 0 && this.konvaElementText.fontSize() * this.konvaElement.scaleX() !== r.size && (this.konvaElementText.fontSize(r.size), this.konvaElement.scaleX(1), this.konvaElement.scaleY(1), this._recomputePosition = !0, this.supportBackground() && (d = !0)), r.scale !== void 0 && this.konvaElement.scaleX() !== r.scale && (this.konvaElement.scaleX(r.scale), this.konvaElement.scaleY(r.scale), this._recomputePosition = !0, this.supportBackground() && (d = !0)), r.color !== void 0 && this.konvaElementText.fill() !== r.color && (this.konvaElementText.fill(r.color), this.draw = !0), r.justification !== void 0 && this.konvaElementText.align() !== r.justification && (this.konvaElementText.align(r.justification), this.draw = !0);
      let l = !1;
      if (r.shadow !== void 0 && (r.shadow.enabled !== void 0 && this.konvaElementText.hasShadow() !== r.shadow.enabled && (this.konvaElementText.shadowEnabled(r.shadow.enabled), r.shadow.enabled && (this.konvaElementText.shadowColor(r.shadow.color || "#000000"), this.konvaElementText.shadowOpacity(0.5), l = !0), this.draw = !0), r.shadow.color !== void 0 && this.konvaElementText.shadowColor() !== r.shadow.color && (this.konvaElementText.shadowColor(r.shadow.color), this.draw = !0), r.shadow.offsetX !== void 0 && this.shadowX !== r.shadow.offsetX && (this.shadowX = r.shadow.offsetX, l = !0), r.shadow.offsetY !== void 0 && this.shadowY !== r.shadow.offsetY && (this.shadowY = r.shadow.offsetY, l = !0)), r.background !== void 0 && (r.background.color !== void 0 && this.konvaElementBackground.fill() !== r.background.color && (this.konvaElementBackground.fill(r.background.color), this.draw = !0), r.background.distortion !== void 0 && (!this.backgroundDistortion || this.backgroundDistortion !== r.background.distortion) && (this.backgroundDistortion = r.background.distortion, this.backgroundDistortionAngle = r.background.angleDistortion, d = !0), r.background.mode !== void 0 && this.backgroundMode !== r.background.mode && (this.backgroundMode = r.background.mode, this.backgroundMode === "disabled" ? this.konvaElementBackground.hide() : this.konvaElementBackground.show(), d = !0, this.draw = !0), r.background.radius !== void 0 && (d = !0, this.draw = !0)), r.angle !== void 0 && r.angle !== this.currentAngle() && (this.konvaElement.rotation(r.angle), this.konvaElementText.hasShadow() && (l = !0), this._recomputePosition = !0), l) {
        if (this.currentAngle() !== 0) {
          const p = [[this.konvaElementText.shadowOffsetX(), this.konvaElementText.shadowOffsetY()]];
          Dh(p, ss(this.currentAngle())), this.konvaElementText.shadowOffset({ x: p[0][0], y: p[0][1] });
        } else
          this.konvaElementText.shadowOffsetX(this.shadowX), this.konvaElementText.shadowOffsetY(this.shadowY);
        this.draw = !0;
      }
      if (r.background !== void 0 && r.background.padding !== void 0 && r.background.padding !== this.backgroundPadding && (this.backgroundPadding = r.background.padding, this.backgroundMode !== "disabled")) {
        const p = r.background.padding;
        this.konvaElement.setAttrs({
          offsetX: this.konvaElementText.width() / 2 + p,
          offsetY: this.konvaElementText.height() / 2 + p,
          width: this.konvaElementText.height() + 2 * p,
          height: this.konvaElementText.height() + 2 * p
        }), this.konvaElementText.setAttrs({
          x: p,
          y: p
        }), d = !0;
      }
      const e = !this.documentSize || o && (this.documentSize.width !== o.width || this.documentSize.height !== o.height), s = r.position !== void 0 && (r.position.x !== void 0 && this.displayedPosition.x !== r.position.x || r.position.y !== void 0 && this.displayedPosition.y !== r.position.y);
      if (this._recomputePosition || s || e) {
        this._recomputePosition = !1, this.documentSize || (this.documentSize = { width: 0, height: 0 }), o && o.width && (this.documentSize.width = o.width), o && o.height && (this.documentSize.height = o.height), r.position && ns(this.displayedPosition, r.position);
        const { x: p, y: m } = Eo(this.displayedPosition, this.documentSize), x = this.backgroundMode !== "disabled" ? Math.ceil(this.konvaElementText.fontSize() * this.backgroundPadding / 100) : 0;
        this.konvaElement.setAttrs({
          x: p,
          y: m,
          offsetX: this.konvaElementText.width() / 2 + x,
          offsetY: this.konvaElementText.height() / 2 + x,
          width: this.konvaElementText.width() + 2 * x,
          height: this.konvaElementText.height() + 2 * x
        }), this.konvaElementText.setAttrs({
          x,
          y: x
        }), this._recomputePosition = !0, this.draw = !0;
      }
      if (d) {
        const p = Math.ceil(this.konvaElementText.fontSize() * this.backgroundPadding / 100), m = this.konvaElementText.height() + 2 * p, x = this.konvaElementText.width() + 2 * p, g = this.options.background && this.options.background.radius ? this.options.background.radius : 0, S = Math.PI;
        if (this.backgroundMode === "distorted" || this.backgroundMode === "normal") {
          let y = [...OA];
          this.backgroundMode === "distorted" && (y = [...this.backgroundDistortion]), V2(y, [1, 1]), Ih(y, x / 2, m / 2), this.konvaElementBackground.setAttrs({
            width: this.konvaElementText.width() + 2 * p,
            height: this.konvaElementText.height() + 2 * p,
            sceneFunc(b, n) {
              b.beginPath(), b.moveTo(y[0][0], y[0][1]), b.lineTo(y[1][0], y[1][1]), b.lineTo(y[2][0], y[2][1]), b.lineTo(y[3][0], y[3][1]), b.lineTo(y[0][0], y[0][1]), b.closePath(), b.fillStrokeShape(n);
            }
          });
        } else
          this.backgroundMode === "rounded" && this.konvaElementBackground.setAttrs({
            width: this.konvaElementText.width() + 2 * p,
            height: this.konvaElementText.height() + 2 * p,
            sceneFunc(y, b) {
              y.beginPath(), y.moveTo(g, 0), y.lineTo(x - g, 0), y.arc(x - g, g, g, 3 * S / 2, 0), y.lineTo(x, m - g), y.arc(x - g, m - g, g, 0, S / 2), y.lineTo(g, m), y.arc(g, m - g, g, S / 2, S), y.lineTo(0, g), y.arc(g, g, g, S, 3 * S / 2), y.lineTo(g, 0), y.closePath(), y.fillStrokeShape(b);
            }
          });
        this._recomputePosition = !0, this.draw = !0;
      }
      this.konvaTransformer !== void 0 && this.konvaTransformer.forceUpdate(), this.zIndex() !== this.konvaElement.zIndex() && (this.konvaElement.zIndex(this.zIndex()), this.draw = !0), this.draw && (this.draw = !1, this.vida.draw()), this._inPromise = !1, u && this.vida.onComponentUpdated(this.id()), c();
    });
  }
  adjustPosition() {
    !this.konvaElementText || !this.konvaElementBackground || (this._backupCurrentState({}), this._adjustPosition(), !this._cleanUndoHistory() && this.vida.onComponentUpdated(this.id()));
  }
  adjustSizeAndAngle() {
    var d;
    this._backupCurrentState({}), this._adjustAngle(), this._adjustPosition();
    let r = this.konvaElementText.fontSize() * this.konvaElement.scaleX(), o = !1;
    const c = Or(this.options.rules, "size", {});
    if (c.fixed !== void 0 && c.fixed ? (r = this.optionsFontSize(), o = !0) : (c.min !== void 0 && r < c.min && (r = c.min, o = !0), c.max !== void 0 && r > c.max && (r = c.max, o = !0)), o) {
      const u = r / this.konvaElementText.fontSize();
      (d = this.konvaElement) == null || d.setAttrs({
        scaleX: u,
        scaleY: u
      });
    }
    Math.abs(r - this.optionsFontSize()) > 0.1 && (this.editingLocale !== null ? (this._appendToCurrentBackup({ i18n: { [this.editingLocale]: { size: r } } }), Fn(this.options.i18n, { [this.editingLocale]: { size: r } }, void 0)) : (this._appendToCurrentBackup({ size: r }), this.options.size = r)), !this._cleanUndoHistory() && this.vida.onComponentUpdated(this.id());
  }
  optionsFontSize() {
    return this.optionsValue("size");
  }
  supportBackground() {
    return this.type === "text" || this.type === "textchoice";
  }
}
var H2 = { exports: {} };
/*! pdfmake v0.2.10, @license MIT, @link http://pdfmake.org */
(function(a, t) {
  (function(o, c) {
    a.exports = c();
  })(typeof self < "u" ? self : ki, function() {
    return (
      /******/
      function() {
        var r = {
          /***/
          41783: (
            /***/
            function(u, l) {
              l.OP = 0, l.CL = 1, l.CP = 2, l.QU = 3, l.GL = 4, l.NS = 5, l.EX = 6, l.SY = 7, l.IS = 8, l.PR = 9, l.PO = 10, l.NU = 11, l.AL = 12, l.HL = 13, l.ID = 14, l.IN = 15, l.HY = 16, l.BA = 17, l.BB = 18, l.B2 = 19, l.ZW = 20, l.CM = 21, l.WJ = 22, l.H2 = 23, l.H3 = 24, l.JL = 25, l.JV = 26, l.JT = 27, l.RI = 28, l.EB = 29, l.EM = 30, l.ZWJ = 31, l.CB = 32, l.AI = 33, l.BK = 34, l.CJ = 35, l.CR = 36, l.LF = 37, l.NL = 38, l.SA = 39, l.SG = 40, l.SP = 41, l.XX = 42;
            }
          ),
          /***/
          98282: (
            /***/
            function(u, l) {
              var e, s, i, f, h;
              l.DI_BRK = i = 0, l.IN_BRK = f = 1, l.CI_BRK = e = 2, l.CP_BRK = s = 3, l.PR_BRK = h = 4, l.pairTable = [
                //OP   , CL    , CP    , QU    , GL    , NS    , EX    , SY    , IS    , PR    , PO    , NU    , AL    , HL    , ID    , IN    , HY    , BA    , BB    , B2    , ZW    , CM    , WJ    , H2    , H3    , JL    , JV    , JT    , RI    , EB    , EM    , ZWJ   , CB
                [h, h, h, h, h, h, h, h, h, h, h, h, h, h, h, h, h, h, h, h, h, s, h, h, h, h, h, h, h, h, h, h, h],
                // OP
                [i, h, h, f, f, h, h, h, h, f, f, i, i, i, i, f, f, f, i, i, h, e, h, i, i, i, i, i, i, i, i, f, i],
                // CL
                [i, h, h, f, f, h, h, h, h, f, f, f, f, f, i, f, f, f, i, i, h, e, h, i, i, i, i, i, i, i, i, f, i],
                // CP
                [h, h, h, f, f, f, h, h, h, f, f, f, f, f, f, f, f, f, f, f, h, e, h, f, f, f, f, f, f, f, f, f, f],
                // QU
                [f, h, h, f, f, f, h, h, h, f, f, f, f, f, f, f, f, f, f, f, h, e, h, f, f, f, f, f, f, f, f, f, f],
                // GL
                [i, h, h, f, f, f, h, h, h, i, i, i, i, i, i, f, f, f, i, i, h, e, h, i, i, i, i, i, i, i, i, f, i],
                // NS
                [i, h, h, f, f, f, h, h, h, i, i, i, i, i, i, f, f, f, i, i, h, e, h, i, i, i, i, i, i, i, i, f, i],
                // EX
                [i, h, h, f, f, f, h, h, h, i, i, f, i, f, i, f, f, f, i, i, h, e, h, i, i, i, i, i, i, i, i, f, i],
                // SY
                [i, h, h, f, f, f, h, h, h, i, i, f, f, f, i, f, f, f, i, i, h, e, h, i, i, i, i, i, i, i, i, f, i],
                // IS
                [f, h, h, f, f, f, h, h, h, i, i, f, f, f, f, f, f, f, i, i, h, e, h, f, f, f, f, f, i, f, f, f, i],
                // PR
                [f, h, h, f, f, f, h, h, h, i, i, f, f, f, i, f, f, f, i, i, h, e, h, i, i, i, i, i, i, i, i, f, i],
                // PO
                [f, h, h, f, f, f, h, h, h, f, f, f, f, f, i, f, f, f, i, i, h, e, h, i, i, i, i, i, i, i, i, f, i],
                // NU
                [f, h, h, f, f, f, h, h, h, f, f, f, f, f, i, f, f, f, i, i, h, e, h, i, i, i, i, i, i, i, i, f, i],
                // AL
                [f, h, h, f, f, f, h, h, h, f, f, f, f, f, i, f, f, f, i, i, h, e, h, i, i, i, i, i, i, i, i, f, i],
                // HL
                [i, h, h, f, f, f, h, h, h, i, f, i, i, i, i, f, f, f, i, i, h, e, h, i, i, i, i, i, i, i, i, f, i],
                // ID
                [i, h, h, f, f, f, h, h, h, i, i, i, i, i, i, f, f, f, i, i, h, e, h, i, i, i, i, i, i, i, i, f, i],
                // IN
                [i, h, h, f, i, f, h, h, h, i, i, f, i, i, i, f, f, f, i, i, h, e, h, i, i, i, i, i, i, i, i, f, i],
                // HY
                [i, h, h, f, i, f, h, h, h, i, i, i, i, i, i, f, f, f, i, i, h, e, h, i, i, i, i, i, i, i, i, f, i],
                // BA
                [f, h, h, f, f, f, h, h, h, f, f, f, f, f, f, f, f, f, f, f, h, e, h, f, f, f, f, f, f, f, f, f, i],
                // BB
                [i, h, h, f, f, f, h, h, h, i, i, i, i, i, i, f, f, f, i, h, h, e, h, i, i, i, i, i, i, i, i, f, i],
                // B2
                [i, i, i, i, i, i, i, i, i, i, i, i, i, i, i, i, i, i, i, i, h, i, i, i, i, i, i, i, i, i, i, i, i],
                // ZW
                [f, h, h, f, f, f, h, h, h, f, f, f, f, f, i, f, f, f, i, i, h, e, h, i, i, i, i, i, i, i, i, f, i],
                // CM
                [f, h, h, f, f, f, h, h, h, f, f, f, f, f, f, f, f, f, f, f, h, e, h, f, f, f, f, f, f, f, f, f, f],
                // WJ
                [i, h, h, f, f, f, h, h, h, i, f, i, i, i, i, f, f, f, i, i, h, e, h, i, i, i, f, f, i, i, i, f, i],
                // H2
                [i, h, h, f, f, f, h, h, h, i, f, i, i, i, i, f, f, f, i, i, h, e, h, i, i, i, i, f, i, i, i, f, i],
                // H3
                [i, h, h, f, f, f, h, h, h, i, f, i, i, i, i, f, f, f, i, i, h, e, h, f, f, f, f, i, i, i, i, f, i],
                // JL
                [i, h, h, f, f, f, h, h, h, i, f, i, i, i, i, f, f, f, i, i, h, e, h, i, i, i, f, f, i, i, i, f, i],
                // JV
                [i, h, h, f, f, f, h, h, h, i, f, i, i, i, i, f, f, f, i, i, h, e, h, i, i, i, i, f, i, i, i, f, i],
                // JT
                [i, h, h, f, f, f, h, h, h, i, i, i, i, i, i, f, f, f, i, i, h, e, h, i, i, i, i, i, f, i, i, f, i],
                // RI
                [i, h, h, f, f, f, h, h, h, i, f, i, i, i, i, f, f, f, i, i, h, e, h, i, i, i, i, i, i, i, f, f, i],
                // EB
                [i, h, h, f, f, f, h, h, h, i, f, i, i, i, i, f, f, f, i, i, h, e, h, i, i, i, i, i, i, i, i, f, i],
                // EM
                [f, h, h, f, f, f, h, h, h, f, f, f, f, f, i, f, f, f, i, i, h, e, h, i, i, i, i, i, i, i, i, f, i],
                // ZWJ
                [i, h, h, f, f, i, h, h, h, i, i, i, i, i, i, i, i, i, i, i, h, e, h, i, i, i, i, i, i, i, i, f, i]
                // CB
              ];
            }
          ),
          /***/
          57013: (
            /***/
            function(u, l, e) {
              e(18756), l.EncodeStream = e(16176), l.DecodeStream = e(78984), l.Array = e(38637), l.LazyArray = e(88687), l.Bitfield = e(72959), l.Boolean = e(64888), l.Buffer = e(77324), l.Enum = e(71499), l.Optional = e(72526), l.Reserved = e(10298), l.String = e(36291), l.Struct = e(2731), l.VersionedStruct = e(48084);
              var s = e(76949), i = e(63787), f = e(41545);
              Object.assign(l, s, i, f);
            }
          ),
          /***/
          38637: (
            /***/
            function(u, l, e) {
              e(65292), e(73844), e(69330), e(11765), e(81755), e(20731), e(24863), e(14032), e(61726), e(57114), e(58281), e(94712);
              function s(x, g) {
                var S = typeof Symbol < "u" && x[Symbol.iterator] || x["@@iterator"];
                if (S)
                  return (S = S.call(x)).next.bind(S);
                if (Array.isArray(x) || (S = i(x)) || g && x && typeof x.length == "number") {
                  S && (x = S);
                  var y = 0;
                  return function() {
                    return y >= x.length ? { done: !0 } : { done: !1, value: x[y++] };
                  };
                }
                throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }
              function i(x, g) {
                if (x) {
                  if (typeof x == "string")
                    return f(x, g);
                  var S = Object.prototype.toString.call(x).slice(8, -1);
                  if (S === "Object" && x.constructor && (S = x.constructor.name), S === "Map" || S === "Set")
                    return Array.from(x);
                  if (S === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(S))
                    return f(x, g);
                }
              }
              function f(x, g) {
                (g == null || g > x.length) && (g = x.length);
                for (var S = 0, y = new Array(g); S < g; S++)
                  y[S] = x[S];
                return y;
              }
              var h = e(63787), v = h.Number, p = e(76949), m = /* @__PURE__ */ function() {
                function x(S, y, b) {
                  b === void 0 && (b = "count"), this.type = S, this.length = y, this.lengthType = b;
                }
                var g = x.prototype;
                return g.decode = function(y, b) {
                  var n, w = y.pos, E = [], A = b;
                  if (this.length != null && (n = p.resolveLength(this.length, y, b)), this.length instanceof v && (Object.defineProperties(E, {
                    parent: {
                      value: b
                    },
                    _startOffset: {
                      value: w
                    },
                    _currentOffset: {
                      value: 0,
                      writable: !0
                    },
                    _length: {
                      value: n
                    }
                  }), A = E), n == null || this.lengthType === "bytes")
                    for (var O = n != null ? y.pos + n : b != null && b._length ? b._startOffset + b._length : y.length; y.pos < O; )
                      E.push(this.type.decode(y, A));
                  else
                    for (var C = 0, T = n; C < T; C++)
                      E.push(this.type.decode(y, A));
                  return E;
                }, g.size = function(y, b) {
                  if (!y)
                    return this.type.size(null, b) * p.resolveLength(this.length, null, b);
                  var n = 0;
                  this.length instanceof v && (n += this.length.size(), b = {
                    parent: b
                  });
                  for (var w = s(y), E; !(E = w()).done; ) {
                    var A = E.value;
                    n += this.type.size(A, b);
                  }
                  return n;
                }, g.encode = function(y, b, n) {
                  var w = n;
                  this.length instanceof v && (w = {
                    pointers: [],
                    startOffset: y.pos,
                    parent: n
                  }, w.pointerOffset = y.pos + this.size(b, w), this.length.encode(y, b.length));
                  for (var E = s(b), A; !(A = E()).done; ) {
                    var O = A.value;
                    this.type.encode(y, O, w);
                  }
                  if (this.length instanceof v)
                    for (var C = 0; C < w.pointers.length; ) {
                      var T = w.pointers[C++];
                      T.type.encode(y, T.val);
                    }
                }, x;
              }();
              u.exports = m;
            }
          ),
          /***/
          72959: (
            /***/
            function(u, l, e) {
              e(74516);
              var s = /* @__PURE__ */ function() {
                function i(h, v) {
                  v === void 0 && (v = []), this.type = h, this.flags = v;
                }
                var f = i.prototype;
                return f.decode = function(v) {
                  for (var p = this.type.decode(v), m = {}, x = 0; x < this.flags.length; x++) {
                    var g = this.flags[x];
                    g != null && (m[g] = !!(p & 1 << x));
                  }
                  return m;
                }, f.size = function() {
                  return this.type.size();
                }, f.encode = function(v, p) {
                  for (var m = 0, x = 0; x < this.flags.length; x++) {
                    var g = this.flags[x];
                    g != null && p[g] && (m |= 1 << x);
                  }
                  return this.type.encode(v, m);
                }, i;
              }();
              u.exports = s;
            }
          ),
          /***/
          64888: (
            /***/
            function(u) {
              var l = /* @__PURE__ */ function() {
                function e(i) {
                  this.type = i;
                }
                var s = e.prototype;
                return s.decode = function(f, h) {
                  return !!this.type.decode(f, h);
                }, s.size = function(f, h) {
                  return this.type.size(f, h);
                }, s.encode = function(f, h, v) {
                  return this.type.encode(f, +h, v);
                }, e;
              }();
              u.exports = l;
            }
          ),
          /***/
          77324: (
            /***/
            function(u, l, e) {
              var s = e(76949), i = e(63787), f = i.Number, h = /* @__PURE__ */ function() {
                function v(m) {
                  this.length = m;
                }
                var p = v.prototype;
                return p.decode = function(x, g) {
                  var S = s.resolveLength(this.length, x, g);
                  return x.readBuffer(S);
                }, p.size = function(x, g) {
                  return x ? x.length : s.resolveLength(this.length, null, g);
                }, p.encode = function(x, g, S) {
                  return this.length instanceof f && this.length.encode(x, g.length), x.writeBuffer(g);
                }, v;
              }();
              u.exports = h;
            }
          ),
          /***/
          78984: (
            /***/
            function(u, l, e) {
              var s = e(50621).Buffer;
              e(20731), e(14032), e(61726), e(57114), e(46467);
              var i;
              try {
                i = e(54171);
              } catch {
              }
              var f = /* @__PURE__ */ function() {
                function p(x) {
                  this.buffer = x, this.pos = 0, this.length = this.buffer.length;
                }
                var m = p.prototype;
                return m.readString = function(g, S) {
                  switch (S === void 0 && (S = "ascii"), S) {
                    case "utf16le":
                    case "ucs2":
                    case "utf8":
                    case "ascii":
                      return this.buffer.toString(S, this.pos, this.pos += g);
                    case "utf16be":
                      for (var y = s.from(this.readBuffer(g)), b = 0, n = y.length - 1; b < n; b += 2) {
                        var w = y[b];
                        y[b] = y[b + 1], y[b + 1] = w;
                      }
                      return y.toString("utf16le");
                    default:
                      if (y = this.readBuffer(g), i)
                        try {
                          return i.decode(y, S);
                        } catch {
                        }
                      return y;
                  }
                }, m.readBuffer = function(g) {
                  return this.buffer.slice(this.pos, this.pos += g);
                }, m.readUInt24BE = function() {
                  return (this.readUInt16BE() << 8) + this.readUInt8();
                }, m.readUInt24LE = function() {
                  return this.readUInt16LE() + (this.readUInt8() << 16);
                }, m.readInt24BE = function() {
                  return (this.readInt16BE() << 8) + this.readUInt8();
                }, m.readInt24LE = function() {
                  return this.readUInt16LE() + (this.readInt8() << 16);
                }, p;
              }();
              f.TYPES = {
                UInt8: 1,
                UInt16: 2,
                UInt24: 3,
                UInt32: 4,
                Int8: 1,
                Int16: 2,
                Int24: 3,
                Int32: 4,
                Float: 4,
                Double: 8
              };
              var h = function(m) {
                if (m.slice(0, 4) === "read") {
                  var x = f.TYPES[m.replace(/read|[BL]E/g, "")];
                  f.prototype[m] = function() {
                    var g = this.buffer[m](this.pos);
                    return this.pos += x, g;
                  };
                }
              };
              for (var v in s.prototype)
                h(v);
              u.exports = f;
            }
          ),
          /***/
          16176: (
            /***/
            function(u, l, e) {
              var s = e(50621).Buffer;
              e(41584), e(20731), e(61726), e(46467);
              function i(S, y) {
                S.prototype = Object.create(y.prototype), S.prototype.constructor = S, f(S, y);
              }
              function f(S, y) {
                return f = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, w) {
                  return n.__proto__ = w, n;
                }, f(S, y);
              }
              var h, v = e(9760), p = e(78984);
              try {
                h = e(54171);
              } catch {
              }
              var m = /* @__PURE__ */ function(S) {
                i(y, S);
                function y(n) {
                  var w;
                  return n === void 0 && (n = 65536), w = S.apply(this, arguments) || this, w.buffer = s.alloc(n), w.bufferOffset = 0, w.pos = 0, w;
                }
                var b = y.prototype;
                return b._read = function() {
                }, b.ensure = function(w) {
                  if (this.bufferOffset + w > this.buffer.length)
                    return this.flush();
                }, b.flush = function() {
                  if (this.bufferOffset > 0)
                    return this.push(s.from(this.buffer.slice(0, this.bufferOffset))), this.bufferOffset = 0;
                }, b.writeBuffer = function(w) {
                  return this.flush(), this.push(w), this.pos += w.length;
                }, b.writeString = function(w, E) {
                  switch (E === void 0 && (E = "ascii"), E) {
                    case "utf16le":
                    case "ucs2":
                    case "utf8":
                    case "ascii":
                      return this.writeBuffer(s.from(w, E));
                    case "utf16be":
                      for (var A = s.from(w, "utf16le"), O = 0, C = A.length - 1; O < C; O += 2) {
                        var T = A[O];
                        A[O] = A[O + 1], A[O + 1] = T;
                      }
                      return this.writeBuffer(A);
                    default:
                      if (h)
                        return this.writeBuffer(h.encode(w, E));
                      throw new Error("Install iconv-lite to enable additional string encodings.");
                  }
                }, b.writeUInt24BE = function(w) {
                  return this.ensure(3), this.buffer[this.bufferOffset++] = w >>> 16 & 255, this.buffer[this.bufferOffset++] = w >>> 8 & 255, this.buffer[this.bufferOffset++] = w & 255, this.pos += 3;
                }, b.writeUInt24LE = function(w) {
                  return this.ensure(3), this.buffer[this.bufferOffset++] = w & 255, this.buffer[this.bufferOffset++] = w >>> 8 & 255, this.buffer[this.bufferOffset++] = w >>> 16 & 255, this.pos += 3;
                }, b.writeInt24BE = function(w) {
                  return w >= 0 ? this.writeUInt24BE(w) : this.writeUInt24BE(w + 16777215 + 1);
                }, b.writeInt24LE = function(w) {
                  return w >= 0 ? this.writeUInt24LE(w) : this.writeUInt24LE(w + 16777215 + 1);
                }, b.fill = function(w, E) {
                  if (E < this.buffer.length)
                    return this.ensure(E), this.buffer.fill(w, this.bufferOffset, this.bufferOffset + E), this.bufferOffset += E, this.pos += E;
                  var A = s.alloc(E);
                  return A.fill(w), this.writeBuffer(A);
                }, b.end = function() {
                  return this.flush(), this.push(null);
                }, y;
              }(v.Readable), x = function(y) {
                if (y.slice(0, 5) === "write") {
                  var b = +p.TYPES[y.replace(/write|[BL]E/g, "")];
                  m.prototype[y] = function(n) {
                    return this.ensure(b), this.buffer[y](n, this.bufferOffset), this.bufferOffset += b, this.pos += b;
                  };
                }
              };
              for (var g in s.prototype)
                x(g);
              u.exports = m;
            }
          ),
          /***/
          71499: (
            /***/
            function(u) {
              var l = /* @__PURE__ */ function() {
                function e(i, f) {
                  f === void 0 && (f = []), this.type = i, this.options = f;
                }
                var s = e.prototype;
                return s.decode = function(f) {
                  var h = this.type.decode(f);
                  return this.options[h] || h;
                }, s.size = function() {
                  return this.type.size();
                }, s.encode = function(f, h) {
                  var v = this.options.indexOf(h);
                  if (v === -1)
                    throw new Error("Unknown option in enum: " + h);
                  return this.type.encode(f, v);
                }, e;
              }();
              u.exports = l;
            }
          ),
          /***/
          88687: (
            /***/
            function(u, l, e) {
              e(14032), e(68067);
              function s(y, b) {
                y.prototype = Object.create(b.prototype), y.prototype.constructor = y, i(y, b);
              }
              function i(y, b) {
                return i = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(w, E) {
                  return w.__proto__ = E, w;
                }, i(y, b);
              }
              var f = e(38637), h = e(63787), v = h.Number, p = e(76949), m = e(7187), x = m.inspect, g = /* @__PURE__ */ function(y) {
                s(b, y);
                function b() {
                  return y.apply(this, arguments) || this;
                }
                var n = b.prototype;
                return n.decode = function(E, A) {
                  var O = E.pos, C = p.resolveLength(this.length, E, A);
                  this.length instanceof v && (A = {
                    parent: A,
                    _startOffset: O,
                    _currentOffset: 0,
                    _length: C
                  });
                  var T = new S(this.type, C, E, A);
                  return E.pos += C * this.type.size(null, A), T;
                }, n.size = function(E, A) {
                  return E instanceof S && (E = E.toArray()), y.prototype.size.call(this, E, A);
                }, n.encode = function(E, A, O) {
                  return A instanceof S && (A = A.toArray()), y.prototype.encode.call(this, E, A, O);
                }, b;
              }(f), S = /* @__PURE__ */ function() {
                function y(n, w, E, A) {
                  this.type = n, this.length = w, this.stream = E, this.ctx = A, this.base = this.stream.pos, this.items = [];
                }
                var b = y.prototype;
                return b.get = function(w) {
                  if (!(w < 0 || w >= this.length)) {
                    if (this.items[w] == null) {
                      var E = this.stream.pos;
                      this.stream.pos = this.base + this.type.size(null, this.ctx) * w, this.items[w] = this.type.decode(this.stream, this.ctx), this.stream.pos = E;
                    }
                    return this.items[w];
                  }
                }, b.toArray = function() {
                  for (var w = [], E = 0, A = this.length; E < A; E++)
                    w.push(this.get(E));
                  return w;
                }, b.inspect = function() {
                  return x(this.toArray());
                }, y;
              }();
              u.exports = g;
            }
          ),
          /***/
          63787: (
            /***/
            function(u, l, e) {
              function s(p, m) {
                p.prototype = Object.create(m.prototype), p.prototype.constructor = p, i(p, m);
              }
              function i(p, m) {
                return i = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(g, S) {
                  return g.__proto__ = S, g;
                }, i(p, m);
              }
              var f = e(78984), h = /* @__PURE__ */ function() {
                function p(x, g) {
                  g === void 0 && (g = "BE"), this.type = x, this.endian = g, this.fn = this.type, this.type[this.type.length - 1] !== "8" && (this.fn += this.endian);
                }
                var m = p.prototype;
                return m.size = function() {
                  return f.TYPES[this.type];
                }, m.decode = function(g) {
                  return g["read" + this.fn]();
                }, m.encode = function(g, S) {
                  return g["write" + this.fn](S);
                }, p;
              }();
              l.Number = h, l.uint8 = new h("UInt8"), l.uint16be = l.uint16 = new h("UInt16", "BE"), l.uint16le = new h("UInt16", "LE"), l.uint24be = l.uint24 = new h("UInt24", "BE"), l.uint24le = new h("UInt24", "LE"), l.uint32be = l.uint32 = new h("UInt32", "BE"), l.uint32le = new h("UInt32", "LE"), l.int8 = new h("Int8"), l.int16be = l.int16 = new h("Int16", "BE"), l.int16le = new h("Int16", "LE"), l.int24be = l.int24 = new h("Int24", "BE"), l.int24le = new h("Int24", "LE"), l.int32be = l.int32 = new h("Int32", "BE"), l.int32le = new h("Int32", "LE"), l.floatbe = l.float = new h("Float", "BE"), l.floatle = new h("Float", "LE"), l.doublebe = l.double = new h("Double", "BE"), l.doublele = new h("Double", "LE");
              var v = /* @__PURE__ */ function(p) {
                s(m, p);
                function m(g, S, y) {
                  var b;
                  return y === void 0 && (y = g >> 1), b = p.call(this, "Int" + g, S) || this, b._point = 1 << y, b;
                }
                var x = m.prototype;
                return x.decode = function(S) {
                  return p.prototype.decode.call(this, S) / this._point;
                }, x.encode = function(S, y) {
                  return p.prototype.encode.call(this, S, y * this._point | 0);
                }, m;
              }(h);
              l.Fixed = v, l.fixed16be = l.fixed16 = new v(16, "BE"), l.fixed16le = new v(16, "LE"), l.fixed32be = l.fixed32 = new v(32, "BE"), l.fixed32le = new v(32, "LE");
            }
          ),
          /***/
          72526: (
            /***/
            function(u) {
              var l = /* @__PURE__ */ function() {
                function e(i, f) {
                  f === void 0 && (f = !0), this.type = i, this.condition = f;
                }
                var s = e.prototype;
                return s.decode = function(f, h) {
                  var v = this.condition;
                  if (typeof v == "function" && (v = v.call(h, h)), v)
                    return this.type.decode(f, h);
                }, s.size = function(f, h) {
                  var v = this.condition;
                  return typeof v == "function" && (v = v.call(h, h)), v ? this.type.size(f, h) : 0;
                }, s.encode = function(f, h, v) {
                  var p = this.condition;
                  if (typeof p == "function" && (p = p.call(v, v)), p)
                    return this.type.encode(f, h, v);
                }, e;
              }();
              u.exports = l;
            }
          ),
          /***/
          41545: (
            /***/
            function(u, l, e) {
              var s = e(76949), i = /* @__PURE__ */ function() {
                function h(p, m, x) {
                  if (x === void 0 && (x = {}), this.offsetType = p, this.type = m, this.options = x, this.type === "void" && (this.type = null), this.options.type == null && (this.options.type = "local"), this.options.allowNull == null && (this.options.allowNull = !0), this.options.nullValue == null && (this.options.nullValue = 0), this.options.lazy == null && (this.options.lazy = !1), this.options.relativeTo) {
                    if (typeof this.options.relativeTo != "function")
                      throw new Error("relativeTo option must be a function");
                    this.relativeToGetter = x.relativeTo;
                  }
                }
                var v = h.prototype;
                return v.decode = function(m, x) {
                  var g = this, S = this.offsetType.decode(m, x);
                  if (S === this.options.nullValue && this.options.allowNull)
                    return null;
                  var y;
                  switch (this.options.type) {
                    case "local":
                      y = x._startOffset;
                      break;
                    case "immediate":
                      y = m.pos - this.offsetType.size();
                      break;
                    case "parent":
                      y = x.parent._startOffset;
                      break;
                    default:
                      for (var b = x; b.parent; )
                        b = b.parent;
                      y = b._startOffset || 0;
                  }
                  this.options.relativeTo && (y += this.relativeToGetter(x));
                  var n = S + y;
                  if (this.type != null) {
                    var w = null, E = function() {
                      if (w != null)
                        return w;
                      var O = m.pos;
                      return m.pos = n, w = g.type.decode(m, x), m.pos = O, w;
                    };
                    return this.options.lazy ? new s.PropertyDescriptor({
                      get: E
                    }) : E();
                  } else
                    return n;
                }, v.size = function(m, x) {
                  var g = x;
                  switch (this.options.type) {
                    case "local":
                    case "immediate":
                      break;
                    case "parent":
                      x = x.parent;
                      break;
                    default:
                      for (; x.parent; )
                        x = x.parent;
                  }
                  var S = this.type;
                  if (S == null) {
                    if (!(m instanceof f))
                      throw new Error("Must be a VoidPointer");
                    var y = m;
                    S = y.type, m = m.value;
                  }
                  return m && x && (x.pointerSize += S.size(m, g)), this.offsetType.size();
                }, v.encode = function(m, x, g) {
                  var S, y = g;
                  if (x == null) {
                    this.offsetType.encode(m, this.options.nullValue);
                    return;
                  }
                  switch (this.options.type) {
                    case "local":
                      S = g.startOffset;
                      break;
                    case "immediate":
                      S = m.pos + this.offsetType.size(x, y);
                      break;
                    case "parent":
                      g = g.parent, S = g.startOffset;
                      break;
                    default:
                      for (S = 0; g.parent; )
                        g = g.parent;
                  }
                  this.options.relativeTo && (S += this.relativeToGetter(y.val)), this.offsetType.encode(m, g.pointerOffset - S);
                  var b = this.type;
                  if (b == null) {
                    if (!(x instanceof f))
                      throw new Error("Must be a VoidPointer");
                    var n = x;
                    b = n.type, x = x.value;
                  }
                  return g.pointers.push({
                    type: b,
                    val: x,
                    parent: y
                  }), g.pointerOffset += b.size(x, y);
                }, h;
              }(), f = function(v, p) {
                this.type = v, this.value = p;
              };
              l.Pointer = i, l.VoidPointer = f;
            }
          ),
          /***/
          10298: (
            /***/
            function(u, l, e) {
              e(41584);
              var s = e(76949), i = /* @__PURE__ */ function() {
                function f(v, p) {
                  p === void 0 && (p = 1), this.type = v, this.count = p;
                }
                var h = f.prototype;
                return h.decode = function(p, m) {
                  p.pos += this.size(null, m);
                }, h.size = function(p, m) {
                  var x = s.resolveLength(this.count, null, m);
                  return this.type.size() * x;
                }, h.encode = function(p, m, x) {
                  return p.fill(0, this.size(m, x));
                }, f;
              }();
              u.exports = i;
            }
          ),
          /***/
          36291: (
            /***/
            function(u, l, e) {
              var s = e(50621).Buffer, i = e(63787), f = i.Number, h = e(76949), v = /* @__PURE__ */ function() {
                function p(x, g) {
                  g === void 0 && (g = "ascii"), this.length = x, this.encoding = g;
                }
                var m = p.prototype;
                return m.decode = function(g, S) {
                  var y, b;
                  if (this.length != null)
                    y = h.resolveLength(this.length, g, S);
                  else {
                    var n;
                    for (n = g.buffer, y = g.length, b = g.pos; b < y && n[b] !== 0; )
                      ++b;
                    y = b - g.pos;
                  }
                  var w = this.encoding;
                  typeof w == "function" && (w = w.call(S, S) || "ascii");
                  var E = g.readString(y, w);
                  return this.length == null && g.pos < g.length && g.pos++, E;
                }, m.size = function(g, S) {
                  if (!g)
                    return h.resolveLength(this.length, null, S);
                  var y = this.encoding;
                  typeof y == "function" && (y = y.call(S != null ? S.val : void 0, S != null ? S.val : void 0) || "ascii"), y === "utf16be" && (y = "utf16le");
                  var b = s.byteLength(g, y);
                  return this.length instanceof f && (b += this.length.size()), this.length == null && b++, b;
                }, m.encode = function(g, S, y) {
                  var b = this.encoding;
                  if (typeof b == "function" && (b = b.call(y != null ? y.val : void 0, y != null ? y.val : void 0) || "ascii"), this.length instanceof f && this.length.encode(g, s.byteLength(S, b)), g.writeString(S, b), this.length == null)
                    return g.writeUInt8(0);
                }, p;
              }();
              u.exports = v;
            }
          ),
          /***/
          2731: (
            /***/
            function(u, l, e) {
              var s = e(76949), i = /* @__PURE__ */ function() {
                function f(v) {
                  v === void 0 && (v = {}), this.fields = v;
                }
                var h = f.prototype;
                return h.decode = function(p, m, x) {
                  x === void 0 && (x = 0);
                  var g = this._setup(p, m, x);
                  return this._parseFields(p, g, this.fields), this.process != null && this.process.call(g, p), g;
                }, h._setup = function(p, m, x) {
                  var g = {};
                  return Object.defineProperties(g, {
                    parent: {
                      value: m
                    },
                    _startOffset: {
                      value: p.pos
                    },
                    _currentOffset: {
                      value: 0,
                      writable: !0
                    },
                    _length: {
                      value: x
                    }
                  }), g;
                }, h._parseFields = function(p, m, x) {
                  for (var g in x) {
                    var S, y = x[g];
                    typeof y == "function" ? S = y.call(m, m) : S = y.decode(p, m), S !== void 0 && (S instanceof s.PropertyDescriptor ? Object.defineProperty(m, g, S) : m[g] = S), m._currentOffset = p.pos - m._startOffset;
                  }
                }, h.size = function(p, m, x) {
                  p == null && (p = {}), x == null && (x = !0);
                  var g = {
                    parent: m,
                    val: p,
                    pointerSize: 0
                  }, S = 0;
                  for (var y in this.fields) {
                    var b = this.fields[y];
                    b.size != null && (S += b.size(p[y], g));
                  }
                  return x && (S += g.pointerSize), S;
                }, h.encode = function(p, m, x) {
                  var g;
                  this.preEncode != null && this.preEncode.call(m, p);
                  var S = {
                    pointers: [],
                    startOffset: p.pos,
                    parent: x,
                    val: m,
                    pointerSize: 0
                  };
                  S.pointerOffset = p.pos + this.size(m, S, !1);
                  for (var y in this.fields)
                    g = this.fields[y], g.encode != null && g.encode(p, m[y], S);
                  for (var b = 0; b < S.pointers.length; ) {
                    var n = S.pointers[b++];
                    n.type.encode(p, n.val, n.parent);
                  }
                }, f;
              }();
              u.exports = i;
            }
          ),
          /***/
          48084: (
            /***/
            function(u, l, e) {
              e(14032);
              function s(p, m) {
                p.prototype = Object.create(m.prototype), p.prototype.constructor = p, i(p, m);
              }
              function i(p, m) {
                return i = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(g, S) {
                  return g.__proto__ = S, g;
                }, i(p, m);
              }
              var f = e(2731), h = function(m, x) {
                return x.reduce(function(g, S) {
                  return g && g[S];
                }, m);
              }, v = /* @__PURE__ */ function(p) {
                s(m, p);
                function m(g, S) {
                  var y;
                  return S === void 0 && (S = {}), y = p.call(this) || this, y.type = g, y.versions = S, typeof g == "string" && (y.versionPath = g.split(".")), y;
                }
                var x = m.prototype;
                return x.decode = function(S, y, b) {
                  b === void 0 && (b = 0);
                  var n = this._setup(S, y, b);
                  typeof this.type == "string" ? n.version = h(y, this.versionPath) : n.version = this.type.decode(S), this.versions.header && this._parseFields(S, n, this.versions.header);
                  var w = this.versions[n.version];
                  if (w == null)
                    throw new Error("Unknown version " + n.version);
                  return w instanceof m ? w.decode(S, y) : (this._parseFields(S, n, w), this.process != null && this.process.call(n, S), n);
                }, x.size = function(S, y, b) {
                  b === void 0 && (b = !0);
                  var n, w;
                  if (!S)
                    throw new Error("Not a fixed size");
                  var E = {
                    parent: y,
                    val: S,
                    pointerSize: 0
                  }, A = 0;
                  if (typeof this.type != "string" && (A += this.type.size(S.version, E)), this.versions.header)
                    for (n in this.versions.header)
                      w = this.versions.header[n], w.size != null && (A += w.size(S[n], E));
                  var O = this.versions[S.version];
                  if (O == null)
                    throw new Error("Unknown version " + S.version);
                  for (n in O)
                    w = O[n], w.size != null && (A += w.size(S[n], E));
                  return b && (A += E.pointerSize), A;
                }, x.encode = function(S, y, b) {
                  var n, w;
                  this.preEncode != null && this.preEncode.call(y, S);
                  var E = {
                    pointers: [],
                    startOffset: S.pos,
                    parent: b,
                    val: y,
                    pointerSize: 0
                  };
                  if (E.pointerOffset = S.pos + this.size(y, E, !1), typeof this.type != "string" && this.type.encode(S, y.version), this.versions.header)
                    for (n in this.versions.header)
                      w = this.versions.header[n], w.encode != null && w.encode(S, y[n], E);
                  var A = this.versions[y.version];
                  for (n in A)
                    w = A[n], w.encode != null && w.encode(S, y[n], E);
                  for (var O = 0; O < E.pointers.length; ) {
                    var C = E.pointers[O++];
                    C.type.encode(S, C.val, C.parent);
                  }
                }, m;
              }(f);
              u.exports = v;
            }
          ),
          /***/
          76949: (
            /***/
            function(u, l, e) {
              var s = e(63787), i = s.Number;
              l.resolveLength = function(h, v, p) {
                var m;
                if (typeof h == "number" ? m = h : typeof h == "function" ? m = h.call(p, p) : p && typeof h == "string" ? m = p[h] : v && h instanceof i && (m = h.decode(v)), isNaN(m))
                  throw new Error("Not a fixed size");
                return m;
              };
              var f = function(v) {
                v === void 0 && (v = {}), this.enumerable = !0, this.configurable = !0;
                for (var p in v) {
                  var m = v[p];
                  this[p] = m;
                }
              };
              l.PropertyDescriptor = f;
            }
          ),
          /***/
          50621: (
            /***/
            function(u, l, e) {
              /*!
               * The buffer module from node.js, for the browser.
               *
               * @author   Feross Aboukhadijeh <https://feross.org>
               * @license  MIT
               */
              e(65292), e(73844), e(5597), e(39081), e(68626), e(41584), e(58028), e(81755), e(20731), e(10720), e(7585), e(24863), e(7283), e(2876), e(14032), e(61726), e(57114), e(47458), e(46467), e(72095), e(56912), e(73663), e(29883), e(35471), e(21012), e(88997), e(97464), e(2857), e(94715), e(13624), e(91132), e(62514), e(24597), e(88042), e(4660), e(92451), e(44206), e(66288), e(13250), e(3858), e(84538), e(64793), e(74202), e(52529), e(41863);
              function s(nt, j) {
                for (var V = 0; V < j.length; V++) {
                  var yt = j[V];
                  yt.enumerable = yt.enumerable || !1, yt.configurable = !0, "value" in yt && (yt.writable = !0), Object.defineProperty(nt, f(yt.key), yt);
                }
              }
              function i(nt, j, V) {
                return j && s(nt.prototype, j), V && s(nt, V), Object.defineProperty(nt, "prototype", { writable: !1 }), nt;
              }
              function f(nt) {
                var j = h(nt, "string");
                return typeof j == "symbol" ? j : String(j);
              }
              function h(nt, j) {
                if (typeof nt != "object" || !nt)
                  return nt;
                var V = nt[Symbol.toPrimitive];
                if (V !== void 0) {
                  var yt = V.call(nt, j || "default");
                  if (typeof yt != "object")
                    return yt;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (j === "string" ? String : Number)(nt);
              }
              function v(nt) {
                if (nt === void 0)
                  throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return nt;
              }
              function p(nt, j) {
                nt.prototype = Object.create(j.prototype), nt.prototype.constructor = nt, m(nt, j);
              }
              function m(nt, j) {
                return m = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(yt, it) {
                  return yt.__proto__ = it, yt;
                }, m(nt, j);
              }
              var x = e(32504), g = e(89029), S = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
              l.Buffer = w, l.SlowBuffer = z, l.INSPECT_MAX_BYTES = 50;
              var y = 2147483647;
              l.kMaxLength = y, w.TYPED_ARRAY_SUPPORT = b(), !w.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
              function b() {
                try {
                  var nt = new Uint8Array(1), j = {
                    foo: function() {
                      return 42;
                    }
                  };
                  return Object.setPrototypeOf(j, Uint8Array.prototype), Object.setPrototypeOf(nt, j), nt.foo() === 42;
                } catch {
                  return !1;
                }
              }
              Object.defineProperty(w.prototype, "parent", {
                enumerable: !0,
                get: function() {
                  if (w.isBuffer(this))
                    return this.buffer;
                }
              }), Object.defineProperty(w.prototype, "offset", {
                enumerable: !0,
                get: function() {
                  if (w.isBuffer(this))
                    return this.byteOffset;
                }
              });
              function n(nt) {
                if (nt > y)
                  throw new RangeError('The value "' + nt + '" is invalid for option "size"');
                var j = new Uint8Array(nt);
                return Object.setPrototypeOf(j, w.prototype), j;
              }
              function w(nt, j, V) {
                if (typeof nt == "number") {
                  if (typeof j == "string")
                    throw new TypeError('The "string" argument must be of type string. Received type number');
                  return C(nt);
                }
                return E(nt, j, V);
              }
              w.poolSize = 8192;
              function E(nt, j, V) {
                if (typeof nt == "string")
                  return T(nt, j);
                if (ArrayBuffer.isView(nt))
                  return I(nt);
                if (nt == null)
                  throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof nt);
                if (Pe(nt, ArrayBuffer) || nt && Pe(nt.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (Pe(nt, SharedArrayBuffer) || nt && Pe(nt.buffer, SharedArrayBuffer)))
                  return F(nt, j, V);
                if (typeof nt == "number")
                  throw new TypeError('The "value" argument must not be of type number. Received type number');
                var yt = nt.valueOf && nt.valueOf();
                if (yt != null && yt !== nt)
                  return w.from(yt, j, V);
                var it = B(nt);
                if (it)
                  return it;
                if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof nt[Symbol.toPrimitive] == "function")
                  return w.from(nt[Symbol.toPrimitive]("string"), j, V);
                throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof nt);
              }
              w.from = function(nt, j, V) {
                return E(nt, j, V);
              }, Object.setPrototypeOf(w.prototype, Uint8Array.prototype), Object.setPrototypeOf(w, Uint8Array);
              function A(nt) {
                if (typeof nt != "number")
                  throw new TypeError('"size" argument must be of type number');
                if (nt < 0)
                  throw new RangeError('The value "' + nt + '" is invalid for option "size"');
              }
              function O(nt, j, V) {
                return A(nt), nt <= 0 ? n(nt) : j !== void 0 ? typeof V == "string" ? n(nt).fill(j, V) : n(nt).fill(j) : n(nt);
              }
              w.alloc = function(nt, j, V) {
                return O(nt, j, V);
              };
              function C(nt) {
                return A(nt), n(nt < 0 ? 0 : M(nt) | 0);
              }
              w.allocUnsafe = function(nt) {
                return C(nt);
              }, w.allocUnsafeSlow = function(nt) {
                return C(nt);
              };
              function T(nt, j) {
                if ((typeof j != "string" || j === "") && (j = "utf8"), !w.isEncoding(j))
                  throw new TypeError("Unknown encoding: " + j);
                var V = L(nt, j) | 0, yt = n(V), it = yt.write(nt, j);
                return it !== V && (yt = yt.slice(0, it)), yt;
              }
              function P(nt) {
                for (var j = nt.length < 0 ? 0 : M(nt.length) | 0, V = n(j), yt = 0; yt < j; yt += 1)
                  V[yt] = nt[yt] & 255;
                return V;
              }
              function I(nt) {
                if (Pe(nt, Uint8Array)) {
                  var j = new Uint8Array(nt);
                  return F(j.buffer, j.byteOffset, j.byteLength);
                }
                return P(nt);
              }
              function F(nt, j, V) {
                if (j < 0 || nt.byteLength < j)
                  throw new RangeError('"offset" is outside of buffer bounds');
                if (nt.byteLength < j + (V || 0))
                  throw new RangeError('"length" is outside of buffer bounds');
                var yt;
                return j === void 0 && V === void 0 ? yt = new Uint8Array(nt) : V === void 0 ? yt = new Uint8Array(nt, j) : yt = new Uint8Array(nt, j, V), Object.setPrototypeOf(yt, w.prototype), yt;
              }
              function B(nt) {
                if (w.isBuffer(nt)) {
                  var j = M(nt.length) | 0, V = n(j);
                  return V.length === 0 || nt.copy(V, 0, 0, j), V;
                }
                if (nt.length !== void 0)
                  return typeof nt.length != "number" || Be(nt.length) ? n(0) : P(nt);
                if (nt.type === "Buffer" && Array.isArray(nt.data))
                  return P(nt.data);
              }
              function M(nt) {
                if (nt >= y)
                  throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + y.toString(16) + " bytes");
                return nt | 0;
              }
              function z(nt) {
                return +nt != nt && (nt = 0), w.alloc(+nt);
              }
              w.isBuffer = function(j) {
                return j != null && j._isBuffer === !0 && j !== w.prototype;
              }, w.compare = function(j, V) {
                if (Pe(j, Uint8Array) && (j = w.from(j, j.offset, j.byteLength)), Pe(V, Uint8Array) && (V = w.from(V, V.offset, V.byteLength)), !w.isBuffer(j) || !w.isBuffer(V))
                  throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
                if (j === V)
                  return 0;
                for (var yt = j.length, it = V.length, _t = 0, ne = Math.min(yt, it); _t < ne; ++_t)
                  if (j[_t] !== V[_t]) {
                    yt = j[_t], it = V[_t];
                    break;
                  }
                return yt < it ? -1 : it < yt ? 1 : 0;
              }, w.isEncoding = function(j) {
                switch (String(j).toLowerCase()) {
                  case "hex":
                  case "utf8":
                  case "utf-8":
                  case "ascii":
                  case "latin1":
                  case "binary":
                  case "base64":
                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return !0;
                  default:
                    return !1;
                }
              }, w.concat = function(j, V) {
                if (!Array.isArray(j))
                  throw new TypeError('"list" argument must be an Array of Buffers');
                if (j.length === 0)
                  return w.alloc(0);
                var yt;
                if (V === void 0)
                  for (V = 0, yt = 0; yt < j.length; ++yt)
                    V += j[yt].length;
                var it = w.allocUnsafe(V), _t = 0;
                for (yt = 0; yt < j.length; ++yt) {
                  var ne = j[yt];
                  if (Pe(ne, Uint8Array))
                    _t + ne.length > it.length ? (w.isBuffer(ne) || (ne = w.from(ne)), ne.copy(it, _t)) : Uint8Array.prototype.set.call(it, ne, _t);
                  else if (w.isBuffer(ne))
                    ne.copy(it, _t);
                  else
                    throw new TypeError('"list" argument must be an Array of Buffers');
                  _t += ne.length;
                }
                return it;
              };
              function L(nt, j) {
                if (w.isBuffer(nt))
                  return nt.length;
                if (ArrayBuffer.isView(nt) || Pe(nt, ArrayBuffer))
                  return nt.byteLength;
                if (typeof nt != "string")
                  throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof nt);
                var V = nt.length, yt = arguments.length > 2 && arguments[2] === !0;
                if (!yt && V === 0)
                  return 0;
                for (var it = !1; ; )
                  switch (j) {
                    case "ascii":
                    case "latin1":
                    case "binary":
                      return V;
                    case "utf8":
                    case "utf-8":
                      return Fe(nt).length;
                    case "ucs2":
                    case "ucs-2":
                    case "utf16le":
                    case "utf-16le":
                      return V * 2;
                    case "hex":
                      return V >>> 1;
                    case "base64":
                      return ve(nt).length;
                    default:
                      if (it)
                        return yt ? -1 : Fe(nt).length;
                      j = ("" + j).toLowerCase(), it = !0;
                  }
              }
              w.byteLength = L;
              function J(nt, j, V) {
                var yt = !1;
                if ((j === void 0 || j < 0) && (j = 0), j > this.length || ((V === void 0 || V > this.length) && (V = this.length), V <= 0) || (V >>>= 0, j >>>= 0, V <= j))
                  return "";
                for (nt || (nt = "utf8"); ; )
                  switch (nt) {
                    case "hex":
                      return Ft(this, j, V);
                    case "utf8":
                    case "utf-8":
                      return X(this, j, V);
                    case "ascii":
                      return rt(this, j, V);
                    case "latin1":
                    case "binary":
                      return wt(this, j, V);
                    case "base64":
                      return Dt(this, j, V);
                    case "ucs2":
                    case "ucs-2":
                    case "utf16le":
                    case "utf-16le":
                      return zt(this, j, V);
                    default:
                      if (yt)
                        throw new TypeError("Unknown encoding: " + nt);
                      nt = (nt + "").toLowerCase(), yt = !0;
                  }
              }
              w.prototype._isBuffer = !0;
              function ft(nt, j, V) {
                var yt = nt[j];
                nt[j] = nt[V], nt[V] = yt;
              }
              w.prototype.swap16 = function() {
                var j = this.length;
                if (j % 2 !== 0)
                  throw new RangeError("Buffer size must be a multiple of 16-bits");
                for (var V = 0; V < j; V += 2)
                  ft(this, V, V + 1);
                return this;
              }, w.prototype.swap32 = function() {
                var j = this.length;
                if (j % 4 !== 0)
                  throw new RangeError("Buffer size must be a multiple of 32-bits");
                for (var V = 0; V < j; V += 4)
                  ft(this, V, V + 3), ft(this, V + 1, V + 2);
                return this;
              }, w.prototype.swap64 = function() {
                var j = this.length;
                if (j % 8 !== 0)
                  throw new RangeError("Buffer size must be a multiple of 64-bits");
                for (var V = 0; V < j; V += 8)
                  ft(this, V, V + 7), ft(this, V + 1, V + 6), ft(this, V + 2, V + 5), ft(this, V + 3, V + 4);
                return this;
              }, w.prototype.toString = function() {
                var j = this.length;
                return j === 0 ? "" : arguments.length === 0 ? X(this, 0, j) : J.apply(this, arguments);
              }, w.prototype.toLocaleString = w.prototype.toString, w.prototype.equals = function(j) {
                if (!w.isBuffer(j))
                  throw new TypeError("Argument must be a Buffer");
                return this === j ? !0 : w.compare(this, j) === 0;
              }, w.prototype.inspect = function() {
                var j = "", V = l.INSPECT_MAX_BYTES;
                return j = this.toString("hex", 0, V).replace(/(.{2})/g, "$1 ").trim(), this.length > V && (j += " ... "), "<Buffer " + j + ">";
              }, S && (w.prototype[S] = w.prototype.inspect), w.prototype.compare = function(j, V, yt, it, _t) {
                if (Pe(j, Uint8Array) && (j = w.from(j, j.offset, j.byteLength)), !w.isBuffer(j))
                  throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof j);
                if (V === void 0 && (V = 0), yt === void 0 && (yt = j ? j.length : 0), it === void 0 && (it = 0), _t === void 0 && (_t = this.length), V < 0 || yt > j.length || it < 0 || _t > this.length)
                  throw new RangeError("out of range index");
                if (it >= _t && V >= yt)
                  return 0;
                if (it >= _t)
                  return -1;
                if (V >= yt)
                  return 1;
                if (V >>>= 0, yt >>>= 0, it >>>= 0, _t >>>= 0, this === j)
                  return 0;
                for (var ne = _t - it, Y = yt - V, Jt = Math.min(ne, Y), ie = this.slice(it, _t), Tt = j.slice(V, yt), Xt = 0; Xt < Jt; ++Xt)
                  if (ie[Xt] !== Tt[Xt]) {
                    ne = ie[Xt], Y = Tt[Xt];
                    break;
                  }
                return ne < Y ? -1 : Y < ne ? 1 : 0;
              };
              function Q(nt, j, V, yt, it) {
                if (nt.length === 0)
                  return -1;
                if (typeof V == "string" ? (yt = V, V = 0) : V > 2147483647 ? V = 2147483647 : V < -2147483648 && (V = -2147483648), V = +V, Be(V) && (V = it ? 0 : nt.length - 1), V < 0 && (V = nt.length + V), V >= nt.length) {
                  if (it)
                    return -1;
                  V = nt.length - 1;
                } else if (V < 0)
                  if (it)
                    V = 0;
                  else
                    return -1;
                if (typeof j == "string" && (j = w.from(j, yt)), w.isBuffer(j))
                  return j.length === 0 ? -1 : xt(nt, j, V, yt, it);
                if (typeof j == "number")
                  return j = j & 255, typeof Uint8Array.prototype.indexOf == "function" ? it ? Uint8Array.prototype.indexOf.call(nt, j, V) : Uint8Array.prototype.lastIndexOf.call(nt, j, V) : xt(nt, [j], V, yt, it);
                throw new TypeError("val must be string, number or Buffer");
              }
              function xt(nt, j, V, yt, it) {
                var _t = 1, ne = nt.length, Y = j.length;
                if (yt !== void 0 && (yt = String(yt).toLowerCase(), yt === "ucs2" || yt === "ucs-2" || yt === "utf16le" || yt === "utf-16le")) {
                  if (nt.length < 2 || j.length < 2)
                    return -1;
                  _t = 2, ne /= 2, Y /= 2, V /= 2;
                }
                function Jt(Ve, ke) {
                  return _t === 1 ? Ve[ke] : Ve.readUInt16BE(ke * _t);
                }
                var ie;
                if (it) {
                  var Tt = -1;
                  for (ie = V; ie < ne; ie++)
                    if (Jt(nt, ie) === Jt(j, Tt === -1 ? 0 : ie - Tt)) {
                      if (Tt === -1 && (Tt = ie), ie - Tt + 1 === Y)
                        return Tt * _t;
                    } else
                      Tt !== -1 && (ie -= ie - Tt), Tt = -1;
                } else
                  for (V + Y > ne && (V = ne - Y), ie = V; ie >= 0; ie--) {
                    for (var Xt = !0, ue = 0; ue < Y; ue++)
                      if (Jt(nt, ie + ue) !== Jt(j, ue)) {
                        Xt = !1;
                        break;
                      }
                    if (Xt)
                      return ie;
                  }
                return -1;
              }
              w.prototype.includes = function(j, V, yt) {
                return this.indexOf(j, V, yt) !== -1;
              }, w.prototype.indexOf = function(j, V, yt) {
                return Q(this, j, V, yt, !0);
              }, w.prototype.lastIndexOf = function(j, V, yt) {
                return Q(this, j, V, yt, !1);
              };
              function St(nt, j, V, yt) {
                V = Number(V) || 0;
                var it = nt.length - V;
                yt ? (yt = Number(yt), yt > it && (yt = it)) : yt = it;
                var _t = j.length;
                yt > _t / 2 && (yt = _t / 2);
                var ne;
                for (ne = 0; ne < yt; ++ne) {
                  var Y = parseInt(j.substr(ne * 2, 2), 16);
                  if (Be(Y))
                    return ne;
                  nt[V + ne] = Y;
                }
                return ne;
              }
              function Pt(nt, j, V, yt) {
                return Se(Fe(j, nt.length - V), nt, V, yt);
              }
              function Gt(nt, j, V, yt) {
                return Se(Zt(j), nt, V, yt);
              }
              function Rt(nt, j, V, yt) {
                return Se(ve(j), nt, V, yt);
              }
              function bt(nt, j, V, yt) {
                return Se(qt(j, nt.length - V), nt, V, yt);
              }
              w.prototype.write = function(j, V, yt, it) {
                if (V === void 0)
                  it = "utf8", yt = this.length, V = 0;
                else if (yt === void 0 && typeof V == "string")
                  it = V, yt = this.length, V = 0;
                else if (isFinite(V))
                  V = V >>> 0, isFinite(yt) ? (yt = yt >>> 0, it === void 0 && (it = "utf8")) : (it = yt, yt = void 0);
                else
                  throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                var _t = this.length - V;
                if ((yt === void 0 || yt > _t) && (yt = _t), j.length > 0 && (yt < 0 || V < 0) || V > this.length)
                  throw new RangeError("Attempt to write outside buffer bounds");
                it || (it = "utf8");
                for (var ne = !1; ; )
                  switch (it) {
                    case "hex":
                      return St(this, j, V, yt);
                    case "utf8":
                    case "utf-8":
                      return Pt(this, j, V, yt);
                    case "ascii":
                    case "latin1":
                    case "binary":
                      return Gt(this, j, V, yt);
                    case "base64":
                      return Rt(this, j, V, yt);
                    case "ucs2":
                    case "ucs-2":
                    case "utf16le":
                    case "utf-16le":
                      return bt(this, j, V, yt);
                    default:
                      if (ne)
                        throw new TypeError("Unknown encoding: " + it);
                      it = ("" + it).toLowerCase(), ne = !0;
                  }
              }, w.prototype.toJSON = function() {
                return {
                  type: "Buffer",
                  data: Array.prototype.slice.call(this._arr || this, 0)
                };
              };
              function Dt(nt, j, V) {
                return j === 0 && V === nt.length ? x.fromByteArray(nt) : x.fromByteArray(nt.slice(j, V));
              }
              function X(nt, j, V) {
                V = Math.min(nt.length, V);
                for (var yt = [], it = j; it < V; ) {
                  var _t = nt[it], ne = null, Y = _t > 239 ? 4 : _t > 223 ? 3 : _t > 191 ? 2 : 1;
                  if (it + Y <= V) {
                    var Jt = void 0, ie = void 0, Tt = void 0, Xt = void 0;
                    switch (Y) {
                      case 1:
                        _t < 128 && (ne = _t);
                        break;
                      case 2:
                        Jt = nt[it + 1], (Jt & 192) === 128 && (Xt = (_t & 31) << 6 | Jt & 63, Xt > 127 && (ne = Xt));
                        break;
                      case 3:
                        Jt = nt[it + 1], ie = nt[it + 2], (Jt & 192) === 128 && (ie & 192) === 128 && (Xt = (_t & 15) << 12 | (Jt & 63) << 6 | ie & 63, Xt > 2047 && (Xt < 55296 || Xt > 57343) && (ne = Xt));
                        break;
                      case 4:
                        Jt = nt[it + 1], ie = nt[it + 2], Tt = nt[it + 3], (Jt & 192) === 128 && (ie & 192) === 128 && (Tt & 192) === 128 && (Xt = (_t & 15) << 18 | (Jt & 63) << 12 | (ie & 63) << 6 | Tt & 63, Xt > 65535 && Xt < 1114112 && (ne = Xt));
                    }
                  }
                  ne === null ? (ne = 65533, Y = 1) : ne > 65535 && (ne -= 65536, yt.push(ne >>> 10 & 1023 | 55296), ne = 56320 | ne & 1023), yt.push(ne), it += Y;
                }
                return st(yt);
              }
              var gt = 4096;
              function st(nt) {
                var j = nt.length;
                if (j <= gt)
                  return String.fromCharCode.apply(String, nt);
                for (var V = "", yt = 0; yt < j; )
                  V += String.fromCharCode.apply(String, nt.slice(yt, yt += gt));
                return V;
              }
              function rt(nt, j, V) {
                var yt = "";
                V = Math.min(nt.length, V);
                for (var it = j; it < V; ++it)
                  yt += String.fromCharCode(nt[it] & 127);
                return yt;
              }
              function wt(nt, j, V) {
                var yt = "";
                V = Math.min(nt.length, V);
                for (var it = j; it < V; ++it)
                  yt += String.fromCharCode(nt[it]);
                return yt;
              }
              function Ft(nt, j, V) {
                var yt = nt.length;
                (!j || j < 0) && (j = 0), (!V || V < 0 || V > yt) && (V = yt);
                for (var it = "", _t = j; _t < V; ++_t)
                  it += De[nt[_t]];
                return it;
              }
              function zt(nt, j, V) {
                for (var yt = nt.slice(j, V), it = "", _t = 0; _t < yt.length - 1; _t += 2)
                  it += String.fromCharCode(yt[_t] + yt[_t + 1] * 256);
                return it;
              }
              w.prototype.slice = function(j, V) {
                var yt = this.length;
                j = ~~j, V = V === void 0 ? yt : ~~V, j < 0 ? (j += yt, j < 0 && (j = 0)) : j > yt && (j = yt), V < 0 ? (V += yt, V < 0 && (V = 0)) : V > yt && (V = yt), V < j && (V = j);
                var it = this.subarray(j, V);
                return Object.setPrototypeOf(it, w.prototype), it;
              };
              function G(nt, j, V) {
                if (nt % 1 !== 0 || nt < 0)
                  throw new RangeError("offset is not uint");
                if (nt + j > V)
                  throw new RangeError("Trying to access beyond buffer length");
              }
              w.prototype.readUintLE = w.prototype.readUIntLE = function(j, V, yt) {
                j = j >>> 0, V = V >>> 0, yt || G(j, V, this.length);
                for (var it = this[j], _t = 1, ne = 0; ++ne < V && (_t *= 256); )
                  it += this[j + ne] * _t;
                return it;
              }, w.prototype.readUintBE = w.prototype.readUIntBE = function(j, V, yt) {
                j = j >>> 0, V = V >>> 0, yt || G(j, V, this.length);
                for (var it = this[j + --V], _t = 1; V > 0 && (_t *= 256); )
                  it += this[j + --V] * _t;
                return it;
              }, w.prototype.readUint8 = w.prototype.readUInt8 = function(j, V) {
                return j = j >>> 0, V || G(j, 1, this.length), this[j];
              }, w.prototype.readUint16LE = w.prototype.readUInt16LE = function(j, V) {
                return j = j >>> 0, V || G(j, 2, this.length), this[j] | this[j + 1] << 8;
              }, w.prototype.readUint16BE = w.prototype.readUInt16BE = function(j, V) {
                return j = j >>> 0, V || G(j, 2, this.length), this[j] << 8 | this[j + 1];
              }, w.prototype.readUint32LE = w.prototype.readUInt32LE = function(j, V) {
                return j = j >>> 0, V || G(j, 4, this.length), (this[j] | this[j + 1] << 8 | this[j + 2] << 16) + this[j + 3] * 16777216;
              }, w.prototype.readUint32BE = w.prototype.readUInt32BE = function(j, V) {
                return j = j >>> 0, V || G(j, 4, this.length), this[j] * 16777216 + (this[j + 1] << 16 | this[j + 2] << 8 | this[j + 3]);
              }, w.prototype.readBigUInt64LE = It(function(j) {
                j = j >>> 0, ge(j, "offset");
                var V = this[j], yt = this[j + 7];
                (V === void 0 || yt === void 0) && Re(j, this.length - 8);
                var it = V + this[++j] * Math.pow(2, 8) + this[++j] * Math.pow(2, 16) + this[++j] * Math.pow(2, 24), _t = this[++j] + this[++j] * Math.pow(2, 8) + this[++j] * Math.pow(2, 16) + yt * Math.pow(2, 24);
                return BigInt(it) + (BigInt(_t) << BigInt(32));
              }), w.prototype.readBigUInt64BE = It(function(j) {
                j = j >>> 0, ge(j, "offset");
                var V = this[j], yt = this[j + 7];
                (V === void 0 || yt === void 0) && Re(j, this.length - 8);
                var it = V * Math.pow(2, 24) + this[++j] * Math.pow(2, 16) + this[++j] * Math.pow(2, 8) + this[++j], _t = this[++j] * Math.pow(2, 24) + this[++j] * Math.pow(2, 16) + this[++j] * Math.pow(2, 8) + yt;
                return (BigInt(it) << BigInt(32)) + BigInt(_t);
              }), w.prototype.readIntLE = function(j, V, yt) {
                j = j >>> 0, V = V >>> 0, yt || G(j, V, this.length);
                for (var it = this[j], _t = 1, ne = 0; ++ne < V && (_t *= 256); )
                  it += this[j + ne] * _t;
                return _t *= 128, it >= _t && (it -= Math.pow(2, 8 * V)), it;
              }, w.prototype.readIntBE = function(j, V, yt) {
                j = j >>> 0, V = V >>> 0, yt || G(j, V, this.length);
                for (var it = V, _t = 1, ne = this[j + --it]; it > 0 && (_t *= 256); )
                  ne += this[j + --it] * _t;
                return _t *= 128, ne >= _t && (ne -= Math.pow(2, 8 * V)), ne;
              }, w.prototype.readInt8 = function(j, V) {
                return j = j >>> 0, V || G(j, 1, this.length), this[j] & 128 ? (255 - this[j] + 1) * -1 : this[j];
              }, w.prototype.readInt16LE = function(j, V) {
                j = j >>> 0, V || G(j, 2, this.length);
                var yt = this[j] | this[j + 1] << 8;
                return yt & 32768 ? yt | 4294901760 : yt;
              }, w.prototype.readInt16BE = function(j, V) {
                j = j >>> 0, V || G(j, 2, this.length);
                var yt = this[j + 1] | this[j] << 8;
                return yt & 32768 ? yt | 4294901760 : yt;
              }, w.prototype.readInt32LE = function(j, V) {
                return j = j >>> 0, V || G(j, 4, this.length), this[j] | this[j + 1] << 8 | this[j + 2] << 16 | this[j + 3] << 24;
              }, w.prototype.readInt32BE = function(j, V) {
                return j = j >>> 0, V || G(j, 4, this.length), this[j] << 24 | this[j + 1] << 16 | this[j + 2] << 8 | this[j + 3];
              }, w.prototype.readBigInt64LE = It(function(j) {
                j = j >>> 0, ge(j, "offset");
                var V = this[j], yt = this[j + 7];
                (V === void 0 || yt === void 0) && Re(j, this.length - 8);
                var it = this[j + 4] + this[j + 5] * Math.pow(2, 8) + this[j + 6] * Math.pow(2, 16) + (yt << 24);
                return (BigInt(it) << BigInt(32)) + BigInt(V + this[++j] * Math.pow(2, 8) + this[++j] * Math.pow(2, 16) + this[++j] * Math.pow(2, 24));
              }), w.prototype.readBigInt64BE = It(function(j) {
                j = j >>> 0, ge(j, "offset");
                var V = this[j], yt = this[j + 7];
                (V === void 0 || yt === void 0) && Re(j, this.length - 8);
                var it = (V << 24) + // Overflow
                this[++j] * Math.pow(2, 16) + this[++j] * Math.pow(2, 8) + this[++j];
                return (BigInt(it) << BigInt(32)) + BigInt(this[++j] * Math.pow(2, 24) + this[++j] * Math.pow(2, 16) + this[++j] * Math.pow(2, 8) + yt);
              }), w.prototype.readFloatLE = function(j, V) {
                return j = j >>> 0, V || G(j, 4, this.length), g.read(this, j, !0, 23, 4);
              }, w.prototype.readFloatBE = function(j, V) {
                return j = j >>> 0, V || G(j, 4, this.length), g.read(this, j, !1, 23, 4);
              }, w.prototype.readDoubleLE = function(j, V) {
                return j = j >>> 0, V || G(j, 8, this.length), g.read(this, j, !0, 52, 8);
              }, w.prototype.readDoubleBE = function(j, V) {
                return j = j >>> 0, V || G(j, 8, this.length), g.read(this, j, !1, 52, 8);
              };
              function D(nt, j, V, yt, it, _t) {
                if (!w.isBuffer(nt))
                  throw new TypeError('"buffer" argument must be a Buffer instance');
                if (j > it || j < _t)
                  throw new RangeError('"value" argument is out of bounds');
                if (V + yt > nt.length)
                  throw new RangeError("Index out of range");
              }
              w.prototype.writeUintLE = w.prototype.writeUIntLE = function(j, V, yt, it) {
                if (j = +j, V = V >>> 0, yt = yt >>> 0, !it) {
                  var _t = Math.pow(2, 8 * yt) - 1;
                  D(this, j, V, yt, _t, 0);
                }
                var ne = 1, Y = 0;
                for (this[V] = j & 255; ++Y < yt && (ne *= 256); )
                  this[V + Y] = j / ne & 255;
                return V + yt;
              }, w.prototype.writeUintBE = w.prototype.writeUIntBE = function(j, V, yt, it) {
                if (j = +j, V = V >>> 0, yt = yt >>> 0, !it) {
                  var _t = Math.pow(2, 8 * yt) - 1;
                  D(this, j, V, yt, _t, 0);
                }
                var ne = yt - 1, Y = 1;
                for (this[V + ne] = j & 255; --ne >= 0 && (Y *= 256); )
                  this[V + ne] = j / Y & 255;
                return V + yt;
              }, w.prototype.writeUint8 = w.prototype.writeUInt8 = function(j, V, yt) {
                return j = +j, V = V >>> 0, yt || D(this, j, V, 1, 255, 0), this[V] = j & 255, V + 1;
              }, w.prototype.writeUint16LE = w.prototype.writeUInt16LE = function(j, V, yt) {
                return j = +j, V = V >>> 0, yt || D(this, j, V, 2, 65535, 0), this[V] = j & 255, this[V + 1] = j >>> 8, V + 2;
              }, w.prototype.writeUint16BE = w.prototype.writeUInt16BE = function(j, V, yt) {
                return j = +j, V = V >>> 0, yt || D(this, j, V, 2, 65535, 0), this[V] = j >>> 8, this[V + 1] = j & 255, V + 2;
              }, w.prototype.writeUint32LE = w.prototype.writeUInt32LE = function(j, V, yt) {
                return j = +j, V = V >>> 0, yt || D(this, j, V, 4, 4294967295, 0), this[V + 3] = j >>> 24, this[V + 2] = j >>> 16, this[V + 1] = j >>> 8, this[V] = j & 255, V + 4;
              }, w.prototype.writeUint32BE = w.prototype.writeUInt32BE = function(j, V, yt) {
                return j = +j, V = V >>> 0, yt || D(this, j, V, 4, 4294967295, 0), this[V] = j >>> 24, this[V + 1] = j >>> 16, this[V + 2] = j >>> 8, this[V + 3] = j & 255, V + 4;
              };
              function Z(nt, j, V, yt, it) {
                Bt(j, yt, it, nt, V, 7);
                var _t = Number(j & BigInt(4294967295));
                nt[V++] = _t, _t = _t >> 8, nt[V++] = _t, _t = _t >> 8, nt[V++] = _t, _t = _t >> 8, nt[V++] = _t;
                var ne = Number(j >> BigInt(32) & BigInt(4294967295));
                return nt[V++] = ne, ne = ne >> 8, nt[V++] = ne, ne = ne >> 8, nt[V++] = ne, ne = ne >> 8, nt[V++] = ne, V;
              }
              function et(nt, j, V, yt, it) {
                Bt(j, yt, it, nt, V, 7);
                var _t = Number(j & BigInt(4294967295));
                nt[V + 7] = _t, _t = _t >> 8, nt[V + 6] = _t, _t = _t >> 8, nt[V + 5] = _t, _t = _t >> 8, nt[V + 4] = _t;
                var ne = Number(j >> BigInt(32) & BigInt(4294967295));
                return nt[V + 3] = ne, ne = ne >> 8, nt[V + 2] = ne, ne = ne >> 8, nt[V + 1] = ne, ne = ne >> 8, nt[V] = ne, V + 8;
              }
              w.prototype.writeBigUInt64LE = It(function(j, V) {
                return V === void 0 && (V = 0), Z(this, j, V, BigInt(0), BigInt("0xffffffffffffffff"));
              }), w.prototype.writeBigUInt64BE = It(function(j, V) {
                return V === void 0 && (V = 0), et(this, j, V, BigInt(0), BigInt("0xffffffffffffffff"));
              }), w.prototype.writeIntLE = function(j, V, yt, it) {
                if (j = +j, V = V >>> 0, !it) {
                  var _t = Math.pow(2, 8 * yt - 1);
                  D(this, j, V, yt, _t - 1, -_t);
                }
                var ne = 0, Y = 1, Jt = 0;
                for (this[V] = j & 255; ++ne < yt && (Y *= 256); )
                  j < 0 && Jt === 0 && this[V + ne - 1] !== 0 && (Jt = 1), this[V + ne] = (j / Y >> 0) - Jt & 255;
                return V + yt;
              }, w.prototype.writeIntBE = function(j, V, yt, it) {
                if (j = +j, V = V >>> 0, !it) {
                  var _t = Math.pow(2, 8 * yt - 1);
                  D(this, j, V, yt, _t - 1, -_t);
                }
                var ne = yt - 1, Y = 1, Jt = 0;
                for (this[V + ne] = j & 255; --ne >= 0 && (Y *= 256); )
                  j < 0 && Jt === 0 && this[V + ne + 1] !== 0 && (Jt = 1), this[V + ne] = (j / Y >> 0) - Jt & 255;
                return V + yt;
              }, w.prototype.writeInt8 = function(j, V, yt) {
                return j = +j, V = V >>> 0, yt || D(this, j, V, 1, 127, -128), j < 0 && (j = 255 + j + 1), this[V] = j & 255, V + 1;
              }, w.prototype.writeInt16LE = function(j, V, yt) {
                return j = +j, V = V >>> 0, yt || D(this, j, V, 2, 32767, -32768), this[V] = j & 255, this[V + 1] = j >>> 8, V + 2;
              }, w.prototype.writeInt16BE = function(j, V, yt) {
                return j = +j, V = V >>> 0, yt || D(this, j, V, 2, 32767, -32768), this[V] = j >>> 8, this[V + 1] = j & 255, V + 2;
              }, w.prototype.writeInt32LE = function(j, V, yt) {
                return j = +j, V = V >>> 0, yt || D(this, j, V, 4, 2147483647, -2147483648), this[V] = j & 255, this[V + 1] = j >>> 8, this[V + 2] = j >>> 16, this[V + 3] = j >>> 24, V + 4;
              }, w.prototype.writeInt32BE = function(j, V, yt) {
                return j = +j, V = V >>> 0, yt || D(this, j, V, 4, 2147483647, -2147483648), j < 0 && (j = 4294967295 + j + 1), this[V] = j >>> 24, this[V + 1] = j >>> 16, this[V + 2] = j >>> 8, this[V + 3] = j & 255, V + 4;
              }, w.prototype.writeBigInt64LE = It(function(j, V) {
                return V === void 0 && (V = 0), Z(this, j, V, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
              }), w.prototype.writeBigInt64BE = It(function(j, V) {
                return V === void 0 && (V = 0), et(this, j, V, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
              });
              function vt(nt, j, V, yt, it, _t) {
                if (V + yt > nt.length)
                  throw new RangeError("Index out of range");
                if (V < 0)
                  throw new RangeError("Index out of range");
              }
              function lt(nt, j, V, yt, it) {
                return j = +j, V = V >>> 0, it || vt(nt, j, V, 4), g.write(nt, j, V, yt, 23, 4), V + 4;
              }
              w.prototype.writeFloatLE = function(j, V, yt) {
                return lt(this, j, V, !0, yt);
              }, w.prototype.writeFloatBE = function(j, V, yt) {
                return lt(this, j, V, !1, yt);
              };
              function dt(nt, j, V, yt, it) {
                return j = +j, V = V >>> 0, it || vt(nt, j, V, 8), g.write(nt, j, V, yt, 52, 8), V + 8;
              }
              w.prototype.writeDoubleLE = function(j, V, yt) {
                return dt(this, j, V, !0, yt);
              }, w.prototype.writeDoubleBE = function(j, V, yt) {
                return dt(this, j, V, !1, yt);
              }, w.prototype.copy = function(j, V, yt, it) {
                if (!w.isBuffer(j))
                  throw new TypeError("argument should be a Buffer");
                if (yt || (yt = 0), !it && it !== 0 && (it = this.length), V >= j.length && (V = j.length), V || (V = 0), it > 0 && it < yt && (it = yt), it === yt || j.length === 0 || this.length === 0)
                  return 0;
                if (V < 0)
                  throw new RangeError("targetStart out of bounds");
                if (yt < 0 || yt >= this.length)
                  throw new RangeError("Index out of range");
                if (it < 0)
                  throw new RangeError("sourceEnd out of bounds");
                it > this.length && (it = this.length), j.length - V < it - yt && (it = j.length - V + yt);
                var _t = it - yt;
                return this === j && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(V, yt, it) : Uint8Array.prototype.set.call(j, this.subarray(yt, it), V), _t;
              }, w.prototype.fill = function(j, V, yt, it) {
                if (typeof j == "string") {
                  if (typeof V == "string" ? (it = V, V = 0, yt = this.length) : typeof yt == "string" && (it = yt, yt = this.length), it !== void 0 && typeof it != "string")
                    throw new TypeError("encoding must be a string");
                  if (typeof it == "string" && !w.isEncoding(it))
                    throw new TypeError("Unknown encoding: " + it);
                  if (j.length === 1) {
                    var _t = j.charCodeAt(0);
                    (it === "utf8" && _t < 128 || it === "latin1") && (j = _t);
                  }
                } else
                  typeof j == "number" ? j = j & 255 : typeof j == "boolean" && (j = Number(j));
                if (V < 0 || this.length < V || this.length < yt)
                  throw new RangeError("Out of range index");
                if (yt <= V)
                  return this;
                V = V >>> 0, yt = yt === void 0 ? this.length : yt >>> 0, j || (j = 0);
                var ne;
                if (typeof j == "number")
                  for (ne = V; ne < yt; ++ne)
                    this[ne] = j;
                else {
                  var Y = w.isBuffer(j) ? j : w.from(j, it), Jt = Y.length;
                  if (Jt === 0)
                    throw new TypeError('The value "' + j + '" is invalid for argument "value"');
                  for (ne = 0; ne < yt - V; ++ne)
                    this[ne + V] = Y[ne % Jt];
                }
                return this;
              };
              var kt = {};
              function jt(nt, j, V) {
                kt[nt] = /* @__PURE__ */ function(yt) {
                  p(it, yt);
                  function it() {
                    var ne;
                    return ne = yt.call(this) || this, Object.defineProperty(v(ne), "message", {
                      value: j.apply(v(ne), arguments),
                      writable: !0,
                      configurable: !0
                    }), ne.name = ne.name + " [" + nt + "]", ne.stack, delete ne.name, ne;
                  }
                  var _t = it.prototype;
                  return _t.toString = function() {
                    return this.name + " [" + nt + "]: " + this.message;
                  }, i(it, [{
                    key: "code",
                    get: function() {
                      return nt;
                    },
                    set: function(Y) {
                      Object.defineProperty(this, "code", {
                        configurable: !0,
                        enumerable: !0,
                        value: Y,
                        writable: !0
                      });
                    }
                  }]), it;
                }(V);
              }
              jt("ERR_BUFFER_OUT_OF_BOUNDS", function(nt) {
                return nt ? nt + " is outside of buffer bounds" : "Attempt to access memory outside buffer bounds";
              }, RangeError), jt("ERR_INVALID_ARG_TYPE", function(nt, j) {
                return 'The "' + nt + '" argument must be of type number. Received type ' + typeof j;
              }, TypeError), jt("ERR_OUT_OF_RANGE", function(nt, j, V) {
                var yt = 'The value of "' + nt + '" is out of range.', it = V;
                return Number.isInteger(V) && Math.abs(V) > Math.pow(2, 32) ? it = me(String(V)) : typeof V == "bigint" && (it = String(V), (V > Math.pow(BigInt(2), BigInt(32)) || V < -Math.pow(BigInt(2), BigInt(32))) && (it = me(it)), it += "n"), yt += " It must be " + j + ". Received " + it, yt;
              }, RangeError);
              function me(nt) {
                for (var j = "", V = nt.length, yt = nt[0] === "-" ? 1 : 0; V >= yt + 4; V -= 3)
                  j = "_" + nt.slice(V - 3, V) + j;
                return "" + nt.slice(0, V) + j;
              }
              function se(nt, j, V) {
                ge(j, "offset"), (nt[j] === void 0 || nt[j + V] === void 0) && Re(j, nt.length - (V + 1));
              }
              function Bt(nt, j, V, yt, it, _t) {
                if (nt > V || nt < j) {
                  var ne = typeof j == "bigint" ? "n" : "", Y;
                  throw _t > 3 ? j === 0 || j === BigInt(0) ? Y = ">= 0" + ne + " and < 2" + ne + " ** " + (_t + 1) * 8 + ne : Y = ">= -(2" + ne + " ** " + ((_t + 1) * 8 - 1) + ne + ") and < 2 ** " + ("" + ((_t + 1) * 8 - 1) + ne) : Y = ">= " + j + ne + " and <= " + V + ne, new kt.ERR_OUT_OF_RANGE("value", Y, nt);
                }
                se(yt, it, _t);
              }
              function ge(nt, j) {
                if (typeof nt != "number")
                  throw new kt.ERR_INVALID_ARG_TYPE(j, "number", nt);
              }
              function Re(nt, j, V) {
                throw Math.floor(nt) !== nt ? (ge(nt, V), new kt.ERR_OUT_OF_RANGE(V || "offset", "an integer", nt)) : j < 0 ? new kt.ERR_BUFFER_OUT_OF_BOUNDS() : new kt.ERR_OUT_OF_RANGE(V || "offset", ">= " + (V ? 1 : 0) + " and <= " + j, nt);
              }
              var Te = /[^+/0-9A-Za-z-_]/g;
              function xe(nt) {
                if (nt = nt.split("=")[0], nt = nt.trim().replace(Te, ""), nt.length < 2)
                  return "";
                for (; nt.length % 4 !== 0; )
                  nt = nt + "=";
                return nt;
              }
              function Fe(nt, j) {
                j = j || 1 / 0;
                for (var V, yt = nt.length, it = null, _t = [], ne = 0; ne < yt; ++ne) {
                  if (V = nt.charCodeAt(ne), V > 55295 && V < 57344) {
                    if (!it) {
                      if (V > 56319) {
                        (j -= 3) > -1 && _t.push(239, 191, 189);
                        continue;
                      } else if (ne + 1 === yt) {
                        (j -= 3) > -1 && _t.push(239, 191, 189);
                        continue;
                      }
                      it = V;
                      continue;
                    }
                    if (V < 56320) {
                      (j -= 3) > -1 && _t.push(239, 191, 189), it = V;
                      continue;
                    }
                    V = (it - 55296 << 10 | V - 56320) + 65536;
                  } else
                    it && (j -= 3) > -1 && _t.push(239, 191, 189);
                  if (it = null, V < 128) {
                    if ((j -= 1) < 0)
                      break;
                    _t.push(V);
                  } else if (V < 2048) {
                    if ((j -= 2) < 0)
                      break;
                    _t.push(V >> 6 | 192, V & 63 | 128);
                  } else if (V < 65536) {
                    if ((j -= 3) < 0)
                      break;
                    _t.push(V >> 12 | 224, V >> 6 & 63 | 128, V & 63 | 128);
                  } else if (V < 1114112) {
                    if ((j -= 4) < 0)
                      break;
                    _t.push(V >> 18 | 240, V >> 12 & 63 | 128, V >> 6 & 63 | 128, V & 63 | 128);
                  } else
                    throw new Error("Invalid code point");
                }
                return _t;
              }
              function Zt(nt) {
                for (var j = [], V = 0; V < nt.length; ++V)
                  j.push(nt.charCodeAt(V) & 255);
                return j;
              }
              function qt(nt, j) {
                for (var V, yt, it, _t = [], ne = 0; ne < nt.length && !((j -= 2) < 0); ++ne)
                  V = nt.charCodeAt(ne), yt = V >> 8, it = V % 256, _t.push(it), _t.push(yt);
                return _t;
              }
              function ve(nt) {
                return x.toByteArray(xe(nt));
              }
              function Se(nt, j, V, yt) {
                var it;
                for (it = 0; it < yt && !(it + V >= j.length || it >= nt.length); ++it)
                  j[it + V] = nt[it];
                return it;
              }
              function Pe(nt, j) {
                return nt instanceof j || nt != null && nt.constructor != null && nt.constructor.name != null && nt.constructor.name === j.name;
              }
              function Be(nt) {
                return nt !== nt;
              }
              var De = function() {
                for (var nt = "0123456789abcdef", j = new Array(256), V = 0; V < 16; ++V)
                  for (var yt = V * 16, it = 0; it < 16; ++it)
                    j[yt + it] = nt[V] + nt[it];
                return j;
              }();
              function It(nt) {
                return typeof BigInt > "u" ? he : nt;
              }
              function he() {
                throw new Error("BigInt not supported");
              }
            }
          ),
          /***/
          38719: (
            /***/
            function(u, l, e) {
              e(10720), e(14032), u.exports = typeof ArrayBuffer < "u" && typeof DataView < "u";
            }
          ),
          /***/
          36597: (
            /***/
            function(u, l, e) {
              var s = e(38719), i = e(15567), f = e(32010), h = e(94578), v = e(24517), p = e(20340), m = e(52564), x = e(68664), g = e(48914), S = e(13711), y = e(95892).f, b = e(70176), n = e(69548), w = e(3840), E = e(38688), A = e(46859), O = f.Int8Array, C = O && O.prototype, T = f.Uint8ClampedArray, P = T && T.prototype, I = O && n(O), F = C && n(C), B = Object.prototype, M = f.TypeError, z = E("toStringTag"), L = A("TYPED_ARRAY_TAG"), J = A("TYPED_ARRAY_CONSTRUCTOR"), ft = s && !!w && m(f.opera) !== "Opera", Q = !1, xt, St, Pt, Gt = {
                Int8Array: 1,
                Uint8Array: 1,
                Uint8ClampedArray: 1,
                Int16Array: 2,
                Uint16Array: 2,
                Int32Array: 4,
                Uint32Array: 4,
                Float32Array: 4,
                Float64Array: 8
              }, Rt = {
                BigInt64Array: 8,
                BigUint64Array: 8
              }, bt = function(Ft) {
                if (!v(Ft))
                  return !1;
                var zt = m(Ft);
                return zt === "DataView" || p(Gt, zt) || p(Rt, zt);
              }, Dt = function(Ft) {
                if (!v(Ft))
                  return !1;
                var zt = m(Ft);
                return p(Gt, zt) || p(Rt, zt);
              }, X = function(Ft) {
                if (Dt(Ft))
                  return Ft;
                throw M("Target is not a typed array");
              }, gt = function(Ft) {
                if (h(Ft) && (!w || b(I, Ft)))
                  return Ft;
                throw M(x(Ft) + " is not a typed array constructor");
              }, st = function(Ft, zt, G) {
                if (i) {
                  if (G)
                    for (var D in Gt) {
                      var Z = f[D];
                      if (Z && p(Z.prototype, Ft))
                        try {
                          delete Z.prototype[Ft];
                        } catch {
                        }
                    }
                  (!F[Ft] || G) && S(F, Ft, G ? zt : ft && C[Ft] || zt);
                }
              }, rt = function(Ft, zt, G) {
                var D, Z;
                if (i) {
                  if (w) {
                    if (G) {
                      for (D in Gt)
                        if (Z = f[D], Z && p(Z, Ft))
                          try {
                            delete Z[Ft];
                          } catch {
                          }
                    }
                    if (!I[Ft] || G)
                      try {
                        return S(I, Ft, G ? zt : ft && I[Ft] || zt);
                      } catch {
                      }
                    else
                      return;
                  }
                  for (D in Gt)
                    Z = f[D], Z && (!Z[Ft] || G) && S(Z, Ft, zt);
                }
              };
              for (xt in Gt)
                St = f[xt], Pt = St && St.prototype, Pt ? g(Pt, J, St) : ft = !1;
              for (xt in Rt)
                St = f[xt], Pt = St && St.prototype, Pt && g(Pt, J, St);
              if ((!ft || !h(I) || I === Function.prototype) && (I = function() {
                throw M("Incorrect invocation");
              }, ft))
                for (xt in Gt)
                  f[xt] && w(f[xt], I);
              if ((!ft || !F || F === B) && (F = I.prototype, ft))
                for (xt in Gt)
                  f[xt] && w(f[xt].prototype, F);
              if (ft && n(P) !== F && w(P, F), i && !p(F, z)) {
                Q = !0, y(F, z, {
                  get: function() {
                    return v(this) ? this[L] : void 0;
                  }
                });
                for (xt in Gt)
                  f[xt] && g(f[xt], L, xt);
              }
              u.exports = {
                NATIVE_ARRAY_BUFFER_VIEWS: ft,
                TYPED_ARRAY_CONSTRUCTOR: J,
                TYPED_ARRAY_TAG: Q && L,
                aTypedArray: X,
                aTypedArrayConstructor: gt,
                exportTypedArrayMethod: st,
                exportTypedArrayStaticMethod: rt,
                isView: bt,
                isTypedArray: Dt,
                TypedArray: I,
                TypedArrayPrototype: F
              };
            }
          ),
          /***/
          89987: (
            /***/
            function(u, l, e) {
              e(24863);
              var s = e(32010), i = e(38347), f = e(15567), h = e(38719), v = e(7081), p = e(48914), m = e(15341), x = e(47044), g = e(2868), S = e(26882), y = e(23417), b = e(71265), n = e(64397), w = e(69548), E = e(3840), A = e(6611).f, O = e(95892).f, C = e(72864), T = e(73163), P = e(15216), I = e(70172), F = v.PROPER, B = v.CONFIGURABLE, M = I.get, z = I.set, L = "ArrayBuffer", J = "DataView", ft = "prototype", Q = "Wrong length", xt = "Wrong index", St = s[L], Pt = St, Gt = Pt && Pt[ft], Rt = s[J], bt = Rt && Rt[ft], Dt = Object.prototype, X = s.Array, gt = s.RangeError, st = i(C), rt = i([].reverse), wt = n.pack, Ft = n.unpack, zt = function(xe) {
                return [xe & 255];
              }, G = function(xe) {
                return [xe & 255, xe >> 8 & 255];
              }, D = function(xe) {
                return [xe & 255, xe >> 8 & 255, xe >> 16 & 255, xe >> 24 & 255];
              }, Z = function(xe) {
                return xe[3] << 24 | xe[2] << 16 | xe[1] << 8 | xe[0];
              }, et = function(xe) {
                return wt(xe, 23, 4);
              }, vt = function(xe) {
                return wt(xe, 52, 8);
              }, lt = function(xe, Fe) {
                O(xe[ft], Fe, {
                  get: function() {
                    return M(this)[Fe];
                  }
                });
              }, dt = function(xe, Fe, Zt, qt) {
                var ve = b(Zt), Se = M(xe);
                if (ve + Fe > Se.byteLength)
                  throw gt(xt);
                var Pe = M(Se.buffer).bytes, Be = ve + Se.byteOffset, De = T(Pe, Be, Be + Fe);
                return qt ? De : rt(De);
              }, kt = function(xe, Fe, Zt, qt, ve, Se) {
                var Pe = b(Zt), Be = M(xe);
                if (Pe + Fe > Be.byteLength)
                  throw gt(xt);
                for (var De = M(Be.buffer).bytes, It = Pe + Be.byteOffset, he = qt(+ve), nt = 0; nt < Fe; nt++)
                  De[It + nt] = he[Se ? nt : Fe - nt - 1];
              };
              if (!h)
                Pt = function(xe) {
                  g(this, Gt);
                  var Fe = b(xe);
                  z(this, {
                    bytes: st(X(Fe), 0),
                    byteLength: Fe
                  }), f || (this.byteLength = Fe);
                }, Gt = Pt[ft], Rt = function(xe, Fe, Zt) {
                  g(this, bt), g(xe, Gt);
                  var qt = M(xe).byteLength, ve = S(Fe);
                  if (ve < 0 || ve > qt)
                    throw gt("Wrong offset");
                  if (Zt = Zt === void 0 ? qt - ve : y(Zt), ve + Zt > qt)
                    throw gt(Q);
                  z(this, {
                    buffer: xe,
                    byteLength: Zt,
                    byteOffset: ve
                  }), f || (this.buffer = xe, this.byteLength = Zt, this.byteOffset = ve);
                }, bt = Rt[ft], f && (lt(Pt, "byteLength"), lt(Rt, "buffer"), lt(Rt, "byteLength"), lt(Rt, "byteOffset")), m(bt, {
                  getInt8: function(xe) {
                    return dt(this, 1, xe)[0] << 24 >> 24;
                  },
                  getUint8: function(xe) {
                    return dt(this, 1, xe)[0];
                  },
                  getInt16: function(xe) {
                    var Fe = dt(this, 2, xe, arguments.length > 1 ? arguments[1] : void 0);
                    return (Fe[1] << 8 | Fe[0]) << 16 >> 16;
                  },
                  getUint16: function(xe) {
                    var Fe = dt(this, 2, xe, arguments.length > 1 ? arguments[1] : void 0);
                    return Fe[1] << 8 | Fe[0];
                  },
                  getInt32: function(xe) {
                    return Z(dt(this, 4, xe, arguments.length > 1 ? arguments[1] : void 0));
                  },
                  getUint32: function(xe) {
                    return Z(dt(this, 4, xe, arguments.length > 1 ? arguments[1] : void 0)) >>> 0;
                  },
                  getFloat32: function(xe) {
                    return Ft(dt(this, 4, xe, arguments.length > 1 ? arguments[1] : void 0), 23);
                  },
                  getFloat64: function(xe) {
                    return Ft(dt(this, 8, xe, arguments.length > 1 ? arguments[1] : void 0), 52);
                  },
                  setInt8: function(xe, Fe) {
                    kt(this, 1, xe, zt, Fe);
                  },
                  setUint8: function(xe, Fe) {
                    kt(this, 1, xe, zt, Fe);
                  },
                  setInt16: function(xe, Fe) {
                    kt(this, 2, xe, G, Fe, arguments.length > 2 ? arguments[2] : void 0);
                  },
                  setUint16: function(xe, Fe) {
                    kt(this, 2, xe, G, Fe, arguments.length > 2 ? arguments[2] : void 0);
                  },
                  setInt32: function(xe, Fe) {
                    kt(this, 4, xe, D, Fe, arguments.length > 2 ? arguments[2] : void 0);
                  },
                  setUint32: function(xe, Fe) {
                    kt(this, 4, xe, D, Fe, arguments.length > 2 ? arguments[2] : void 0);
                  },
                  setFloat32: function(xe, Fe) {
                    kt(this, 4, xe, et, Fe, arguments.length > 2 ? arguments[2] : void 0);
                  },
                  setFloat64: function(xe, Fe) {
                    kt(this, 8, xe, vt, Fe, arguments.length > 2 ? arguments[2] : void 0);
                  }
                });
              else {
                var jt = F && St.name !== L;
                if (!x(function() {
                  St(1);
                }) || !x(function() {
                  new St(-1);
                }) || x(function() {
                  return new St(), new St(1.5), new St(NaN), jt && !B;
                })) {
                  Pt = function(xe) {
                    return g(this, Gt), new St(b(xe));
                  }, Pt[ft] = Gt;
                  for (var me = A(St), se = 0, Bt; me.length > se; )
                    (Bt = me[se++]) in Pt || p(Pt, Bt, St[Bt]);
                  Gt.constructor = Pt;
                } else
                  jt && B && p(St, "name", L);
                E && w(bt) !== Dt && E(bt, Dt);
                var ge = new Rt(new Pt(2)), Re = i(bt.setInt8);
                ge.setInt8(0, 2147483648), ge.setInt8(1, 2147483649), (ge.getInt8(0) || !ge.getInt8(1)) && m(bt, {
                  setInt8: function(xe, Fe) {
                    Re(this, xe, Fe << 24 >> 24);
                  },
                  setUint8: function(xe, Fe) {
                    Re(this, xe, Fe << 24 >> 24);
                  }
                }, {
                  unsafe: !0
                });
              }
              P(Pt, L), P(Rt, J), u.exports = {
                ArrayBuffer: Pt,
                DataView: Rt
              };
            }
          ),
          /***/
          10720: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(32010), f = e(89987), h = e(51334), v = "ArrayBuffer", p = f[v], m = i[v];
              s({
                global: !0,
                forced: m !== p
              }, {
                ArrayBuffer: p
              }), h(v);
            }
          ),
          /***/
          6993: (
            /***/
            function(u, l, e) {
              (function(s, i, f) {
                u.exports = i(e(34559), e(49300), e(72342), e(36572), e(28395));
              })(void 0, function(s) {
                return function() {
                  var i = s, f = i.lib, h = f.BlockCipher, v = i.algo, p = [], m = [], x = [], g = [], S = [], y = [], b = [], n = [], w = [], E = [];
                  (function() {
                    for (var C = [], T = 0; T < 256; T++)
                      T < 128 ? C[T] = T << 1 : C[T] = T << 1 ^ 283;
                    for (var P = 0, I = 0, T = 0; T < 256; T++) {
                      var F = I ^ I << 1 ^ I << 2 ^ I << 3 ^ I << 4;
                      F = F >>> 8 ^ F & 255 ^ 99, p[P] = F, m[F] = P;
                      var B = C[P], M = C[B], z = C[M], L = C[F] * 257 ^ F * 16843008;
                      x[P] = L << 24 | L >>> 8, g[P] = L << 16 | L >>> 16, S[P] = L << 8 | L >>> 24, y[P] = L;
                      var L = z * 16843009 ^ M * 65537 ^ B * 257 ^ P * 16843008;
                      b[F] = L << 24 | L >>> 8, n[F] = L << 16 | L >>> 16, w[F] = L << 8 | L >>> 24, E[F] = L, P ? (P = B ^ C[C[C[z ^ B]]], I ^= C[C[I]]) : P = I = 1;
                    }
                  })();
                  var A = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], O = v.AES = h.extend({
                    _doReset: function() {
                      var T;
                      if (!(this._nRounds && this._keyPriorReset === this._key)) {
                        for (var P = this._keyPriorReset = this._key, I = P.words, F = P.sigBytes / 4, B = this._nRounds = F + 6, M = (B + 1) * 4, z = this._keySchedule = [], L = 0; L < M; L++)
                          L < F ? z[L] = I[L] : (T = z[L - 1], L % F ? F > 6 && L % F == 4 && (T = p[T >>> 24] << 24 | p[T >>> 16 & 255] << 16 | p[T >>> 8 & 255] << 8 | p[T & 255]) : (T = T << 8 | T >>> 24, T = p[T >>> 24] << 24 | p[T >>> 16 & 255] << 16 | p[T >>> 8 & 255] << 8 | p[T & 255], T ^= A[L / F | 0] << 24), z[L] = z[L - F] ^ T);
                        for (var J = this._invKeySchedule = [], ft = 0; ft < M; ft++) {
                          var L = M - ft;
                          if (ft % 4)
                            var T = z[L];
                          else
                            var T = z[L - 4];
                          ft < 4 || L <= 4 ? J[ft] = T : J[ft] = b[p[T >>> 24]] ^ n[p[T >>> 16 & 255]] ^ w[p[T >>> 8 & 255]] ^ E[p[T & 255]];
                        }
                      }
                    },
                    encryptBlock: function(T, P) {
                      this._doCryptBlock(T, P, this._keySchedule, x, g, S, y, p);
                    },
                    decryptBlock: function(T, P) {
                      var I = T[P + 1];
                      T[P + 1] = T[P + 3], T[P + 3] = I, this._doCryptBlock(T, P, this._invKeySchedule, b, n, w, E, m);
                      var I = T[P + 1];
                      T[P + 1] = T[P + 3], T[P + 3] = I;
                    },
                    _doCryptBlock: function(T, P, I, F, B, M, z, L) {
                      for (var J = this._nRounds, ft = T[P] ^ I[0], Q = T[P + 1] ^ I[1], xt = T[P + 2] ^ I[2], St = T[P + 3] ^ I[3], Pt = 4, Gt = 1; Gt < J; Gt++) {
                        var Rt = F[ft >>> 24] ^ B[Q >>> 16 & 255] ^ M[xt >>> 8 & 255] ^ z[St & 255] ^ I[Pt++], bt = F[Q >>> 24] ^ B[xt >>> 16 & 255] ^ M[St >>> 8 & 255] ^ z[ft & 255] ^ I[Pt++], Dt = F[xt >>> 24] ^ B[St >>> 16 & 255] ^ M[ft >>> 8 & 255] ^ z[Q & 255] ^ I[Pt++], X = F[St >>> 24] ^ B[ft >>> 16 & 255] ^ M[Q >>> 8 & 255] ^ z[xt & 255] ^ I[Pt++];
                        ft = Rt, Q = bt, xt = Dt, St = X;
                      }
                      var Rt = (L[ft >>> 24] << 24 | L[Q >>> 16 & 255] << 16 | L[xt >>> 8 & 255] << 8 | L[St & 255]) ^ I[Pt++], bt = (L[Q >>> 24] << 24 | L[xt >>> 16 & 255] << 16 | L[St >>> 8 & 255] << 8 | L[ft & 255]) ^ I[Pt++], Dt = (L[xt >>> 24] << 24 | L[St >>> 16 & 255] << 16 | L[ft >>> 8 & 255] << 8 | L[Q & 255]) ^ I[Pt++], X = (L[St >>> 24] << 24 | L[ft >>> 16 & 255] << 16 | L[Q >>> 8 & 255] << 8 | L[xt & 255]) ^ I[Pt++];
                      T[P] = Rt, T[P + 1] = bt, T[P + 2] = Dt, T[P + 3] = X;
                    },
                    keySize: 256 / 32
                  });
                  i.AES = h._createHelper(O);
                }(), s.AES;
              });
            }
          ),
          /***/
          83122: (
            /***/
            function(u, l, e) {
              (function(s, i, f) {
                u.exports = i(e(34559), e(49300), e(72342), e(36572), e(28395));
              })(void 0, function(s) {
                return function() {
                  var i = s, f = i.lib, h = f.BlockCipher, v = i.algo, p = 16, m = [608135816, 2242054355, 320440878, 57701188, 2752067618, 698298832, 137296536, 3964562569, 1160258022, 953160567, 3193202383, 887688300, 3232508343, 3380367581, 1065670069, 3041331479, 2450970073, 2306472731], x = [[3509652390, 2564797868, 805139163, 3491422135, 3101798381, 1780907670, 3128725573, 4046225305, 614570311, 3012652279, 134345442, 2240740374, 1667834072, 1901547113, 2757295779, 4103290238, 227898511, 1921955416, 1904987480, 2182433518, 2069144605, 3260701109, 2620446009, 720527379, 3318853667, 677414384, 3393288472, 3101374703, 2390351024, 1614419982, 1822297739, 2954791486, 3608508353, 3174124327, 2024746970, 1432378464, 3864339955, 2857741204, 1464375394, 1676153920, 1439316330, 715854006, 3033291828, 289532110, 2706671279, 2087905683, 3018724369, 1668267050, 732546397, 1947742710, 3462151702, 2609353502, 2950085171, 1814351708, 2050118529, 680887927, 999245976, 1800124847, 3300911131, 1713906067, 1641548236, 4213287313, 1216130144, 1575780402, 4018429277, 3917837745, 3693486850, 3949271944, 596196993, 3549867205, 258830323, 2213823033, 772490370, 2760122372, 1774776394, 2652871518, 566650946, 4142492826, 1728879713, 2882767088, 1783734482, 3629395816, 2517608232, 2874225571, 1861159788, 326777828, 3124490320, 2130389656, 2716951837, 967770486, 1724537150, 2185432712, 2364442137, 1164943284, 2105845187, 998989502, 3765401048, 2244026483, 1075463327, 1455516326, 1322494562, 910128902, 469688178, 1117454909, 936433444, 3490320968, 3675253459, 1240580251, 122909385, 2157517691, 634681816, 4142456567, 3825094682, 3061402683, 2540495037, 79693498, 3249098678, 1084186820, 1583128258, 426386531, 1761308591, 1047286709, 322548459, 995290223, 1845252383, 2603652396, 3431023940, 2942221577, 3202600964, 3727903485, 1712269319, 422464435, 3234572375, 1170764815, 3523960633, 3117677531, 1434042557, 442511882, 3600875718, 1076654713, 1738483198, 4213154764, 2393238008, 3677496056, 1014306527, 4251020053, 793779912, 2902807211, 842905082, 4246964064, 1395751752, 1040244610, 2656851899, 3396308128, 445077038, 3742853595, 3577915638, 679411651, 2892444358, 2354009459, 1767581616, 3150600392, 3791627101, 3102740896, 284835224, 4246832056, 1258075500, 768725851, 2589189241, 3069724005, 3532540348, 1274779536, 3789419226, 2764799539, 1660621633, 3471099624, 4011903706, 913787905, 3497959166, 737222580, 2514213453, 2928710040, 3937242737, 1804850592, 3499020752, 2949064160, 2386320175, 2390070455, 2415321851, 4061277028, 2290661394, 2416832540, 1336762016, 1754252060, 3520065937, 3014181293, 791618072, 3188594551, 3933548030, 2332172193, 3852520463, 3043980520, 413987798, 3465142937, 3030929376, 4245938359, 2093235073, 3534596313, 375366246, 2157278981, 2479649556, 555357303, 3870105701, 2008414854, 3344188149, 4221384143, 3956125452, 2067696032, 3594591187, 2921233993, 2428461, 544322398, 577241275, 1471733935, 610547355, 4027169054, 1432588573, 1507829418, 2025931657, 3646575487, 545086370, 48609733, 2200306550, 1653985193, 298326376, 1316178497, 3007786442, 2064951626, 458293330, 2589141269, 3591329599, 3164325604, 727753846, 2179363840, 146436021, 1461446943, 4069977195, 705550613, 3059967265, 3887724982, 4281599278, 3313849956, 1404054877, 2845806497, 146425753, 1854211946], [1266315497, 3048417604, 3681880366, 3289982499, 290971e4, 1235738493, 2632868024, 2414719590, 3970600049, 1771706367, 1449415276, 3266420449, 422970021, 1963543593, 2690192192, 3826793022, 1062508698, 1531092325, 1804592342, 2583117782, 2714934279, 4024971509, 1294809318, 4028980673, 1289560198, 2221992742, 1669523910, 35572830, 157838143, 1052438473, 1016535060, 1802137761, 1753167236, 1386275462, 3080475397, 2857371447, 1040679964, 2145300060, 2390574316, 1461121720, 2956646967, 4031777805, 4028374788, 33600511, 2920084762, 1018524850, 629373528, 3691585981, 3515945977, 2091462646, 2486323059, 586499841, 988145025, 935516892, 3367335476, 2599673255, 2839830854, 265290510, 3972581182, 2759138881, 3795373465, 1005194799, 847297441, 406762289, 1314163512, 1332590856, 1866599683, 4127851711, 750260880, 613907577, 1450815602, 3165620655, 3734664991, 3650291728, 3012275730, 3704569646, 1427272223, 778793252, 1343938022, 2676280711, 2052605720, 1946737175, 3164576444, 3914038668, 3967478842, 3682934266, 1661551462, 3294938066, 4011595847, 840292616, 3712170807, 616741398, 312560963, 711312465, 1351876610, 322626781, 1910503582, 271666773, 2175563734, 1594956187, 70604529, 3617834859, 1007753275, 1495573769, 4069517037, 2549218298, 2663038764, 504708206, 2263041392, 3941167025, 2249088522, 1514023603, 1998579484, 1312622330, 694541497, 2582060303, 2151582166, 1382467621, 776784248, 2618340202, 3323268794, 2497899128, 2784771155, 503983604, 4076293799, 907881277, 423175695, 432175456, 1378068232, 4145222326, 3954048622, 3938656102, 3820766613, 2793130115, 2977904593, 26017576, 3274890735, 3194772133, 1700274565, 1756076034, 4006520079, 3677328699, 720338349, 1533947780, 354530856, 688349552, 3973924725, 1637815568, 332179504, 3949051286, 53804574, 2852348879, 3044236432, 1282449977, 3583942155, 3416972820, 4006381244, 1617046695, 2628476075, 3002303598, 1686838959, 431878346, 2686675385, 1700445008, 1080580658, 1009431731, 832498133, 3223435511, 2605976345, 2271191193, 2516031870, 1648197032, 4164389018, 2548247927, 300782431, 375919233, 238389289, 3353747414, 2531188641, 2019080857, 1475708069, 455242339, 2609103871, 448939670, 3451063019, 1395535956, 2413381860, 1841049896, 1491858159, 885456874, 4264095073, 4001119347, 1565136089, 3898914787, 1108368660, 540939232, 1173283510, 2745871338, 3681308437, 4207628240, 3343053890, 4016749493, 1699691293, 1103962373, 3625875870, 2256883143, 3830138730, 1031889488, 3479347698, 1535977030, 4236805024, 3251091107, 2132092099, 1774941330, 1199868427, 1452454533, 157007616, 2904115357, 342012276, 595725824, 1480756522, 206960106, 497939518, 591360097, 863170706, 2375253569, 3596610801, 1814182875, 2094937945, 3421402208, 1082520231, 3463918190, 2785509508, 435703966, 3908032597, 1641649973, 2842273706, 3305899714, 1510255612, 2148256476, 2655287854, 3276092548, 4258621189, 236887753, 3681803219, 274041037, 1734335097, 3815195456, 3317970021, 1899903192, 1026095262, 4050517792, 356393447, 2410691914, 3873677099, 3682840055], [3913112168, 2491498743, 4132185628, 2489919796, 1091903735, 1979897079, 3170134830, 3567386728, 3557303409, 857797738, 1136121015, 1342202287, 507115054, 2535736646, 337727348, 3213592640, 1301675037, 2528481711, 1895095763, 1721773893, 3216771564, 62756741, 2142006736, 835421444, 2531993523, 1442658625, 3659876326, 2882144922, 676362277, 1392781812, 170690266, 3921047035, 1759253602, 3611846912, 1745797284, 664899054, 1329594018, 3901205900, 3045908486, 2062866102, 2865634940, 3543621612, 3464012697, 1080764994, 553557557, 3656615353, 3996768171, 991055499, 499776247, 1265440854, 648242737, 3940784050, 980351604, 3713745714, 1749149687, 3396870395, 4211799374, 3640570775, 1161844396, 3125318951, 1431517754, 545492359, 4268468663, 3499529547, 1437099964, 2702547544, 3433638243, 2581715763, 2787789398, 1060185593, 1593081372, 2418618748, 4260947970, 69676912, 2159744348, 86519011, 2512459080, 3838209314, 1220612927, 3339683548, 133810670, 1090789135, 1078426020, 1569222167, 845107691, 3583754449, 4072456591, 1091646820, 628848692, 1613405280, 3757631651, 526609435, 236106946, 48312990, 2942717905, 3402727701, 1797494240, 859738849, 992217954, 4005476642, 2243076622, 3870952857, 3732016268, 765654824, 3490871365, 2511836413, 1685915746, 3888969200, 1414112111, 2273134842, 3281911079, 4080962846, 172450625, 2569994100, 980381355, 4109958455, 2819808352, 2716589560, 2568741196, 3681446669, 3329971472, 1835478071, 660984891, 3704678404, 4045999559, 3422617507, 3040415634, 1762651403, 1719377915, 3470491036, 2693910283, 3642056355, 3138596744, 1364962596, 2073328063, 1983633131, 926494387, 3423689081, 2150032023, 4096667949, 1749200295, 3328846651, 309677260, 2016342300, 1779581495, 3079819751, 111262694, 1274766160, 443224088, 298511866, 1025883608, 3806446537, 1145181785, 168956806, 3641502830, 3584813610, 1689216846, 3666258015, 3200248200, 1692713982, 2646376535, 4042768518, 1618508792, 1610833997, 3523052358, 4130873264, 2001055236, 3610705100, 2202168115, 4028541809, 2961195399, 1006657119, 2006996926, 3186142756, 1430667929, 3210227297, 1314452623, 4074634658, 4101304120, 2273951170, 1399257539, 3367210612, 3027628629, 1190975929, 2062231137, 2333990788, 2221543033, 2438960610, 1181637006, 548689776, 2362791313, 3372408396, 3104550113, 3145860560, 296247880, 1970579870, 3078560182, 3769228297, 1714227617, 3291629107, 3898220290, 166772364, 1251581989, 493813264, 448347421, 195405023, 2709975567, 677966185, 3703036547, 1463355134, 2715995803, 1338867538, 1343315457, 2802222074, 2684532164, 233230375, 2599980071, 2000651841, 3277868038, 1638401717, 4028070440, 3237316320, 6314154, 819756386, 300326615, 590932579, 1405279636, 3267499572, 3150704214, 2428286686, 3959192993, 3461946742, 1862657033, 1266418056, 963775037, 2089974820, 2263052895, 1917689273, 448879540, 3550394620, 3981727096, 150775221, 3627908307, 1303187396, 508620638, 2975983352, 2726630617, 1817252668, 1876281319, 1457606340, 908771278, 3720792119, 3617206836, 2455994898, 1729034894, 1080033504], [976866871, 3556439503, 2881648439, 1522871579, 1555064734, 1336096578, 3548522304, 2579274686, 3574697629, 3205460757, 3593280638, 3338716283, 3079412587, 564236357, 2993598910, 1781952180, 1464380207, 3163844217, 3332601554, 1699332808, 1393555694, 1183702653, 3581086237, 1288719814, 691649499, 2847557200, 2895455976, 3193889540, 2717570544, 1781354906, 1676643554, 2592534050, 3230253752, 1126444790, 2770207658, 2633158820, 2210423226, 2615765581, 2414155088, 3127139286, 673620729, 2805611233, 1269405062, 4015350505, 3341807571, 4149409754, 1057255273, 2012875353, 2162469141, 2276492801, 2601117357, 993977747, 3918593370, 2654263191, 753973209, 36408145, 2530585658, 25011837, 3520020182, 2088578344, 530523599, 2918365339, 1524020338, 1518925132, 3760827505, 3759777254, 1202760957, 3985898139, 3906192525, 674977740, 4174734889, 2031300136, 2019492241, 3983892565, 4153806404, 3822280332, 352677332, 2297720250, 60907813, 90501309, 3286998549, 1016092578, 2535922412, 2839152426, 457141659, 509813237, 4120667899, 652014361, 1966332200, 2975202805, 55981186, 2327461051, 676427537, 3255491064, 2882294119, 3433927263, 1307055953, 942726286, 933058658, 2468411793, 3933900994, 4215176142, 1361170020, 2001714738, 2830558078, 3274259782, 1222529897, 1679025792, 2729314320, 3714953764, 1770335741, 151462246, 3013232138, 1682292957, 1483529935, 471910574, 1539241949, 458788160, 3436315007, 1807016891, 3718408830, 978976581, 1043663428, 3165965781, 1927990952, 4200891579, 2372276910, 3208408903, 3533431907, 1412390302, 2931980059, 4132332400, 1947078029, 3881505623, 4168226417, 2941484381, 1077988104, 1320477388, 886195818, 18198404, 3786409e3, 2509781533, 112762804, 3463356488, 1866414978, 891333506, 18488651, 661792760, 1628790961, 3885187036, 3141171499, 876946877, 2693282273, 1372485963, 791857591, 2686433993, 3759982718, 3167212022, 3472953795, 2716379847, 445679433, 3561995674, 3504004811, 3574258232, 54117162, 3331405415, 2381918588, 3769707343, 4154350007, 1140177722, 4074052095, 668550556, 3214352940, 367459370, 261225585, 2610173221, 4209349473, 3468074219, 3265815641, 314222801, 3066103646, 3808782860, 282218597, 3406013506, 3773591054, 379116347, 1285071038, 846784868, 2669647154, 3771962079, 3550491691, 2305946142, 453669953, 1268987020, 3317592352, 3279303384, 3744833421, 2610507566, 3859509063, 266596637, 3847019092, 517658769, 3462560207, 3443424879, 370717030, 4247526661, 2224018117, 4143653529, 4112773975, 2788324899, 2477274417, 1456262402, 2901442914, 1517677493, 1846949527, 2295493580, 3734397586, 2176403920, 1280348187, 1908823572, 3871786941, 846861322, 1172426758, 3287448474, 3383383037, 1655181056, 3139813346, 901632758, 1897031941, 2986607138, 3066810236, 3447102507, 1393639104, 373351379, 950779232, 625454576, 3124240540, 4148612726, 2007998917, 544563296, 2244738638, 2330496472, 2058025392, 1291430526, 424198748, 50039436, 29584100, 3605783033, 2429876329, 2791104160, 1057563949, 3255363231, 3075367218, 3463963227, 1469046755, 985887462]], g = {
                    pbox: [],
                    sbox: []
                  };
                  function S(E, A) {
                    var O = A >> 24 & 255, C = A >> 16 & 255, T = A >> 8 & 255, P = A & 255, I = E.sbox[0][O] + E.sbox[1][C];
                    return I = I ^ E.sbox[2][T], I = I + E.sbox[3][P], I;
                  }
                  function y(E, A, O) {
                    for (var C = A, T = O, P, I = 0; I < p; ++I)
                      C = C ^ E.pbox[I], T = S(E, C) ^ T, P = C, C = T, T = P;
                    return P = C, C = T, T = P, T = T ^ E.pbox[p], C = C ^ E.pbox[p + 1], {
                      left: C,
                      right: T
                    };
                  }
                  function b(E, A, O) {
                    for (var C = A, T = O, P, I = p + 1; I > 1; --I)
                      C = C ^ E.pbox[I], T = S(E, C) ^ T, P = C, C = T, T = P;
                    return P = C, C = T, T = P, T = T ^ E.pbox[1], C = C ^ E.pbox[0], {
                      left: C,
                      right: T
                    };
                  }
                  function n(E, A, O) {
                    for (var C = 0; C < 4; C++) {
                      E.sbox[C] = [];
                      for (var T = 0; T < 256; T++)
                        E.sbox[C][T] = x[C][T];
                    }
                    for (var P = 0, I = 0; I < p + 2; I++)
                      E.pbox[I] = m[I] ^ A[P], P++, P >= O && (P = 0);
                    for (var F = 0, B = 0, M = 0, z = 0; z < p + 2; z += 2)
                      M = y(E, F, B), F = M.left, B = M.right, E.pbox[z] = F, E.pbox[z + 1] = B;
                    for (var L = 0; L < 4; L++)
                      for (var J = 0; J < 256; J += 2)
                        M = y(E, F, B), F = M.left, B = M.right, E.sbox[L][J] = F, E.sbox[L][J + 1] = B;
                    return !0;
                  }
                  var w = v.Blowfish = h.extend({
                    _doReset: function() {
                      if (this._keyPriorReset !== this._key) {
                        var A = this._keyPriorReset = this._key, O = A.words, C = A.sigBytes / 4;
                        n(g, O, C);
                      }
                    },
                    encryptBlock: function(A, O) {
                      var C = y(g, A[O], A[O + 1]);
                      A[O] = C.left, A[O + 1] = C.right;
                    },
                    decryptBlock: function(A, O) {
                      var C = b(g, A[O], A[O + 1]);
                      A[O] = C.left, A[O + 1] = C.right;
                    },
                    blockSize: 64 / 32,
                    keySize: 128 / 32,
                    ivSize: 64 / 32
                  });
                  i.Blowfish = h._createHelper(w);
                }(), s.Blowfish;
              });
            }
          ),
          /***/
          28395: (
            /***/
            function(u, l, e) {
              e(39081), e(20731), e(23913), e(14032), e(57114), function(s, i, f) {
                u.exports = i(e(34559), e(36572));
              }(void 0, function(s) {
                s.lib.Cipher || function(i) {
                  var f = s, h = f.lib, v = h.Base, p = h.WordArray, m = h.BufferedBlockAlgorithm, x = f.enc;
                  x.Utf8;
                  var g = x.Base64, S = f.algo, y = S.EvpKDF, b = h.Cipher = m.extend({
                    /**
                     * Configuration options.
                     *
                     * @property {WordArray} iv The IV to use for this operation.
                     */
                    cfg: v.extend(),
                    /**
                     * Creates this cipher in encryption mode.
                     *
                     * @param {WordArray} key The key.
                     * @param {Object} cfg (Optional) The configuration options to use for this operation.
                     *
                     * @return {Cipher} A cipher instance.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
                     */
                    createEncryptor: function(L, J) {
                      return this.create(this._ENC_XFORM_MODE, L, J);
                    },
                    /**
                     * Creates this cipher in decryption mode.
                     *
                     * @param {WordArray} key The key.
                     * @param {Object} cfg (Optional) The configuration options to use for this operation.
                     *
                     * @return {Cipher} A cipher instance.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
                     */
                    createDecryptor: function(L, J) {
                      return this.create(this._DEC_XFORM_MODE, L, J);
                    },
                    /**
                     * Initializes a newly created cipher.
                     *
                     * @param {number} xformMode Either the encryption or decryption transormation mode constant.
                     * @param {WordArray} key The key.
                     * @param {Object} cfg (Optional) The configuration options to use for this operation.
                     *
                     * @example
                     *
                     *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
                     */
                    init: function(L, J, ft) {
                      this.cfg = this.cfg.extend(ft), this._xformMode = L, this._key = J, this.reset();
                    },
                    /**
                     * Resets this cipher to its initial state.
                     *
                     * @example
                     *
                     *     cipher.reset();
                     */
                    reset: function() {
                      m.reset.call(this), this._doReset();
                    },
                    /**
                     * Adds data to be encrypted or decrypted.
                     *
                     * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
                     *
                     * @return {WordArray} The data after processing.
                     *
                     * @example
                     *
                     *     var encrypted = cipher.process('data');
                     *     var encrypted = cipher.process(wordArray);
                     */
                    process: function(L) {
                      return this._append(L), this._process();
                    },
                    /**
                     * Finalizes the encryption or decryption process.
                     * Note that the finalize operation is effectively a destructive, read-once operation.
                     *
                     * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
                     *
                     * @return {WordArray} The data after final processing.
                     *
                     * @example
                     *
                     *     var encrypted = cipher.finalize();
                     *     var encrypted = cipher.finalize('data');
                     *     var encrypted = cipher.finalize(wordArray);
                     */
                    finalize: function(L) {
                      L && this._append(L);
                      var J = this._doFinalize();
                      return J;
                    },
                    keySize: 128 / 32,
                    ivSize: 128 / 32,
                    _ENC_XFORM_MODE: 1,
                    _DEC_XFORM_MODE: 2,
                    /**
                     * Creates shortcut functions to a cipher's object interface.
                     *
                     * @param {Cipher} cipher The cipher to create a helper for.
                     *
                     * @return {Object} An object with encrypt and decrypt shortcut functions.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
                     */
                    _createHelper: function() {
                      function z(L) {
                        return typeof L == "string" ? M : I;
                      }
                      return function(L) {
                        return {
                          encrypt: function(ft, Q, xt) {
                            return z(Q).encrypt(L, ft, Q, xt);
                          },
                          decrypt: function(ft, Q, xt) {
                            return z(Q).decrypt(L, ft, Q, xt);
                          }
                        };
                      };
                    }()
                  });
                  h.StreamCipher = b.extend({
                    _doFinalize: function() {
                      var L = this._process(!0);
                      return L;
                    },
                    blockSize: 1
                  });
                  var n = f.mode = {}, w = h.BlockCipherMode = v.extend({
                    /**
                     * Creates this mode for encryption.
                     *
                     * @param {Cipher} cipher A block cipher instance.
                     * @param {Array} iv The IV words.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
                     */
                    createEncryptor: function(L, J) {
                      return this.Encryptor.create(L, J);
                    },
                    /**
                     * Creates this mode for decryption.
                     *
                     * @param {Cipher} cipher A block cipher instance.
                     * @param {Array} iv The IV words.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
                     */
                    createDecryptor: function(L, J) {
                      return this.Decryptor.create(L, J);
                    },
                    /**
                     * Initializes a newly created mode.
                     *
                     * @param {Cipher} cipher A block cipher instance.
                     * @param {Array} iv The IV words.
                     *
                     * @example
                     *
                     *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
                     */
                    init: function(L, J) {
                      this._cipher = L, this._iv = J;
                    }
                  }), E = n.CBC = function() {
                    var z = w.extend();
                    z.Encryptor = z.extend({
                      /**
                       * Processes the data block at offset.
                       *
                       * @param {Array} words The data words to operate on.
                       * @param {number} offset The offset where the block starts.
                       *
                       * @example
                       *
                       *     mode.processBlock(data.words, offset);
                       */
                      processBlock: function(ft, Q) {
                        var xt = this._cipher, St = xt.blockSize;
                        L.call(this, ft, Q, St), xt.encryptBlock(ft, Q), this._prevBlock = ft.slice(Q, Q + St);
                      }
                    }), z.Decryptor = z.extend({
                      /**
                       * Processes the data block at offset.
                       *
                       * @param {Array} words The data words to operate on.
                       * @param {number} offset The offset where the block starts.
                       *
                       * @example
                       *
                       *     mode.processBlock(data.words, offset);
                       */
                      processBlock: function(ft, Q) {
                        var xt = this._cipher, St = xt.blockSize, Pt = ft.slice(Q, Q + St);
                        xt.decryptBlock(ft, Q), L.call(this, ft, Q, St), this._prevBlock = Pt;
                      }
                    });
                    function L(J, ft, Q) {
                      var xt, St = this._iv;
                      St ? (xt = St, this._iv = i) : xt = this._prevBlock;
                      for (var Pt = 0; Pt < Q; Pt++)
                        J[ft + Pt] ^= xt[Pt];
                    }
                    return z;
                  }(), A = f.pad = {}, O = A.Pkcs7 = {
                    /**
                     * Pads data using the algorithm defined in PKCS #5/7.
                     *
                     * @param {WordArray} data The data to pad.
                     * @param {number} blockSize The multiple that the data should be padded to.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
                     */
                    pad: function(L, J) {
                      for (var ft = J * 4, Q = ft - L.sigBytes % ft, xt = Q << 24 | Q << 16 | Q << 8 | Q, St = [], Pt = 0; Pt < Q; Pt += 4)
                        St.push(xt);
                      var Gt = p.create(St, Q);
                      L.concat(Gt);
                    },
                    /**
                     * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
                     *
                     * @param {WordArray} data The data to unpad.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     CryptoJS.pad.Pkcs7.unpad(wordArray);
                     */
                    unpad: function(L) {
                      var J = L.words[L.sigBytes - 1 >>> 2] & 255;
                      L.sigBytes -= J;
                    }
                  };
                  h.BlockCipher = b.extend({
                    /**
                     * Configuration options.
                     *
                     * @property {Mode} mode The block mode to use. Default: CBC
                     * @property {Padding} padding The padding strategy to use. Default: Pkcs7
                     */
                    cfg: b.cfg.extend({
                      mode: E,
                      padding: O
                    }),
                    reset: function() {
                      var L;
                      b.reset.call(this);
                      var J = this.cfg, ft = J.iv, Q = J.mode;
                      this._xformMode == this._ENC_XFORM_MODE ? L = Q.createEncryptor : (L = Q.createDecryptor, this._minBufferSize = 1), this._mode && this._mode.__creator == L ? this._mode.init(this, ft && ft.words) : (this._mode = L.call(Q, this, ft && ft.words), this._mode.__creator = L);
                    },
                    _doProcessBlock: function(L, J) {
                      this._mode.processBlock(L, J);
                    },
                    _doFinalize: function() {
                      var L, J = this.cfg.padding;
                      return this._xformMode == this._ENC_XFORM_MODE ? (J.pad(this._data, this.blockSize), L = this._process(!0)) : (L = this._process(!0), J.unpad(L)), L;
                    },
                    blockSize: 4
                  });
                  var C = h.CipherParams = v.extend({
                    /**
                     * Initializes a newly created cipher params object.
                     *
                     * @param {Object} cipherParams An object with any of the possible cipher parameters.
                     *
                     * @example
                     *
                     *     var cipherParams = CryptoJS.lib.CipherParams.create({
                     *         ciphertext: ciphertextWordArray,
                     *         key: keyWordArray,
                     *         iv: ivWordArray,
                     *         salt: saltWordArray,
                     *         algorithm: CryptoJS.algo.AES,
                     *         mode: CryptoJS.mode.CBC,
                     *         padding: CryptoJS.pad.PKCS7,
                     *         blockSize: 4,
                     *         formatter: CryptoJS.format.OpenSSL
                     *     });
                     */
                    init: function(L) {
                      this.mixIn(L);
                    },
                    /**
                     * Converts this cipher params object to a string.
                     *
                     * @param {Format} formatter (Optional) The formatting strategy to use.
                     *
                     * @return {string} The stringified cipher params.
                     *
                     * @throws Error If neither the formatter nor the default formatter is set.
                     *
                     * @example
                     *
                     *     var string = cipherParams + '';
                     *     var string = cipherParams.toString();
                     *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
                     */
                    toString: function(L) {
                      return (L || this.formatter).stringify(this);
                    }
                  }), T = f.format = {}, P = T.OpenSSL = {
                    /**
                     * Converts a cipher params object to an OpenSSL-compatible string.
                     *
                     * @param {CipherParams} cipherParams The cipher params object.
                     *
                     * @return {string} The OpenSSL-compatible string.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
                     */
                    stringify: function(L) {
                      var J, ft = L.ciphertext, Q = L.salt;
                      return Q ? J = p.create([1398893684, 1701076831]).concat(Q).concat(ft) : J = ft, J.toString(g);
                    },
                    /**
                     * Converts an OpenSSL-compatible string to a cipher params object.
                     *
                     * @param {string} openSSLStr The OpenSSL-compatible string.
                     *
                     * @return {CipherParams} The cipher params object.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
                     */
                    parse: function(L) {
                      var J, ft = g.parse(L), Q = ft.words;
                      return Q[0] == 1398893684 && Q[1] == 1701076831 && (J = p.create(Q.slice(2, 4)), Q.splice(0, 4), ft.sigBytes -= 16), C.create({
                        ciphertext: ft,
                        salt: J
                      });
                    }
                  }, I = h.SerializableCipher = v.extend({
                    /**
                     * Configuration options.
                     *
                     * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
                     */
                    cfg: v.extend({
                      format: P
                    }),
                    /**
                     * Encrypts a message.
                     *
                     * @param {Cipher} cipher The cipher algorithm to use.
                     * @param {WordArray|string} message The message to encrypt.
                     * @param {WordArray} key The key.
                     * @param {Object} cfg (Optional) The configuration options to use for this operation.
                     *
                     * @return {CipherParams} A cipher params object.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
                     *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
                     *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
                     */
                    encrypt: function(L, J, ft, Q) {
                      Q = this.cfg.extend(Q);
                      var xt = L.createEncryptor(ft, Q), St = xt.finalize(J), Pt = xt.cfg;
                      return C.create({
                        ciphertext: St,
                        key: ft,
                        iv: Pt.iv,
                        algorithm: L,
                        mode: Pt.mode,
                        padding: Pt.padding,
                        blockSize: L.blockSize,
                        formatter: Q.format
                      });
                    },
                    /**
                     * Decrypts serialized ciphertext.
                     *
                     * @param {Cipher} cipher The cipher algorithm to use.
                     * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
                     * @param {WordArray} key The key.
                     * @param {Object} cfg (Optional) The configuration options to use for this operation.
                     *
                     * @return {WordArray} The plaintext.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
                     *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
                     */
                    decrypt: function(L, J, ft, Q) {
                      Q = this.cfg.extend(Q), J = this._parse(J, Q.format);
                      var xt = L.createDecryptor(ft, Q).finalize(J.ciphertext);
                      return xt;
                    },
                    /**
                     * Converts serialized ciphertext to CipherParams,
                     * else assumed CipherParams already and returns ciphertext unchanged.
                     *
                     * @param {CipherParams|string} ciphertext The ciphertext.
                     * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
                     *
                     * @return {CipherParams} The unserialized ciphertext.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
                     */
                    _parse: function(L, J) {
                      return typeof L == "string" ? J.parse(L, this) : L;
                    }
                  }), F = f.kdf = {}, B = F.OpenSSL = {
                    /**
                     * Derives a key and IV from a password.
                     *
                     * @param {string} password The password to derive from.
                     * @param {number} keySize The size in words of the key to generate.
                     * @param {number} ivSize The size in words of the IV to generate.
                     * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
                     *
                     * @return {CipherParams} A cipher params object with the key, IV, and salt.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
                     *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
                     */
                    execute: function(L, J, ft, Q, xt) {
                      if (Q || (Q = p.random(64 / 8)), xt)
                        var St = y.create({
                          keySize: J + ft,
                          hasher: xt
                        }).compute(L, Q);
                      else
                        var St = y.create({
                          keySize: J + ft
                        }).compute(L, Q);
                      var Pt = p.create(St.words.slice(J), ft * 4);
                      return St.sigBytes = J * 4, C.create({
                        key: St,
                        iv: Pt,
                        salt: Q
                      });
                    }
                  }, M = h.PasswordBasedCipher = I.extend({
                    /**
                     * Configuration options.
                     *
                     * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
                     */
                    cfg: I.cfg.extend({
                      kdf: B
                    }),
                    /**
                     * Encrypts a message using a password.
                     *
                     * @param {Cipher} cipher The cipher algorithm to use.
                     * @param {WordArray|string} message The message to encrypt.
                     * @param {string} password The password.
                     * @param {Object} cfg (Optional) The configuration options to use for this operation.
                     *
                     * @return {CipherParams} A cipher params object.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
                     *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
                     */
                    encrypt: function(L, J, ft, Q) {
                      Q = this.cfg.extend(Q);
                      var xt = Q.kdf.execute(ft, L.keySize, L.ivSize, Q.salt, Q.hasher);
                      Q.iv = xt.iv;
                      var St = I.encrypt.call(this, L, J, xt.key, Q);
                      return St.mixIn(xt), St;
                    },
                    /**
                     * Decrypts serialized ciphertext using a password.
                     *
                     * @param {Cipher} cipher The cipher algorithm to use.
                     * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
                     * @param {string} password The password.
                     * @param {Object} cfg (Optional) The configuration options to use for this operation.
                     *
                     * @return {WordArray} The plaintext.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
                     *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
                     */
                    decrypt: function(L, J, ft, Q) {
                      Q = this.cfg.extend(Q), J = this._parse(J, Q.format);
                      var xt = Q.kdf.execute(ft, L.keySize, L.ivSize, J.salt, Q.hasher);
                      Q.iv = xt.iv;
                      var St = I.decrypt.call(this, L, J, xt.key, Q);
                      return St;
                    }
                  });
                }();
              });
            }
          ),
          /***/
          34559: (
            /***/
            function(u, l, e) {
              e(39081), e(81755), e(94845), e(20731), e(23913), e(14032), e(57114), e(59735), e(73663), e(29883), e(35471), e(21012), e(88997), e(97464), e(2857), e(94715), e(13624), e(91132), e(62514), e(24597), e(88042), e(4660), e(92451), e(44206), e(66288), e(13250), e(3858), e(84538), e(64793), e(74202), e(52529), e(49109), function(s, i) {
                u.exports = i();
              }(void 0, function() {
                var s = s || function(i, f) {
                  var h;
                  if (typeof window < "u" && window.crypto && (h = window.crypto), typeof self < "u" && self.crypto && (h = self.crypto), typeof globalThis < "u" && globalThis.crypto && (h = globalThis.crypto), !h && typeof window < "u" && window.msCrypto && (h = window.msCrypto), !h && typeof e.g < "u" && e.g.crypto && (h = e.g.crypto), !h)
                    try {
                      h = e(50477);
                    } catch {
                    }
                  var v = function() {
                    if (h) {
                      if (typeof h.getRandomValues == "function")
                        try {
                          return h.getRandomValues(new Uint32Array(1))[0];
                        } catch {
                        }
                      if (typeof h.randomBytes == "function")
                        try {
                          return h.randomBytes(4).readInt32LE();
                        } catch {
                        }
                    }
                    throw new Error("Native crypto module could not be used to get secure random number.");
                  }, p = Object.create || function() {
                    function O() {
                    }
                    return function(C) {
                      var T;
                      return O.prototype = C, T = new O(), O.prototype = null, T;
                    };
                  }(), m = {}, x = m.lib = {}, g = x.Base = function() {
                    return {
                      /**
                       * Creates a new object that inherits from this object.
                       *
                       * @param {Object} overrides Properties to copy into the new object.
                       *
                       * @return {Object} The new object.
                       *
                       * @static
                       *
                       * @example
                       *
                       *     var MyType = CryptoJS.lib.Base.extend({
                       *         field: 'value',
                       *
                       *         method: function () {
                       *         }
                       *     });
                       */
                      extend: function(C) {
                        var T = p(this);
                        return C && T.mixIn(C), (!T.hasOwnProperty("init") || this.init === T.init) && (T.init = function() {
                          T.$super.init.apply(this, arguments);
                        }), T.init.prototype = T, T.$super = this, T;
                      },
                      /**
                       * Extends this object and runs the init method.
                       * Arguments to create() will be passed to init().
                       *
                       * @return {Object} The new object.
                       *
                       * @static
                       *
                       * @example
                       *
                       *     var instance = MyType.create();
                       */
                      create: function() {
                        var C = this.extend();
                        return C.init.apply(C, arguments), C;
                      },
                      /**
                       * Initializes a newly created object.
                       * Override this method to add some logic when your objects are created.
                       *
                       * @example
                       *
                       *     var MyType = CryptoJS.lib.Base.extend({
                       *         init: function () {
                       *             // ...
                       *         }
                       *     });
                       */
                      init: function() {
                      },
                      /**
                       * Copies properties into this object.
                       *
                       * @param {Object} properties The properties to mix in.
                       *
                       * @example
                       *
                       *     MyType.mixIn({
                       *         field: 'value'
                       *     });
                       */
                      mixIn: function(C) {
                        for (var T in C)
                          C.hasOwnProperty(T) && (this[T] = C[T]);
                        C.hasOwnProperty("toString") && (this.toString = C.toString);
                      },
                      /**
                       * Creates a copy of this object.
                       *
                       * @return {Object} The clone.
                       *
                       * @example
                       *
                       *     var clone = instance.clone();
                       */
                      clone: function() {
                        return this.init.prototype.extend(this);
                      }
                    };
                  }(), S = x.WordArray = g.extend({
                    /**
                     * Initializes a newly created word array.
                     *
                     * @param {Array} words (Optional) An array of 32-bit words.
                     * @param {number} sigBytes (Optional) The number of significant bytes in the words.
                     *
                     * @example
                     *
                     *     var wordArray = CryptoJS.lib.WordArray.create();
                     *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
                     *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
                     */
                    init: function(C, T) {
                      C = this.words = C || [], T != f ? this.sigBytes = T : this.sigBytes = C.length * 4;
                    },
                    /**
                     * Converts this word array to a string.
                     *
                     * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
                     *
                     * @return {string} The stringified word array.
                     *
                     * @example
                     *
                     *     var string = wordArray + '';
                     *     var string = wordArray.toString();
                     *     var string = wordArray.toString(CryptoJS.enc.Utf8);
                     */
                    toString: function(C) {
                      return (C || b).stringify(this);
                    },
                    /**
                     * Concatenates a word array to this word array.
                     *
                     * @param {WordArray} wordArray The word array to append.
                     *
                     * @return {WordArray} This word array.
                     *
                     * @example
                     *
                     *     wordArray1.concat(wordArray2);
                     */
                    concat: function(C) {
                      var T = this.words, P = C.words, I = this.sigBytes, F = C.sigBytes;
                      if (this.clamp(), I % 4)
                        for (var B = 0; B < F; B++) {
                          var M = P[B >>> 2] >>> 24 - B % 4 * 8 & 255;
                          T[I + B >>> 2] |= M << 24 - (I + B) % 4 * 8;
                        }
                      else
                        for (var z = 0; z < F; z += 4)
                          T[I + z >>> 2] = P[z >>> 2];
                      return this.sigBytes += F, this;
                    },
                    /**
                     * Removes insignificant bits.
                     *
                     * @example
                     *
                     *     wordArray.clamp();
                     */
                    clamp: function() {
                      var C = this.words, T = this.sigBytes;
                      C[T >>> 2] &= 4294967295 << 32 - T % 4 * 8, C.length = i.ceil(T / 4);
                    },
                    /**
                     * Creates a copy of this word array.
                     *
                     * @return {WordArray} The clone.
                     *
                     * @example
                     *
                     *     var clone = wordArray.clone();
                     */
                    clone: function() {
                      var C = g.clone.call(this);
                      return C.words = this.words.slice(0), C;
                    },
                    /**
                     * Creates a word array filled with random bytes.
                     *
                     * @param {number} nBytes The number of random bytes to generate.
                     *
                     * @return {WordArray} The random word array.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var wordArray = CryptoJS.lib.WordArray.random(16);
                     */
                    random: function(C) {
                      for (var T = [], P = 0; P < C; P += 4)
                        T.push(v());
                      return new S.init(T, C);
                    }
                  }), y = m.enc = {}, b = y.Hex = {
                    /**
                     * Converts a word array to a hex string.
                     *
                     * @param {WordArray} wordArray The word array.
                     *
                     * @return {string} The hex string.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
                     */
                    stringify: function(C) {
                      for (var T = C.words, P = C.sigBytes, I = [], F = 0; F < P; F++) {
                        var B = T[F >>> 2] >>> 24 - F % 4 * 8 & 255;
                        I.push((B >>> 4).toString(16)), I.push((B & 15).toString(16));
                      }
                      return I.join("");
                    },
                    /**
                     * Converts a hex string to a word array.
                     *
                     * @param {string} hexStr The hex string.
                     *
                     * @return {WordArray} The word array.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
                     */
                    parse: function(C) {
                      for (var T = C.length, P = [], I = 0; I < T; I += 2)
                        P[I >>> 3] |= parseInt(C.substr(I, 2), 16) << 24 - I % 8 * 4;
                      return new S.init(P, T / 2);
                    }
                  }, n = y.Latin1 = {
                    /**
                     * Converts a word array to a Latin1 string.
                     *
                     * @param {WordArray} wordArray The word array.
                     *
                     * @return {string} The Latin1 string.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
                     */
                    stringify: function(C) {
                      for (var T = C.words, P = C.sigBytes, I = [], F = 0; F < P; F++) {
                        var B = T[F >>> 2] >>> 24 - F % 4 * 8 & 255;
                        I.push(String.fromCharCode(B));
                      }
                      return I.join("");
                    },
                    /**
                     * Converts a Latin1 string to a word array.
                     *
                     * @param {string} latin1Str The Latin1 string.
                     *
                     * @return {WordArray} The word array.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
                     */
                    parse: function(C) {
                      for (var T = C.length, P = [], I = 0; I < T; I++)
                        P[I >>> 2] |= (C.charCodeAt(I) & 255) << 24 - I % 4 * 8;
                      return new S.init(P, T);
                    }
                  }, w = y.Utf8 = {
                    /**
                     * Converts a word array to a UTF-8 string.
                     *
                     * @param {WordArray} wordArray The word array.
                     *
                     * @return {string} The UTF-8 string.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
                     */
                    stringify: function(C) {
                      try {
                        return decodeURIComponent(escape(n.stringify(C)));
                      } catch {
                        throw new Error("Malformed UTF-8 data");
                      }
                    },
                    /**
                     * Converts a UTF-8 string to a word array.
                     *
                     * @param {string} utf8Str The UTF-8 string.
                     *
                     * @return {WordArray} The word array.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
                     */
                    parse: function(C) {
                      return n.parse(unescape(encodeURIComponent(C)));
                    }
                  }, E = x.BufferedBlockAlgorithm = g.extend({
                    /**
                     * Resets this block algorithm's data buffer to its initial state.
                     *
                     * @example
                     *
                     *     bufferedBlockAlgorithm.reset();
                     */
                    reset: function() {
                      this._data = new S.init(), this._nDataBytes = 0;
                    },
                    /**
                     * Adds new data to this block algorithm's buffer.
                     *
                     * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
                     *
                     * @example
                     *
                     *     bufferedBlockAlgorithm._append('data');
                     *     bufferedBlockAlgorithm._append(wordArray);
                     */
                    _append: function(C) {
                      typeof C == "string" && (C = w.parse(C)), this._data.concat(C), this._nDataBytes += C.sigBytes;
                    },
                    /**
                     * Processes available data blocks.
                     *
                     * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
                     *
                     * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
                     *
                     * @return {WordArray} The processed data.
                     *
                     * @example
                     *
                     *     var processedData = bufferedBlockAlgorithm._process();
                     *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
                     */
                    _process: function(C) {
                      var T, P = this._data, I = P.words, F = P.sigBytes, B = this.blockSize, M = B * 4, z = F / M;
                      C ? z = i.ceil(z) : z = i.max((z | 0) - this._minBufferSize, 0);
                      var L = z * B, J = i.min(L * 4, F);
                      if (L) {
                        for (var ft = 0; ft < L; ft += B)
                          this._doProcessBlock(I, ft);
                        T = I.splice(0, L), P.sigBytes -= J;
                      }
                      return new S.init(T, J);
                    },
                    /**
                     * Creates a copy of this object.
                     *
                     * @return {Object} The clone.
                     *
                     * @example
                     *
                     *     var clone = bufferedBlockAlgorithm.clone();
                     */
                    clone: function() {
                      var C = g.clone.call(this);
                      return C._data = this._data.clone(), C;
                    },
                    _minBufferSize: 0
                  });
                  x.Hasher = E.extend({
                    /**
                     * Configuration options.
                     */
                    cfg: g.extend(),
                    /**
                     * Initializes a newly created hasher.
                     *
                     * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
                     *
                     * @example
                     *
                     *     var hasher = CryptoJS.algo.SHA256.create();
                     */
                    init: function(C) {
                      this.cfg = this.cfg.extend(C), this.reset();
                    },
                    /**
                     * Resets this hasher to its initial state.
                     *
                     * @example
                     *
                     *     hasher.reset();
                     */
                    reset: function() {
                      E.reset.call(this), this._doReset();
                    },
                    /**
                     * Updates this hasher with a message.
                     *
                     * @param {WordArray|string} messageUpdate The message to append.
                     *
                     * @return {Hasher} This hasher.
                     *
                     * @example
                     *
                     *     hasher.update('message');
                     *     hasher.update(wordArray);
                     */
                    update: function(C) {
                      return this._append(C), this._process(), this;
                    },
                    /**
                     * Finalizes the hash computation.
                     * Note that the finalize operation is effectively a destructive, read-once operation.
                     *
                     * @param {WordArray|string} messageUpdate (Optional) A final message update.
                     *
                     * @return {WordArray} The hash.
                     *
                     * @example
                     *
                     *     var hash = hasher.finalize();
                     *     var hash = hasher.finalize('message');
                     *     var hash = hasher.finalize(wordArray);
                     */
                    finalize: function(C) {
                      C && this._append(C);
                      var T = this._doFinalize();
                      return T;
                    },
                    blockSize: 16,
                    /**
                     * Creates a shortcut function to a hasher's object interface.
                     *
                     * @param {Hasher} hasher The hasher to create a helper for.
                     *
                     * @return {Function} The shortcut function.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
                     */
                    _createHelper: function(C) {
                      return function(T, P) {
                        return new C.init(P).finalize(T);
                      };
                    },
                    /**
                     * Creates a shortcut function to the HMAC's object interface.
                     *
                     * @param {Hasher} hasher The hasher to use in this HMAC helper.
                     *
                     * @return {Function} The shortcut function.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
                     */
                    _createHmacHelper: function(C) {
                      return function(T, P) {
                        return new A.HMAC.init(C, P).finalize(T);
                      };
                    }
                  });
                  var A = m.algo = {};
                  return m;
                }(Math);
                return s;
              });
            }
          ),
          /***/
          49300: (
            /***/
            function(u, l, e) {
              e(94845), function(s, i) {
                u.exports = i(e(34559));
              }(void 0, function(s) {
                return function() {
                  var i = s, f = i.lib, h = f.WordArray, v = i.enc;
                  v.Base64 = {
                    /**
                     * Converts a word array to a Base64 string.
                     *
                     * @param {WordArray} wordArray The word array.
                     *
                     * @return {string} The Base64 string.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
                     */
                    stringify: function(x) {
                      var g = x.words, S = x.sigBytes, y = this._map;
                      x.clamp();
                      for (var b = [], n = 0; n < S; n += 3)
                        for (var w = g[n >>> 2] >>> 24 - n % 4 * 8 & 255, E = g[n + 1 >>> 2] >>> 24 - (n + 1) % 4 * 8 & 255, A = g[n + 2 >>> 2] >>> 24 - (n + 2) % 4 * 8 & 255, O = w << 16 | E << 8 | A, C = 0; C < 4 && n + C * 0.75 < S; C++)
                          b.push(y.charAt(O >>> 6 * (3 - C) & 63));
                      var T = y.charAt(64);
                      if (T)
                        for (; b.length % 4; )
                          b.push(T);
                      return b.join("");
                    },
                    /**
                     * Converts a Base64 string to a word array.
                     *
                     * @param {string} base64Str The Base64 string.
                     *
                     * @return {WordArray} The word array.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
                     */
                    parse: function(x) {
                      var g = x.length, S = this._map, y = this._reverseMap;
                      if (!y) {
                        y = this._reverseMap = [];
                        for (var b = 0; b < S.length; b++)
                          y[S.charCodeAt(b)] = b;
                      }
                      var n = S.charAt(64);
                      if (n) {
                        var w = x.indexOf(n);
                        w !== -1 && (g = w);
                      }
                      return p(x, g, y);
                    },
                    _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
                  };
                  function p(m, x, g) {
                    for (var S = [], y = 0, b = 0; b < x; b++)
                      if (b % 4) {
                        var n = g[m.charCodeAt(b - 1)] << b % 4 * 2, w = g[m.charCodeAt(b)] >>> 6 - b % 4 * 2, E = n | w;
                        S[y >>> 2] |= E << 24 - y % 4 * 8, y++;
                      }
                    return h.create(S, y);
                  }
                }(), s.enc.Base64;
              });
            }
          ),
          /***/
          375: (
            /***/
            function(u, l, e) {
              e(94845), function(s, i) {
                u.exports = i(e(34559));
              }(void 0, function(s) {
                return function() {
                  var i = s, f = i.lib, h = f.WordArray, v = i.enc;
                  v.Base64url = {
                    /**
                     * Converts a word array to a Base64url string.
                     *
                     * @param {WordArray} wordArray The word array.
                     *
                     * @param {boolean} urlSafe Whether to use url safe
                     *
                     * @return {string} The Base64url string.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
                     */
                    stringify: function(x, g) {
                      g === void 0 && (g = !0);
                      var S = x.words, y = x.sigBytes, b = g ? this._safe_map : this._map;
                      x.clamp();
                      for (var n = [], w = 0; w < y; w += 3)
                        for (var E = S[w >>> 2] >>> 24 - w % 4 * 8 & 255, A = S[w + 1 >>> 2] >>> 24 - (w + 1) % 4 * 8 & 255, O = S[w + 2 >>> 2] >>> 24 - (w + 2) % 4 * 8 & 255, C = E << 16 | A << 8 | O, T = 0; T < 4 && w + T * 0.75 < y; T++)
                          n.push(b.charAt(C >>> 6 * (3 - T) & 63));
                      var P = b.charAt(64);
                      if (P)
                        for (; n.length % 4; )
                          n.push(P);
                      return n.join("");
                    },
                    /**
                     * Converts a Base64url string to a word array.
                     *
                     * @param {string} base64Str The Base64url string.
                     *
                     * @param {boolean} urlSafe Whether to use url safe
                     *
                     * @return {WordArray} The word array.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
                     */
                    parse: function(x, g) {
                      g === void 0 && (g = !0);
                      var S = x.length, y = g ? this._safe_map : this._map, b = this._reverseMap;
                      if (!b) {
                        b = this._reverseMap = [];
                        for (var n = 0; n < y.length; n++)
                          b[y.charCodeAt(n)] = n;
                      }
                      var w = y.charAt(64);
                      if (w) {
                        var E = x.indexOf(w);
                        E !== -1 && (S = E);
                      }
                      return p(x, S, b);
                    },
                    _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
                    _safe_map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"
                  };
                  function p(m, x, g) {
                    for (var S = [], y = 0, b = 0; b < x; b++)
                      if (b % 4) {
                        var n = g[m.charCodeAt(b - 1)] << b % 4 * 2, w = g[m.charCodeAt(b)] >>> 6 - b % 4 * 2, E = n | w;
                        S[y >>> 2] |= E << 24 - y % 4 * 8, y++;
                      }
                    return h.create(S, y);
                  }
                }(), s.enc.Base64url;
              });
            }
          ),
          /***/
          56217: (
            /***/
            function(u, l, e) {
              e(94845), function(s, i) {
                u.exports = i(e(34559));
              }(void 0, function(s) {
                return function() {
                  var i = s, f = i.lib, h = f.WordArray, v = i.enc;
                  v.Utf16 = v.Utf16BE = {
                    /**
                     * Converts a word array to a UTF-16 BE string.
                     *
                     * @param {WordArray} wordArray The word array.
                     *
                     * @return {string} The UTF-16 BE string.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
                     */
                    stringify: function(x) {
                      for (var g = x.words, S = x.sigBytes, y = [], b = 0; b < S; b += 2) {
                        var n = g[b >>> 2] >>> 16 - b % 4 * 8 & 65535;
                        y.push(String.fromCharCode(n));
                      }
                      return y.join("");
                    },
                    /**
                     * Converts a UTF-16 BE string to a word array.
                     *
                     * @param {string} utf16Str The UTF-16 BE string.
                     *
                     * @return {WordArray} The word array.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
                     */
                    parse: function(x) {
                      for (var g = x.length, S = [], y = 0; y < g; y++)
                        S[y >>> 1] |= x.charCodeAt(y) << 16 - y % 2 * 16;
                      return h.create(S, g * 2);
                    }
                  }, v.Utf16LE = {
                    /**
                     * Converts a word array to a UTF-16 LE string.
                     *
                     * @param {WordArray} wordArray The word array.
                     *
                     * @return {string} The UTF-16 LE string.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
                     */
                    stringify: function(x) {
                      for (var g = x.words, S = x.sigBytes, y = [], b = 0; b < S; b += 2) {
                        var n = p(g[b >>> 2] >>> 16 - b % 4 * 8 & 65535);
                        y.push(String.fromCharCode(n));
                      }
                      return y.join("");
                    },
                    /**
                     * Converts a UTF-16 LE string to a word array.
                     *
                     * @param {string} utf16Str The UTF-16 LE string.
                     *
                     * @return {WordArray} The word array.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
                     */
                    parse: function(x) {
                      for (var g = x.length, S = [], y = 0; y < g; y++)
                        S[y >>> 1] |= p(x.charCodeAt(y) << 16 - y % 2 * 16);
                      return h.create(S, g * 2);
                    }
                  };
                  function p(m) {
                    return m << 8 & 4278255360 | m >>> 8 & 16711935;
                  }
                }(), s.enc.Utf16;
              });
            }
          ),
          /***/
          36572: (
            /***/
            function(u, l, e) {
              e(39081), function(s, i, f) {
                u.exports = i(e(34559), e(76289), e(30443));
              }(void 0, function(s) {
                return function() {
                  var i = s, f = i.lib, h = f.Base, v = f.WordArray, p = i.algo, m = p.MD5, x = p.EvpKDF = h.extend({
                    /**
                     * Configuration options.
                     *
                     * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
                     * @property {Hasher} hasher The hash algorithm to use. Default: MD5
                     * @property {number} iterations The number of iterations to perform. Default: 1
                     */
                    cfg: h.extend({
                      keySize: 128 / 32,
                      hasher: m,
                      iterations: 1
                    }),
                    /**
                     * Initializes a newly created key derivation function.
                     *
                     * @param {Object} cfg (Optional) The configuration options to use for the derivation.
                     *
                     * @example
                     *
                     *     var kdf = CryptoJS.algo.EvpKDF.create();
                     *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
                     *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
                     */
                    init: function(S) {
                      this.cfg = this.cfg.extend(S);
                    },
                    /**
                     * Derives a key from a password.
                     *
                     * @param {WordArray|string} password The password.
                     * @param {WordArray|string} salt A salt.
                     *
                     * @return {WordArray} The derived key.
                     *
                     * @example
                     *
                     *     var key = kdf.compute(password, salt);
                     */
                    compute: function(S, y) {
                      for (var b, n = this.cfg, w = n.hasher.create(), E = v.create(), A = E.words, O = n.keySize, C = n.iterations; A.length < O; ) {
                        b && w.update(b), b = w.update(S).finalize(y), w.reset();
                        for (var T = 1; T < C; T++)
                          b = w.finalize(b), w.reset();
                        E.concat(b);
                      }
                      return E.sigBytes = O * 4, E;
                    }
                  });
                  i.EvpKDF = function(g, S, y) {
                    return x.create(y).compute(g, S);
                  };
                }(), s.EvpKDF;
              });
            }
          ),
          /***/
          68219: (
            /***/
            function(u, l, e) {
              e(14032), e(57114), function(s, i, f) {
                u.exports = i(e(34559), e(28395));
              }(void 0, function(s) {
                return function(i) {
                  var f = s, h = f.lib, v = h.CipherParams, p = f.enc, m = p.Hex, x = f.format;
                  x.Hex = {
                    /**
                     * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
                     *
                     * @param {CipherParams} cipherParams The cipher params object.
                     *
                     * @return {string} The hexadecimally encoded string.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
                     */
                    stringify: function(S) {
                      return S.ciphertext.toString(m);
                    },
                    /**
                     * Converts a hexadecimally encoded ciphertext string to a cipher params object.
                     *
                     * @param {string} input The hexadecimally encoded string.
                     *
                     * @return {CipherParams} The cipher params object.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
                     */
                    parse: function(S) {
                      var y = m.parse(S);
                      return v.create({
                        ciphertext: y
                      });
                    }
                  };
                }(), s.format.Hex;
              });
            }
          ),
          /***/
          30443: (
            /***/
            function(u, l, e) {
              e(39081), function(s, i) {
                u.exports = i(e(34559));
              }(void 0, function(s) {
                (function() {
                  var i = s, f = i.lib, h = f.Base, v = i.enc, p = v.Utf8, m = i.algo;
                  m.HMAC = h.extend({
                    /**
                     * Initializes a newly created HMAC.
                     *
                     * @param {Hasher} hasher The hash algorithm to use.
                     * @param {WordArray|string} key The secret key.
                     *
                     * @example
                     *
                     *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
                     */
                    init: function(g, S) {
                      g = this._hasher = new g.init(), typeof S == "string" && (S = p.parse(S));
                      var y = g.blockSize, b = y * 4;
                      S.sigBytes > b && (S = g.finalize(S)), S.clamp();
                      for (var n = this._oKey = S.clone(), w = this._iKey = S.clone(), E = n.words, A = w.words, O = 0; O < y; O++)
                        E[O] ^= 1549556828, A[O] ^= 909522486;
                      n.sigBytes = w.sigBytes = b, this.reset();
                    },
                    /**
                     * Resets this HMAC to its initial state.
                     *
                     * @example
                     *
                     *     hmacHasher.reset();
                     */
                    reset: function() {
                      var g = this._hasher;
                      g.reset(), g.update(this._iKey);
                    },
                    /**
                     * Updates this HMAC with a message.
                     *
                     * @param {WordArray|string} messageUpdate The message to append.
                     *
                     * @return {HMAC} This HMAC instance.
                     *
                     * @example
                     *
                     *     hmacHasher.update('message');
                     *     hmacHasher.update(wordArray);
                     */
                    update: function(g) {
                      return this._hasher.update(g), this;
                    },
                    /**
                     * Finalizes the HMAC computation.
                     * Note that the finalize operation is effectively a destructive, read-once operation.
                     *
                     * @param {WordArray|string} messageUpdate (Optional) A final message update.
                     *
                     * @return {WordArray} The HMAC.
                     *
                     * @example
                     *
                     *     var hmac = hmacHasher.finalize();
                     *     var hmac = hmacHasher.finalize('message');
                     *     var hmac = hmacHasher.finalize(wordArray);
                     */
                    finalize: function(g) {
                      var S = this._hasher, y = S.finalize(g);
                      S.reset();
                      var b = S.finalize(this._oKey.clone().concat(y));
                      return b;
                    }
                  });
                })();
              });
            }
          ),
          /***/
          66122: (
            /***/
            function(u, l, e) {
              (function(s, i, f) {
                u.exports = i(e(34559), e(26478), e(80986), e(56217), e(49300), e(375), e(72342), e(76289), e(26739), e(75230), e(97074), e(371), e(80767), e(76930), e(30443), e(95729), e(36572), e(28395), e(2727), e(59493), e(18494), e(5219), e(96112), e(51583), e(99215), e(43960), e(40681), e(16934), e(68219), e(6993), e(64390), e(76635), e(55380), e(9814), e(83122));
              })(void 0, function(s) {
                return s;
              });
            }
          ),
          /***/
          80986: (
            /***/
            function(u, l, e) {
              e(81755), e(10720), e(14032), e(3131), e(90868), e(65553), e(75626), e(95756), e(56912), e(58099), e(47969), e(59735), e(73663), e(29883), e(35471), e(21012), e(88997), e(97464), e(2857), e(94715), e(13624), e(91132), e(62514), e(24597), e(88042), e(4660), e(92451), e(44206), e(66288), e(13250), e(3858), e(84538), e(64793), e(74202), e(52529), function(s, i) {
                u.exports = i(e(34559));
              }(void 0, function(s) {
                return function() {
                  if (typeof ArrayBuffer == "function") {
                    var i = s, f = i.lib, h = f.WordArray, v = h.init, p = h.init = function(m) {
                      if (m instanceof ArrayBuffer && (m = new Uint8Array(m)), (m instanceof Int8Array || typeof Uint8ClampedArray < "u" && m instanceof Uint8ClampedArray || m instanceof Int16Array || m instanceof Uint16Array || m instanceof Int32Array || m instanceof Uint32Array || m instanceof Float32Array || m instanceof Float64Array) && (m = new Uint8Array(m.buffer, m.byteOffset, m.byteLength)), m instanceof Uint8Array) {
                        for (var x = m.byteLength, g = [], S = 0; S < x; S++)
                          g[S >>> 2] |= m[S] << 24 - S % 4 * 8;
                        v.call(this, g, x);
                      } else
                        v.apply(this, arguments);
                    };
                    p.prototype = h;
                  }
                }(), s.lib.WordArray;
              });
            }
          ),
          /***/
          72342: (
            /***/
            function(u, l, e) {
              (function(s, i) {
                u.exports = i(e(34559));
              })(void 0, function(s) {
                return function(i) {
                  var f = s, h = f.lib, v = h.WordArray, p = h.Hasher, m = f.algo, x = [];
                  (function() {
                    for (var w = 0; w < 64; w++)
                      x[w] = i.abs(i.sin(w + 1)) * 4294967296 | 0;
                  })();
                  var g = m.MD5 = p.extend({
                    _doReset: function() {
                      this._hash = new v.init([1732584193, 4023233417, 2562383102, 271733878]);
                    },
                    _doProcessBlock: function(E, A) {
                      for (var O = 0; O < 16; O++) {
                        var C = A + O, T = E[C];
                        E[C] = (T << 8 | T >>> 24) & 16711935 | (T << 24 | T >>> 8) & 4278255360;
                      }
                      var P = this._hash.words, I = E[A + 0], F = E[A + 1], B = E[A + 2], M = E[A + 3], z = E[A + 4], L = E[A + 5], J = E[A + 6], ft = E[A + 7], Q = E[A + 8], xt = E[A + 9], St = E[A + 10], Pt = E[A + 11], Gt = E[A + 12], Rt = E[A + 13], bt = E[A + 14], Dt = E[A + 15], X = P[0], gt = P[1], st = P[2], rt = P[3];
                      X = S(X, gt, st, rt, I, 7, x[0]), rt = S(rt, X, gt, st, F, 12, x[1]), st = S(st, rt, X, gt, B, 17, x[2]), gt = S(gt, st, rt, X, M, 22, x[3]), X = S(X, gt, st, rt, z, 7, x[4]), rt = S(rt, X, gt, st, L, 12, x[5]), st = S(st, rt, X, gt, J, 17, x[6]), gt = S(gt, st, rt, X, ft, 22, x[7]), X = S(X, gt, st, rt, Q, 7, x[8]), rt = S(rt, X, gt, st, xt, 12, x[9]), st = S(st, rt, X, gt, St, 17, x[10]), gt = S(gt, st, rt, X, Pt, 22, x[11]), X = S(X, gt, st, rt, Gt, 7, x[12]), rt = S(rt, X, gt, st, Rt, 12, x[13]), st = S(st, rt, X, gt, bt, 17, x[14]), gt = S(gt, st, rt, X, Dt, 22, x[15]), X = y(X, gt, st, rt, F, 5, x[16]), rt = y(rt, X, gt, st, J, 9, x[17]), st = y(st, rt, X, gt, Pt, 14, x[18]), gt = y(gt, st, rt, X, I, 20, x[19]), X = y(X, gt, st, rt, L, 5, x[20]), rt = y(rt, X, gt, st, St, 9, x[21]), st = y(st, rt, X, gt, Dt, 14, x[22]), gt = y(gt, st, rt, X, z, 20, x[23]), X = y(X, gt, st, rt, xt, 5, x[24]), rt = y(rt, X, gt, st, bt, 9, x[25]), st = y(st, rt, X, gt, M, 14, x[26]), gt = y(gt, st, rt, X, Q, 20, x[27]), X = y(X, gt, st, rt, Rt, 5, x[28]), rt = y(rt, X, gt, st, B, 9, x[29]), st = y(st, rt, X, gt, ft, 14, x[30]), gt = y(gt, st, rt, X, Gt, 20, x[31]), X = b(X, gt, st, rt, L, 4, x[32]), rt = b(rt, X, gt, st, Q, 11, x[33]), st = b(st, rt, X, gt, Pt, 16, x[34]), gt = b(gt, st, rt, X, bt, 23, x[35]), X = b(X, gt, st, rt, F, 4, x[36]), rt = b(rt, X, gt, st, z, 11, x[37]), st = b(st, rt, X, gt, ft, 16, x[38]), gt = b(gt, st, rt, X, St, 23, x[39]), X = b(X, gt, st, rt, Rt, 4, x[40]), rt = b(rt, X, gt, st, I, 11, x[41]), st = b(st, rt, X, gt, M, 16, x[42]), gt = b(gt, st, rt, X, J, 23, x[43]), X = b(X, gt, st, rt, xt, 4, x[44]), rt = b(rt, X, gt, st, Gt, 11, x[45]), st = b(st, rt, X, gt, Dt, 16, x[46]), gt = b(gt, st, rt, X, B, 23, x[47]), X = n(X, gt, st, rt, I, 6, x[48]), rt = n(rt, X, gt, st, ft, 10, x[49]), st = n(st, rt, X, gt, bt, 15, x[50]), gt = n(gt, st, rt, X, L, 21, x[51]), X = n(X, gt, st, rt, Gt, 6, x[52]), rt = n(rt, X, gt, st, M, 10, x[53]), st = n(st, rt, X, gt, St, 15, x[54]), gt = n(gt, st, rt, X, F, 21, x[55]), X = n(X, gt, st, rt, Q, 6, x[56]), rt = n(rt, X, gt, st, Dt, 10, x[57]), st = n(st, rt, X, gt, J, 15, x[58]), gt = n(gt, st, rt, X, Rt, 21, x[59]), X = n(X, gt, st, rt, z, 6, x[60]), rt = n(rt, X, gt, st, Pt, 10, x[61]), st = n(st, rt, X, gt, B, 15, x[62]), gt = n(gt, st, rt, X, xt, 21, x[63]), P[0] = P[0] + X | 0, P[1] = P[1] + gt | 0, P[2] = P[2] + st | 0, P[3] = P[3] + rt | 0;
                    },
                    _doFinalize: function() {
                      var E = this._data, A = E.words, O = this._nDataBytes * 8, C = E.sigBytes * 8;
                      A[C >>> 5] |= 128 << 24 - C % 32;
                      var T = i.floor(O / 4294967296), P = O;
                      A[(C + 64 >>> 9 << 4) + 15] = (T << 8 | T >>> 24) & 16711935 | (T << 24 | T >>> 8) & 4278255360, A[(C + 64 >>> 9 << 4) + 14] = (P << 8 | P >>> 24) & 16711935 | (P << 24 | P >>> 8) & 4278255360, E.sigBytes = (A.length + 1) * 4, this._process();
                      for (var I = this._hash, F = I.words, B = 0; B < 4; B++) {
                        var M = F[B];
                        F[B] = (M << 8 | M >>> 24) & 16711935 | (M << 24 | M >>> 8) & 4278255360;
                      }
                      return I;
                    },
                    clone: function() {
                      var E = p.clone.call(this);
                      return E._hash = this._hash.clone(), E;
                    }
                  });
                  function S(w, E, A, O, C, T, P) {
                    var I = w + (E & A | ~E & O) + C + P;
                    return (I << T | I >>> 32 - T) + E;
                  }
                  function y(w, E, A, O, C, T, P) {
                    var I = w + (E & O | A & ~O) + C + P;
                    return (I << T | I >>> 32 - T) + E;
                  }
                  function b(w, E, A, O, C, T, P) {
                    var I = w + (E ^ A ^ O) + C + P;
                    return (I << T | I >>> 32 - T) + E;
                  }
                  function n(w, E, A, O, C, T, P) {
                    var I = w + (A ^ (E | ~O)) + C + P;
                    return (I << T | I >>> 32 - T) + E;
                  }
                  f.MD5 = p._createHelper(g), f.HmacMD5 = p._createHmacHelper(g);
                }(Math), s.MD5;
              });
            }
          ),
          /***/
          2727: (
            /***/
            function(u, l, e) {
              e(20731), function(s, i, f) {
                u.exports = i(e(34559), e(28395));
              }(void 0, function(s) {
                return s.mode.CFB = function() {
                  var i = s.lib.BlockCipherMode.extend();
                  i.Encryptor = i.extend({
                    processBlock: function(v, p) {
                      var m = this._cipher, x = m.blockSize;
                      f.call(this, v, p, x, m), this._prevBlock = v.slice(p, p + x);
                    }
                  }), i.Decryptor = i.extend({
                    processBlock: function(v, p) {
                      var m = this._cipher, x = m.blockSize, g = v.slice(p, p + x);
                      f.call(this, v, p, x, m), this._prevBlock = g;
                    }
                  });
                  function f(h, v, p, m) {
                    var x, g = this._iv;
                    g ? (x = g.slice(0), this._iv = void 0) : x = this._prevBlock, m.encryptBlock(x, 0);
                    for (var S = 0; S < p; S++)
                      h[v + S] ^= x[S];
                  }
                  return i;
                }(), s.mode.CFB;
              });
            }
          ),
          /***/
          18494: (
            /***/
            function(u, l, e) {
              e(20731), function(s, i, f) {
                u.exports = i(e(34559), e(28395));
              }(void 0, function(s) {
                /** @preserve
                 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
                 * derived from CryptoJS.mode.CTR
                 * Jan Hruby jhruby.web@gmail.com
                 */
                return s.mode.CTRGladman = function() {
                  var i = s.lib.BlockCipherMode.extend();
                  function f(p) {
                    if ((p >> 24 & 255) === 255) {
                      var m = p >> 16 & 255, x = p >> 8 & 255, g = p & 255;
                      m === 255 ? (m = 0, x === 255 ? (x = 0, g === 255 ? g = 0 : ++g) : ++x) : ++m, p = 0, p += m << 16, p += x << 8, p += g;
                    } else
                      p += 16777216;
                    return p;
                  }
                  function h(p) {
                    return (p[0] = f(p[0])) === 0 && (p[1] = f(p[1])), p;
                  }
                  var v = i.Encryptor = i.extend({
                    processBlock: function(m, x) {
                      var g = this._cipher, S = g.blockSize, y = this._iv, b = this._counter;
                      y && (b = this._counter = y.slice(0), this._iv = void 0), h(b);
                      var n = b.slice(0);
                      g.encryptBlock(n, 0);
                      for (var w = 0; w < S; w++)
                        m[x + w] ^= n[w];
                    }
                  });
                  return i.Decryptor = v, i;
                }(), s.mode.CTRGladman;
              });
            }
          ),
          /***/
          59493: (
            /***/
            function(u, l, e) {
              e(20731), function(s, i, f) {
                u.exports = i(e(34559), e(28395));
              }(void 0, function(s) {
                return s.mode.CTR = function() {
                  var i = s.lib.BlockCipherMode.extend(), f = i.Encryptor = i.extend({
                    processBlock: function(v, p) {
                      var m = this._cipher, x = m.blockSize, g = this._iv, S = this._counter;
                      g && (S = this._counter = g.slice(0), this._iv = void 0);
                      var y = S.slice(0);
                      m.encryptBlock(y, 0), S[x - 1] = S[x - 1] + 1 | 0;
                      for (var b = 0; b < x; b++)
                        v[p + b] ^= y[b];
                    }
                  });
                  return i.Decryptor = f, i;
                }(), s.mode.CTR;
              });
            }
          ),
          /***/
          96112: (
            /***/
            function(u, l, e) {
              (function(s, i, f) {
                u.exports = i(e(34559), e(28395));
              })(void 0, function(s) {
                return s.mode.ECB = function() {
                  var i = s.lib.BlockCipherMode.extend();
                  return i.Encryptor = i.extend({
                    processBlock: function(h, v) {
                      this._cipher.encryptBlock(h, v);
                    }
                  }), i.Decryptor = i.extend({
                    processBlock: function(h, v) {
                      this._cipher.decryptBlock(h, v);
                    }
                  }), i;
                }(), s.mode.ECB;
              });
            }
          ),
          /***/
          5219: (
            /***/
            function(u, l, e) {
              e(20731), function(s, i, f) {
                u.exports = i(e(34559), e(28395));
              }(void 0, function(s) {
                return s.mode.OFB = function() {
                  var i = s.lib.BlockCipherMode.extend(), f = i.Encryptor = i.extend({
                    processBlock: function(v, p) {
                      var m = this._cipher, x = m.blockSize, g = this._iv, S = this._keystream;
                      g && (S = this._keystream = g.slice(0), this._iv = void 0), m.encryptBlock(S, 0);
                      for (var y = 0; y < x; y++)
                        v[p + y] ^= S[y];
                    }
                  });
                  return i.Decryptor = f, i;
                }(), s.mode.OFB;
              });
            }
          ),
          /***/
          51583: (
            /***/
            function(u, l, e) {
              (function(s, i, f) {
                u.exports = i(e(34559), e(28395));
              })(void 0, function(s) {
                return s.pad.AnsiX923 = {
                  pad: function(f, h) {
                    var v = f.sigBytes, p = h * 4, m = p - v % p, x = v + m - 1;
                    f.clamp(), f.words[x >>> 2] |= m << 24 - x % 4 * 8, f.sigBytes += m;
                  },
                  unpad: function(f) {
                    var h = f.words[f.sigBytes - 1 >>> 2] & 255;
                    f.sigBytes -= h;
                  }
                }, s.pad.Ansix923;
              });
            }
          ),
          /***/
          99215: (
            /***/
            function(u, l, e) {
              e(39081), function(s, i, f) {
                u.exports = i(e(34559), e(28395));
              }(void 0, function(s) {
                return s.pad.Iso10126 = {
                  pad: function(f, h) {
                    var v = h * 4, p = v - f.sigBytes % v;
                    f.concat(s.lib.WordArray.random(p - 1)).concat(s.lib.WordArray.create([p << 24], 1));
                  },
                  unpad: function(f) {
                    var h = f.words[f.sigBytes - 1 >>> 2] & 255;
                    f.sigBytes -= h;
                  }
                }, s.pad.Iso10126;
              });
            }
          ),
          /***/
          43960: (
            /***/
            function(u, l, e) {
              e(39081), function(s, i, f) {
                u.exports = i(e(34559), e(28395));
              }(void 0, function(s) {
                return s.pad.Iso97971 = {
                  pad: function(f, h) {
                    f.concat(s.lib.WordArray.create([2147483648], 1)), s.pad.ZeroPadding.pad(f, h);
                  },
                  unpad: function(f) {
                    s.pad.ZeroPadding.unpad(f), f.sigBytes--;
                  }
                }, s.pad.Iso97971;
              });
            }
          ),
          /***/
          16934: (
            /***/
            function(u, l, e) {
              (function(s, i, f) {
                u.exports = i(e(34559), e(28395));
              })(void 0, function(s) {
                return s.pad.NoPadding = {
                  pad: function() {
                  },
                  unpad: function() {
                  }
                }, s.pad.NoPadding;
              });
            }
          ),
          /***/
          40681: (
            /***/
            function(u, l, e) {
              (function(s, i, f) {
                u.exports = i(e(34559), e(28395));
              })(void 0, function(s) {
                return s.pad.ZeroPadding = {
                  pad: function(f, h) {
                    var v = h * 4;
                    f.clamp(), f.sigBytes += v - (f.sigBytes % v || v);
                  },
                  unpad: function(f) {
                    for (var h = f.words, v = f.sigBytes - 1, v = f.sigBytes - 1; v >= 0; v--)
                      if (h[v >>> 2] >>> 24 - v % 4 * 8 & 255) {
                        f.sigBytes = v + 1;
                        break;
                      }
                  }
                }, s.pad.ZeroPadding;
              });
            }
          ),
          /***/
          95729: (
            /***/
            function(u, l, e) {
              e(39081), function(s, i, f) {
                u.exports = i(e(34559), e(26739), e(30443));
              }(void 0, function(s) {
                return function() {
                  var i = s, f = i.lib, h = f.Base, v = f.WordArray, p = i.algo, m = p.SHA256, x = p.HMAC, g = p.PBKDF2 = h.extend({
                    /**
                     * Configuration options.
                     *
                     * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
                     * @property {Hasher} hasher The hasher to use. Default: SHA256
                     * @property {number} iterations The number of iterations to perform. Default: 250000
                     */
                    cfg: h.extend({
                      keySize: 128 / 32,
                      hasher: m,
                      iterations: 25e4
                    }),
                    /**
                     * Initializes a newly created key derivation function.
                     *
                     * @param {Object} cfg (Optional) The configuration options to use for the derivation.
                     *
                     * @example
                     *
                     *     var kdf = CryptoJS.algo.PBKDF2.create();
                     *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
                     *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
                     */
                    init: function(y) {
                      this.cfg = this.cfg.extend(y);
                    },
                    /**
                     * Computes the Password-Based Key Derivation Function 2.
                     *
                     * @param {WordArray|string} password The password.
                     * @param {WordArray|string} salt A salt.
                     *
                     * @return {WordArray} The derived key.
                     *
                     * @example
                     *
                     *     var key = kdf.compute(password, salt);
                     */
                    compute: function(y, b) {
                      for (var n = this.cfg, w = x.create(n.hasher, y), E = v.create(), A = v.create([1]), O = E.words, C = A.words, T = n.keySize, P = n.iterations; O.length < T; ) {
                        var I = w.update(b).finalize(A);
                        w.reset();
                        for (var F = I.words, B = F.length, M = I, z = 1; z < P; z++) {
                          M = w.finalize(M), w.reset();
                          for (var L = M.words, J = 0; J < B; J++)
                            F[J] ^= L[J];
                        }
                        E.concat(I), C[0]++;
                      }
                      return E.sigBytes = T * 4, E;
                    }
                  });
                  i.PBKDF2 = function(S, y, b) {
                    return g.create(b).compute(S, y);
                  };
                }(), s.PBKDF2;
              });
            }
          ),
          /***/
          9814: (
            /***/
            function(u, l, e) {
              (function(s, i, f) {
                u.exports = i(e(34559), e(49300), e(72342), e(36572), e(28395));
              })(void 0, function(s) {
                return function() {
                  var i = s, f = i.lib, h = f.StreamCipher, v = i.algo, p = [], m = [], x = [], g = v.RabbitLegacy = h.extend({
                    _doReset: function() {
                      var b = this._key.words, n = this.cfg.iv, w = this._X = [b[0], b[3] << 16 | b[2] >>> 16, b[1], b[0] << 16 | b[3] >>> 16, b[2], b[1] << 16 | b[0] >>> 16, b[3], b[2] << 16 | b[1] >>> 16], E = this._C = [b[2] << 16 | b[2] >>> 16, b[0] & 4294901760 | b[1] & 65535, b[3] << 16 | b[3] >>> 16, b[1] & 4294901760 | b[2] & 65535, b[0] << 16 | b[0] >>> 16, b[2] & 4294901760 | b[3] & 65535, b[1] << 16 | b[1] >>> 16, b[3] & 4294901760 | b[0] & 65535];
                      this._b = 0;
                      for (var A = 0; A < 4; A++)
                        S.call(this);
                      for (var A = 0; A < 8; A++)
                        E[A] ^= w[A + 4 & 7];
                      if (n) {
                        var O = n.words, C = O[0], T = O[1], P = (C << 8 | C >>> 24) & 16711935 | (C << 24 | C >>> 8) & 4278255360, I = (T << 8 | T >>> 24) & 16711935 | (T << 24 | T >>> 8) & 4278255360, F = P >>> 16 | I & 4294901760, B = I << 16 | P & 65535;
                        E[0] ^= P, E[1] ^= F, E[2] ^= I, E[3] ^= B, E[4] ^= P, E[5] ^= F, E[6] ^= I, E[7] ^= B;
                        for (var A = 0; A < 4; A++)
                          S.call(this);
                      }
                    },
                    _doProcessBlock: function(b, n) {
                      var w = this._X;
                      S.call(this), p[0] = w[0] ^ w[5] >>> 16 ^ w[3] << 16, p[1] = w[2] ^ w[7] >>> 16 ^ w[5] << 16, p[2] = w[4] ^ w[1] >>> 16 ^ w[7] << 16, p[3] = w[6] ^ w[3] >>> 16 ^ w[1] << 16;
                      for (var E = 0; E < 4; E++)
                        p[E] = (p[E] << 8 | p[E] >>> 24) & 16711935 | (p[E] << 24 | p[E] >>> 8) & 4278255360, b[n + E] ^= p[E];
                    },
                    blockSize: 128 / 32,
                    ivSize: 64 / 32
                  });
                  function S() {
                    for (var y = this._X, b = this._C, n = 0; n < 8; n++)
                      m[n] = b[n];
                    b[0] = b[0] + 1295307597 + this._b | 0, b[1] = b[1] + 3545052371 + (b[0] >>> 0 < m[0] >>> 0 ? 1 : 0) | 0, b[2] = b[2] + 886263092 + (b[1] >>> 0 < m[1] >>> 0 ? 1 : 0) | 0, b[3] = b[3] + 1295307597 + (b[2] >>> 0 < m[2] >>> 0 ? 1 : 0) | 0, b[4] = b[4] + 3545052371 + (b[3] >>> 0 < m[3] >>> 0 ? 1 : 0) | 0, b[5] = b[5] + 886263092 + (b[4] >>> 0 < m[4] >>> 0 ? 1 : 0) | 0, b[6] = b[6] + 1295307597 + (b[5] >>> 0 < m[5] >>> 0 ? 1 : 0) | 0, b[7] = b[7] + 3545052371 + (b[6] >>> 0 < m[6] >>> 0 ? 1 : 0) | 0, this._b = b[7] >>> 0 < m[7] >>> 0 ? 1 : 0;
                    for (var n = 0; n < 8; n++) {
                      var w = y[n] + b[n], E = w & 65535, A = w >>> 16, O = ((E * E >>> 17) + E * A >>> 15) + A * A, C = ((w & 4294901760) * w | 0) + ((w & 65535) * w | 0);
                      x[n] = O ^ C;
                    }
                    y[0] = x[0] + (x[7] << 16 | x[7] >>> 16) + (x[6] << 16 | x[6] >>> 16) | 0, y[1] = x[1] + (x[0] << 8 | x[0] >>> 24) + x[7] | 0, y[2] = x[2] + (x[1] << 16 | x[1] >>> 16) + (x[0] << 16 | x[0] >>> 16) | 0, y[3] = x[3] + (x[2] << 8 | x[2] >>> 24) + x[1] | 0, y[4] = x[4] + (x[3] << 16 | x[3] >>> 16) + (x[2] << 16 | x[2] >>> 16) | 0, y[5] = x[5] + (x[4] << 8 | x[4] >>> 24) + x[3] | 0, y[6] = x[6] + (x[5] << 16 | x[5] >>> 16) + (x[4] << 16 | x[4] >>> 16) | 0, y[7] = x[7] + (x[6] << 8 | x[6] >>> 24) + x[5] | 0;
                  }
                  i.RabbitLegacy = h._createHelper(g);
                }(), s.RabbitLegacy;
              });
            }
          ),
          /***/
          55380: (
            /***/
            function(u, l, e) {
              (function(s, i, f) {
                u.exports = i(e(34559), e(49300), e(72342), e(36572), e(28395));
              })(void 0, function(s) {
                return function() {
                  var i = s, f = i.lib, h = f.StreamCipher, v = i.algo, p = [], m = [], x = [], g = v.Rabbit = h.extend({
                    _doReset: function() {
                      for (var b = this._key.words, n = this.cfg.iv, w = 0; w < 4; w++)
                        b[w] = (b[w] << 8 | b[w] >>> 24) & 16711935 | (b[w] << 24 | b[w] >>> 8) & 4278255360;
                      var E = this._X = [b[0], b[3] << 16 | b[2] >>> 16, b[1], b[0] << 16 | b[3] >>> 16, b[2], b[1] << 16 | b[0] >>> 16, b[3], b[2] << 16 | b[1] >>> 16], A = this._C = [b[2] << 16 | b[2] >>> 16, b[0] & 4294901760 | b[1] & 65535, b[3] << 16 | b[3] >>> 16, b[1] & 4294901760 | b[2] & 65535, b[0] << 16 | b[0] >>> 16, b[2] & 4294901760 | b[3] & 65535, b[1] << 16 | b[1] >>> 16, b[3] & 4294901760 | b[0] & 65535];
                      this._b = 0;
                      for (var w = 0; w < 4; w++)
                        S.call(this);
                      for (var w = 0; w < 8; w++)
                        A[w] ^= E[w + 4 & 7];
                      if (n) {
                        var O = n.words, C = O[0], T = O[1], P = (C << 8 | C >>> 24) & 16711935 | (C << 24 | C >>> 8) & 4278255360, I = (T << 8 | T >>> 24) & 16711935 | (T << 24 | T >>> 8) & 4278255360, F = P >>> 16 | I & 4294901760, B = I << 16 | P & 65535;
                        A[0] ^= P, A[1] ^= F, A[2] ^= I, A[3] ^= B, A[4] ^= P, A[5] ^= F, A[6] ^= I, A[7] ^= B;
                        for (var w = 0; w < 4; w++)
                          S.call(this);
                      }
                    },
                    _doProcessBlock: function(b, n) {
                      var w = this._X;
                      S.call(this), p[0] = w[0] ^ w[5] >>> 16 ^ w[3] << 16, p[1] = w[2] ^ w[7] >>> 16 ^ w[5] << 16, p[2] = w[4] ^ w[1] >>> 16 ^ w[7] << 16, p[3] = w[6] ^ w[3] >>> 16 ^ w[1] << 16;
                      for (var E = 0; E < 4; E++)
                        p[E] = (p[E] << 8 | p[E] >>> 24) & 16711935 | (p[E] << 24 | p[E] >>> 8) & 4278255360, b[n + E] ^= p[E];
                    },
                    blockSize: 128 / 32,
                    ivSize: 64 / 32
                  });
                  function S() {
                    for (var y = this._X, b = this._C, n = 0; n < 8; n++)
                      m[n] = b[n];
                    b[0] = b[0] + 1295307597 + this._b | 0, b[1] = b[1] + 3545052371 + (b[0] >>> 0 < m[0] >>> 0 ? 1 : 0) | 0, b[2] = b[2] + 886263092 + (b[1] >>> 0 < m[1] >>> 0 ? 1 : 0) | 0, b[3] = b[3] + 1295307597 + (b[2] >>> 0 < m[2] >>> 0 ? 1 : 0) | 0, b[4] = b[4] + 3545052371 + (b[3] >>> 0 < m[3] >>> 0 ? 1 : 0) | 0, b[5] = b[5] + 886263092 + (b[4] >>> 0 < m[4] >>> 0 ? 1 : 0) | 0, b[6] = b[6] + 1295307597 + (b[5] >>> 0 < m[5] >>> 0 ? 1 : 0) | 0, b[7] = b[7] + 3545052371 + (b[6] >>> 0 < m[6] >>> 0 ? 1 : 0) | 0, this._b = b[7] >>> 0 < m[7] >>> 0 ? 1 : 0;
                    for (var n = 0; n < 8; n++) {
                      var w = y[n] + b[n], E = w & 65535, A = w >>> 16, O = ((E * E >>> 17) + E * A >>> 15) + A * A, C = ((w & 4294901760) * w | 0) + ((w & 65535) * w | 0);
                      x[n] = O ^ C;
                    }
                    y[0] = x[0] + (x[7] << 16 | x[7] >>> 16) + (x[6] << 16 | x[6] >>> 16) | 0, y[1] = x[1] + (x[0] << 8 | x[0] >>> 24) + x[7] | 0, y[2] = x[2] + (x[1] << 16 | x[1] >>> 16) + (x[0] << 16 | x[0] >>> 16) | 0, y[3] = x[3] + (x[2] << 8 | x[2] >>> 24) + x[1] | 0, y[4] = x[4] + (x[3] << 16 | x[3] >>> 16) + (x[2] << 16 | x[2] >>> 16) | 0, y[5] = x[5] + (x[4] << 8 | x[4] >>> 24) + x[3] | 0, y[6] = x[6] + (x[5] << 16 | x[5] >>> 16) + (x[4] << 16 | x[4] >>> 16) | 0, y[7] = x[7] + (x[6] << 8 | x[6] >>> 24) + x[5] | 0;
                  }
                  i.Rabbit = h._createHelper(g);
                }(), s.Rabbit;
              });
            }
          ),
          /***/
          76635: (
            /***/
            function(u, l, e) {
              e(14032), e(68067), function(s, i, f) {
                u.exports = i(e(34559), e(49300), e(72342), e(36572), e(28395));
              }(void 0, function(s) {
                return function() {
                  var i = s, f = i.lib, h = f.StreamCipher, v = i.algo, p = v.RC4 = h.extend({
                    _doReset: function() {
                      for (var S = this._key, y = S.words, b = S.sigBytes, n = this._S = [], w = 0; w < 256; w++)
                        n[w] = w;
                      for (var w = 0, E = 0; w < 256; w++) {
                        var A = w % b, O = y[A >>> 2] >>> 24 - A % 4 * 8 & 255;
                        E = (E + n[w] + O) % 256;
                        var C = n[w];
                        n[w] = n[E], n[E] = C;
                      }
                      this._i = this._j = 0;
                    },
                    _doProcessBlock: function(S, y) {
                      S[y] ^= m.call(this);
                    },
                    keySize: 256 / 32,
                    ivSize: 0
                  });
                  function m() {
                    for (var g = this._S, S = this._i, y = this._j, b = 0, n = 0; n < 4; n++) {
                      S = (S + 1) % 256, y = (y + g[S]) % 256;
                      var w = g[S];
                      g[S] = g[y], g[y] = w, b |= g[(g[S] + g[y]) % 256] << 24 - n * 8;
                    }
                    return this._i = S, this._j = y, b;
                  }
                  i.RC4 = h._createHelper(p);
                  var x = v.RC4Drop = p.extend({
                    /**
                     * Configuration options.
                     *
                     * @property {number} drop The number of keystream words to drop. Default 192
                     */
                    cfg: p.cfg.extend({
                      drop: 192
                    }),
                    _doReset: function() {
                      p._doReset.call(this);
                      for (var S = this.cfg.drop; S > 0; S--)
                        m.call(this);
                    }
                  });
                  i.RC4Drop = h._createHelper(x);
                }(), s.RC4;
              });
            }
          ),
          /***/
          76930: (
            /***/
            function(u, l, e) {
              (function(s, i) {
                u.exports = i(e(34559));
              })(void 0, function(s) {
                /** @preserve
                (c) 2012 by Cédric Mesnil. All rights reserved.
                	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
                	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
                    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
                	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                */
                return function(i) {
                  var f = s, h = f.lib, v = h.WordArray, p = h.Hasher, m = f.algo, x = v.create([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13]), g = v.create([5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11]), S = v.create([11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6]), y = v.create([8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11]), b = v.create([0, 1518500249, 1859775393, 2400959708, 2840853838]), n = v.create([1352829926, 1548603684, 1836072691, 2053994217, 0]), w = m.RIPEMD160 = p.extend({
                    _doReset: function() {
                      this._hash = v.create([1732584193, 4023233417, 2562383102, 271733878, 3285377520]);
                    },
                    _doProcessBlock: function(F, B) {
                      for (var M = 0; M < 16; M++) {
                        var z = B + M, L = F[z];
                        F[z] = (L << 8 | L >>> 24) & 16711935 | (L << 24 | L >>> 8) & 4278255360;
                      }
                      var J = this._hash.words, ft = b.words, Q = n.words, xt = x.words, St = g.words, Pt = S.words, Gt = y.words, Rt, bt, Dt, X, gt, st, rt, wt, Ft, zt;
                      st = Rt = J[0], rt = bt = J[1], wt = Dt = J[2], Ft = X = J[3], zt = gt = J[4];
                      for (var G, M = 0; M < 80; M += 1)
                        G = Rt + F[B + xt[M]] | 0, M < 16 ? G += E(bt, Dt, X) + ft[0] : M < 32 ? G += A(bt, Dt, X) + ft[1] : M < 48 ? G += O(bt, Dt, X) + ft[2] : M < 64 ? G += C(bt, Dt, X) + ft[3] : G += T(bt, Dt, X) + ft[4], G = G | 0, G = P(G, Pt[M]), G = G + gt | 0, Rt = gt, gt = X, X = P(Dt, 10), Dt = bt, bt = G, G = st + F[B + St[M]] | 0, M < 16 ? G += T(rt, wt, Ft) + Q[0] : M < 32 ? G += C(rt, wt, Ft) + Q[1] : M < 48 ? G += O(rt, wt, Ft) + Q[2] : M < 64 ? G += A(rt, wt, Ft) + Q[3] : G += E(rt, wt, Ft) + Q[4], G = G | 0, G = P(G, Gt[M]), G = G + zt | 0, st = zt, zt = Ft, Ft = P(wt, 10), wt = rt, rt = G;
                      G = J[1] + Dt + Ft | 0, J[1] = J[2] + X + zt | 0, J[2] = J[3] + gt + st | 0, J[3] = J[4] + Rt + rt | 0, J[4] = J[0] + bt + wt | 0, J[0] = G;
                    },
                    _doFinalize: function() {
                      var F = this._data, B = F.words, M = this._nDataBytes * 8, z = F.sigBytes * 8;
                      B[z >>> 5] |= 128 << 24 - z % 32, B[(z + 64 >>> 9 << 4) + 14] = (M << 8 | M >>> 24) & 16711935 | (M << 24 | M >>> 8) & 4278255360, F.sigBytes = (B.length + 1) * 4, this._process();
                      for (var L = this._hash, J = L.words, ft = 0; ft < 5; ft++) {
                        var Q = J[ft];
                        J[ft] = (Q << 8 | Q >>> 24) & 16711935 | (Q << 24 | Q >>> 8) & 4278255360;
                      }
                      return L;
                    },
                    clone: function() {
                      var F = p.clone.call(this);
                      return F._hash = this._hash.clone(), F;
                    }
                  });
                  function E(I, F, B) {
                    return I ^ F ^ B;
                  }
                  function A(I, F, B) {
                    return I & F | ~I & B;
                  }
                  function O(I, F, B) {
                    return (I | ~F) ^ B;
                  }
                  function C(I, F, B) {
                    return I & B | F & ~B;
                  }
                  function T(I, F, B) {
                    return I ^ (F | ~B);
                  }
                  function P(I, F) {
                    return I << F | I >>> 32 - F;
                  }
                  f.RIPEMD160 = p._createHelper(w), f.HmacRIPEMD160 = p._createHmacHelper(w);
                }(), s.RIPEMD160;
              });
            }
          ),
          /***/
          76289: (
            /***/
            function(u, l, e) {
              (function(s, i) {
                u.exports = i(e(34559));
              })(void 0, function(s) {
                return function() {
                  var i = s, f = i.lib, h = f.WordArray, v = f.Hasher, p = i.algo, m = [], x = p.SHA1 = v.extend({
                    _doReset: function() {
                      this._hash = new h.init([1732584193, 4023233417, 2562383102, 271733878, 3285377520]);
                    },
                    _doProcessBlock: function(S, y) {
                      for (var b = this._hash.words, n = b[0], w = b[1], E = b[2], A = b[3], O = b[4], C = 0; C < 80; C++) {
                        if (C < 16)
                          m[C] = S[y + C] | 0;
                        else {
                          var T = m[C - 3] ^ m[C - 8] ^ m[C - 14] ^ m[C - 16];
                          m[C] = T << 1 | T >>> 31;
                        }
                        var P = (n << 5 | n >>> 27) + O + m[C];
                        C < 20 ? P += (w & E | ~w & A) + 1518500249 : C < 40 ? P += (w ^ E ^ A) + 1859775393 : C < 60 ? P += (w & E | w & A | E & A) - 1894007588 : P += (w ^ E ^ A) - 899497514, O = A, A = E, E = w << 30 | w >>> 2, w = n, n = P;
                      }
                      b[0] = b[0] + n | 0, b[1] = b[1] + w | 0, b[2] = b[2] + E | 0, b[3] = b[3] + A | 0, b[4] = b[4] + O | 0;
                    },
                    _doFinalize: function() {
                      var S = this._data, y = S.words, b = this._nDataBytes * 8, n = S.sigBytes * 8;
                      return y[n >>> 5] |= 128 << 24 - n % 32, y[(n + 64 >>> 9 << 4) + 14] = Math.floor(b / 4294967296), y[(n + 64 >>> 9 << 4) + 15] = b, S.sigBytes = y.length * 4, this._process(), this._hash;
                    },
                    clone: function() {
                      var S = v.clone.call(this);
                      return S._hash = this._hash.clone(), S;
                    }
                  });
                  i.SHA1 = v._createHelper(x), i.HmacSHA1 = v._createHmacHelper(x);
                }(), s.SHA1;
              });
            }
          ),
          /***/
          75230: (
            /***/
            function(u, l, e) {
              (function(s, i, f) {
                u.exports = i(e(34559), e(26739));
              })(void 0, function(s) {
                return function() {
                  var i = s, f = i.lib, h = f.WordArray, v = i.algo, p = v.SHA256, m = v.SHA224 = p.extend({
                    _doReset: function() {
                      this._hash = new h.init([3238371032, 914150663, 812702999, 4144912697, 4290775857, 1750603025, 1694076839, 3204075428]);
                    },
                    _doFinalize: function() {
                      var g = p._doFinalize.call(this);
                      return g.sigBytes -= 4, g;
                    }
                  });
                  i.SHA224 = p._createHelper(m), i.HmacSHA224 = p._createHmacHelper(m);
                }(), s.SHA224;
              });
            }
          ),
          /***/
          26739: (
            /***/
            function(u, l, e) {
              e(20731), function(s, i) {
                u.exports = i(e(34559));
              }(void 0, function(s) {
                return function(i) {
                  var f = s, h = f.lib, v = h.WordArray, p = h.Hasher, m = f.algo, x = [], g = [];
                  (function() {
                    function b(A) {
                      for (var O = i.sqrt(A), C = 2; C <= O; C++)
                        if (!(A % C))
                          return !1;
                      return !0;
                    }
                    function n(A) {
                      return (A - (A | 0)) * 4294967296 | 0;
                    }
                    for (var w = 2, E = 0; E < 64; )
                      b(w) && (E < 8 && (x[E] = n(i.pow(w, 0.5))), g[E] = n(i.pow(w, 0.3333333333333333)), E++), w++;
                  })();
                  var S = [], y = m.SHA256 = p.extend({
                    _doReset: function() {
                      this._hash = new v.init(x.slice(0));
                    },
                    _doProcessBlock: function(n, w) {
                      for (var E = this._hash.words, A = E[0], O = E[1], C = E[2], T = E[3], P = E[4], I = E[5], F = E[6], B = E[7], M = 0; M < 64; M++) {
                        if (M < 16)
                          S[M] = n[w + M] | 0;
                        else {
                          var z = S[M - 15], L = (z << 25 | z >>> 7) ^ (z << 14 | z >>> 18) ^ z >>> 3, J = S[M - 2], ft = (J << 15 | J >>> 17) ^ (J << 13 | J >>> 19) ^ J >>> 10;
                          S[M] = L + S[M - 7] + ft + S[M - 16];
                        }
                        var Q = P & I ^ ~P & F, xt = A & O ^ A & C ^ O & C, St = (A << 30 | A >>> 2) ^ (A << 19 | A >>> 13) ^ (A << 10 | A >>> 22), Pt = (P << 26 | P >>> 6) ^ (P << 21 | P >>> 11) ^ (P << 7 | P >>> 25), Gt = B + Pt + Q + g[M] + S[M], Rt = St + xt;
                        B = F, F = I, I = P, P = T + Gt | 0, T = C, C = O, O = A, A = Gt + Rt | 0;
                      }
                      E[0] = E[0] + A | 0, E[1] = E[1] + O | 0, E[2] = E[2] + C | 0, E[3] = E[3] + T | 0, E[4] = E[4] + P | 0, E[5] = E[5] + I | 0, E[6] = E[6] + F | 0, E[7] = E[7] + B | 0;
                    },
                    _doFinalize: function() {
                      var n = this._data, w = n.words, E = this._nDataBytes * 8, A = n.sigBytes * 8;
                      return w[A >>> 5] |= 128 << 24 - A % 32, w[(A + 64 >>> 9 << 4) + 14] = i.floor(E / 4294967296), w[(A + 64 >>> 9 << 4) + 15] = E, n.sigBytes = w.length * 4, this._process(), this._hash;
                    },
                    clone: function() {
                      var n = p.clone.call(this);
                      return n._hash = this._hash.clone(), n;
                    }
                  });
                  f.SHA256 = p._createHelper(y), f.HmacSHA256 = p._createHmacHelper(y);
                }(Math), s.SHA256;
              });
            }
          ),
          /***/
          80767: (
            /***/
            function(u, l, e) {
              e(20731), function(s, i, f) {
                u.exports = i(e(34559), e(26478));
              }(void 0, function(s) {
                return function(i) {
                  var f = s, h = f.lib, v = h.WordArray, p = h.Hasher, m = f.x64, x = m.Word, g = f.algo, S = [], y = [], b = [];
                  (function() {
                    for (var E = 1, A = 0, O = 0; O < 24; O++) {
                      S[E + 5 * A] = (O + 1) * (O + 2) / 2 % 64;
                      var C = A % 5, T = (2 * E + 3 * A) % 5;
                      E = C, A = T;
                    }
                    for (var E = 0; E < 5; E++)
                      for (var A = 0; A < 5; A++)
                        y[E + 5 * A] = A + (2 * E + 3 * A) % 5 * 5;
                    for (var P = 1, I = 0; I < 24; I++) {
                      for (var F = 0, B = 0, M = 0; M < 7; M++) {
                        if (P & 1) {
                          var z = (1 << M) - 1;
                          z < 32 ? B ^= 1 << z : F ^= 1 << z - 32;
                        }
                        P & 128 ? P = P << 1 ^ 113 : P <<= 1;
                      }
                      b[I] = x.create(F, B);
                    }
                  })();
                  var n = [];
                  (function() {
                    for (var E = 0; E < 25; E++)
                      n[E] = x.create();
                  })();
                  var w = g.SHA3 = p.extend({
                    /**
                     * Configuration options.
                     *
                     * @property {number} outputLength
                     *   The desired number of bits in the output hash.
                     *   Only values permitted are: 224, 256, 384, 512.
                     *   Default: 512
                     */
                    cfg: p.cfg.extend({
                      outputLength: 512
                    }),
                    _doReset: function() {
                      for (var A = this._state = [], O = 0; O < 25; O++)
                        A[O] = new x.init();
                      this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
                    },
                    _doProcessBlock: function(A, O) {
                      for (var C = this._state, T = this.blockSize / 2, P = 0; P < T; P++) {
                        var I = A[O + 2 * P], F = A[O + 2 * P + 1];
                        I = (I << 8 | I >>> 24) & 16711935 | (I << 24 | I >>> 8) & 4278255360, F = (F << 8 | F >>> 24) & 16711935 | (F << 24 | F >>> 8) & 4278255360;
                        var B = C[P];
                        B.high ^= F, B.low ^= I;
                      }
                      for (var M = 0; M < 24; M++) {
                        for (var z = 0; z < 5; z++) {
                          for (var L = 0, J = 0, ft = 0; ft < 5; ft++) {
                            var B = C[z + 5 * ft];
                            L ^= B.high, J ^= B.low;
                          }
                          var Q = n[z];
                          Q.high = L, Q.low = J;
                        }
                        for (var z = 0; z < 5; z++)
                          for (var xt = n[(z + 4) % 5], St = n[(z + 1) % 5], Pt = St.high, Gt = St.low, L = xt.high ^ (Pt << 1 | Gt >>> 31), J = xt.low ^ (Gt << 1 | Pt >>> 31), ft = 0; ft < 5; ft++) {
                            var B = C[z + 5 * ft];
                            B.high ^= L, B.low ^= J;
                          }
                        for (var Rt = 1; Rt < 25; Rt++) {
                          var L, J, B = C[Rt], bt = B.high, Dt = B.low, X = S[Rt];
                          X < 32 ? (L = bt << X | Dt >>> 32 - X, J = Dt << X | bt >>> 32 - X) : (L = Dt << X - 32 | bt >>> 64 - X, J = bt << X - 32 | Dt >>> 64 - X);
                          var gt = n[y[Rt]];
                          gt.high = L, gt.low = J;
                        }
                        var st = n[0], rt = C[0];
                        st.high = rt.high, st.low = rt.low;
                        for (var z = 0; z < 5; z++)
                          for (var ft = 0; ft < 5; ft++) {
                            var Rt = z + 5 * ft, B = C[Rt], wt = n[Rt], Ft = n[(z + 1) % 5 + 5 * ft], zt = n[(z + 2) % 5 + 5 * ft];
                            B.high = wt.high ^ ~Ft.high & zt.high, B.low = wt.low ^ ~Ft.low & zt.low;
                          }
                        var B = C[0], G = b[M];
                        B.high ^= G.high, B.low ^= G.low;
                      }
                    },
                    _doFinalize: function() {
                      var A = this._data, O = A.words;
                      this._nDataBytes * 8;
                      var C = A.sigBytes * 8, T = this.blockSize * 32;
                      O[C >>> 5] |= 1 << 24 - C % 32, O[(i.ceil((C + 1) / T) * T >>> 5) - 1] |= 128, A.sigBytes = O.length * 4, this._process();
                      for (var P = this._state, I = this.cfg.outputLength / 8, F = I / 8, B = [], M = 0; M < F; M++) {
                        var z = P[M], L = z.high, J = z.low;
                        L = (L << 8 | L >>> 24) & 16711935 | (L << 24 | L >>> 8) & 4278255360, J = (J << 8 | J >>> 24) & 16711935 | (J << 24 | J >>> 8) & 4278255360, B.push(J), B.push(L);
                      }
                      return new v.init(B, I);
                    },
                    clone: function() {
                      for (var A = p.clone.call(this), O = A._state = this._state.slice(0), C = 0; C < 25; C++)
                        O[C] = O[C].clone();
                      return A;
                    }
                  });
                  f.SHA3 = p._createHelper(w), f.HmacSHA3 = p._createHmacHelper(w);
                }(Math), s.SHA3;
              });
            }
          ),
          /***/
          371: (
            /***/
            function(u, l, e) {
              (function(s, i, f) {
                u.exports = i(e(34559), e(26478), e(97074));
              })(void 0, function(s) {
                return function() {
                  var i = s, f = i.x64, h = f.Word, v = f.WordArray, p = i.algo, m = p.SHA512, x = p.SHA384 = m.extend({
                    _doReset: function() {
                      this._hash = new v.init([new h.init(3418070365, 3238371032), new h.init(1654270250, 914150663), new h.init(2438529370, 812702999), new h.init(355462360, 4144912697), new h.init(1731405415, 4290775857), new h.init(2394180231, 1750603025), new h.init(3675008525, 1694076839), new h.init(1203062813, 3204075428)]);
                    },
                    _doFinalize: function() {
                      var S = m._doFinalize.call(this);
                      return S.sigBytes -= 16, S;
                    }
                  });
                  i.SHA384 = m._createHelper(x), i.HmacSHA384 = m._createHmacHelper(x);
                }(), s.SHA384;
              });
            }
          ),
          /***/
          97074: (
            /***/
            function(u, l, e) {
              (function(s, i, f) {
                u.exports = i(e(34559), e(26478));
              })(void 0, function(s) {
                return function() {
                  var i = s, f = i.lib, h = f.Hasher, v = i.x64, p = v.Word, m = v.WordArray, x = i.algo;
                  function g() {
                    return p.create.apply(p, arguments);
                  }
                  var S = [g(1116352408, 3609767458), g(1899447441, 602891725), g(3049323471, 3964484399), g(3921009573, 2173295548), g(961987163, 4081628472), g(1508970993, 3053834265), g(2453635748, 2937671579), g(2870763221, 3664609560), g(3624381080, 2734883394), g(310598401, 1164996542), g(607225278, 1323610764), g(1426881987, 3590304994), g(1925078388, 4068182383), g(2162078206, 991336113), g(2614888103, 633803317), g(3248222580, 3479774868), g(3835390401, 2666613458), g(4022224774, 944711139), g(264347078, 2341262773), g(604807628, 2007800933), g(770255983, 1495990901), g(1249150122, 1856431235), g(1555081692, 3175218132), g(1996064986, 2198950837), g(2554220882, 3999719339), g(2821834349, 766784016), g(2952996808, 2566594879), g(3210313671, 3203337956), g(3336571891, 1034457026), g(3584528711, 2466948901), g(113926993, 3758326383), g(338241895, 168717936), g(666307205, 1188179964), g(773529912, 1546045734), g(1294757372, 1522805485), g(1396182291, 2643833823), g(1695183700, 2343527390), g(1986661051, 1014477480), g(2177026350, 1206759142), g(2456956037, 344077627), g(2730485921, 1290863460), g(2820302411, 3158454273), g(3259730800, 3505952657), g(3345764771, 106217008), g(3516065817, 3606008344), g(3600352804, 1432725776), g(4094571909, 1467031594), g(275423344, 851169720), g(430227734, 3100823752), g(506948616, 1363258195), g(659060556, 3750685593), g(883997877, 3785050280), g(958139571, 3318307427), g(1322822218, 3812723403), g(1537002063, 2003034995), g(1747873779, 3602036899), g(1955562222, 1575990012), g(2024104815, 1125592928), g(2227730452, 2716904306), g(2361852424, 442776044), g(2428436474, 593698344), g(2756734187, 3733110249), g(3204031479, 2999351573), g(3329325298, 3815920427), g(3391569614, 3928383900), g(3515267271, 566280711), g(3940187606, 3454069534), g(4118630271, 4000239992), g(116418474, 1914138554), g(174292421, 2731055270), g(289380356, 3203993006), g(460393269, 320620315), g(685471733, 587496836), g(852142971, 1086792851), g(1017036298, 365543100), g(1126000580, 2618297676), g(1288033470, 3409855158), g(1501505948, 4234509866), g(1607167915, 987167468), g(1816402316, 1246189591)], y = [];
                  (function() {
                    for (var n = 0; n < 80; n++)
                      y[n] = g();
                  })();
                  var b = x.SHA512 = h.extend({
                    _doReset: function() {
                      this._hash = new m.init([new p.init(1779033703, 4089235720), new p.init(3144134277, 2227873595), new p.init(1013904242, 4271175723), new p.init(2773480762, 1595750129), new p.init(1359893119, 2917565137), new p.init(2600822924, 725511199), new p.init(528734635, 4215389547), new p.init(1541459225, 327033209)]);
                    },
                    _doProcessBlock: function(w, E) {
                      for (var A = this._hash.words, O = A[0], C = A[1], T = A[2], P = A[3], I = A[4], F = A[5], B = A[6], M = A[7], z = O.high, L = O.low, J = C.high, ft = C.low, Q = T.high, xt = T.low, St = P.high, Pt = P.low, Gt = I.high, Rt = I.low, bt = F.high, Dt = F.low, X = B.high, gt = B.low, st = M.high, rt = M.low, wt = z, Ft = L, zt = J, G = ft, D = Q, Z = xt, et = St, vt = Pt, lt = Gt, dt = Rt, kt = bt, jt = Dt, me = X, se = gt, Bt = st, ge = rt, Re = 0; Re < 80; Re++) {
                        var Te, xe, Fe = y[Re];
                        if (Re < 16)
                          xe = Fe.high = w[E + Re * 2] | 0, Te = Fe.low = w[E + Re * 2 + 1] | 0;
                        else {
                          var Zt = y[Re - 15], qt = Zt.high, ve = Zt.low, Se = (qt >>> 1 | ve << 31) ^ (qt >>> 8 | ve << 24) ^ qt >>> 7, Pe = (ve >>> 1 | qt << 31) ^ (ve >>> 8 | qt << 24) ^ (ve >>> 7 | qt << 25), Be = y[Re - 2], De = Be.high, It = Be.low, he = (De >>> 19 | It << 13) ^ (De << 3 | It >>> 29) ^ De >>> 6, nt = (It >>> 19 | De << 13) ^ (It << 3 | De >>> 29) ^ (It >>> 6 | De << 26), j = y[Re - 7], V = j.high, yt = j.low, it = y[Re - 16], _t = it.high, ne = it.low;
                          Te = Pe + yt, xe = Se + V + (Te >>> 0 < Pe >>> 0 ? 1 : 0), Te = Te + nt, xe = xe + he + (Te >>> 0 < nt >>> 0 ? 1 : 0), Te = Te + ne, xe = xe + _t + (Te >>> 0 < ne >>> 0 ? 1 : 0), Fe.high = xe, Fe.low = Te;
                        }
                        var Y = lt & kt ^ ~lt & me, Jt = dt & jt ^ ~dt & se, ie = wt & zt ^ wt & D ^ zt & D, Tt = Ft & G ^ Ft & Z ^ G & Z, Xt = (wt >>> 28 | Ft << 4) ^ (wt << 30 | Ft >>> 2) ^ (wt << 25 | Ft >>> 7), ue = (Ft >>> 28 | wt << 4) ^ (Ft << 30 | wt >>> 2) ^ (Ft << 25 | wt >>> 7), Ve = (lt >>> 14 | dt << 18) ^ (lt >>> 18 | dt << 14) ^ (lt << 23 | dt >>> 9), ke = (dt >>> 14 | lt << 18) ^ (dt >>> 18 | lt << 14) ^ (dt << 23 | lt >>> 9), Xe = S[Re], je = Xe.high, Wr = Xe.low, vr = ge + ke, nr = Bt + Ve + (vr >>> 0 < ge >>> 0 ? 1 : 0), vr = vr + Jt, nr = nr + Y + (vr >>> 0 < Jt >>> 0 ? 1 : 0), vr = vr + Wr, nr = nr + je + (vr >>> 0 < Wr >>> 0 ? 1 : 0), vr = vr + Te, nr = nr + xe + (vr >>> 0 < Te >>> 0 ? 1 : 0), Fr = ue + Tt, Jr = Xt + ie + (Fr >>> 0 < ue >>> 0 ? 1 : 0);
                        Bt = me, ge = se, me = kt, se = jt, kt = lt, jt = dt, dt = vt + vr | 0, lt = et + nr + (dt >>> 0 < vt >>> 0 ? 1 : 0) | 0, et = D, vt = Z, D = zt, Z = G, zt = wt, G = Ft, Ft = vr + Fr | 0, wt = nr + Jr + (Ft >>> 0 < vr >>> 0 ? 1 : 0) | 0;
                      }
                      L = O.low = L + Ft, O.high = z + wt + (L >>> 0 < Ft >>> 0 ? 1 : 0), ft = C.low = ft + G, C.high = J + zt + (ft >>> 0 < G >>> 0 ? 1 : 0), xt = T.low = xt + Z, T.high = Q + D + (xt >>> 0 < Z >>> 0 ? 1 : 0), Pt = P.low = Pt + vt, P.high = St + et + (Pt >>> 0 < vt >>> 0 ? 1 : 0), Rt = I.low = Rt + dt, I.high = Gt + lt + (Rt >>> 0 < dt >>> 0 ? 1 : 0), Dt = F.low = Dt + jt, F.high = bt + kt + (Dt >>> 0 < jt >>> 0 ? 1 : 0), gt = B.low = gt + se, B.high = X + me + (gt >>> 0 < se >>> 0 ? 1 : 0), rt = M.low = rt + ge, M.high = st + Bt + (rt >>> 0 < ge >>> 0 ? 1 : 0);
                    },
                    _doFinalize: function() {
                      var w = this._data, E = w.words, A = this._nDataBytes * 8, O = w.sigBytes * 8;
                      E[O >>> 5] |= 128 << 24 - O % 32, E[(O + 128 >>> 10 << 5) + 30] = Math.floor(A / 4294967296), E[(O + 128 >>> 10 << 5) + 31] = A, w.sigBytes = E.length * 4, this._process();
                      var C = this._hash.toX32();
                      return C;
                    },
                    clone: function() {
                      var w = h.clone.call(this);
                      return w._hash = this._hash.clone(), w;
                    },
                    blockSize: 1024 / 32
                  });
                  i.SHA512 = h._createHelper(b), i.HmacSHA512 = h._createHmacHelper(b);
                }(), s.SHA512;
              });
            }
          ),
          /***/
          64390: (
            /***/
            function(u, l, e) {
              e(20731), function(s, i, f) {
                u.exports = i(e(34559), e(49300), e(72342), e(36572), e(28395));
              }(void 0, function(s) {
                return function() {
                  var i = s, f = i.lib, h = f.WordArray, v = f.BlockCipher, p = i.algo, m = [57, 49, 41, 33, 25, 17, 9, 1, 58, 50, 42, 34, 26, 18, 10, 2, 59, 51, 43, 35, 27, 19, 11, 3, 60, 52, 44, 36, 63, 55, 47, 39, 31, 23, 15, 7, 62, 54, 46, 38, 30, 22, 14, 6, 61, 53, 45, 37, 29, 21, 13, 5, 28, 20, 12, 4], x = [14, 17, 11, 24, 1, 5, 3, 28, 15, 6, 21, 10, 23, 19, 12, 4, 26, 8, 16, 7, 27, 20, 13, 2, 41, 52, 31, 37, 47, 55, 30, 40, 51, 45, 33, 48, 44, 49, 39, 56, 34, 53, 46, 42, 50, 36, 29, 32], g = [1, 2, 4, 6, 8, 10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28], S = [{
                    0: 8421888,
                    268435456: 32768,
                    536870912: 8421378,
                    805306368: 2,
                    1073741824: 512,
                    1342177280: 8421890,
                    1610612736: 8389122,
                    1879048192: 8388608,
                    2147483648: 514,
                    2415919104: 8389120,
                    2684354560: 33280,
                    2952790016: 8421376,
                    3221225472: 32770,
                    3489660928: 8388610,
                    3758096384: 0,
                    4026531840: 33282,
                    134217728: 0,
                    402653184: 8421890,
                    671088640: 33282,
                    939524096: 32768,
                    1207959552: 8421888,
                    1476395008: 512,
                    1744830464: 8421378,
                    2013265920: 2,
                    2281701376: 8389120,
                    2550136832: 33280,
                    2818572288: 8421376,
                    3087007744: 8389122,
                    3355443200: 8388610,
                    3623878656: 32770,
                    3892314112: 514,
                    4160749568: 8388608,
                    1: 32768,
                    268435457: 2,
                    536870913: 8421888,
                    805306369: 8388608,
                    1073741825: 8421378,
                    1342177281: 33280,
                    1610612737: 512,
                    1879048193: 8389122,
                    2147483649: 8421890,
                    2415919105: 8421376,
                    2684354561: 8388610,
                    2952790017: 33282,
                    3221225473: 514,
                    3489660929: 8389120,
                    3758096385: 32770,
                    4026531841: 0,
                    134217729: 8421890,
                    402653185: 8421376,
                    671088641: 8388608,
                    939524097: 512,
                    1207959553: 32768,
                    1476395009: 8388610,
                    1744830465: 2,
                    2013265921: 33282,
                    2281701377: 32770,
                    2550136833: 8389122,
                    2818572289: 514,
                    3087007745: 8421888,
                    3355443201: 8389120,
                    3623878657: 0,
                    3892314113: 33280,
                    4160749569: 8421378
                  }, {
                    0: 1074282512,
                    16777216: 16384,
                    33554432: 524288,
                    50331648: 1074266128,
                    67108864: 1073741840,
                    83886080: 1074282496,
                    100663296: 1073758208,
                    117440512: 16,
                    134217728: 540672,
                    150994944: 1073758224,
                    167772160: 1073741824,
                    184549376: 540688,
                    201326592: 524304,
                    218103808: 0,
                    234881024: 16400,
                    251658240: 1074266112,
                    8388608: 1073758208,
                    25165824: 540688,
                    41943040: 16,
                    58720256: 1073758224,
                    75497472: 1074282512,
                    92274688: 1073741824,
                    109051904: 524288,
                    125829120: 1074266128,
                    142606336: 524304,
                    159383552: 0,
                    176160768: 16384,
                    192937984: 1074266112,
                    209715200: 1073741840,
                    226492416: 540672,
                    243269632: 1074282496,
                    260046848: 16400,
                    268435456: 0,
                    285212672: 1074266128,
                    301989888: 1073758224,
                    318767104: 1074282496,
                    335544320: 1074266112,
                    352321536: 16,
                    369098752: 540688,
                    385875968: 16384,
                    402653184: 16400,
                    419430400: 524288,
                    436207616: 524304,
                    452984832: 1073741840,
                    469762048: 540672,
                    486539264: 1073758208,
                    503316480: 1073741824,
                    520093696: 1074282512,
                    276824064: 540688,
                    293601280: 524288,
                    310378496: 1074266112,
                    327155712: 16384,
                    343932928: 1073758208,
                    360710144: 1074282512,
                    377487360: 16,
                    394264576: 1073741824,
                    411041792: 1074282496,
                    427819008: 1073741840,
                    444596224: 1073758224,
                    461373440: 524304,
                    478150656: 0,
                    494927872: 16400,
                    511705088: 1074266128,
                    528482304: 540672
                  }, {
                    0: 260,
                    1048576: 0,
                    2097152: 67109120,
                    3145728: 65796,
                    4194304: 65540,
                    5242880: 67108868,
                    6291456: 67174660,
                    7340032: 67174400,
                    8388608: 67108864,
                    9437184: 67174656,
                    10485760: 65792,
                    11534336: 67174404,
                    12582912: 67109124,
                    13631488: 65536,
                    14680064: 4,
                    15728640: 256,
                    524288: 67174656,
                    1572864: 67174404,
                    2621440: 0,
                    3670016: 67109120,
                    4718592: 67108868,
                    5767168: 65536,
                    6815744: 65540,
                    7864320: 260,
                    8912896: 4,
                    9961472: 256,
                    11010048: 67174400,
                    12058624: 65796,
                    13107200: 65792,
                    14155776: 67109124,
                    15204352: 67174660,
                    16252928: 67108864,
                    16777216: 67174656,
                    17825792: 65540,
                    18874368: 65536,
                    19922944: 67109120,
                    20971520: 256,
                    22020096: 67174660,
                    23068672: 67108868,
                    24117248: 0,
                    25165824: 67109124,
                    26214400: 67108864,
                    27262976: 4,
                    28311552: 65792,
                    29360128: 67174400,
                    30408704: 260,
                    31457280: 65796,
                    32505856: 67174404,
                    17301504: 67108864,
                    18350080: 260,
                    19398656: 67174656,
                    20447232: 0,
                    21495808: 65540,
                    22544384: 67109120,
                    23592960: 256,
                    24641536: 67174404,
                    25690112: 65536,
                    26738688: 67174660,
                    27787264: 65796,
                    28835840: 67108868,
                    29884416: 67109124,
                    30932992: 67174400,
                    31981568: 4,
                    33030144: 65792
                  }, {
                    0: 2151682048,
                    65536: 2147487808,
                    131072: 4198464,
                    196608: 2151677952,
                    262144: 0,
                    327680: 4198400,
                    393216: 2147483712,
                    458752: 4194368,
                    524288: 2147483648,
                    589824: 4194304,
                    655360: 64,
                    720896: 2147487744,
                    786432: 2151678016,
                    851968: 4160,
                    917504: 4096,
                    983040: 2151682112,
                    32768: 2147487808,
                    98304: 64,
                    163840: 2151678016,
                    229376: 2147487744,
                    294912: 4198400,
                    360448: 2151682112,
                    425984: 0,
                    491520: 2151677952,
                    557056: 4096,
                    622592: 2151682048,
                    688128: 4194304,
                    753664: 4160,
                    819200: 2147483648,
                    884736: 4194368,
                    950272: 4198464,
                    1015808: 2147483712,
                    1048576: 4194368,
                    1114112: 4198400,
                    1179648: 2147483712,
                    1245184: 0,
                    1310720: 4160,
                    1376256: 2151678016,
                    1441792: 2151682048,
                    1507328: 2147487808,
                    1572864: 2151682112,
                    1638400: 2147483648,
                    1703936: 2151677952,
                    1769472: 4198464,
                    1835008: 2147487744,
                    1900544: 4194304,
                    1966080: 64,
                    2031616: 4096,
                    1081344: 2151677952,
                    1146880: 2151682112,
                    1212416: 0,
                    1277952: 4198400,
                    1343488: 4194368,
                    1409024: 2147483648,
                    1474560: 2147487808,
                    1540096: 64,
                    1605632: 2147483712,
                    1671168: 4096,
                    1736704: 2147487744,
                    1802240: 2151678016,
                    1867776: 4160,
                    1933312: 2151682048,
                    1998848: 4194304,
                    2064384: 4198464
                  }, {
                    0: 128,
                    4096: 17039360,
                    8192: 262144,
                    12288: 536870912,
                    16384: 537133184,
                    20480: 16777344,
                    24576: 553648256,
                    28672: 262272,
                    32768: 16777216,
                    36864: 537133056,
                    40960: 536871040,
                    45056: 553910400,
                    49152: 553910272,
                    53248: 0,
                    57344: 17039488,
                    61440: 553648128,
                    2048: 17039488,
                    6144: 553648256,
                    10240: 128,
                    14336: 17039360,
                    18432: 262144,
                    22528: 537133184,
                    26624: 553910272,
                    30720: 536870912,
                    34816: 537133056,
                    38912: 0,
                    43008: 553910400,
                    47104: 16777344,
                    51200: 536871040,
                    55296: 553648128,
                    59392: 16777216,
                    63488: 262272,
                    65536: 262144,
                    69632: 128,
                    73728: 536870912,
                    77824: 553648256,
                    81920: 16777344,
                    86016: 553910272,
                    90112: 537133184,
                    94208: 16777216,
                    98304: 553910400,
                    102400: 553648128,
                    106496: 17039360,
                    110592: 537133056,
                    114688: 262272,
                    118784: 536871040,
                    122880: 0,
                    126976: 17039488,
                    67584: 553648256,
                    71680: 16777216,
                    75776: 17039360,
                    79872: 537133184,
                    83968: 536870912,
                    88064: 17039488,
                    92160: 128,
                    96256: 553910272,
                    100352: 262272,
                    104448: 553910400,
                    108544: 0,
                    112640: 553648128,
                    116736: 16777344,
                    120832: 262144,
                    124928: 537133056,
                    129024: 536871040
                  }, {
                    0: 268435464,
                    256: 8192,
                    512: 270532608,
                    768: 270540808,
                    1024: 268443648,
                    1280: 2097152,
                    1536: 2097160,
                    1792: 268435456,
                    2048: 0,
                    2304: 268443656,
                    2560: 2105344,
                    2816: 8,
                    3072: 270532616,
                    3328: 2105352,
                    3584: 8200,
                    3840: 270540800,
                    128: 270532608,
                    384: 270540808,
                    640: 8,
                    896: 2097152,
                    1152: 2105352,
                    1408: 268435464,
                    1664: 268443648,
                    1920: 8200,
                    2176: 2097160,
                    2432: 8192,
                    2688: 268443656,
                    2944: 270532616,
                    3200: 0,
                    3456: 270540800,
                    3712: 2105344,
                    3968: 268435456,
                    4096: 268443648,
                    4352: 270532616,
                    4608: 270540808,
                    4864: 8200,
                    5120: 2097152,
                    5376: 268435456,
                    5632: 268435464,
                    5888: 2105344,
                    6144: 2105352,
                    6400: 0,
                    6656: 8,
                    6912: 270532608,
                    7168: 8192,
                    7424: 268443656,
                    7680: 270540800,
                    7936: 2097160,
                    4224: 8,
                    4480: 2105344,
                    4736: 2097152,
                    4992: 268435464,
                    5248: 268443648,
                    5504: 8200,
                    5760: 270540808,
                    6016: 270532608,
                    6272: 270540800,
                    6528: 270532616,
                    6784: 8192,
                    7040: 2105352,
                    7296: 2097160,
                    7552: 0,
                    7808: 268435456,
                    8064: 268443656
                  }, {
                    0: 1048576,
                    16: 33555457,
                    32: 1024,
                    48: 1049601,
                    64: 34604033,
                    80: 0,
                    96: 1,
                    112: 34603009,
                    128: 33555456,
                    144: 1048577,
                    160: 33554433,
                    176: 34604032,
                    192: 34603008,
                    208: 1025,
                    224: 1049600,
                    240: 33554432,
                    8: 34603009,
                    24: 0,
                    40: 33555457,
                    56: 34604032,
                    72: 1048576,
                    88: 33554433,
                    104: 33554432,
                    120: 1025,
                    136: 1049601,
                    152: 33555456,
                    168: 34603008,
                    184: 1048577,
                    200: 1024,
                    216: 34604033,
                    232: 1,
                    248: 1049600,
                    256: 33554432,
                    272: 1048576,
                    288: 33555457,
                    304: 34603009,
                    320: 1048577,
                    336: 33555456,
                    352: 34604032,
                    368: 1049601,
                    384: 1025,
                    400: 34604033,
                    416: 1049600,
                    432: 1,
                    448: 0,
                    464: 34603008,
                    480: 33554433,
                    496: 1024,
                    264: 1049600,
                    280: 33555457,
                    296: 34603009,
                    312: 1,
                    328: 33554432,
                    344: 1048576,
                    360: 1025,
                    376: 34604032,
                    392: 33554433,
                    408: 34603008,
                    424: 0,
                    440: 34604033,
                    456: 1049601,
                    472: 1024,
                    488: 33555456,
                    504: 1048577
                  }, {
                    0: 134219808,
                    1: 131072,
                    2: 134217728,
                    3: 32,
                    4: 131104,
                    5: 134350880,
                    6: 134350848,
                    7: 2048,
                    8: 134348800,
                    9: 134219776,
                    10: 133120,
                    11: 134348832,
                    12: 2080,
                    13: 0,
                    14: 134217760,
                    15: 133152,
                    2147483648: 2048,
                    2147483649: 134350880,
                    2147483650: 134219808,
                    2147483651: 134217728,
                    2147483652: 134348800,
                    2147483653: 133120,
                    2147483654: 133152,
                    2147483655: 32,
                    2147483656: 134217760,
                    2147483657: 2080,
                    2147483658: 131104,
                    2147483659: 134350848,
                    2147483660: 0,
                    2147483661: 134348832,
                    2147483662: 134219776,
                    2147483663: 131072,
                    16: 133152,
                    17: 134350848,
                    18: 32,
                    19: 2048,
                    20: 134219776,
                    21: 134217760,
                    22: 134348832,
                    23: 131072,
                    24: 0,
                    25: 131104,
                    26: 134348800,
                    27: 134219808,
                    28: 134350880,
                    29: 133120,
                    30: 2080,
                    31: 134217728,
                    2147483664: 131072,
                    2147483665: 2048,
                    2147483666: 134348832,
                    2147483667: 133152,
                    2147483668: 32,
                    2147483669: 134348800,
                    2147483670: 134217728,
                    2147483671: 134219808,
                    2147483672: 134350880,
                    2147483673: 134217760,
                    2147483674: 134219776,
                    2147483675: 0,
                    2147483676: 133120,
                    2147483677: 2080,
                    2147483678: 131104,
                    2147483679: 134350848
                  }], y = [4160749569, 528482304, 33030144, 2064384, 129024, 8064, 504, 2147483679], b = p.DES = v.extend({
                    _doReset: function() {
                      for (var O = this._key, C = O.words, T = [], P = 0; P < 56; P++) {
                        var I = m[P] - 1;
                        T[P] = C[I >>> 5] >>> 31 - I % 32 & 1;
                      }
                      for (var F = this._subKeys = [], B = 0; B < 16; B++) {
                        for (var M = F[B] = [], z = g[B], P = 0; P < 24; P++)
                          M[P / 6 | 0] |= T[(x[P] - 1 + z) % 28] << 31 - P % 6, M[4 + (P / 6 | 0)] |= T[28 + (x[P + 24] - 1 + z) % 28] << 31 - P % 6;
                        M[0] = M[0] << 1 | M[0] >>> 31;
                        for (var P = 1; P < 7; P++)
                          M[P] = M[P] >>> (P - 1) * 4 + 3;
                        M[7] = M[7] << 5 | M[7] >>> 27;
                      }
                      for (var L = this._invSubKeys = [], P = 0; P < 16; P++)
                        L[P] = F[15 - P];
                    },
                    encryptBlock: function(O, C) {
                      this._doCryptBlock(O, C, this._subKeys);
                    },
                    decryptBlock: function(O, C) {
                      this._doCryptBlock(O, C, this._invSubKeys);
                    },
                    _doCryptBlock: function(O, C, T) {
                      this._lBlock = O[C], this._rBlock = O[C + 1], n.call(this, 4, 252645135), n.call(this, 16, 65535), w.call(this, 2, 858993459), w.call(this, 8, 16711935), n.call(this, 1, 1431655765);
                      for (var P = 0; P < 16; P++) {
                        for (var I = T[P], F = this._lBlock, B = this._rBlock, M = 0, z = 0; z < 8; z++)
                          M |= S[z][((B ^ I[z]) & y[z]) >>> 0];
                        this._lBlock = B, this._rBlock = F ^ M;
                      }
                      var L = this._lBlock;
                      this._lBlock = this._rBlock, this._rBlock = L, n.call(this, 1, 1431655765), w.call(this, 8, 16711935), w.call(this, 2, 858993459), n.call(this, 16, 65535), n.call(this, 4, 252645135), O[C] = this._lBlock, O[C + 1] = this._rBlock;
                    },
                    keySize: 64 / 32,
                    ivSize: 64 / 32,
                    blockSize: 64 / 32
                  });
                  function n(A, O) {
                    var C = (this._lBlock >>> A ^ this._rBlock) & O;
                    this._rBlock ^= C, this._lBlock ^= C << A;
                  }
                  function w(A, O) {
                    var C = (this._rBlock >>> A ^ this._lBlock) & O;
                    this._lBlock ^= C, this._rBlock ^= C << A;
                  }
                  i.DES = v._createHelper(b);
                  var E = p.TripleDES = v.extend({
                    _doReset: function() {
                      var O = this._key, C = O.words;
                      if (C.length !== 2 && C.length !== 4 && C.length < 6)
                        throw new Error("Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.");
                      var T = C.slice(0, 2), P = C.length < 4 ? C.slice(0, 2) : C.slice(2, 4), I = C.length < 6 ? C.slice(0, 2) : C.slice(4, 6);
                      this._des1 = b.createEncryptor(h.create(T)), this._des2 = b.createEncryptor(h.create(P)), this._des3 = b.createEncryptor(h.create(I));
                    },
                    encryptBlock: function(O, C) {
                      this._des1.encryptBlock(O, C), this._des2.decryptBlock(O, C), this._des3.encryptBlock(O, C);
                    },
                    decryptBlock: function(O, C) {
                      this._des3.decryptBlock(O, C), this._des2.encryptBlock(O, C), this._des1.decryptBlock(O, C);
                    },
                    keySize: 192 / 32,
                    ivSize: 64 / 32,
                    blockSize: 64 / 32
                  });
                  i.TripleDES = v._createHelper(E);
                }(), s.TripleDES;
              });
            }
          ),
          /***/
          26478: (
            /***/
            function(u, l, e) {
              e(20731), function(s, i) {
                u.exports = i(e(34559));
              }(void 0, function(s) {
                return function(i) {
                  var f = s, h = f.lib, v = h.Base, p = h.WordArray, m = f.x64 = {};
                  m.Word = v.extend({
                    /**
                     * Initializes a newly created 64-bit word.
                     *
                     * @param {number} high The high 32 bits.
                     * @param {number} low The low 32 bits.
                     *
                     * @example
                     *
                     *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
                     */
                    init: function(g, S) {
                      this.high = g, this.low = S;
                    }
                    /**
                     * Bitwise NOTs this word.
                     *
                     * @return {X64Word} A new x64-Word object after negating.
                     *
                     * @example
                     *
                     *     var negated = x64Word.not();
                     */
                    // not: function () {
                    // var high = ~this.high;
                    // var low = ~this.low;
                    // return X64Word.create(high, low);
                    // },
                    /**
                     * Bitwise ANDs this word with the passed word.
                     *
                     * @param {X64Word} word The x64-Word to AND with this word.
                     *
                     * @return {X64Word} A new x64-Word object after ANDing.
                     *
                     * @example
                     *
                     *     var anded = x64Word.and(anotherX64Word);
                     */
                    // and: function (word) {
                    // var high = this.high & word.high;
                    // var low = this.low & word.low;
                    // return X64Word.create(high, low);
                    // },
                    /**
                     * Bitwise ORs this word with the passed word.
                     *
                     * @param {X64Word} word The x64-Word to OR with this word.
                     *
                     * @return {X64Word} A new x64-Word object after ORing.
                     *
                     * @example
                     *
                     *     var ored = x64Word.or(anotherX64Word);
                     */
                    // or: function (word) {
                    // var high = this.high | word.high;
                    // var low = this.low | word.low;
                    // return X64Word.create(high, low);
                    // },
                    /**
                     * Bitwise XORs this word with the passed word.
                     *
                     * @param {X64Word} word The x64-Word to XOR with this word.
                     *
                     * @return {X64Word} A new x64-Word object after XORing.
                     *
                     * @example
                     *
                     *     var xored = x64Word.xor(anotherX64Word);
                     */
                    // xor: function (word) {
                    // var high = this.high ^ word.high;
                    // var low = this.low ^ word.low;
                    // return X64Word.create(high, low);
                    // },
                    /**
                     * Shifts this word n bits to the left.
                     *
                     * @param {number} n The number of bits to shift.
                     *
                     * @return {X64Word} A new x64-Word object after shifting.
                     *
                     * @example
                     *
                     *     var shifted = x64Word.shiftL(25);
                     */
                    // shiftL: function (n) {
                    // if (n < 32) {
                    // var high = (this.high << n) | (this.low >>> (32 - n));
                    // var low = this.low << n;
                    // } else {
                    // var high = this.low << (n - 32);
                    // var low = 0;
                    // }
                    // return X64Word.create(high, low);
                    // },
                    /**
                     * Shifts this word n bits to the right.
                     *
                     * @param {number} n The number of bits to shift.
                     *
                     * @return {X64Word} A new x64-Word object after shifting.
                     *
                     * @example
                     *
                     *     var shifted = x64Word.shiftR(7);
                     */
                    // shiftR: function (n) {
                    // if (n < 32) {
                    // var low = (this.low >>> n) | (this.high << (32 - n));
                    // var high = this.high >>> n;
                    // } else {
                    // var low = this.high >>> (n - 32);
                    // var high = 0;
                    // }
                    // return X64Word.create(high, low);
                    // },
                    /**
                     * Rotates this word n bits to the left.
                     *
                     * @param {number} n The number of bits to rotate.
                     *
                     * @return {X64Word} A new x64-Word object after rotating.
                     *
                     * @example
                     *
                     *     var rotated = x64Word.rotL(25);
                     */
                    // rotL: function (n) {
                    // return this.shiftL(n).or(this.shiftR(64 - n));
                    // },
                    /**
                     * Rotates this word n bits to the right.
                     *
                     * @param {number} n The number of bits to rotate.
                     *
                     * @return {X64Word} A new x64-Word object after rotating.
                     *
                     * @example
                     *
                     *     var rotated = x64Word.rotR(7);
                     */
                    // rotR: function (n) {
                    // return this.shiftR(n).or(this.shiftL(64 - n));
                    // },
                    /**
                     * Adds this word with the passed word.
                     *
                     * @param {X64Word} word The x64-Word to add with this word.
                     *
                     * @return {X64Word} A new x64-Word object after adding.
                     *
                     * @example
                     *
                     *     var added = x64Word.add(anotherX64Word);
                     */
                    // add: function (word) {
                    // var low = (this.low + word.low) | 0;
                    // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
                    // var high = (this.high + word.high + carry) | 0;
                    // return X64Word.create(high, low);
                    // }
                  }), m.WordArray = v.extend({
                    /**
                     * Initializes a newly created word array.
                     *
                     * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
                     * @param {number} sigBytes (Optional) The number of significant bytes in the words.
                     *
                     * @example
                     *
                     *     var wordArray = CryptoJS.x64.WordArray.create();
                     *
                     *     var wordArray = CryptoJS.x64.WordArray.create([
                     *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
                     *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
                     *     ]);
                     *
                     *     var wordArray = CryptoJS.x64.WordArray.create([
                     *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
                     *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
                     *     ], 10);
                     */
                    init: function(g, S) {
                      g = this.words = g || [], S != i ? this.sigBytes = S : this.sigBytes = g.length * 8;
                    },
                    /**
                     * Converts this 64-bit word array to a 32-bit word array.
                     *
                     * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
                     *
                     * @example
                     *
                     *     var x32WordArray = x64WordArray.toX32();
                     */
                    toX32: function() {
                      for (var g = this.words, S = g.length, y = [], b = 0; b < S; b++) {
                        var n = g[b];
                        y.push(n.high), y.push(n.low);
                      }
                      return p.create(y, this.sigBytes);
                    },
                    /**
                     * Creates a copy of this word array.
                     *
                     * @return {X64WordArray} The clone.
                     *
                     * @example
                     *
                     *     var clone = x64WordArray.clone();
                     */
                    clone: function() {
                      for (var g = v.clone.call(this), S = g.words = this.words.slice(0), y = S.length, b = 0; b < y; b++)
                        S[b] = S[b].clone();
                      return g;
                    }
                  });
                }(), s;
              });
            }
          ),
          /***/
          91836: (
            /***/
            function(u, l, e) {
              e(35877), e(38178), e(11765), e(24863), e(43448), e(63956), e(71950), e(68067), e(57114), e(42437), e(65292), e(73844), e(69330), e(81755), e(20731), e(14032), e(61726), e(58281), e(6422), e(94712);
              function s(x, g) {
                var S = typeof Symbol < "u" && x[Symbol.iterator] || x["@@iterator"];
                if (S)
                  return (S = S.call(x)).next.bind(S);
                if (Array.isArray(x) || (S = i(x)) || g && x && typeof x.length == "number") {
                  S && (x = S);
                  var y = 0;
                  return function() {
                    return y >= x.length ? { done: !0 } : { done: !1, value: x[y++] };
                  };
                }
                throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }
              function i(x, g) {
                if (x) {
                  if (typeof x == "string")
                    return f(x, g);
                  var S = Object.prototype.toString.call(x).slice(8, -1);
                  if (S === "Object" && x.constructor && (S = x.constructor.name), S === "Map" || S === "Set")
                    return Array.from(x);
                  if (S === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(S))
                    return f(x, g);
                }
              }
              function f(x, g) {
                (g == null || g > x.length) && (g = x.length);
                for (var S = 0, y = new Array(g); S < g; S++)
                  y[S] = x[S];
                return y;
              }
              function h() {
                /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
                h = function() {
                  return g;
                };
                var x, g = {}, S = Object.prototype, y = S.hasOwnProperty, b = Object.defineProperty || function(rt, wt, Ft) {
                  rt[wt] = Ft.value;
                }, n = typeof Symbol == "function" ? Symbol : {}, w = n.iterator || "@@iterator", E = n.asyncIterator || "@@asyncIterator", A = n.toStringTag || "@@toStringTag";
                function O(rt, wt, Ft) {
                  return Object.defineProperty(rt, wt, { value: Ft, enumerable: !0, configurable: !0, writable: !0 }), rt[wt];
                }
                try {
                  O({}, "");
                } catch {
                  O = function(Ft, zt, G) {
                    return Ft[zt] = G;
                  };
                }
                function C(rt, wt, Ft, zt) {
                  var G = wt && wt.prototype instanceof z ? wt : z, D = Object.create(G.prototype), Z = new gt(zt || []);
                  return b(D, "_invoke", { value: Rt(rt, Ft, Z) }), D;
                }
                function T(rt, wt, Ft) {
                  try {
                    return { type: "normal", arg: rt.call(wt, Ft) };
                  } catch (zt) {
                    return { type: "throw", arg: zt };
                  }
                }
                g.wrap = C;
                var P = "suspendedStart", I = "suspendedYield", F = "executing", B = "completed", M = {};
                function z() {
                }
                function L() {
                }
                function J() {
                }
                var ft = {};
                O(ft, w, function() {
                  return this;
                });
                var Q = Object.getPrototypeOf, xt = Q && Q(Q(st([])));
                xt && xt !== S && y.call(xt, w) && (ft = xt);
                var St = J.prototype = z.prototype = Object.create(ft);
                function Pt(rt) {
                  ["next", "throw", "return"].forEach(function(wt) {
                    O(rt, wt, function(Ft) {
                      return this._invoke(wt, Ft);
                    });
                  });
                }
                function Gt(rt, wt) {
                  function Ft(G, D, Z, et) {
                    var vt = T(rt[G], rt, D);
                    if (vt.type !== "throw") {
                      var lt = vt.arg, dt = lt.value;
                      return dt && typeof dt == "object" && y.call(dt, "__await") ? wt.resolve(dt.__await).then(function(kt) {
                        Ft("next", kt, Z, et);
                      }, function(kt) {
                        Ft("throw", kt, Z, et);
                      }) : wt.resolve(dt).then(function(kt) {
                        lt.value = kt, Z(lt);
                      }, function(kt) {
                        return Ft("throw", kt, Z, et);
                      });
                    }
                    et(vt.arg);
                  }
                  var zt;
                  b(this, "_invoke", { value: function(D, Z) {
                    function et() {
                      return new wt(function(vt, lt) {
                        Ft(D, Z, vt, lt);
                      });
                    }
                    return zt = zt ? zt.then(et, et) : et();
                  } });
                }
                function Rt(rt, wt, Ft) {
                  var zt = P;
                  return function(G, D) {
                    if (zt === F)
                      throw new Error("Generator is already running");
                    if (zt === B) {
                      if (G === "throw")
                        throw D;
                      return { value: x, done: !0 };
                    }
                    for (Ft.method = G, Ft.arg = D; ; ) {
                      var Z = Ft.delegate;
                      if (Z) {
                        var et = bt(Z, Ft);
                        if (et) {
                          if (et === M)
                            continue;
                          return et;
                        }
                      }
                      if (Ft.method === "next")
                        Ft.sent = Ft._sent = Ft.arg;
                      else if (Ft.method === "throw") {
                        if (zt === P)
                          throw zt = B, Ft.arg;
                        Ft.dispatchException(Ft.arg);
                      } else
                        Ft.method === "return" && Ft.abrupt("return", Ft.arg);
                      zt = F;
                      var vt = T(rt, wt, Ft);
                      if (vt.type === "normal") {
                        if (zt = Ft.done ? B : I, vt.arg === M)
                          continue;
                        return { value: vt.arg, done: Ft.done };
                      }
                      vt.type === "throw" && (zt = B, Ft.method = "throw", Ft.arg = vt.arg);
                    }
                  };
                }
                function bt(rt, wt) {
                  var Ft = wt.method, zt = rt.iterator[Ft];
                  if (zt === x)
                    return wt.delegate = null, Ft === "throw" && rt.iterator.return && (wt.method = "return", wt.arg = x, bt(rt, wt), wt.method === "throw") || Ft !== "return" && (wt.method = "throw", wt.arg = new TypeError("The iterator does not provide a '" + Ft + "' method")), M;
                  var G = T(zt, rt.iterator, wt.arg);
                  if (G.type === "throw")
                    return wt.method = "throw", wt.arg = G.arg, wt.delegate = null, M;
                  var D = G.arg;
                  return D ? D.done ? (wt[rt.resultName] = D.value, wt.next = rt.nextLoc, wt.method !== "return" && (wt.method = "next", wt.arg = x), wt.delegate = null, M) : D : (wt.method = "throw", wt.arg = new TypeError("iterator result is not an object"), wt.delegate = null, M);
                }
                function Dt(rt) {
                  var wt = { tryLoc: rt[0] };
                  1 in rt && (wt.catchLoc = rt[1]), 2 in rt && (wt.finallyLoc = rt[2], wt.afterLoc = rt[3]), this.tryEntries.push(wt);
                }
                function X(rt) {
                  var wt = rt.completion || {};
                  wt.type = "normal", delete wt.arg, rt.completion = wt;
                }
                function gt(rt) {
                  this.tryEntries = [{ tryLoc: "root" }], rt.forEach(Dt, this), this.reset(!0);
                }
                function st(rt) {
                  if (rt || rt === "") {
                    var wt = rt[w];
                    if (wt)
                      return wt.call(rt);
                    if (typeof rt.next == "function")
                      return rt;
                    if (!isNaN(rt.length)) {
                      var Ft = -1, zt = function G() {
                        for (; ++Ft < rt.length; )
                          if (y.call(rt, Ft))
                            return G.value = rt[Ft], G.done = !1, G;
                        return G.value = x, G.done = !0, G;
                      };
                      return zt.next = zt;
                    }
                  }
                  throw new TypeError(typeof rt + " is not iterable");
                }
                return L.prototype = J, b(St, "constructor", { value: J, configurable: !0 }), b(J, "constructor", { value: L, configurable: !0 }), L.displayName = O(J, A, "GeneratorFunction"), g.isGeneratorFunction = function(rt) {
                  var wt = typeof rt == "function" && rt.constructor;
                  return !!wt && (wt === L || (wt.displayName || wt.name) === "GeneratorFunction");
                }, g.mark = function(rt) {
                  return Object.setPrototypeOf ? Object.setPrototypeOf(rt, J) : (rt.__proto__ = J, O(rt, A, "GeneratorFunction")), rt.prototype = Object.create(St), rt;
                }, g.awrap = function(rt) {
                  return { __await: rt };
                }, Pt(Gt.prototype), O(Gt.prototype, E, function() {
                  return this;
                }), g.AsyncIterator = Gt, g.async = function(rt, wt, Ft, zt, G) {
                  G === void 0 && (G = Promise);
                  var D = new Gt(C(rt, wt, Ft, zt), G);
                  return g.isGeneratorFunction(wt) ? D : D.next().then(function(Z) {
                    return Z.done ? Z.value : D.next();
                  });
                }, Pt(St), O(St, A, "Generator"), O(St, w, function() {
                  return this;
                }), O(St, "toString", function() {
                  return "[object Generator]";
                }), g.keys = function(rt) {
                  var wt = Object(rt), Ft = [];
                  for (var zt in wt)
                    Ft.push(zt);
                  return Ft.reverse(), function G() {
                    for (; Ft.length; ) {
                      var D = Ft.pop();
                      if (D in wt)
                        return G.value = D, G.done = !1, G;
                    }
                    return G.done = !0, G;
                  };
                }, g.values = st, gt.prototype = { constructor: gt, reset: function(wt) {
                  if (this.prev = 0, this.next = 0, this.sent = this._sent = x, this.done = !1, this.delegate = null, this.method = "next", this.arg = x, this.tryEntries.forEach(X), !wt)
                    for (var Ft in this)
                      Ft.charAt(0) === "t" && y.call(this, Ft) && !isNaN(+Ft.slice(1)) && (this[Ft] = x);
                }, stop: function() {
                  this.done = !0;
                  var wt = this.tryEntries[0].completion;
                  if (wt.type === "throw")
                    throw wt.arg;
                  return this.rval;
                }, dispatchException: function(wt) {
                  if (this.done)
                    throw wt;
                  var Ft = this;
                  function zt(lt, dt) {
                    return Z.type = "throw", Z.arg = wt, Ft.next = lt, dt && (Ft.method = "next", Ft.arg = x), !!dt;
                  }
                  for (var G = this.tryEntries.length - 1; G >= 0; --G) {
                    var D = this.tryEntries[G], Z = D.completion;
                    if (D.tryLoc === "root")
                      return zt("end");
                    if (D.tryLoc <= this.prev) {
                      var et = y.call(D, "catchLoc"), vt = y.call(D, "finallyLoc");
                      if (et && vt) {
                        if (this.prev < D.catchLoc)
                          return zt(D.catchLoc, !0);
                        if (this.prev < D.finallyLoc)
                          return zt(D.finallyLoc);
                      } else if (et) {
                        if (this.prev < D.catchLoc)
                          return zt(D.catchLoc, !0);
                      } else {
                        if (!vt)
                          throw new Error("try statement without catch or finally");
                        if (this.prev < D.finallyLoc)
                          return zt(D.finallyLoc);
                      }
                    }
                  }
                }, abrupt: function(wt, Ft) {
                  for (var zt = this.tryEntries.length - 1; zt >= 0; --zt) {
                    var G = this.tryEntries[zt];
                    if (G.tryLoc <= this.prev && y.call(G, "finallyLoc") && this.prev < G.finallyLoc) {
                      var D = G;
                      break;
                    }
                  }
                  D && (wt === "break" || wt === "continue") && D.tryLoc <= Ft && Ft <= D.finallyLoc && (D = null);
                  var Z = D ? D.completion : {};
                  return Z.type = wt, Z.arg = Ft, D ? (this.method = "next", this.next = D.finallyLoc, M) : this.complete(Z);
                }, complete: function(wt, Ft) {
                  if (wt.type === "throw")
                    throw wt.arg;
                  return wt.type === "break" || wt.type === "continue" ? this.next = wt.arg : wt.type === "return" ? (this.rval = this.arg = wt.arg, this.method = "return", this.next = "end") : wt.type === "normal" && Ft && (this.next = Ft), M;
                }, finish: function(wt) {
                  for (var Ft = this.tryEntries.length - 1; Ft >= 0; --Ft) {
                    var zt = this.tryEntries[Ft];
                    if (zt.finallyLoc === wt)
                      return this.complete(zt.completion, zt.afterLoc), X(zt), M;
                  }
                }, catch: function(wt) {
                  for (var Ft = this.tryEntries.length - 1; Ft >= 0; --Ft) {
                    var zt = this.tryEntries[Ft];
                    if (zt.tryLoc === wt) {
                      var G = zt.completion;
                      if (G.type === "throw") {
                        var D = G.arg;
                        X(zt);
                      }
                      return D;
                    }
                  }
                  throw new Error("illegal catch attempt");
                }, delegateYield: function(wt, Ft, zt) {
                  return this.delegate = { iterator: st(wt), resultName: Ft, nextLoc: zt }, this.method === "next" && (this.arg = x), M;
                } }, g;
              }
              var v = 1, p = 0, m = /* @__PURE__ */ function() {
                function x(S) {
                  this.stateTable = S.stateTable, this.accepting = S.accepting, this.tags = S.tags;
                }
                var g = x.prototype;
                return g.match = function(y) {
                  var b, n = this;
                  return b = {}, b[Symbol.iterator] = /* @__PURE__ */ h().mark(function w() {
                    var E, A, O, C, T, P;
                    return h().wrap(function(F) {
                      for (; ; )
                        switch (F.prev = F.next) {
                          case 0:
                            E = v, A = null, O = null, C = null, T = 0;
                          case 5:
                            if (!(T < y.length)) {
                              F.next = 21;
                              break;
                            }
                            if (P = y[T], C = E, E = n.stateTable[E][P], E !== p) {
                              F.next = 15;
                              break;
                            }
                            if (!(A != null && O != null && O >= A)) {
                              F.next = 13;
                              break;
                            }
                            return F.next = 13, [A, O, n.tags[C]];
                          case 13:
                            E = n.stateTable[v][P], A = null;
                          case 15:
                            E !== p && A == null && (A = T), n.accepting[E] && (O = T), E === p && (E = v);
                          case 18:
                            T++, F.next = 5;
                            break;
                          case 21:
                            if (!(A != null && O != null && O >= A)) {
                              F.next = 24;
                              break;
                            }
                            return F.next = 24, [A, O, n.tags[E]];
                          case 24:
                          case "end":
                            return F.stop();
                        }
                    }, w);
                  }), b;
                }, g.apply = function(y, b) {
                  for (var n = s(this.match(y)), w; !(w = n()).done; )
                    for (var E = w.value, A = E[0], O = E[1], C = E[2], T = s(C), P; !(P = T()).done; ) {
                      var I = P.value;
                      typeof b[I] == "function" && b[I](A, O, y.slice(A, O + 1));
                    }
                }, x;
              }();
              u.exports = m;
            }
          ),
          /***/
          80646: (
            /***/
            function(u, l, e) {
              var s = e(50621).Buffer;
              e(58028), e(20731), e(14032), e(68067);
              var i = e(48181), f = e(6729);
              u.exports = /* @__PURE__ */ function() {
                h.decode = function(m, x) {
                  return i.readFile(m, function(g, S) {
                    var y = new h(S);
                    return y.decode(function(b) {
                      return x(b);
                    });
                  });
                }, h.load = function(m) {
                  var x = i.readFileSync(m);
                  return new h(x);
                };
                function h(p) {
                  var m;
                  for (this.data = p, this.pos = 8, this.palette = [], this.imgData = [], this.transparency = {}, this.text = {}; ; ) {
                    var x = this.readUInt32(), g = "";
                    for (m = 0; m < 4; m++)
                      g += String.fromCharCode(this.data[this.pos++]);
                    switch (g) {
                      case "IHDR":
                        this.width = this.readUInt32(), this.height = this.readUInt32(), this.bits = this.data[this.pos++], this.colorType = this.data[this.pos++], this.compressionMethod = this.data[this.pos++], this.filterMethod = this.data[this.pos++], this.interlaceMethod = this.data[this.pos++];
                        break;
                      case "PLTE":
                        this.palette = this.read(x);
                        break;
                      case "IDAT":
                        for (m = 0; m < x; m++)
                          this.imgData.push(this.data[this.pos++]);
                        break;
                      case "tRNS":
                        switch (this.transparency = {}, this.colorType) {
                          case 3:
                            this.transparency.indexed = this.read(x);
                            var S = 255 - this.transparency.indexed.length;
                            if (S > 0)
                              for (m = 0; m < S; m++)
                                this.transparency.indexed.push(255);
                            break;
                          case 0:
                            this.transparency.grayscale = this.read(x)[0];
                            break;
                          case 2:
                            this.transparency.rgb = this.read(x);
                            break;
                        }
                        break;
                      case "tEXt":
                        var y = this.read(x), b = y.indexOf(0), n = String.fromCharCode.apply(String, y.slice(0, b));
                        this.text[n] = String.fromCharCode.apply(String, y.slice(b + 1));
                        break;
                      case "IEND":
                        switch (this.colorType) {
                          case 0:
                          case 3:
                          case 4:
                            this.colors = 1;
                            break;
                          case 2:
                          case 6:
                            this.colors = 3;
                            break;
                        }
                        this.hasAlphaChannel = [4, 6].includes(this.colorType);
                        var w = this.colors + (this.hasAlphaChannel ? 1 : 0);
                        switch (this.pixelBitlength = this.bits * w, this.colors) {
                          case 1:
                            this.colorSpace = "DeviceGray";
                            break;
                          case 3:
                            this.colorSpace = "DeviceRGB";
                            break;
                        }
                        this.imgData = new s(this.imgData);
                        return;
                      default:
                        this.pos += x;
                    }
                    if (this.pos += 4, this.pos > this.data.length)
                      throw new Error("Incomplete or corrupt PNG file");
                  }
                }
                var v = h.prototype;
                return v.read = function(m) {
                  for (var x = new Array(m), g = 0; g < m; g++)
                    x[g] = this.data[this.pos++];
                  return x;
                }, v.readUInt32 = function() {
                  var m = this.data[this.pos++] << 24, x = this.data[this.pos++] << 16, g = this.data[this.pos++] << 8, S = this.data[this.pos++];
                  return m | x | g | S;
                }, v.readUInt16 = function() {
                  var m = this.data[this.pos++] << 8, x = this.data[this.pos++];
                  return m | x;
                }, v.decodePixels = function(m) {
                  var x = this;
                  return f.inflate(this.imgData, function(g, S) {
                    if (g)
                      throw g;
                    var y = x.width, b = x.height, n = x.pixelBitlength / 8, w = new s(y * b * n), E = S.length, A = 0;
                    function O(C, T, P, I, F) {
                      F === void 0 && (F = !1);
                      for (var B = Math.ceil((y - C) / P), M = Math.ceil((b - T) / I), z = n * B, L = F ? w : new s(z * M), J = 0, ft = 0; J < M && A < E; ) {
                        var Q, xt, St, Pt, Gt;
                        switch (S[A++]) {
                          case 0:
                            for (St = 0; St < z; St++)
                              L[ft++] = S[A++];
                            break;
                          case 1:
                            for (St = 0; St < z; St++)
                              Q = S[A++], Pt = St < n ? 0 : L[ft - n], L[ft++] = (Q + Pt) % 256;
                            break;
                          case 2:
                            for (St = 0; St < z; St++)
                              Q = S[A++], xt = (St - St % n) / n, Gt = J && L[(J - 1) * z + xt * n + St % n], L[ft++] = (Gt + Q) % 256;
                            break;
                          case 3:
                            for (St = 0; St < z; St++)
                              Q = S[A++], xt = (St - St % n) / n, Pt = St < n ? 0 : L[ft - n], Gt = J && L[(J - 1) * z + xt * n + St % n], L[ft++] = (Q + Math.floor((Pt + Gt) / 2)) % 256;
                            break;
                          case 4:
                            for (St = 0; St < z; St++) {
                              var Rt, bt;
                              Q = S[A++], xt = (St - St % n) / n, Pt = St < n ? 0 : L[ft - n], J === 0 ? Gt = bt = 0 : (Gt = L[(J - 1) * z + xt * n + St % n], bt = xt && L[(J - 1) * z + (xt - 1) * n + St % n]);
                              var Dt = Pt + Gt - bt, X = Math.abs(Dt - Pt), gt = Math.abs(Dt - Gt), st = Math.abs(Dt - bt);
                              X <= gt && X <= st ? Rt = Pt : gt <= st ? Rt = Gt : Rt = bt, L[ft++] = (Q + Rt) % 256;
                            }
                            break;
                          default:
                            throw new Error("Invalid filter algorithm: " + S[A - 1]);
                        }
                        if (!F) {
                          var rt = ((T + J * I) * y + C) * n, wt = J * z;
                          for (St = 0; St < B; St++) {
                            for (var Ft = 0; Ft < n; Ft++)
                              w[rt++] = L[wt++];
                            rt += (P - 1) * n;
                          }
                        }
                        J++;
                      }
                    }
                    return x.interlaceMethod === 1 ? (O(0, 0, 8, 8), O(4, 0, 8, 8), O(0, 4, 4, 8), O(2, 0, 4, 4), O(0, 2, 2, 4), O(1, 0, 2, 2), O(0, 1, 1, 2)) : O(0, 0, 1, 1, !0), m(w);
                  });
                }, v.decodePalette = function() {
                  for (var m = this.palette, x = m.length, g = this.transparency.indexed || [], S = new s(g.length + x), y = 0, b = 0, n = 0; n < x; n += 3) {
                    var w;
                    S[y++] = m[n], S[y++] = m[n + 1], S[y++] = m[n + 2], S[y++] = (w = g[b++]) != null ? w : 255;
                  }
                  return S;
                }, v.copyToImageData = function(m, x) {
                  var g, S, y = this.colors, b = null, n = this.hasAlphaChannel;
                  this.palette.length && (b = this._decodedPalette || (this._decodedPalette = this.decodePalette()), y = 4, n = !0);
                  var w = m.data || m, E = w.length, A = b || x, O = g = 0;
                  if (y === 1)
                    for (; O < E; ) {
                      S = b ? x[O / 4] * 4 : g;
                      var C = A[S++];
                      w[O++] = C, w[O++] = C, w[O++] = C, w[O++] = n ? A[S++] : 255, g = S;
                    }
                  else
                    for (; O < E; )
                      S = b ? x[O / 4] * 4 : g, w[O++] = A[S++], w[O++] = A[S++], w[O++] = A[S++], w[O++] = n ? A[S++] : 255, g = S;
                }, v.decode = function(m) {
                  var x = this, g = new s(this.width * this.height * 4);
                  return this.decodePixels(function(S) {
                    return x.copyToImageData(g, S), m(g);
                  });
                }, h;
              }();
            }
          ),
          /***/
          16696: (
            /***/
            function(u, l, e) {
              var s = e(9964);
              e(41584), e(81755), e(14032), e(56912), e(73663), e(29883), e(35471), e(21012), e(88997), e(97464), e(2857), e(83326), e(94715), e(13624), e(91132), e(62514), e(24597), e(88042), e(4660), e(92451), e(44206), e(66288), e(13250), e(3858), e(84538), e(64793), e(74202), e(52529);
              var i = e(50621), f = i.Buffer, h = {}, v;
              for (v in i)
                i.hasOwnProperty(v) && (v === "SlowBuffer" || v === "Buffer" || (h[v] = i[v]));
              var p = h.Buffer = {};
              for (v in f)
                f.hasOwnProperty(v) && (v === "allocUnsafe" || v === "allocUnsafeSlow" || (p[v] = f[v]));
              if (h.Buffer.prototype = f.prototype, (!p.from || p.from === Uint8Array.from) && (p.from = function(m, x, g) {
                if (typeof m == "number")
                  throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof m);
                if (m && typeof m.length > "u")
                  throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof m);
                return f(m, x, g);
              }), p.alloc || (p.alloc = function(m, x, g) {
                if (typeof m != "number")
                  throw new TypeError('The "size" argument must be of type number. Received type ' + typeof m);
                if (m < 0 || m >= 2147483648)
                  throw new RangeError('The value "' + m + '" is invalid for option "size"');
                var S = f(m);
                return !x || x.length === 0 ? S.fill(0) : typeof g == "string" ? S.fill(x, g) : S.fill(x), S;
              }), !h.kStringMaxLength)
                try {
                  h.kStringMaxLength = s.binding("buffer").kStringMaxLength;
                } catch {
                }
              h.constants || (h.constants = {
                MAX_LENGTH: h.kMaxLength
              }, h.kStringMaxLength && (h.constants.MAX_STRING_LENGTH = h.kStringMaxLength)), u.exports = h;
            }
          ),
          /***/
          57540: (
            /***/
            function(u, l, e) {
              e(65292), e(73844), e(5597), e(49063), e(20731), e(7585), e(7283), e(57444), e(28331), e(37309), e(14032), e(42437);
              function s(E, A) {
                var O = Object.keys(E);
                if (Object.getOwnPropertySymbols) {
                  var C = Object.getOwnPropertySymbols(E);
                  A && (C = C.filter(function(T) {
                    return Object.getOwnPropertyDescriptor(E, T).enumerable;
                  })), O.push.apply(O, C);
                }
                return O;
              }
              function i(E) {
                for (var A = 1; A < arguments.length; A++) {
                  var O = arguments[A] != null ? arguments[A] : {};
                  A % 2 ? s(Object(O), !0).forEach(function(C) {
                    f(E, C, O[C]);
                  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(E, Object.getOwnPropertyDescriptors(O)) : s(Object(O)).forEach(function(C) {
                    Object.defineProperty(E, C, Object.getOwnPropertyDescriptor(O, C));
                  });
                }
                return E;
              }
              function f(E, A, O) {
                return A = m(A), A in E ? Object.defineProperty(E, A, {
                  value: O,
                  enumerable: !0,
                  configurable: !0,
                  writable: !0
                }) : E[A] = O, E;
              }
              function h(E, A) {
                if (!(E instanceof A))
                  throw new TypeError("Cannot call a class as a function");
              }
              function v(E, A) {
                for (var O = 0; O < A.length; O++) {
                  var C = A[O];
                  C.enumerable = C.enumerable || !1, C.configurable = !0, "value" in C && (C.writable = !0), Object.defineProperty(E, m(C.key), C);
                }
              }
              function p(E, A, O) {
                return A && v(E.prototype, A), O && v(E, O), Object.defineProperty(E, "prototype", {
                  writable: !1
                }), E;
              }
              function m(E) {
                var A = x(E, "string");
                return typeof A == "symbol" ? A : String(A);
              }
              function x(E, A) {
                if (typeof E != "object" || E === null)
                  return E;
                var O = E[Symbol.toPrimitive];
                if (O !== void 0) {
                  var C = O.call(E, A || "default");
                  if (typeof C != "object")
                    return C;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (A === "string" ? String : Number)(E);
              }
              var g = e(50621), S = g.Buffer, y = e(63779), b = y.inspect, n = b && b.custom || "inspect";
              function w(E, A, O) {
                S.prototype.copy.call(E, A, O);
              }
              u.exports = /* @__PURE__ */ function() {
                function E() {
                  h(this, E), this.head = null, this.tail = null, this.length = 0;
                }
                return p(E, [{
                  key: "push",
                  value: function(O) {
                    var C = {
                      data: O,
                      next: null
                    };
                    this.length > 0 ? this.tail.next = C : this.head = C, this.tail = C, ++this.length;
                  }
                }, {
                  key: "unshift",
                  value: function(O) {
                    var C = {
                      data: O,
                      next: this.head
                    };
                    this.length === 0 && (this.tail = C), this.head = C, ++this.length;
                  }
                }, {
                  key: "shift",
                  value: function() {
                    if (this.length !== 0) {
                      var O = this.head.data;
                      return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, O;
                    }
                  }
                }, {
                  key: "clear",
                  value: function() {
                    this.head = this.tail = null, this.length = 0;
                  }
                }, {
                  key: "join",
                  value: function(O) {
                    if (this.length === 0)
                      return "";
                    for (var C = this.head, T = "" + C.data; C = C.next; )
                      T += O + C.data;
                    return T;
                  }
                }, {
                  key: "concat",
                  value: function(O) {
                    if (this.length === 0)
                      return S.alloc(0);
                    for (var C = S.allocUnsafe(O >>> 0), T = this.head, P = 0; T; )
                      w(T.data, C, P), P += T.data.length, T = T.next;
                    return C;
                  }
                  // Consumes a specified amount of bytes or characters from the buffered data.
                }, {
                  key: "consume",
                  value: function(O, C) {
                    var T;
                    return O < this.head.data.length ? (T = this.head.data.slice(0, O), this.head.data = this.head.data.slice(O)) : O === this.head.data.length ? T = this.shift() : T = C ? this._getString(O) : this._getBuffer(O), T;
                  }
                }, {
                  key: "first",
                  value: function() {
                    return this.head.data;
                  }
                  // Consumes a specified amount of characters from the buffered data.
                }, {
                  key: "_getString",
                  value: function(O) {
                    var C = this.head, T = 1, P = C.data;
                    for (O -= P.length; C = C.next; ) {
                      var I = C.data, F = O > I.length ? I.length : O;
                      if (F === I.length ? P += I : P += I.slice(0, O), O -= F, O === 0) {
                        F === I.length ? (++T, C.next ? this.head = C.next : this.head = this.tail = null) : (this.head = C, C.data = I.slice(F));
                        break;
                      }
                      ++T;
                    }
                    return this.length -= T, P;
                  }
                  // Consumes a specified amount of bytes from the buffered data.
                }, {
                  key: "_getBuffer",
                  value: function(O) {
                    var C = S.allocUnsafe(O), T = this.head, P = 1;
                    for (T.data.copy(C), O -= T.data.length; T = T.next; ) {
                      var I = T.data, F = O > I.length ? I.length : O;
                      if (I.copy(C, C.length - O, 0, F), O -= F, O === 0) {
                        F === I.length ? (++P, T.next ? this.head = T.next : this.head = this.tail = null) : (this.head = T, T.data = I.slice(F));
                        break;
                      }
                      ++P;
                    }
                    return this.length -= P, C;
                  }
                  // Make sure the linked list only shows the minimal necessary information.
                }, {
                  key: n,
                  value: function(O, C) {
                    return b(this, i(i({}, C), {}, {
                      // Only inspect one level.
                      depth: 0,
                      // It should not recurse.
                      customInspect: !1
                    }));
                  }
                }]), E;
              }();
            }
          ),
          /***/
          72361: (
            /***/
            function(u, l, e) {
              e(41584);
              var s = e(50621), i = s.Buffer;
              function f(v, p) {
                for (var m in v)
                  p[m] = v[m];
              }
              i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? u.exports = s : (f(s, l), l.Buffer = h);
              function h(v, p, m) {
                return i(v, p, m);
              }
              f(i, h), h.from = function(v, p, m) {
                if (typeof v == "number")
                  throw new TypeError("Argument must not be a number");
                return i(v, p, m);
              }, h.alloc = function(v, p, m) {
                if (typeof v != "number")
                  throw new TypeError("Argument must be a number");
                var x = i(v);
                return p !== void 0 ? typeof m == "string" ? x.fill(p, m) : x.fill(p) : x.fill(0), x;
              }, h.allocUnsafe = function(v) {
                if (typeof v != "number")
                  throw new TypeError("Argument must be a number");
                return i(v);
              }, h.allocUnsafeSlow = function(v) {
                if (typeof v != "number")
                  throw new TypeError("Argument must be a number");
                return s.SlowBuffer(v);
              };
            }
          ),
          /***/
          41209: (
            /***/
            function(u, l, e) {
              e(81755), e(20731), e(14032), e(56912), e(59735), e(73663), e(29883), e(35471), e(21012), e(88997), e(97464), e(2857), e(94715), e(13624), e(91132), e(62514), e(24597), e(88042), e(4660), e(92451), e(44206), e(66288), e(13250), e(3858), e(84538), e(64793), e(74202), e(52529);
              var s = e(3483), i = e(51014), f = i.swap32LE, h = 6 + 5, v = 5, p = h - v, m = 65536 >> h, x = 1 << p, g = x - 1, S = 2, y = 1 << v, b = y - 1, n = 65536 >> v, w = 1024 >> v, E = n + w, A = E, O = 32, C = A + O, T = 1 << S, P = /* @__PURE__ */ function() {
                function I(B) {
                  var M = typeof B.readUInt32BE == "function" && typeof B.slice == "function";
                  if (M || B instanceof Uint8Array) {
                    var z;
                    if (M)
                      this.highStart = B.readUInt32LE(0), this.errorValue = B.readUInt32LE(4), z = B.readUInt32LE(8), B = B.slice(12);
                    else {
                      var L = new DataView(B.buffer);
                      this.highStart = L.getUint32(0, !0), this.errorValue = L.getUint32(4, !0), z = L.getUint32(8, !0), B = B.subarray(12);
                    }
                    B = s(B, new Uint8Array(z)), B = s(B, new Uint8Array(z)), f(B), this.data = new Uint32Array(B.buffer);
                  } else {
                    var J = B;
                    this.data = J.data, this.highStart = J.highStart, this.errorValue = J.errorValue;
                  }
                }
                var F = I.prototype;
                return F.get = function(M) {
                  var z;
                  return M < 0 || M > 1114111 ? this.errorValue : M < 55296 || M > 56319 && M <= 65535 ? (z = (this.data[M >> v] << S) + (M & b), this.data[z]) : M <= 65535 ? (z = (this.data[n + (M - 55296 >> v)] << S) + (M & b), this.data[z]) : M < this.highStart ? (z = this.data[C - m + (M >> h)], z = this.data[z + (M >> v & g)], z = (z << S) + (M & b), this.data[z]) : this.data[this.data.length - T];
                }, I;
              }();
              u.exports = P;
            }
          ),
          /***/
          51014: (
            /***/
            function(u, l, e) {
              e(81755), e(14032), e(56912), e(59735), e(73663), e(29883), e(35471), e(21012), e(88997), e(97464), e(2857), e(94715), e(13624), e(91132), e(62514), e(24597), e(88042), e(4660), e(92451), e(44206), e(66288), e(13250), e(3858), e(84538), e(64793), e(74202), e(52529);
              var s = new Uint8Array(new Uint32Array([305419896]).buffer)[0] === 18, i = function(p, m, x) {
                var g = p[m];
                p[m] = p[x], p[x] = g;
              }, f = function(p) {
                for (var m = p.length, x = 0; x < m; x += 4)
                  i(p, x, x + 3), i(p, x + 1, x + 2);
              }, h = function(p) {
                s && f(p);
              };
              u.exports = {
                swap32LE: h
              };
            }
          ),
          /***/
          54074: (
            /***/
            function(u, l, e) {
              var s = e(94732);
              u.exports = s;
            }
          ),
          /***/
          94732: (
            /***/
            function(u, l, e) {
              u = e.nmd(u), e(39081), e(41584), e(81755), e(20731), e(24863), e(7283), e(37309), e(14032), e(61726), e(6422), e(46467), e(7851), e(72095), e(47259), e(1083), e(94712);
              var s = function(f, h, v, p, m) {
                var x = {
                  aliceblue: [240, 248, 255],
                  antiquewhite: [250, 235, 215],
                  aqua: [0, 255, 255],
                  aquamarine: [127, 255, 212],
                  azure: [240, 255, 255],
                  beige: [245, 245, 220],
                  bisque: [255, 228, 196],
                  black: [0, 0, 0],
                  blanchedalmond: [255, 235, 205],
                  blue: [0, 0, 255],
                  blueviolet: [138, 43, 226],
                  brown: [165, 42, 42],
                  burlywood: [222, 184, 135],
                  cadetblue: [95, 158, 160],
                  chartreuse: [127, 255, 0],
                  chocolate: [210, 105, 30],
                  coral: [255, 127, 80],
                  cornflowerblue: [100, 149, 237],
                  cornsilk: [255, 248, 220],
                  crimson: [220, 20, 60],
                  cyan: [0, 255, 255],
                  darkblue: [0, 0, 139],
                  darkcyan: [0, 139, 139],
                  darkgoldenrod: [184, 134, 11],
                  darkgray: [169, 169, 169],
                  darkgrey: [169, 169, 169],
                  darkgreen: [0, 100, 0],
                  darkkhaki: [189, 183, 107],
                  darkmagenta: [139, 0, 139],
                  darkolivegreen: [85, 107, 47],
                  darkorange: [255, 140, 0],
                  darkorchid: [153, 50, 204],
                  darkred: [139, 0, 0],
                  darksalmon: [233, 150, 122],
                  darkseagreen: [143, 188, 143],
                  darkslateblue: [72, 61, 139],
                  darkslategray: [47, 79, 79],
                  darkslategrey: [47, 79, 79],
                  darkturquoise: [0, 206, 209],
                  darkviolet: [148, 0, 211],
                  deeppink: [255, 20, 147],
                  deepskyblue: [0, 191, 255],
                  dimgray: [105, 105, 105],
                  dimgrey: [105, 105, 105],
                  dodgerblue: [30, 144, 255],
                  firebrick: [178, 34, 34],
                  floralwhite: [255, 250, 240],
                  forestgreen: [34, 139, 34],
                  fuchsia: [255, 0, 255],
                  gainsboro: [220, 220, 220],
                  ghostwhite: [248, 248, 255],
                  gold: [255, 215, 0],
                  goldenrod: [218, 165, 32],
                  gray: [128, 128, 128],
                  grey: [128, 128, 128],
                  green: [0, 128, 0],
                  greenyellow: [173, 255, 47],
                  honeydew: [240, 255, 240],
                  hotpink: [255, 105, 180],
                  indianred: [205, 92, 92],
                  indigo: [75, 0, 130],
                  ivory: [255, 255, 240],
                  khaki: [240, 230, 140],
                  lavender: [230, 230, 250],
                  lavenderblush: [255, 240, 245],
                  lawngreen: [124, 252, 0],
                  lemonchiffon: [255, 250, 205],
                  lightblue: [173, 216, 230],
                  lightcoral: [240, 128, 128],
                  lightcyan: [224, 255, 255],
                  lightgoldenrodyellow: [250, 250, 210],
                  lightgray: [211, 211, 211],
                  lightgrey: [211, 211, 211],
                  lightgreen: [144, 238, 144],
                  lightpink: [255, 182, 193],
                  lightsalmon: [255, 160, 122],
                  lightseagreen: [32, 178, 170],
                  lightskyblue: [135, 206, 250],
                  lightslategray: [119, 136, 153],
                  lightslategrey: [119, 136, 153],
                  lightsteelblue: [176, 196, 222],
                  lightyellow: [255, 255, 224],
                  lime: [0, 255, 0],
                  limegreen: [50, 205, 50],
                  linen: [250, 240, 230],
                  magenta: [255, 0, 255],
                  maroon: [128, 0, 0],
                  mediumaquamarine: [102, 205, 170],
                  mediumblue: [0, 0, 205],
                  mediumorchid: [186, 85, 211],
                  mediumpurple: [147, 112, 219],
                  mediumseagreen: [60, 179, 113],
                  mediumslateblue: [123, 104, 238],
                  mediumspringgreen: [0, 250, 154],
                  mediumturquoise: [72, 209, 204],
                  mediumvioletred: [199, 21, 133],
                  midnightblue: [25, 25, 112],
                  mintcream: [245, 255, 250],
                  mistyrose: [255, 228, 225],
                  moccasin: [255, 228, 181],
                  navajowhite: [255, 222, 173],
                  navy: [0, 0, 128],
                  oldlace: [253, 245, 230],
                  olive: [128, 128, 0],
                  olivedrab: [107, 142, 35],
                  orange: [255, 165, 0],
                  orangered: [255, 69, 0],
                  orchid: [218, 112, 214],
                  palegoldenrod: [238, 232, 170],
                  palegreen: [152, 251, 152],
                  paleturquoise: [175, 238, 238],
                  palevioletred: [219, 112, 147],
                  papayawhip: [255, 239, 213],
                  peachpuff: [255, 218, 185],
                  peru: [205, 133, 63],
                  pink: [255, 192, 203],
                  plum: [221, 160, 221],
                  powderblue: [176, 224, 230],
                  purple: [128, 0, 128],
                  rebeccapurple: [102, 51, 153],
                  red: [255, 0, 0],
                  rosybrown: [188, 143, 143],
                  royalblue: [65, 105, 225],
                  saddlebrown: [139, 69, 19],
                  salmon: [250, 128, 114],
                  sandybrown: [244, 164, 96],
                  seagreen: [46, 139, 87],
                  seashell: [255, 245, 238],
                  sienna: [160, 82, 45],
                  silver: [192, 192, 192],
                  skyblue: [135, 206, 235],
                  slateblue: [106, 90, 205],
                  slategray: [112, 128, 144],
                  slategrey: [112, 128, 144],
                  snow: [255, 250, 250],
                  springgreen: [0, 255, 127],
                  steelblue: [70, 130, 180],
                  tan: [210, 180, 140],
                  teal: [0, 128, 128],
                  thistle: [216, 191, 216],
                  tomato: [255, 99, 71],
                  turquoise: [64, 224, 208],
                  violet: [238, 130, 238],
                  wheat: [245, 222, 179],
                  white: [255, 255, 255],
                  whitesmoke: [245, 245, 245],
                  yellow: [255, 255, 0]
                }, g = {
                  black: [x.black, 1],
                  white: [x.white, 1],
                  transparent: [x.black, 0]
                }, S = {
                  quot: 34,
                  amp: 38,
                  lt: 60,
                  gt: 62,
                  apos: 39,
                  OElig: 338,
                  oelig: 339,
                  Scaron: 352,
                  scaron: 353,
                  Yuml: 376,
                  circ: 710,
                  tilde: 732,
                  ensp: 8194,
                  emsp: 8195,
                  thinsp: 8201,
                  zwnj: 8204,
                  zwj: 8205,
                  lrm: 8206,
                  rlm: 8207,
                  ndash: 8211,
                  mdash: 8212,
                  lsquo: 8216,
                  rsquo: 8217,
                  sbquo: 8218,
                  ldquo: 8220,
                  rdquo: 8221,
                  bdquo: 8222,
                  dagger: 8224,
                  Dagger: 8225,
                  permil: 8240,
                  lsaquo: 8249,
                  rsaquo: 8250,
                  euro: 8364,
                  nbsp: 160,
                  iexcl: 161,
                  cent: 162,
                  pound: 163,
                  curren: 164,
                  yen: 165,
                  brvbar: 166,
                  sect: 167,
                  uml: 168,
                  copy: 169,
                  ordf: 170,
                  laquo: 171,
                  not: 172,
                  shy: 173,
                  reg: 174,
                  macr: 175,
                  deg: 176,
                  plusmn: 177,
                  sup2: 178,
                  sup3: 179,
                  acute: 180,
                  micro: 181,
                  para: 182,
                  middot: 183,
                  cedil: 184,
                  sup1: 185,
                  ordm: 186,
                  raquo: 187,
                  frac14: 188,
                  frac12: 189,
                  frac34: 190,
                  iquest: 191,
                  Agrave: 192,
                  Aacute: 193,
                  Acirc: 194,
                  Atilde: 195,
                  Auml: 196,
                  Aring: 197,
                  AElig: 198,
                  Ccedil: 199,
                  Egrave: 200,
                  Eacute: 201,
                  Ecirc: 202,
                  Euml: 203,
                  Igrave: 204,
                  Iacute: 205,
                  Icirc: 206,
                  Iuml: 207,
                  ETH: 208,
                  Ntilde: 209,
                  Ograve: 210,
                  Oacute: 211,
                  Ocirc: 212,
                  Otilde: 213,
                  Ouml: 214,
                  times: 215,
                  Oslash: 216,
                  Ugrave: 217,
                  Uacute: 218,
                  Ucirc: 219,
                  Uuml: 220,
                  Yacute: 221,
                  THORN: 222,
                  szlig: 223,
                  agrave: 224,
                  aacute: 225,
                  acirc: 226,
                  atilde: 227,
                  auml: 228,
                  aring: 229,
                  aelig: 230,
                  ccedil: 231,
                  egrave: 232,
                  eacute: 233,
                  ecirc: 234,
                  euml: 235,
                  igrave: 236,
                  iacute: 237,
                  icirc: 238,
                  iuml: 239,
                  eth: 240,
                  ntilde: 241,
                  ograve: 242,
                  oacute: 243,
                  ocirc: 244,
                  otilde: 245,
                  ouml: 246,
                  divide: 247,
                  oslash: 248,
                  ugrave: 249,
                  uacute: 250,
                  ucirc: 251,
                  uuml: 252,
                  yacute: 253,
                  thorn: 254,
                  yuml: 255,
                  fnof: 402,
                  Alpha: 913,
                  Beta: 914,
                  Gamma: 915,
                  Delta: 916,
                  Epsilon: 917,
                  Zeta: 918,
                  Eta: 919,
                  Theta: 920,
                  Iota: 921,
                  Kappa: 922,
                  Lambda: 923,
                  Mu: 924,
                  Nu: 925,
                  Xi: 926,
                  Omicron: 927,
                  Pi: 928,
                  Rho: 929,
                  Sigma: 931,
                  Tau: 932,
                  Upsilon: 933,
                  Phi: 934,
                  Chi: 935,
                  Psi: 936,
                  Omega: 937,
                  alpha: 945,
                  beta: 946,
                  gamma: 947,
                  delta: 948,
                  epsilon: 949,
                  zeta: 950,
                  eta: 951,
                  theta: 952,
                  iota: 953,
                  kappa: 954,
                  lambda: 955,
                  mu: 956,
                  nu: 957,
                  xi: 958,
                  omicron: 959,
                  pi: 960,
                  rho: 961,
                  sigmaf: 962,
                  sigma: 963,
                  tau: 964,
                  upsilon: 965,
                  phi: 966,
                  chi: 967,
                  psi: 968,
                  omega: 969,
                  thetasym: 977,
                  upsih: 978,
                  piv: 982,
                  bull: 8226,
                  hellip: 8230,
                  prime: 8242,
                  Prime: 8243,
                  oline: 8254,
                  frasl: 8260,
                  weierp: 8472,
                  image: 8465,
                  real: 8476,
                  trade: 8482,
                  alefsym: 8501,
                  larr: 8592,
                  uarr: 8593,
                  rarr: 8594,
                  darr: 8595,
                  harr: 8596,
                  crarr: 8629,
                  lArr: 8656,
                  uArr: 8657,
                  rArr: 8658,
                  dArr: 8659,
                  hArr: 8660,
                  forall: 8704,
                  part: 8706,
                  exist: 8707,
                  empty: 8709,
                  nabla: 8711,
                  isin: 8712,
                  notin: 8713,
                  ni: 8715,
                  prod: 8719,
                  sum: 8721,
                  minus: 8722,
                  lowast: 8727,
                  radic: 8730,
                  prop: 8733,
                  infin: 8734,
                  ang: 8736,
                  and: 8743,
                  or: 8744,
                  cap: 8745,
                  cup: 8746,
                  int: 8747,
                  there4: 8756,
                  sim: 8764,
                  cong: 8773,
                  asymp: 8776,
                  ne: 8800,
                  equiv: 8801,
                  le: 8804,
                  ge: 8805,
                  sub: 8834,
                  sup: 8835,
                  nsub: 8836,
                  sube: 8838,
                  supe: 8839,
                  oplus: 8853,
                  otimes: 8855,
                  perp: 8869,
                  sdot: 8901,
                  lceil: 8968,
                  rceil: 8969,
                  lfloor: 8970,
                  rfloor: 8971,
                  lang: 9001,
                  rang: 9002,
                  loz: 9674,
                  spades: 9824,
                  clubs: 9827,
                  hearts: 9829,
                  diams: 9830
                }, y = {
                  A: 7,
                  a: 7,
                  C: 6,
                  c: 6,
                  H: 1,
                  h: 1,
                  L: 2,
                  l: 2,
                  M: 2,
                  m: 2,
                  Q: 4,
                  q: 4,
                  S: 4,
                  s: 4,
                  T: 2,
                  t: 2,
                  V: 1,
                  v: 1,
                  Z: 0,
                  z: 0
                }, b = {
                  A3: !0,
                  A4: !0,
                  a3: !0,
                  a4: !0
                }, n = {
                  color: {
                    inherit: !0,
                    initial: void 0
                  },
                  visibility: {
                    inherit: !0,
                    initial: "visible",
                    values: {
                      hidden: "hidden",
                      collapse: "hidden",
                      visible: "visible"
                    }
                  },
                  fill: {
                    inherit: !0,
                    initial: g.black
                  },
                  stroke: {
                    inherit: !0,
                    initial: "none"
                  },
                  "stop-color": {
                    inherit: !1,
                    initial: g.black
                  },
                  "fill-opacity": {
                    inherit: !0,
                    initial: 1
                  },
                  "stroke-opacity": {
                    inherit: !0,
                    initial: 1
                  },
                  "stop-opacity": {
                    inherit: !1,
                    initial: 1
                  },
                  "fill-rule": {
                    inherit: !0,
                    initial: "nonzero",
                    values: {
                      nonzero: "nonzero",
                      evenodd: "evenodd"
                    }
                  },
                  "clip-rule": {
                    inherit: !0,
                    initial: "nonzero",
                    values: {
                      nonzero: "nonzero",
                      evenodd: "evenodd"
                    }
                  },
                  "stroke-width": {
                    inherit: !0,
                    initial: 1
                  },
                  "stroke-dasharray": {
                    inherit: !0,
                    initial: []
                  },
                  "stroke-dashoffset": {
                    inherit: !0,
                    initial: 0
                  },
                  "stroke-miterlimit": {
                    inherit: !0,
                    initial: 4
                  },
                  "stroke-linejoin": {
                    inherit: !0,
                    initial: "miter",
                    values: {
                      miter: "miter",
                      round: "round",
                      bevel: "bevel"
                    }
                  },
                  "stroke-linecap": {
                    inherit: !0,
                    initial: "butt",
                    values: {
                      butt: "butt",
                      round: "round",
                      square: "square"
                    }
                  },
                  "font-size": {
                    inherit: !0,
                    initial: 16,
                    values: {
                      "xx-small": 9,
                      "x-small": 10,
                      small: 13,
                      medium: 16,
                      large: 18,
                      "x-large": 24,
                      "xx-large": 32
                    }
                  },
                  "font-family": {
                    inherit: !0,
                    initial: "sans-serif"
                  },
                  "font-weight": {
                    inherit: !0,
                    initial: "normal",
                    values: {
                      600: "bold",
                      700: "bold",
                      800: "bold",
                      900: "bold",
                      bold: "bold",
                      bolder: "bold",
                      500: "normal",
                      400: "normal",
                      300: "normal",
                      200: "normal",
                      100: "normal",
                      normal: "normal",
                      lighter: "normal"
                    }
                  },
                  "font-style": {
                    inherit: !0,
                    initial: "normal",
                    values: {
                      italic: "italic",
                      oblique: "italic",
                      normal: "normal"
                    }
                  },
                  "text-anchor": {
                    inherit: !0,
                    initial: "start",
                    values: {
                      start: "start",
                      middle: "middle",
                      end: "end"
                    }
                  },
                  direction: {
                    inherit: !0,
                    initial: "ltr",
                    values: {
                      ltr: "ltr",
                      rtl: "rtl"
                    }
                  },
                  "dominant-baseline": {
                    inherit: !0,
                    initial: "baseline",
                    values: {
                      auto: "baseline",
                      baseline: "baseline",
                      "before-edge": "before-edge",
                      "text-before-edge": "before-edge",
                      middle: "middle",
                      central: "central",
                      "after-edge": "after-edge",
                      "text-after-edge": "after-edge",
                      ideographic: "ideographic",
                      alphabetic: "alphabetic",
                      hanging: "hanging",
                      mathematical: "mathematical"
                    }
                  },
                  "alignment-baseline": {
                    inherit: !1,
                    initial: void 0,
                    values: {
                      auto: "baseline",
                      baseline: "baseline",
                      "before-edge": "before-edge",
                      "text-before-edge": "before-edge",
                      middle: "middle",
                      central: "central",
                      "after-edge": "after-edge",
                      "text-after-edge": "after-edge",
                      ideographic: "ideographic",
                      alphabetic: "alphabetic",
                      hanging: "hanging",
                      mathematical: "mathematical"
                    }
                  },
                  "baseline-shift": {
                    inherit: !0,
                    initial: "baseline",
                    values: {
                      baseline: "baseline",
                      sub: "sub",
                      super: "super"
                    }
                  },
                  "word-spacing": {
                    inherit: !0,
                    initial: 0,
                    values: {
                      normal: 0
                    }
                  },
                  "letter-spacing": {
                    inherit: !0,
                    initial: 0,
                    values: {
                      normal: 0
                    }
                  },
                  "text-decoration": {
                    inherit: !1,
                    initial: "none",
                    values: {
                      none: "none",
                      underline: "underline",
                      overline: "overline",
                      "line-through": "line-through"
                    }
                  },
                  "xml:space": {
                    inherit: !0,
                    initial: "default",
                    css: "white-space",
                    values: {
                      preserve: "preserve",
                      default: "default",
                      pre: "preserve",
                      "pre-line": "preserve",
                      "pre-wrap": "preserve",
                      nowrap: "default"
                    }
                  },
                  "marker-start": {
                    inherit: !0,
                    initial: "none"
                  },
                  "marker-mid": {
                    inherit: !0,
                    initial: "none"
                  },
                  "marker-end": {
                    inherit: !0,
                    initial: "none"
                  },
                  opacity: {
                    inherit: !1,
                    initial: 1
                  },
                  transform: {
                    inherit: !1,
                    initial: [1, 0, 0, 1, 0, 0]
                  },
                  display: {
                    inherit: !1,
                    initial: "inline",
                    values: {
                      none: "none",
                      inline: "inline",
                      block: "inline"
                    }
                  },
                  "clip-path": {
                    inherit: !1,
                    initial: "none"
                  },
                  mask: {
                    inherit: !1,
                    initial: "none"
                  },
                  overflow: {
                    inherit: !1,
                    initial: "hidden",
                    values: {
                      hidden: "hidden",
                      scroll: "hidden",
                      visible: "visible"
                    }
                  }
                };
                function w($t) {
                  var Mt = new function() {
                  }();
                  return Mt.name = "G" + (f._groupCount = (f._groupCount || 0) + 1), Mt.resources = f.ref(), Mt.xobj = f.ref({
                    Type: "XObject",
                    Subtype: "Form",
                    FormType: 1,
                    BBox: $t,
                    Group: {
                      S: "Transparency",
                      CS: "DeviceRGB",
                      I: !0,
                      K: !1
                    },
                    Resources: Mt.resources
                  }), Mt.xobj.write(""), Mt.savedMatrix = f._ctm, Mt.savedPage = f.page, Si.push(Mt), f._ctm = [1, 0, 0, 1, 0, 0], f.page = {
                    width: f.page.width,
                    height: f.page.height,
                    write: function(Lt) {
                      Mt.xobj.write(Lt);
                    },
                    fonts: {},
                    xobjects: {},
                    ext_gstates: {},
                    patterns: {}
                  }, Mt;
                }
                function E($t) {
                  if ($t !== Si.pop())
                    throw "Group not matching";
                  Object.keys(f.page.fonts).length && ($t.resources.data.Font = f.page.fonts), Object.keys(f.page.xobjects).length && ($t.resources.data.XObject = f.page.xobjects), Object.keys(f.page.ext_gstates).length && ($t.resources.data.ExtGState = f.page.ext_gstates), Object.keys(f.page.patterns).length && ($t.resources.data.Pattern = f.page.patterns), $t.resources.end(), $t.xobj.end(), f._ctm = $t.savedMatrix, f.page = $t.savedPage;
                }
                function A($t) {
                  f.page.xobjects[$t.name] = $t.xobj, f.addContent("/" + $t.name + " Do");
                }
                function O($t, Mt) {
                  var oe = "M" + (f._maskCount = (f._maskCount || 0) + 1), Lt = f.ref({
                    Type: "ExtGState",
                    CA: 1,
                    ca: 1,
                    BM: "Normal",
                    SMask: {
                      S: "Luminosity",
                      G: $t.xobj,
                      BC: Mt ? [0, 0, 0] : [1, 1, 1]
                    }
                  });
                  Lt.end(), f.page.ext_gstates[oe] = Lt, f.addContent("/" + oe + " gs");
                }
                function C($t, Mt, oe, Lt) {
                  var Ut = new function() {
                  }();
                  return Ut.group = $t, Ut.dx = Mt, Ut.dy = oe, Ut.matrix = Lt || [1, 0, 0, 1, 0, 0], Ut;
                }
                function T($t, Mt) {
                  var oe = "P" + (f._patternCount = (f._patternCount || 0) + 1), Lt = f.ref({
                    Type: "Pattern",
                    PatternType: 1,
                    PaintType: 1,
                    TilingType: 2,
                    BBox: [0, 0, $t.dx, $t.dy],
                    XStep: $t.dx,
                    YStep: $t.dy,
                    Matrix: Pt(f._ctm, $t.matrix),
                    Resources: {
                      ProcSet: ["PDF", "Text", "ImageB", "ImageC", "ImageI"],
                      XObject: function() {
                        var Ut = {};
                        return Ut[$t.group.name] = $t.group.xobj, Ut;
                      }()
                    }
                  });
                  Lt.write("/" + $t.group.name + " Do"), Lt.end(), f.page.patterns[oe] = Lt, Mt ? (f.addContent("/Pattern CS"), f.addContent("/" + oe + " SCN")) : (f.addContent("/Pattern cs"), f.addContent("/" + oe + " scn"));
                }
                function P($t, Mt) {
                  f.page.fonts[$t.id] || (f.page.fonts[$t.id] = $t.ref()), f.addContent("BT").addContent("/" + $t.id + " " + Mt + " Tf");
                }
                function I($t, Mt, oe, Lt, Ut, Vt) {
                  f.addContent(Ft($t) + " " + Ft(Mt) + " " + Ft(-oe) + " " + Ft(-Lt) + " " + Ft(Ut) + " " + Ft(Vt) + " Tm");
                }
                function F($t, Mt) {
                  var oe = $t && Mt ? 2 : Mt ? 1 : $t ? 0 : 3;
                  f.addContent(oe + " Tr");
                }
                function B($t) {
                  f.addContent("<" + $t + "> Tj");
                }
                function M() {
                  f.addContent("ET");
                }
                function z($t) {
                  $t[0].constructor.name === "PDFPattern" ? (f.fillOpacity($t[1]), T($t[0], !1)) : f.fillColor($t[0], $t[1]);
                }
                function L($t) {
                  $t[0].constructor.name === "PDFPattern" ? (f.strokeOpacity($t[1]), T($t[0], !0)) : f.strokeColor($t[0], $t[1]);
                }
                function J($t, Mt, oe, Lt, Ut) {
                  var Vt = f.ref({
                    Type: "Annot",
                    Subtype: "Link",
                    Rect: [$t, Mt, oe, Lt],
                    Border: [0, 0, 0],
                    A: {
                      S: "URI",
                      URI: new String(Ut)
                    }
                  });
                  Vt.end(), Ze.push(Vt);
                }
                function ft($t) {
                  var Mt = function(Ht, fe, Qt, Ce) {
                    this.error = Ce, this.nodeName = Ht, this.nodeValue = Qt, this.nodeType = fe, this.attributes = /* @__PURE__ */ Object.create(null), this.childNodes = [], this.parentNode = null, this.id = "", this.textContent = "", this.classList = [];
                  };
                  Mt.prototype.getAttribute = function(re) {
                    return this.attributes[re] != null ? this.attributes[re] : null;
                  }, Mt.prototype.getElementById = function(re) {
                    var Ht = null;
                    return function fe(Qt) {
                      if (!Ht && Qt.nodeType === 1) {
                        Qt.id === re && (Ht = Qt);
                        for (var Ce = 0; Ce < Qt.childNodes.length; Ce++)
                          fe(Qt.childNodes[Ce]);
                      }
                    }(this), Ht;
                  }, Mt.prototype.getElementsByTagName = function(re) {
                    var Ht = [];
                    return function fe(Qt) {
                      if (Qt.nodeType === 1) {
                        Qt.nodeName === re && Ht.push(Qt);
                        for (var Ce = 0; Ce < Qt.childNodes.length; Ce++)
                          fe(Qt.childNodes[Ce]);
                      }
                    }(this), Ht;
                  };
                  for (var oe = new Te($t.trim()), Lt, Ut, Vt = !1, Yt = function re() {
                    var Ht, fe;
                    if (Ht = oe.match(/^<([\w:.-]+)\s*/, !0)) {
                      for (var Qt = new Mt(Ht[1], 1, null, Vt); Ht = oe.match(/^([\w:.-]+)(?:\s*=\s*"([^"]*)"|\s*=\s*'([^']*)')?\s*/, !0); ) {
                        var Ce = Ht[1], ze = Q(Ht[2] || Ht[3] || "");
                        Qt.attributes[Ce] ? (yr('parseXml: duplicate attribute "' + Ce + '"'), Vt = !0) : (Qt.attributes[Ce] = ze, Ce === "id" && (Qt.id = ze), Ce === "class" && (Qt.classList = ze.split(" ")));
                      }
                      if (oe.match(/^>/)) {
                        for (; fe = re(); )
                          Qt.childNodes.push(fe), fe.parentNode = Qt, Qt.textContent += fe.nodeType === 3 || fe.nodeType === 4 ? fe.nodeValue : fe.textContent;
                        return (Ht = oe.match(/^<\/([\w:.-]+)\s*>/, !0)) ? (Ht[1] === Qt.nodeName || (yr('parseXml: tag not matching, opening "' + Qt.nodeName + '" & closing "' + Ht[1] + '"'), Vt = !0), Qt) : (yr('parseXml: tag not matching, opening "' + Qt.nodeName + '" & not closing'), Vt = !0, Qt);
                      } else {
                        if (oe.match(/^\/>/))
                          return Qt;
                        yr('parseXml: tag could not be parsed "' + Qt.nodeName + '"'), Vt = !0;
                      }
                    } else {
                      if (Ht = oe.match(/^<!--[\s\S]*?-->/))
                        return new Mt(null, 8, Ht, Vt);
                      if (Ht = oe.match(/^<\?[\s\S]*?\?>/))
                        return new Mt(null, 7, Ht, Vt);
                      if (Ht = oe.match(/^<!DOCTYPE\s*([\s\S]*?)>/))
                        return new Mt(null, 10, Ht, Vt);
                      if (Ht = oe.match(/^<!\[CDATA\[([\s\S]*?)\]\]>/, !0))
                        return new Mt("#cdata-section", 4, Ht[1], Vt);
                      if (Ht = oe.match(/^([^<]+)/, !0))
                        return new Mt("#text", 3, Q(Ht[1]), Vt);
                    }
                  }; Ut = Yt(); )
                    Ut.nodeType === 1 && !Lt ? Lt = Ut : (Ut.nodeType === 1 || Ut.nodeType === 3 && Ut.nodeValue.trim() !== "") && yr("parseXml: data after document end has been discarded");
                  return oe.matchAll() && yr("parseXml: parsing error"), Lt;
                }
                function Q($t) {
                  return $t.replace(/&(?:#([0-9]+)|#[xX]([0-9A-Fa-f]+)|([0-9A-Za-z]+));/g, function(Mt, oe, Lt, Ut) {
                    return oe ? String.fromCharCode(parseInt(oe, 10)) : Lt ? String.fromCharCode(parseInt(Lt, 16)) : Ut && S[Ut] ? String.fromCharCode(S[Ut]) : Mt;
                  });
                }
                function xt($t) {
                  var Mt, oe;
                  return $t = ($t || "").trim(), (Mt = x[$t]) ? oe = [Mt.slice(), 1] : (Mt = $t.match(/^rgba\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9.]+)\s*\)$/i)) ? (Mt[1] = parseInt(Mt[1]), Mt[2] = parseInt(Mt[2]), Mt[3] = parseInt(Mt[3]), Mt[4] = parseFloat(Mt[4]), Mt[1] < 256 && Mt[2] < 256 && Mt[3] < 256 && Mt[4] <= 1 && (oe = [Mt.slice(1, 4), Mt[4]])) : (Mt = $t.match(/^rgb\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*\)$/i)) ? (Mt[1] = parseInt(Mt[1]), Mt[2] = parseInt(Mt[2]), Mt[3] = parseInt(Mt[3]), Mt[1] < 256 && Mt[2] < 256 && Mt[3] < 256 && (oe = [Mt.slice(1, 4), 1])) : (Mt = $t.match(/^rgb\(\s*([0-9.]+)%\s*,\s*([0-9.]+)%\s*,\s*([0-9.]+)%\s*\)$/i)) ? (Mt[1] = 2.55 * parseFloat(Mt[1]), Mt[2] = 2.55 * parseFloat(Mt[2]), Mt[3] = 2.55 * parseFloat(Mt[3]), Mt[1] < 256 && Mt[2] < 256 && Mt[3] < 256 && (oe = [Mt.slice(1, 4), 1])) : (Mt = $t.match(/^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i)) ? oe = [[parseInt(Mt[1], 16), parseInt(Mt[2], 16), parseInt(Mt[3], 16)], 1] : (Mt = $t.match(/^#([0-9a-f])([0-9a-f])([0-9a-f])$/i)) && (oe = [[17 * parseInt(Mt[1], 16), 17 * parseInt(Mt[2], 16), 17 * parseInt(Mt[3], 16)], 1]), gn ? gn(oe, $t) : oe;
                }
                function St($t, Mt, oe) {
                  var Lt = $t[0].slice(), Ut = $t[1] * Mt;
                  if (oe) {
                    for (var Vt = 0; Vt < $t.length; Vt++)
                      Lt[Vt] *= Ut;
                    return [Lt, 1];
                  } else
                    return [Lt, Ut];
                }
                function Pt() {
                  function $t(Lt, Ut) {
                    return [Lt[0] * Ut[0] + Lt[2] * Ut[1], Lt[1] * Ut[0] + Lt[3] * Ut[1], Lt[0] * Ut[2] + Lt[2] * Ut[3], Lt[1] * Ut[2] + Lt[3] * Ut[3], Lt[0] * Ut[4] + Lt[2] * Ut[5] + Lt[4], Lt[1] * Ut[4] + Lt[3] * Ut[5] + Lt[5]];
                  }
                  for (var Mt = arguments[0], oe = 1; oe < arguments.length; oe++)
                    Mt = $t(Mt, arguments[oe]);
                  return Mt;
                }
                function Gt($t, Mt) {
                  return [Mt[0] * $t[0] + Mt[2] * $t[1] + Mt[4], Mt[1] * $t[0] + Mt[3] * $t[1] + Mt[5]];
                }
                function Rt() {
                  for (var $t = f._ctm, Mt = Si.length - 1; Mt >= 0; Mt--)
                    $t = Pt(Si[Mt].savedMatrix, $t);
                  return $t;
                }
                function bt() {
                  return new Zt().M(0, 0).L(f.page.width, 0).L(f.page.width, f.page.height).L(0, f.page.height).transform(Dt(Rt())).getBoundingBox();
                }
                function Dt($t) {
                  var Mt = $t[0] * $t[3] - $t[1] * $t[2];
                  return [$t[3] / Mt, -$t[1] / Mt, -$t[2] / Mt, $t[0] / Mt, ($t[2] * $t[5] - $t[3] * $t[4]) / Mt, ($t[1] * $t[4] - $t[0] * $t[5]) / Mt];
                }
                function X($t) {
                  var Mt = Ft($t[0]), oe = Ft($t[1]), Lt = Ft($t[2]), Ut = Ft($t[3]), Vt = Ft($t[4]), Yt = Ft($t[5]);
                  if (wt(Mt * Ut - oe * Lt, 0))
                    return [Mt, oe, Lt, Ut, Vt, Yt];
                }
                function gt($t) {
                  var Mt = $t[2] || 0, oe = $t[1] || 0, Lt = $t[0] || 0;
                  if (rt(Mt, 0) && rt(oe, 0))
                    return [];
                  if (rt(Mt, 0))
                    return [-Lt / oe];
                  var Ut = oe * oe - 4 * Mt * Lt;
                  return wt(Ut, 0) && Ut > 0 ? [(-oe + Math.sqrt(Ut)) / (2 * Mt), (-oe - Math.sqrt(Ut)) / (2 * Mt)] : rt(Ut, 0) ? [-oe / (2 * Mt)] : [];
                }
                function st($t, Mt) {
                  return (Mt[0] || 0) + (Mt[1] || 0) * $t + (Mt[2] || 0) * $t * $t + (Mt[3] || 0) * $t * $t * $t;
                }
                function rt($t, Mt) {
                  return Math.abs($t - Mt) < 1e-10;
                }
                function wt($t, Mt) {
                  return Math.abs($t - Mt) >= 1e-10;
                }
                function Ft($t) {
                  return $t > -1e21 && $t < 1e21 ? Math.round($t * 1e6) / 1e6 : 0;
                }
                function zt($t) {
                  return typeof $t == "object" && $t !== null && typeof $t.length == "number";
                }
                function G($t) {
                  for (var Mt = new Te(($t || "").trim()), oe = [1, 0, 0, 1, 0, 0], Lt; Lt = Mt.match(/^([A-Za-z]+)\s*[(]([^(]+)[)]/, !0); ) {
                    for (var Ut = Lt[1], Vt = [], Yt = new Te(Lt[2].trim()), re = void 0; re = Yt.matchNumber(); )
                      Vt.push(Number(re)), Yt.matchSeparator();
                    if (Ut === "matrix" && Vt.length === 6)
                      oe = Pt(oe, [Vt[0], Vt[1], Vt[2], Vt[3], Vt[4], Vt[5]]);
                    else if (Ut === "translate" && Vt.length === 2)
                      oe = Pt(oe, [1, 0, 0, 1, Vt[0], Vt[1]]);
                    else if (Ut === "translate" && Vt.length === 1)
                      oe = Pt(oe, [1, 0, 0, 1, Vt[0], 0]);
                    else if (Ut === "scale" && Vt.length === 2)
                      oe = Pt(oe, [Vt[0], 0, 0, Vt[1], 0, 0]);
                    else if (Ut === "scale" && Vt.length === 1)
                      oe = Pt(oe, [Vt[0], 0, 0, Vt[0], 0, 0]);
                    else if (Ut === "rotate" && Vt.length === 3) {
                      var Ht = Vt[0] * Math.PI / 180;
                      oe = Pt(oe, [1, 0, 0, 1, Vt[1], Vt[2]], [Math.cos(Ht), Math.sin(Ht), -Math.sin(Ht), Math.cos(Ht), 0, 0], [1, 0, 0, 1, -Vt[1], -Vt[2]]);
                    } else if (Ut === "rotate" && Vt.length === 1) {
                      var fe = Vt[0] * Math.PI / 180;
                      oe = Pt(oe, [Math.cos(fe), Math.sin(fe), -Math.sin(fe), Math.cos(fe), 0, 0]);
                    } else if (Ut === "skewX" && Vt.length === 1) {
                      var Qt = Vt[0] * Math.PI / 180;
                      oe = Pt(oe, [1, 0, Math.tan(Qt), 1, 0, 0]);
                    } else if (Ut === "skewY" && Vt.length === 1) {
                      var Ce = Vt[0] * Math.PI / 180;
                      oe = Pt(oe, [1, Math.tan(Ce), 0, 1, 0, 0]);
                    } else
                      return;
                    Mt.matchSeparator();
                  }
                  if (!Mt.matchAll())
                    return oe;
                }
                function D($t, Mt, oe, Lt, Ut, Vt) {
                  var Yt = ($t || "").trim().match(/^(none)$|^x(Min|Mid|Max)Y(Min|Mid|Max)(?:\s+(meet|slice))?$/) || [], re = Yt[1] || Yt[4] || "meet", Ht = Yt[2] || "Mid", fe = Yt[3] || "Mid", Qt = Mt / Lt, Ce = oe / Ut, ze = {
                    Min: 0,
                    Mid: 0.5,
                    Max: 1
                  }[Ht] - (Vt || 0), He = {
                    Min: 0,
                    Mid: 0.5,
                    Max: 1
                  }[fe] - (Vt || 0);
                  return re === "slice" ? Ce = Qt = Math.max(Qt, Ce) : re === "meet" && (Ce = Qt = Math.min(Qt, Ce)), [Qt, 0, 0, Ce, ze * (Mt - Lt * Qt), He * (oe - Ut * Ce)];
                }
                function Z($t) {
                  var Mt = /* @__PURE__ */ Object.create(null);
                  $t = ($t || "").trim().split(/;/);
                  for (var oe = 0; oe < $t.length; oe++) {
                    var Lt = ($t[oe].split(":")[0] || "").trim(), Ut = ($t[oe].split(":")[1] || "").trim();
                    Lt && (Mt[Lt] = Ut);
                  }
                  if (Mt.marker && (Mt["marker-start"] || (Mt["marker-start"] = Mt.marker), Mt["marker-mid"] || (Mt["marker-mid"] = Mt.marker), Mt["marker-end"] || (Mt["marker-end"] = Mt.marker)), Mt.font) {
                    for (var Vt = null, Yt = null, re = "normal", Ht = "normal", fe = "normal", Qt = Mt.font.split(/\s+/), Ce = 0; Ce < Qt.length; Ce++)
                      switch (Qt[Ce]) {
                        case "normal":
                          break;
                        case "italic":
                        case "oblique":
                          re = Qt[Ce];
                          break;
                        case "small-caps":
                          fe = Qt[Ce];
                          break;
                        case "bold":
                        case "bolder":
                        case "lighter":
                        case "100":
                        case "200":
                        case "300":
                        case "400":
                        case "500":
                        case "600":
                        case "700":
                        case "800":
                        case "900":
                          Ht = Qt[Ce];
                          break;
                        default:
                          Yt ? Vt ? Vt += " " + Qt[Ce] : Vt = Qt[Ce] : Yt = Qt[Ce].split("/")[0];
                          break;
                      }
                    Mt["font-style"] || (Mt["font-style"] = re), Mt["font-variant"] || (Mt["font-variant"] = fe), Mt["font-weight"] || (Mt["font-weight"] = Ht), Mt["font-size"] || (Mt["font-size"] = Yt), Mt["font-family"] || (Mt["font-family"] = Vt);
                  }
                  return Mt;
                }
                function et($t) {
                  for (var Mt = $t.split(/(?=[.#])/g), oe = [], Lt = [], Ut = [], Vt, Yt = 0; Yt < Mt.length; Yt++)
                    if (Vt = Mt[Yt].match(/^[#]([_A-Za-z0-9-]+)$/))
                      oe.push(Vt[1]);
                    else if (Vt = Mt[Yt].match(/^[.]([_A-Za-z0-9-]+)$/))
                      Lt.push(Vt[1]);
                    else if (Vt = Mt[Yt].match(/^([_A-Za-z0-9-]+)$/))
                      Ut.push(Vt[1]);
                    else if (Mt[Yt] !== "*")
                      return;
                  return {
                    tags: Ut,
                    ids: oe,
                    classes: Lt,
                    specificity: oe.length * 1e4 + Lt.length * 100 + Ut.length
                  };
                }
                function vt($t) {
                  for (var Mt = new Te($t.trim()), oe = [], Lt; Lt = Mt.match(/^\s*([^\{\}]*?)\s*\{([^\{\}]*?)\}/, !0); )
                    for (var Ut = Lt[1].split(/\s*,\s*/g), Vt = Z(Lt[2]), Yt = 0; Yt < Ut.length; Yt++) {
                      var re = et(Ut[Yt]);
                      re && oe.push({
                        selector: re,
                        css: Vt
                      });
                    }
                  return oe;
                }
                function lt($t, Mt) {
                  if ($t.nodeType !== 1)
                    return !1;
                  for (var oe = 0; oe < Mt.tags.length; oe++)
                    if (Mt.tags[oe] !== $t.nodeName)
                      return !1;
                  for (var Lt = 0; Lt < Mt.ids.length; Lt++)
                    if (Mt.ids[Lt] !== $t.id)
                      return !1;
                  for (var Ut = 0; Ut < Mt.classes.length; Ut++)
                    if ($t.classList.indexOf(Mt.classes[Ut]) === -1)
                      return !1;
                  return !0;
                }
                function dt($t) {
                  for (var Mt = /* @__PURE__ */ Object.create(null), oe = /* @__PURE__ */ Object.create(null), Lt = 0; Lt < qe.length; Lt++) {
                    var Ut = qe[Lt];
                    if (lt($t, Ut.selector))
                      for (var Vt in Ut.css)
                        oe[Vt] > Ut.selector.specificity || (Mt[Vt] = Ut.css[Vt], oe[Vt] = Ut.selector.specificity);
                  }
                  return Mt;
                }
                function kt($t, Mt) {
                  return $t.concat(Mt.slice($t.length));
                }
                function jt($t, Mt) {
                  return Math.max($t.ascender, ($t.bbox[3] || $t.bbox.maxY) * ($t.scale || 1)) * Mt / 1e3;
                }
                function me($t, Mt) {
                  return Math.min($t.descender, ($t.bbox[1] || $t.bbox.minY) * ($t.scale || 1)) * Mt / 1e3;
                }
                function se($t, Mt) {
                  return ($t.xHeight || 0.5 * ($t.ascender - $t.descender)) * Mt / 1e3;
                }
                function Bt($t, Mt, oe, Lt) {
                  var Ut, Vt;
                  switch (oe) {
                    case "middle":
                      Ut = 0.5 * se($t, Mt);
                      break;
                    case "central":
                      Ut = 0.5 * (me($t, Mt) + jt($t, Mt));
                      break;
                    case "after-edge":
                    case "text-after-edge":
                      Ut = me($t, Mt);
                      break;
                    case "alphabetic":
                    case "auto":
                    case "baseline":
                      Ut = 0;
                      break;
                    case "mathematical":
                      Ut = 0.5 * jt($t, Mt);
                      break;
                    case "hanging":
                      Ut = 0.8 * jt($t, Mt);
                      break;
                    case "before-edge":
                    case "text-before-edge":
                      Ut = jt($t, Mt);
                      break;
                    default:
                      Ut = 0;
                      break;
                  }
                  switch (Lt) {
                    case "baseline":
                      Vt = 0;
                      break;
                    case "super":
                      Vt = 0.6 * Mt;
                      break;
                    case "sub":
                      Vt = -0.6 * Mt;
                      break;
                    default:
                      Vt = Lt;
                      break;
                  }
                  return Ut - Vt;
                }
                function ge($t, Mt, oe) {
                  for (var Lt = $t.encode("" + oe), Ut = Lt[0], Vt = Lt[1], Yt = [], re = 0; re < Ut.length; re++) {
                    var Ht = $t.unicode ? $t.unicode[parseInt(Ut[re], 16)] : [oe.charCodeAt(re)];
                    Yt.push({
                      glyph: Ut[re],
                      unicode: Ht,
                      width: Vt[re].advanceWidth * Mt / 1e3,
                      xOffset: Vt[re].xOffset * Mt / 1e3,
                      yOffset: Vt[re].yOffset * Mt / 1e3,
                      xAdvance: Vt[re].xAdvance * Mt / 1e3,
                      yAdvance: Vt[re].yAdvance * Mt / 1e3
                    });
                  }
                  return Yt;
                }
                function Re($t, Mt) {
                  switch ($t.nodeName) {
                    case "use":
                      return new Be($t, Mt);
                    case "symbol":
                      return new De($t, Mt);
                    case "g":
                      return new It($t, Mt);
                    case "a":
                      return new he($t, Mt);
                    case "svg":
                      return new nt($t, Mt);
                    case "image":
                      return new j($t, Mt);
                    case "rect":
                      return new _t($t, Mt);
                    case "circle":
                      return new ne($t, Mt);
                    case "ellipse":
                      return new Y($t, Mt);
                    case "line":
                      return new Jt($t, Mt);
                    case "polyline":
                      return new ie($t, Mt);
                    case "polygon":
                      return new Tt($t, Mt);
                    case "path":
                      return new Xt($t, Mt);
                    case "text":
                      return new nr($t, Mt);
                    case "tspan":
                      return new Wr($t, Mt);
                    case "textPath":
                      return new vr($t, Mt);
                    case "#text":
                    case "#cdata-section":
                      return new je($t);
                    default:
                      return new qt($t, Mt);
                  }
                }
                var Te = function(Mt) {
                  this.match = function(oe, Lt) {
                    var Ut = Mt.match(oe);
                    if (!(!Ut || Ut.index !== 0))
                      return Mt = Mt.substring(Ut[0].length), Lt ? Ut : Ut[0];
                  }, this.matchSeparator = function() {
                    return this.match(/^(?:\s*,\s*|\s*|)/);
                  }, this.matchSpace = function() {
                    return this.match(/^(?:\s*)/);
                  }, this.matchLengthUnit = function() {
                    return this.match(/^(?:px|pt|cm|mm|in|pc|em|ex|%|)/);
                  }, this.matchNumber = function() {
                    return this.match(/^(?:[-+]?(?:[0-9]+[.][0-9]+|[0-9]+[.]|[.][0-9]+|[0-9]+)(?:[eE][-+]?[0-9]+)?)/);
                  }, this.matchAll = function() {
                    return this.match(/^[\s\S]+/);
                  };
                }, xe = function(Mt, oe, Lt, Ut, Vt, Yt, re, Ht) {
                  for (var fe = 6 * wi, Qt = [Mt, -3 * Mt + 3 * Lt, 3 * Mt - 6 * Lt + 3 * Vt, -Mt + 3 * Lt - 3 * Vt + re], Ce = [oe, -3 * oe + 3 * Ut, 3 * oe - 6 * Ut + 3 * Yt, -oe + 3 * Ut - 3 * Yt + Ht], ze = [-3 * Mt + 3 * Lt, 6 * Mt - 12 * Lt + 6 * Vt, -3 * Mt + 9 * Lt - 9 * Vt + 3 * re], He = [-3 * oe + 3 * Ut, 6 * oe - 12 * Ut + 6 * Yt, -3 * oe + 9 * Ut - 9 * Yt + 3 * Ht], Je = [0], ar = 1; ar <= fe; ar++) {
                    var mr = (ar - 0.5) / fe, we = st(mr, ze) / fe, We = st(mr, He) / fe, fr = Math.sqrt(we * we + We * We);
                    Je[ar] = Je[ar - 1] + fr;
                  }
                  this.totalLength = Je[fe], this.startPoint = [Mt, oe, rt(Mt, Lt) && rt(oe, Ut) ? Math.atan2(Yt - Ut, Vt - Lt) : Math.atan2(Ut - oe, Lt - Mt)], this.endPoint = [re, Ht, rt(Vt, re) && rt(Yt, Ht) ? Math.atan2(Yt - Ut, Vt - Lt) : Math.atan2(Ht - Yt, re - Vt)], this.getBoundingBox = function() {
                    var Ke, pr = st(0, Qt), tr = st(0, Ce), Er = st(1, Qt), xr = st(1, Ce);
                    pr > Er && (Ke = Er, Er = pr, pr = Ke), tr > xr && (Ke = xr, xr = tr, tr = Ke);
                    for (var Gr = gt(ze), tn = 0; tn < Gr.length; tn++)
                      if (Gr[tn] >= 0 && Gr[tn] <= 1) {
                        var Qr = st(Gr[tn], Qt);
                        Qr < pr && (pr = Qr), Qr > Er && (Er = Qr);
                      }
                    for (var _r = gt(He), Yr = 0; Yr < _r.length; Yr++)
                      if (_r[Yr] >= 0 && _r[Yr] <= 1) {
                        var Rr = st(_r[Yr], Ce);
                        Rr < tr && (tr = Rr), Rr > xr && (xr = Rr);
                      }
                    return [pr, tr, Er, xr];
                  }, this.getPointAtLength = function(Ke) {
                    if (rt(Ke, 0))
                      return this.startPoint;
                    if (rt(Ke, this.totalLength))
                      return this.endPoint;
                    if (!(Ke < 0 || Ke > this.totalLength))
                      for (var pr = 1; pr <= fe; pr++) {
                        var tr = Je[pr - 1], Er = Je[pr];
                        if (tr <= Ke && Ke <= Er) {
                          var xr = (pr - (Er - Ke) / (Er - tr)) / fe, Gr = st(xr, Qt), tn = st(xr, Ce), Qr = st(xr, ze), _r = st(xr, He);
                          return [Gr, tn, Math.atan2(_r, Qr)];
                        }
                      }
                  };
                }, Fe = function(Mt, oe, Lt, Ut) {
                  this.totalLength = Math.sqrt((Lt - Mt) * (Lt - Mt) + (Ut - oe) * (Ut - oe)), this.startPoint = [Mt, oe, Math.atan2(Ut - oe, Lt - Mt)], this.endPoint = [Lt, Ut, Math.atan2(Ut - oe, Lt - Mt)], this.getBoundingBox = function() {
                    return [Math.min(this.startPoint[0], this.endPoint[0]), Math.min(this.startPoint[1], this.endPoint[1]), Math.max(this.startPoint[0], this.endPoint[0]), Math.max(this.startPoint[1], this.endPoint[1])];
                  }, this.getPointAtLength = function(Vt) {
                    if (Vt >= 0 && Vt <= this.totalLength) {
                      var Yt = Vt / this.totalLength || 0, re = this.startPoint[0] + Yt * (this.endPoint[0] - this.startPoint[0]), Ht = this.startPoint[1] + Yt * (this.endPoint[1] - this.startPoint[1]);
                      return [re, Ht, this.startPoint[2]];
                    }
                  };
                }, Zt = function $t() {
                  this.pathCommands = [], this.pathSegments = [], this.startPoint = null, this.endPoint = null, this.totalLength = 0;
                  var Mt = 0, oe = 0, Lt = 0, Ut = 0, Vt, Yt, re;
                  this.move = function(Ht, fe) {
                    return Mt = Lt = Ht, oe = Ut = fe, null;
                  }, this.line = function(Ht, fe) {
                    var Qt = new Fe(Lt, Ut, Ht, fe);
                    return Lt = Ht, Ut = fe, Qt;
                  }, this.curve = function(Ht, fe, Qt, Ce, ze, He) {
                    var Je = new xe(Lt, Ut, Ht, fe, Qt, Ce, ze, He);
                    return Lt = ze, Ut = He, Je;
                  }, this.close = function() {
                    var Ht = new Fe(Lt, Ut, Mt, oe);
                    return Lt = Mt, Ut = oe, Ht;
                  }, this.addCommand = function(Ht) {
                    this.pathCommands.push(Ht);
                    var fe = this[Ht[0]].apply(this, Ht.slice(3));
                    fe && (fe.hasStart = Ht[1], fe.hasEnd = Ht[2], this.startPoint = this.startPoint || fe.startPoint, this.endPoint = fe.endPoint, this.pathSegments.push(fe), this.totalLength += fe.totalLength);
                  }, this.M = function(Ht, fe) {
                    return this.addCommand(["move", !0, !0, Ht, fe]), Vt = "M", this;
                  }, this.m = function(Ht, fe) {
                    return this.M(Lt + Ht, Ut + fe);
                  }, this.Z = this.z = function() {
                    return this.addCommand(["close", !0, !0]), Vt = "Z", this;
                  }, this.L = function(Ht, fe) {
                    return this.addCommand(["line", !0, !0, Ht, fe]), Vt = "L", this;
                  }, this.l = function(Ht, fe) {
                    return this.L(Lt + Ht, Ut + fe);
                  }, this.H = function(Ht) {
                    return this.L(Ht, Ut);
                  }, this.h = function(Ht) {
                    return this.L(Lt + Ht, Ut);
                  }, this.V = function(Ht) {
                    return this.L(Lt, Ht);
                  }, this.v = function(Ht) {
                    return this.L(Lt, Ut + Ht);
                  }, this.C = function(Ht, fe, Qt, Ce, ze, He) {
                    return this.addCommand(["curve", !0, !0, Ht, fe, Qt, Ce, ze, He]), Vt = "C", Yt = Qt, re = Ce, this;
                  }, this.c = function(Ht, fe, Qt, Ce, ze, He) {
                    return this.C(Lt + Ht, Ut + fe, Lt + Qt, Ut + Ce, Lt + ze, Ut + He);
                  }, this.S = function(Ht, fe, Qt, Ce) {
                    return this.C(Lt + (Vt === "C" ? Lt - Yt : 0), Ut + (Vt === "C" ? Ut - re : 0), Ht, fe, Qt, Ce);
                  }, this.s = function(Ht, fe, Qt, Ce) {
                    return this.C(Lt + (Vt === "C" ? Lt - Yt : 0), Ut + (Vt === "C" ? Ut - re : 0), Lt + Ht, Ut + fe, Lt + Qt, Ut + Ce);
                  }, this.Q = function(Ht, fe, Qt, Ce) {
                    var ze = Lt + 0.6666666666666666 * (Ht - Lt), He = Ut + 2 / 3 * (fe - Ut), Je = Qt + 2 / 3 * (Ht - Qt), ar = Ce + 2 / 3 * (fe - Ce);
                    return this.addCommand(["curve", !0, !0, ze, He, Je, ar, Qt, Ce]), Vt = "Q", Yt = Ht, re = fe, this;
                  }, this.q = function(Ht, fe, Qt, Ce) {
                    return this.Q(Lt + Ht, Ut + fe, Lt + Qt, Ut + Ce);
                  }, this.T = function(Ht, fe) {
                    return this.Q(Lt + (Vt === "Q" ? Lt - Yt : 0), Ut + (Vt === "Q" ? Ut - re : 0), Ht, fe);
                  }, this.t = function(Ht, fe) {
                    return this.Q(Lt + (Vt === "Q" ? Lt - Yt : 0), Ut + (Vt === "Q" ? Ut - re : 0), Lt + Ht, Ut + fe);
                  }, this.A = function(Ht, fe, Qt, Ce, ze, He, Je) {
                    if (rt(Ht, 0) || rt(fe, 0))
                      this.addCommand(["line", !0, !0, He, Je]);
                    else {
                      Qt = Qt * (Math.PI / 180), Ht = Math.abs(Ht), fe = Math.abs(fe), Ce = 1 * !!Ce, ze = 1 * !!ze;
                      var ar = Math.cos(Qt) * (Lt - He) / 2 + Math.sin(Qt) * (Ut - Je) / 2, mr = Math.cos(Qt) * (Ut - Je) / 2 - Math.sin(Qt) * (Lt - He) / 2, we = ar * ar / (Ht * Ht) + mr * mr / (fe * fe);
                      we > 1 && (Ht *= Math.sqrt(we), fe *= Math.sqrt(we));
                      var We = Math.sqrt(Math.max(0, Ht * Ht * fe * fe - Ht * Ht * mr * mr - fe * fe * ar * ar) / (Ht * Ht * mr * mr + fe * fe * ar * ar)), fr = (Ce === ze ? -1 : 1) * We * Ht * mr / fe, Ke = (Ce === ze ? 1 : -1) * We * fe * ar / Ht, pr = Math.cos(Qt) * fr - Math.sin(Qt) * Ke + (Lt + He) / 2, tr = Math.sin(Qt) * fr + Math.cos(Qt) * Ke + (Ut + Je) / 2, Er = Math.atan2((mr - Ke) / fe, (ar - fr) / Ht), xr = Math.atan2((-mr - Ke) / fe, (-ar - fr) / Ht);
                      ze === 0 && xr - Er > 0 ? xr -= 2 * Math.PI : ze === 1 && xr - Er < 0 && (xr += 2 * Math.PI);
                      for (var Gr = Math.ceil(Math.abs(xr - Er) / (Math.PI / wi)), tn = 0; tn < Gr; tn++) {
                        var Qr = Er + tn * (xr - Er) / Gr, _r = Er + (tn + 1) * (xr - Er) / Gr, Yr = 4 / 3 * Math.tan((_r - Qr) / 4), Rr = pr + Math.cos(Qt) * Ht * (Math.cos(Qr) - Yr * Math.sin(Qr)) - Math.sin(Qt) * fe * (Math.sin(Qr) + Yr * Math.cos(Qr)), qn = tr + Math.sin(Qt) * Ht * (Math.cos(Qr) - Yr * Math.sin(Qr)) + Math.cos(Qt) * fe * (Math.sin(Qr) + Yr * Math.cos(Qr)), Sn = pr + Math.cos(Qt) * Ht * (Math.cos(_r) + Yr * Math.sin(_r)) - Math.sin(Qt) * fe * (Math.sin(_r) - Yr * Math.cos(_r)), $r = tr + Math.sin(Qt) * Ht * (Math.cos(_r) + Yr * Math.sin(_r)) + Math.cos(Qt) * fe * (Math.sin(_r) - Yr * Math.cos(_r)), ln = pr + Math.cos(Qt) * Ht * Math.cos(_r) - Math.sin(Qt) * fe * Math.sin(_r), pn = tr + Math.sin(Qt) * Ht * Math.cos(_r) + Math.cos(Qt) * fe * Math.sin(_r);
                        this.addCommand(["curve", tn === 0, tn === Gr - 1, Rr, qn, Sn, $r, ln, pn]);
                      }
                    }
                    return Vt = "A", this;
                  }, this.a = function(Ht, fe, Qt, Ce, ze, He, Je) {
                    return this.A(Ht, fe, Qt, Ce, ze, Lt + He, Ut + Je);
                  }, this.path = function(Ht) {
                    for (var fe, Qt, Ce, ze = new Te((Ht || "").trim()); fe = ze.match(/^[astvzqmhlcASTVZQMHLC]/); ) {
                      ze.matchSeparator();
                      for (var He = []; Qt = b[fe + He.length] ? ze.match(/^[01]/) : ze.matchNumber(); )
                        ze.matchSeparator(), He.length === y[fe] && (this[fe].apply(this, He), He = [], fe === "M" ? fe = "L" : fe === "m" && (fe = "l")), He.push(Number(Qt));
                      if (He.length === y[fe])
                        this[fe].apply(this, He);
                      else {
                        yr("SvgPath: command " + fe + " with " + He.length + " numbers");
                        return;
                      }
                    }
                    return (Ce = ze.matchAll()) && yr("SvgPath: unexpected string " + Ce), this;
                  }, this.getBoundingBox = function() {
                    var Ht = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
                    function fe(Ce) {
                      Ce[0] < Ht[0] && (Ht[0] = Ce[0]), Ce[2] > Ht[2] && (Ht[2] = Ce[2]), Ce[1] < Ht[1] && (Ht[1] = Ce[1]), Ce[3] > Ht[3] && (Ht[3] = Ce[3]);
                    }
                    for (var Qt = 0; Qt < this.pathSegments.length; Qt++)
                      fe(this.pathSegments[Qt].getBoundingBox());
                    return Ht[0] === 1 / 0 && (Ht[0] = 0), Ht[1] === 1 / 0 && (Ht[1] = 0), Ht[2] === -1 / 0 && (Ht[2] = 0), Ht[3] === -1 / 0 && (Ht[3] = 0), Ht;
                  }, this.getPointAtLength = function(Ht) {
                    if (Ht >= 0 && Ht <= this.totalLength) {
                      for (var fe, Qt = 0; Qt < this.pathSegments.length; Qt++) {
                        if (fe = this.pathSegments[Qt].getPointAtLength(Ht))
                          return fe;
                        Ht -= this.pathSegments[Qt].totalLength;
                      }
                      return this.endPoint;
                    }
                  }, this.transform = function(Ht) {
                    this.pathSegments = [], this.startPoint = null, this.endPoint = null, this.totalLength = 0;
                    for (var fe = 0; fe < this.pathCommands.length; fe++) {
                      for (var Qt = this.pathCommands.shift(), Ce = 3; Ce < Qt.length; Ce += 2) {
                        var ze = Gt([Qt[Ce], Qt[Ce + 1]], Ht);
                        Qt[Ce] = ze[0], Qt[Ce + 1] = ze[1];
                      }
                      this.addCommand(Qt);
                    }
                    return this;
                  }, this.mergeShape = function(Ht) {
                    for (var fe = 0; fe < Ht.pathCommands.length; fe++)
                      this.addCommand(Ht.pathCommands[fe].slice());
                    return this;
                  }, this.clone = function() {
                    return new $t().mergeShape(this);
                  }, this.insertInDocument = function() {
                    for (var Ht = 0; Ht < this.pathCommands.length; Ht++) {
                      var fe = this.pathCommands[Ht][0], Qt = this.pathCommands[Ht].slice(3);
                      switch (fe) {
                        case "move":
                          f.moveTo(Qt[0], Qt[1]);
                          break;
                        case "line":
                          f.lineTo(Qt[0], Qt[1]);
                          break;
                        case "curve":
                          f.bezierCurveTo(Qt[0], Qt[1], Qt[2], Qt[3], Qt[4], Qt[5]);
                          break;
                        case "close":
                          f.closePath();
                          break;
                      }
                    }
                  }, this.getSubPaths = function() {
                    for (var Ht = [], fe = new $t(), Qt = 0; Qt < this.pathCommands.length; Qt++) {
                      var Ce = this.pathCommands[Qt], ze = this.pathCommands[Qt][0];
                      ze === "move" && Qt !== 0 && (Ht.push(fe), fe = new $t()), fe.addCommand(Ce);
                    }
                    return Ht.push(fe), Ht;
                  }, this.getMarkers = function() {
                    for (var Ht = [], fe = this.getSubPaths(), Qt = 0; Qt < fe.length; Qt++) {
                      for (var Ce = fe[Qt], ze = [], He = 0; He < Ce.pathSegments.length; He++) {
                        var Je = Ce.pathSegments[He];
                        if (wt(Je.totalLength, 0) || He === 0 || He === Ce.pathSegments.length - 1) {
                          if (Je.hasStart) {
                            var ar = Je.getPointAtLength(0), mr = ze.pop();
                            mr && (ar[2] = 0.5 * (mr[2] + ar[2])), ze.push(ar);
                          }
                          if (Je.hasEnd) {
                            var we = Je.getPointAtLength(Je.totalLength);
                            ze.push(we);
                          }
                        }
                      }
                      Ht = Ht.concat(ze);
                    }
                    return Ht;
                  };
                }, qt = function(Mt, oe) {
                  var Lt = /* @__PURE__ */ Object.create(null), Ut = null;
                  this.name = Mt.nodeName, this.isOuterElement = Mt === h || !Mt.parentNode, this.inherits = oe || (this.isOuterElement ? null : Re(Mt.parentNode, null)), this.stack = this.inherits ? this.inherits.stack.concat(Mt) : [Mt], this.style = Z(typeof Mt.getAttribute == "function" && Mt.getAttribute("style")), this.css = Yn ? getComputedStyle(Mt) : dt(Mt), this.allowedChildren = [], this.attr = function(Vt) {
                    if (typeof Mt.getAttribute == "function")
                      return Mt.getAttribute(Vt);
                  }, this.resolveUrl = function(Vt) {
                    var Yt = (Vt || "").match(/^\s*(?:url\("(.*)#(.*)"\)|url\('(.*)#(.*)'\)|url\((.*)#(.*)\)|(.*)#(.*))\s*$/) || [], re = Yt[1] || Yt[3] || Yt[5] || Yt[7], Ht = Yt[2] || Yt[4] || Yt[6] || Yt[8];
                    if (Ht) {
                      if (!re) {
                        var fe = h.getElementById(Ht);
                        if (fe) {
                          if (this.stack.indexOf(fe) === -1)
                            return fe;
                          yr('SVGtoPDF: loop of circular references for id "' + Ht + '"');
                          return;
                        }
                      }
                      if (un) {
                        var Qt = Me[re];
                        if (!Qt) {
                          Qt = un(re), zt(Qt) || (Qt = [Qt]);
                          for (var Ce = 0; Ce < Qt.length; Ce++)
                            typeof Qt[Ce] == "string" && (Qt[Ce] = ft(Qt[Ce]));
                          Me[re] = Qt;
                        }
                        for (var ze = 0; ze < Qt.length; ze++) {
                          var He = Qt[ze].getElementById(Ht);
                          if (He) {
                            if (this.stack.indexOf(He) === -1)
                              return He;
                            yr('SVGtoPDF: loop of circular references for id "' + re + "#" + Ht + '"');
                            return;
                          }
                        }
                      }
                    }
                  }, this.computeUnits = function(Vt, Yt, re, Ht) {
                    return Yt === "%" ? parseFloat(Vt) / 100 * (Ht || re != null ? re : this.getViewport()) : Yt === "ex" || Yt === "em" ? Vt * {
                      em: 1,
                      ex: 0.5
                    }[Yt] * (Ht ? re : this.get("font-size")) : Vt * {
                      "": 1,
                      px: 1,
                      pt: 96 / 72,
                      cm: 96 / 2.54,
                      mm: 96 / 25.4,
                      in: 96,
                      pc: 96 / 6
                    }[Yt];
                  }, this.computeLength = function(Vt, Yt, re, Ht) {
                    var fe = new Te((Vt || "").trim()), Qt, Ce;
                    return typeof (Qt = fe.matchNumber()) == "string" && typeof (Ce = fe.matchLengthUnit()) == "string" && !fe.matchAll() ? this.computeUnits(Qt, Ce, Yt, Ht) : re;
                  }, this.computeLengthList = function(Vt, Yt, re) {
                    for (var Ht = new Te((Vt || "").trim()), fe = [], Qt, Ce; typeof (Qt = Ht.matchNumber()) == "string" && typeof (Ce = Ht.matchLengthUnit()) == "string"; )
                      fe.push(this.computeUnits(Qt, Ce, Yt)), Ht.matchSeparator();
                    if (!(re && Ht.matchAll()))
                      return fe;
                  }, this.getLength = function(Vt, Yt, re) {
                    return this.computeLength(this.attr(Vt), Yt, re);
                  }, this.getLengthList = function(Vt, Yt) {
                    return this.computeLengthList(this.attr(Vt), Yt);
                  }, this.getUrl = function(Vt) {
                    return this.resolveUrl(this.attr(Vt));
                  }, this.getNumberList = function(Vt) {
                    for (var Yt = new Te((this.attr(Vt) || "").trim()), re = [], Ht; Ht = Yt.matchNumber(); )
                      re.push(Number(Ht)), Yt.matchSeparator();
                    return re.error = Yt.matchAll(), re;
                  }, this.getViewbox = function(Vt, Yt) {
                    var re = this.getNumberList(Vt);
                    return re.length === 4 && re[2] >= 0 && re[3] >= 0 ? re : Yt;
                  }, this.getPercent = function(Vt, Yt) {
                    var re = this.attr(Vt), Ht = new Te((re || "").trim()), fe = Ht.matchNumber();
                    return !fe || (Ht.match("%") && (fe *= 0.01), Ht.matchAll()) ? Yt : Math.max(0, Math.min(1, fe));
                  }, this.chooseValue = function(Vt) {
                    for (var Yt = 0; Yt < arguments.length; Yt++)
                      if (arguments[Yt] != null && arguments[Yt] === arguments[Yt])
                        return arguments[Yt];
                    return arguments[arguments.length - 1];
                  }, this.get = function(Vt) {
                    if (Lt[Vt] !== void 0)
                      return Lt[Vt];
                    for (var Yt = n[Vt] || {}, re, Ht, fe = 0; fe < 3; fe++) {
                      switch (fe) {
                        case 0:
                          Vt !== "transform" && (re = this.css[Yt.css || Vt]);
                          break;
                        case 1:
                          re = this.style[Vt];
                          break;
                        case 2:
                          re = this.attr(Vt);
                          break;
                      }
                      if (re === "inherit" && (Ht = this.inherits ? this.inherits.get(Vt) : Yt.initial, Ht != null) || Yt.values != null && (Ht = Yt.values[re], Ht != null))
                        return Lt[Vt] = Ht;
                      if (re != null) {
                        var Qt = void 0;
                        switch (Vt) {
                          case "font-size":
                            Ht = this.computeLength(re, this.inherits ? this.inherits.get(Vt) : Yt.initial, void 0, !0);
                            break;
                          case "baseline-shift":
                            Ht = this.computeLength(re, this.get("font-size"));
                            break;
                          case "font-family":
                            Ht = re || void 0;
                            break;
                          case "opacity":
                          case "stroke-opacity":
                          case "fill-opacity":
                          case "stop-opacity":
                            Qt = parseFloat(re), isNaN(Qt) || (Ht = Math.max(0, Math.min(1, Qt)));
                            break;
                          case "transform":
                            Ht = G(re);
                            break;
                          case "stroke-dasharray":
                            if (re === "none")
                              Ht = [];
                            else if (Qt = this.computeLengthList(re, this.getViewport(), !0)) {
                              for (var Ce = 0, ze = !1, He = 0; He < Qt.length; He++)
                                Qt[He] < 0 && (ze = !0), Ce += Qt[He];
                              ze || (Qt.length % 2 === 1 && (Qt = Qt.concat(Qt)), Ht = Ce === 0 ? [] : Qt);
                            }
                            break;
                          case "color":
                            re === "none" || re === "transparent" ? Ht = "none" : Ht = xt(re);
                            break;
                          case "fill":
                          case "stroke":
                            if (re === "none" || re === "transparent")
                              Ht = "none";
                            else if (re === "currentColor")
                              Ht = this.get("color");
                            else {
                              if (Qt = xt(re))
                                return Qt;
                              if (Qt = (re || "").split(" ")) {
                                var Je = this.resolveUrl(Qt[0]), ar = xt(Qt[1]);
                                Je == null ? Ht = ar : Je.nodeName === "linearGradient" || Je.nodeName === "radialGradient" ? Ht = new yt(Je, null, ar) : Je.nodeName === "pattern" ? Ht = new V(Je, null, ar) : Ht = ar;
                              }
                            }
                            break;
                          case "stop-color":
                            re === "none" || re === "transparent" ? Ht = "none" : re === "currentColor" ? Ht = this.get("color") : Ht = xt(re);
                            break;
                          case "marker-start":
                          case "marker-mid":
                          case "marker-end":
                          case "clip-path":
                          case "mask":
                            re === "none" ? Ht = "none" : Ht = this.resolveUrl(re);
                            break;
                          case "stroke-width":
                            Qt = this.computeLength(re, this.getViewport()), Qt != null && Qt >= 0 && (Ht = Qt);
                            break;
                          case "stroke-miterlimit":
                            Qt = parseFloat(re), Qt != null && Qt >= 1 && (Ht = Qt);
                            break;
                          case "word-spacing":
                          case "letter-spacing":
                            Ht = this.computeLength(re, this.getViewport());
                            break;
                          case "stroke-dashoffset":
                            if (Ht = this.computeLength(re, this.getViewport()), Ht != null && Ht < 0)
                              for (var mr = this.get("stroke-dasharray"), we = 0; we < mr.length; we++)
                                Ht += mr[we];
                            break;
                        }
                        if (Ht != null)
                          return Lt[Vt] = Ht;
                      }
                    }
                    return Lt[Vt] = Yt.inherit && this.inherits ? this.inherits.get(Vt) : Yt.initial;
                  }, this.getChildren = function() {
                    if (Ut != null)
                      return Ut;
                    for (var Vt = [], Yt = 0; Yt < Mt.childNodes.length; Yt++) {
                      var re = Mt.childNodes[Yt];
                      !re.error && this.allowedChildren.indexOf(re.nodeName) !== -1 && Vt.push(Re(re, this));
                    }
                    return Ut = Vt;
                  }, this.getParentVWidth = function() {
                    return this.inherits ? this.inherits.getVWidth() : Jr;
                  }, this.getParentVHeight = function() {
                    return this.inherits ? this.inherits.getVHeight() : dn;
                  }, this.getParentViewport = function() {
                    return Math.sqrt(0.5 * this.getParentVWidth() * this.getParentVWidth() + 0.5 * this.getParentVHeight() * this.getParentVHeight());
                  }, this.getVWidth = function() {
                    return this.getParentVWidth();
                  }, this.getVHeight = function() {
                    return this.getParentVHeight();
                  }, this.getViewport = function() {
                    return Math.sqrt(0.5 * this.getVWidth() * this.getVWidth() + 0.5 * this.getVHeight() * this.getVHeight());
                  }, this.getBoundingBox = function() {
                    var Vt = this.getBoundingShape();
                    return Vt.getBoundingBox();
                  };
                }, ve = function(Mt, oe) {
                  qt.call(this, Mt, oe), this.transform = function() {
                    f.transform.apply(f, this.getTransformation());
                  }, this.clip = function() {
                    if (this.get("clip-path") !== "none") {
                      var Lt = new Ve(this.get("clip-path"), null);
                      return Lt.useMask(this.getBoundingBox()), !0;
                    }
                  }, this.mask = function() {
                    if (this.get("mask") !== "none") {
                      var Lt = new ke(this.get("mask"), null);
                      return Lt.useMask(this.getBoundingBox()), !0;
                    }
                  }, this.getFill = function(Lt, Ut) {
                    var Vt = this.get("opacity"), Yt = this.get("fill"), re = this.get("fill-opacity");
                    if (Lt)
                      return g.white;
                    if (Yt !== "none" && Vt && re)
                      return Yt instanceof yt || Yt instanceof V ? Yt.getPaint(this.getBoundingBox(), re * Vt, Lt, Ut) : St(Yt, re * Vt, Ut);
                  }, this.getStroke = function(Lt, Ut) {
                    var Vt = this.get("opacity"), Yt = this.get("stroke"), re = this.get("stroke-opacity");
                    if (!(Lt || rt(this.get("stroke-width"), 0)) && Yt !== "none" && Vt && re)
                      return Yt instanceof yt || Yt instanceof V ? Yt.getPaint(this.getBoundingBox(), re * Vt, Lt, Ut) : St(Yt, re * Vt, Ut);
                  };
                }, Se = function(Mt, oe) {
                  ve.call(this, Mt, oe), this.allowedChildren = ["use", "g", "a", "svg", "image", "rect", "circle", "ellipse", "line", "polyline", "polygon", "path", "text"], this.getBoundingShape = function() {
                    for (var Lt = new Zt(), Ut = this.getChildren(), Vt = 0; Vt < Ut.length; Vt++)
                      if (Ut[Vt].get("display") !== "none" && typeof Ut[Vt].getBoundingShape == "function") {
                        var Yt = Ut[Vt].getBoundingShape().clone();
                        typeof Ut[Vt].getTransformation == "function" && Yt.transform(Ut[Vt].getTransformation()), Lt.mergeShape(Yt);
                      }
                    return Lt;
                  }, this.drawChildren = function(Lt, Ut) {
                    for (var Vt = this.getChildren(), Yt = 0; Yt < Vt.length; Yt++)
                      Vt[Yt].get("display") !== "none" && typeof Vt[Yt].drawInDocument == "function" && Vt[Yt].drawInDocument(Lt, Ut);
                  };
                }, Pe = function(Mt, oe) {
                  Se.call(this, Mt, oe), this.drawContent = function(Lt, Ut) {
                    this.transform();
                    var Vt = this.clip(), Yt = this.mask(), re;
                    (this.get("opacity") < 1 || Vt || Yt) && !Lt && (re = w(bt())), this.drawChildren(Lt, Ut), re && (E(re), f.fillOpacity(this.get("opacity")), A(re));
                  };
                }, Be = function(Mt, oe) {
                  Pe.call(this, Mt, oe);
                  var Lt = this.getLength("x", this.getVWidth(), 0), Ut = this.getLength("y", this.getVHeight(), 0), Vt = this.getUrl("href") || this.getUrl("xlink:href");
                  Vt && (Vt = Re(Vt, this)), this.getChildren = function() {
                    return Vt ? [Vt] : [];
                  }, this.drawInDocument = function(Yt, re) {
                    f.save(), this.drawContent(Yt, re), f.restore();
                  }, this.getTransformation = function() {
                    return Pt(this.get("transform"), [1, 0, 0, 1, Lt, Ut]);
                  };
                }, De = function(Mt, oe) {
                  Pe.call(this, Mt, oe);
                  var Lt = this.getLength("width", this.getParentVWidth(), this.getParentVWidth()), Ut = this.getLength("height", this.getParentVHeight(), this.getParentVHeight());
                  oe instanceof Be && (Lt = oe.getLength("width", oe.getParentVWidth(), Lt), Ut = oe.getLength("height", oe.getParentVHeight(), Ut));
                  var Vt = (this.attr("preserveAspectRatio") || "").trim(), Yt = this.getViewbox("viewBox", [0, 0, Lt, Ut]);
                  this.getVWidth = function() {
                    return Yt[2];
                  }, this.getVHeight = function() {
                    return Yt[3];
                  }, this.drawInDocument = function(re, Ht) {
                    f.save(), this.drawContent(re, Ht), f.restore();
                  }, this.getTransformation = function() {
                    return Pt(D(Vt, Lt, Ut, Yt[2], Yt[3]), [1, 0, 0, 1, -Yt[0], -Yt[1]]);
                  };
                }, It = function(Mt, oe) {
                  Pe.call(this, Mt, oe), this.drawInDocument = function(Lt, Ut) {
                    f.save(), this.link && !Lt && !Ut && this.addLink(), this.drawContent(Lt, Ut), f.restore();
                  }, this.getTransformation = function() {
                    return this.get("transform");
                  };
                }, he = function(Mt, oe) {
                  oe && oe.isText ? (Wr.call(this, Mt, oe), this.allowedChildren = ["textPath", "tspan", "#text", "#cdata-section", "a"]) : It.call(this, Mt, oe), this.link = this.attr("href") || this.attr("xlink:href"), this.addLink = function() {
                    if (this.link.match(/^(?:[a-z][a-z0-9+.-]*:|\/\/)?/i) && this.getChildren().length) {
                      var Lt = this.getBoundingShape().transform(Rt()).getBoundingBox();
                      J(Lt[0], Lt[1], Lt[2], Lt[3], this.link);
                    }
                  };
                }, nt = function(Mt, oe) {
                  Pe.call(this, Mt, oe);
                  var Lt = this.getLength("width", this.getParentVWidth(), this.getParentVWidth()), Ut = this.getLength("height", this.getParentVHeight(), this.getParentVHeight()), Vt = this.getLength("x", this.getParentVWidth(), 0), Yt = this.getLength("y", this.getParentVHeight(), 0);
                  oe instanceof Be && (Lt = oe.getLength("width", oe.getParentVWidth(), Lt), Ut = oe.getLength("height", oe.getParentVHeight(), Ut));
                  var re = this.attr("preserveAspectRatio"), Ht = this.getViewbox("viewBox", [0, 0, Lt, Ut]);
                  this.isOuterElement && kn && (Vt = Yt = 0, Lt = Jr, Ut = dn, re = kn), this.getVWidth = function() {
                    return Ht[2];
                  }, this.getVHeight = function() {
                    return Ht[3];
                  }, this.drawInDocument = function(fe, Qt) {
                    f.save(), this.get("overflow") === "hidden" && (new Zt().M(Vt, Yt).L(Vt + Lt, Yt).L(Vt + Lt, Yt + Ut).L(Vt, Yt + Ut).Z().transform(this.get("transform")).insertInDocument(), f.clip()), this.drawContent(fe, Qt), f.restore();
                  }, this.getTransformation = function() {
                    return Pt(this.get("transform"), [1, 0, 0, 1, Vt, Yt], D(re, Lt, Ut, Ht[2], Ht[3]), [1, 0, 0, 1, -Ht[0], -Ht[1]]);
                  };
                }, j = function(Mt, oe) {
                  ve.call(this, Mt, oe);
                  var Lt = qr(this.attr("href") || this.attr("xlink:href") || ""), Ut = this.getLength("x", this.getVWidth(), 0), Vt = this.getLength("y", this.getVHeight(), 0), Yt = this.getLength("width", this.getVWidth(), "auto"), re = this.getLength("height", this.getVHeight(), "auto"), Ht;
                  try {
                    Ht = f.openImage(Lt);
                  } catch {
                    yr('SVGElemImage: failed to open image "' + Lt + '" in PDFKit');
                  }
                  Ht && (Yt === "auto" && re !== "auto" ? Yt = re * Ht.width / Ht.height : re === "auto" && Yt !== "auto" ? re = Yt * Ht.height / Ht.width : Yt === "auto" && re === "auto" && (Yt = Ht.width, re = Ht.height)), (Yt === "auto" || Yt < 0) && (Yt = 0), (re === "auto" || re < 0) && (re = 0), this.getTransformation = function() {
                    return this.get("transform");
                  }, this.getBoundingShape = function() {
                    return new Zt().M(Ut, Vt).L(Ut + Yt, Vt).M(Ut + Yt, Vt + re).L(Ut, Vt + re);
                  }, this.drawInDocument = function(fe, Qt) {
                    this.get("visibility") === "hidden" || !Ht || (f.save(), this.transform(), this.get("overflow") === "hidden" && f.rect(Ut, Vt, Yt, re).clip(), this.clip(), this.mask(), f.translate(Ut, Vt), f.transform.apply(f, D(this.attr("preserveAspectRatio"), Yt, re, Ht ? Ht.width : Yt, Ht ? Ht.height : re)), fe ? (f.rect(0, 0, Ht.width, Ht.height), z(g.white).fill()) : (f.fillOpacity(this.get("opacity")), f.image(Ht, 0, 0)), f.restore());
                  };
                }, V = function $t(Mt, oe, Lt) {
                  Se.call(this, Mt, oe), this.ref = (function() {
                    var Yt = this.getUrl("href") || this.getUrl("xlink:href");
                    if (Yt && Yt.nodeName === Mt.nodeName)
                      return new $t(Yt, oe, Lt);
                  }).call(this);
                  var Ut = this.attr;
                  this.attr = function(Yt) {
                    var re = Ut.call(this, Yt);
                    return re != null || Yt === "href" || Yt === "xlink:href" ? re : this.ref ? this.ref.attr(Yt) : null;
                  };
                  var Vt = this.getChildren;
                  this.getChildren = function() {
                    var Yt = Vt.call(this);
                    return Yt.length > 0 ? Yt : this.ref ? this.ref.getChildren() : [];
                  }, this.getPaint = function(Yt, re, Ht, fe) {
                    var Qt = this.attr("patternUnits") !== "userSpaceOnUse", Ce = this.attr("patternContentUnits") === "objectBoundingBox", ze = this.getLength("x", Qt ? 1 : this.getParentVWidth(), 0), He = this.getLength("y", Qt ? 1 : this.getParentVHeight(), 0), Je = this.getLength("width", Qt ? 1 : this.getParentVWidth(), 0), ar = this.getLength("height", Qt ? 1 : this.getParentVHeight(), 0);
                    Ce && !Qt ? (ze = (ze - Yt[0]) / (Yt[2] - Yt[0]) || 0, He = (He - Yt[1]) / (Yt[3] - Yt[1]) || 0, Je = Je / (Yt[2] - Yt[0]) || 0, ar = ar / (Yt[3] - Yt[1]) || 0) : !Ce && Qt && (ze = Yt[0] + ze * (Yt[2] - Yt[0]), He = Yt[1] + He * (Yt[3] - Yt[1]), Je = Je * (Yt[2] - Yt[0]), ar = ar * (Yt[3] - Yt[1]));
                    var mr = this.getViewbox("viewBox", [0, 0, Je, ar]), we = (this.attr("preserveAspectRatio") || "").trim(), We = Pt(D(we, Je, ar, mr[2], mr[3], 0), [1, 0, 0, 1, -mr[0], -mr[1]]), fr = G(this.attr("patternTransform"));
                    if (Ce && (fr = Pt([Yt[2] - Yt[0], 0, 0, Yt[3] - Yt[1], Yt[0], Yt[1]], fr)), fr = Pt(fr, [1, 0, 0, 1, ze, He]), (fr = X(fr)) && (We = X(We)) && (Je = Ft(Je)) && (ar = Ft(ar))) {
                      var Ke = w([0, 0, Je, ar]);
                      return f.transform.apply(f, We), this.drawChildren(Ht, fe), E(Ke), [C(Ke, Je, ar, fr), re];
                    } else
                      return Lt ? [Lt[0], Lt[1] * re] : void 0;
                  }, this.getVWidth = function() {
                    var Yt = this.attr("patternUnits") !== "userSpaceOnUse", re = this.getLength("width", Yt ? 1 : this.getParentVWidth(), 0);
                    return this.getViewbox("viewBox", [0, 0, re, 0])[2];
                  }, this.getVHeight = function() {
                    var Yt = this.attr("patternUnits") !== "userSpaceOnUse", re = this.getLength("height", Yt ? 1 : this.getParentVHeight(), 0);
                    return this.getViewbox("viewBox", [0, 0, 0, re])[3];
                  };
                }, yt = function $t(Mt, oe, Lt) {
                  qt.call(this, Mt, oe), this.allowedChildren = ["stop"], this.ref = (function() {
                    var Yt = this.getUrl("href") || this.getUrl("xlink:href");
                    if (Yt && Yt.nodeName === Mt.nodeName)
                      return new $t(Yt, oe, Lt);
                  }).call(this);
                  var Ut = this.attr;
                  this.attr = function(Yt) {
                    var re = Ut.call(this, Yt);
                    return re != null || Yt === "href" || Yt === "xlink:href" ? re : this.ref ? this.ref.attr(Yt) : null;
                  };
                  var Vt = this.getChildren;
                  this.getChildren = function() {
                    var Yt = Vt.call(this);
                    return Yt.length > 0 ? Yt : this.ref ? this.ref.getChildren() : [];
                  }, this.getPaint = function(Yt, re, Ht, fe) {
                    var Qt = this.getChildren();
                    if (Qt.length !== 0) {
                      if (Qt.length === 1) {
                        var Ce = Qt[0], ze = Ce.get("stop-color");
                        return ze === "none" ? void 0 : St(ze, Ce.get("stop-opacity") * re, fe);
                      }
                      var He = this.attr("gradientUnits") !== "userSpaceOnUse", Je = G(this.attr("gradientTransform")), ar = this.attr("spreadMethod"), mr, we, We, fr, Ke, pr, tr = 0, Er = 0, xr = 1;
                      if (He && (Je = Pt([Yt[2] - Yt[0], 0, 0, Yt[3] - Yt[1], Yt[0], Yt[1]], Je)), Je = X(Je)) {
                        if (this.name === "linearGradient")
                          we = this.getLength("x1", He ? 1 : this.getVWidth(), 0), We = this.getLength("x2", He ? 1 : this.getVWidth(), He ? 1 : this.getVWidth()), fr = this.getLength("y1", He ? 1 : this.getVHeight(), 0), Ke = this.getLength("y2", He ? 1 : this.getVHeight(), 0);
                        else {
                          We = this.getLength("cx", He ? 1 : this.getVWidth(), He ? 0.5 : 0.5 * this.getVWidth()), Ke = this.getLength("cy", He ? 1 : this.getVHeight(), He ? 0.5 : 0.5 * this.getVHeight()), pr = this.getLength("r", He ? 1 : this.getViewport(), He ? 0.5 : 0.5 * this.getViewport()), we = this.getLength("fx", He ? 1 : this.getVWidth(), We), fr = this.getLength("fy", He ? 1 : this.getVHeight(), Ke), pr < 0 && yr("SvgElemGradient: negative r value");
                          var Gr = Math.sqrt(Math.pow(We - we, 2) + Math.pow(Ke - fr, 2)), tn = 1;
                          Gr > pr && (tn = pr / Gr, we = We + (we - We) * tn, fr = Ke + (fr - Ke) * tn), pr = Math.max(pr, Gr * tn * (1 + 1e-6));
                        }
                        if (ar === "reflect" || ar === "repeat") {
                          var Qr = Dt(Je), _r = Gt([Yt[0], Yt[1]], Qr), Yr = Gt([Yt[2], Yt[1]], Qr), Rr = Gt([Yt[2], Yt[3]], Qr), qn = Gt([Yt[0], Yt[3]], Qr);
                          this.name === "linearGradient" ? (tr = Math.max((_r[0] - We) * (We - we) + (_r[1] - Ke) * (Ke - fr), (Yr[0] - We) * (We - we) + (Yr[1] - Ke) * (Ke - fr), (Rr[0] - We) * (We - we) + (Rr[1] - Ke) * (Ke - fr), (qn[0] - We) * (We - we) + (qn[1] - Ke) * (Ke - fr)) / (Math.pow(We - we, 2) + Math.pow(Ke - fr, 2)), Er = Math.max((_r[0] - we) * (we - We) + (_r[1] - fr) * (fr - Ke), (Yr[0] - we) * (we - We) + (Yr[1] - fr) * (fr - Ke), (Rr[0] - we) * (we - We) + (Rr[1] - fr) * (fr - Ke), (qn[0] - we) * (we - We) + (qn[1] - fr) * (fr - Ke)) / (Math.pow(We - we, 2) + Math.pow(Ke - fr, 2))) : tr = Math.sqrt(Math.max(Math.pow(_r[0] - We, 2) + Math.pow(_r[1] - Ke, 2), Math.pow(Yr[0] - We, 2) + Math.pow(Yr[1] - Ke, 2), Math.pow(Rr[0] - We, 2) + Math.pow(Rr[1] - Ke, 2), Math.pow(qn[0] - We, 2) + Math.pow(qn[1] - Ke, 2))) / pr - 1, tr = Math.ceil(tr + 0.5), Er = Math.ceil(Er + 0.5), xr = Er + 1 + tr;
                        }
                        this.name === "linearGradient" ? mr = f.linearGradient(we - Er * (We - we), fr - Er * (Ke - fr), We + tr * (We - we), Ke + tr * (Ke - fr)) : mr = f.radialGradient(we, fr, 0, We, Ke, pr + tr * pr);
                        for (var Sn = 0; Sn < xr; Sn++)
                          for (var $r = 0, ln = ar !== "reflect" || (Sn - Er) % 2 === 0, pn = 0; pn < Qt.length; pn++) {
                            var Nn = Qt[ln ? pn : Qt.length - 1 - pn], Rn = Nn.get("stop-color");
                            Rn === "none" && (Rn = g.transparent), Rn = St(Rn, Nn.get("stop-opacity") * re, fe), $r = Math.max($r, ln ? Nn.getPercent("offset", 0) : 1 - Nn.getPercent("offset", 0)), pn === 0 && Rn[0].length === 4 && (mr._colorSpace = "DeviceCMYK"), pn === 0 && $r > 0 && mr.stop((Sn + 0) / xr, Rn[0], Rn[1]), mr.stop((Sn + $r) / (tr + Er + 1), Rn[0], Rn[1]), pn === Qt.length - 1 && $r < 1 && mr.stop((Sn + 1) / xr, Rn[0], Rn[1]);
                          }
                        return mr.setTransform.apply(mr, Je), [mr, 1];
                      } else
                        return Lt ? [Lt[0], Lt[1] * re] : void 0;
                    }
                  };
                }, it = function(Mt, oe) {
                  ve.call(this, Mt, oe), this.dashScale = 1, this.getBoundingShape = function() {
                    return this.shape;
                  }, this.getTransformation = function() {
                    return this.get("transform");
                  }, this.drawInDocument = function(Lt, Ut) {
                    if (!(this.get("visibility") === "hidden" || !this.shape)) {
                      if (f.save(), this.transform(), this.clip(), Lt)
                        this.shape.insertInDocument(), z(g.white), f.fill(this.get("clip-rule"));
                      else {
                        var Vt = this.mask(), Yt;
                        Vt && (Yt = w(bt()));
                        var re = this.shape.getSubPaths(), Ht = this.getFill(Lt, Ut), fe = this.getStroke(Lt, Ut), Qt = this.get("stroke-width"), Ce = this.get("stroke-linecap");
                        if (Ht || fe) {
                          if (Ht && z(Ht), fe) {
                            for (var ze = 0; ze < re.length; ze++)
                              if (rt(re[ze].totalLength, 0) && (Ce === "square" || Ce === "round") && Qt > 0 && re[ze].startPoint && re[ze].startPoint.length > 1) {
                                var He = re[ze].startPoint[0], Je = re[ze].startPoint[1];
                                z(fe), Ce === "square" ? f.rect(He - 0.5 * Qt, Je - 0.5 * Qt, Qt, Qt) : Ce === "round" && f.circle(He, Je, 0.5 * Qt), f.fill();
                              }
                            var ar = this.get("stroke-dasharray"), mr = this.get("stroke-dashoffset");
                            if (wt(this.dashScale, 1)) {
                              for (var we = 0; we < ar.length; we++)
                                ar[we] *= this.dashScale;
                              mr *= this.dashScale;
                            }
                            L(fe), f.lineWidth(Qt).miterLimit(this.get("stroke-miterlimit")).lineJoin(this.get("stroke-linejoin")).lineCap(Ce).dash(ar, {
                              phase: mr
                            });
                          }
                          for (var We = 0; We < re.length; We++)
                            re[We].totalLength > 0 && re[We].insertInDocument();
                          Ht && fe ? f.fillAndStroke(this.get("fill-rule")) : Ht ? f.fill(this.get("fill-rule")) : fe && f.stroke();
                        }
                        var fr = this.get("marker-start"), Ke = this.get("marker-mid"), pr = this.get("marker-end");
                        if (fr !== "none" || Ke !== "none" || pr !== "none") {
                          var tr = this.shape.getMarkers();
                          if (fr !== "none") {
                            var Er = new ue(fr, null);
                            Er.drawMarker(!1, Ut, tr[0], Qt);
                          }
                          if (Ke !== "none")
                            for (var xr = 1; xr < tr.length - 1; xr++) {
                              var Gr = new ue(Ke, null);
                              Gr.drawMarker(!1, Ut, tr[xr], Qt);
                            }
                          if (pr !== "none") {
                            var tn = new ue(pr, null);
                            tn.drawMarker(!1, Ut, tr[tr.length - 1], Qt);
                          }
                        }
                        Yt && (E(Yt), A(Yt));
                      }
                      f.restore();
                    }
                  };
                }, _t = function(Mt, oe) {
                  it.call(this, Mt, oe);
                  var Lt = this.getLength("x", this.getVWidth(), 0), Ut = this.getLength("y", this.getVHeight(), 0), Vt = this.getLength("width", this.getVWidth(), 0), Yt = this.getLength("height", this.getVHeight(), 0), re = this.getLength("rx", this.getVWidth()), Ht = this.getLength("ry", this.getVHeight());
                  re === void 0 && Ht === void 0 ? re = Ht = 0 : re === void 0 && Ht !== void 0 ? re = Ht : re !== void 0 && Ht === void 0 && (Ht = re), Vt > 0 && Yt > 0 ? re && Ht ? (re = Math.min(re, 0.5 * Vt), Ht = Math.min(Ht, 0.5 * Yt), this.shape = new Zt().M(Lt + re, Ut).L(Lt + Vt - re, Ut).A(re, Ht, 0, 0, 1, Lt + Vt, Ut + Ht).L(Lt + Vt, Ut + Yt - Ht).A(re, Ht, 0, 0, 1, Lt + Vt - re, Ut + Yt).L(Lt + re, Ut + Yt).A(re, Ht, 0, 0, 1, Lt, Ut + Yt - Ht).L(Lt, Ut + Ht).A(re, Ht, 0, 0, 1, Lt + re, Ut).Z()) : this.shape = new Zt().M(Lt, Ut).L(Lt + Vt, Ut).L(Lt + Vt, Ut + Yt).L(Lt, Ut + Yt).Z() : this.shape = new Zt();
                }, ne = function(Mt, oe) {
                  it.call(this, Mt, oe);
                  var Lt = this.getLength("cx", this.getVWidth(), 0), Ut = this.getLength("cy", this.getVHeight(), 0), Vt = this.getLength("r", this.getViewport(), 0);
                  Vt > 0 ? this.shape = new Zt().M(Lt + Vt, Ut).A(Vt, Vt, 0, 0, 1, Lt - Vt, Ut).A(Vt, Vt, 0, 0, 1, Lt + Vt, Ut).Z() : this.shape = new Zt();
                }, Y = function(Mt, oe) {
                  it.call(this, Mt, oe);
                  var Lt = this.getLength("cx", this.getVWidth(), 0), Ut = this.getLength("cy", this.getVHeight(), 0), Vt = this.getLength("rx", this.getVWidth(), 0), Yt = this.getLength("ry", this.getVHeight(), 0);
                  Vt > 0 && Yt > 0 ? this.shape = new Zt().M(Lt + Vt, Ut).A(Vt, Yt, 0, 0, 1, Lt - Vt, Ut).A(Vt, Yt, 0, 0, 1, Lt + Vt, Ut).Z() : this.shape = new Zt();
                }, Jt = function(Mt, oe) {
                  it.call(this, Mt, oe);
                  var Lt = this.getLength("x1", this.getVWidth(), 0), Ut = this.getLength("y1", this.getVHeight(), 0), Vt = this.getLength("x2", this.getVWidth(), 0), Yt = this.getLength("y2", this.getVHeight(), 0);
                  this.shape = new Zt().M(Lt, Ut).L(Vt, Yt);
                }, ie = function(Mt, oe) {
                  it.call(this, Mt, oe);
                  var Lt = this.getNumberList("points");
                  this.shape = new Zt();
                  for (var Ut = 0; Ut < Lt.length - 1; Ut += 2)
                    Ut === 0 ? this.shape.M(Lt[Ut], Lt[Ut + 1]) : this.shape.L(Lt[Ut], Lt[Ut + 1]);
                  Lt.error && yr("SvgElemPolygon: unexpected string " + Lt.error), Lt.length % 2 === 1 && yr("SvgElemPolyline: uneven number of coordinates");
                }, Tt = function(Mt, oe) {
                  it.call(this, Mt, oe);
                  var Lt = this.getNumberList("points");
                  this.shape = new Zt();
                  for (var Ut = 0; Ut < Lt.length - 1; Ut += 2)
                    Ut === 0 ? this.shape.M(Lt[Ut], Lt[Ut + 1]) : this.shape.L(Lt[Ut], Lt[Ut + 1]);
                  this.shape.Z(), Lt.error && yr("SvgElemPolygon: unexpected string " + Lt.error), Lt.length % 2 === 1 && yr("SvgElemPolygon: uneven number of coordinates");
                }, Xt = function(Mt, oe) {
                  it.call(this, Mt, oe), this.shape = new Zt().path(this.attr("d"));
                  var Lt = this.getLength("pathLength", this.getViewport());
                  this.pathLength = Lt > 0 ? Lt : void 0, this.dashScale = this.pathLength !== void 0 ? this.shape.totalLength / this.pathLength : 1;
                }, ue = function(Mt, oe) {
                  Se.call(this, Mt, oe);
                  var Lt = this.getLength("markerWidth", this.getParentVWidth(), 3), Ut = this.getLength("markerHeight", this.getParentVHeight(), 3), Vt = this.getViewbox("viewBox", [0, 0, Lt, Ut]);
                  this.getVWidth = function() {
                    return Vt[2];
                  }, this.getVHeight = function() {
                    return Vt[3];
                  }, this.drawMarker = function(Yt, re, Ht, fe) {
                    f.save();
                    var Qt = this.attr("orient"), Ce = this.attr("markerUnits"), ze = Qt === "auto" ? Ht[2] : (parseFloat(Qt) || 0) * Math.PI / 180, He = Ce === "userSpaceOnUse" ? 1 : fe;
                    f.transform(Math.cos(ze) * He, Math.sin(ze) * He, -Math.sin(ze) * He, Math.cos(ze) * He, Ht[0], Ht[1]);
                    var Je = this.getLength("refX", this.getVWidth(), 0), ar = this.getLength("refY", this.getVHeight(), 0), mr = D(this.attr("preserveAspectRatio"), Lt, Ut, Vt[2], Vt[3], 0.5);
                    this.get("overflow") === "hidden" && f.rect(mr[0] * (Vt[0] + Vt[2] / 2 - Je) - Lt / 2, mr[3] * (Vt[1] + Vt[3] / 2 - ar) - Ut / 2, Lt, Ut).clip(), f.transform.apply(f, mr), f.translate(-Je, -ar);
                    var we;
                    this.get("opacity") < 1 && !Yt && (we = w(bt())), this.drawChildren(Yt, re), we && (E(we), f.fillOpacity(this.get("opacity")), A(we)), f.restore();
                  };
                }, Ve = function(Mt, oe) {
                  Se.call(this, Mt, oe), this.useMask = function(Lt) {
                    var Ut = w(bt());
                    f.save(), this.attr("clipPathUnits") === "objectBoundingBox" && f.transform(Lt[2] - Lt[0], 0, 0, Lt[3] - Lt[1], Lt[0], Lt[1]), this.clip(), this.drawChildren(!0, !1), f.restore(), E(Ut), O(Ut, !0);
                  };
                }, ke = function(Mt, oe) {
                  Se.call(this, Mt, oe), this.useMask = function(Lt) {
                    var Ut = w(bt());
                    f.save();
                    var Vt, Yt, re, Ht;
                    this.attr("maskUnits") === "userSpaceOnUse" ? (Vt = this.getLength("x", this.getVWidth(), -0.1 * (Lt[2] - Lt[0]) + Lt[0]), Yt = this.getLength("y", this.getVHeight(), -0.1 * (Lt[3] - Lt[1]) + Lt[1]), re = this.getLength("width", this.getVWidth(), 1.2 * (Lt[2] - Lt[0])), Ht = this.getLength("height", this.getVHeight(), 1.2 * (Lt[3] - Lt[1]))) : (Vt = this.getLength("x", this.getVWidth(), -0.1) * (Lt[2] - Lt[0]) + Lt[0], Yt = this.getLength("y", this.getVHeight(), -0.1) * (Lt[3] - Lt[1]) + Lt[1], re = this.getLength("width", this.getVWidth(), 1.2) * (Lt[2] - Lt[0]), Ht = this.getLength("height", this.getVHeight(), 1.2) * (Lt[3] - Lt[1])), f.rect(Vt, Yt, re, Ht).clip(), this.attr("maskContentUnits") === "objectBoundingBox" && f.transform(Lt[2] - Lt[0], 0, 0, Lt[3] - Lt[1], Lt[0], Lt[1]), this.clip(), this.drawChildren(!1, !0), f.restore(), E(Ut), O(Ut, !0);
                  };
                }, Xe = function(Mt, oe) {
                  ve.call(this, Mt, oe), this.allowedChildren = ["tspan", "#text", "#cdata-section", "a"], this.isText = !0, this.getBoundingShape = function() {
                    for (var Lt = new Zt(), Ut = 0; Ut < this._pos.length; Ut++) {
                      var Vt = this._pos[Ut];
                      if (!Vt.hidden) {
                        var Yt = Vt.ascent * Math.sin(Vt.rotate), re = -Vt.ascent * Math.cos(Vt.rotate), Ht = Vt.descent * Math.sin(Vt.rotate), fe = -Vt.descent * Math.cos(Vt.rotate), Qt = Vt.width * Math.cos(Vt.rotate), Ce = Vt.width * Math.sin(Vt.rotate);
                        Lt.M(Vt.x + Yt, Vt.y + re).L(Vt.x + Yt + Qt, Vt.y + re + Ce).M(Vt.x + Ht + Qt, Vt.y + fe + Ce).L(Vt.x + Ht, Vt.y + fe);
                      }
                    }
                    return Lt;
                  }, this.drawTextInDocument = function(Lt, Ut) {
                    this.link && !Lt && !Ut && this.addLink(), this.get("text-decoration") === "underline" && this.decorate(0.05 * this._font.size, -0.075 * this._font.size, Lt, Ut), this.get("text-decoration") === "overline" && this.decorate(0.05 * this._font.size, jt(this._font.font, this._font.size) + 0.075 * this._font.size, Lt, Ut);
                    var Vt = this.getFill(Lt, Ut), Yt = this.getStroke(Lt, Ut), re = this.get("stroke-width");
                    this._font.fauxBold && (Yt ? re += this._font.size * 0.03 : (Yt = Vt, re = this._font.size * 0.03));
                    for (var Ht = this.getChildren(), fe = 0; fe < Ht.length; fe++) {
                      var Qt = Ht[fe];
                      switch (Qt.name) {
                        case "tspan":
                        case "textPath":
                        case "a":
                          Qt.get("display") !== "none" && Qt.drawTextInDocument(Lt, Ut);
                          break;
                        case "#text":
                        case "#cdata-section":
                          if (this.get("visibility") === "hidden")
                            continue;
                          if (Vt || Yt || Lt) {
                            Vt && z(Vt), Yt && re && (L(Yt), f.lineWidth(re).miterLimit(this.get("stroke-miterlimit")).lineJoin(this.get("stroke-linejoin")).lineCap(this.get("stroke-linecap")).dash(this.get("stroke-dasharray"), {
                              phase: this.get("stroke-dashoffset")
                            })), P(this._font.font, this._font.size), F(!!Vt, !!Yt);
                            for (var Ce = 0, ze = Qt._pos; Ce < ze.length; Ce++)
                              if (!ze[Ce].hidden && wt(ze[Ce].width, 0)) {
                                var He = Math.cos(ze[Ce].rotate), Je = Math.sin(ze[Ce].rotate), ar = this._font.fauxItalic ? -0.25 : 0;
                                I(He * ze[Ce].scale, Je * ze[Ce].scale, He * ar - Je, Je * ar + He, ze[Ce].x, ze[Ce].y), B(ze[Ce].glyph);
                              }
                            M();
                          }
                          break;
                      }
                    }
                    this.get("text-decoration") === "line-through" && this.decorate(0.05 * this._font.size, 0.5 * (jt(this._font.font, this._font.size) + me(this._font.font, this._font.size)), Lt, Ut);
                  }, this.decorate = function(Lt, Ut, Vt, Yt) {
                    var re = this.getFill(Vt, Yt), Ht = this.getStroke(Vt, Yt);
                    re && z(re), Ht && (L(Ht), f.lineWidth(this.get("stroke-width")).miterLimit(this.get("stroke-miterlimit")).lineJoin(this.get("stroke-linejoin")).lineCap(this.get("stroke-linecap")).dash(this.get("stroke-dasharray"), {
                      phase: this.get("stroke-dashoffset")
                    }));
                    for (var fe = 0, Qt = this._pos; fe < Qt.length; fe++)
                      if (!Qt[fe].hidden && wt(Qt[fe].width, 0)) {
                        var Ce = (Ut + Lt / 2) * Math.sin(Qt[fe].rotate), ze = -(Ut + Lt / 2) * Math.cos(Qt[fe].rotate), He = (Ut - Lt / 2) * Math.sin(Qt[fe].rotate), Je = -(Ut - Lt / 2) * Math.cos(Qt[fe].rotate), ar = Qt[fe].width * Math.cos(Qt[fe].rotate), mr = Qt[fe].width * Math.sin(Qt[fe].rotate);
                        new Zt().M(Qt[fe].x + Ce, Qt[fe].y + ze).L(Qt[fe].x + Ce + ar, Qt[fe].y + ze + mr).L(Qt[fe].x + He + ar, Qt[fe].y + Je + mr).L(Qt[fe].x + He, Qt[fe].y + Je).Z().insertInDocument(), re && Ht ? f.fillAndStroke() : re ? f.fill() : Ht && f.stroke();
                      }
                  };
                }, je = function(Mt, oe) {
                  this.name = Mt.nodeName, this.textContent = Mt.nodeValue;
                }, Wr = function(Mt, oe) {
                  Xe.call(this, Mt, oe);
                }, vr = function(Mt, oe) {
                  Xe.call(this, Mt, oe);
                  var Lt;
                  if ((Lt = this.attr("path")) && Lt.trim() !== "") {
                    var Ut = this.getLength("pathLength", this.getViewport());
                    this.pathObject = new Zt().path(Lt), this.pathLength = Ut > 0 ? Ut : this.pathObject.totalLength, this.pathScale = this.pathObject.totalLength / this.pathLength;
                  } else if ((Lt = this.getUrl("href") || this.getUrl("xlink:href")) && Lt.nodeName === "path") {
                    var Vt = new Xt(Lt, this);
                    this.pathObject = Vt.shape.clone().transform(Vt.get("transform")), this.pathLength = this.chooseValue(Vt.pathLength, this.pathObject.totalLength), this.pathScale = this.pathObject.totalLength / this.pathLength;
                  }
                }, nr = function(Mt, oe) {
                  Xe.call(this, Mt, oe), this.allowedChildren = ["textPath", "tspan", "#text", "#cdata-section", "a"], function(Lt) {
                    var Ut = "", Vt = Mt.textContent, Yt = [], re = [], Ht, fe, Qt = 0, Ce = 0;
                    function ze() {
                      if (re.length)
                        for (var we = re[re.length - 1], We = re[0], fr = we.x + we.width - We.x, Ke = {
                          startltr: 0,
                          middleltr: 0.5,
                          endltr: 1,
                          startrtl: 1,
                          middlertl: 0.5,
                          endrtl: 0
                        }[Ht + fe] * fr || 0, pr = 0; pr < re.length; pr++)
                          re[pr].x -= Ke;
                      re = [];
                    }
                    function He(we, We, fr) {
                      var Ke = we[0], pr = we[we.length - 1], tr = Ke.x, Er = pr.x + pr.width;
                      if (fr) {
                        var xr = We / (Er - tr);
                        if (xr > 0 && xr < 1 / 0)
                          for (var Gr = 0; Gr < we.length; Gr++)
                            we[Gr].x = tr + xr * (we[Gr].x - tr), we[Gr].scale *= xr, we[Gr].width *= xr;
                      } else if (we.length >= 2)
                        for (var tn = (We - (Er - tr)) / (we.length - 1), Qr = 0; Qr < we.length; Qr++)
                          we[Qr].x += Qr * tn;
                      Qt += We - (Er - tr);
                    }
                    function Je(we, We) {
                      we._x = kt(we.getLengthList("x", we.getVWidth()), We ? We._x.slice(We._pos.length) : []), we._y = kt(we.getLengthList("y", we.getVHeight()), We ? We._y.slice(We._pos.length) : []), we._dx = kt(we.getLengthList("dx", we.getVWidth()), We ? We._dx.slice(We._pos.length) : []), we._dy = kt(we.getLengthList("dy", we.getVHeight()), We ? We._dy.slice(We._pos.length) : []), we._rot = kt(we.getNumberList("rotate"), We ? We._rot.slice(We._pos.length) : []), we._defRot = we.chooseValue(we._rot[we._rot.length - 1], We && We._defRot, 0), we.name === "textPath" && (we._y = []);
                      var fr = {
                        fauxItalic: !1,
                        fauxBold: !1
                      }, Ke = Tn(we.get("font-family"), we.get("font-weight") === "bold", we.get("font-style") === "italic", fr);
                      try {
                        f.font(Ke);
                      } catch {
                        yr('SVGElemText: failed to open font "' + Ke + '" in PDFKit');
                      }
                      we._pos = [], we._index = 0, we._font = {
                        font: f._font,
                        size: we.get("font-size"),
                        fauxItalic: fr.fauxItalic,
                        fauxBold: fr.fauxBold
                      };
                      var pr = we.getLength("textLength", we.getVWidth(), void 0), tr = we.attr("lengthAdjust") === "spacingAndGlyphs", Er = we.get("word-spacing"), xr = we.get("letter-spacing"), Gr = we.get("text-anchor"), tn = we.get("direction"), Qr = Bt(we._font.font, we._font.size, we.get("alignment-baseline") || we.get("dominant-baseline"), we.get("baseline-shift"));
                      we.name === "textPath" && (ze(), Qt = Ce = 0);
                      for (var _r = we.getChildren(), Yr = 0; Yr < _r.length; Yr++) {
                        var Rr = _r[Yr];
                        switch (Rr.name) {
                          case "tspan":
                          case "textPath":
                          case "a":
                            Je(Rr, we);
                            break;
                          case "#text":
                          case "#cdata-section":
                            var qn = Rr.textContent, Sn = qn, $r = void 0;
                            Rr._font = we._font, Rr._pos = [], Vt = Vt.substring(qn.length), we.get("xml:space") === "preserve" ? Sn = Sn.replace(/[\s]/g, " ") : (Sn = Sn.replace(/[\s]+/g, " "), Ut.match(/[\s]$|^$/) && (Sn = Sn.replace(/^[\s]/, "")), Vt.match(/^[\s]*$/) && (Sn = Sn.replace(/[\s]$/, ""))), Ut += qn, Er === 0 ? $r = [Sn] : $r = Sn.split(/(\s)/);
                            for (var ln = 0; ln < $r.length; ln++) {
                              for (var pn = ge(we._font.font, we._font.size, $r[ln]), Nn = 0; Nn < pn.length; Nn++) {
                                var Rn = we._index, Na = we._x[Rn], zi = we._y[Rn], La = we._dx[Rn], Ua = we._dy[Rn], va = we._rot[Rn], Gi = !(ln === 0 && Nn === 0);
                                Na !== void 0 && (Gi = !1, ze(), Qt = Na), zi !== void 0 && (Gi = !1, ze(), Ce = zi), La !== void 0 && (Gi = !1, Qt += La), Ua !== void 0 && (Gi = !1, Ce += Ua), (va !== void 0 || we._defRot !== 0) && (Gi = !1);
                                var ga = {
                                  glyph: pn[Nn].glyph,
                                  rotate: Math.PI / 180 * we.chooseValue(va, we._defRot),
                                  x: Qt + pn[Nn].xOffset,
                                  y: Ce + Qr + pn[Nn].yOffset,
                                  width: pn[Nn].width,
                                  ascent: jt(we._font.font, we._font.size),
                                  descent: me(we._font.font, we._font.size),
                                  scale: 1,
                                  hidden: !1,
                                  continuous: Gi
                                };
                                re.push(ga), Rr._pos.push(ga), we._pos.push(ga), we._index += pn[Nn].unicode.length, re.length === 1 && (Ht = Gr, fe = tn), Qt += pn[Nn].xAdvance + xr, Ce += pn[Nn].yAdvance;
                              }
                              $r[ln] === " " && (Qt += Er);
                            }
                            break;
                          default:
                            Vt = Vt.substring(Rr.textContent.length);
                        }
                      }
                      if (pr && we._pos.length && He(we._pos, pr, tr), (we.name === "textPath" || we.name === "text") && ze(), we.name === "textPath") {
                        Yt.push(we);
                        var Zi = we.pathObject;
                        Zi && (Qt = Zi.endPoint[0], Ce = Zi.endPoint[1]);
                      }
                      We && (We._pos = We._pos.concat(we._pos), We._index += we._index);
                    }
                    function ar(we) {
                      var We = we.pathObject, fr = we.pathLength, Ke = we.pathScale;
                      if (We)
                        for (var pr = we.getLength("startOffset", fr, 0), tr = 0; tr < we._pos.length; tr++) {
                          var Er = pr + we._pos[tr].x + 0.5 * we._pos[tr].width;
                          if (Er > fr || Er < 0)
                            we._pos[tr].hidden = !0;
                          else {
                            var xr = We.getPointAtLength(Er * Ke);
                            wt(Ke, 1) && (we._pos[tr].scale *= Ke, we._pos[tr].width *= Ke), we._pos[tr].x = xr[0] - 0.5 * we._pos[tr].width * Math.cos(xr[2]) - we._pos[tr].y * Math.sin(xr[2]), we._pos[tr].y = xr[1] - 0.5 * we._pos[tr].width * Math.sin(xr[2]) + we._pos[tr].y * Math.cos(xr[2]), we._pos[tr].rotate = xr[2] + we._pos[tr].rotate, we._pos[tr].continuous = !1;
                          }
                        }
                      else
                        for (var Gr = 0; Gr < we._pos.length; Gr++)
                          we._pos[Gr].hidden = !0;
                    }
                    Je(Lt, null);
                    for (var mr = 0; mr < Yt.length; mr++)
                      ar(Yt[mr]);
                  }(this), this.getTransformation = function() {
                    return this.get("transform");
                  }, this.drawInDocument = function(Lt, Ut) {
                    f.save(), this.transform(), this.clip();
                    var Vt = this.mask(), Yt;
                    Vt && (Yt = w(bt())), this.drawTextInDocument(Lt, Ut), Yt && (E(Yt), A(Yt)), f.restore();
                  };
                };
                m = m || {};
                var Fr = m.assumePt ? 1 : 72 / 96, Jr = (m.width || f.page.width) / Fr, dn = (m.height || f.page.height) / Fr, kn = m.preserveAspectRatio || null, Yn = m.useCSS && typeof SVGElement < "u" && h instanceof SVGElement && typeof getComputedStyle == "function", yr = m.warningCallback, Tn = m.fontCallback, qr = m.imageCallback, gn = m.colorCallback, un = m.documentCallback, wi = Math.ceil(Math.max(1, m.precision)) || 3, Si = [], Me = {}, Ze = [], qe = [];
                if (typeof yr != "function" && (yr = function(Mt) {
                  typeof console !== void 0 && typeof console.warn == "function" && console.warn(Mt);
                }), typeof Tn != "function" && (Tn = function(Mt, oe, Lt, Ut) {
                  if (oe && Lt) {
                    if (f._registeredFonts.hasOwnProperty(Mt + "-BoldItalic"))
                      return Mt + "-BoldItalic";
                    if (f._registeredFonts.hasOwnProperty(Mt + "-Italic"))
                      return Ut.fauxBold = !0, Mt + "-Italic";
                    if (f._registeredFonts.hasOwnProperty(Mt + "-Bold"))
                      return Ut.fauxItalic = !0, Mt + "-Bold";
                    if (f._registeredFonts.hasOwnProperty(Mt))
                      return Ut.fauxBold = !0, Ut.fauxItalic = !0, Mt;
                  }
                  if (oe && !Lt) {
                    if (f._registeredFonts.hasOwnProperty(Mt + "-Bold"))
                      return Mt + "-Bold";
                    if (f._registeredFonts.hasOwnProperty(Mt))
                      return Ut.fauxBold = !0, Mt;
                  }
                  if (!oe && Lt) {
                    if (f._registeredFonts.hasOwnProperty(Mt + "-Italic"))
                      return Mt + "-Italic";
                    if (f._registeredFonts.hasOwnProperty(Mt))
                      return Ut.fauxItalic = !0, Mt;
                  }
                  if (!oe && !Lt && f._registeredFonts.hasOwnProperty(Mt))
                    return Mt;
                  if (Mt.match(/(?:^|,)\s*serif\s*$/)) {
                    if (oe && Lt)
                      return "Times-BoldItalic";
                    if (oe && !Lt)
                      return "Times-Bold";
                    if (!oe && Lt)
                      return "Times-Italic";
                    if (!oe && !Lt)
                      return "Times-Roman";
                  } else if (Mt.match(/(?:^|,)\s*monospace\s*$/)) {
                    if (oe && Lt)
                      return "Courier-BoldOblique";
                    if (oe && !Lt)
                      return "Courier-Bold";
                    if (!oe && Lt)
                      return "Courier-Oblique";
                    if (!oe && !Lt)
                      return "Courier";
                  } else {
                    if (Mt.match(/(?:^|,)\s*sans-serif\s*$/), oe && Lt)
                      return "Helvetica-BoldOblique";
                    if (oe && !Lt)
                      return "Helvetica-Bold";
                    if (!oe && Lt)
                      return "Helvetica-Oblique";
                    if (!oe && !Lt)
                      return "Helvetica";
                  }
                }), typeof qr != "function" && (qr = function(Mt) {
                  return Mt.replace(/\s+/g, "");
                }), typeof gn != "function")
                  gn = null;
                else
                  for (var gr in g) {
                    var Wn = gn(g[gr]);
                    g[gr][0] = Wn[0], g[gr][1] = Wn[1];
                  }
                if (typeof un != "function" && (un = null), typeof h == "string" && (h = ft(h)), h) {
                  for (var sr = h.getElementsByTagName("style"), Oi = 0; Oi < sr.length; Oi++)
                    qe = qe.concat(vt(sr[Oi].textContent));
                  var Yi = Re(h, null);
                  if (typeof Yi.drawInDocument == "function") {
                    m.useCSS && !Yn && yr("SVGtoPDF: useCSS option can only be used for SVG *elements* in compatible browsers");
                    var vi = f._fillColor;
                    f.save().translate(v || 0, p || 0).scale(Fr), Yi.drawInDocument();
                    for (var Ct = 0; Ct < Ze.length; Ct++)
                      f.page.annotations.push(Ze[Ct]);
                    f.restore(), f._fillColor = vi;
                  } else
                    yr("SVGtoPDF: this element can't be rendered directly: " + h.nodeName);
                } else
                  yr("SVGtoPDF: the input does not look like a valid SVG");
              };
              u && typeof u.exports < "u" && (u.exports = s);
            }
          ),
          /***/
          48585: (
            /***/
            function(u, l, e) {
              var s = "/", i = e(50621).Buffer;
              Object.defineProperty(l, "__esModule", {
                value: !0
              }), l.default = void 0, e(65292), e(73844), e(69330), e(39081), e(41584), e(49063), e(11765), e(58028), e(81755), e(94845), e(80055), e(20731), e(45337), e(10720), e(24863), e(7283), e(70095), e(10849), e(18756), e(57444), e(28331), e(71950), e(37309), e(14032), e(68067), e(73228), e(61726), e(57114), e(26663), e(65578), e(58281), e(6422), e(46467), e(7851), e(72095), e(62046), e(47259), e(18425), e(56912), e(73663), e(29883), e(35471), e(21012), e(88997), e(97464), e(2857), e(94715), e(13624), e(91132), e(62514), e(24597), e(88042), e(4660), e(92451), e(44206), e(66288), e(13250), e(3858), e(84538), e(64793), e(74202), e(52529), e(42437), e(94712);
              var f = S(e(9760)), h = S(e(6729)), v = S(e(66122)), p = S(e(60421)), m = e(64785), x = S(e(19304)), g = S(e(80646));
              function S(Et) {
                return Et && Et.__esModule ? Et : { default: Et };
              }
              var y = e(48181);
              function b(Et, _) {
                if (!(Et instanceof _))
                  throw new TypeError("Cannot call a class as a function");
              }
              function n(Et, _) {
                for (var U = 0; U < _.length; U++) {
                  var tt = _[U];
                  tt.enumerable = tt.enumerable || !1, tt.configurable = !0, "value" in tt && (tt.writable = !0), Object.defineProperty(Et, tt.key, tt);
                }
              }
              function w(Et, _, U) {
                return _ && n(Et.prototype, _), U && n(Et, U), Et;
              }
              function E(Et, _, U) {
                return _ in Et ? Object.defineProperty(Et, _, {
                  value: U,
                  enumerable: !0,
                  configurable: !0,
                  writable: !0
                }) : Et[_] = U, Et;
              }
              function A(Et, _) {
                var U = Object.keys(Et);
                if (Object.getOwnPropertySymbols) {
                  var tt = Object.getOwnPropertySymbols(Et);
                  _ && (tt = tt.filter(function(K) {
                    return Object.getOwnPropertyDescriptor(Et, K).enumerable;
                  })), U.push.apply(U, tt);
                }
                return U;
              }
              function O(Et) {
                for (var _ = 1; _ < arguments.length; _++) {
                  var U = arguments[_] != null ? arguments[_] : {};
                  _ % 2 ? A(Object(U), !0).forEach(function(tt) {
                    E(Et, tt, U[tt]);
                  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Et, Object.getOwnPropertyDescriptors(U)) : A(Object(U)).forEach(function(tt) {
                    Object.defineProperty(Et, tt, Object.getOwnPropertyDescriptor(U, tt));
                  });
                }
                return Et;
              }
              function C(Et, _) {
                if (typeof _ != "function" && _ !== null)
                  throw new TypeError("Super expression must either be null or a function");
                Et.prototype = Object.create(_ && _.prototype, {
                  constructor: {
                    value: Et,
                    writable: !0,
                    configurable: !0
                  }
                }), _ && P(Et, _);
              }
              function T(Et) {
                return T = Object.setPrototypeOf ? Object.getPrototypeOf : function(U) {
                  return U.__proto__ || Object.getPrototypeOf(U);
                }, T(Et);
              }
              function P(Et, _) {
                return P = Object.setPrototypeOf || function(tt, K) {
                  return tt.__proto__ = K, tt;
                }, P(Et, _);
              }
              function I() {
                if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                  return !1;
                if (typeof Proxy == "function")
                  return !0;
                try {
                  return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
                  })), !0;
                } catch {
                  return !1;
                }
              }
              function F(Et) {
                if (Et === void 0)
                  throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return Et;
              }
              function B(Et, _) {
                return _ && (typeof _ == "object" || typeof _ == "function") ? _ : F(Et);
              }
              function M(Et) {
                var _ = I();
                return function() {
                  var tt = T(Et), K;
                  if (_) {
                    var mt = T(this).constructor;
                    K = Reflect.construct(tt, arguments, mt);
                  } else
                    K = tt.apply(this, arguments);
                  return B(this, K);
                };
              }
              function z(Et, _) {
                return ft(Et) || xt(Et, _) || St(Et, _) || Rt();
              }
              function L(Et) {
                return J(Et) || Q(Et) || St(Et) || Gt();
              }
              function J(Et) {
                if (Array.isArray(Et))
                  return Pt(Et);
              }
              function ft(Et) {
                if (Array.isArray(Et))
                  return Et;
              }
              function Q(Et) {
                if (typeof Symbol < "u" && Symbol.iterator in Object(Et))
                  return Array.from(Et);
              }
              function xt(Et, _) {
                if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(Et)))) {
                  var U = [], tt = !0, K = !1, mt = void 0;
                  try {
                    for (var At = Et[Symbol.iterator](), ee; !(tt = (ee = At.next()).done) && (U.push(ee.value), !(_ && U.length === _)); tt = !0)
                      ;
                  } catch (ae) {
                    K = !0, mt = ae;
                  } finally {
                    try {
                      !tt && At.return != null && At.return();
                    } finally {
                      if (K)
                        throw mt;
                    }
                  }
                  return U;
                }
              }
              function St(Et, _) {
                if (Et) {
                  if (typeof Et == "string")
                    return Pt(Et, _);
                  var U = Object.prototype.toString.call(Et).slice(8, -1);
                  if (U === "Object" && Et.constructor && (U = Et.constructor.name), U === "Map" || U === "Set")
                    return Array.from(Et);
                  if (U === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(U))
                    return Pt(Et, _);
                }
              }
              function Pt(Et, _) {
                (_ == null || _ > Et.length) && (_ = Et.length);
                for (var U = 0, tt = new Array(_); U < _; U++)
                  tt[U] = Et[U];
                return tt;
              }
              function Gt() {
                throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }
              function Rt() {
                throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }
              function bt(Et, _) {
                var U;
                if (typeof Symbol > "u" || Et[Symbol.iterator] == null) {
                  if (Array.isArray(Et) || (U = St(Et)) || _ && Et && typeof Et.length == "number") {
                    U && (Et = U);
                    var tt = 0, K = function() {
                    };
                    return {
                      s: K,
                      n: function() {
                        return tt >= Et.length ? {
                          done: !0
                        } : {
                          done: !1,
                          value: Et[tt++]
                        };
                      },
                      e: function(ye) {
                        throw ye;
                      },
                      f: K
                    };
                  }
                  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
                }
                var mt = !0, At = !1, ee;
                return {
                  s: function() {
                    U = Et[Symbol.iterator]();
                  },
                  n: function() {
                    var ye = U.next();
                    return mt = ye.done, ye;
                  },
                  e: function(ye) {
                    At = !0, ee = ye;
                  },
                  f: function() {
                    try {
                      !mt && U.return != null && U.return();
                    } finally {
                      if (At)
                        throw ee;
                    }
                  }
                };
              }
              var Dt = /* @__PURE__ */ function() {
                function Et() {
                  b(this, Et);
                }
                return w(Et, [{
                  key: "toString",
                  value: function() {
                    throw new Error("Must be implemented by subclasses");
                  }
                }]), Et;
              }(), X = /* @__PURE__ */ function() {
                function Et() {
                  var _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                  b(this, Et), this._items = {}, this.limits = typeof _.limits == "boolean" ? _.limits : !0;
                }
                return w(Et, [{
                  key: "add",
                  value: function(U, tt) {
                    return this._items[U] = tt;
                  }
                }, {
                  key: "get",
                  value: function(U) {
                    return this._items[U];
                  }
                }, {
                  key: "toString",
                  value: function() {
                    var U = this, tt = Object.keys(this._items).sort(function(Ae, Oe) {
                      return U._compareKeys(Ae, Oe);
                    }), K = ["<<"];
                    if (this.limits && tt.length > 1) {
                      var mt = tt[0], At = tt[tt.length - 1];
                      K.push("  /Limits ".concat(Ft.convert([this._dataForKey(mt), this._dataForKey(At)])));
                    }
                    K.push("  /".concat(this._keysName(), " ["));
                    var ee = bt(tt), ae;
                    try {
                      for (ee.s(); !(ae = ee.n()).done; ) {
                        var ye = ae.value;
                        K.push("    ".concat(Ft.convert(this._dataForKey(ye)), " ").concat(Ft.convert(this._items[ye])));
                      }
                    } catch (Ae) {
                      ee.e(Ae);
                    } finally {
                      ee.f();
                    }
                    return K.push("]"), K.push(">>"), K.join(`
`);
                  }
                }, {
                  key: "_compareKeys",
                  value: function() {
                    throw new Error("Must be implemented by subclasses");
                  }
                }, {
                  key: "_keysName",
                  value: function() {
                    throw new Error("Must be implemented by subclasses");
                  }
                }, {
                  key: "_dataForKey",
                  value: function() {
                    throw new Error("Must be implemented by subclasses");
                  }
                }]), Et;
              }(), gt = function(_, U) {
                return (Array(U + 1).join("0") + _).slice(-U);
              }, st = /[\n\r\t\b\f()\\]/g, rt = {
                "\n": "\\n",
                "\r": "\\r",
                "	": "\\t",
                "\b": "\\b",
                "\f": "\\f",
                "\\": "\\\\",
                "(": "\\(",
                ")": "\\)"
              }, wt = function(_) {
                var U = _.length;
                if (U & 1)
                  throw new Error("Buffer length must be even");
                for (var tt = 0, K = U - 1; tt < K; tt += 2) {
                  var mt = _[tt];
                  _[tt] = _[tt + 1], _[tt + 1] = mt;
                }
                return _;
              }, Ft = /* @__PURE__ */ function() {
                function Et() {
                  b(this, Et);
                }
                return w(Et, null, [{
                  key: "convert",
                  value: function(U) {
                    var tt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                    if (typeof U == "string")
                      return "/".concat(U);
                    if (U instanceof String) {
                      for (var K = U, mt = !1, At = 0, ee = K.length; At < ee; At++)
                        if (K.charCodeAt(At) > 127) {
                          mt = !0;
                          break;
                        }
                      var ae;
                      return mt ? ae = wt(i.from("\uFEFF".concat(K), "utf16le")) : ae = i.from(K.valueOf(), "ascii"), tt ? K = tt(ae).toString("binary") : K = ae.toString("binary"), K = K.replace(st, function(Qe) {
                        return rt[Qe];
                      }), "(".concat(K, ")");
                    } else {
                      if (i.isBuffer(U))
                        return "<".concat(U.toString("hex"), ">");
                      if (U instanceof Dt || U instanceof X)
                        return U.toString();
                      if (U instanceof Date) {
                        var ye = "D:".concat(gt(U.getUTCFullYear(), 4)) + gt(U.getUTCMonth() + 1, 2) + gt(U.getUTCDate(), 2) + gt(U.getUTCHours(), 2) + gt(U.getUTCMinutes(), 2) + gt(U.getUTCSeconds(), 2) + "Z";
                        return tt && (ye = tt(i.from(ye, "ascii")).toString("binary"), ye = ye.replace(st, function(Qe) {
                          return rt[Qe];
                        })), "(".concat(ye, ")");
                      } else if (Array.isArray(U)) {
                        var Ae = U.map(function(Qe) {
                          return Et.convert(Qe, tt);
                        }).join(" ");
                        return "[".concat(Ae, "]");
                      } else if ({}.toString.call(U) === "[object Object]") {
                        var Oe = ["<<"];
                        for (var Ie in U) {
                          var Ne = U[Ie];
                          Oe.push("/".concat(Ie, " ").concat(Et.convert(Ne, tt)));
                        }
                        return Oe.push(">>"), Oe.join(`
`);
                      } else
                        return typeof U == "number" ? Et.number(U) : "".concat(U);
                    }
                  }
                }, {
                  key: "number",
                  value: function(U) {
                    if (U > -1e21 && U < 1e21)
                      return Math.round(U * 1e6) / 1e6;
                    throw new Error("unsupported number: ".concat(U));
                  }
                }]), Et;
              }(), zt = /* @__PURE__ */ function(Et) {
                C(U, Et);
                var _ = M(U);
                function U(tt, K) {
                  var mt, At = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                  return b(this, U), mt = _.call(this), mt.document = tt, mt.id = K, mt.data = At, mt.gen = 0, mt.compress = mt.document.compress && !mt.data.Filter, mt.uncompressedLength = 0, mt.buffer = [], mt;
                }
                return w(U, [{
                  key: "write",
                  value: function(K) {
                    if (i.isBuffer(K) || (K = i.from(K + `
`, "binary")), this.uncompressedLength += K.length, this.data.Length == null && (this.data.Length = 0), this.buffer.push(K), this.data.Length += K.length, this.compress)
                      return this.data.Filter = "FlateDecode";
                  }
                }, {
                  key: "end",
                  value: function(K) {
                    return K && this.write(K), this.finalize();
                  }
                }, {
                  key: "finalize",
                  value: function() {
                    this.offset = this.document._offset;
                    var K = this.document._security ? this.document._security.getEncryptFn(this.id, this.gen) : null;
                    this.buffer.length && (this.buffer = i.concat(this.buffer), this.compress && (this.buffer = h.default.deflateSync(this.buffer)), K && (this.buffer = K(this.buffer)), this.data.Length = this.buffer.length), this.document._write("".concat(this.id, " ").concat(this.gen, " obj")), this.document._write(Ft.convert(this.data, K)), this.buffer.length && (this.document._write("stream"), this.document._write(this.buffer), this.buffer = [], this.document._write(`
endstream`)), this.document._write("endobj"), this.document._refEnd(this);
                  }
                }, {
                  key: "toString",
                  value: function() {
                    return "".concat(this.id, " ").concat(this.gen, " R");
                  }
                }]), U;
              }(Dt), G = {
                top: 72,
                left: 72,
                bottom: 72,
                right: 72
              }, D = {
                "4A0": [4767.87, 6740.79],
                "2A0": [3370.39, 4767.87],
                A0: [2383.94, 3370.39],
                A1: [1683.78, 2383.94],
                A2: [1190.55, 1683.78],
                A3: [841.89, 1190.55],
                A4: [595.28, 841.89],
                A5: [419.53, 595.28],
                A6: [297.64, 419.53],
                A7: [209.76, 297.64],
                A8: [147.4, 209.76],
                A9: [104.88, 147.4],
                A10: [73.7, 104.88],
                B0: [2834.65, 4008.19],
                B1: [2004.09, 2834.65],
                B2: [1417.32, 2004.09],
                B3: [1000.63, 1417.32],
                B4: [708.66, 1000.63],
                B5: [498.9, 708.66],
                B6: [354.33, 498.9],
                B7: [249.45, 354.33],
                B8: [175.75, 249.45],
                B9: [124.72, 175.75],
                B10: [87.87, 124.72],
                C0: [2599.37, 3676.54],
                C1: [1836.85, 2599.37],
                C2: [1298.27, 1836.85],
                C3: [918.43, 1298.27],
                C4: [649.13, 918.43],
                C5: [459.21, 649.13],
                C6: [323.15, 459.21],
                C7: [229.61, 323.15],
                C8: [161.57, 229.61],
                C9: [113.39, 161.57],
                C10: [79.37, 113.39],
                RA0: [2437.8, 3458.27],
                RA1: [1729.13, 2437.8],
                RA2: [1218.9, 1729.13],
                RA3: [864.57, 1218.9],
                RA4: [609.45, 864.57],
                SRA0: [2551.18, 3628.35],
                SRA1: [1814.17, 2551.18],
                SRA2: [1275.59, 1814.17],
                SRA3: [907.09, 1275.59],
                SRA4: [637.8, 907.09],
                EXECUTIVE: [521.86, 756],
                FOLIO: [612, 936],
                LEGAL: [612, 1008],
                LETTER: [612, 792],
                TABLOID: [792, 1224]
              }, Z = /* @__PURE__ */ function() {
                function Et(_) {
                  var U = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                  b(this, Et), this.document = _, this.size = U.size || "letter", this.layout = U.layout || "portrait", typeof U.margin == "number" ? this.margins = {
                    top: U.margin,
                    left: U.margin,
                    bottom: U.margin,
                    right: U.margin
                  } : this.margins = U.margins || G;
                  var tt = Array.isArray(this.size) ? this.size : D[this.size.toUpperCase()];
                  this.width = tt[this.layout === "portrait" ? 0 : 1], this.height = tt[this.layout === "portrait" ? 1 : 0], this.content = this.document.ref(), this.resources = this.document.ref({
                    ProcSet: ["PDF", "Text", "ImageB", "ImageC", "ImageI"]
                  }), this.dictionary = this.document.ref({
                    Type: "Page",
                    Parent: this.document._root.data.Pages,
                    MediaBox: [0, 0, this.width, this.height],
                    Contents: this.content,
                    Resources: this.resources
                  }), this.markings = [];
                }
                return w(Et, [{
                  key: "maxY",
                  value: function() {
                    return this.height - this.margins.bottom;
                  }
                }, {
                  key: "write",
                  value: function(U) {
                    return this.content.write(U);
                  }
                }, {
                  key: "end",
                  value: function() {
                    return this.dictionary.end(), this.resources.end(), this.content.end();
                  }
                }, {
                  key: "fonts",
                  get: function() {
                    var U = this.resources.data;
                    return U.Font != null ? U.Font : U.Font = {};
                  }
                }, {
                  key: "xobjects",
                  get: function() {
                    var U = this.resources.data;
                    return U.XObject != null ? U.XObject : U.XObject = {};
                  }
                }, {
                  key: "ext_gstates",
                  get: function() {
                    var U = this.resources.data;
                    return U.ExtGState != null ? U.ExtGState : U.ExtGState = {};
                  }
                }, {
                  key: "patterns",
                  get: function() {
                    var U = this.resources.data;
                    return U.Pattern != null ? U.Pattern : U.Pattern = {};
                  }
                }, {
                  key: "colorSpaces",
                  get: function() {
                    var U = this.resources.data;
                    return U.ColorSpace || (U.ColorSpace = {});
                  }
                }, {
                  key: "annotations",
                  get: function() {
                    var U = this.dictionary.data;
                    return U.Annots != null ? U.Annots : U.Annots = [];
                  }
                }, {
                  key: "structParentTreeKey",
                  get: function() {
                    var U = this.dictionary.data;
                    return U.StructParents != null ? U.StructParents : U.StructParents = this.document.createStructParentTreeNextKey();
                  }
                }]), Et;
              }(), et = /* @__PURE__ */ function(Et) {
                C(U, Et);
                var _ = M(U);
                function U() {
                  return b(this, U), _.apply(this, arguments);
                }
                return w(U, [{
                  key: "_compareKeys",
                  value: function(K, mt) {
                    return K.localeCompare(mt);
                  }
                }, {
                  key: "_keysName",
                  value: function() {
                    return "Names";
                  }
                }, {
                  key: "_dataForKey",
                  value: function(K) {
                    return new String(K);
                  }
                }]), U;
              }(X);
              function vt(Et, _) {
                if (Et < _[0])
                  return !1;
                for (var U = 0, tt = _.length / 2; U <= tt; ) {
                  var K = Math.floor((U + tt) / 2), mt = K * 2;
                  if (Et >= _[mt] && Et <= _[mt + 1])
                    return !0;
                  Et > _[mt + 1] ? U = K + 1 : tt = K - 1;
                }
                return !1;
              }
              var lt = [545, 545, 564, 591, 686, 687, 751, 767, 848, 863, 880, 883, 886, 889, 891, 893, 895, 899, 907, 907, 909, 909, 930, 930, 975, 975, 1015, 1023, 1159, 1159, 1231, 1231, 1270, 1271, 1274, 1279, 1296, 1328, 1367, 1368, 1376, 1376, 1416, 1416, 1419, 1424, 1442, 1442, 1466, 1466, 1477, 1487, 1515, 1519, 1525, 1547, 1549, 1562, 1564, 1566, 1568, 1568, 1595, 1599, 1622, 1631, 1774, 1775, 1791, 1791, 1806, 1806, 1837, 1839, 1867, 1919, 1970, 2304, 2308, 2308, 2362, 2363, 2382, 2383, 2389, 2391, 2417, 2432, 2436, 2436, 2445, 2446, 2449, 2450, 2473, 2473, 2481, 2481, 2483, 2485, 2490, 2491, 2493, 2493, 2501, 2502, 2505, 2506, 2510, 2518, 2520, 2523, 2526, 2526, 2532, 2533, 2555, 2561, 2563, 2564, 2571, 2574, 2577, 2578, 2601, 2601, 2609, 2609, 2612, 2612, 2615, 2615, 2618, 2619, 2621, 2621, 2627, 2630, 2633, 2634, 2638, 2648, 2653, 2653, 2655, 2661, 2677, 2688, 2692, 2692, 2700, 2700, 2702, 2702, 2706, 2706, 2729, 2729, 2737, 2737, 2740, 2740, 2746, 2747, 2758, 2758, 2762, 2762, 2766, 2767, 2769, 2783, 2785, 2789, 2800, 2816, 2820, 2820, 2829, 2830, 2833, 2834, 2857, 2857, 2865, 2865, 2868, 2869, 2874, 2875, 2884, 2886, 2889, 2890, 2894, 2901, 2904, 2907, 2910, 2910, 2914, 2917, 2929, 2945, 2948, 2948, 2955, 2957, 2961, 2961, 2966, 2968, 2971, 2971, 2973, 2973, 2976, 2978, 2981, 2983, 2987, 2989, 2998, 2998, 3002, 3005, 3011, 3013, 3017, 3017, 3022, 3030, 3032, 3046, 3059, 3072, 3076, 3076, 3085, 3085, 3089, 3089, 3113, 3113, 3124, 3124, 3130, 3133, 3141, 3141, 3145, 3145, 3150, 3156, 3159, 3167, 3170, 3173, 3184, 3201, 3204, 3204, 3213, 3213, 3217, 3217, 3241, 3241, 3252, 3252, 3258, 3261, 3269, 3269, 3273, 3273, 3278, 3284, 3287, 3293, 3295, 3295, 3298, 3301, 3312, 3329, 3332, 3332, 3341, 3341, 3345, 3345, 3369, 3369, 3386, 3389, 3396, 3397, 3401, 3401, 3406, 3414, 3416, 3423, 3426, 3429, 3440, 3457, 3460, 3460, 3479, 3481, 3506, 3506, 3516, 3516, 3518, 3519, 3527, 3529, 3531, 3534, 3541, 3541, 3543, 3543, 3552, 3569, 3573, 3584, 3643, 3646, 3676, 3712, 3715, 3715, 3717, 3718, 3721, 3721, 3723, 3724, 3726, 3731, 3736, 3736, 3744, 3744, 3748, 3748, 3750, 3750, 3752, 3753, 3756, 3756, 3770, 3770, 3774, 3775, 3781, 3781, 3783, 3783, 3790, 3791, 3802, 3803, 3806, 3839, 3912, 3912, 3947, 3952, 3980, 3983, 3992, 3992, 4029, 4029, 4045, 4046, 4048, 4095, 4130, 4130, 4136, 4136, 4139, 4139, 4147, 4149, 4154, 4159, 4186, 4255, 4294, 4303, 4345, 4346, 4348, 4351, 4442, 4446, 4515, 4519, 4602, 4607, 4615, 4615, 4679, 4679, 4681, 4681, 4686, 4687, 4695, 4695, 4697, 4697, 4702, 4703, 4743, 4743, 4745, 4745, 4750, 4751, 4783, 4783, 4785, 4785, 4790, 4791, 4799, 4799, 4801, 4801, 4806, 4807, 4815, 4815, 4823, 4823, 4847, 4847, 4879, 4879, 4881, 4881, 4886, 4887, 4895, 4895, 4935, 4935, 4955, 4960, 4989, 5023, 5109, 5120, 5751, 5759, 5789, 5791, 5873, 5887, 5901, 5901, 5909, 5919, 5943, 5951, 5972, 5983, 5997, 5997, 6001, 6001, 6004, 6015, 6109, 6111, 6122, 6143, 6159, 6159, 6170, 6175, 6264, 6271, 6314, 7679, 7836, 7839, 7930, 7935, 7958, 7959, 7966, 7967, 8006, 8007, 8014, 8015, 8024, 8024, 8026, 8026, 8028, 8028, 8030, 8030, 8062, 8063, 8117, 8117, 8133, 8133, 8148, 8149, 8156, 8156, 8176, 8177, 8181, 8181, 8191, 8191, 8275, 8278, 8280, 8286, 8292, 8297, 8306, 8307, 8335, 8351, 8370, 8399, 8427, 8447, 8507, 8508, 8524, 8530, 8580, 8591, 9167, 9215, 9255, 9279, 9291, 9311, 9471, 9471, 9748, 9749, 9752, 9752, 9854, 9855, 9866, 9984, 9989, 9989, 9994, 9995, 10024, 10024, 10060, 10060, 10062, 10062, 10067, 10069, 10071, 10071, 10079, 10080, 10133, 10135, 10160, 10160, 10175, 10191, 10220, 10223, 11008, 11903, 11930, 11930, 12020, 12031, 12246, 12271, 12284, 12287, 12352, 12352, 12439, 12440, 12544, 12548, 12589, 12592, 12687, 12687, 12728, 12783, 12829, 12831, 12868, 12880, 12924, 12926, 13004, 13007, 13055, 13055, 13175, 13178, 13278, 13279, 13311, 13311, 19894, 19967, 40870, 40959, 42125, 42127, 42183, 44031, 55204, 55295, 64046, 64047, 64107, 64255, 64263, 64274, 64280, 64284, 64311, 64311, 64317, 64317, 64319, 64319, 64322, 64322, 64325, 64325, 64434, 64466, 64832, 64847, 64912, 64913, 64968, 64975, 65021, 65023, 65040, 65055, 65060, 65071, 65095, 65096, 65107, 65107, 65127, 65127, 65132, 65135, 65141, 65141, 65277, 65278, 65280, 65280, 65471, 65473, 65480, 65481, 65488, 65489, 65496, 65497, 65501, 65503, 65511, 65511, 65519, 65528, 65536, 66303, 66335, 66335, 66340, 66351, 66379, 66559, 66598, 66599, 66638, 118783, 119030, 119039, 119079, 119081, 119262, 119807, 119893, 119893, 119965, 119965, 119968, 119969, 119971, 119972, 119975, 119976, 119981, 119981, 119994, 119994, 119996, 119996, 120001, 120001, 120004, 120004, 120070, 120070, 120075, 120076, 120085, 120085, 120093, 120093, 120122, 120122, 120127, 120127, 120133, 120133, 120135, 120137, 120145, 120145, 120484, 120487, 120778, 120781, 120832, 131069, 173783, 194559, 195102, 196605, 196608, 262141, 262144, 327677, 327680, 393213, 393216, 458749, 458752, 524285, 524288, 589821, 589824, 655357, 655360, 720893, 720896, 786429, 786432, 851965, 851968, 917501, 917504, 917504, 917506, 917535, 917632, 983037], dt = function(_) {
                return vt(_, lt);
              }, kt = [173, 173, 847, 847, 6150, 6150, 6155, 6155, 6156, 6156, 6157, 6157, 8203, 8203, 8204, 8204, 8205, 8205, 8288, 8288, 65024, 65024, 65025, 65025, 65026, 65026, 65027, 65027, 65028, 65028, 65029, 65029, 65030, 65030, 65031, 65031, 65032, 65032, 65033, 65033, 65034, 65034, 65035, 65035, 65036, 65036, 65037, 65037, 65038, 65038, 65039, 65039, 65279, 65279], jt = function(_) {
                return vt(_, kt);
              }, me = [
                160,
                160,
                5760,
                5760,
                8192,
                8192,
                8193,
                8193,
                8194,
                8194,
                8195,
                8195,
                8196,
                8196,
                8197,
                8197,
                8198,
                8198,
                8199,
                8199,
                8200,
                8200,
                8201,
                8201,
                8202,
                8202,
                8203,
                8203,
                8239,
                8239,
                8287,
                8287,
                12288,
                12288
                /* IDEOGRAPHIC SPACE */
              ], se = function(_) {
                return vt(_, me);
              }, Bt = [
                /**
                 * C.2.2 Non-ASCII control characters
                 * @link https://tools.ietf.org/html/rfc3454#appendix-C.2.2
                 */
                128,
                159,
                1757,
                1757,
                1807,
                1807,
                6158,
                6158,
                8204,
                8204,
                8205,
                8205,
                8232,
                8232,
                8233,
                8233,
                8288,
                8288,
                8289,
                8289,
                8290,
                8290,
                8291,
                8291,
                8298,
                8303,
                65279,
                65279,
                65529,
                65532,
                119155,
                119162
                /* [MUSICAL CONTROL CHARACTERS] */
              ], ge = [
                /**
                 * C.4 Non-character code points
                 * @link https://tools.ietf.org/html/rfc3454#appendix-C.4
                 */
                64976,
                65007,
                65534,
                65535,
                131070,
                131071,
                196606,
                196607,
                262142,
                262143,
                327678,
                327679,
                393214,
                393215,
                458750,
                458751,
                524286,
                524287,
                589822,
                589823,
                655358,
                655359,
                720894,
                720895,
                786430,
                786431,
                851966,
                851967,
                917502,
                917503,
                983038,
                983039,
                1114110,
                1114111
                /* [NONCHARACTER CODE POINTS] */
              ], Re = [
                /**
                 * C.2.1 ASCII control characters
                 * @link https://tools.ietf.org/html/rfc3454#appendix-C.2.1
                 */
                0,
                31,
                127,
                127,
                /**
                 * C.8 Change display properties or are deprecated
                 * @link https://tools.ietf.org/html/rfc3454#appendix-C.8
                 */
                832,
                832,
                833,
                833,
                8206,
                8206,
                8207,
                8207,
                8234,
                8234,
                8235,
                8235,
                8236,
                8236,
                8237,
                8237,
                8238,
                8238,
                8298,
                8298,
                8299,
                8299,
                8300,
                8300,
                8301,
                8301,
                8302,
                8302,
                8303,
                8303,
                /**
                 * C.7 Inappropriate for canonical representation
                 * @link https://tools.ietf.org/html/rfc3454#appendix-C.7
                 */
                12272,
                12283,
                /**
                 * C.5 Surrogate codes
                 * @link https://tools.ietf.org/html/rfc3454#appendix-C.5
                 */
                55296,
                57343,
                /**
                 * C.3 Private use
                 * @link https://tools.ietf.org/html/rfc3454#appendix-C.3
                 */
                57344,
                63743,
                /**
                 * C.6 Inappropriate for plain text
                 * @link https://tools.ietf.org/html/rfc3454#appendix-C.6
                 */
                65529,
                65529,
                65530,
                65530,
                65531,
                65531,
                65532,
                65532,
                65533,
                65533,
                /**
                 * C.9 Tagging characters
                 * @link https://tools.ietf.org/html/rfc3454#appendix-C.9
                 */
                917505,
                917505,
                917536,
                917631,
                /**
                 * C.3 Private use
                 * @link https://tools.ietf.org/html/rfc3454#appendix-C.3
                 */
                983040,
                1048573,
                1048576,
                1114109
                /* [PRIVATE USE, PLANE 16] */
              ], Te = function(_) {
                return vt(_, me) || vt(_, Re) || vt(_, Bt) || vt(_, ge);
              }, xe = [1470, 1470, 1472, 1472, 1475, 1475, 1488, 1514, 1520, 1524, 1563, 1563, 1567, 1567, 1569, 1594, 1600, 1610, 1645, 1647, 1649, 1749, 1757, 1757, 1765, 1766, 1786, 1790, 1792, 1805, 1808, 1808, 1810, 1836, 1920, 1957, 1969, 1969, 8207, 8207, 64285, 64285, 64287, 64296, 64298, 64310, 64312, 64316, 64318, 64318, 64320, 64321, 64323, 64324, 64326, 64433, 64467, 64829, 64848, 64911, 64914, 64967, 65008, 65020, 65136, 65140, 65142, 65276], Fe = function(_) {
                return vt(_, xe);
              }, Zt = [65, 90, 97, 122, 170, 170, 181, 181, 186, 186, 192, 214, 216, 246, 248, 544, 546, 563, 592, 685, 688, 696, 699, 705, 720, 721, 736, 740, 750, 750, 890, 890, 902, 902, 904, 906, 908, 908, 910, 929, 931, 974, 976, 1013, 1024, 1154, 1162, 1230, 1232, 1269, 1272, 1273, 1280, 1295, 1329, 1366, 1369, 1375, 1377, 1415, 1417, 1417, 2307, 2307, 2309, 2361, 2365, 2368, 2377, 2380, 2384, 2384, 2392, 2401, 2404, 2416, 2434, 2435, 2437, 2444, 2447, 2448, 2451, 2472, 2474, 2480, 2482, 2482, 2486, 2489, 2494, 2496, 2503, 2504, 2507, 2508, 2519, 2519, 2524, 2525, 2527, 2529, 2534, 2545, 2548, 2554, 2565, 2570, 2575, 2576, 2579, 2600, 2602, 2608, 2610, 2611, 2613, 2614, 2616, 2617, 2622, 2624, 2649, 2652, 2654, 2654, 2662, 2671, 2674, 2676, 2691, 2691, 2693, 2699, 2701, 2701, 2703, 2705, 2707, 2728, 2730, 2736, 2738, 2739, 2741, 2745, 2749, 2752, 2761, 2761, 2763, 2764, 2768, 2768, 2784, 2784, 2790, 2799, 2818, 2819, 2821, 2828, 2831, 2832, 2835, 2856, 2858, 2864, 2866, 2867, 2870, 2873, 2877, 2878, 2880, 2880, 2887, 2888, 2891, 2892, 2903, 2903, 2908, 2909, 2911, 2913, 2918, 2928, 2947, 2947, 2949, 2954, 2958, 2960, 2962, 2965, 2969, 2970, 2972, 2972, 2974, 2975, 2979, 2980, 2984, 2986, 2990, 2997, 2999, 3001, 3006, 3007, 3009, 3010, 3014, 3016, 3018, 3020, 3031, 3031, 3047, 3058, 3073, 3075, 3077, 3084, 3086, 3088, 3090, 3112, 3114, 3123, 3125, 3129, 3137, 3140, 3168, 3169, 3174, 3183, 3202, 3203, 3205, 3212, 3214, 3216, 3218, 3240, 3242, 3251, 3253, 3257, 3262, 3262, 3264, 3268, 3271, 3272, 3274, 3275, 3285, 3286, 3294, 3294, 3296, 3297, 3302, 3311, 3330, 3331, 3333, 3340, 3342, 3344, 3346, 3368, 3370, 3385, 3390, 3392, 3398, 3400, 3402, 3404, 3415, 3415, 3424, 3425, 3430, 3439, 3458, 3459, 3461, 3478, 3482, 3505, 3507, 3515, 3517, 3517, 3520, 3526, 3535, 3537, 3544, 3551, 3570, 3572, 3585, 3632, 3634, 3635, 3648, 3654, 3663, 3675, 3713, 3714, 3716, 3716, 3719, 3720, 3722, 3722, 3725, 3725, 3732, 3735, 3737, 3743, 3745, 3747, 3749, 3749, 3751, 3751, 3754, 3755, 3757, 3760, 3762, 3763, 3773, 3773, 3776, 3780, 3782, 3782, 3792, 3801, 3804, 3805, 3840, 3863, 3866, 3892, 3894, 3894, 3896, 3896, 3902, 3911, 3913, 3946, 3967, 3967, 3973, 3973, 3976, 3979, 4030, 4037, 4039, 4044, 4047, 4047, 4096, 4129, 4131, 4135, 4137, 4138, 4140, 4140, 4145, 4145, 4152, 4152, 4160, 4183, 4256, 4293, 4304, 4344, 4347, 4347, 4352, 4441, 4447, 4514, 4520, 4601, 4608, 4614, 4616, 4678, 4680, 4680, 4682, 4685, 4688, 4694, 4696, 4696, 4698, 4701, 4704, 4742, 4744, 4744, 4746, 4749, 4752, 4782, 4784, 4784, 4786, 4789, 4792, 4798, 4800, 4800, 4802, 4805, 4808, 4814, 4816, 4822, 4824, 4846, 4848, 4878, 4880, 4880, 4882, 4885, 4888, 4894, 4896, 4934, 4936, 4954, 4961, 4988, 5024, 5108, 5121, 5750, 5761, 5786, 5792, 5872, 5888, 5900, 5902, 5905, 5920, 5937, 5941, 5942, 5952, 5969, 5984, 5996, 5998, 6e3, 6016, 6070, 6078, 6085, 6087, 6088, 6100, 6106, 6108, 6108, 6112, 6121, 6160, 6169, 6176, 6263, 6272, 6312, 7680, 7835, 7840, 7929, 7936, 7957, 7960, 7965, 7968, 8005, 8008, 8013, 8016, 8023, 8025, 8025, 8027, 8027, 8029, 8029, 8031, 8061, 8064, 8116, 8118, 8124, 8126, 8126, 8130, 8132, 8134, 8140, 8144, 8147, 8150, 8155, 8160, 8172, 8178, 8180, 8182, 8188, 8206, 8206, 8305, 8305, 8319, 8319, 8450, 8450, 8455, 8455, 8458, 8467, 8469, 8469, 8473, 8477, 8484, 8484, 8486, 8486, 8488, 8488, 8490, 8493, 8495, 8497, 8499, 8505, 8509, 8511, 8517, 8521, 8544, 8579, 9014, 9082, 9109, 9109, 9372, 9449, 12293, 12295, 12321, 12329, 12337, 12341, 12344, 12348, 12353, 12438, 12445, 12447, 12449, 12538, 12540, 12543, 12549, 12588, 12593, 12686, 12688, 12727, 12784, 12828, 12832, 12867, 12896, 12923, 12927, 12976, 12992, 13003, 13008, 13054, 13056, 13174, 13179, 13277, 13280, 13310, 13312, 19893, 19968, 40869, 40960, 42124, 44032, 55203, 55296, 64045, 64048, 64106, 64256, 64262, 64275, 64279, 65313, 65338, 65345, 65370, 65382, 65470, 65474, 65479, 65482, 65487, 65490, 65495, 65498, 65500, 66304, 66334, 66336, 66339, 66352, 66378, 66560, 66597, 66600, 66637, 118784, 119029, 119040, 119078, 119082, 119142, 119146, 119154, 119171, 119172, 119180, 119209, 119214, 119261, 119808, 119892, 119894, 119964, 119966, 119967, 119970, 119970, 119973, 119974, 119977, 119980, 119982, 119993, 119995, 119995, 119997, 12e4, 120002, 120003, 120005, 120069, 120071, 120074, 120077, 120084, 120086, 120092, 120094, 120121, 120123, 120126, 120128, 120132, 120134, 120134, 120138, 120144, 120146, 120483, 120488, 120777, 131072, 173782, 194560, 195101, 983040, 1048573, 1048576, 1114109], qt = function(_) {
                return vt(_, Zt);
              }, ve = se, Se = jt, Pe = function(_) {
                return _.codePointAt(0);
              }, Be = function(_) {
                return _[0];
              }, De = function(_) {
                return _[_.length - 1];
              };
              function It(Et) {
                for (var _ = [], U = Et.length, tt = 0; tt < U; tt += 1) {
                  var K = Et.charCodeAt(tt);
                  if (K >= 55296 && K <= 56319 && U > tt + 1) {
                    var mt = Et.charCodeAt(tt + 1);
                    if (mt >= 56320 && mt <= 57343) {
                      _.push((K - 55296) * 1024 + mt - 56320 + 65536), tt += 1;
                      continue;
                    }
                  }
                  _.push(K);
                }
                return _;
              }
              function he(Et) {
                var _ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                if (typeof Et != "string")
                  throw new TypeError("Expected string.");
                if (Et.length === 0)
                  return "";
                var U = It(Et).map(function(Oe) {
                  return ve(Oe) ? 32 : Oe;
                }).filter(function(Oe) {
                  return !Se(Oe);
                }), tt = String.fromCodePoint.apply(null, U).normalize("NFKC"), K = It(tt), mt = K.some(Te);
                if (mt)
                  throw new Error("Prohibited character, see https://tools.ietf.org/html/rfc4013#section-2.3");
                if (_.allowUnassigned !== !0) {
                  var At = K.some(dt);
                  if (At)
                    throw new Error("Unassigned code point, see https://tools.ietf.org/html/rfc4013#section-2.5");
                }
                var ee = K.some(Fe), ae = K.some(qt);
                if (ee && ae)
                  throw new Error("String must not contain RandALCat and LCat at the same time, see https://tools.ietf.org/html/rfc3454#section-6");
                var ye = Fe(Pe(Be(tt))), Ae = Fe(Pe(De(tt)));
                if (ee && !(ye && Ae))
                  throw new Error("Bidirectional RandALCat character must be the first and the last character of the string, see https://tools.ietf.org/html/rfc3454#section-6");
                return tt;
              }
              var nt = /* @__PURE__ */ function() {
                w(Et, null, [{
                  key: "generateFileID",
                  value: function() {
                    var U = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, tt = "".concat(U.CreationDate.getTime(), `
`);
                    for (var K in U)
                      U.hasOwnProperty(K) && (tt += "".concat(K, ": ").concat(U[K].valueOf(), `
`));
                    return je(v.default.MD5(tt));
                  }
                }, {
                  key: "generateRandomWordArray",
                  value: function(U) {
                    return v.default.lib.WordArray.random(U);
                  }
                }, {
                  key: "create",
                  value: function(U) {
                    var tt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                    return !tt.ownerPassword && !tt.userPassword ? null : new Et(U, tt);
                  }
                }]);
                function Et(_) {
                  var U = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                  if (b(this, Et), !U.ownerPassword && !U.userPassword)
                    throw new Error("None of owner password and user password is defined.");
                  this.document = _, this._setupEncryption(U);
                }
                return w(Et, [{
                  key: "_setupEncryption",
                  value: function(U) {
                    switch (U.pdfVersion) {
                      case "1.4":
                      case "1.5":
                        this.version = 2;
                        break;
                      case "1.6":
                      case "1.7":
                        this.version = 4;
                        break;
                      case "1.7ext3":
                        this.version = 5;
                        break;
                      default:
                        this.version = 1;
                        break;
                    }
                    var tt = {
                      Filter: "Standard"
                    };
                    switch (this.version) {
                      case 1:
                      case 2:
                      case 4:
                        this._setupEncryptionV1V2V4(this.version, tt, U);
                        break;
                      case 5:
                        this._setupEncryptionV5(tt, U);
                        break;
                    }
                    this.dictionary = this.document.ref(tt);
                  }
                }, {
                  key: "_setupEncryptionV1V2V4",
                  value: function(U, tt, K) {
                    var mt, At;
                    switch (U) {
                      case 1:
                        mt = 2, this.keyBits = 40, At = j(K.permissions);
                        break;
                      case 2:
                        mt = 3, this.keyBits = 128, At = V(K.permissions);
                        break;
                      case 4:
                        mt = 4, this.keyBits = 128, At = V(K.permissions);
                        break;
                    }
                    var ee = Ve(K.userPassword), ae = K.ownerPassword ? Ve(K.ownerPassword) : ee, ye = _t(mt, this.keyBits, ee, ae);
                    this.encryptionKey = ne(mt, this.keyBits, this.document._id, ee, ye, At);
                    var Ae;
                    mt === 2 ? Ae = yt(this.encryptionKey) : Ae = it(this.document._id, this.encryptionKey), tt.V = U, U >= 2 && (tt.Length = this.keyBits), U === 4 && (tt.CF = {
                      StdCF: {
                        AuthEvent: "DocOpen",
                        CFM: "AESV2",
                        Length: this.keyBits / 8
                      }
                    }, tt.StmF = "StdCF", tt.StrF = "StdCF"), tt.R = mt, tt.O = je(ye), tt.U = je(Ae), tt.P = At;
                  }
                }, {
                  key: "_setupEncryptionV5",
                  value: function(U, tt) {
                    this.keyBits = 256;
                    var K = V(tt.permissions), mt = ke(tt.userPassword), At = tt.ownerPassword ? ke(tt.ownerPassword) : mt;
                    this.encryptionKey = Xt(Et.generateRandomWordArray);
                    var ee = Y(mt, Et.generateRandomWordArray), ae = v.default.lib.WordArray.create(ee.words.slice(10, 12), 8), ye = Jt(mt, ae, this.encryptionKey), Ae = ie(At, ee, Et.generateRandomWordArray), Oe = v.default.lib.WordArray.create(Ae.words.slice(10, 12), 8), Ie = Tt(At, Oe, ee, this.encryptionKey), Ne = ue(K, this.encryptionKey, Et.generateRandomWordArray);
                    U.V = 5, U.Length = this.keyBits, U.CF = {
                      StdCF: {
                        AuthEvent: "DocOpen",
                        CFM: "AESV3",
                        Length: this.keyBits / 8
                      }
                    }, U.StmF = "StdCF", U.StrF = "StdCF", U.R = 5, U.O = je(Ae), U.OE = je(Ie), U.U = je(ee), U.UE = je(ye), U.P = K, U.Perms = je(Ne);
                  }
                }, {
                  key: "getEncryptFn",
                  value: function(U, tt) {
                    var K;
                    if (this.version < 5 && (K = this.encryptionKey.clone().concat(v.default.lib.WordArray.create([(U & 255) << 24 | (U & 65280) << 8 | U >> 8 & 65280 | tt & 255, (tt & 65280) << 16], 5))), this.version === 1 || this.version === 2) {
                      var mt = v.default.MD5(K);
                      return mt.sigBytes = Math.min(16, this.keyBits / 8 + 5), function(ye) {
                        return je(v.default.RC4.encrypt(v.default.lib.WordArray.create(ye), mt).ciphertext);
                      };
                    }
                    var At;
                    this.version === 4 ? At = v.default.MD5(K.concat(v.default.lib.WordArray.create([1933667412], 4))) : At = this.encryptionKey;
                    var ee = Et.generateRandomWordArray(16), ae = {
                      mode: v.default.mode.CBC,
                      padding: v.default.pad.Pkcs7,
                      iv: ee
                    };
                    return function(ye) {
                      return je(ee.clone().concat(v.default.AES.encrypt(v.default.lib.WordArray.create(ye), At, ae).ciphertext));
                    };
                  }
                }, {
                  key: "end",
                  value: function() {
                    this.dictionary.end();
                  }
                }]), Et;
              }();
              function j() {
                var Et = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ = -64;
                return Et.printing && (_ |= 4), Et.modifying && (_ |= 8), Et.copying && (_ |= 16), Et.annotating && (_ |= 32), _;
              }
              function V() {
                var Et = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ = -3904;
                return Et.printing === "lowResolution" && (_ |= 4), Et.printing === "highResolution" && (_ |= 2052), Et.modifying && (_ |= 8), Et.copying && (_ |= 16), Et.annotating && (_ |= 32), Et.fillingForms && (_ |= 256), Et.contentAccessibility && (_ |= 512), Et.documentAssembly && (_ |= 1024), _;
              }
              function yt(Et) {
                return v.default.RC4.encrypt(Ve(), Et).ciphertext;
              }
              function it(Et, _) {
                for (var U = _.clone(), tt = v.default.MD5(Ve().concat(v.default.lib.WordArray.create(Et))), K = 0; K < 20; K++) {
                  for (var mt = Math.ceil(U.sigBytes / 4), At = 0; At < mt; At++)
                    U.words[At] = _.words[At] ^ (K | K << 8 | K << 16 | K << 24);
                  tt = v.default.RC4.encrypt(tt, U).ciphertext;
                }
                return tt.concat(v.default.lib.WordArray.create(null, 16));
              }
              function _t(Et, _, U, tt) {
                for (var K = tt, mt = Et >= 3 ? 51 : 1, At = 0; At < mt; At++)
                  K = v.default.MD5(K);
                var ee = K.clone();
                ee.sigBytes = _ / 8;
                var ae = U;
                mt = Et >= 3 ? 20 : 1;
                for (var ye = 0; ye < mt; ye++) {
                  for (var Ae = Math.ceil(ee.sigBytes / 4), Oe = 0; Oe < Ae; Oe++)
                    ee.words[Oe] = K.words[Oe] ^ (ye | ye << 8 | ye << 16 | ye << 24);
                  ae = v.default.RC4.encrypt(ae, ee).ciphertext;
                }
                return ae;
              }
              function ne(Et, _, U, tt, K, mt) {
                for (var At = tt.clone().concat(K).concat(v.default.lib.WordArray.create([Xe(mt)], 4)).concat(v.default.lib.WordArray.create(U)), ee = Et >= 3 ? 51 : 1, ae = 0; ae < ee; ae++)
                  At = v.default.MD5(At), At.sigBytes = _ / 8;
                return At;
              }
              function Y(Et, _) {
                var U = _(8), tt = _(8);
                return v.default.SHA256(Et.clone().concat(U)).concat(U).concat(tt);
              }
              function Jt(Et, _, U) {
                var tt = v.default.SHA256(Et.clone().concat(_)), K = {
                  mode: v.default.mode.CBC,
                  padding: v.default.pad.NoPadding,
                  iv: v.default.lib.WordArray.create(null, 16)
                };
                return v.default.AES.encrypt(U, tt, K).ciphertext;
              }
              function ie(Et, _, U) {
                var tt = U(8), K = U(8);
                return v.default.SHA256(Et.clone().concat(tt).concat(_)).concat(tt).concat(K);
              }
              function Tt(Et, _, U, tt) {
                var K = v.default.SHA256(Et.clone().concat(_).concat(U)), mt = {
                  mode: v.default.mode.CBC,
                  padding: v.default.pad.NoPadding,
                  iv: v.default.lib.WordArray.create(null, 16)
                };
                return v.default.AES.encrypt(tt, K, mt).ciphertext;
              }
              function Xt(Et) {
                return Et(32);
              }
              function ue(Et, _, U) {
                var tt = v.default.lib.WordArray.create([Xe(Et), 4294967295, 1415668834], 12).concat(U(4)), K = {
                  mode: v.default.mode.ECB,
                  padding: v.default.pad.NoPadding
                };
                return v.default.AES.encrypt(tt, _, K).ciphertext;
              }
              function Ve() {
                for (var Et = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", _ = i.alloc(32), U = Et.length, tt = 0; tt < U && tt < 32; ) {
                  var K = Et.charCodeAt(tt);
                  if (K > 255)
                    throw new Error("Password contains one or more invalid characters.");
                  _[tt] = K, tt++;
                }
                for (; tt < 32; )
                  _[tt] = Wr[tt - U], tt++;
                return v.default.lib.WordArray.create(_);
              }
              function ke() {
                var Et = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
                Et = unescape(encodeURIComponent(he(Et)));
                for (var _ = Math.min(127, Et.length), U = i.alloc(_), tt = 0; tt < _; tt++)
                  U[tt] = Et.charCodeAt(tt);
                return v.default.lib.WordArray.create(U);
              }
              function Xe(Et) {
                return (Et & 255) << 24 | (Et & 65280) << 8 | Et >> 8 & 65280 | Et >> 24 & 255;
              }
              function je(Et) {
                for (var _ = [], U = 0; U < Et.sigBytes; U++)
                  _.push(Et.words[Math.floor(U / 4)] >> 8 * (3 - U % 4) & 255);
                return i.from(_);
              }
              var Wr = [40, 191, 78, 94, 78, 117, 138, 65, 100, 0, 78, 86, 255, 250, 1, 8, 46, 46, 0, 182, 208, 104, 62, 128, 47, 12, 169, 254, 100, 83, 105, 122], vr = Ft.number, nr = /* @__PURE__ */ function() {
                function Et(_) {
                  b(this, Et), this.doc = _, this.stops = [], this.embedded = !1, this.transform = [1, 0, 0, 1, 0, 0];
                }
                return w(Et, [{
                  key: "stop",
                  value: function(U, tt, K) {
                    if (K == null && (K = 1), tt = this.doc._normalizeColor(tt), this.stops.length === 0)
                      if (tt.length === 3)
                        this._colorSpace = "DeviceRGB";
                      else if (tt.length === 4)
                        this._colorSpace = "DeviceCMYK";
                      else if (tt.length === 1)
                        this._colorSpace = "DeviceGray";
                      else
                        throw new Error("Unknown color space");
                    else if (this._colorSpace === "DeviceRGB" && tt.length !== 3 || this._colorSpace === "DeviceCMYK" && tt.length !== 4 || this._colorSpace === "DeviceGray" && tt.length !== 1)
                      throw new Error("All gradient stops must use the same color space");
                    return K = Math.max(0, Math.min(1, K)), this.stops.push([U, tt, K]), this;
                  }
                }, {
                  key: "setTransform",
                  value: function(U, tt, K, mt, At, ee) {
                    return this.transform = [U, tt, K, mt, At, ee], this;
                  }
                }, {
                  key: "embed",
                  value: function(U) {
                    var tt, K = this.stops.length;
                    if (K !== 0) {
                      this.embedded = !0, this.matrix = U;
                      var mt = this.stops[K - 1];
                      mt[0] < 1 && this.stops.push([1, mt[1], mt[2]]);
                      for (var At = [], ee = [], ae = [], ye = 0; ye < K - 1; ye++)
                        ee.push(0, 1), ye + 2 !== K && At.push(this.stops[ye + 1][0]), tt = this.doc.ref({
                          FunctionType: 2,
                          Domain: [0, 1],
                          C0: this.stops[ye + 0][1],
                          C1: this.stops[ye + 1][1],
                          N: 1
                        }), ae.push(tt), tt.end();
                      K === 1 ? tt = ae[0] : (tt = this.doc.ref({
                        FunctionType: 3,
                        // stitching function
                        Domain: [0, 1],
                        Functions: ae,
                        Bounds: At,
                        Encode: ee
                      }), tt.end()), this.id = "Sh".concat(++this.doc._gradCount);
                      var Ae = this.shader(tt);
                      Ae.end();
                      var Oe = this.doc.ref({
                        Type: "Pattern",
                        PatternType: 2,
                        Shading: Ae,
                        Matrix: this.matrix.map(vr)
                      });
                      if (Oe.end(), this.stops.some(function(Ot) {
                        return Ot[2] < 1;
                      })) {
                        var Ie = this.opacityGradient();
                        Ie._colorSpace = "DeviceGray";
                        var Ne = bt(this.stops), Qe;
                        try {
                          for (Ne.s(); !(Qe = Ne.n()).done; ) {
                            var rr = Qe.value;
                            Ie.stop(rr[0], [rr[2]]);
                          }
                        } catch (Ot) {
                          Ne.e(Ot);
                        } finally {
                          Ne.f();
                        }
                        Ie = Ie.embed(this.matrix);
                        var cr = [0, 0, this.doc.page.width, this.doc.page.height], N = this.doc.ref({
                          Type: "XObject",
                          Subtype: "Form",
                          FormType: 1,
                          BBox: cr,
                          Group: {
                            Type: "Group",
                            S: "Transparency",
                            CS: "DeviceGray"
                          },
                          Resources: {
                            ProcSet: ["PDF", "Text", "ImageB", "ImageC", "ImageI"],
                            Pattern: {
                              Sh1: Ie
                            }
                          }
                        });
                        N.write("/Pattern cs /Sh1 scn"), N.end("".concat(cr.join(" "), " re f"));
                        var q = this.doc.ref({
                          Type: "ExtGState",
                          SMask: {
                            Type: "Mask",
                            S: "Luminosity",
                            G: N
                          }
                        });
                        q.end();
                        var pt = this.doc.ref({
                          Type: "Pattern",
                          PatternType: 1,
                          PaintType: 1,
                          TilingType: 2,
                          BBox: cr,
                          XStep: cr[2],
                          YStep: cr[3],
                          Resources: {
                            ProcSet: ["PDF", "Text", "ImageB", "ImageC", "ImageI"],
                            Pattern: {
                              Sh1: Oe
                            },
                            ExtGState: {
                              Gs1: q
                            }
                          }
                        });
                        pt.write("/Gs1 gs /Pattern cs /Sh1 scn"), pt.end("".concat(cr.join(" "), " re f")), this.doc.page.patterns[this.id] = pt;
                      } else
                        this.doc.page.patterns[this.id] = Oe;
                      return Oe;
                    }
                  }
                }, {
                  key: "apply",
                  value: function(U) {
                    var tt = z(this.doc._ctm, 6), K = tt[0], mt = tt[1], At = tt[2], ee = tt[3], ae = tt[4], ye = tt[5], Ae = z(this.transform, 6), Oe = Ae[0], Ie = Ae[1], Ne = Ae[2], Qe = Ae[3], rr = Ae[4], cr = Ae[5], N = [K * Oe + At * Ie, mt * Oe + ee * Ie, K * Ne + At * Qe, mt * Ne + ee * Qe, K * rr + At * cr + ae, mt * rr + ee * cr + ye];
                    (!this.embedded || N.join(" ") !== this.matrix.join(" ")) && this.embed(N), this.doc._setColorSpace("Pattern", U);
                    var q = U ? "SCN" : "scn";
                    return this.doc.addContent("/".concat(this.id, " ").concat(q));
                  }
                }]), Et;
              }(), Fr = /* @__PURE__ */ function(Et) {
                C(U, Et);
                var _ = M(U);
                function U(tt, K, mt, At, ee) {
                  var ae;
                  return b(this, U), ae = _.call(this, tt), ae.x1 = K, ae.y1 = mt, ae.x2 = At, ae.y2 = ee, ae;
                }
                return w(U, [{
                  key: "shader",
                  value: function(K) {
                    return this.doc.ref({
                      ShadingType: 2,
                      ColorSpace: this._colorSpace,
                      Coords: [this.x1, this.y1, this.x2, this.y2],
                      Function: K,
                      Extend: [!0, !0]
                    });
                  }
                }, {
                  key: "opacityGradient",
                  value: function() {
                    return new U(this.doc, this.x1, this.y1, this.x2, this.y2);
                  }
                }]), U;
              }(nr), Jr = /* @__PURE__ */ function(Et) {
                C(U, Et);
                var _ = M(U);
                function U(tt, K, mt, At, ee, ae, ye) {
                  var Ae;
                  return b(this, U), Ae = _.call(this, tt), Ae.doc = tt, Ae.x1 = K, Ae.y1 = mt, Ae.r1 = At, Ae.x2 = ee, Ae.y2 = ae, Ae.r2 = ye, Ae;
                }
                return w(U, [{
                  key: "shader",
                  value: function(K) {
                    return this.doc.ref({
                      ShadingType: 3,
                      ColorSpace: this._colorSpace,
                      Coords: [this.x1, this.y1, this.r1, this.x2, this.y2, this.r2],
                      Function: K,
                      Extend: [!0, !0]
                    });
                  }
                }, {
                  key: "opacityGradient",
                  value: function() {
                    return new U(this.doc, this.x1, this.y1, this.r1, this.x2, this.y2, this.r2);
                  }
                }]), U;
              }(nr), dn = {
                PDFGradient: nr,
                PDFLinearGradient: Fr,
                PDFRadialGradient: Jr
              }, kn = ["DeviceCMYK", "DeviceRGB"], Yn = /* @__PURE__ */ function() {
                function Et(_, U, tt, K, mt) {
                  b(this, Et), this.doc = _, this.bBox = U, this.xStep = tt, this.yStep = K, this.stream = mt;
                }
                return w(Et, [{
                  key: "createPattern",
                  value: function() {
                    var U = this.doc.ref();
                    U.end();
                    var tt = z(this.doc._ctm, 6), K = tt[0], mt = tt[1], At = tt[2], ee = tt[3], ae = tt[4], ye = tt[5], Ae = 1, Oe = 0, Ie = 0, Ne = 1, Qe = 0, rr = 0, cr = [K * Ae + At * Oe, mt * Ae + ee * Oe, K * Ie + At * Ne, mt * Ie + ee * Ne, K * Qe + At * rr + ae, mt * Qe + ee * rr + ye], N = this.doc.ref({
                      Type: "Pattern",
                      PatternType: 1,
                      // tiling
                      PaintType: 2,
                      // 1-colored, 2-uncolored
                      TilingType: 2,
                      // 2-no distortion
                      BBox: this.bBox,
                      XStep: this.xStep,
                      YStep: this.yStep,
                      Matrix: cr.map(function(q) {
                        return +q.toFixed(5);
                      }),
                      Resources: U
                    });
                    return N.end(this.stream), N;
                  }
                }, {
                  key: "embedPatternColorSpaces",
                  value: function() {
                    var U = this;
                    kn.forEach(function(tt) {
                      var K = U.getPatternColorSpaceId(tt);
                      if (!U.doc.page.colorSpaces[K]) {
                        var mt = U.doc.ref(["Pattern", tt]);
                        mt.end(), U.doc.page.colorSpaces[K] = mt;
                      }
                    });
                  }
                }, {
                  key: "getPatternColorSpaceId",
                  value: function(U) {
                    return "CsP".concat(U);
                  }
                }, {
                  key: "embed",
                  value: function() {
                    this.id || (this.doc._patternCount = this.doc._patternCount + 1, this.id = "P" + this.doc._patternCount, this.pattern = this.createPattern()), this.doc.page.patterns[this.id] || (this.doc.page.patterns[this.id] = this.pattern);
                  }
                }, {
                  key: "apply",
                  value: function(U, tt) {
                    this.embedPatternColorSpaces(), this.embed();
                    var K = this.doc._normalizeColor(tt);
                    if (!K)
                      throw Error("invalid pattern color. (value: ".concat(tt, ")"));
                    var mt = this.getPatternColorSpaceId(this.doc._getColorSpace(K));
                    this.doc._setColorSpace(mt, U);
                    var At = U ? "SCN" : "scn";
                    return this.doc.addContent("".concat(K.join(" "), " /").concat(this.id, " ").concat(At));
                  }
                }]), Et;
              }(), yr = {
                PDFTilingPattern: Yn
              }, Tn = dn.PDFGradient, qr = dn.PDFLinearGradient, gn = dn.PDFRadialGradient, un = yr.PDFTilingPattern, wi = {
                initColor: function() {
                  return this._opacityRegistry = {}, this._opacityCount = 0, this._patternCount = 0, this._gradCount = 0;
                },
                _normalizeColor: function(_) {
                  if (typeof _ == "string")
                    if (_.charAt(0) === "#") {
                      _.length === 4 && (_ = _.replace(/#([0-9A-F])([0-9A-F])([0-9A-F])/i, "#$1$1$2$2$3$3"));
                      var U = parseInt(_.slice(1), 16);
                      _ = [U >> 16, U >> 8 & 255, U & 255];
                    } else
                      Si[_] && (_ = Si[_]);
                  return Array.isArray(_) ? (_.length === 3 ? _ = _.map(function(tt) {
                    return tt / 255;
                  }) : _.length === 4 && (_ = _.map(function(tt) {
                    return tt / 100;
                  })), _) : null;
                },
                _setColor: function(_, U) {
                  return _ instanceof Tn ? (_.apply(U), !0) : Array.isArray(_) && _[0] instanceof un ? (_[0].apply(U, _[1]), !0) : this._setColorCore(_, U);
                },
                _setColorCore: function(_, U) {
                  if (_ = this._normalizeColor(_), !_)
                    return !1;
                  var tt = U ? "SCN" : "scn", K = this._getColorSpace(_);
                  return this._setColorSpace(K, U), _ = _.join(" "), this.addContent("".concat(_, " ").concat(tt)), !0;
                },
                _setColorSpace: function(_, U) {
                  var tt = U ? "CS" : "cs";
                  return this.addContent("/".concat(_, " ").concat(tt));
                },
                _getColorSpace: function(_) {
                  return _.length === 4 ? "DeviceCMYK" : "DeviceRGB";
                },
                fillColor: function(_, U) {
                  var tt = this._setColor(_, !1);
                  return tt && this.fillOpacity(U), this._fillColor = [_, U], this;
                },
                strokeColor: function(_, U) {
                  var tt = this._setColor(_, !0);
                  return tt && this.strokeOpacity(U), this;
                },
                opacity: function(_) {
                  return this._doOpacity(_, _), this;
                },
                fillOpacity: function(_) {
                  return this._doOpacity(_, null), this;
                },
                strokeOpacity: function(_) {
                  return this._doOpacity(null, _), this;
                },
                _doOpacity: function(_, U) {
                  var tt, K;
                  if (!(_ == null && U == null)) {
                    _ != null && (_ = Math.max(0, Math.min(1, _))), U != null && (U = Math.max(0, Math.min(1, U)));
                    var mt = "".concat(_, "_").concat(U);
                    if (this._opacityRegistry[mt]) {
                      var At = z(this._opacityRegistry[mt], 2);
                      tt = At[0], K = At[1];
                    } else {
                      tt = {
                        Type: "ExtGState"
                      }, _ != null && (tt.ca = _), U != null && (tt.CA = U), tt = this.ref(tt), tt.end();
                      var ee = ++this._opacityCount;
                      K = "Gs".concat(ee), this._opacityRegistry[mt] = [tt, K];
                    }
                    return this.page.ext_gstates[K] = tt, this.addContent("/".concat(K, " gs"));
                  }
                },
                linearGradient: function(_, U, tt, K) {
                  return new qr(this, _, U, tt, K);
                },
                radialGradient: function(_, U, tt, K, mt, At) {
                  return new gn(this, _, U, tt, K, mt, At);
                },
                pattern: function(_, U, tt, K) {
                  return new un(this, _, U, tt, K);
                }
              }, Si = {
                aliceblue: [240, 248, 255],
                antiquewhite: [250, 235, 215],
                aqua: [0, 255, 255],
                aquamarine: [127, 255, 212],
                azure: [240, 255, 255],
                beige: [245, 245, 220],
                bisque: [255, 228, 196],
                black: [0, 0, 0],
                blanchedalmond: [255, 235, 205],
                blue: [0, 0, 255],
                blueviolet: [138, 43, 226],
                brown: [165, 42, 42],
                burlywood: [222, 184, 135],
                cadetblue: [95, 158, 160],
                chartreuse: [127, 255, 0],
                chocolate: [210, 105, 30],
                coral: [255, 127, 80],
                cornflowerblue: [100, 149, 237],
                cornsilk: [255, 248, 220],
                crimson: [220, 20, 60],
                cyan: [0, 255, 255],
                darkblue: [0, 0, 139],
                darkcyan: [0, 139, 139],
                darkgoldenrod: [184, 134, 11],
                darkgray: [169, 169, 169],
                darkgreen: [0, 100, 0],
                darkgrey: [169, 169, 169],
                darkkhaki: [189, 183, 107],
                darkmagenta: [139, 0, 139],
                darkolivegreen: [85, 107, 47],
                darkorange: [255, 140, 0],
                darkorchid: [153, 50, 204],
                darkred: [139, 0, 0],
                darksalmon: [233, 150, 122],
                darkseagreen: [143, 188, 143],
                darkslateblue: [72, 61, 139],
                darkslategray: [47, 79, 79],
                darkslategrey: [47, 79, 79],
                darkturquoise: [0, 206, 209],
                darkviolet: [148, 0, 211],
                deeppink: [255, 20, 147],
                deepskyblue: [0, 191, 255],
                dimgray: [105, 105, 105],
                dimgrey: [105, 105, 105],
                dodgerblue: [30, 144, 255],
                firebrick: [178, 34, 34],
                floralwhite: [255, 250, 240],
                forestgreen: [34, 139, 34],
                fuchsia: [255, 0, 255],
                gainsboro: [220, 220, 220],
                ghostwhite: [248, 248, 255],
                gold: [255, 215, 0],
                goldenrod: [218, 165, 32],
                gray: [128, 128, 128],
                grey: [128, 128, 128],
                green: [0, 128, 0],
                greenyellow: [173, 255, 47],
                honeydew: [240, 255, 240],
                hotpink: [255, 105, 180],
                indianred: [205, 92, 92],
                indigo: [75, 0, 130],
                ivory: [255, 255, 240],
                khaki: [240, 230, 140],
                lavender: [230, 230, 250],
                lavenderblush: [255, 240, 245],
                lawngreen: [124, 252, 0],
                lemonchiffon: [255, 250, 205],
                lightblue: [173, 216, 230],
                lightcoral: [240, 128, 128],
                lightcyan: [224, 255, 255],
                lightgoldenrodyellow: [250, 250, 210],
                lightgray: [211, 211, 211],
                lightgreen: [144, 238, 144],
                lightgrey: [211, 211, 211],
                lightpink: [255, 182, 193],
                lightsalmon: [255, 160, 122],
                lightseagreen: [32, 178, 170],
                lightskyblue: [135, 206, 250],
                lightslategray: [119, 136, 153],
                lightslategrey: [119, 136, 153],
                lightsteelblue: [176, 196, 222],
                lightyellow: [255, 255, 224],
                lime: [0, 255, 0],
                limegreen: [50, 205, 50],
                linen: [250, 240, 230],
                magenta: [255, 0, 255],
                maroon: [128, 0, 0],
                mediumaquamarine: [102, 205, 170],
                mediumblue: [0, 0, 205],
                mediumorchid: [186, 85, 211],
                mediumpurple: [147, 112, 219],
                mediumseagreen: [60, 179, 113],
                mediumslateblue: [123, 104, 238],
                mediumspringgreen: [0, 250, 154],
                mediumturquoise: [72, 209, 204],
                mediumvioletred: [199, 21, 133],
                midnightblue: [25, 25, 112],
                mintcream: [245, 255, 250],
                mistyrose: [255, 228, 225],
                moccasin: [255, 228, 181],
                navajowhite: [255, 222, 173],
                navy: [0, 0, 128],
                oldlace: [253, 245, 230],
                olive: [128, 128, 0],
                olivedrab: [107, 142, 35],
                orange: [255, 165, 0],
                orangered: [255, 69, 0],
                orchid: [218, 112, 214],
                palegoldenrod: [238, 232, 170],
                palegreen: [152, 251, 152],
                paleturquoise: [175, 238, 238],
                palevioletred: [219, 112, 147],
                papayawhip: [255, 239, 213],
                peachpuff: [255, 218, 185],
                peru: [205, 133, 63],
                pink: [255, 192, 203],
                plum: [221, 160, 221],
                powderblue: [176, 224, 230],
                purple: [128, 0, 128],
                red: [255, 0, 0],
                rosybrown: [188, 143, 143],
                royalblue: [65, 105, 225],
                saddlebrown: [139, 69, 19],
                salmon: [250, 128, 114],
                sandybrown: [244, 164, 96],
                seagreen: [46, 139, 87],
                seashell: [255, 245, 238],
                sienna: [160, 82, 45],
                silver: [192, 192, 192],
                skyblue: [135, 206, 235],
                slateblue: [106, 90, 205],
                slategray: [112, 128, 144],
                slategrey: [112, 128, 144],
                snow: [255, 250, 250],
                springgreen: [0, 255, 127],
                steelblue: [70, 130, 180],
                tan: [210, 180, 140],
                teal: [0, 128, 128],
                thistle: [216, 191, 216],
                tomato: [255, 99, 71],
                turquoise: [64, 224, 208],
                violet: [238, 130, 238],
                wheat: [245, 222, 179],
                white: [255, 255, 255],
                whitesmoke: [245, 245, 245],
                yellow: [255, 255, 0],
                yellowgreen: [154, 205, 50]
              }, Me, Ze, qe, gr, Wn, sr;
              Me = Ze = qe = gr = Wn = sr = 0;
              var Oi = {
                A: 7,
                a: 7,
                C: 6,
                c: 6,
                H: 1,
                h: 1,
                L: 2,
                l: 2,
                M: 2,
                m: 2,
                Q: 4,
                q: 4,
                S: 4,
                s: 4,
                T: 2,
                t: 2,
                V: 1,
                v: 1,
                Z: 0,
                z: 0
              }, Yi = function(_) {
                var U, tt = [], K = [], mt = "", At = !1, ee = 0, ae = bt(_), ye;
                try {
                  for (ae.s(); !(ye = ae.n()).done; ) {
                    var Ae = ye.value;
                    if (Oi[Ae] != null)
                      ee = Oi[Ae], U && (mt.length > 0 && (K[K.length] = +mt), tt[tt.length] = {
                        cmd: U,
                        args: K
                      }, K = [], mt = "", At = !1), U = Ae;
                    else if ([" ", ","].includes(Ae) || Ae === "-" && mt.length > 0 && mt[mt.length - 1] !== "e" || Ae === "." && At) {
                      if (mt.length === 0)
                        continue;
                      K.length === ee ? (tt[tt.length] = {
                        cmd: U,
                        args: K
                      }, K = [+mt], U === "M" && (U = "L"), U === "m" && (U = "l")) : K[K.length] = +mt, At = Ae === ".", mt = ["-", "."].includes(Ae) ? Ae : "";
                    } else
                      mt += Ae, Ae === "." && (At = !0);
                  }
                } catch (Oe) {
                  ae.e(Oe);
                } finally {
                  ae.f();
                }
                return mt.length > 0 && (K.length === ee ? (tt[tt.length] = {
                  cmd: U,
                  args: K
                }, K = [+mt], U === "M" && (U = "L"), U === "m" && (U = "l")) : K[K.length] = +mt), tt[tt.length] = {
                  cmd: U,
                  args: K
                }, tt;
              }, vi = function(_, U) {
                Me = Ze = qe = gr = Wn = sr = 0;
                for (var tt = 0; tt < _.length; tt++) {
                  var K = _[tt];
                  typeof Ct[K.cmd] == "function" && Ct[K.cmd](U, K.args);
                }
              }, Ct = {
                M: function(_, U) {
                  return Me = U[0], Ze = U[1], qe = gr = null, Wn = Me, sr = Ze, _.moveTo(Me, Ze);
                },
                m: function(_, U) {
                  return Me += U[0], Ze += U[1], qe = gr = null, Wn = Me, sr = Ze, _.moveTo(Me, Ze);
                },
                C: function(_, U) {
                  return Me = U[4], Ze = U[5], qe = U[2], gr = U[3], _.bezierCurveTo.apply(_, L(U));
                },
                c: function(_, U) {
                  return _.bezierCurveTo(U[0] + Me, U[1] + Ze, U[2] + Me, U[3] + Ze, U[4] + Me, U[5] + Ze), qe = Me + U[2], gr = Ze + U[3], Me += U[4], Ze += U[5];
                },
                S: function(_, U) {
                  return qe === null && (qe = Me, gr = Ze), _.bezierCurveTo(Me - (qe - Me), Ze - (gr - Ze), U[0], U[1], U[2], U[3]), qe = U[0], gr = U[1], Me = U[2], Ze = U[3];
                },
                s: function(_, U) {
                  return qe === null && (qe = Me, gr = Ze), _.bezierCurveTo(Me - (qe - Me), Ze - (gr - Ze), Me + U[0], Ze + U[1], Me + U[2], Ze + U[3]), qe = Me + U[0], gr = Ze + U[1], Me += U[2], Ze += U[3];
                },
                Q: function(_, U) {
                  return qe = U[0], gr = U[1], Me = U[2], Ze = U[3], _.quadraticCurveTo(U[0], U[1], Me, Ze);
                },
                q: function(_, U) {
                  return _.quadraticCurveTo(U[0] + Me, U[1] + Ze, U[2] + Me, U[3] + Ze), qe = Me + U[0], gr = Ze + U[1], Me += U[2], Ze += U[3];
                },
                T: function(_, U) {
                  return qe === null ? (qe = Me, gr = Ze) : (qe = Me - (qe - Me), gr = Ze - (gr - Ze)), _.quadraticCurveTo(qe, gr, U[0], U[1]), qe = Me - (qe - Me), gr = Ze - (gr - Ze), Me = U[0], Ze = U[1];
                },
                t: function(_, U) {
                  return qe === null ? (qe = Me, gr = Ze) : (qe = Me - (qe - Me), gr = Ze - (gr - Ze)), _.quadraticCurveTo(qe, gr, Me + U[0], Ze + U[1]), Me += U[0], Ze += U[1];
                },
                A: function(_, U) {
                  return $t(_, Me, Ze, U), Me = U[5], Ze = U[6];
                },
                a: function(_, U) {
                  return U[5] += Me, U[6] += Ze, $t(_, Me, Ze, U), Me = U[5], Ze = U[6];
                },
                L: function(_, U) {
                  return Me = U[0], Ze = U[1], qe = gr = null, _.lineTo(Me, Ze);
                },
                l: function(_, U) {
                  return Me += U[0], Ze += U[1], qe = gr = null, _.lineTo(Me, Ze);
                },
                H: function(_, U) {
                  return Me = U[0], qe = gr = null, _.lineTo(Me, Ze);
                },
                h: function(_, U) {
                  return Me += U[0], qe = gr = null, _.lineTo(Me, Ze);
                },
                V: function(_, U) {
                  return Ze = U[0], qe = gr = null, _.lineTo(Me, Ze);
                },
                v: function(_, U) {
                  return Ze += U[0], qe = gr = null, _.lineTo(Me, Ze);
                },
                Z: function(_) {
                  return _.closePath(), Me = Wn, Ze = sr;
                },
                z: function(_) {
                  return _.closePath(), Me = Wn, Ze = sr;
                }
              }, $t = function(_, U, tt, K) {
                var mt = z(K, 7), At = mt[0], ee = mt[1], ae = mt[2], ye = mt[3], Ae = mt[4], Oe = mt[5], Ie = mt[6], Ne = Mt(Oe, Ie, At, ee, ye, Ae, ae, U, tt), Qe = bt(Ne), rr;
                try {
                  for (Qe.s(); !(rr = Qe.n()).done; ) {
                    var cr = rr.value, N = oe.apply(void 0, L(cr));
                    _.bezierCurveTo.apply(_, L(N));
                  }
                } catch (q) {
                  Qe.e(q);
                } finally {
                  Qe.f();
                }
              }, Mt = function(_, U, tt, K, mt, At, ee, ae, ye) {
                var Ae = ee * (Math.PI / 180), Oe = Math.sin(Ae), Ie = Math.cos(Ae);
                tt = Math.abs(tt), K = Math.abs(K), qe = Ie * (ae - _) * 0.5 + Oe * (ye - U) * 0.5, gr = Ie * (ye - U) * 0.5 - Oe * (ae - _) * 0.5;
                var Ne = qe * qe / (tt * tt) + gr * gr / (K * K);
                Ne > 1 && (Ne = Math.sqrt(Ne), tt *= Ne, K *= Ne);
                var Qe = Ie / tt, rr = Oe / tt, cr = -Oe / K, N = Ie / K, q = Qe * ae + rr * ye, pt = cr * ae + N * ye, Ot = Qe * _ + rr * U, Wt = cr * _ + N * U, le = (Ot - q) * (Ot - q) + (Wt - pt) * (Wt - pt), ce = 1 / le - 0.25;
                ce < 0 && (ce = 0);
                var be = Math.sqrt(ce);
                At === mt && (be = -be);
                var Ge = 0.5 * (q + Ot) - be * (Wt - pt), er = 0.5 * (pt + Wt) + be * (Ot - q), br = Math.atan2(pt - er, q - Ge), Nr = Math.atan2(Wt - er, Ot - Ge), hr = Nr - br;
                hr < 0 && At === 1 ? hr += 2 * Math.PI : hr > 0 && At === 0 && (hr -= 2 * Math.PI);
                for (var ir = Math.ceil(Math.abs(hr / (Math.PI * 0.5 + 1e-3))), ur = [], rn = 0; rn < ir; rn++) {
                  var Pn = br + rn * hr / ir, li = br + (rn + 1) * hr / ir;
                  ur[rn] = [Ge, er, Pn, li, tt, K, Oe, Ie];
                }
                return ur;
              }, oe = function(_, U, tt, K, mt, At, ee, ae) {
                var ye = ae * mt, Ae = -ee * At, Oe = ee * mt, Ie = ae * At, Ne = 0.5 * (K - tt), Qe = 8 / 3 * Math.sin(Ne * 0.5) * Math.sin(Ne * 0.5) / Math.sin(Ne), rr = _ + Math.cos(tt) - Qe * Math.sin(tt), cr = U + Math.sin(tt) + Qe * Math.cos(tt), N = _ + Math.cos(K), q = U + Math.sin(K), pt = N + Qe * Math.sin(K), Ot = q - Qe * Math.cos(K);
                return [ye * rr + Ae * cr, Oe * rr + Ie * cr, ye * pt + Ae * Ot, Oe * pt + Ie * Ot, ye * N + Ae * q, Oe * N + Ie * q];
              }, Lt = /* @__PURE__ */ function() {
                function Et() {
                  b(this, Et);
                }
                return w(Et, null, [{
                  key: "apply",
                  value: function(U, tt) {
                    var K = Yi(tt);
                    vi(K, U);
                  }
                }]), Et;
              }(), Ut = Ft.number, Vt = 4 * ((Math.sqrt(2) - 1) / 3), Yt = {
                initVector: function() {
                  return this._ctm = [1, 0, 0, 1, 0, 0], this._ctmStack = [];
                },
                save: function() {
                  return this._ctmStack.push(this._ctm.slice()), this.addContent("q");
                },
                restore: function() {
                  return this._ctm = this._ctmStack.pop() || [1, 0, 0, 1, 0, 0], this.addContent("Q");
                },
                closePath: function() {
                  return this.addContent("h");
                },
                lineWidth: function(_) {
                  return this.addContent("".concat(Ut(_), " w"));
                },
                _CAP_STYLES: {
                  BUTT: 0,
                  ROUND: 1,
                  SQUARE: 2
                },
                lineCap: function(_) {
                  return typeof _ == "string" && (_ = this._CAP_STYLES[_.toUpperCase()]), this.addContent("".concat(_, " J"));
                },
                _JOIN_STYLES: {
                  MITER: 0,
                  ROUND: 1,
                  BEVEL: 2
                },
                lineJoin: function(_) {
                  return typeof _ == "string" && (_ = this._JOIN_STYLES[_.toUpperCase()]), this.addContent("".concat(_, " j"));
                },
                miterLimit: function(_) {
                  return this.addContent("".concat(Ut(_), " M"));
                },
                dash: function(_) {
                  var U = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, tt = _;
                  Array.isArray(_) || (_ = [_, U.space || _]);
                  var K = _.every(function(mt) {
                    return Number.isFinite(mt) && mt > 0;
                  });
                  if (!K)
                    throw new Error("dash(".concat(JSON.stringify(tt), ", ").concat(JSON.stringify(U), ") invalid, lengths must be numeric and greater than zero"));
                  return _ = _.map(Ut).join(" "), this.addContent("[".concat(_, "] ").concat(Ut(U.phase || 0), " d"));
                },
                undash: function() {
                  return this.addContent("[] 0 d");
                },
                moveTo: function(_, U) {
                  return this.addContent("".concat(Ut(_), " ").concat(Ut(U), " m"));
                },
                lineTo: function(_, U) {
                  return this.addContent("".concat(Ut(_), " ").concat(Ut(U), " l"));
                },
                bezierCurveTo: function(_, U, tt, K, mt, At) {
                  return this.addContent("".concat(Ut(_), " ").concat(Ut(U), " ").concat(Ut(tt), " ").concat(Ut(K), " ").concat(Ut(mt), " ").concat(Ut(At), " c"));
                },
                quadraticCurveTo: function(_, U, tt, K) {
                  return this.addContent("".concat(Ut(_), " ").concat(Ut(U), " ").concat(Ut(tt), " ").concat(Ut(K), " v"));
                },
                rect: function(_, U, tt, K) {
                  return this.addContent("".concat(Ut(_), " ").concat(Ut(U), " ").concat(Ut(tt), " ").concat(Ut(K), " re"));
                },
                roundedRect: function(_, U, tt, K, mt) {
                  mt == null && (mt = 0), mt = Math.min(mt, 0.5 * tt, 0.5 * K);
                  var At = mt * (1 - Vt);
                  return this.moveTo(_ + mt, U), this.lineTo(_ + tt - mt, U), this.bezierCurveTo(_ + tt - At, U, _ + tt, U + At, _ + tt, U + mt), this.lineTo(_ + tt, U + K - mt), this.bezierCurveTo(_ + tt, U + K - At, _ + tt - At, U + K, _ + tt - mt, U + K), this.lineTo(_ + mt, U + K), this.bezierCurveTo(_ + At, U + K, _, U + K - At, _, U + K - mt), this.lineTo(_, U + mt), this.bezierCurveTo(_, U + At, _ + At, U, _ + mt, U), this.closePath();
                },
                ellipse: function(_, U, tt, K) {
                  K == null && (K = tt), _ -= tt, U -= K;
                  var mt = tt * Vt, At = K * Vt, ee = _ + tt * 2, ae = U + K * 2, ye = _ + tt, Ae = U + K;
                  return this.moveTo(_, Ae), this.bezierCurveTo(_, Ae - At, ye - mt, U, ye, U), this.bezierCurveTo(ye + mt, U, ee, Ae - At, ee, Ae), this.bezierCurveTo(ee, Ae + At, ye + mt, ae, ye, ae), this.bezierCurveTo(ye - mt, ae, _, Ae + At, _, Ae), this.closePath();
                },
                circle: function(_, U, tt) {
                  return this.ellipse(_, U, tt);
                },
                arc: function(_, U, tt, K, mt, At) {
                  At == null && (At = !1);
                  var ee = 2 * Math.PI, ae = 0.5 * Math.PI, ye = mt - K;
                  if (Math.abs(ye) > ee)
                    ye = ee;
                  else if (ye !== 0 && At !== ye < 0) {
                    var Ae = At ? -1 : 1;
                    ye = Ae * ee + ye;
                  }
                  var Oe = Math.ceil(Math.abs(ye) / ae), Ie = ye / Oe, Ne = Ie / ae * Vt * tt, Qe = K, rr = -Math.sin(Qe) * Ne, cr = Math.cos(Qe) * Ne, N = _ + Math.cos(Qe) * tt, q = U + Math.sin(Qe) * tt;
                  this.moveTo(N, q);
                  for (var pt = 0; pt < Oe; pt++) {
                    var Ot = N + rr, Wt = q + cr;
                    Qe += Ie, N = _ + Math.cos(Qe) * tt, q = U + Math.sin(Qe) * tt, rr = -Math.sin(Qe) * Ne, cr = Math.cos(Qe) * Ne;
                    var le = N - rr, ce = q - cr;
                    this.bezierCurveTo(Ot, Wt, le, ce, N, q);
                  }
                  return this;
                },
                polygon: function() {
                  for (var _ = arguments.length, U = new Array(_), tt = 0; tt < _; tt++)
                    U[tt] = arguments[tt];
                  this.moveTo.apply(this, L(U.shift() || []));
                  for (var K = 0, mt = U; K < mt.length; K++) {
                    var At = mt[K];
                    this.lineTo.apply(this, L(At || []));
                  }
                  return this.closePath();
                },
                path: function(_) {
                  return Lt.apply(this, _), this;
                },
                _windingRule: function(_) {
                  return /even-?odd/.test(_) ? "*" : "";
                },
                fill: function(_, U) {
                  return /(even-?odd)|(non-?zero)/.test(_) && (U = _, _ = null), _ && this.fillColor(_), this.addContent("f".concat(this._windingRule(U)));
                },
                stroke: function(_) {
                  return _ && this.strokeColor(_), this.addContent("S");
                },
                fillAndStroke: function(_, U, tt) {
                  U == null && (U = _);
                  var K = /(even-?odd)|(non-?zero)/;
                  return K.test(_) && (tt = _, _ = null), K.test(U) && (tt = U, U = _), _ && (this.fillColor(_), this.strokeColor(U)), this.addContent("B".concat(this._windingRule(tt)));
                },
                clip: function(_) {
                  return this.addContent("W".concat(this._windingRule(_), " n"));
                },
                transform: function(_, U, tt, K, mt, At) {
                  var ee = this._ctm, ae = z(ee, 6), ye = ae[0], Ae = ae[1], Oe = ae[2], Ie = ae[3], Ne = ae[4], Qe = ae[5];
                  ee[0] = ye * _ + Oe * U, ee[1] = Ae * _ + Ie * U, ee[2] = ye * tt + Oe * K, ee[3] = Ae * tt + Ie * K, ee[4] = ye * mt + Oe * At + Ne, ee[5] = Ae * mt + Ie * At + Qe;
                  var rr = [_, U, tt, K, mt, At].map(function(cr) {
                    return Ut(cr);
                  }).join(" ");
                  return this.addContent("".concat(rr, " cm"));
                },
                translate: function(_, U) {
                  return this.transform(1, 0, 0, 1, _, U);
                },
                rotate: function(_) {
                  var U = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, tt, K = _ * Math.PI / 180, mt = Math.cos(K), At = Math.sin(K), ee = tt = 0;
                  if (U.origin != null) {
                    var ae = z(U.origin, 2);
                    ee = ae[0], tt = ae[1];
                    var ye = ee * mt - tt * At, Ae = ee * At + tt * mt;
                    ee -= ye, tt -= Ae;
                  }
                  return this.transform(mt, At, -At, mt, ee, tt);
                },
                scale: function(_, U) {
                  var tt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, K;
                  U == null && (U = _), typeof U == "object" && (tt = U, U = _);
                  var mt = K = 0;
                  if (tt.origin != null) {
                    var At = z(tt.origin, 2);
                    mt = At[0], K = At[1], mt -= _ * mt, K -= U * K;
                  }
                  return this.transform(_, 0, 0, U, mt, K);
                }
              }, re = {
                402: 131,
                8211: 150,
                8212: 151,
                8216: 145,
                8217: 146,
                8218: 130,
                8220: 147,
                8221: 148,
                8222: 132,
                8224: 134,
                8225: 135,
                8226: 149,
                8230: 133,
                8364: 128,
                8240: 137,
                8249: 139,
                8250: 155,
                710: 136,
                8482: 153,
                338: 140,
                339: 156,
                732: 152,
                352: 138,
                353: 154,
                376: 159,
                381: 142,
                382: 158
              }, Ht = `.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
  
space         exclam         quotedbl       numbersign
dollar        percent        ampersand      quotesingle
parenleft     parenright     asterisk       plus
comma         hyphen         period         slash
zero          one            two            three
four          five           six            seven
eight         nine           colon          semicolon
less          equal          greater        question
  
at            A              B              C
D             E              F              G
H             I              J              K
L             M              N              O
P             Q              R              S
T             U              V              W
X             Y              Z              bracketleft
backslash     bracketright   asciicircum    underscore
  
grave         a              b              c
d             e              f              g
h             i              j              k
l             m              n              o
p             q              r              s
t             u              v              w
x             y              z              braceleft
bar           braceright     asciitilde     .notdef
  
Euro          .notdef        quotesinglbase florin
quotedblbase  ellipsis       dagger         daggerdbl
circumflex    perthousand    Scaron         guilsinglleft
OE            .notdef        Zcaron         .notdef
.notdef       quoteleft      quoteright     quotedblleft
quotedblright bullet         endash         emdash
tilde         trademark      scaron         guilsinglright
oe            .notdef        zcaron         ydieresis
  
space         exclamdown     cent           sterling
currency      yen            brokenbar      section
dieresis      copyright      ordfeminine    guillemotleft
logicalnot    hyphen         registered     macron
degree        plusminus      twosuperior    threesuperior
acute         mu             paragraph      periodcentered
cedilla       onesuperior    ordmasculine   guillemotright
onequarter    onehalf        threequarters  questiondown
  
Agrave        Aacute         Acircumflex    Atilde
Adieresis     Aring          AE             Ccedilla
Egrave        Eacute         Ecircumflex    Edieresis
Igrave        Iacute         Icircumflex    Idieresis
Eth           Ntilde         Ograve         Oacute
Ocircumflex   Otilde         Odieresis      multiply
Oslash        Ugrave         Uacute         Ucircumflex
Udieresis     Yacute         Thorn          germandbls
  
agrave        aacute         acircumflex    atilde
adieresis     aring          ae             ccedilla
egrave        eacute         ecircumflex    edieresis
igrave        iacute         icircumflex    idieresis
eth           ntilde         ograve         oacute
ocircumflex   otilde         odieresis      divide
oslash        ugrave         uacute         ucircumflex
udieresis     yacute         thorn          ydieresis`.split(/\s+/), fe = /* @__PURE__ */ function() {
                w(Et, null, [{
                  key: "open",
                  value: function(U) {
                    return new Et(y.readFileSync(U, "utf8"));
                  }
                }]);
                function Et(_) {
                  b(this, Et), this.contents = _, this.attributes = {}, this.glyphWidths = {}, this.boundingBoxes = {}, this.kernPairs = {}, this.parse(), this.charWidths = new Array(256);
                  for (var U = 0; U <= 255; U++)
                    this.charWidths[U] = this.glyphWidths[Ht[U]];
                  this.bbox = this.attributes.FontBBox.split(/\s+/).map(function(tt) {
                    return +tt;
                  }), this.ascender = +(this.attributes.Ascender || 0), this.descender = +(this.attributes.Descender || 0), this.xHeight = +(this.attributes.XHeight || 0), this.capHeight = +(this.attributes.CapHeight || 0), this.lineGap = this.bbox[3] - this.bbox[1] - (this.ascender - this.descender);
                }
                return w(Et, [{
                  key: "parse",
                  value: function() {
                    var U = "", tt = bt(this.contents.split(`
`)), K;
                    try {
                      for (tt.s(); !(K = tt.n()).done; ) {
                        var mt = K.value, At, ee;
                        if (At = mt.match(/^Start(\w+)/)) {
                          U = At[1];
                          continue;
                        } else if (At = mt.match(/^End(\w+)/)) {
                          U = "";
                          continue;
                        }
                        switch (U) {
                          case "FontMetrics":
                            At = mt.match(/(^\w+)\s+(.*)/);
                            var ae = At[1], ye = At[2];
                            (ee = this.attributes[ae]) ? (Array.isArray(ee) || (ee = this.attributes[ae] = [ee]), ee.push(ye)) : this.attributes[ae] = ye;
                            break;
                          case "CharMetrics":
                            if (!/^CH?\s/.test(mt))
                              continue;
                            var Ae = mt.match(/\bN\s+(\.?\w+)\s*;/)[1];
                            this.glyphWidths[Ae] = +mt.match(/\bWX\s+(\d+)\s*;/)[1];
                            break;
                          case "KernPairs":
                            At = mt.match(/^KPX\s+(\.?\w+)\s+(\.?\w+)\s+(-?\d+)/), At && (this.kernPairs[At[1] + "\0" + At[2]] = parseInt(At[3]));
                            break;
                        }
                      }
                    } catch (Oe) {
                      tt.e(Oe);
                    } finally {
                      tt.f();
                    }
                  }
                }, {
                  key: "encodeText",
                  value: function(U) {
                    for (var tt = [], K = 0, mt = U.length; K < mt; K++) {
                      var At = U.charCodeAt(K);
                      At = re[At] || At, tt.push(At.toString(16));
                    }
                    return tt;
                  }
                }, {
                  key: "glyphsForString",
                  value: function(U) {
                    for (var tt = [], K = 0, mt = U.length; K < mt; K++) {
                      var At = U.charCodeAt(K);
                      tt.push(this.characterToGlyph(At));
                    }
                    return tt;
                  }
                }, {
                  key: "characterToGlyph",
                  value: function(U) {
                    return Ht[re[U] || U] || ".notdef";
                  }
                }, {
                  key: "widthOfGlyph",
                  value: function(U) {
                    return this.glyphWidths[U] || 0;
                  }
                }, {
                  key: "getKernPair",
                  value: function(U, tt) {
                    return this.kernPairs[U + "\0" + tt] || 0;
                  }
                }, {
                  key: "advancesForGlyphs",
                  value: function(U) {
                    for (var tt = [], K = 0; K < U.length; K++) {
                      var mt = U[K], At = U[K + 1];
                      tt.push(this.widthOfGlyph(mt) + this.getKernPair(mt, At));
                    }
                    return tt;
                  }
                }]), Et;
              }(), Qt = /* @__PURE__ */ function() {
                function Et() {
                  b(this, Et);
                }
                return w(Et, [{
                  key: "encode",
                  value: function() {
                    throw new Error("Must be implemented by subclasses");
                  }
                }, {
                  key: "widthOfString",
                  value: function() {
                    throw new Error("Must be implemented by subclasses");
                  }
                }, {
                  key: "ref",
                  value: function() {
                    return this.dictionary != null ? this.dictionary : this.dictionary = this.document.ref();
                  }
                }, {
                  key: "finalize",
                  value: function() {
                    if (!(this.embedded || this.dictionary == null))
                      return this.embed(), this.embedded = !0;
                  }
                }, {
                  key: "embed",
                  value: function() {
                    throw new Error("Must be implemented by subclasses");
                  }
                }, {
                  key: "lineHeight",
                  value: function(U, tt) {
                    tt == null && (tt = !1);
                    var K = tt ? this.lineGap : 0;
                    return (this.ascender + K - this.descender) / 1e3 * U;
                  }
                }]), Et;
              }(), Ce = {
                Courier: function() {
                  return y.readFileSync(s + "/data/Courier.afm", "utf8");
                },
                "Courier-Bold": function() {
                  return y.readFileSync(s + "/data/Courier-Bold.afm", "utf8");
                },
                "Courier-Oblique": function() {
                  return y.readFileSync(s + "/data/Courier-Oblique.afm", "utf8");
                },
                "Courier-BoldOblique": function() {
                  return y.readFileSync(s + "/data/Courier-BoldOblique.afm", "utf8");
                },
                Helvetica: function() {
                  return y.readFileSync(s + "/data/Helvetica.afm", "utf8");
                },
                "Helvetica-Bold": function() {
                  return y.readFileSync(s + "/data/Helvetica-Bold.afm", "utf8");
                },
                "Helvetica-Oblique": function() {
                  return y.readFileSync(s + "/data/Helvetica-Oblique.afm", "utf8");
                },
                "Helvetica-BoldOblique": function() {
                  return y.readFileSync(s + "/data/Helvetica-BoldOblique.afm", "utf8");
                },
                "Times-Roman": function() {
                  return y.readFileSync(s + "/data/Times-Roman.afm", "utf8");
                },
                "Times-Bold": function() {
                  return y.readFileSync(s + "/data/Times-Bold.afm", "utf8");
                },
                "Times-Italic": function() {
                  return y.readFileSync(s + "/data/Times-Italic.afm", "utf8");
                },
                "Times-BoldItalic": function() {
                  return y.readFileSync(s + "/data/Times-BoldItalic.afm", "utf8");
                },
                Symbol: function() {
                  return y.readFileSync(s + "/data/Symbol.afm", "utf8");
                },
                ZapfDingbats: function() {
                  return y.readFileSync(s + "/data/ZapfDingbats.afm", "utf8");
                }
              }, ze = /* @__PURE__ */ function(Et) {
                C(U, Et);
                var _ = M(U);
                function U(tt, K, mt) {
                  var At;
                  b(this, U), At = _.call(this), At.document = tt, At.name = K, At.id = mt, At.font = new fe(Ce[At.name]());
                  var ee = At.font;
                  return At.ascender = ee.ascender, At.descender = ee.descender, At.bbox = ee.bbox, At.lineGap = ee.lineGap, At.xHeight = ee.xHeight, At.capHeight = ee.capHeight, At;
                }
                return w(U, [{
                  key: "embed",
                  value: function() {
                    return this.dictionary.data = {
                      Type: "Font",
                      BaseFont: this.name,
                      Subtype: "Type1",
                      Encoding: "WinAnsiEncoding"
                    }, this.dictionary.end();
                  }
                }, {
                  key: "encode",
                  value: function(K) {
                    for (var mt = this.font.encodeText(K), At = this.font.glyphsForString("".concat(K)), ee = this.font.advancesForGlyphs(At), ae = [], ye = 0; ye < At.length; ye++) {
                      var Ae = At[ye];
                      ae.push({
                        xAdvance: ee[ye],
                        yAdvance: 0,
                        xOffset: 0,
                        yOffset: 0,
                        advanceWidth: this.font.widthOfGlyph(Ae)
                      });
                    }
                    return [mt, ae];
                  }
                }, {
                  key: "widthOfString",
                  value: function(K, mt) {
                    var At = this.font.glyphsForString("".concat(K)), ee = this.font.advancesForGlyphs(At), ae = 0, ye = bt(ee), Ae;
                    try {
                      for (ye.s(); !(Ae = ye.n()).done; ) {
                        var Oe = Ae.value;
                        ae += Oe;
                      }
                    } catch (Ne) {
                      ye.e(Ne);
                    } finally {
                      ye.f();
                    }
                    var Ie = mt / 1e3;
                    return ae * Ie;
                  }
                }], [{
                  key: "isStandardFont",
                  value: function(K) {
                    return K in Ce;
                  }
                }]), U;
              }(Qt), He = function(_) {
                return "0000".concat(_.toString(16)).slice(-4);
              }, Je = /* @__PURE__ */ function(Et) {
                C(U, Et);
                var _ = M(U);
                function U(tt, K, mt) {
                  var At;
                  return b(this, U), At = _.call(this), At.document = tt, At.font = K, At.id = mt, At.subset = At.font.createSubset(), At.unicode = [[0]], At.widths = [At.font.getGlyph(0).advanceWidth], At.name = At.font.postscriptName, At.scale = 1e3 / At.font.unitsPerEm, At.ascender = At.font.ascent * At.scale, At.descender = At.font.descent * At.scale, At.xHeight = At.font.xHeight * At.scale, At.capHeight = At.font.capHeight * At.scale, At.lineGap = At.font.lineGap * At.scale, At.bbox = At.font.bbox, tt.options.fontLayoutCache !== !1 && (At.layoutCache = /* @__PURE__ */ Object.create(null)), At;
                }
                return w(U, [{
                  key: "layoutRun",
                  value: function(K, mt) {
                    for (var At = this.font.layout(K, mt), ee = 0; ee < At.positions.length; ee++) {
                      var ae = At.positions[ee];
                      for (var ye in ae)
                        ae[ye] *= this.scale;
                      ae.advanceWidth = At.glyphs[ee].advanceWidth * this.scale;
                    }
                    return At;
                  }
                }, {
                  key: "layoutCached",
                  value: function(K) {
                    if (!this.layoutCache)
                      return this.layoutRun(K);
                    var mt;
                    if (mt = this.layoutCache[K])
                      return mt;
                    var At = this.layoutRun(K);
                    return this.layoutCache[K] = At, At;
                  }
                }, {
                  key: "layout",
                  value: function(K, mt, At) {
                    if (mt)
                      return this.layoutRun(K, mt);
                    for (var ee = At ? null : [], ae = At ? null : [], ye = 0, Ae = 0, Oe = 0; Oe <= K.length; ) {
                      var Ie;
                      if (Oe === K.length && Ae < Oe || (Ie = K.charAt(Oe), [" ", "	"].includes(Ie))) {
                        var Ne = this.layoutCached(K.slice(Ae, ++Oe));
                        At || (ee = ee.concat(Ne.glyphs), ae = ae.concat(Ne.positions)), ye += Ne.advanceWidth, Ae = Oe;
                      } else
                        Oe++;
                    }
                    return {
                      glyphs: ee,
                      positions: ae,
                      advanceWidth: ye
                    };
                  }
                }, {
                  key: "encode",
                  value: function(K, mt) {
                    for (var At = this.layout(K, mt), ee = At.glyphs, ae = At.positions, ye = [], Ae = 0; Ae < ee.length; Ae++) {
                      var Oe = ee[Ae], Ie = this.subset.includeGlyph(Oe.id);
                      ye.push("0000".concat(Ie.toString(16)).slice(-4)), this.widths[Ie] == null && (this.widths[Ie] = Oe.advanceWidth * this.scale), this.unicode[Ie] == null && (this.unicode[Ie] = Oe.codePoints);
                    }
                    return [ye, ae];
                  }
                }, {
                  key: "widthOfString",
                  value: function(K, mt, At) {
                    var ee = this.layout(K, At, !0).advanceWidth, ae = mt / 1e3;
                    return ee * ae;
                  }
                }, {
                  key: "embed",
                  value: function() {
                    var K = this, mt = this.subset.cff != null, At = this.document.ref();
                    mt && (At.data.Subtype = "CIDFontType0C"), this.subset.encodeStream().on("data", function(N) {
                      return At.write(N);
                    }).on("end", function() {
                      return At.end();
                    });
                    var ee = ((this.font["OS/2"] != null ? this.font["OS/2"].sFamilyClass : void 0) || 0) >> 8, ae = 0;
                    this.font.post.isFixedPitch && (ae |= 1), 1 <= ee && ee <= 7 && (ae |= 2), ae |= 4, ee === 10 && (ae |= 8), this.font.head.macStyle.italic && (ae |= 64);
                    var ye = [1, 2, 3, 4, 5, 6].map(function(N) {
                      return String.fromCharCode((K.id.charCodeAt(N) || 73) + 17);
                    }).join(""), Ae = ye + "+" + this.font.postscriptName, Oe = this.font.bbox, Ie = this.document.ref({
                      Type: "FontDescriptor",
                      FontName: Ae,
                      Flags: ae,
                      FontBBox: [Oe.minX * this.scale, Oe.minY * this.scale, Oe.maxX * this.scale, Oe.maxY * this.scale],
                      ItalicAngle: this.font.italicAngle,
                      Ascent: this.ascender,
                      Descent: this.descender,
                      CapHeight: (this.font.capHeight || this.font.ascent) * this.scale,
                      XHeight: (this.font.xHeight || 0) * this.scale,
                      StemV: 0
                    });
                    if (mt ? Ie.data.FontFile3 = At : Ie.data.FontFile2 = At, this.document.subset) {
                      var Ne = i.from("FFFFFFFFC0", "hex"), Qe = this.document.ref();
                      Qe.write(Ne), Qe.end(), Ie.data.CIDSet = Qe;
                    }
                    Ie.end();
                    var rr = {
                      Type: "Font",
                      Subtype: "CIDFontType0",
                      BaseFont: Ae,
                      CIDSystemInfo: {
                        Registry: new String("Adobe"),
                        Ordering: new String("Identity"),
                        Supplement: 0
                      },
                      FontDescriptor: Ie,
                      W: [0, this.widths]
                    };
                    mt || (rr.Subtype = "CIDFontType2", rr.CIDToGIDMap = "Identity");
                    var cr = this.document.ref(rr);
                    return cr.end(), this.dictionary.data = {
                      Type: "Font",
                      Subtype: "Type0",
                      BaseFont: Ae,
                      Encoding: "Identity-H",
                      DescendantFonts: [cr],
                      ToUnicode: this.toUnicodeCmap()
                    }, this.dictionary.end();
                  }
                  // Maps the glyph ids encoded in the PDF back to unicode strings
                  // Because of ligature substitutions and the like, there may be one or more
                  // unicode characters represented by each glyph.
                }, {
                  key: "toUnicodeCmap",
                  value: function() {
                    var K = this.document.ref(), mt = [], At = bt(this.unicode), ee;
                    try {
                      for (At.s(); !(ee = At.n()).done; ) {
                        var ae = ee.value, ye = [], Ae = bt(ae), Oe;
                        try {
                          for (Ae.s(); !(Oe = Ae.n()).done; ) {
                            var Ie = Oe.value;
                            Ie > 65535 && (Ie -= 65536, ye.push(He(Ie >>> 10 & 1023 | 55296)), Ie = 56320 | Ie & 1023), ye.push(He(Ie));
                          }
                        } catch (Ne) {
                          Ae.e(Ne);
                        } finally {
                          Ae.f();
                        }
                        mt.push("<".concat(ye.join(" "), ">"));
                      }
                    } catch (Ne) {
                      At.e(Ne);
                    } finally {
                      At.f();
                    }
                    return K.end(`/CIDInit /ProcSet findresource begin
12 dict begin
begincmap
/CIDSystemInfo <<
  /Registry (Adobe)
  /Ordering (UCS)
  /Supplement 0
>> def
/CMapName /Adobe-Identity-UCS def
/CMapType 2 def
1 begincodespacerange
<0000><ffff>
endcodespacerange
1 beginbfrange
<0000> <`.concat(He(mt.length - 1), "> [").concat(mt.join(" "), `]
endbfrange
endcmap
CMapName currentdict /CMap defineresource pop
end
end`)), K;
                  }
                }]), U;
              }(Qt), ar = /* @__PURE__ */ function() {
                function Et() {
                  b(this, Et);
                }
                return w(Et, null, [{
                  key: "open",
                  value: function(U, tt, K, mt) {
                    var At;
                    if (typeof tt == "string") {
                      if (ze.isStandardFont(tt))
                        return new ze(U, tt, mt);
                      tt = y.readFileSync(tt);
                    }
                    if (i.isBuffer(tt) ? At = p.default.create(tt, K) : tt instanceof Uint8Array ? At = p.default.create(i.from(tt), K) : tt instanceof ArrayBuffer && (At = p.default.create(i.from(new Uint8Array(tt)), K)), At == null)
                      throw new Error("Not a supported font format or standard PDF font.");
                    return new Je(U, At, mt);
                  }
                }]), Et;
              }(), mr = {
                initFonts: function() {
                  var _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Helvetica";
                  this._fontFamilies = {}, this._fontCount = 0, this._fontSize = 12, this._font = null, this._registeredFonts = {}, _ && this.font(_);
                },
                font: function(_, U, tt) {
                  var K, mt;
                  if (typeof U == "number" && (tt = U, U = null), typeof _ == "string" && this._registeredFonts[_]) {
                    K = _;
                    var At = this._registeredFonts[_];
                    _ = At.src, U = At.family;
                  } else
                    K = U || _, typeof K != "string" && (K = null);
                  if (tt != null && this.fontSize(tt), mt = this._fontFamilies[K])
                    return this._font = mt, this;
                  var ee = "F".concat(++this._fontCount);
                  return this._font = ar.open(this, _, U, ee), (mt = this._fontFamilies[this._font.name]) ? (this._font = mt, this) : (K && (this._fontFamilies[K] = this._font), this._font.name && (this._fontFamilies[this._font.name] = this._font), this);
                },
                fontSize: function(_) {
                  return this._fontSize = _, this;
                },
                currentLineHeight: function(_) {
                  return _ == null && (_ = !1), this._font.lineHeight(this._fontSize, _);
                },
                registerFont: function(_, U, tt) {
                  return this._registeredFonts[_] = {
                    src: U,
                    family: tt
                  }, this;
                }
              }, we = /* @__PURE__ */ function(Et) {
                C(U, Et);
                var _ = M(U);
                function U(tt, K) {
                  var mt;
                  return b(this, U), mt = _.call(this), mt.document = tt, mt.indent = K.indent || 0, mt.characterSpacing = K.characterSpacing || 0, mt.wordSpacing = K.wordSpacing === 0, mt.columns = K.columns || 1, mt.columnGap = K.columnGap != null ? K.columnGap : 18, mt.lineWidth = (K.width - mt.columnGap * (mt.columns - 1)) / mt.columns, mt.spaceLeft = mt.lineWidth, mt.startX = mt.document.x, mt.startY = mt.document.y, mt.column = 1, mt.ellipsis = K.ellipsis, mt.continuedX = 0, mt.features = K.features, K.height != null ? (mt.height = K.height, mt.maxY = mt.startY + K.height) : mt.maxY = mt.document.page.maxY(), mt.on("firstLine", function(At) {
                    var ee = mt.continuedX || mt.indent;
                    return mt.document.x += ee, mt.lineWidth -= ee, mt.once("line", function() {
                      if (mt.document.x -= ee, mt.lineWidth += ee, At.continued && !mt.continuedX && (mt.continuedX = mt.indent), !At.continued)
                        return mt.continuedX = 0;
                    });
                  }), mt.on("lastLine", function(At) {
                    var ee = At.align;
                    return ee === "justify" && (At.align = "left"), mt.lastLine = !0, mt.once("line", function() {
                      return mt.document.y += At.paragraphGap || 0, At.align = ee, mt.lastLine = !1;
                    });
                  }), mt;
                }
                return w(U, [{
                  key: "wordWidth",
                  value: function(K) {
                    return this.document.widthOfString(K, this) + this.characterSpacing + this.wordSpacing;
                  }
                }, {
                  key: "eachWord",
                  value: function(K, mt) {
                    for (var At, ee = new x.default(K), ae = null, ye = /* @__PURE__ */ Object.create(null); At = ee.nextBreak(); ) {
                      var Ae, Oe = K.slice((ae != null ? ae.position : void 0) || 0, At.position), Ie = ye[Oe] != null ? ye[Oe] : ye[Oe] = this.wordWidth(Oe);
                      if (Ie > this.lineWidth + this.continuedX)
                        for (var Ne = ae, Qe = {}; Oe.length; ) {
                          var rr, cr;
                          Ie > this.spaceLeft ? (rr = Math.ceil(this.spaceLeft / (Ie / Oe.length)), Ie = this.wordWidth(Oe.slice(0, rr)), cr = Ie <= this.spaceLeft && rr < Oe.length) : rr = Oe.length;
                          for (var N = Ie > this.spaceLeft && rr > 0; N || cr; )
                            N ? (Ie = this.wordWidth(Oe.slice(0, --rr)), N = Ie > this.spaceLeft && rr > 0) : (Ie = this.wordWidth(Oe.slice(0, ++rr)), N = Ie > this.spaceLeft && rr > 0, cr = Ie <= this.spaceLeft && rr < Oe.length);
                          if (rr === 0 && this.spaceLeft === this.lineWidth && (rr = 1), Qe.required = At.required || rr < Oe.length, Ae = mt(Oe.slice(0, rr), Ie, Qe, Ne), Ne = {
                            required: !1
                          }, Oe = Oe.slice(rr), Ie = this.wordWidth(Oe), Ae === !1)
                            break;
                        }
                      else
                        Ae = mt(Oe, Ie, At, ae);
                      if (Ae === !1)
                        break;
                      ae = At;
                    }
                  }
                }, {
                  key: "wrap",
                  value: function(K, mt) {
                    var At = this;
                    mt.indent != null && (this.indent = mt.indent), mt.characterSpacing != null && (this.characterSpacing = mt.characterSpacing), mt.wordSpacing != null && (this.wordSpacing = mt.wordSpacing), mt.ellipsis != null && (this.ellipsis = mt.ellipsis);
                    var ee = this.document.y + this.document.currentLineHeight(!0);
                    (this.document.y > this.maxY || ee > this.maxY) && this.nextSection();
                    var ae = "", ye = 0, Ae = 0, Oe = 0, Ie = this.document.y, Ne = function() {
                      return mt.textWidth = ye + At.wordSpacing * (Ae - 1), mt.wordCount = Ae, mt.lineWidth = At.lineWidth, Ie = At.document.y, At.emit("line", ae, mt, At), Oe++;
                    };
                    return this.emit("sectionStart", mt, this), this.eachWord(K, function(Qe, rr, cr, N) {
                      if ((N == null || N.required) && (At.emit("firstLine", mt, At), At.spaceLeft = At.lineWidth), rr <= At.spaceLeft && (ae += Qe, ye += rr, Ae++), cr.required || rr > At.spaceLeft) {
                        var q = At.document.currentLineHeight(!0);
                        if (At.height != null && At.ellipsis && At.document.y + q * 2 > At.maxY && At.column >= At.columns) {
                          for (At.ellipsis === !0 && (At.ellipsis = "…"), ae = ae.replace(/\s+$/, ""), ye = At.wordWidth(ae + At.ellipsis); ae && ye > At.lineWidth; )
                            ae = ae.slice(0, -1).replace(/\s+$/, ""), ye = At.wordWidth(ae + At.ellipsis);
                          ye <= At.lineWidth && (ae = ae + At.ellipsis), ye = At.wordWidth(ae);
                        }
                        if (cr.required && (rr > At.spaceLeft && (Ne(), ae = Qe, ye = rr, Ae = 1), At.emit("lastLine", mt, At)), Ne(), At.document.y + q > At.maxY) {
                          var pt = At.nextSection();
                          if (!pt)
                            return Ae = 0, ae = "", !1;
                        }
                        return cr.required ? (At.spaceLeft = At.lineWidth, ae = "", ye = 0, Ae = 0) : (At.spaceLeft = At.lineWidth - rr, ae = Qe, ye = rr, Ae = 1);
                      } else
                        return At.spaceLeft -= rr;
                    }), Ae > 0 && (this.emit("lastLine", mt, this), Ne()), this.emit("sectionEnd", mt, this), mt.continued === !0 ? (Oe > 1 && (this.continuedX = 0), this.continuedX += mt.textWidth || 0, this.document.y = Ie) : this.document.x = this.startX;
                  }
                }, {
                  key: "nextSection",
                  value: function(K) {
                    if (this.emit("sectionEnd", K, this), ++this.column > this.columns) {
                      if (this.height != null)
                        return !1;
                      if (this.document.continueOnNewPage(), this.column = 1, this.startY = this.document.page.margins.top, this.maxY = this.document.page.maxY(), this.document.x = this.startX, this.document._fillColor) {
                        var mt;
                        (mt = this.document).fillColor.apply(mt, L(this.document._fillColor));
                      }
                      this.emit("pageBreak", K, this);
                    } else
                      this.document.x += this.lineWidth + this.columnGap, this.document.y = this.startY, this.emit("columnBreak", K, this);
                    return this.emit("sectionStart", K, this), !0;
                  }
                }]), U;
              }(m.EventEmitter), We = Ft.number, fr = {
                initText: function() {
                  return this._line = this._line.bind(this), this.x = 0, this.y = 0, this._lineGap = 0;
                },
                lineGap: function(_) {
                  return this._lineGap = _, this;
                },
                moveDown: function(_) {
                  return _ == null && (_ = 1), this.y += this.currentLineHeight(!0) * _ + this._lineGap, this;
                },
                moveUp: function(_) {
                  return _ == null && (_ = 1), this.y -= this.currentLineHeight(!0) * _ + this._lineGap, this;
                },
                _text: function(_, U, tt, K, mt) {
                  var At = this;
                  K = this._initOptions(U, tt, K), _ = _ == null ? "" : "".concat(_), K.wordSpacing && (_ = _.replace(/\s{2,}/g, " "));
                  var ee = function() {
                    K.structParent && K.structParent.add(At.struct(K.structType || "P", [At.markStructureContent(K.structType || "P")]));
                  };
                  if (K.width) {
                    var ae = this._wrapper;
                    ae || (ae = new we(this, K), ae.on("line", mt), ae.on("firstLine", ee)), this._wrapper = K.continued ? ae : null, this._textOptions = K.continued ? K : null, ae.wrap(_, K);
                  } else {
                    var ye = bt(_.split(`
`)), Ae;
                    try {
                      for (ye.s(); !(Ae = ye.n()).done; ) {
                        var Oe = Ae.value;
                        ee(), mt(Oe, K);
                      }
                    } catch (Ie) {
                      ye.e(Ie);
                    } finally {
                      ye.f();
                    }
                  }
                  return this;
                },
                text: function(_, U, tt, K) {
                  return this._text(_, U, tt, K, this._line);
                },
                widthOfString: function(_) {
                  var U = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                  return this._font.widthOfString(_, this._fontSize, U.features) + (U.characterSpacing || 0) * (_.length - 1);
                },
                heightOfString: function(_, U) {
                  var tt = this, K = this.x, mt = this.y;
                  U = this._initOptions(U), U.height = 1 / 0;
                  var At = U.lineGap || this._lineGap || 0;
                  this._text(_, this.x, this.y, U, function() {
                    return tt.y += tt.currentLineHeight(!0) + At;
                  });
                  var ee = this.y - mt;
                  return this.x = K, this.y = mt, ee;
                },
                list: function(_, U, tt, K, mt) {
                  var At = this;
                  K = this._initOptions(U, tt, K);
                  var ee = K.listType || "bullet", ae = Math.round(this._font.ascender / 1e3 * this._fontSize), ye = ae / 2, Ae = K.bulletRadius || ae / 3, Oe = K.textIndent || (ee === "bullet" ? Ae * 5 : ae * 2), Ie = K.bulletIndent || (ee === "bullet" ? Ae * 8 : ae * 2), Ne = 1, Qe = [], rr = [], cr = [], N = function Ot(Wt) {
                    for (var le = 1, ce = 0; ce < Wt.length; ce++) {
                      var be = Wt[ce];
                      Array.isArray(be) ? (Ne++, Ot(be), Ne--) : (Qe.push(be), rr.push(Ne), ee !== "bullet" && cr.push(le++));
                    }
                  };
                  N(_);
                  var q = function(Wt) {
                    switch (ee) {
                      case "numbered":
                        return "".concat(Wt, ".");
                      case "lettered":
                        var le = String.fromCharCode((Wt - 1) % 26 + 65), ce = Math.floor((Wt - 1) / 26 + 1), be = Array(ce + 1).join(le);
                        return "".concat(be, ".");
                    }
                  };
                  mt = new we(this, K), mt.on("line", this._line), Ne = 1;
                  var pt = 0;
                  return mt.on("firstLine", function() {
                    var Ot, Wt, le, ce;
                    if (K.structParent)
                      if (K.structTypes) {
                        var be = z(K.structTypes, 3);
                        Wt = be[0], le = be[1], ce = be[2];
                      } else
                        Wt = "LI", le = "Lbl", ce = "LBody";
                    Wt ? (Ot = At.struct(Wt), K.structParent.add(Ot)) : K.structParent && (Ot = K.structParent);
                    var Ge;
                    if ((Ge = rr[pt++]) !== Ne) {
                      var er = Ie * (Ge - Ne);
                      At.x += er, mt.lineWidth -= er, Ne = Ge;
                    }
                    switch (Ot && (le || ce) && Ot.add(At.struct(le || ce, [At.markStructureContent(le || ce)])), ee) {
                      case "bullet":
                        At.circle(At.x - Oe + Ae, At.y + ye, Ae), At.fill();
                        break;
                      case "numbered":
                      case "lettered":
                        var br = q(cr[pt - 1]);
                        At._fragment(br, At.x - Oe, At.y, K);
                        break;
                    }
                    Ot && le && ce && Ot.add(At.struct(ce, [At.markStructureContent(ce)])), Ot && Ot !== K.structParent && Ot.end();
                  }), mt.on("sectionStart", function() {
                    var Ot = Oe + Ie * (Ne - 1);
                    return At.x += Ot, mt.lineWidth -= Ot;
                  }), mt.on("sectionEnd", function() {
                    var Ot = Oe + Ie * (Ne - 1);
                    return At.x -= Ot, mt.lineWidth += Ot;
                  }), mt.wrap(Qe.join(`
`), K), this;
                },
                _initOptions: function() {
                  var _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, U = arguments.length > 1 ? arguments[1] : void 0, tt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                  typeof _ == "object" && (tt = _, _ = null);
                  var K = Object.assign({}, tt);
                  if (this._textOptions)
                    for (var mt in this._textOptions) {
                      var At = this._textOptions[mt];
                      mt !== "continued" && K[mt] === void 0 && (K[mt] = At);
                    }
                  return _ != null && (this.x = _), U != null && (this.y = U), K.lineBreak !== !1 && (K.width == null && (K.width = this.page.width - this.x - this.page.margins.right), K.width = Math.max(K.width, 0)), K.columns || (K.columns = 0), K.columnGap == null && (K.columnGap = 18), K;
                },
                _line: function(_) {
                  var U = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, tt = arguments.length > 2 ? arguments[2] : void 0;
                  this._fragment(_, this.x, this.y, U);
                  var K = U.lineGap || this._lineGap || 0;
                  return tt ? this.y += this.currentLineHeight(!0) + K : this.x += this.widthOfString(_);
                },
                _fragment: function(_, U, tt, K) {
                  var mt = this, At, ee, ae, ye, Ae, Oe;
                  if (_ = "".concat(_).replace(/\n/g, ""), _.length !== 0) {
                    var Ie = K.align || "left", Ne = K.wordSpacing || 0, Qe = K.characterSpacing || 0;
                    if (K.width)
                      switch (Ie) {
                        case "right":
                          Ae = this.widthOfString(_.replace(/\s+$/, ""), K), U += K.lineWidth - Ae;
                          break;
                        case "center":
                          U += K.lineWidth / 2 - K.textWidth / 2;
                          break;
                        case "justify":
                          Oe = _.trim().split(/\s+/), Ae = this.widthOfString(_.replace(/\s+/g, ""), K);
                          var rr = this.widthOfString(" ") + Qe;
                          Ne = Math.max(0, (K.lineWidth - Ae) / Math.max(1, Oe.length - 1) - rr);
                          break;
                      }
                    if (typeof K.baseline == "number")
                      At = -K.baseline;
                    else {
                      switch (K.baseline) {
                        case "svg-middle":
                          At = 0.5 * this._font.xHeight;
                          break;
                        case "middle":
                        case "svg-central":
                          At = 0.5 * (this._font.descender + this._font.ascender);
                          break;
                        case "bottom":
                        case "ideographic":
                          At = this._font.descender;
                          break;
                        case "alphabetic":
                          At = 0;
                          break;
                        case "mathematical":
                          At = 0.5 * this._font.ascender;
                          break;
                        case "hanging":
                          At = 0.8 * this._font.ascender;
                          break;
                        case "top":
                          At = this._font.ascender;
                          break;
                        default:
                          At = this._font.ascender;
                      }
                      At = At / 1e3 * this._fontSize;
                    }
                    var cr = K.textWidth + Ne * (K.wordCount - 1) + Qe * (_.length - 1);
                    if (K.link != null && this.link(U, tt, cr, this.currentLineHeight(), K.link), K.goTo != null && this.goTo(U, tt, cr, this.currentLineHeight(), K.goTo), K.destination != null && this.addNamedDestination(K.destination, "XYZ", U, tt, null), K.underline) {
                      this.save(), K.stroke || this.strokeColor.apply(this, L(this._fillColor || []));
                      var N = this._fontSize < 10 ? 0.5 : Math.floor(this._fontSize / 10);
                      this.lineWidth(N);
                      var q = tt + this.currentLineHeight() - N;
                      this.moveTo(U, q), this.lineTo(U + cr, q), this.stroke(), this.restore();
                    }
                    if (K.strike) {
                      this.save(), K.stroke || this.strokeColor.apply(this, L(this._fillColor || []));
                      var pt = this._fontSize < 10 ? 0.5 : Math.floor(this._fontSize / 10);
                      this.lineWidth(pt);
                      var Ot = tt + this.currentLineHeight() / 2;
                      this.moveTo(U, Ot), this.lineTo(U + cr, Ot), this.stroke(), this.restore();
                    }
                    if (this.save(), K.oblique) {
                      var Wt;
                      typeof K.oblique == "number" ? Wt = -Math.tan(K.oblique * Math.PI / 180) : Wt = -0.25, this.transform(1, 0, 0, 1, U, tt), this.transform(1, 0, Wt, 1, -Wt * At, 0), this.transform(1, 0, 0, 1, -U, -tt);
                    }
                    this.transform(1, 0, 0, -1, 0, this.page.height), tt = this.page.height - tt - At, this.page.fonts[this._font.id] == null && (this.page.fonts[this._font.id] = this._font.ref()), this.addContent("BT"), this.addContent("1 0 0 1 ".concat(We(U), " ").concat(We(tt), " Tm")), this.addContent("/".concat(this._font.id, " ").concat(We(this._fontSize), " Tf"));
                    var le = K.fill && K.stroke ? 2 : K.stroke ? 1 : 0;
                    if (le && this.addContent("".concat(le, " Tr")), Qe && this.addContent("".concat(We(Qe), " Tc")), Ne) {
                      Oe = _.trim().split(/\s+/), Ne += this.widthOfString(" ") + Qe, Ne *= 1e3 / this._fontSize, ee = [], ye = [];
                      var ce = bt(Oe), be;
                      try {
                        for (ce.s(); !(be = ce.n()).done; ) {
                          var Ge = be.value, er = this._font.encode(Ge, K.features), br = z(er, 2), Nr = br[0], hr = br[1];
                          ee = ee.concat(Nr), ye = ye.concat(hr);
                          var ir = {}, ur = ye[ye.length - 1];
                          for (var rn in ur) {
                            var Pn = ur[rn];
                            ir[rn] = Pn;
                          }
                          ir.xAdvance += Ne, ye[ye.length - 1] = ir;
                        }
                      } catch (Rs) {
                        ce.e(Rs);
                      } finally {
                        ce.f();
                      }
                    } else {
                      var li = this._font.encode(_, K.features), ii = z(li, 2);
                      ee = ii[0], ye = ii[1];
                    }
                    var fi = this._fontSize / 1e3, Vi = [], gi = 0, Hi = !1, Gn = function(pa) {
                      if (gi < pa) {
                        var tu = ee.slice(gi, pa).join(""), eu = ye[pa - 1].xAdvance - ye[pa - 1].advanceWidth;
                        Vi.push("<".concat(tu, "> ").concat(We(-eu)));
                      }
                      return gi = pa;
                    }, Is = function(pa) {
                      if (Gn(pa), Vi.length > 0)
                        return mt.addContent("[".concat(Vi.join(" "), "] TJ")), Vi.length = 0;
                    };
                    for (ae = 0; ae < ye.length; ae++) {
                      var Ki = ye[ae];
                      Ki.xOffset || Ki.yOffset ? (Is(ae), this.addContent("1 0 0 1 ".concat(We(U + Ki.xOffset * fi), " ").concat(We(tt + Ki.yOffset * fi), " Tm")), Is(ae + 1), Hi = !0) : (Hi && (this.addContent("1 0 0 1 ".concat(We(U), " ").concat(We(tt), " Tm")), Hi = !1), Ki.xAdvance - Ki.advanceWidth !== 0 && Gn(ae + 1)), U += Ki.xAdvance * fi;
                    }
                    return Is(ae), this.addContent("ET"), this.restore();
                  }
                }
              }, Ke = [65472, 65473, 65474, 65475, 65477, 65478, 65479, 65480, 65481, 65482, 65483, 65484, 65485, 65486, 65487], pr = {
                1: "DeviceGray",
                3: "DeviceRGB",
                4: "DeviceCMYK"
              }, tr = /* @__PURE__ */ function() {
                function Et(_, U) {
                  b(this, Et);
                  var tt;
                  if (this.data = _, this.label = U, this.data.readUInt16BE(0) !== 65496)
                    throw "SOI not found in JPEG";
                  for (var K = 2; K < this.data.length && (tt = this.data.readUInt16BE(K), K += 2, !Ke.includes(tt)); )
                    K += this.data.readUInt16BE(K);
                  if (!Ke.includes(tt))
                    throw "Invalid JPEG.";
                  K += 2, this.bits = this.data[K++], this.height = this.data.readUInt16BE(K), K += 2, this.width = this.data.readUInt16BE(K), K += 2;
                  var mt = this.data[K++];
                  this.colorSpace = pr[mt], this.obj = null;
                }
                return w(Et, [{
                  key: "embed",
                  value: function(U) {
                    if (!this.obj)
                      return this.obj = U.ref({
                        Type: "XObject",
                        Subtype: "Image",
                        BitsPerComponent: this.bits,
                        Width: this.width,
                        Height: this.height,
                        ColorSpace: this.colorSpace,
                        Filter: "DCTDecode"
                      }), this.colorSpace === "DeviceCMYK" && (this.obj.data.Decode = [1, 0, 1, 0, 1, 0, 1, 0]), this.obj.end(this.data), this.data = null;
                  }
                }]), Et;
              }(), Er = /* @__PURE__ */ function() {
                function Et(_, U) {
                  b(this, Et), this.label = U, this.image = new g.default(_), this.width = this.image.width, this.height = this.image.height, this.imgData = this.image.imgData, this.obj = null;
                }
                return w(Et, [{
                  key: "embed",
                  value: function(U) {
                    var tt = !1;
                    if (this.document = U, !this.obj) {
                      var K = this.image.hasAlphaChannel, mt = this.image.interlaceMethod === 1;
                      if (this.obj = this.document.ref({
                        Type: "XObject",
                        Subtype: "Image",
                        BitsPerComponent: K ? 8 : this.image.bits,
                        Width: this.width,
                        Height: this.height,
                        Filter: "FlateDecode"
                      }), !K) {
                        var At = this.document.ref({
                          Predictor: mt ? 1 : 15,
                          Colors: this.image.colors,
                          BitsPerComponent: this.image.bits,
                          Columns: this.width
                        });
                        this.obj.data.DecodeParms = At, At.end();
                      }
                      if (this.image.palette.length === 0)
                        this.obj.data.ColorSpace = this.image.colorSpace;
                      else {
                        var ee = this.document.ref();
                        ee.end(i.from(this.image.palette)), this.obj.data.ColorSpace = ["Indexed", "DeviceRGB", this.image.palette.length / 3 - 1, ee];
                      }
                      if (this.image.transparency.grayscale != null) {
                        var ae = this.image.transparency.grayscale;
                        this.obj.data.Mask = [ae, ae];
                      } else if (this.image.transparency.rgb) {
                        var ye = this.image.transparency.rgb, Ae = [], Oe = bt(ye), Ie;
                        try {
                          for (Oe.s(); !(Ie = Oe.n()).done; ) {
                            var Ne = Ie.value;
                            Ae.push(Ne, Ne);
                          }
                        } catch (Qe) {
                          Oe.e(Qe);
                        } finally {
                          Oe.f();
                        }
                        this.obj.data.Mask = Ae;
                      } else {
                        if (this.image.transparency.indexed)
                          return tt = !0, this.loadIndexedAlphaChannel();
                        if (K)
                          return tt = !0, this.splitAlphaChannel();
                      }
                      if (mt && !tt)
                        return this.decodeData();
                      this.finalize();
                    }
                  }
                }, {
                  key: "finalize",
                  value: function() {
                    if (this.alphaChannel) {
                      var U = this.document.ref({
                        Type: "XObject",
                        Subtype: "Image",
                        Height: this.height,
                        Width: this.width,
                        BitsPerComponent: 8,
                        Filter: "FlateDecode",
                        ColorSpace: "DeviceGray",
                        Decode: [0, 1]
                      });
                      U.end(this.alphaChannel), this.obj.data.SMask = U;
                    }
                    return this.obj.end(this.imgData), this.image = null, this.imgData = null;
                  }
                }, {
                  key: "splitAlphaChannel",
                  value: function() {
                    var U = this;
                    return this.image.decodePixels(function(tt) {
                      for (var K, mt, At = U.image.colors, ee = U.width * U.height, ae = i.alloc(ee * At), ye = i.alloc(ee), Ae = mt = K = 0, Oe = tt.length, Ie = U.image.bits === 16 ? 1 : 0; Ae < Oe; ) {
                        for (var Ne = 0; Ne < At; Ne++)
                          ae[mt++] = tt[Ae++], Ae += Ie;
                        ye[K++] = tt[Ae++], Ae += Ie;
                      }
                      return U.imgData = h.default.deflateSync(ae), U.alphaChannel = h.default.deflateSync(ye), U.finalize();
                    });
                  }
                }, {
                  key: "loadIndexedAlphaChannel",
                  value: function() {
                    var U = this, tt = this.image.transparency.indexed;
                    return this.image.decodePixels(function(K) {
                      for (var mt = i.alloc(U.width * U.height), At = 0, ee = 0, ae = K.length; ee < ae; ee++)
                        mt[At++] = tt[K[ee]];
                      return U.alphaChannel = h.default.deflateSync(mt), U.finalize();
                    });
                  }
                }, {
                  key: "decodeData",
                  value: function() {
                    var U = this;
                    this.image.decodePixels(function(tt) {
                      U.imgData = h.default.deflateSync(tt), U.finalize();
                    });
                  }
                }]), Et;
              }(), xr = /* @__PURE__ */ function() {
                function Et() {
                  b(this, Et);
                }
                return w(Et, null, [{
                  key: "open",
                  value: function(U, tt) {
                    var K;
                    if (i.isBuffer(U))
                      K = U;
                    else if (U instanceof ArrayBuffer)
                      K = i.from(new Uint8Array(U));
                    else {
                      var mt;
                      if (mt = /^data:.+;base64,(.*)$/.exec(U))
                        K = i.from(mt[1], "base64");
                      else if (K = y.readFileSync(U), !K)
                        return;
                    }
                    if (K[0] === 255 && K[1] === 216)
                      return new tr(K, tt);
                    if (K[0] === 137 && K.toString("ascii", 1, 4) === "PNG")
                      return new Er(K, tt);
                    throw new Error("Unknown image format.");
                  }
                }]), Et;
              }(), Gr = {
                initImages: function() {
                  return this._imageRegistry = {}, this._imageCount = 0;
                },
                image: function(_, U, tt) {
                  var K = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, mt, At, ee, ae, ye, Ae, Oe;
                  typeof U == "object" && (K = U, U = null), U = (Ae = U ?? K.x) != null ? Ae : this.x, tt = (Oe = tt ?? K.y) != null ? Oe : this.y, typeof _ == "string" && (ae = this._imageRegistry[_]), ae || (_.width && _.height ? ae = _ : ae = this.openImage(_)), ae.obj || ae.embed(this), this.page.xobjects[ae.label] == null && (this.page.xobjects[ae.label] = ae.obj);
                  var Ie = K.width || ae.width, Ne = K.height || ae.height;
                  if (K.width && !K.height) {
                    var Qe = Ie / ae.width;
                    Ie = ae.width * Qe, Ne = ae.height * Qe;
                  } else if (K.height && !K.width) {
                    var rr = Ne / ae.height;
                    Ie = ae.width * rr, Ne = ae.height * rr;
                  } else if (K.scale)
                    Ie = ae.width * K.scale, Ne = ae.height * K.scale;
                  else if (K.fit) {
                    var cr = z(K.fit, 2);
                    ee = cr[0], mt = cr[1], At = ee / mt, ye = ae.width / ae.height, ye > At ? (Ie = ee, Ne = ee / ye) : (Ne = mt, Ie = mt * ye);
                  } else if (K.cover) {
                    var N = z(K.cover, 2);
                    ee = N[0], mt = N[1], At = ee / mt, ye = ae.width / ae.height, ye > At ? (Ne = mt, Ie = mt * ye) : (Ie = ee, Ne = ee / ye);
                  }
                  return (K.fit || K.cover) && (K.align === "center" ? U = U + ee / 2 - Ie / 2 : K.align === "right" && (U = U + ee - Ie), K.valign === "center" ? tt = tt + mt / 2 - Ne / 2 : K.valign === "bottom" && (tt = tt + mt - Ne)), K.link != null && this.link(U, tt, Ie, Ne, K.link), K.goTo != null && this.goTo(U, tt, Ie, Ne, K.goTo), K.destination != null && this.addNamedDestination(K.destination, "XYZ", U, tt, null), this.y === tt && (this.y += Ne), this.save(), this.transform(Ie, 0, 0, -Ne, U, tt + Ne), this.addContent("/".concat(ae.label, " Do")), this.restore(), this;
                },
                openImage: function(_) {
                  var U;
                  return typeof _ == "string" && (U = this._imageRegistry[_]), U || (U = xr.open(_, "I".concat(++this._imageCount)), typeof _ == "string" && (this._imageRegistry[_] = U)), U;
                }
              }, tn = {
                annotate: function(_, U, tt, K, mt) {
                  mt.Type = "Annot", mt.Rect = this._convertRect(_, U, tt, K), mt.Border = [0, 0, 0], mt.Subtype === "Link" && typeof mt.F > "u" && (mt.F = 4), mt.Subtype !== "Link" && mt.C == null && (mt.C = this._normalizeColor(mt.color || [0, 0, 0])), delete mt.color, typeof mt.Dest == "string" && (mt.Dest = new String(mt.Dest));
                  for (var At in mt) {
                    var ee = mt[At];
                    mt[At[0].toUpperCase() + At.slice(1)] = ee;
                  }
                  var ae = this.ref(mt);
                  return this.page.annotations.push(ae), ae.end(), this;
                },
                note: function(_, U, tt, K, mt) {
                  var At = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
                  return At.Subtype = "Text", At.Contents = new String(mt), At.Name = "Comment", At.color == null && (At.color = [243, 223, 92]), this.annotate(_, U, tt, K, At);
                },
                goTo: function(_, U, tt, K, mt) {
                  var At = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
                  return At.Subtype = "Link", At.A = this.ref({
                    S: "GoTo",
                    D: new String(mt)
                  }), At.A.end(), this.annotate(_, U, tt, K, At);
                },
                link: function(_, U, tt, K, mt) {
                  var At = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
                  if (At.Subtype = "Link", typeof mt == "number") {
                    var ee = this._root.data.Pages.data;
                    if (mt >= 0 && mt < ee.Kids.length)
                      At.A = this.ref({
                        S: "GoTo",
                        D: [ee.Kids[mt], "XYZ", null, null, null]
                      }), At.A.end();
                    else
                      throw new Error("The document has no page ".concat(mt));
                  } else
                    At.A = this.ref({
                      S: "URI",
                      URI: new String(mt)
                    }), At.A.end();
                  return this.annotate(_, U, tt, K, At);
                },
                _markup: function(_, U, tt, K) {
                  var mt = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {}, At = this._convertRect(_, U, tt, K), ee = z(At, 4), ae = ee[0], ye = ee[1], Ae = ee[2], Oe = ee[3];
                  return mt.QuadPoints = [ae, Oe, Ae, Oe, ae, ye, Ae, ye], mt.Contents = new String(), this.annotate(_, U, tt, K, mt);
                },
                highlight: function(_, U, tt, K) {
                  var mt = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
                  return mt.Subtype = "Highlight", mt.color == null && (mt.color = [241, 238, 148]), this._markup(_, U, tt, K, mt);
                },
                underline: function(_, U, tt, K) {
                  var mt = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
                  return mt.Subtype = "Underline", this._markup(_, U, tt, K, mt);
                },
                strike: function(_, U, tt, K) {
                  var mt = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
                  return mt.Subtype = "StrikeOut", this._markup(_, U, tt, K, mt);
                },
                lineAnnotation: function(_, U, tt, K) {
                  var mt = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
                  return mt.Subtype = "Line", mt.Contents = new String(), mt.L = [_, this.page.height - U, tt, this.page.height - K], this.annotate(_, U, tt, K, mt);
                },
                rectAnnotation: function(_, U, tt, K) {
                  var mt = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
                  return mt.Subtype = "Square", mt.Contents = new String(), this.annotate(_, U, tt, K, mt);
                },
                ellipseAnnotation: function(_, U, tt, K) {
                  var mt = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
                  return mt.Subtype = "Circle", mt.Contents = new String(), this.annotate(_, U, tt, K, mt);
                },
                textAnnotation: function(_, U, tt, K, mt) {
                  var At = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
                  return At.Subtype = "FreeText", At.Contents = new String(mt), At.DA = new String(), this.annotate(_, U, tt, K, At);
                },
                fileAnnotation: function(_, U, tt, K) {
                  var mt = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {}, At = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, ee = this.file(mt.src, Object.assign({
                    hidden: !0
                  }, mt));
                  return At.Subtype = "FileAttachment", At.FS = ee, At.Contents ? At.Contents = new String(At.Contents) : ee.data.Desc && (At.Contents = ee.data.Desc), this.annotate(_, U, tt, K, At);
                },
                _convertRect: function(_, U, tt, K) {
                  var mt = U;
                  U += K;
                  var At = _ + tt, ee = z(this._ctm, 6), ae = ee[0], ye = ee[1], Ae = ee[2], Oe = ee[3], Ie = ee[4], Ne = ee[5];
                  return _ = ae * _ + Ae * U + Ie, U = ye * _ + Oe * U + Ne, At = ae * At + Ae * mt + Ie, mt = ye * At + Oe * mt + Ne, [_, U, At, mt];
                }
              }, Qr = /* @__PURE__ */ function() {
                function Et(_, U, tt, K) {
                  var mt = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
                    expanded: !1
                  };
                  b(this, Et), this.document = _, this.options = mt, this.outlineData = {}, K !== null && (this.outlineData.Dest = [K.dictionary, "Fit"]), U !== null && (this.outlineData.Parent = U), tt !== null && (this.outlineData.Title = new String(tt)), this.dictionary = this.document.ref(this.outlineData), this.children = [];
                }
                return w(Et, [{
                  key: "addItem",
                  value: function(U) {
                    var tt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
                      expanded: !1
                    }, K = new Et(this.document, this.dictionary, U, this.document.page, tt);
                    return this.children.push(K), K;
                  }
                }, {
                  key: "endOutline",
                  value: function() {
                    if (this.children.length > 0) {
                      this.options.expanded && (this.outlineData.Count = this.children.length);
                      var U = this.children[0], tt = this.children[this.children.length - 1];
                      this.outlineData.First = U.dictionary, this.outlineData.Last = tt.dictionary;
                      for (var K = 0, mt = this.children.length; K < mt; K++) {
                        var At = this.children[K];
                        K > 0 && (At.outlineData.Prev = this.children[K - 1].dictionary), K < this.children.length - 1 && (At.outlineData.Next = this.children[K + 1].dictionary), At.endOutline();
                      }
                    }
                    return this.dictionary.end();
                  }
                }]), Et;
              }(), _r = {
                initOutline: function() {
                  return this.outline = new Qr(this, null, null, null);
                },
                endOutline: function() {
                  if (this.outline.endOutline(), this.outline.children.length > 0)
                    return this._root.data.Outlines = this.outline.dictionary, this._root.data.PageMode = "UseOutlines";
                }
              }, Yr = /* @__PURE__ */ function() {
                function Et(_, U) {
                  b(this, Et), this.refs = [{
                    pageRef: _,
                    mcid: U
                  }];
                }
                return w(Et, [{
                  key: "push",
                  value: function(U) {
                    var tt = this;
                    U.refs.forEach(function(K) {
                      return tt.refs.push(K);
                    });
                  }
                }]), Et;
              }(), Rr = /* @__PURE__ */ function() {
                function Et(_, U) {
                  var tt = this, K = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, mt = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
                  b(this, Et), this.document = _, this._attached = !1, this._ended = !1, this._flushed = !1, this.dictionary = _.ref({
                    // Type: "StructElem",
                    S: U
                  });
                  var At = this.dictionary.data;
                  (Array.isArray(K) || this._isValidChild(K)) && (mt = K, K = {}), typeof K.title < "u" && (At.T = new String(K.title)), typeof K.lang < "u" && (At.Lang = new String(K.lang)), typeof K.alt < "u" && (At.Alt = new String(K.alt)), typeof K.expanded < "u" && (At.E = new String(K.expanded)), typeof K.actual < "u" && (At.ActualText = new String(K.actual)), this._children = [], mt && (Array.isArray(mt) || (mt = [mt]), mt.forEach(function(ee) {
                    return tt.add(ee);
                  }), this.end());
                }
                return w(Et, [{
                  key: "add",
                  value: function(U) {
                    if (this._ended)
                      throw new Error("Cannot add child to already-ended structure element");
                    if (!this._isValidChild(U))
                      throw new Error("Invalid structure element child");
                    return U instanceof Et && (U.setParent(this.dictionary), this._attached && U.setAttached()), U instanceof Yr && this._addContentToParentTree(U), typeof U == "function" && this._attached && (U = this._contentForClosure(U)), this._children.push(U), this;
                  }
                }, {
                  key: "_addContentToParentTree",
                  value: function(U) {
                    var tt = this;
                    U.refs.forEach(function(K) {
                      var mt = K.pageRef, At = K.mcid, ee = tt.document.getStructParentTree().get(mt.data.StructParents);
                      ee[At] = tt.dictionary;
                    });
                  }
                }, {
                  key: "setParent",
                  value: function(U) {
                    if (this.dictionary.data.P)
                      throw new Error("Structure element added to more than one parent");
                    this.dictionary.data.P = U, this._flush();
                  }
                }, {
                  key: "setAttached",
                  value: function() {
                    var U = this;
                    this._attached || (this._children.forEach(function(tt, K) {
                      tt instanceof Et && tt.setAttached(), typeof tt == "function" && (U._children[K] = U._contentForClosure(tt));
                    }), this._attached = !0, this._flush());
                  }
                }, {
                  key: "end",
                  value: function() {
                    this._ended || (this._children.filter(function(U) {
                      return U instanceof Et;
                    }).forEach(function(U) {
                      return U.end();
                    }), this._ended = !0, this._flush());
                  }
                }, {
                  key: "_isValidChild",
                  value: function(U) {
                    return U instanceof Et || U instanceof Yr || typeof U == "function";
                  }
                }, {
                  key: "_contentForClosure",
                  value: function(U) {
                    var tt = this.document.markStructureContent(this.dictionary.data.S);
                    return U(), this.document.endMarkedContent(), this._addContentToParentTree(tt), tt;
                  }
                }, {
                  key: "_isFlushable",
                  value: function() {
                    return !this.dictionary.data.P || !this._ended ? !1 : this._children.every(function(U) {
                      return typeof U == "function" ? !1 : U instanceof Et ? U._isFlushable() : !0;
                    });
                  }
                }, {
                  key: "_flush",
                  value: function() {
                    var U = this;
                    this._flushed || !this._isFlushable() || (this.dictionary.data.K = [], this._children.forEach(function(tt) {
                      return U._flushChild(tt);
                    }), this.dictionary.end(), this._children = [], this.dictionary.data.K = null, this._flushed = !0);
                  }
                }, {
                  key: "_flushChild",
                  value: function(U) {
                    var tt = this;
                    U instanceof Et && this.dictionary.data.K.push(U.dictionary), U instanceof Yr && U.refs.forEach(function(K) {
                      var mt = K.pageRef, At = K.mcid;
                      tt.dictionary.data.Pg || (tt.dictionary.data.Pg = mt), tt.dictionary.data.Pg === mt ? tt.dictionary.data.K.push(At) : tt.dictionary.data.K.push({
                        Type: "MCR",
                        Pg: mt,
                        MCID: At
                      });
                    });
                  }
                }]), Et;
              }(), qn = /* @__PURE__ */ function(Et) {
                C(U, Et);
                var _ = M(U);
                function U() {
                  return b(this, U), _.apply(this, arguments);
                }
                return w(U, [{
                  key: "_compareKeys",
                  value: function(K, mt) {
                    return parseInt(K) - parseInt(mt);
                  }
                }, {
                  key: "_keysName",
                  value: function() {
                    return "Nums";
                  }
                }, {
                  key: "_dataForKey",
                  value: function(K) {
                    return parseInt(K);
                  }
                }]), U;
              }(X), Sn = {
                initMarkings: function(_) {
                  this.structChildren = [], _.tagged && (this.getMarkInfoDictionary().data.Marked = !0, this.getStructTreeRoot());
                },
                markContent: function(_) {
                  var U = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                  if (_ === "Artifact" || U && U.mcid) {
                    var tt = 0;
                    for (this.page.markings.forEach(function(mt) {
                      (tt || mt.structContent || mt.tag === "Artifact") && tt++;
                    }); tt--; )
                      this.endMarkedContent();
                  }
                  if (!U)
                    return this.page.markings.push({
                      tag: _
                    }), this.addContent("/".concat(_, " BMC")), this;
                  this.page.markings.push({
                    tag: _,
                    options: U
                  });
                  var K = {};
                  return typeof U.mcid < "u" && (K.MCID = U.mcid), _ === "Artifact" && (typeof U.type == "string" && (K.Type = U.type), Array.isArray(U.bbox) && (K.BBox = [U.bbox[0], this.page.height - U.bbox[3], U.bbox[2], this.page.height - U.bbox[1]]), Array.isArray(U.attached) && U.attached.every(function(mt) {
                    return typeof mt == "string";
                  }) && (K.Attached = U.attached)), _ === "Span" && (U.lang && (K.Lang = new String(U.lang)), U.alt && (K.Alt = new String(U.alt)), U.expanded && (K.E = new String(U.expanded)), U.actual && (K.ActualText = new String(U.actual))), this.addContent("/".concat(_, " ").concat(Ft.convert(K), " BDC")), this;
                },
                markStructureContent: function(_) {
                  var U = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, tt = this.getStructParentTree().get(this.page.structParentTreeKey), K = tt.length;
                  tt.push(null), this.markContent(_, O(O({}, U), {}, {
                    mcid: K
                  }));
                  var mt = new Yr(this.page.dictionary, K);
                  return this.page.markings.slice(-1)[0].structContent = mt, mt;
                },
                endMarkedContent: function() {
                  return this.page.markings.pop(), this.addContent("EMC"), this;
                },
                struct: function(_) {
                  var U = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, tt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
                  return new Rr(this, _, U, tt);
                },
                addStructure: function(_) {
                  var U = this.getStructTreeRoot();
                  return _.setParent(U), _.setAttached(), this.structChildren.push(_), U.data.K || (U.data.K = []), U.data.K.push(_.dictionary), this;
                },
                initPageMarkings: function(_) {
                  var U = this;
                  _.forEach(function(tt) {
                    if (tt.structContent) {
                      var K = tt.structContent, mt = U.markStructureContent(tt.tag, tt.options);
                      K.push(mt), U.page.markings.slice(-1)[0].structContent = K;
                    } else
                      U.markContent(tt.tag, tt.options);
                  });
                },
                endPageMarkings: function(_) {
                  var U = _.markings;
                  return U.forEach(function() {
                    return _.write("EMC");
                  }), _.markings = [], U;
                },
                getMarkInfoDictionary: function() {
                  return this._root.data.MarkInfo || (this._root.data.MarkInfo = this.ref({})), this._root.data.MarkInfo;
                },
                getStructTreeRoot: function() {
                  return this._root.data.StructTreeRoot || (this._root.data.StructTreeRoot = this.ref({
                    Type: "StructTreeRoot",
                    ParentTree: new qn(),
                    ParentTreeNextKey: 0
                  })), this._root.data.StructTreeRoot;
                },
                getStructParentTree: function() {
                  return this.getStructTreeRoot().data.ParentTree;
                },
                createStructParentTreeNextKey: function() {
                  this.getMarkInfoDictionary();
                  var _ = this.getStructTreeRoot(), U = _.data.ParentTreeNextKey++;
                  return _.data.ParentTree.add(U, []), U;
                },
                endMarkings: function() {
                  var _ = this._root.data.StructTreeRoot;
                  _ && (_.end(), this.structChildren.forEach(function(U) {
                    return U.end();
                  })), this._root.data.MarkInfo && this._root.data.MarkInfo.end();
                }
              }, $r = {
                readOnly: 1,
                required: 2,
                noExport: 4,
                multiline: 4096,
                password: 8192,
                toggleToOffButton: 16384,
                radioButton: 32768,
                pushButton: 65536,
                combo: 131072,
                edit: 262144,
                sort: 524288,
                multiSelect: 2097152,
                noSpell: 4194304
              }, ln = {
                left: 0,
                center: 1,
                right: 2
              }, pn = {
                value: "V",
                defaultValue: "DV"
              }, Nn = {
                zip: "0",
                zipPlus4: "1",
                zip4: "1",
                phone: "2",
                ssn: "3"
              }, Rn = {
                number: {
                  nDec: 0,
                  sepComma: !1,
                  negStyle: "MinusBlack",
                  currency: "",
                  currencyPrepend: !0
                },
                percent: {
                  nDec: 0,
                  sepComma: !1
                }
              }, Na = {
                /**
                 * Must call if adding AcroForms to a document. Must also call font() before
                 * this method to set the default font.
                 */
                initForm: function() {
                  if (!this._font)
                    throw new Error("Must set a font before calling initForm method");
                  this._acroform = {
                    fonts: {},
                    defaultFont: this._font.name
                  }, this._acroform.fonts[this._font.id] = this._font.ref();
                  var _ = {
                    Fields: [],
                    NeedAppearances: !0,
                    DA: new String("/".concat(this._font.id, " 0 Tf 0 g")),
                    DR: {
                      Font: {}
                    }
                  };
                  _.DR.Font[this._font.id] = this._font.ref();
                  var U = this.ref(_);
                  return this._root.data.AcroForm = U, this;
                },
                /**
                 * Called automatically by document.js
                 */
                endAcroForm: function() {
                  var _ = this;
                  if (this._root.data.AcroForm) {
                    if (!Object.keys(this._acroform.fonts).length && !this._acroform.defaultFont)
                      throw new Error("No fonts specified for PDF form");
                    var U = this._root.data.AcroForm.data.DR.Font;
                    Object.keys(this._acroform.fonts).forEach(function(tt) {
                      U[tt] = _._acroform.fonts[tt];
                    }), this._root.data.AcroForm.data.Fields.forEach(function(tt) {
                      _._endChild(tt);
                    }), this._root.data.AcroForm.end();
                  }
                  return this;
                },
                _endChild: function(_) {
                  var U = this;
                  return Array.isArray(_.data.Kids) && (_.data.Kids.forEach(function(tt) {
                    U._endChild(tt);
                  }), _.end()), this;
                },
                /**
                 * Creates and adds a form field to the document. Form fields are intermediate
                 * nodes in a PDF form that are used to specify form name heirarchy and form
                 * value defaults.
                 * @param {string} name - field name (T attribute in field dictionary)
                 * @param {object} options  - other attributes to include in field dictionary
                 */
                formField: function(_) {
                  var U = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, tt = this._fieldDict(_, null, U), K = this.ref(tt);
                  return this._addToParent(K), K;
                },
                /**
                 * Creates and adds a Form Annotation to the document. Form annotations are
                 * called Widget annotations internally within a PDF file.
                 * @param {string} name - form field name (T attribute of widget annotation
                 * dictionary)
                 * @param {number} x
                 * @param {number} y
                 * @param {number} w
                 * @param {number} h
                 * @param {object} options
                 */
                formAnnotation: function(_, U, tt, K, mt, At) {
                  var ee = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : {}, ae = this._fieldDict(_, U, ee);
                  ae.Subtype = "Widget", ae.F === void 0 && (ae.F = 4), this.annotate(tt, K, mt, At, ae);
                  var ye = this.page.annotations[this.page.annotations.length - 1];
                  return this._addToParent(ye);
                },
                formText: function(_, U, tt, K, mt) {
                  var At = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
                  return this.formAnnotation(_, "text", U, tt, K, mt, At);
                },
                formPushButton: function(_, U, tt, K, mt) {
                  var At = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
                  return this.formAnnotation(_, "pushButton", U, tt, K, mt, At);
                },
                formCombo: function(_, U, tt, K, mt) {
                  var At = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
                  return this.formAnnotation(_, "combo", U, tt, K, mt, At);
                },
                formList: function(_, U, tt, K, mt) {
                  var At = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
                  return this.formAnnotation(_, "list", U, tt, K, mt, At);
                },
                formRadioButton: function(_, U, tt, K, mt) {
                  var At = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
                  return this.formAnnotation(_, "radioButton", U, tt, K, mt, At);
                },
                formCheckbox: function(_, U, tt, K, mt) {
                  var At = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
                  return this.formAnnotation(_, "checkbox", U, tt, K, mt, At);
                },
                _addToParent: function(_) {
                  var U = _.data.Parent;
                  return U ? (U.data.Kids || (U.data.Kids = []), U.data.Kids.push(_)) : this._root.data.AcroForm.data.Fields.push(_), this;
                },
                _fieldDict: function(_, U) {
                  var tt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                  if (!this._acroform)
                    throw new Error("Call document.initForms() method before adding form elements to document");
                  var K = Object.assign({}, tt);
                  return U !== null && (K = this._resolveType(U, tt)), K = this._resolveFlags(K), K = this._resolveJustify(K), K = this._resolveFont(K), K = this._resolveStrings(K), K = this._resolveColors(K), K = this._resolveFormat(K), K.T = new String(_), K.parent && (K.Parent = K.parent, delete K.parent), K;
                },
                _resolveType: function(_, U) {
                  if (_ === "text")
                    U.FT = "Tx";
                  else if (_ === "pushButton")
                    U.FT = "Btn", U.pushButton = !0;
                  else if (_ === "radioButton")
                    U.FT = "Btn", U.radioButton = !0;
                  else if (_ === "checkbox")
                    U.FT = "Btn";
                  else if (_ === "combo")
                    U.FT = "Ch", U.combo = !0;
                  else if (_ === "list")
                    U.FT = "Ch";
                  else
                    throw new Error("Invalid form annotation type '".concat(_, "'"));
                  return U;
                },
                _resolveFormat: function(_) {
                  var U = _.format;
                  if (U && U.type) {
                    var tt, K, mt = "";
                    if (Nn[U.type] !== void 0)
                      tt = "AFSpecial_Keystroke", K = "AFSpecial_Format", mt = Nn[U.type];
                    else {
                      var At = U.type.charAt(0).toUpperCase() + U.type.slice(1);
                      if (tt = "AF".concat(At, "_Keystroke"), K = "AF".concat(At, "_Format"), U.type === "date")
                        tt += "Ex", mt = String(U.param);
                      else if (U.type === "time")
                        mt = String(U.param);
                      else if (U.type === "number") {
                        var ee = Object.assign({}, Rn.number, U);
                        mt = String([String(ee.nDec), ee.sepComma ? "0" : "1", '"' + ee.negStyle + '"', "null", '"' + ee.currency + '"', String(ee.currencyPrepend)].join(","));
                      } else if (U.type === "percent") {
                        var ae = Object.assign({}, Rn.percent, U);
                        mt = String([String(ae.nDec), ae.sepComma ? "0" : "1"].join(","));
                      }
                    }
                    _.AA = _.AA ? _.AA : {}, _.AA.K = {
                      S: "JavaScript",
                      JS: new String("".concat(tt, "(").concat(mt, ");"))
                    }, _.AA.F = {
                      S: "JavaScript",
                      JS: new String("".concat(K, "(").concat(mt, ");"))
                    };
                  }
                  return delete _.format, _;
                },
                _resolveColors: function(_) {
                  var U = this._normalizeColor(_.backgroundColor);
                  return U && (_.MK || (_.MK = {}), _.MK.BG = U), U = this._normalizeColor(_.borderColor), U && (_.MK || (_.MK = {}), _.MK.BC = U), delete _.backgroundColor, delete _.borderColor, _;
                },
                _resolveFlags: function(_) {
                  var U = 0;
                  return Object.keys(_).forEach(function(tt) {
                    $r[tt] && (U |= $r[tt], delete _[tt]);
                  }), U !== 0 && (_.Ff = _.Ff ? _.Ff : 0, _.Ff |= U), _;
                },
                _resolveJustify: function(_) {
                  var U = 0;
                  return _.align !== void 0 && (typeof ln[_.align] == "number" && (U = ln[_.align]), delete _.align), U !== 0 && (_.Q = U), _;
                },
                _resolveFont: function(_) {
                  if (this._acroform.fonts[this._font.id] === null && (this._acroform.fonts[this._font.id] = this._font.ref()), this._acroform.defaultFont !== this._font.name) {
                    _.DR = {
                      Font: {}
                    };
                    var U = _.fontSize || 0;
                    _.DR.Font[this._font.id] = this._font.ref(), _.DA = new String("/".concat(this._font.id, " ").concat(U, " Tf 0 g"));
                  }
                  return _;
                },
                _resolveStrings: function(_) {
                  var U = [];
                  function tt(K) {
                    if (Array.isArray(K))
                      for (var mt = 0; mt < K.length; mt++)
                        typeof K[mt] == "string" ? U.push(new String(K[mt])) : U.push(K[mt]);
                  }
                  return tt(_.Opt), _.select && (tt(_.select), delete _.select), U.length && (_.Opt = U), Object.keys(pn).forEach(function(K) {
                    _[K] !== void 0 && (_[pn[K]] = _[K], delete _[K]);
                  }), ["V", "DV"].forEach(function(K) {
                    typeof _[K] == "string" && (_[K] = new String(_[K]));
                  }), _.MK && _.MK.CA && (_.MK.CA = new String(_.MK.CA)), _.label && (_.MK = _.MK ? _.MK : {}, _.MK.CA = new String(_.label), delete _.label), _;
                }
              }, zi = {
                /**
                 * Embed contents of `src` in PDF
                 * @param {Buffer | ArrayBuffer | string} src input Buffer, ArrayBuffer, base64 encoded string or path to file
                 * @param {object} options
                 *  * options.name: filename to be shown in PDF, will use `src` if none set
                 *  * options.type: filetype to be shown in PDF
                 *  * options.description: description to be shown in PDF
                 *  * options.hidden: if true, do not add attachment to EmbeddedFiles dictionary. Useful for file attachment annotations
                 *  * options.creationDate: override creation date
                 *  * options.modifiedDate: override modified date
                 * @returns filespec reference
                 */
                file: function(_) {
                  var U = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                  U.name = U.name || _;
                  var tt = {
                    Type: "EmbeddedFile",
                    Params: {}
                  }, K;
                  if (!_)
                    throw new Error("No src specified");
                  if (i.isBuffer(_))
                    K = _;
                  else if (_ instanceof ArrayBuffer)
                    K = i.from(new Uint8Array(_));
                  else {
                    var mt;
                    if (mt = /^data:(.*);base64,(.*)$/.exec(_))
                      mt[1] && (tt.Subtype = mt[1].replace("/", "#2F")), K = i.from(mt[2], "base64");
                    else {
                      if (K = y.readFileSync(_), !K)
                        throw new Error("Could not read contents of file at filepath ".concat(_));
                      var At = y.statSync(_), ee = At.birthtime, ae = At.ctime;
                      tt.Params.CreationDate = ee, tt.Params.ModDate = ae;
                    }
                  }
                  U.creationDate instanceof Date && (tt.Params.CreationDate = U.creationDate), U.modifiedDate instanceof Date && (tt.Params.ModDate = U.modifiedDate), U.type && (tt.Subtype = U.type.replace("/", "#2F"));
                  var ye = v.default.MD5(v.default.lib.WordArray.create(new Uint8Array(K)));
                  tt.Params.CheckSum = new String(ye), tt.Params.Size = K.byteLength;
                  var Ae;
                  this._fileRegistry || (this._fileRegistry = {});
                  var Oe = this._fileRegistry[U.name];
                  Oe && La(tt, Oe) ? Ae = Oe.ref : (Ae = this.ref(tt), Ae.end(K), this._fileRegistry[U.name] = O(O({}, tt), {}, {
                    ref: Ae
                  }));
                  var Ie = {
                    Type: "Filespec",
                    F: new String(U.name),
                    EF: {
                      F: Ae
                    },
                    UF: new String(U.name)
                  };
                  U.description && (Ie.Desc = new String(U.description));
                  var Ne = this.ref(Ie);
                  return Ne.end(), U.hidden || this.addNamedEmbeddedFile(U.name, Ne), Ne;
                }
              };
              function La(Et, _) {
                return Et.Subtype === _.Subtype && Et.Params.CheckSum.toString() === _.Params.CheckSum.toString() && Et.Params.Size === _.Params.Size && Et.Params.CreationDate === _.Params.CreationDate && Et.Params.ModDate === _.Params.ModDate;
              }
              var Ua = {
                initPDFA: function(_) {
                  _.charAt(_.length - 3) === "-" ? (this.subset_conformance = _.charAt(_.length - 1).toUpperCase(), this.subset = parseInt(_.charAt(_.length - 2))) : (this.subset_conformance = "B", this.subset = parseInt(_.charAt(_.length - 1)));
                },
                endSubset: function() {
                  this._addPdfaMetadata();
                  var _ = "".concat(s, "/data/sRGB_IEC61966_2_1.icc"), U = "".concat(s, "/../color_profiles/sRGB_IEC61966_2_1.icc");
                  this._addColorOutputIntent(y.existsSync(_) ? _ : U);
                },
                _addColorOutputIntent: function(_) {
                  var U = y.readFileSync(_), tt = this.ref({
                    Length: U.length,
                    N: 3
                  });
                  tt.write(U), tt.end();
                  var K = this.ref({
                    Type: "OutputIntent",
                    S: "GTS_PDFA1",
                    Info: new String("sRGB IEC61966-2.1"),
                    OutputConditionIdentifier: new String("sRGB IEC61966-2.1"),
                    DestOutputProfile: tt
                  });
                  K.end(), this._root.data.OutputIntents = [K];
                },
                _getPdfaid: function() {
                  return `
        <rdf:Description xmlns:pdfaid="http://www.aiim.org/pdfa/ns/id/" rdf:about="">
            <pdfaid:part>`.concat(this.subset, `</pdfaid:part>
            <pdfaid:conformance>`).concat(this.subset_conformance, `</pdfaid:conformance>
        </rdf:Description>
        `);
                },
                _addPdfaMetadata: function() {
                  this.appendXML(this._getPdfaid());
                }
              }, va = {
                _importSubset: function(_) {
                  Object.assign(this, _);
                },
                initSubset: function(_) {
                  switch (_.subset) {
                    case "PDF/A-1":
                    case "PDF/A-1a":
                    case "PDF/A-1b":
                    case "PDF/A-2":
                    case "PDF/A-2a":
                    case "PDF/A-2b":
                    case "PDF/A-3":
                    case "PDF/A-3a":
                    case "PDF/A-3b":
                      this._importSubset(Ua), this.initPDFA(_.subset);
                      break;
                  }
                }
              }, Gi = /* @__PURE__ */ function() {
                function Et() {
                  b(this, Et), this._metadata = `
        <?xpacket begin="\uFEFF" id="W5M0MpCehiHzreSzNTczkc9d"?>
            <x:xmpmeta xmlns:x="adobe:ns:meta/">
                <rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">
        `;
                }
                return w(Et, [{
                  key: "_closeTags",
                  value: function() {
                    this._metadata = this._metadata.concat(`
                </rdf:RDF>
            </x:xmpmeta>
        <?xpacket end="w"?>
        `);
                  }
                }, {
                  key: "append",
                  value: function(U) {
                    var tt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
                    this._metadata = this._metadata.concat(U), tt && (this._metadata = this._metadata.concat(`
`));
                  }
                }, {
                  key: "getXML",
                  value: function() {
                    return this._metadata;
                  }
                }, {
                  key: "getLength",
                  value: function() {
                    return this._metadata.length;
                  }
                }, {
                  key: "end",
                  value: function() {
                    this._closeTags(), this._metadata = this._metadata.trim();
                  }
                }]), Et;
              }(), ga = {
                initMetadata: function() {
                  this.metadata = new Gi();
                },
                appendXML: function(_) {
                  var U = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
                  this.metadata.append(_, U);
                },
                _addInfo: function() {
                  this.appendXML(`
        <rdf:Description rdf:about="" xmlns:xmp="http://ns.adobe.com/xap/1.0/">
            <xmp:CreateDate>`.concat(this.info.CreationDate.toISOString().split(".")[0] + "Z", `</xmp:CreateDate>
            <xmp:CreatorTool>`).concat(this.info.Creator, `</xmp:CreatorTool>
        </rdf:Description>
        `)), (this.info.Title || this.info.Author || this.info.Subject) && (this.appendXML(`
            <rdf:Description rdf:about="" xmlns:dc="http://purl.org/dc/elements/1.1/">
            `), this.info.Title && this.appendXML(`
                <dc:title>
                    <rdf:Alt>
                        <rdf:li xml:lang="x-default">`.concat(this.info.Title, `</rdf:li>
                    </rdf:Alt>
                </dc:title>
                `)), this.info.Author && this.appendXML(`
                <dc:creator>
                    <rdf:Seq>
                        <rdf:li>`.concat(this.info.Author, `</rdf:li>
                    </rdf:Seq>
                </dc:creator>
                `)), this.info.Subject && this.appendXML(`
                <dc:description>
                    <rdf:Alt>
                        <rdf:li xml:lang="x-default">`.concat(this.info.Subject, `</rdf:li>
                    </rdf:Alt>
                </dc:description>
                `)), this.appendXML(`
            </rdf:Description>
            `)), this.appendXML(`
        <rdf:Description rdf:about="" xmlns:pdf="http://ns.adobe.com/pdf/1.3/">
            <pdf:Producer>`.concat(this.info.Creator, "</pdf:Producer>"), !1), this.info.Keywords && this.appendXML(`
            <pdf:Keywords>`.concat(this.info.Keywords, "</pdf:Keywords>"), !1), this.appendXML(`
        </rdf:Description>
        `);
                },
                endMetadata: function() {
                  this._addInfo(), this.metadata.end(), this.version != 1.3 && (this.metadataRef = this.ref({
                    length: this.metadata.getLength(),
                    Type: "Metadata",
                    Subtype: "XML"
                  }), this.metadataRef.compress = !1, this.metadataRef.write(i.from(this.metadata.getXML(), "utf-8")), this.metadataRef.end(), this._root.data.Metadata = this.metadataRef);
                }
              }, Zi = /* @__PURE__ */ function(Et) {
                C(U, Et);
                var _ = M(U);
                function U() {
                  var tt, K = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                  switch (b(this, U), tt = _.call(this, K), tt.options = K, K.pdfVersion) {
                    case "1.4":
                      tt.version = 1.4;
                      break;
                    case "1.5":
                      tt.version = 1.5;
                      break;
                    case "1.6":
                      tt.version = 1.6;
                      break;
                    case "1.7":
                    case "1.7ext3":
                      tt.version = 1.7;
                      break;
                    default:
                      tt.version = 1.3;
                      break;
                  }
                  tt.compress = tt.options.compress != null ? tt.options.compress : !0, tt._pageBuffer = [], tt._pageBufferStart = 0, tt._offsets = [], tt._waiting = 0, tt._ended = !1, tt._offset = 0;
                  var mt = tt.ref({
                    Type: "Pages",
                    Count: 0,
                    Kids: []
                  }), At = tt.ref({
                    Dests: new et()
                  });
                  if (tt._root = tt.ref({
                    Type: "Catalog",
                    Pages: mt,
                    Names: At
                  }), tt.options.lang && (tt._root.data.Lang = new String(tt.options.lang)), tt.page = null, tt.initMetadata(), tt.initColor(), tt.initVector(), tt.initFonts(K.font), tt.initText(), tt.initImages(), tt.initOutline(), tt.initMarkings(K), tt.initSubset(K), tt.info = {
                    Producer: "PDFKit",
                    Creator: "PDFKit",
                    CreationDate: /* @__PURE__ */ new Date()
                  }, tt.options.info)
                    for (var ee in tt.options.info) {
                      var ae = tt.options.info[ee];
                      tt.info[ee] = ae;
                    }
                  return tt.options.displayTitle && (tt._root.data.ViewerPreferences = tt.ref({
                    DisplayDocTitle: !0
                  })), tt._id = nt.generateFileID(tt.info), tt._security = nt.create(F(tt), K), tt._write("%PDF-".concat(tt.version)), tt._write("%ÿÿÿÿ"), tt.options.autoFirstPage !== !1 && tt.addPage(), tt;
                }
                return w(U, [{
                  key: "addPage",
                  value: function(K) {
                    K == null && (K = this.options), this.options.bufferPages || this.flushPages(), this.page = new Z(this, K), this._pageBuffer.push(this.page);
                    var mt = this._root.data.Pages.data;
                    return mt.Kids.push(this.page.dictionary), mt.Count++, this.x = this.page.margins.left, this.y = this.page.margins.top, this._ctm = [1, 0, 0, 1, 0, 0], this.transform(1, 0, 0, -1, 0, this.page.height), this.emit("pageAdded"), this;
                  }
                }, {
                  key: "continueOnNewPage",
                  value: function(K) {
                    var mt = this.endPageMarkings(this.page);
                    return this.addPage(K), this.initPageMarkings(mt), this;
                  }
                }, {
                  key: "bufferedPageRange",
                  value: function() {
                    return {
                      start: this._pageBufferStart,
                      count: this._pageBuffer.length
                    };
                  }
                }, {
                  key: "switchToPage",
                  value: function(K) {
                    var mt;
                    if (!(mt = this._pageBuffer[K - this._pageBufferStart]))
                      throw new Error("switchToPage(".concat(K, ") out of bounds, current buffer covers pages ").concat(this._pageBufferStart, " to ").concat(this._pageBufferStart + this._pageBuffer.length - 1));
                    return this.page = mt;
                  }
                }, {
                  key: "flushPages",
                  value: function() {
                    var K = this._pageBuffer;
                    this._pageBuffer = [], this._pageBufferStart += K.length;
                    var mt = bt(K), At;
                    try {
                      for (mt.s(); !(At = mt.n()).done; ) {
                        var ee = At.value;
                        this.endPageMarkings(ee), ee.end();
                      }
                    } catch (ae) {
                      mt.e(ae);
                    } finally {
                      mt.f();
                    }
                  }
                }, {
                  key: "addNamedDestination",
                  value: function(K) {
                    for (var mt = arguments.length, At = new Array(mt > 1 ? mt - 1 : 0), ee = 1; ee < mt; ee++)
                      At[ee - 1] = arguments[ee];
                    At.length === 0 && (At = ["XYZ", null, null, null]), At[0] === "XYZ" && At[2] !== null && (At[2] = this.page.height - At[2]), At.unshift(this.page.dictionary), this._root.data.Names.data.Dests.add(K, At);
                  }
                }, {
                  key: "addNamedEmbeddedFile",
                  value: function(K, mt) {
                    this._root.data.Names.data.EmbeddedFiles || (this._root.data.Names.data.EmbeddedFiles = new et({
                      limits: !1
                    })), this._root.data.Names.data.EmbeddedFiles.add(K, mt);
                  }
                }, {
                  key: "addNamedJavaScript",
                  value: function(K, mt) {
                    this._root.data.Names.data.JavaScript || (this._root.data.Names.data.JavaScript = new et());
                    var At = {
                      JS: new String(mt),
                      S: "JavaScript"
                    };
                    this._root.data.Names.data.JavaScript.add(K, At);
                  }
                }, {
                  key: "ref",
                  value: function(K) {
                    var mt = new zt(this, this._offsets.length + 1, K);
                    return this._offsets.push(null), this._waiting++, mt;
                  }
                }, {
                  key: "_read",
                  value: function() {
                  }
                  // do nothing, but this method is required by node
                }, {
                  key: "_write",
                  value: function(K) {
                    return i.isBuffer(K) || (K = i.from(K + `
`, "binary")), this.push(K), this._offset += K.length;
                  }
                }, {
                  key: "addContent",
                  value: function(K) {
                    return this.page.write(K), this;
                  }
                }, {
                  key: "_refEnd",
                  value: function(K) {
                    if (this._offsets[K.id - 1] = K.offset, --this._waiting === 0 && this._ended)
                      return this._finalize(), this._ended = !1;
                  }
                }, {
                  key: "write",
                  value: function(K, mt) {
                    var At = new Error("PDFDocument#write is deprecated, and will be removed in a future version of PDFKit. Please pipe the document into a Node stream.");
                    return console.warn(At.stack), this.pipe(y.createWriteStream(K)), this.end(), this.once("end", mt);
                  }
                }, {
                  key: "end",
                  value: function() {
                    this.flushPages(), this._info = this.ref();
                    for (var K in this.info) {
                      var mt = this.info[K];
                      typeof mt == "string" && (mt = new String(mt));
                      var At = this.ref(mt);
                      At.end(), this._info.data[K] = At;
                    }
                    this._info.end();
                    for (var ee in this._fontFamilies) {
                      var ae = this._fontFamilies[ee];
                      ae.finalize();
                    }
                    return this.endOutline(), this.endMarkings(), this.subset && this.endSubset(), this.endMetadata(), this._root.end(), this._root.data.Pages.end(), this._root.data.Names.end(), this.endAcroForm(), this._root.data.ViewerPreferences && this._root.data.ViewerPreferences.end(), this._security && this._security.end(), this._waiting === 0 ? this._finalize() : this._ended = !0;
                  }
                }, {
                  key: "_finalize",
                  value: function() {
                    var K = this._offset;
                    this._write("xref"), this._write("0 ".concat(this._offsets.length + 1)), this._write("0000000000 65535 f ");
                    var mt = bt(this._offsets), At;
                    try {
                      for (mt.s(); !(At = mt.n()).done; ) {
                        var ee = At.value;
                        ee = "0000000000".concat(ee).slice(-10), this._write(ee + " 00000 n ");
                      }
                    } catch (ye) {
                      mt.e(ye);
                    } finally {
                      mt.f();
                    }
                    var ae = {
                      Size: this._offsets.length + 1,
                      Root: this._root,
                      Info: this._info,
                      ID: [this._id, this._id]
                    };
                    return this._security && (ae.Encrypt = this._security.dictionary), this._write("trailer"), this._write(Ft.convert(ae)), this._write("startxref"), this._write("".concat(K)), this._write("%%EOF"), this.push(null);
                  }
                }, {
                  key: "toString",
                  value: function() {
                    return "[object PDFDocument]";
                  }
                }]), U;
              }(f.default.Readable), si = function(_) {
                Object.assign(Zi.prototype, _);
              };
              si(ga), si(wi), si(Yt), si(mr), si(fr), si(Gr), si(tn), si(_r), si(Sn), si(Na), si(zi), si(va), Zi.LineWrapper = we, l.default = Zi;
            }
          ),
          /***/
          36164: (
            /***/
            function(u, l, e) {
              var s = e(45314), i = e(72022), f = i;
              typeof f.pdfMake > "u" && (f.pdfMake = s), u.exports = s;
            }
          ),
          /***/
          80182: (
            /***/
            function(u, l, e) {
              var s = e(9964);
              function i(D) {
                "@babel/helpers - typeof";
                return i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Z) {
                  return typeof Z;
                } : function(Z) {
                  return Z && typeof Symbol == "function" && Z.constructor === Symbol && Z !== Symbol.prototype ? "symbol" : typeof Z;
                }, i(D);
              }
              function f(D, Z) {
                for (var et = 0; et < Z.length; et++) {
                  var vt = Z[et];
                  vt.enumerable = vt.enumerable || !1, vt.configurable = !0, "value" in vt && (vt.writable = !0), Object.defineProperty(D, v(vt.key), vt);
                }
              }
              function h(D, Z, et) {
                return Z && f(D.prototype, Z), et && f(D, et), Object.defineProperty(D, "prototype", { writable: !1 }), D;
              }
              function v(D) {
                var Z = p(D, "string");
                return i(Z) === "symbol" ? Z : String(Z);
              }
              function p(D, Z) {
                if (i(D) !== "object" || D === null)
                  return D;
                var et = D[Symbol.toPrimitive];
                if (et !== void 0) {
                  var vt = et.call(D, Z || "default");
                  if (i(vt) !== "object")
                    return vt;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (Z === "string" ? String : Number)(D);
              }
              function m(D, Z) {
                if (!(D instanceof Z))
                  throw new TypeError("Cannot call a class as a function");
              }
              var x = e(35403), g = x.codes, S = g.ERR_AMBIGUOUS_ARGUMENT, y = g.ERR_INVALID_ARG_TYPE, b = g.ERR_INVALID_ARG_VALUE, n = g.ERR_INVALID_RETURN_VALUE, w = g.ERR_MISSING_ARGS, E = e(85416), A = e(7187), O = A.inspect, C = e(7187).types, T = C.isPromise, P = C.isRegExp, I = e(37596)(), F = e(89636)(), B = e(67913)("RegExp.prototype.test"), M, z;
              function L() {
                var D = e(86781);
                M = D.isDeepEqual, z = D.isDeepStrictEqual;
              }
              var J = !1, ft = u.exports = Gt, Q = {};
              function xt(D) {
                throw D.message instanceof Error ? D.message : new E(D);
              }
              function St(D, Z, et, vt, lt) {
                var dt = arguments.length, kt;
                if (dt === 0)
                  kt = "Failed";
                else if (dt === 1)
                  et = D, D = void 0;
                else {
                  if (J === !1) {
                    J = !0;
                    var jt = s.emitWarning ? s.emitWarning : console.warn.bind(console);
                    jt("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", "DeprecationWarning", "DEP0094");
                  }
                  dt === 2 && (vt = "!=");
                }
                if (et instanceof Error)
                  throw et;
                var me = {
                  actual: D,
                  expected: Z,
                  operator: vt === void 0 ? "fail" : vt,
                  stackStartFn: lt || St
                };
                et !== void 0 && (me.message = et);
                var se = new E(me);
                throw kt && (se.message = kt, se.generatedMessage = !0), se;
              }
              ft.fail = St, ft.AssertionError = E;
              function Pt(D, Z, et, vt) {
                if (!et) {
                  var lt = !1;
                  if (Z === 0)
                    lt = !0, vt = "No value argument passed to `assert.ok()`";
                  else if (vt instanceof Error)
                    throw vt;
                  var dt = new E({
                    actual: et,
                    expected: !0,
                    message: vt,
                    operator: "==",
                    stackStartFn: D
                  });
                  throw dt.generatedMessage = lt, dt;
                }
              }
              function Gt() {
                for (var D = arguments.length, Z = new Array(D), et = 0; et < D; et++)
                  Z[et] = arguments[et];
                Pt.apply(void 0, [Gt, Z.length].concat(Z));
              }
              ft.ok = Gt, ft.equal = function D(Z, et, vt) {
                if (arguments.length < 2)
                  throw new w("actual", "expected");
                Z != et && xt({
                  actual: Z,
                  expected: et,
                  message: vt,
                  operator: "==",
                  stackStartFn: D
                });
              }, ft.notEqual = function D(Z, et, vt) {
                if (arguments.length < 2)
                  throw new w("actual", "expected");
                Z == et && xt({
                  actual: Z,
                  expected: et,
                  message: vt,
                  operator: "!=",
                  stackStartFn: D
                });
              }, ft.deepEqual = function D(Z, et, vt) {
                if (arguments.length < 2)
                  throw new w("actual", "expected");
                M === void 0 && L(), M(Z, et) || xt({
                  actual: Z,
                  expected: et,
                  message: vt,
                  operator: "deepEqual",
                  stackStartFn: D
                });
              }, ft.notDeepEqual = function D(Z, et, vt) {
                if (arguments.length < 2)
                  throw new w("actual", "expected");
                M === void 0 && L(), M(Z, et) && xt({
                  actual: Z,
                  expected: et,
                  message: vt,
                  operator: "notDeepEqual",
                  stackStartFn: D
                });
              }, ft.deepStrictEqual = function D(Z, et, vt) {
                if (arguments.length < 2)
                  throw new w("actual", "expected");
                M === void 0 && L(), z(Z, et) || xt({
                  actual: Z,
                  expected: et,
                  message: vt,
                  operator: "deepStrictEqual",
                  stackStartFn: D
                });
              }, ft.notDeepStrictEqual = Rt;
              function Rt(D, Z, et) {
                if (arguments.length < 2)
                  throw new w("actual", "expected");
                M === void 0 && L(), z(D, Z) && xt({
                  actual: D,
                  expected: Z,
                  message: et,
                  operator: "notDeepStrictEqual",
                  stackStartFn: Rt
                });
              }
              ft.strictEqual = function D(Z, et, vt) {
                if (arguments.length < 2)
                  throw new w("actual", "expected");
                F(Z, et) || xt({
                  actual: Z,
                  expected: et,
                  message: vt,
                  operator: "strictEqual",
                  stackStartFn: D
                });
              }, ft.notStrictEqual = function D(Z, et, vt) {
                if (arguments.length < 2)
                  throw new w("actual", "expected");
                F(Z, et) && xt({
                  actual: Z,
                  expected: et,
                  message: vt,
                  operator: "notStrictEqual",
                  stackStartFn: D
                });
              };
              var bt = /* @__PURE__ */ h(function D(Z, et, vt) {
                var lt = this;
                m(this, D), et.forEach(function(dt) {
                  dt in Z && (vt !== void 0 && typeof vt[dt] == "string" && P(Z[dt]) && B(Z[dt], vt[dt]) ? lt[dt] = vt[dt] : lt[dt] = Z[dt]);
                });
              });
              function Dt(D, Z, et, vt, lt, dt) {
                if (!(et in D) || !z(D[et], Z[et])) {
                  if (!vt) {
                    var kt = new bt(D, lt), jt = new bt(Z, lt, D), me = new E({
                      actual: kt,
                      expected: jt,
                      operator: "deepStrictEqual",
                      stackStartFn: dt
                    });
                    throw me.actual = D, me.expected = Z, me.operator = dt.name, me;
                  }
                  xt({
                    actual: D,
                    expected: Z,
                    message: vt,
                    operator: dt.name,
                    stackStartFn: dt
                  });
                }
              }
              function X(D, Z, et, vt) {
                if (typeof Z != "function") {
                  if (P(Z))
                    return B(Z, D);
                  if (arguments.length === 2)
                    throw new y("expected", ["Function", "RegExp"], Z);
                  if (i(D) !== "object" || D === null) {
                    var lt = new E({
                      actual: D,
                      expected: Z,
                      message: et,
                      operator: "deepStrictEqual",
                      stackStartFn: vt
                    });
                    throw lt.operator = vt.name, lt;
                  }
                  var dt = Object.keys(Z);
                  if (Z instanceof Error)
                    dt.push("name", "message");
                  else if (dt.length === 0)
                    throw new b("error", Z, "may not be an empty object");
                  return M === void 0 && L(), dt.forEach(function(kt) {
                    typeof D[kt] == "string" && P(Z[kt]) && B(Z[kt], D[kt]) || Dt(D, Z, kt, et, dt, vt);
                  }), !0;
                }
                return Z.prototype !== void 0 && D instanceof Z ? !0 : Error.isPrototypeOf(Z) ? !1 : Z.call({}, D) === !0;
              }
              function gt(D) {
                if (typeof D != "function")
                  throw new y("fn", "Function", D);
                try {
                  D();
                } catch (Z) {
                  return Z;
                }
                return Q;
              }
              function st(D) {
                return T(D) || D !== null && i(D) === "object" && typeof D.then == "function" && typeof D.catch == "function";
              }
              function rt(D) {
                return Promise.resolve().then(function() {
                  var Z;
                  if (typeof D == "function") {
                    if (Z = D(), !st(Z))
                      throw new n("instance of Promise", "promiseFn", Z);
                  } else if (st(D))
                    Z = D;
                  else
                    throw new y("promiseFn", ["Function", "Promise"], D);
                  return Promise.resolve().then(function() {
                    return Z;
                  }).then(function() {
                    return Q;
                  }).catch(function(et) {
                    return et;
                  });
                });
              }
              function wt(D, Z, et, vt) {
                if (typeof et == "string") {
                  if (arguments.length === 4)
                    throw new y("error", ["Object", "Error", "Function", "RegExp"], et);
                  if (i(Z) === "object" && Z !== null) {
                    if (Z.message === et)
                      throw new S("error/message", 'The error message "'.concat(Z.message, '" is identical to the message.'));
                  } else if (Z === et)
                    throw new S("error/message", 'The error "'.concat(Z, '" is identical to the message.'));
                  vt = et, et = void 0;
                } else if (et != null && i(et) !== "object" && typeof et != "function")
                  throw new y("error", ["Object", "Error", "Function", "RegExp"], et);
                if (Z === Q) {
                  var lt = "";
                  et && et.name && (lt += " (".concat(et.name, ")")), lt += vt ? ": ".concat(vt) : ".";
                  var dt = D.name === "rejects" ? "rejection" : "exception";
                  xt({
                    actual: void 0,
                    expected: et,
                    operator: D.name,
                    message: "Missing expected ".concat(dt).concat(lt),
                    stackStartFn: D
                  });
                }
                if (et && !X(Z, et, vt, D))
                  throw Z;
              }
              function Ft(D, Z, et, vt) {
                if (Z !== Q) {
                  if (typeof et == "string" && (vt = et, et = void 0), !et || X(Z, et)) {
                    var lt = vt ? ": ".concat(vt) : ".", dt = D.name === "doesNotReject" ? "rejection" : "exception";
                    xt({
                      actual: Z,
                      expected: et,
                      operator: D.name,
                      message: "Got unwanted ".concat(dt).concat(lt, `
`) + 'Actual message: "'.concat(Z && Z.message, '"'),
                      stackStartFn: D
                    });
                  }
                  throw Z;
                }
              }
              ft.throws = function D(Z) {
                for (var et = arguments.length, vt = new Array(et > 1 ? et - 1 : 0), lt = 1; lt < et; lt++)
                  vt[lt - 1] = arguments[lt];
                wt.apply(void 0, [D, gt(Z)].concat(vt));
              }, ft.rejects = function D(Z) {
                for (var et = arguments.length, vt = new Array(et > 1 ? et - 1 : 0), lt = 1; lt < et; lt++)
                  vt[lt - 1] = arguments[lt];
                return rt(Z).then(function(dt) {
                  return wt.apply(void 0, [D, dt].concat(vt));
                });
              }, ft.doesNotThrow = function D(Z) {
                for (var et = arguments.length, vt = new Array(et > 1 ? et - 1 : 0), lt = 1; lt < et; lt++)
                  vt[lt - 1] = arguments[lt];
                Ft.apply(void 0, [D, gt(Z)].concat(vt));
              }, ft.doesNotReject = function D(Z) {
                for (var et = arguments.length, vt = new Array(et > 1 ? et - 1 : 0), lt = 1; lt < et; lt++)
                  vt[lt - 1] = arguments[lt];
                return rt(Z).then(function(dt) {
                  return Ft.apply(void 0, [D, dt].concat(vt));
                });
              }, ft.ifError = function D(Z) {
                if (Z != null) {
                  var et = "ifError got unwanted exception: ";
                  i(Z) === "object" && typeof Z.message == "string" ? Z.message.length === 0 && Z.constructor ? et += Z.constructor.name : et += Z.message : et += O(Z);
                  var vt = new E({
                    actual: Z,
                    expected: null,
                    operator: "ifError",
                    message: et,
                    stackStartFn: D
                  }), lt = Z.stack;
                  if (typeof lt == "string") {
                    var dt = lt.split(`
`);
                    dt.shift();
                    for (var kt = vt.stack.split(`
`), jt = 0; jt < dt.length; jt++) {
                      var me = kt.indexOf(dt[jt]);
                      if (me !== -1) {
                        kt = kt.slice(0, me);
                        break;
                      }
                    }
                    vt.stack = "".concat(kt.join(`
`), `
`).concat(dt.join(`
`));
                  }
                  throw vt;
                }
              };
              function zt(D, Z, et, vt, lt) {
                if (!P(Z))
                  throw new y("regexp", "RegExp", Z);
                var dt = lt === "match";
                if (typeof D != "string" || B(Z, D) !== dt) {
                  if (et instanceof Error)
                    throw et;
                  var kt = !et;
                  et = et || (typeof D != "string" ? 'The "string" argument must be of type string. Received type ' + "".concat(i(D), " (").concat(O(D), ")") : (dt ? "The input did not match the regular expression " : "The input was expected to not match the regular expression ") + "".concat(O(Z), `. Input:

`).concat(O(D), `
`));
                  var jt = new E({
                    actual: D,
                    expected: Z,
                    message: et,
                    operator: lt,
                    stackStartFn: vt
                  });
                  throw jt.generatedMessage = kt, jt;
                }
              }
              ft.match = function D(Z, et, vt) {
                zt(Z, et, vt, D, "match");
              }, ft.doesNotMatch = function D(Z, et, vt) {
                zt(Z, et, vt, D, "doesNotMatch");
              };
              function G() {
                for (var D = arguments.length, Z = new Array(D), et = 0; et < D; et++)
                  Z[et] = arguments[et];
                Pt.apply(void 0, [G, Z.length].concat(Z));
              }
              ft.strict = I(G, ft, {
                equal: ft.strictEqual,
                deepEqual: ft.deepStrictEqual,
                notEqual: ft.notStrictEqual,
                notDeepEqual: ft.notDeepStrictEqual
              }), ft.strict.strict = ft.strict;
            }
          ),
          /***/
          85416: (
            /***/
            function(u, l, e) {
              var s = e(9964);
              function i(X, gt) {
                var st = Object.keys(X);
                if (Object.getOwnPropertySymbols) {
                  var rt = Object.getOwnPropertySymbols(X);
                  gt && (rt = rt.filter(function(wt) {
                    return Object.getOwnPropertyDescriptor(X, wt).enumerable;
                  })), st.push.apply(st, rt);
                }
                return st;
              }
              function f(X) {
                for (var gt = 1; gt < arguments.length; gt++) {
                  var st = arguments[gt] != null ? arguments[gt] : {};
                  gt % 2 ? i(Object(st), !0).forEach(function(rt) {
                    h(X, rt, st[rt]);
                  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(X, Object.getOwnPropertyDescriptors(st)) : i(Object(st)).forEach(function(rt) {
                    Object.defineProperty(X, rt, Object.getOwnPropertyDescriptor(st, rt));
                  });
                }
                return X;
              }
              function h(X, gt, st) {
                return gt = x(gt), gt in X ? Object.defineProperty(X, gt, { value: st, enumerable: !0, configurable: !0, writable: !0 }) : X[gt] = st, X;
              }
              function v(X, gt) {
                if (!(X instanceof gt))
                  throw new TypeError("Cannot call a class as a function");
              }
              function p(X, gt) {
                for (var st = 0; st < gt.length; st++) {
                  var rt = gt[st];
                  rt.enumerable = rt.enumerable || !1, rt.configurable = !0, "value" in rt && (rt.writable = !0), Object.defineProperty(X, x(rt.key), rt);
                }
              }
              function m(X, gt, st) {
                return gt && p(X.prototype, gt), st && p(X, st), Object.defineProperty(X, "prototype", { writable: !1 }), X;
              }
              function x(X) {
                var gt = g(X, "string");
                return P(gt) === "symbol" ? gt : String(gt);
              }
              function g(X, gt) {
                if (P(X) !== "object" || X === null)
                  return X;
                var st = X[Symbol.toPrimitive];
                if (st !== void 0) {
                  var rt = st.call(X, gt || "default");
                  if (P(rt) !== "object")
                    return rt;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (gt === "string" ? String : Number)(X);
              }
              function S(X, gt) {
                if (typeof gt != "function" && gt !== null)
                  throw new TypeError("Super expression must either be null or a function");
                X.prototype = Object.create(gt && gt.prototype, { constructor: { value: X, writable: !0, configurable: !0 } }), Object.defineProperty(X, "prototype", { writable: !1 }), gt && C(X, gt);
              }
              function y(X) {
                var gt = A();
                return function() {
                  var rt = T(X), wt;
                  if (gt) {
                    var Ft = T(this).constructor;
                    wt = Reflect.construct(rt, arguments, Ft);
                  } else
                    wt = rt.apply(this, arguments);
                  return b(this, wt);
                };
              }
              function b(X, gt) {
                if (gt && (P(gt) === "object" || typeof gt == "function"))
                  return gt;
                if (gt !== void 0)
                  throw new TypeError("Derived constructors may only return object or undefined");
                return n(X);
              }
              function n(X) {
                if (X === void 0)
                  throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return X;
              }
              function w(X) {
                var gt = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
                return w = function(rt) {
                  if (rt === null || !O(rt))
                    return rt;
                  if (typeof rt != "function")
                    throw new TypeError("Super expression must either be null or a function");
                  if (typeof gt < "u") {
                    if (gt.has(rt))
                      return gt.get(rt);
                    gt.set(rt, wt);
                  }
                  function wt() {
                    return E(rt, arguments, T(this).constructor);
                  }
                  return wt.prototype = Object.create(rt.prototype, { constructor: { value: wt, enumerable: !1, writable: !0, configurable: !0 } }), C(wt, rt);
                }, w(X);
              }
              function E(X, gt, st) {
                return A() ? E = Reflect.construct.bind() : E = function(wt, Ft, zt) {
                  var G = [null];
                  G.push.apply(G, Ft);
                  var D = Function.bind.apply(wt, G), Z = new D();
                  return zt && C(Z, zt.prototype), Z;
                }, E.apply(null, arguments);
              }
              function A() {
                if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                  return !1;
                if (typeof Proxy == "function")
                  return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                  })), !0;
                } catch {
                  return !1;
                }
              }
              function O(X) {
                return Function.toString.call(X).indexOf("[native code]") !== -1;
              }
              function C(X, gt) {
                return C = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(rt, wt) {
                  return rt.__proto__ = wt, rt;
                }, C(X, gt);
              }
              function T(X) {
                return T = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(st) {
                  return st.__proto__ || Object.getPrototypeOf(st);
                }, T(X);
              }
              function P(X) {
                "@babel/helpers - typeof";
                return P = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(gt) {
                  return typeof gt;
                } : function(gt) {
                  return gt && typeof Symbol == "function" && gt.constructor === Symbol && gt !== Symbol.prototype ? "symbol" : typeof gt;
                }, P(X);
              }
              var I = e(7187), F = I.inspect, B = e(35403), M = B.codes.ERR_INVALID_ARG_TYPE;
              function z(X, gt, st) {
                return (st === void 0 || st > X.length) && (st = X.length), X.substring(st - gt.length, st) === gt;
              }
              function L(X, gt) {
                if (gt = Math.floor(gt), X.length == 0 || gt == 0)
                  return "";
                var st = X.length * gt;
                for (gt = Math.floor(Math.log(gt) / Math.log(2)); gt; )
                  X += X, gt--;
                return X += X.substring(0, st - X.length), X;
              }
              var J = "", ft = "", Q = "", xt = "", St = {
                deepStrictEqual: "Expected values to be strictly deep-equal:",
                strictEqual: "Expected values to be strictly equal:",
                strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
                deepEqual: "Expected values to be loosely deep-equal:",
                equal: "Expected values to be loosely equal:",
                notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
                notStrictEqual: 'Expected "actual" to be strictly unequal to:',
                notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
                notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
                notEqual: 'Expected "actual" to be loosely unequal to:',
                notIdentical: "Values identical but not reference-equal:"
              }, Pt = 10;
              function Gt(X) {
                var gt = Object.keys(X), st = Object.create(Object.getPrototypeOf(X));
                return gt.forEach(function(rt) {
                  st[rt] = X[rt];
                }), Object.defineProperty(st, "message", {
                  value: X.message
                }), st;
              }
              function Rt(X) {
                return F(X, {
                  compact: !1,
                  customInspect: !1,
                  depth: 1e3,
                  maxArrayLength: 1 / 0,
                  // Assert compares only enumerable properties (with a few exceptions).
                  showHidden: !1,
                  // Having a long line as error is better than wrapping the line for
                  // comparison for now.
                  // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
                  // have meta information about the inspected properties (i.e., know where
                  // in what line the property starts and ends).
                  breakLength: 1 / 0,
                  // Assert does not detect proxies currently.
                  showProxy: !1,
                  sorted: !0,
                  // Inspect getters as we also check them when comparing entries.
                  getters: !0
                });
              }
              function bt(X, gt, st) {
                var rt = "", wt = "", Ft = 0, zt = "", G = !1, D = Rt(X), Z = D.split(`
`), et = Rt(gt).split(`
`), vt = 0, lt = "";
                if (st === "strictEqual" && P(X) === "object" && P(gt) === "object" && X !== null && gt !== null && (st = "strictEqualObject"), Z.length === 1 && et.length === 1 && Z[0] !== et[0]) {
                  var dt = Z[0].length + et[0].length;
                  if (dt <= Pt) {
                    if ((P(X) !== "object" || X === null) && (P(gt) !== "object" || gt === null) && (X !== 0 || gt !== 0))
                      return "".concat(St[st], `

`) + "".concat(Z[0], " !== ").concat(et[0], `
`);
                  } else if (st !== "strictEqualObject") {
                    var kt = s.stderr && s.stderr.isTTY ? s.stderr.columns : 80;
                    if (dt < kt) {
                      for (; Z[0][vt] === et[0][vt]; )
                        vt++;
                      vt > 2 && (lt = `
  `.concat(L(" ", vt), "^"), vt = 0);
                    }
                  }
                }
                for (var jt = Z[Z.length - 1], me = et[et.length - 1]; jt === me && (vt++ < 2 ? zt = `
  `.concat(jt).concat(zt) : rt = jt, Z.pop(), et.pop(), !(Z.length === 0 || et.length === 0)); )
                  jt = Z[Z.length - 1], me = et[et.length - 1];
                var se = Math.max(Z.length, et.length);
                if (se === 0) {
                  var Bt = D.split(`
`);
                  if (Bt.length > 30)
                    for (Bt[26] = "".concat(J, "...").concat(xt); Bt.length > 27; )
                      Bt.pop();
                  return "".concat(St.notIdentical, `

`).concat(Bt.join(`
`), `
`);
                }
                vt > 3 && (zt = `
`.concat(J, "...").concat(xt).concat(zt), G = !0), rt !== "" && (zt = `
  `.concat(rt).concat(zt), rt = "");
                var ge = 0, Re = St[st] + `
`.concat(ft, "+ actual").concat(xt, " ").concat(Q, "- expected").concat(xt), Te = " ".concat(J, "...").concat(xt, " Lines skipped");
                for (vt = 0; vt < se; vt++) {
                  var xe = vt - Ft;
                  if (Z.length < vt + 1)
                    xe > 1 && vt > 2 && (xe > 4 ? (wt += `
`.concat(J, "...").concat(xt), G = !0) : xe > 3 && (wt += `
  `.concat(et[vt - 2]), ge++), wt += `
  `.concat(et[vt - 1]), ge++), Ft = vt, rt += `
`.concat(Q, "-").concat(xt, " ").concat(et[vt]), ge++;
                  else if (et.length < vt + 1)
                    xe > 1 && vt > 2 && (xe > 4 ? (wt += `
`.concat(J, "...").concat(xt), G = !0) : xe > 3 && (wt += `
  `.concat(Z[vt - 2]), ge++), wt += `
  `.concat(Z[vt - 1]), ge++), Ft = vt, wt += `
`.concat(ft, "+").concat(xt, " ").concat(Z[vt]), ge++;
                  else {
                    var Fe = et[vt], Zt = Z[vt], qt = Zt !== Fe && (!z(Zt, ",") || Zt.slice(0, -1) !== Fe);
                    qt && z(Fe, ",") && Fe.slice(0, -1) === Zt && (qt = !1, Zt += ","), qt ? (xe > 1 && vt > 2 && (xe > 4 ? (wt += `
`.concat(J, "...").concat(xt), G = !0) : xe > 3 && (wt += `
  `.concat(Z[vt - 2]), ge++), wt += `
  `.concat(Z[vt - 1]), ge++), Ft = vt, wt += `
`.concat(ft, "+").concat(xt, " ").concat(Zt), rt += `
`.concat(Q, "-").concat(xt, " ").concat(Fe), ge += 2) : (wt += rt, rt = "", (xe === 1 || vt === 0) && (wt += `
  `.concat(Zt), ge++));
                  }
                  if (ge > 20 && vt < se - 2)
                    return "".concat(Re).concat(Te, `
`).concat(wt, `
`).concat(J, "...").concat(xt).concat(rt, `
`) + "".concat(J, "...").concat(xt);
                }
                return "".concat(Re).concat(G ? Te : "", `
`).concat(wt).concat(rt).concat(zt).concat(lt);
              }
              var Dt = /* @__PURE__ */ function(X, gt) {
                S(rt, X);
                var st = y(rt);
                function rt(wt) {
                  var Ft;
                  if (v(this, rt), P(wt) !== "object" || wt === null)
                    throw new M("options", "Object", wt);
                  var zt = wt.message, G = wt.operator, D = wt.stackStartFn, Z = wt.actual, et = wt.expected, vt = Error.stackTraceLimit;
                  if (Error.stackTraceLimit = 0, zt != null)
                    Ft = st.call(this, String(zt));
                  else if (s.stderr && s.stderr.isTTY && (s.stderr && s.stderr.getColorDepth && s.stderr.getColorDepth() !== 1 ? (J = "\x1B[34m", ft = "\x1B[32m", xt = "\x1B[39m", Q = "\x1B[31m") : (J = "", ft = "", xt = "", Q = "")), P(Z) === "object" && Z !== null && P(et) === "object" && et !== null && "stack" in Z && Z instanceof Error && "stack" in et && et instanceof Error && (Z = Gt(Z), et = Gt(et)), G === "deepStrictEqual" || G === "strictEqual")
                    Ft = st.call(this, bt(Z, et, G));
                  else if (G === "notDeepStrictEqual" || G === "notStrictEqual") {
                    var lt = St[G], dt = Rt(Z).split(`
`);
                    if (G === "notStrictEqual" && P(Z) === "object" && Z !== null && (lt = St.notStrictEqualObject), dt.length > 30)
                      for (dt[26] = "".concat(J, "...").concat(xt); dt.length > 27; )
                        dt.pop();
                    dt.length === 1 ? Ft = st.call(this, "".concat(lt, " ").concat(dt[0])) : Ft = st.call(this, "".concat(lt, `

`).concat(dt.join(`
`), `
`));
                  } else {
                    var kt = Rt(Z), jt = "", me = St[G];
                    G === "notDeepEqual" || G === "notEqual" ? (kt = "".concat(St[G], `

`).concat(kt), kt.length > 1024 && (kt = "".concat(kt.slice(0, 1021), "..."))) : (jt = "".concat(Rt(et)), kt.length > 512 && (kt = "".concat(kt.slice(0, 509), "...")), jt.length > 512 && (jt = "".concat(jt.slice(0, 509), "...")), G === "deepEqual" || G === "equal" ? kt = "".concat(me, `

`).concat(kt, `

should equal

`) : jt = " ".concat(G, " ").concat(jt)), Ft = st.call(this, "".concat(kt).concat(jt));
                  }
                  return Error.stackTraceLimit = vt, Ft.generatedMessage = !zt, Object.defineProperty(n(Ft), "name", {
                    value: "AssertionError [ERR_ASSERTION]",
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                  }), Ft.code = "ERR_ASSERTION", Ft.actual = Z, Ft.expected = et, Ft.operator = G, Error.captureStackTrace && Error.captureStackTrace(n(Ft), D), Ft.stack, Ft.name = "AssertionError", b(Ft);
                }
                return m(rt, [{
                  key: "toString",
                  value: function() {
                    return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
                  }
                }, {
                  key: gt,
                  value: function(Ft, zt) {
                    return F(this, f(f({}, zt), {}, {
                      customInspect: !1,
                      depth: 0
                    }));
                  }
                }]), rt;
              }(/* @__PURE__ */ w(Error), F.custom);
              u.exports = Dt;
            }
          ),
          /***/
          35403: (
            /***/
            function(u, l, e) {
              function s(F) {
                "@babel/helpers - typeof";
                return s = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(B) {
                  return typeof B;
                } : function(B) {
                  return B && typeof Symbol == "function" && B.constructor === Symbol && B !== Symbol.prototype ? "symbol" : typeof B;
                }, s(F);
              }
              function i(F, B) {
                for (var M = 0; M < B.length; M++) {
                  var z = B[M];
                  z.enumerable = z.enumerable || !1, z.configurable = !0, "value" in z && (z.writable = !0), Object.defineProperty(F, h(z.key), z);
                }
              }
              function f(F, B, M) {
                return B && i(F.prototype, B), M && i(F, M), Object.defineProperty(F, "prototype", { writable: !1 }), F;
              }
              function h(F) {
                var B = v(F, "string");
                return s(B) === "symbol" ? B : String(B);
              }
              function v(F, B) {
                if (s(F) !== "object" || F === null)
                  return F;
                var M = F[Symbol.toPrimitive];
                if (M !== void 0) {
                  var z = M.call(F, B || "default");
                  if (s(z) !== "object")
                    return z;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (B === "string" ? String : Number)(F);
              }
              function p(F, B) {
                if (!(F instanceof B))
                  throw new TypeError("Cannot call a class as a function");
              }
              function m(F, B) {
                if (typeof B != "function" && B !== null)
                  throw new TypeError("Super expression must either be null or a function");
                F.prototype = Object.create(B && B.prototype, { constructor: { value: F, writable: !0, configurable: !0 } }), Object.defineProperty(F, "prototype", { writable: !1 }), B && x(F, B);
              }
              function x(F, B) {
                return x = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(z, L) {
                  return z.__proto__ = L, z;
                }, x(F, B);
              }
              function g(F) {
                var B = b();
                return function() {
                  var z = n(F), L;
                  if (B) {
                    var J = n(this).constructor;
                    L = Reflect.construct(z, arguments, J);
                  } else
                    L = z.apply(this, arguments);
                  return S(this, L);
                };
              }
              function S(F, B) {
                if (B && (s(B) === "object" || typeof B == "function"))
                  return B;
                if (B !== void 0)
                  throw new TypeError("Derived constructors may only return object or undefined");
                return y(F);
              }
              function y(F) {
                if (F === void 0)
                  throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return F;
              }
              function b() {
                if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                  return !1;
                if (typeof Proxy == "function")
                  return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                  })), !0;
                } catch {
                  return !1;
                }
              }
              function n(F) {
                return n = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(M) {
                  return M.__proto__ || Object.getPrototypeOf(M);
                }, n(F);
              }
              var w = {}, E, A;
              function O(F, B, M) {
                M || (M = Error);
                function z(J, ft, Q) {
                  return typeof B == "string" ? B : B(J, ft, Q);
                }
                var L = /* @__PURE__ */ function(J) {
                  m(Q, J);
                  var ft = g(Q);
                  function Q(xt, St, Pt) {
                    var Gt;
                    return p(this, Q), Gt = ft.call(this, z(xt, St, Pt)), Gt.code = F, Gt;
                  }
                  return f(Q);
                }(M);
                w[F] = L;
              }
              function C(F, B) {
                if (Array.isArray(F)) {
                  var M = F.length;
                  return F = F.map(function(z) {
                    return String(z);
                  }), M > 2 ? "one of ".concat(B, " ").concat(F.slice(0, M - 1).join(", "), ", or ") + F[M - 1] : M === 2 ? "one of ".concat(B, " ").concat(F[0], " or ").concat(F[1]) : "of ".concat(B, " ").concat(F[0]);
                } else
                  return "of ".concat(B, " ").concat(String(F));
              }
              function T(F, B, M) {
                return F.substr(!M || M < 0 ? 0 : +M, B.length) === B;
              }
              function P(F, B, M) {
                return (M === void 0 || M > F.length) && (M = F.length), F.substring(M - B.length, M) === B;
              }
              function I(F, B, M) {
                return typeof M != "number" && (M = 0), M + B.length > F.length ? !1 : F.indexOf(B, M) !== -1;
              }
              O("ERR_AMBIGUOUS_ARGUMENT", 'The "%s" argument is ambiguous. %s', TypeError), O("ERR_INVALID_ARG_TYPE", function(F, B, M) {
                E === void 0 && (E = e(80182)), E(typeof F == "string", "'name' must be a string");
                var z;
                typeof B == "string" && T(B, "not ") ? (z = "must not be", B = B.replace(/^not /, "")) : z = "must be";
                var L;
                if (P(F, " argument"))
                  L = "The ".concat(F, " ").concat(z, " ").concat(C(B, "type"));
                else {
                  var J = I(F, ".") ? "property" : "argument";
                  L = 'The "'.concat(F, '" ').concat(J, " ").concat(z, " ").concat(C(B, "type"));
                }
                return L += ". Received type ".concat(s(M)), L;
              }, TypeError), O("ERR_INVALID_ARG_VALUE", function(F, B) {
                var M = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "is invalid";
                A === void 0 && (A = e(7187));
                var z = A.inspect(B);
                return z.length > 128 && (z = "".concat(z.slice(0, 128), "...")), "The argument '".concat(F, "' ").concat(M, ". Received ").concat(z);
              }, TypeError), O("ERR_INVALID_RETURN_VALUE", function(F, B, M) {
                var z;
                return M && M.constructor && M.constructor.name ? z = "instance of ".concat(M.constructor.name) : z = "type ".concat(s(M)), "Expected ".concat(F, ' to be returned from the "').concat(B, '"') + " function but got ".concat(z, ".");
              }, TypeError), O("ERR_MISSING_ARGS", function() {
                for (var F = arguments.length, B = new Array(F), M = 0; M < F; M++)
                  B[M] = arguments[M];
                E === void 0 && (E = e(80182)), E(B.length > 0, "At least one arg needs to be specified");
                var z = "The ", L = B.length;
                switch (B = B.map(function(J) {
                  return '"'.concat(J, '"');
                }), L) {
                  case 1:
                    z += "".concat(B[0], " argument");
                    break;
                  case 2:
                    z += "".concat(B[0], " and ").concat(B[1], " arguments");
                    break;
                  default:
                    z += B.slice(0, L - 1).join(", "), z += ", and ".concat(B[L - 1], " arguments");
                    break;
                }
                return "".concat(z, " must be specified");
              }, TypeError), u.exports.codes = w;
            }
          ),
          /***/
          86781: (
            /***/
            function(u, l, e) {
              function s(Zt, qt) {
                return p(Zt) || v(Zt, qt) || f(Zt, qt) || i();
              }
              function i() {
                throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }
              function f(Zt, qt) {
                if (Zt) {
                  if (typeof Zt == "string")
                    return h(Zt, qt);
                  var ve = Object.prototype.toString.call(Zt).slice(8, -1);
                  if (ve === "Object" && Zt.constructor && (ve = Zt.constructor.name), ve === "Map" || ve === "Set")
                    return Array.from(Zt);
                  if (ve === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ve))
                    return h(Zt, qt);
                }
              }
              function h(Zt, qt) {
                (qt == null || qt > Zt.length) && (qt = Zt.length);
                for (var ve = 0, Se = new Array(qt); ve < qt; ve++)
                  Se[ve] = Zt[ve];
                return Se;
              }
              function v(Zt, qt) {
                var ve = Zt == null ? null : typeof Symbol < "u" && Zt[Symbol.iterator] || Zt["@@iterator"];
                if (ve != null) {
                  var Se, Pe, Be, De, It = [], he = !0, nt = !1;
                  try {
                    if (Be = (ve = ve.call(Zt)).next, qt === 0) {
                      if (Object(ve) !== ve)
                        return;
                      he = !1;
                    } else
                      for (; !(he = (Se = Be.call(ve)).done) && (It.push(Se.value), It.length !== qt); he = !0)
                        ;
                  } catch (j) {
                    nt = !0, Pe = j;
                  } finally {
                    try {
                      if (!he && ve.return != null && (De = ve.return(), Object(De) !== De))
                        return;
                    } finally {
                      if (nt)
                        throw Pe;
                    }
                  }
                  return It;
                }
              }
              function p(Zt) {
                if (Array.isArray(Zt))
                  return Zt;
              }
              function m(Zt) {
                "@babel/helpers - typeof";
                return m = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(qt) {
                  return typeof qt;
                } : function(qt) {
                  return qt && typeof Symbol == "function" && qt.constructor === Symbol && qt !== Symbol.prototype ? "symbol" : typeof qt;
                }, m(Zt);
              }
              var x = /a/g.flags !== void 0, g = function(qt) {
                var ve = [];
                return qt.forEach(function(Se) {
                  return ve.push(Se);
                }), ve;
              }, S = function(qt) {
                var ve = [];
                return qt.forEach(function(Se, Pe) {
                  return ve.push([Pe, Se]);
                }), ve;
              }, y = Object.is ? Object.is : e(98527), b = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
                return [];
              }, n = Number.isNaN ? Number.isNaN : e(7051);
              function w(Zt) {
                return Zt.call.bind(Zt);
              }
              var E = w(Object.prototype.hasOwnProperty), A = w(Object.prototype.propertyIsEnumerable), O = w(Object.prototype.toString), C = e(7187).types, T = C.isAnyArrayBuffer, P = C.isArrayBufferView, I = C.isDate, F = C.isMap, B = C.isRegExp, M = C.isSet, z = C.isNativeError, L = C.isBoxedPrimitive, J = C.isNumberObject, ft = C.isStringObject, Q = C.isBooleanObject, xt = C.isBigIntObject, St = C.isSymbolObject, Pt = C.isFloat32Array, Gt = C.isFloat64Array;
              function Rt(Zt) {
                if (Zt.length === 0 || Zt.length > 10)
                  return !0;
                for (var qt = 0; qt < Zt.length; qt++) {
                  var ve = Zt.charCodeAt(qt);
                  if (ve < 48 || ve > 57)
                    return !0;
                }
                return Zt.length === 10 && Zt >= Math.pow(2, 32);
              }
              function bt(Zt) {
                return Object.keys(Zt).filter(Rt).concat(b(Zt).filter(Object.prototype.propertyIsEnumerable.bind(Zt)));
              }
              /*!
               * The buffer module from node.js, for the browser.
               *
               * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
               * @license  MIT
               */
              function Dt(Zt, qt) {
                if (Zt === qt)
                  return 0;
                for (var ve = Zt.length, Se = qt.length, Pe = 0, Be = Math.min(ve, Se); Pe < Be; ++Pe)
                  if (Zt[Pe] !== qt[Pe]) {
                    ve = Zt[Pe], Se = qt[Pe];
                    break;
                  }
                return ve < Se ? -1 : Se < ve ? 1 : 0;
              }
              var X = !0, gt = !1, st = 0, rt = 1, wt = 2, Ft = 3;
              function zt(Zt, qt) {
                return x ? Zt.source === qt.source && Zt.flags === qt.flags : RegExp.prototype.toString.call(Zt) === RegExp.prototype.toString.call(qt);
              }
              function G(Zt, qt) {
                if (Zt.byteLength !== qt.byteLength)
                  return !1;
                for (var ve = 0; ve < Zt.byteLength; ve++)
                  if (Zt[ve] !== qt[ve])
                    return !1;
                return !0;
              }
              function D(Zt, qt) {
                return Zt.byteLength !== qt.byteLength ? !1 : Dt(new Uint8Array(Zt.buffer, Zt.byteOffset, Zt.byteLength), new Uint8Array(qt.buffer, qt.byteOffset, qt.byteLength)) === 0;
              }
              function Z(Zt, qt) {
                return Zt.byteLength === qt.byteLength && Dt(new Uint8Array(Zt), new Uint8Array(qt)) === 0;
              }
              function et(Zt, qt) {
                return J(Zt) ? J(qt) && y(Number.prototype.valueOf.call(Zt), Number.prototype.valueOf.call(qt)) : ft(Zt) ? ft(qt) && String.prototype.valueOf.call(Zt) === String.prototype.valueOf.call(qt) : Q(Zt) ? Q(qt) && Boolean.prototype.valueOf.call(Zt) === Boolean.prototype.valueOf.call(qt) : xt(Zt) ? xt(qt) && BigInt.prototype.valueOf.call(Zt) === BigInt.prototype.valueOf.call(qt) : St(qt) && Symbol.prototype.valueOf.call(Zt) === Symbol.prototype.valueOf.call(qt);
              }
              function vt(Zt, qt, ve, Se) {
                if (Zt === qt)
                  return Zt !== 0 ? !0 : ve ? y(Zt, qt) : !0;
                if (ve) {
                  if (m(Zt) !== "object")
                    return typeof Zt == "number" && n(Zt) && n(qt);
                  if (m(qt) !== "object" || Zt === null || qt === null || Object.getPrototypeOf(Zt) !== Object.getPrototypeOf(qt))
                    return !1;
                } else {
                  if (Zt === null || m(Zt) !== "object")
                    return qt === null || m(qt) !== "object" ? Zt == qt : !1;
                  if (qt === null || m(qt) !== "object")
                    return !1;
                }
                var Pe = O(Zt), Be = O(qt);
                if (Pe !== Be)
                  return !1;
                if (Array.isArray(Zt)) {
                  if (Zt.length !== qt.length)
                    return !1;
                  var De = bt(Zt), It = bt(qt);
                  return De.length !== It.length ? !1 : dt(Zt, qt, ve, Se, rt, De);
                }
                if (Pe === "[object Object]" && (!F(Zt) && F(qt) || !M(Zt) && M(qt)))
                  return !1;
                if (I(Zt)) {
                  if (!I(qt) || Date.prototype.getTime.call(Zt) !== Date.prototype.getTime.call(qt))
                    return !1;
                } else if (B(Zt)) {
                  if (!B(qt) || !zt(Zt, qt))
                    return !1;
                } else if (z(Zt) || Zt instanceof Error) {
                  if (Zt.message !== qt.message || Zt.name !== qt.name)
                    return !1;
                } else if (P(Zt)) {
                  if (!ve && (Pt(Zt) || Gt(Zt))) {
                    if (!G(Zt, qt))
                      return !1;
                  } else if (!D(Zt, qt))
                    return !1;
                  var he = bt(Zt), nt = bt(qt);
                  return he.length !== nt.length ? !1 : dt(Zt, qt, ve, Se, st, he);
                } else {
                  if (M(Zt))
                    return !M(qt) || Zt.size !== qt.size ? !1 : dt(Zt, qt, ve, Se, wt);
                  if (F(Zt))
                    return !F(qt) || Zt.size !== qt.size ? !1 : dt(Zt, qt, ve, Se, Ft);
                  if (T(Zt)) {
                    if (!Z(Zt, qt))
                      return !1;
                  } else if (L(Zt) && !et(Zt, qt))
                    return !1;
                }
                return dt(Zt, qt, ve, Se, st);
              }
              function lt(Zt, qt) {
                return qt.filter(function(ve) {
                  return A(Zt, ve);
                });
              }
              function dt(Zt, qt, ve, Se, Pe, Be) {
                if (arguments.length === 5) {
                  Be = Object.keys(Zt);
                  var De = Object.keys(qt);
                  if (Be.length !== De.length)
                    return !1;
                }
                for (var It = 0; It < Be.length; It++)
                  if (!E(qt, Be[It]))
                    return !1;
                if (ve && arguments.length === 5) {
                  var he = b(Zt);
                  if (he.length !== 0) {
                    var nt = 0;
                    for (It = 0; It < he.length; It++) {
                      var j = he[It];
                      if (A(Zt, j)) {
                        if (!A(qt, j))
                          return !1;
                        Be.push(j), nt++;
                      } else if (A(qt, j))
                        return !1;
                    }
                    var V = b(qt);
                    if (he.length !== V.length && lt(qt, V).length !== nt)
                      return !1;
                  } else {
                    var yt = b(qt);
                    if (yt.length !== 0 && lt(qt, yt).length !== 0)
                      return !1;
                  }
                }
                if (Be.length === 0 && (Pe === st || Pe === rt && Zt.length === 0 || Zt.size === 0))
                  return !0;
                if (Se === void 0)
                  Se = {
                    val1: /* @__PURE__ */ new Map(),
                    val2: /* @__PURE__ */ new Map(),
                    position: 0
                  };
                else {
                  var it = Se.val1.get(Zt);
                  if (it !== void 0) {
                    var _t = Se.val2.get(qt);
                    if (_t !== void 0)
                      return it === _t;
                  }
                  Se.position++;
                }
                Se.val1.set(Zt, Se.position), Se.val2.set(qt, Se.position);
                var ne = Te(Zt, qt, ve, Be, Se, Pe);
                return Se.val1.delete(Zt), Se.val2.delete(qt), ne;
              }
              function kt(Zt, qt, ve, Se) {
                for (var Pe = g(Zt), Be = 0; Be < Pe.length; Be++) {
                  var De = Pe[Be];
                  if (vt(qt, De, ve, Se))
                    return Zt.delete(De), !0;
                }
                return !1;
              }
              function jt(Zt) {
                switch (m(Zt)) {
                  case "undefined":
                    return null;
                  case "object":
                    return;
                  case "symbol":
                    return !1;
                  case "string":
                    Zt = +Zt;
                  case "number":
                    if (n(Zt))
                      return !1;
                }
                return !0;
              }
              function me(Zt, qt, ve) {
                var Se = jt(ve);
                return Se ?? (qt.has(Se) && !Zt.has(Se));
              }
              function se(Zt, qt, ve, Se, Pe) {
                var Be = jt(ve);
                if (Be != null)
                  return Be;
                var De = qt.get(Be);
                return De === void 0 && !qt.has(Be) || !vt(Se, De, !1, Pe) ? !1 : !Zt.has(Be) && vt(Se, De, !1, Pe);
              }
              function Bt(Zt, qt, ve, Se) {
                for (var Pe = null, Be = g(Zt), De = 0; De < Be.length; De++) {
                  var It = Be[De];
                  if (m(It) === "object" && It !== null)
                    Pe === null && (Pe = /* @__PURE__ */ new Set()), Pe.add(It);
                  else if (!qt.has(It)) {
                    if (ve || !me(Zt, qt, It))
                      return !1;
                    Pe === null && (Pe = /* @__PURE__ */ new Set()), Pe.add(It);
                  }
                }
                if (Pe !== null) {
                  for (var he = g(qt), nt = 0; nt < he.length; nt++) {
                    var j = he[nt];
                    if (m(j) === "object" && j !== null) {
                      if (!kt(Pe, j, ve, Se))
                        return !1;
                    } else if (!ve && !Zt.has(j) && !kt(Pe, j, ve, Se))
                      return !1;
                  }
                  return Pe.size === 0;
                }
                return !0;
              }
              function ge(Zt, qt, ve, Se, Pe, Be) {
                for (var De = g(Zt), It = 0; It < De.length; It++) {
                  var he = De[It];
                  if (vt(ve, he, Pe, Be) && vt(Se, qt.get(he), Pe, Be))
                    return Zt.delete(he), !0;
                }
                return !1;
              }
              function Re(Zt, qt, ve, Se) {
                for (var Pe = null, Be = S(Zt), De = 0; De < Be.length; De++) {
                  var It = s(Be[De], 2), he = It[0], nt = It[1];
                  if (m(he) === "object" && he !== null)
                    Pe === null && (Pe = /* @__PURE__ */ new Set()), Pe.add(he);
                  else {
                    var j = qt.get(he);
                    if (j === void 0 && !qt.has(he) || !vt(nt, j, ve, Se)) {
                      if (ve || !se(Zt, qt, he, nt, Se))
                        return !1;
                      Pe === null && (Pe = /* @__PURE__ */ new Set()), Pe.add(he);
                    }
                  }
                }
                if (Pe !== null) {
                  for (var V = S(qt), yt = 0; yt < V.length; yt++) {
                    var it = s(V[yt], 2), _t = it[0], ne = it[1];
                    if (m(_t) === "object" && _t !== null) {
                      if (!ge(Pe, Zt, _t, ne, ve, Se))
                        return !1;
                    } else if (!ve && (!Zt.has(_t) || !vt(Zt.get(_t), ne, !1, Se)) && !ge(Pe, Zt, _t, ne, !1, Se))
                      return !1;
                  }
                  return Pe.size === 0;
                }
                return !0;
              }
              function Te(Zt, qt, ve, Se, Pe, Be) {
                var De = 0;
                if (Be === wt) {
                  if (!Bt(Zt, qt, ve, Pe))
                    return !1;
                } else if (Be === Ft) {
                  if (!Re(Zt, qt, ve, Pe))
                    return !1;
                } else if (Be === rt)
                  for (; De < Zt.length; De++)
                    if (E(Zt, De)) {
                      if (!E(qt, De) || !vt(Zt[De], qt[De], ve, Pe))
                        return !1;
                    } else {
                      if (E(qt, De))
                        return !1;
                      for (var It = Object.keys(Zt); De < It.length; De++) {
                        var he = It[De];
                        if (!E(qt, he) || !vt(Zt[he], qt[he], ve, Pe))
                          return !1;
                      }
                      return It.length === Object.keys(qt).length;
                    }
                for (De = 0; De < Se.length; De++) {
                  var nt = Se[De];
                  if (!vt(Zt[nt], qt[nt], ve, Pe))
                    return !1;
                }
                return !0;
              }
              function xe(Zt, qt) {
                return vt(Zt, qt, gt);
              }
              function Fe(Zt, qt) {
                return vt(Zt, qt, X);
              }
              u.exports = {
                isDeepEqual: xe,
                isDeepStrictEqual: Fe
              };
            }
          ),
          /***/
          32504: (
            /***/
            function(u, l) {
              l.byteLength = m, l.toByteArray = g, l.fromByteArray = b;
              for (var e = [], s = [], i = typeof Uint8Array < "u" ? Uint8Array : Array, f = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", h = 0, v = f.length; h < v; ++h)
                e[h] = f[h], s[f.charCodeAt(h)] = h;
              s["-".charCodeAt(0)] = 62, s["_".charCodeAt(0)] = 63;
              function p(n) {
                var w = n.length;
                if (w % 4 > 0)
                  throw new Error("Invalid string. Length must be a multiple of 4");
                var E = n.indexOf("=");
                E === -1 && (E = w);
                var A = E === w ? 0 : 4 - E % 4;
                return [E, A];
              }
              function m(n) {
                var w = p(n), E = w[0], A = w[1];
                return (E + A) * 3 / 4 - A;
              }
              function x(n, w, E) {
                return (w + E) * 3 / 4 - E;
              }
              function g(n) {
                var w, E = p(n), A = E[0], O = E[1], C = new i(x(n, A, O)), T = 0, P = O > 0 ? A - 4 : A, I;
                for (I = 0; I < P; I += 4)
                  w = s[n.charCodeAt(I)] << 18 | s[n.charCodeAt(I + 1)] << 12 | s[n.charCodeAt(I + 2)] << 6 | s[n.charCodeAt(I + 3)], C[T++] = w >> 16 & 255, C[T++] = w >> 8 & 255, C[T++] = w & 255;
                return O === 2 && (w = s[n.charCodeAt(I)] << 2 | s[n.charCodeAt(I + 1)] >> 4, C[T++] = w & 255), O === 1 && (w = s[n.charCodeAt(I)] << 10 | s[n.charCodeAt(I + 1)] << 4 | s[n.charCodeAt(I + 2)] >> 2, C[T++] = w >> 8 & 255, C[T++] = w & 255), C;
              }
              function S(n) {
                return e[n >> 18 & 63] + e[n >> 12 & 63] + e[n >> 6 & 63] + e[n & 63];
              }
              function y(n, w, E) {
                for (var A, O = [], C = w; C < E; C += 3)
                  A = (n[C] << 16 & 16711680) + (n[C + 1] << 8 & 65280) + (n[C + 2] & 255), O.push(S(A));
                return O.join("");
              }
              function b(n) {
                for (var w, E = n.length, A = E % 3, O = [], C = 16383, T = 0, P = E - A; T < P; T += C)
                  O.push(y(
                    n,
                    T,
                    T + C > P ? P : T + C
                  ));
                return A === 1 ? (w = n[E - 1], O.push(
                  e[w >> 2] + e[w << 4 & 63] + "=="
                )) : A === 2 && (w = (n[E - 2] << 8) + n[E - 1], O.push(
                  e[w >> 10] + e[w >> 4 & 63] + e[w << 2 & 63] + "="
                )), O.join("");
              }
            }
          ),
          /***/
          34097: (
            /***/
            function(u) {
              var l = 4096, e = 2 * l + 32, s = 2 * l - 1, i = new Uint32Array([
                0,
                1,
                3,
                7,
                15,
                31,
                63,
                127,
                255,
                511,
                1023,
                2047,
                4095,
                8191,
                16383,
                32767,
                65535,
                131071,
                262143,
                524287,
                1048575,
                2097151,
                4194303,
                8388607,
                16777215
              ]);
              function f(h) {
                this.buf_ = new Uint8Array(e), this.input_ = h, this.reset();
              }
              f.READ_SIZE = l, f.IBUF_MASK = s, f.prototype.reset = function() {
                this.buf_ptr_ = 0, this.val_ = 0, this.pos_ = 0, this.bit_pos_ = 0, this.bit_end_pos_ = 0, this.eos_ = 0, this.readMoreInput();
                for (var h = 0; h < 4; h++)
                  this.val_ |= this.buf_[this.pos_] << 8 * h, ++this.pos_;
                return this.bit_end_pos_ > 0;
              }, f.prototype.readMoreInput = function() {
                if (!(this.bit_end_pos_ > 256))
                  if (this.eos_) {
                    if (this.bit_pos_ > this.bit_end_pos_)
                      throw new Error("Unexpected end of input " + this.bit_pos_ + " " + this.bit_end_pos_);
                  } else {
                    var h = this.buf_ptr_, v = this.input_.read(this.buf_, h, l);
                    if (v < 0)
                      throw new Error("Unexpected end of input");
                    if (v < l) {
                      this.eos_ = 1;
                      for (var p = 0; p < 32; p++)
                        this.buf_[h + v + p] = 0;
                    }
                    if (h === 0) {
                      for (var p = 0; p < 32; p++)
                        this.buf_[(l << 1) + p] = this.buf_[p];
                      this.buf_ptr_ = l;
                    } else
                      this.buf_ptr_ = 0;
                    this.bit_end_pos_ += v << 3;
                  }
              }, f.prototype.fillBitWindow = function() {
                for (; this.bit_pos_ >= 8; )
                  this.val_ >>>= 8, this.val_ |= this.buf_[this.pos_ & s] << 24, ++this.pos_, this.bit_pos_ = this.bit_pos_ - 8 >>> 0, this.bit_end_pos_ = this.bit_end_pos_ - 8 >>> 0;
              }, f.prototype.readBits = function(h) {
                32 - this.bit_pos_ < h && this.fillBitWindow();
                var v = this.val_ >>> this.bit_pos_ & i[h];
                return this.bit_pos_ += h, v;
              }, u.exports = f;
            }
          ),
          /***/
          7043: (
            /***/
            function(u, l) {
              l.lookup = new Uint8Array([
                /* CONTEXT_UTF8, last byte. */
                /* ASCII range. */
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                4,
                4,
                0,
                0,
                4,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                8,
                12,
                16,
                12,
                12,
                20,
                12,
                16,
                24,
                28,
                12,
                12,
                32,
                12,
                36,
                12,
                44,
                44,
                44,
                44,
                44,
                44,
                44,
                44,
                44,
                44,
                32,
                32,
                24,
                40,
                28,
                12,
                12,
                48,
                52,
                52,
                52,
                48,
                52,
                52,
                52,
                48,
                52,
                52,
                52,
                52,
                52,
                48,
                52,
                52,
                52,
                52,
                52,
                48,
                52,
                52,
                52,
                52,
                52,
                24,
                12,
                28,
                12,
                12,
                12,
                56,
                60,
                60,
                60,
                56,
                60,
                60,
                60,
                56,
                60,
                60,
                60,
                60,
                60,
                56,
                60,
                60,
                60,
                60,
                60,
                56,
                60,
                60,
                60,
                60,
                60,
                24,
                12,
                28,
                12,
                0,
                /* UTF8 continuation byte range. */
                0,
                1,
                0,
                1,
                0,
                1,
                0,
                1,
                0,
                1,
                0,
                1,
                0,
                1,
                0,
                1,
                0,
                1,
                0,
                1,
                0,
                1,
                0,
                1,
                0,
                1,
                0,
                1,
                0,
                1,
                0,
                1,
                0,
                1,
                0,
                1,
                0,
                1,
                0,
                1,
                0,
                1,
                0,
                1,
                0,
                1,
                0,
                1,
                0,
                1,
                0,
                1,
                0,
                1,
                0,
                1,
                0,
                1,
                0,
                1,
                0,
                1,
                0,
                1,
                /* UTF8 lead byte range. */
                2,
                3,
                2,
                3,
                2,
                3,
                2,
                3,
                2,
                3,
                2,
                3,
                2,
                3,
                2,
                3,
                2,
                3,
                2,
                3,
                2,
                3,
                2,
                3,
                2,
                3,
                2,
                3,
                2,
                3,
                2,
                3,
                2,
                3,
                2,
                3,
                2,
                3,
                2,
                3,
                2,
                3,
                2,
                3,
                2,
                3,
                2,
                3,
                2,
                3,
                2,
                3,
                2,
                3,
                2,
                3,
                2,
                3,
                2,
                3,
                2,
                3,
                2,
                3,
                /* CONTEXT_UTF8 second last byte. */
                /* ASCII range. */
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                1,
                1,
                1,
                1,
                1,
                1,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                1,
                1,
                1,
                1,
                0,
                /* UTF8 continuation byte range. */
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                /* UTF8 lead byte range. */
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                /* CONTEXT_SIGNED, second last byte. */
                0,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                4,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                6,
                6,
                6,
                6,
                6,
                6,
                6,
                6,
                6,
                6,
                6,
                6,
                6,
                6,
                6,
                7,
                /* CONTEXT_SIGNED, last byte, same as the above values shifted by 3 bits. */
                0,
                8,
                8,
                8,
                8,
                8,
                8,
                8,
                8,
                8,
                8,
                8,
                8,
                8,
                8,
                8,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                48,
                48,
                48,
                48,
                48,
                48,
                48,
                48,
                48,
                48,
                48,
                48,
                48,
                48,
                48,
                56,
                /* CONTEXT_LSB6, last byte. */
                0,
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17,
                18,
                19,
                20,
                21,
                22,
                23,
                24,
                25,
                26,
                27,
                28,
                29,
                30,
                31,
                32,
                33,
                34,
                35,
                36,
                37,
                38,
                39,
                40,
                41,
                42,
                43,
                44,
                45,
                46,
                47,
                48,
                49,
                50,
                51,
                52,
                53,
                54,
                55,
                56,
                57,
                58,
                59,
                60,
                61,
                62,
                63,
                0,
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17,
                18,
                19,
                20,
                21,
                22,
                23,
                24,
                25,
                26,
                27,
                28,
                29,
                30,
                31,
                32,
                33,
                34,
                35,
                36,
                37,
                38,
                39,
                40,
                41,
                42,
                43,
                44,
                45,
                46,
                47,
                48,
                49,
                50,
                51,
                52,
                53,
                54,
                55,
                56,
                57,
                58,
                59,
                60,
                61,
                62,
                63,
                0,
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17,
                18,
                19,
                20,
                21,
                22,
                23,
                24,
                25,
                26,
                27,
                28,
                29,
                30,
                31,
                32,
                33,
                34,
                35,
                36,
                37,
                38,
                39,
                40,
                41,
                42,
                43,
                44,
                45,
                46,
                47,
                48,
                49,
                50,
                51,
                52,
                53,
                54,
                55,
                56,
                57,
                58,
                59,
                60,
                61,
                62,
                63,
                0,
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17,
                18,
                19,
                20,
                21,
                22,
                23,
                24,
                25,
                26,
                27,
                28,
                29,
                30,
                31,
                32,
                33,
                34,
                35,
                36,
                37,
                38,
                39,
                40,
                41,
                42,
                43,
                44,
                45,
                46,
                47,
                48,
                49,
                50,
                51,
                52,
                53,
                54,
                55,
                56,
                57,
                58,
                59,
                60,
                61,
                62,
                63,
                /* CONTEXT_MSB6, last byte. */
                0,
                0,
                0,
                0,
                1,
                1,
                1,
                1,
                2,
                2,
                2,
                2,
                3,
                3,
                3,
                3,
                4,
                4,
                4,
                4,
                5,
                5,
                5,
                5,
                6,
                6,
                6,
                6,
                7,
                7,
                7,
                7,
                8,
                8,
                8,
                8,
                9,
                9,
                9,
                9,
                10,
                10,
                10,
                10,
                11,
                11,
                11,
                11,
                12,
                12,
                12,
                12,
                13,
                13,
                13,
                13,
                14,
                14,
                14,
                14,
                15,
                15,
                15,
                15,
                16,
                16,
                16,
                16,
                17,
                17,
                17,
                17,
                18,
                18,
                18,
                18,
                19,
                19,
                19,
                19,
                20,
                20,
                20,
                20,
                21,
                21,
                21,
                21,
                22,
                22,
                22,
                22,
                23,
                23,
                23,
                23,
                24,
                24,
                24,
                24,
                25,
                25,
                25,
                25,
                26,
                26,
                26,
                26,
                27,
                27,
                27,
                27,
                28,
                28,
                28,
                28,
                29,
                29,
                29,
                29,
                30,
                30,
                30,
                30,
                31,
                31,
                31,
                31,
                32,
                32,
                32,
                32,
                33,
                33,
                33,
                33,
                34,
                34,
                34,
                34,
                35,
                35,
                35,
                35,
                36,
                36,
                36,
                36,
                37,
                37,
                37,
                37,
                38,
                38,
                38,
                38,
                39,
                39,
                39,
                39,
                40,
                40,
                40,
                40,
                41,
                41,
                41,
                41,
                42,
                42,
                42,
                42,
                43,
                43,
                43,
                43,
                44,
                44,
                44,
                44,
                45,
                45,
                45,
                45,
                46,
                46,
                46,
                46,
                47,
                47,
                47,
                47,
                48,
                48,
                48,
                48,
                49,
                49,
                49,
                49,
                50,
                50,
                50,
                50,
                51,
                51,
                51,
                51,
                52,
                52,
                52,
                52,
                53,
                53,
                53,
                53,
                54,
                54,
                54,
                54,
                55,
                55,
                55,
                55,
                56,
                56,
                56,
                56,
                57,
                57,
                57,
                57,
                58,
                58,
                58,
                58,
                59,
                59,
                59,
                59,
                60,
                60,
                60,
                60,
                61,
                61,
                61,
                61,
                62,
                62,
                62,
                62,
                63,
                63,
                63,
                63,
                /* CONTEXT_{M,L}SB6, second last byte, */
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
              ]), l.lookupOffsets = new Uint16Array([
                /* CONTEXT_LSB6 */
                1024,
                1536,
                /* CONTEXT_MSB6 */
                1280,
                1536,
                /* CONTEXT_UTF8 */
                0,
                256,
                /* CONTEXT_SIGNED */
                768,
                512
              ]);
            }
          ),
          /***/
          20980: (
            /***/
            function(u, l, e) {
              var s = e(98197).z, i = e(98197).y, f = e(34097), h = e(80614), v = e(81561).z, p = e(81561).u, m = e(7043), x = e(42210), g = e(87984), S = 8, y = 16, b = 256, n = 704, w = 26, E = 6, A = 2, O = 8, C = 255, T = 1080, P = 18, I = new Uint8Array([
                1,
                2,
                3,
                4,
                0,
                5,
                17,
                6,
                16,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15
              ]), F = 16, B = new Uint8Array([
                3,
                2,
                1,
                0,
                3,
                3,
                3,
                3,
                3,
                3,
                2,
                2,
                2,
                2,
                2,
                2
              ]), M = new Int8Array([
                0,
                0,
                0,
                0,
                -1,
                1,
                -2,
                2,
                -3,
                3,
                -1,
                1,
                -2,
                2,
                -3,
                3
              ]), z = new Uint16Array([
                256,
                402,
                436,
                468,
                500,
                534,
                566,
                598,
                630,
                662,
                694,
                726,
                758,
                790,
                822,
                854,
                886,
                920,
                952,
                984,
                1016,
                1048,
                1080
              ]);
              function L(D) {
                var Z;
                return D.readBits(1) === 0 ? 16 : (Z = D.readBits(3), Z > 0 ? 17 + Z : (Z = D.readBits(3), Z > 0 ? 8 + Z : 17));
              }
              function J(D) {
                if (D.readBits(1)) {
                  var Z = D.readBits(3);
                  return Z === 0 ? 1 : D.readBits(Z) + (1 << Z);
                }
                return 0;
              }
              function ft() {
                this.meta_block_length = 0, this.input_end = 0, this.is_uncompressed = 0, this.is_metadata = !1;
              }
              function Q(D) {
                var Z = new ft(), et, vt, lt;
                if (Z.input_end = D.readBits(1), Z.input_end && D.readBits(1))
                  return Z;
                if (et = D.readBits(2) + 4, et === 7) {
                  if (Z.is_metadata = !0, D.readBits(1) !== 0)
                    throw new Error("Invalid reserved bit");
                  if (vt = D.readBits(2), vt === 0)
                    return Z;
                  for (lt = 0; lt < vt; lt++) {
                    var dt = D.readBits(8);
                    if (lt + 1 === vt && vt > 1 && dt === 0)
                      throw new Error("Invalid size byte");
                    Z.meta_block_length |= dt << lt * 8;
                  }
                } else
                  for (lt = 0; lt < et; ++lt) {
                    var kt = D.readBits(4);
                    if (lt + 1 === et && et > 4 && kt === 0)
                      throw new Error("Invalid size nibble");
                    Z.meta_block_length |= kt << lt * 4;
                  }
                return ++Z.meta_block_length, !Z.input_end && !Z.is_metadata && (Z.is_uncompressed = D.readBits(1)), Z;
              }
              function xt(D, Z, et) {
                var vt;
                return et.fillBitWindow(), Z += et.val_ >>> et.bit_pos_ & C, vt = D[Z].bits - O, vt > 0 && (et.bit_pos_ += O, Z += D[Z].value, Z += et.val_ >>> et.bit_pos_ & (1 << vt) - 1), et.bit_pos_ += D[Z].bits, D[Z].value;
              }
              function St(D, Z, et, vt) {
                for (var lt = 0, dt = S, kt = 0, jt = 0, me = 32768, se = [], Bt = 0; Bt < 32; Bt++)
                  se.push(new v(0, 0));
                for (p(se, 0, 5, D, P); lt < Z && me > 0; ) {
                  var ge = 0, Re;
                  if (vt.readMoreInput(), vt.fillBitWindow(), ge += vt.val_ >>> vt.bit_pos_ & 31, vt.bit_pos_ += se[ge].bits, Re = se[ge].value & 255, Re < y)
                    kt = 0, et[lt++] = Re, Re !== 0 && (dt = Re, me -= 32768 >> Re);
                  else {
                    var Te = Re - 14, xe, Fe, Zt = 0;
                    if (Re === y && (Zt = dt), jt !== Zt && (kt = 0, jt = Zt), xe = kt, kt > 0 && (kt -= 2, kt <<= Te), kt += vt.readBits(Te) + 3, Fe = kt - xe, lt + Fe > Z)
                      throw new Error("[ReadHuffmanCodeLengths] symbol + repeat_delta > num_symbols");
                    for (var qt = 0; qt < Fe; qt++)
                      et[lt + qt] = jt;
                    lt += Fe, jt !== 0 && (me -= Fe << 15 - jt);
                  }
                }
                if (me !== 0)
                  throw new Error("[ReadHuffmanCodeLengths] space = " + me);
                for (; lt < Z; lt++)
                  et[lt] = 0;
              }
              function Pt(D, Z, et, vt) {
                var lt = 0, dt, kt = new Uint8Array(D);
                if (vt.readMoreInput(), dt = vt.readBits(2), dt === 1) {
                  for (var jt, me = D - 1, se = 0, Bt = new Int32Array(4), ge = vt.readBits(2) + 1; me; )
                    me >>= 1, ++se;
                  for (jt = 0; jt < ge; ++jt)
                    Bt[jt] = vt.readBits(se) % D, kt[Bt[jt]] = 2;
                  switch (kt[Bt[0]] = 1, ge) {
                    case 1:
                      break;
                    case 3:
                      if (Bt[0] === Bt[1] || Bt[0] === Bt[2] || Bt[1] === Bt[2])
                        throw new Error("[ReadHuffmanCode] invalid symbols");
                      break;
                    case 2:
                      if (Bt[0] === Bt[1])
                        throw new Error("[ReadHuffmanCode] invalid symbols");
                      kt[Bt[1]] = 1;
                      break;
                    case 4:
                      if (Bt[0] === Bt[1] || Bt[0] === Bt[2] || Bt[0] === Bt[3] || Bt[1] === Bt[2] || Bt[1] === Bt[3] || Bt[2] === Bt[3])
                        throw new Error("[ReadHuffmanCode] invalid symbols");
                      vt.readBits(1) ? (kt[Bt[2]] = 3, kt[Bt[3]] = 3) : kt[Bt[0]] = 2;
                      break;
                  }
                } else {
                  var jt, Re = new Uint8Array(P), Te = 32, xe = 0, Fe = [
                    new v(2, 0),
                    new v(2, 4),
                    new v(2, 3),
                    new v(3, 2),
                    new v(2, 0),
                    new v(2, 4),
                    new v(2, 3),
                    new v(4, 1),
                    new v(2, 0),
                    new v(2, 4),
                    new v(2, 3),
                    new v(3, 2),
                    new v(2, 0),
                    new v(2, 4),
                    new v(2, 3),
                    new v(4, 5)
                  ];
                  for (jt = dt; jt < P && Te > 0; ++jt) {
                    var Zt = I[jt], qt = 0, ve;
                    vt.fillBitWindow(), qt += vt.val_ >>> vt.bit_pos_ & 15, vt.bit_pos_ += Fe[qt].bits, ve = Fe[qt].value, Re[Zt] = ve, ve !== 0 && (Te -= 32 >> ve, ++xe);
                  }
                  if (!(xe === 1 || Te === 0))
                    throw new Error("[ReadHuffmanCode] invalid num_codes or space");
                  St(Re, D, kt, vt);
                }
                if (lt = p(Z, et, O, kt, D), lt === 0)
                  throw new Error("[ReadHuffmanCode] BuildHuffmanTable failed: ");
                return lt;
              }
              function Gt(D, Z, et) {
                var vt, lt;
                return vt = xt(D, Z, et), lt = x.kBlockLengthPrefixCode[vt].nbits, x.kBlockLengthPrefixCode[vt].offset + et.readBits(lt);
              }
              function Rt(D, Z, et) {
                var vt;
                return D < F ? (et += B[D], et &= 3, vt = Z[et] + M[D]) : vt = D - F + 1, vt;
              }
              function bt(D, Z) {
                for (var et = D[Z], vt = Z; vt; --vt)
                  D[vt] = D[vt - 1];
                D[0] = et;
              }
              function Dt(D, Z) {
                var et = new Uint8Array(256), vt;
                for (vt = 0; vt < 256; ++vt)
                  et[vt] = vt;
                for (vt = 0; vt < Z; ++vt) {
                  var lt = D[vt];
                  D[vt] = et[lt], lt && bt(et, lt);
                }
              }
              function X(D, Z) {
                this.alphabet_size = D, this.num_htrees = Z, this.codes = new Array(Z + Z * z[D + 31 >>> 5]), this.htrees = new Uint32Array(Z);
              }
              X.prototype.decode = function(D) {
                var Z, et, vt = 0;
                for (Z = 0; Z < this.num_htrees; ++Z)
                  this.htrees[Z] = vt, et = Pt(this.alphabet_size, this.codes, vt, D), vt += et;
              };
              function gt(D, Z) {
                var et = { num_htrees: null, context_map: null }, vt, lt = 0, dt, kt;
                Z.readMoreInput();
                var jt = et.num_htrees = J(Z) + 1, me = et.context_map = new Uint8Array(D);
                if (jt <= 1)
                  return et;
                for (vt = Z.readBits(1), vt && (lt = Z.readBits(4) + 1), dt = [], kt = 0; kt < T; kt++)
                  dt[kt] = new v(0, 0);
                for (Pt(jt + lt, dt, 0, Z), kt = 0; kt < D; ) {
                  var se;
                  if (Z.readMoreInput(), se = xt(dt, 0, Z), se === 0)
                    me[kt] = 0, ++kt;
                  else if (se <= lt)
                    for (var Bt = 1 + (1 << se) + Z.readBits(se); --Bt; ) {
                      if (kt >= D)
                        throw new Error("[DecodeContextMap] i >= context_map_size");
                      me[kt] = 0, ++kt;
                    }
                  else
                    me[kt] = se - lt, ++kt;
                }
                return Z.readBits(1) && Dt(me, D), et;
              }
              function st(D, Z, et, vt, lt, dt, kt) {
                var jt = et * 2, me = et, se = xt(Z, et * T, kt), Bt;
                se === 0 ? Bt = lt[jt + (dt[me] & 1)] : se === 1 ? Bt = lt[jt + (dt[me] - 1 & 1)] + 1 : Bt = se - 2, Bt >= D && (Bt -= D), vt[et] = Bt, lt[jt + (dt[me] & 1)] = Bt, ++dt[me];
              }
              function rt(D, Z, et, vt, lt, dt) {
                var kt = lt + 1, jt = et & lt, me = dt.pos_ & f.IBUF_MASK, se;
                if (Z < 8 || dt.bit_pos_ + (Z << 3) < dt.bit_end_pos_) {
                  for (; Z-- > 0; )
                    dt.readMoreInput(), vt[jt++] = dt.readBits(8), jt === kt && (D.write(vt, kt), jt = 0);
                  return;
                }
                if (dt.bit_end_pos_ < 32)
                  throw new Error("[CopyUncompressedBlockToOutput] br.bit_end_pos_ < 32");
                for (; dt.bit_pos_ < 32; )
                  vt[jt] = dt.val_ >>> dt.bit_pos_, dt.bit_pos_ += 8, ++jt, --Z;
                if (se = dt.bit_end_pos_ - dt.bit_pos_ >> 3, me + se > f.IBUF_MASK) {
                  for (var Bt = f.IBUF_MASK + 1 - me, ge = 0; ge < Bt; ge++)
                    vt[jt + ge] = dt.buf_[me + ge];
                  se -= Bt, jt += Bt, Z -= Bt, me = 0;
                }
                for (var ge = 0; ge < se; ge++)
                  vt[jt + ge] = dt.buf_[me + ge];
                if (jt += se, Z -= se, jt >= kt) {
                  D.write(vt, kt), jt -= kt;
                  for (var ge = 0; ge < jt; ge++)
                    vt[ge] = vt[kt + ge];
                }
                for (; jt + Z >= kt; ) {
                  if (se = kt - jt, dt.input_.read(vt, jt, se) < se)
                    throw new Error("[CopyUncompressedBlockToOutput] not enough bytes");
                  D.write(vt, kt), Z -= se, jt = 0;
                }
                if (dt.input_.read(vt, jt, Z) < Z)
                  throw new Error("[CopyUncompressedBlockToOutput] not enough bytes");
                dt.reset();
              }
              function wt(D) {
                var Z = D.bit_pos_ + 7 & -8, et = D.readBits(Z - D.bit_pos_);
                return et == 0;
              }
              function Ft(D) {
                var Z = new s(D), et = new f(Z);
                L(et);
                var vt = Q(et);
                return vt.meta_block_length;
              }
              function zt(D, Z) {
                var et = new s(D);
                Z == null && (Z = Ft(D));
                var vt = new Uint8Array(Z), lt = new i(vt);
                return G(et, lt), lt.pos < lt.buffer.length && (lt.buffer = lt.buffer.subarray(0, lt.pos)), lt.buffer;
              }
              l.BrotliDecompressBuffer = zt;
              function G(D, Z) {
                var et, vt = 0, lt = 0, dt = 0, kt, jt = 0, me, se, Bt, ge, Re = [16, 15, 11, 4], Te = 0, xe = 0, Fe = 0, Zt = [new X(0, 0), new X(0, 0), new X(0, 0)], qt, ve, Se, Pe = 128 + f.READ_SIZE;
                Se = new f(D), dt = L(Se), kt = (1 << dt) - 16, me = 1 << dt, se = me - 1, Bt = new Uint8Array(me + Pe + h.maxDictionaryWordLength), ge = me, qt = [], ve = [];
                for (var Be = 0; Be < 3 * T; Be++)
                  qt[Be] = new v(0, 0), ve[Be] = new v(0, 0);
                for (; !lt; ) {
                  var De = 0, It, he = [1 << 28, 1 << 28, 1 << 28], nt = [0], j = [1, 1, 1], V = [0, 1, 0, 1, 0, 1], yt = [0], it, _t, ne, Y, Jt = null, ie = null, Tt, Xt = null, ue, Ve = 0, ke = null, Xe = 0, je = 0, Wr = null, vr = 0, nr = 0, Fr = 0, Jr, dn;
                  for (et = 0; et < 3; ++et)
                    Zt[et].codes = null, Zt[et].htrees = null;
                  Se.readMoreInput();
                  var kn = Q(Se);
                  if (De = kn.meta_block_length, vt + De > Z.buffer.length) {
                    var Yn = new Uint8Array(vt + De);
                    Yn.set(Z.buffer), Z.buffer = Yn;
                  }
                  if (lt = kn.input_end, It = kn.is_uncompressed, kn.is_metadata) {
                    for (wt(Se); De > 0; --De)
                      Se.readMoreInput(), Se.readBits(8);
                    continue;
                  }
                  if (De !== 0) {
                    if (It) {
                      Se.bit_pos_ = Se.bit_pos_ + 7 & -8, rt(
                        Z,
                        De,
                        vt,
                        Bt,
                        se,
                        Se
                      ), vt += De;
                      continue;
                    }
                    for (et = 0; et < 3; ++et)
                      j[et] = J(Se) + 1, j[et] >= 2 && (Pt(j[et] + 2, qt, et * T, Se), Pt(w, ve, et * T, Se), he[et] = Gt(ve, et * T, Se), yt[et] = 1);
                    for (Se.readMoreInput(), it = Se.readBits(2), _t = F + (Se.readBits(4) << it), ne = (1 << it) - 1, Y = _t + (48 << it), ie = new Uint8Array(j[0]), et = 0; et < j[0]; ++et)
                      Se.readMoreInput(), ie[et] = Se.readBits(2) << 1;
                    var yr = gt(j[0] << E, Se);
                    Tt = yr.num_htrees, Jt = yr.context_map;
                    var Tn = gt(j[2] << A, Se);
                    for (ue = Tn.num_htrees, Xt = Tn.context_map, Zt[0] = new X(b, Tt), Zt[1] = new X(n, j[1]), Zt[2] = new X(Y, ue), et = 0; et < 3; ++et)
                      Zt[et].decode(Se);
                    for (ke = 0, Wr = 0, Jr = ie[nt[0]], nr = m.lookupOffsets[Jr], Fr = m.lookupOffsets[Jr + 1], dn = Zt[1].htrees[0]; De > 0; ) {
                      var qr, gn, un, wi, Si, Me, Ze, qe, gr, Wn, sr;
                      for (Se.readMoreInput(), he[1] === 0 && (st(
                        j[1],
                        qt,
                        1,
                        nt,
                        V,
                        yt,
                        Se
                      ), he[1] = Gt(ve, T, Se), dn = Zt[1].htrees[nt[1]]), --he[1], qr = xt(Zt[1].codes, dn, Se), gn = qr >> 6, gn >= 2 ? (gn -= 2, Ze = -1) : Ze = 0, un = x.kInsertRangeLut[gn] + (qr >> 3 & 7), wi = x.kCopyRangeLut[gn] + (qr & 7), Si = x.kInsertLengthPrefixCode[un].offset + Se.readBits(x.kInsertLengthPrefixCode[un].nbits), Me = x.kCopyLengthPrefixCode[wi].offset + Se.readBits(x.kCopyLengthPrefixCode[wi].nbits), xe = Bt[vt - 1 & se], Fe = Bt[vt - 2 & se], Wn = 0; Wn < Si; ++Wn)
                        Se.readMoreInput(), he[0] === 0 && (st(
                          j[0],
                          qt,
                          0,
                          nt,
                          V,
                          yt,
                          Se
                        ), he[0] = Gt(ve, 0, Se), Ve = nt[0] << E, ke = Ve, Jr = ie[nt[0]], nr = m.lookupOffsets[Jr], Fr = m.lookupOffsets[Jr + 1]), gr = m.lookup[nr + xe] | m.lookup[Fr + Fe], Xe = Jt[ke + gr], --he[0], Fe = xe, xe = xt(Zt[0].codes, Zt[0].htrees[Xe], Se), Bt[vt & se] = xe, (vt & se) === se && Z.write(Bt, me), ++vt;
                      if (De -= Si, De <= 0)
                        break;
                      if (Ze < 0) {
                        var gr;
                        if (Se.readMoreInput(), he[2] === 0 && (st(
                          j[2],
                          qt,
                          2,
                          nt,
                          V,
                          yt,
                          Se
                        ), he[2] = Gt(ve, 2 * T, Se), je = nt[2] << A, Wr = je), --he[2], gr = (Me > 4 ? 3 : Me - 2) & 255, vr = Xt[Wr + gr], Ze = xt(Zt[2].codes, Zt[2].htrees[vr], Se), Ze >= _t) {
                          var Oi, Yi, vi;
                          Ze -= _t, Yi = Ze & ne, Ze >>= it, Oi = (Ze >> 1) + 1, vi = (2 + (Ze & 1) << Oi) - 4, Ze = _t + (vi + Se.readBits(Oi) << it) + Yi;
                        }
                      }
                      if (qe = Rt(Ze, Re, Te), qe < 0)
                        throw new Error("[BrotliDecompress] invalid distance");
                      if (vt < kt && jt !== kt ? jt = vt : jt = kt, sr = vt & se, qe > jt)
                        if (Me >= h.minDictionaryWordLength && Me <= h.maxDictionaryWordLength) {
                          var vi = h.offsetsByLength[Me], Ct = qe - jt - 1, $t = h.sizeBitsByLength[Me], Mt = (1 << $t) - 1, oe = Ct & Mt, Lt = Ct >> $t;
                          if (vi += oe * Me, Lt < g.kNumTransforms) {
                            var Ut = g.transformDictionaryWord(Bt, sr, vi, Me, Lt);
                            if (sr += Ut, vt += Ut, De -= Ut, sr >= ge) {
                              Z.write(Bt, me);
                              for (var Vt = 0; Vt < sr - ge; Vt++)
                                Bt[Vt] = Bt[ge + Vt];
                            }
                          } else
                            throw new Error("Invalid backward reference. pos: " + vt + " distance: " + qe + " len: " + Me + " bytes left: " + De);
                        } else
                          throw new Error("Invalid backward reference. pos: " + vt + " distance: " + qe + " len: " + Me + " bytes left: " + De);
                      else {
                        if (Ze > 0 && (Re[Te & 3] = qe, ++Te), Me > De)
                          throw new Error("Invalid backward reference. pos: " + vt + " distance: " + qe + " len: " + Me + " bytes left: " + De);
                        for (Wn = 0; Wn < Me; ++Wn)
                          Bt[vt & se] = Bt[vt - qe & se], (vt & se) === se && Z.write(Bt, me), ++vt, --De;
                      }
                      xe = Bt[vt - 1 & se], Fe = Bt[vt - 2 & se];
                    }
                    vt &= 1073741823;
                  }
                }
                Z.write(Bt, vt & se);
              }
              h.init();
            }
          ),
          /***/
          84543: (
            /***/
            function(u, l, e) {
              var s = e(32504);
              l.init = function() {
                var i = e(20980).BrotliDecompressBuffer, f = s.toByteArray(e(13501));
                return i(f);
              };
            }
          ),
          /***/
          13501: (
            /***/
            function(u) {
              u.exports = "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";
            }
          ),
          /***/
          80614: (
            /***/
            function(u, l, e) {
              var s = e(84543);
              l.init = function() {
                l.dictionary = s.init();
              }, l.offsetsByLength = new Uint32Array([
                0,
                0,
                0,
                0,
                0,
                4096,
                9216,
                21504,
                35840,
                44032,
                53248,
                63488,
                74752,
                87040,
                93696,
                100864,
                104704,
                106752,
                108928,
                113536,
                115968,
                118528,
                119872,
                121280,
                122016
              ]), l.sizeBitsByLength = new Uint8Array([
                0,
                0,
                0,
                0,
                10,
                10,
                11,
                11,
                10,
                10,
                10,
                10,
                10,
                9,
                9,
                8,
                7,
                7,
                8,
                7,
                7,
                6,
                6,
                5,
                5
              ]), l.minDictionaryWordLength = 4, l.maxDictionaryWordLength = 24;
            }
          ),
          /***/
          81561: (
            /***/
            function(u, l) {
              function e(v, p) {
                this.bits = v, this.value = p;
              }
              l.z = e;
              var s = 15;
              function i(v, p) {
                for (var m = 1 << p - 1; v & m; )
                  m >>= 1;
                return (v & m - 1) + m;
              }
              function f(v, p, m, x, g) {
                do
                  x -= m, v[p + x] = new e(g.bits, g.value);
                while (x > 0);
              }
              function h(v, p, m) {
                for (var x = 1 << p - m; p < s && (x -= v[p], !(x <= 0)); )
                  ++p, x <<= 1;
                return p - m;
              }
              l.u = function(v, p, m, x, g) {
                var S = p, y, b, n, w, E, A, O, C, T, P, I, F = new Int32Array(s + 1), B = new Int32Array(s + 1);
                for (I = new Int32Array(g), n = 0; n < g; n++)
                  F[x[n]]++;
                for (B[1] = 0, b = 1; b < s; b++)
                  B[b + 1] = B[b] + F[b];
                for (n = 0; n < g; n++)
                  x[n] !== 0 && (I[B[x[n]]++] = n);
                if (C = m, T = 1 << C, P = T, B[s] === 1) {
                  for (w = 0; w < P; ++w)
                    v[p + w] = new e(0, I[0] & 65535);
                  return P;
                }
                for (w = 0, n = 0, b = 1, E = 2; b <= m; ++b, E <<= 1)
                  for (; F[b] > 0; --F[b])
                    y = new e(b & 255, I[n++] & 65535), f(v, p + w, E, T, y), w = i(w, b);
                for (O = P - 1, A = -1, b = m + 1, E = 2; b <= s; ++b, E <<= 1)
                  for (; F[b] > 0; --F[b])
                    (w & O) !== A && (p += T, C = h(F, b, m), T = 1 << C, P += T, A = w & O, v[S + A] = new e(C + m & 255, p - S - A & 65535)), y = new e(b - m & 255, I[n++] & 65535), f(v, p + (w >> m), E, T, y), w = i(w, b);
                return P;
              };
            }
          ),
          /***/
          42210: (
            /***/
            function(u, l) {
              function e(s, i) {
                this.offset = s, this.nbits = i;
              }
              l.kBlockLengthPrefixCode = [
                new e(1, 2),
                new e(5, 2),
                new e(9, 2),
                new e(13, 2),
                new e(17, 3),
                new e(25, 3),
                new e(33, 3),
                new e(41, 3),
                new e(49, 4),
                new e(65, 4),
                new e(81, 4),
                new e(97, 4),
                new e(113, 5),
                new e(145, 5),
                new e(177, 5),
                new e(209, 5),
                new e(241, 6),
                new e(305, 6),
                new e(369, 7),
                new e(497, 8),
                new e(753, 9),
                new e(1265, 10),
                new e(2289, 11),
                new e(4337, 12),
                new e(8433, 13),
                new e(16625, 24)
              ], l.kInsertLengthPrefixCode = [
                new e(0, 0),
                new e(1, 0),
                new e(2, 0),
                new e(3, 0),
                new e(4, 0),
                new e(5, 0),
                new e(6, 1),
                new e(8, 1),
                new e(10, 2),
                new e(14, 2),
                new e(18, 3),
                new e(26, 3),
                new e(34, 4),
                new e(50, 4),
                new e(66, 5),
                new e(98, 5),
                new e(130, 6),
                new e(194, 7),
                new e(322, 8),
                new e(578, 9),
                new e(1090, 10),
                new e(2114, 12),
                new e(6210, 14),
                new e(22594, 24)
              ], l.kCopyLengthPrefixCode = [
                new e(2, 0),
                new e(3, 0),
                new e(4, 0),
                new e(5, 0),
                new e(6, 0),
                new e(7, 0),
                new e(8, 0),
                new e(9, 0),
                new e(10, 1),
                new e(12, 1),
                new e(14, 2),
                new e(18, 2),
                new e(22, 3),
                new e(30, 3),
                new e(38, 4),
                new e(54, 4),
                new e(70, 5),
                new e(102, 5),
                new e(134, 6),
                new e(198, 7),
                new e(326, 8),
                new e(582, 9),
                new e(1094, 10),
                new e(2118, 24)
              ], l.kInsertRangeLut = [
                0,
                0,
                8,
                8,
                0,
                16,
                8,
                16,
                16
              ], l.kCopyRangeLut = [
                0,
                8,
                0,
                8,
                16,
                0,
                16,
                8,
                16
              ];
            }
          ),
          /***/
          98197: (
            /***/
            function(u, l) {
              function e(i) {
                this.buffer = i, this.pos = 0;
              }
              e.prototype.read = function(i, f, h) {
                this.pos + h > this.buffer.length && (h = this.buffer.length - this.pos);
                for (var v = 0; v < h; v++)
                  i[f + v] = this.buffer[this.pos + v];
                return this.pos += h, h;
              }, l.z = e;
              function s(i) {
                this.buffer = i, this.pos = 0;
              }
              s.prototype.write = function(i, f) {
                if (this.pos + f > this.buffer.length)
                  throw new Error("Output buffer is not large enough");
                return this.buffer.set(i.subarray(0, f), this.pos), this.pos += f, f;
              }, l.y = s;
            }
          ),
          /***/
          87984: (
            /***/
            function(u, l, e) {
              var s = e(80614), i = 0, f = 1, h = 2, v = 3, p = 4, m = 5, x = 6, g = 7, S = 8, y = 9, b = 10, n = 11, w = 12, E = 13, A = 14, O = 15, C = 16, T = 17, P = 18, I = 20;
              function F(z, L, J) {
                this.prefix = new Uint8Array(z.length), this.transform = L, this.suffix = new Uint8Array(J.length);
                for (var ft = 0; ft < z.length; ft++)
                  this.prefix[ft] = z.charCodeAt(ft);
                for (var ft = 0; ft < J.length; ft++)
                  this.suffix[ft] = J.charCodeAt(ft);
              }
              var B = [
                new F("", i, ""),
                new F("", i, " "),
                new F(" ", i, " "),
                new F("", w, ""),
                new F("", b, " "),
                new F("", i, " the "),
                new F(" ", i, ""),
                new F("s ", i, " "),
                new F("", i, " of "),
                new F("", b, ""),
                new F("", i, " and "),
                new F("", E, ""),
                new F("", f, ""),
                new F(", ", i, " "),
                new F("", i, ", "),
                new F(" ", b, " "),
                new F("", i, " in "),
                new F("", i, " to "),
                new F("e ", i, " "),
                new F("", i, '"'),
                new F("", i, "."),
                new F("", i, '">'),
                new F("", i, `
`),
                new F("", v, ""),
                new F("", i, "]"),
                new F("", i, " for "),
                new F("", A, ""),
                new F("", h, ""),
                new F("", i, " a "),
                new F("", i, " that "),
                new F(" ", b, ""),
                new F("", i, ". "),
                new F(".", i, ""),
                new F(" ", i, ", "),
                new F("", O, ""),
                new F("", i, " with "),
                new F("", i, "'"),
                new F("", i, " from "),
                new F("", i, " by "),
                new F("", C, ""),
                new F("", T, ""),
                new F(" the ", i, ""),
                new F("", p, ""),
                new F("", i, ". The "),
                new F("", n, ""),
                new F("", i, " on "),
                new F("", i, " as "),
                new F("", i, " is "),
                new F("", g, ""),
                new F("", f, "ing "),
                new F("", i, `
	`),
                new F("", i, ":"),
                new F(" ", i, ". "),
                new F("", i, "ed "),
                new F("", I, ""),
                new F("", P, ""),
                new F("", x, ""),
                new F("", i, "("),
                new F("", b, ", "),
                new F("", S, ""),
                new F("", i, " at "),
                new F("", i, "ly "),
                new F(" the ", i, " of "),
                new F("", m, ""),
                new F("", y, ""),
                new F(" ", b, ", "),
                new F("", b, '"'),
                new F(".", i, "("),
                new F("", n, " "),
                new F("", b, '">'),
                new F("", i, '="'),
                new F(" ", i, "."),
                new F(".com/", i, ""),
                new F(" the ", i, " of the "),
                new F("", b, "'"),
                new F("", i, ". This "),
                new F("", i, ","),
                new F(".", i, " "),
                new F("", b, "("),
                new F("", b, "."),
                new F("", i, " not "),
                new F(" ", i, '="'),
                new F("", i, "er "),
                new F(" ", n, " "),
                new F("", i, "al "),
                new F(" ", n, ""),
                new F("", i, "='"),
                new F("", n, '"'),
                new F("", b, ". "),
                new F(" ", i, "("),
                new F("", i, "ful "),
                new F(" ", b, ". "),
                new F("", i, "ive "),
                new F("", i, "less "),
                new F("", n, "'"),
                new F("", i, "est "),
                new F(" ", b, "."),
                new F("", n, '">'),
                new F(" ", i, "='"),
                new F("", b, ","),
                new F("", i, "ize "),
                new F("", n, "."),
                new F("Â ", i, ""),
                new F(" ", i, ","),
                new F("", b, '="'),
                new F("", n, '="'),
                new F("", i, "ous "),
                new F("", n, ", "),
                new F("", b, "='"),
                new F(" ", b, ","),
                new F(" ", n, '="'),
                new F(" ", n, ", "),
                new F("", n, ","),
                new F("", n, "("),
                new F("", n, ". "),
                new F(" ", n, "."),
                new F("", n, "='"),
                new F(" ", n, ". "),
                new F(" ", b, '="'),
                new F(" ", n, "='"),
                new F(" ", b, "='")
              ];
              l.kTransforms = B, l.kNumTransforms = B.length;
              function M(z, L) {
                return z[L] < 192 ? (z[L] >= 97 && z[L] <= 122 && (z[L] ^= 32), 1) : z[L] < 224 ? (z[L + 1] ^= 32, 2) : (z[L + 2] ^= 5, 3);
              }
              l.transformDictionaryWord = function(z, L, J, ft, Q) {
                var xt = B[Q].prefix, St = B[Q].suffix, Pt = B[Q].transform, Gt = Pt < w ? 0 : Pt - (w - 1), Rt = 0, bt = L, Dt;
                Gt > ft && (Gt = ft);
                for (var X = 0; X < xt.length; )
                  z[L++] = xt[X++];
                for (J += Gt, ft -= Gt, Pt <= y && (ft -= Pt), Rt = 0; Rt < ft; Rt++)
                  z[L++] = s.dictionary[J + Rt];
                if (Dt = L - ft, Pt === b)
                  M(z, Dt);
                else if (Pt === n)
                  for (; ft > 0; ) {
                    var gt = M(z, Dt);
                    Dt += gt, ft -= gt;
                  }
                for (var st = 0; st < St.length; )
                  z[L++] = St[st++];
                return L - bt;
              };
            }
          ),
          /***/
          34460: (
            /***/
            function(u, l, e) {
              u.exports = e(20980).BrotliDecompressBuffer;
            }
          ),
          /***/
          72908: (
            /***/
            function(u, l, e) {
              var s = e(50621).Buffer, i = e(9964), f = e(80182), h = e(37468), v = e(22925), p = e(2269), m = e(81607);
              for (var x in m)
                l[x] = m[x];
              l.NONE = 0, l.DEFLATE = 1, l.INFLATE = 2, l.GZIP = 3, l.GUNZIP = 4, l.DEFLATERAW = 5, l.INFLATERAW = 6, l.UNZIP = 7;
              var g = 31, S = 139;
              function y(b) {
                if (typeof b != "number" || b < l.DEFLATE || b > l.UNZIP)
                  throw new TypeError("Bad argument");
                this.dictionary = null, this.err = 0, this.flush = 0, this.init_done = !1, this.level = 0, this.memLevel = 0, this.mode = b, this.strategy = 0, this.windowBits = 0, this.write_in_progress = !1, this.pending_close = !1, this.gzip_id_bytes_read = 0;
              }
              y.prototype.close = function() {
                if (this.write_in_progress) {
                  this.pending_close = !0;
                  return;
                }
                this.pending_close = !1, f(this.init_done, "close before init"), f(this.mode <= l.UNZIP), this.mode === l.DEFLATE || this.mode === l.GZIP || this.mode === l.DEFLATERAW ? v.deflateEnd(this.strm) : (this.mode === l.INFLATE || this.mode === l.GUNZIP || this.mode === l.INFLATERAW || this.mode === l.UNZIP) && p.inflateEnd(this.strm), this.mode = l.NONE, this.dictionary = null;
              }, y.prototype.write = function(b, n, w, E, A, O, C) {
                return this._write(!0, b, n, w, E, A, O, C);
              }, y.prototype.writeSync = function(b, n, w, E, A, O, C) {
                return this._write(!1, b, n, w, E, A, O, C);
              }, y.prototype._write = function(b, n, w, E, A, O, C, T) {
                if (f.equal(arguments.length, 8), f(this.init_done, "write before init"), f(this.mode !== l.NONE, "already finalized"), f.equal(!1, this.write_in_progress, "write already in progress"), f.equal(!1, this.pending_close, "close is pending"), this.write_in_progress = !0, f.equal(!1, n === void 0, "must provide flush value"), this.write_in_progress = !0, n !== l.Z_NO_FLUSH && n !== l.Z_PARTIAL_FLUSH && n !== l.Z_SYNC_FLUSH && n !== l.Z_FULL_FLUSH && n !== l.Z_FINISH && n !== l.Z_BLOCK)
                  throw new Error("Invalid flush value");
                if (w == null && (w = s.alloc(0), A = 0, E = 0), this.strm.avail_in = A, this.strm.input = w, this.strm.next_in = E, this.strm.avail_out = T, this.strm.output = O, this.strm.next_out = C, this.flush = n, !b)
                  return this._process(), this._checkError() ? this._afterSync() : void 0;
                var P = this;
                return i.nextTick(function() {
                  P._process(), P._after();
                }), this;
              }, y.prototype._afterSync = function() {
                var b = this.strm.avail_out, n = this.strm.avail_in;
                return this.write_in_progress = !1, [n, b];
              }, y.prototype._process = function() {
                var b = null;
                switch (this.mode) {
                  case l.DEFLATE:
                  case l.GZIP:
                  case l.DEFLATERAW:
                    this.err = v.deflate(this.strm, this.flush);
                    break;
                  case l.UNZIP:
                    switch (this.strm.avail_in > 0 && (b = this.strm.next_in), this.gzip_id_bytes_read) {
                      case 0:
                        if (b === null)
                          break;
                        if (this.strm.input[b] === g) {
                          if (this.gzip_id_bytes_read = 1, b++, this.strm.avail_in === 1)
                            break;
                        } else {
                          this.mode = l.INFLATE;
                          break;
                        }
                      case 1:
                        if (b === null)
                          break;
                        this.strm.input[b] === S ? (this.gzip_id_bytes_read = 2, this.mode = l.GUNZIP) : this.mode = l.INFLATE;
                        break;
                      default:
                        throw new Error("invalid number of gzip magic number bytes read");
                    }
                  case l.INFLATE:
                  case l.GUNZIP:
                  case l.INFLATERAW:
                    for (this.err = p.inflate(
                      this.strm,
                      this.flush
                      // If data was encoded with dictionary
                    ), this.err === l.Z_NEED_DICT && this.dictionary && (this.err = p.inflateSetDictionary(this.strm, this.dictionary), this.err === l.Z_OK ? this.err = p.inflate(this.strm, this.flush) : this.err === l.Z_DATA_ERROR && (this.err = l.Z_NEED_DICT)); this.strm.avail_in > 0 && this.mode === l.GUNZIP && this.err === l.Z_STREAM_END && this.strm.next_in[0] !== 0; )
                      this.reset(), this.err = p.inflate(this.strm, this.flush);
                    break;
                  default:
                    throw new Error("Unknown mode " + this.mode);
                }
              }, y.prototype._checkError = function() {
                switch (this.err) {
                  case l.Z_OK:
                  case l.Z_BUF_ERROR:
                    if (this.strm.avail_out !== 0 && this.flush === l.Z_FINISH)
                      return this._error("unexpected end of file"), !1;
                    break;
                  case l.Z_STREAM_END:
                    break;
                  case l.Z_NEED_DICT:
                    return this.dictionary == null ? this._error("Missing dictionary") : this._error("Bad dictionary"), !1;
                  default:
                    return this._error("Zlib error"), !1;
                }
                return !0;
              }, y.prototype._after = function() {
                if (this._checkError()) {
                  var b = this.strm.avail_out, n = this.strm.avail_in;
                  this.write_in_progress = !1, this.callback(n, b), this.pending_close && this.close();
                }
              }, y.prototype._error = function(b) {
                this.strm.msg && (b = this.strm.msg), this.onerror(
                  b,
                  this.err
                  // no hope of rescue.
                ), this.write_in_progress = !1, this.pending_close && this.close();
              }, y.prototype.init = function(b, n, w, E, A) {
                f(arguments.length === 4 || arguments.length === 5, "init(windowBits, level, memLevel, strategy, [dictionary])"), f(b >= 8 && b <= 15, "invalid windowBits"), f(n >= -1 && n <= 9, "invalid compression level"), f(w >= 1 && w <= 9, "invalid memlevel"), f(E === l.Z_FILTERED || E === l.Z_HUFFMAN_ONLY || E === l.Z_RLE || E === l.Z_FIXED || E === l.Z_DEFAULT_STRATEGY, "invalid strategy"), this._init(n, b, w, E, A), this._setDictionary();
              }, y.prototype.params = function() {
                throw new Error("deflateParams Not supported");
              }, y.prototype.reset = function() {
                this._reset(), this._setDictionary();
              }, y.prototype._init = function(b, n, w, E, A) {
                switch (this.level = b, this.windowBits = n, this.memLevel = w, this.strategy = E, this.flush = l.Z_NO_FLUSH, this.err = l.Z_OK, (this.mode === l.GZIP || this.mode === l.GUNZIP) && (this.windowBits += 16), this.mode === l.UNZIP && (this.windowBits += 32), (this.mode === l.DEFLATERAW || this.mode === l.INFLATERAW) && (this.windowBits = -1 * this.windowBits), this.strm = new h(), this.mode) {
                  case l.DEFLATE:
                  case l.GZIP:
                  case l.DEFLATERAW:
                    this.err = v.deflateInit2(this.strm, this.level, l.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
                    break;
                  case l.INFLATE:
                  case l.GUNZIP:
                  case l.INFLATERAW:
                  case l.UNZIP:
                    this.err = p.inflateInit2(this.strm, this.windowBits);
                    break;
                  default:
                    throw new Error("Unknown mode " + this.mode);
                }
                this.err !== l.Z_OK && this._error("Init error"), this.dictionary = A, this.write_in_progress = !1, this.init_done = !0;
              }, y.prototype._setDictionary = function() {
                if (this.dictionary != null) {
                  switch (this.err = l.Z_OK, this.mode) {
                    case l.DEFLATE:
                    case l.DEFLATERAW:
                      this.err = v.deflateSetDictionary(this.strm, this.dictionary);
                      break;
                  }
                  this.err !== l.Z_OK && this._error("Failed to set dictionary");
                }
              }, y.prototype._reset = function() {
                switch (this.err = l.Z_OK, this.mode) {
                  case l.DEFLATE:
                  case l.DEFLATERAW:
                  case l.GZIP:
                    this.err = v.deflateReset(this.strm);
                    break;
                  case l.INFLATE:
                  case l.INFLATERAW:
                  case l.GUNZIP:
                    this.err = p.inflateReset(this.strm);
                    break;
                }
                this.err !== l.Z_OK && this._error("Failed to reset stream");
              }, l.Zlib = y;
            }
          ),
          /***/
          6729: (
            /***/
            function(u, l, e) {
              var s = e(9964), i = e(50621).Buffer, f = e(9760).Transform, h = e(72908), v = e(7187), p = e(80182).ok, m = e(50621).kMaxLength, x = "Cannot create final Buffer. It would be larger than 0x" + m.toString(16) + " bytes";
              h.Z_MIN_WINDOWBITS = 8, h.Z_MAX_WINDOWBITS = 15, h.Z_DEFAULT_WINDOWBITS = 15, h.Z_MIN_CHUNK = 64, h.Z_MAX_CHUNK = 1 / 0, h.Z_DEFAULT_CHUNK = 16384, h.Z_MIN_MEMLEVEL = 1, h.Z_MAX_MEMLEVEL = 9, h.Z_DEFAULT_MEMLEVEL = 8, h.Z_MIN_LEVEL = -1, h.Z_MAX_LEVEL = 9, h.Z_DEFAULT_LEVEL = h.Z_DEFAULT_COMPRESSION;
              for (var g = Object.keys(h), S = 0; S < g.length; S++) {
                var y = g[S];
                y.match(/^Z/) && Object.defineProperty(l, y, {
                  enumerable: !0,
                  value: h[y],
                  writable: !1
                });
              }
              for (var b = {
                Z_OK: h.Z_OK,
                Z_STREAM_END: h.Z_STREAM_END,
                Z_NEED_DICT: h.Z_NEED_DICT,
                Z_ERRNO: h.Z_ERRNO,
                Z_STREAM_ERROR: h.Z_STREAM_ERROR,
                Z_DATA_ERROR: h.Z_DATA_ERROR,
                Z_MEM_ERROR: h.Z_MEM_ERROR,
                Z_BUF_ERROR: h.Z_BUF_ERROR,
                Z_VERSION_ERROR: h.Z_VERSION_ERROR
              }, n = Object.keys(b), w = 0; w < n.length; w++) {
                var E = n[w];
                b[b[E]] = E;
              }
              Object.defineProperty(l, "codes", {
                enumerable: !0,
                value: Object.freeze(b),
                writable: !1
              }), l.Deflate = C, l.Inflate = T, l.Gzip = P, l.Gunzip = I, l.DeflateRaw = F, l.InflateRaw = B, l.Unzip = M, l.createDeflate = function(Q) {
                return new C(Q);
              }, l.createInflate = function(Q) {
                return new T(Q);
              }, l.createDeflateRaw = function(Q) {
                return new F(Q);
              }, l.createInflateRaw = function(Q) {
                return new B(Q);
              }, l.createGzip = function(Q) {
                return new P(Q);
              }, l.createGunzip = function(Q) {
                return new I(Q);
              }, l.createUnzip = function(Q) {
                return new M(Q);
              }, l.deflate = function(Q, xt, St) {
                return typeof xt == "function" && (St = xt, xt = {}), A(new C(xt), Q, St);
              }, l.deflateSync = function(Q, xt) {
                return O(new C(xt), Q);
              }, l.gzip = function(Q, xt, St) {
                return typeof xt == "function" && (St = xt, xt = {}), A(new P(xt), Q, St);
              }, l.gzipSync = function(Q, xt) {
                return O(new P(xt), Q);
              }, l.deflateRaw = function(Q, xt, St) {
                return typeof xt == "function" && (St = xt, xt = {}), A(new F(xt), Q, St);
              }, l.deflateRawSync = function(Q, xt) {
                return O(new F(xt), Q);
              }, l.unzip = function(Q, xt, St) {
                return typeof xt == "function" && (St = xt, xt = {}), A(new M(xt), Q, St);
              }, l.unzipSync = function(Q, xt) {
                return O(new M(xt), Q);
              }, l.inflate = function(Q, xt, St) {
                return typeof xt == "function" && (St = xt, xt = {}), A(new T(xt), Q, St);
              }, l.inflateSync = function(Q, xt) {
                return O(new T(xt), Q);
              }, l.gunzip = function(Q, xt, St) {
                return typeof xt == "function" && (St = xt, xt = {}), A(new I(xt), Q, St);
              }, l.gunzipSync = function(Q, xt) {
                return O(new I(xt), Q);
              }, l.inflateRaw = function(Q, xt, St) {
                return typeof xt == "function" && (St = xt, xt = {}), A(new B(xt), Q, St);
              }, l.inflateRawSync = function(Q, xt) {
                return O(new B(xt), Q);
              };
              function A(Q, xt, St) {
                var Pt = [], Gt = 0;
                Q.on("error", bt), Q.on("end", Dt), Q.end(xt), Rt();
                function Rt() {
                  for (var X; (X = Q.read()) !== null; )
                    Pt.push(X), Gt += X.length;
                  Q.once("readable", Rt);
                }
                function bt(X) {
                  Q.removeListener("end", Dt), Q.removeListener("readable", Rt), St(X);
                }
                function Dt() {
                  var X, gt = null;
                  Gt >= m ? gt = new RangeError(x) : X = i.concat(Pt, Gt), Pt = [], Q.close(), St(gt, X);
                }
              }
              function O(Q, xt) {
                if (typeof xt == "string" && (xt = i.from(xt)), !i.isBuffer(xt))
                  throw new TypeError("Not a string or buffer");
                var St = Q._finishFlushFlag;
                return Q._processChunk(xt, St);
              }
              function C(Q) {
                if (!(this instanceof C))
                  return new C(Q);
                L.call(this, Q, h.DEFLATE);
              }
              function T(Q) {
                if (!(this instanceof T))
                  return new T(Q);
                L.call(this, Q, h.INFLATE);
              }
              function P(Q) {
                if (!(this instanceof P))
                  return new P(Q);
                L.call(this, Q, h.GZIP);
              }
              function I(Q) {
                if (!(this instanceof I))
                  return new I(Q);
                L.call(this, Q, h.GUNZIP);
              }
              function F(Q) {
                if (!(this instanceof F))
                  return new F(Q);
                L.call(this, Q, h.DEFLATERAW);
              }
              function B(Q) {
                if (!(this instanceof B))
                  return new B(Q);
                L.call(this, Q, h.INFLATERAW);
              }
              function M(Q) {
                if (!(this instanceof M))
                  return new M(Q);
                L.call(this, Q, h.UNZIP);
              }
              function z(Q) {
                return Q === h.Z_NO_FLUSH || Q === h.Z_PARTIAL_FLUSH || Q === h.Z_SYNC_FLUSH || Q === h.Z_FULL_FLUSH || Q === h.Z_FINISH || Q === h.Z_BLOCK;
              }
              function L(Q, xt) {
                var St = this;
                if (this._opts = Q = Q || {}, this._chunkSize = Q.chunkSize || l.Z_DEFAULT_CHUNK, f.call(this, Q), Q.flush && !z(Q.flush))
                  throw new Error("Invalid flush flag: " + Q.flush);
                if (Q.finishFlush && !z(Q.finishFlush))
                  throw new Error("Invalid flush flag: " + Q.finishFlush);
                if (this._flushFlag = Q.flush || h.Z_NO_FLUSH, this._finishFlushFlag = typeof Q.finishFlush < "u" ? Q.finishFlush : h.Z_FINISH, Q.chunkSize && (Q.chunkSize < l.Z_MIN_CHUNK || Q.chunkSize > l.Z_MAX_CHUNK))
                  throw new Error("Invalid chunk size: " + Q.chunkSize);
                if (Q.windowBits && (Q.windowBits < l.Z_MIN_WINDOWBITS || Q.windowBits > l.Z_MAX_WINDOWBITS))
                  throw new Error("Invalid windowBits: " + Q.windowBits);
                if (Q.level && (Q.level < l.Z_MIN_LEVEL || Q.level > l.Z_MAX_LEVEL))
                  throw new Error("Invalid compression level: " + Q.level);
                if (Q.memLevel && (Q.memLevel < l.Z_MIN_MEMLEVEL || Q.memLevel > l.Z_MAX_MEMLEVEL))
                  throw new Error("Invalid memLevel: " + Q.memLevel);
                if (Q.strategy && Q.strategy != l.Z_FILTERED && Q.strategy != l.Z_HUFFMAN_ONLY && Q.strategy != l.Z_RLE && Q.strategy != l.Z_FIXED && Q.strategy != l.Z_DEFAULT_STRATEGY)
                  throw new Error("Invalid strategy: " + Q.strategy);
                if (Q.dictionary && !i.isBuffer(Q.dictionary))
                  throw new Error("Invalid dictionary: it should be a Buffer instance");
                this._handle = new h.Zlib(xt);
                var Pt = this;
                this._hadError = !1, this._handle.onerror = function(bt, Dt) {
                  J(Pt), Pt._hadError = !0;
                  var X = new Error(bt);
                  X.errno = Dt, X.code = l.codes[Dt], Pt.emit("error", X);
                };
                var Gt = l.Z_DEFAULT_COMPRESSION;
                typeof Q.level == "number" && (Gt = Q.level);
                var Rt = l.Z_DEFAULT_STRATEGY;
                typeof Q.strategy == "number" && (Rt = Q.strategy), this._handle.init(Q.windowBits || l.Z_DEFAULT_WINDOWBITS, Gt, Q.memLevel || l.Z_DEFAULT_MEMLEVEL, Rt, Q.dictionary), this._buffer = i.allocUnsafe(this._chunkSize), this._offset = 0, this._level = Gt, this._strategy = Rt, this.once("end", this.close), Object.defineProperty(this, "_closed", {
                  get: function() {
                    return !St._handle;
                  },
                  configurable: !0,
                  enumerable: !0
                });
              }
              v.inherits(L, f), L.prototype.params = function(Q, xt, St) {
                if (Q < l.Z_MIN_LEVEL || Q > l.Z_MAX_LEVEL)
                  throw new RangeError("Invalid compression level: " + Q);
                if (xt != l.Z_FILTERED && xt != l.Z_HUFFMAN_ONLY && xt != l.Z_RLE && xt != l.Z_FIXED && xt != l.Z_DEFAULT_STRATEGY)
                  throw new TypeError("Invalid strategy: " + xt);
                if (this._level !== Q || this._strategy !== xt) {
                  var Pt = this;
                  this.flush(h.Z_SYNC_FLUSH, function() {
                    p(Pt._handle, "zlib binding closed"), Pt._handle.params(Q, xt), Pt._hadError || (Pt._level = Q, Pt._strategy = xt, St && St());
                  });
                } else
                  s.nextTick(St);
              }, L.prototype.reset = function() {
                return p(this._handle, "zlib binding closed"), this._handle.reset();
              }, L.prototype._flush = function(Q) {
                this._transform(i.alloc(0), "", Q);
              }, L.prototype.flush = function(Q, xt) {
                var St = this, Pt = this._writableState;
                (typeof Q == "function" || Q === void 0 && !xt) && (xt = Q, Q = h.Z_FULL_FLUSH), Pt.ended ? xt && s.nextTick(xt) : Pt.ending ? xt && this.once("end", xt) : Pt.needDrain ? xt && this.once("drain", function() {
                  return St.flush(Q, xt);
                }) : (this._flushFlag = Q, this.write(i.alloc(0), "", xt));
              }, L.prototype.close = function(Q) {
                J(this, Q), s.nextTick(ft, this);
              };
              function J(Q, xt) {
                xt && s.nextTick(xt), Q._handle && (Q._handle.close(), Q._handle = null);
              }
              function ft(Q) {
                Q.emit("close");
              }
              L.prototype._transform = function(Q, xt, St) {
                var Pt, Gt = this._writableState, Rt = Gt.ending || Gt.ended, bt = Rt && (!Q || Gt.length === Q.length);
                if (Q !== null && !i.isBuffer(Q))
                  return St(new Error("invalid input"));
                if (!this._handle)
                  return St(new Error("zlib binding closed"));
                bt ? Pt = this._finishFlushFlag : (Pt = this._flushFlag, Q.length >= Gt.length && (this._flushFlag = this._opts.flush || h.Z_NO_FLUSH)), this._processChunk(Q, Pt, St);
              }, L.prototype._processChunk = function(Q, xt, St) {
                var Pt = Q && Q.length, Gt = this._chunkSize - this._offset, Rt = 0, bt = this, Dt = typeof St == "function";
                if (!Dt) {
                  var X = [], gt = 0, st;
                  this.on("error", function(G) {
                    st = G;
                  }), p(this._handle, "zlib binding closed");
                  do
                    var rt = this._handle.writeSync(
                      xt,
                      Q,
                      // in
                      Rt,
                      // in_off
                      Pt,
                      // in_len
                      this._buffer,
                      // out
                      this._offset,
                      //out_off
                      Gt
                    );
                  while (!this._hadError && zt(rt[0], rt[1]));
                  if (this._hadError)
                    throw st;
                  if (gt >= m)
                    throw J(this), new RangeError(x);
                  var wt = i.concat(X, gt);
                  return J(this), wt;
                }
                p(this._handle, "zlib binding closed");
                var Ft = this._handle.write(
                  xt,
                  Q,
                  // in
                  Rt,
                  // in_off
                  Pt,
                  // in_len
                  this._buffer,
                  // out
                  this._offset,
                  //out_off
                  Gt
                );
                Ft.buffer = Q, Ft.callback = zt;
                function zt(G, D) {
                  if (this && (this.buffer = null, this.callback = null), !bt._hadError) {
                    var Z = Gt - D;
                    if (p(Z >= 0, "have should not go down"), Z > 0) {
                      var et = bt._buffer.slice(bt._offset, bt._offset + Z);
                      bt._offset += Z, Dt ? bt.push(et) : (X.push(et), gt += et.length);
                    }
                    if ((D === 0 || bt._offset >= bt._chunkSize) && (Gt = bt._chunkSize, bt._offset = 0, bt._buffer = i.allocUnsafe(bt._chunkSize)), D === 0) {
                      if (Rt += Pt - G, Pt = G, !Dt)
                        return !0;
                      var vt = bt._handle.write(xt, Q, Rt, Pt, bt._buffer, bt._offset, bt._chunkSize);
                      vt.callback = zt, vt.buffer = Q;
                      return;
                    }
                    if (!Dt)
                      return !1;
                    St();
                  }
                }
              }, v.inherits(C, L), v.inherits(T, L), v.inherits(P, L), v.inherits(I, L), v.inherits(F, L), v.inherits(B, L), v.inherits(M, L);
            }
          ),
          /***/
          67913: (
            /***/
            function(u, l, e) {
              var s = e(28651), i = e(26601), f = i(s("String.prototype.indexOf"));
              u.exports = function(v, p) {
                var m = s(v, !!p);
                return typeof m == "function" && f(v, ".prototype.") > -1 ? i(m) : m;
              };
            }
          ),
          /***/
          26601: (
            /***/
            function(u, l, e) {
              var s = e(5049), i = e(28651), f = e(86255), h = e(96785), v = i("%Function.prototype.apply%"), p = i("%Function.prototype.call%"), m = i("%Reflect.apply%", !0) || s.call(p, v), x = e(56649), g = i("%Math.max%");
              u.exports = function(b) {
                if (typeof b != "function")
                  throw new h("a function is required");
                var n = m(s, p, arguments);
                return f(
                  n,
                  1 + g(0, b.length - (arguments.length - 1)),
                  !0
                );
              };
              var S = function() {
                return m(s, v, arguments);
              };
              x ? x(u.exports, "apply", { value: S }) : u.exports.apply = S;
            }
          ),
          /***/
          41613: (
            /***/
            function(u, l, e) {
              var s = e(50621).Buffer, i = function() {
                function f(g, S, y, b) {
                  typeof S == "object" && (y = S.depth, b = S.prototype, S.filter, S = S.circular);
                  var n = [], w = [], E = typeof s < "u";
                  typeof S > "u" && (S = !0), typeof y > "u" && (y = 1 / 0);
                  function A(O, C) {
                    if (O === null)
                      return null;
                    if (C == 0)
                      return O;
                    var T, P;
                    if (typeof O != "object")
                      return O;
                    if (f.__isArray(O))
                      T = [];
                    else if (f.__isRegExp(O))
                      T = new RegExp(O.source, x(O)), O.lastIndex && (T.lastIndex = O.lastIndex);
                    else if (f.__isDate(O))
                      T = new Date(O.getTime());
                    else {
                      if (E && s.isBuffer(O))
                        return s.allocUnsafe ? T = s.allocUnsafe(O.length) : T = new s(O.length), O.copy(T), T;
                      typeof b > "u" ? (P = Object.getPrototypeOf(O), T = Object.create(P)) : (T = Object.create(b), P = b);
                    }
                    if (S) {
                      var I = n.indexOf(O);
                      if (I != -1)
                        return w[I];
                      n.push(O), w.push(T);
                    }
                    for (var F in O) {
                      var B;
                      P && (B = Object.getOwnPropertyDescriptor(P, F)), !(B && B.set == null) && (T[F] = A(O[F], C - 1));
                    }
                    return T;
                  }
                  return A(g, y);
                }
                f.clonePrototype = function(S) {
                  if (S === null)
                    return null;
                  var y = function() {
                  };
                  return y.prototype = S, new y();
                };
                function h(g) {
                  return Object.prototype.toString.call(g);
                }
                f.__objToStr = h;
                function v(g) {
                  return typeof g == "object" && h(g) === "[object Date]";
                }
                f.__isDate = v;
                function p(g) {
                  return typeof g == "object" && h(g) === "[object Array]";
                }
                f.__isArray = p;
                function m(g) {
                  return typeof g == "object" && h(g) === "[object RegExp]";
                }
                f.__isRegExp = m;
                function x(g) {
                  var S = "";
                  return g.global && (S += "g"), g.ignoreCase && (S += "i"), g.multiline && (S += "m"), S;
                }
                return f.__getRegExpFlags = x, f;
              }();
              u.exports && (u.exports = i);
            }
          ),
          /***/
          83043: (
            /***/
            function(u, l, e) {
              e(59883);
              var s = e(11206);
              u.exports = s.Object.values;
            }
          ),
          /***/
          42075: (
            /***/
            function(u, l, e) {
              e(94910), e(81755), e(14032), e(68067), e(77074), e(44455), e(58605), e(58281);
              var s = e(11206);
              u.exports = s.Promise;
            }
          ),
          /***/
          98168: (
            /***/
            function(u, l, e) {
              var s = e(90780);
              e(84151), e(98443), e(49261), e(67858), u.exports = s;
            }
          ),
          /***/
          32631: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(94578), f = e(68664), h = s.TypeError;
              u.exports = function(v) {
                if (i(v))
                  return v;
                throw h(f(v) + " is not a function");
              };
            }
          ),
          /***/
          69075: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(20884), f = e(68664), h = s.TypeError;
              u.exports = function(v) {
                if (i(v))
                  return v;
                throw h(f(v) + " is not a constructor");
              };
            }
          ),
          /***/
          58659: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(94578), f = s.String, h = s.TypeError;
              u.exports = function(v) {
                if (typeof v == "object" || i(v))
                  return v;
                throw h("Can't set " + f(v) + " as a prototype");
              };
            }
          ),
          /***/
          71156: (
            /***/
            function(u, l, e) {
              var s = e(38688), i = e(10819), f = e(95892), h = s("unscopables"), v = Array.prototype;
              v[h] == null && f.f(v, h, {
                configurable: !0,
                value: i(null)
              }), u.exports = function(p) {
                v[h][p] = !0;
              };
            }
          ),
          /***/
          36352: (
            /***/
            function(u, l, e) {
              var s = e(69510).charAt;
              u.exports = function(i, f, h) {
                return f + (h ? s(i, f).length : 1);
              };
            }
          ),
          /***/
          2868: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(70176), f = s.TypeError;
              u.exports = function(h, v) {
                if (i(v, h))
                  return h;
                throw f("Incorrect invocation");
              };
            }
          ),
          /***/
          34984: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(24517), f = s.String, h = s.TypeError;
              u.exports = function(v) {
                if (i(v))
                  return v;
                throw h(f(v) + " is not an object");
              };
            }
          ),
          /***/
          92642: (
            /***/
            function(u, l, e) {
              var s = e(43162), i = e(74841), f = e(45495), h = Math.min;
              u.exports = [].copyWithin || function(p, m) {
                var x = s(this), g = f(x), S = i(p, g), y = i(m, g), b = arguments.length > 2 ? arguments[2] : void 0, n = h((b === void 0 ? g : i(b, g)) - y, g - S), w = 1;
                for (y < S && S < y + n && (w = -1, y += n - 1, S += n - 1); n-- > 0; )
                  y in x ? x[S] = x[y] : delete x[S], S += w, y += w;
                return x;
              };
            }
          ),
          /***/
          72864: (
            /***/
            function(u, l, e) {
              var s = e(43162), i = e(74841), f = e(45495);
              u.exports = function(v) {
                for (var p = s(this), m = f(p), x = arguments.length, g = i(x > 1 ? arguments[1] : void 0, m), S = x > 2 ? arguments[2] : void 0, y = S === void 0 ? m : i(S, m); y > g; )
                  p[g++] = v;
                return p;
              };
            }
          ),
          /***/
          82938: (
            /***/
            function(u, l, e) {
              var s = e(91102).forEach, i = e(81007), f = i("forEach");
              u.exports = f ? [].forEach : function(v) {
                return s(this, v, arguments.length > 1 ? arguments[1] : void 0);
              };
            }
          ),
          /***/
          34269: (
            /***/
            function(u) {
              u.exports = function(l, e) {
                for (var s = 0, i = e.length, f = new l(i); i > s; )
                  f[s] = e[s++];
                return f;
              };
            }
          ),
          /***/
          95717: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(25567), f = e(2834), h = e(43162), v = e(97738), p = e(89564), m = e(20884), x = e(45495), g = e(38639), S = e(15892), y = e(13872), b = s.Array;
              u.exports = function(w) {
                var E = h(w), A = m(this), O = arguments.length, C = O > 1 ? arguments[1] : void 0, T = C !== void 0;
                T && (C = i(C, O > 2 ? arguments[2] : void 0));
                var P = y(E), I = 0, F, B, M, z, L, J;
                if (P && !(this == b && p(P)))
                  for (z = S(E, P), L = z.next, B = A ? new this() : []; !(M = f(L, z)).done; I++)
                    J = T ? v(z, C, [M.value, I], !0) : M.value, g(B, I, J);
                else
                  for (F = x(E), B = A ? new this(F) : b(F); F > I; I++)
                    J = T ? C(E[I], I) : E[I], g(B, I, J);
                return B.length = I, B;
              };
            }
          ),
          /***/
          12636: (
            /***/
            function(u, l, e) {
              var s = e(98086), i = e(74841), f = e(45495), h = function(v) {
                return function(p, m, x) {
                  var g = s(p), S = f(g), y = i(x, S), b;
                  if (v && m != m) {
                    for (; S > y; )
                      if (b = g[y++], b != b)
                        return !0;
                  } else
                    for (; S > y; y++)
                      if ((v || y in g) && g[y] === m)
                        return v || y || 0;
                  return !v && -1;
                };
              };
              u.exports = {
                // `Array.prototype.includes` method
                // https://tc39.es/ecma262/#sec-array.prototype.includes
                includes: h(!0),
                // `Array.prototype.indexOf` method
                // https://tc39.es/ecma262/#sec-array.prototype.indexof
                indexOf: h(!1)
              };
            }
          ),
          /***/
          91102: (
            /***/
            function(u, l, e) {
              var s = e(25567), i = e(38347), f = e(7514), h = e(43162), v = e(45495), p = e(45744), m = i([].push), x = function(g) {
                var S = g == 1, y = g == 2, b = g == 3, n = g == 4, w = g == 6, E = g == 7, A = g == 5 || w;
                return function(O, C, T, P) {
                  for (var I = h(O), F = f(I), B = s(C, T), M = v(F), z = 0, L = P || p, J = S ? L(O, M) : y || E ? L(O, 0) : void 0, ft, Q; M > z; z++)
                    if ((A || z in F) && (ft = F[z], Q = B(ft, z, I), g))
                      if (S)
                        J[z] = Q;
                      else if (Q)
                        switch (g) {
                          case 3:
                            return !0;
                          case 5:
                            return ft;
                          case 6:
                            return z;
                          case 2:
                            m(J, ft);
                        }
                      else
                        switch (g) {
                          case 4:
                            return !1;
                          case 7:
                            m(J, ft);
                        }
                  return w ? -1 : b || n ? n : J;
                };
              };
              u.exports = {
                // `Array.prototype.forEach` method
                // https://tc39.es/ecma262/#sec-array.prototype.foreach
                forEach: x(0),
                // `Array.prototype.map` method
                // https://tc39.es/ecma262/#sec-array.prototype.map
                map: x(1),
                // `Array.prototype.filter` method
                // https://tc39.es/ecma262/#sec-array.prototype.filter
                filter: x(2),
                // `Array.prototype.some` method
                // https://tc39.es/ecma262/#sec-array.prototype.some
                some: x(3),
                // `Array.prototype.every` method
                // https://tc39.es/ecma262/#sec-array.prototype.every
                every: x(4),
                // `Array.prototype.find` method
                // https://tc39.es/ecma262/#sec-array.prototype.find
                find: x(5),
                // `Array.prototype.findIndex` method
                // https://tc39.es/ecma262/#sec-array.prototype.findIndex
                findIndex: x(6),
                // `Array.prototype.filterReject` method
                // https://github.com/tc39/proposal-array-filtering
                filterReject: x(7)
              };
            }
          ),
          /***/
          84320: (
            /***/
            function(u, l, e) {
              var s = e(58448), i = e(98086), f = e(26882), h = e(45495), v = e(81007), p = Math.min, m = [].lastIndexOf, x = !!m && 1 / [1].lastIndexOf(1, -0) < 0, g = v("lastIndexOf"), S = x || !g;
              u.exports = S ? function(b) {
                if (x)
                  return s(m, this, arguments) || 0;
                var n = i(this), w = h(n), E = w - 1;
                for (arguments.length > 1 && (E = p(E, f(arguments[1]))), E < 0 && (E = w + E); E >= 0; E--)
                  if (E in n && n[E] === b)
                    return E || 0;
                return -1;
              } : m;
            }
          ),
          /***/
          56280: (
            /***/
            function(u, l, e) {
              var s = e(47044), i = e(38688), f = e(70091), h = i("species");
              u.exports = function(v) {
                return f >= 51 || !s(function() {
                  var p = [], m = p.constructor = {};
                  return m[h] = function() {
                    return { foo: 1 };
                  }, p[v](Boolean).foo !== 1;
                });
              };
            }
          ),
          /***/
          81007: (
            /***/
            function(u, l, e) {
              var s = e(47044);
              u.exports = function(i, f) {
                var h = [][i];
                return !!h && s(function() {
                  h.call(null, f || function() {
                    throw 1;
                  }, 1);
                });
              };
            }
          ),
          /***/
          32843: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(32631), f = e(43162), h = e(7514), v = e(45495), p = s.TypeError, m = function(x) {
                return function(g, S, y, b) {
                  i(S);
                  var n = f(g), w = h(n), E = v(n), A = x ? E - 1 : 0, O = x ? -1 : 1;
                  if (y < 2)
                    for (; ; ) {
                      if (A in w) {
                        b = w[A], A += O;
                        break;
                      }
                      if (A += O, x ? A < 0 : E <= A)
                        throw p("Reduce of empty array with no initial value");
                    }
                  for (; x ? A >= 0 : E > A; A += O)
                    A in w && (b = S(b, w[A], A, n));
                  return b;
                };
              };
              u.exports = {
                // `Array.prototype.reduce` method
                // https://tc39.es/ecma262/#sec-array.prototype.reduce
                left: m(!1),
                // `Array.prototype.reduceRight` method
                // https://tc39.es/ecma262/#sec-array.prototype.reduceright
                right: m(!0)
              };
            }
          ),
          /***/
          73163: (
            /***/
            function(u, l, e) {
              var s = e(38347);
              u.exports = s([].slice);
            }
          ),
          /***/
          43977: (
            /***/
            function(u, l, e) {
              var s = e(73163), i = Math.floor, f = function(p, m) {
                var x = p.length, g = i(x / 2);
                return x < 8 ? h(p, m) : v(
                  p,
                  f(s(p, 0, g), m),
                  f(s(p, g), m),
                  m
                );
              }, h = function(p, m) {
                for (var x = p.length, g = 1, S, y; g < x; ) {
                  for (y = g, S = p[g]; y && m(p[y - 1], S) > 0; )
                    p[y] = p[--y];
                  y !== g++ && (p[y] = S);
                }
                return p;
              }, v = function(p, m, x, g) {
                for (var S = m.length, y = x.length, b = 0, n = 0; b < S || n < y; )
                  p[b + n] = b < S && n < y ? g(m[b], x[n]) <= 0 ? m[b++] : x[n++] : b < S ? m[b++] : x[n++];
                return p;
              };
              u.exports = f;
            }
          ),
          /***/
          98578: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(59113), f = e(20884), h = e(24517), v = e(38688), p = v("species"), m = s.Array;
              u.exports = function(x) {
                var g;
                return i(x) && (g = x.constructor, f(g) && (g === m || i(g.prototype)) ? g = void 0 : h(g) && (g = g[p], g === null && (g = void 0))), g === void 0 ? m : g;
              };
            }
          ),
          /***/
          45744: (
            /***/
            function(u, l, e) {
              var s = e(98578);
              u.exports = function(i, f) {
                return new (s(i))(f === 0 ? 0 : f);
              };
            }
          ),
          /***/
          97738: (
            /***/
            function(u, l, e) {
              var s = e(34984), i = e(50194);
              u.exports = function(f, h, v, p) {
                try {
                  return p ? h(s(v)[0], v[1]) : h(v);
                } catch (m) {
                  i(f, "throw", m);
                }
              };
            }
          ),
          /***/
          46769: (
            /***/
            function(u, l, e) {
              var s = e(38688), i = s("iterator"), f = !1;
              try {
                var h = 0, v = {
                  next: function() {
                    return { done: !!h++ };
                  },
                  return: function() {
                    f = !0;
                  }
                };
                v[i] = function() {
                  return this;
                }, Array.from(v, function() {
                  throw 2;
                });
              } catch {
              }
              u.exports = function(p, m) {
                if (!m && !f)
                  return !1;
                var x = !1;
                try {
                  var g = {};
                  g[i] = function() {
                    return {
                      next: function() {
                        return { done: x = !0 };
                      }
                    };
                  }, p(g);
                } catch {
                }
                return x;
              };
            }
          ),
          /***/
          93975: (
            /***/
            function(u, l, e) {
              var s = e(38347), i = s({}.toString), f = s("".slice);
              u.exports = function(h) {
                return f(i(h), 8, -1);
              };
            }
          ),
          /***/
          52564: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(24663), f = e(94578), h = e(93975), v = e(38688), p = v("toStringTag"), m = s.Object, x = h(function() {
                return arguments;
              }()) == "Arguments", g = function(S, y) {
                try {
                  return S[y];
                } catch {
                }
              };
              u.exports = i ? h : function(S) {
                var y, b, n;
                return S === void 0 ? "Undefined" : S === null ? "Null" : typeof (b = g(y = m(S), p)) == "string" ? b : x ? h(y) : (n = h(y)) == "Object" && f(y.callee) ? "Arguments" : n;
              };
            }
          ),
          /***/
          34074: (
            /***/
            function(u, l, e) {
              var s = e(38347), i = e(73163), f = s("".replace), h = s("".split), v = s([].join), p = function(S) {
                return String(Error(S).stack);
              }("zxcasd"), m = /\n\s*at [^:]*:[^\n]*/, x = m.test(p), g = /@[^\n]*\n/.test(p) && !/zxcasd/.test(p);
              u.exports = function(S, y) {
                if (typeof S != "string")
                  return S;
                if (x)
                  for (; y--; )
                    S = f(S, m, "");
                else if (g)
                  return v(i(h(S, `
`), y), `
`);
                return S;
              };
            }
          ),
          /***/
          9649: (
            /***/
            function(u, l, e) {
              var s = e(95892).f, i = e(10819), f = e(15341), h = e(25567), v = e(2868), p = e(80383), m = e(97001), x = e(51334), g = e(15567), S = e(62148).fastKey, y = e(70172), b = y.set, n = y.getterFor;
              u.exports = {
                getConstructor: function(w, E, A, O) {
                  var C = w(function(B, M) {
                    v(B, T), b(B, {
                      type: E,
                      index: i(null),
                      first: void 0,
                      last: void 0,
                      size: 0
                    }), g || (B.size = 0), M != null && p(M, B[O], { that: B, AS_ENTRIES: A });
                  }), T = C.prototype, P = n(E), I = function(B, M, z) {
                    var L = P(B), J = F(B, M), ft, Q;
                    return J ? J.value = z : (L.last = J = {
                      index: Q = S(M, !0),
                      key: M,
                      value: z,
                      previous: ft = L.last,
                      next: void 0,
                      removed: !1
                    }, L.first || (L.first = J), ft && (ft.next = J), g ? L.size++ : B.size++, Q !== "F" && (L.index[Q] = J)), B;
                  }, F = function(B, M) {
                    var z = P(B), L = S(M), J;
                    if (L !== "F")
                      return z.index[L];
                    for (J = z.first; J; J = J.next)
                      if (J.key == M)
                        return J;
                  };
                  return f(T, {
                    // `{ Map, Set }.prototype.clear()` methods
                    // https://tc39.es/ecma262/#sec-map.prototype.clear
                    // https://tc39.es/ecma262/#sec-set.prototype.clear
                    clear: function() {
                      for (var M = this, z = P(M), L = z.index, J = z.first; J; )
                        J.removed = !0, J.previous && (J.previous = J.previous.next = void 0), delete L[J.index], J = J.next;
                      z.first = z.last = void 0, g ? z.size = 0 : M.size = 0;
                    },
                    // `{ Map, Set }.prototype.delete(key)` methods
                    // https://tc39.es/ecma262/#sec-map.prototype.delete
                    // https://tc39.es/ecma262/#sec-set.prototype.delete
                    delete: function(B) {
                      var M = this, z = P(M), L = F(M, B);
                      if (L) {
                        var J = L.next, ft = L.previous;
                        delete z.index[L.index], L.removed = !0, ft && (ft.next = J), J && (J.previous = ft), z.first == L && (z.first = J), z.last == L && (z.last = ft), g ? z.size-- : M.size--;
                      }
                      return !!L;
                    },
                    // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
                    // https://tc39.es/ecma262/#sec-map.prototype.foreach
                    // https://tc39.es/ecma262/#sec-set.prototype.foreach
                    forEach: function(M) {
                      for (var z = P(this), L = h(M, arguments.length > 1 ? arguments[1] : void 0), J; J = J ? J.next : z.first; )
                        for (L(J.value, J.key, this); J && J.removed; )
                          J = J.previous;
                    },
                    // `{ Map, Set}.prototype.has(key)` methods
                    // https://tc39.es/ecma262/#sec-map.prototype.has
                    // https://tc39.es/ecma262/#sec-set.prototype.has
                    has: function(M) {
                      return !!F(this, M);
                    }
                  }), f(T, A ? {
                    // `Map.prototype.get(key)` method
                    // https://tc39.es/ecma262/#sec-map.prototype.get
                    get: function(M) {
                      var z = F(this, M);
                      return z && z.value;
                    },
                    // `Map.prototype.set(key, value)` method
                    // https://tc39.es/ecma262/#sec-map.prototype.set
                    set: function(M, z) {
                      return I(this, M === 0 ? 0 : M, z);
                    }
                  } : {
                    // `Set.prototype.add(value)` method
                    // https://tc39.es/ecma262/#sec-set.prototype.add
                    add: function(M) {
                      return I(this, M = M === 0 ? 0 : M, M);
                    }
                  }), g && s(T, "size", {
                    get: function() {
                      return P(this).size;
                    }
                  }), C;
                },
                setStrong: function(w, E, A) {
                  var O = E + " Iterator", C = n(E), T = n(O);
                  m(w, E, function(P, I) {
                    b(this, {
                      type: O,
                      target: P,
                      state: C(P),
                      kind: I,
                      last: void 0
                    });
                  }, function() {
                    for (var P = T(this), I = P.kind, F = P.last; F && F.removed; )
                      F = F.previous;
                    return !P.target || !(P.last = F = F ? F.next : P.state.first) ? (P.target = void 0, { value: void 0, done: !0 }) : I == "keys" ? { value: F.key, done: !1 } : I == "values" ? { value: F.value, done: !1 } : { value: [F.key, F.value], done: !1 };
                  }, A ? "entries" : "values", !A, !0), x(E);
                }
              };
            }
          ),
          /***/
          36673: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(32010), f = e(38347), h = e(39599), v = e(13711), p = e(62148), m = e(80383), x = e(2868), g = e(94578), S = e(24517), y = e(47044), b = e(46769), n = e(15216), w = e(51868);
              u.exports = function(E, A, O) {
                var C = E.indexOf("Map") !== -1, T = E.indexOf("Weak") !== -1, P = C ? "set" : "add", I = i[E], F = I && I.prototype, B = I, M = {}, z = function(Pt) {
                  var Gt = f(F[Pt]);
                  v(
                    F,
                    Pt,
                    Pt == "add" ? function(bt) {
                      return Gt(this, bt === 0 ? 0 : bt), this;
                    } : Pt == "delete" ? function(Rt) {
                      return T && !S(Rt) ? !1 : Gt(this, Rt === 0 ? 0 : Rt);
                    } : Pt == "get" ? function(bt) {
                      return T && !S(bt) ? void 0 : Gt(this, bt === 0 ? 0 : bt);
                    } : Pt == "has" ? function(bt) {
                      return T && !S(bt) ? !1 : Gt(this, bt === 0 ? 0 : bt);
                    } : function(bt, Dt) {
                      return Gt(this, bt === 0 ? 0 : bt, Dt), this;
                    }
                  );
                }, L = h(
                  E,
                  !g(I) || !(T || F.forEach && !y(function() {
                    new I().entries().next();
                  }))
                );
                if (L)
                  B = O.getConstructor(A, E, C, P), p.enable();
                else if (h(E, !0)) {
                  var J = new B(), ft = J[P](T ? {} : -0, 1) != J, Q = y(function() {
                    J.has(1);
                  }), xt = b(function(Pt) {
                    new I(Pt);
                  }), St = !T && y(function() {
                    for (var Pt = new I(), Gt = 5; Gt--; )
                      Pt[P](Gt, Gt);
                    return !Pt.has(-0);
                  });
                  xt || (B = A(function(Pt, Gt) {
                    x(Pt, F);
                    var Rt = w(new I(), Pt, B);
                    return Gt != null && m(Gt, Rt[P], { that: Rt, AS_ENTRIES: C }), Rt;
                  }), B.prototype = F, F.constructor = B), (Q || St) && (z("delete"), z("has"), C && z("get")), (St || ft) && z(P), T && F.clear && delete F.clear;
                }
                return M[E] = B, s({ global: !0, forced: B != I }, M), n(B, E), T || O.setStrong(B, E, C), B;
              };
            }
          ),
          /***/
          2675: (
            /***/
            function(u, l, e) {
              var s = e(20340), i = e(21594), f = e(72062), h = e(95892);
              u.exports = function(v, p) {
                for (var m = i(p), x = h.f, g = f.f, S = 0; S < m.length; S++) {
                  var y = m[S];
                  s(v, y) || x(v, y, g(p, y));
                }
              };
            }
          ),
          /***/
          91151: (
            /***/
            function(u, l, e) {
              var s = e(38688), i = s("match");
              u.exports = function(f) {
                var h = /./;
                try {
                  "/./"[f](h);
                } catch {
                  try {
                    return h[i] = !1, "/./"[f](h);
                  } catch {
                  }
                }
                return !1;
              };
            }
          ),
          /***/
          68494: (
            /***/
            function(u, l, e) {
              var s = e(47044);
              u.exports = !s(function() {
                function i() {
                }
                return i.prototype.constructor = null, Object.getPrototypeOf(new i()) !== i.prototype;
              });
            }
          ),
          /***/
          91159: (
            /***/
            function(u, l, e) {
              var s = e(38347), i = e(83943), f = e(25096), h = /"/g, v = s("".replace);
              u.exports = function(p, m, x, g) {
                var S = f(i(p)), y = "<" + m;
                return x !== "" && (y += " " + x + '="' + v(f(g), h, "&quot;") + '"'), y + ">" + S + "</" + m + ">";
              };
            }
          ),
          /***/
          13945: (
            /***/
            function(u, l, e) {
              var s = e(5844).IteratorPrototype, i = e(10819), f = e(97841), h = e(15216), v = e(15366), p = function() {
                return this;
              };
              u.exports = function(m, x, g) {
                var S = x + " Iterator";
                return m.prototype = i(s, { next: f(1, g) }), h(m, S, !1, !0), v[S] = p, m;
              };
            }
          ),
          /***/
          48914: (
            /***/
            function(u, l, e) {
              var s = e(15567), i = e(95892), f = e(97841);
              u.exports = s ? function(h, v, p) {
                return i.f(h, v, f(1, p));
              } : function(h, v, p) {
                return h[v] = p, h;
              };
            }
          ),
          /***/
          97841: (
            /***/
            function(u) {
              u.exports = function(l, e) {
                return {
                  enumerable: !(l & 1),
                  configurable: !(l & 2),
                  writable: !(l & 4),
                  value: e
                };
              };
            }
          ),
          /***/
          38639: (
            /***/
            function(u, l, e) {
              var s = e(63918), i = e(95892), f = e(97841);
              u.exports = function(h, v, p) {
                var m = s(v);
                m in h ? i.f(h, m, f(0, p)) : h[m] = p;
              };
            }
          ),
          /***/
          53087: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(34984), f = e(39629), h = s.TypeError;
              u.exports = function(v) {
                if (i(this), v === "string" || v === "default")
                  v = "string";
                else if (v !== "number")
                  throw h("Incorrect hint");
                return f(this, v);
              };
            }
          ),
          /***/
          97001: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(2834), f = e(63432), h = e(7081), v = e(94578), p = e(13945), m = e(69548), x = e(3840), g = e(15216), S = e(48914), y = e(13711), b = e(38688), n = e(15366), w = e(5844), E = h.PROPER, A = h.CONFIGURABLE, O = w.IteratorPrototype, C = w.BUGGY_SAFARI_ITERATORS, T = b("iterator"), P = "keys", I = "values", F = "entries", B = function() {
                return this;
              };
              u.exports = function(M, z, L, J, ft, Q, xt) {
                p(L, z, J);
                var St = function(wt) {
                  if (wt === ft && Dt)
                    return Dt;
                  if (!C && wt in Rt)
                    return Rt[wt];
                  switch (wt) {
                    case P:
                      return function() {
                        return new L(this, wt);
                      };
                    case I:
                      return function() {
                        return new L(this, wt);
                      };
                    case F:
                      return function() {
                        return new L(this, wt);
                      };
                  }
                  return function() {
                    return new L(this);
                  };
                }, Pt = z + " Iterator", Gt = !1, Rt = M.prototype, bt = Rt[T] || Rt["@@iterator"] || ft && Rt[ft], Dt = !C && bt || St(ft), X = z == "Array" && Rt.entries || bt, gt, st, rt;
                if (X && (gt = m(X.call(new M())), gt !== Object.prototype && gt.next && (!f && m(gt) !== O && (x ? x(gt, O) : v(gt[T]) || y(gt, T, B)), g(gt, Pt, !0, !0), f && (n[Pt] = B))), E && ft == I && bt && bt.name !== I && (!f && A ? S(Rt, "name", I) : (Gt = !0, Dt = function() {
                  return i(bt, this);
                })), ft)
                  if (st = {
                    values: St(I),
                    keys: Q ? Dt : St(P),
                    entries: St(F)
                  }, xt)
                    for (rt in st)
                      (C || Gt || !(rt in Rt)) && y(Rt, rt, st[rt]);
                  else
                    s({ target: z, proto: !0, forced: C || Gt }, st);
                return (!f || xt) && Rt[T] !== Dt && y(Rt, T, Dt, { name: ft }), n[z] = Dt, st;
              };
            }
          ),
          /***/
          46042: (
            /***/
            function(u, l, e) {
              var s = e(11206), i = e(20340), f = e(75960), h = e(95892).f;
              u.exports = function(v) {
                var p = s.Symbol || (s.Symbol = {});
                i(p, v) || h(p, v, {
                  value: f.f(v)
                });
              };
            }
          ),
          /***/
          15567: (
            /***/
            function(u, l, e) {
              var s = e(47044);
              u.exports = !s(function() {
                return Object.defineProperty({}, 1, { get: function() {
                  return 7;
                } })[1] != 7;
              });
            }
          ),
          /***/
          12072: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(24517), f = s.document, h = i(f) && i(f.createElement);
              u.exports = function(v) {
                return h ? f.createElement(v) : {};
              };
            }
          ),
          /***/
          23327: (
            /***/
            function(u) {
              u.exports = {
                CSSRuleList: 0,
                CSSStyleDeclaration: 0,
                CSSValueList: 0,
                ClientRectList: 0,
                DOMRectList: 0,
                DOMStringList: 0,
                DOMTokenList: 1,
                DataTransferItemList: 0,
                FileList: 0,
                HTMLAllCollection: 0,
                HTMLCollection: 0,
                HTMLFormElement: 0,
                HTMLSelectElement: 0,
                MediaList: 0,
                MimeTypeArray: 0,
                NamedNodeMap: 0,
                NodeList: 1,
                PaintRequestList: 0,
                Plugin: 0,
                PluginArray: 0,
                SVGLengthList: 0,
                SVGNumberList: 0,
                SVGPathSegList: 0,
                SVGPointList: 0,
                SVGStringList: 0,
                SVGTransformList: 0,
                SourceBufferList: 0,
                StyleSheetList: 0,
                TextTrackCueList: 0,
                TextTrackList: 0,
                TouchList: 0
              };
            }
          ),
          /***/
          67797: (
            /***/
            function(u, l, e) {
              var s = e(12072), i = s("span").classList, f = i && i.constructor && i.constructor.prototype;
              u.exports = f === Object.prototype ? void 0 : f;
            }
          ),
          /***/
          3809: (
            /***/
            function(u, l, e) {
              var s = e(40715), i = s.match(/firefox\/(\d+)/i);
              u.exports = !!i && +i[1];
            }
          ),
          /***/
          3157: (
            /***/
            function(u) {
              u.exports = typeof window == "object";
            }
          ),
          /***/
          21983: (
            /***/
            function(u, l, e) {
              var s = e(40715);
              u.exports = /MSIE|Trident/.test(s);
            }
          ),
          /***/
          70573: (
            /***/
            function(u, l, e) {
              var s = e(40715), i = e(32010);
              u.exports = /ipad|iphone|ipod/i.test(s) && i.Pebble !== void 0;
            }
          ),
          /***/
          17716: (
            /***/
            function(u, l, e) {
              var s = e(40715);
              u.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(s);
            }
          ),
          /***/
          95053: (
            /***/
            function(u, l, e) {
              var s = e(93975), i = e(32010);
              u.exports = s(i.process) == "process";
            }
          ),
          /***/
          664: (
            /***/
            function(u, l, e) {
              var s = e(40715);
              u.exports = /web0s(?!.*chrome)/i.test(s);
            }
          ),
          /***/
          40715: (
            /***/
            function(u, l, e) {
              var s = e(38486);
              u.exports = s("navigator", "userAgent") || "";
            }
          ),
          /***/
          70091: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(40715), f = s.process, h = s.Deno, v = f && f.versions || h && h.version, p = v && v.v8, m, x;
              p && (m = p.split("."), x = m[0] > 0 && m[0] < 4 ? 1 : +(m[0] + m[1])), !x && i && (m = i.match(/Edge\/(\d+)/), (!m || m[1] >= 74) && (m = i.match(/Chrome\/(\d+)/), m && (x = +m[1]))), u.exports = x;
            }
          ),
          /***/
          41731: (
            /***/
            function(u, l, e) {
              var s = e(40715), i = s.match(/AppleWebKit\/(\d+)\./);
              u.exports = !!i && +i[1];
            }
          ),
          /***/
          2416: (
            /***/
            function(u) {
              u.exports = [
                "constructor",
                "hasOwnProperty",
                "isPrototypeOf",
                "propertyIsEnumerable",
                "toLocaleString",
                "toString",
                "valueOf"
              ];
            }
          ),
          /***/
          45144: (
            /***/
            function(u, l, e) {
              var s = e(47044), i = e(97841);
              u.exports = !s(function() {
                var f = Error("a");
                return "stack" in f ? (Object.defineProperty(f, "stack", i(1, 7)), f.stack !== 7) : !0;
              });
            }
          ),
          /***/
          56475: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(72062).f, f = e(48914), h = e(13711), v = e(7421), p = e(2675), m = e(39599);
              u.exports = function(x, g) {
                var S = x.target, y = x.global, b = x.stat, n, w, E, A, O, C;
                if (y ? w = s : b ? w = s[S] || v(S, {}) : w = (s[S] || {}).prototype, w)
                  for (E in g) {
                    if (O = g[E], x.noTargetGet ? (C = i(w, E), A = C && C.value) : A = w[E], n = m(y ? E : S + (b ? "." : "#") + E, x.forced), !n && A !== void 0) {
                      if (typeof O == typeof A)
                        continue;
                      p(O, A);
                    }
                    (x.sham || A && A.sham) && f(O, "sham", !0), h(w, E, O, x);
                  }
              };
            }
          ),
          /***/
          47044: (
            /***/
            function(u) {
              u.exports = function(l) {
                try {
                  return !!l();
                } catch {
                  return !0;
                }
              };
            }
          ),
          /***/
          11813: (
            /***/
            function(u, l, e) {
              e(61726);
              var s = e(38347), i = e(13711), f = e(49820), h = e(47044), v = e(38688), p = e(48914), m = v("species"), x = RegExp.prototype;
              u.exports = function(g, S, y, b) {
                var n = v(g), w = !h(function() {
                  var C = {};
                  return C[n] = function() {
                    return 7;
                  }, ""[g](C) != 7;
                }), E = w && !h(function() {
                  var C = !1, T = /a/;
                  return g === "split" && (T = {}, T.constructor = {}, T.constructor[m] = function() {
                    return T;
                  }, T.flags = "", T[n] = /./[n]), T.exec = function() {
                    return C = !0, null;
                  }, T[n](""), !C;
                });
                if (!w || !E || y) {
                  var A = s(/./[n]), O = S(n, ""[g], function(C, T, P, I, F) {
                    var B = s(C), M = T.exec;
                    return M === f || M === x.exec ? w && !F ? { done: !0, value: A(T, P, I) } : { done: !0, value: B(P, T, I) } : { done: !1 };
                  });
                  i(String.prototype, g, O[0]), i(x, n, O[1]);
                }
                b && p(x[n], "sham", !0);
              };
            }
          ),
          /***/
          55481: (
            /***/
            function(u, l, e) {
              var s = e(47044);
              u.exports = !s(function() {
                return Object.isExtensible(Object.preventExtensions({}));
              });
            }
          ),
          /***/
          58448: (
            /***/
            function(u) {
              var l = Function.prototype, e = l.apply, s = l.bind, i = l.call;
              u.exports = typeof Reflect == "object" && Reflect.apply || (s ? i.bind(e) : function() {
                return i.apply(e, arguments);
              });
            }
          ),
          /***/
          25567: (
            /***/
            function(u, l, e) {
              var s = e(38347), i = e(32631), f = s(s.bind);
              u.exports = function(h, v) {
                return i(h), v === void 0 ? h : f ? f(h, v) : function() {
                  return h.apply(v, arguments);
                };
              };
            }
          ),
          /***/
          5481: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(38347), f = e(32631), h = e(24517), v = e(20340), p = e(73163), m = s.Function, x = i([].concat), g = i([].join), S = {}, y = function(b, n, w) {
                if (!v(S, n)) {
                  for (var E = [], A = 0; A < n; A++)
                    E[A] = "a[" + A + "]";
                  S[n] = m("C,a", "return new C(" + g(E, ",") + ")");
                }
                return S[n](b, w);
              };
              u.exports = m.bind || function(n) {
                var w = f(this), E = w.prototype, A = p(arguments, 1), O = function() {
                  var T = x(A, p(arguments));
                  return this instanceof O ? y(w, T.length, T) : w.apply(n, T);
                };
                return h(E) && (O.prototype = E), O;
              };
            }
          ),
          /***/
          2834: (
            /***/
            function(u) {
              var l = Function.prototype.call;
              u.exports = l.bind ? l.bind(l) : function() {
                return l.apply(l, arguments);
              };
            }
          ),
          /***/
          7081: (
            /***/
            function(u, l, e) {
              var s = e(15567), i = e(20340), f = Function.prototype, h = s && Object.getOwnPropertyDescriptor, v = i(f, "name"), p = v && (function() {
              }).name === "something", m = v && (!s || s && h(f, "name").configurable);
              u.exports = {
                EXISTS: v,
                PROPER: p,
                CONFIGURABLE: m
              };
            }
          ),
          /***/
          38347: (
            /***/
            function(u) {
              var l = Function.prototype, e = l.bind, s = l.call, i = e && e.bind(s);
              u.exports = e ? function(f) {
                return f && i(s, f);
              } : function(f) {
                return f && function() {
                  return s.apply(f, arguments);
                };
              };
            }
          ),
          /***/
          38486: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(94578), f = function(h) {
                return i(h) ? h : void 0;
              };
              u.exports = function(h, v) {
                return arguments.length < 2 ? f(s[h]) : s[h] && s[h][v];
              };
            }
          ),
          /***/
          13872: (
            /***/
            function(u, l, e) {
              var s = e(52564), i = e(51839), f = e(15366), h = e(38688), v = h("iterator");
              u.exports = function(p) {
                if (p != null)
                  return i(p, v) || i(p, "@@iterator") || f[s(p)];
              };
            }
          ),
          /***/
          15892: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(2834), f = e(32631), h = e(34984), v = e(68664), p = e(13872), m = s.TypeError;
              u.exports = function(x, g) {
                var S = arguments.length < 2 ? p(x) : g;
                if (f(S))
                  return h(i(S, x));
                throw m(v(x) + " is not iterable");
              };
            }
          ),
          /***/
          51839: (
            /***/
            function(u, l, e) {
              var s = e(32631);
              u.exports = function(i, f) {
                var h = i[f];
                return h == null ? void 0 : s(h);
              };
            }
          ),
          /***/
          29519: (
            /***/
            function(u, l, e) {
              var s = e(38347), i = e(43162), f = Math.floor, h = s("".charAt), v = s("".replace), p = s("".slice), m = /\$([$&'`]|\d{1,2}|<[^>]*>)/g, x = /\$([$&'`]|\d{1,2})/g;
              u.exports = function(g, S, y, b, n, w) {
                var E = y + g.length, A = b.length, O = x;
                return n !== void 0 && (n = i(n), O = m), v(w, O, function(C, T) {
                  var P;
                  switch (h(T, 0)) {
                    case "$":
                      return "$";
                    case "&":
                      return g;
                    case "`":
                      return p(S, 0, y);
                    case "'":
                      return p(S, E);
                    case "<":
                      P = n[p(T, 1, -1)];
                      break;
                    default:
                      var I = +T;
                      if (I === 0)
                        return C;
                      if (I > A) {
                        var F = f(I / 10);
                        return F === 0 ? C : F <= A ? b[F - 1] === void 0 ? h(T, 1) : b[F - 1] + h(T, 1) : C;
                      }
                      P = b[I - 1];
                  }
                  return P === void 0 ? "" : P;
                });
              };
            }
          ),
          /***/
          32010: (
            /***/
            function(u, l, e) {
              var s = function(i) {
                return i && i.Math == Math && i;
              };
              u.exports = // eslint-disable-next-line es/no-global-this -- safe
              s(typeof globalThis == "object" && globalThis) || s(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
              s(typeof self == "object" && self) || s(typeof e.g == "object" && e.g) || // eslint-disable-next-line no-new-func -- fallback
              function() {
                return this;
              }() || Function("return this")();
            }
          ),
          /***/
          20340: (
            /***/
            function(u, l, e) {
              var s = e(38347), i = e(43162), f = s({}.hasOwnProperty);
              u.exports = Object.hasOwn || function(v, p) {
                return f(i(v), p);
              };
            }
          ),
          /***/
          90682: (
            /***/
            function(u) {
              u.exports = {};
            }
          ),
          /***/
          61144: (
            /***/
            function(u, l, e) {
              var s = e(32010);
              u.exports = function(i, f) {
                var h = s.console;
                h && h.error && (arguments.length == 1 ? h.error(i) : h.error(i, f));
              };
            }
          ),
          /***/
          520: (
            /***/
            function(u, l, e) {
              var s = e(38486);
              u.exports = s("document", "documentElement");
            }
          ),
          /***/
          18904: (
            /***/
            function(u, l, e) {
              var s = e(15567), i = e(47044), f = e(12072);
              u.exports = !s && !i(function() {
                return Object.defineProperty(f("div"), "a", {
                  get: function() {
                    return 7;
                  }
                }).a != 7;
              });
            }
          ),
          /***/
          64397: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = s.Array, f = Math.abs, h = Math.pow, v = Math.floor, p = Math.log, m = Math.LN2, x = function(S, y, b) {
                var n = i(b), w = b * 8 - y - 1, E = (1 << w) - 1, A = E >> 1, O = y === 23 ? h(2, -24) - h(2, -77) : 0, C = S < 0 || S === 0 && 1 / S < 0 ? 1 : 0, T = 0, P, I, F;
                for (S = f(S), S != S || S === 1 / 0 ? (I = S != S ? 1 : 0, P = E) : (P = v(p(S) / m), S * (F = h(2, -P)) < 1 && (P--, F *= 2), P + A >= 1 ? S += O / F : S += O * h(2, 1 - A), S * F >= 2 && (P++, F /= 2), P + A >= E ? (I = 0, P = E) : P + A >= 1 ? (I = (S * F - 1) * h(2, y), P = P + A) : (I = S * h(2, A - 1) * h(2, y), P = 0)); y >= 8; n[T++] = I & 255, I /= 256, y -= 8)
                  ;
                for (P = P << y | I, w += y; w > 0; n[T++] = P & 255, P /= 256, w -= 8)
                  ;
                return n[--T] |= C * 128, n;
              }, g = function(S, y) {
                var b = S.length, n = b * 8 - y - 1, w = (1 << n) - 1, E = w >> 1, A = n - 7, O = b - 1, C = S[O--], T = C & 127, P;
                for (C >>= 7; A > 0; T = T * 256 + S[O], O--, A -= 8)
                  ;
                for (P = T & (1 << -A) - 1, T >>= -A, A += y; A > 0; P = P * 256 + S[O], O--, A -= 8)
                  ;
                if (T === 0)
                  T = 1 - E;
                else {
                  if (T === w)
                    return P ? NaN : C ? -1 / 0 : 1 / 0;
                  P = P + h(2, y), T = T - E;
                }
                return (C ? -1 : 1) * P * h(2, T - y);
              };
              u.exports = {
                pack: x,
                unpack: g
              };
            }
          ),
          /***/
          7514: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(38347), f = e(47044), h = e(93975), v = s.Object, p = i("".split);
              u.exports = f(function() {
                return !v("z").propertyIsEnumerable(0);
              }) ? function(m) {
                return h(m) == "String" ? p(m, "") : v(m);
              } : v;
            }
          ),
          /***/
          51868: (
            /***/
            function(u, l, e) {
              var s = e(94578), i = e(24517), f = e(3840);
              u.exports = function(h, v, p) {
                var m, x;
                return (
                  // it can work only with native `setPrototypeOf`
                  f && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
                  s(m = v.constructor) && m !== p && i(x = m.prototype) && x !== p.prototype && f(h, x), h
                );
              };
            }
          ),
          /***/
          10447: (
            /***/
            function(u, l, e) {
              var s = e(38347), i = e(94578), f = e(55480), h = s(Function.toString);
              i(f.inspectSource) || (f.inspectSource = function(v) {
                return h(v);
              }), u.exports = f.inspectSource;
            }
          ),
          /***/
          87811: (
            /***/
            function(u, l, e) {
              var s = e(24517), i = e(48914);
              u.exports = function(f, h) {
                s(h) && "cause" in h && i(f, "cause", h.cause);
              };
            }
          ),
          /***/
          62148: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(38347), f = e(90682), h = e(24517), v = e(20340), p = e(95892).f, m = e(6611), x = e(8807), g = e(46859), S = e(55481), y = !1, b = g("meta"), n = 0, w = Object.isExtensible || function() {
                return !0;
              }, E = function(I) {
                p(I, b, { value: {
                  objectID: "O" + n++,
                  // object ID
                  weakData: {}
                  // weak collections IDs
                } });
              }, A = function(I, F) {
                if (!h(I))
                  return typeof I == "symbol" ? I : (typeof I == "string" ? "S" : "P") + I;
                if (!v(I, b)) {
                  if (!w(I))
                    return "F";
                  if (!F)
                    return "E";
                  E(I);
                }
                return I[b].objectID;
              }, O = function(I, F) {
                if (!v(I, b)) {
                  if (!w(I))
                    return !0;
                  if (!F)
                    return !1;
                  E(I);
                }
                return I[b].weakData;
              }, C = function(I) {
                return S && y && w(I) && !v(I, b) && E(I), I;
              }, T = function() {
                P.enable = function() {
                }, y = !0;
                var I = m.f, F = i([].splice), B = {};
                B[b] = 1, I(B).length && (m.f = function(M) {
                  for (var z = I(M), L = 0, J = z.length; L < J; L++)
                    if (z[L] === b) {
                      F(z, L, 1);
                      break;
                    }
                  return z;
                }, s({ target: "Object", stat: !0, forced: !0 }, {
                  getOwnPropertyNames: x.f
                }));
              }, P = u.exports = {
                enable: T,
                fastKey: A,
                getWeakData: O,
                onFreeze: C
              };
              f[b] = !0;
            }
          ),
          /***/
          70172: (
            /***/
            function(u, l, e) {
              var s = e(26168), i = e(32010), f = e(38347), h = e(24517), v = e(48914), p = e(20340), m = e(55480), x = e(82194), g = e(90682), S = "Object already initialized", y = i.TypeError, b = i.WeakMap, n, w, E, A = function(B) {
                return E(B) ? w(B) : n(B, {});
              }, O = function(B) {
                return function(M) {
                  var z;
                  if (!h(M) || (z = w(M)).type !== B)
                    throw y("Incompatible receiver, " + B + " required");
                  return z;
                };
              };
              if (s || m.state) {
                var C = m.state || (m.state = new b()), T = f(C.get), P = f(C.has), I = f(C.set);
                n = function(B, M) {
                  if (P(C, B))
                    throw new y(S);
                  return M.facade = B, I(C, B, M), M;
                }, w = function(B) {
                  return T(C, B) || {};
                }, E = function(B) {
                  return P(C, B);
                };
              } else {
                var F = x("state");
                g[F] = !0, n = function(B, M) {
                  if (p(B, F))
                    throw new y(S);
                  return M.facade = B, v(B, F, M), M;
                }, w = function(B) {
                  return p(B, F) ? B[F] : {};
                }, E = function(B) {
                  return p(B, F);
                };
              }
              u.exports = {
                set: n,
                get: w,
                has: E,
                enforce: A,
                getterFor: O
              };
            }
          ),
          /***/
          89564: (
            /***/
            function(u, l, e) {
              var s = e(38688), i = e(15366), f = s("iterator"), h = Array.prototype;
              u.exports = function(v) {
                return v !== void 0 && (i.Array === v || h[f] === v);
              };
            }
          ),
          /***/
          59113: (
            /***/
            function(u, l, e) {
              var s = e(93975);
              u.exports = Array.isArray || function(f) {
                return s(f) == "Array";
              };
            }
          ),
          /***/
          94578: (
            /***/
            function(u) {
              u.exports = function(l) {
                return typeof l == "function";
              };
            }
          ),
          /***/
          20884: (
            /***/
            function(u, l, e) {
              var s = e(38347), i = e(47044), f = e(94578), h = e(52564), v = e(38486), p = e(10447), m = function() {
              }, x = [], g = v("Reflect", "construct"), S = /^\s*(?:class|function)\b/, y = s(S.exec), b = !S.exec(m), n = function(E) {
                if (!f(E))
                  return !1;
                try {
                  return g(m, x, E), !0;
                } catch {
                  return !1;
                }
              }, w = function(E) {
                if (!f(E))
                  return !1;
                switch (h(E)) {
                  case "AsyncFunction":
                  case "GeneratorFunction":
                  case "AsyncGeneratorFunction":
                    return !1;
                }
                return b || !!y(S, p(E));
              };
              u.exports = !g || i(function() {
                var E;
                return n(n.call) || !n(Object) || !n(function() {
                  E = !0;
                }) || E;
              }) ? w : n;
            }
          ),
          /***/
          39599: (
            /***/
            function(u, l, e) {
              var s = e(47044), i = e(94578), f = /#|\.prototype\./, h = function(g, S) {
                var y = p[v(g)];
                return y == x ? !0 : y == m ? !1 : i(S) ? s(S) : !!S;
              }, v = h.normalize = function(g) {
                return String(g).replace(f, ".").toLowerCase();
              }, p = h.data = {}, m = h.NATIVE = "N", x = h.POLYFILL = "P";
              u.exports = h;
            }
          ),
          /***/
          17506: (
            /***/
            function(u, l, e) {
              var s = e(24517), i = Math.floor;
              u.exports = Number.isInteger || function(h) {
                return !s(h) && isFinite(h) && i(h) === h;
              };
            }
          ),
          /***/
          24517: (
            /***/
            function(u, l, e) {
              var s = e(94578);
              u.exports = function(i) {
                return typeof i == "object" ? i !== null : s(i);
              };
            }
          ),
          /***/
          63432: (
            /***/
            function(u) {
              u.exports = !1;
            }
          ),
          /***/
          28831: (
            /***/
            function(u, l, e) {
              var s = e(24517), i = e(93975), f = e(38688), h = f("match");
              u.exports = function(v) {
                var p;
                return s(v) && ((p = v[h]) !== void 0 ? !!p : i(v) == "RegExp");
              };
            }
          ),
          /***/
          46290: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(38486), f = e(94578), h = e(70176), v = e(9567), p = s.Object;
              u.exports = v ? function(m) {
                return typeof m == "symbol";
              } : function(m) {
                var x = i("Symbol");
                return f(x) && h(x.prototype, p(m));
              };
            }
          ),
          /***/
          80383: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(25567), f = e(2834), h = e(34984), v = e(68664), p = e(89564), m = e(45495), x = e(70176), g = e(15892), S = e(13872), y = e(50194), b = s.TypeError, n = function(E, A) {
                this.stopped = E, this.result = A;
              }, w = n.prototype;
              u.exports = function(E, A, O) {
                var C = O && O.that, T = !!(O && O.AS_ENTRIES), P = !!(O && O.IS_ITERATOR), I = !!(O && O.INTERRUPTED), F = i(A, C), B, M, z, L, J, ft, Q, xt = function(Pt) {
                  return B && y(B, "normal", Pt), new n(!0, Pt);
                }, St = function(Pt) {
                  return T ? (h(Pt), I ? F(Pt[0], Pt[1], xt) : F(Pt[0], Pt[1])) : I ? F(Pt, xt) : F(Pt);
                };
                if (P)
                  B = E;
                else {
                  if (M = S(E), !M)
                    throw b(v(E) + " is not iterable");
                  if (p(M)) {
                    for (z = 0, L = m(E); L > z; z++)
                      if (J = St(E[z]), J && x(w, J))
                        return J;
                    return new n(!1);
                  }
                  B = g(E, M);
                }
                for (ft = B.next; !(Q = f(ft, B)).done; ) {
                  try {
                    J = St(Q.value);
                  } catch (Pt) {
                    y(B, "throw", Pt);
                  }
                  if (typeof J == "object" && J && x(w, J))
                    return J;
                }
                return new n(!1);
              };
            }
          ),
          /***/
          50194: (
            /***/
            function(u, l, e) {
              var s = e(2834), i = e(34984), f = e(51839);
              u.exports = function(h, v, p) {
                var m, x;
                i(h);
                try {
                  if (m = f(h, "return"), !m) {
                    if (v === "throw")
                      throw p;
                    return p;
                  }
                  m = s(m, h);
                } catch (g) {
                  x = !0, m = g;
                }
                if (v === "throw")
                  throw p;
                if (x)
                  throw m;
                return i(m), p;
              };
            }
          ),
          /***/
          5844: (
            /***/
            function(u, l, e) {
              var s = e(47044), i = e(94578), f = e(10819), h = e(69548), v = e(13711), p = e(38688), m = e(63432), x = p("iterator"), g = !1, S, y, b;
              [].keys && (b = [].keys(), "next" in b ? (y = h(h(b)), y !== Object.prototype && (S = y)) : g = !0);
              var n = S == null || s(function() {
                var w = {};
                return S[x].call(w) !== w;
              });
              n ? S = {} : m && (S = f(S)), i(S[x]) || v(S, x, function() {
                return this;
              }), u.exports = {
                IteratorPrototype: S,
                BUGGY_SAFARI_ITERATORS: g
              };
            }
          ),
          /***/
          15366: (
            /***/
            function(u) {
              u.exports = {};
            }
          ),
          /***/
          45495: (
            /***/
            function(u, l, e) {
              var s = e(23417);
              u.exports = function(i) {
                return s(i.length);
              };
            }
          ),
          /***/
          59804: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(25567), f = e(72062).f, h = e(6616).set, v = e(17716), p = e(70573), m = e(664), x = e(95053), g = s.MutationObserver || s.WebKitMutationObserver, S = s.document, y = s.process, b = s.Promise, n = f(s, "queueMicrotask"), w = n && n.value, E, A, O, C, T, P, I, F;
              w || (E = function() {
                var B, M;
                for (x && (B = y.domain) && B.exit(); A; ) {
                  M = A.fn, A = A.next;
                  try {
                    M();
                  } catch (z) {
                    throw A ? C() : O = void 0, z;
                  }
                }
                O = void 0, B && B.enter();
              }, !v && !x && !m && g && S ? (T = !0, P = S.createTextNode(""), new g(E).observe(P, { characterData: !0 }), C = function() {
                P.data = T = !T;
              }) : !p && b && b.resolve ? (I = b.resolve(void 0), I.constructor = b, F = i(I.then, I), C = function() {
                F(E);
              }) : x ? C = function() {
                y.nextTick(E);
              } : (h = i(h, s), C = function() {
                h(E);
              })), u.exports = w || function(B) {
                var M = { fn: B, next: void 0 };
                O && (O.next = M), A || (A = M, C()), O = M;
              };
            }
          ),
          /***/
          5155: (
            /***/
            function(u, l, e) {
              var s = e(32010);
              u.exports = s.Promise;
            }
          ),
          /***/
          46887: (
            /***/
            function(u, l, e) {
              var s = e(70091), i = e(47044);
              u.exports = !!Object.getOwnPropertySymbols && !i(function() {
                var f = Symbol();
                return !String(f) || !(Object(f) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
                !Symbol.sham && s && s < 41;
              });
            }
          ),
          /***/
          26168: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(94578), f = e(10447), h = s.WeakMap;
              u.exports = i(h) && /native code/.test(f(h));
            }
          ),
          /***/
          56614: (
            /***/
            function(u, l, e) {
              var s = e(32631), i = function(f) {
                var h, v;
                this.promise = new f(function(p, m) {
                  if (h !== void 0 || v !== void 0)
                    throw TypeError("Bad Promise constructor");
                  h = p, v = m;
                }), this.resolve = s(h), this.reject = s(v);
              };
              u.exports.f = function(f) {
                return new i(f);
              };
            }
          ),
          /***/
          86392: (
            /***/
            function(u, l, e) {
              var s = e(25096);
              u.exports = function(i, f) {
                return i === void 0 ? arguments.length < 2 ? "" : f : s(i);
              };
            }
          ),
          /***/
          93666: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(28831), f = s.TypeError;
              u.exports = function(h) {
                if (i(h))
                  throw f("The method doesn't accept regular expressions");
                return h;
              };
            }
          ),
          /***/
          59805: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = s.isFinite;
              u.exports = Number.isFinite || function(h) {
                return typeof h == "number" && i(h);
              };
            }
          ),
          /***/
          87146: (
            /***/
            function(u, l, e) {
              var s = e(15567), i = e(38347), f = e(2834), h = e(47044), v = e(84675), p = e(61146), m = e(55574), x = e(43162), g = e(7514), S = Object.assign, y = Object.defineProperty, b = i([].concat);
              u.exports = !S || h(function() {
                if (s && S({ b: 1 }, S(y({}, "a", {
                  enumerable: !0,
                  get: function() {
                    y(this, "b", {
                      value: 3,
                      enumerable: !1
                    });
                  }
                }), { b: 2 })).b !== 1)
                  return !0;
                var n = {}, w = {}, E = Symbol(), A = "abcdefghijklmnopqrst";
                return n[E] = 7, A.split("").forEach(function(O) {
                  w[O] = O;
                }), S({}, n)[E] != 7 || v(S({}, w)).join("") != A;
              }) ? function(w, E) {
                for (var A = x(w), O = arguments.length, C = 1, T = p.f, P = m.f; O > C; )
                  for (var I = g(arguments[C++]), F = T ? b(v(I), T(I)) : v(I), B = F.length, M = 0, z; B > M; )
                    z = F[M++], (!s || f(P, I, z)) && (A[z] = I[z]);
                return A;
              } : S;
            }
          ),
          /***/
          10819: (
            /***/
            function(u, l, e) {
              var s = e(34984), i = e(10196), f = e(2416), h = e(90682), v = e(520), p = e(12072), m = e(82194), x = ">", g = "<", S = "prototype", y = "script", b = m("IE_PROTO"), n = function() {
              }, w = function(T) {
                return g + y + x + T + g + "/" + y + x;
              }, E = function(T) {
                T.write(w("")), T.close();
                var P = T.parentWindow.Object;
                return T = null, P;
              }, A = function() {
                var T = p("iframe"), P = "java" + y + ":", I;
                return T.style.display = "none", v.appendChild(T), T.src = String(P), I = T.contentWindow.document, I.open(), I.write(w("document.F=Object")), I.close(), I.F;
              }, O, C = function() {
                try {
                  O = new ActiveXObject("htmlfile");
                } catch {
                }
                C = typeof document < "u" ? document.domain && O ? E(O) : A() : E(O);
                for (var T = f.length; T--; )
                  delete C[S][f[T]];
                return C();
              };
              h[b] = !0, u.exports = Object.create || function(P, I) {
                var F;
                return P !== null ? (n[S] = s(P), F = new n(), n[S] = null, F[b] = P) : F = C(), I === void 0 ? F : i(F, I);
              };
            }
          ),
          /***/
          10196: (
            /***/
            function(u, l, e) {
              var s = e(15567), i = e(95892), f = e(34984), h = e(98086), v = e(84675);
              u.exports = s ? Object.defineProperties : function(m, x) {
                f(m);
                for (var g = h(x), S = v(x), y = S.length, b = 0, n; y > b; )
                  i.f(m, n = S[b++], g[n]);
                return m;
              };
            }
          ),
          /***/
          95892: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(15567), f = e(18904), h = e(34984), v = e(63918), p = s.TypeError, m = Object.defineProperty;
              l.f = i ? m : function(g, S, y) {
                if (h(g), S = v(S), h(y), f)
                  try {
                    return m(g, S, y);
                  } catch {
                  }
                if ("get" in y || "set" in y)
                  throw p("Accessors not supported");
                return "value" in y && (g[S] = y.value), g;
              };
            }
          ),
          /***/
          72062: (
            /***/
            function(u, l, e) {
              var s = e(15567), i = e(2834), f = e(55574), h = e(97841), v = e(98086), p = e(63918), m = e(20340), x = e(18904), g = Object.getOwnPropertyDescriptor;
              l.f = s ? g : function(y, b) {
                if (y = v(y), b = p(b), x)
                  try {
                    return g(y, b);
                  } catch {
                  }
                if (m(y, b))
                  return h(!i(f.f, y, b), y[b]);
              };
            }
          ),
          /***/
          8807: (
            /***/
            function(u, l, e) {
              var s = e(93975), i = e(98086), f = e(6611).f, h = e(73163), v = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], p = function(m) {
                try {
                  return f(m);
                } catch {
                  return h(v);
                }
              };
              u.exports.f = function(x) {
                return v && s(x) == "Window" ? p(x) : f(i(x));
              };
            }
          ),
          /***/
          6611: (
            /***/
            function(u, l, e) {
              var s = e(64429), i = e(2416), f = i.concat("length", "prototype");
              l.f = Object.getOwnPropertyNames || function(v) {
                return s(v, f);
              };
            }
          ),
          /***/
          61146: (
            /***/
            function(u, l) {
              l.f = Object.getOwnPropertySymbols;
            }
          ),
          /***/
          69548: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(20340), f = e(94578), h = e(43162), v = e(82194), p = e(68494), m = v("IE_PROTO"), x = s.Object, g = x.prototype;
              u.exports = p ? x.getPrototypeOf : function(S) {
                var y = h(S);
                if (i(y, m))
                  return y[m];
                var b = y.constructor;
                return f(b) && y instanceof b ? b.prototype : y instanceof x ? g : null;
              };
            }
          ),
          /***/
          70176: (
            /***/
            function(u, l, e) {
              var s = e(38347);
              u.exports = s({}.isPrototypeOf);
            }
          ),
          /***/
          64429: (
            /***/
            function(u, l, e) {
              var s = e(38347), i = e(20340), f = e(98086), h = e(12636).indexOf, v = e(90682), p = s([].push);
              u.exports = function(m, x) {
                var g = f(m), S = 0, y = [], b;
                for (b in g)
                  !i(v, b) && i(g, b) && p(y, b);
                for (; x.length > S; )
                  i(g, b = x[S++]) && (~h(y, b) || p(y, b));
                return y;
              };
            }
          ),
          /***/
          84675: (
            /***/
            function(u, l, e) {
              var s = e(64429), i = e(2416);
              u.exports = Object.keys || function(h) {
                return s(h, i);
              };
            }
          ),
          /***/
          55574: (
            /***/
            function(u, l) {
              var e = {}.propertyIsEnumerable, s = Object.getOwnPropertyDescriptor, i = s && !e.call({ 1: 2 }, 1);
              l.f = i ? function(h) {
                var v = s(this, h);
                return !!v && v.enumerable;
              } : e;
            }
          ),
          /***/
          3840: (
            /***/
            function(u, l, e) {
              var s = e(38347), i = e(34984), f = e(58659);
              u.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
                var h = !1, v = {}, p;
                try {
                  p = s(Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set), p(v, []), h = v instanceof Array;
                } catch {
                }
                return function(x, g) {
                  return i(x), f(g), h ? p(x, g) : x.__proto__ = g, x;
                };
              }() : void 0);
            }
          ),
          /***/
          80754: (
            /***/
            function(u, l, e) {
              var s = e(15567), i = e(38347), f = e(84675), h = e(98086), v = e(55574).f, p = i(v), m = i([].push), x = function(g) {
                return function(S) {
                  for (var y = h(S), b = f(y), n = b.length, w = 0, E = [], A; n > w; )
                    A = b[w++], (!s || p(y, A)) && m(E, g ? [A, y[A]] : y[A]);
                  return E;
                };
              };
              u.exports = {
                // `Object.entries` method
                // https://tc39.es/ecma262/#sec-object.entries
                entries: x(!0),
                // `Object.values` method
                // https://tc39.es/ecma262/#sec-object.values
                values: x(!1)
              };
            }
          ),
          /***/
          52598: (
            /***/
            function(u, l, e) {
              var s = e(24663), i = e(52564);
              u.exports = s ? {}.toString : function() {
                return "[object " + i(this) + "]";
              };
            }
          ),
          /***/
          39629: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(2834), f = e(94578), h = e(24517), v = s.TypeError;
              u.exports = function(p, m) {
                var x, g;
                if (m === "string" && f(x = p.toString) && !h(g = i(x, p)) || f(x = p.valueOf) && !h(g = i(x, p)) || m !== "string" && f(x = p.toString) && !h(g = i(x, p)))
                  return g;
                throw v("Can't convert object to primitive value");
              };
            }
          ),
          /***/
          21594: (
            /***/
            function(u, l, e) {
              var s = e(38486), i = e(38347), f = e(6611), h = e(61146), v = e(34984), p = i([].concat);
              u.exports = s("Reflect", "ownKeys") || function(x) {
                var g = f.f(v(x)), S = h.f;
                return S ? p(g, S(x)) : g;
              };
            }
          ),
          /***/
          11206: (
            /***/
            function(u, l, e) {
              var s = e(32010);
              u.exports = s;
            }
          ),
          /***/
          61900: (
            /***/
            function(u) {
              u.exports = function(l) {
                try {
                  return { error: !1, value: l() };
                } catch (e) {
                  return { error: !0, value: e };
                }
              };
            }
          ),
          /***/
          28617: (
            /***/
            function(u, l, e) {
              var s = e(34984), i = e(24517), f = e(56614);
              u.exports = function(h, v) {
                if (s(h), i(v) && v.constructor === h)
                  return v;
                var p = f.f(h), m = p.resolve;
                return m(v), p.promise;
              };
            }
          ),
          /***/
          15341: (
            /***/
            function(u, l, e) {
              var s = e(13711);
              u.exports = function(i, f, h) {
                for (var v in f)
                  s(i, v, f[v], h);
                return i;
              };
            }
          ),
          /***/
          13711: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(94578), f = e(20340), h = e(48914), v = e(7421), p = e(10447), m = e(70172), x = e(7081).CONFIGURABLE, g = m.get, S = m.enforce, y = String(String).split("String");
              (u.exports = function(b, n, w, E) {
                var A = E ? !!E.unsafe : !1, O = E ? !!E.enumerable : !1, C = E ? !!E.noTargetGet : !1, T = E && E.name !== void 0 ? E.name : n, P;
                if (i(w) && (String(T).slice(0, 7) === "Symbol(" && (T = "[" + String(T).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"), (!f(w, "name") || x && w.name !== T) && h(w, "name", T), P = S(w), P.source || (P.source = y.join(typeof T == "string" ? T : ""))), b === s) {
                  O ? b[n] = w : v(n, w);
                  return;
                } else
                  A ? !C && b[n] && (O = !0) : delete b[n];
                O ? b[n] = w : h(b, n, w);
              })(Function.prototype, "toString", function() {
                return i(this) && g(this).source || p(this);
              });
            }
          ),
          /***/
          66723: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(2834), f = e(34984), h = e(94578), v = e(93975), p = e(49820), m = s.TypeError;
              u.exports = function(x, g) {
                var S = x.exec;
                if (h(S)) {
                  var y = i(S, x, g);
                  return y !== null && f(y), y;
                }
                if (v(x) === "RegExp")
                  return i(p, x, g);
                throw m("RegExp#exec called on incompatible receiver");
              };
            }
          ),
          /***/
          49820: (
            /***/
            function(u, l, e) {
              var s = e(2834), i = e(38347), f = e(25096), h = e(21182), v = e(74846), p = e(464), m = e(10819), x = e(70172).get, g = e(84030), S = e(97739), y = p("native-string-replace", String.prototype.replace), b = RegExp.prototype.exec, n = b, w = i("".charAt), E = i("".indexOf), A = i("".replace), O = i("".slice), C = function() {
                var F = /a/, B = /b*/g;
                return s(b, F, "a"), s(b, B, "a"), F.lastIndex !== 0 || B.lastIndex !== 0;
              }(), T = v.UNSUPPORTED_Y || v.BROKEN_CARET, P = /()??/.exec("")[1] !== void 0, I = C || P || T || g || S;
              I && (n = function(B) {
                var M = this, z = x(M), L = f(B), J = z.raw, ft, Q, xt, St, Pt, Gt, Rt;
                if (J)
                  return J.lastIndex = M.lastIndex, ft = s(n, J, L), M.lastIndex = J.lastIndex, ft;
                var bt = z.groups, Dt = T && M.sticky, X = s(h, M), gt = M.source, st = 0, rt = L;
                if (Dt && (X = A(X, "y", ""), E(X, "g") === -1 && (X += "g"), rt = O(L, M.lastIndex), M.lastIndex > 0 && (!M.multiline || M.multiline && w(L, M.lastIndex - 1) !== `
`) && (gt = "(?: " + gt + ")", rt = " " + rt, st++), Q = new RegExp("^(?:" + gt + ")", X)), P && (Q = new RegExp("^" + gt + "$(?!\\s)", X)), C && (xt = M.lastIndex), St = s(b, Dt ? Q : M, rt), Dt ? St ? (St.input = O(St.input, st), St[0] = O(St[0], st), St.index = M.lastIndex, M.lastIndex += St[0].length) : M.lastIndex = 0 : C && St && (M.lastIndex = M.global ? St.index + St[0].length : xt), P && St && St.length > 1 && s(y, St[0], Q, function() {
                  for (Pt = 1; Pt < arguments.length - 2; Pt++)
                    arguments[Pt] === void 0 && (St[Pt] = void 0);
                }), St && bt)
                  for (St.groups = Gt = m(null), Pt = 0; Pt < bt.length; Pt++)
                    Rt = bt[Pt], Gt[Rt[0]] = St[Rt[1]];
                return St;
              }), u.exports = n;
            }
          ),
          /***/
          21182: (
            /***/
            function(u, l, e) {
              var s = e(34984);
              u.exports = function() {
                var i = s(this), f = "";
                return i.global && (f += "g"), i.ignoreCase && (f += "i"), i.multiline && (f += "m"), i.dotAll && (f += "s"), i.unicode && (f += "u"), i.sticky && (f += "y"), f;
              };
            }
          ),
          /***/
          74846: (
            /***/
            function(u, l, e) {
              var s = e(47044), i = e(32010), f = i.RegExp;
              l.UNSUPPORTED_Y = s(function() {
                var h = f("a", "y");
                return h.lastIndex = 2, h.exec("abcd") != null;
              }), l.BROKEN_CARET = s(function() {
                var h = f("^r", "gy");
                return h.lastIndex = 2, h.exec("str") != null;
              });
            }
          ),
          /***/
          84030: (
            /***/
            function(u, l, e) {
              var s = e(47044), i = e(32010), f = i.RegExp;
              u.exports = s(function() {
                var h = f(".", "s");
                return !(h.dotAll && h.exec(`
`) && h.flags === "s");
              });
            }
          ),
          /***/
          97739: (
            /***/
            function(u, l, e) {
              var s = e(47044), i = e(32010), f = i.RegExp;
              u.exports = s(function() {
                var h = f("(?<a>b)", "g");
                return h.exec("b").groups.a !== "b" || "b".replace(h, "$<a>c") !== "bc";
              });
            }
          ),
          /***/
          83943: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = s.TypeError;
              u.exports = function(f) {
                if (f == null)
                  throw i("Can't call method on " + f);
                return f;
              };
            }
          ),
          /***/
          7421: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = Object.defineProperty;
              u.exports = function(f, h) {
                try {
                  i(s, f, { value: h, configurable: !0, writable: !0 });
                } catch {
                  s[f] = h;
                }
                return h;
              };
            }
          ),
          /***/
          51334: (
            /***/
            function(u, l, e) {
              var s = e(38486), i = e(95892), f = e(38688), h = e(15567), v = f("species");
              u.exports = function(p) {
                var m = s(p), x = i.f;
                h && m && !m[v] && x(m, v, {
                  configurable: !0,
                  get: function() {
                    return this;
                  }
                });
              };
            }
          ),
          /***/
          15216: (
            /***/
            function(u, l, e) {
              var s = e(95892).f, i = e(20340), f = e(38688), h = f("toStringTag");
              u.exports = function(v, p, m) {
                v && !i(v = m ? v : v.prototype, h) && s(v, h, { configurable: !0, value: p });
              };
            }
          ),
          /***/
          82194: (
            /***/
            function(u, l, e) {
              var s = e(464), i = e(46859), f = s("keys");
              u.exports = function(h) {
                return f[h] || (f[h] = i(h));
              };
            }
          ),
          /***/
          55480: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(7421), f = "__core-js_shared__", h = s[f] || i(f, {});
              u.exports = h;
            }
          ),
          /***/
          464: (
            /***/
            function(u, l, e) {
              var s = e(63432), i = e(55480);
              (u.exports = function(f, h) {
                return i[f] || (i[f] = h !== void 0 ? h : {});
              })("versions", []).push({
                version: "3.19.0",
                mode: s ? "pure" : "global",
                copyright: "© 2021 Denis Pushkarev (zloirock.ru)"
              });
            }
          ),
          /***/
          27754: (
            /***/
            function(u, l, e) {
              var s = e(34984), i = e(69075), f = e(38688), h = f("species");
              u.exports = function(v, p) {
                var m = s(v).constructor, x;
                return m === void 0 || (x = s(m)[h]) == null ? p : i(x);
              };
            }
          ),
          /***/
          7452: (
            /***/
            function(u, l, e) {
              var s = e(47044);
              u.exports = function(i) {
                return s(function() {
                  var f = ""[i]('"');
                  return f !== f.toLowerCase() || f.split('"').length > 3;
                });
              };
            }
          ),
          /***/
          69510: (
            /***/
            function(u, l, e) {
              var s = e(38347), i = e(26882), f = e(25096), h = e(83943), v = s("".charAt), p = s("".charCodeAt), m = s("".slice), x = function(g) {
                return function(S, y) {
                  var b = f(h(S)), n = i(y), w = b.length, E, A;
                  return n < 0 || n >= w ? g ? "" : void 0 : (E = p(b, n), E < 55296 || E > 56319 || n + 1 === w || (A = p(b, n + 1)) < 56320 || A > 57343 ? g ? v(b, n) : E : g ? m(b, n, n + 2) : (E - 55296 << 10) + (A - 56320) + 65536);
                };
              };
              u.exports = {
                // `String.prototype.codePointAt` method
                // https://tc39.es/ecma262/#sec-string.prototype.codepointat
                codeAt: x(!1),
                // `String.prototype.at` method
                // https://github.com/mathiasbynens/String.prototype.at
                charAt: x(!0)
              };
            }
          ),
          /***/
          34858: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(26882), f = e(25096), h = e(83943), v = s.RangeError;
              u.exports = function(m) {
                var x = f(h(this)), g = "", S = i(m);
                if (S < 0 || S == 1 / 0)
                  throw v("Wrong number of repetitions");
                for (; S > 0; (S >>>= 1) && (x += x))
                  S & 1 && (g += x);
                return g;
              };
            }
          ),
          /***/
          68899: (
            /***/
            function(u, l, e) {
              var s = e(7081).PROPER, i = e(47044), f = e(43187), h = "​᠎";
              u.exports = function(v) {
                return i(function() {
                  return !!f[v]() || h[v]() !== h || s && f[v].name !== v;
                });
              };
            }
          ),
          /***/
          29841: (
            /***/
            function(u, l, e) {
              var s = e(38347), i = e(83943), f = e(25096), h = e(43187), v = s("".replace), p = "[" + h + "]", m = RegExp("^" + p + p + "*"), x = RegExp(p + p + "*$"), g = function(S) {
                return function(y) {
                  var b = f(i(y));
                  return S & 1 && (b = v(b, m, "")), S & 2 && (b = v(b, x, "")), b;
                };
              };
              u.exports = {
                // `String.prototype.{ trimLeft, trimStart }` methods
                // https://tc39.es/ecma262/#sec-string.prototype.trimstart
                start: g(1),
                // `String.prototype.{ trimRight, trimEnd }` methods
                // https://tc39.es/ecma262/#sec-string.prototype.trimend
                end: g(2),
                // `String.prototype.trim` method
                // https://tc39.es/ecma262/#sec-string.prototype.trim
                trim: g(3)
              };
            }
          ),
          /***/
          6616: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(58448), f = e(25567), h = e(94578), v = e(20340), p = e(47044), m = e(520), x = e(73163), g = e(12072), S = e(17716), y = e(95053), b = s.setImmediate, n = s.clearImmediate, w = s.process, E = s.Dispatch, A = s.Function, O = s.MessageChannel, C = s.String, T = 0, P = {}, I = "onreadystatechange", F, B, M, z;
              try {
                F = s.location;
              } catch {
              }
              var L = function(xt) {
                if (v(P, xt)) {
                  var St = P[xt];
                  delete P[xt], St();
                }
              }, J = function(xt) {
                return function() {
                  L(xt);
                };
              }, ft = function(xt) {
                L(xt.data);
              }, Q = function(xt) {
                s.postMessage(C(xt), F.protocol + "//" + F.host);
              };
              (!b || !n) && (b = function(St) {
                var Pt = x(arguments, 1);
                return P[++T] = function() {
                  i(h(St) ? St : A(St), void 0, Pt);
                }, B(T), T;
              }, n = function(St) {
                delete P[St];
              }, y ? B = function(xt) {
                w.nextTick(J(xt));
              } : E && E.now ? B = function(xt) {
                E.now(J(xt));
              } : O && !S ? (M = new O(), z = M.port2, M.port1.onmessage = ft, B = f(z.postMessage, z)) : s.addEventListener && h(s.postMessage) && !s.importScripts && F && F.protocol !== "file:" && !p(Q) ? (B = Q, s.addEventListener("message", ft, !1)) : I in g("script") ? B = function(xt) {
                m.appendChild(g("script"))[I] = function() {
                  m.removeChild(this), L(xt);
                };
              } : B = function(xt) {
                setTimeout(J(xt), 0);
              }), u.exports = {
                set: b,
                clear: n
              };
            }
          ),
          /***/
          16679: (
            /***/
            function(u, l, e) {
              var s = e(38347);
              u.exports = s(1 .valueOf);
            }
          ),
          /***/
          74841: (
            /***/
            function(u, l, e) {
              var s = e(26882), i = Math.max, f = Math.min;
              u.exports = function(h, v) {
                var p = s(h);
                return p < 0 ? i(p + v, 0) : f(p, v);
              };
            }
          ),
          /***/
          71265: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(26882), f = e(23417), h = s.RangeError;
              u.exports = function(v) {
                if (v === void 0)
                  return 0;
                var p = i(v), m = f(p);
                if (p !== m)
                  throw h("Wrong length or index");
                return m;
              };
            }
          ),
          /***/
          98086: (
            /***/
            function(u, l, e) {
              var s = e(7514), i = e(83943);
              u.exports = function(f) {
                return s(i(f));
              };
            }
          ),
          /***/
          26882: (
            /***/
            function(u) {
              var l = Math.ceil, e = Math.floor;
              u.exports = function(s) {
                var i = +s;
                return i !== i || i === 0 ? 0 : (i > 0 ? e : l)(i);
              };
            }
          ),
          /***/
          23417: (
            /***/
            function(u, l, e) {
              var s = e(26882), i = Math.min;
              u.exports = function(f) {
                return f > 0 ? i(s(f), 9007199254740991) : 0;
              };
            }
          ),
          /***/
          43162: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(83943), f = s.Object;
              u.exports = function(h) {
                return f(i(h));
              };
            }
          ),
          /***/
          80670: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(64913), f = s.RangeError;
              u.exports = function(h, v) {
                var p = i(h);
                if (p % v)
                  throw f("Wrong offset");
                return p;
              };
            }
          ),
          /***/
          64913: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(26882), f = s.RangeError;
              u.exports = function(h) {
                var v = i(h);
                if (v < 0)
                  throw f("The argument can't be less than 0");
                return v;
              };
            }
          ),
          /***/
          2644: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(2834), f = e(24517), h = e(46290), v = e(51839), p = e(39629), m = e(38688), x = s.TypeError, g = m("toPrimitive");
              u.exports = function(S, y) {
                if (!f(S) || h(S))
                  return S;
                var b = v(S, g), n;
                if (b) {
                  if (y === void 0 && (y = "default"), n = i(b, S, y), !f(n) || h(n))
                    return n;
                  throw x("Can't convert object to primitive value");
                }
                return y === void 0 && (y = "number"), p(S, y);
              };
            }
          ),
          /***/
          63918: (
            /***/
            function(u, l, e) {
              var s = e(2644), i = e(46290);
              u.exports = function(f) {
                var h = s(f, "string");
                return i(h) ? h : h + "";
              };
            }
          ),
          /***/
          24663: (
            /***/
            function(u, l, e) {
              var s = e(38688), i = s("toStringTag"), f = {};
              f[i] = "z", u.exports = String(f) === "[object z]";
            }
          ),
          /***/
          25096: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(52564), f = s.String;
              u.exports = function(h) {
                if (i(h) === "Symbol")
                  throw TypeError("Cannot convert a Symbol value to a string");
                return f(h);
              };
            }
          ),
          /***/
          68664: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = s.String;
              u.exports = function(f) {
                try {
                  return i(f);
                } catch {
                  return "Object";
                }
              };
            }
          ),
          /***/
          98828: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(32010), f = e(2834), h = e(15567), v = e(28834), p = e(36597), m = e(89987), x = e(2868), g = e(97841), S = e(48914), y = e(17506), b = e(23417), n = e(71265), w = e(80670), E = e(63918), A = e(20340), O = e(52564), C = e(24517), T = e(46290), P = e(10819), I = e(70176), F = e(3840), B = e(6611).f, M = e(83590), z = e(91102).forEach, L = e(51334), J = e(95892), ft = e(72062), Q = e(70172), xt = e(51868), St = Q.get, Pt = Q.set, Gt = J.f, Rt = ft.f, bt = Math.round, Dt = i.RangeError, X = m.ArrayBuffer, gt = X.prototype, st = m.DataView, rt = p.NATIVE_ARRAY_BUFFER_VIEWS, wt = p.TYPED_ARRAY_CONSTRUCTOR, Ft = p.TYPED_ARRAY_TAG, zt = p.TypedArray, G = p.TypedArrayPrototype, D = p.aTypedArrayConstructor, Z = p.isTypedArray, et = "BYTES_PER_ELEMENT", vt = "Wrong length", lt = function(Bt, ge) {
                D(Bt);
                for (var Re = 0, Te = ge.length, xe = new Bt(Te); Te > Re; )
                  xe[Re] = ge[Re++];
                return xe;
              }, dt = function(Bt, ge) {
                Gt(Bt, ge, { get: function() {
                  return St(this)[ge];
                } });
              }, kt = function(Bt) {
                var ge;
                return I(gt, Bt) || (ge = O(Bt)) == "ArrayBuffer" || ge == "SharedArrayBuffer";
              }, jt = function(Bt, ge) {
                return Z(Bt) && !T(ge) && ge in Bt && y(+ge) && ge >= 0;
              }, me = function(ge, Re) {
                return Re = E(Re), jt(ge, Re) ? g(2, ge[Re]) : Rt(ge, Re);
              }, se = function(ge, Re, Te) {
                return Re = E(Re), jt(ge, Re) && C(Te) && A(Te, "value") && !A(Te, "get") && !A(Te, "set") && !Te.configurable && (!A(Te, "writable") || Te.writable) && (!A(Te, "enumerable") || Te.enumerable) ? (ge[Re] = Te.value, ge) : Gt(ge, Re, Te);
              };
              h ? (rt || (ft.f = me, J.f = se, dt(G, "buffer"), dt(G, "byteOffset"), dt(G, "byteLength"), dt(G, "length")), s({ target: "Object", stat: !0, forced: !rt }, {
                getOwnPropertyDescriptor: me,
                defineProperty: se
              }), u.exports = function(Bt, ge, Re) {
                var Te = Bt.match(/\d+$/)[0] / 8, xe = Bt + (Re ? "Clamped" : "") + "Array", Fe = "get" + Bt, Zt = "set" + Bt, qt = i[xe], ve = qt, Se = ve && ve.prototype, Pe = {}, Be = function(he, nt) {
                  var j = St(he);
                  return j.view[Fe](nt * Te + j.byteOffset, !0);
                }, De = function(he, nt, j) {
                  var V = St(he);
                  Re && (j = (j = bt(j)) < 0 ? 0 : j > 255 ? 255 : j & 255), V.view[Zt](nt * Te + V.byteOffset, j, !0);
                }, It = function(he, nt) {
                  Gt(he, nt, {
                    get: function() {
                      return Be(this, nt);
                    },
                    set: function(j) {
                      return De(this, nt, j);
                    },
                    enumerable: !0
                  });
                };
                rt ? v && (ve = ge(function(he, nt, j, V) {
                  return x(he, Se), xt(function() {
                    return C(nt) ? kt(nt) ? V !== void 0 ? new qt(nt, w(j, Te), V) : j !== void 0 ? new qt(nt, w(j, Te)) : new qt(nt) : Z(nt) ? lt(ve, nt) : f(M, ve, nt) : new qt(n(nt));
                  }(), he, ve);
                }), F && F(ve, zt), z(B(qt), function(he) {
                  he in ve || S(ve, he, qt[he]);
                }), ve.prototype = Se) : (ve = ge(function(he, nt, j, V) {
                  x(he, Se);
                  var yt = 0, it = 0, _t, ne, Y;
                  if (!C(nt))
                    Y = n(nt), ne = Y * Te, _t = new X(ne);
                  else if (kt(nt)) {
                    _t = nt, it = w(j, Te);
                    var Jt = nt.byteLength;
                    if (V === void 0) {
                      if (Jt % Te || (ne = Jt - it, ne < 0))
                        throw Dt(vt);
                    } else if (ne = b(V) * Te, ne + it > Jt)
                      throw Dt(vt);
                    Y = ne / Te;
                  } else
                    return Z(nt) ? lt(ve, nt) : f(M, ve, nt);
                  for (Pt(he, {
                    buffer: _t,
                    byteOffset: it,
                    byteLength: ne,
                    length: Y,
                    view: new st(_t)
                  }); yt < Y; )
                    It(he, yt++);
                }), F && F(ve, zt), Se = ve.prototype = P(G)), Se.constructor !== ve && S(Se, "constructor", ve), S(Se, wt, ve), Ft && S(Se, Ft, xe), Pe[xe] = ve, s({
                  global: !0,
                  forced: ve != qt,
                  sham: !rt
                }, Pe), et in ve || S(ve, et, Te), et in Se || S(Se, et, Te), L(xe);
              }) : u.exports = function() {
              };
            }
          ),
          /***/
          28834: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(47044), f = e(46769), h = e(36597).NATIVE_ARRAY_BUFFER_VIEWS, v = s.ArrayBuffer, p = s.Int8Array;
              u.exports = !h || !i(function() {
                p(1);
              }) || !i(function() {
                new p(-1);
              }) || !f(function(m) {
                new p(), new p(null), new p(1.5), new p(m);
              }, !0) || i(function() {
                return new p(new v(2), 1, void 0).length !== 1;
              });
            }
          ),
          /***/
          59610: (
            /***/
            function(u, l, e) {
              var s = e(34269), i = e(34815);
              u.exports = function(f, h) {
                return s(i(f), h);
              };
            }
          ),
          /***/
          83590: (
            /***/
            function(u, l, e) {
              var s = e(25567), i = e(2834), f = e(69075), h = e(43162), v = e(45495), p = e(15892), m = e(13872), x = e(89564), g = e(36597).aTypedArrayConstructor;
              u.exports = function(y) {
                var b = f(this), n = h(y), w = arguments.length, E = w > 1 ? arguments[1] : void 0, A = E !== void 0, O = m(n), C, T, P, I, F, B;
                if (O && !x(O))
                  for (F = p(n, O), B = F.next, n = []; !(I = i(B, F)).done; )
                    n.push(I.value);
                for (A && w > 2 && (E = s(E, arguments[2])), T = v(n), P = new (g(b))(T), C = 0; T > C; C++)
                  P[C] = A ? E(n[C], C) : n[C];
                return P;
              };
            }
          ),
          /***/
          34815: (
            /***/
            function(u, l, e) {
              var s = e(36597), i = e(27754), f = s.TYPED_ARRAY_CONSTRUCTOR, h = s.aTypedArrayConstructor;
              u.exports = function(v) {
                return h(i(v, v[f]));
              };
            }
          ),
          /***/
          46859: (
            /***/
            function(u, l, e) {
              var s = e(38347), i = 0, f = Math.random(), h = s(1 .toString);
              u.exports = function(v) {
                return "Symbol(" + (v === void 0 ? "" : v) + ")_" + h(++i + f, 36);
              };
            }
          ),
          /***/
          9567: (
            /***/
            function(u, l, e) {
              var s = e(46887);
              u.exports = s && !Symbol.sham && typeof Symbol.iterator == "symbol";
            }
          ),
          /***/
          75960: (
            /***/
            function(u, l, e) {
              var s = e(38688);
              l.f = s;
            }
          ),
          /***/
          38688: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(464), f = e(20340), h = e(46859), v = e(46887), p = e(9567), m = i("wks"), x = s.Symbol, g = x && x.for, S = p ? x : x && x.withoutSetter || h;
              u.exports = function(y) {
                if (!f(m, y) || !(v || typeof m[y] == "string")) {
                  var b = "Symbol." + y;
                  v && f(x, y) ? m[y] = x[y] : p && g ? m[y] = g(b) : m[y] = S(b);
                }
                return m[y];
              };
            }
          ),
          /***/
          43187: (
            /***/
            function(u) {
              u.exports = `	
\v\f\r                　\u2028\u2029\uFEFF`;
            }
          ),
          /***/
          94910: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(32010), f = e(70176), h = e(69548), v = e(3840), p = e(2675), m = e(10819), x = e(48914), g = e(97841), S = e(34074), y = e(87811), b = e(80383), n = e(86392), w = e(45144), E = i.Error, A = [].push, O = function(P, I) {
                var F = f(C, this) ? this : m(C), B = arguments.length > 2 ? arguments[2] : void 0;
                v && (F = v(new E(void 0), h(F))), x(F, "message", n(I, "")), w && x(F, "stack", S(F.stack, 1)), y(F, B);
                var M = [];
                return b(P, A, { that: M }), x(F, "errors", M), F;
              };
              v ? v(O, E) : p(O, E);
              var C = O.prototype = m(E.prototype, {
                constructor: g(1, O),
                message: g(1, ""),
                name: g(1, "AggregateError")
              });
              s({ global: !0 }, {
                AggregateError: O
              });
            }
          ),
          /***/
          39081: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(32010), f = e(47044), h = e(59113), v = e(24517), p = e(43162), m = e(45495), x = e(38639), g = e(45744), S = e(56280), y = e(38688), b = e(70091), n = y("isConcatSpreadable"), w = 9007199254740991, E = "Maximum allowed index exceeded", A = i.TypeError, O = b >= 51 || !f(function() {
                var I = [];
                return I[n] = !1, I.concat()[0] !== I;
              }), C = S("concat"), T = function(I) {
                if (!v(I))
                  return !1;
                var F = I[n];
                return F !== void 0 ? !!F : h(I);
              }, P = !O || !C;
              s({ target: "Array", proto: !0, forced: P }, {
                // eslint-disable-next-line no-unused-vars -- required for `.length`
                concat: function(F) {
                  var B = p(this), M = g(B, 0), z = 0, L, J, ft, Q, xt;
                  for (L = -1, ft = arguments.length; L < ft; L++)
                    if (xt = L === -1 ? B : arguments[L], T(xt)) {
                      if (Q = m(xt), z + Q > w)
                        throw A(E);
                      for (J = 0; J < Q; J++, z++)
                        J in xt && x(M, z, xt[J]);
                    } else {
                      if (z >= w)
                        throw A(E);
                      x(M, z++, xt);
                    }
                  return M.length = z, M;
                }
              });
            }
          ),
          /***/
          68626: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(92642), f = e(71156);
              s({ target: "Array", proto: !0 }, {
                copyWithin: i
              }), f("copyWithin");
            }
          ),
          /***/
          41584: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(72864), f = e(71156);
              s({ target: "Array", proto: !0 }, {
                fill: i
              }), f("fill");
            }
          ),
          /***/
          49063: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(91102).filter, f = e(56280), h = f("filter");
              s({ target: "Array", proto: !0, forced: !h }, {
                filter: function(p) {
                  return i(this, p, arguments.length > 1 ? arguments[1] : void 0);
                }
              });
            }
          ),
          /***/
          11765: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(95717), f = e(46769), h = !f(function(v) {
                Array.from(v);
              });
              s({ target: "Array", stat: !0, forced: h }, {
                from: i
              });
            }
          ),
          /***/
          58028: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(12636).includes, f = e(71156);
              s({ target: "Array", proto: !0 }, {
                includes: function(v) {
                  return i(this, v, arguments.length > 1 ? arguments[1] : void 0);
                }
              }), f("includes");
            }
          ),
          /***/
          81755: (
            /***/
            function(u, l, e) {
              var s = e(98086), i = e(71156), f = e(15366), h = e(70172), v = e(97001), p = "Array Iterator", m = h.set, x = h.getterFor(p);
              u.exports = v(Array, "Array", function(g, S) {
                m(this, {
                  type: p,
                  target: s(g),
                  // target
                  index: 0,
                  // next index
                  kind: S
                  // kind
                });
              }, function() {
                var g = x(this), S = g.target, y = g.kind, b = g.index++;
                return !S || b >= S.length ? (g.target = void 0, { value: void 0, done: !0 }) : y == "keys" ? { value: b, done: !1 } : y == "values" ? { value: S[b], done: !1 } : { value: [b, S[b]], done: !1 };
              }, "values"), f.Arguments = f.Array, i("keys"), i("values"), i("entries");
            }
          ),
          /***/
          94845: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(38347), f = e(7514), h = e(98086), v = e(81007), p = i([].join), m = f != Object, x = v("join", ",");
              s({ target: "Array", proto: !0, forced: m || !x }, {
                join: function(S) {
                  return p(h(this), S === void 0 ? "," : S);
                }
              });
            }
          ),
          /***/
          80055: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(91102).map, f = e(56280), h = f("map");
              s({ target: "Array", proto: !0, forced: !h }, {
                map: function(p) {
                  return i(this, p, arguments.length > 1 ? arguments[1] : void 0);
                }
              });
            }
          ),
          /***/
          20731: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(32010), f = e(59113), h = e(20884), v = e(24517), p = e(74841), m = e(45495), x = e(98086), g = e(38639), S = e(38688), y = e(56280), b = e(73163), n = y("slice"), w = S("species"), E = i.Array, A = Math.max;
              s({ target: "Array", proto: !0, forced: !n }, {
                slice: function(C, T) {
                  var P = x(this), I = m(P), F = p(C, I), B = p(T === void 0 ? I : T, I), M, z, L;
                  if (f(P) && (M = P.constructor, h(M) && (M === E || f(M.prototype)) ? M = void 0 : v(M) && (M = M[w], M === null && (M = void 0)), M === E || M === void 0))
                    return b(P, F, B);
                  for (z = new (M === void 0 ? E : M)(A(B - F, 0)), L = 0; F < B; F++, L++)
                    F in P && g(z, L, P[F]);
                  return z.length = L, z;
                }
              });
            }
          ),
          /***/
          45337: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(38347), f = e(32631), h = e(43162), v = e(45495), p = e(25096), m = e(47044), x = e(43977), g = e(81007), S = e(3809), y = e(21983), b = e(70091), n = e(41731), w = [], E = i(w.sort), A = i(w.push), O = m(function() {
                w.sort(void 0);
              }), C = m(function() {
                w.sort(null);
              }), T = g("sort"), P = !m(function() {
                if (b)
                  return b < 70;
                if (!(S && S > 3)) {
                  if (y)
                    return !0;
                  if (n)
                    return n < 603;
                  var B = "", M, z, L, J;
                  for (M = 65; M < 76; M++) {
                    switch (z = String.fromCharCode(M), M) {
                      case 66:
                      case 69:
                      case 70:
                      case 72:
                        L = 3;
                        break;
                      case 68:
                      case 71:
                        L = 4;
                        break;
                      default:
                        L = 2;
                    }
                    for (J = 0; J < 47; J++)
                      w.push({ k: z + J, v: L });
                  }
                  for (w.sort(function(ft, Q) {
                    return Q.v - ft.v;
                  }), J = 0; J < w.length; J++)
                    z = w[J].k.charAt(0), B.charAt(B.length - 1) !== z && (B += z);
                  return B !== "DGBEFHACIJK";
                }
              }), I = O || !C || !T || !P, F = function(B) {
                return function(M, z) {
                  return z === void 0 ? -1 : M === void 0 ? 1 : B !== void 0 ? +B(M, z) || 0 : p(M) > p(z) ? 1 : -1;
                };
              };
              s({ target: "Array", proto: !0, forced: I }, {
                sort: function(M) {
                  M !== void 0 && f(M);
                  var z = h(this);
                  if (P)
                    return M === void 0 ? E(z) : E(z, M);
                  var L = [], J = v(z), ft, Q;
                  for (Q = 0; Q < J; Q++)
                    Q in z && A(L, z[Q]);
                  for (x(L, F(M)), ft = L.length, Q = 0; Q < ft; )
                    z[Q] = L[Q++];
                  for (; Q < J; )
                    delete z[Q++];
                  return z;
                }
              });
            }
          ),
          /***/
          23913: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(32010), f = e(74841), h = e(26882), v = e(45495), p = e(43162), m = e(45744), x = e(38639), g = e(56280), S = g("splice"), y = i.TypeError, b = Math.max, n = Math.min, w = 9007199254740991, E = "Maximum allowed length exceeded";
              s({ target: "Array", proto: !0, forced: !S }, {
                splice: function(O, C) {
                  var T = p(this), P = v(T), I = f(O, P), F = arguments.length, B, M, z, L, J, ft;
                  if (F === 0 ? B = M = 0 : F === 1 ? (B = 0, M = P - I) : (B = F - 2, M = n(b(h(C), 0), P - I)), P + B - M > w)
                    throw y(E);
                  for (z = m(T, M), L = 0; L < M; L++)
                    J = I + L, J in T && x(z, L, T[J]);
                  if (z.length = M, B < M) {
                    for (L = I; L < P - M; L++)
                      J = L + M, ft = L + B, J in T ? T[ft] = T[J] : delete T[ft];
                    for (L = P; L > P - M + B; L--)
                      delete T[L - 1];
                  } else if (B > M)
                    for (L = P - M; L > I; L--)
                      J = L + M - 1, ft = L + B - 1, J in T ? T[ft] = T[J] : delete T[ft];
                  for (L = 0; L < B; L++)
                    T[L + I] = arguments[L + 2];
                  return T.length = P - M + B, z;
                }
              });
            }
          ),
          /***/
          7585: (
            /***/
            function(u, l, e) {
              var s = e(20340), i = e(13711), f = e(53087), h = e(38688), v = h("toPrimitive"), p = Date.prototype;
              s(p, v) || i(p, v, f);
            }
          ),
          /***/
          24863: (
            /***/
            function(u, l, e) {
              var s = e(15567), i = e(7081).EXISTS, f = e(38347), h = e(95892).f, v = Function.prototype, p = f(v.toString), m = /^\s*function ([^ (]*)/, x = f(m.exec), g = "name";
              s && !i && h(v, g, {
                configurable: !0,
                get: function() {
                  try {
                    return x(m, p(this))[1];
                  } catch {
                    return "";
                  }
                }
              });
            }
          ),
          /***/
          64384: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(32010);
              s({ global: !0 }, {
                globalThis: i
              });
            }
          ),
          /***/
          43448: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(15216);
              i(s.JSON, "JSON", !0);
            }
          ),
          /***/
          18828: (
            /***/
            function(u, l, e) {
              var s = e(36673), i = e(9649);
              s("Map", function(f) {
                return function() {
                  return f(this, arguments.length ? arguments[0] : void 0);
                };
              }, i);
            }
          ),
          /***/
          63956: (
            /***/
            function(u, l, e) {
              var s = e(15216);
              s(Math, "Math", !0);
            }
          ),
          /***/
          7283: (
            /***/
            function(u, l, e) {
              var s = e(15567), i = e(32010), f = e(38347), h = e(39599), v = e(13711), p = e(20340), m = e(51868), x = e(70176), g = e(46290), S = e(2644), y = e(47044), b = e(6611).f, n = e(72062).f, w = e(95892).f, E = e(16679), A = e(29841).trim, O = "Number", C = i[O], T = C.prototype, P = i.TypeError, I = f("".slice), F = f("".charCodeAt), B = function(Q) {
                var xt = S(Q, "number");
                return typeof xt == "bigint" ? xt : M(xt);
              }, M = function(Q) {
                var xt = S(Q, "number"), St, Pt, Gt, Rt, bt, Dt, X, gt;
                if (g(xt))
                  throw P("Cannot convert a Symbol value to a number");
                if (typeof xt == "string" && xt.length > 2) {
                  if (xt = A(xt), St = F(xt, 0), St === 43 || St === 45) {
                    if (Pt = F(xt, 2), Pt === 88 || Pt === 120)
                      return NaN;
                  } else if (St === 48) {
                    switch (F(xt, 1)) {
                      case 66:
                      case 98:
                        Gt = 2, Rt = 49;
                        break;
                      case 79:
                      case 111:
                        Gt = 8, Rt = 55;
                        break;
                      default:
                        return +xt;
                    }
                    for (bt = I(xt, 2), Dt = bt.length, X = 0; X < Dt; X++)
                      if (gt = F(bt, X), gt < 48 || gt > Rt)
                        return NaN;
                    return parseInt(bt, Gt);
                  }
                }
                return +xt;
              };
              if (h(O, !C(" 0o1") || !C("0b1") || C("+0x1"))) {
                for (var z = function(xt) {
                  var St = arguments.length < 1 ? 0 : C(B(xt)), Pt = this;
                  return x(T, Pt) && y(function() {
                    E(Pt);
                  }) ? m(Object(St), Pt, z) : St;
                }, L = s ? b(C) : (
                  // ES3:
                  "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,fromString,range".split(",")
                ), J = 0, ft; L.length > J; J++)
                  p(C, ft = L[J]) && !p(z, ft) && w(z, ft, n(C, ft));
                z.prototype = T, T.constructor = z, v(i, O, z);
              }
            }
          ),
          /***/
          58549: (
            /***/
            function(u, l, e) {
              var s = e(56475);
              s({ target: "Number", stat: !0 }, {
                EPSILON: Math.pow(2, -52)
              });
            }
          ),
          /***/
          70095: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(59805);
              s({ target: "Number", stat: !0 }, { isFinite: i });
            }
          ),
          /***/
          2876: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(17506);
              s({ target: "Number", stat: !0 }, {
                isInteger: i
              });
            }
          ),
          /***/
          10849: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(32010), f = e(38347), h = e(26882), v = e(16679), p = e(34858), m = e(47044), x = i.RangeError, g = i.String, S = Math.floor, y = f(p), b = f("".slice), n = f(1 .toFixed), w = function(P, I, F) {
                return I === 0 ? F : I % 2 === 1 ? w(P, I - 1, F * P) : w(P * P, I / 2, F);
              }, E = function(P) {
                for (var I = 0, F = P; F >= 4096; )
                  I += 12, F /= 4096;
                for (; F >= 2; )
                  I += 1, F /= 2;
                return I;
              }, A = function(P, I, F) {
                for (var B = -1, M = F; ++B < 6; )
                  M += I * P[B], P[B] = M % 1e7, M = S(M / 1e7);
              }, O = function(P, I) {
                for (var F = 6, B = 0; --F >= 0; )
                  B += P[F], P[F] = S(B / I), B = B % I * 1e7;
              }, C = function(P) {
                for (var I = 6, F = ""; --I >= 0; )
                  if (F !== "" || I === 0 || P[I] !== 0) {
                    var B = g(P[I]);
                    F = F === "" ? B : F + y("0", 7 - B.length) + B;
                  }
                return F;
              }, T = m(function() {
                return n(8e-5, 3) !== "0.000" || n(0.9, 0) !== "1" || n(1.255, 2) !== "1.25" || n(1000000000000000100, 0) !== "1000000000000000128";
              }) || !m(function() {
                n({});
              });
              s({ target: "Number", proto: !0, forced: T }, {
                toFixed: function(I) {
                  var F = v(this), B = h(I), M = [0, 0, 0, 0, 0, 0], z = "", L = "0", J, ft, Q, xt;
                  if (B < 0 || B > 20)
                    throw x("Incorrect fraction digits");
                  if (F != F)
                    return "NaN";
                  if (F <= -1e21 || F >= 1e21)
                    return g(F);
                  if (F < 0 && (z = "-", F = -F), F > 1e-21)
                    if (J = E(F * w(2, 69, 1)) - 69, ft = J < 0 ? F * w(2, -J, 1) : F / w(2, J, 1), ft *= 4503599627370496, J = 52 - J, J > 0) {
                      for (A(M, 0, ft), Q = B; Q >= 7; )
                        A(M, 1e7, 0), Q -= 7;
                      for (A(M, w(10, Q, 1), 0), Q = J - 1; Q >= 23; )
                        O(M, 8388608), Q -= 23;
                      O(M, 1 << Q), A(M, 1, 1), O(M, 2), L = C(M);
                    } else
                      A(M, 0, ft), A(M, 1 << -J, 0), L = C(M) + y("0", B);
                  return B > 0 ? (xt = L.length, L = z + (xt <= B ? "0." + y("0", B - xt) + L : b(L, 0, xt - B) + "." + b(L, xt - B))) : L = z + L, L;
                }
              });
            }
          ),
          /***/
          18756: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(87146);
              s({ target: "Object", stat: !0, forced: Object.assign !== i }, {
                assign: i
              });
            }
          ),
          /***/
          75174: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(55481), f = e(47044), h = e(24517), v = e(62148).onFreeze, p = Object.freeze, m = f(function() {
                p(1);
              });
              s({ target: "Object", stat: !0, forced: m, sham: !i }, {
                freeze: function(g) {
                  return p && h(g) ? p(v(g)) : g;
                }
              });
            }
          ),
          /***/
          57444: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(47044), f = e(98086), h = e(72062).f, v = e(15567), p = i(function() {
                h(1);
              }), m = !v || p;
              s({ target: "Object", stat: !0, forced: m, sham: !v }, {
                getOwnPropertyDescriptor: function(g, S) {
                  return h(f(g), S);
                }
              });
            }
          ),
          /***/
          28331: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(15567), f = e(21594), h = e(98086), v = e(72062), p = e(38639);
              s({ target: "Object", stat: !0, sham: !i }, {
                getOwnPropertyDescriptors: function(x) {
                  for (var g = h(x), S = v.f, y = f(g), b = {}, n = 0, w, E; y.length > n; )
                    E = S(g, w = y[n++]), E !== void 0 && p(b, w, E);
                  return b;
                }
              });
            }
          ),
          /***/
          71950: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(47044), f = e(43162), h = e(69548), v = e(68494), p = i(function() {
                h(1);
              });
              s({ target: "Object", stat: !0, forced: p, sham: !v }, {
                getPrototypeOf: function(x) {
                  return h(f(x));
                }
              });
            }
          ),
          /***/
          37309: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(43162), f = e(84675), h = e(47044), v = h(function() {
                f(1);
              });
              s({ target: "Object", stat: !0, forced: v }, {
                keys: function(m) {
                  return f(i(m));
                }
              });
            }
          ),
          /***/
          14032: (
            /***/
            function(u, l, e) {
              var s = e(24663), i = e(13711), f = e(52598);
              s || i(Object.prototype, "toString", f, { unsafe: !0 });
            }
          ),
          /***/
          59883: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(80754).values;
              s({ target: "Object", stat: !0 }, {
                values: function(h) {
                  return i(h);
                }
              });
            }
          ),
          /***/
          77074: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(2834), f = e(32631), h = e(56614), v = e(61900), p = e(80383);
              s({ target: "Promise", stat: !0 }, {
                allSettled: function(x) {
                  var g = this, S = h.f(g), y = S.resolve, b = S.reject, n = v(function() {
                    var w = f(g.resolve), E = [], A = 0, O = 1;
                    p(x, function(C) {
                      var T = A++, P = !1;
                      O++, i(w, g, C).then(function(I) {
                        P || (P = !0, E[T] = { status: "fulfilled", value: I }, --O || y(E));
                      }, function(I) {
                        P || (P = !0, E[T] = { status: "rejected", reason: I }, --O || y(E));
                      });
                    }), --O || y(E);
                  });
                  return n.error && b(n.value), S.promise;
                }
              });
            }
          ),
          /***/
          44455: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(32631), f = e(38486), h = e(2834), v = e(56614), p = e(61900), m = e(80383), x = "No one promise resolved";
              s({ target: "Promise", stat: !0 }, {
                any: function(S) {
                  var y = this, b = f("AggregateError"), n = v.f(y), w = n.resolve, E = n.reject, A = p(function() {
                    var O = i(y.resolve), C = [], T = 0, P = 1, I = !1;
                    m(S, function(F) {
                      var B = T++, M = !1;
                      P++, h(O, y, F).then(function(z) {
                        M || I || (I = !0, w(z));
                      }, function(z) {
                        M || I || (M = !0, C[B] = z, --P || E(new b(C, x)));
                      });
                    }), --P || E(new b(C, x));
                  });
                  return A.error && E(A.value), n.promise;
                }
              });
            }
          ),
          /***/
          58605: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(63432), f = e(5155), h = e(47044), v = e(38486), p = e(94578), m = e(27754), x = e(28617), g = e(13711), S = !!f && h(function() {
                f.prototype.finally.call({ then: function() {
                } }, function() {
                });
              });
              if (s({ target: "Promise", proto: !0, real: !0, forced: S }, {
                finally: function(b) {
                  var n = m(this, v("Promise")), w = p(b);
                  return this.then(
                    w ? function(E) {
                      return x(n, b()).then(function() {
                        return E;
                      });
                    } : b,
                    w ? function(E) {
                      return x(n, b()).then(function() {
                        throw E;
                      });
                    } : b
                  );
                }
              }), !i && p(f)) {
                var y = v("Promise").prototype.finally;
                f.prototype.finally !== y && g(f.prototype, "finally", y, { unsafe: !0 });
              }
            }
          ),
          /***/
          68067: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(63432), f = e(32010), h = e(38486), v = e(2834), p = e(5155), m = e(13711), x = e(15341), g = e(3840), S = e(15216), y = e(51334), b = e(32631), n = e(94578), w = e(24517), E = e(2868), A = e(10447), O = e(80383), C = e(46769), T = e(27754), P = e(6616).set, I = e(59804), F = e(28617), B = e(61144), M = e(56614), z = e(61900), L = e(70172), J = e(39599), ft = e(38688), Q = e(3157), xt = e(95053), St = e(70091), Pt = ft("species"), Gt = "Promise", Rt = L.get, bt = L.set, Dt = L.getterFor(Gt), X = p && p.prototype, gt = p, st = X, rt = f.TypeError, wt = f.document, Ft = f.process, zt = M.f, G = zt, D = !!(wt && wt.createEvent && f.dispatchEvent), Z = n(f.PromiseRejectionEvent), et = "unhandledrejection", vt = "rejectionhandled", lt = 0, dt = 1, kt = 2, jt = 1, me = 2, se = !1, Bt, ge, Re, Te, xe = J(Gt, function() {
                var nt = A(gt), j = nt !== String(gt);
                if (!j && St === 66 || i && !st.finally)
                  return !0;
                if (St >= 51 && /native code/.test(nt))
                  return !1;
                var V = new gt(function(_t) {
                  _t(1);
                }), yt = function(_t) {
                  _t(function() {
                  }, function() {
                  });
                }, it = V.constructor = {};
                return it[Pt] = yt, se = V.then(function() {
                }) instanceof yt, se ? !j && Q && !Z : !0;
              }), Fe = xe || !C(function(nt) {
                gt.all(nt).catch(function() {
                });
              }), Zt = function(nt) {
                var j;
                return w(nt) && n(j = nt.then) ? j : !1;
              }, qt = function(nt, j) {
                if (!nt.notified) {
                  nt.notified = !0;
                  var V = nt.reactions;
                  I(function() {
                    for (var yt = nt.value, it = nt.state == dt, _t = 0; V.length > _t; ) {
                      var ne = V[_t++], Y = it ? ne.ok : ne.fail, Jt = ne.resolve, ie = ne.reject, Tt = ne.domain, Xt, ue, Ve;
                      try {
                        Y ? (it || (nt.rejection === me && Be(nt), nt.rejection = jt), Y === !0 ? Xt = yt : (Tt && Tt.enter(), Xt = Y(yt), Tt && (Tt.exit(), Ve = !0)), Xt === ne.promise ? ie(rt("Promise-chain cycle")) : (ue = Zt(Xt)) ? v(ue, Xt, Jt, ie) : Jt(Xt)) : ie(yt);
                      } catch (ke) {
                        Tt && !Ve && Tt.exit(), ie(ke);
                      }
                    }
                    nt.reactions = [], nt.notified = !1, j && !nt.rejection && Se(nt);
                  });
                }
              }, ve = function(nt, j, V) {
                var yt, it;
                D ? (yt = wt.createEvent("Event"), yt.promise = j, yt.reason = V, yt.initEvent(nt, !1, !0), f.dispatchEvent(yt)) : yt = { promise: j, reason: V }, !Z && (it = f["on" + nt]) ? it(yt) : nt === et && B("Unhandled promise rejection", V);
              }, Se = function(nt) {
                v(P, f, function() {
                  var j = nt.facade, V = nt.value, yt = Pe(nt), it;
                  if (yt && (it = z(function() {
                    xt ? Ft.emit("unhandledRejection", V, j) : ve(et, j, V);
                  }), nt.rejection = xt || Pe(nt) ? me : jt, it.error))
                    throw it.value;
                });
              }, Pe = function(nt) {
                return nt.rejection !== jt && !nt.parent;
              }, Be = function(nt) {
                v(P, f, function() {
                  var j = nt.facade;
                  xt ? Ft.emit("rejectionHandled", j) : ve(vt, j, nt.value);
                });
              }, De = function(nt, j, V) {
                return function(yt) {
                  nt(j, yt, V);
                };
              }, It = function(nt, j, V) {
                nt.done || (nt.done = !0, V && (nt = V), nt.value = j, nt.state = kt, qt(nt, !0));
              }, he = function(nt, j, V) {
                if (!nt.done) {
                  nt.done = !0, V && (nt = V);
                  try {
                    if (nt.facade === j)
                      throw rt("Promise can't be resolved itself");
                    var yt = Zt(j);
                    yt ? I(function() {
                      var it = { done: !1 };
                      try {
                        v(
                          yt,
                          j,
                          De(he, it, nt),
                          De(It, it, nt)
                        );
                      } catch (_t) {
                        It(it, _t, nt);
                      }
                    }) : (nt.value = j, nt.state = dt, qt(nt, !1));
                  } catch (it) {
                    It({ done: !1 }, it, nt);
                  }
                }
              };
              if (xe && (gt = function(j) {
                E(this, st), b(j), v(Bt, this);
                var V = Rt(this);
                try {
                  j(De(he, V), De(It, V));
                } catch (yt) {
                  It(V, yt);
                }
              }, st = gt.prototype, Bt = function(j) {
                bt(this, {
                  type: Gt,
                  done: !1,
                  notified: !1,
                  parent: !1,
                  reactions: [],
                  rejection: !1,
                  state: lt,
                  value: void 0
                });
              }, Bt.prototype = x(st, {
                // `Promise.prototype.then` method
                // https://tc39.es/ecma262/#sec-promise.prototype.then
                then: function(j, V) {
                  var yt = Dt(this), it = yt.reactions, _t = zt(T(this, gt));
                  return _t.ok = n(j) ? j : !0, _t.fail = n(V) && V, _t.domain = xt ? Ft.domain : void 0, yt.parent = !0, it[it.length] = _t, yt.state != lt && qt(yt, !1), _t.promise;
                },
                // `Promise.prototype.catch` method
                // https://tc39.es/ecma262/#sec-promise.prototype.catch
                catch: function(nt) {
                  return this.then(void 0, nt);
                }
              }), ge = function() {
                var nt = new Bt(), j = Rt(nt);
                this.promise = nt, this.resolve = De(he, j), this.reject = De(It, j);
              }, M.f = zt = function(nt) {
                return nt === gt || nt === Re ? new ge(nt) : G(nt);
              }, !i && n(p) && X !== Object.prototype)) {
                Te = X.then, se || (m(X, "then", function(j, V) {
                  var yt = this;
                  return new gt(function(it, _t) {
                    v(Te, yt, it, _t);
                  }).then(j, V);
                }, { unsafe: !0 }), m(X, "catch", st.catch, { unsafe: !0 }));
                try {
                  delete X.constructor;
                } catch {
                }
                g && g(X, st);
              }
              s({ global: !0, wrap: !0, forced: xe }, {
                Promise: gt
              }), S(gt, Gt, !1, !0), y(Gt), Re = h(Gt), s({ target: Gt, stat: !0, forced: xe }, {
                // `Promise.reject` method
                // https://tc39.es/ecma262/#sec-promise.reject
                reject: function(j) {
                  var V = zt(this);
                  return v(V.reject, void 0, j), V.promise;
                }
              }), s({ target: Gt, stat: !0, forced: i || xe }, {
                // `Promise.resolve` method
                // https://tc39.es/ecma262/#sec-promise.resolve
                resolve: function(j) {
                  return F(i && this === Re ? gt : this, j);
                }
              }), s({ target: Gt, stat: !0, forced: Fe }, {
                // `Promise.all` method
                // https://tc39.es/ecma262/#sec-promise.all
                all: function(j) {
                  var V = this, yt = zt(V), it = yt.resolve, _t = yt.reject, ne = z(function() {
                    var Y = b(V.resolve), Jt = [], ie = 0, Tt = 1;
                    O(j, function(Xt) {
                      var ue = ie++, Ve = !1;
                      Tt++, v(Y, V, Xt).then(function(ke) {
                        Ve || (Ve = !0, Jt[ue] = ke, --Tt || it(Jt));
                      }, _t);
                    }), --Tt || it(Jt);
                  });
                  return ne.error && _t(ne.value), yt.promise;
                },
                // `Promise.race` method
                // https://tc39.es/ecma262/#sec-promise.race
                race: function(j) {
                  var V = this, yt = zt(V), it = yt.reject, _t = z(function() {
                    var ne = b(V.resolve);
                    O(j, function(Y) {
                      v(ne, V, Y).then(yt.resolve, it);
                    });
                  });
                  return _t.error && it(_t.value), yt.promise;
                }
              });
            }
          ),
          /***/
          73228: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(38486), f = e(58448), h = e(5481), v = e(69075), p = e(34984), m = e(24517), x = e(10819), g = e(47044), S = i("Reflect", "construct"), y = Object.prototype, b = [].push, n = g(function() {
                function A() {
                }
                return !(S(function() {
                }, [], A) instanceof A);
              }), w = !g(function() {
                S(function() {
                });
              }), E = n || w;
              s({ target: "Reflect", stat: !0, forced: E, sham: E }, {
                construct: function(O, C) {
                  v(O), p(C);
                  var T = arguments.length < 3 ? O : v(arguments[2]);
                  if (w && !n)
                    return S(O, C, T);
                  if (O == T) {
                    switch (C.length) {
                      case 0:
                        return new O();
                      case 1:
                        return new O(C[0]);
                      case 2:
                        return new O(C[0], C[1]);
                      case 3:
                        return new O(C[0], C[1], C[2]);
                      case 4:
                        return new O(C[0], C[1], C[2], C[3]);
                    }
                    var P = [null];
                    return f(b, P, C), new (f(h, O, P))();
                  }
                  var I = T.prototype, F = x(m(I) ? I : y), B = f(O, F, C);
                  return m(B) ? B : F;
                }
              });
            }
          ),
          /***/
          61726: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(49820);
              s({ target: "RegExp", proto: !0, forced: /./.exec !== i }, {
                exec: i
              });
            }
          ),
          /***/
          74516: (
            /***/
            function(u, l, e) {
              var s = e(15567), i = e(95892), f = e(21182), h = e(47044), v = RegExp.prototype, p = s && h(function() {
                return Object.getOwnPropertyDescriptor(v, "flags").get.call({ dotAll: !0, sticky: !0 }) !== "sy";
              });
              p && i.f(v, "flags", {
                configurable: !0,
                get: f
              });
            }
          ),
          /***/
          57114: (
            /***/
            function(u, l, e) {
              var s = e(38347), i = e(7081).PROPER, f = e(13711), h = e(34984), v = e(70176), p = e(25096), m = e(47044), x = e(21182), g = "toString", S = RegExp.prototype, y = S[g], b = s(x), n = m(function() {
                return y.call({ source: "a", flags: "b" }) != "/a/b";
              }), w = i && y.name != g;
              (n || w) && f(RegExp.prototype, g, function() {
                var A = h(this), O = p(A.source), C = A.flags, T = p(C === void 0 && v(S, A) && !("flags" in S) ? b(A) : C);
                return "/" + O + "/" + T;
              }, { unsafe: !0 });
            }
          ),
          /***/
          76014: (
            /***/
            function(u, l, e) {
              var s = e(36673), i = e(9649);
              s("Set", function(f) {
                return function() {
                  return f(this, arguments.length ? arguments[0] : void 0);
                };
              }, i);
            }
          ),
          /***/
          26663: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(69510).codeAt;
              s({ target: "String", proto: !0 }, {
                codePointAt: function(h) {
                  return i(this, h);
                }
              });
            }
          ),
          /***/
          65578: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(32010), f = e(38347), h = e(74841), v = i.RangeError, p = String.fromCharCode, m = String.fromCodePoint, x = f([].join), g = !!m && m.length != 1;
              s({ target: "String", stat: !0, forced: g }, {
                // eslint-disable-next-line no-unused-vars -- required for `.length`
                fromCodePoint: function(y) {
                  for (var b = [], n = arguments.length, w = 0, E; n > w; ) {
                    if (E = +arguments[w++], h(E, 1114111) !== E)
                      throw v(E + " is not a valid code point");
                    b[w] = E < 65536 ? p(E) : p(((E -= 65536) >> 10) + 55296, E % 1024 + 56320);
                  }
                  return x(b, "");
                }
              });
            }
          ),
          /***/
          47458: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(38347), f = e(93666), h = e(83943), v = e(25096), p = e(91151), m = i("".indexOf);
              s({ target: "String", proto: !0, forced: !p("includes") }, {
                includes: function(g) {
                  return !!~m(
                    v(h(this)),
                    v(f(g)),
                    arguments.length > 1 ? arguments[1] : void 0
                  );
                }
              });
            }
          ),
          /***/
          62046: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(91159), f = e(7452);
              s({ target: "String", proto: !0, forced: f("italics") }, {
                italics: function() {
                  return i(this, "i", "", "");
                }
              });
            }
          ),
          /***/
          58281: (
            /***/
            function(u, l, e) {
              var s = e(69510).charAt, i = e(25096), f = e(70172), h = e(97001), v = "String Iterator", p = f.set, m = f.getterFor(v);
              h(String, "String", function(x) {
                p(this, {
                  type: v,
                  string: i(x),
                  index: 0
                });
              }, function() {
                var g = m(this), S = g.string, y = g.index, b;
                return y >= S.length ? { value: void 0, done: !0 } : (b = s(S, y), g.index += b.length, { value: b, done: !1 });
              });
            }
          ),
          /***/
          47259: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(91159), f = e(7452);
              s({ target: "String", proto: !0, forced: f("link") }, {
                link: function(v) {
                  return i(this, "a", "href", v);
                }
              });
            }
          ),
          /***/
          71768: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(32010), f = e(2834), h = e(38347), v = e(13945), p = e(83943), m = e(23417), x = e(25096), g = e(34984), S = e(93975), y = e(70176), b = e(28831), n = e(21182), w = e(51839), E = e(13711), A = e(47044), O = e(38688), C = e(27754), T = e(36352), P = e(66723), I = e(70172), F = e(63432), B = O("matchAll"), M = "RegExp String", z = M + " Iterator", L = I.set, J = I.getterFor(z), ft = RegExp.prototype, Q = i.TypeError, xt = h(n), St = h("".indexOf), Pt = h("".matchAll), Gt = !!Pt && !A(function() {
                Pt("a", /./);
              }), Rt = v(function(X, gt, st, rt) {
                L(this, {
                  type: z,
                  regexp: X,
                  string: gt,
                  global: st,
                  unicode: rt,
                  done: !1
                });
              }, M, function() {
                var X = J(this);
                if (X.done)
                  return { value: void 0, done: !0 };
                var gt = X.regexp, st = X.string, rt = P(gt, st);
                return rt === null ? { value: void 0, done: X.done = !0 } : X.global ? (x(rt[0]) === "" && (gt.lastIndex = T(st, m(gt.lastIndex), X.unicode)), { value: rt, done: !1 }) : (X.done = !0, { value: rt, done: !1 });
              }), bt = function(Dt) {
                var X = g(this), gt = x(Dt), st, rt, wt, Ft, zt, G;
                return st = C(X, RegExp), rt = X.flags, rt === void 0 && y(ft, X) && !("flags" in ft) && (rt = xt(X)), wt = rt === void 0 ? "" : x(rt), Ft = new st(st === RegExp ? X.source : X, wt), zt = !!~St(wt, "g"), G = !!~St(wt, "u"), Ft.lastIndex = m(X.lastIndex), new Rt(Ft, gt, zt, G);
              };
              s({ target: "String", proto: !0, forced: Gt }, {
                matchAll: function(X) {
                  var gt = p(this), st, rt, wt, Ft;
                  if (X != null) {
                    if (b(X) && (st = x(p(
                      "flags" in ft ? X.flags : xt(X)
                    )), !~St(st, "g")))
                      throw Q("`.matchAll` does not allow non-global regexes");
                    if (Gt)
                      return Pt(gt, X);
                    if (wt = w(X, B), wt === void 0 && F && S(X) == "RegExp" && (wt = bt), wt)
                      return f(wt, X, gt);
                  } else if (Gt)
                    return Pt(gt, X);
                  return rt = x(gt), Ft = new RegExp(X, "g"), F ? f(bt, Ft, rt) : Ft[B](rt);
                }
              }), F || B in ft || E(ft, B, bt);
            }
          ),
          /***/
          6422: (
            /***/
            function(u, l, e) {
              var s = e(2834), i = e(11813), f = e(34984), h = e(23417), v = e(25096), p = e(83943), m = e(51839), x = e(36352), g = e(66723);
              i("match", function(S, y, b) {
                return [
                  // `String.prototype.match` method
                  // https://tc39.es/ecma262/#sec-string.prototype.match
                  function(w) {
                    var E = p(this), A = w == null ? void 0 : m(w, S);
                    return A ? s(A, w, E) : new RegExp(w)[S](v(E));
                  },
                  // `RegExp.prototype[@@match]` method
                  // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
                  function(n) {
                    var w = f(this), E = v(n), A = b(y, w, E);
                    if (A.done)
                      return A.value;
                    if (!w.global)
                      return g(w, E);
                    var O = w.unicode;
                    w.lastIndex = 0;
                    for (var C = [], T = 0, P; (P = g(w, E)) !== null; ) {
                      var I = v(P[0]);
                      C[T] = I, I === "" && (w.lastIndex = x(E, h(w.lastIndex), O)), T++;
                    }
                    return T === 0 ? null : C;
                  }
                ];
              });
            }
          ),
          /***/
          28264: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(34858);
              s({ target: "String", proto: !0 }, {
                repeat: i
              });
            }
          ),
          /***/
          46467: (
            /***/
            function(u, l, e) {
              var s = e(58448), i = e(2834), f = e(38347), h = e(11813), v = e(47044), p = e(34984), m = e(94578), x = e(26882), g = e(23417), S = e(25096), y = e(83943), b = e(36352), n = e(51839), w = e(29519), E = e(66723), A = e(38688), O = A("replace"), C = Math.max, T = Math.min, P = f([].concat), I = f([].push), F = f("".indexOf), B = f("".slice), M = function(ft) {
                return ft === void 0 ? ft : String(ft);
              }, z = function() {
                return "a".replace(/./, "$0") === "$0";
              }(), L = function() {
                return /./[O] ? /./[O]("a", "$0") === "" : !1;
              }(), J = !v(function() {
                var ft = /./;
                return ft.exec = function() {
                  var Q = [];
                  return Q.groups = { a: "7" }, Q;
                }, "".replace(ft, "$<a>") !== "7";
              });
              h("replace", function(ft, Q, xt) {
                var St = L ? "$" : "$0";
                return [
                  // `String.prototype.replace` method
                  // https://tc39.es/ecma262/#sec-string.prototype.replace
                  function(Gt, Rt) {
                    var bt = y(this), Dt = Gt == null ? void 0 : n(Gt, O);
                    return Dt ? i(Dt, Gt, bt, Rt) : i(Q, S(bt), Gt, Rt);
                  },
                  // `RegExp.prototype[@@replace]` method
                  // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
                  function(Pt, Gt) {
                    var Rt = p(this), bt = S(Pt);
                    if (typeof Gt == "string" && F(Gt, St) === -1 && F(Gt, "$<") === -1) {
                      var Dt = xt(Q, Rt, bt, Gt);
                      if (Dt.done)
                        return Dt.value;
                    }
                    var X = m(Gt);
                    X || (Gt = S(Gt));
                    var gt = Rt.global;
                    if (gt) {
                      var st = Rt.unicode;
                      Rt.lastIndex = 0;
                    }
                    for (var rt = []; ; ) {
                      var wt = E(Rt, bt);
                      if (wt === null || (I(rt, wt), !gt))
                        break;
                      var Ft = S(wt[0]);
                      Ft === "" && (Rt.lastIndex = b(bt, g(Rt.lastIndex), st));
                    }
                    for (var zt = "", G = 0, D = 0; D < rt.length; D++) {
                      wt = rt[D];
                      for (var Z = S(wt[0]), et = C(T(x(wt.index), bt.length), 0), vt = [], lt = 1; lt < wt.length; lt++)
                        I(vt, M(wt[lt]));
                      var dt = wt.groups;
                      if (X) {
                        var kt = P([Z], vt, et, bt);
                        dt !== void 0 && I(kt, dt);
                        var jt = S(s(Gt, void 0, kt));
                      } else
                        jt = w(Z, bt, et, vt, dt, Gt);
                      et >= G && (zt += B(bt, G, et) + jt, G = et + Z.length);
                    }
                    return zt + B(bt, G);
                  }
                ];
              }, !J || !z || L);
            }
          ),
          /***/
          7851: (
            /***/
            function(u, l, e) {
              var s = e(58448), i = e(2834), f = e(38347), h = e(11813), v = e(28831), p = e(34984), m = e(83943), x = e(27754), g = e(36352), S = e(23417), y = e(25096), b = e(51839), n = e(73163), w = e(66723), E = e(49820), A = e(74846), O = e(47044), C = A.UNSUPPORTED_Y, T = 4294967295, P = Math.min, I = [].push, F = f(/./.exec), B = f(I), M = f("".slice), z = !O(function() {
                var L = /(?:)/, J = L.exec;
                L.exec = function() {
                  return J.apply(this, arguments);
                };
                var ft = "ab".split(L);
                return ft.length !== 2 || ft[0] !== "a" || ft[1] !== "b";
              });
              h("split", function(L, J, ft) {
                var Q;
                return "abbc".split(/(b)*/)[1] == "c" || // eslint-disable-next-line regexp/no-empty-group -- required for testing
                "test".split(/(?:)/, -1).length != 4 || "ab".split(/(?:ab)*/).length != 2 || ".".split(/(.?)(.?)/).length != 4 || // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
                ".".split(/()()/).length > 1 || "".split(/.?/).length ? Q = function(xt, St) {
                  var Pt = y(m(this)), Gt = St === void 0 ? T : St >>> 0;
                  if (Gt === 0)
                    return [];
                  if (xt === void 0)
                    return [Pt];
                  if (!v(xt))
                    return i(J, Pt, xt, Gt);
                  for (var Rt = [], bt = (xt.ignoreCase ? "i" : "") + (xt.multiline ? "m" : "") + (xt.unicode ? "u" : "") + (xt.sticky ? "y" : ""), Dt = 0, X = new RegExp(xt.source, bt + "g"), gt, st, rt; (gt = i(E, X, Pt)) && (st = X.lastIndex, !(st > Dt && (B(Rt, M(Pt, Dt, gt.index)), gt.length > 1 && gt.index < Pt.length && s(I, Rt, n(gt, 1)), rt = gt[0].length, Dt = st, Rt.length >= Gt))); )
                    X.lastIndex === gt.index && X.lastIndex++;
                  return Dt === Pt.length ? (rt || !F(X, "")) && B(Rt, "") : B(Rt, M(Pt, Dt)), Rt.length > Gt ? n(Rt, 0, Gt) : Rt;
                } : "0".split(void 0, 0).length ? Q = function(xt, St) {
                  return xt === void 0 && St === 0 ? [] : i(J, this, xt, St);
                } : Q = J, [
                  // `String.prototype.split` method
                  // https://tc39.es/ecma262/#sec-string.prototype.split
                  function(St, Pt) {
                    var Gt = m(this), Rt = St == null ? void 0 : b(St, L);
                    return Rt ? i(Rt, St, Gt, Pt) : i(Q, y(Gt), St, Pt);
                  },
                  // `RegExp.prototype[@@split]` method
                  // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
                  //
                  // NOTE: This cannot be properly polyfilled in engines that don't support
                  // the 'y' flag.
                  function(xt, St) {
                    var Pt = p(this), Gt = y(xt), Rt = ft(Q, Pt, Gt, St, Q !== J);
                    if (Rt.done)
                      return Rt.value;
                    var bt = x(Pt, RegExp), Dt = Pt.unicode, X = (Pt.ignoreCase ? "i" : "") + (Pt.multiline ? "m" : "") + (Pt.unicode ? "u" : "") + (C ? "g" : "y"), gt = new bt(C ? "^(?:" + Pt.source + ")" : Pt, X), st = St === void 0 ? T : St >>> 0;
                    if (st === 0)
                      return [];
                    if (Gt.length === 0)
                      return w(gt, Gt) === null ? [Gt] : [];
                    for (var rt = 0, wt = 0, Ft = []; wt < Gt.length; ) {
                      gt.lastIndex = C ? 0 : wt;
                      var zt = w(gt, C ? M(Gt, wt) : Gt), G;
                      if (zt === null || (G = P(S(gt.lastIndex + (C ? wt : 0)), Gt.length)) === rt)
                        wt = g(Gt, wt, Dt);
                      else {
                        if (B(Ft, M(Gt, rt, wt)), Ft.length === st)
                          return Ft;
                        for (var D = 1; D <= zt.length - 1; D++)
                          if (B(Ft, zt[D]), Ft.length === st)
                            return Ft;
                        wt = rt = G;
                      }
                    }
                    return B(Ft, M(Gt, rt)), Ft;
                  }
                ];
              }, !z, C);
            }
          ),
          /***/
          18425: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(91159), f = e(7452);
              s({ target: "String", proto: !0, forced: f("strike") }, {
                strike: function() {
                  return i(this, "strike", "", "");
                }
              });
            }
          ),
          /***/
          72095: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(29841).trim, f = e(68899);
              s({ target: "String", proto: !0, forced: f("trim") }, {
                trim: function() {
                  return i(this);
                }
              });
            }
          ),
          /***/
          35877: (
            /***/
            function(u, l, e) {
              var s = e(46042);
              s("asyncIterator");
            }
          ),
          /***/
          73844: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(15567), f = e(32010), h = e(38347), v = e(20340), p = e(94578), m = e(70176), x = e(25096), g = e(95892).f, S = e(2675), y = f.Symbol, b = y && y.prototype;
              if (i && p(y) && (!("description" in b) || // Safari 12 bug
              y().description !== void 0)) {
                var n = {}, w = function() {
                  var F = arguments.length < 1 || arguments[0] === void 0 ? void 0 : x(arguments[0]), B = m(b, this) ? new y(F) : F === void 0 ? y() : y(F);
                  return F === "" && (n[B] = !0), B;
                };
                S(w, y), w.prototype = b, b.constructor = w;
                var E = String(y("test")) == "Symbol(test)", A = h(b.toString), O = h(b.valueOf), C = /^Symbol\((.*)\)[^)]+$/, T = h("".replace), P = h("".slice);
                g(b, "description", {
                  configurable: !0,
                  get: function() {
                    var F = O(this), B = A(F);
                    if (v(n, F))
                      return "";
                    var M = E ? P(B, 7, -1) : T(B, C, "$1");
                    return M === "" ? void 0 : M;
                  }
                }), s({ global: !0, forced: !0 }, {
                  Symbol: w
                });
              }
            }
          ),
          /***/
          69330: (
            /***/
            function(u, l, e) {
              var s = e(46042);
              s("iterator");
            }
          ),
          /***/
          65292: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(32010), f = e(38486), h = e(58448), v = e(2834), p = e(38347), m = e(63432), x = e(15567), g = e(46887), S = e(47044), y = e(20340), b = e(59113), n = e(94578), w = e(24517), E = e(70176), A = e(46290), O = e(34984), C = e(43162), T = e(98086), P = e(63918), I = e(25096), F = e(97841), B = e(10819), M = e(84675), z = e(6611), L = e(8807), J = e(61146), ft = e(72062), Q = e(95892), xt = e(55574), St = e(73163), Pt = e(13711), Gt = e(464), Rt = e(82194), bt = e(90682), Dt = e(46859), X = e(38688), gt = e(75960), st = e(46042), rt = e(15216), wt = e(70172), Ft = e(91102).forEach, zt = Rt("hidden"), G = "Symbol", D = "prototype", Z = X("toPrimitive"), et = wt.set, vt = wt.getterFor(G), lt = Object[D], dt = i.Symbol, kt = dt && dt[D], jt = i.TypeError, me = i.QObject, se = f("JSON", "stringify"), Bt = ft.f, ge = Q.f, Re = L.f, Te = xt.f, xe = p([].push), Fe = Gt("symbols"), Zt = Gt("op-symbols"), qt = Gt("string-to-symbol-registry"), ve = Gt("symbol-to-string-registry"), Se = Gt("wks"), Pe = !me || !me[D] || !me[D].findChild, Be = x && S(function() {
                return B(ge({}, "a", {
                  get: function() {
                    return ge(this, "a", { value: 7 }).a;
                  }
                })).a != 7;
              }) ? function(Y, Jt, ie) {
                var Tt = Bt(lt, Jt);
                Tt && delete lt[Jt], ge(Y, Jt, ie), Tt && Y !== lt && ge(lt, Jt, Tt);
              } : ge, De = function(Y, Jt) {
                var ie = Fe[Y] = B(kt);
                return et(ie, {
                  type: G,
                  tag: Y,
                  description: Jt
                }), x || (ie.description = Jt), ie;
              }, It = function(Jt, ie, Tt) {
                Jt === lt && It(Zt, ie, Tt), O(Jt);
                var Xt = P(ie);
                return O(Tt), y(Fe, Xt) ? (Tt.enumerable ? (y(Jt, zt) && Jt[zt][Xt] && (Jt[zt][Xt] = !1), Tt = B(Tt, { enumerable: F(0, !1) })) : (y(Jt, zt) || ge(Jt, zt, F(1, {})), Jt[zt][Xt] = !0), Be(Jt, Xt, Tt)) : ge(Jt, Xt, Tt);
              }, he = function(Jt, ie) {
                O(Jt);
                var Tt = T(ie), Xt = M(Tt).concat(it(Tt));
                return Ft(Xt, function(ue) {
                  (!x || v(j, Tt, ue)) && It(Jt, ue, Tt[ue]);
                }), Jt;
              }, nt = function(Jt, ie) {
                return ie === void 0 ? B(Jt) : he(B(Jt), ie);
              }, j = function(Jt) {
                var ie = P(Jt), Tt = v(Te, this, ie);
                return this === lt && y(Fe, ie) && !y(Zt, ie) ? !1 : Tt || !y(this, ie) || !y(Fe, ie) || y(this, zt) && this[zt][ie] ? Tt : !0;
              }, V = function(Jt, ie) {
                var Tt = T(Jt), Xt = P(ie);
                if (!(Tt === lt && y(Fe, Xt) && !y(Zt, Xt))) {
                  var ue = Bt(Tt, Xt);
                  return ue && y(Fe, Xt) && !(y(Tt, zt) && Tt[zt][Xt]) && (ue.enumerable = !0), ue;
                }
              }, yt = function(Jt) {
                var ie = Re(T(Jt)), Tt = [];
                return Ft(ie, function(Xt) {
                  !y(Fe, Xt) && !y(bt, Xt) && xe(Tt, Xt);
                }), Tt;
              }, it = function(Jt) {
                var ie = Jt === lt, Tt = Re(ie ? Zt : T(Jt)), Xt = [];
                return Ft(Tt, function(ue) {
                  y(Fe, ue) && (!ie || y(lt, ue)) && xe(Xt, Fe[ue]);
                }), Xt;
              };
              if (g || (dt = function() {
                if (E(kt, this))
                  throw jt("Symbol is not a constructor");
                var Jt = !arguments.length || arguments[0] === void 0 ? void 0 : I(arguments[0]), ie = Dt(Jt), Tt = function(Xt) {
                  this === lt && v(Tt, Zt, Xt), y(this, zt) && y(this[zt], ie) && (this[zt][ie] = !1), Be(this, ie, F(1, Xt));
                };
                return x && Pe && Be(lt, ie, { configurable: !0, set: Tt }), De(ie, Jt);
              }, kt = dt[D], Pt(kt, "toString", function() {
                return vt(this).tag;
              }), Pt(dt, "withoutSetter", function(Y) {
                return De(Dt(Y), Y);
              }), xt.f = j, Q.f = It, ft.f = V, z.f = L.f = yt, J.f = it, gt.f = function(Y) {
                return De(X(Y), Y);
              }, x && (ge(kt, "description", {
                configurable: !0,
                get: function() {
                  return vt(this).description;
                }
              }), m || Pt(lt, "propertyIsEnumerable", j, { unsafe: !0 }))), s({ global: !0, wrap: !0, forced: !g, sham: !g }, {
                Symbol: dt
              }), Ft(M(Se), function(Y) {
                st(Y);
              }), s({ target: G, stat: !0, forced: !g }, {
                // `Symbol.for` method
                // https://tc39.es/ecma262/#sec-symbol.for
                for: function(Y) {
                  var Jt = I(Y);
                  if (y(qt, Jt))
                    return qt[Jt];
                  var ie = dt(Jt);
                  return qt[Jt] = ie, ve[ie] = Jt, ie;
                },
                // `Symbol.keyFor` method
                // https://tc39.es/ecma262/#sec-symbol.keyfor
                keyFor: function(Jt) {
                  if (!A(Jt))
                    throw jt(Jt + " is not a symbol");
                  if (y(ve, Jt))
                    return ve[Jt];
                },
                useSetter: function() {
                  Pe = !0;
                },
                useSimple: function() {
                  Pe = !1;
                }
              }), s({ target: "Object", stat: !0, forced: !g, sham: !x }, {
                // `Object.create` method
                // https://tc39.es/ecma262/#sec-object.create
                create: nt,
                // `Object.defineProperty` method
                // https://tc39.es/ecma262/#sec-object.defineproperty
                defineProperty: It,
                // `Object.defineProperties` method
                // https://tc39.es/ecma262/#sec-object.defineproperties
                defineProperties: he,
                // `Object.getOwnPropertyDescriptor` method
                // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
                getOwnPropertyDescriptor: V
              }), s({ target: "Object", stat: !0, forced: !g }, {
                // `Object.getOwnPropertyNames` method
                // https://tc39.es/ecma262/#sec-object.getownpropertynames
                getOwnPropertyNames: yt,
                // `Object.getOwnPropertySymbols` method
                // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
                getOwnPropertySymbols: it
              }), s({ target: "Object", stat: !0, forced: S(function() {
                J.f(1);
              }) }, {
                getOwnPropertySymbols: function(Jt) {
                  return J.f(C(Jt));
                }
              }), se) {
                var _t = !g || S(function() {
                  var Y = dt();
                  return se([Y]) != "[null]" || se({ a: Y }) != "{}" || se(Object(Y)) != "{}";
                });
                s({ target: "JSON", stat: !0, forced: _t }, {
                  // eslint-disable-next-line no-unused-vars -- required for `.length`
                  stringify: function(Jt, ie, Tt) {
                    var Xt = St(arguments), ue = ie;
                    if (!(!w(ie) && Jt === void 0 || A(Jt)))
                      return b(ie) || (ie = function(Ve, ke) {
                        if (n(ue) && (ke = v(ue, this, Ve, ke)), !A(ke))
                          return ke;
                      }), Xt[1] = ie, h(se, null, Xt);
                  }
                });
              }
              if (!kt[Z]) {
                var ne = kt.valueOf;
                Pt(kt, Z, function(Y) {
                  return v(ne, this);
                });
              }
              rt(dt, G), bt[zt] = !0;
            }
          ),
          /***/
          5597: (
            /***/
            function(u, l, e) {
              var s = e(46042);
              s("toPrimitive");
            }
          ),
          /***/
          38178: (
            /***/
            function(u, l, e) {
              var s = e(46042);
              s("toStringTag");
            }
          ),
          /***/
          73663: (
            /***/
            function(u, l, e) {
              var s = e(38347), i = e(36597), f = e(92642), h = s(f), v = i.aTypedArray, p = i.exportTypedArrayMethod;
              p("copyWithin", function(x, g) {
                return h(v(this), x, g, arguments.length > 2 ? arguments[2] : void 0);
              });
            }
          ),
          /***/
          29883: (
            /***/
            function(u, l, e) {
              var s = e(36597), i = e(91102).every, f = s.aTypedArray, h = s.exportTypedArrayMethod;
              h("every", function(p) {
                return i(f(this), p, arguments.length > 1 ? arguments[1] : void 0);
              });
            }
          ),
          /***/
          35471: (
            /***/
            function(u, l, e) {
              var s = e(36597), i = e(2834), f = e(72864), h = s.aTypedArray, v = s.exportTypedArrayMethod;
              v("fill", function(m) {
                var x = arguments.length;
                return i(
                  f,
                  h(this),
                  m,
                  x > 1 ? arguments[1] : void 0,
                  x > 2 ? arguments[2] : void 0
                );
              });
            }
          ),
          /***/
          21012: (
            /***/
            function(u, l, e) {
              var s = e(36597), i = e(91102).filter, f = e(59610), h = s.aTypedArray, v = s.exportTypedArrayMethod;
              v("filter", function(m) {
                var x = i(h(this), m, arguments.length > 1 ? arguments[1] : void 0);
                return f(this, x);
              });
            }
          ),
          /***/
          97464: (
            /***/
            function(u, l, e) {
              var s = e(36597), i = e(91102).findIndex, f = s.aTypedArray, h = s.exportTypedArrayMethod;
              h("findIndex", function(p) {
                return i(f(this), p, arguments.length > 1 ? arguments[1] : void 0);
              });
            }
          ),
          /***/
          88997: (
            /***/
            function(u, l, e) {
              var s = e(36597), i = e(91102).find, f = s.aTypedArray, h = s.exportTypedArrayMethod;
              h("find", function(p) {
                return i(f(this), p, arguments.length > 1 ? arguments[1] : void 0);
              });
            }
          ),
          /***/
          3131: (
            /***/
            function(u, l, e) {
              var s = e(98828);
              s("Float32", function(i) {
                return function(h, v, p) {
                  return i(this, h, v, p);
                };
              });
            }
          ),
          /***/
          90868: (
            /***/
            function(u, l, e) {
              var s = e(98828);
              s("Float64", function(i) {
                return function(h, v, p) {
                  return i(this, h, v, p);
                };
              });
            }
          ),
          /***/
          2857: (
            /***/
            function(u, l, e) {
              var s = e(36597), i = e(91102).forEach, f = s.aTypedArray, h = s.exportTypedArrayMethod;
              h("forEach", function(p) {
                i(f(this), p, arguments.length > 1 ? arguments[1] : void 0);
              });
            }
          ),
          /***/
          83326: (
            /***/
            function(u, l, e) {
              var s = e(28834), i = e(36597).exportTypedArrayStaticMethod, f = e(83590);
              i("from", f, s);
            }
          ),
          /***/
          94715: (
            /***/
            function(u, l, e) {
              var s = e(36597), i = e(12636).includes, f = s.aTypedArray, h = s.exportTypedArrayMethod;
              h("includes", function(p) {
                return i(f(this), p, arguments.length > 1 ? arguments[1] : void 0);
              });
            }
          ),
          /***/
          13624: (
            /***/
            function(u, l, e) {
              var s = e(36597), i = e(12636).indexOf, f = s.aTypedArray, h = s.exportTypedArrayMethod;
              h("indexOf", function(p) {
                return i(f(this), p, arguments.length > 1 ? arguments[1] : void 0);
              });
            }
          ),
          /***/
          75626: (
            /***/
            function(u, l, e) {
              var s = e(98828);
              s("Int16", function(i) {
                return function(h, v, p) {
                  return i(this, h, v, p);
                };
              });
            }
          ),
          /***/
          95756: (
            /***/
            function(u, l, e) {
              var s = e(98828);
              s("Int32", function(i) {
                return function(h, v, p) {
                  return i(this, h, v, p);
                };
              });
            }
          ),
          /***/
          65553: (
            /***/
            function(u, l, e) {
              var s = e(98828);
              s("Int8", function(i) {
                return function(h, v, p) {
                  return i(this, h, v, p);
                };
              });
            }
          ),
          /***/
          91132: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(38347), f = e(7081).PROPER, h = e(36597), v = e(81755), p = e(38688), m = p("iterator"), x = s.Uint8Array, g = i(v.values), S = i(v.keys), y = i(v.entries), b = h.aTypedArray, n = h.exportTypedArrayMethod, w = x && x.prototype[m], E = !!w && w.name === "values", A = function() {
                return g(b(this));
              };
              n("entries", function() {
                return y(b(this));
              }), n("keys", function() {
                return S(b(this));
              }), n("values", A, f && !E), n(m, A, f && !E);
            }
          ),
          /***/
          62514: (
            /***/
            function(u, l, e) {
              var s = e(36597), i = e(38347), f = s.aTypedArray, h = s.exportTypedArrayMethod, v = i([].join);
              h("join", function(m) {
                return v(f(this), m);
              });
            }
          ),
          /***/
          24597: (
            /***/
            function(u, l, e) {
              var s = e(36597), i = e(58448), f = e(84320), h = s.aTypedArray, v = s.exportTypedArrayMethod;
              v("lastIndexOf", function(m) {
                var x = arguments.length;
                return i(f, h(this), x > 1 ? [m, arguments[1]] : [m]);
              });
            }
          ),
          /***/
          88042: (
            /***/
            function(u, l, e) {
              var s = e(36597), i = e(91102).map, f = e(34815), h = s.aTypedArray, v = s.exportTypedArrayMethod;
              v("map", function(m) {
                return i(h(this), m, arguments.length > 1 ? arguments[1] : void 0, function(x, g) {
                  return new (f(x))(g);
                });
              });
            }
          ),
          /***/
          92451: (
            /***/
            function(u, l, e) {
              var s = e(36597), i = e(32843).right, f = s.aTypedArray, h = s.exportTypedArrayMethod;
              h("reduceRight", function(p) {
                var m = arguments.length;
                return i(f(this), p, m, m > 1 ? arguments[1] : void 0);
              });
            }
          ),
          /***/
          4660: (
            /***/
            function(u, l, e) {
              var s = e(36597), i = e(32843).left, f = s.aTypedArray, h = s.exportTypedArrayMethod;
              h("reduce", function(p) {
                var m = arguments.length;
                return i(f(this), p, m, m > 1 ? arguments[1] : void 0);
              });
            }
          ),
          /***/
          44206: (
            /***/
            function(u, l, e) {
              var s = e(36597), i = s.aTypedArray, f = s.exportTypedArrayMethod, h = Math.floor;
              f("reverse", function() {
                for (var p = this, m = i(p).length, x = h(m / 2), g = 0, S; g < x; )
                  S = p[g], p[g++] = p[--m], p[m] = S;
                return p;
              });
            }
          ),
          /***/
          66288: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(36597), f = e(45495), h = e(80670), v = e(43162), p = e(47044), m = s.RangeError, x = i.aTypedArray, g = i.exportTypedArrayMethod, S = p(function() {
                new Int8Array(1).set({});
              });
              g("set", function(b) {
                x(this);
                var n = h(arguments.length > 1 ? arguments[1] : void 0, 1), w = this.length, E = v(b), A = f(E), O = 0;
                if (A + n > w)
                  throw m("Wrong length");
                for (; O < A; )
                  this[n + O] = E[O++];
              }, S);
            }
          ),
          /***/
          13250: (
            /***/
            function(u, l, e) {
              var s = e(36597), i = e(34815), f = e(47044), h = e(73163), v = s.aTypedArray, p = s.exportTypedArrayMethod, m = f(function() {
                new Int8Array(1).slice();
              });
              p("slice", function(g, S) {
                for (var y = h(v(this), g, S), b = i(this), n = 0, w = y.length, E = new b(w); w > n; )
                  E[n] = y[n++];
                return E;
              }, m);
            }
          ),
          /***/
          3858: (
            /***/
            function(u, l, e) {
              var s = e(36597), i = e(91102).some, f = s.aTypedArray, h = s.exportTypedArrayMethod;
              h("some", function(p) {
                return i(f(this), p, arguments.length > 1 ? arguments[1] : void 0);
              });
            }
          ),
          /***/
          84538: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(38347), f = e(47044), h = e(32631), v = e(43977), p = e(36597), m = e(3809), x = e(21983), g = e(70091), S = e(41731), y = s.Array, b = p.aTypedArray, n = p.exportTypedArrayMethod, w = s.Uint16Array, E = w && i(w.prototype.sort), A = !!E && !(f(function() {
                E(new w(2), null);
              }) && f(function() {
                E(new w(2), {});
              })), O = !!E && !f(function() {
                if (g)
                  return g < 74;
                if (m)
                  return m < 67;
                if (x)
                  return !0;
                if (S)
                  return S < 602;
                var T = new w(516), P = y(516), I, F;
                for (I = 0; I < 516; I++)
                  F = I % 4, T[I] = 515 - I, P[I] = I - 2 * F + 3;
                for (E(T, function(B, M) {
                  return (B / 4 | 0) - (M / 4 | 0);
                }), I = 0; I < 516; I++)
                  if (T[I] !== P[I])
                    return !0;
              }), C = function(T) {
                return function(P, I) {
                  return T !== void 0 ? +T(P, I) || 0 : I !== I ? -1 : P !== P ? 1 : P === 0 && I === 0 ? 1 / P > 0 && 1 / I < 0 ? 1 : -1 : P > I;
                };
              };
              n("sort", function(P) {
                return P !== void 0 && h(P), O ? E(this, P) : v(b(this), C(P));
              }, !O || A);
            }
          ),
          /***/
          64793: (
            /***/
            function(u, l, e) {
              var s = e(36597), i = e(23417), f = e(74841), h = e(34815), v = s.aTypedArray, p = s.exportTypedArrayMethod;
              p("subarray", function(x, g) {
                var S = v(this), y = S.length, b = f(x, y), n = h(S);
                return new n(
                  S.buffer,
                  S.byteOffset + b * S.BYTES_PER_ELEMENT,
                  i((g === void 0 ? y : f(g, y)) - b)
                );
              });
            }
          ),
          /***/
          74202: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(58448), f = e(36597), h = e(47044), v = e(73163), p = s.Int8Array, m = f.aTypedArray, x = f.exportTypedArrayMethod, g = [].toLocaleString, S = !!p && h(function() {
                g.call(new p(1));
              }), y = h(function() {
                return [1, 2].toLocaleString() != new p([1, 2]).toLocaleString();
              }) || !h(function() {
                p.prototype.toLocaleString.call([1, 2]);
              });
              x("toLocaleString", function() {
                return i(
                  g,
                  S ? v(m(this)) : m(this),
                  v(arguments)
                );
              }, y);
            }
          ),
          /***/
          52529: (
            /***/
            function(u, l, e) {
              var s = e(36597).exportTypedArrayMethod, i = e(47044), f = e(32010), h = e(38347), v = f.Uint8Array, p = v && v.prototype || {}, m = [].toString, x = h([].join);
              i(function() {
                m.call({});
              }) && (m = function() {
                return x(this);
              });
              var g = p.toString != m;
              s("toString", m, g);
            }
          ),
          /***/
          47969: (
            /***/
            function(u, l, e) {
              var s = e(98828);
              s("Uint16", function(i) {
                return function(h, v, p) {
                  return i(this, h, v, p);
                };
              });
            }
          ),
          /***/
          59735: (
            /***/
            function(u, l, e) {
              var s = e(98828);
              s("Uint32", function(i) {
                return function(h, v, p) {
                  return i(this, h, v, p);
                };
              });
            }
          ),
          /***/
          56912: (
            /***/
            function(u, l, e) {
              var s = e(98828);
              s("Uint8", function(i) {
                return function(h, v, p) {
                  return i(this, h, v, p);
                };
              });
            }
          ),
          /***/
          58099: (
            /***/
            function(u, l, e) {
              var s = e(98828);
              s("Uint8", function(i) {
                return function(h, v, p) {
                  return i(this, h, v, p);
                };
              }, !0);
            }
          ),
          /***/
          84151: (
            /***/
            function(u, l, e) {
              e(94910);
            }
          ),
          /***/
          49109: (
            /***/
            function(u, l, e) {
              e(64384);
            }
          ),
          /***/
          98443: (
            /***/
            function(u, l, e) {
              e(77074);
            }
          ),
          /***/
          67858: (
            /***/
            function(u, l, e) {
              e(44455);
            }
          ),
          /***/
          49261: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(56614), f = e(61900);
              s({ target: "Promise", stat: !0 }, {
                try: function(h) {
                  var v = i.f(this), p = f(h);
                  return (p.error ? v.reject : v.resolve)(p.value), v.promise;
                }
              });
            }
          ),
          /***/
          1083: (
            /***/
            function(u, l, e) {
              e(71768);
            }
          ),
          /***/
          42437: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(23327), f = e(67797), h = e(82938), v = e(48914), p = function(x) {
                if (x && x.forEach !== h)
                  try {
                    v(x, "forEach", h);
                  } catch {
                    x.forEach = h;
                  }
              };
              for (var m in i)
                i[m] && p(s[m] && s[m].prototype);
              p(f);
            }
          ),
          /***/
          94712: (
            /***/
            function(u, l, e) {
              var s = e(32010), i = e(23327), f = e(67797), h = e(81755), v = e(48914), p = e(38688), m = p("iterator"), x = p("toStringTag"), g = h.values, S = function(b, n) {
                if (b) {
                  if (b[m] !== g)
                    try {
                      v(b, m, g);
                    } catch {
                      b[m] = g;
                    }
                  if (b[x] || v(b, x, n), i[n]) {
                    for (var w in h)
                      if (b[w] !== h[w])
                        try {
                          v(b, w, h[w]);
                        } catch {
                          b[w] = h[w];
                        }
                  }
                }
              };
              for (var y in i)
                S(s[y] && s[y].prototype, y);
              S(f, "DOMTokenList");
            }
          ),
          /***/
          41863: (
            /***/
            function(u, l, e) {
              var s = e(56475), i = e(2834);
              s({ target: "URL", proto: !0, enumerable: !0 }, {
                toJSON: function() {
                  return i(URL.prototype.toString, this);
                }
              });
            }
          ),
          /***/
          90780: (
            /***/
            function(u, l, e) {
              var s = e(42075);
              e(94712), u.exports = s;
            }
          ),
          /***/
          45728: (
            /***/
            function(u, l, e) {
              var s = e(35643), i = e(67906), f = e(98527), h = e(71689), v = e(64607), p = e(71230), m = Date.prototype.getTime;
              function x(b, n, w) {
                var E = w || {};
                return (E.strict ? f(b, n) : b === n) ? !0 : !b || !n || typeof b != "object" && typeof n != "object" ? E.strict ? f(b, n) : b == n : y(b, n, E);
              }
              function g(b) {
                return b == null;
              }
              function S(b) {
                return !(!b || typeof b != "object" || typeof b.length != "number" || typeof b.copy != "function" || typeof b.slice != "function" || b.length > 0 && typeof b[0] != "number");
              }
              function y(b, n, w) {
                var E, A;
                if (typeof b != typeof n || g(b) || g(n) || b.prototype !== n.prototype || i(b) !== i(n))
                  return !1;
                var O = h(b), C = h(n);
                if (O !== C)
                  return !1;
                if (O || C)
                  return b.source === n.source && v(b) === v(n);
                if (p(b) && p(n))
                  return m.call(b) === m.call(n);
                var T = S(b), P = S(n);
                if (T !== P)
                  return !1;
                if (T || P) {
                  if (b.length !== n.length)
                    return !1;
                  for (E = 0; E < b.length; E++)
                    if (b[E] !== n[E])
                      return !1;
                  return !0;
                }
                if (typeof b != typeof n)
                  return !1;
                try {
                  var I = s(b), F = s(n);
                } catch {
                  return !1;
                }
                if (I.length !== F.length)
                  return !1;
                for (I.sort(), F.sort(), E = I.length - 1; E >= 0; E--)
                  if (I[E] != F[E])
                    return !1;
                for (E = I.length - 1; E >= 0; E--)
                  if (A = I[E], !x(b[A], n[A], w))
                    return !1;
                return !0;
              }
              u.exports = x;
            }
          ),
          /***/
          89295: (
            /***/
            function(u, l, e) {
              var s = e(56649), i = e(57770), f = e(96785), h = e(68109);
              u.exports = function(p, m, x) {
                if (!p || typeof p != "object" && typeof p != "function")
                  throw new f("`obj` must be an object or a function`");
                if (typeof m != "string" && typeof m != "symbol")
                  throw new f("`property` must be a string or a symbol`");
                if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
                  throw new f("`nonEnumerable`, if provided, must be a boolean or null");
                if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
                  throw new f("`nonWritable`, if provided, must be a boolean or null");
                if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
                  throw new f("`nonConfigurable`, if provided, must be a boolean or null");
                if (arguments.length > 6 && typeof arguments[6] != "boolean")
                  throw new f("`loose`, if provided, must be a boolean");
                var g = arguments.length > 3 ? arguments[3] : null, S = arguments.length > 4 ? arguments[4] : null, y = arguments.length > 5 ? arguments[5] : null, b = arguments.length > 6 ? arguments[6] : !1, n = !!h && h(p, m);
                if (s)
                  s(p, m, {
                    configurable: y === null && n ? n.configurable : !y,
                    enumerable: g === null && n ? n.enumerable : !g,
                    value: x,
                    writable: S === null && n ? n.writable : !S
                  });
                else if (b || !g && !S && !y)
                  p[m] = x;
                else
                  throw new i("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
              };
            }
          ),
          /***/
          77802: (
            /***/
            function(u, l, e) {
              var s = e(35643), i = typeof Symbol == "function" && typeof Symbol("foo") == "symbol", f = Object.prototype.toString, h = Array.prototype.concat, v = e(89295), p = function(S) {
                return typeof S == "function" && f.call(S) === "[object Function]";
              }, m = e(18890)(), x = function(S, y, b, n) {
                if (y in S) {
                  if (n === !0) {
                    if (S[y] === b)
                      return;
                  } else if (!p(n) || !n())
                    return;
                }
                m ? v(S, y, b, !0) : v(S, y, b);
              }, g = function(S, y) {
                var b = arguments.length > 2 ? arguments[2] : {}, n = s(y);
                i && (n = h.call(n, Object.getOwnPropertySymbols(y)));
                for (var w = 0; w < n.length; w += 1)
                  x(S, n[w], y[n[w]], b[n[w]]);
              };
              g.supportsDescriptors = !!m, u.exports = g;
            }
          ),
          /***/
          56649: (
            /***/
            function(u, l, e) {
              var s = e(28651), i = s("%Object.defineProperty%", !0) || !1;
              if (i)
                try {
                  i({}, "a", { value: 1 });
                } catch {
                  i = !1;
                }
              u.exports = i;
            }
          ),
          /***/
          29055: (
            /***/
            function(u) {
              u.exports = EvalError;
            }
          ),
          /***/
          15293: (
            /***/
            function(u) {
              u.exports = Error;
            }
          ),
          /***/
          18888: (
            /***/
            function(u) {
              u.exports = RangeError;
            }
          ),
          /***/
          47900: (
            /***/
            function(u) {
              u.exports = ReferenceError;
            }
          ),
          /***/
          57770: (
            /***/
            function(u) {
              u.exports = SyntaxError;
            }
          ),
          /***/
          96785: (
            /***/
            function(u) {
              u.exports = TypeError;
            }
          ),
          /***/
          54055: (
            /***/
            function(u) {
              u.exports = URIError;
            }
          ),
          /***/
          64785: (
            /***/
            function(u) {
              var l = typeof Reflect == "object" ? Reflect : null, e = l && typeof l.apply == "function" ? l.apply : function(P, I, F) {
                return Function.prototype.apply.call(P, I, F);
              }, s;
              l && typeof l.ownKeys == "function" ? s = l.ownKeys : Object.getOwnPropertySymbols ? s = function(P) {
                return Object.getOwnPropertyNames(P).concat(Object.getOwnPropertySymbols(P));
              } : s = function(P) {
                return Object.getOwnPropertyNames(P);
              };
              function i(T) {
                console && console.warn && console.warn(T);
              }
              var f = Number.isNaN || function(P) {
                return P !== P;
              };
              function h() {
                h.init.call(this);
              }
              u.exports = h, u.exports.once = A, h.EventEmitter = h, h.prototype._events = void 0, h.prototype._eventsCount = 0, h.prototype._maxListeners = void 0;
              var v = 10;
              function p(T) {
                if (typeof T != "function")
                  throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof T);
              }
              Object.defineProperty(h, "defaultMaxListeners", {
                enumerable: !0,
                get: function() {
                  return v;
                },
                set: function(T) {
                  if (typeof T != "number" || T < 0 || f(T))
                    throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + T + ".");
                  v = T;
                }
              }), h.init = function() {
                (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
              }, h.prototype.setMaxListeners = function(P) {
                if (typeof P != "number" || P < 0 || f(P))
                  throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + P + ".");
                return this._maxListeners = P, this;
              };
              function m(T) {
                return T._maxListeners === void 0 ? h.defaultMaxListeners : T._maxListeners;
              }
              h.prototype.getMaxListeners = function() {
                return m(this);
              }, h.prototype.emit = function(P) {
                for (var I = [], F = 1; F < arguments.length; F++)
                  I.push(arguments[F]);
                var B = P === "error", M = this._events;
                if (M !== void 0)
                  B = B && M.error === void 0;
                else if (!B)
                  return !1;
                if (B) {
                  var z;
                  if (I.length > 0 && (z = I[0]), z instanceof Error)
                    throw z;
                  var L = new Error("Unhandled error." + (z ? " (" + z.message + ")" : ""));
                  throw L.context = z, L;
                }
                var J = M[P];
                if (J === void 0)
                  return !1;
                if (typeof J == "function")
                  e(J, this, I);
                else
                  for (var ft = J.length, Q = n(J, ft), F = 0; F < ft; ++F)
                    e(Q[F], this, I);
                return !0;
              };
              function x(T, P, I, F) {
                var B, M, z;
                if (p(I), M = T._events, M === void 0 ? (M = T._events = /* @__PURE__ */ Object.create(null), T._eventsCount = 0) : (M.newListener !== void 0 && (T.emit(
                  "newListener",
                  P,
                  I.listener ? I.listener : I
                ), M = T._events), z = M[P]), z === void 0)
                  z = M[P] = I, ++T._eventsCount;
                else if (typeof z == "function" ? z = M[P] = F ? [I, z] : [z, I] : F ? z.unshift(I) : z.push(I), B = m(T), B > 0 && z.length > B && !z.warned) {
                  z.warned = !0;
                  var L = new Error("Possible EventEmitter memory leak detected. " + z.length + " " + String(P) + " listeners added. Use emitter.setMaxListeners() to increase limit");
                  L.name = "MaxListenersExceededWarning", L.emitter = T, L.type = P, L.count = z.length, i(L);
                }
                return T;
              }
              h.prototype.addListener = function(P, I) {
                return x(this, P, I, !1);
              }, h.prototype.on = h.prototype.addListener, h.prototype.prependListener = function(P, I) {
                return x(this, P, I, !0);
              };
              function g() {
                if (!this.fired)
                  return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
              }
              function S(T, P, I) {
                var F = { fired: !1, wrapFn: void 0, target: T, type: P, listener: I }, B = g.bind(F);
                return B.listener = I, F.wrapFn = B, B;
              }
              h.prototype.once = function(P, I) {
                return p(I), this.on(P, S(this, P, I)), this;
              }, h.prototype.prependOnceListener = function(P, I) {
                return p(I), this.prependListener(P, S(this, P, I)), this;
              }, h.prototype.removeListener = function(P, I) {
                var F, B, M, z, L;
                if (p(I), B = this._events, B === void 0)
                  return this;
                if (F = B[P], F === void 0)
                  return this;
                if (F === I || F.listener === I)
                  --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete B[P], B.removeListener && this.emit("removeListener", P, F.listener || I));
                else if (typeof F != "function") {
                  for (M = -1, z = F.length - 1; z >= 0; z--)
                    if (F[z] === I || F[z].listener === I) {
                      L = F[z].listener, M = z;
                      break;
                    }
                  if (M < 0)
                    return this;
                  M === 0 ? F.shift() : w(F, M), F.length === 1 && (B[P] = F[0]), B.removeListener !== void 0 && this.emit("removeListener", P, L || I);
                }
                return this;
              }, h.prototype.off = h.prototype.removeListener, h.prototype.removeAllListeners = function(P) {
                var I, F, B;
                if (F = this._events, F === void 0)
                  return this;
                if (F.removeListener === void 0)
                  return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : F[P] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete F[P]), this;
                if (arguments.length === 0) {
                  var M = Object.keys(F), z;
                  for (B = 0; B < M.length; ++B)
                    z = M[B], z !== "removeListener" && this.removeAllListeners(z);
                  return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
                }
                if (I = F[P], typeof I == "function")
                  this.removeListener(P, I);
                else if (I !== void 0)
                  for (B = I.length - 1; B >= 0; B--)
                    this.removeListener(P, I[B]);
                return this;
              };
              function y(T, P, I) {
                var F = T._events;
                if (F === void 0)
                  return [];
                var B = F[P];
                return B === void 0 ? [] : typeof B == "function" ? I ? [B.listener || B] : [B] : I ? E(B) : n(B, B.length);
              }
              h.prototype.listeners = function(P) {
                return y(this, P, !0);
              }, h.prototype.rawListeners = function(P) {
                return y(this, P, !1);
              }, h.listenerCount = function(T, P) {
                return typeof T.listenerCount == "function" ? T.listenerCount(P) : b.call(T, P);
              }, h.prototype.listenerCount = b;
              function b(T) {
                var P = this._events;
                if (P !== void 0) {
                  var I = P[T];
                  if (typeof I == "function")
                    return 1;
                  if (I !== void 0)
                    return I.length;
                }
                return 0;
              }
              h.prototype.eventNames = function() {
                return this._eventsCount > 0 ? s(this._events) : [];
              };
              function n(T, P) {
                for (var I = new Array(P), F = 0; F < P; ++F)
                  I[F] = T[F];
                return I;
              }
              function w(T, P) {
                for (; P + 1 < T.length; P++)
                  T[P] = T[P + 1];
                T.pop();
              }
              function E(T) {
                for (var P = new Array(T.length), I = 0; I < P.length; ++I)
                  P[I] = T[I].listener || T[I];
                return P;
              }
              function A(T, P) {
                return new Promise(function(I, F) {
                  function B(z) {
                    T.removeListener(P, M), F(z);
                  }
                  function M() {
                    typeof T.removeListener == "function" && T.removeListener("error", B), I([].slice.call(arguments));
                  }
                  C(T, P, M, { once: !0 }), P !== "error" && O(T, B, { once: !0 });
                });
              }
              function O(T, P, I) {
                typeof T.on == "function" && C(T, "error", P, I);
              }
              function C(T, P, I, F) {
                if (typeof T.on == "function")
                  F.once ? T.once(P, I) : T.on(P, I);
                else if (typeof T.addEventListener == "function")
                  T.addEventListener(P, function B(M) {
                    F.once && T.removeEventListener(P, B), I(M);
                  });
                else
                  throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof T);
              }
            }
          ),
          /***/
          72022: (
            /***/
            function(u, l, e) {
              u.exports = function() {
                if (typeof globalThis == "object")
                  return globalThis;
                var s;
                try {
                  s = this || new Function("return this")();
                } catch {
                  if (typeof window == "object")
                    return window;
                  if (typeof self == "object")
                    return self;
                  if (typeof e.g < "u")
                    return e.g;
                }
                return s;
              }();
            }
          ),
          /***/
          68404: (
            /***/
            function(u, l, e) {
              var s = e(3746), i = Object.prototype.toString, f = Object.prototype.hasOwnProperty, h = function(g, S, y) {
                for (var b = 0, n = g.length; b < n; b++)
                  f.call(g, b) && (y == null ? S(g[b], b, g) : S.call(y, g[b], b, g));
              }, v = function(g, S, y) {
                for (var b = 0, n = g.length; b < n; b++)
                  y == null ? S(g.charAt(b), b, g) : S.call(y, g.charAt(b), b, g);
              }, p = function(g, S, y) {
                for (var b in g)
                  f.call(g, b) && (y == null ? S(g[b], b, g) : S.call(y, g[b], b, g));
              }, m = function(g, S, y) {
                if (!s(S))
                  throw new TypeError("iterator must be a function");
                var b;
                arguments.length >= 3 && (b = y), i.call(g) === "[object Array]" ? h(g, S, b) : typeof g == "string" ? v(g, S, b) : p(g, S, b);
              };
              u.exports = m;
            }
          ),
          /***/
          12719: (
            /***/
            function(u) {
              var l = "Function.prototype.bind called on incompatible ", e = Object.prototype.toString, s = Math.max, i = "[object Function]", f = function(m, x) {
                for (var g = [], S = 0; S < m.length; S += 1)
                  g[S] = m[S];
                for (var y = 0; y < x.length; y += 1)
                  g[y + m.length] = x[y];
                return g;
              }, h = function(m, x) {
                for (var g = [], S = x || 0, y = 0; S < m.length; S += 1, y += 1)
                  g[y] = m[S];
                return g;
              }, v = function(p, m) {
                for (var x = "", g = 0; g < p.length; g += 1)
                  x += p[g], g + 1 < p.length && (x += m);
                return x;
              };
              u.exports = function(m) {
                var x = this;
                if (typeof x != "function" || e.apply(x) !== i)
                  throw new TypeError(l + x);
                for (var g = h(arguments, 1), S, y = function() {
                  if (this instanceof S) {
                    var A = x.apply(
                      this,
                      f(g, arguments)
                    );
                    return Object(A) === A ? A : this;
                  }
                  return x.apply(
                    m,
                    f(g, arguments)
                  );
                }, b = s(0, x.length - g.length), n = [], w = 0; w < b; w++)
                  n[w] = "$" + w;
                if (S = Function("binder", "return function (" + v(n, ",") + "){ return binder.apply(this,arguments); }")(y), x.prototype) {
                  var E = function() {
                  };
                  E.prototype = x.prototype, S.prototype = new E(), E.prototype = null;
                }
                return S;
              };
            }
          ),
          /***/
          5049: (
            /***/
            function(u, l, e) {
              var s = e(12719);
              u.exports = Function.prototype.bind || s;
            }
          ),
          /***/
          61084: (
            /***/
            function(u) {
              var l = function() {
                return typeof (function() {
                }).name == "string";
              }, e = Object.getOwnPropertyDescriptor;
              if (e)
                try {
                  e([], "length");
                } catch {
                  e = null;
                }
              l.functionsHaveConfigurableNames = function() {
                if (!l() || !e)
                  return !1;
                var f = e(function() {
                }, "name");
                return !!f && !!f.configurable;
              };
              var s = Function.prototype.bind;
              l.boundFunctionsHaveNames = function() {
                return l() && typeof s == "function" && (function() {
                }).bind().name !== "";
              }, u.exports = l;
            }
          ),
          /***/
          28651: (
            /***/
            function(u, l, e) {
              var s, i = e(15293), f = e(29055), h = e(18888), v = e(47900), p = e(57770), m = e(96785), x = e(54055), g = Function, S = function(Rt) {
                try {
                  return g('"use strict"; return (' + Rt + ").constructor;")();
                } catch {
                }
              }, y = Object.getOwnPropertyDescriptor;
              if (y)
                try {
                  y({}, "");
                } catch {
                  y = null;
                }
              var b = function() {
                throw new m();
              }, n = y ? function() {
                try {
                  return arguments.callee, b;
                } catch {
                  try {
                    return y(arguments, "callee").get;
                  } catch {
                    return b;
                  }
                }
              }() : b, w = e(73257)(), E = e(85726)(), A = Object.getPrototypeOf || (E ? function(Rt) {
                return Rt.__proto__;
              } : null), O = {}, C = typeof Uint8Array > "u" || !A ? s : A(Uint8Array), T = {
                __proto__: null,
                "%AggregateError%": typeof AggregateError > "u" ? s : AggregateError,
                "%Array%": Array,
                "%ArrayBuffer%": typeof ArrayBuffer > "u" ? s : ArrayBuffer,
                "%ArrayIteratorPrototype%": w && A ? A([][Symbol.iterator]()) : s,
                "%AsyncFromSyncIteratorPrototype%": s,
                "%AsyncFunction%": O,
                "%AsyncGenerator%": O,
                "%AsyncGeneratorFunction%": O,
                "%AsyncIteratorPrototype%": O,
                "%Atomics%": typeof Atomics > "u" ? s : Atomics,
                "%BigInt%": typeof BigInt > "u" ? s : BigInt,
                "%BigInt64Array%": typeof BigInt64Array > "u" ? s : BigInt64Array,
                "%BigUint64Array%": typeof BigUint64Array > "u" ? s : BigUint64Array,
                "%Boolean%": Boolean,
                "%DataView%": typeof DataView > "u" ? s : DataView,
                "%Date%": Date,
                "%decodeURI%": decodeURI,
                "%decodeURIComponent%": decodeURIComponent,
                "%encodeURI%": encodeURI,
                "%encodeURIComponent%": encodeURIComponent,
                "%Error%": i,
                "%eval%": eval,
                // eslint-disable-line no-eval
                "%EvalError%": f,
                "%Float32Array%": typeof Float32Array > "u" ? s : Float32Array,
                "%Float64Array%": typeof Float64Array > "u" ? s : Float64Array,
                "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? s : FinalizationRegistry,
                "%Function%": g,
                "%GeneratorFunction%": O,
                "%Int8Array%": typeof Int8Array > "u" ? s : Int8Array,
                "%Int16Array%": typeof Int16Array > "u" ? s : Int16Array,
                "%Int32Array%": typeof Int32Array > "u" ? s : Int32Array,
                "%isFinite%": isFinite,
                "%isNaN%": isNaN,
                "%IteratorPrototype%": w && A ? A(A([][Symbol.iterator]())) : s,
                "%JSON%": typeof JSON == "object" ? JSON : s,
                "%Map%": typeof Map > "u" ? s : Map,
                "%MapIteratorPrototype%": typeof Map > "u" || !w || !A ? s : A((/* @__PURE__ */ new Map())[Symbol.iterator]()),
                "%Math%": Math,
                "%Number%": Number,
                "%Object%": Object,
                "%parseFloat%": parseFloat,
                "%parseInt%": parseInt,
                "%Promise%": typeof Promise > "u" ? s : Promise,
                "%Proxy%": typeof Proxy > "u" ? s : Proxy,
                "%RangeError%": h,
                "%ReferenceError%": v,
                "%Reflect%": typeof Reflect > "u" ? s : Reflect,
                "%RegExp%": RegExp,
                "%Set%": typeof Set > "u" ? s : Set,
                "%SetIteratorPrototype%": typeof Set > "u" || !w || !A ? s : A((/* @__PURE__ */ new Set())[Symbol.iterator]()),
                "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? s : SharedArrayBuffer,
                "%String%": String,
                "%StringIteratorPrototype%": w && A ? A(""[Symbol.iterator]()) : s,
                "%Symbol%": w ? Symbol : s,
                "%SyntaxError%": p,
                "%ThrowTypeError%": n,
                "%TypedArray%": C,
                "%TypeError%": m,
                "%Uint8Array%": typeof Uint8Array > "u" ? s : Uint8Array,
                "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? s : Uint8ClampedArray,
                "%Uint16Array%": typeof Uint16Array > "u" ? s : Uint16Array,
                "%Uint32Array%": typeof Uint32Array > "u" ? s : Uint32Array,
                "%URIError%": x,
                "%WeakMap%": typeof WeakMap > "u" ? s : WeakMap,
                "%WeakRef%": typeof WeakRef > "u" ? s : WeakRef,
                "%WeakSet%": typeof WeakSet > "u" ? s : WeakSet
              };
              if (A)
                try {
                  null.error;
                } catch (Rt) {
                  var P = A(A(Rt));
                  T["%Error.prototype%"] = P;
                }
              var I = function Rt(bt) {
                var Dt;
                if (bt === "%AsyncFunction%")
                  Dt = S("async function () {}");
                else if (bt === "%GeneratorFunction%")
                  Dt = S("function* () {}");
                else if (bt === "%AsyncGeneratorFunction%")
                  Dt = S("async function* () {}");
                else if (bt === "%AsyncGenerator%") {
                  var X = Rt("%AsyncGeneratorFunction%");
                  X && (Dt = X.prototype);
                } else if (bt === "%AsyncIteratorPrototype%") {
                  var gt = Rt("%AsyncGenerator%");
                  gt && A && (Dt = A(gt.prototype));
                }
                return T[bt] = Dt, Dt;
              }, F = {
                __proto__: null,
                "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
                "%ArrayPrototype%": ["Array", "prototype"],
                "%ArrayProto_entries%": ["Array", "prototype", "entries"],
                "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
                "%ArrayProto_keys%": ["Array", "prototype", "keys"],
                "%ArrayProto_values%": ["Array", "prototype", "values"],
                "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
                "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
                "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
                "%BooleanPrototype%": ["Boolean", "prototype"],
                "%DataViewPrototype%": ["DataView", "prototype"],
                "%DatePrototype%": ["Date", "prototype"],
                "%ErrorPrototype%": ["Error", "prototype"],
                "%EvalErrorPrototype%": ["EvalError", "prototype"],
                "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
                "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
                "%FunctionPrototype%": ["Function", "prototype"],
                "%Generator%": ["GeneratorFunction", "prototype"],
                "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
                "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
                "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
                "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
                "%JSONParse%": ["JSON", "parse"],
                "%JSONStringify%": ["JSON", "stringify"],
                "%MapPrototype%": ["Map", "prototype"],
                "%NumberPrototype%": ["Number", "prototype"],
                "%ObjectPrototype%": ["Object", "prototype"],
                "%ObjProto_toString%": ["Object", "prototype", "toString"],
                "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
                "%PromisePrototype%": ["Promise", "prototype"],
                "%PromiseProto_then%": ["Promise", "prototype", "then"],
                "%Promise_all%": ["Promise", "all"],
                "%Promise_reject%": ["Promise", "reject"],
                "%Promise_resolve%": ["Promise", "resolve"],
                "%RangeErrorPrototype%": ["RangeError", "prototype"],
                "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
                "%RegExpPrototype%": ["RegExp", "prototype"],
                "%SetPrototype%": ["Set", "prototype"],
                "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
                "%StringPrototype%": ["String", "prototype"],
                "%SymbolPrototype%": ["Symbol", "prototype"],
                "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
                "%TypedArrayPrototype%": ["TypedArray", "prototype"],
                "%TypeErrorPrototype%": ["TypeError", "prototype"],
                "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
                "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
                "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
                "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
                "%URIErrorPrototype%": ["URIError", "prototype"],
                "%WeakMapPrototype%": ["WeakMap", "prototype"],
                "%WeakSetPrototype%": ["WeakSet", "prototype"]
              }, B = e(5049), M = e(55215), z = B.call(Function.call, Array.prototype.concat), L = B.call(Function.apply, Array.prototype.splice), J = B.call(Function.call, String.prototype.replace), ft = B.call(Function.call, String.prototype.slice), Q = B.call(Function.call, RegExp.prototype.exec), xt = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, St = /\\(\\)?/g, Pt = function(bt) {
                var Dt = ft(bt, 0, 1), X = ft(bt, -1);
                if (Dt === "%" && X !== "%")
                  throw new p("invalid intrinsic syntax, expected closing `%`");
                if (X === "%" && Dt !== "%")
                  throw new p("invalid intrinsic syntax, expected opening `%`");
                var gt = [];
                return J(bt, xt, function(st, rt, wt, Ft) {
                  gt[gt.length] = wt ? J(Ft, St, "$1") : rt || st;
                }), gt;
              }, Gt = function(bt, Dt) {
                var X = bt, gt;
                if (M(F, X) && (gt = F[X], X = "%" + gt[0] + "%"), M(T, X)) {
                  var st = T[X];
                  if (st === O && (st = I(X)), typeof st > "u" && !Dt)
                    throw new m("intrinsic " + bt + " exists, but is not available. Please file an issue!");
                  return {
                    alias: gt,
                    name: X,
                    value: st
                  };
                }
                throw new p("intrinsic " + bt + " does not exist!");
              };
              u.exports = function(bt, Dt) {
                if (typeof bt != "string" || bt.length === 0)
                  throw new m("intrinsic name must be a non-empty string");
                if (arguments.length > 1 && typeof Dt != "boolean")
                  throw new m('"allowMissing" argument must be a boolean');
                if (Q(/^%?[^%]*%?$/, bt) === null)
                  throw new p("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
                var X = Pt(bt), gt = X.length > 0 ? X[0] : "", st = Gt("%" + gt + "%", Dt), rt = st.name, wt = st.value, Ft = !1, zt = st.alias;
                zt && (gt = zt[0], L(X, z([0, 1], zt)));
                for (var G = 1, D = !0; G < X.length; G += 1) {
                  var Z = X[G], et = ft(Z, 0, 1), vt = ft(Z, -1);
                  if ((et === '"' || et === "'" || et === "`" || vt === '"' || vt === "'" || vt === "`") && et !== vt)
                    throw new p("property names with quotes must have matching quotes");
                  if ((Z === "constructor" || !D) && (Ft = !0), gt += "." + Z, rt = "%" + gt + "%", M(T, rt))
                    wt = T[rt];
                  else if (wt != null) {
                    if (!(Z in wt)) {
                      if (!Dt)
                        throw new m("base intrinsic for " + bt + " exists, but the property is not available.");
                      return;
                    }
                    if (y && G + 1 >= X.length) {
                      var lt = y(wt, Z);
                      D = !!lt, D && "get" in lt && !("originalValue" in lt.get) ? wt = lt.get : wt = wt[Z];
                    } else
                      D = M(wt, Z), wt = wt[Z];
                    D && !Ft && (T[rt] = wt);
                  }
                }
                return wt;
              };
            }
          ),
          /***/
          68109: (
            /***/
            function(u, l, e) {
              var s = e(28651), i = s("%Object.getOwnPropertyDescriptor%", !0);
              if (i)
                try {
                  i([], "length");
                } catch {
                  i = null;
                }
              u.exports = i;
            }
          ),
          /***/
          18890: (
            /***/
            function(u, l, e) {
              var s = e(56649), i = function() {
                return !!s;
              };
              i.hasArrayLengthDefineBug = function() {
                if (!s)
                  return null;
                try {
                  return s([], "length", { value: 1 }).length !== 1;
                } catch {
                  return !0;
                }
              }, u.exports = i;
            }
          ),
          /***/
          85726: (
            /***/
            function(u) {
              var l = {
                __proto__: null,
                foo: {}
              }, e = Object;
              u.exports = function() {
                return { __proto__: l }.foo === l.foo && !(l instanceof e);
              };
            }
          ),
          /***/
          73257: (
            /***/
            function(u, l, e) {
              var s = typeof Symbol < "u" && Symbol, i = e(12843);
              u.exports = function() {
                return typeof s != "function" || typeof Symbol != "function" || typeof s("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : i();
              };
            }
          ),
          /***/
          12843: (
            /***/
            function(u) {
              u.exports = function() {
                if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
                  return !1;
                if (typeof Symbol.iterator == "symbol")
                  return !0;
                var e = {}, s = Symbol("test"), i = Object(s);
                if (typeof s == "string" || Object.prototype.toString.call(s) !== "[object Symbol]" || Object.prototype.toString.call(i) !== "[object Symbol]")
                  return !1;
                var f = 42;
                e[s] = f;
                for (s in e)
                  return !1;
                if (typeof Object.keys == "function" && Object.keys(e).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(e).length !== 0)
                  return !1;
                var h = Object.getOwnPropertySymbols(e);
                if (h.length !== 1 || h[0] !== s || !Object.prototype.propertyIsEnumerable.call(e, s))
                  return !1;
                if (typeof Object.getOwnPropertyDescriptor == "function") {
                  var v = Object.getOwnPropertyDescriptor(e, s);
                  if (v.value !== f || v.enumerable !== !0)
                    return !1;
                }
                return !0;
              };
            }
          ),
          /***/
          26626: (
            /***/
            function(u, l, e) {
              var s = e(12843);
              u.exports = function() {
                return s() && !!Symbol.toStringTag;
              };
            }
          ),
          /***/
          55215: (
            /***/
            function(u, l, e) {
              var s = Function.prototype.call, i = Object.prototype.hasOwnProperty, f = e(5049);
              u.exports = f.call(s, i);
            }
          ),
          /***/
          35143: (
            /***/
            function(u, l, e) {
              var s = e(16696).Buffer;
              l._dbcs = g;
              for (var i = -1, f = -2, h = -10, v = -1e3, p = new Array(256), m = -1, x = 0; x < 256; x++)
                p[x] = i;
              function g(n, w) {
                if (this.encodingName = n.encodingName, !n)
                  throw new Error("DBCS codec is called without the data.");
                if (!n.table)
                  throw new Error("Encoding '" + this.encodingName + "' has no data.");
                var E = n.table();
                this.decodeTables = [], this.decodeTables[0] = p.slice(0), this.decodeTableSeq = [];
                for (var A = 0; A < E.length; A++)
                  this._addDecodeChunk(E[A]);
                if (typeof n.gb18030 == "function") {
                  this.gb18030 = n.gb18030();
                  var O = this.decodeTables.length;
                  this.decodeTables.push(p.slice(0));
                  var C = this.decodeTables.length;
                  this.decodeTables.push(p.slice(0));
                  for (var T = this.decodeTables[0], A = 129; A <= 254; A++)
                    for (var P = this.decodeTables[v - T[A]], I = 48; I <= 57; I++) {
                      if (P[I] === i)
                        P[I] = v - O;
                      else if (P[I] > v)
                        throw new Error("gb18030 decode tables conflict at byte 2");
                      for (var F = this.decodeTables[v - P[I]], B = 129; B <= 254; B++) {
                        if (F[B] === i)
                          F[B] = v - C;
                        else {
                          if (F[B] === v - C)
                            continue;
                          if (F[B] > v)
                            throw new Error("gb18030 decode tables conflict at byte 3");
                        }
                        for (var M = this.decodeTables[v - F[B]], z = 48; z <= 57; z++)
                          M[z] === i && (M[z] = f);
                      }
                    }
                }
                this.defaultCharUnicode = w.defaultCharUnicode, this.encodeTable = [], this.encodeTableSeq = [];
                var L = {};
                if (n.encodeSkipVals)
                  for (var A = 0; A < n.encodeSkipVals.length; A++) {
                    var J = n.encodeSkipVals[A];
                    if (typeof J == "number")
                      L[J] = !0;
                    else
                      for (var I = J.from; I <= J.to; I++)
                        L[I] = !0;
                  }
                if (this._fillEncodeTable(0, 0, L), n.encodeAdd)
                  for (var ft in n.encodeAdd)
                    Object.prototype.hasOwnProperty.call(n.encodeAdd, ft) && this._setEncodeChar(ft.charCodeAt(0), n.encodeAdd[ft]);
                this.defCharSB = this.encodeTable[0][w.defaultCharSingleByte.charCodeAt(0)], this.defCharSB === i && (this.defCharSB = this.encodeTable[0]["?"]), this.defCharSB === i && (this.defCharSB = "?".charCodeAt(0));
              }
              g.prototype.encoder = S, g.prototype.decoder = y, g.prototype._getDecodeTrieNode = function(n) {
                for (var w = []; n > 0; n >>>= 8)
                  w.push(n & 255);
                w.length == 0 && w.push(0);
                for (var E = this.decodeTables[0], A = w.length - 1; A > 0; A--) {
                  var O = E[w[A]];
                  if (O == i)
                    E[w[A]] = v - this.decodeTables.length, this.decodeTables.push(E = p.slice(0));
                  else if (O <= v)
                    E = this.decodeTables[v - O];
                  else
                    throw new Error("Overwrite byte in " + this.encodingName + ", addr: " + n.toString(16));
                }
                return E;
              }, g.prototype._addDecodeChunk = function(n) {
                var w = parseInt(n[0], 16), E = this._getDecodeTrieNode(w);
                w = w & 255;
                for (var A = 1; A < n.length; A++) {
                  var O = n[A];
                  if (typeof O == "string")
                    for (var C = 0; C < O.length; ) {
                      var T = O.charCodeAt(C++);
                      if (55296 <= T && T < 56320) {
                        var P = O.charCodeAt(C++);
                        if (56320 <= P && P < 57344)
                          E[w++] = 65536 + (T - 55296) * 1024 + (P - 56320);
                        else
                          throw new Error("Incorrect surrogate pair in " + this.encodingName + " at chunk " + n[0]);
                      } else if (4080 < T && T <= 4095) {
                        for (var I = 4095 - T + 2, F = [], B = 0; B < I; B++)
                          F.push(O.charCodeAt(C++));
                        E[w++] = h - this.decodeTableSeq.length, this.decodeTableSeq.push(F);
                      } else
                        E[w++] = T;
                    }
                  else if (typeof O == "number")
                    for (var M = E[w - 1] + 1, C = 0; C < O; C++)
                      E[w++] = M++;
                  else
                    throw new Error("Incorrect type '" + typeof O + "' given in " + this.encodingName + " at chunk " + n[0]);
                }
                if (w > 255)
                  throw new Error("Incorrect chunk in " + this.encodingName + " at addr " + n[0] + ": too long" + w);
              }, g.prototype._getEncodeBucket = function(n) {
                var w = n >> 8;
                return this.encodeTable[w] === void 0 && (this.encodeTable[w] = p.slice(0)), this.encodeTable[w];
              }, g.prototype._setEncodeChar = function(n, w) {
                var E = this._getEncodeBucket(n), A = n & 255;
                E[A] <= h ? this.encodeTableSeq[h - E[A]][m] = w : E[A] == i && (E[A] = w);
              }, g.prototype._setEncodeSequence = function(n, w) {
                var E = n[0], A = this._getEncodeBucket(E), O = E & 255, C;
                A[O] <= h ? C = this.encodeTableSeq[h - A[O]] : (C = {}, A[O] !== i && (C[m] = A[O]), A[O] = h - this.encodeTableSeq.length, this.encodeTableSeq.push(C));
                for (var T = 1; T < n.length - 1; T++) {
                  var P = C[E];
                  typeof P == "object" ? C = P : (C = C[E] = {}, P !== void 0 && (C[m] = P));
                }
                E = n[n.length - 1], C[E] = w;
              }, g.prototype._fillEncodeTable = function(n, w, E) {
                for (var A = this.decodeTables[n], O = !1, C = {}, T = 0; T < 256; T++) {
                  var P = A[T], I = w + T;
                  if (!E[I])
                    if (P >= 0)
                      this._setEncodeChar(P, I), O = !0;
                    else if (P <= v) {
                      var F = v - P;
                      if (!C[F]) {
                        var B = I << 8 >>> 0;
                        this._fillEncodeTable(F, B, E) ? O = !0 : C[F] = !0;
                      }
                    } else
                      P <= h && (this._setEncodeSequence(this.decodeTableSeq[h - P], I), O = !0);
                }
                return O;
              };
              function S(n, w) {
                this.leadSurrogate = -1, this.seqObj = void 0, this.encodeTable = w.encodeTable, this.encodeTableSeq = w.encodeTableSeq, this.defaultCharSingleByte = w.defCharSB, this.gb18030 = w.gb18030;
              }
              S.prototype.write = function(n) {
                for (var w = s.alloc(n.length * (this.gb18030 ? 4 : 3)), E = this.leadSurrogate, A = this.seqObj, O = -1, C = 0, T = 0; ; ) {
                  if (O === -1) {
                    if (C == n.length)
                      break;
                    var P = n.charCodeAt(C++);
                  } else {
                    var P = O;
                    O = -1;
                  }
                  if (55296 <= P && P < 57344)
                    if (P < 56320)
                      if (E === -1) {
                        E = P;
                        continue;
                      } else
                        E = P, P = i;
                    else
                      E !== -1 ? (P = 65536 + (E - 55296) * 1024 + (P - 56320), E = -1) : P = i;
                  else
                    E !== -1 && (O = P, P = i, E = -1);
                  var I = i;
                  if (A !== void 0 && P != i) {
                    var F = A[P];
                    if (typeof F == "object") {
                      A = F;
                      continue;
                    } else
                      typeof F == "number" ? I = F : F == null && (F = A[m], F !== void 0 && (I = F, O = P));
                    A = void 0;
                  } else if (P >= 0) {
                    var B = this.encodeTable[P >> 8];
                    if (B !== void 0 && (I = B[P & 255]), I <= h) {
                      A = this.encodeTableSeq[h - I];
                      continue;
                    }
                    if (I == i && this.gb18030) {
                      var M = b(this.gb18030.uChars, P);
                      if (M != -1) {
                        var I = this.gb18030.gbChars[M] + (P - this.gb18030.uChars[M]);
                        w[T++] = 129 + Math.floor(I / 12600), I = I % 12600, w[T++] = 48 + Math.floor(I / 1260), I = I % 1260, w[T++] = 129 + Math.floor(I / 10), I = I % 10, w[T++] = 48 + I;
                        continue;
                      }
                    }
                  }
                  I === i && (I = this.defaultCharSingleByte), I < 256 ? w[T++] = I : I < 65536 ? (w[T++] = I >> 8, w[T++] = I & 255) : I < 16777216 ? (w[T++] = I >> 16, w[T++] = I >> 8 & 255, w[T++] = I & 255) : (w[T++] = I >>> 24, w[T++] = I >>> 16 & 255, w[T++] = I >>> 8 & 255, w[T++] = I & 255);
                }
                return this.seqObj = A, this.leadSurrogate = E, w.slice(0, T);
              }, S.prototype.end = function() {
                if (!(this.leadSurrogate === -1 && this.seqObj === void 0)) {
                  var n = s.alloc(10), w = 0;
                  if (this.seqObj) {
                    var E = this.seqObj[m];
                    E !== void 0 && (E < 256 ? n[w++] = E : (n[w++] = E >> 8, n[w++] = E & 255)), this.seqObj = void 0;
                  }
                  return this.leadSurrogate !== -1 && (n[w++] = this.defaultCharSingleByte, this.leadSurrogate = -1), n.slice(0, w);
                }
              }, S.prototype.findIdx = b;
              function y(n, w) {
                this.nodeIdx = 0, this.prevBytes = [], this.decodeTables = w.decodeTables, this.decodeTableSeq = w.decodeTableSeq, this.defaultCharUnicode = w.defaultCharUnicode, this.gb18030 = w.gb18030;
              }
              y.prototype.write = function(n) {
                for (var w = s.alloc(n.length * 2), E = this.nodeIdx, A = this.prevBytes, O = this.prevBytes.length, C = -this.prevBytes.length, T, P = 0, I = 0; P < n.length; P++) {
                  var F = P >= 0 ? n[P] : A[P + O], T = this.decodeTables[E][F];
                  if (!(T >= 0))
                    if (T === i)
                      T = this.defaultCharUnicode.charCodeAt(0), P = C;
                    else if (T === f) {
                      if (P >= 3)
                        var B = (n[P - 3] - 129) * 12600 + (n[P - 2] - 48) * 1260 + (n[P - 1] - 129) * 10 + (F - 48);
                      else
                        var B = (A[P - 3 + O] - 129) * 12600 + ((P - 2 >= 0 ? n[P - 2] : A[P - 2 + O]) - 48) * 1260 + ((P - 1 >= 0 ? n[P - 1] : A[P - 1 + O]) - 129) * 10 + (F - 48);
                      var M = b(this.gb18030.gbChars, B);
                      T = this.gb18030.uChars[M] + B - this.gb18030.gbChars[M];
                    } else if (T <= v) {
                      E = v - T;
                      continue;
                    } else if (T <= h) {
                      for (var z = this.decodeTableSeq[h - T], L = 0; L < z.length - 1; L++)
                        T = z[L], w[I++] = T & 255, w[I++] = T >> 8;
                      T = z[z.length - 1];
                    } else
                      throw new Error("iconv-lite internal error: invalid decoding table value " + T + " at " + E + "/" + F);
                  if (T >= 65536) {
                    T -= 65536;
                    var J = 55296 | T >> 10;
                    w[I++] = J & 255, w[I++] = J >> 8, T = 56320 | T & 1023;
                  }
                  w[I++] = T & 255, w[I++] = T >> 8, E = 0, C = P + 1;
                }
                return this.nodeIdx = E, this.prevBytes = C >= 0 ? Array.prototype.slice.call(n, C) : A.slice(C + O).concat(Array.prototype.slice.call(n)), w.slice(0, I).toString("ucs2");
              }, y.prototype.end = function() {
                for (var n = ""; this.prevBytes.length > 0; ) {
                  n += this.defaultCharUnicode;
                  var w = this.prevBytes.slice(1);
                  this.prevBytes = [], this.nodeIdx = 0, w.length > 0 && (n += this.write(w));
                }
                return this.prevBytes = [], this.nodeIdx = 0, n;
              };
              function b(n, w) {
                if (n[0] > w)
                  return -1;
                for (var E = 0, A = n.length; E < A - 1; ) {
                  var O = E + (A - E + 1 >> 1);
                  n[O] <= w ? E = O : A = O;
                }
                return E;
              }
            }
          ),
          /***/
          90481: (
            /***/
            function(u, l, e) {
              u.exports = {
                // == Japanese/ShiftJIS ====================================================
                // All japanese encodings are based on JIS X set of standards:
                // JIS X 0201 - Single-byte encoding of ASCII + ¥ + Kana chars at 0xA1-0xDF.
                // JIS X 0208 - Main set of 6879 characters, placed in 94x94 plane, to be encoded by 2 bytes. 
                //              Has several variations in 1978, 1983, 1990 and 1997.
                // JIS X 0212 - Supplementary plane of 6067 chars in 94x94 plane. 1990. Effectively dead.
                // JIS X 0213 - Extension and modern replacement of 0208 and 0212. Total chars: 11233.
                //              2 planes, first is superset of 0208, second - revised 0212.
                //              Introduced in 2000, revised 2004. Some characters are in Unicode Plane 2 (0x2xxxx)
                // Byte encodings are:
                //  * Shift_JIS: Compatible with 0201, uses not defined chars in top half as lead bytes for double-byte
                //               encoding of 0208. Lead byte ranges: 0x81-0x9F, 0xE0-0xEF; Trail byte ranges: 0x40-0x7E, 0x80-0x9E, 0x9F-0xFC.
                //               Windows CP932 is a superset of Shift_JIS. Some companies added more chars, notably KDDI.
                //  * EUC-JP:    Up to 3 bytes per character. Used mostly on *nixes.
                //               0x00-0x7F       - lower part of 0201
                //               0x8E, 0xA1-0xDF - upper part of 0201
                //               (0xA1-0xFE)x2   - 0208 plane (94x94).
                //               0x8F, (0xA1-0xFE)x2 - 0212 plane (94x94).
                //  * JIS X 208: 7-bit, direct encoding of 0208. Byte ranges: 0x21-0x7E (94 values). Uncommon.
                //               Used as-is in ISO2022 family.
                //  * ISO2022-JP: Stateful encoding, with escape sequences to switch between ASCII, 
                //                0201-1976 Roman, 0208-1978, 0208-1983.
                //  * ISO2022-JP-1: Adds esc seq for 0212-1990.
                //  * ISO2022-JP-2: Adds esc seq for GB2313-1980, KSX1001-1992, ISO8859-1, ISO8859-7.
                //  * ISO2022-JP-3: Adds esc seq for 0201-1976 Kana set, 0213-2000 Planes 1, 2.
                //  * ISO2022-JP-2004: Adds 0213-2004 Plane 1.
                //
                // After JIS X 0213 appeared, Shift_JIS-2004, EUC-JISX0213 and ISO2022-JP-2004 followed, with just changing the planes.
                //
                // Overall, it seems that it's a mess :( http://www8.plala.or.jp/tkubota1/unicode-symbols-map2.html
                shiftjis: {
                  type: "_dbcs",
                  table: function() {
                    return e(40679);
                  },
                  encodeAdd: { "¥": 92, "‾": 126 },
                  encodeSkipVals: [{ from: 60736, to: 63808 }]
                },
                csshiftjis: "shiftjis",
                mskanji: "shiftjis",
                sjis: "shiftjis",
                windows31j: "shiftjis",
                ms31j: "shiftjis",
                xsjis: "shiftjis",
                windows932: "shiftjis",
                ms932: "shiftjis",
                932: "shiftjis",
                cp932: "shiftjis",
                eucjp: {
                  type: "_dbcs",
                  table: function() {
                    return e(56406);
                  },
                  encodeAdd: { "¥": 92, "‾": 126 }
                },
                // TODO: KDDI extension to Shift_JIS
                // TODO: IBM CCSID 942 = CP932, but F0-F9 custom chars and other char changes.
                // TODO: IBM CCSID 943 = Shift_JIS = CP932 with original Shift_JIS lower 128 chars.
                // == Chinese/GBK ==========================================================
                // http://en.wikipedia.org/wiki/GBK
                // We mostly implement W3C recommendation: https://www.w3.org/TR/encoding/#gbk-encoder
                // Oldest GB2312 (1981, ~7600 chars) is a subset of CP936
                gb2312: "cp936",
                gb231280: "cp936",
                gb23121980: "cp936",
                csgb2312: "cp936",
                csiso58gb231280: "cp936",
                euccn: "cp936",
                // Microsoft's CP936 is a subset and approximation of GBK.
                windows936: "cp936",
                ms936: "cp936",
                936: "cp936",
                cp936: {
                  type: "_dbcs",
                  table: function() {
                    return e(74488);
                  }
                },
                // GBK (~22000 chars) is an extension of CP936 that added user-mapped chars and some other.
                gbk: {
                  type: "_dbcs",
                  table: function() {
                    return e(74488).concat(e(55914));
                  }
                },
                xgbk: "gbk",
                isoir58: "gbk",
                // GB18030 is an algorithmic extension of GBK.
                // Main source: https://www.w3.org/TR/encoding/#gbk-encoder
                // http://icu-project.org/docs/papers/gb18030.html
                // http://source.icu-project.org/repos/icu/data/trunk/charset/data/xml/gb-18030-2000.xml
                // http://www.khngai.com/chinese/charmap/tblgbk.php?page=0
                gb18030: {
                  type: "_dbcs",
                  table: function() {
                    return e(74488).concat(e(55914));
                  },
                  gb18030: function() {
                    return e(99129);
                  },
                  encodeSkipVals: [128],
                  encodeAdd: { "€": 41699 }
                },
                chinese: "gb18030",
                // == Korean ===============================================================
                // EUC-KR, KS_C_5601 and KS X 1001 are exactly the same.
                windows949: "cp949",
                ms949: "cp949",
                949: "cp949",
                cp949: {
                  type: "_dbcs",
                  table: function() {
                    return e(21166);
                  }
                },
                cseuckr: "cp949",
                csksc56011987: "cp949",
                euckr: "cp949",
                isoir149: "cp949",
                korean: "cp949",
                ksc56011987: "cp949",
                ksc56011989: "cp949",
                ksc5601: "cp949",
                // == Big5/Taiwan/Hong Kong ================================================
                // There are lots of tables for Big5 and cp950. Please see the following links for history:
                // http://moztw.org/docs/big5/  http://www.haible.de/bruno/charsets/conversion-tables/Big5.html
                // Variations, in roughly number of defined chars:
                //  * Windows CP 950: Microsoft variant of Big5. Canonical: http://www.unicode.org/Public/MAPPINGS/VENDORS/MICSFT/WINDOWS/CP950.TXT
                //  * Windows CP 951: Microsoft variant of Big5-HKSCS-2001. Seems to be never public. http://me.abelcheung.org/articles/research/what-is-cp951/
                //  * Big5-2003 (Taiwan standard) almost superset of cp950.
                //  * Unicode-at-on (UAO) / Mozilla 1.8. Falling out of use on the Web. Not supported by other browsers.
                //  * Big5-HKSCS (-2001, -2004, -2008). Hong Kong standard. 
                //    many unicode code points moved from PUA to Supplementary plane (U+2XXXX) over the years.
                //    Plus, it has 4 combining sequences.
                //    Seems that Mozilla refused to support it for 10 yrs. https://bugzilla.mozilla.org/show_bug.cgi?id=162431 https://bugzilla.mozilla.org/show_bug.cgi?id=310299
                //    because big5-hkscs is the only encoding to include astral characters in non-algorithmic way.
                //    Implementations are not consistent within browsers; sometimes labeled as just big5.
                //    MS Internet Explorer switches from big5 to big5-hkscs when a patch applied.
                //    Great discussion & recap of what's going on https://bugzilla.mozilla.org/show_bug.cgi?id=912470#c31
                //    In the encoder, it might make sense to support encoding old PUA mappings to Big5 bytes seq-s.
                //    Official spec: http://www.ogcio.gov.hk/en/business/tech_promotion/ccli/terms/doc/2003cmp_2008.txt
                //                   http://www.ogcio.gov.hk/tc/business/tech_promotion/ccli/terms/doc/hkscs-2008-big5-iso.txt
                // 
                // Current understanding of how to deal with Big5(-HKSCS) is in the Encoding Standard, http://encoding.spec.whatwg.org/#big5-encoder
                // Unicode mapping (http://www.unicode.org/Public/MAPPINGS/OBSOLETE/EASTASIA/OTHER/BIG5.TXT) is said to be wrong.
                windows950: "cp950",
                ms950: "cp950",
                950: "cp950",
                cp950: {
                  type: "_dbcs",
                  table: function() {
                    return e(72324);
                  }
                },
                // Big5 has many variations and is an extension of cp950. We use Encoding Standard's as a consensus.
                big5: "big5hkscs",
                big5hkscs: {
                  type: "_dbcs",
                  table: function() {
                    return e(72324).concat(e(43267));
                  },
                  encodeSkipVals: [
                    // Although Encoding Standard says we should avoid encoding to HKSCS area (See Step 1 of
                    // https://encoding.spec.whatwg.org/#index-big5-pointer), we still do it to increase compatibility with ICU.
                    // But if a single unicode point can be encoded both as HKSCS and regular Big5, we prefer the latter.
                    36457,
                    36463,
                    36478,
                    36523,
                    36532,
                    36557,
                    36560,
                    36695,
                    36713,
                    36718,
                    36811,
                    36862,
                    36973,
                    36986,
                    37060,
                    37084,
                    37105,
                    37311,
                    37551,
                    37552,
                    37553,
                    37554,
                    37585,
                    37959,
                    38090,
                    38361,
                    38652,
                    39285,
                    39798,
                    39800,
                    39803,
                    39878,
                    39902,
                    39916,
                    39926,
                    40002,
                    40019,
                    40034,
                    40040,
                    40043,
                    40055,
                    40124,
                    40125,
                    40144,
                    40279,
                    40282,
                    40388,
                    40431,
                    40443,
                    40617,
                    40687,
                    40701,
                    40800,
                    40907,
                    41079,
                    41180,
                    41183,
                    36812,
                    37576,
                    38468,
                    38637,
                    // Step 2 of https://encoding.spec.whatwg.org/#index-big5-pointer: Use last pointer for U+2550, U+255E, U+2561, U+256A, U+5341, or U+5345
                    41636,
                    41637,
                    41639,
                    41638,
                    41676,
                    41678
                  ]
                },
                cnbig5: "big5hkscs",
                csbig5: "big5hkscs",
                xxbig5: "big5hkscs"
              };
            }
          ),
          /***/
          26326: (
            /***/
            function(u, l, e) {
              for (var s = [
                e(16793),
                e(24162),
                e(17100),
                e(11326),
                e(99948),
                e(99900),
                e(81492),
                e(35143),
                e(90481)
              ], i = 0; i < s.length; i++) {
                var f = s[i];
                for (var h in f)
                  Object.prototype.hasOwnProperty.call(f, h) && (l[h] = f[h]);
              }
            }
          ),
          /***/
          16793: (
            /***/
            function(u, l, e) {
              var s = e(16696).Buffer;
              u.exports = {
                // Encodings
                utf8: { type: "_internal", bomAware: !0 },
                cesu8: { type: "_internal", bomAware: !0 },
                unicode11utf8: "utf8",
                ucs2: { type: "_internal", bomAware: !0 },
                utf16le: "ucs2",
                binary: { type: "_internal" },
                base64: { type: "_internal" },
                hex: { type: "_internal" },
                // Codec.
                _internal: i
              };
              function i(g, S) {
                this.enc = g.encodingName, this.bomAware = g.bomAware, this.enc === "base64" ? this.encoder = p : this.enc === "cesu8" && (this.enc = "utf8", this.encoder = m, s.from("eda0bdedb2a9", "hex").toString() !== "💩" && (this.decoder = x, this.defaultCharUnicode = S.defaultCharUnicode));
              }
              i.prototype.encoder = v, i.prototype.decoder = h;
              var f = e(43143).I;
              f.prototype.end || (f.prototype.end = function() {
              });
              function h(g, S) {
                this.decoder = new f(S.enc);
              }
              h.prototype.write = function(g) {
                return s.isBuffer(g) || (g = s.from(g)), this.decoder.write(g);
              }, h.prototype.end = function() {
                return this.decoder.end();
              };
              function v(g, S) {
                this.enc = S.enc;
              }
              v.prototype.write = function(g) {
                return s.from(g, this.enc);
              }, v.prototype.end = function() {
              };
              function p(g, S) {
                this.prevStr = "";
              }
              p.prototype.write = function(g) {
                g = this.prevStr + g;
                var S = g.length - g.length % 4;
                return this.prevStr = g.slice(S), g = g.slice(0, S), s.from(g, "base64");
              }, p.prototype.end = function() {
                return s.from(this.prevStr, "base64");
              };
              function m(g, S) {
              }
              m.prototype.write = function(g) {
                for (var S = s.alloc(g.length * 3), y = 0, b = 0; b < g.length; b++) {
                  var n = g.charCodeAt(b);
                  n < 128 ? S[y++] = n : n < 2048 ? (S[y++] = 192 + (n >>> 6), S[y++] = 128 + (n & 63)) : (S[y++] = 224 + (n >>> 12), S[y++] = 128 + (n >>> 6 & 63), S[y++] = 128 + (n & 63));
                }
                return S.slice(0, y);
              }, m.prototype.end = function() {
              };
              function x(g, S) {
                this.acc = 0, this.contBytes = 0, this.accBytes = 0, this.defaultCharUnicode = S.defaultCharUnicode;
              }
              x.prototype.write = function(g) {
                for (var S = this.acc, y = this.contBytes, b = this.accBytes, n = "", w = 0; w < g.length; w++) {
                  var E = g[w];
                  (E & 192) !== 128 ? (y > 0 && (n += this.defaultCharUnicode, y = 0), E < 128 ? n += String.fromCharCode(E) : E < 224 ? (S = E & 31, y = 1, b = 1) : E < 240 ? (S = E & 15, y = 2, b = 1) : n += this.defaultCharUnicode) : y > 0 ? (S = S << 6 | E & 63, y--, b++, y === 0 && (b === 2 && S < 128 && S > 0 ? n += this.defaultCharUnicode : b === 3 && S < 2048 ? n += this.defaultCharUnicode : n += String.fromCharCode(S))) : n += this.defaultCharUnicode;
                }
                return this.acc = S, this.contBytes = y, this.accBytes = b, n;
              }, x.prototype.end = function() {
                var g = 0;
                return this.contBytes > 0 && (g += this.defaultCharUnicode), g;
              };
            }
          ),
          /***/
          99948: (
            /***/
            function(u, l, e) {
              var s = e(16696).Buffer;
              l._sbcs = i;
              function i(v, p) {
                if (!v)
                  throw new Error("SBCS codec is called without the data.");
                if (!v.chars || v.chars.length !== 128 && v.chars.length !== 256)
                  throw new Error("Encoding '" + v.type + "' has incorrect 'chars' (must be of len 128 or 256)");
                if (v.chars.length === 128) {
                  for (var m = "", x = 0; x < 128; x++)
                    m += String.fromCharCode(x);
                  v.chars = m + v.chars;
                }
                this.decodeBuf = s.from(v.chars, "ucs2");
                for (var g = s.alloc(65536, p.defaultCharSingleByte.charCodeAt(0)), x = 0; x < v.chars.length; x++)
                  g[v.chars.charCodeAt(x)] = x;
                this.encodeBuf = g;
              }
              i.prototype.encoder = f, i.prototype.decoder = h;
              function f(v, p) {
                this.encodeBuf = p.encodeBuf;
              }
              f.prototype.write = function(v) {
                for (var p = s.alloc(v.length), m = 0; m < v.length; m++)
                  p[m] = this.encodeBuf[v.charCodeAt(m)];
                return p;
              }, f.prototype.end = function() {
              };
              function h(v, p) {
                this.decodeBuf = p.decodeBuf;
              }
              h.prototype.write = function(v) {
                for (var p = this.decodeBuf, m = s.alloc(v.length * 2), x = 0, g = 0, S = 0; S < v.length; S++)
                  x = v[S] * 2, g = S * 2, m[g] = p[x], m[g + 1] = p[x + 1];
                return m.toString("ucs2");
              }, h.prototype.end = function() {
              };
            }
          ),
          /***/
          81492: (
            /***/
            function(u) {
              u.exports = {
                437: "cp437",
                737: "cp737",
                775: "cp775",
                850: "cp850",
                852: "cp852",
                855: "cp855",
                856: "cp856",
                857: "cp857",
                858: "cp858",
                860: "cp860",
                861: "cp861",
                862: "cp862",
                863: "cp863",
                864: "cp864",
                865: "cp865",
                866: "cp866",
                869: "cp869",
                874: "windows874",
                922: "cp922",
                1046: "cp1046",
                1124: "cp1124",
                1125: "cp1125",
                1129: "cp1129",
                1133: "cp1133",
                1161: "cp1161",
                1162: "cp1162",
                1163: "cp1163",
                1250: "windows1250",
                1251: "windows1251",
                1252: "windows1252",
                1253: "windows1253",
                1254: "windows1254",
                1255: "windows1255",
                1256: "windows1256",
                1257: "windows1257",
                1258: "windows1258",
                28591: "iso88591",
                28592: "iso88592",
                28593: "iso88593",
                28594: "iso88594",
                28595: "iso88595",
                28596: "iso88596",
                28597: "iso88597",
                28598: "iso88598",
                28599: "iso88599",
                28600: "iso885910",
                28601: "iso885911",
                28603: "iso885913",
                28604: "iso885914",
                28605: "iso885915",
                28606: "iso885916",
                windows874: {
                  type: "_sbcs",
                  chars: "€����…�����������‘’“”•–—�������� กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����"
                },
                win874: "windows874",
                cp874: "windows874",
                windows1250: {
                  type: "_sbcs",
                  chars: "€�‚�„…†‡�‰Š‹ŚŤŽŹ�‘’“”•–—�™š›śťžź ˇ˘Ł¤Ą¦§¨©Ş«¬­®Ż°±˛ł´µ¶·¸ąş»Ľ˝ľżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙"
                },
                win1250: "windows1250",
                cp1250: "windows1250",
                windows1251: {
                  type: "_sbcs",
                  chars: "ЂЃ‚ѓ„…†‡€‰Љ‹ЊЌЋЏђ‘’“”•–—�™љ›њќћџ ЎўЈ¤Ґ¦§Ё©Є«¬­®Ї°±Ііґµ¶·ё№є»јЅѕїАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя"
                },
                win1251: "windows1251",
                cp1251: "windows1251",
                windows1252: {
                  type: "_sbcs",
                  chars: "€�‚ƒ„…†‡ˆ‰Š‹Œ�Ž��‘’“”•–—˜™š›œ�žŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ"
                },
                win1252: "windows1252",
                cp1252: "windows1252",
                windows1253: {
                  type: "_sbcs",
                  chars: "€�‚ƒ„…†‡�‰�‹�����‘’“”•–—�™�›���� ΅Ά£¤¥¦§¨©�«¬­®―°±²³΄µ¶·ΈΉΊ»Ό½ΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�"
                },
                win1253: "windows1253",
                cp1253: "windows1253",
                windows1254: {
                  type: "_sbcs",
                  chars: "€�‚ƒ„…†‡ˆ‰Š‹Œ����‘’“”•–—˜™š›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏĞÑÒÓÔÕÖ×ØÙÚÛÜİŞßàáâãäåæçèéêëìíîïğñòóôõö÷øùúûüışÿ"
                },
                win1254: "windows1254",
                cp1254: "windows1254",
                windows1255: {
                  type: "_sbcs",
                  chars: "€�‚ƒ„…†‡ˆ‰�‹�����‘’“”•–—˜™�›���� ¡¢£₪¥¦§¨©×«¬­®¯°±²³´µ¶·¸¹÷»¼½¾¿ְֱֲֳִֵֶַָֹֺֻּֽ־ֿ׀ׁׂ׃װױײ׳״�������אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�"
                },
                win1255: "windows1255",
                cp1255: "windows1255",
                windows1256: {
                  type: "_sbcs",
                  chars: "€پ‚ƒ„…†‡ˆ‰ٹ‹Œچژڈگ‘’“”•–—ک™ڑ›œ‌‍ں ،¢£¤¥¦§¨©ھ«¬­®¯°±²³´µ¶·¸¹؛»¼½¾؟ہءآأؤإئابةتثجحخدذرزسشصض×طظعغـفقكàلâمنهوçèéêëىيîïًٌٍَôُِ÷ّùْûü‎‏ے"
                },
                win1256: "windows1256",
                cp1256: "windows1256",
                windows1257: {
                  type: "_sbcs",
                  chars: "€�‚�„…†‡�‰�‹�¨ˇ¸�‘’“”•–—�™�›�¯˛� �¢£¤�¦§Ø©Ŗ«¬­®Æ°±²³´µ¶·ø¹ŗ»¼½¾æĄĮĀĆÄÅĘĒČÉŹĖĢĶĪĻŠŃŅÓŌÕÖ×ŲŁŚŪÜŻŽßąįāćäåęēčéźėģķīļšńņóōõö÷ųłśūüżž˙"
                },
                win1257: "windows1257",
                cp1257: "windows1257",
                windows1258: {
                  type: "_sbcs",
                  chars: "€�‚ƒ„…†‡ˆ‰�‹Œ����‘’“”•–—˜™�›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ"
                },
                win1258: "windows1258",
                cp1258: "windows1258",
                iso88591: {
                  type: "_sbcs",
                  chars: " ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ"
                },
                cp28591: "iso88591",
                iso88592: {
                  type: "_sbcs",
                  chars: " Ą˘Ł¤ĽŚ§¨ŠŞŤŹ­ŽŻ°ą˛ł´ľśˇ¸šşťź˝žżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙"
                },
                cp28592: "iso88592",
                iso88593: {
                  type: "_sbcs",
                  chars: " Ħ˘£¤�Ĥ§¨İŞĞĴ­�Ż°ħ²³´µĥ·¸ışğĵ½�żÀÁÂ�ÄĊĈÇÈÉÊËÌÍÎÏ�ÑÒÓÔĠÖ×ĜÙÚÛÜŬŜßàáâ�äċĉçèéêëìíîï�ñòóôġö÷ĝùúûüŭŝ˙"
                },
                cp28593: "iso88593",
                iso88594: {
                  type: "_sbcs",
                  chars: " ĄĸŖ¤ĨĻ§¨ŠĒĢŦ­Ž¯°ą˛ŗ´ĩļˇ¸šēģŧŊžŋĀÁÂÃÄÅÆĮČÉĘËĖÍÎĪĐŅŌĶÔÕÖ×ØŲÚÛÜŨŪßāáâãäåæįčéęëėíîīđņōķôõö÷øųúûüũū˙"
                },
                cp28594: "iso88594",
                iso88595: {
                  type: "_sbcs",
                  chars: " ЁЂЃЄЅІЇЈЉЊЋЌ­ЎЏАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя№ёђѓєѕіїјљњћќ§ўџ"
                },
                cp28595: "iso88595",
                iso88596: {
                  type: "_sbcs",
                  chars: " ���¤�������،­�������������؛���؟�ءآأؤإئابةتثجحخدذرزسشصضطظعغ�����ـفقكلمنهوىيًٌٍَُِّْ�������������"
                },
                cp28596: "iso88596",
                iso88597: {
                  type: "_sbcs",
                  chars: " ‘’£€₯¦§¨©ͺ«¬­�―°±²³΄΅Ά·ΈΉΊ»Ό½ΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�"
                },
                cp28597: "iso88597",
                iso88598: {
                  type: "_sbcs",
                  chars: " �¢£¤¥¦§¨©×«¬­®¯°±²³´µ¶·¸¹÷»¼½¾��������������������������������‗אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�"
                },
                cp28598: "iso88598",
                iso88599: {
                  type: "_sbcs",
                  chars: " ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏĞÑÒÓÔÕÖ×ØÙÚÛÜİŞßàáâãäåæçèéêëìíîïğñòóôõö÷øùúûüışÿ"
                },
                cp28599: "iso88599",
                iso885910: {
                  type: "_sbcs",
                  chars: " ĄĒĢĪĨĶ§ĻĐŠŦŽ­ŪŊ°ąēģīĩķ·ļđšŧž―ūŋĀÁÂÃÄÅÆĮČÉĘËĖÍÎÏÐŅŌÓÔÕÖŨØŲÚÛÜÝÞßāáâãäåæįčéęëėíîïðņōóôõöũøųúûüýþĸ"
                },
                cp28600: "iso885910",
                iso885911: {
                  type: "_sbcs",
                  chars: " กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����"
                },
                cp28601: "iso885911",
                iso885913: {
                  type: "_sbcs",
                  chars: " ”¢£¤„¦§Ø©Ŗ«¬­®Æ°±²³“µ¶·ø¹ŗ»¼½¾æĄĮĀĆÄÅĘĒČÉŹĖĢĶĪĻŠŃŅÓŌÕÖ×ŲŁŚŪÜŻŽßąįāćäåęēčéźėģķīļšńņóōõö÷ųłśūüżž’"
                },
                cp28603: "iso885913",
                iso885914: {
                  type: "_sbcs",
                  chars: " Ḃḃ£ĊċḊ§Ẁ©ẂḋỲ­®ŸḞḟĠġṀṁ¶ṖẁṗẃṠỳẄẅṡÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏŴÑÒÓÔÕÖṪØÙÚÛÜÝŶßàáâãäåæçèéêëìíîïŵñòóôõöṫøùúûüýŷÿ"
                },
                cp28604: "iso885914",
                iso885915: {
                  type: "_sbcs",
                  chars: " ¡¢£€¥Š§š©ª«¬­®¯°±²³Žµ¶·ž¹º»ŒœŸ¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ"
                },
                cp28605: "iso885915",
                iso885916: {
                  type: "_sbcs",
                  chars: " ĄąŁ€„Š§š©Ș«Ź­źŻ°±ČłŽ”¶·žčș»ŒœŸżÀÁÂĂÄĆÆÇÈÉÊËÌÍÎÏĐŃÒÓÔŐÖŚŰÙÚÛÜĘȚßàáâăäćæçèéêëìíîïđńòóôőöśűùúûüęțÿ"
                },
                cp28606: "iso885916",
                cp437: {
                  type: "_sbcs",
                  chars: "ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜ¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
                },
                ibm437: "cp437",
                csibm437: "cp437",
                cp737: {
                  type: "_sbcs",
                  chars: "ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρσςτυφχψ░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀ωάέήϊίόύϋώΆΈΉΊΌΎΏ±≥≤ΪΫ÷≈°∙·√ⁿ²■ "
                },
                ibm737: "cp737",
                csibm737: "cp737",
                cp775: {
                  type: "_sbcs",
                  chars: "ĆüéāäģåćłēŖŗīŹÄÅÉæÆōöĢ¢ŚśÖÜø£Ø×¤ĀĪóŻżź”¦©®¬½¼Ł«»░▒▓│┤ĄČĘĖ╣║╗╝ĮŠ┐└┴┬├─┼ŲŪ╚╔╩╦╠═╬Žąčęėįšųūž┘┌█▄▌▐▀ÓßŌŃõÕµńĶķĻļņĒŅ’­±“¾¶§÷„°∙·¹³²■ "
                },
                ibm775: "cp775",
                csibm775: "cp775",
                cp850: {
                  type: "_sbcs",
                  chars: "ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈıÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´­±‗¾¶§÷¸°¨·¹³²■ "
                },
                ibm850: "cp850",
                csibm850: "cp850",
                cp852: {
                  type: "_sbcs",
                  chars: "ÇüéâäůćçłëŐőîŹÄĆÉĹĺôöĽľŚśÖÜŤťŁ×čáíóúĄąŽžĘę¬źČş«»░▒▓│┤ÁÂĚŞ╣║╗╝Żż┐└┴┬├─┼Ăă╚╔╩╦╠═╬¤đĐĎËďŇÍÎě┘┌█▄ŢŮ▀ÓßÔŃńňŠšŔÚŕŰýÝţ´­˝˛ˇ˘§÷¸°¨˙űŘř■ "
                },
                ibm852: "cp852",
                csibm852: "cp852",
                cp855: {
                  type: "_sbcs",
                  chars: "ђЂѓЃёЁєЄѕЅіІїЇјЈљЉњЊћЋќЌўЎџЏюЮъЪаАбБцЦдДеЕфФгГ«»░▒▓│┤хХиИ╣║╗╝йЙ┐└┴┬├─┼кК╚╔╩╦╠═╬¤лЛмМнНоОп┘┌█▄Пя▀ЯрРсСтТуУжЖвВьЬ№­ыЫзЗшШэЭщЩчЧ§■ "
                },
                ibm855: "cp855",
                csibm855: "cp855",
                cp856: {
                  type: "_sbcs",
                  chars: "אבגדהוזחטיךכלםמןנסעףפץצקרשת�£�×����������®¬½¼�«»░▒▓│┤���©╣║╗╝¢¥┐└┴┬├─┼��╚╔╩╦╠═╬¤���������┘┌█▄¦�▀������µ�������¯´­±‗¾¶§÷¸°¨·¹³²■ "
                },
                ibm856: "cp856",
                csibm856: "cp856",
                cp857: {
                  type: "_sbcs",
                  chars: "ÇüéâäàåçêëèïîıÄÅÉæÆôöòûùİÖÜø£ØŞşáíóúñÑĞğ¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ºªÊËÈ�ÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµ�×ÚÛÙìÿ¯´­±�¾¶§÷¸°¨·¹³²■ "
                },
                ibm857: "cp857",
                csibm857: "cp857",
                cp858: {
                  type: "_sbcs",
                  chars: "ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈ€ÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´­±‗¾¶§÷¸°¨·¹³²■ "
                },
                ibm858: "cp858",
                csibm858: "cp858",
                cp860: {
                  type: "_sbcs",
                  chars: "ÇüéâãàÁçêÊèÍÔìÃÂÉÀÈôõòÚùÌÕÜ¢£Ù₧ÓáíóúñÑªº¿Ò¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
                },
                ibm860: "cp860",
                csibm860: "cp860",
                cp861: {
                  type: "_sbcs",
                  chars: "ÇüéâäàåçêëèÐðÞÄÅÉæÆôöþûÝýÖÜø£Ø₧ƒáíóúÁÍÓÚ¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
                },
                ibm861: "cp861",
                csibm861: "cp861",
                cp862: {
                  type: "_sbcs",
                  chars: "אבגדהוזחטיךכלםמןנסעףפץצקרשת¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
                },
                ibm862: "cp862",
                csibm862: "cp862",
                cp863: {
                  type: "_sbcs",
                  chars: "ÇüéâÂà¶çêëèïî‗À§ÉÈÊôËÏûù¤ÔÜ¢£ÙÛƒ¦´óú¨¸³¯Î⌐¬½¼¾«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
                },
                ibm863: "cp863",
                csibm863: "cp863",
                cp864: {
                  type: "_sbcs",
                  chars: `\0\x07\b	
\v\f\r\x1B !"#$٪&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_\`abcdefghijklmnopqrstuvwxyz{|}~°·∙√▒─│┼┤┬├┴┐┌└┘β∞φ±½¼≈«»ﻷﻸ��ﻻﻼ� ­ﺂ£¤ﺄ��ﺎﺏﺕﺙ،ﺝﺡﺥ٠١٢٣٤٥٦٧٨٩ﻑ؛ﺱﺵﺹ؟¢ﺀﺁﺃﺅﻊﺋﺍﺑﺓﺗﺛﺟﺣﺧﺩﺫﺭﺯﺳﺷﺻﺿﻁﻅﻋﻏ¦¬÷×ﻉـﻓﻗﻛﻟﻣﻧﻫﻭﻯﻳﺽﻌﻎﻍﻡﹽّﻥﻩﻬﻰﻲﻐﻕﻵﻶﻝﻙﻱ■�`
                },
                ibm864: "cp864",
                csibm864: "cp864",
                cp865: {
                  type: "_sbcs",
                  chars: "ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø₧ƒáíóúñÑªº¿⌐¬½¼¡«¤░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
                },
                ibm865: "cp865",
                csibm865: "cp865",
                cp866: {
                  type: "_sbcs",
                  chars: "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў°∙·√№¤■ "
                },
                ibm866: "cp866",
                csibm866: "cp866",
                cp869: {
                  type: "_sbcs",
                  chars: "������Ά�·¬¦‘’Έ―ΉΊΪΌ��ΎΫ©Ώ²³ά£έήίϊΐόύΑΒΓΔΕΖΗ½ΘΙ«»░▒▓│┤ΚΛΜΝ╣║╗╝ΞΟ┐└┴┬├─┼ΠΡ╚╔╩╦╠═╬ΣΤΥΦΧΨΩαβγ┘┌█▄δε▀ζηθικλμνξοπρσςτ΄­±υφχ§ψ΅°¨ωϋΰώ■ "
                },
                ibm869: "cp869",
                csibm869: "cp869",
                cp922: {
                  type: "_sbcs",
                  chars: " ¡¢£¤¥¦§¨©ª«¬­®‾°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏŠÑÒÓÔÕÖ×ØÙÚÛÜÝŽßàáâãäåæçèéêëìíîïšñòóôõö÷øùúûüýžÿ"
                },
                ibm922: "cp922",
                csibm922: "cp922",
                cp1046: {
                  type: "_sbcs",
                  chars: "ﺈ×÷ﹱ■│─┐┌└┘ﹹﹻﹽﹿﹷﺊﻰﻳﻲﻎﻏﻐﻶﻸﻺﻼ ¤ﺋﺑﺗﺛﺟﺣ،­ﺧﺳ٠١٢٣٤٥٦٧٨٩ﺷ؛ﺻﺿﻊ؟ﻋءآأؤإئابةتثجحخدذرزسشصضطﻇعغﻌﺂﺄﺎﻓـفقكلمنهوىيًٌٍَُِّْﻗﻛﻟﻵﻷﻹﻻﻣﻧﻬﻩ�"
                },
                ibm1046: "cp1046",
                csibm1046: "cp1046",
                cp1124: {
                  type: "_sbcs",
                  chars: " ЁЂҐЄЅІЇЈЉЊЋЌ­ЎЏАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя№ёђґєѕіїјљњћќ§ўџ"
                },
                ibm1124: "cp1124",
                csibm1124: "cp1124",
                cp1125: {
                  type: "_sbcs",
                  chars: "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёҐґЄєІіЇї·√№¤■ "
                },
                ibm1125: "cp1125",
                csibm1125: "cp1125",
                cp1129: {
                  type: "_sbcs",
                  chars: " ¡¢£¤¥¦§œ©ª«¬­®¯°±²³Ÿµ¶·Œ¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ"
                },
                ibm1129: "cp1129",
                csibm1129: "cp1129",
                cp1133: {
                  type: "_sbcs",
                  chars: " ກຂຄງຈສຊຍດຕຖທນບປຜຝພຟມຢຣລວຫອຮ���ຯະາຳິີຶືຸູຼັົຽ���ເແໂໃໄ່້໊໋໌ໍໆ�ໜໝ₭����������������໐໑໒໓໔໕໖໗໘໙��¢¬¦�"
                },
                ibm1133: "cp1133",
                csibm1133: "cp1133",
                cp1161: {
                  type: "_sbcs",
                  chars: "��������������������������������่กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู้๊๋€฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛¢¬¦ "
                },
                ibm1161: "cp1161",
                csibm1161: "cp1161",
                cp1162: {
                  type: "_sbcs",
                  chars: "€…‘’“”•–— กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����"
                },
                ibm1162: "cp1162",
                csibm1162: "cp1162",
                cp1163: {
                  type: "_sbcs",
                  chars: " ¡¢£€¥¦§œ©ª«¬­®¯°±²³Ÿµ¶·Œ¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ"
                },
                ibm1163: "cp1163",
                csibm1163: "cp1163",
                maccroatian: {
                  type: "_sbcs",
                  chars: "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®Š™´¨≠ŽØ∞±≤≥∆µ∂∑∏š∫ªºΩžø¿¡¬√ƒ≈Ć«Č… ÀÃÕŒœĐ—“”‘’÷◊�©⁄¤‹›Æ»–·‚„‰ÂćÁčÈÍÎÏÌÓÔđÒÚÛÙıˆ˜¯πË˚¸Êæˇ"
                },
                maccyrillic: {
                  type: "_sbcs",
                  chars: "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°¢£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµ∂ЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю¤"
                },
                macgreek: {
                  type: "_sbcs",
                  chars: "Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦­ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩάΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ�"
                },
                maciceland: {
                  type: "_sbcs",
                  chars: "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ"
                },
                macroman: {
                  type: "_sbcs",
                  chars: "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ"
                },
                macromania: {
                  type: "_sbcs",
                  chars: "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ĂŞ∞±≤≥¥µ∂∑∏π∫ªºΩăş¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›Ţţ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ"
                },
                macthai: {
                  type: "_sbcs",
                  chars: "«»…“”�•‘’� กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู\uFEFF​–—฿เแโใไๅๆ็่้๊๋์ํ™๏๐๑๒๓๔๕๖๗๘๙®©����"
                },
                macturkish: {
                  type: "_sbcs",
                  chars: "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙ�ˆ˜¯˘˙˚¸˝˛ˇ"
                },
                macukraine: {
                  type: "_sbcs",
                  chars: "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°Ґ£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµґЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю¤"
                },
                koi8r: {
                  type: "_sbcs",
                  chars: "─│┌┐└┘├┤┬┴┼▀▄█▌▐░▒▓⌠■∙√≈≤≥ ⌡°²·÷═║╒ё╓╔╕╖╗╘╙╚╛╜╝╞╟╠╡Ё╢╣╤╥╦╧╨╩╪╫╬©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ"
                },
                koi8u: {
                  type: "_sbcs",
                  chars: "─│┌┐└┘├┤┬┴┼▀▄█▌▐░▒▓⌠■∙√≈≤≥ ⌡°²·÷═║╒ёє╔ії╗╘╙╚╛ґ╝╞╟╠╡ЁЄ╣ІЇ╦╧╨╩╪Ґ╬©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ"
                },
                koi8ru: {
                  type: "_sbcs",
                  chars: "─│┌┐└┘├┤┬┴┼▀▄█▌▐░▒▓⌠■∙√≈≤≥ ⌡°²·÷═║╒ёє╔ії╗╘╙╚╛ґў╞╟╠╡ЁЄ╣ІЇ╦╧╨╩╪ҐЎ©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ"
                },
                koi8t: {
                  type: "_sbcs",
                  chars: "қғ‚Ғ„…†‡�‰ҳ‹ҲҷҶ�Қ‘’“”•–—�™�›�����ӯӮё¤ӣ¦§���«¬­®�°±²Ё�Ӣ¶·�№�»���©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ"
                },
                armscii8: {
                  type: "_sbcs",
                  chars: " �և։)(»«—.՝,-֊…՜՛՞ԱաԲբԳգԴդԵեԶզԷէԸըԹթԺժԻիԼլԽխԾծԿկՀհՁձՂղՃճՄմՅյՆնՇշՈոՉչՊպՋջՌռՍսՎվՏտՐրՑցՒւՓփՔքՕօՖֆ՚�"
                },
                rk1048: {
                  type: "_sbcs",
                  chars: "ЂЃ‚ѓ„…†‡€‰Љ‹ЊҚҺЏђ‘’“”•–—�™љ›њқһџ ҰұӘ¤Ө¦§Ё©Ғ«¬­®Ү°±Ііөµ¶·ё№ғ»әҢңүАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя"
                },
                tcvn: {
                  type: "_sbcs",
                  chars: `\0ÚỤỪỬỮ\x07\b	
\v\f\rỨỰỲỶỸÝỴ\x1B !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_\`abcdefghijklmnopqrstuvwxyz{|}~ÀẢÃÁẠẶẬÈẺẼÉẸỆÌỈĨÍỊÒỎÕÓỌỘỜỞỠỚỢÙỦŨ ĂÂÊÔƠƯĐăâêôơưđẶ̀̀̉̃́àảãáạẲằẳẵắẴẮẦẨẪẤỀặầẩẫấậèỂẻẽéẹềểễếệìỉỄẾỒĩíịòỔỏõóọồổỗốộờởỡớợùỖủũúụừửữứựỳỷỹýỵỐ`
                },
                georgianacademy: {
                  type: "_sbcs",
                  chars: "‚ƒ„…†‡ˆ‰Š‹Œ‘’“”•–—˜™š›œŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿აბგდევზთიკლმნოპჟრსტუფქღყშჩცძწჭხჯჰჱჲჳჴჵჶçèéêëìíîïðñòóôõö÷øùúûüýþÿ"
                },
                georgianps: {
                  type: "_sbcs",
                  chars: "‚ƒ„…†‡ˆ‰Š‹Œ‘’“”•–—˜™š›œŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿აბგდევზჱთიკლმნჲოპჟრსტჳუფქღყშჩცძწჭხჴჯჰჵæçèéêëìíîïðñòóôõö÷øùúûüýþÿ"
                },
                pt154: {
                  type: "_sbcs",
                  chars: "ҖҒӮғ„…ҶҮҲүҠӢҢҚҺҸҗ‘’“”•–—ҳҷҡӣңқһҹ ЎўЈӨҘҰ§Ё©Ә«¬ӯ®Ҝ°ұІіҙө¶·ё№ә»јҪҫҝАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя"
                },
                viscii: {
                  type: "_sbcs",
                  chars: `\0ẲẴẪ\x07\b	
\v\f\rỶỸ\x1BỴ !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_\`abcdefghijklmnopqrstuvwxyz{|}~ẠẮẰẶẤẦẨẬẼẸẾỀỂỄỆỐỒỔỖỘỢỚỜỞỊỎỌỈỦŨỤỲÕắằặấầẩậẽẹếềểễệốồổỗỠƠộờởịỰỨỪỬơớƯÀÁÂÃẢĂẳẵÈÉÊẺÌÍĨỳĐứÒÓÔạỷừửÙÚỹỵÝỡưàáâãảăữẫèéêẻìíĩỉđựòóôõỏọụùúũủýợỮ`
                },
                iso646cn: {
                  type: "_sbcs",
                  chars: `\0\x07\b	
\v\f\r\x1B !"#¥%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_\`abcdefghijklmnopqrstuvwxyz{|}‾��������������������������������������������������������������������������������������������������������������������������������`
                },
                iso646jp: {
                  type: "_sbcs",
                  chars: `\0\x07\b	
\v\f\r\x1B !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[¥]^_\`abcdefghijklmnopqrstuvwxyz{|}‾��������������������������������������������������������������������������������������������������������������������������������`
                },
                hproman8: {
                  type: "_sbcs",
                  chars: " ÀÂÈÊËÎÏ´ˋˆ¨˜ÙÛ₤¯Ýý°ÇçÑñ¡¿¤£¥§ƒ¢âêôûáéóúàèòùäëöüÅîØÆåíøæÄìÖÜÉïßÔÁÃãÐðÍÌÓÒÕõŠšÚŸÿÞþ·µ¶¾—¼½ªº«■»±�"
                },
                macintosh: {
                  type: "_sbcs",
                  chars: "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ"
                },
                ascii: {
                  type: "_sbcs",
                  chars: "��������������������������������������������������������������������������������������������������������������������������������"
                },
                tis620: {
                  type: "_sbcs",
                  chars: "���������������������������������กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����"
                }
              };
            }
          ),
          /***/
          99900: (
            /***/
            function(u) {
              u.exports = {
                // Not supported by iconv, not sure why.
                10029: "maccenteuro",
                maccenteuro: {
                  type: "_sbcs",
                  chars: "ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ"
                },
                808: "cp808",
                ibm808: "cp808",
                cp808: {
                  type: "_sbcs",
                  chars: "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў°∙·√№€■ "
                },
                mik: {
                  type: "_sbcs",
                  chars: "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя└┴┬├─┼╣║╚╔╩╦╠═╬┐░▒▓│┤№§╗╝┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
                },
                cp720: {
                  type: "_sbcs",
                  chars: "éâàçêëèïîّْô¤ـûùءآأؤ£إئابةتثجحخدذرزسشص«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀ضطظعغفµقكلمنهوىي≡ًٌٍَُِ≈°∙·√ⁿ²■ "
                },
                // Aliases of generated encodings.
                ascii8bit: "ascii",
                usascii: "ascii",
                ansix34: "ascii",
                ansix341968: "ascii",
                ansix341986: "ascii",
                csascii: "ascii",
                cp367: "ascii",
                ibm367: "ascii",
                isoir6: "ascii",
                iso646us: "ascii",
                iso646irv: "ascii",
                us: "ascii",
                latin1: "iso88591",
                latin2: "iso88592",
                latin3: "iso88593",
                latin4: "iso88594",
                latin5: "iso88599",
                latin6: "iso885910",
                latin7: "iso885913",
                latin8: "iso885914",
                latin9: "iso885915",
                latin10: "iso885916",
                csisolatin1: "iso88591",
                csisolatin2: "iso88592",
                csisolatin3: "iso88593",
                csisolatin4: "iso88594",
                csisolatincyrillic: "iso88595",
                csisolatinarabic: "iso88596",
                csisolatingreek: "iso88597",
                csisolatinhebrew: "iso88598",
                csisolatin5: "iso88599",
                csisolatin6: "iso885910",
                l1: "iso88591",
                l2: "iso88592",
                l3: "iso88593",
                l4: "iso88594",
                l5: "iso88599",
                l6: "iso885910",
                l7: "iso885913",
                l8: "iso885914",
                l9: "iso885915",
                l10: "iso885916",
                isoir14: "iso646jp",
                isoir57: "iso646cn",
                isoir100: "iso88591",
                isoir101: "iso88592",
                isoir109: "iso88593",
                isoir110: "iso88594",
                isoir144: "iso88595",
                isoir127: "iso88596",
                isoir126: "iso88597",
                isoir138: "iso88598",
                isoir148: "iso88599",
                isoir157: "iso885910",
                isoir166: "tis620",
                isoir179: "iso885913",
                isoir199: "iso885914",
                isoir203: "iso885915",
                isoir226: "iso885916",
                cp819: "iso88591",
                ibm819: "iso88591",
                cyrillic: "iso88595",
                arabic: "iso88596",
                arabic8: "iso88596",
                ecma114: "iso88596",
                asmo708: "iso88596",
                greek: "iso88597",
                greek8: "iso88597",
                ecma118: "iso88597",
                elot928: "iso88597",
                hebrew: "iso88598",
                hebrew8: "iso88598",
                turkish: "iso88599",
                turkish8: "iso88599",
                thai: "iso885911",
                thai8: "iso885911",
                celtic: "iso885914",
                celtic8: "iso885914",
                isoceltic: "iso885914",
                tis6200: "tis620",
                tis62025291: "tis620",
                tis62025330: "tis620",
                1e4: "macroman",
                10006: "macgreek",
                10007: "maccyrillic",
                10079: "maciceland",
                10081: "macturkish",
                cspc8codepage437: "cp437",
                cspc775baltic: "cp775",
                cspc850multilingual: "cp850",
                cspcp852: "cp852",
                cspc862latinhebrew: "cp862",
                cpgr: "cp869",
                msee: "cp1250",
                mscyrl: "cp1251",
                msansi: "cp1252",
                msgreek: "cp1253",
                msturk: "cp1254",
                mshebr: "cp1255",
                msarab: "cp1256",
                winbaltrim: "cp1257",
                cp20866: "koi8r",
                20866: "koi8r",
                ibm878: "koi8r",
                cskoi8r: "koi8r",
                cp21866: "koi8u",
                21866: "koi8u",
                ibm1168: "koi8u",
                strk10482002: "rk1048",
                tcvn5712: "tcvn",
                tcvn57121: "tcvn",
                gb198880: "iso646cn",
                cn: "iso646cn",
                csiso14jisc6220ro: "iso646jp",
                jisc62201969ro: "iso646jp",
                jp: "iso646jp",
                cshproman8: "hproman8",
                r8: "hproman8",
                roman8: "hproman8",
                xroman8: "hproman8",
                ibm1051: "hproman8",
                mac: "macintosh",
                csmacintosh: "macintosh"
              };
            }
          ),
          /***/
          17100: (
            /***/
            function(u, l, e) {
              var s = e(16696).Buffer;
              l.utf16be = i;
              function i() {
              }
              i.prototype.encoder = f, i.prototype.decoder = h, i.prototype.bomAware = !0;
              function f() {
              }
              f.prototype.write = function(g) {
                for (var S = s.from(g, "ucs2"), y = 0; y < S.length; y += 2) {
                  var b = S[y];
                  S[y] = S[y + 1], S[y + 1] = b;
                }
                return S;
              }, f.prototype.end = function() {
              };
              function h() {
                this.overflowByte = -1;
              }
              h.prototype.write = function(g) {
                if (g.length == 0)
                  return "";
                var S = s.alloc(g.length + 1), y = 0, b = 0;
                for (this.overflowByte !== -1 && (S[0] = g[0], S[1] = this.overflowByte, y = 1, b = 2); y < g.length - 1; y += 2, b += 2)
                  S[b] = g[y + 1], S[b + 1] = g[y];
                return this.overflowByte = y == g.length - 1 ? g[g.length - 1] : -1, S.slice(0, b).toString("ucs2");
              }, h.prototype.end = function() {
                this.overflowByte = -1;
              }, l.utf16 = v;
              function v(g, S) {
                this.iconv = S;
              }
              v.prototype.encoder = p, v.prototype.decoder = m;
              function p(g, S) {
                g = g || {}, g.addBOM === void 0 && (g.addBOM = !0), this.encoder = S.iconv.getEncoder("utf-16le", g);
              }
              p.prototype.write = function(g) {
                return this.encoder.write(g);
              }, p.prototype.end = function() {
                return this.encoder.end();
              };
              function m(g, S) {
                this.decoder = null, this.initialBufs = [], this.initialBufsLen = 0, this.options = g || {}, this.iconv = S.iconv;
              }
              m.prototype.write = function(g) {
                if (!this.decoder) {
                  if (this.initialBufs.push(g), this.initialBufsLen += g.length, this.initialBufsLen < 16)
                    return "";
                  var S = x(this.initialBufs, this.options.defaultEncoding);
                  this.decoder = this.iconv.getDecoder(S, this.options);
                  for (var y = "", b = 0; b < this.initialBufs.length; b++)
                    y += this.decoder.write(this.initialBufs[b]);
                  return this.initialBufs.length = this.initialBufsLen = 0, y;
                }
                return this.decoder.write(g);
              }, m.prototype.end = function() {
                if (!this.decoder) {
                  var g = x(this.initialBufs, this.options.defaultEncoding);
                  this.decoder = this.iconv.getDecoder(g, this.options);
                  for (var S = "", y = 0; y < this.initialBufs.length; y++)
                    S += this.decoder.write(this.initialBufs[y]);
                  var b = this.decoder.end();
                  return b && (S += b), this.initialBufs.length = this.initialBufsLen = 0, S;
                }
                return this.decoder.end();
              };
              function x(g, S) {
                var y = [], b = 0, n = 0, w = 0;
                t:
                  for (var E = 0; E < g.length; E++)
                    for (var A = g[E], O = 0; O < A.length; O++)
                      if (y.push(A[O]), y.length === 2) {
                        if (b === 0) {
                          if (y[0] === 255 && y[1] === 254)
                            return "utf-16le";
                          if (y[0] === 254 && y[1] === 255)
                            return "utf-16be";
                        }
                        if (y[0] === 0 && y[1] !== 0 && w++, y[0] !== 0 && y[1] === 0 && n++, y.length = 0, b++, b >= 100)
                          break t;
                      }
                return w > n ? "utf-16be" : w < n ? "utf-16le" : S || "utf-16le";
              }
            }
          ),
          /***/
          24162: (
            /***/
            function(u, l, e) {
              var s = e(16696).Buffer;
              l._utf32 = i;
              function i(S, y) {
                this.iconv = y, this.bomAware = !0, this.isLE = S.isLE;
              }
              l.utf32le = { type: "_utf32", isLE: !0 }, l.utf32be = { type: "_utf32", isLE: !1 }, l.ucs4le = "utf32le", l.ucs4be = "utf32be", i.prototype.encoder = f, i.prototype.decoder = h;
              function f(S, y) {
                this.isLE = y.isLE, this.highSurrogate = 0;
              }
              f.prototype.write = function(S) {
                for (var y = s.from(S, "ucs2"), b = s.alloc(y.length * 2), n = this.isLE ? b.writeUInt32LE : b.writeUInt32BE, w = 0, E = 0; E < y.length; E += 2) {
                  var A = y.readUInt16LE(E), O = 55296 <= A && A < 56320, C = 56320 <= A && A < 57344;
                  if (this.highSurrogate)
                    if (O || !C)
                      n.call(b, this.highSurrogate, w), w += 4;
                    else {
                      var T = (this.highSurrogate - 55296 << 10 | A - 56320) + 65536;
                      n.call(b, T, w), w += 4, this.highSurrogate = 0;
                      continue;
                    }
                  O ? this.highSurrogate = A : (n.call(b, A, w), w += 4, this.highSurrogate = 0);
                }
                return w < b.length && (b = b.slice(0, w)), b;
              }, f.prototype.end = function() {
                if (this.highSurrogate) {
                  var S = s.alloc(4);
                  return this.isLE ? S.writeUInt32LE(this.highSurrogate, 0) : S.writeUInt32BE(this.highSurrogate, 0), this.highSurrogate = 0, S;
                }
              };
              function h(S, y) {
                this.isLE = y.isLE, this.badChar = y.iconv.defaultCharUnicode.charCodeAt(0), this.overflow = [];
              }
              h.prototype.write = function(S) {
                if (S.length === 0)
                  return "";
                var y = 0, b = 0, n = s.alloc(S.length + 4), w = 0, E = this.isLE, A = this.overflow, O = this.badChar;
                if (A.length > 0) {
                  for (; y < S.length && A.length < 4; y++)
                    A.push(S[y]);
                  A.length === 4 && (E ? b = A[y] | A[y + 1] << 8 | A[y + 2] << 16 | A[y + 3] << 24 : b = A[y + 3] | A[y + 2] << 8 | A[y + 1] << 16 | A[y] << 24, A.length = 0, w = v(n, w, b, O));
                }
                for (; y < S.length - 3; y += 4)
                  E ? b = S[y] | S[y + 1] << 8 | S[y + 2] << 16 | S[y + 3] << 24 : b = S[y + 3] | S[y + 2] << 8 | S[y + 1] << 16 | S[y] << 24, w = v(n, w, b, O);
                for (; y < S.length; y++)
                  A.push(S[y]);
                return n.slice(0, w).toString("ucs2");
              };
              function v(S, y, b, n) {
                if ((b < 0 || b > 1114111) && (b = n), b >= 65536) {
                  b -= 65536;
                  var w = 55296 | b >> 10;
                  S[y++] = w & 255, S[y++] = w >> 8;
                  var b = 56320 | b & 1023;
                }
                return S[y++] = b & 255, S[y++] = b >> 8, y;
              }
              h.prototype.end = function() {
                this.overflow.length = 0;
              }, l.utf32 = p, l.ucs4 = "utf32";
              function p(S, y) {
                this.iconv = y;
              }
              p.prototype.encoder = m, p.prototype.decoder = x;
              function m(S, y) {
                S = S || {}, S.addBOM === void 0 && (S.addBOM = !0), this.encoder = y.iconv.getEncoder(S.defaultEncoding || "utf-32le", S);
              }
              m.prototype.write = function(S) {
                return this.encoder.write(S);
              }, m.prototype.end = function() {
                return this.encoder.end();
              };
              function x(S, y) {
                this.decoder = null, this.initialBufs = [], this.initialBufsLen = 0, this.options = S || {}, this.iconv = y.iconv;
              }
              x.prototype.write = function(S) {
                if (!this.decoder) {
                  if (this.initialBufs.push(S), this.initialBufsLen += S.length, this.initialBufsLen < 32)
                    return "";
                  var y = g(this.initialBufs, this.options.defaultEncoding);
                  this.decoder = this.iconv.getDecoder(y, this.options);
                  for (var b = "", n = 0; n < this.initialBufs.length; n++)
                    b += this.decoder.write(this.initialBufs[n]);
                  return this.initialBufs.length = this.initialBufsLen = 0, b;
                }
                return this.decoder.write(S);
              }, x.prototype.end = function() {
                if (!this.decoder) {
                  var S = g(this.initialBufs, this.options.defaultEncoding);
                  this.decoder = this.iconv.getDecoder(S, this.options);
                  for (var y = "", b = 0; b < this.initialBufs.length; b++)
                    y += this.decoder.write(this.initialBufs[b]);
                  var n = this.decoder.end();
                  return n && (y += n), this.initialBufs.length = this.initialBufsLen = 0, y;
                }
                return this.decoder.end();
              };
              function g(S, y) {
                var b = [], n = 0, w = 0, E = 0, A = 0, O = 0;
                t:
                  for (var C = 0; C < S.length; C++)
                    for (var T = S[C], P = 0; P < T.length; P++)
                      if (b.push(T[P]), b.length === 4) {
                        if (n === 0) {
                          if (b[0] === 255 && b[1] === 254 && b[2] === 0 && b[3] === 0)
                            return "utf-32le";
                          if (b[0] === 0 && b[1] === 0 && b[2] === 254 && b[3] === 255)
                            return "utf-32be";
                        }
                        if ((b[0] !== 0 || b[1] > 16) && E++, (b[3] !== 0 || b[2] > 16) && w++, b[0] === 0 && b[1] === 0 && (b[2] !== 0 || b[3] !== 0) && O++, (b[0] !== 0 || b[1] !== 0) && b[2] === 0 && b[3] === 0 && A++, b.length = 0, n++, n >= 100)
                          break t;
                      }
                return O - E > A - w ? "utf-32be" : O - E < A - w ? "utf-32le" : y || "utf-32le";
              }
            }
          ),
          /***/
          11326: (
            /***/
            function(u, l, e) {
              var s = e(16696).Buffer;
              l.utf7 = i, l.unicode11utf7 = "utf7";
              function i(A, O) {
                this.iconv = O;
              }
              i.prototype.encoder = h, i.prototype.decoder = v, i.prototype.bomAware = !0;
              var f = /[^A-Za-z0-9'\(\),-\.\/:\? \n\r\t]+/g;
              function h(A, O) {
                this.iconv = O.iconv;
              }
              h.prototype.write = function(A) {
                return s.from(A.replace(f, (function(O) {
                  return "+" + (O === "+" ? "" : this.iconv.encode(O, "utf16-be").toString("base64").replace(/=+$/, "")) + "-";
                }).bind(this)));
              }, h.prototype.end = function() {
              };
              function v(A, O) {
                this.iconv = O.iconv, this.inBase64 = !1, this.base64Accum = "";
              }
              for (var p = /[A-Za-z0-9\/+]/, m = [], x = 0; x < 256; x++)
                m[x] = p.test(String.fromCharCode(x));
              var g = "+".charCodeAt(0), S = "-".charCodeAt(0), y = "&".charCodeAt(0);
              v.prototype.write = function(A) {
                for (var O = "", C = 0, T = this.inBase64, P = this.base64Accum, I = 0; I < A.length; I++)
                  if (!T)
                    A[I] == g && (O += this.iconv.decode(A.slice(C, I), "ascii"), C = I + 1, T = !0);
                  else if (!m[A[I]]) {
                    if (I == C && A[I] == S)
                      O += "+";
                    else {
                      var F = P + this.iconv.decode(A.slice(C, I), "ascii");
                      O += this.iconv.decode(s.from(F, "base64"), "utf16-be");
                    }
                    A[I] != S && I--, C = I + 1, T = !1, P = "";
                  }
                if (!T)
                  O += this.iconv.decode(A.slice(C), "ascii");
                else {
                  var F = P + this.iconv.decode(A.slice(C), "ascii"), B = F.length - F.length % 8;
                  P = F.slice(B), F = F.slice(0, B), O += this.iconv.decode(s.from(F, "base64"), "utf16-be");
                }
                return this.inBase64 = T, this.base64Accum = P, O;
              }, v.prototype.end = function() {
                var A = "";
                return this.inBase64 && this.base64Accum.length > 0 && (A = this.iconv.decode(s.from(this.base64Accum, "base64"), "utf16-be")), this.inBase64 = !1, this.base64Accum = "", A;
              }, l.utf7imap = b;
              function b(A, O) {
                this.iconv = O;
              }
              b.prototype.encoder = n, b.prototype.decoder = w, b.prototype.bomAware = !0;
              function n(A, O) {
                this.iconv = O.iconv, this.inBase64 = !1, this.base64Accum = s.alloc(6), this.base64AccumIdx = 0;
              }
              n.prototype.write = function(A) {
                for (var O = this.inBase64, C = this.base64Accum, T = this.base64AccumIdx, P = s.alloc(A.length * 5 + 10), I = 0, F = 0; F < A.length; F++) {
                  var B = A.charCodeAt(F);
                  32 <= B && B <= 126 ? (O && (T > 0 && (I += P.write(C.slice(0, T).toString("base64").replace(/\//g, ",").replace(/=+$/, ""), I), T = 0), P[I++] = S, O = !1), O || (P[I++] = B, B === y && (P[I++] = S))) : (O || (P[I++] = y, O = !0), O && (C[T++] = B >> 8, C[T++] = B & 255, T == C.length && (I += P.write(C.toString("base64").replace(/\//g, ","), I), T = 0)));
                }
                return this.inBase64 = O, this.base64AccumIdx = T, P.slice(0, I);
              }, n.prototype.end = function() {
                var A = s.alloc(10), O = 0;
                return this.inBase64 && (this.base64AccumIdx > 0 && (O += A.write(this.base64Accum.slice(0, this.base64AccumIdx).toString("base64").replace(/\//g, ",").replace(/=+$/, ""), O), this.base64AccumIdx = 0), A[O++] = S, this.inBase64 = !1), A.slice(0, O);
              };
              function w(A, O) {
                this.iconv = O.iconv, this.inBase64 = !1, this.base64Accum = "";
              }
              var E = m.slice();
              E[",".charCodeAt(0)] = !0, w.prototype.write = function(A) {
                for (var O = "", C = 0, T = this.inBase64, P = this.base64Accum, I = 0; I < A.length; I++)
                  if (!T)
                    A[I] == y && (O += this.iconv.decode(A.slice(C, I), "ascii"), C = I + 1, T = !0);
                  else if (!E[A[I]]) {
                    if (I == C && A[I] == S)
                      O += "&";
                    else {
                      var F = P + this.iconv.decode(A.slice(C, I), "ascii").replace(/,/g, "/");
                      O += this.iconv.decode(s.from(F, "base64"), "utf16-be");
                    }
                    A[I] != S && I--, C = I + 1, T = !1, P = "";
                  }
                if (!T)
                  O += this.iconv.decode(A.slice(C), "ascii");
                else {
                  var F = P + this.iconv.decode(A.slice(C), "ascii").replace(/,/g, "/"), B = F.length - F.length % 8;
                  P = F.slice(B), F = F.slice(0, B), O += this.iconv.decode(s.from(F, "base64"), "utf16-be");
                }
                return this.inBase64 = T, this.base64Accum = P, O;
              }, w.prototype.end = function() {
                var A = "";
                return this.inBase64 && this.base64Accum.length > 0 && (A = this.iconv.decode(s.from(this.base64Accum, "base64"), "utf16-be")), this.inBase64 = !1, this.base64Accum = "", A;
              };
            }
          ),
          /***/
          52331: (
            /***/
            function(u, l) {
              var e = "\uFEFF";
              l.PrependBOM = s;
              function s(f, h) {
                this.encoder = f, this.addBOM = !0;
              }
              s.prototype.write = function(f) {
                return this.addBOM && (f = e + f, this.addBOM = !1), this.encoder.write(f);
              }, s.prototype.end = function() {
                return this.encoder.end();
              }, l.StripBOM = i;
              function i(f, h) {
                this.decoder = f, this.pass = !1, this.options = h || {};
              }
              i.prototype.write = function(f) {
                var h = this.decoder.write(f);
                return this.pass || !h || (h[0] === e && (h = h.slice(1), typeof this.options.stripBOM == "function" && this.options.stripBOM()), this.pass = !0), h;
              }, i.prototype.end = function() {
                return this.decoder.end();
              };
            }
          ),
          /***/
          54171: (
            /***/
            function(u, l, e) {
              var s = e(16696).Buffer, i = e(52331), f = u.exports;
              f.encodings = null, f.defaultCharUnicode = "�", f.defaultCharSingleByte = "?", f.encode = function(p, m, x) {
                p = "" + (p || "");
                var g = f.getEncoder(m, x), S = g.write(p), y = g.end();
                return y && y.length > 0 ? s.concat([S, y]) : S;
              }, f.decode = function(p, m, x) {
                typeof p == "string" && (f.skipDecodeWarning || (console.error("Iconv-lite warning: decode()-ing strings is deprecated. Refer to https://github.com/ashtuchkin/iconv-lite/wiki/Use-Buffers-when-decoding"), f.skipDecodeWarning = !0), p = s.from("" + (p || ""), "binary"));
                var g = f.getDecoder(m, x), S = g.write(p), y = g.end();
                return y ? S + y : S;
              }, f.encodingExists = function(p) {
                try {
                  return f.getCodec(p), !0;
                } catch {
                  return !1;
                }
              }, f.toEncoding = f.encode, f.fromEncoding = f.decode, f._codecDataCache = {}, f.getCodec = function(p) {
                f.encodings || (f.encodings = e(26326));
                for (var m = f._canonicalizeEncoding(p), x = {}; ; ) {
                  var g = f._codecDataCache[m];
                  if (g)
                    return g;
                  var S = f.encodings[m];
                  switch (typeof S) {
                    case "string":
                      m = S;
                      break;
                    case "object":
                      for (var y in S)
                        x[y] = S[y];
                      x.encodingName || (x.encodingName = m), m = S.type;
                      break;
                    case "function":
                      return x.encodingName || (x.encodingName = m), g = new S(x, f), f._codecDataCache[x.encodingName] = g, g;
                    default:
                      throw new Error("Encoding not recognized: '" + p + "' (searched as: '" + m + "')");
                  }
                }
              }, f._canonicalizeEncoding = function(v) {
                return ("" + v).toLowerCase().replace(/:\d{4}$|[^0-9a-z]/g, "");
              }, f.getEncoder = function(p, m) {
                var x = f.getCodec(p), g = new x.encoder(m, x);
                return x.bomAware && m && m.addBOM && (g = new i.PrependBOM(g, m)), g;
              }, f.getDecoder = function(p, m) {
                var x = f.getCodec(p), g = new x.decoder(m, x);
                return x.bomAware && !(m && m.stripBOM === !1) && (g = new i.StripBOM(g, m)), g;
              }, f.enableStreamingAPI = function(p) {
                if (!f.supportsStreams) {
                  var m = e(34506)(p);
                  f.IconvLiteEncoderStream = m.IconvLiteEncoderStream, f.IconvLiteDecoderStream = m.IconvLiteDecoderStream, f.encodeStream = function(g, S) {
                    return new f.IconvLiteEncoderStream(f.getEncoder(g, S), S);
                  }, f.decodeStream = function(g, S) {
                    return new f.IconvLiteDecoderStream(f.getDecoder(g, S), S);
                  }, f.supportsStreams = !0;
                }
              };
              var h;
              try {
                h = e(16403);
              } catch {
              }
              h && h.Transform ? f.enableStreamingAPI(h) : f.encodeStream = f.decodeStream = function() {
                throw new Error("iconv-lite Streaming API is not enabled. Use iconv.enableStreamingAPI(require('stream')); to enable it.");
              };
            }
          ),
          /***/
          34506: (
            /***/
            function(u, l, e) {
              var s = e(16696).Buffer;
              u.exports = function(i) {
                var f = i.Transform;
                function h(p, m) {
                  this.conv = p, m = m || {}, m.decodeStrings = !1, f.call(this, m);
                }
                h.prototype = Object.create(f.prototype, {
                  constructor: { value: h }
                }), h.prototype._transform = function(p, m, x) {
                  if (typeof p != "string")
                    return x(new Error("Iconv encoding stream needs strings as its input."));
                  try {
                    var g = this.conv.write(p);
                    g && g.length && this.push(g), x();
                  } catch (S) {
                    x(S);
                  }
                }, h.prototype._flush = function(p) {
                  try {
                    var m = this.conv.end();
                    m && m.length && this.push(m), p();
                  } catch (x) {
                    p(x);
                  }
                }, h.prototype.collect = function(p) {
                  var m = [];
                  return this.on("error", p), this.on("data", function(x) {
                    m.push(x);
                  }), this.on("end", function() {
                    p(null, s.concat(m));
                  }), this;
                };
                function v(p, m) {
                  this.conv = p, m = m || {}, m.encoding = this.encoding = "utf8", f.call(this, m);
                }
                return v.prototype = Object.create(f.prototype, {
                  constructor: { value: v }
                }), v.prototype._transform = function(p, m, x) {
                  if (!s.isBuffer(p) && !(p instanceof Uint8Array))
                    return x(new Error("Iconv decoding stream needs buffers as its input."));
                  try {
                    var g = this.conv.write(p);
                    g && g.length && this.push(g, this.encoding), x();
                  } catch (S) {
                    x(S);
                  }
                }, v.prototype._flush = function(p) {
                  try {
                    var m = this.conv.end();
                    m && m.length && this.push(m, this.encoding), p();
                  } catch (x) {
                    p(x);
                  }
                }, v.prototype.collect = function(p) {
                  var m = "";
                  return this.on("error", p), this.on("data", function(x) {
                    m += x;
                  }), this.on("end", function() {
                    p(null, m);
                  }), this;
                }, {
                  IconvLiteEncoderStream: h,
                  IconvLiteDecoderStream: v
                };
              };
            }
          ),
          /***/
          89029: (
            /***/
            function(u, l) {
              /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
              l.read = function(e, s, i, f, h) {
                var v, p, m = h * 8 - f - 1, x = (1 << m) - 1, g = x >> 1, S = -7, y = i ? h - 1 : 0, b = i ? -1 : 1, n = e[s + y];
                for (y += b, v = n & (1 << -S) - 1, n >>= -S, S += m; S > 0; v = v * 256 + e[s + y], y += b, S -= 8)
                  ;
                for (p = v & (1 << -S) - 1, v >>= -S, S += f; S > 0; p = p * 256 + e[s + y], y += b, S -= 8)
                  ;
                if (v === 0)
                  v = 1 - g;
                else {
                  if (v === x)
                    return p ? NaN : (n ? -1 : 1) * (1 / 0);
                  p = p + Math.pow(2, f), v = v - g;
                }
                return (n ? -1 : 1) * p * Math.pow(2, v - f);
              }, l.write = function(e, s, i, f, h, v) {
                var p, m, x, g = v * 8 - h - 1, S = (1 << g) - 1, y = S >> 1, b = h === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, n = f ? 0 : v - 1, w = f ? 1 : -1, E = s < 0 || s === 0 && 1 / s < 0 ? 1 : 0;
                for (s = Math.abs(s), isNaN(s) || s === 1 / 0 ? (m = isNaN(s) ? 1 : 0, p = S) : (p = Math.floor(Math.log(s) / Math.LN2), s * (x = Math.pow(2, -p)) < 1 && (p--, x *= 2), p + y >= 1 ? s += b / x : s += b * Math.pow(2, 1 - y), s * x >= 2 && (p++, x /= 2), p + y >= S ? (m = 0, p = S) : p + y >= 1 ? (m = (s * x - 1) * Math.pow(2, h), p = p + y) : (m = s * Math.pow(2, y - 1) * Math.pow(2, h), p = 0)); h >= 8; e[i + n] = m & 255, n += w, m /= 256, h -= 8)
                  ;
                for (p = p << h | m, g += h; g > 0; e[i + n] = p & 255, n += w, p /= 256, g -= 8)
                  ;
                e[i + n - w] |= E * 128;
              };
            }
          ),
          /***/
          89784: (
            /***/
            function(u) {
              typeof Object.create == "function" ? u.exports = function(e, s) {
                s && (e.super_ = s, e.prototype = Object.create(s.prototype, {
                  constructor: {
                    value: e,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                  }
                }));
              } : u.exports = function(e, s) {
                if (s) {
                  e.super_ = s;
                  var i = function() {
                  };
                  i.prototype = s.prototype, e.prototype = new i(), e.prototype.constructor = e;
                }
              };
            }
          ),
          /***/
          67906: (
            /***/
            function(u, l, e) {
              var s = e(26626)(), i = e(67913), f = i("Object.prototype.toString"), h = function(x) {
                return s && x && typeof x == "object" && Symbol.toStringTag in x ? !1 : f(x) === "[object Arguments]";
              }, v = function(x) {
                return h(x) ? !0 : x !== null && typeof x == "object" && typeof x.length == "number" && x.length >= 0 && f(x) !== "[object Array]" && f(x.callee) === "[object Function]";
              }, p = function() {
                return h(arguments);
              }();
              h.isLegacyArguments = v, u.exports = p ? h : v;
            }
          ),
          /***/
          3746: (
            /***/
            function(u) {
              var l = Function.prototype.toString, e = typeof Reflect == "object" && Reflect !== null && Reflect.apply, s, i;
              if (typeof e == "function" && typeof Object.defineProperty == "function")
                try {
                  s = Object.defineProperty({}, "length", {
                    get: function() {
                      throw i;
                    }
                  }), i = {}, e(function() {
                    throw 42;
                  }, null, s);
                } catch (O) {
                  O !== i && (e = null);
                }
              else
                e = null;
              var f = /^\s*class\b/, h = function(C) {
                try {
                  var T = l.call(C);
                  return f.test(T);
                } catch {
                  return !1;
                }
              }, v = function(C) {
                try {
                  return h(C) ? !1 : (l.call(C), !0);
                } catch {
                  return !1;
                }
              }, p = Object.prototype.toString, m = "[object Object]", x = "[object Function]", g = "[object GeneratorFunction]", S = "[object HTMLAllCollection]", y = "[object HTML document.all class]", b = "[object HTMLCollection]", n = typeof Symbol == "function" && !!Symbol.toStringTag, w = !(0 in [,]), E = function() {
                return !1;
              };
              if (typeof document == "object") {
                var A = document.all;
                p.call(A) === p.call(document.all) && (E = function(C) {
                  if ((w || !C) && (typeof C > "u" || typeof C == "object"))
                    try {
                      var T = p.call(C);
                      return (T === S || T === y || T === b || T === m) && C("") == null;
                    } catch {
                    }
                  return !1;
                });
              }
              u.exports = e ? function(C) {
                if (E(C))
                  return !0;
                if (!C || typeof C != "function" && typeof C != "object")
                  return !1;
                try {
                  e(C, null, s);
                } catch (T) {
                  if (T !== i)
                    return !1;
                }
                return !h(C) && v(C);
              } : function(C) {
                if (E(C))
                  return !0;
                if (!C || typeof C != "function" && typeof C != "object")
                  return !1;
                if (n)
                  return v(C);
                if (h(C))
                  return !1;
                var T = p.call(C);
                return T !== x && T !== g && !/^\[object HTML/.test(T) ? !1 : v(C);
              };
            }
          ),
          /***/
          71230: (
            /***/
            function(u, l, e) {
              var s = Date.prototype.getDay, i = function(m) {
                try {
                  return s.call(m), !0;
                } catch {
                  return !1;
                }
              }, f = Object.prototype.toString, h = "[object Date]", v = e(26626)();
              u.exports = function(m) {
                return typeof m != "object" || m === null ? !1 : v ? i(m) : f.call(m) === h;
              };
            }
          ),
          /***/
          44610: (
            /***/
            function(u, l, e) {
              var s = Object.prototype.toString, i = Function.prototype.toString, f = /^\s*(?:function)?\*/, h = e(26626)(), v = Object.getPrototypeOf, p = function() {
                if (!h)
                  return !1;
                try {
                  return Function("return function*() {}")();
                } catch {
                }
              }, m;
              u.exports = function(g) {
                if (typeof g != "function")
                  return !1;
                if (f.test(i.call(g)))
                  return !0;
                if (!h) {
                  var S = s.call(g);
                  return S === "[object GeneratorFunction]";
                }
                if (!v)
                  return !1;
                if (typeof m > "u") {
                  var y = p();
                  m = y ? v(y) : !1;
                }
                return v(g) === m;
              };
            }
          ),
          /***/
          82621: (
            /***/
            function(u) {
              u.exports = function(e) {
                return e !== e;
              };
            }
          ),
          /***/
          7051: (
            /***/
            function(u, l, e) {
              var s = e(26601), i = e(77802), f = e(82621), h = e(61320), v = e(35074), p = s(h(), Number);
              i(p, {
                getPolyfill: h,
                implementation: f,
                shim: v
              }), u.exports = p;
            }
          ),
          /***/
          61320: (
            /***/
            function(u, l, e) {
              var s = e(82621);
              u.exports = function() {
                return Number.isNaN && Number.isNaN(NaN) && !Number.isNaN("a") ? Number.isNaN : s;
              };
            }
          ),
          /***/
          35074: (
            /***/
            function(u, l, e) {
              var s = e(77802), i = e(61320);
              u.exports = function() {
                var h = i();
                return s(Number, { isNaN: h }, {
                  isNaN: function() {
                    return Number.isNaN !== h;
                  }
                }), h;
              };
            }
          ),
          /***/
          71689: (
            /***/
            function(u, l, e) {
              var s = e(67913), i = e(26626)(), f, h, v, p;
              if (i) {
                f = s("Object.prototype.hasOwnProperty"), h = s("RegExp.prototype.exec"), v = {};
                var m = function() {
                  throw v;
                };
                p = {
                  toString: m,
                  valueOf: m
                }, typeof Symbol.toPrimitive == "symbol" && (p[Symbol.toPrimitive] = m);
              }
              var x = s("Object.prototype.toString"), g = Object.getOwnPropertyDescriptor, S = "[object RegExp]";
              u.exports = i ? function(b) {
                if (!b || typeof b != "object")
                  return !1;
                var n = g(b, "lastIndex"), w = n && f(n, "value");
                if (!w)
                  return !1;
                try {
                  h(b, p);
                } catch (E) {
                  return E === v;
                }
              } : function(b) {
                return !b || typeof b != "object" && typeof b != "function" ? !1 : x(b) === S;
              };
            }
          ),
          /***/
          46094: (
            /***/
            function(u, l, e) {
              var s = e(43381);
              u.exports = function(f) {
                return !!s(f);
              };
            }
          ),
          /***/
          63249: (
            /***/
            function(u) {
              var l = function(e) {
                return e !== e;
              };
              u.exports = function(s, i) {
                return s === 0 && i === 0 ? 1 / s === 1 / i : !!(s === i || l(s) && l(i));
              };
            }
          ),
          /***/
          98527: (
            /***/
            function(u, l, e) {
              var s = e(77802), i = e(26601), f = e(63249), h = e(89636), v = e(3534), p = i(h(), Object);
              s(p, {
                getPolyfill: h,
                implementation: f,
                shim: v
              }), u.exports = p;
            }
          ),
          /***/
          89636: (
            /***/
            function(u, l, e) {
              var s = e(63249);
              u.exports = function() {
                return typeof Object.is == "function" ? Object.is : s;
              };
            }
          ),
          /***/
          3534: (
            /***/
            function(u, l, e) {
              var s = e(89636), i = e(77802);
              u.exports = function() {
                var h = s();
                return i(Object, { is: h }, {
                  is: function() {
                    return Object.is !== h;
                  }
                }), h;
              };
            }
          ),
          /***/
          48461: (
            /***/
            function(u, l, e) {
              var s;
              if (!Object.keys) {
                var i = Object.prototype.hasOwnProperty, f = Object.prototype.toString, h = e(76515), v = Object.prototype.propertyIsEnumerable, p = !v.call({ toString: null }, "toString"), m = v.call(function() {
                }, "prototype"), x = [
                  "toString",
                  "toLocaleString",
                  "valueOf",
                  "hasOwnProperty",
                  "isPrototypeOf",
                  "propertyIsEnumerable",
                  "constructor"
                ], g = function(n) {
                  var w = n.constructor;
                  return w && w.prototype === n;
                }, S = {
                  $applicationCache: !0,
                  $console: !0,
                  $external: !0,
                  $frame: !0,
                  $frameElement: !0,
                  $frames: !0,
                  $innerHeight: !0,
                  $innerWidth: !0,
                  $onmozfullscreenchange: !0,
                  $onmozfullscreenerror: !0,
                  $outerHeight: !0,
                  $outerWidth: !0,
                  $pageXOffset: !0,
                  $pageYOffset: !0,
                  $parent: !0,
                  $scrollLeft: !0,
                  $scrollTop: !0,
                  $scrollX: !0,
                  $scrollY: !0,
                  $self: !0,
                  $webkitIndexedDB: !0,
                  $webkitStorageInfo: !0,
                  $window: !0
                }, y = function() {
                  if (typeof window > "u")
                    return !1;
                  for (var n in window)
                    try {
                      if (!S["$" + n] && i.call(window, n) && window[n] !== null && typeof window[n] == "object")
                        try {
                          g(window[n]);
                        } catch {
                          return !0;
                        }
                    } catch {
                      return !0;
                    }
                  return !1;
                }(), b = function(n) {
                  if (typeof window > "u" || !y)
                    return g(n);
                  try {
                    return g(n);
                  } catch {
                    return !1;
                  }
                };
                s = function(w) {
                  var E = w !== null && typeof w == "object", A = f.call(w) === "[object Function]", O = h(w), C = E && f.call(w) === "[object String]", T = [];
                  if (!E && !A && !O)
                    throw new TypeError("Object.keys called on a non-object");
                  var P = m && A;
                  if (C && w.length > 0 && !i.call(w, 0))
                    for (var I = 0; I < w.length; ++I)
                      T.push(String(I));
                  if (O && w.length > 0)
                    for (var F = 0; F < w.length; ++F)
                      T.push(String(F));
                  else
                    for (var B in w)
                      !(P && B === "prototype") && i.call(w, B) && T.push(String(B));
                  if (p)
                    for (var M = b(w), z = 0; z < x.length; ++z)
                      !(M && x[z] === "constructor") && i.call(w, x[z]) && T.push(x[z]);
                  return T;
                };
              }
              u.exports = s;
            }
          ),
          /***/
          35643: (
            /***/
            function(u, l, e) {
              var s = Array.prototype.slice, i = e(76515), f = Object.keys, h = f ? function(m) {
                return f(m);
              } : e(48461), v = Object.keys;
              h.shim = function() {
                if (Object.keys) {
                  var m = function() {
                    var x = Object.keys(arguments);
                    return x && x.length === arguments.length;
                  }(1, 2);
                  m || (Object.keys = function(g) {
                    return i(g) ? v(s.call(g)) : v(g);
                  });
                } else
                  Object.keys = h;
                return Object.keys || h;
              }, u.exports = h;
            }
          ),
          /***/
          76515: (
            /***/
            function(u) {
              var l = Object.prototype.toString;
              u.exports = function(s) {
                var i = l.call(s), f = i === "[object Arguments]";
                return f || (f = i !== "[object Array]" && s !== null && typeof s == "object" && typeof s.length == "number" && s.length >= 0 && l.call(s.callee) === "[object Function]"), f;
              };
            }
          ),
          /***/
          36521: (
            /***/
            function(u, l, e) {
              var s = e(35643), i = e(12843)(), f = e(67913), h = Object, v = f("Array.prototype.push"), p = f("Object.prototype.propertyIsEnumerable"), m = i ? Object.getOwnPropertySymbols : null;
              u.exports = function(g, S) {
                if (g == null)
                  throw new TypeError("target must be an object");
                var y = h(g);
                if (arguments.length === 1)
                  return y;
                for (var b = 1; b < arguments.length; ++b) {
                  var n = h(arguments[b]), w = s(n), E = i && (Object.getOwnPropertySymbols || m);
                  if (E)
                    for (var A = E(n), O = 0; O < A.length; ++O) {
                      var C = A[O];
                      p(n, C) && v(w, C);
                    }
                  for (var T = 0; T < w.length; ++T) {
                    var P = w[T];
                    if (p(n, P)) {
                      var I = n[P];
                      y[P] = I;
                    }
                  }
                }
                return y;
              };
            }
          ),
          /***/
          37596: (
            /***/
            function(u, l, e) {
              var s = e(36521), i = function() {
                if (!Object.assign)
                  return !1;
                for (var h = "abcdefghijklmnopqrst", v = h.split(""), p = {}, m = 0; m < v.length; ++m)
                  p[v[m]] = v[m];
                var x = Object.assign({}, p), g = "";
                for (var S in x)
                  g += S;
                return h !== g;
              }, f = function() {
                if (!Object.assign || !Object.preventExtensions)
                  return !1;
                var h = Object.preventExtensions({ 1: 2 });
                try {
                  Object.assign(h, "xy");
                } catch {
                  return h[1] === "y";
                }
                return !1;
              };
              u.exports = function() {
                return !Object.assign || i() || f() ? s : Object.assign;
              };
            }
          ),
          /***/
          72519: (
            /***/
            function(u, l) {
              var e = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
              function s(h, v) {
                return Object.prototype.hasOwnProperty.call(h, v);
              }
              l.assign = function(h) {
                for (var v = Array.prototype.slice.call(arguments, 1); v.length; ) {
                  var p = v.shift();
                  if (p) {
                    if (typeof p != "object")
                      throw new TypeError(p + "must be non-object");
                    for (var m in p)
                      s(p, m) && (h[m] = p[m]);
                  }
                }
                return h;
              }, l.shrinkBuf = function(h, v) {
                return h.length === v ? h : h.subarray ? h.subarray(0, v) : (h.length = v, h);
              };
              var i = {
                arraySet: function(h, v, p, m, x) {
                  if (v.subarray && h.subarray) {
                    h.set(v.subarray(p, p + m), x);
                    return;
                  }
                  for (var g = 0; g < m; g++)
                    h[x + g] = v[p + g];
                },
                // Join array of chunks to single array.
                flattenChunks: function(h) {
                  var v, p, m, x, g, S;
                  for (m = 0, v = 0, p = h.length; v < p; v++)
                    m += h[v].length;
                  for (S = new Uint8Array(m), x = 0, v = 0, p = h.length; v < p; v++)
                    g = h[v], S.set(g, x), x += g.length;
                  return S;
                }
              }, f = {
                arraySet: function(h, v, p, m, x) {
                  for (var g = 0; g < m; g++)
                    h[x + g] = v[p + g];
                },
                // Join array of chunks to single array.
                flattenChunks: function(h) {
                  return [].concat.apply([], h);
                }
              };
              l.setTyped = function(h) {
                h ? (l.Buf8 = Uint8Array, l.Buf16 = Uint16Array, l.Buf32 = Int32Array, l.assign(l, i)) : (l.Buf8 = Array, l.Buf16 = Array, l.Buf32 = Array, l.assign(l, f));
              }, l.setTyped(e);
            }
          ),
          /***/
          46911: (
            /***/
            function(u) {
              function l(e, s, i, f) {
                for (var h = e & 65535 | 0, v = e >>> 16 & 65535 | 0, p = 0; i !== 0; ) {
                  p = i > 2e3 ? 2e3 : i, i -= p;
                  do
                    h = h + s[f++] | 0, v = v + h | 0;
                  while (--p);
                  h %= 65521, v %= 65521;
                }
                return h | v << 16 | 0;
              }
              u.exports = l;
            }
          ),
          /***/
          81607: (
            /***/
            function(u) {
              u.exports = {
                /* Allowed flush values; see deflate() and inflate() below for details */
                Z_NO_FLUSH: 0,
                Z_PARTIAL_FLUSH: 1,
                Z_SYNC_FLUSH: 2,
                Z_FULL_FLUSH: 3,
                Z_FINISH: 4,
                Z_BLOCK: 5,
                Z_TREES: 6,
                /* Return codes for the compression/decompression functions. Negative values
                * are errors, positive values are used for special but normal events.
                */
                Z_OK: 0,
                Z_STREAM_END: 1,
                Z_NEED_DICT: 2,
                Z_ERRNO: -1,
                Z_STREAM_ERROR: -2,
                Z_DATA_ERROR: -3,
                //Z_MEM_ERROR:     -4,
                Z_BUF_ERROR: -5,
                //Z_VERSION_ERROR: -6,
                /* compression levels */
                Z_NO_COMPRESSION: 0,
                Z_BEST_SPEED: 1,
                Z_BEST_COMPRESSION: 9,
                Z_DEFAULT_COMPRESSION: -1,
                Z_FILTERED: 1,
                Z_HUFFMAN_ONLY: 2,
                Z_RLE: 3,
                Z_FIXED: 4,
                Z_DEFAULT_STRATEGY: 0,
                /* Possible values of the data_type field (though see inflate()) */
                Z_BINARY: 0,
                Z_TEXT: 1,
                //Z_ASCII:                1, // = Z_TEXT (deprecated)
                Z_UNKNOWN: 2,
                /* The deflate compression method */
                Z_DEFLATED: 8
                //Z_NULL:                 null // Use -1 or null inline, depending on var type
              };
            }
          ),
          /***/
          99049: (
            /***/
            function(u) {
              function l() {
                for (var i, f = [], h = 0; h < 256; h++) {
                  i = h;
                  for (var v = 0; v < 8; v++)
                    i = i & 1 ? 3988292384 ^ i >>> 1 : i >>> 1;
                  f[h] = i;
                }
                return f;
              }
              var e = l();
              function s(i, f, h, v) {
                var p = e, m = v + h;
                i ^= -1;
                for (var x = v; x < m; x++)
                  i = i >>> 8 ^ p[(i ^ f[x]) & 255];
                return i ^ -1;
              }
              u.exports = s;
            }
          ),
          /***/
          22925: (
            /***/
            function(u, l, e) {
              var s = e(72519), i = e(22367), f = e(46911), h = e(99049), v = e(56228), p = 0, m = 1, x = 3, g = 4, S = 5, y = 0, b = 1, n = -2, w = -3, E = -5, A = -1, O = 1, C = 2, T = 3, P = 4, I = 0, F = 2, B = 8, M = 9, z = 15, L = 8, J = 29, ft = 256, Q = ft + 1 + J, xt = 30, St = 19, Pt = 2 * Q + 1, Gt = 15, Rt = 3, bt = 258, Dt = bt + Rt + 1, X = 32, gt = 42, st = 69, rt = 73, wt = 91, Ft = 103, zt = 113, G = 666, D = 1, Z = 2, et = 3, vt = 4, lt = 3;
              function dt(Y, Jt) {
                return Y.msg = v[Jt], Jt;
              }
              function kt(Y) {
                return (Y << 1) - (Y > 4 ? 9 : 0);
              }
              function jt(Y) {
                for (var Jt = Y.length; --Jt >= 0; )
                  Y[Jt] = 0;
              }
              function me(Y) {
                var Jt = Y.state, ie = Jt.pending;
                ie > Y.avail_out && (ie = Y.avail_out), ie !== 0 && (s.arraySet(Y.output, Jt.pending_buf, Jt.pending_out, ie, Y.next_out), Y.next_out += ie, Jt.pending_out += ie, Y.total_out += ie, Y.avail_out -= ie, Jt.pending -= ie, Jt.pending === 0 && (Jt.pending_out = 0));
              }
              function se(Y, Jt) {
                i._tr_flush_block(Y, Y.block_start >= 0 ? Y.block_start : -1, Y.strstart - Y.block_start, Jt), Y.block_start = Y.strstart, me(Y.strm);
              }
              function Bt(Y, Jt) {
                Y.pending_buf[Y.pending++] = Jt;
              }
              function ge(Y, Jt) {
                Y.pending_buf[Y.pending++] = Jt >>> 8 & 255, Y.pending_buf[Y.pending++] = Jt & 255;
              }
              function Re(Y, Jt, ie, Tt) {
                var Xt = Y.avail_in;
                return Xt > Tt && (Xt = Tt), Xt === 0 ? 0 : (Y.avail_in -= Xt, s.arraySet(Jt, Y.input, Y.next_in, Xt, ie), Y.state.wrap === 1 ? Y.adler = f(Y.adler, Jt, Xt, ie) : Y.state.wrap === 2 && (Y.adler = h(Y.adler, Jt, Xt, ie)), Y.next_in += Xt, Y.total_in += Xt, Xt);
              }
              function Te(Y, Jt) {
                var ie = Y.max_chain_length, Tt = Y.strstart, Xt, ue, Ve = Y.prev_length, ke = Y.nice_match, Xe = Y.strstart > Y.w_size - Dt ? Y.strstart - (Y.w_size - Dt) : 0, je = Y.window, Wr = Y.w_mask, vr = Y.prev, nr = Y.strstart + bt, Fr = je[Tt + Ve - 1], Jr = je[Tt + Ve];
                Y.prev_length >= Y.good_match && (ie >>= 2), ke > Y.lookahead && (ke = Y.lookahead);
                do
                  if (Xt = Jt, !(je[Xt + Ve] !== Jr || je[Xt + Ve - 1] !== Fr || je[Xt] !== je[Tt] || je[++Xt] !== je[Tt + 1])) {
                    Tt += 2, Xt++;
                    do
                      ;
                    while (je[++Tt] === je[++Xt] && je[++Tt] === je[++Xt] && je[++Tt] === je[++Xt] && je[++Tt] === je[++Xt] && je[++Tt] === je[++Xt] && je[++Tt] === je[++Xt] && je[++Tt] === je[++Xt] && je[++Tt] === je[++Xt] && Tt < nr);
                    if (ue = bt - (nr - Tt), Tt = nr - bt, ue > Ve) {
                      if (Y.match_start = Jt, Ve = ue, ue >= ke)
                        break;
                      Fr = je[Tt + Ve - 1], Jr = je[Tt + Ve];
                    }
                  }
                while ((Jt = vr[Jt & Wr]) > Xe && --ie !== 0);
                return Ve <= Y.lookahead ? Ve : Y.lookahead;
              }
              function xe(Y) {
                var Jt = Y.w_size, ie, Tt, Xt, ue, Ve;
                do {
                  if (ue = Y.window_size - Y.lookahead - Y.strstart, Y.strstart >= Jt + (Jt - Dt)) {
                    s.arraySet(Y.window, Y.window, Jt, Jt, 0), Y.match_start -= Jt, Y.strstart -= Jt, Y.block_start -= Jt, Tt = Y.hash_size, ie = Tt;
                    do
                      Xt = Y.head[--ie], Y.head[ie] = Xt >= Jt ? Xt - Jt : 0;
                    while (--Tt);
                    Tt = Jt, ie = Tt;
                    do
                      Xt = Y.prev[--ie], Y.prev[ie] = Xt >= Jt ? Xt - Jt : 0;
                    while (--Tt);
                    ue += Jt;
                  }
                  if (Y.strm.avail_in === 0)
                    break;
                  if (Tt = Re(Y.strm, Y.window, Y.strstart + Y.lookahead, ue), Y.lookahead += Tt, Y.lookahead + Y.insert >= Rt)
                    for (Ve = Y.strstart - Y.insert, Y.ins_h = Y.window[Ve], Y.ins_h = (Y.ins_h << Y.hash_shift ^ Y.window[Ve + 1]) & Y.hash_mask; Y.insert && (Y.ins_h = (Y.ins_h << Y.hash_shift ^ Y.window[Ve + Rt - 1]) & Y.hash_mask, Y.prev[Ve & Y.w_mask] = Y.head[Y.ins_h], Y.head[Y.ins_h] = Ve, Ve++, Y.insert--, !(Y.lookahead + Y.insert < Rt)); )
                      ;
                } while (Y.lookahead < Dt && Y.strm.avail_in !== 0);
              }
              function Fe(Y, Jt) {
                var ie = 65535;
                for (ie > Y.pending_buf_size - 5 && (ie = Y.pending_buf_size - 5); ; ) {
                  if (Y.lookahead <= 1) {
                    if (xe(Y), Y.lookahead === 0 && Jt === p)
                      return D;
                    if (Y.lookahead === 0)
                      break;
                  }
                  Y.strstart += Y.lookahead, Y.lookahead = 0;
                  var Tt = Y.block_start + ie;
                  if ((Y.strstart === 0 || Y.strstart >= Tt) && (Y.lookahead = Y.strstart - Tt, Y.strstart = Tt, se(Y, !1), Y.strm.avail_out === 0) || Y.strstart - Y.block_start >= Y.w_size - Dt && (se(Y, !1), Y.strm.avail_out === 0))
                    return D;
                }
                return Y.insert = 0, Jt === g ? (se(Y, !0), Y.strm.avail_out === 0 ? et : vt) : (Y.strstart > Y.block_start && (se(Y, !1), Y.strm.avail_out === 0), D);
              }
              function Zt(Y, Jt) {
                for (var ie, Tt; ; ) {
                  if (Y.lookahead < Dt) {
                    if (xe(Y), Y.lookahead < Dt && Jt === p)
                      return D;
                    if (Y.lookahead === 0)
                      break;
                  }
                  if (ie = 0, Y.lookahead >= Rt && (Y.ins_h = (Y.ins_h << Y.hash_shift ^ Y.window[Y.strstart + Rt - 1]) & Y.hash_mask, ie = Y.prev[Y.strstart & Y.w_mask] = Y.head[Y.ins_h], Y.head[Y.ins_h] = Y.strstart), ie !== 0 && Y.strstart - ie <= Y.w_size - Dt && (Y.match_length = Te(Y, ie)), Y.match_length >= Rt)
                    if (Tt = i._tr_tally(Y, Y.strstart - Y.match_start, Y.match_length - Rt), Y.lookahead -= Y.match_length, Y.match_length <= Y.max_lazy_match && Y.lookahead >= Rt) {
                      Y.match_length--;
                      do
                        Y.strstart++, Y.ins_h = (Y.ins_h << Y.hash_shift ^ Y.window[Y.strstart + Rt - 1]) & Y.hash_mask, ie = Y.prev[Y.strstart & Y.w_mask] = Y.head[Y.ins_h], Y.head[Y.ins_h] = Y.strstart;
                      while (--Y.match_length !== 0);
                      Y.strstart++;
                    } else
                      Y.strstart += Y.match_length, Y.match_length = 0, Y.ins_h = Y.window[Y.strstart], Y.ins_h = (Y.ins_h << Y.hash_shift ^ Y.window[Y.strstart + 1]) & Y.hash_mask;
                  else
                    Tt = i._tr_tally(Y, 0, Y.window[Y.strstart]), Y.lookahead--, Y.strstart++;
                  if (Tt && (se(Y, !1), Y.strm.avail_out === 0))
                    return D;
                }
                return Y.insert = Y.strstart < Rt - 1 ? Y.strstart : Rt - 1, Jt === g ? (se(Y, !0), Y.strm.avail_out === 0 ? et : vt) : Y.last_lit && (se(Y, !1), Y.strm.avail_out === 0) ? D : Z;
              }
              function qt(Y, Jt) {
                for (var ie, Tt, Xt; ; ) {
                  if (Y.lookahead < Dt) {
                    if (xe(Y), Y.lookahead < Dt && Jt === p)
                      return D;
                    if (Y.lookahead === 0)
                      break;
                  }
                  if (ie = 0, Y.lookahead >= Rt && (Y.ins_h = (Y.ins_h << Y.hash_shift ^ Y.window[Y.strstart + Rt - 1]) & Y.hash_mask, ie = Y.prev[Y.strstart & Y.w_mask] = Y.head[Y.ins_h], Y.head[Y.ins_h] = Y.strstart), Y.prev_length = Y.match_length, Y.prev_match = Y.match_start, Y.match_length = Rt - 1, ie !== 0 && Y.prev_length < Y.max_lazy_match && Y.strstart - ie <= Y.w_size - Dt && (Y.match_length = Te(Y, ie), Y.match_length <= 5 && (Y.strategy === O || Y.match_length === Rt && Y.strstart - Y.match_start > 4096) && (Y.match_length = Rt - 1)), Y.prev_length >= Rt && Y.match_length <= Y.prev_length) {
                    Xt = Y.strstart + Y.lookahead - Rt, Tt = i._tr_tally(Y, Y.strstart - 1 - Y.prev_match, Y.prev_length - Rt), Y.lookahead -= Y.prev_length - 1, Y.prev_length -= 2;
                    do
                      ++Y.strstart <= Xt && (Y.ins_h = (Y.ins_h << Y.hash_shift ^ Y.window[Y.strstart + Rt - 1]) & Y.hash_mask, ie = Y.prev[Y.strstart & Y.w_mask] = Y.head[Y.ins_h], Y.head[Y.ins_h] = Y.strstart);
                    while (--Y.prev_length !== 0);
                    if (Y.match_available = 0, Y.match_length = Rt - 1, Y.strstart++, Tt && (se(Y, !1), Y.strm.avail_out === 0))
                      return D;
                  } else if (Y.match_available) {
                    if (Tt = i._tr_tally(Y, 0, Y.window[Y.strstart - 1]), Tt && se(Y, !1), Y.strstart++, Y.lookahead--, Y.strm.avail_out === 0)
                      return D;
                  } else
                    Y.match_available = 1, Y.strstart++, Y.lookahead--;
                }
                return Y.match_available && (Tt = i._tr_tally(Y, 0, Y.window[Y.strstart - 1]), Y.match_available = 0), Y.insert = Y.strstart < Rt - 1 ? Y.strstart : Rt - 1, Jt === g ? (se(Y, !0), Y.strm.avail_out === 0 ? et : vt) : Y.last_lit && (se(Y, !1), Y.strm.avail_out === 0) ? D : Z;
              }
              function ve(Y, Jt) {
                for (var ie, Tt, Xt, ue, Ve = Y.window; ; ) {
                  if (Y.lookahead <= bt) {
                    if (xe(Y), Y.lookahead <= bt && Jt === p)
                      return D;
                    if (Y.lookahead === 0)
                      break;
                  }
                  if (Y.match_length = 0, Y.lookahead >= Rt && Y.strstart > 0 && (Xt = Y.strstart - 1, Tt = Ve[Xt], Tt === Ve[++Xt] && Tt === Ve[++Xt] && Tt === Ve[++Xt])) {
                    ue = Y.strstart + bt;
                    do
                      ;
                    while (Tt === Ve[++Xt] && Tt === Ve[++Xt] && Tt === Ve[++Xt] && Tt === Ve[++Xt] && Tt === Ve[++Xt] && Tt === Ve[++Xt] && Tt === Ve[++Xt] && Tt === Ve[++Xt] && Xt < ue);
                    Y.match_length = bt - (ue - Xt), Y.match_length > Y.lookahead && (Y.match_length = Y.lookahead);
                  }
                  if (Y.match_length >= Rt ? (ie = i._tr_tally(Y, 1, Y.match_length - Rt), Y.lookahead -= Y.match_length, Y.strstart += Y.match_length, Y.match_length = 0) : (ie = i._tr_tally(Y, 0, Y.window[Y.strstart]), Y.lookahead--, Y.strstart++), ie && (se(Y, !1), Y.strm.avail_out === 0))
                    return D;
                }
                return Y.insert = 0, Jt === g ? (se(Y, !0), Y.strm.avail_out === 0 ? et : vt) : Y.last_lit && (se(Y, !1), Y.strm.avail_out === 0) ? D : Z;
              }
              function Se(Y, Jt) {
                for (var ie; ; ) {
                  if (Y.lookahead === 0 && (xe(Y), Y.lookahead === 0)) {
                    if (Jt === p)
                      return D;
                    break;
                  }
                  if (Y.match_length = 0, ie = i._tr_tally(Y, 0, Y.window[Y.strstart]), Y.lookahead--, Y.strstart++, ie && (se(Y, !1), Y.strm.avail_out === 0))
                    return D;
                }
                return Y.insert = 0, Jt === g ? (se(Y, !0), Y.strm.avail_out === 0 ? et : vt) : Y.last_lit && (se(Y, !1), Y.strm.avail_out === 0) ? D : Z;
              }
              function Pe(Y, Jt, ie, Tt, Xt) {
                this.good_length = Y, this.max_lazy = Jt, this.nice_length = ie, this.max_chain = Tt, this.func = Xt;
              }
              var Be;
              Be = [
                /*      good lazy nice chain */
                new Pe(0, 0, 0, 0, Fe),
                /* 0 store only */
                new Pe(4, 4, 8, 4, Zt),
                /* 1 max speed, no lazy matches */
                new Pe(4, 5, 16, 8, Zt),
                /* 2 */
                new Pe(4, 6, 32, 32, Zt),
                /* 3 */
                new Pe(4, 4, 16, 16, qt),
                /* 4 lazy matches */
                new Pe(8, 16, 32, 32, qt),
                /* 5 */
                new Pe(8, 16, 128, 128, qt),
                /* 6 */
                new Pe(8, 32, 128, 256, qt),
                /* 7 */
                new Pe(32, 128, 258, 1024, qt),
                /* 8 */
                new Pe(32, 258, 258, 4096, qt)
                /* 9 max compression */
              ];
              function De(Y) {
                Y.window_size = 2 * Y.w_size, jt(Y.head), Y.max_lazy_match = Be[Y.level].max_lazy, Y.good_match = Be[Y.level].good_length, Y.nice_match = Be[Y.level].nice_length, Y.max_chain_length = Be[Y.level].max_chain, Y.strstart = 0, Y.block_start = 0, Y.lookahead = 0, Y.insert = 0, Y.match_length = Y.prev_length = Rt - 1, Y.match_available = 0, Y.ins_h = 0;
              }
              function It() {
                this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = B, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new s.Buf16(Pt * 2), this.dyn_dtree = new s.Buf16((2 * xt + 1) * 2), this.bl_tree = new s.Buf16((2 * St + 1) * 2), jt(this.dyn_ltree), jt(this.dyn_dtree), jt(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new s.Buf16(Gt + 1), this.heap = new s.Buf16(2 * Q + 1), jt(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new s.Buf16(2 * Q + 1), jt(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
              }
              function he(Y) {
                var Jt;
                return !Y || !Y.state ? dt(Y, n) : (Y.total_in = Y.total_out = 0, Y.data_type = F, Jt = Y.state, Jt.pending = 0, Jt.pending_out = 0, Jt.wrap < 0 && (Jt.wrap = -Jt.wrap), Jt.status = Jt.wrap ? gt : zt, Y.adler = Jt.wrap === 2 ? 0 : 1, Jt.last_flush = p, i._tr_init(Jt), y);
              }
              function nt(Y) {
                var Jt = he(Y);
                return Jt === y && De(Y.state), Jt;
              }
              function j(Y, Jt) {
                return !Y || !Y.state || Y.state.wrap !== 2 ? n : (Y.state.gzhead = Jt, y);
              }
              function V(Y, Jt, ie, Tt, Xt, ue) {
                if (!Y)
                  return n;
                var Ve = 1;
                if (Jt === A && (Jt = 6), Tt < 0 ? (Ve = 0, Tt = -Tt) : Tt > 15 && (Ve = 2, Tt -= 16), Xt < 1 || Xt > M || ie !== B || Tt < 8 || Tt > 15 || Jt < 0 || Jt > 9 || ue < 0 || ue > P)
                  return dt(Y, n);
                Tt === 8 && (Tt = 9);
                var ke = new It();
                return Y.state = ke, ke.strm = Y, ke.wrap = Ve, ke.gzhead = null, ke.w_bits = Tt, ke.w_size = 1 << ke.w_bits, ke.w_mask = ke.w_size - 1, ke.hash_bits = Xt + 7, ke.hash_size = 1 << ke.hash_bits, ke.hash_mask = ke.hash_size - 1, ke.hash_shift = ~~((ke.hash_bits + Rt - 1) / Rt), ke.window = new s.Buf8(ke.w_size * 2), ke.head = new s.Buf16(ke.hash_size), ke.prev = new s.Buf16(ke.w_size), ke.lit_bufsize = 1 << Xt + 6, ke.pending_buf_size = ke.lit_bufsize * 4, ke.pending_buf = new s.Buf8(ke.pending_buf_size), ke.d_buf = 1 * ke.lit_bufsize, ke.l_buf = 3 * ke.lit_bufsize, ke.level = Jt, ke.strategy = ue, ke.method = ie, nt(Y);
              }
              function yt(Y, Jt) {
                return V(Y, Jt, B, z, L, I);
              }
              function it(Y, Jt) {
                var ie, Tt, Xt, ue;
                if (!Y || !Y.state || Jt > S || Jt < 0)
                  return Y ? dt(Y, n) : n;
                if (Tt = Y.state, !Y.output || !Y.input && Y.avail_in !== 0 || Tt.status === G && Jt !== g)
                  return dt(Y, Y.avail_out === 0 ? E : n);
                if (Tt.strm = Y, ie = Tt.last_flush, Tt.last_flush = Jt, Tt.status === gt)
                  if (Tt.wrap === 2)
                    Y.adler = 0, Bt(Tt, 31), Bt(Tt, 139), Bt(Tt, 8), Tt.gzhead ? (Bt(
                      Tt,
                      (Tt.gzhead.text ? 1 : 0) + (Tt.gzhead.hcrc ? 2 : 0) + (Tt.gzhead.extra ? 4 : 0) + (Tt.gzhead.name ? 8 : 0) + (Tt.gzhead.comment ? 16 : 0)
                    ), Bt(Tt, Tt.gzhead.time & 255), Bt(Tt, Tt.gzhead.time >> 8 & 255), Bt(Tt, Tt.gzhead.time >> 16 & 255), Bt(Tt, Tt.gzhead.time >> 24 & 255), Bt(Tt, Tt.level === 9 ? 2 : Tt.strategy >= C || Tt.level < 2 ? 4 : 0), Bt(Tt, Tt.gzhead.os & 255), Tt.gzhead.extra && Tt.gzhead.extra.length && (Bt(Tt, Tt.gzhead.extra.length & 255), Bt(Tt, Tt.gzhead.extra.length >> 8 & 255)), Tt.gzhead.hcrc && (Y.adler = h(Y.adler, Tt.pending_buf, Tt.pending, 0)), Tt.gzindex = 0, Tt.status = st) : (Bt(Tt, 0), Bt(Tt, 0), Bt(Tt, 0), Bt(Tt, 0), Bt(Tt, 0), Bt(Tt, Tt.level === 9 ? 2 : Tt.strategy >= C || Tt.level < 2 ? 4 : 0), Bt(Tt, lt), Tt.status = zt);
                  else {
                    var Ve = B + (Tt.w_bits - 8 << 4) << 8, ke = -1;
                    Tt.strategy >= C || Tt.level < 2 ? ke = 0 : Tt.level < 6 ? ke = 1 : Tt.level === 6 ? ke = 2 : ke = 3, Ve |= ke << 6, Tt.strstart !== 0 && (Ve |= X), Ve += 31 - Ve % 31, Tt.status = zt, ge(Tt, Ve), Tt.strstart !== 0 && (ge(Tt, Y.adler >>> 16), ge(Tt, Y.adler & 65535)), Y.adler = 1;
                  }
                if (Tt.status === st)
                  if (Tt.gzhead.extra) {
                    for (Xt = Tt.pending; Tt.gzindex < (Tt.gzhead.extra.length & 65535) && !(Tt.pending === Tt.pending_buf_size && (Tt.gzhead.hcrc && Tt.pending > Xt && (Y.adler = h(Y.adler, Tt.pending_buf, Tt.pending - Xt, Xt)), me(Y), Xt = Tt.pending, Tt.pending === Tt.pending_buf_size)); )
                      Bt(Tt, Tt.gzhead.extra[Tt.gzindex] & 255), Tt.gzindex++;
                    Tt.gzhead.hcrc && Tt.pending > Xt && (Y.adler = h(Y.adler, Tt.pending_buf, Tt.pending - Xt, Xt)), Tt.gzindex === Tt.gzhead.extra.length && (Tt.gzindex = 0, Tt.status = rt);
                  } else
                    Tt.status = rt;
                if (Tt.status === rt)
                  if (Tt.gzhead.name) {
                    Xt = Tt.pending;
                    do {
                      if (Tt.pending === Tt.pending_buf_size && (Tt.gzhead.hcrc && Tt.pending > Xt && (Y.adler = h(Y.adler, Tt.pending_buf, Tt.pending - Xt, Xt)), me(Y), Xt = Tt.pending, Tt.pending === Tt.pending_buf_size)) {
                        ue = 1;
                        break;
                      }
                      Tt.gzindex < Tt.gzhead.name.length ? ue = Tt.gzhead.name.charCodeAt(Tt.gzindex++) & 255 : ue = 0, Bt(Tt, ue);
                    } while (ue !== 0);
                    Tt.gzhead.hcrc && Tt.pending > Xt && (Y.adler = h(Y.adler, Tt.pending_buf, Tt.pending - Xt, Xt)), ue === 0 && (Tt.gzindex = 0, Tt.status = wt);
                  } else
                    Tt.status = wt;
                if (Tt.status === wt)
                  if (Tt.gzhead.comment) {
                    Xt = Tt.pending;
                    do {
                      if (Tt.pending === Tt.pending_buf_size && (Tt.gzhead.hcrc && Tt.pending > Xt && (Y.adler = h(Y.adler, Tt.pending_buf, Tt.pending - Xt, Xt)), me(Y), Xt = Tt.pending, Tt.pending === Tt.pending_buf_size)) {
                        ue = 1;
                        break;
                      }
                      Tt.gzindex < Tt.gzhead.comment.length ? ue = Tt.gzhead.comment.charCodeAt(Tt.gzindex++) & 255 : ue = 0, Bt(Tt, ue);
                    } while (ue !== 0);
                    Tt.gzhead.hcrc && Tt.pending > Xt && (Y.adler = h(Y.adler, Tt.pending_buf, Tt.pending - Xt, Xt)), ue === 0 && (Tt.status = Ft);
                  } else
                    Tt.status = Ft;
                if (Tt.status === Ft && (Tt.gzhead.hcrc ? (Tt.pending + 2 > Tt.pending_buf_size && me(Y), Tt.pending + 2 <= Tt.pending_buf_size && (Bt(Tt, Y.adler & 255), Bt(Tt, Y.adler >> 8 & 255), Y.adler = 0, Tt.status = zt)) : Tt.status = zt), Tt.pending !== 0) {
                  if (me(Y), Y.avail_out === 0)
                    return Tt.last_flush = -1, y;
                } else if (Y.avail_in === 0 && kt(Jt) <= kt(ie) && Jt !== g)
                  return dt(Y, E);
                if (Tt.status === G && Y.avail_in !== 0)
                  return dt(Y, E);
                if (Y.avail_in !== 0 || Tt.lookahead !== 0 || Jt !== p && Tt.status !== G) {
                  var Xe = Tt.strategy === C ? Se(Tt, Jt) : Tt.strategy === T ? ve(Tt, Jt) : Be[Tt.level].func(Tt, Jt);
                  if ((Xe === et || Xe === vt) && (Tt.status = G), Xe === D || Xe === et)
                    return Y.avail_out === 0 && (Tt.last_flush = -1), y;
                  if (Xe === Z && (Jt === m ? i._tr_align(Tt) : Jt !== S && (i._tr_stored_block(Tt, 0, 0, !1), Jt === x && (jt(Tt.head), Tt.lookahead === 0 && (Tt.strstart = 0, Tt.block_start = 0, Tt.insert = 0))), me(Y), Y.avail_out === 0))
                    return Tt.last_flush = -1, y;
                }
                return Jt !== g ? y : Tt.wrap <= 0 ? b : (Tt.wrap === 2 ? (Bt(Tt, Y.adler & 255), Bt(Tt, Y.adler >> 8 & 255), Bt(Tt, Y.adler >> 16 & 255), Bt(Tt, Y.adler >> 24 & 255), Bt(Tt, Y.total_in & 255), Bt(Tt, Y.total_in >> 8 & 255), Bt(Tt, Y.total_in >> 16 & 255), Bt(Tt, Y.total_in >> 24 & 255)) : (ge(Tt, Y.adler >>> 16), ge(Tt, Y.adler & 65535)), me(Y), Tt.wrap > 0 && (Tt.wrap = -Tt.wrap), Tt.pending !== 0 ? y : b);
              }
              function _t(Y) {
                var Jt;
                return !Y || !Y.state ? n : (Jt = Y.state.status, Jt !== gt && Jt !== st && Jt !== rt && Jt !== wt && Jt !== Ft && Jt !== zt && Jt !== G ? dt(Y, n) : (Y.state = null, Jt === zt ? dt(Y, w) : y));
              }
              function ne(Y, Jt) {
                var ie = Jt.length, Tt, Xt, ue, Ve, ke, Xe, je, Wr;
                if (!Y || !Y.state || (Tt = Y.state, Ve = Tt.wrap, Ve === 2 || Ve === 1 && Tt.status !== gt || Tt.lookahead))
                  return n;
                for (Ve === 1 && (Y.adler = f(Y.adler, Jt, ie, 0)), Tt.wrap = 0, ie >= Tt.w_size && (Ve === 0 && (jt(Tt.head), Tt.strstart = 0, Tt.block_start = 0, Tt.insert = 0), Wr = new s.Buf8(Tt.w_size), s.arraySet(Wr, Jt, ie - Tt.w_size, Tt.w_size, 0), Jt = Wr, ie = Tt.w_size), ke = Y.avail_in, Xe = Y.next_in, je = Y.input, Y.avail_in = ie, Y.next_in = 0, Y.input = Jt, xe(Tt); Tt.lookahead >= Rt; ) {
                  Xt = Tt.strstart, ue = Tt.lookahead - (Rt - 1);
                  do
                    Tt.ins_h = (Tt.ins_h << Tt.hash_shift ^ Tt.window[Xt + Rt - 1]) & Tt.hash_mask, Tt.prev[Xt & Tt.w_mask] = Tt.head[Tt.ins_h], Tt.head[Tt.ins_h] = Xt, Xt++;
                  while (--ue);
                  Tt.strstart = Xt, Tt.lookahead = Rt - 1, xe(Tt);
                }
                return Tt.strstart += Tt.lookahead, Tt.block_start = Tt.strstart, Tt.insert = Tt.lookahead, Tt.lookahead = 0, Tt.match_length = Tt.prev_length = Rt - 1, Tt.match_available = 0, Y.next_in = Xe, Y.input = je, Y.avail_in = ke, Tt.wrap = Ve, y;
              }
              l.deflateInit = yt, l.deflateInit2 = V, l.deflateReset = nt, l.deflateResetKeep = he, l.deflateSetHeader = j, l.deflate = it, l.deflateEnd = _t, l.deflateSetDictionary = ne, l.deflateInfo = "pako deflate (from Nodeca project)";
            }
          ),
          /***/
          96395: (
            /***/
            function(u) {
              var l = 30, e = 12;
              u.exports = function(i, f) {
                var h, v, p, m, x, g, S, y, b, n, w, E, A, O, C, T, P, I, F, B, M, z, L, J, ft;
                h = i.state, v = i.next_in, J = i.input, p = v + (i.avail_in - 5), m = i.next_out, ft = i.output, x = m - (f - i.avail_out), g = m + (i.avail_out - 257), S = h.dmax, y = h.wsize, b = h.whave, n = h.wnext, w = h.window, E = h.hold, A = h.bits, O = h.lencode, C = h.distcode, T = (1 << h.lenbits) - 1, P = (1 << h.distbits) - 1;
                t:
                  do {
                    A < 15 && (E += J[v++] << A, A += 8, E += J[v++] << A, A += 8), I = O[E & T];
                    e:
                      for (; ; ) {
                        if (F = I >>> 24, E >>>= F, A -= F, F = I >>> 16 & 255, F === 0)
                          ft[m++] = I & 65535;
                        else if (F & 16) {
                          B = I & 65535, F &= 15, F && (A < F && (E += J[v++] << A, A += 8), B += E & (1 << F) - 1, E >>>= F, A -= F), A < 15 && (E += J[v++] << A, A += 8, E += J[v++] << A, A += 8), I = C[E & P];
                          r:
                            for (; ; ) {
                              if (F = I >>> 24, E >>>= F, A -= F, F = I >>> 16 & 255, F & 16) {
                                if (M = I & 65535, F &= 15, A < F && (E += J[v++] << A, A += 8, A < F && (E += J[v++] << A, A += 8)), M += E & (1 << F) - 1, M > S) {
                                  i.msg = "invalid distance too far back", h.mode = l;
                                  break t;
                                }
                                if (E >>>= F, A -= F, F = m - x, M > F) {
                                  if (F = M - F, F > b && h.sane) {
                                    i.msg = "invalid distance too far back", h.mode = l;
                                    break t;
                                  }
                                  if (z = 0, L = w, n === 0) {
                                    if (z += y - F, F < B) {
                                      B -= F;
                                      do
                                        ft[m++] = w[z++];
                                      while (--F);
                                      z = m - M, L = ft;
                                    }
                                  } else if (n < F) {
                                    if (z += y + n - F, F -= n, F < B) {
                                      B -= F;
                                      do
                                        ft[m++] = w[z++];
                                      while (--F);
                                      if (z = 0, n < B) {
                                        F = n, B -= F;
                                        do
                                          ft[m++] = w[z++];
                                        while (--F);
                                        z = m - M, L = ft;
                                      }
                                    }
                                  } else if (z += n - F, F < B) {
                                    B -= F;
                                    do
                                      ft[m++] = w[z++];
                                    while (--F);
                                    z = m - M, L = ft;
                                  }
                                  for (; B > 2; )
                                    ft[m++] = L[z++], ft[m++] = L[z++], ft[m++] = L[z++], B -= 3;
                                  B && (ft[m++] = L[z++], B > 1 && (ft[m++] = L[z++]));
                                } else {
                                  z = m - M;
                                  do
                                    ft[m++] = ft[z++], ft[m++] = ft[z++], ft[m++] = ft[z++], B -= 3;
                                  while (B > 2);
                                  B && (ft[m++] = ft[z++], B > 1 && (ft[m++] = ft[z++]));
                                }
                              } else if (F & 64) {
                                i.msg = "invalid distance code", h.mode = l;
                                break t;
                              } else {
                                I = C[(I & 65535) + (E & (1 << F) - 1)];
                                continue r;
                              }
                              break;
                            }
                        } else if (F & 64)
                          if (F & 32) {
                            h.mode = e;
                            break t;
                          } else {
                            i.msg = "invalid literal/length code", h.mode = l;
                            break t;
                          }
                        else {
                          I = O[(I & 65535) + (E & (1 << F) - 1)];
                          continue e;
                        }
                        break;
                      }
                  } while (v < p && m < g);
                B = A >> 3, v -= B, A -= B << 3, E &= (1 << A) - 1, i.next_in = v, i.next_out = m, i.avail_in = v < p ? 5 + (p - v) : 5 - (v - p), i.avail_out = m < g ? 257 + (g - m) : 257 - (m - g), h.hold = E, h.bits = A;
              };
            }
          ),
          /***/
          2269: (
            /***/
            function(u, l, e) {
              var s = e(72519), i = e(46911), f = e(99049), h = e(96395), v = e(92920), p = 0, m = 1, x = 2, g = 4, S = 5, y = 6, b = 0, n = 1, w = 2, E = -2, A = -3, O = -4, C = -5, T = 8, P = 1, I = 2, F = 3, B = 4, M = 5, z = 6, L = 7, J = 8, ft = 9, Q = 10, xt = 11, St = 12, Pt = 13, Gt = 14, Rt = 15, bt = 16, Dt = 17, X = 18, gt = 19, st = 20, rt = 21, wt = 22, Ft = 23, zt = 24, G = 25, D = 26, Z = 27, et = 28, vt = 29, lt = 30, dt = 31, kt = 32, jt = 852, me = 592, se = 15, Bt = se;
              function ge(V) {
                return (V >>> 24 & 255) + (V >>> 8 & 65280) + ((V & 65280) << 8) + ((V & 255) << 24);
              }
              function Re() {
                this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new s.Buf16(320), this.work = new s.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
              }
              function Te(V) {
                var yt;
                return !V || !V.state ? E : (yt = V.state, V.total_in = V.total_out = yt.total = 0, V.msg = "", yt.wrap && (V.adler = yt.wrap & 1), yt.mode = P, yt.last = 0, yt.havedict = 0, yt.dmax = 32768, yt.head = null, yt.hold = 0, yt.bits = 0, yt.lencode = yt.lendyn = new s.Buf32(jt), yt.distcode = yt.distdyn = new s.Buf32(me), yt.sane = 1, yt.back = -1, b);
              }
              function xe(V) {
                var yt;
                return !V || !V.state ? E : (yt = V.state, yt.wsize = 0, yt.whave = 0, yt.wnext = 0, Te(V));
              }
              function Fe(V, yt) {
                var it, _t;
                return !V || !V.state || (_t = V.state, yt < 0 ? (it = 0, yt = -yt) : (it = (yt >> 4) + 1, yt < 48 && (yt &= 15)), yt && (yt < 8 || yt > 15)) ? E : (_t.window !== null && _t.wbits !== yt && (_t.window = null), _t.wrap = it, _t.wbits = yt, xe(V));
              }
              function Zt(V, yt) {
                var it, _t;
                return V ? (_t = new Re(), V.state = _t, _t.window = null, it = Fe(V, yt), it !== b && (V.state = null), it) : E;
              }
              function qt(V) {
                return Zt(V, Bt);
              }
              var ve = !0, Se, Pe;
              function Be(V) {
                if (ve) {
                  var yt;
                  for (Se = new s.Buf32(512), Pe = new s.Buf32(32), yt = 0; yt < 144; )
                    V.lens[yt++] = 8;
                  for (; yt < 256; )
                    V.lens[yt++] = 9;
                  for (; yt < 280; )
                    V.lens[yt++] = 7;
                  for (; yt < 288; )
                    V.lens[yt++] = 8;
                  for (v(m, V.lens, 0, 288, Se, 0, V.work, { bits: 9 }), yt = 0; yt < 32; )
                    V.lens[yt++] = 5;
                  v(x, V.lens, 0, 32, Pe, 0, V.work, { bits: 5 }), ve = !1;
                }
                V.lencode = Se, V.lenbits = 9, V.distcode = Pe, V.distbits = 5;
              }
              function De(V, yt, it, _t) {
                var ne, Y = V.state;
                return Y.window === null && (Y.wsize = 1 << Y.wbits, Y.wnext = 0, Y.whave = 0, Y.window = new s.Buf8(Y.wsize)), _t >= Y.wsize ? (s.arraySet(Y.window, yt, it - Y.wsize, Y.wsize, 0), Y.wnext = 0, Y.whave = Y.wsize) : (ne = Y.wsize - Y.wnext, ne > _t && (ne = _t), s.arraySet(Y.window, yt, it - _t, ne, Y.wnext), _t -= ne, _t ? (s.arraySet(Y.window, yt, it - _t, _t, 0), Y.wnext = _t, Y.whave = Y.wsize) : (Y.wnext += ne, Y.wnext === Y.wsize && (Y.wnext = 0), Y.whave < Y.wsize && (Y.whave += ne))), 0;
              }
              function It(V, yt) {
                var it, _t, ne, Y, Jt, ie, Tt, Xt, ue, Ve, ke, Xe, je, Wr, vr = 0, nr, Fr, Jr, dn, kn, Yn, yr, Tn, qr = new s.Buf8(4), gn, un, wi = (
                  /* permutation of code lengths */
                  [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]
                );
                if (!V || !V.state || !V.output || !V.input && V.avail_in !== 0)
                  return E;
                it = V.state, it.mode === St && (it.mode = Pt), Jt = V.next_out, ne = V.output, Tt = V.avail_out, Y = V.next_in, _t = V.input, ie = V.avail_in, Xt = it.hold, ue = it.bits, Ve = ie, ke = Tt, Tn = b;
                t:
                  for (; ; )
                    switch (it.mode) {
                      case P:
                        if (it.wrap === 0) {
                          it.mode = Pt;
                          break;
                        }
                        for (; ue < 16; ) {
                          if (ie === 0)
                            break t;
                          ie--, Xt += _t[Y++] << ue, ue += 8;
                        }
                        if (it.wrap & 2 && Xt === 35615) {
                          it.check = 0, qr[0] = Xt & 255, qr[1] = Xt >>> 8 & 255, it.check = f(it.check, qr, 2, 0), Xt = 0, ue = 0, it.mode = I;
                          break;
                        }
                        if (it.flags = 0, it.head && (it.head.done = !1), !(it.wrap & 1) || /* check if zlib header allowed */
                        (((Xt & 255) << 8) + (Xt >> 8)) % 31) {
                          V.msg = "incorrect header check", it.mode = lt;
                          break;
                        }
                        if ((Xt & 15) !== T) {
                          V.msg = "unknown compression method", it.mode = lt;
                          break;
                        }
                        if (Xt >>>= 4, ue -= 4, yr = (Xt & 15) + 8, it.wbits === 0)
                          it.wbits = yr;
                        else if (yr > it.wbits) {
                          V.msg = "invalid window size", it.mode = lt;
                          break;
                        }
                        it.dmax = 1 << yr, V.adler = it.check = 1, it.mode = Xt & 512 ? Q : St, Xt = 0, ue = 0;
                        break;
                      case I:
                        for (; ue < 16; ) {
                          if (ie === 0)
                            break t;
                          ie--, Xt += _t[Y++] << ue, ue += 8;
                        }
                        if (it.flags = Xt, (it.flags & 255) !== T) {
                          V.msg = "unknown compression method", it.mode = lt;
                          break;
                        }
                        if (it.flags & 57344) {
                          V.msg = "unknown header flags set", it.mode = lt;
                          break;
                        }
                        it.head && (it.head.text = Xt >> 8 & 1), it.flags & 512 && (qr[0] = Xt & 255, qr[1] = Xt >>> 8 & 255, it.check = f(it.check, qr, 2, 0)), Xt = 0, ue = 0, it.mode = F;
                      case F:
                        for (; ue < 32; ) {
                          if (ie === 0)
                            break t;
                          ie--, Xt += _t[Y++] << ue, ue += 8;
                        }
                        it.head && (it.head.time = Xt), it.flags & 512 && (qr[0] = Xt & 255, qr[1] = Xt >>> 8 & 255, qr[2] = Xt >>> 16 & 255, qr[3] = Xt >>> 24 & 255, it.check = f(it.check, qr, 4, 0)), Xt = 0, ue = 0, it.mode = B;
                      case B:
                        for (; ue < 16; ) {
                          if (ie === 0)
                            break t;
                          ie--, Xt += _t[Y++] << ue, ue += 8;
                        }
                        it.head && (it.head.xflags = Xt & 255, it.head.os = Xt >> 8), it.flags & 512 && (qr[0] = Xt & 255, qr[1] = Xt >>> 8 & 255, it.check = f(it.check, qr, 2, 0)), Xt = 0, ue = 0, it.mode = M;
                      case M:
                        if (it.flags & 1024) {
                          for (; ue < 16; ) {
                            if (ie === 0)
                              break t;
                            ie--, Xt += _t[Y++] << ue, ue += 8;
                          }
                          it.length = Xt, it.head && (it.head.extra_len = Xt), it.flags & 512 && (qr[0] = Xt & 255, qr[1] = Xt >>> 8 & 255, it.check = f(it.check, qr, 2, 0)), Xt = 0, ue = 0;
                        } else
                          it.head && (it.head.extra = null);
                        it.mode = z;
                      case z:
                        if (it.flags & 1024 && (Xe = it.length, Xe > ie && (Xe = ie), Xe && (it.head && (yr = it.head.extra_len - it.length, it.head.extra || (it.head.extra = new Array(it.head.extra_len)), s.arraySet(
                          it.head.extra,
                          _t,
                          Y,
                          // extra field is limited to 65536 bytes
                          // - no need for additional size check
                          Xe,
                          /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
                          yr
                        )), it.flags & 512 && (it.check = f(it.check, _t, Xe, Y)), ie -= Xe, Y += Xe, it.length -= Xe), it.length))
                          break t;
                        it.length = 0, it.mode = L;
                      case L:
                        if (it.flags & 2048) {
                          if (ie === 0)
                            break t;
                          Xe = 0;
                          do
                            yr = _t[Y + Xe++], it.head && yr && it.length < 65536 && (it.head.name += String.fromCharCode(yr));
                          while (yr && Xe < ie);
                          if (it.flags & 512 && (it.check = f(it.check, _t, Xe, Y)), ie -= Xe, Y += Xe, yr)
                            break t;
                        } else
                          it.head && (it.head.name = null);
                        it.length = 0, it.mode = J;
                      case J:
                        if (it.flags & 4096) {
                          if (ie === 0)
                            break t;
                          Xe = 0;
                          do
                            yr = _t[Y + Xe++], it.head && yr && it.length < 65536 && (it.head.comment += String.fromCharCode(yr));
                          while (yr && Xe < ie);
                          if (it.flags & 512 && (it.check = f(it.check, _t, Xe, Y)), ie -= Xe, Y += Xe, yr)
                            break t;
                        } else
                          it.head && (it.head.comment = null);
                        it.mode = ft;
                      case ft:
                        if (it.flags & 512) {
                          for (; ue < 16; ) {
                            if (ie === 0)
                              break t;
                            ie--, Xt += _t[Y++] << ue, ue += 8;
                          }
                          if (Xt !== (it.check & 65535)) {
                            V.msg = "header crc mismatch", it.mode = lt;
                            break;
                          }
                          Xt = 0, ue = 0;
                        }
                        it.head && (it.head.hcrc = it.flags >> 9 & 1, it.head.done = !0), V.adler = it.check = 0, it.mode = St;
                        break;
                      case Q:
                        for (; ue < 32; ) {
                          if (ie === 0)
                            break t;
                          ie--, Xt += _t[Y++] << ue, ue += 8;
                        }
                        V.adler = it.check = ge(Xt), Xt = 0, ue = 0, it.mode = xt;
                      case xt:
                        if (it.havedict === 0)
                          return V.next_out = Jt, V.avail_out = Tt, V.next_in = Y, V.avail_in = ie, it.hold = Xt, it.bits = ue, w;
                        V.adler = it.check = 1, it.mode = St;
                      case St:
                        if (yt === S || yt === y)
                          break t;
                      case Pt:
                        if (it.last) {
                          Xt >>>= ue & 7, ue -= ue & 7, it.mode = Z;
                          break;
                        }
                        for (; ue < 3; ) {
                          if (ie === 0)
                            break t;
                          ie--, Xt += _t[Y++] << ue, ue += 8;
                        }
                        switch (it.last = Xt & 1, Xt >>>= 1, ue -= 1, Xt & 3) {
                          case 0:
                            it.mode = Gt;
                            break;
                          case 1:
                            if (Be(it), it.mode = st, yt === y) {
                              Xt >>>= 2, ue -= 2;
                              break t;
                            }
                            break;
                          case 2:
                            it.mode = Dt;
                            break;
                          case 3:
                            V.msg = "invalid block type", it.mode = lt;
                        }
                        Xt >>>= 2, ue -= 2;
                        break;
                      case Gt:
                        for (Xt >>>= ue & 7, ue -= ue & 7; ue < 32; ) {
                          if (ie === 0)
                            break t;
                          ie--, Xt += _t[Y++] << ue, ue += 8;
                        }
                        if ((Xt & 65535) !== (Xt >>> 16 ^ 65535)) {
                          V.msg = "invalid stored block lengths", it.mode = lt;
                          break;
                        }
                        if (it.length = Xt & 65535, Xt = 0, ue = 0, it.mode = Rt, yt === y)
                          break t;
                      case Rt:
                        it.mode = bt;
                      case bt:
                        if (Xe = it.length, Xe) {
                          if (Xe > ie && (Xe = ie), Xe > Tt && (Xe = Tt), Xe === 0)
                            break t;
                          s.arraySet(ne, _t, Y, Xe, Jt), ie -= Xe, Y += Xe, Tt -= Xe, Jt += Xe, it.length -= Xe;
                          break;
                        }
                        it.mode = St;
                        break;
                      case Dt:
                        for (; ue < 14; ) {
                          if (ie === 0)
                            break t;
                          ie--, Xt += _t[Y++] << ue, ue += 8;
                        }
                        if (it.nlen = (Xt & 31) + 257, Xt >>>= 5, ue -= 5, it.ndist = (Xt & 31) + 1, Xt >>>= 5, ue -= 5, it.ncode = (Xt & 15) + 4, Xt >>>= 4, ue -= 4, it.nlen > 286 || it.ndist > 30) {
                          V.msg = "too many length or distance symbols", it.mode = lt;
                          break;
                        }
                        it.have = 0, it.mode = X;
                      case X:
                        for (; it.have < it.ncode; ) {
                          for (; ue < 3; ) {
                            if (ie === 0)
                              break t;
                            ie--, Xt += _t[Y++] << ue, ue += 8;
                          }
                          it.lens[wi[it.have++]] = Xt & 7, Xt >>>= 3, ue -= 3;
                        }
                        for (; it.have < 19; )
                          it.lens[wi[it.have++]] = 0;
                        if (it.lencode = it.lendyn, it.lenbits = 7, gn = { bits: it.lenbits }, Tn = v(p, it.lens, 0, 19, it.lencode, 0, it.work, gn), it.lenbits = gn.bits, Tn) {
                          V.msg = "invalid code lengths set", it.mode = lt;
                          break;
                        }
                        it.have = 0, it.mode = gt;
                      case gt:
                        for (; it.have < it.nlen + it.ndist; ) {
                          for (; vr = it.lencode[Xt & (1 << it.lenbits) - 1], nr = vr >>> 24, Fr = vr >>> 16 & 255, Jr = vr & 65535, !(nr <= ue); ) {
                            if (ie === 0)
                              break t;
                            ie--, Xt += _t[Y++] << ue, ue += 8;
                          }
                          if (Jr < 16)
                            Xt >>>= nr, ue -= nr, it.lens[it.have++] = Jr;
                          else {
                            if (Jr === 16) {
                              for (un = nr + 2; ue < un; ) {
                                if (ie === 0)
                                  break t;
                                ie--, Xt += _t[Y++] << ue, ue += 8;
                              }
                              if (Xt >>>= nr, ue -= nr, it.have === 0) {
                                V.msg = "invalid bit length repeat", it.mode = lt;
                                break;
                              }
                              yr = it.lens[it.have - 1], Xe = 3 + (Xt & 3), Xt >>>= 2, ue -= 2;
                            } else if (Jr === 17) {
                              for (un = nr + 3; ue < un; ) {
                                if (ie === 0)
                                  break t;
                                ie--, Xt += _t[Y++] << ue, ue += 8;
                              }
                              Xt >>>= nr, ue -= nr, yr = 0, Xe = 3 + (Xt & 7), Xt >>>= 3, ue -= 3;
                            } else {
                              for (un = nr + 7; ue < un; ) {
                                if (ie === 0)
                                  break t;
                                ie--, Xt += _t[Y++] << ue, ue += 8;
                              }
                              Xt >>>= nr, ue -= nr, yr = 0, Xe = 11 + (Xt & 127), Xt >>>= 7, ue -= 7;
                            }
                            if (it.have + Xe > it.nlen + it.ndist) {
                              V.msg = "invalid bit length repeat", it.mode = lt;
                              break;
                            }
                            for (; Xe--; )
                              it.lens[it.have++] = yr;
                          }
                        }
                        if (it.mode === lt)
                          break;
                        if (it.lens[256] === 0) {
                          V.msg = "invalid code -- missing end-of-block", it.mode = lt;
                          break;
                        }
                        if (it.lenbits = 9, gn = { bits: it.lenbits }, Tn = v(m, it.lens, 0, it.nlen, it.lencode, 0, it.work, gn), it.lenbits = gn.bits, Tn) {
                          V.msg = "invalid literal/lengths set", it.mode = lt;
                          break;
                        }
                        if (it.distbits = 6, it.distcode = it.distdyn, gn = { bits: it.distbits }, Tn = v(x, it.lens, it.nlen, it.ndist, it.distcode, 0, it.work, gn), it.distbits = gn.bits, Tn) {
                          V.msg = "invalid distances set", it.mode = lt;
                          break;
                        }
                        if (it.mode = st, yt === y)
                          break t;
                      case st:
                        it.mode = rt;
                      case rt:
                        if (ie >= 6 && Tt >= 258) {
                          V.next_out = Jt, V.avail_out = Tt, V.next_in = Y, V.avail_in = ie, it.hold = Xt, it.bits = ue, h(V, ke), Jt = V.next_out, ne = V.output, Tt = V.avail_out, Y = V.next_in, _t = V.input, ie = V.avail_in, Xt = it.hold, ue = it.bits, it.mode === St && (it.back = -1);
                          break;
                        }
                        for (it.back = 0; vr = it.lencode[Xt & (1 << it.lenbits) - 1], nr = vr >>> 24, Fr = vr >>> 16 & 255, Jr = vr & 65535, !(nr <= ue); ) {
                          if (ie === 0)
                            break t;
                          ie--, Xt += _t[Y++] << ue, ue += 8;
                        }
                        if (Fr && !(Fr & 240)) {
                          for (dn = nr, kn = Fr, Yn = Jr; vr = it.lencode[Yn + ((Xt & (1 << dn + kn) - 1) >> dn)], nr = vr >>> 24, Fr = vr >>> 16 & 255, Jr = vr & 65535, !(dn + nr <= ue); ) {
                            if (ie === 0)
                              break t;
                            ie--, Xt += _t[Y++] << ue, ue += 8;
                          }
                          Xt >>>= dn, ue -= dn, it.back += dn;
                        }
                        if (Xt >>>= nr, ue -= nr, it.back += nr, it.length = Jr, Fr === 0) {
                          it.mode = D;
                          break;
                        }
                        if (Fr & 32) {
                          it.back = -1, it.mode = St;
                          break;
                        }
                        if (Fr & 64) {
                          V.msg = "invalid literal/length code", it.mode = lt;
                          break;
                        }
                        it.extra = Fr & 15, it.mode = wt;
                      case wt:
                        if (it.extra) {
                          for (un = it.extra; ue < un; ) {
                            if (ie === 0)
                              break t;
                            ie--, Xt += _t[Y++] << ue, ue += 8;
                          }
                          it.length += Xt & (1 << it.extra) - 1, Xt >>>= it.extra, ue -= it.extra, it.back += it.extra;
                        }
                        it.was = it.length, it.mode = Ft;
                      case Ft:
                        for (; vr = it.distcode[Xt & (1 << it.distbits) - 1], nr = vr >>> 24, Fr = vr >>> 16 & 255, Jr = vr & 65535, !(nr <= ue); ) {
                          if (ie === 0)
                            break t;
                          ie--, Xt += _t[Y++] << ue, ue += 8;
                        }
                        if (!(Fr & 240)) {
                          for (dn = nr, kn = Fr, Yn = Jr; vr = it.distcode[Yn + ((Xt & (1 << dn + kn) - 1) >> dn)], nr = vr >>> 24, Fr = vr >>> 16 & 255, Jr = vr & 65535, !(dn + nr <= ue); ) {
                            if (ie === 0)
                              break t;
                            ie--, Xt += _t[Y++] << ue, ue += 8;
                          }
                          Xt >>>= dn, ue -= dn, it.back += dn;
                        }
                        if (Xt >>>= nr, ue -= nr, it.back += nr, Fr & 64) {
                          V.msg = "invalid distance code", it.mode = lt;
                          break;
                        }
                        it.offset = Jr, it.extra = Fr & 15, it.mode = zt;
                      case zt:
                        if (it.extra) {
                          for (un = it.extra; ue < un; ) {
                            if (ie === 0)
                              break t;
                            ie--, Xt += _t[Y++] << ue, ue += 8;
                          }
                          it.offset += Xt & (1 << it.extra) - 1, Xt >>>= it.extra, ue -= it.extra, it.back += it.extra;
                        }
                        if (it.offset > it.dmax) {
                          V.msg = "invalid distance too far back", it.mode = lt;
                          break;
                        }
                        it.mode = G;
                      case G:
                        if (Tt === 0)
                          break t;
                        if (Xe = ke - Tt, it.offset > Xe) {
                          if (Xe = it.offset - Xe, Xe > it.whave && it.sane) {
                            V.msg = "invalid distance too far back", it.mode = lt;
                            break;
                          }
                          Xe > it.wnext ? (Xe -= it.wnext, je = it.wsize - Xe) : je = it.wnext - Xe, Xe > it.length && (Xe = it.length), Wr = it.window;
                        } else
                          Wr = ne, je = Jt - it.offset, Xe = it.length;
                        Xe > Tt && (Xe = Tt), Tt -= Xe, it.length -= Xe;
                        do
                          ne[Jt++] = Wr[je++];
                        while (--Xe);
                        it.length === 0 && (it.mode = rt);
                        break;
                      case D:
                        if (Tt === 0)
                          break t;
                        ne[Jt++] = it.length, Tt--, it.mode = rt;
                        break;
                      case Z:
                        if (it.wrap) {
                          for (; ue < 32; ) {
                            if (ie === 0)
                              break t;
                            ie--, Xt |= _t[Y++] << ue, ue += 8;
                          }
                          if (ke -= Tt, V.total_out += ke, it.total += ke, ke && (V.adler = it.check = /*UPDATE(state.check, put - _out, _out);*/
                          it.flags ? f(it.check, ne, ke, Jt - ke) : i(it.check, ne, ke, Jt - ke)), ke = Tt, (it.flags ? Xt : ge(Xt)) !== it.check) {
                            V.msg = "incorrect data check", it.mode = lt;
                            break;
                          }
                          Xt = 0, ue = 0;
                        }
                        it.mode = et;
                      case et:
                        if (it.wrap && it.flags) {
                          for (; ue < 32; ) {
                            if (ie === 0)
                              break t;
                            ie--, Xt += _t[Y++] << ue, ue += 8;
                          }
                          if (Xt !== (it.total & 4294967295)) {
                            V.msg = "incorrect length check", it.mode = lt;
                            break;
                          }
                          Xt = 0, ue = 0;
                        }
                        it.mode = vt;
                      case vt:
                        Tn = n;
                        break t;
                      case lt:
                        Tn = A;
                        break t;
                      case dt:
                        return O;
                      case kt:
                      default:
                        return E;
                    }
                return V.next_out = Jt, V.avail_out = Tt, V.next_in = Y, V.avail_in = ie, it.hold = Xt, it.bits = ue, (it.wsize || ke !== V.avail_out && it.mode < lt && (it.mode < Z || yt !== g)) && De(V, V.output, V.next_out, ke - V.avail_out), Ve -= V.avail_in, ke -= V.avail_out, V.total_in += Ve, V.total_out += ke, it.total += ke, it.wrap && ke && (V.adler = it.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
                it.flags ? f(it.check, ne, ke, V.next_out - ke) : i(it.check, ne, ke, V.next_out - ke)), V.data_type = it.bits + (it.last ? 64 : 0) + (it.mode === St ? 128 : 0) + (it.mode === st || it.mode === Rt ? 256 : 0), (Ve === 0 && ke === 0 || yt === g) && Tn === b && (Tn = C), Tn;
              }
              function he(V) {
                if (!V || !V.state)
                  return E;
                var yt = V.state;
                return yt.window && (yt.window = null), V.state = null, b;
              }
              function nt(V, yt) {
                var it;
                return !V || !V.state || (it = V.state, !(it.wrap & 2)) ? E : (it.head = yt, yt.done = !1, b);
              }
              function j(V, yt) {
                var it = yt.length, _t, ne, Y;
                return !V || !V.state || (_t = V.state, _t.wrap !== 0 && _t.mode !== xt) ? E : _t.mode === xt && (ne = 1, ne = i(ne, yt, it, 0), ne !== _t.check) ? A : (Y = De(V, yt, it, it), Y ? (_t.mode = dt, O) : (_t.havedict = 1, b));
              }
              l.inflateReset = xe, l.inflateReset2 = Fe, l.inflateResetKeep = Te, l.inflateInit = qt, l.inflateInit2 = Zt, l.inflate = It, l.inflateEnd = he, l.inflateGetHeader = nt, l.inflateSetDictionary = j, l.inflateInfo = "pako inflate (from Nodeca project)";
            }
          ),
          /***/
          92920: (
            /***/
            function(u, l, e) {
              var s = e(72519), i = 15, f = 852, h = 592, v = 0, p = 1, m = 2, x = [
                /* Length codes 257..285 base */
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                13,
                15,
                17,
                19,
                23,
                27,
                31,
                35,
                43,
                51,
                59,
                67,
                83,
                99,
                115,
                131,
                163,
                195,
                227,
                258,
                0,
                0
              ], g = [
                /* Length codes 257..285 extra */
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                17,
                17,
                17,
                17,
                18,
                18,
                18,
                18,
                19,
                19,
                19,
                19,
                20,
                20,
                20,
                20,
                21,
                21,
                21,
                21,
                16,
                72,
                78
              ], S = [
                /* Distance codes 0..29 base */
                1,
                2,
                3,
                4,
                5,
                7,
                9,
                13,
                17,
                25,
                33,
                49,
                65,
                97,
                129,
                193,
                257,
                385,
                513,
                769,
                1025,
                1537,
                2049,
                3073,
                4097,
                6145,
                8193,
                12289,
                16385,
                24577,
                0,
                0
              ], y = [
                /* Distance codes 0..29 extra */
                16,
                16,
                16,
                16,
                17,
                17,
                18,
                18,
                19,
                19,
                20,
                20,
                21,
                21,
                22,
                22,
                23,
                23,
                24,
                24,
                25,
                25,
                26,
                26,
                27,
                27,
                28,
                28,
                29,
                29,
                64,
                64
              ];
              u.exports = function(n, w, E, A, O, C, T, P) {
                var I = P.bits, F = 0, B = 0, M = 0, z = 0, L = 0, J = 0, ft = 0, Q = 0, xt = 0, St = 0, Pt, Gt, Rt, bt, Dt, X = null, gt = 0, st, rt = new s.Buf16(i + 1), wt = new s.Buf16(i + 1), Ft = null, zt = 0, G, D, Z;
                for (F = 0; F <= i; F++)
                  rt[F] = 0;
                for (B = 0; B < A; B++)
                  rt[w[E + B]]++;
                for (L = I, z = i; z >= 1 && rt[z] === 0; z--)
                  ;
                if (L > z && (L = z), z === 0)
                  return O[C++] = 20971520, O[C++] = 20971520, P.bits = 1, 0;
                for (M = 1; M < z && rt[M] === 0; M++)
                  ;
                for (L < M && (L = M), Q = 1, F = 1; F <= i; F++)
                  if (Q <<= 1, Q -= rt[F], Q < 0)
                    return -1;
                if (Q > 0 && (n === v || z !== 1))
                  return -1;
                for (wt[1] = 0, F = 1; F < i; F++)
                  wt[F + 1] = wt[F] + rt[F];
                for (B = 0; B < A; B++)
                  w[E + B] !== 0 && (T[wt[w[E + B]]++] = B);
                if (n === v ? (X = Ft = T, st = 19) : n === p ? (X = x, gt -= 257, Ft = g, zt -= 257, st = 256) : (X = S, Ft = y, st = -1), St = 0, B = 0, F = M, Dt = C, J = L, ft = 0, Rt = -1, xt = 1 << L, bt = xt - 1, n === p && xt > f || n === m && xt > h)
                  return 1;
                for (; ; ) {
                  G = F - ft, T[B] < st ? (D = 0, Z = T[B]) : T[B] > st ? (D = Ft[zt + T[B]], Z = X[gt + T[B]]) : (D = 96, Z = 0), Pt = 1 << F - ft, Gt = 1 << J, M = Gt;
                  do
                    Gt -= Pt, O[Dt + (St >> ft) + Gt] = G << 24 | D << 16 | Z | 0;
                  while (Gt !== 0);
                  for (Pt = 1 << F - 1; St & Pt; )
                    Pt >>= 1;
                  if (Pt !== 0 ? (St &= Pt - 1, St += Pt) : St = 0, B++, --rt[F] === 0) {
                    if (F === z)
                      break;
                    F = w[E + T[B]];
                  }
                  if (F > L && (St & bt) !== Rt) {
                    for (ft === 0 && (ft = L), Dt += M, J = F - ft, Q = 1 << J; J + ft < z && (Q -= rt[J + ft], !(Q <= 0)); )
                      J++, Q <<= 1;
                    if (xt += 1 << J, n === p && xt > f || n === m && xt > h)
                      return 1;
                    Rt = St & bt, O[Rt] = L << 24 | J << 16 | Dt - C | 0;
                  }
                }
                return St !== 0 && (O[Dt + St] = F - ft << 24 | 4194304 | 0), P.bits = L, 0;
              };
            }
          ),
          /***/
          56228: (
            /***/
            function(u) {
              u.exports = {
                2: "need dictionary",
                /* Z_NEED_DICT       2  */
                1: "stream end",
                /* Z_STREAM_END      1  */
                0: "",
                /* Z_OK              0  */
                "-1": "file error",
                /* Z_ERRNO         (-1) */
                "-2": "stream error",
                /* Z_STREAM_ERROR  (-2) */
                "-3": "data error",
                /* Z_DATA_ERROR    (-3) */
                "-4": "insufficient memory",
                /* Z_MEM_ERROR     (-4) */
                "-5": "buffer error",
                /* Z_BUF_ERROR     (-5) */
                "-6": "incompatible version"
                /* Z_VERSION_ERROR (-6) */
              };
            }
          ),
          /***/
          22367: (
            /***/
            function(u, l, e) {
              var s = e(72519), i = 4, f = 0, h = 1, v = 2;
              function p(It) {
                for (var he = It.length; --he >= 0; )
                  It[he] = 0;
              }
              var m = 0, x = 1, g = 2, S = 3, y = 258, b = 29, n = 256, w = n + 1 + b, E = 30, A = 19, O = 2 * w + 1, C = 15, T = 16, P = 7, I = 256, F = 16, B = 17, M = 18, z = (
                /* extra bits for each length code */
                [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]
              ), L = (
                /* extra bits for each distance code */
                [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]
              ), J = (
                /* extra bits for each bit length code */
                [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]
              ), ft = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], Q = 512, xt = new Array((w + 2) * 2);
              p(xt);
              var St = new Array(E * 2);
              p(St);
              var Pt = new Array(Q);
              p(Pt);
              var Gt = new Array(y - S + 1);
              p(Gt);
              var Rt = new Array(b);
              p(Rt);
              var bt = new Array(E);
              p(bt);
              function Dt(It, he, nt, j, V) {
                this.static_tree = It, this.extra_bits = he, this.extra_base = nt, this.elems = j, this.max_length = V, this.has_stree = It && It.length;
              }
              var X, gt, st;
              function rt(It, he) {
                this.dyn_tree = It, this.max_code = 0, this.stat_desc = he;
              }
              function wt(It) {
                return It < 256 ? Pt[It] : Pt[256 + (It >>> 7)];
              }
              function Ft(It, he) {
                It.pending_buf[It.pending++] = he & 255, It.pending_buf[It.pending++] = he >>> 8 & 255;
              }
              function zt(It, he, nt) {
                It.bi_valid > T - nt ? (It.bi_buf |= he << It.bi_valid & 65535, Ft(It, It.bi_buf), It.bi_buf = he >> T - It.bi_valid, It.bi_valid += nt - T) : (It.bi_buf |= he << It.bi_valid & 65535, It.bi_valid += nt);
              }
              function G(It, he, nt) {
                zt(
                  It,
                  nt[he * 2],
                  nt[he * 2 + 1]
                  /*.Len*/
                );
              }
              function D(It, he) {
                var nt = 0;
                do
                  nt |= It & 1, It >>>= 1, nt <<= 1;
                while (--he > 0);
                return nt >>> 1;
              }
              function Z(It) {
                It.bi_valid === 16 ? (Ft(It, It.bi_buf), It.bi_buf = 0, It.bi_valid = 0) : It.bi_valid >= 8 && (It.pending_buf[It.pending++] = It.bi_buf & 255, It.bi_buf >>= 8, It.bi_valid -= 8);
              }
              function et(It, he) {
                var nt = he.dyn_tree, j = he.max_code, V = he.stat_desc.static_tree, yt = he.stat_desc.has_stree, it = he.stat_desc.extra_bits, _t = he.stat_desc.extra_base, ne = he.stat_desc.max_length, Y, Jt, ie, Tt, Xt, ue, Ve = 0;
                for (Tt = 0; Tt <= C; Tt++)
                  It.bl_count[Tt] = 0;
                for (nt[It.heap[It.heap_max] * 2 + 1] = 0, Y = It.heap_max + 1; Y < O; Y++)
                  Jt = It.heap[Y], Tt = nt[nt[Jt * 2 + 1] * 2 + 1] + 1, Tt > ne && (Tt = ne, Ve++), nt[Jt * 2 + 1] = Tt, !(Jt > j) && (It.bl_count[Tt]++, Xt = 0, Jt >= _t && (Xt = it[Jt - _t]), ue = nt[Jt * 2], It.opt_len += ue * (Tt + Xt), yt && (It.static_len += ue * (V[Jt * 2 + 1] + Xt)));
                if (Ve !== 0) {
                  do {
                    for (Tt = ne - 1; It.bl_count[Tt] === 0; )
                      Tt--;
                    It.bl_count[Tt]--, It.bl_count[Tt + 1] += 2, It.bl_count[ne]--, Ve -= 2;
                  } while (Ve > 0);
                  for (Tt = ne; Tt !== 0; Tt--)
                    for (Jt = It.bl_count[Tt]; Jt !== 0; )
                      ie = It.heap[--Y], !(ie > j) && (nt[ie * 2 + 1] !== Tt && (It.opt_len += (Tt - nt[ie * 2 + 1]) * nt[ie * 2], nt[ie * 2 + 1] = Tt), Jt--);
                }
              }
              function vt(It, he, nt) {
                var j = new Array(C + 1), V = 0, yt, it;
                for (yt = 1; yt <= C; yt++)
                  j[yt] = V = V + nt[yt - 1] << 1;
                for (it = 0; it <= he; it++) {
                  var _t = It[it * 2 + 1];
                  _t !== 0 && (It[it * 2] = D(j[_t]++, _t));
                }
              }
              function lt() {
                var It, he, nt, j, V, yt = new Array(C + 1);
                for (nt = 0, j = 0; j < b - 1; j++)
                  for (Rt[j] = nt, It = 0; It < 1 << z[j]; It++)
                    Gt[nt++] = j;
                for (Gt[nt - 1] = j, V = 0, j = 0; j < 16; j++)
                  for (bt[j] = V, It = 0; It < 1 << L[j]; It++)
                    Pt[V++] = j;
                for (V >>= 7; j < E; j++)
                  for (bt[j] = V << 7, It = 0; It < 1 << L[j] - 7; It++)
                    Pt[256 + V++] = j;
                for (he = 0; he <= C; he++)
                  yt[he] = 0;
                for (It = 0; It <= 143; )
                  xt[It * 2 + 1] = 8, It++, yt[8]++;
                for (; It <= 255; )
                  xt[It * 2 + 1] = 9, It++, yt[9]++;
                for (; It <= 279; )
                  xt[It * 2 + 1] = 7, It++, yt[7]++;
                for (; It <= 287; )
                  xt[It * 2 + 1] = 8, It++, yt[8]++;
                for (vt(xt, w + 1, yt), It = 0; It < E; It++)
                  St[It * 2 + 1] = 5, St[It * 2] = D(It, 5);
                X = new Dt(xt, z, n + 1, w, C), gt = new Dt(St, L, 0, E, C), st = new Dt(new Array(0), J, 0, A, P);
              }
              function dt(It) {
                var he;
                for (he = 0; he < w; he++)
                  It.dyn_ltree[he * 2] = 0;
                for (he = 0; he < E; he++)
                  It.dyn_dtree[he * 2] = 0;
                for (he = 0; he < A; he++)
                  It.bl_tree[he * 2] = 0;
                It.dyn_ltree[I * 2] = 1, It.opt_len = It.static_len = 0, It.last_lit = It.matches = 0;
              }
              function kt(It) {
                It.bi_valid > 8 ? Ft(It, It.bi_buf) : It.bi_valid > 0 && (It.pending_buf[It.pending++] = It.bi_buf), It.bi_buf = 0, It.bi_valid = 0;
              }
              function jt(It, he, nt, j) {
                kt(It), j && (Ft(It, nt), Ft(It, ~nt)), s.arraySet(It.pending_buf, It.window, he, nt, It.pending), It.pending += nt;
              }
              function me(It, he, nt, j) {
                var V = he * 2, yt = nt * 2;
                return It[V] < It[yt] || It[V] === It[yt] && j[he] <= j[nt];
              }
              function se(It, he, nt) {
                for (var j = It.heap[nt], V = nt << 1; V <= It.heap_len && (V < It.heap_len && me(he, It.heap[V + 1], It.heap[V], It.depth) && V++, !me(he, j, It.heap[V], It.depth)); )
                  It.heap[nt] = It.heap[V], nt = V, V <<= 1;
                It.heap[nt] = j;
              }
              function Bt(It, he, nt) {
                var j, V, yt = 0, it, _t;
                if (It.last_lit !== 0)
                  do
                    j = It.pending_buf[It.d_buf + yt * 2] << 8 | It.pending_buf[It.d_buf + yt * 2 + 1], V = It.pending_buf[It.l_buf + yt], yt++, j === 0 ? G(It, V, he) : (it = Gt[V], G(It, it + n + 1, he), _t = z[it], _t !== 0 && (V -= Rt[it], zt(It, V, _t)), j--, it = wt(j), G(It, it, nt), _t = L[it], _t !== 0 && (j -= bt[it], zt(It, j, _t)));
                  while (yt < It.last_lit);
                G(It, I, he);
              }
              function ge(It, he) {
                var nt = he.dyn_tree, j = he.stat_desc.static_tree, V = he.stat_desc.has_stree, yt = he.stat_desc.elems, it, _t, ne = -1, Y;
                for (It.heap_len = 0, It.heap_max = O, it = 0; it < yt; it++)
                  nt[it * 2] !== 0 ? (It.heap[++It.heap_len] = ne = it, It.depth[it] = 0) : nt[it * 2 + 1] = 0;
                for (; It.heap_len < 2; )
                  Y = It.heap[++It.heap_len] = ne < 2 ? ++ne : 0, nt[Y * 2] = 1, It.depth[Y] = 0, It.opt_len--, V && (It.static_len -= j[Y * 2 + 1]);
                for (he.max_code = ne, it = It.heap_len >> 1; it >= 1; it--)
                  se(It, nt, it);
                Y = yt;
                do
                  it = It.heap[
                    1
                    /*SMALLEST*/
                  ], It.heap[
                    1
                    /*SMALLEST*/
                  ] = It.heap[It.heap_len--], se(
                    It,
                    nt,
                    1
                    /*SMALLEST*/
                  ), _t = It.heap[
                    1
                    /*SMALLEST*/
                  ], It.heap[--It.heap_max] = it, It.heap[--It.heap_max] = _t, nt[Y * 2] = nt[it * 2] + nt[_t * 2], It.depth[Y] = (It.depth[it] >= It.depth[_t] ? It.depth[it] : It.depth[_t]) + 1, nt[it * 2 + 1] = nt[_t * 2 + 1] = Y, It.heap[
                    1
                    /*SMALLEST*/
                  ] = Y++, se(
                    It,
                    nt,
                    1
                    /*SMALLEST*/
                  );
                while (It.heap_len >= 2);
                It.heap[--It.heap_max] = It.heap[
                  1
                  /*SMALLEST*/
                ], et(It, he), vt(nt, ne, It.bl_count);
              }
              function Re(It, he, nt) {
                var j, V = -1, yt, it = he[0 * 2 + 1], _t = 0, ne = 7, Y = 4;
                for (it === 0 && (ne = 138, Y = 3), he[(nt + 1) * 2 + 1] = 65535, j = 0; j <= nt; j++)
                  yt = it, it = he[(j + 1) * 2 + 1], !(++_t < ne && yt === it) && (_t < Y ? It.bl_tree[yt * 2] += _t : yt !== 0 ? (yt !== V && It.bl_tree[yt * 2]++, It.bl_tree[F * 2]++) : _t <= 10 ? It.bl_tree[B * 2]++ : It.bl_tree[M * 2]++, _t = 0, V = yt, it === 0 ? (ne = 138, Y = 3) : yt === it ? (ne = 6, Y = 3) : (ne = 7, Y = 4));
              }
              function Te(It, he, nt) {
                var j, V = -1, yt, it = he[0 * 2 + 1], _t = 0, ne = 7, Y = 4;
                for (it === 0 && (ne = 138, Y = 3), j = 0; j <= nt; j++)
                  if (yt = it, it = he[(j + 1) * 2 + 1], !(++_t < ne && yt === it)) {
                    if (_t < Y)
                      do
                        G(It, yt, It.bl_tree);
                      while (--_t !== 0);
                    else
                      yt !== 0 ? (yt !== V && (G(It, yt, It.bl_tree), _t--), G(It, F, It.bl_tree), zt(It, _t - 3, 2)) : _t <= 10 ? (G(It, B, It.bl_tree), zt(It, _t - 3, 3)) : (G(It, M, It.bl_tree), zt(It, _t - 11, 7));
                    _t = 0, V = yt, it === 0 ? (ne = 138, Y = 3) : yt === it ? (ne = 6, Y = 3) : (ne = 7, Y = 4);
                  }
              }
              function xe(It) {
                var he;
                for (Re(It, It.dyn_ltree, It.l_desc.max_code), Re(It, It.dyn_dtree, It.d_desc.max_code), ge(It, It.bl_desc), he = A - 1; he >= 3 && It.bl_tree[ft[he] * 2 + 1] === 0; he--)
                  ;
                return It.opt_len += 3 * (he + 1) + 5 + 5 + 4, he;
              }
              function Fe(It, he, nt, j) {
                var V;
                for (zt(It, he - 257, 5), zt(It, nt - 1, 5), zt(It, j - 4, 4), V = 0; V < j; V++)
                  zt(It, It.bl_tree[ft[V] * 2 + 1], 3);
                Te(It, It.dyn_ltree, he - 1), Te(It, It.dyn_dtree, nt - 1);
              }
              function Zt(It) {
                var he = 4093624447, nt;
                for (nt = 0; nt <= 31; nt++, he >>>= 1)
                  if (he & 1 && It.dyn_ltree[nt * 2] !== 0)
                    return f;
                if (It.dyn_ltree[18] !== 0 || It.dyn_ltree[20] !== 0 || It.dyn_ltree[26] !== 0)
                  return h;
                for (nt = 32; nt < n; nt++)
                  if (It.dyn_ltree[nt * 2] !== 0)
                    return h;
                return f;
              }
              var qt = !1;
              function ve(It) {
                qt || (lt(), qt = !0), It.l_desc = new rt(It.dyn_ltree, X), It.d_desc = new rt(It.dyn_dtree, gt), It.bl_desc = new rt(It.bl_tree, st), It.bi_buf = 0, It.bi_valid = 0, dt(It);
              }
              function Se(It, he, nt, j) {
                zt(It, (m << 1) + (j ? 1 : 0), 3), jt(It, he, nt, !0);
              }
              function Pe(It) {
                zt(It, x << 1, 3), G(It, I, xt), Z(It);
              }
              function Be(It, he, nt, j) {
                var V, yt, it = 0;
                It.level > 0 ? (It.strm.data_type === v && (It.strm.data_type = Zt(It)), ge(It, It.l_desc), ge(It, It.d_desc), it = xe(It), V = It.opt_len + 3 + 7 >>> 3, yt = It.static_len + 3 + 7 >>> 3, yt <= V && (V = yt)) : V = yt = nt + 5, nt + 4 <= V && he !== -1 ? Se(It, he, nt, j) : It.strategy === i || yt === V ? (zt(It, (x << 1) + (j ? 1 : 0), 3), Bt(It, xt, St)) : (zt(It, (g << 1) + (j ? 1 : 0), 3), Fe(It, It.l_desc.max_code + 1, It.d_desc.max_code + 1, it + 1), Bt(It, It.dyn_ltree, It.dyn_dtree)), dt(It), j && kt(It);
              }
              function De(It, he, nt) {
                return It.pending_buf[It.d_buf + It.last_lit * 2] = he >>> 8 & 255, It.pending_buf[It.d_buf + It.last_lit * 2 + 1] = he & 255, It.pending_buf[It.l_buf + It.last_lit] = nt & 255, It.last_lit++, he === 0 ? It.dyn_ltree[nt * 2]++ : (It.matches++, he--, It.dyn_ltree[(Gt[nt] + n + 1) * 2]++, It.dyn_dtree[wt(he) * 2]++), It.last_lit === It.lit_bufsize - 1;
              }
              l._tr_init = ve, l._tr_stored_block = Se, l._tr_flush_block = Be, l._tr_tally = De, l._tr_align = Pe;
            }
          ),
          /***/
          37468: (
            /***/
            function(u) {
              function l() {
                this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
              }
              u.exports = l;
            }
          ),
          /***/
          10884: (
            /***/
            function(u) {
              u.exports = [
                "Float32Array",
                "Float64Array",
                "Int8Array",
                "Int16Array",
                "Int32Array",
                "Uint8Array",
                "Uint8ClampedArray",
                "Uint16Array",
                "Uint32Array",
                "BigInt64Array",
                "BigUint64Array"
              ];
            }
          ),
          /***/
          9964: (
            /***/
            function(u) {
              var l = u.exports = {}, e, s;
              function i() {
                throw new Error("setTimeout has not been defined");
              }
              function f() {
                throw new Error("clearTimeout has not been defined");
              }
              (function() {
                try {
                  typeof setTimeout == "function" ? e = setTimeout : e = i;
                } catch {
                  e = i;
                }
                try {
                  typeof clearTimeout == "function" ? s = clearTimeout : s = f;
                } catch {
                  s = f;
                }
              })();
              function h(w) {
                if (e === setTimeout)
                  return setTimeout(w, 0);
                if ((e === i || !e) && setTimeout)
                  return e = setTimeout, setTimeout(w, 0);
                try {
                  return e(w, 0);
                } catch {
                  try {
                    return e.call(null, w, 0);
                  } catch {
                    return e.call(this, w, 0);
                  }
                }
              }
              function v(w) {
                if (s === clearTimeout)
                  return clearTimeout(w);
                if ((s === f || !s) && clearTimeout)
                  return s = clearTimeout, clearTimeout(w);
                try {
                  return s(w);
                } catch {
                  try {
                    return s.call(null, w);
                  } catch {
                    return s.call(this, w);
                  }
                }
              }
              var p = [], m = !1, x, g = -1;
              function S() {
                !m || !x || (m = !1, x.length ? p = x.concat(p) : g = -1, p.length && y());
              }
              function y() {
                if (!m) {
                  var w = h(S);
                  m = !0;
                  for (var E = p.length; E; ) {
                    for (x = p, p = []; ++g < E; )
                      x && x[g].run();
                    g = -1, E = p.length;
                  }
                  x = null, m = !1, v(w);
                }
              }
              l.nextTick = function(w) {
                var E = new Array(arguments.length - 1);
                if (arguments.length > 1)
                  for (var A = 1; A < arguments.length; A++)
                    E[A - 1] = arguments[A];
                p.push(new b(w, E)), p.length === 1 && !m && h(y);
              };
              function b(w, E) {
                this.fun = w, this.array = E;
              }
              b.prototype.run = function() {
                this.fun.apply(null, this.array);
              }, l.title = "browser", l.browser = !0, l.env = {}, l.argv = [], l.version = "", l.versions = {};
              function n() {
              }
              l.on = n, l.addListener = n, l.once = n, l.off = n, l.removeListener = n, l.removeAllListeners = n, l.emit = n, l.prependListener = n, l.prependOnceListener = n, l.listeners = function(w) {
                return [];
              }, l.binding = function(w) {
                throw new Error("process.binding is not supported");
              }, l.cwd = function() {
                return "/";
              }, l.chdir = function(w) {
                throw new Error("process.chdir is not supported");
              }, l.umask = function() {
                return 0;
              };
            }
          ),
          /***/
          83089: (
            /***/
            function(u, l, e) {
              var s = e(95304), i = e(96785), f = Object;
              u.exports = s(function() {
                if (this == null || this !== f(this))
                  throw new i("RegExp.prototype.flags getter called on non-object");
                var v = "";
                return this.hasIndices && (v += "d"), this.global && (v += "g"), this.ignoreCase && (v += "i"), this.multiline && (v += "m"), this.dotAll && (v += "s"), this.unicode && (v += "u"), this.unicodeSets && (v += "v"), this.sticky && (v += "y"), v;
              }, "get flags", !0);
            }
          ),
          /***/
          64607: (
            /***/
            function(u, l, e) {
              var s = e(77802), i = e(26601), f = e(83089), h = e(7844), v = e(51374), p = i(h());
              s(p, {
                getPolyfill: h,
                implementation: f,
                shim: v
              }), u.exports = p;
            }
          ),
          /***/
          7844: (
            /***/
            function(u, l, e) {
              var s = e(83089), i = e(77802).supportsDescriptors, f = Object.getOwnPropertyDescriptor;
              u.exports = function() {
                if (i && /a/mig.flags === "gim") {
                  var v = f(RegExp.prototype, "flags");
                  if (v && typeof v.get == "function" && typeof RegExp.prototype.dotAll == "boolean" && typeof RegExp.prototype.hasIndices == "boolean") {
                    var p = "", m = {};
                    if (Object.defineProperty(m, "hasIndices", {
                      get: function() {
                        p += "d";
                      }
                    }), Object.defineProperty(m, "sticky", {
                      get: function() {
                        p += "y";
                      }
                    }), p === "dy")
                      return v.get;
                  }
                }
                return s;
              };
            }
          ),
          /***/
          51374: (
            /***/
            function(u, l, e) {
              var s = e(77802).supportsDescriptors, i = e(7844), f = Object.getOwnPropertyDescriptor, h = Object.defineProperty, v = TypeError, p = Object.getPrototypeOf, m = /a/;
              u.exports = function() {
                if (!s || !p)
                  throw new v("RegExp.prototype.flags requires a true ES5 environment that supports property descriptors");
                var g = i(), S = p(m), y = f(S, "flags");
                return (!y || y.get !== g) && h(S, "flags", {
                  configurable: !0,
                  enumerable: !1,
                  get: g
                }), g;
              };
            }
          ),
          /***/
          61733: (
            /***/
            function(u, l, e) {
              var s = e(50621).Buffer;
              (function(i) {
                i.parser = function(G, D) {
                  return new h(G, D);
                }, i.SAXParser = h, i.SAXStream = y, i.createStream = S, i.MAX_BUFFER_LENGTH = 65536;
                var f = [
                  "comment",
                  "sgmlDecl",
                  "textNode",
                  "tagName",
                  "doctype",
                  "procInstName",
                  "procInstBody",
                  "entity",
                  "attribName",
                  "attribValue",
                  "cdata",
                  "script"
                ];
                i.EVENTS = [
                  "text",
                  "processinginstruction",
                  "sgmldeclaration",
                  "doctype",
                  "comment",
                  "opentagstart",
                  "attribute",
                  "opentag",
                  "closetag",
                  "opencdata",
                  "cdata",
                  "closecdata",
                  "error",
                  "end",
                  "ready",
                  "script",
                  "opennamespace",
                  "closenamespace"
                ];
                function h(G, D) {
                  if (!(this instanceof h))
                    return new h(G, D);
                  var Z = this;
                  p(Z), Z.q = Z.c = "", Z.bufferCheckPosition = i.MAX_BUFFER_LENGTH, Z.opt = D || {}, Z.opt.lowercase = Z.opt.lowercase || Z.opt.lowercasetags, Z.looseCase = Z.opt.lowercase ? "toLowerCase" : "toUpperCase", Z.tags = [], Z.closed = Z.closedRoot = Z.sawRoot = !1, Z.tag = Z.error = null, Z.strict = !!G, Z.noscript = !!(G || Z.opt.noscript), Z.state = L.BEGIN, Z.strictEntities = Z.opt.strictEntities, Z.ENTITIES = Z.strictEntities ? Object.create(i.XML_ENTITIES) : Object.create(i.ENTITIES), Z.attribList = [], Z.opt.xmlns && (Z.ns = Object.create(A)), Z.trackPosition = Z.opt.position !== !1, Z.trackPosition && (Z.position = Z.line = Z.column = 0), ft(Z, "onready");
                }
                Object.create || (Object.create = function(G) {
                  function D() {
                  }
                  D.prototype = G;
                  var Z = new D();
                  return Z;
                }), Object.keys || (Object.keys = function(G) {
                  var D = [];
                  for (var Z in G)
                    G.hasOwnProperty(Z) && D.push(Z);
                  return D;
                });
                function v(G) {
                  for (var D = Math.max(i.MAX_BUFFER_LENGTH, 10), Z = 0, et = 0, vt = f.length; et < vt; et++) {
                    var lt = G[f[et]].length;
                    if (lt > D)
                      switch (f[et]) {
                        case "textNode":
                          xt(G);
                          break;
                        case "cdata":
                          Q(G, "oncdata", G.cdata), G.cdata = "";
                          break;
                        case "script":
                          Q(G, "onscript", G.script), G.script = "";
                          break;
                        default:
                          Pt(G, "Max buffer length exceeded: " + f[et]);
                      }
                    Z = Math.max(Z, lt);
                  }
                  var dt = i.MAX_BUFFER_LENGTH - Z;
                  G.bufferCheckPosition = dt + G.position;
                }
                function p(G) {
                  for (var D = 0, Z = f.length; D < Z; D++)
                    G[f[D]] = "";
                }
                function m(G) {
                  xt(G), G.cdata !== "" && (Q(G, "oncdata", G.cdata), G.cdata = ""), G.script !== "" && (Q(G, "onscript", G.script), G.script = "");
                }
                h.prototype = {
                  end: function() {
                    Gt(this);
                  },
                  write: zt,
                  resume: function() {
                    return this.error = null, this;
                  },
                  close: function() {
                    return this.write(null);
                  },
                  flush: function() {
                    m(this);
                  }
                };
                var x;
                try {
                  x = e(9760).Stream;
                } catch {
                  x = function() {
                  };
                }
                x || (x = function() {
                });
                var g = i.EVENTS.filter(function(G) {
                  return G !== "error" && G !== "end";
                });
                function S(G, D) {
                  return new y(G, D);
                }
                function y(G, D) {
                  if (!(this instanceof y))
                    return new y(G, D);
                  x.apply(this), this._parser = new h(G, D), this.writable = !0, this.readable = !0;
                  var Z = this;
                  this._parser.onend = function() {
                    Z.emit("end");
                  }, this._parser.onerror = function(et) {
                    Z.emit("error", et), Z._parser.error = null;
                  }, this._decoder = null, g.forEach(function(et) {
                    Object.defineProperty(Z, "on" + et, {
                      get: function() {
                        return Z._parser["on" + et];
                      },
                      set: function(vt) {
                        if (!vt)
                          return Z.removeAllListeners(et), Z._parser["on" + et] = vt, vt;
                        Z.on(et, vt);
                      },
                      enumerable: !0,
                      configurable: !1
                    });
                  });
                }
                y.prototype = Object.create(x.prototype, {
                  constructor: {
                    value: y
                  }
                }), y.prototype.write = function(G) {
                  if (typeof s == "function" && typeof s.isBuffer == "function" && s.isBuffer(G)) {
                    if (!this._decoder) {
                      var D = e(43143).I;
                      this._decoder = new D("utf8");
                    }
                    G = this._decoder.write(G);
                  }
                  return this._parser.write(G.toString()), this.emit("data", G), !0;
                }, y.prototype.end = function(G) {
                  return G && G.length && this.write(G), this._parser.end(), !0;
                }, y.prototype.on = function(G, D) {
                  var Z = this;
                  return !Z._parser["on" + G] && g.indexOf(G) !== -1 && (Z._parser["on" + G] = function() {
                    var et = arguments.length === 1 ? [arguments[0]] : Array.apply(null, arguments);
                    et.splice(0, 0, G), Z.emit.apply(Z, et);
                  }), x.prototype.on.call(Z, G, D);
                };
                var b = "[CDATA[", n = "DOCTYPE", w = "http://www.w3.org/XML/1998/namespace", E = "http://www.w3.org/2000/xmlns/", A = { xml: w, xmlns: E }, O = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, C = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/, T = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, P = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/;
                function I(G) {
                  return G === " " || G === `
` || G === "\r" || G === "	";
                }
                function F(G) {
                  return G === '"' || G === "'";
                }
                function B(G) {
                  return G === ">" || I(G);
                }
                function M(G, D) {
                  return G.test(D);
                }
                function z(G, D) {
                  return !M(G, D);
                }
                var L = 0;
                i.STATE = {
                  BEGIN: L++,
                  // leading byte order mark or whitespace
                  BEGIN_WHITESPACE: L++,
                  // leading whitespace
                  TEXT: L++,
                  // general stuff
                  TEXT_ENTITY: L++,
                  // &amp and such.
                  OPEN_WAKA: L++,
                  // <
                  SGML_DECL: L++,
                  // <!BLARG
                  SGML_DECL_QUOTED: L++,
                  // <!BLARG foo "bar
                  DOCTYPE: L++,
                  // <!DOCTYPE
                  DOCTYPE_QUOTED: L++,
                  // <!DOCTYPE "//blah
                  DOCTYPE_DTD: L++,
                  // <!DOCTYPE "//blah" [ ...
                  DOCTYPE_DTD_QUOTED: L++,
                  // <!DOCTYPE "//blah" [ "foo
                  COMMENT_STARTING: L++,
                  // <!-
                  COMMENT: L++,
                  // <!--
                  COMMENT_ENDING: L++,
                  // <!-- blah -
                  COMMENT_ENDED: L++,
                  // <!-- blah --
                  CDATA: L++,
                  // <![CDATA[ something
                  CDATA_ENDING: L++,
                  // ]
                  CDATA_ENDING_2: L++,
                  // ]]
                  PROC_INST: L++,
                  // <?hi
                  PROC_INST_BODY: L++,
                  // <?hi there
                  PROC_INST_ENDING: L++,
                  // <?hi "there" ?
                  OPEN_TAG: L++,
                  // <strong
                  OPEN_TAG_SLASH: L++,
                  // <strong /
                  ATTRIB: L++,
                  // <a
                  ATTRIB_NAME: L++,
                  // <a foo
                  ATTRIB_NAME_SAW_WHITE: L++,
                  // <a foo _
                  ATTRIB_VALUE: L++,
                  // <a foo=
                  ATTRIB_VALUE_QUOTED: L++,
                  // <a foo="bar
                  ATTRIB_VALUE_CLOSED: L++,
                  // <a foo="bar"
                  ATTRIB_VALUE_UNQUOTED: L++,
                  // <a foo=bar
                  ATTRIB_VALUE_ENTITY_Q: L++,
                  // <foo bar="&quot;"
                  ATTRIB_VALUE_ENTITY_U: L++,
                  // <foo bar=&quot
                  CLOSE_TAG: L++,
                  // </a
                  CLOSE_TAG_SAW_WHITE: L++,
                  // </a   >
                  SCRIPT: L++,
                  // <script> ...
                  SCRIPT_ENDING: L++
                  // <script> ... <
                }, i.XML_ENTITIES = {
                  amp: "&",
                  gt: ">",
                  lt: "<",
                  quot: '"',
                  apos: "'"
                }, i.ENTITIES = {
                  amp: "&",
                  gt: ">",
                  lt: "<",
                  quot: '"',
                  apos: "'",
                  AElig: 198,
                  Aacute: 193,
                  Acirc: 194,
                  Agrave: 192,
                  Aring: 197,
                  Atilde: 195,
                  Auml: 196,
                  Ccedil: 199,
                  ETH: 208,
                  Eacute: 201,
                  Ecirc: 202,
                  Egrave: 200,
                  Euml: 203,
                  Iacute: 205,
                  Icirc: 206,
                  Igrave: 204,
                  Iuml: 207,
                  Ntilde: 209,
                  Oacute: 211,
                  Ocirc: 212,
                  Ograve: 210,
                  Oslash: 216,
                  Otilde: 213,
                  Ouml: 214,
                  THORN: 222,
                  Uacute: 218,
                  Ucirc: 219,
                  Ugrave: 217,
                  Uuml: 220,
                  Yacute: 221,
                  aacute: 225,
                  acirc: 226,
                  aelig: 230,
                  agrave: 224,
                  aring: 229,
                  atilde: 227,
                  auml: 228,
                  ccedil: 231,
                  eacute: 233,
                  ecirc: 234,
                  egrave: 232,
                  eth: 240,
                  euml: 235,
                  iacute: 237,
                  icirc: 238,
                  igrave: 236,
                  iuml: 239,
                  ntilde: 241,
                  oacute: 243,
                  ocirc: 244,
                  ograve: 242,
                  oslash: 248,
                  otilde: 245,
                  ouml: 246,
                  szlig: 223,
                  thorn: 254,
                  uacute: 250,
                  ucirc: 251,
                  ugrave: 249,
                  uuml: 252,
                  yacute: 253,
                  yuml: 255,
                  copy: 169,
                  reg: 174,
                  nbsp: 160,
                  iexcl: 161,
                  cent: 162,
                  pound: 163,
                  curren: 164,
                  yen: 165,
                  brvbar: 166,
                  sect: 167,
                  uml: 168,
                  ordf: 170,
                  laquo: 171,
                  not: 172,
                  shy: 173,
                  macr: 175,
                  deg: 176,
                  plusmn: 177,
                  sup1: 185,
                  sup2: 178,
                  sup3: 179,
                  acute: 180,
                  micro: 181,
                  para: 182,
                  middot: 183,
                  cedil: 184,
                  ordm: 186,
                  raquo: 187,
                  frac14: 188,
                  frac12: 189,
                  frac34: 190,
                  iquest: 191,
                  times: 215,
                  divide: 247,
                  OElig: 338,
                  oelig: 339,
                  Scaron: 352,
                  scaron: 353,
                  Yuml: 376,
                  fnof: 402,
                  circ: 710,
                  tilde: 732,
                  Alpha: 913,
                  Beta: 914,
                  Gamma: 915,
                  Delta: 916,
                  Epsilon: 917,
                  Zeta: 918,
                  Eta: 919,
                  Theta: 920,
                  Iota: 921,
                  Kappa: 922,
                  Lambda: 923,
                  Mu: 924,
                  Nu: 925,
                  Xi: 926,
                  Omicron: 927,
                  Pi: 928,
                  Rho: 929,
                  Sigma: 931,
                  Tau: 932,
                  Upsilon: 933,
                  Phi: 934,
                  Chi: 935,
                  Psi: 936,
                  Omega: 937,
                  alpha: 945,
                  beta: 946,
                  gamma: 947,
                  delta: 948,
                  epsilon: 949,
                  zeta: 950,
                  eta: 951,
                  theta: 952,
                  iota: 953,
                  kappa: 954,
                  lambda: 955,
                  mu: 956,
                  nu: 957,
                  xi: 958,
                  omicron: 959,
                  pi: 960,
                  rho: 961,
                  sigmaf: 962,
                  sigma: 963,
                  tau: 964,
                  upsilon: 965,
                  phi: 966,
                  chi: 967,
                  psi: 968,
                  omega: 969,
                  thetasym: 977,
                  upsih: 978,
                  piv: 982,
                  ensp: 8194,
                  emsp: 8195,
                  thinsp: 8201,
                  zwnj: 8204,
                  zwj: 8205,
                  lrm: 8206,
                  rlm: 8207,
                  ndash: 8211,
                  mdash: 8212,
                  lsquo: 8216,
                  rsquo: 8217,
                  sbquo: 8218,
                  ldquo: 8220,
                  rdquo: 8221,
                  bdquo: 8222,
                  dagger: 8224,
                  Dagger: 8225,
                  bull: 8226,
                  hellip: 8230,
                  permil: 8240,
                  prime: 8242,
                  Prime: 8243,
                  lsaquo: 8249,
                  rsaquo: 8250,
                  oline: 8254,
                  frasl: 8260,
                  euro: 8364,
                  image: 8465,
                  weierp: 8472,
                  real: 8476,
                  trade: 8482,
                  alefsym: 8501,
                  larr: 8592,
                  uarr: 8593,
                  rarr: 8594,
                  darr: 8595,
                  harr: 8596,
                  crarr: 8629,
                  lArr: 8656,
                  uArr: 8657,
                  rArr: 8658,
                  dArr: 8659,
                  hArr: 8660,
                  forall: 8704,
                  part: 8706,
                  exist: 8707,
                  empty: 8709,
                  nabla: 8711,
                  isin: 8712,
                  notin: 8713,
                  ni: 8715,
                  prod: 8719,
                  sum: 8721,
                  minus: 8722,
                  lowast: 8727,
                  radic: 8730,
                  prop: 8733,
                  infin: 8734,
                  ang: 8736,
                  and: 8743,
                  or: 8744,
                  cap: 8745,
                  cup: 8746,
                  int: 8747,
                  there4: 8756,
                  sim: 8764,
                  cong: 8773,
                  asymp: 8776,
                  ne: 8800,
                  equiv: 8801,
                  le: 8804,
                  ge: 8805,
                  sub: 8834,
                  sup: 8835,
                  nsub: 8836,
                  sube: 8838,
                  supe: 8839,
                  oplus: 8853,
                  otimes: 8855,
                  perp: 8869,
                  sdot: 8901,
                  lceil: 8968,
                  rceil: 8969,
                  lfloor: 8970,
                  rfloor: 8971,
                  lang: 9001,
                  rang: 9002,
                  loz: 9674,
                  spades: 9824,
                  clubs: 9827,
                  hearts: 9829,
                  diams: 9830
                }, Object.keys(i.ENTITIES).forEach(function(G) {
                  var D = i.ENTITIES[G], Z = typeof D == "number" ? String.fromCharCode(D) : D;
                  i.ENTITIES[G] = Z;
                });
                for (var J in i.STATE)
                  i.STATE[i.STATE[J]] = J;
                L = i.STATE;
                function ft(G, D, Z) {
                  G[D] && G[D](Z);
                }
                function Q(G, D, Z) {
                  G.textNode && xt(G), ft(G, D, Z);
                }
                function xt(G) {
                  G.textNode = St(G.opt, G.textNode), G.textNode && ft(G, "ontext", G.textNode), G.textNode = "";
                }
                function St(G, D) {
                  return G.trim && (D = D.trim()), G.normalize && (D = D.replace(/\s+/g, " ")), D;
                }
                function Pt(G, D) {
                  return xt(G), G.trackPosition && (D += `
Line: ` + G.line + `
Column: ` + G.column + `
Char: ` + G.c), D = new Error(D), G.error = D, ft(G, "onerror", D), G;
                }
                function Gt(G) {
                  return G.sawRoot && !G.closedRoot && Rt(G, "Unclosed root tag"), G.state !== L.BEGIN && G.state !== L.BEGIN_WHITESPACE && G.state !== L.TEXT && Pt(G, "Unexpected end"), xt(G), G.c = "", G.closed = !0, ft(G, "onend"), h.call(G, G.strict, G.opt), G;
                }
                function Rt(G, D) {
                  if (typeof G != "object" || !(G instanceof h))
                    throw new Error("bad call to strictFail");
                  G.strict && Pt(G, D);
                }
                function bt(G) {
                  G.strict || (G.tagName = G.tagName[G.looseCase]());
                  var D = G.tags[G.tags.length - 1] || G, Z = G.tag = { name: G.tagName, attributes: {} };
                  G.opt.xmlns && (Z.ns = D.ns), G.attribList.length = 0, Q(G, "onopentagstart", Z);
                }
                function Dt(G, D) {
                  var Z = G.indexOf(":"), et = Z < 0 ? ["", G] : G.split(":"), vt = et[0], lt = et[1];
                  return D && G === "xmlns" && (vt = "xmlns", lt = ""), { prefix: vt, local: lt };
                }
                function X(G) {
                  if (G.strict || (G.attribName = G.attribName[G.looseCase]()), G.attribList.indexOf(G.attribName) !== -1 || G.tag.attributes.hasOwnProperty(G.attribName)) {
                    G.attribName = G.attribValue = "";
                    return;
                  }
                  if (G.opt.xmlns) {
                    var D = Dt(G.attribName, !0), Z = D.prefix, et = D.local;
                    if (Z === "xmlns")
                      if (et === "xml" && G.attribValue !== w)
                        Rt(
                          G,
                          "xml: prefix must be bound to " + w + `
Actual: ` + G.attribValue
                        );
                      else if (et === "xmlns" && G.attribValue !== E)
                        Rt(
                          G,
                          "xmlns: prefix must be bound to " + E + `
Actual: ` + G.attribValue
                        );
                      else {
                        var vt = G.tag, lt = G.tags[G.tags.length - 1] || G;
                        vt.ns === lt.ns && (vt.ns = Object.create(lt.ns)), vt.ns[et] = G.attribValue;
                      }
                    G.attribList.push([G.attribName, G.attribValue]);
                  } else
                    G.tag.attributes[G.attribName] = G.attribValue, Q(G, "onattribute", {
                      name: G.attribName,
                      value: G.attribValue
                    });
                  G.attribName = G.attribValue = "";
                }
                function gt(G, D) {
                  if (G.opt.xmlns) {
                    var Z = G.tag, et = Dt(G.tagName);
                    Z.prefix = et.prefix, Z.local = et.local, Z.uri = Z.ns[et.prefix] || "", Z.prefix && !Z.uri && (Rt(G, "Unbound namespace prefix: " + JSON.stringify(G.tagName)), Z.uri = et.prefix);
                    var vt = G.tags[G.tags.length - 1] || G;
                    Z.ns && vt.ns !== Z.ns && Object.keys(Z.ns).forEach(function(xe) {
                      Q(G, "onopennamespace", {
                        prefix: xe,
                        uri: Z.ns[xe]
                      });
                    });
                    for (var lt = 0, dt = G.attribList.length; lt < dt; lt++) {
                      var kt = G.attribList[lt], jt = kt[0], me = kt[1], se = Dt(jt, !0), Bt = se.prefix, ge = se.local, Re = Bt === "" ? "" : Z.ns[Bt] || "", Te = {
                        name: jt,
                        value: me,
                        prefix: Bt,
                        local: ge,
                        uri: Re
                      };
                      Bt && Bt !== "xmlns" && !Re && (Rt(G, "Unbound namespace prefix: " + JSON.stringify(Bt)), Te.uri = Bt), G.tag.attributes[jt] = Te, Q(G, "onattribute", Te);
                    }
                    G.attribList.length = 0;
                  }
                  G.tag.isSelfClosing = !!D, G.sawRoot = !0, G.tags.push(G.tag), Q(G, "onopentag", G.tag), D || (!G.noscript && G.tagName.toLowerCase() === "script" ? G.state = L.SCRIPT : G.state = L.TEXT, G.tag = null, G.tagName = ""), G.attribName = G.attribValue = "", G.attribList.length = 0;
                }
                function st(G) {
                  if (!G.tagName) {
                    Rt(G, "Weird empty close tag."), G.textNode += "</>", G.state = L.TEXT;
                    return;
                  }
                  if (G.script) {
                    if (G.tagName !== "script") {
                      G.script += "</" + G.tagName + ">", G.tagName = "", G.state = L.SCRIPT;
                      return;
                    }
                    Q(G, "onscript", G.script), G.script = "";
                  }
                  var D = G.tags.length, Z = G.tagName;
                  G.strict || (Z = Z[G.looseCase]());
                  for (var et = Z; D--; ) {
                    var vt = G.tags[D];
                    if (vt.name !== et)
                      Rt(G, "Unexpected close tag");
                    else
                      break;
                  }
                  if (D < 0) {
                    Rt(G, "Unmatched closing tag: " + G.tagName), G.textNode += "</" + G.tagName + ">", G.state = L.TEXT;
                    return;
                  }
                  G.tagName = Z;
                  for (var lt = G.tags.length; lt-- > D; ) {
                    var dt = G.tag = G.tags.pop();
                    G.tagName = G.tag.name, Q(G, "onclosetag", G.tagName);
                    var kt = {};
                    for (var jt in dt.ns)
                      kt[jt] = dt.ns[jt];
                    var me = G.tags[G.tags.length - 1] || G;
                    G.opt.xmlns && dt.ns !== me.ns && Object.keys(dt.ns).forEach(function(se) {
                      var Bt = dt.ns[se];
                      Q(G, "onclosenamespace", { prefix: se, uri: Bt });
                    });
                  }
                  D === 0 && (G.closedRoot = !0), G.tagName = G.attribValue = G.attribName = "", G.attribList.length = 0, G.state = L.TEXT;
                }
                function rt(G) {
                  var D = G.entity, Z = D.toLowerCase(), et, vt = "";
                  return G.ENTITIES[D] ? G.ENTITIES[D] : G.ENTITIES[Z] ? G.ENTITIES[Z] : (D = Z, D.charAt(0) === "#" && (D.charAt(1) === "x" ? (D = D.slice(2), et = parseInt(D, 16), vt = et.toString(16)) : (D = D.slice(1), et = parseInt(D, 10), vt = et.toString(10))), D = D.replace(/^0+/, ""), isNaN(et) || vt.toLowerCase() !== D ? (Rt(G, "Invalid character entity"), "&" + G.entity + ";") : String.fromCodePoint(et));
                }
                function wt(G, D) {
                  D === "<" ? (G.state = L.OPEN_WAKA, G.startTagPosition = G.position) : I(D) || (Rt(G, "Non-whitespace before first tag."), G.textNode = D, G.state = L.TEXT);
                }
                function Ft(G, D) {
                  var Z = "";
                  return D < G.length && (Z = G.charAt(D)), Z;
                }
                function zt(G) {
                  var D = this;
                  if (this.error)
                    throw this.error;
                  if (D.closed)
                    return Pt(
                      D,
                      "Cannot write after close. Assign an onready handler."
                    );
                  if (G === null)
                    return Gt(D);
                  typeof G == "object" && (G = G.toString());
                  for (var Z = 0, et = ""; et = Ft(G, Z++), D.c = et, !!et; )
                    switch (D.trackPosition && (D.position++, et === `
` ? (D.line++, D.column = 0) : D.column++), D.state) {
                      case L.BEGIN:
                        if (D.state = L.BEGIN_WHITESPACE, et === "\uFEFF")
                          continue;
                        wt(D, et);
                        continue;
                      case L.BEGIN_WHITESPACE:
                        wt(D, et);
                        continue;
                      case L.TEXT:
                        if (D.sawRoot && !D.closedRoot) {
                          for (var vt = Z - 1; et && et !== "<" && et !== "&"; )
                            et = Ft(G, Z++), et && D.trackPosition && (D.position++, et === `
` ? (D.line++, D.column = 0) : D.column++);
                          D.textNode += G.substring(vt, Z - 1);
                        }
                        et === "<" && !(D.sawRoot && D.closedRoot && !D.strict) ? (D.state = L.OPEN_WAKA, D.startTagPosition = D.position) : (!I(et) && (!D.sawRoot || D.closedRoot) && Rt(D, "Text data outside of root node."), et === "&" ? D.state = L.TEXT_ENTITY : D.textNode += et);
                        continue;
                      case L.SCRIPT:
                        et === "<" ? D.state = L.SCRIPT_ENDING : D.script += et;
                        continue;
                      case L.SCRIPT_ENDING:
                        et === "/" ? D.state = L.CLOSE_TAG : (D.script += "<" + et, D.state = L.SCRIPT);
                        continue;
                      case L.OPEN_WAKA:
                        if (et === "!")
                          D.state = L.SGML_DECL, D.sgmlDecl = "";
                        else if (!I(et))
                          if (M(O, et))
                            D.state = L.OPEN_TAG, D.tagName = et;
                          else if (et === "/")
                            D.state = L.CLOSE_TAG, D.tagName = "";
                          else if (et === "?")
                            D.state = L.PROC_INST, D.procInstName = D.procInstBody = "";
                          else {
                            if (Rt(D, "Unencoded <"), D.startTagPosition + 1 < D.position) {
                              var lt = D.position - D.startTagPosition;
                              et = new Array(lt).join(" ") + et;
                            }
                            D.textNode += "<" + et, D.state = L.TEXT;
                          }
                        continue;
                      case L.SGML_DECL:
                        (D.sgmlDecl + et).toUpperCase() === b ? (Q(D, "onopencdata"), D.state = L.CDATA, D.sgmlDecl = "", D.cdata = "") : D.sgmlDecl + et === "--" ? (D.state = L.COMMENT, D.comment = "", D.sgmlDecl = "") : (D.sgmlDecl + et).toUpperCase() === n ? (D.state = L.DOCTYPE, (D.doctype || D.sawRoot) && Rt(
                          D,
                          "Inappropriately located doctype declaration"
                        ), D.doctype = "", D.sgmlDecl = "") : et === ">" ? (Q(D, "onsgmldeclaration", D.sgmlDecl), D.sgmlDecl = "", D.state = L.TEXT) : (F(et) && (D.state = L.SGML_DECL_QUOTED), D.sgmlDecl += et);
                        continue;
                      case L.SGML_DECL_QUOTED:
                        et === D.q && (D.state = L.SGML_DECL, D.q = ""), D.sgmlDecl += et;
                        continue;
                      case L.DOCTYPE:
                        et === ">" ? (D.state = L.TEXT, Q(D, "ondoctype", D.doctype), D.doctype = !0) : (D.doctype += et, et === "[" ? D.state = L.DOCTYPE_DTD : F(et) && (D.state = L.DOCTYPE_QUOTED, D.q = et));
                        continue;
                      case L.DOCTYPE_QUOTED:
                        D.doctype += et, et === D.q && (D.q = "", D.state = L.DOCTYPE);
                        continue;
                      case L.DOCTYPE_DTD:
                        D.doctype += et, et === "]" ? D.state = L.DOCTYPE : F(et) && (D.state = L.DOCTYPE_DTD_QUOTED, D.q = et);
                        continue;
                      case L.DOCTYPE_DTD_QUOTED:
                        D.doctype += et, et === D.q && (D.state = L.DOCTYPE_DTD, D.q = "");
                        continue;
                      case L.COMMENT:
                        et === "-" ? D.state = L.COMMENT_ENDING : D.comment += et;
                        continue;
                      case L.COMMENT_ENDING:
                        et === "-" ? (D.state = L.COMMENT_ENDED, D.comment = St(D.opt, D.comment), D.comment && Q(D, "oncomment", D.comment), D.comment = "") : (D.comment += "-" + et, D.state = L.COMMENT);
                        continue;
                      case L.COMMENT_ENDED:
                        et !== ">" ? (Rt(D, "Malformed comment"), D.comment += "--" + et, D.state = L.COMMENT) : D.state = L.TEXT;
                        continue;
                      case L.CDATA:
                        et === "]" ? D.state = L.CDATA_ENDING : D.cdata += et;
                        continue;
                      case L.CDATA_ENDING:
                        et === "]" ? D.state = L.CDATA_ENDING_2 : (D.cdata += "]" + et, D.state = L.CDATA);
                        continue;
                      case L.CDATA_ENDING_2:
                        et === ">" ? (D.cdata && Q(D, "oncdata", D.cdata), Q(D, "onclosecdata"), D.cdata = "", D.state = L.TEXT) : et === "]" ? D.cdata += "]" : (D.cdata += "]]" + et, D.state = L.CDATA);
                        continue;
                      case L.PROC_INST:
                        et === "?" ? D.state = L.PROC_INST_ENDING : I(et) ? D.state = L.PROC_INST_BODY : D.procInstName += et;
                        continue;
                      case L.PROC_INST_BODY:
                        if (!D.procInstBody && I(et))
                          continue;
                        et === "?" ? D.state = L.PROC_INST_ENDING : D.procInstBody += et;
                        continue;
                      case L.PROC_INST_ENDING:
                        et === ">" ? (Q(D, "onprocessinginstruction", {
                          name: D.procInstName,
                          body: D.procInstBody
                        }), D.procInstName = D.procInstBody = "", D.state = L.TEXT) : (D.procInstBody += "?" + et, D.state = L.PROC_INST_BODY);
                        continue;
                      case L.OPEN_TAG:
                        M(C, et) ? D.tagName += et : (bt(D), et === ">" ? gt(D) : et === "/" ? D.state = L.OPEN_TAG_SLASH : (I(et) || Rt(D, "Invalid character in tag name"), D.state = L.ATTRIB));
                        continue;
                      case L.OPEN_TAG_SLASH:
                        et === ">" ? (gt(D, !0), st(D)) : (Rt(D, "Forward-slash in opening tag not followed by >"), D.state = L.ATTRIB);
                        continue;
                      case L.ATTRIB:
                        if (I(et))
                          continue;
                        et === ">" ? gt(D) : et === "/" ? D.state = L.OPEN_TAG_SLASH : M(O, et) ? (D.attribName = et, D.attribValue = "", D.state = L.ATTRIB_NAME) : Rt(D, "Invalid attribute name");
                        continue;
                      case L.ATTRIB_NAME:
                        et === "=" ? D.state = L.ATTRIB_VALUE : et === ">" ? (Rt(D, "Attribute without value"), D.attribValue = D.attribName, X(D), gt(D)) : I(et) ? D.state = L.ATTRIB_NAME_SAW_WHITE : M(C, et) ? D.attribName += et : Rt(D, "Invalid attribute name");
                        continue;
                      case L.ATTRIB_NAME_SAW_WHITE:
                        if (et === "=")
                          D.state = L.ATTRIB_VALUE;
                        else {
                          if (I(et))
                            continue;
                          Rt(D, "Attribute without value"), D.tag.attributes[D.attribName] = "", D.attribValue = "", Q(D, "onattribute", {
                            name: D.attribName,
                            value: ""
                          }), D.attribName = "", et === ">" ? gt(D) : M(O, et) ? (D.attribName = et, D.state = L.ATTRIB_NAME) : (Rt(D, "Invalid attribute name"), D.state = L.ATTRIB);
                        }
                        continue;
                      case L.ATTRIB_VALUE:
                        if (I(et))
                          continue;
                        F(et) ? (D.q = et, D.state = L.ATTRIB_VALUE_QUOTED) : (Rt(D, "Unquoted attribute value"), D.state = L.ATTRIB_VALUE_UNQUOTED, D.attribValue = et);
                        continue;
                      case L.ATTRIB_VALUE_QUOTED:
                        if (et !== D.q) {
                          et === "&" ? D.state = L.ATTRIB_VALUE_ENTITY_Q : D.attribValue += et;
                          continue;
                        }
                        X(D), D.q = "", D.state = L.ATTRIB_VALUE_CLOSED;
                        continue;
                      case L.ATTRIB_VALUE_CLOSED:
                        I(et) ? D.state = L.ATTRIB : et === ">" ? gt(D) : et === "/" ? D.state = L.OPEN_TAG_SLASH : M(O, et) ? (Rt(D, "No whitespace between attributes"), D.attribName = et, D.attribValue = "", D.state = L.ATTRIB_NAME) : Rt(D, "Invalid attribute name");
                        continue;
                      case L.ATTRIB_VALUE_UNQUOTED:
                        if (!B(et)) {
                          et === "&" ? D.state = L.ATTRIB_VALUE_ENTITY_U : D.attribValue += et;
                          continue;
                        }
                        X(D), et === ">" ? gt(D) : D.state = L.ATTRIB;
                        continue;
                      case L.CLOSE_TAG:
                        if (D.tagName)
                          et === ">" ? st(D) : M(C, et) ? D.tagName += et : D.script ? (D.script += "</" + D.tagName, D.tagName = "", D.state = L.SCRIPT) : (I(et) || Rt(D, "Invalid tagname in closing tag"), D.state = L.CLOSE_TAG_SAW_WHITE);
                        else {
                          if (I(et))
                            continue;
                          z(O, et) ? D.script ? (D.script += "</" + et, D.state = L.SCRIPT) : Rt(D, "Invalid tagname in closing tag.") : D.tagName = et;
                        }
                        continue;
                      case L.CLOSE_TAG_SAW_WHITE:
                        if (I(et))
                          continue;
                        et === ">" ? st(D) : Rt(D, "Invalid characters in closing tag");
                        continue;
                      case L.TEXT_ENTITY:
                      case L.ATTRIB_VALUE_ENTITY_Q:
                      case L.ATTRIB_VALUE_ENTITY_U:
                        var dt, kt;
                        switch (D.state) {
                          case L.TEXT_ENTITY:
                            dt = L.TEXT, kt = "textNode";
                            break;
                          case L.ATTRIB_VALUE_ENTITY_Q:
                            dt = L.ATTRIB_VALUE_QUOTED, kt = "attribValue";
                            break;
                          case L.ATTRIB_VALUE_ENTITY_U:
                            dt = L.ATTRIB_VALUE_UNQUOTED, kt = "attribValue";
                            break;
                        }
                        if (et === ";")
                          if (D.opt.unparsedEntities) {
                            var jt = rt(D);
                            D.entity = "", D.state = dt, D.write(jt);
                          } else
                            D[kt] += rt(D), D.entity = "", D.state = dt;
                        else
                          M(D.entity.length ? P : T, et) ? D.entity += et : (Rt(D, "Invalid character in entity name"), D[kt] += "&" + D.entity + et, D.entity = "", D.state = dt);
                        continue;
                      default:
                        throw new Error(D, "Unknown state: " + D.state);
                    }
                  return D.position >= D.bufferCheckPosition && v(D), D;
                }
                /*! http://mths.be/fromcodepoint v0.1.0 by @mathias */
                String.fromCodePoint || function() {
                  var G = String.fromCharCode, D = Math.floor, Z = function() {
                    var et = 16384, vt = [], lt, dt, kt = -1, jt = arguments.length;
                    if (!jt)
                      return "";
                    for (var me = ""; ++kt < jt; ) {
                      var se = Number(arguments[kt]);
                      if (!isFinite(se) || // `NaN`, `+Infinity`, or `-Infinity`
                      se < 0 || // not a valid Unicode code point
                      se > 1114111 || // not a valid Unicode code point
                      D(se) !== se)
                        throw RangeError("Invalid code point: " + se);
                      se <= 65535 ? vt.push(se) : (se -= 65536, lt = (se >> 10) + 55296, dt = se % 1024 + 56320, vt.push(lt, dt)), (kt + 1 === jt || vt.length > et) && (me += G.apply(null, vt), vt.length = 0);
                    }
                    return me;
                  };
                  Object.defineProperty ? Object.defineProperty(String, "fromCodePoint", {
                    value: Z,
                    configurable: !0,
                    writable: !0
                  }) : String.fromCodePoint = Z;
                }();
              })(l);
            }
          ),
          /***/
          86255: (
            /***/
            function(u, l, e) {
              var s = e(28651), i = e(89295), f = e(18890)(), h = e(68109), v = e(96785), p = s("%Math.floor%");
              u.exports = function(x, g) {
                if (typeof x != "function")
                  throw new v("`fn` is not a function");
                if (typeof g != "number" || g < 0 || g > 4294967295 || p(g) !== g)
                  throw new v("`length` must be a positive 32-bit integer");
                var S = arguments.length > 2 && !!arguments[2], y = !0, b = !0;
                if ("length" in x && h) {
                  var n = h(x, "length");
                  n && !n.configurable && (y = !1), n && !n.writable && (b = !1);
                }
                return (y || b || !S) && (f ? i(
                  /** @type {Parameters<define>[0]} */
                  x,
                  "length",
                  g,
                  !0,
                  !0
                ) : i(
                  /** @type {Parameters<define>[0]} */
                  x,
                  "length",
                  g
                )), x;
              };
            }
          ),
          /***/
          95304: (
            /***/
            function(u, l, e) {
              var s = e(89295), i = e(18890)(), f = e(61084).functionsHaveConfigurableNames(), h = e(96785);
              u.exports = function(p, m) {
                if (typeof p != "function")
                  throw new h("`fn` is not a function");
                var x = arguments.length > 2 && !!arguments[2];
                return (!x || f) && (i ? s(
                  /** @type {Parameters<define>[0]} */
                  p,
                  "name",
                  m,
                  !0,
                  !0
                ) : s(
                  /** @type {Parameters<define>[0]} */
                  p,
                  "name",
                  m
                )), p;
              };
            }
          ),
          /***/
          9760: (
            /***/
            function(u, l, e) {
              u.exports = f;
              var s = e(64785).EventEmitter, i = e(89784);
              i(f, s), f.Readable = e(88261), f.Writable = e(29781), f.Duplex = e(14903), f.Transform = e(48569), f.PassThrough = e(17723), f.finished = e(12167), f.pipeline = e(43765), f.Stream = f;
              function f() {
                s.call(this);
              }
              f.prototype.pipe = function(h, v) {
                var p = this;
                function m(w) {
                  h.writable && h.write(w) === !1 && p.pause && p.pause();
                }
                p.on("data", m);
                function x() {
                  p.readable && p.resume && p.resume();
                }
                h.on("drain", x), !h._isStdio && (!v || v.end !== !1) && (p.on("end", S), p.on("close", y));
                var g = !1;
                function S() {
                  g || (g = !0, h.end());
                }
                function y() {
                  g || (g = !0, typeof h.destroy == "function" && h.destroy());
                }
                function b(w) {
                  if (n(), s.listenerCount(this, "error") === 0)
                    throw w;
                }
                p.on("error", b), h.on("error", b);
                function n() {
                  p.removeListener("data", m), h.removeListener("drain", x), p.removeListener("end", S), p.removeListener("close", y), p.removeListener("error", b), h.removeListener("error", b), p.removeListener("end", n), p.removeListener("close", n), h.removeListener("close", n);
                }
                return p.on("end", n), p.on("close", n), h.on("close", n), h.emit("pipe", p), h;
              };
            }
          ),
          /***/
          83797: (
            /***/
            function(u) {
              function l(p, m) {
                p.prototype = Object.create(m.prototype), p.prototype.constructor = p, p.__proto__ = m;
              }
              var e = {};
              function s(p, m, x) {
                x || (x = Error);
                function g(y, b, n) {
                  return typeof m == "string" ? m : m(y, b, n);
                }
                var S = /* @__PURE__ */ function(y) {
                  l(b, y);
                  function b(n, w, E) {
                    return y.call(this, g(n, w, E)) || this;
                  }
                  return b;
                }(x);
                S.prototype.name = x.name, S.prototype.code = p, e[p] = S;
              }
              function i(p, m) {
                if (Array.isArray(p)) {
                  var x = p.length;
                  return p = p.map(function(g) {
                    return String(g);
                  }), x > 2 ? "one of ".concat(m, " ").concat(p.slice(0, x - 1).join(", "), ", or ") + p[x - 1] : x === 2 ? "one of ".concat(m, " ").concat(p[0], " or ").concat(p[1]) : "of ".concat(m, " ").concat(p[0]);
                } else
                  return "of ".concat(m, " ").concat(String(p));
              }
              function f(p, m, x) {
                return p.substr(!x || x < 0 ? 0 : +x, m.length) === m;
              }
              function h(p, m, x) {
                return (x === void 0 || x > p.length) && (x = p.length), p.substring(x - m.length, x) === m;
              }
              function v(p, m, x) {
                return typeof x != "number" && (x = 0), x + m.length > p.length ? !1 : p.indexOf(m, x) !== -1;
              }
              s("ERR_INVALID_OPT_VALUE", function(p, m) {
                return 'The value "' + m + '" is invalid for option "' + p + '"';
              }, TypeError), s("ERR_INVALID_ARG_TYPE", function(p, m, x) {
                var g;
                typeof m == "string" && f(m, "not ") ? (g = "must not be", m = m.replace(/^not /, "")) : g = "must be";
                var S;
                if (h(p, " argument"))
                  S = "The ".concat(p, " ").concat(g, " ").concat(i(m, "type"));
                else {
                  var y = v(p, ".") ? "property" : "argument";
                  S = 'The "'.concat(p, '" ').concat(y, " ").concat(g, " ").concat(i(m, "type"));
                }
                return S += ". Received type ".concat(typeof x), S;
              }, TypeError), s("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), s("ERR_METHOD_NOT_IMPLEMENTED", function(p) {
                return "The " + p + " method is not implemented";
              }), s("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), s("ERR_STREAM_DESTROYED", function(p) {
                return "Cannot call " + p + " after a stream was destroyed";
              }), s("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), s("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), s("ERR_STREAM_WRITE_AFTER_END", "write after end"), s("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), s("ERR_UNKNOWN_ENCODING", function(p) {
                return "Unknown encoding: " + p;
              }, TypeError), s("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), u.exports.F = e;
            }
          ),
          /***/
          14903: (
            /***/
            function(u, l, e) {
              var s = e(9964), i = Object.keys || function(y) {
                var b = [];
                for (var n in y)
                  b.push(n);
                return b;
              };
              u.exports = x;
              var f = e(88261), h = e(29781);
              e(89784)(x, f);
              for (var v = i(h.prototype), p = 0; p < v.length; p++) {
                var m = v[p];
                x.prototype[m] || (x.prototype[m] = h.prototype[m]);
              }
              function x(y) {
                if (!(this instanceof x))
                  return new x(y);
                f.call(this, y), h.call(this, y), this.allowHalfOpen = !0, y && (y.readable === !1 && (this.readable = !1), y.writable === !1 && (this.writable = !1), y.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", g)));
              }
              Object.defineProperty(x.prototype, "writableHighWaterMark", {
                // making it explicit this property is not enumerable
                // because otherwise some prototype manipulation in
                // userland will fail
                enumerable: !1,
                get: function() {
                  return this._writableState.highWaterMark;
                }
              }), Object.defineProperty(x.prototype, "writableBuffer", {
                // making it explicit this property is not enumerable
                // because otherwise some prototype manipulation in
                // userland will fail
                enumerable: !1,
                get: function() {
                  return this._writableState && this._writableState.getBuffer();
                }
              }), Object.defineProperty(x.prototype, "writableLength", {
                // making it explicit this property is not enumerable
                // because otherwise some prototype manipulation in
                // userland will fail
                enumerable: !1,
                get: function() {
                  return this._writableState.length;
                }
              });
              function g() {
                this._writableState.ended || s.nextTick(S, this);
              }
              function S(y) {
                y.end();
              }
              Object.defineProperty(x.prototype, "destroyed", {
                // making it explicit this property is not enumerable
                // because otherwise some prototype manipulation in
                // userland will fail
                enumerable: !1,
                get: function() {
                  return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
                },
                set: function(b) {
                  this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = b, this._writableState.destroyed = b);
                }
              });
            }
          ),
          /***/
          17723: (
            /***/
            function(u, l, e) {
              u.exports = i;
              var s = e(48569);
              e(89784)(i, s);
              function i(f) {
                if (!(this instanceof i))
                  return new i(f);
                s.call(this, f);
              }
              i.prototype._transform = function(f, h, v) {
                v(null, f);
              };
            }
          ),
          /***/
          88261: (
            /***/
            function(u, l, e) {
              var s = e(9964);
              u.exports = J;
              var i;
              J.ReadableState = L, e(64785).EventEmitter;
              var f = function(dt, kt) {
                return dt.listeners(kt).length;
              }, h = e(99018), v = e(50621).Buffer, p = (typeof e.g < "u" ? e.g : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
              };
              function m(lt) {
                return v.from(lt);
              }
              function x(lt) {
                return v.isBuffer(lt) || lt instanceof p;
              }
              var g = e(77199), S;
              g && g.debuglog ? S = g.debuglog("stream") : S = function() {
              };
              var y = e(57540), b = e(37385), n = e(68130), w = n.getHighWaterMark, E = e(83797).F, A = E.ERR_INVALID_ARG_TYPE, O = E.ERR_STREAM_PUSH_AFTER_EOF, C = E.ERR_METHOD_NOT_IMPLEMENTED, T = E.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, P, I, F;
              e(89784)(J, h);
              var B = b.errorOrDestroy, M = ["error", "close", "destroy", "pause", "resume"];
              function z(lt, dt, kt) {
                if (typeof lt.prependListener == "function")
                  return lt.prependListener(dt, kt);
                !lt._events || !lt._events[dt] ? lt.on(dt, kt) : Array.isArray(lt._events[dt]) ? lt._events[dt].unshift(kt) : lt._events[dt] = [kt, lt._events[dt]];
              }
              function L(lt, dt, kt) {
                i = i || e(14903), lt = lt || {}, typeof kt != "boolean" && (kt = dt instanceof i), this.objectMode = !!lt.objectMode, kt && (this.objectMode = this.objectMode || !!lt.readableObjectMode), this.highWaterMark = w(this, lt, "readableHighWaterMark", kt), this.buffer = new y(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = lt.emitClose !== !1, this.autoDestroy = !!lt.autoDestroy, this.destroyed = !1, this.defaultEncoding = lt.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, lt.encoding && (P || (P = e(43143).I), this.decoder = new P(lt.encoding), this.encoding = lt.encoding);
              }
              function J(lt) {
                if (i = i || e(14903), !(this instanceof J))
                  return new J(lt);
                var dt = this instanceof i;
                this._readableState = new L(lt, this, dt), this.readable = !0, lt && (typeof lt.read == "function" && (this._read = lt.read), typeof lt.destroy == "function" && (this._destroy = lt.destroy)), h.call(this);
              }
              Object.defineProperty(J.prototype, "destroyed", {
                // making it explicit this property is not enumerable
                // because otherwise some prototype manipulation in
                // userland will fail
                enumerable: !1,
                get: function() {
                  return this._readableState === void 0 ? !1 : this._readableState.destroyed;
                },
                set: function(dt) {
                  this._readableState && (this._readableState.destroyed = dt);
                }
              }), J.prototype.destroy = b.destroy, J.prototype._undestroy = b.undestroy, J.prototype._destroy = function(lt, dt) {
                dt(lt);
              }, J.prototype.push = function(lt, dt) {
                var kt = this._readableState, jt;
                return kt.objectMode ? jt = !0 : typeof lt == "string" && (dt = dt || kt.defaultEncoding, dt !== kt.encoding && (lt = v.from(lt, dt), dt = ""), jt = !0), ft(this, lt, dt, !1, jt);
              }, J.prototype.unshift = function(lt) {
                return ft(this, lt, null, !0, !1);
              };
              function ft(lt, dt, kt, jt, me) {
                S("readableAddChunk", dt);
                var se = lt._readableState;
                if (dt === null)
                  se.reading = !1, Rt(lt, se);
                else {
                  var Bt;
                  if (me || (Bt = xt(se, dt)), Bt)
                    B(lt, Bt);
                  else if (se.objectMode || dt && dt.length > 0)
                    if (typeof dt != "string" && !se.objectMode && Object.getPrototypeOf(dt) !== v.prototype && (dt = m(dt)), jt)
                      se.endEmitted ? B(lt, new T()) : Q(lt, se, dt, !0);
                    else if (se.ended)
                      B(lt, new O());
                    else {
                      if (se.destroyed)
                        return !1;
                      se.reading = !1, se.decoder && !kt ? (dt = se.decoder.write(dt), se.objectMode || dt.length !== 0 ? Q(lt, se, dt, !1) : X(lt, se)) : Q(lt, se, dt, !1);
                    }
                  else
                    jt || (se.reading = !1, X(lt, se));
                }
                return !se.ended && (se.length < se.highWaterMark || se.length === 0);
              }
              function Q(lt, dt, kt, jt) {
                dt.flowing && dt.length === 0 && !dt.sync ? (dt.awaitDrain = 0, lt.emit("data", kt)) : (dt.length += dt.objectMode ? 1 : kt.length, jt ? dt.buffer.unshift(kt) : dt.buffer.push(kt), dt.needReadable && bt(lt)), X(lt, dt);
              }
              function xt(lt, dt) {
                var kt;
                return !x(dt) && typeof dt != "string" && dt !== void 0 && !lt.objectMode && (kt = new A("chunk", ["string", "Buffer", "Uint8Array"], dt)), kt;
              }
              J.prototype.isPaused = function() {
                return this._readableState.flowing === !1;
              }, J.prototype.setEncoding = function(lt) {
                P || (P = e(43143).I);
                var dt = new P(lt);
                this._readableState.decoder = dt, this._readableState.encoding = this._readableState.decoder.encoding;
                for (var kt = this._readableState.buffer.head, jt = ""; kt !== null; )
                  jt += dt.write(kt.data), kt = kt.next;
                return this._readableState.buffer.clear(), jt !== "" && this._readableState.buffer.push(jt), this._readableState.length = jt.length, this;
              };
              var St = 1073741824;
              function Pt(lt) {
                return lt >= St ? lt = St : (lt--, lt |= lt >>> 1, lt |= lt >>> 2, lt |= lt >>> 4, lt |= lt >>> 8, lt |= lt >>> 16, lt++), lt;
              }
              function Gt(lt, dt) {
                return lt <= 0 || dt.length === 0 && dt.ended ? 0 : dt.objectMode ? 1 : lt !== lt ? dt.flowing && dt.length ? dt.buffer.head.data.length : dt.length : (lt > dt.highWaterMark && (dt.highWaterMark = Pt(lt)), lt <= dt.length ? lt : dt.ended ? dt.length : (dt.needReadable = !0, 0));
              }
              J.prototype.read = function(lt) {
                S("read", lt), lt = parseInt(lt, 10);
                var dt = this._readableState, kt = lt;
                if (lt !== 0 && (dt.emittedReadable = !1), lt === 0 && dt.needReadable && ((dt.highWaterMark !== 0 ? dt.length >= dt.highWaterMark : dt.length > 0) || dt.ended))
                  return S("read: emitReadable", dt.length, dt.ended), dt.length === 0 && dt.ended ? Z(this) : bt(this), null;
                if (lt = Gt(lt, dt), lt === 0 && dt.ended)
                  return dt.length === 0 && Z(this), null;
                var jt = dt.needReadable;
                S("need readable", jt), (dt.length === 0 || dt.length - lt < dt.highWaterMark) && (jt = !0, S("length less than watermark", jt)), dt.ended || dt.reading ? (jt = !1, S("reading or ended", jt)) : jt && (S("do read"), dt.reading = !0, dt.sync = !0, dt.length === 0 && (dt.needReadable = !0), this._read(dt.highWaterMark), dt.sync = !1, dt.reading || (lt = Gt(kt, dt)));
                var me;
                return lt > 0 ? me = D(lt, dt) : me = null, me === null ? (dt.needReadable = dt.length <= dt.highWaterMark, lt = 0) : (dt.length -= lt, dt.awaitDrain = 0), dt.length === 0 && (dt.ended || (dt.needReadable = !0), kt !== lt && dt.ended && Z(this)), me !== null && this.emit("data", me), me;
              };
              function Rt(lt, dt) {
                if (S("onEofChunk"), !dt.ended) {
                  if (dt.decoder) {
                    var kt = dt.decoder.end();
                    kt && kt.length && (dt.buffer.push(kt), dt.length += dt.objectMode ? 1 : kt.length);
                  }
                  dt.ended = !0, dt.sync ? bt(lt) : (dt.needReadable = !1, dt.emittedReadable || (dt.emittedReadable = !0, Dt(lt)));
                }
              }
              function bt(lt) {
                var dt = lt._readableState;
                S("emitReadable", dt.needReadable, dt.emittedReadable), dt.needReadable = !1, dt.emittedReadable || (S("emitReadable", dt.flowing), dt.emittedReadable = !0, s.nextTick(Dt, lt));
              }
              function Dt(lt) {
                var dt = lt._readableState;
                S("emitReadable_", dt.destroyed, dt.length, dt.ended), !dt.destroyed && (dt.length || dt.ended) && (lt.emit("readable"), dt.emittedReadable = !1), dt.needReadable = !dt.flowing && !dt.ended && dt.length <= dt.highWaterMark, G(lt);
              }
              function X(lt, dt) {
                dt.readingMore || (dt.readingMore = !0, s.nextTick(gt, lt, dt));
              }
              function gt(lt, dt) {
                for (; !dt.reading && !dt.ended && (dt.length < dt.highWaterMark || dt.flowing && dt.length === 0); ) {
                  var kt = dt.length;
                  if (S("maybeReadMore read 0"), lt.read(0), kt === dt.length)
                    break;
                }
                dt.readingMore = !1;
              }
              J.prototype._read = function(lt) {
                B(this, new C("_read()"));
              }, J.prototype.pipe = function(lt, dt) {
                var kt = this, jt = this._readableState;
                switch (jt.pipesCount) {
                  case 0:
                    jt.pipes = lt;
                    break;
                  case 1:
                    jt.pipes = [jt.pipes, lt];
                    break;
                  default:
                    jt.pipes.push(lt);
                    break;
                }
                jt.pipesCount += 1, S("pipe count=%d opts=%j", jt.pipesCount, dt);
                var me = (!dt || dt.end !== !1) && lt !== s.stdout && lt !== s.stderr, se = me ? ge : Se;
                jt.endEmitted ? s.nextTick(se) : kt.once("end", se), lt.on("unpipe", Bt);
                function Bt(Pe, Be) {
                  S("onunpipe"), Pe === kt && Be && Be.hasUnpiped === !1 && (Be.hasUnpiped = !0, xe());
                }
                function ge() {
                  S("onend"), lt.end();
                }
                var Re = st(kt);
                lt.on("drain", Re);
                var Te = !1;
                function xe() {
                  S("cleanup"), lt.removeListener("close", qt), lt.removeListener("finish", ve), lt.removeListener("drain", Re), lt.removeListener("error", Zt), lt.removeListener("unpipe", Bt), kt.removeListener("end", ge), kt.removeListener("end", Se), kt.removeListener("data", Fe), Te = !0, jt.awaitDrain && (!lt._writableState || lt._writableState.needDrain) && Re();
                }
                kt.on("data", Fe);
                function Fe(Pe) {
                  S("ondata");
                  var Be = lt.write(Pe);
                  S("dest.write", Be), Be === !1 && ((jt.pipesCount === 1 && jt.pipes === lt || jt.pipesCount > 1 && vt(jt.pipes, lt) !== -1) && !Te && (S("false write response, pause", jt.awaitDrain), jt.awaitDrain++), kt.pause());
                }
                function Zt(Pe) {
                  S("onerror", Pe), Se(), lt.removeListener("error", Zt), f(lt, "error") === 0 && B(lt, Pe);
                }
                z(lt, "error", Zt);
                function qt() {
                  lt.removeListener("finish", ve), Se();
                }
                lt.once("close", qt);
                function ve() {
                  S("onfinish"), lt.removeListener("close", qt), Se();
                }
                lt.once("finish", ve);
                function Se() {
                  S("unpipe"), kt.unpipe(lt);
                }
                return lt.emit("pipe", kt), jt.flowing || (S("pipe resume"), kt.resume()), lt;
              };
              function st(lt) {
                return function() {
                  var kt = lt._readableState;
                  S("pipeOnDrain", kt.awaitDrain), kt.awaitDrain && kt.awaitDrain--, kt.awaitDrain === 0 && f(lt, "data") && (kt.flowing = !0, G(lt));
                };
              }
              J.prototype.unpipe = function(lt) {
                var dt = this._readableState, kt = {
                  hasUnpiped: !1
                };
                if (dt.pipesCount === 0)
                  return this;
                if (dt.pipesCount === 1)
                  return lt && lt !== dt.pipes ? this : (lt || (lt = dt.pipes), dt.pipes = null, dt.pipesCount = 0, dt.flowing = !1, lt && lt.emit("unpipe", this, kt), this);
                if (!lt) {
                  var jt = dt.pipes, me = dt.pipesCount;
                  dt.pipes = null, dt.pipesCount = 0, dt.flowing = !1;
                  for (var se = 0; se < me; se++)
                    jt[se].emit("unpipe", this, {
                      hasUnpiped: !1
                    });
                  return this;
                }
                var Bt = vt(dt.pipes, lt);
                return Bt === -1 ? this : (dt.pipes.splice(Bt, 1), dt.pipesCount -= 1, dt.pipesCount === 1 && (dt.pipes = dt.pipes[0]), lt.emit("unpipe", this, kt), this);
              }, J.prototype.on = function(lt, dt) {
                var kt = h.prototype.on.call(this, lt, dt), jt = this._readableState;
                return lt === "data" ? (jt.readableListening = this.listenerCount("readable") > 0, jt.flowing !== !1 && this.resume()) : lt === "readable" && !jt.endEmitted && !jt.readableListening && (jt.readableListening = jt.needReadable = !0, jt.flowing = !1, jt.emittedReadable = !1, S("on readable", jt.length, jt.reading), jt.length ? bt(this) : jt.reading || s.nextTick(wt, this)), kt;
              }, J.prototype.addListener = J.prototype.on, J.prototype.removeListener = function(lt, dt) {
                var kt = h.prototype.removeListener.call(this, lt, dt);
                return lt === "readable" && s.nextTick(rt, this), kt;
              }, J.prototype.removeAllListeners = function(lt) {
                var dt = h.prototype.removeAllListeners.apply(this, arguments);
                return (lt === "readable" || lt === void 0) && s.nextTick(rt, this), dt;
              };
              function rt(lt) {
                var dt = lt._readableState;
                dt.readableListening = lt.listenerCount("readable") > 0, dt.resumeScheduled && !dt.paused ? dt.flowing = !0 : lt.listenerCount("data") > 0 && lt.resume();
              }
              function wt(lt) {
                S("readable nexttick read 0"), lt.read(0);
              }
              J.prototype.resume = function() {
                var lt = this._readableState;
                return lt.flowing || (S("resume"), lt.flowing = !lt.readableListening, Ft(this, lt)), lt.paused = !1, this;
              };
              function Ft(lt, dt) {
                dt.resumeScheduled || (dt.resumeScheduled = !0, s.nextTick(zt, lt, dt));
              }
              function zt(lt, dt) {
                S("resume", dt.reading), dt.reading || lt.read(0), dt.resumeScheduled = !1, lt.emit("resume"), G(lt), dt.flowing && !dt.reading && lt.read(0);
              }
              J.prototype.pause = function() {
                return S("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (S("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
              };
              function G(lt) {
                var dt = lt._readableState;
                for (S("flow", dt.flowing); dt.flowing && lt.read() !== null; )
                  ;
              }
              J.prototype.wrap = function(lt) {
                var dt = this, kt = this._readableState, jt = !1;
                lt.on("end", function() {
                  if (S("wrapped end"), kt.decoder && !kt.ended) {
                    var Bt = kt.decoder.end();
                    Bt && Bt.length && dt.push(Bt);
                  }
                  dt.push(null);
                }), lt.on("data", function(Bt) {
                  if (S("wrapped data"), kt.decoder && (Bt = kt.decoder.write(Bt)), !(kt.objectMode && Bt == null) && !(!kt.objectMode && (!Bt || !Bt.length))) {
                    var ge = dt.push(Bt);
                    ge || (jt = !0, lt.pause());
                  }
                });
                for (var me in lt)
                  this[me] === void 0 && typeof lt[me] == "function" && (this[me] = function(ge) {
                    return function() {
                      return lt[ge].apply(lt, arguments);
                    };
                  }(me));
                for (var se = 0; se < M.length; se++)
                  lt.on(M[se], this.emit.bind(this, M[se]));
                return this._read = function(Bt) {
                  S("wrapped _read", Bt), jt && (jt = !1, lt.resume());
                }, this;
              }, typeof Symbol == "function" && (J.prototype[Symbol.asyncIterator] = function() {
                return I === void 0 && (I = e(79676)), I(this);
              }), Object.defineProperty(J.prototype, "readableHighWaterMark", {
                // making it explicit this property is not enumerable
                // because otherwise some prototype manipulation in
                // userland will fail
                enumerable: !1,
                get: function() {
                  return this._readableState.highWaterMark;
                }
              }), Object.defineProperty(J.prototype, "readableBuffer", {
                // making it explicit this property is not enumerable
                // because otherwise some prototype manipulation in
                // userland will fail
                enumerable: !1,
                get: function() {
                  return this._readableState && this._readableState.buffer;
                }
              }), Object.defineProperty(J.prototype, "readableFlowing", {
                // making it explicit this property is not enumerable
                // because otherwise some prototype manipulation in
                // userland will fail
                enumerable: !1,
                get: function() {
                  return this._readableState.flowing;
                },
                set: function(dt) {
                  this._readableState && (this._readableState.flowing = dt);
                }
              }), J._fromList = D, Object.defineProperty(J.prototype, "readableLength", {
                // making it explicit this property is not enumerable
                // because otherwise some prototype manipulation in
                // userland will fail
                enumerable: !1,
                get: function() {
                  return this._readableState.length;
                }
              });
              function D(lt, dt) {
                if (dt.length === 0)
                  return null;
                var kt;
                return dt.objectMode ? kt = dt.buffer.shift() : !lt || lt >= dt.length ? (dt.decoder ? kt = dt.buffer.join("") : dt.buffer.length === 1 ? kt = dt.buffer.first() : kt = dt.buffer.concat(dt.length), dt.buffer.clear()) : kt = dt.buffer.consume(lt, dt.decoder), kt;
              }
              function Z(lt) {
                var dt = lt._readableState;
                S("endReadable", dt.endEmitted), dt.endEmitted || (dt.ended = !0, s.nextTick(et, dt, lt));
              }
              function et(lt, dt) {
                if (S("endReadableNT", lt.endEmitted, lt.length), !lt.endEmitted && lt.length === 0 && (lt.endEmitted = !0, dt.readable = !1, dt.emit("end"), lt.autoDestroy)) {
                  var kt = dt._writableState;
                  (!kt || kt.autoDestroy && kt.finished) && dt.destroy();
                }
              }
              typeof Symbol == "function" && (J.from = function(lt, dt) {
                return F === void 0 && (F = e(60378)), F(J, lt, dt);
              });
              function vt(lt, dt) {
                for (var kt = 0, jt = lt.length; kt < jt; kt++)
                  if (lt[kt] === dt)
                    return kt;
                return -1;
              }
            }
          ),
          /***/
          48569: (
            /***/
            function(u, l, e) {
              u.exports = x;
              var s = e(83797).F, i = s.ERR_METHOD_NOT_IMPLEMENTED, f = s.ERR_MULTIPLE_CALLBACK, h = s.ERR_TRANSFORM_ALREADY_TRANSFORMING, v = s.ERR_TRANSFORM_WITH_LENGTH_0, p = e(14903);
              e(89784)(x, p);
              function m(y, b) {
                var n = this._transformState;
                n.transforming = !1;
                var w = n.writecb;
                if (w === null)
                  return this.emit("error", new f());
                n.writechunk = null, n.writecb = null, b != null && this.push(b), w(y);
                var E = this._readableState;
                E.reading = !1, (E.needReadable || E.length < E.highWaterMark) && this._read(E.highWaterMark);
              }
              function x(y) {
                if (!(this instanceof x))
                  return new x(y);
                p.call(this, y), this._transformState = {
                  afterTransform: m.bind(this),
                  needTransform: !1,
                  transforming: !1,
                  writecb: null,
                  writechunk: null,
                  writeencoding: null
                }, this._readableState.needReadable = !0, this._readableState.sync = !1, y && (typeof y.transform == "function" && (this._transform = y.transform), typeof y.flush == "function" && (this._flush = y.flush)), this.on("prefinish", g);
              }
              function g() {
                var y = this;
                typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(b, n) {
                  S(y, b, n);
                }) : S(this, null, null);
              }
              x.prototype.push = function(y, b) {
                return this._transformState.needTransform = !1, p.prototype.push.call(this, y, b);
              }, x.prototype._transform = function(y, b, n) {
                n(new i("_transform()"));
              }, x.prototype._write = function(y, b, n) {
                var w = this._transformState;
                if (w.writecb = n, w.writechunk = y, w.writeencoding = b, !w.transforming) {
                  var E = this._readableState;
                  (w.needTransform || E.needReadable || E.length < E.highWaterMark) && this._read(E.highWaterMark);
                }
              }, x.prototype._read = function(y) {
                var b = this._transformState;
                b.writechunk !== null && !b.transforming ? (b.transforming = !0, this._transform(b.writechunk, b.writeencoding, b.afterTransform)) : b.needTransform = !0;
              }, x.prototype._destroy = function(y, b) {
                p.prototype._destroy.call(this, y, function(n) {
                  b(n);
                });
              };
              function S(y, b, n) {
                if (b)
                  return y.emit("error", b);
                if (n != null && y.push(n), y._writableState.length)
                  throw new v();
                if (y._transformState.transforming)
                  throw new h();
                return y.push(null);
              }
            }
          ),
          /***/
          29781: (
            /***/
            function(u, l, e) {
              var s = e(9964);
              u.exports = L;
              function i(G) {
                var D = this;
                this.next = null, this.entry = null, this.finish = function() {
                  zt(D, G);
                };
              }
              var f;
              L.WritableState = M;
              var h = {
                deprecate: e(16465)
              }, v = e(99018), p = e(50621).Buffer, m = (typeof e.g < "u" ? e.g : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
              };
              function x(G) {
                return p.from(G);
              }
              function g(G) {
                return p.isBuffer(G) || G instanceof m;
              }
              var S = e(37385), y = e(68130), b = y.getHighWaterMark, n = e(83797).F, w = n.ERR_INVALID_ARG_TYPE, E = n.ERR_METHOD_NOT_IMPLEMENTED, A = n.ERR_MULTIPLE_CALLBACK, O = n.ERR_STREAM_CANNOT_PIPE, C = n.ERR_STREAM_DESTROYED, T = n.ERR_STREAM_NULL_VALUES, P = n.ERR_STREAM_WRITE_AFTER_END, I = n.ERR_UNKNOWN_ENCODING, F = S.errorOrDestroy;
              e(89784)(L, v);
              function B() {
              }
              function M(G, D, Z) {
                f = f || e(14903), G = G || {}, typeof Z != "boolean" && (Z = D instanceof f), this.objectMode = !!G.objectMode, Z && (this.objectMode = this.objectMode || !!G.writableObjectMode), this.highWaterMark = b(this, G, "writableHighWaterMark", Z), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
                var et = G.decodeStrings === !1;
                this.decodeStrings = !et, this.defaultEncoding = G.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(vt) {
                  Rt(D, vt);
                }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = G.emitClose !== !1, this.autoDestroy = !!G.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new i(this);
              }
              M.prototype.getBuffer = function() {
                for (var D = this.bufferedRequest, Z = []; D; )
                  Z.push(D), D = D.next;
                return Z;
              }, function() {
                try {
                  Object.defineProperty(M.prototype, "buffer", {
                    get: h.deprecate(function() {
                      return this.getBuffer();
                    }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
                  });
                } catch {
                }
              }();
              var z;
              typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (z = Function.prototype[Symbol.hasInstance], Object.defineProperty(L, Symbol.hasInstance, {
                value: function(D) {
                  return z.call(this, D) ? !0 : this !== L ? !1 : D && D._writableState instanceof M;
                }
              })) : z = function(D) {
                return D instanceof this;
              };
              function L(G) {
                f = f || e(14903);
                var D = this instanceof f;
                if (!D && !z.call(L, this))
                  return new L(G);
                this._writableState = new M(G, this, D), this.writable = !0, G && (typeof G.write == "function" && (this._write = G.write), typeof G.writev == "function" && (this._writev = G.writev), typeof G.destroy == "function" && (this._destroy = G.destroy), typeof G.final == "function" && (this._final = G.final)), v.call(this);
              }
              L.prototype.pipe = function() {
                F(this, new O());
              };
              function J(G, D) {
                var Z = new P();
                F(G, Z), s.nextTick(D, Z);
              }
              function ft(G, D, Z, et) {
                var vt;
                return Z === null ? vt = new T() : typeof Z != "string" && !D.objectMode && (vt = new w("chunk", ["string", "Buffer"], Z)), vt ? (F(G, vt), s.nextTick(et, vt), !1) : !0;
              }
              L.prototype.write = function(G, D, Z) {
                var et = this._writableState, vt = !1, lt = !et.objectMode && g(G);
                return lt && !p.isBuffer(G) && (G = x(G)), typeof D == "function" && (Z = D, D = null), lt ? D = "buffer" : D || (D = et.defaultEncoding), typeof Z != "function" && (Z = B), et.ending ? J(this, Z) : (lt || ft(this, et, G, Z)) && (et.pendingcb++, vt = xt(this, et, lt, G, D, Z)), vt;
              }, L.prototype.cork = function() {
                this._writableState.corked++;
              }, L.prototype.uncork = function() {
                var G = this._writableState;
                G.corked && (G.corked--, !G.writing && !G.corked && !G.bufferProcessing && G.bufferedRequest && X(this, G));
              }, L.prototype.setDefaultEncoding = function(D) {
                if (typeof D == "string" && (D = D.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((D + "").toLowerCase()) > -1))
                  throw new I(D);
                return this._writableState.defaultEncoding = D, this;
              }, Object.defineProperty(L.prototype, "writableBuffer", {
                // making it explicit this property is not enumerable
                // because otherwise some prototype manipulation in
                // userland will fail
                enumerable: !1,
                get: function() {
                  return this._writableState && this._writableState.getBuffer();
                }
              });
              function Q(G, D, Z) {
                return !G.objectMode && G.decodeStrings !== !1 && typeof D == "string" && (D = p.from(D, Z)), D;
              }
              Object.defineProperty(L.prototype, "writableHighWaterMark", {
                // making it explicit this property is not enumerable
                // because otherwise some prototype manipulation in
                // userland will fail
                enumerable: !1,
                get: function() {
                  return this._writableState.highWaterMark;
                }
              });
              function xt(G, D, Z, et, vt, lt) {
                if (!Z) {
                  var dt = Q(D, et, vt);
                  et !== dt && (Z = !0, vt = "buffer", et = dt);
                }
                var kt = D.objectMode ? 1 : et.length;
                D.length += kt;
                var jt = D.length < D.highWaterMark;
                if (jt || (D.needDrain = !0), D.writing || D.corked) {
                  var me = D.lastBufferedRequest;
                  D.lastBufferedRequest = {
                    chunk: et,
                    encoding: vt,
                    isBuf: Z,
                    callback: lt,
                    next: null
                  }, me ? me.next = D.lastBufferedRequest : D.bufferedRequest = D.lastBufferedRequest, D.bufferedRequestCount += 1;
                } else
                  St(G, D, !1, kt, et, vt, lt);
                return jt;
              }
              function St(G, D, Z, et, vt, lt, dt) {
                D.writelen = et, D.writecb = dt, D.writing = !0, D.sync = !0, D.destroyed ? D.onwrite(new C("write")) : Z ? G._writev(vt, D.onwrite) : G._write(vt, lt, D.onwrite), D.sync = !1;
              }
              function Pt(G, D, Z, et, vt) {
                --D.pendingcb, Z ? (s.nextTick(vt, et), s.nextTick(wt, G, D), G._writableState.errorEmitted = !0, F(G, et)) : (vt(et), G._writableState.errorEmitted = !0, F(G, et), wt(G, D));
              }
              function Gt(G) {
                G.writing = !1, G.writecb = null, G.length -= G.writelen, G.writelen = 0;
              }
              function Rt(G, D) {
                var Z = G._writableState, et = Z.sync, vt = Z.writecb;
                if (typeof vt != "function")
                  throw new A();
                if (Gt(Z), D)
                  Pt(G, Z, et, D, vt);
                else {
                  var lt = gt(Z) || G.destroyed;
                  !lt && !Z.corked && !Z.bufferProcessing && Z.bufferedRequest && X(G, Z), et ? s.nextTick(bt, G, Z, lt, vt) : bt(G, Z, lt, vt);
                }
              }
              function bt(G, D, Z, et) {
                Z || Dt(G, D), D.pendingcb--, et(), wt(G, D);
              }
              function Dt(G, D) {
                D.length === 0 && D.needDrain && (D.needDrain = !1, G.emit("drain"));
              }
              function X(G, D) {
                D.bufferProcessing = !0;
                var Z = D.bufferedRequest;
                if (G._writev && Z && Z.next) {
                  var et = D.bufferedRequestCount, vt = new Array(et), lt = D.corkedRequestsFree;
                  lt.entry = Z;
                  for (var dt = 0, kt = !0; Z; )
                    vt[dt] = Z, Z.isBuf || (kt = !1), Z = Z.next, dt += 1;
                  vt.allBuffers = kt, St(G, D, !0, D.length, vt, "", lt.finish), D.pendingcb++, D.lastBufferedRequest = null, lt.next ? (D.corkedRequestsFree = lt.next, lt.next = null) : D.corkedRequestsFree = new i(D), D.bufferedRequestCount = 0;
                } else {
                  for (; Z; ) {
                    var jt = Z.chunk, me = Z.encoding, se = Z.callback, Bt = D.objectMode ? 1 : jt.length;
                    if (St(G, D, !1, Bt, jt, me, se), Z = Z.next, D.bufferedRequestCount--, D.writing)
                      break;
                  }
                  Z === null && (D.lastBufferedRequest = null);
                }
                D.bufferedRequest = Z, D.bufferProcessing = !1;
              }
              L.prototype._write = function(G, D, Z) {
                Z(new E("_write()"));
              }, L.prototype._writev = null, L.prototype.end = function(G, D, Z) {
                var et = this._writableState;
                return typeof G == "function" ? (Z = G, G = null, D = null) : typeof D == "function" && (Z = D, D = null), G != null && this.write(G, D), et.corked && (et.corked = 1, this.uncork()), et.ending || Ft(this, et, Z), this;
              }, Object.defineProperty(L.prototype, "writableLength", {
                // making it explicit this property is not enumerable
                // because otherwise some prototype manipulation in
                // userland will fail
                enumerable: !1,
                get: function() {
                  return this._writableState.length;
                }
              });
              function gt(G) {
                return G.ending && G.length === 0 && G.bufferedRequest === null && !G.finished && !G.writing;
              }
              function st(G, D) {
                G._final(function(Z) {
                  D.pendingcb--, Z && F(G, Z), D.prefinished = !0, G.emit("prefinish"), wt(G, D);
                });
              }
              function rt(G, D) {
                !D.prefinished && !D.finalCalled && (typeof G._final == "function" && !D.destroyed ? (D.pendingcb++, D.finalCalled = !0, s.nextTick(st, G, D)) : (D.prefinished = !0, G.emit("prefinish")));
              }
              function wt(G, D) {
                var Z = gt(D);
                if (Z && (rt(G, D), D.pendingcb === 0 && (D.finished = !0, G.emit("finish"), D.autoDestroy))) {
                  var et = G._readableState;
                  (!et || et.autoDestroy && et.endEmitted) && G.destroy();
                }
                return Z;
              }
              function Ft(G, D, Z) {
                D.ending = !0, wt(G, D), Z && (D.finished ? s.nextTick(Z) : G.once("finish", Z)), D.ended = !0, G.writable = !1;
              }
              function zt(G, D, Z) {
                var et = G.entry;
                for (G.entry = null; et; ) {
                  var vt = et.callback;
                  D.pendingcb--, vt(Z), et = et.next;
                }
                D.corkedRequestsFree.next = G;
              }
              Object.defineProperty(L.prototype, "destroyed", {
                // making it explicit this property is not enumerable
                // because otherwise some prototype manipulation in
                // userland will fail
                enumerable: !1,
                get: function() {
                  return this._writableState === void 0 ? !1 : this._writableState.destroyed;
                },
                set: function(D) {
                  this._writableState && (this._writableState.destroyed = D);
                }
              }), L.prototype.destroy = S.destroy, L.prototype._undestroy = S.undestroy, L.prototype._destroy = function(G, D) {
                D(G);
              };
            }
          ),
          /***/
          79676: (
            /***/
            function(u, l, e) {
              var s = e(9964), i;
              function f(I, F, B) {
                return F = h(F), F in I ? Object.defineProperty(I, F, { value: B, enumerable: !0, configurable: !0, writable: !0 }) : I[F] = B, I;
              }
              function h(I) {
                var F = v(I, "string");
                return typeof F == "symbol" ? F : String(F);
              }
              function v(I, F) {
                if (typeof I != "object" || I === null)
                  return I;
                var B = I[Symbol.toPrimitive];
                if (B !== void 0) {
                  var M = B.call(I, F || "default");
                  if (typeof M != "object")
                    return M;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (F === "string" ? String : Number)(I);
              }
              var p = e(12167), m = Symbol("lastResolve"), x = Symbol("lastReject"), g = Symbol("error"), S = Symbol("ended"), y = Symbol("lastPromise"), b = Symbol("handlePromise"), n = Symbol("stream");
              function w(I, F) {
                return {
                  value: I,
                  done: F
                };
              }
              function E(I) {
                var F = I[m];
                if (F !== null) {
                  var B = I[n].read();
                  B !== null && (I[y] = null, I[m] = null, I[x] = null, F(w(B, !1)));
                }
              }
              function A(I) {
                s.nextTick(E, I);
              }
              function O(I, F) {
                return function(B, M) {
                  I.then(function() {
                    if (F[S]) {
                      B(w(void 0, !0));
                      return;
                    }
                    F[b](B, M);
                  }, M);
                };
              }
              var C = Object.getPrototypeOf(function() {
              }), T = Object.setPrototypeOf((i = {
                get stream() {
                  return this[n];
                },
                next: function() {
                  var F = this, B = this[g];
                  if (B !== null)
                    return Promise.reject(B);
                  if (this[S])
                    return Promise.resolve(w(void 0, !0));
                  if (this[n].destroyed)
                    return new Promise(function(J, ft) {
                      s.nextTick(function() {
                        F[g] ? ft(F[g]) : J(w(void 0, !0));
                      });
                    });
                  var M = this[y], z;
                  if (M)
                    z = new Promise(O(M, this));
                  else {
                    var L = this[n].read();
                    if (L !== null)
                      return Promise.resolve(w(L, !1));
                    z = new Promise(this[b]);
                  }
                  return this[y] = z, z;
                }
              }, f(i, Symbol.asyncIterator, function() {
                return this;
              }), f(i, "return", function() {
                var F = this;
                return new Promise(function(B, M) {
                  F[n].destroy(null, function(z) {
                    if (z) {
                      M(z);
                      return;
                    }
                    B(w(void 0, !0));
                  });
                });
              }), i), C), P = function(F) {
                var B, M = Object.create(T, (B = {}, f(B, n, {
                  value: F,
                  writable: !0
                }), f(B, m, {
                  value: null,
                  writable: !0
                }), f(B, x, {
                  value: null,
                  writable: !0
                }), f(B, g, {
                  value: null,
                  writable: !0
                }), f(B, S, {
                  value: F._readableState.endEmitted,
                  writable: !0
                }), f(B, b, {
                  value: function(L, J) {
                    var ft = M[n].read();
                    ft ? (M[y] = null, M[m] = null, M[x] = null, L(w(ft, !1))) : (M[m] = L, M[x] = J);
                  },
                  writable: !0
                }), B));
                return M[y] = null, p(F, function(z) {
                  if (z && z.code !== "ERR_STREAM_PREMATURE_CLOSE") {
                    var L = M[x];
                    L !== null && (M[y] = null, M[m] = null, M[x] = null, L(z)), M[g] = z;
                    return;
                  }
                  var J = M[m];
                  J !== null && (M[y] = null, M[m] = null, M[x] = null, J(w(void 0, !0))), M[S] = !0;
                }), F.on("readable", A.bind(null, M)), M;
              };
              u.exports = P;
            }
          ),
          /***/
          37385: (
            /***/
            function(u, l, e) {
              var s = e(9964);
              function i(x, g) {
                var S = this, y = this._readableState && this._readableState.destroyed, b = this._writableState && this._writableState.destroyed;
                return y || b ? (g ? g(x) : x && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, s.nextTick(p, this, x)) : s.nextTick(p, this, x)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(x || null, function(n) {
                  !g && n ? S._writableState ? S._writableState.errorEmitted ? s.nextTick(h, S) : (S._writableState.errorEmitted = !0, s.nextTick(f, S, n)) : s.nextTick(f, S, n) : g ? (s.nextTick(h, S), g(n)) : s.nextTick(h, S);
                }), this);
              }
              function f(x, g) {
                p(x, g), h(x);
              }
              function h(x) {
                x._writableState && !x._writableState.emitClose || x._readableState && !x._readableState.emitClose || x.emit("close");
              }
              function v() {
                this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
              }
              function p(x, g) {
                x.emit("error", g);
              }
              function m(x, g) {
                var S = x._readableState, y = x._writableState;
                S && S.autoDestroy || y && y.autoDestroy ? x.destroy(g) : x.emit("error", g);
              }
              u.exports = {
                destroy: i,
                undestroy: v,
                errorOrDestroy: m
              };
            }
          ),
          /***/
          12167: (
            /***/
            function(u, l, e) {
              var s = e(83797).F.ERR_STREAM_PREMATURE_CLOSE;
              function i(p) {
                var m = !1;
                return function() {
                  if (!m) {
                    m = !0;
                    for (var x = arguments.length, g = new Array(x), S = 0; S < x; S++)
                      g[S] = arguments[S];
                    p.apply(this, g);
                  }
                };
              }
              function f() {
              }
              function h(p) {
                return p.setHeader && typeof p.abort == "function";
              }
              function v(p, m, x) {
                if (typeof m == "function")
                  return v(p, null, m);
                m || (m = {}), x = i(x || f);
                var g = m.readable || m.readable !== !1 && p.readable, S = m.writable || m.writable !== !1 && p.writable, y = function() {
                  p.writable || n();
                }, b = p._writableState && p._writableState.finished, n = function() {
                  S = !1, b = !0, g || x.call(p);
                }, w = p._readableState && p._readableState.endEmitted, E = function() {
                  g = !1, w = !0, S || x.call(p);
                }, A = function(P) {
                  x.call(p, P);
                }, O = function() {
                  var P;
                  if (g && !w)
                    return (!p._readableState || !p._readableState.ended) && (P = new s()), x.call(p, P);
                  if (S && !b)
                    return (!p._writableState || !p._writableState.ended) && (P = new s()), x.call(p, P);
                }, C = function() {
                  p.req.on("finish", n);
                };
                return h(p) ? (p.on("complete", n), p.on("abort", O), p.req ? C() : p.on("request", C)) : S && !p._writableState && (p.on("end", y), p.on("close", y)), p.on("end", E), p.on("finish", n), m.error !== !1 && p.on("error", A), p.on("close", O), function() {
                  p.removeListener("complete", n), p.removeListener("abort", O), p.removeListener("request", C), p.req && p.req.removeListener("finish", n), p.removeListener("end", y), p.removeListener("close", y), p.removeListener("finish", n), p.removeListener("end", E), p.removeListener("error", A), p.removeListener("close", O);
                };
              }
              u.exports = v;
            }
          ),
          /***/
          60378: (
            /***/
            function(u) {
              u.exports = function() {
                throw new Error("Readable.from is not available in the browser");
              };
            }
          ),
          /***/
          43765: (
            /***/
            function(u, l, e) {
              var s;
              function i(n) {
                var w = !1;
                return function() {
                  w || (w = !0, n.apply(void 0, arguments));
                };
              }
              var f = e(83797).F, h = f.ERR_MISSING_ARGS, v = f.ERR_STREAM_DESTROYED;
              function p(n) {
                if (n)
                  throw n;
              }
              function m(n) {
                return n.setHeader && typeof n.abort == "function";
              }
              function x(n, w, E, A) {
                A = i(A);
                var O = !1;
                n.on("close", function() {
                  O = !0;
                }), s === void 0 && (s = e(12167)), s(n, {
                  readable: w,
                  writable: E
                }, function(T) {
                  if (T)
                    return A(T);
                  O = !0, A();
                });
                var C = !1;
                return function(T) {
                  if (!O && !C) {
                    if (C = !0, m(n))
                      return n.abort();
                    if (typeof n.destroy == "function")
                      return n.destroy();
                    A(T || new v("pipe"));
                  }
                };
              }
              function g(n) {
                n();
              }
              function S(n, w) {
                return n.pipe(w);
              }
              function y(n) {
                return !n.length || typeof n[n.length - 1] != "function" ? p : n.pop();
              }
              function b() {
                for (var n = arguments.length, w = new Array(n), E = 0; E < n; E++)
                  w[E] = arguments[E];
                var A = y(w);
                if (Array.isArray(w[0]) && (w = w[0]), w.length < 2)
                  throw new h("streams");
                var O, C = w.map(function(T, P) {
                  var I = P < w.length - 1, F = P > 0;
                  return x(T, I, F, function(B) {
                    O || (O = B), B && C.forEach(g), !I && (C.forEach(g), A(O));
                  });
                });
                return w.reduce(S);
              }
              u.exports = b;
            }
          ),
          /***/
          68130: (
            /***/
            function(u, l, e) {
              var s = e(83797).F.ERR_INVALID_OPT_VALUE;
              function i(h, v, p) {
                return h.highWaterMark != null ? h.highWaterMark : v ? h[p] : null;
              }
              function f(h, v, p, m) {
                var x = i(v, m, p);
                if (x != null) {
                  if (!(isFinite(x) && Math.floor(x) === x) || x < 0) {
                    var g = m ? p : "highWaterMark";
                    throw new s(g, x);
                  }
                  return Math.floor(x);
                }
                return h.objectMode ? 16 : 16384;
              }
              u.exports = {
                getHighWaterMark: f
              };
            }
          ),
          /***/
          99018: (
            /***/
            function(u, l, e) {
              u.exports = e(64785).EventEmitter;
            }
          ),
          /***/
          43143: (
            /***/
            function(u, l, e) {
              var s = e(72361).Buffer, i = s.isEncoding || function(C) {
                switch (C = "" + C, C && C.toLowerCase()) {
                  case "hex":
                  case "utf8":
                  case "utf-8":
                  case "ascii":
                  case "binary":
                  case "base64":
                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                  case "raw":
                    return !0;
                  default:
                    return !1;
                }
              };
              function f(C) {
                if (!C)
                  return "utf8";
                for (var T; ; )
                  switch (C) {
                    case "utf8":
                    case "utf-8":
                      return "utf8";
                    case "ucs2":
                    case "ucs-2":
                    case "utf16le":
                    case "utf-16le":
                      return "utf16le";
                    case "latin1":
                    case "binary":
                      return "latin1";
                    case "base64":
                    case "ascii":
                    case "hex":
                      return C;
                    default:
                      if (T)
                        return;
                      C = ("" + C).toLowerCase(), T = !0;
                  }
              }
              function h(C) {
                var T = f(C);
                if (typeof T != "string" && (s.isEncoding === i || !i(C)))
                  throw new Error("Unknown encoding: " + C);
                return T || C;
              }
              l.I = v;
              function v(C) {
                this.encoding = h(C);
                var T;
                switch (this.encoding) {
                  case "utf16le":
                    this.text = b, this.end = n, T = 4;
                    break;
                  case "utf8":
                    this.fillLast = g, T = 4;
                    break;
                  case "base64":
                    this.text = w, this.end = E, T = 3;
                    break;
                  default:
                    this.write = A, this.end = O;
                    return;
                }
                this.lastNeed = 0, this.lastTotal = 0, this.lastChar = s.allocUnsafe(T);
              }
              v.prototype.write = function(C) {
                if (C.length === 0)
                  return "";
                var T, P;
                if (this.lastNeed) {
                  if (T = this.fillLast(C), T === void 0)
                    return "";
                  P = this.lastNeed, this.lastNeed = 0;
                } else
                  P = 0;
                return P < C.length ? T ? T + this.text(C, P) : this.text(C, P) : T || "";
              }, v.prototype.end = y, v.prototype.text = S, v.prototype.fillLast = function(C) {
                if (this.lastNeed <= C.length)
                  return C.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
                C.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, C.length), this.lastNeed -= C.length;
              };
              function p(C) {
                return C <= 127 ? 0 : C >> 5 === 6 ? 2 : C >> 4 === 14 ? 3 : C >> 3 === 30 ? 4 : C >> 6 === 2 ? -1 : -2;
              }
              function m(C, T, P) {
                var I = T.length - 1;
                if (I < P)
                  return 0;
                var F = p(T[I]);
                return F >= 0 ? (F > 0 && (C.lastNeed = F - 1), F) : --I < P || F === -2 ? 0 : (F = p(T[I]), F >= 0 ? (F > 0 && (C.lastNeed = F - 2), F) : --I < P || F === -2 ? 0 : (F = p(T[I]), F >= 0 ? (F > 0 && (F === 2 ? F = 0 : C.lastNeed = F - 3), F) : 0));
              }
              function x(C, T, P) {
                if ((T[0] & 192) !== 128)
                  return C.lastNeed = 0, "�";
                if (C.lastNeed > 1 && T.length > 1) {
                  if ((T[1] & 192) !== 128)
                    return C.lastNeed = 1, "�";
                  if (C.lastNeed > 2 && T.length > 2 && (T[2] & 192) !== 128)
                    return C.lastNeed = 2, "�";
                }
              }
              function g(C) {
                var T = this.lastTotal - this.lastNeed, P = x(this, C);
                if (P !== void 0)
                  return P;
                if (this.lastNeed <= C.length)
                  return C.copy(this.lastChar, T, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
                C.copy(this.lastChar, T, 0, C.length), this.lastNeed -= C.length;
              }
              function S(C, T) {
                var P = m(this, C, T);
                if (!this.lastNeed)
                  return C.toString("utf8", T);
                this.lastTotal = P;
                var I = C.length - (P - this.lastNeed);
                return C.copy(this.lastChar, 0, I), C.toString("utf8", T, I);
              }
              function y(C) {
                var T = C && C.length ? this.write(C) : "";
                return this.lastNeed ? T + "�" : T;
              }
              function b(C, T) {
                if ((C.length - T) % 2 === 0) {
                  var P = C.toString("utf16le", T);
                  if (P) {
                    var I = P.charCodeAt(P.length - 1);
                    if (I >= 55296 && I <= 56319)
                      return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = C[C.length - 2], this.lastChar[1] = C[C.length - 1], P.slice(0, -1);
                  }
                  return P;
                }
                return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = C[C.length - 1], C.toString("utf16le", T, C.length - 1);
              }
              function n(C) {
                var T = C && C.length ? this.write(C) : "";
                if (this.lastNeed) {
                  var P = this.lastTotal - this.lastNeed;
                  return T + this.lastChar.toString("utf16le", 0, P);
                }
                return T;
              }
              function w(C, T) {
                var P = (C.length - T) % 3;
                return P === 0 ? C.toString("base64", T) : (this.lastNeed = 3 - P, this.lastTotal = 3, P === 1 ? this.lastChar[0] = C[C.length - 1] : (this.lastChar[0] = C[C.length - 2], this.lastChar[1] = C[C.length - 1]), C.toString("base64", T, C.length - P));
              }
              function E(C) {
                var T = C && C.length ? this.write(C) : "";
                return this.lastNeed ? T + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : T;
              }
              function A(C) {
                return C.toString(this.encoding);
              }
              function O(C) {
                return C && C.length ? this.write(C) : "";
              }
            }
          ),
          /***/
          3483: (
            /***/
            function(u) {
              var l = 0, e = -3;
              function s() {
                this.table = new Uint16Array(16), this.trans = new Uint16Array(288);
              }
              function i(B, M) {
                this.source = B, this.sourceIndex = 0, this.tag = 0, this.bitcount = 0, this.dest = M, this.destLen = 0, this.ltree = new s(), this.dtree = new s();
              }
              var f = new s(), h = new s(), v = new Uint8Array(30), p = new Uint16Array(30), m = new Uint8Array(30), x = new Uint16Array(30), g = new Uint8Array([
                16,
                17,
                18,
                0,
                8,
                7,
                9,
                6,
                10,
                5,
                11,
                4,
                12,
                3,
                13,
                2,
                14,
                1,
                15
              ]), S = new s(), y = new Uint8Array(288 + 32);
              function b(B, M, z, L) {
                var J, ft;
                for (J = 0; J < z; ++J)
                  B[J] = 0;
                for (J = 0; J < 30 - z; ++J)
                  B[J + z] = J / z | 0;
                for (ft = L, J = 0; J < 30; ++J)
                  M[J] = ft, ft += 1 << B[J];
              }
              function n(B, M) {
                var z;
                for (z = 0; z < 7; ++z)
                  B.table[z] = 0;
                for (B.table[7] = 24, B.table[8] = 152, B.table[9] = 112, z = 0; z < 24; ++z)
                  B.trans[z] = 256 + z;
                for (z = 0; z < 144; ++z)
                  B.trans[24 + z] = z;
                for (z = 0; z < 8; ++z)
                  B.trans[168 + z] = 280 + z;
                for (z = 0; z < 112; ++z)
                  B.trans[176 + z] = 144 + z;
                for (z = 0; z < 5; ++z)
                  M.table[z] = 0;
                for (M.table[5] = 32, z = 0; z < 32; ++z)
                  M.trans[z] = z;
              }
              var w = new Uint16Array(16);
              function E(B, M, z, L) {
                var J, ft;
                for (J = 0; J < 16; ++J)
                  B.table[J] = 0;
                for (J = 0; J < L; ++J)
                  B.table[M[z + J]]++;
                for (B.table[0] = 0, ft = 0, J = 0; J < 16; ++J)
                  w[J] = ft, ft += B.table[J];
                for (J = 0; J < L; ++J)
                  M[z + J] && (B.trans[w[M[z + J]]++] = J);
              }
              function A(B) {
                B.bitcount-- || (B.tag = B.source[B.sourceIndex++], B.bitcount = 7);
                var M = B.tag & 1;
                return B.tag >>>= 1, M;
              }
              function O(B, M, z) {
                if (!M)
                  return z;
                for (; B.bitcount < 24; )
                  B.tag |= B.source[B.sourceIndex++] << B.bitcount, B.bitcount += 8;
                var L = B.tag & 65535 >>> 16 - M;
                return B.tag >>>= M, B.bitcount -= M, L + z;
              }
              function C(B, M) {
                for (; B.bitcount < 24; )
                  B.tag |= B.source[B.sourceIndex++] << B.bitcount, B.bitcount += 8;
                var z = 0, L = 0, J = 0, ft = B.tag;
                do
                  L = 2 * L + (ft & 1), ft >>>= 1, ++J, z += M.table[J], L -= M.table[J];
                while (L >= 0);
                return B.tag = ft, B.bitcount -= J, M.trans[z + L];
              }
              function T(B, M, z) {
                var L, J, ft, Q, xt, St;
                for (L = O(B, 5, 257), J = O(B, 5, 1), ft = O(B, 4, 4), Q = 0; Q < 19; ++Q)
                  y[Q] = 0;
                for (Q = 0; Q < ft; ++Q) {
                  var Pt = O(B, 3, 0);
                  y[g[Q]] = Pt;
                }
                for (E(S, y, 0, 19), xt = 0; xt < L + J; ) {
                  var Gt = C(B, S);
                  switch (Gt) {
                    case 16:
                      var Rt = y[xt - 1];
                      for (St = O(B, 2, 3); St; --St)
                        y[xt++] = Rt;
                      break;
                    case 17:
                      for (St = O(B, 3, 3); St; --St)
                        y[xt++] = 0;
                      break;
                    case 18:
                      for (St = O(B, 7, 11); St; --St)
                        y[xt++] = 0;
                      break;
                    default:
                      y[xt++] = Gt;
                      break;
                  }
                }
                E(M, y, 0, L), E(z, y, L, J);
              }
              function P(B, M, z) {
                for (; ; ) {
                  var L = C(B, M);
                  if (L === 256)
                    return l;
                  if (L < 256)
                    B.dest[B.destLen++] = L;
                  else {
                    var J, ft, Q, xt;
                    for (L -= 257, J = O(B, v[L], p[L]), ft = C(B, z), Q = B.destLen - O(B, m[ft], x[ft]), xt = Q; xt < Q + J; ++xt)
                      B.dest[B.destLen++] = B.dest[xt];
                  }
                }
              }
              function I(B) {
                for (var M, z, L; B.bitcount > 8; )
                  B.sourceIndex--, B.bitcount -= 8;
                if (M = B.source[B.sourceIndex + 1], M = 256 * M + B.source[B.sourceIndex], z = B.source[B.sourceIndex + 3], z = 256 * z + B.source[B.sourceIndex + 2], M !== (~z & 65535))
                  return e;
                for (B.sourceIndex += 4, L = M; L; --L)
                  B.dest[B.destLen++] = B.source[B.sourceIndex++];
                return B.bitcount = 0, l;
              }
              function F(B, M) {
                var z = new i(B, M), L, J, ft;
                do {
                  switch (L = A(z), J = O(z, 2, 0), J) {
                    case 0:
                      ft = I(z);
                      break;
                    case 1:
                      ft = P(z, f, h);
                      break;
                    case 2:
                      T(z, z.ltree, z.dtree), ft = P(z, z.ltree, z.dtree);
                      break;
                    default:
                      ft = e;
                  }
                  if (ft !== l)
                    throw new Error("Data error");
                } while (!L);
                return z.destLen < z.dest.length ? typeof z.dest.slice == "function" ? z.dest.slice(0, z.destLen) : z.dest.subarray(0, z.destLen) : z.dest;
              }
              n(f, h), b(v, p, 4, 3), b(m, x, 2, 1), v[28] = 0, p[28] = 258, u.exports = F;
            }
          ),
          /***/
          16465: (
            /***/
            function(u, l, e) {
              u.exports = s;
              function s(f, h) {
                if (i("noDeprecation"))
                  return f;
                var v = !1;
                function p() {
                  if (!v) {
                    if (i("throwDeprecation"))
                      throw new Error(h);
                    i("traceDeprecation") ? console.trace(h) : console.warn(h), v = !0;
                  }
                  return f.apply(this, arguments);
                }
                return p;
              }
              function i(f) {
                try {
                  if (!e.g.localStorage)
                    return !1;
                } catch {
                  return !1;
                }
                var h = e.g.localStorage[f];
                return h == null ? !1 : String(h).toLowerCase() === "true";
              }
            }
          ),
          /***/
          41201: (
            /***/
            function(u) {
              u.exports = function(e) {
                return e && typeof e == "object" && typeof e.copy == "function" && typeof e.fill == "function" && typeof e.readUInt8 == "function";
              };
            }
          ),
          /***/
          29490: (
            /***/
            function(u, l, e) {
              var s = e(67906), i = e(44610), f = e(43381), h = e(46094);
              function v(Bt) {
                return Bt.call.bind(Bt);
              }
              var p = typeof BigInt < "u", m = typeof Symbol < "u", x = v(Object.prototype.toString), g = v(Number.prototype.valueOf), S = v(String.prototype.valueOf), y = v(Boolean.prototype.valueOf);
              if (p)
                var b = v(BigInt.prototype.valueOf);
              if (m)
                var n = v(Symbol.prototype.valueOf);
              function w(Bt, ge) {
                if (typeof Bt != "object")
                  return !1;
                try {
                  return ge(Bt), !0;
                } catch {
                  return !1;
                }
              }
              l.isArgumentsObject = s, l.isGeneratorFunction = i, l.isTypedArray = h;
              function E(Bt) {
                return typeof Promise < "u" && Bt instanceof Promise || Bt !== null && typeof Bt == "object" && typeof Bt.then == "function" && typeof Bt.catch == "function";
              }
              l.isPromise = E;
              function A(Bt) {
                return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(Bt) : h(Bt) || st(Bt);
              }
              l.isArrayBufferView = A;
              function O(Bt) {
                return f(Bt) === "Uint8Array";
              }
              l.isUint8Array = O;
              function C(Bt) {
                return f(Bt) === "Uint8ClampedArray";
              }
              l.isUint8ClampedArray = C;
              function T(Bt) {
                return f(Bt) === "Uint16Array";
              }
              l.isUint16Array = T;
              function P(Bt) {
                return f(Bt) === "Uint32Array";
              }
              l.isUint32Array = P;
              function I(Bt) {
                return f(Bt) === "Int8Array";
              }
              l.isInt8Array = I;
              function F(Bt) {
                return f(Bt) === "Int16Array";
              }
              l.isInt16Array = F;
              function B(Bt) {
                return f(Bt) === "Int32Array";
              }
              l.isInt32Array = B;
              function M(Bt) {
                return f(Bt) === "Float32Array";
              }
              l.isFloat32Array = M;
              function z(Bt) {
                return f(Bt) === "Float64Array";
              }
              l.isFloat64Array = z;
              function L(Bt) {
                return f(Bt) === "BigInt64Array";
              }
              l.isBigInt64Array = L;
              function J(Bt) {
                return f(Bt) === "BigUint64Array";
              }
              l.isBigUint64Array = J;
              function ft(Bt) {
                return x(Bt) === "[object Map]";
              }
              ft.working = typeof Map < "u" && ft(/* @__PURE__ */ new Map());
              function Q(Bt) {
                return typeof Map > "u" ? !1 : ft.working ? ft(Bt) : Bt instanceof Map;
              }
              l.isMap = Q;
              function xt(Bt) {
                return x(Bt) === "[object Set]";
              }
              xt.working = typeof Set < "u" && xt(/* @__PURE__ */ new Set());
              function St(Bt) {
                return typeof Set > "u" ? !1 : xt.working ? xt(Bt) : Bt instanceof Set;
              }
              l.isSet = St;
              function Pt(Bt) {
                return x(Bt) === "[object WeakMap]";
              }
              Pt.working = typeof WeakMap < "u" && Pt(/* @__PURE__ */ new WeakMap());
              function Gt(Bt) {
                return typeof WeakMap > "u" ? !1 : Pt.working ? Pt(Bt) : Bt instanceof WeakMap;
              }
              l.isWeakMap = Gt;
              function Rt(Bt) {
                return x(Bt) === "[object WeakSet]";
              }
              Rt.working = typeof WeakSet < "u" && Rt(/* @__PURE__ */ new WeakSet());
              function bt(Bt) {
                return Rt(Bt);
              }
              l.isWeakSet = bt;
              function Dt(Bt) {
                return x(Bt) === "[object ArrayBuffer]";
              }
              Dt.working = typeof ArrayBuffer < "u" && Dt(new ArrayBuffer());
              function X(Bt) {
                return typeof ArrayBuffer > "u" ? !1 : Dt.working ? Dt(Bt) : Bt instanceof ArrayBuffer;
              }
              l.isArrayBuffer = X;
              function gt(Bt) {
                return x(Bt) === "[object DataView]";
              }
              gt.working = typeof ArrayBuffer < "u" && typeof DataView < "u" && gt(new DataView(new ArrayBuffer(1), 0, 1));
              function st(Bt) {
                return typeof DataView > "u" ? !1 : gt.working ? gt(Bt) : Bt instanceof DataView;
              }
              l.isDataView = st;
              var rt = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : void 0;
              function wt(Bt) {
                return x(Bt) === "[object SharedArrayBuffer]";
              }
              function Ft(Bt) {
                return typeof rt > "u" ? !1 : (typeof wt.working > "u" && (wt.working = wt(new rt())), wt.working ? wt(Bt) : Bt instanceof rt);
              }
              l.isSharedArrayBuffer = Ft;
              function zt(Bt) {
                return x(Bt) === "[object AsyncFunction]";
              }
              l.isAsyncFunction = zt;
              function G(Bt) {
                return x(Bt) === "[object Map Iterator]";
              }
              l.isMapIterator = G;
              function D(Bt) {
                return x(Bt) === "[object Set Iterator]";
              }
              l.isSetIterator = D;
              function Z(Bt) {
                return x(Bt) === "[object Generator]";
              }
              l.isGeneratorObject = Z;
              function et(Bt) {
                return x(Bt) === "[object WebAssembly.Module]";
              }
              l.isWebAssemblyCompiledModule = et;
              function vt(Bt) {
                return w(Bt, g);
              }
              l.isNumberObject = vt;
              function lt(Bt) {
                return w(Bt, S);
              }
              l.isStringObject = lt;
              function dt(Bt) {
                return w(Bt, y);
              }
              l.isBooleanObject = dt;
              function kt(Bt) {
                return p && w(Bt, b);
              }
              l.isBigIntObject = kt;
              function jt(Bt) {
                return m && w(Bt, n);
              }
              l.isSymbolObject = jt;
              function me(Bt) {
                return vt(Bt) || lt(Bt) || dt(Bt) || kt(Bt) || jt(Bt);
              }
              l.isBoxedPrimitive = me;
              function se(Bt) {
                return typeof Uint8Array < "u" && (X(Bt) || Ft(Bt));
              }
              l.isAnyArrayBuffer = se, ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function(Bt) {
                Object.defineProperty(l, Bt, {
                  enumerable: !1,
                  value: function() {
                    throw new Error(Bt + " is not supported in userland");
                  }
                });
              });
            }
          ),
          /***/
          7187: (
            /***/
            function(u, l, e) {
              var s = e(9964), i = Object.getOwnPropertyDescriptors || function(rt) {
                for (var wt = Object.keys(rt), Ft = {}, zt = 0; zt < wt.length; zt++)
                  Ft[wt[zt]] = Object.getOwnPropertyDescriptor(rt, wt[zt]);
                return Ft;
              }, f = /%[sdj%]/g;
              l.format = function(st) {
                if (!F(st)) {
                  for (var rt = [], wt = 0; wt < arguments.length; wt++)
                    rt.push(m(arguments[wt]));
                  return rt.join(" ");
                }
                for (var wt = 1, Ft = arguments, zt = Ft.length, G = String(st).replace(f, function(Z) {
                  if (Z === "%%")
                    return "%";
                  if (wt >= zt)
                    return Z;
                  switch (Z) {
                    case "%s":
                      return String(Ft[wt++]);
                    case "%d":
                      return Number(Ft[wt++]);
                    case "%j":
                      try {
                        return JSON.stringify(Ft[wt++]);
                      } catch {
                        return "[Circular]";
                      }
                    default:
                      return Z;
                  }
                }), D = Ft[wt]; wt < zt; D = Ft[++wt])
                  T(D) || !L(D) ? G += " " + D : G += " " + m(D);
                return G;
              }, l.deprecate = function(st, rt) {
                if (typeof s < "u" && s.noDeprecation === !0)
                  return st;
                if (typeof s > "u")
                  return function() {
                    return l.deprecate(st, rt).apply(this, arguments);
                  };
                var wt = !1;
                function Ft() {
                  if (!wt) {
                    if (s.throwDeprecation)
                      throw new Error(rt);
                    s.traceDeprecation ? console.trace(rt) : console.error(rt), wt = !0;
                  }
                  return st.apply(this, arguments);
                }
                return Ft;
              };
              var h = {}, v = /^$/;
              if (s.env.NODE_DEBUG) {
                var p = s.env.NODE_DEBUG;
                p = p.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), v = new RegExp("^" + p + "$", "i");
              }
              l.debuglog = function(st) {
                if (st = st.toUpperCase(), !h[st])
                  if (v.test(st)) {
                    var rt = s.pid;
                    h[st] = function() {
                      var wt = l.format.apply(l, arguments);
                      console.error("%s %d: %s", st, rt, wt);
                    };
                  } else
                    h[st] = function() {
                    };
                return h[st];
              };
              function m(st, rt) {
                var wt = {
                  seen: [],
                  stylize: g
                };
                return arguments.length >= 3 && (wt.depth = arguments[2]), arguments.length >= 4 && (wt.colors = arguments[3]), C(rt) ? wt.showHidden = rt : rt && l._extend(wt, rt), M(wt.showHidden) && (wt.showHidden = !1), M(wt.depth) && (wt.depth = 2), M(wt.colors) && (wt.colors = !1), M(wt.customInspect) && (wt.customInspect = !0), wt.colors && (wt.stylize = x), y(wt, st, wt.depth);
              }
              l.inspect = m, m.colors = {
                bold: [1, 22],
                italic: [3, 23],
                underline: [4, 24],
                inverse: [7, 27],
                white: [37, 39],
                grey: [90, 39],
                black: [30, 39],
                blue: [34, 39],
                cyan: [36, 39],
                green: [32, 39],
                magenta: [35, 39],
                red: [31, 39],
                yellow: [33, 39]
              }, m.styles = {
                special: "cyan",
                number: "yellow",
                boolean: "yellow",
                undefined: "grey",
                null: "bold",
                string: "green",
                date: "magenta",
                // "name": intentionally not styling
                regexp: "red"
              };
              function x(st, rt) {
                var wt = m.styles[rt];
                return wt ? "\x1B[" + m.colors[wt][0] + "m" + st + "\x1B[" + m.colors[wt][1] + "m" : st;
              }
              function g(st, rt) {
                return st;
              }
              function S(st) {
                var rt = {};
                return st.forEach(function(wt, Ft) {
                  rt[wt] = !0;
                }), rt;
              }
              function y(st, rt, wt) {
                if (st.customInspect && rt && Q(rt.inspect) && // Filter out the util module, it's inspect function is special
                rt.inspect !== l.inspect && // Also filter out any prototype objects using the circular check.
                !(rt.constructor && rt.constructor.prototype === rt)) {
                  var Ft = rt.inspect(wt, st);
                  return F(Ft) || (Ft = y(st, Ft, wt)), Ft;
                }
                var zt = b(st, rt);
                if (zt)
                  return zt;
                var G = Object.keys(rt), D = S(G);
                if (st.showHidden && (G = Object.getOwnPropertyNames(rt)), ft(rt) && (G.indexOf("message") >= 0 || G.indexOf("description") >= 0))
                  return n(rt);
                if (G.length === 0) {
                  if (Q(rt)) {
                    var Z = rt.name ? ": " + rt.name : "";
                    return st.stylize("[Function" + Z + "]", "special");
                  }
                  if (z(rt))
                    return st.stylize(RegExp.prototype.toString.call(rt), "regexp");
                  if (J(rt))
                    return st.stylize(Date.prototype.toString.call(rt), "date");
                  if (ft(rt))
                    return n(rt);
                }
                var et = "", vt = !1, lt = ["{", "}"];
                if (O(rt) && (vt = !0, lt = ["[", "]"]), Q(rt)) {
                  var dt = rt.name ? ": " + rt.name : "";
                  et = " [Function" + dt + "]";
                }
                if (z(rt) && (et = " " + RegExp.prototype.toString.call(rt)), J(rt) && (et = " " + Date.prototype.toUTCString.call(rt)), ft(rt) && (et = " " + n(rt)), G.length === 0 && (!vt || rt.length == 0))
                  return lt[0] + et + lt[1];
                if (wt < 0)
                  return z(rt) ? st.stylize(RegExp.prototype.toString.call(rt), "regexp") : st.stylize("[Object]", "special");
                st.seen.push(rt);
                var kt;
                return vt ? kt = w(st, rt, wt, D, G) : kt = G.map(function(jt) {
                  return E(st, rt, wt, D, jt, vt);
                }), st.seen.pop(), A(kt, et, lt);
              }
              function b(st, rt) {
                if (M(rt))
                  return st.stylize("undefined", "undefined");
                if (F(rt)) {
                  var wt = "'" + JSON.stringify(rt).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
                  return st.stylize(wt, "string");
                }
                if (I(rt))
                  return st.stylize("" + rt, "number");
                if (C(rt))
                  return st.stylize("" + rt, "boolean");
                if (T(rt))
                  return st.stylize("null", "null");
              }
              function n(st) {
                return "[" + Error.prototype.toString.call(st) + "]";
              }
              function w(st, rt, wt, Ft, zt) {
                for (var G = [], D = 0, Z = rt.length; D < Z; ++D)
                  bt(rt, String(D)) ? G.push(E(
                    st,
                    rt,
                    wt,
                    Ft,
                    String(D),
                    !0
                  )) : G.push("");
                return zt.forEach(function(et) {
                  et.match(/^\d+$/) || G.push(E(
                    st,
                    rt,
                    wt,
                    Ft,
                    et,
                    !0
                  ));
                }), G;
              }
              function E(st, rt, wt, Ft, zt, G) {
                var D, Z, et;
                if (et = Object.getOwnPropertyDescriptor(rt, zt) || { value: rt[zt] }, et.get ? et.set ? Z = st.stylize("[Getter/Setter]", "special") : Z = st.stylize("[Getter]", "special") : et.set && (Z = st.stylize("[Setter]", "special")), bt(Ft, zt) || (D = "[" + zt + "]"), Z || (st.seen.indexOf(et.value) < 0 ? (T(wt) ? Z = y(st, et.value, null) : Z = y(st, et.value, wt - 1), Z.indexOf(`
`) > -1 && (G ? Z = Z.split(`
`).map(function(vt) {
                  return "  " + vt;
                }).join(`
`).slice(2) : Z = `
` + Z.split(`
`).map(function(vt) {
                  return "   " + vt;
                }).join(`
`))) : Z = st.stylize("[Circular]", "special")), M(D)) {
                  if (G && zt.match(/^\d+$/))
                    return Z;
                  D = JSON.stringify("" + zt), D.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (D = D.slice(1, -1), D = st.stylize(D, "name")) : (D = D.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), D = st.stylize(D, "string"));
                }
                return D + ": " + Z;
              }
              function A(st, rt, wt) {
                var Ft = st.reduce(function(zt, G) {
                  return G.indexOf(`
`) >= 0, zt + G.replace(/\u001b\[\d\d?m/g, "").length + 1;
                }, 0);
                return Ft > 60 ? wt[0] + (rt === "" ? "" : rt + `
 `) + " " + st.join(`,
  `) + " " + wt[1] : wt[0] + rt + " " + st.join(", ") + " " + wt[1];
              }
              l.types = e(29490);
              function O(st) {
                return Array.isArray(st);
              }
              l.isArray = O;
              function C(st) {
                return typeof st == "boolean";
              }
              l.isBoolean = C;
              function T(st) {
                return st === null;
              }
              l.isNull = T;
              function P(st) {
                return st == null;
              }
              l.isNullOrUndefined = P;
              function I(st) {
                return typeof st == "number";
              }
              l.isNumber = I;
              function F(st) {
                return typeof st == "string";
              }
              l.isString = F;
              function B(st) {
                return typeof st == "symbol";
              }
              l.isSymbol = B;
              function M(st) {
                return st === void 0;
              }
              l.isUndefined = M;
              function z(st) {
                return L(st) && St(st) === "[object RegExp]";
              }
              l.isRegExp = z, l.types.isRegExp = z;
              function L(st) {
                return typeof st == "object" && st !== null;
              }
              l.isObject = L;
              function J(st) {
                return L(st) && St(st) === "[object Date]";
              }
              l.isDate = J, l.types.isDate = J;
              function ft(st) {
                return L(st) && (St(st) === "[object Error]" || st instanceof Error);
              }
              l.isError = ft, l.types.isNativeError = ft;
              function Q(st) {
                return typeof st == "function";
              }
              l.isFunction = Q;
              function xt(st) {
                return st === null || typeof st == "boolean" || typeof st == "number" || typeof st == "string" || typeof st == "symbol" || // ES6 symbol
                typeof st > "u";
              }
              l.isPrimitive = xt, l.isBuffer = e(41201);
              function St(st) {
                return Object.prototype.toString.call(st);
              }
              function Pt(st) {
                return st < 10 ? "0" + st.toString(10) : st.toString(10);
              }
              var Gt = [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
              ];
              function Rt() {
                var st = /* @__PURE__ */ new Date(), rt = [
                  Pt(st.getHours()),
                  Pt(st.getMinutes()),
                  Pt(st.getSeconds())
                ].join(":");
                return [st.getDate(), Gt[st.getMonth()], rt].join(" ");
              }
              l.log = function() {
                console.log("%s - %s", Rt(), l.format.apply(l, arguments));
              }, l.inherits = e(89784), l._extend = function(st, rt) {
                if (!rt || !L(rt))
                  return st;
                for (var wt = Object.keys(rt), Ft = wt.length; Ft--; )
                  st[wt[Ft]] = rt[wt[Ft]];
                return st;
              };
              function bt(st, rt) {
                return Object.prototype.hasOwnProperty.call(st, rt);
              }
              var Dt = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
              l.promisify = function(rt) {
                if (typeof rt != "function")
                  throw new TypeError('The "original" argument must be of type Function');
                if (Dt && rt[Dt]) {
                  var wt = rt[Dt];
                  if (typeof wt != "function")
                    throw new TypeError('The "util.promisify.custom" argument must be of type Function');
                  return Object.defineProperty(wt, Dt, {
                    value: wt,
                    enumerable: !1,
                    writable: !1,
                    configurable: !0
                  }), wt;
                }
                function wt() {
                  for (var Ft, zt, G = new Promise(function(et, vt) {
                    Ft = et, zt = vt;
                  }), D = [], Z = 0; Z < arguments.length; Z++)
                    D.push(arguments[Z]);
                  D.push(function(et, vt) {
                    et ? zt(et) : Ft(vt);
                  });
                  try {
                    rt.apply(this, D);
                  } catch (et) {
                    zt(et);
                  }
                  return G;
                }
                return Object.setPrototypeOf(wt, Object.getPrototypeOf(rt)), Dt && Object.defineProperty(wt, Dt, {
                  value: wt,
                  enumerable: !1,
                  writable: !1,
                  configurable: !0
                }), Object.defineProperties(
                  wt,
                  i(rt)
                );
              }, l.promisify.custom = Dt;
              function X(st, rt) {
                if (!st) {
                  var wt = new Error("Promise was rejected with a falsy value");
                  wt.reason = st, st = wt;
                }
                return rt(st);
              }
              function gt(st) {
                if (typeof st != "function")
                  throw new TypeError('The "original" argument must be of type Function');
                function rt() {
                  for (var wt = [], Ft = 0; Ft < arguments.length; Ft++)
                    wt.push(arguments[Ft]);
                  var zt = wt.pop();
                  if (typeof zt != "function")
                    throw new TypeError("The last argument must be of type Function");
                  var G = this, D = function() {
                    return zt.apply(G, arguments);
                  };
                  st.apply(this, wt).then(
                    function(Z) {
                      s.nextTick(D.bind(null, null, Z));
                    },
                    function(Z) {
                      s.nextTick(X.bind(null, Z, D));
                    }
                  );
                }
                return Object.setPrototypeOf(rt, Object.getPrototypeOf(st)), Object.defineProperties(
                  rt,
                  i(st)
                ), rt;
              }
              l.callbackify = gt;
            }
          ),
          /***/
          43381: (
            /***/
            function(u, l, e) {
              var s = e(68404), i = e(10821), f = e(26601), h = e(67913), v = e(68109), p = h("Object.prototype.toString"), m = e(26626)(), x = typeof globalThis > "u" ? e.g : globalThis, g = i(), S = h("String.prototype.slice"), y = Object.getPrototypeOf, b = h("Array.prototype.indexOf", !0) || /** @type {(array: readonly unknown[], value: unknown) => keyof array} */
              function(O, C) {
                for (var T = 0; T < O.length; T += 1)
                  if (O[T] === C)
                    return T;
                return -1;
              }, n = { __proto__: null };
              m && v && y ? s(g, function(A) {
                var O = new x[A]();
                if (Symbol.toStringTag in O) {
                  var C = y(O), T = v(C, Symbol.toStringTag);
                  if (!T) {
                    var P = y(C);
                    T = v(P, Symbol.toStringTag);
                  }
                  n["$" + A] = f(T.get);
                }
              }) : s(g, function(A) {
                var O = new x[A](), C = O.slice || O.set;
                C && (n["$" + A] = f(C));
              });
              var w = function(O) {
                var C = !1;
                return s(
                  // eslint-disable-next-line no-extra-parens
                  /** @type {Record<`\$${TypedArrayName}`, typeof cache>} */
                  /** @type {any} */
                  n,
                  /** @type {(getter: typeof cache, name: `\$${TypedArrayName}`) => void} */
                  function(T, P) {
                    if (!C)
                      try {
                        "$" + T(O) === P && (C = S(P, 1));
                      } catch {
                      }
                  }
                ), C;
              }, E = function(O) {
                var C = !1;
                return s(
                  // eslint-disable-next-line no-extra-parens
                  /** @type {any} */
                  n,
                  /** @type {(getter: typeof cache, name: `\$${TypedArrayName}`) => void} */
                  function(T, P) {
                    if (!C)
                      try {
                        T(O), C = S(P, 1);
                      } catch {
                      }
                  }
                ), C;
              };
              u.exports = function(O) {
                if (!O || typeof O != "object")
                  return !1;
                if (!m) {
                  var C = S(p(O), 8, -1);
                  return b(g, C) > -1 ? C : C !== "Object" ? !1 : E(O);
                }
                return v ? w(O) : null;
              };
            }
          ),
          /***/
          52242: (
            /***/
            function(u, l, e) {
              u.exports = e(45349);
            }
          ),
          /***/
          45349: (
            /***/
            function(u, l, e) {
              (function() {
                var s;
                if (u.exports && !e.g.xmldocAssumeBrowser)
                  s = e(61733);
                else if (s = this.sax, !s)
                  throw new Error(
                    "Expected sax to be defined. Make sure you're including sax.js before this file."
                  );
                function i(T, P) {
                  if (!P) {
                    var I = m[m.length - 1];
                    I.parser && (P = I.parser);
                  }
                  this.name = T.name, this.attr = T.attributes, this.val = "", this.children = [], this.firstChild = null, this.lastChild = null, this.line = P ? P.line : null, this.column = P ? P.column : null, this.position = P ? P.position : null, this.startTagPosition = P ? P.startTagPosition : null;
                }
                i.prototype._addChild = function(T) {
                  this.children.push(T), this.firstChild || (this.firstChild = T), this.lastChild = T;
                }, i.prototype._opentag = function(T) {
                  var P = new i(T);
                  this._addChild(P), m.unshift(P);
                }, i.prototype._closetag = function() {
                  m.shift();
                }, i.prototype._text = function(T) {
                  typeof this.children > "u" || (this.val += T, this._addChild(new f(T)));
                }, i.prototype._cdata = function(T) {
                  this.val += T, this._addChild(new h(T));
                }, i.prototype._comment = function(T) {
                  typeof this.children > "u" || this._addChild(new v(T));
                }, i.prototype._error = function(T) {
                  throw T;
                }, i.prototype.eachChild = function(T, P) {
                  for (var I = 0, F = this.children.length; I < F; I++)
                    if (this.children[I].type === "element" && T.call(P, this.children[I], I, this.children) === !1)
                      return;
                }, i.prototype.childNamed = function(T) {
                  for (var P = 0, I = this.children.length; P < I; P++) {
                    var F = this.children[P];
                    if (F.name === T)
                      return F;
                  }
                }, i.prototype.childrenNamed = function(T) {
                  for (var P = [], I = 0, F = this.children.length; I < F; I++)
                    this.children[I].name === T && P.push(this.children[I]);
                  return P;
                }, i.prototype.childWithAttribute = function(T, P) {
                  for (var I = 0, F = this.children.length; I < F; I++) {
                    var B = this.children[I];
                    if (B.type === "element" && (P && B.attr[T] === P || !P && B.attr[T]))
                      return B;
                  }
                }, i.prototype.descendantsNamed = function(T) {
                  for (var P = [], I = 0, F = this.children.length; I < F; I++) {
                    var B = this.children[I];
                    B.type === "element" && (B.name === T && P.push(B), P = P.concat(B.descendantsNamed(T)));
                  }
                  return P;
                }, i.prototype.descendantWithPath = function(T) {
                  for (var P = this, I = T.split("."), F = 0, B = I.length; F < B; F++)
                    if (P && P.type === "element")
                      P = P.childNamed(I[F]);
                    else
                      return;
                  return P;
                }, i.prototype.valueWithPath = function(T) {
                  var P = T.split("@"), I = this.descendantWithPath(P[0]);
                  if (I)
                    return P.length > 1 ? I.attr[P[1]] : I.val;
                }, i.prototype.toString = function(T) {
                  return this.toStringWithIndent("", T);
                }, i.prototype.toStringWithIndent = function(T, P) {
                  var I = T + "<" + this.name, F = P && P.compressed ? "" : `
`;
                  P && P.preserveWhitespace;
                  for (var B in this.attr)
                    Object.prototype.hasOwnProperty.call(this.attr, B) && (I += " " + B + '="' + O(this.attr[B]) + '"');
                  if (this.children.length === 1 && this.children[0].type !== "element")
                    I += ">" + this.children[0].toString(P) + "</" + this.name + ">";
                  else if (this.children.length) {
                    I += ">" + F;
                    for (var M = T + (P && P.compressed ? "" : "  "), z = 0, L = this.children.length; z < L; z++)
                      I += this.children[z].toStringWithIndent(M, P) + F;
                    I += T + "</" + this.name + ">";
                  } else if (P && P.html) {
                    var J = [
                      "area",
                      "base",
                      "br",
                      "col",
                      "embed",
                      "frame",
                      "hr",
                      "img",
                      "input",
                      "keygen",
                      "link",
                      "menuitem",
                      "meta",
                      "param",
                      "source",
                      "track",
                      "wbr"
                    ];
                    J.indexOf(this.name) !== -1 ? I += "/>" : I += "></" + this.name + ">";
                  } else
                    I += "/>";
                  return I;
                };
                function f(T) {
                  this.text = T;
                }
                f.prototype.toString = function(T) {
                  return C(O(this.text), T);
                }, f.prototype.toStringWithIndent = function(T, P) {
                  return T + this.toString(P);
                };
                function h(T) {
                  this.cdata = T;
                }
                h.prototype.toString = function(T) {
                  return "<![CDATA[" + C(this.cdata, T) + "]]>";
                }, h.prototype.toStringWithIndent = function(T, P) {
                  return T + this.toString(P);
                };
                function v(T) {
                  this.comment = T;
                }
                v.prototype.toString = function(T) {
                  return "<!--" + C(O(this.comment), T) + "-->";
                }, v.prototype.toStringWithIndent = function(T, P) {
                  return T + this.toString(P);
                }, i.prototype.type = "element", f.prototype.type = "text", h.prototype.type = "cdata", v.prototype.type = "comment";
                function p(T) {
                  if (T && (T = T.toString().trim()), !T)
                    throw new Error("No XML to parse!");
                  this.doctype = "", this.parser = s.parser(!0), x(this.parser), m = [this];
                  try {
                    this.parser.write(T);
                  } finally {
                    delete this.parser;
                  }
                }
                A(p.prototype, i.prototype), p.prototype._opentag = function(T) {
                  typeof this.children > "u" ? i.call(this, T) : i.prototype._opentag.apply(this, arguments);
                }, p.prototype._doctype = function(T) {
                  this.doctype += T;
                };
                var m = null;
                function x(T) {
                  T.onopentag = g, T.onclosetag = S, T.ontext = y, T.oncdata = b, T.oncomment = n, T.ondoctype = w, T.onerror = E;
                }
                function g() {
                  m[0] && m[0]._opentag.apply(m[0], arguments);
                }
                function S() {
                  m[0] && m[0]._closetag.apply(m[0], arguments);
                }
                function y() {
                  m[0] && m[0]._text.apply(m[0], arguments);
                }
                function b() {
                  m[0] && m[0]._cdata.apply(m[0], arguments);
                }
                function n() {
                  m[0] && m[0]._comment.apply(m[0], arguments);
                }
                function w() {
                  m[0] && m[0]._doctype.apply(m[0], arguments);
                }
                function E() {
                  m[0] && m[0]._error.apply(m[0], arguments);
                }
                function A(T, P) {
                  for (var I in P)
                    P.hasOwnProperty(I) && (T[I] = P[I]);
                }
                function O(T) {
                  return T.toString().replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&apos;").replace(/"/g, "&quot;");
                }
                function C(T, P) {
                  var I = T;
                  return P && P.trimmed && T.length > 25 && (I = I.substring(0, 25).trim() + "…"), P && P.preserveWhitespace || (I = I.trim()), I;
                }
                u.exports && !e.g.xmldocAssumeBrowser ? (u.exports.XmlDocument = p, u.exports.XmlElement = i, u.exports.XmlTextNode = f, u.exports.XmlCDataNode = h, u.exports.XmlCommentNode = v) : (this.XmlDocument = p, this.XmlElement = i, this.XmlTextNode = f, this.XmlCDataNode = h, this.XmlCommentNode = v);
              })();
            }
          ),
          /***/
          7785: (
            /***/
            function(u, l, e) {
              typeof window < "u" && !window.Promise && e(98168), e(83043);
              var s = function(f, h) {
                return new Promise(function(v, p) {
                  var m = new XMLHttpRequest();
                  m.open("GET", f, !0);
                  for (var x in h)
                    m.setRequestHeader(x, h[x]);
                  m.responseType = "arraybuffer", m.onreadystatechange = function() {
                    if (m.readyState === 4) {
                      var g = m.status >= 200 && m.status < 300;
                      g || setTimeout(function() {
                        p(new TypeError('Failed to fetch (url: "' + f + '")'));
                      }, 0);
                    }
                  }, m.onload = function() {
                    var g = m.status >= 200 && m.status < 300;
                    g && v(m.response);
                  }, m.onerror = function() {
                    setTimeout(function() {
                      p(new TypeError('Network request failed (url: "' + f + '")'));
                    }, 0);
                  }, m.ontimeout = function() {
                    setTimeout(function() {
                      p(new TypeError('Network request failed (url: "' + f + '")'));
                    }, 0);
                  }, m.send();
                });
              };
              function i(f) {
                this.fs = f, this.resolving = {};
              }
              i.prototype.resolve = function(f, h) {
                if (!this.resolving[f]) {
                  var v = this;
                  this.resolving[f] = new Promise(function(p, m) {
                    f.toLowerCase().indexOf("https://") === 0 || f.toLowerCase().indexOf("http://") === 0 ? v.fs.existsSync(f) ? p() : s(f, h).then(function(x) {
                      v.fs.writeFileSync(f, x), p();
                    }, function(x) {
                      m(x);
                    }) : p();
                  });
                }
                return this.resolving[f];
              }, i.prototype.resolved = function() {
                var f = this;
                return new Promise(function(h, v) {
                  Promise.all(Object.values(f.resolving)).then(function() {
                    h();
                  }, function(p) {
                    v(p);
                  });
                });
              }, u.exports = i;
            }
          ),
          /***/
          45314: (
            /***/
            function(u, l, e) {
              var s = e(50621).Buffer, i = e(91867).isFunction, f = e(91867).isUndefined;
              e(91867).isNull;
              var h = e(44134), v = h.saveAs, p = {
                Roboto: {
                  normal: "Roboto-Regular.ttf",
                  bold: "Roboto-Medium.ttf",
                  italics: "Roboto-Italic.ttf",
                  bolditalics: "Roboto-MediumItalic.ttf"
                }
              };
              function m(g, S, y, b) {
                this.docDefinition = g, this.tableLayouts = S || null, this.fonts = y || p, this.vfs = b;
              }
              function x() {
                try {
                  var g = new Uint8Array(1), S = { foo: function() {
                    return 42;
                  } };
                  return Object.setPrototypeOf(S, Uint8Array.prototype), Object.setPrototypeOf(g, S), g.foo() === 42;
                } catch {
                  return !1;
                }
              }
              m.prototype._createDoc = function(g, S) {
                var y = function(I) {
                  return typeof I == "object" ? { url: I.url, headers: I.headers } : { url: I, headers: {} };
                };
                g = g || {}, this.tableLayouts && (g.tableLayouts = this.tableLayouts);
                var b = e(81566), n = new b(this.fonts);
                if (e(48181).bindFS(this.vfs), !i(S)) {
                  var w = n.createPdfKitDocument(this.docDefinition, g);
                  return w;
                }
                var E = e(7785), A = new E(e(48181));
                for (var O in this.fonts)
                  if (this.fonts.hasOwnProperty(O)) {
                    if (this.fonts[O].normal)
                      if (Array.isArray(this.fonts[O].normal)) {
                        var C = y(this.fonts[O].normal[0]);
                        A.resolve(C.url, C.headers), this.fonts[O].normal[0] = C.url;
                      } else {
                        var C = y(this.fonts[O].normal);
                        A.resolve(C.url, C.headers), this.fonts[O].normal = C.url;
                      }
                    if (this.fonts[O].bold)
                      if (Array.isArray(this.fonts[O].bold)) {
                        var C = y(this.fonts[O].bold[0]);
                        A.resolve(C.url, C.headers), this.fonts[O].bold[0] = C.url;
                      } else {
                        var C = y(this.fonts[O].bold);
                        A.resolve(C.url, C.headers), this.fonts[O].bold = C.url;
                      }
                    if (this.fonts[O].italics)
                      if (Array.isArray(this.fonts[O].italics)) {
                        var C = y(this.fonts[O].italics[0]);
                        A.resolve(C.url, C.headers), this.fonts[O].italics[0] = C.url;
                      } else {
                        var C = y(this.fonts[O].italics);
                        A.resolve(C.url, C.headers), this.fonts[O].italics = C.url;
                      }
                    if (this.fonts[O].bolditalics)
                      if (Array.isArray(this.fonts[O].bolditalics)) {
                        var C = y(this.fonts[O].bolditalics[0]);
                        A.resolve(C.url, C.headers), this.fonts[O].bolditalics[0] = C.url;
                      } else {
                        var C = y(this.fonts[O].bolditalics);
                        A.resolve(C.url, C.headers), this.fonts[O].bolditalics = C.url;
                      }
                  }
                if (this.docDefinition.images) {
                  for (var T in this.docDefinition.images)
                    if (this.docDefinition.images.hasOwnProperty(T)) {
                      var C = y(this.docDefinition.images[T]);
                      A.resolve(C.url, C.headers), this.docDefinition.images[T] = C.url;
                    }
                }
                var P = this;
                A.resolved().then(function() {
                  var I = n.createPdfKitDocument(P.docDefinition, g);
                  S(I);
                }, function(I) {
                  throw I;
                });
              }, m.prototype._flushDoc = function(g, S) {
                var y = [], b;
                g.on("readable", function() {
                  for (var n; (n = g.read(9007199254740991)) !== null; )
                    y.push(n);
                }), g.on("end", function() {
                  b = s.concat(y), S(b, g._pdfMakePages);
                }), g.end();
              }, m.prototype._getPages = function(g, S) {
                if (!S)
                  throw "_getPages is an async method and needs a callback argument";
                var y = this;
                this._createDoc(g, function(b) {
                  y._flushDoc(b, function(n, w) {
                    S(w);
                  });
                });
              }, m.prototype._bufferToBlob = function(g) {
                var S;
                try {
                  S = new Blob([g], { type: "application/pdf" });
                } catch (b) {
                  if (b.name === "InvalidStateError") {
                    var y = new Uint8Array(g);
                    S = new Blob([y.buffer], { type: "application/pdf" });
                  }
                }
                if (!S)
                  throw "Could not generate blob";
                return S;
              }, m.prototype._openWindow = function() {
                var g = window.open("", "_blank");
                if (g === null)
                  throw "Open PDF in new window blocked by browser";
                return g;
              }, m.prototype._openPdf = function(g, S) {
                S || (S = this._openWindow());
                try {
                  this.getBlob(function(y) {
                    var b = window.URL || window.webkitURL, n = b.createObjectURL(y);
                    S.location.href = n;
                  }, g);
                } catch (y) {
                  throw S.close(), y;
                }
              }, m.prototype.open = function(g, S) {
                g = g || {}, g.autoPrint = !1, S = S || null, this._openPdf(g, S);
              }, m.prototype.print = function(g, S) {
                g = g || {}, g.autoPrint = !0, S = S || null, this._openPdf(g, S);
              }, m.prototype.download = function(g, S, y) {
                i(g) && (f(S) || (y = S), S = g, g = null), g = g || "file.pdf", this.getBlob(function(b) {
                  v(b, g), i(S) && S();
                }, y);
              }, m.prototype.getBase64 = function(g, S) {
                if (!g)
                  throw "getBase64 is an async method and needs a callback argument";
                this.getBuffer(function(y) {
                  g(y.toString("base64"));
                }, S);
              }, m.prototype.getDataUrl = function(g, S) {
                if (!g)
                  throw "getDataUrl is an async method and needs a callback argument";
                this.getBuffer(function(y) {
                  g("data:application/pdf;base64," + y.toString("base64"));
                }, S);
              }, m.prototype.getBlob = function(g, S) {
                if (!g)
                  throw "getBlob is an async method and needs a callback argument";
                var y = this;
                this.getBuffer(function(b) {
                  var n = y._bufferToBlob(b);
                  g(n);
                }, S);
              }, m.prototype.getBuffer = function(g, S) {
                if (!g)
                  throw "getBuffer is an async method and needs a callback argument";
                var y = this;
                this._createDoc(S, function(b) {
                  y._flushDoc(b, function(n) {
                    g(n);
                  });
                });
              }, m.prototype.getStream = function(g, S) {
                if (!i(S)) {
                  var y = this._createDoc(g);
                  return y;
                }
                this._createDoc(g, function(b) {
                  S(b);
                });
              }, u.exports = {
                createPdf: function(g, S, y, b) {
                  if (!x())
                    throw "Your browser does not provide the level of support needed";
                  return new m(
                    g,
                    S || e.g.pdfMake.tableLayouts,
                    y || e.g.pdfMake.fonts,
                    b || e.g.pdfMake.vfs
                  );
                }
              };
            }
          ),
          /***/
          48181: (
            /***/
            function(u, l, e) {
              var s = "/", i = e(50621).Buffer;
              function f() {
                this.fileSystem = {}, this.dataSystem = {};
              }
              f.prototype.existsSync = function(v) {
                return v = h(v), typeof this.fileSystem[v] < "u" || typeof this.dataSystem[v] < "u";
              }, f.prototype.readFileSync = function(v, p) {
                v = h(v);
                var m = this.dataSystem[v];
                if (typeof m == "string" && p === "utf8")
                  return m;
                if (m)
                  return new i(m, typeof m == "string" ? "base64" : void 0);
                var x = this.fileSystem[v];
                if (x)
                  return x;
                throw "File '" + v + "' not found in virtual file system";
              }, f.prototype.writeFileSync = function(v, p) {
                this.fileSystem[h(v)] = p;
              }, f.prototype.bindFS = function(v) {
                this.dataSystem = v || {};
              };
              function h(v) {
                return v.indexOf(s) === 0 && (v = v.substring(s.length)), v.indexOf("/") === 0 && (v = v.substring(1)), v;
              }
              u.exports = new f();
            }
          ),
          /***/
          77530: (
            /***/
            function(u, l, e) {
              var s = e(91867).isString;
              function i(p, m) {
                var x = [], g = 0, S = 0, y = [], b = 0, n = 0, w = [], E = m;
                p.forEach(function(I) {
                  f(I) ? (x.push(I), g += I._minWidth, S += I._maxWidth) : h(I) ? (y.push(I), b = Math.max(b, I._minWidth), n = Math.max(n, I._maxWidth)) : w.push(I);
                }), w.forEach(function(I) {
                  s(I.width) && /\d+%/.test(I.width) && (I.width = parseFloat(I.width) * E / 100), I.width < I._minWidth && I.elasticWidth ? I._calcWidth = I._minWidth : I._calcWidth = I.width, m -= I._calcWidth;
                });
                var A = g + b * y.length, O = S + n * y.length;
                if (A >= m)
                  x.forEach(function(I) {
                    I._calcWidth = I._minWidth;
                  }), y.forEach(function(I) {
                    I._calcWidth = b;
                  });
                else {
                  if (O < m)
                    x.forEach(function(I) {
                      I._calcWidth = I._maxWidth, m -= I._calcWidth;
                    });
                  else {
                    var C = m - A, T = O - A;
                    x.forEach(function(I) {
                      var F = I._maxWidth - I._minWidth;
                      I._calcWidth = I._minWidth + F * C / T, m -= I._calcWidth;
                    });
                  }
                  if (y.length > 0) {
                    var P = m / y.length;
                    y.forEach(function(I) {
                      I._calcWidth = P;
                    });
                  }
                }
              }
              function f(p) {
                return p.width === "auto";
              }
              function h(p) {
                return p.width === null || p.width === void 0 || p.width === "*" || p.width === "star";
              }
              function v(p) {
                for (var m = { min: 0, max: 0 }, x = { min: 0, max: 0 }, g = 0, S = 0, y = p.length; S < y; S++) {
                  var b = p[S];
                  h(b) ? (x.min = Math.max(x.min, b._minWidth), x.max = Math.max(x.max, b._maxWidth), g++) : f(b) ? (m.min += b._minWidth, m.max += b._maxWidth) : (m.min += b.width !== void 0 && b.width || b._minWidth, m.max += b.width !== void 0 && b.width || b._maxWidth);
                }
                return g && (m.min += g * x.min, m.max += g * x.max), m;
              }
              u.exports = {
                buildColumnWidths: i,
                measureMinMax: v,
                isAutoColumn: f,
                isStarColumn: h
              };
            }
          ),
          /***/
          42526: (
            /***/
            function(u, l, e) {
              var s = e(11548), i = e(76442), f = e(77530), h = e(91867).isString, v = e(91867).isNumber, p = e(91867).isObject, m = e(91867).isArray, x = e(91867).fontStringify, g = e(91867).getNodeId, S = e(91867).pack, y = e(72155);
              function b(n, w, E, A, O, C, T) {
                this.textTools = new s(n), this.styleStack = new i(w, E), this.imageMeasure = A, this.svgMeasure = O, this.tableLayouts = C, this.images = T, this.autoImageIndex = 1;
              }
              b.prototype.measureDocument = function(n) {
                return this.measureNode(n);
              }, b.prototype.measureNode = function(n) {
                var w = this;
                return this.styleStack.auto(n, function() {
                  if (n._margin = A(), n.columns)
                    return E(w.measureColumns(n));
                  if (n.stack)
                    return E(w.measureVerticalContainer(n));
                  if (n.ul)
                    return E(w.measureUnorderedList(n));
                  if (n.ol)
                    return E(w.measureOrderedList(n));
                  if (n.table)
                    return E(w.measureTable(n));
                  if (n.text !== void 0)
                    return E(w.measureLeaf(n));
                  if (n.toc)
                    return E(w.measureToc(n));
                  if (n.image)
                    return E(w.measureImage(n));
                  if (n.svg)
                    return E(w.measureSVG(n));
                  if (n.canvas)
                    return E(w.measureCanvas(n));
                  if (n.qr)
                    return E(w.measureQr(n));
                  throw "Unrecognized document structure: " + JSON.stringify(n, x);
                });
                function E(O) {
                  var C = O._margin;
                  return C && (O._minWidth += C[0] + C[2], O._maxWidth += C[0] + C[2]), O;
                }
                function A() {
                  function O(B, M) {
                    return B.marginLeft || B.marginTop || B.marginRight || B.marginBottom ? [
                      B.marginLeft || M[0] || 0,
                      B.marginTop || M[1] || 0,
                      B.marginRight || M[2] || 0,
                      B.marginBottom || M[3] || 0
                    ] : M;
                  }
                  function C(B) {
                    for (var M = {}, z = B.length - 1; z >= 0; z--) {
                      var L = B[z], J = w.styleStack.styleDictionary[L];
                      for (var ft in J)
                        J.hasOwnProperty(ft) && (M[ft] = J[ft]);
                    }
                    return M;
                  }
                  function T(B) {
                    return v(B) ? B = [B, B, B, B] : m(B) && B.length === 2 && (B = [B[0], B[1], B[0], B[1]]), B;
                  }
                  var P = [void 0, void 0, void 0, void 0];
                  if (n.style) {
                    var I = m(n.style) ? n.style : [n.style], F = C(I);
                    F && (P = O(F, P)), F.margin && (P = T(F.margin));
                  }
                  return P = O(n, P), n.margin && (P = T(n.margin)), P[0] === void 0 && P[1] === void 0 && P[2] === void 0 && P[3] === void 0 ? null : P;
                }
              }, b.prototype.convertIfBase64Image = function(n) {
                if (/^data:image\/(jpeg|jpg|png);base64,/.test(n.image)) {
                  var w = "$$pdfmake$$" + this.autoImageIndex++;
                  this.images[w] = n.image, n.image = w;
                }
              }, b.prototype.measureImageWithDimensions = function(n, w) {
                if (n.fit) {
                  var E = w.width / w.height > n.fit[0] / n.fit[1] ? n.fit[0] / w.width : n.fit[1] / w.height;
                  n._width = n._minWidth = n._maxWidth = w.width * E, n._height = w.height * E;
                } else
                  n.cover ? (n._width = n._minWidth = n._maxWidth = n.cover.width, n._height = n._minHeight = n._maxHeight = n.cover.height) : (n._width = n._minWidth = n._maxWidth = n.width || w.width, n._height = n.height || w.height * n._width / w.width, v(n.maxWidth) && n.maxWidth < n._width && (n._width = n._minWidth = n._maxWidth = n.maxWidth, n._height = n._width * w.height / w.width), v(n.maxHeight) && n.maxHeight < n._height && (n._height = n.maxHeight, n._width = n._minWidth = n._maxWidth = n._height * w.width / w.height), v(n.minWidth) && n.minWidth > n._width && (n._width = n._minWidth = n._maxWidth = n.minWidth, n._height = n._width * w.height / w.width), v(n.minHeight) && n.minHeight > n._height && (n._height = n.minHeight, n._width = n._minWidth = n._maxWidth = n._height * w.width / w.height));
                n._alignment = this.styleStack.getProperty("alignment");
              }, b.prototype.measureImage = function(n) {
                this.images && this.convertIfBase64Image(n);
                var w = this.imageMeasure.measureImage(n.image);
                return this.measureImageWithDimensions(n, w), n;
              }, b.prototype.measureSVG = function(n) {
                var w = this.svgMeasure.measureSVG(n.svg);
                return this.measureImageWithDimensions(n, w), n.font = this.styleStack.getProperty("font"), n.svg = this.svgMeasure.writeDimensions(n.svg, {
                  width: n._width,
                  height: n._height
                }), n;
              }, b.prototype.measureLeaf = function(n) {
                n._textRef && n._textRef._textNodeRef.text && (n.text = n._textRef._textNodeRef.text);
                var w = this.styleStack.clone();
                w.push(n);
                var E = this.textTools.buildInlines(n.text, w);
                return n._inlines = E.items, n._minWidth = E.minWidth, n._maxWidth = E.maxWidth, n;
              }, b.prototype.measureToc = function(n) {
                if (n.toc.title && (n.toc.title = this.measureNode(n.toc.title)), n.toc._items.length > 0) {
                  for (var w = [], E = n.toc.textStyle || {}, A = n.toc.numberStyle || E, O = n.toc.textMargin || [0, 0, 0, 0], C = 0, T = n.toc._items.length; C < T; C++) {
                    var P = n.toc._items[C], I = P._textNodeRef.tocStyle || E, F = P._textNodeRef.tocMargin || O, B = P._textNodeRef.tocNumberStyle || A, M = g(P._nodeRef);
                    w.push([
                      { text: P._textNodeRef.text, linkToDestination: M, alignment: "left", style: I, margin: F },
                      { text: "00000", linkToDestination: M, alignment: "right", _tocItemRef: P._nodeRef, style: B, margin: [0, F[1], 0, F[3]] }
                    ]);
                  }
                  n.toc._table = {
                    table: {
                      dontBreakRows: !0,
                      widths: ["*", "auto"],
                      body: w
                    },
                    layout: "noBorders"
                  }, n.toc._table = this.measureNode(n.toc._table);
                }
                return n;
              }, b.prototype.measureVerticalContainer = function(n) {
                var w = n.stack;
                n._minWidth = 0, n._maxWidth = 0;
                for (var E = 0, A = w.length; E < A; E++)
                  w[E] = this.measureNode(w[E]), n._minWidth = Math.max(n._minWidth, w[E]._minWidth), n._maxWidth = Math.max(n._maxWidth, w[E]._maxWidth);
                return n;
              }, b.prototype.gapSizeForList = function() {
                return this.textTools.sizeOfString("9. ", this.styleStack);
              }, b.prototype.buildUnorderedMarker = function(n, w, E) {
                function A(I, F) {
                  var B = I.fontSize / 6;
                  return {
                    canvas: [{
                      x: B,
                      y: I.height / I.lineHeight + I.descender - I.fontSize / 3,
                      r1: B,
                      r2: B,
                      type: "ellipse",
                      color: F
                    }]
                  };
                }
                function O(I, F) {
                  var B = I.fontSize / 3;
                  return {
                    canvas: [{
                      x: 0,
                      y: I.height / I.lineHeight + I.descender - I.fontSize / 3 - B / 2,
                      h: B,
                      w: B,
                      type: "rect",
                      color: F
                    }]
                  };
                }
                function C(I, F) {
                  var B = I.fontSize / 6;
                  return {
                    canvas: [{
                      x: B,
                      y: I.height / I.lineHeight + I.descender - I.fontSize / 3,
                      r1: B,
                      r2: B,
                      type: "ellipse",
                      lineColor: F
                    }]
                  };
                }
                var T, P = n.getProperty("markerColor") || n.getProperty("color") || "black";
                switch (E) {
                  case "circle":
                    T = C(w, P);
                    break;
                  case "square":
                    T = O(w, P);
                    break;
                  case "none":
                    T = {};
                    break;
                  case "disc":
                  default:
                    T = A(w, P);
                    break;
                }
                return T._minWidth = T._maxWidth = w.width, T._minHeight = T._maxHeight = w.height, T;
              }, b.prototype.buildOrderedMarker = function(n, w, E, A) {
                function O(B) {
                  function M(z) {
                    return (z >= 26 ? M((z / 26 >> 0) - 1) : "") + "abcdefghijklmnopqrstuvwxyz"[z % 26 >> 0];
                  }
                  return B < 1 ? B.toString() : M(B - 1);
                }
                function C(B) {
                  if (B < 1 || B > 4999)
                    return B.toString();
                  var M = B, z = { M: 1e3, CM: 900, D: 500, CD: 400, C: 100, XC: 90, L: 50, XL: 40, X: 10, IX: 9, V: 5, IV: 4, I: 1 }, L = "", J;
                  for (J in z)
                    for (; M >= z[J]; )
                      L += J, M -= z[J];
                  return L;
                }
                function T(B) {
                  return B.toString();
                }
                var P;
                switch (E) {
                  case "none":
                    P = null;
                    break;
                  case "upper-alpha":
                    P = O(n).toUpperCase();
                    break;
                  case "lower-alpha":
                    P = O(n);
                    break;
                  case "upper-roman":
                    P = C(n);
                    break;
                  case "lower-roman":
                    P = C(n).toLowerCase();
                    break;
                  case "decimal":
                  default:
                    P = T(n);
                    break;
                }
                if (P === null)
                  return {};
                A && (m(A) ? (A[0] && (P = A[0] + P), A[1] && (P += A[1]), P += " ") : P += A + " ");
                var I = { text: P }, F = w.getProperty("markerColor");
                return F && (I.color = F), { _inlines: this.textTools.buildInlines(I, w).items };
              }, b.prototype.measureUnorderedList = function(n) {
                var w = this.styleStack.clone(), E = n.ul;
                n.type = n.type || "disc", n._gapSize = this.gapSizeForList(), n._minWidth = 0, n._maxWidth = 0;
                for (var A = 0, O = E.length; A < O; A++) {
                  var C = E[A] = this.measureNode(E[A]);
                  !C.ol && !C.ul && (C.listMarker = this.buildUnorderedMarker(w, n._gapSize, C.listType || n.type)), n._minWidth = Math.max(n._minWidth, E[A]._minWidth + n._gapSize.width), n._maxWidth = Math.max(n._maxWidth, E[A]._maxWidth + n._gapSize.width);
                }
                return n;
              }, b.prototype.measureOrderedList = function(n) {
                var w = this.styleStack.clone(), E = n.ol;
                n.type = n.type || "decimal", n.separator = n.separator || ".", n.reversed = n.reversed || !1, v(n.start) || (n.start = n.reversed ? E.length : 1), n._gapSize = this.gapSizeForList(), n._minWidth = 0, n._maxWidth = 0;
                for (var A = n.start, O = 0, C = E.length; O < C; O++) {
                  var T = E[O] = this.measureNode(E[O]);
                  if (!T.ol && !T.ul) {
                    var P = v(T.counter) ? T.counter : A;
                    T.listMarker = this.buildOrderedMarker(P, w, T.listType || n.type, n.separator), T.listMarker._inlines && (n._gapSize.width = Math.max(n._gapSize.width, T.listMarker._inlines[0].width));
                  }
                  n._minWidth = Math.max(n._minWidth, E[O]._minWidth), n._maxWidth = Math.max(n._maxWidth, E[O]._maxWidth), n.reversed ? A-- : A++;
                }
                n._minWidth += n._gapSize.width, n._maxWidth += n._gapSize.width;
                for (var O = 0, C = E.length; O < C; O++) {
                  var T = E[O];
                  !T.ol && !T.ul && (T.listMarker._minWidth = T.listMarker._maxWidth = n._gapSize.width);
                }
                return n;
              }, b.prototype.measureColumns = function(n) {
                var w = n.columns;
                n._gap = this.styleStack.getProperty("columnGap") || 0;
                for (var E = 0, A = w.length; E < A; E++)
                  w[E] = this.measureNode(w[E]);
                var O = f.measureMinMax(w), C = w.length > 0 ? w.length - 1 : 0;
                return n._minWidth = O.min + n._gap * C, n._maxWidth = O.max + n._gap * C, n;
              }, b.prototype.measureTable = function(n) {
                xt(n), n._layout = M(this.tableLayouts), n._offsets = z(n._layout);
                var w = [], E, A, O, C;
                for (E = 0, O = n.table.body[0].length; E < O; E++) {
                  var T = n.table.widths[E];
                  for (T._minWidth = 0, T._maxWidth = 0, A = 0, C = n.table.body.length; A < C; A++) {
                    var P = n.table.body[A], I = P[E];
                    if (I === void 0)
                      throw console.error("Malformed table row ", P, "in node ", n), "Malformed table row, a cell is undefined.";
                    I === null && (I = ""), I._span || (I = P[E] = this.styleStack.auto(I, B(this, I)), I.colSpan && I.colSpan > 1 ? (ft(P, E, I.colSpan), w.push({ col: E, span: I.colSpan, minWidth: I._minWidth, maxWidth: I._maxWidth })) : (T._minWidth = Math.max(T._minWidth, I._minWidth), T._maxWidth = Math.max(T._maxWidth, I._maxWidth))), I.rowSpan && I.rowSpan > 1 && Q(n.table, A, E, I.rowSpan);
                  }
                }
                L();
                var F = f.measureMinMax(n.table.widths);
                return n._minWidth = F.min + n._offsets.total, n._maxWidth = F.max + n._offsets.total, n;
                function B(St, Pt) {
                  return function() {
                    return p(Pt) && (Pt.fillColor = St.styleStack.getProperty("fillColor"), Pt.fillOpacity = St.styleStack.getProperty("fillOpacity")), St.measureNode(Pt);
                  };
                }
                function M(St) {
                  var Pt = n.layout;
                  h(Pt) && (Pt = St[Pt]);
                  var Gt = {
                    hLineWidth: function(Rt, bt) {
                      return 1;
                    },
                    vLineWidth: function(Rt, bt) {
                      return 1;
                    },
                    hLineColor: function(Rt, bt) {
                      return "black";
                    },
                    vLineColor: function(Rt, bt) {
                      return "black";
                    },
                    hLineStyle: function(Rt, bt) {
                      return null;
                    },
                    vLineStyle: function(Rt, bt) {
                      return null;
                    },
                    paddingLeft: function(Rt, bt) {
                      return 4;
                    },
                    paddingRight: function(Rt, bt) {
                      return 4;
                    },
                    paddingTop: function(Rt, bt) {
                      return 2;
                    },
                    paddingBottom: function(Rt, bt) {
                      return 2;
                    },
                    fillColor: function(Rt, bt) {
                      return null;
                    },
                    fillOpacity: function(Rt, bt) {
                      return 1;
                    },
                    defaultBorder: !0
                  };
                  return S(Gt, Pt);
                }
                function z(St) {
                  for (var Pt = [], Gt = 0, Rt = 0, bt = 0, Dt = n.table.widths.length; bt < Dt; bt++) {
                    var X = Rt + St.vLineWidth(bt, n) + St.paddingLeft(bt, n);
                    Pt.push(X), Gt += X, Rt = St.paddingRight(bt, n);
                  }
                  return Gt += Rt + St.vLineWidth(n.table.widths.length, n), {
                    total: Gt,
                    offsets: Pt
                  };
                }
                function L() {
                  for (var St, Pt, Gt = 0, Rt = w.length; Gt < Rt; Gt++) {
                    var bt = w[Gt], Dt = J(bt.col, bt.span, n._offsets), X = bt.minWidth - Dt.minWidth, gt = bt.maxWidth - Dt.maxWidth;
                    if (X > 0)
                      for (St = X / bt.span, Pt = 0; Pt < bt.span; Pt++)
                        n.table.widths[bt.col + Pt]._minWidth += St;
                    if (gt > 0)
                      for (St = gt / bt.span, Pt = 0; Pt < bt.span; Pt++)
                        n.table.widths[bt.col + Pt]._maxWidth += St;
                  }
                }
                function J(St, Pt, Gt) {
                  for (var Rt = { minWidth: 0, maxWidth: 0 }, bt = 0; bt < Pt; bt++)
                    Rt.minWidth += n.table.widths[St + bt]._minWidth + (bt ? Gt.offsets[St + bt] : 0), Rt.maxWidth += n.table.widths[St + bt]._maxWidth + (bt ? Gt.offsets[St + bt] : 0);
                  return Rt;
                }
                function ft(St, Pt, Gt) {
                  for (var Rt = 1; Rt < Gt; Rt++)
                    St[Pt + Rt] = {
                      _span: !0,
                      _minWidth: 0,
                      _maxWidth: 0,
                      rowSpan: St[Pt].rowSpan
                    };
                }
                function Q(St, Pt, Gt, Rt) {
                  for (var bt = 1; bt < Rt; bt++)
                    St.body[Pt + bt][Gt] = {
                      _span: !0,
                      _minWidth: 0,
                      _maxWidth: 0,
                      fillColor: St.body[Pt][Gt].fillColor,
                      fillOpacity: St.body[Pt][Gt].fillOpacity
                    };
                }
                function xt(St) {
                  if (St.table.widths || (St.table.widths = "auto"), h(St.table.widths))
                    for (St.table.widths = [St.table.widths]; St.table.widths.length < St.table.body[0].length; )
                      St.table.widths.push(St.table.widths[St.table.widths.length - 1]);
                  for (var Pt = 0, Gt = St.table.widths.length; Pt < Gt; Pt++) {
                    var Rt = St.table.widths[Pt];
                    (v(Rt) || h(Rt)) && (St.table.widths[Pt] = { width: Rt });
                  }
                }
              }, b.prototype.measureCanvas = function(n) {
                for (var w = 0, E = 0, A = 0, O = n.canvas.length; A < O; A++) {
                  var C = n.canvas[A];
                  switch (C.type) {
                    case "ellipse":
                      w = Math.max(w, C.x + C.r1), E = Math.max(E, C.y + C.r2);
                      break;
                    case "rect":
                      w = Math.max(w, C.x + C.w), E = Math.max(E, C.y + C.h);
                      break;
                    case "line":
                      w = Math.max(w, C.x1, C.x2), E = Math.max(E, C.y1, C.y2);
                      break;
                    case "polyline":
                      for (var T = 0, P = C.points.length; T < P; T++)
                        w = Math.max(w, C.points[T].x), E = Math.max(E, C.points[T].y);
                      break;
                  }
                }
                return n._minWidth = n._maxWidth = w, n._minHeight = n._maxHeight = E, n._alignment = this.styleStack.getProperty("alignment"), n;
              }, b.prototype.measureQr = function(n) {
                return n = y.measure(n), n._alignment = this.styleStack.getProperty("alignment"), n;
              }, u.exports = b;
            }
          ),
          /***/
          98883: (
            /***/
            function(u, l, e) {
              var s = e(50621).Buffer, i = e(91867).isString, f = e(91867).isNumber, h = e(91867).isBoolean, v = e(91867).isArray, p = e(91867).isUndefined, m = e(91867).fontStringify;
              function x() {
              }
              x.prototype.preprocessDocument = function(g) {
                return this.parentNode = null, this.tocs = [], this.nodeReferences = [], this.preprocessNode(g);
              }, x.prototype.preprocessNode = function(g) {
                if (v(g) ? g = { stack: g } : i(g) ? g = { text: g } : f(g) || h(g) ? g = { text: g.toString() } : g == null ? g = { text: "" } : Object.keys(g).length === 0 ? g = { text: "" } : "text" in g && (g.text === void 0 || g.text === null) && (g.text = ""), g.columns)
                  return this.preprocessColumns(g);
                if (g.stack)
                  return this.preprocessVerticalContainer(g);
                if (g.ul)
                  return this.preprocessList(g);
                if (g.ol)
                  return this.preprocessList(g);
                if (g.table)
                  return this.preprocessTable(g);
                if (g.text !== void 0)
                  return this.preprocessText(g);
                if (g.toc)
                  return this.preprocessToc(g);
                if (g.image)
                  return this.preprocessImage(g);
                if (g.svg)
                  return this.preprocessSVG(g);
                if (g.canvas)
                  return this.preprocessCanvas(g);
                if (g.qr)
                  return this.preprocessQr(g);
                if (g.pageReference || g.textReference)
                  return this.preprocessText(g);
                throw "Unrecognized document structure: " + JSON.stringify(g, m);
              }, x.prototype.preprocessColumns = function(g) {
                for (var S = g.columns, y = 0, b = S.length; y < b; y++)
                  S[y] = this.preprocessNode(S[y]);
                return g;
              }, x.prototype.preprocessVerticalContainer = function(g) {
                for (var S = g.stack, y = 0, b = S.length; y < b; y++)
                  S[y] = this.preprocessNode(S[y]);
                return g;
              }, x.prototype.preprocessList = function(g) {
                for (var S = g.ul || g.ol, y = 0, b = S.length; y < b; y++)
                  S[y] = this.preprocessNode(S[y]);
                return g;
              }, x.prototype.preprocessTable = function(g) {
                var S, y, b, n;
                for (S = 0, b = g.table.body[0].length; S < b; S++)
                  for (y = 0, n = g.table.body.length; y < n; y++) {
                    var w = g.table.body[y], E = w[S];
                    E !== void 0 && (E === null && (E = ""), E._span || (w[S] = this.preprocessNode(E)));
                  }
                return g;
              }, x.prototype.preprocessText = function(g) {
                if (g.tocItem) {
                  v(g.tocItem) || (g.tocItem = [g.tocItem]);
                  for (var S = 0, y = g.tocItem.length; S < y; S++) {
                    i(g.tocItem[S]) || (g.tocItem[S] = "_default_");
                    var b = g.tocItem[S];
                    this.tocs[b] || (this.tocs[b] = { toc: { _items: [], _pseudo: !0 } }), g.id || (g.id = "toc-" + b + "-" + this.tocs[b].toc._items.length);
                    var n = {
                      _nodeRef: this._getNodeForNodeRef(g),
                      _textNodeRef: g
                    };
                    this.tocs[b].toc._items.push(n);
                  }
                }
                if (g.id)
                  if (this.nodeReferences[g.id]) {
                    if (!this.nodeReferences[g.id]._pseudo)
                      throw "Node id '" + g.id + "' already exists";
                    this.nodeReferences[g.id]._nodeRef = this._getNodeForNodeRef(g), this.nodeReferences[g.id]._textNodeRef = g, this.nodeReferences[g.id]._pseudo = !1;
                  } else
                    this.nodeReferences[g.id] = {
                      _nodeRef: this._getNodeForNodeRef(g),
                      _textNodeRef: g
                    };
                if (g.pageReference && (this.nodeReferences[g.pageReference] || (this.nodeReferences[g.pageReference] = {
                  _nodeRef: {},
                  _textNodeRef: {},
                  _pseudo: !0
                }), g.text = "00000", g.linkToDestination = g.pageReference, g._pageRef = this.nodeReferences[g.pageReference]), g.textReference && (this.nodeReferences[g.textReference] || (this.nodeReferences[g.textReference] = { _nodeRef: {}, _pseudo: !0 }), g.text = "", g.linkToDestination = g.textReference, g._textRef = this.nodeReferences[g.textReference]), g.text && g.text.text)
                  g.text = [this.preprocessNode(g.text)];
                else if (v(g.text)) {
                  var w = !1;
                  this.parentNode === null && (this.parentNode = g, w = !0);
                  for (var S = 0, y = g.text.length; S < y; S++)
                    g.text[S] = this.preprocessNode(g.text[S]);
                  w && (this.parentNode = null);
                }
                return g;
              }, x.prototype.preprocessToc = function(g) {
                if (g.toc.id || (g.toc.id = "_default_"), g.toc.title = g.toc.title ? this.preprocessNode(g.toc.title) : null, g.toc._items = [], this.tocs[g.toc.id]) {
                  if (!this.tocs[g.toc.id].toc._pseudo)
                    throw "TOC '" + g.toc.id + "' already exists";
                  g.toc._items = this.tocs[g.toc.id].toc._items;
                }
                return this.tocs[g.toc.id] = g, g;
              }, x.prototype.preprocessImage = function(g) {
                return !p(g.image.type) && !p(g.image.data) && g.image.type === "Buffer" && v(g.image.data) && (g.image = s.from(g.image.data)), g;
              }, x.prototype.preprocessSVG = function(g) {
                return g;
              }, x.prototype.preprocessCanvas = function(g) {
                return g;
              }, x.prototype.preprocessQr = function(g) {
                return g;
              }, x.prototype._getNodeForNodeRef = function(g) {
                return this.parentNode ? this.parentNode : g;
              }, u.exports = x;
            }
          ),
          /***/
          79178: (
            /***/
            function(u, l, e) {
              var s = e(2318), i = e(91867).isString;
              function f(m, x) {
                this.pages = [], this.pageMargins = x, this.x = x.left, this.availableWidth = m.width - x.left - x.right, this.availableHeight = 0, this.page = -1, this.snapshots = [], this.endingCell = null, this.tracker = new s(), this.backgroundLength = [], this.addPage(m);
              }
              f.prototype.beginColumnGroup = function() {
                this.snapshots.push({
                  x: this.x,
                  y: this.y,
                  availableHeight: this.availableHeight,
                  availableWidth: this.availableWidth,
                  page: this.page,
                  bottomMost: {
                    x: this.x,
                    y: this.y,
                    availableHeight: this.availableHeight,
                    availableWidth: this.availableWidth,
                    page: this.page
                  },
                  endingCell: this.endingCell,
                  lastColumnWidth: this.lastColumnWidth
                }), this.lastColumnWidth = 0;
              }, f.prototype.beginColumn = function(m, x, g) {
                var S = this.snapshots[this.snapshots.length - 1];
                this.calculateBottomMost(S), this.endingCell = g, this.page = S.page, this.x = this.x + this.lastColumnWidth + (x || 0), this.y = S.y, this.availableWidth = m, this.availableHeight = S.availableHeight, this.lastColumnWidth = m;
              }, f.prototype.calculateBottomMost = function(m) {
                this.endingCell ? (this.saveContextInEndingCell(this.endingCell), this.endingCell = null) : m.bottomMost = p(this, m.bottomMost);
              }, f.prototype.markEnding = function(m) {
                this.page = m._columnEndingContext.page, this.x = m._columnEndingContext.x, this.y = m._columnEndingContext.y, this.availableWidth = m._columnEndingContext.availableWidth, this.availableHeight = m._columnEndingContext.availableHeight, this.lastColumnWidth = m._columnEndingContext.lastColumnWidth;
              }, f.prototype.saveContextInEndingCell = function(m) {
                m._columnEndingContext = {
                  page: this.page,
                  x: this.x,
                  y: this.y,
                  availableHeight: this.availableHeight,
                  availableWidth: this.availableWidth,
                  lastColumnWidth: this.lastColumnWidth
                };
              }, f.prototype.completeColumnGroup = function(m) {
                var x = this.snapshots.pop();
                this.calculateBottomMost(x), this.endingCell = null, this.x = x.x;
                var g = x.bottomMost.y;
                m && (x.page === x.bottomMost.page ? x.y + m > g && (g = x.y + m) : g += m), this.y = g, this.page = x.bottomMost.page, this.availableWidth = x.availableWidth, this.availableHeight = x.bottomMost.availableHeight, m && (this.availableHeight -= g - x.bottomMost.y), this.lastColumnWidth = x.lastColumnWidth;
              }, f.prototype.addMargin = function(m, x) {
                this.x += m, this.availableWidth -= m + (x || 0);
              }, f.prototype.moveDown = function(m) {
                return this.y += m, this.availableHeight -= m, this.availableHeight > 0;
              }, f.prototype.initializePage = function() {
                this.y = this.pageMargins.top, this.availableHeight = this.getCurrentPage().pageSize.height - this.pageMargins.top - this.pageMargins.bottom, this.pageSnapshot().availableWidth = this.getCurrentPage().pageSize.width - this.pageMargins.left - this.pageMargins.right;
              }, f.prototype.pageSnapshot = function() {
                return this.snapshots[0] ? this.snapshots[0] : this;
              }, f.prototype.moveTo = function(m, x) {
                m != null && (this.x = m, this.availableWidth = this.getCurrentPage().pageSize.width - this.x - this.pageMargins.right), x != null && (this.y = x, this.availableHeight = this.getCurrentPage().pageSize.height - this.y - this.pageMargins.bottom);
              }, f.prototype.moveToRelative = function(m, x) {
                m != null && (this.x = this.x + m), x != null && (this.y = this.y + x);
              }, f.prototype.beginDetachedBlock = function() {
                this.snapshots.push({
                  x: this.x,
                  y: this.y,
                  availableHeight: this.availableHeight,
                  availableWidth: this.availableWidth,
                  page: this.page,
                  endingCell: this.endingCell,
                  lastColumnWidth: this.lastColumnWidth
                });
              }, f.prototype.endDetachedBlock = function() {
                var m = this.snapshots.pop();
                this.x = m.x, this.y = m.y, this.availableWidth = m.availableWidth, this.availableHeight = m.availableHeight, this.page = m.page, this.endingCell = m.endingCell, this.lastColumnWidth = m.lastColumnWidth;
              };
              function h(m, x) {
                return m === void 0 ? x : i(m) && m.toLowerCase() === "landscape" ? "landscape" : "portrait";
              }
              var v = function(m, x) {
                return x = h(x, m.pageSize.orientation), x !== m.pageSize.orientation ? {
                  orientation: x,
                  width: m.pageSize.height,
                  height: m.pageSize.width
                } : {
                  orientation: m.pageSize.orientation,
                  width: m.pageSize.width,
                  height: m.pageSize.height
                };
              };
              f.prototype.moveToNextPage = function(m) {
                var x = this.page + 1, g = this.page, S = this.y, y = x >= this.pages.length;
                if (y) {
                  var b = this.availableWidth, n = this.getCurrentPage().pageSize.orientation, w = v(this.getCurrentPage(), m);
                  this.addPage(w), n === w.orientation && (this.availableWidth = b);
                } else
                  this.page = x, this.initializePage();
                return {
                  newPageCreated: y,
                  prevPage: g,
                  prevY: S,
                  y: this.y
                };
              }, f.prototype.addPage = function(m) {
                var x = { items: [], pageSize: m };
                return this.pages.push(x), this.backgroundLength.push(0), this.page = this.pages.length - 1, this.initializePage(), this.tracker.emit("pageAdded"), x;
              }, f.prototype.getCurrentPage = function() {
                return this.page < 0 || this.page >= this.pages.length ? null : this.pages[this.page];
              }, f.prototype.getCurrentPosition = function() {
                var m = this.getCurrentPage().pageSize, x = m.height - this.pageMargins.top - this.pageMargins.bottom, g = m.width - this.pageMargins.left - this.pageMargins.right;
                return {
                  pageNumber: this.page + 1,
                  pageOrientation: m.orientation,
                  pageInnerHeight: x,
                  pageInnerWidth: g,
                  left: this.x,
                  top: this.y,
                  verticalRatio: (this.y - this.pageMargins.top) / x,
                  horizontalRatio: (this.x - this.pageMargins.left) / g
                };
              };
              function p(m, x) {
                var g;
                return m.page > x.page ? g = m : x.page > m.page ? g = x : g = m.y > x.y ? m : x, {
                  page: g.page,
                  x: g.x,
                  y: g.y,
                  availableHeight: g.availableHeight,
                  availableWidth: g.availableWidth
                };
              }
              u.exports = f;
            }
          ),
          /***/
          54861: (
            /***/
            function(u, l, e) {
              var s = e(70770), i = e(91867).isNumber, f = e(91867).pack, h = e(91867).offsetVector, v = e(79178);
              function p(g, S) {
                this.context = g, this.contextStack = [], this.tracker = S;
              }
              function m(g, S, y) {
                y == null || y < 0 || y > g.items.length ? g.items.push(S) : g.items.splice(y, 0, S);
              }
              p.prototype.addLine = function(g, S, y) {
                var b = g.getHeight(), n = this.context, w = n.getCurrentPage(), E = this.getCurrentPositionOnPage();
                return n.availableHeight < b || !w ? !1 : (g.x = n.x + (g.x || 0), g.y = n.y + (g.y || 0), this.alignLine(g), m(w, {
                  type: "line",
                  item: g
                }, y), this.tracker.emit("lineAdded", g), S || n.moveDown(b), E);
              }, p.prototype.alignLine = function(g) {
                var S = this.context.availableWidth, y = g.getWidth(), b = g.inlines && g.inlines.length > 0 && g.inlines[0].alignment, n = 0;
                switch (b) {
                  case "right":
                    n = S - y;
                    break;
                  case "center":
                    n = (S - y) / 2;
                    break;
                }
                if (n && (g.x = (g.x || 0) + n), b === "justify" && !g.newLineForced && !g.lastLineInParagraph && g.inlines.length > 1)
                  for (var w = (S - y) / (g.inlines.length - 1), E = 1, A = g.inlines.length; E < A; E++)
                    n = E * w, g.inlines[E].x += n, g.inlines[E].justifyShift = w;
              }, p.prototype.addImage = function(g, S, y) {
                var b = this.context, n = b.getCurrentPage(), w = this.getCurrentPositionOnPage();
                return !n || g.absolutePosition === void 0 && b.availableHeight < g._height && n.items.length > 0 ? !1 : (g._x === void 0 && (g._x = g.x || 0), g.x = b.x + g._x, g.y = b.y, this.alignImage(g), m(n, {
                  type: y || "image",
                  item: g
                }, S), b.moveDown(g._height), w);
              }, p.prototype.addSVG = function(g, S) {
                return this.addImage(g, S, "svg");
              }, p.prototype.addQr = function(g, S) {
                var y = this.context, b = y.getCurrentPage(), n = this.getCurrentPositionOnPage();
                if (!b || g.absolutePosition === void 0 && y.availableHeight < g._height)
                  return !1;
                g._x === void 0 && (g._x = g.x || 0), g.x = y.x + g._x, g.y = y.y, this.alignImage(g);
                for (var w = 0, E = g._canvas.length; w < E; w++) {
                  var A = g._canvas[w];
                  A.x += g.x, A.y += g.y, this.addVector(A, !0, !0, S);
                }
                return y.moveDown(g._height), n;
              }, p.prototype.alignImage = function(g) {
                var S = this.context.availableWidth, y = g._minWidth, b = 0;
                switch (g._alignment) {
                  case "right":
                    b = S - y;
                    break;
                  case "center":
                    b = (S - y) / 2;
                    break;
                }
                b && (g.x = (g.x || 0) + b);
              }, p.prototype.alignCanvas = function(g) {
                var S = this.context.availableWidth, y = g._minWidth, b = 0;
                switch (g._alignment) {
                  case "right":
                    b = S - y;
                    break;
                  case "center":
                    b = (S - y) / 2;
                    break;
                }
                b && g.canvas.forEach(function(n) {
                  h(n, b, 0);
                });
              }, p.prototype.addVector = function(g, S, y, b) {
                var n = this.context, w = n.getCurrentPage(), E = this.getCurrentPositionOnPage();
                if (w)
                  return h(g, S ? 0 : n.x, y ? 0 : n.y), m(w, {
                    type: "vector",
                    item: g
                  }, b), E;
              }, p.prototype.beginClip = function(g, S) {
                var y = this.context, b = y.getCurrentPage();
                return b.items.push({
                  type: "beginClip",
                  item: { x: y.x, y: y.y, width: g, height: S }
                }), !0;
              }, p.prototype.endClip = function() {
                var g = this.context, S = g.getCurrentPage();
                return S.items.push({
                  type: "endClip"
                }), !0;
              };
              function x(g) {
                var S = new s(g.maxWidth);
                for (var y in g)
                  g.hasOwnProperty(y) && (S[y] = g[y]);
                return S;
              }
              p.prototype.addFragment = function(g, S, y, b) {
                var n = this.context, w = n.getCurrentPage();
                return !S && g.height > n.availableHeight ? !1 : (g.items.forEach(function(E) {
                  switch (E.type) {
                    case "line":
                      var A = x(E.item);
                      A._node && (A._node.positions[0].pageNumber = n.page + 1), A.x = (A.x || 0) + (S ? g.xOffset || 0 : n.x), A.y = (A.y || 0) + (y ? g.yOffset || 0 : n.y), w.items.push({
                        type: "line",
                        item: A
                      });
                      break;
                    case "vector":
                      var O = f(E.item);
                      h(O, S ? g.xOffset || 0 : n.x, y ? g.yOffset || 0 : n.y), w.items.push({
                        type: "vector",
                        item: O
                      });
                      break;
                    case "image":
                    case "svg":
                      var C = f(E.item);
                      C.x = (C.x || 0) + (S ? g.xOffset || 0 : n.x), C.y = (C.y || 0) + (y ? g.yOffset || 0 : n.y), w.items.push({
                        type: E.type,
                        item: C
                      });
                      break;
                  }
                }), b || n.moveDown(g.height), !0);
              }, p.prototype.pushContext = function(g, S) {
                g === void 0 && (S = this.context.getCurrentPage().height - this.context.pageMargins.top - this.context.pageMargins.bottom, g = this.context.availableWidth), i(g) && (g = new v({ width: g, height: S }, { left: 0, right: 0, top: 0, bottom: 0 })), this.contextStack.push(this.context), this.context = g;
              }, p.prototype.popContext = function() {
                this.context = this.contextStack.pop();
              }, p.prototype.getCurrentPositionOnPage = function() {
                return (this.contextStack[0] || this.context).getCurrentPosition();
              }, u.exports = p;
            }
          ),
          /***/
          28284: (
            /***/
            function(u, l, e) {
              var s = e(91867).isArray;
              function i(h, v) {
                var p = "normal";
                return h && v ? p = "bolditalics" : h ? p = "bold" : v && (p = "italics"), p;
              }
              function f(h, v) {
                this.fonts = {}, this.pdfKitDoc = v, this.fontCache = {};
                for (var p in h)
                  if (h.hasOwnProperty(p)) {
                    var m = h[p];
                    this.fonts[p] = {
                      normal: m.normal,
                      bold: m.bold,
                      italics: m.italics,
                      bolditalics: m.bolditalics
                    };
                  }
              }
              f.prototype.getFontType = function(h, v) {
                return i(h, v);
              }, f.prototype.getFontFile = function(h, v, p) {
                var m = this.getFontType(v, p);
                return !this.fonts[h] || !this.fonts[h][m] ? null : this.fonts[h][m];
              }, f.prototype.provideFont = function(h, v, p) {
                var m = this.getFontType(v, p);
                if (this.getFontFile(h, v, p) === null)
                  throw new Error("Font '" + h + "' in style '" + m + "' is not defined in the font section of the document definition.");
                if (this.fontCache[h] = this.fontCache[h] || {}, !this.fontCache[h][m]) {
                  var x = this.fonts[h][m];
                  s(x) || (x = [x]), this.fontCache[h][m] = this.pdfKitDoc.font.apply(this.pdfKitDoc, x)._font;
                }
                return this.fontCache[h][m];
              }, u.exports = f;
            }
          ),
          /***/
          91867: (
            /***/
            function(u) {
              function l(n) {
                return typeof n == "string" || n instanceof String;
              }
              function e(n) {
                return typeof n == "number" || n instanceof Number;
              }
              function s(n) {
                return typeof n == "boolean";
              }
              function i(n) {
                return Array.isArray(n);
              }
              function f(n) {
                return typeof n == "function";
              }
              function h(n) {
                return n !== null && typeof n == "object";
              }
              function v(n) {
                return n === null;
              }
              function p(n) {
                return n === void 0;
              }
              function m() {
                for (var n = {}, w = 0, E = arguments.length; w < E; w++) {
                  var A = arguments[w];
                  if (A)
                    for (var O in A)
                      A.hasOwnProperty(O) && (n[O] = A[O]);
                }
                return n;
              }
              function x(n, w, E) {
                switch (n.type) {
                  case "ellipse":
                  case "rect":
                    n.x += w, n.y += E;
                    break;
                  case "line":
                    n.x1 += w, n.x2 += w, n.y1 += E, n.y2 += E;
                    break;
                  case "polyline":
                    for (var A = 0, O = n.points.length; A < O; A++)
                      n.points[A].x += w, n.points[A].y += E;
                    break;
                }
              }
              function g(n, w) {
                return n === "font" ? "font" : w;
              }
              function S(n) {
                if (n.id)
                  return n.id;
                if (i(n.text))
                  for (var w = 0, E = n.text.length; w < E; w++) {
                    var A = n.text[w], O = S(A);
                    if (O)
                      return O;
                  }
                return null;
              }
              function y(n) {
                return i(n) && n.length === 2;
              }
              function b(n, w) {
                return [w[n[0]], n[1]];
              }
              u.exports = {
                isString: l,
                isNumber: e,
                isBoolean: s,
                isArray: i,
                isFunction: f,
                isObject: h,
                isNull: v,
                isUndefined: p,
                pack: m,
                fontStringify: g,
                offsetVector: x,
                getNodeId: S,
                isPattern: y,
                getPattern: b
              };
            }
          ),
          /***/
          93415: (
            /***/
            function(u, l, e) {
              var s = e(50621).Buffer, i = e(48181);
              function f(h, v) {
                this.pdfKitDoc = h, this.imageDictionary = v || {};
              }
              f.prototype.measureImage = function(h) {
                var v, p = this;
                if (this.pdfKitDoc._imageRegistry[h])
                  v = this.pdfKitDoc._imageRegistry[h];
                else {
                  try {
                    if (v = this.pdfKitDoc.openImage(m(h)), !v)
                      throw "No image";
                  } catch (x) {
                    throw "Invalid image: " + x.toString() + `
Images dictionary should contain dataURL entries (or local file paths in node.js)`;
                  }
                  v.embed(this.pdfKitDoc), this.pdfKitDoc._imageRegistry[h] = v;
                }
                return { width: v.width, height: v.height };
                function m(x) {
                  var g = p.imageDictionary[x];
                  if (!g)
                    return x;
                  if (i.existsSync(g))
                    return i.readFileSync(g);
                  var S = g.indexOf("base64,");
                  return S < 0 ? p.imageDictionary[x] : s.from(g.substring(S + 7), "base64");
                }
              }, u.exports = f;
            }
          ),
          /***/
          25235: (
            /***/
            function(u, l, e) {
              var s = e(2318), i = e(98883), f = e(42526), h = e(79178), v = e(11220), p = e(77530), m = e(89836), x = e(70770), g = e(91867).isString, S = e(91867).isArray, y = e(91867).isUndefined, b = e(91867).isNull, n = e(91867).pack, w = e(91867).offsetVector, E = e(91867).fontStringify, A = e(91867).getNodeId, O = e(91867).isFunction, C = e(11548), T = e(76442), P = e(91867).isNumber;
              function I(M, z) {
                z.forEach(function(L) {
                  M.push(L);
                });
              }
              function F(M, z, L, J) {
                this.pageSize = M, this.pageMargins = z, this.tracker = new s(), this.imageMeasure = L, this.svgMeasure = J, this.tableLayouts = {};
              }
              F.prototype.registerTableLayouts = function(M) {
                this.tableLayouts = n(this.tableLayouts, M);
              }, F.prototype.layoutDocument = function(M, z, L, J, ft, Q, xt, St, Pt, Gt) {
                function Rt(X, gt) {
                  if (!O(Gt))
                    return !1;
                  X = X.filter(function(et) {
                    return et.positions.length > 0;
                  }), X.forEach(function(et) {
                    var vt = {};
                    [
                      "id",
                      "text",
                      "ul",
                      "ol",
                      "table",
                      "image",
                      "qr",
                      "canvas",
                      "svg",
                      "columns",
                      "headlineLevel",
                      "style",
                      "pageBreak",
                      "pageOrientation",
                      "width",
                      "height"
                    ].forEach(function(lt) {
                      et[lt] !== void 0 && (vt[lt] = et[lt]);
                    }), vt.startPosition = et.positions[0], vt.pageNumbers = Array.from(new Set(et.positions.map(function(lt) {
                      return lt.pageNumber;
                    }))), vt.pages = gt.length, vt.stack = S(et.stack), et.nodeInfo = vt;
                  });
                  for (var st = 0; st < X.length; st++) {
                    var rt = X[st];
                    if (rt.pageBreak !== "before" && !rt.pageBreakCalculated) {
                      rt.pageBreakCalculated = !0;
                      var wt = rt.nodeInfo.pageNumbers[0], Ft = [], zt = [], G = [];
                      if (Gt.length > 1)
                        for (var D = st + 1, Z = X.length; D < Z; D++)
                          X[D].nodeInfo.pageNumbers.indexOf(wt) > -1 && Ft.push(X[D].nodeInfo), Gt.length > 2 && X[D].nodeInfo.pageNumbers.indexOf(wt + 1) > -1 && zt.push(X[D].nodeInfo);
                      if (Gt.length > 3)
                        for (var D = 0; D < st; D++)
                          X[D].nodeInfo.pageNumbers.indexOf(wt) > -1 && G.push(X[D].nodeInfo);
                      if (Gt(rt.nodeInfo, Ft, zt, G))
                        return rt.pageBreak = "before", !0;
                    }
                  }
                  return !1;
                }
                this.docPreprocessor = new i(), this.docMeasure = new f(z, L, J, this.imageMeasure, this.svgMeasure, this.tableLayouts, St);
                function bt(X) {
                  X.linearNodeList.forEach(function(gt) {
                    gt.resetXY();
                  });
                }
                for (var Dt = this.tryLayoutDocument(M, z, L, J, ft, Q, xt, St, Pt); Rt(Dt.linearNodeList, Dt.pages); )
                  bt(Dt), Dt = this.tryLayoutDocument(M, z, L, J, ft, Q, xt, St, Pt);
                return Dt.pages;
              }, F.prototype.tryLayoutDocument = function(M, z, L, J, ft, Q, xt, St, Pt, Gt) {
                this.linearNodeList = [], M = this.docPreprocessor.preprocessDocument(M), M = this.docMeasure.measureDocument(M), this.writer = new v(
                  new h(this.pageSize, this.pageMargins),
                  this.tracker
                );
                var Rt = this;
                return this.writer.context().tracker.startTracking("pageAdded", function() {
                  Rt.addBackground(ft);
                }), this.addBackground(ft), this.processNode(M), this.addHeadersAndFooters(Q, xt), Pt != null && this.addWatermark(Pt, z, J), { pages: this.writer.context().pages, linearNodeList: this.linearNodeList };
              }, F.prototype.addBackground = function(M) {
                var z = O(M) ? M : function() {
                  return M;
                }, L = this.writer.context(), J = L.getCurrentPage().pageSize, ft = z(L.page + 1, J);
                ft && (this.writer.beginUnbreakableBlock(J.width, J.height), ft = this.docPreprocessor.preprocessDocument(ft), this.processNode(this.docMeasure.measureDocument(ft)), this.writer.commitUnbreakableBlock(0, 0), L.backgroundLength[L.page] += ft.positions.length);
              }, F.prototype.addStaticRepeatable = function(M, z) {
                this.addDynamicRepeatable(function() {
                  return JSON.parse(JSON.stringify(M));
                }, z);
              }, F.prototype.addDynamicRepeatable = function(M, z) {
                for (var L = this.writer.context().pages, J = 0, ft = L.length; J < ft; J++) {
                  this.writer.context().page = J;
                  var Q = M(J + 1, ft, this.writer.context().pages[J].pageSize);
                  if (Q) {
                    var xt = z(this.writer.context().getCurrentPage().pageSize, this.pageMargins);
                    this.writer.beginUnbreakableBlock(xt.width, xt.height), Q = this.docPreprocessor.preprocessDocument(Q), this.processNode(this.docMeasure.measureDocument(Q)), this.writer.commitUnbreakableBlock(xt.x, xt.y);
                  }
                }
              }, F.prototype.addHeadersAndFooters = function(M, z) {
                var L = function(ft, Q) {
                  return {
                    x: 0,
                    y: 0,
                    width: ft.width,
                    height: Q.top
                  };
                }, J = function(ft, Q) {
                  return {
                    x: 0,
                    y: ft.height - Q.bottom,
                    width: ft.width,
                    height: Q.bottom
                  };
                };
                O(M) ? this.addDynamicRepeatable(M, L) : M && this.addStaticRepeatable(M, L), O(z) ? this.addDynamicRepeatable(z, J) : z && this.addStaticRepeatable(z, J);
              }, F.prototype.addWatermark = function(M, z, L) {
                if (g(M) && (M = { text: M }), !M.text)
                  return;
                M.font = M.font || L.font || "Roboto", M.fontSize = M.fontSize || "auto", M.color = M.color || "black", M.opacity = P(M.opacity) ? M.opacity : 0.6, M.bold = M.bold || !1, M.italics = M.italics || !1, M.angle = !y(M.angle) && !b(M.angle) ? M.angle : null, M.angle === null && (M.angle = Math.atan2(this.pageSize.height, this.pageSize.width) * -180 / Math.PI), M.fontSize === "auto" && (M.fontSize = Pt(this.pageSize, M, z));
                var J = {
                  text: M.text,
                  font: z.provideFont(M.font, M.bold, M.italics),
                  fontSize: M.fontSize,
                  color: M.color,
                  opacity: M.opacity,
                  angle: M.angle
                };
                J._size = St(M, z);
                for (var ft = this.writer.context().pages, Q = 0, xt = ft.length; Q < xt; Q++)
                  ft[Q].watermark = J;
                function St(Gt, Rt) {
                  var bt = new C(Rt), Dt = new T(null, { font: Gt.font, bold: Gt.bold, italics: Gt.italics });
                  Dt.push({
                    fontSize: Gt.fontSize
                  });
                  var X = bt.sizeOfString(Gt.text, Dt), gt = bt.sizeOfRotatedText(Gt.text, Gt.angle, Dt);
                  return { size: X, rotatedSize: gt };
                }
                function Pt(Gt, Rt, bt) {
                  for (var Dt = new C(bt), X = new T(null, { font: Rt.font, bold: Rt.bold, italics: Rt.italics }), gt, st = 0, rt = 1e3, wt = (st + rt) / 2; Math.abs(st - rt) > 1; )
                    X.push({
                      fontSize: wt
                    }), gt = Dt.sizeOfRotatedText(Rt.text, Rt.angle, X), gt.width > Gt.width ? (rt = wt, wt = (st + rt) / 2) : gt.width < Gt.width && (gt.height > Gt.height ? (rt = wt, wt = (st + rt) / 2) : (st = wt, wt = (st + rt) / 2)), X.pop();
                  return wt;
                }
              };
              function B(M) {
                var z = M.x, L = M.y;
                M.positions = [], S(M.canvas) && M.canvas.forEach(function(J) {
                  var ft = J.x, Q = J.y, xt = J.x1, St = J.y1, Pt = J.x2, Gt = J.y2;
                  J.resetXY = function() {
                    J.x = ft, J.y = Q, J.x1 = xt, J.y1 = St, J.x2 = Pt, J.y2 = Gt;
                  };
                }), M.resetXY = function() {
                  M.x = z, M.y = L, S(M.canvas) && M.canvas.forEach(function(J) {
                    J.resetXY();
                  });
                };
              }
              F.prototype.processNode = function(M) {
                var z = this;
                this.linearNodeList.push(M), B(M), L(function() {
                  var J = M.unbreakable;
                  J && z.writer.beginUnbreakableBlock();
                  var ft = M.absolutePosition;
                  ft && (z.writer.context().beginDetachedBlock(), z.writer.context().moveTo(ft.x || 0, ft.y || 0));
                  var Q = M.relativePosition;
                  if (Q && (z.writer.context().beginDetachedBlock(), z.writer.context().moveToRelative(Q.x || 0, Q.y || 0)), M.stack)
                    z.processVerticalContainer(M);
                  else if (M.columns)
                    z.processColumns(M);
                  else if (M.ul)
                    z.processList(!1, M);
                  else if (M.ol)
                    z.processList(!0, M);
                  else if (M.table)
                    z.processTable(M);
                  else if (M.text !== void 0)
                    z.processLeaf(M);
                  else if (M.toc)
                    z.processToc(M);
                  else if (M.image)
                    z.processImage(M);
                  else if (M.svg)
                    z.processSVG(M);
                  else if (M.canvas)
                    z.processCanvas(M);
                  else if (M.qr)
                    z.processQr(M);
                  else if (!M._span)
                    throw "Unrecognized document structure: " + JSON.stringify(M, E);
                  (ft || Q) && z.writer.context().endDetachedBlock(), J && z.writer.commitUnbreakableBlock();
                });
                function L(J) {
                  var ft = M._margin;
                  M.pageBreak === "before" ? z.writer.moveToNextPage(M.pageOrientation) : M.pageBreak === "beforeOdd" ? (z.writer.moveToNextPage(M.pageOrientation), (z.writer.context().page + 1) % 2 === 1 && z.writer.moveToNextPage(M.pageOrientation)) : M.pageBreak === "beforeEven" && (z.writer.moveToNextPage(M.pageOrientation), (z.writer.context().page + 1) % 2 === 0 && z.writer.moveToNextPage(M.pageOrientation)), ft && (z.writer.context().moveDown(ft[1]), z.writer.context().addMargin(ft[0], ft[2])), J(), ft && (z.writer.context().addMargin(-ft[0], -ft[2]), z.writer.context().moveDown(ft[3])), M.pageBreak === "after" ? z.writer.moveToNextPage(M.pageOrientation) : M.pageBreak === "afterOdd" ? (z.writer.moveToNextPage(M.pageOrientation), (z.writer.context().page + 1) % 2 === 1 && z.writer.moveToNextPage(M.pageOrientation)) : M.pageBreak === "afterEven" && (z.writer.moveToNextPage(M.pageOrientation), (z.writer.context().page + 1) % 2 === 0 && z.writer.moveToNextPage(M.pageOrientation));
                }
              }, F.prototype.processVerticalContainer = function(M) {
                var z = this;
                M.stack.forEach(function(L) {
                  z.processNode(L), I(M.positions, L.positions);
                });
              }, F.prototype.processColumns = function(M) {
                var z = M.columns, L = this.writer.context().availableWidth, J = Q(M._gap);
                J && (L -= (J.length - 1) * M._gap), p.buildColumnWidths(z, L);
                var ft = this.processRow(z, z, J);
                I(M.positions, ft.positions);
                function Q(xt) {
                  if (!xt)
                    return null;
                  var St = [];
                  St.push(0);
                  for (var Pt = z.length - 1; Pt > 0; Pt--)
                    St.push(xt);
                  return St;
                }
              }, F.prototype.processRow = function(M, z, L, J, ft, Q) {
                var xt = this, St = [], Pt = [];
                return this.tracker.auto("pageChanged", Gt, function() {
                  z = z || M, xt.writer.context().beginColumnGroup();
                  for (var Dt = 0, X = M.length; Dt < X; Dt++) {
                    var gt = M[Dt], st = z[Dt]._calcWidth, rt = Rt(Dt);
                    if (gt.colSpan && gt.colSpan > 1)
                      for (var wt = 1; wt < gt.colSpan; wt++)
                        st += z[++Dt]._calcWidth + L[Dt];
                    xt.writer.context().beginColumn(st, rt, bt(gt, Dt)), gt._span ? gt._columnEndingContext && xt.writer.context().markEnding(gt) : (xt.processNode(gt), I(Pt, gt.positions));
                  }
                  xt.writer.context().completeColumnGroup(Q);
                }), { pageBreaks: St, positions: Pt };
                function Gt(Dt) {
                  for (var X, gt = 0, st = St.length; gt < st; gt++) {
                    var rt = St[gt];
                    if (rt.prevPage === Dt.prevPage) {
                      X = rt;
                      break;
                    }
                  }
                  X || (X = Dt, St.push(X)), X.prevY = Math.max(X.prevY, Dt.prevY), X.y = Math.min(X.y, Dt.y);
                }
                function Rt(Dt) {
                  return L && L.length > Dt ? L[Dt] : 0;
                }
                function bt(Dt, X) {
                  if (Dt.rowSpan && Dt.rowSpan > 1) {
                    var gt = ft + Dt.rowSpan - 1;
                    if (gt >= J.length)
                      throw "Row span for column " + X + " (with indexes starting from 0) exceeded row count";
                    return J[gt][X];
                  }
                  return null;
                }
              }, F.prototype.processList = function(M, z) {
                var L = this, J = M ? z.ol : z.ul, ft = z._gapSize;
                this.writer.context().addMargin(ft.width);
                var Q;
                this.tracker.auto("lineAdded", xt, function() {
                  J.forEach(function(St) {
                    Q = St.listMarker, L.processNode(St), I(z.positions, St.positions);
                  });
                }), this.writer.context().addMargin(-ft.width);
                function xt(St) {
                  if (Q) {
                    var Pt = Q;
                    if (Q = null, Pt.canvas) {
                      var Gt = Pt.canvas[0];
                      w(Gt, -Pt._minWidth, 0), L.writer.addVector(Gt);
                    } else if (Pt._inlines) {
                      var Rt = new x(L.pageSize.width);
                      Rt.addInline(Pt._inlines[0]), Rt.x = -Pt._minWidth, Rt.y = St.getAscenderHeight() - Rt.getAscenderHeight(), L.writer.addLine(Rt, !0);
                    }
                  }
                }
              }, F.prototype.processTable = function(M) {
                var z = new m(M);
                z.beginTable(this.writer);
                for (var L = M.table.heights, J = 0, ft = M.table.body.length; J < ft; J++) {
                  z.beginRow(J, this.writer);
                  var Q;
                  O(L) ? Q = L(J) : S(L) ? Q = L[J] : Q = L, Q === "auto" && (Q = void 0);
                  var xt = this.processRow(M.table.body[J], M.table.widths, M._offsets.offsets, M.table.body, J, Q);
                  I(M.positions, xt.positions), z.endRow(J, this.writer, xt.pageBreaks);
                }
                z.endTable(this.writer);
              }, F.prototype.processLeaf = function(M) {
                var z = this.buildNextLine(M);
                z && (M.tocItem || M.id) && (z._node = M);
                var L = z ? z.getHeight() : 0, J = M.maxHeight || -1;
                if (z) {
                  var ft = A(M);
                  ft && (z.id = ft);
                }
                if (M._tocItemRef && (z._pageNodeRef = M._tocItemRef), M._pageRef && (z._pageNodeRef = M._pageRef._nodeRef), z && z.inlines && S(z.inlines))
                  for (var Q = 0, xt = z.inlines.length; Q < xt; Q++)
                    z.inlines[Q]._tocItemRef && (z.inlines[Q]._pageNodeRef = z.inlines[Q]._tocItemRef), z.inlines[Q]._pageRef && (z.inlines[Q]._pageNodeRef = z.inlines[Q]._pageRef._nodeRef);
                for (; z && (J === -1 || L < J); ) {
                  var St = this.writer.addLine(z);
                  M.positions.push(St), z = this.buildNextLine(M), z && (L += z.getHeight());
                }
              }, F.prototype.processToc = function(M) {
                M.toc.title && this.processNode(M.toc.title), M.toc._table && this.processNode(M.toc._table);
              }, F.prototype.buildNextLine = function(M) {
                function z(Rt) {
                  var bt = Rt.constructor();
                  for (var Dt in Rt)
                    bt[Dt] = Rt[Dt];
                  return bt;
                }
                if (!M._inlines || M._inlines.length === 0)
                  return null;
                for (var L = new x(this.writer.context().availableWidth), J = new C(null), ft = !1; M._inlines && M._inlines.length > 0 && (L.hasEnoughSpaceForInline(M._inlines[0], M._inlines.slice(1)) || ft); ) {
                  var Q = !1, xt = M._inlines.shift();
                  if (ft = !1, !xt.noWrap && xt.text.length > 1 && xt.width > L.getAvailableWidth()) {
                    var St = xt.width / xt.text.length, Pt = Math.floor(L.getAvailableWidth() / St);
                    if (Pt < 1 && (Pt = 1), Pt < xt.text.length) {
                      var Gt = z(xt);
                      Gt.text = xt.text.substr(Pt), xt.text = xt.text.substr(0, Pt), Gt.width = J.widthOfString(Gt.text, Gt.font, Gt.fontSize, Gt.characterSpacing, Gt.fontFeatures), xt.width = J.widthOfString(xt.text, xt.font, xt.fontSize, xt.characterSpacing, xt.fontFeatures), M._inlines.unshift(Gt), Q = !0;
                    }
                  }
                  L.addInline(xt), ft = xt.noNewLine && !Q;
                }
                return L.lastLineInParagraph = M._inlines.length === 0, L;
              }, F.prototype.processImage = function(M) {
                var z = this.writer.addImage(M);
                M.positions.push(z);
              }, F.prototype.processSVG = function(M) {
                var z = this.writer.addSVG(M);
                M.positions.push(z);
              }, F.prototype.processCanvas = function(M) {
                var z = M._minHeight;
                M.absolutePosition === void 0 && this.writer.context().availableHeight < z && this.writer.moveToNextPage(), this.writer.alignCanvas(M), M.canvas.forEach(function(L) {
                  var J = this.writer.addVector(L);
                  M.positions.push(J);
                }, this), this.writer.context().moveDown(z);
              }, F.prototype.processQr = function(M) {
                var z = this.writer.addQr(M);
                M.positions.push(z);
              }, u.exports = F;
            }
          ),
          /***/
          70770: (
            /***/
            function(u) {
              function l(e) {
                this.maxWidth = e, this.leadingCut = 0, this.trailingCut = 0, this.inlineWidths = 0, this.inlines = [];
              }
              l.prototype.getAscenderHeight = function() {
                var e = 0;
                return this.inlines.forEach(function(s) {
                  e = Math.max(e, s.font.ascender / 1e3 * s.fontSize);
                }), e;
              }, l.prototype.hasEnoughSpaceForInline = function(e, s) {
                if (s = s || [], this.inlines.length === 0)
                  return !0;
                if (this.newLineForced)
                  return !1;
                var i = e.width, f = e.trailingCut || 0;
                if (e.noNewLine)
                  for (var h = 0, v = s.length; h < v; h++) {
                    var p = s[h];
                    if (i += p.width, f += p.trailingCut || 0, !p.noNewLine)
                      break;
                  }
                return this.inlineWidths + i - this.leadingCut - f <= this.maxWidth;
              }, l.prototype.addInline = function(e) {
                this.inlines.length === 0 && (this.leadingCut = e.leadingCut || 0), this.trailingCut = e.trailingCut || 0, e.x = this.inlineWidths - this.leadingCut, this.inlines.push(e), this.inlineWidths += e.width, e.lineEnd && (this.newLineForced = !0);
              }, l.prototype.getWidth = function() {
                return this.inlineWidths - this.leadingCut - this.trailingCut;
              }, l.prototype.getAvailableWidth = function() {
                return this.maxWidth - this.getWidth();
              }, l.prototype.getHeight = function() {
                var e = 0;
                return this.inlines.forEach(function(s) {
                  e = Math.max(e, s.height || 0);
                }), e;
              }, u.exports = l;
            }
          ),
          /***/
          11220: (
            /***/
            function(u, l, e) {
              var s = e(91867).isUndefined, i = e(54861);
              function f(v, p) {
                this.transactionLevel = 0, this.repeatables = [], this.tracker = p, this.writer = new i(v, p);
              }
              function h(v, p) {
                var m = p(v);
                return m || (v.moveToNextPage(), m = p(v)), m;
              }
              f.prototype.addLine = function(v, p, m) {
                return h(this, function(x) {
                  return x.writer.addLine(v, p, m);
                });
              }, f.prototype.addImage = function(v, p) {
                return h(this, function(m) {
                  return m.writer.addImage(v, p);
                });
              }, f.prototype.addSVG = function(v, p) {
                return h(this, function(m) {
                  return m.writer.addSVG(v, p);
                });
              }, f.prototype.addQr = function(v, p) {
                return h(this, function(m) {
                  return m.writer.addQr(v, p);
                });
              }, f.prototype.addVector = function(v, p, m, x) {
                return this.writer.addVector(v, p, m, x);
              }, f.prototype.beginClip = function(v, p) {
                return this.writer.beginClip(v, p);
              }, f.prototype.endClip = function() {
                return this.writer.endClip();
              }, f.prototype.alignCanvas = function(v) {
                this.writer.alignCanvas(v);
              }, f.prototype.addFragment = function(v, p, m, x) {
                this.writer.addFragment(v, p, m, x) || (this.moveToNextPage(), this.writer.addFragment(v, p, m, x));
              }, f.prototype.moveToNextPage = function(v) {
                var p = this.writer.context.moveToNextPage(v);
                this.repeatables.forEach(function(m) {
                  s(m.insertedOnPages[this.writer.context.page]) ? (m.insertedOnPages[this.writer.context.page] = !0, this.writer.addFragment(m, !0)) : this.writer.context.moveDown(m.height);
                }, this), this.writer.tracker.emit("pageChanged", {
                  prevPage: p.prevPage,
                  prevY: p.prevY,
                  y: this.writer.context.y
                });
              }, f.prototype.beginUnbreakableBlock = function(v, p) {
                this.transactionLevel++ === 0 && (this.originalX = this.writer.context.x, this.writer.pushContext(v, p));
              }, f.prototype.commitUnbreakableBlock = function(v, p) {
                if (--this.transactionLevel === 0) {
                  var m = this.writer.context;
                  this.writer.popContext();
                  var x = m.pages.length;
                  if (x > 0) {
                    var g = m.pages[0];
                    if (g.xOffset = v, g.yOffset = p, x > 1)
                      if (v !== void 0 || p !== void 0)
                        g.height = m.getCurrentPage().pageSize.height - m.pageMargins.top - m.pageMargins.bottom;
                      else {
                        g.height = this.writer.context.getCurrentPage().pageSize.height - this.writer.context.pageMargins.top - this.writer.context.pageMargins.bottom;
                        for (var S = 0, y = this.repeatables.length; S < y; S++)
                          g.height -= this.repeatables[S].height;
                      }
                    else
                      g.height = m.y;
                    v !== void 0 || p !== void 0 ? this.writer.addFragment(g, !0, !0, !0) : this.addFragment(g);
                  }
                }
              }, f.prototype.currentBlockToRepeatable = function() {
                var v = this.writer.context, p = { items: [] };
                return v.pages[0].items.forEach(function(m) {
                  p.items.push(m);
                }), p.xOffset = this.originalX, p.height = v.y, p.insertedOnPages = [], p;
              }, f.prototype.pushToRepeatables = function(v) {
                this.repeatables.push(v);
              }, f.prototype.popFromRepeatables = function() {
                this.repeatables.pop();
              }, f.prototype.context = function() {
                return this.writer.context;
              }, u.exports = f;
            }
          ),
          /***/
          85208: (
            /***/
            function(u, l, e) {
              function s(v) {
                return v && typeof v == "object" && "default" in v ? v.default : v;
              }
              var i = s(e(48585));
              function f() {
                return i;
              }
              function h(v) {
                return v = v || {}, new i(v);
              }
              u.exports = {
                getEngineInstance: f,
                createPdfDocument: h
              };
            }
          ),
          /***/
          81566: (
            /***/
            function(u, l, e) {
              var s = e(85208), i = e(28284), f = e(25235), h = e(70098), v = e(93415), p = e(89638), m = e(84786), x = e(11548), g = e(91867).isFunction, S = e(91867).isString, y = e(91867).isNumber, b = e(91867).isBoolean, n = e(91867).isArray, w = e(91867).isUndefined, E = e(91867).isPattern, A = e(91867).getPattern, O = e(54074), C = function(X, gt, st) {
                for (var rt = 0; rt < gt.length; rt++) {
                  var wt = gt[rt].toLowerCase();
                  for (var Ft in X)
                    if (Ft.toLowerCase() === wt)
                      return Ft;
                }
                return st;
              };
              function T(X) {
                this.fontDescriptors = X;
              }
              T.prototype.createPdfKitDocument = function(X, gt) {
                gt = gt || {}, X.version = X.version || "1.3", X.compress = b(X.compress) ? X.compress : !0, X.images = X.images || {}, X.pageMargins = X.pageMargins !== void 0 && X.pageMargins !== null ? X.pageMargins : 40;
                var st = F(X.pageSize, X.pageOrientation), rt = {
                  size: [st.width, st.height],
                  pdfVersion: X.version,
                  compress: X.compress,
                  userPassword: X.userPassword,
                  ownerPassword: X.ownerPassword,
                  permissions: X.permissions,
                  lang: X.language,
                  fontLayoutCache: b(gt.fontLayoutCache) ? gt.fontLayoutCache : !0,
                  bufferPages: gt.bufferPages || !1,
                  autoFirstPage: !1,
                  info: P(X),
                  font: null
                };
                this.pdfKitDoc = s.createPdfDocument(rt), this.fontProvider = new i(this.fontDescriptors, this.pdfKitDoc);
                var wt = new f(st, B(X.pageMargins), new v(this.pdfKitDoc, X.images), new p());
                M(wt), gt.tableLayouts && wt.registerTableLayouts(gt.tableLayouts);
                var Ft = wt.layoutDocument(X.content, this.fontProvider, X.styles || {}, X.defaultStyle || {
                  fontSize: 12,
                  font: "Roboto"
                }, X.background, X.header, X.footer, X.images, X.watermark, X.pageBreakBefore), zt = X.maxPagesNumber || -1;
                if (y(zt) && zt > -1 && (Ft = Ft.slice(0, zt)), st.height === 1 / 0) {
                  var G = I(Ft, X.pageMargins);
                  this.pdfKitDoc.options.size = [st.width, G];
                }
                var D = Dt(X.patterns || {}, this.pdfKitDoc);
                if (J(Ft, this.fontProvider, this.pdfKitDoc, D, gt.progressCallback), gt.autoPrint) {
                  var Z = this.pdfKitDoc.ref({
                    Type: "Action",
                    S: "Named",
                    N: "Print"
                  });
                  this.pdfKitDoc._root.data.OpenAction = Z, Z.end();
                }
                return this.pdfKitDoc;
              };
              function P(X) {
                function gt(Ft) {
                  var zt = [
                    "Title",
                    "Author",
                    "Subject",
                    "Keywords",
                    "Creator",
                    "Producer",
                    "CreationDate",
                    "ModDate",
                    "Trapped"
                  ], G = Ft.charAt(0).toUpperCase() + Ft.slice(1);
                  return zt.indexOf(G) !== -1 ? G : Ft.replace(/\s+/g, "");
                }
                var st = {
                  Producer: "pdfmake",
                  Creator: "pdfmake"
                };
                if (X.info)
                  for (var rt in X.info) {
                    var wt = X.info[rt];
                    wt && (rt = gt(rt), st[rt] = wt);
                  }
                return st;
              }
              function I(X, gt) {
                function st(zt) {
                  return g(zt.item.getHeight) ? zt.item.getHeight() : zt.item._height ? zt.item._height : zt.type === "vector" ? typeof zt.item.y1 < "u" ? zt.item.y1 > zt.item.y2 ? zt.item.y1 : zt.item.y2 : zt.item.h : 0;
                }
                function rt(zt) {
                  var G = zt.item.y || 0, D = st(zt);
                  return G + D;
                }
                var wt = B(gt || 40), Ft = wt.top;
                return X.forEach(function(zt) {
                  zt.items.forEach(function(G) {
                    var D = rt(G);
                    D > Ft && (Ft = D);
                  });
                }), Ft += wt.bottom, Ft;
              }
              function F(X, gt) {
                function st(wt) {
                  return S(wt) ? (wt = wt.toLowerCase(), wt === "portrait" && rt.width > rt.height || wt === "landscape" && rt.width < rt.height) : !1;
                }
                X && X.height === "auto" && (X.height = 1 / 0);
                var rt = z(X || "A4");
                return st(gt) && (rt = { width: rt.height, height: rt.width }), rt.orientation = rt.width > rt.height ? "landscape" : "portrait", rt;
              }
              function B(X) {
                if (y(X))
                  X = { left: X, right: X, top: X, bottom: X };
                else if (n(X))
                  if (X.length === 2)
                    X = { left: X[0], top: X[1], right: X[0], bottom: X[1] };
                  else if (X.length === 4)
                    X = { left: X[0], top: X[1], right: X[2], bottom: X[3] };
                  else
                    throw "Invalid pageMargins definition";
                return X;
              }
              function M(X) {
                X.registerTableLayouts({
                  noBorders: {
                    hLineWidth: function(gt) {
                      return 0;
                    },
                    vLineWidth: function(gt) {
                      return 0;
                    },
                    paddingLeft: function(gt) {
                      return gt && 4 || 0;
                    },
                    paddingRight: function(gt, st) {
                      return gt < st.table.widths.length - 1 ? 4 : 0;
                    }
                  },
                  headerLineOnly: {
                    hLineWidth: function(gt, st) {
                      return gt === 0 || gt === st.table.body.length ? 0 : gt === st.table.headerRows ? 2 : 0;
                    },
                    vLineWidth: function(gt) {
                      return 0;
                    },
                    paddingLeft: function(gt) {
                      return gt === 0 ? 0 : 8;
                    },
                    paddingRight: function(gt, st) {
                      return gt === st.table.widths.length - 1 ? 0 : 8;
                    }
                  },
                  lightHorizontalLines: {
                    hLineWidth: function(gt, st) {
                      return gt === 0 || gt === st.table.body.length ? 0 : gt === st.table.headerRows ? 2 : 1;
                    },
                    vLineWidth: function(gt) {
                      return 0;
                    },
                    hLineColor: function(gt) {
                      return gt === 1 ? "black" : "#aaa";
                    },
                    paddingLeft: function(gt) {
                      return gt === 0 ? 0 : 8;
                    },
                    paddingRight: function(gt, st) {
                      return gt === st.table.widths.length - 1 ? 0 : 8;
                    }
                  }
                });
              }
              function z(X) {
                if (S(X)) {
                  var gt = h[X.toUpperCase()];
                  if (!gt)
                    throw "Page size " + X + " not recognized";
                  return { width: gt[0], height: gt[1] };
                }
                return X;
              }
              function L(X, gt) {
                var st = gt.options.size[0] > gt.options.size[1] ? "landscape" : "portrait";
                if (X.pageSize.orientation !== st) {
                  var rt = gt.options.size[0], wt = gt.options.size[1];
                  gt.options.size = [wt, rt];
                }
              }
              function J(X, gt, st, rt, wt) {
                st._pdfMakePages = X, st.addPage();
                var Ft = 0;
                wt && X.forEach(function(lt) {
                  Ft += lt.items.length;
                });
                var zt = 0;
                wt = wt || function() {
                };
                for (var G = 0; G < X.length; G++) {
                  G > 0 && (L(X[G], st), st.addPage(st.options));
                  for (var D = X[G], Z = 0, et = D.items.length; Z < et; Z++) {
                    var vt = D.items[Z];
                    switch (vt.type) {
                      case "vector":
                        St(vt.item, rt, st);
                        break;
                      case "line":
                        Q(vt.item, vt.item.x, vt.item.y, rt, st);
                        break;
                      case "image":
                        Pt(vt.item, vt.item.x, vt.item.y, st);
                        break;
                      case "svg":
                        Gt(vt.item, vt.item.x, vt.item.y, st, gt);
                        break;
                      case "beginClip":
                        Rt(vt.item, st);
                        break;
                      case "endClip":
                        bt(st);
                        break;
                    }
                    zt++, wt(zt / Ft);
                  }
                  D.watermark && xt(D, st);
                }
              }
              function ft(X, gt) {
                var st = X;
                return gt.sup && (st -= gt.fontSize * 0.75), gt.sub && (st += gt.fontSize * 0.35), st;
              }
              function Q(X, gt, st, rt, wt) {
                function Ft(me, se) {
                  var Bt, ge, Re = new x(null);
                  if (w(me.positions))
                    throw "Page reference id not found";
                  var Te = me.positions[0].pageNumber.toString();
                  switch (se.text = Te, Bt = Re.widthOfString(se.text, se.font, se.fontSize, se.characterSpacing, se.fontFeatures), ge = se.width - Bt, se.width = Bt, se.alignment) {
                    case "right":
                      se.x += ge;
                      break;
                    case "center":
                      se.x += ge / 2;
                      break;
                  }
                }
                X._pageNodeRef && Ft(X._pageNodeRef, X.inlines[0]), gt = gt || 0, st = st || 0;
                var zt = X.getHeight(), G = X.getAscenderHeight(), D = zt - G;
                m.drawBackground(X, gt, st, rt, wt);
                for (var Z = 0, et = X.inlines.length; Z < et; Z++) {
                  var vt = X.inlines[Z], lt = zt - vt.font.ascender / 1e3 * vt.fontSize - D;
                  vt._pageNodeRef && Ft(vt._pageNodeRef, vt);
                  var dt = {
                    lineBreak: !1,
                    textWidth: vt.width,
                    characterSpacing: vt.characterSpacing,
                    wordCount: 1,
                    link: vt.link
                  };
                  vt.linkToDestination && (dt.goTo = vt.linkToDestination), X.id && Z === 0 && (dt.destination = X.id), vt.fontFeatures && (dt.features = vt.fontFeatures);
                  var kt = y(vt.opacity) ? vt.opacity : 1;
                  wt.opacity(kt), wt.fill(vt.color || "black"), wt._font = vt.font, wt.fontSize(vt.fontSize);
                  var jt = ft(st + lt, vt);
                  wt.text(vt.text, gt + vt.x, jt, dt), vt.linkToPage && (wt.ref({ Type: "Action", S: "GoTo", D: [vt.linkToPage, 0, 0] }).end(), wt.annotate(gt + vt.x, jt, vt.width, vt.height, {
                    Subtype: "Link",
                    Dest: [vt.linkToPage - 1, "XYZ", null, null, null]
                  }));
                }
                m.drawDecorations(X, gt, st, wt);
              }
              function xt(X, gt) {
                var st = X.watermark;
                gt.fill(st.color), gt.opacity(st.opacity), gt.save(), gt.rotate(st.angle, { origin: [gt.page.width / 2, gt.page.height / 2] });
                var rt = gt.page.width / 2 - st._size.size.width / 2, wt = gt.page.height / 2 - st._size.size.height / 2;
                gt._font = st.font, gt.fontSize(st.fontSize), gt.text(st.text, rt, wt, { lineBreak: !1 }), gt.restore();
              }
              function St(X, gt, st) {
                st.lineWidth(X.lineWidth || 1), X.dash ? st.dash(X.dash.length, { space: X.dash.space || X.dash.length, phase: X.dash.phase || 0 }) : st.undash(), st.lineJoin(X.lineJoin || "miter"), st.lineCap(X.lineCap || "butt");
                var rt = null;
                switch (X.type) {
                  case "ellipse":
                    st.ellipse(X.x, X.y, X.r1, X.r2), X.linearGradient && (rt = st.linearGradient(X.x - X.r1, X.y, X.x + X.r1, X.y));
                    break;
                  case "rect":
                    X.r ? st.roundedRect(X.x, X.y, X.w, X.h, X.r) : st.rect(X.x, X.y, X.w, X.h), X.linearGradient && (rt = st.linearGradient(X.x, X.y, X.x + X.w, X.y));
                    break;
                  case "line":
                    st.moveTo(X.x1, X.y1), st.lineTo(X.x2, X.y2);
                    break;
                  case "polyline":
                    if (X.points.length === 0)
                      break;
                    st.moveTo(X.points[0].x, X.points[0].y);
                    for (var wt = 1, Ft = X.points.length; wt < Ft; wt++)
                      st.lineTo(X.points[wt].x, X.points[wt].y);
                    if (X.points.length > 1) {
                      var zt = X.points[0], G = X.points[X.points.length - 1];
                      (X.closePath || zt.x === G.x && zt.y === G.y) && st.closePath();
                    }
                    break;
                  case "path":
                    st.path(X.d);
                    break;
                }
                if (X.linearGradient && rt) {
                  for (var D = 1 / (X.linearGradient.length - 1), wt = 0; wt < X.linearGradient.length; wt++)
                    rt.stop(wt * D, X.linearGradient[wt]);
                  X.color = rt;
                }
                E(X.color) && (X.color = A(X.color, gt));
                var Z = y(X.fillOpacity) ? X.fillOpacity : 1, et = y(X.strokeOpacity) ? X.strokeOpacity : 1;
                X.color && X.lineColor ? (st.fillColor(X.color, Z), st.strokeColor(X.lineColor, et), st.fillAndStroke()) : X.color ? (st.fillColor(X.color, Z), st.fill()) : (st.strokeColor(X.lineColor || "black", et), st.stroke());
              }
              function Pt(X, gt, st, rt) {
                var wt = y(X.opacity) ? X.opacity : 1;
                if (rt.opacity(wt), X.cover) {
                  var Ft = X.cover.align || "center", zt = X.cover.valign || "center", G = X.cover.width ? X.cover.width : X.width, D = X.cover.height ? X.cover.height : X.height;
                  rt.save(), rt.rect(X.x, X.y, G, D).clip(), rt.image(X.image, X.x, X.y, { cover: [G, D], align: Ft, valign: zt }), rt.restore();
                } else
                  rt.image(X.image, X.x, X.y, { width: X._width, height: X._height });
                X.link && rt.link(X.x, X.y, X._width, X._height, X.link), X.linkToPage && (rt.ref({ Type: "Action", S: "GoTo", D: [X.linkToPage, 0, 0] }).end(), rt.annotate(X.x, X.y, X._width, X._height, { Subtype: "Link", Dest: [X.linkToPage - 1, "XYZ", null, null, null] })), X.linkToDestination && rt.goTo(X.x, X.y, X._width, X._height, X.linkToDestination);
              }
              function Gt(X, gt, st, rt, wt) {
                var Ft = Object.assign({ width: X._width, height: X._height, assumePt: !0 }, X.options);
                Ft.fontCallback = function(zt, G, D) {
                  var Z = zt.split(",").map(function(dt) {
                    return dt.trim().replace(/('|")/g, "");
                  }), et = C(wt.fonts, Z, X.font || "Roboto"), vt = wt.getFontFile(et, G, D);
                  if (vt === null) {
                    var lt = wt.getFontType(G, D);
                    throw new Error("Font '" + et + "' in style '" + lt + "' is not defined in the font section of the document definition.");
                  }
                  return vt;
                }, O(rt, X.svg, X.x, X.y, Ft);
              }
              function Rt(X, gt) {
                gt.save(), gt.addContent("" + X.x + " " + X.y + " " + X.width + " " + X.height + " re"), gt.clip();
              }
              function bt(X) {
                X.restore();
              }
              function Dt(X, gt) {
                var st = {};
                return Object.keys(X).forEach(function(rt) {
                  var wt = X[rt];
                  st[rt] = gt.pattern(wt.boundingBox, wt.xStep, wt.yStep, wt.pattern, wt.colored);
                }), st;
              }
              u.exports = T;
            }
          ),
          /***/
          72155: (
            /***/
            function(u) {
              for (var l = [
                null,
                [[10, 7, 17, 13], [1, 1, 1, 1], []],
                [[16, 10, 28, 22], [1, 1, 1, 1], [4, 16]],
                [[26, 15, 22, 18], [1, 1, 2, 2], [4, 20]],
                [[18, 20, 16, 26], [2, 1, 4, 2], [4, 24]],
                [[24, 26, 22, 18], [2, 1, 4, 4], [4, 28]],
                [[16, 18, 28, 24], [4, 2, 4, 4], [4, 32]],
                [[18, 20, 26, 18], [4, 2, 5, 6], [4, 20, 36]],
                [[22, 24, 26, 22], [4, 2, 6, 6], [4, 22, 40]],
                [[22, 30, 24, 20], [5, 2, 8, 8], [4, 24, 44]],
                [[26, 18, 28, 24], [5, 4, 8, 8], [4, 26, 48]],
                [[30, 20, 24, 28], [5, 4, 11, 8], [4, 28, 52]],
                [[22, 24, 28, 26], [8, 4, 11, 10], [4, 30, 56]],
                [[22, 26, 22, 24], [9, 4, 16, 12], [4, 32, 60]],
                [[24, 30, 24, 20], [9, 4, 16, 16], [4, 24, 44, 64]],
                [[24, 22, 24, 30], [10, 6, 18, 12], [4, 24, 46, 68]],
                [[28, 24, 30, 24], [10, 6, 16, 17], [4, 24, 48, 72]],
                [[28, 28, 28, 28], [11, 6, 19, 16], [4, 28, 52, 76]],
                [[26, 30, 28, 28], [13, 6, 21, 18], [4, 28, 54, 80]],
                [[26, 28, 26, 26], [14, 7, 25, 21], [4, 28, 56, 84]],
                [[26, 28, 28, 30], [16, 8, 25, 20], [4, 32, 60, 88]],
                [[26, 28, 30, 28], [17, 8, 25, 23], [4, 26, 48, 70, 92]],
                [[28, 28, 24, 30], [17, 9, 34, 23], [4, 24, 48, 72, 96]],
                [[28, 30, 30, 30], [18, 9, 30, 25], [4, 28, 52, 76, 100]],
                [[28, 30, 30, 30], [20, 10, 32, 27], [4, 26, 52, 78, 104]],
                [[28, 26, 30, 30], [21, 12, 35, 29], [4, 30, 56, 82, 108]],
                [[28, 28, 30, 28], [23, 12, 37, 34], [4, 28, 56, 84, 112]],
                [[28, 30, 30, 30], [25, 12, 40, 34], [4, 32, 60, 88, 116]],
                [[28, 30, 30, 30], [26, 13, 42, 35], [4, 24, 48, 72, 96, 120]],
                [[28, 30, 30, 30], [28, 14, 45, 38], [4, 28, 52, 76, 100, 124]],
                [[28, 30, 30, 30], [29, 15, 48, 40], [4, 24, 50, 76, 102, 128]],
                [[28, 30, 30, 30], [31, 16, 51, 43], [4, 28, 54, 80, 106, 132]],
                [[28, 30, 30, 30], [33, 17, 54, 45], [4, 32, 58, 84, 110, 136]],
                [[28, 30, 30, 30], [35, 18, 57, 48], [4, 28, 56, 84, 112, 140]],
                [[28, 30, 30, 30], [37, 19, 60, 51], [4, 32, 60, 88, 116, 144]],
                [[28, 30, 30, 30], [38, 19, 63, 53], [4, 28, 52, 76, 100, 124, 148]],
                [[28, 30, 30, 30], [40, 20, 66, 56], [4, 22, 48, 74, 100, 126, 152]],
                [[28, 30, 30, 30], [43, 21, 70, 59], [4, 26, 52, 78, 104, 130, 156]],
                [[28, 30, 30, 30], [45, 22, 74, 62], [4, 30, 56, 82, 108, 134, 160]],
                [[28, 30, 30, 30], [47, 24, 77, 65], [4, 24, 52, 80, 108, 136, 164]],
                [[28, 30, 30, 30], [49, 25, 81, 68], [4, 28, 56, 84, 112, 140, 168]]
              ], e = 0, s = 1, i = 2, f = 4, h = 8, v = /^\d*$/, p = /^[A-Za-z0-9 $%*+\-./:]*$/, m = /^[A-Z0-9 $%*+\-./:]*$/, x = 1, g = 0, S = 3, y = 2, b = [], n = [-1], w = 0, E = 1; w < 255; ++w)
                b.push(E), n[E] = w, E = E * 2 ^ (E >= 128 ? 285 : 0);
              for (var A = [[]], w = 0; w < 30; ++w) {
                for (var O = A[w], C = [], T = 0; T <= w; ++T) {
                  var P = T < w ? b[O[T]] : 0, I = b[(w + (O[T - 1] || 0)) % 255];
                  C.push(n[P ^ I]);
                }
                A.push(C);
              }
              for (var F = {}, w = 0; w < 45; ++w)
                F["0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:".charAt(w)] = w;
              var B = [
                function(G, D) {
                  return (G + D) % 2 === 0;
                },
                function(G, D) {
                  return G % 2 === 0;
                },
                function(G, D) {
                  return D % 3 === 0;
                },
                function(G, D) {
                  return (G + D) % 3 === 0;
                },
                function(G, D) {
                  return ((G / 2 | 0) + (D / 3 | 0)) % 2 === 0;
                },
                function(G, D) {
                  return G * D % 2 + G * D % 3 === 0;
                },
                function(G, D) {
                  return (G * D % 2 + G * D % 3) % 2 === 0;
                },
                function(G, D) {
                  return ((G + D) % 2 + G * D % 3) % 2 === 0;
                }
              ], M = function(G) {
                return G > 6;
              }, z = function(G) {
                return 4 * G + 17;
              }, L = function(G) {
                var D = l[G], Z = 16 * G * G + 128 * G + 64;
                return M(G) && (Z -= 36), D[2].length && (Z -= 25 * D[2].length * D[2].length - 10 * D[2].length - 55), Z;
              }, J = function(G, D) {
                var Z = L(G) & -8, et = l[G];
                return Z -= 8 * et[0][D] * et[1][D], Z;
              }, ft = function(G, D) {
                switch (D) {
                  case s:
                    return G < 10 ? 10 : G < 27 ? 12 : 14;
                  case i:
                    return G < 10 ? 9 : G < 27 ? 11 : 13;
                  case f:
                    return G < 10 ? 8 : 16;
                  case h:
                    return G < 10 ? 8 : G < 27 ? 10 : 12;
                }
              }, Q = function(G, D, Z) {
                var et = J(G, Z) - 4 - ft(G, D);
                switch (D) {
                  case s:
                    return (et / 10 | 0) * 3 + (et % 10 < 4 ? 0 : et % 10 < 7 ? 1 : 2);
                  case i:
                    return (et / 11 | 0) * 2 + (et % 11 < 6 ? 0 : 1);
                  case f:
                    return et / 8 | 0;
                  case h:
                    return et / 13 | 0;
                }
              }, xt = function(G, D) {
                switch (G) {
                  case s:
                    return D.match(v) ? D : null;
                  case i:
                    return D.match(p) ? D.toUpperCase() : null;
                  case f:
                    if (typeof D == "string") {
                      for (var Z = [], et = 0; et < D.length; ++et) {
                        var vt = D.charCodeAt(et);
                        vt < 128 ? Z.push(vt) : vt < 2048 ? Z.push(
                          192 | vt >> 6,
                          128 | vt & 63
                        ) : vt < 65536 ? Z.push(
                          224 | vt >> 12,
                          128 | vt >> 6 & 63,
                          128 | vt & 63
                        ) : Z.push(
                          240 | vt >> 18,
                          128 | vt >> 12 & 63,
                          128 | vt >> 6 & 63,
                          128 | vt & 63
                        );
                      }
                      return Z;
                    } else
                      return D;
                }
              }, St = function(G, D, Z, et) {
                var vt = [], lt = 0, dt = 8, kt = Z.length, jt = function(Bt, ge) {
                  if (ge >= dt) {
                    for (vt.push(lt | Bt >> (ge -= dt)); ge >= 8; )
                      vt.push(Bt >> (ge -= 8) & 255);
                    lt = 0, dt = 8;
                  }
                  ge > 0 && (lt |= (Bt & (1 << ge) - 1) << (dt -= ge));
                }, me = ft(G, D);
                switch (jt(D, 4), jt(kt, me), D) {
                  case s:
                    for (var se = 2; se < kt; se += 3)
                      jt(parseInt(Z.substring(se - 2, se + 1), 10), 10);
                    jt(parseInt(Z.substring(se - 2), 10), [0, 4, 7][kt % 3]);
                    break;
                  case i:
                    for (var se = 1; se < kt; se += 2)
                      jt(F[Z.charAt(se - 1)] * 45 + F[Z.charAt(se)], 11);
                    kt % 2 == 1 && jt(F[Z.charAt(se - 1)], 6);
                    break;
                  case f:
                    for (var se = 0; se < kt; ++se)
                      jt(Z[se], 8);
                    break;
                }
                for (jt(e, 4), dt < 8 && vt.push(lt); vt.length + 1 < et; )
                  vt.push(236, 17);
                return vt.length < et && vt.push(236), vt;
              }, Pt = function(G, D) {
                for (var Z = G.slice(0), et = G.length, vt = D.length, lt = 0; lt < vt; ++lt)
                  Z.push(0);
                for (var lt = 0; lt < et; ) {
                  var dt = n[Z[lt++]];
                  if (dt >= 0)
                    for (var kt = 0; kt < vt; ++kt)
                      Z[lt + kt] ^= b[(dt + D[kt]) % 255];
                }
                return Z.slice(et);
              }, Gt = function(G, D, Z) {
                for (var et = [], vt = G.length / D | 0, lt = 0, dt = D - G.length % D, kt = 0; kt < dt; ++kt)
                  et.push(lt), lt += vt;
                for (var kt = dt; kt < D; ++kt)
                  et.push(lt), lt += vt + 1;
                et.push(lt);
                for (var jt = [], kt = 0; kt < D; ++kt)
                  jt.push(Pt(G.slice(et[kt], et[kt + 1]), Z));
                for (var me = [], se = G.length / D | 0, kt = 0; kt < se; ++kt)
                  for (var Bt = 0; Bt < D; ++Bt)
                    me.push(G[et[Bt] + kt]);
                for (var Bt = dt; Bt < D; ++Bt)
                  me.push(G[et[Bt + 1] - 1]);
                for (var kt = 0; kt < Z.length; ++kt)
                  for (var Bt = 0; Bt < D; ++Bt)
                    me.push(jt[Bt][kt]);
                return me;
              }, Rt = function(G, D, Z, et) {
                for (var vt = G << et, lt = D - 1; lt >= 0; --lt)
                  vt >> et + lt & 1 && (vt ^= Z << lt);
                return G << et | vt;
              }, bt = function(G) {
                for (var D = l[G], Z = z(G), et = [], vt = [], lt = 0; lt < Z; ++lt)
                  et.push([]), vt.push([]);
                var dt = function(Te, xe, Fe, Zt, qt) {
                  for (var ve = 0; ve < Fe; ++ve)
                    for (var Se = 0; Se < Zt; ++Se)
                      et[Te + ve][xe + Se] = qt[ve] >> Se & 1, vt[Te + ve][xe + Se] = 1;
                };
                dt(0, 0, 9, 9, [127, 65, 93, 93, 93, 65, 383, 0, 64]), dt(Z - 8, 0, 8, 9, [256, 127, 65, 93, 93, 93, 65, 127]), dt(0, Z - 8, 9, 8, [254, 130, 186, 186, 186, 130, 254, 0, 0]);
                for (var lt = 9; lt < Z - 8; ++lt)
                  et[6][lt] = et[lt][6] = ~lt & 1, vt[6][lt] = vt[lt][6] = 1;
                for (var kt = D[2], jt = kt.length, lt = 0; lt < jt; ++lt)
                  for (var me = lt === 0 || lt === jt - 1 ? 1 : 0, se = lt === 0 ? jt - 1 : jt, Bt = me; Bt < se; ++Bt)
                    dt(kt[lt], kt[Bt], 5, 5, [31, 17, 21, 17, 31]);
                if (M(G))
                  for (var ge = Rt(G, 6, 7973, 12), Re = 0, lt = 0; lt < 6; ++lt)
                    for (var Bt = 0; Bt < 3; ++Bt)
                      et[lt][Z - 11 + Bt] = et[Z - 11 + Bt][lt] = ge >> Re++ & 1, vt[lt][Z - 11 + Bt] = vt[Z - 11 + Bt][lt] = 1;
                return { matrix: et, reserved: vt };
              }, Dt = function(G, D, Z) {
                for (var et = G.length, vt = 0, lt = -1, dt = et - 1; dt >= 0; dt -= 2) {
                  dt == 6 && --dt;
                  for (var kt = lt < 0 ? et - 1 : 0, jt = 0; jt < et; ++jt) {
                    for (var me = dt; me > dt - 2; --me)
                      D[kt][me] || (G[kt][me] = Z[vt >> 3] >> (~vt & 7) & 1, ++vt);
                    kt += lt;
                  }
                  lt = -lt;
                }
                return G;
              }, X = function(G, D, Z) {
                for (var et = B[Z], vt = G.length, lt = 0; lt < vt; ++lt)
                  for (var dt = 0; dt < vt; ++dt)
                    D[lt][dt] || (G[lt][dt] ^= et(lt, dt));
                return G;
              }, gt = function(G, D, Z, et) {
                for (var vt = G.length, lt = Rt(Z << 3 | et, 5, 1335, 10) ^ 21522, dt = 0; dt < 15; ++dt) {
                  var kt = [0, 1, 2, 3, 4, 5, 7, 8, vt - 7, vt - 6, vt - 5, vt - 4, vt - 3, vt - 2, vt - 1][dt], jt = [vt - 1, vt - 2, vt - 3, vt - 4, vt - 5, vt - 6, vt - 7, vt - 8, 7, 5, 4, 3, 2, 1, 0][dt];
                  G[kt][8] = G[8][jt] = lt >> dt & 1;
                }
                return G;
              }, st = function(G) {
                for (var D = 3, Z = 3, et = 40, vt = 10, lt = function(Fe) {
                  for (var Zt = 0, qt = 0; qt < Fe.length; ++qt)
                    Fe[qt] >= 5 && (Zt += D + (Fe[qt] - 5));
                  for (var qt = 5; qt < Fe.length; qt += 2) {
                    var ve = Fe[qt];
                    Fe[qt - 1] == ve && Fe[qt - 2] == 3 * ve && Fe[qt - 3] == ve && Fe[qt - 4] == ve && (Fe[qt - 5] >= 4 * ve || Fe[qt + 1] >= 4 * ve) && (Zt += et);
                  }
                  return Zt;
                }, dt = G.length, kt = 0, jt = 0, me = 0; me < dt; ++me) {
                  var se = G[me], Bt;
                  Bt = [0];
                  for (var ge = 0; ge < dt; ) {
                    var Re;
                    for (Re = 0; ge < dt && se[ge]; ++Re)
                      ++ge;
                    for (Bt.push(Re), Re = 0; ge < dt && !se[ge]; ++Re)
                      ++ge;
                    Bt.push(Re);
                  }
                  kt += lt(Bt), Bt = [0];
                  for (var ge = 0; ge < dt; ) {
                    var Re;
                    for (Re = 0; ge < dt && G[ge][me]; ++Re)
                      ++ge;
                    for (Bt.push(Re), Re = 0; ge < dt && !G[ge][me]; ++Re)
                      ++ge;
                    Bt.push(Re);
                  }
                  kt += lt(Bt);
                  var Te = G[me + 1] || [];
                  jt += se[0];
                  for (var ge = 1; ge < dt; ++ge) {
                    var xe = se[ge];
                    jt += xe, se[ge - 1] == xe && Te[ge] === xe && Te[ge - 1] === xe && (kt += Z);
                  }
                }
                return kt += vt * (Math.abs(jt / dt / dt - 0.5) / 0.05 | 0), kt;
              }, rt = function(G, D, Z, et, vt) {
                var lt = l[D], dt = St(D, Z, G, J(D, et) >> 3);
                dt = Gt(dt, lt[1][et], A[lt[0][et]]);
                var kt = bt(D), jt = kt.matrix, me = kt.reserved;
                if (Dt(jt, me, dt), vt < 0) {
                  X(jt, me, 0), gt(jt, me, et, 0);
                  var se = 0, Bt = st(jt);
                  for (X(jt, me, 0), vt = 1; vt < 8; ++vt) {
                    X(jt, me, vt), gt(jt, me, et, vt);
                    var ge = st(jt);
                    Bt > ge && (Bt = ge, se = vt), X(jt, me, vt);
                  }
                  vt = se;
                }
                return X(jt, me, vt), gt(jt, me, et, vt), jt;
              };
              function wt(G, D) {
                var Z = {
                  numeric: s,
                  alphanumeric: i,
                  octet: f
                }, et = {
                  L: x,
                  M: g,
                  Q: S,
                  H: y
                };
                D = D || {};
                var vt = D.version || -1, lt = et[(D.eccLevel || "L").toUpperCase()], dt = D.mode ? Z[D.mode.toLowerCase()] : -1, kt = "mask" in D ? D.mask : -1;
                if (dt < 0)
                  typeof G == "string" ? G.match(v) ? dt = s : G.match(m) ? dt = i : dt = f : dt = f;
                else if (!(dt == s || dt == i || dt == f))
                  throw "invalid or unsupported mode";
                if (G = xt(dt, G), G === null)
                  throw "invalid data format";
                if (lt < 0 || lt > 3)
                  throw "invalid ECC level";
                if (vt < 0) {
                  for (vt = 1; vt <= 40 && !(G.length <= Q(vt, dt, lt)); ++vt)
                    ;
                  if (vt > 40)
                    throw "too large data for the Qr format";
                } else if (vt < 1 || vt > 40)
                  throw "invalid Qr version! should be between 1 and 40";
                if (kt != -1 && (kt < 0 || kt > 8))
                  throw "invalid mask";
                return rt(G, vt, dt, lt, kt);
              }
              function Ft(G, D) {
                var Z = [], et = D.background || "#fff", vt = D.foreground || "#000", lt = D.padding || 0, dt = wt(G, D), kt = dt.length, jt = Math.floor(D.fit ? D.fit / kt : 5), me = kt * jt + jt * lt * 2, se = jt * lt;
                Z.push({
                  type: "rect",
                  x: 0,
                  y: 0,
                  w: me,
                  h: me,
                  lineWidth: 0,
                  color: et
                });
                for (var Bt = 0; Bt < kt; ++Bt)
                  for (var ge = 0; ge < kt; ++ge)
                    dt[Bt][ge] && Z.push({
                      type: "rect",
                      x: jt * ge + se,
                      y: jt * Bt + se,
                      w: jt,
                      h: jt,
                      lineWidth: 0,
                      color: vt
                    });
                return {
                  canvas: Z,
                  size: me
                };
              }
              function zt(G) {
                var D = Ft(G.qr, G);
                return G._canvas = D.canvas, G._width = G._height = G._minWidth = G._maxWidth = G._minHeight = G._maxHeight = D.size, G;
              }
              u.exports = {
                measure: zt
              };
            }
          ),
          /***/
          70098: (
            /***/
            function(u) {
              u.exports = {
                "4A0": [4767.87, 6740.79],
                "2A0": [3370.39, 4767.87],
                A0: [2383.94, 3370.39],
                A1: [1683.78, 2383.94],
                A2: [1190.55, 1683.78],
                A3: [841.89, 1190.55],
                A4: [595.28, 841.89],
                A5: [419.53, 595.28],
                A6: [297.64, 419.53],
                A7: [209.76, 297.64],
                A8: [147.4, 209.76],
                A9: [104.88, 147.4],
                A10: [73.7, 104.88],
                B0: [2834.65, 4008.19],
                B1: [2004.09, 2834.65],
                B2: [1417.32, 2004.09],
                B3: [1000.63, 1417.32],
                B4: [708.66, 1000.63],
                B5: [498.9, 708.66],
                B6: [354.33, 498.9],
                B7: [249.45, 354.33],
                B8: [175.75, 249.45],
                B9: [124.72, 175.75],
                B10: [87.87, 124.72],
                C0: [2599.37, 3676.54],
                C1: [1836.85, 2599.37],
                C2: [1298.27, 1836.85],
                C3: [918.43, 1298.27],
                C4: [649.13, 918.43],
                C5: [459.21, 649.13],
                C6: [323.15, 459.21],
                C7: [229.61, 323.15],
                C8: [161.57, 229.61],
                C9: [113.39, 161.57],
                C10: [79.37, 113.39],
                RA0: [2437.8, 3458.27],
                RA1: [1729.13, 2437.8],
                RA2: [1218.9, 1729.13],
                RA3: [864.57, 1218.9],
                RA4: [609.45, 864.57],
                SRA0: [2551.18, 3628.35],
                SRA1: [1814.17, 2551.18],
                SRA2: [1275.59, 1814.17],
                SRA3: [907.09, 1275.59],
                SRA4: [637.8, 907.09],
                EXECUTIVE: [521.86, 756],
                FOLIO: [612, 936],
                LEGAL: [612, 1008],
                LETTER: [612, 792],
                TABLOID: [792, 1224]
              };
            }
          ),
          /***/
          76442: (
            /***/
            function(u, l, e) {
              var s = e(91867).isString, i = e(91867).isArray, f = e(91867).isUndefined, h = e(91867).isNull;
              function v(p, m) {
                this.defaultStyle = m || {}, this.styleDictionary = p, this.styleOverrides = [];
              }
              v.prototype.clone = function() {
                var p = new v(this.styleDictionary, this.defaultStyle);
                return this.styleOverrides.forEach(function(m) {
                  p.styleOverrides.push(m);
                }), p;
              }, v.prototype.push = function(p) {
                this.styleOverrides.push(p);
              }, v.prototype.pop = function(p) {
                for (p = p || 1; p-- > 0; )
                  this.styleOverrides.pop();
              }, v.prototype.autopush = function(p) {
                if (s(p))
                  return 0;
                var m = [];
                p.style && (i(p.style) ? m = p.style : m = [p.style]);
                for (var x = 0, g = m.length; x < g; x++)
                  this.push(m[x]);
                var S = [
                  "font",
                  "fontSize",
                  "fontFeatures",
                  "bold",
                  "italics",
                  "alignment",
                  "color",
                  "columnGap",
                  "fillColor",
                  "fillOpacity",
                  "decoration",
                  "decorationStyle",
                  "decorationColor",
                  "background",
                  "lineHeight",
                  "characterSpacing",
                  "noWrap",
                  "markerColor",
                  "leadingIndent",
                  "sup",
                  "sub"
                  //'tableCellPadding'
                  // 'cellBorder',
                  // 'headerCellBorder',
                  // 'oddRowCellBorder',
                  // 'evenRowCellBorder',
                  // 'tableBorder'
                ], y = {}, b = !1;
                return S.forEach(function(n) {
                  !f(p[n]) && !h(p[n]) && (y[n] = p[n], b = !0);
                }), b && this.push(y), m.length + (b ? 1 : 0);
              }, v.prototype.auto = function(p, m) {
                var x = this.autopush(p), g = m();
                return x > 0 && this.pop(x), g;
              }, v.prototype.getProperty = function(p) {
                if (this.styleOverrides)
                  for (var m = this.styleOverrides.length - 1; m >= 0; m--) {
                    var x = this.styleOverrides[m];
                    if (s(x)) {
                      var g = this.styleDictionary[x];
                      if (g && !f(g[p]) && !h(g[p]))
                        return g[p];
                    } else if (!f(x[p]) && !h(x[p]))
                      return x[p];
                  }
                return this.defaultStyle && this.defaultStyle[p];
              }, u.exports = v;
            }
          ),
          /***/
          89638: (
            /***/
            function(u, l, e) {
              var s = e(52242);
              function i(v) {
                var p = parseFloat(v);
                if (!(typeof p != "number" || isNaN(p)))
                  return p;
              }
              function f(v) {
                var p;
                try {
                  p = new s.XmlDocument(v);
                } catch (m) {
                  throw new Error("SVGMeasure: " + m);
                }
                if (p.name !== "svg")
                  throw new Error("SVGMeasure: expected <svg> document");
                return p;
              }
              function h() {
              }
              h.prototype.measureSVG = function(v) {
                var p = f(v), m = i(p.attr.width), x = i(p.attr.height);
                if ((m == null || x == null) && typeof p.attr.viewBox == "string") {
                  var g = p.attr.viewBox.split(/[,\s]+/);
                  if (g.length !== 4)
                    throw new Error("Unexpected svg viewbox format, should have 4 entries but found: '" + p.attr.viewBox + "'");
                  m == null && (m = i(g[2])), x == null && (x = i(g[3]));
                }
                return {
                  width: m,
                  height: x
                };
              }, h.prototype.writeDimensions = function(v, p) {
                var m = f(v);
                return m.attr.width = "" + p.width, m.attr.height = "" + p.height, m.toString();
              }, u.exports = h;
            }
          ),
          /***/
          89836: (
            /***/
            function(u, l, e) {
              var s = e(77530), i = e(91867).isFunction, f = e(91867).isNumber;
              function h(v) {
                this.tableNode = v;
              }
              h.prototype.beginTable = function(v) {
                var p, m, x = this;
                if (p = this.tableNode, this.offsets = p._offsets, this.layout = p._layout, m = v.context().availableWidth - this.offsets.total, s.buildColumnWidths(p.table.widths, m), this.tableWidth = p._offsets.total + g(), this.rowSpanData = S(), this.cleanUpRepeatables = !1, this.headerRows = p.table.headerRows || 0, this.headerRows > p.table.body.length)
                  throw new Error(`Too few rows in the table. Property headerRows requires at least ${this.headerRows}, contains only ${p.table.body.length}`);
                this.rowsWithoutPageBreak = this.headerRows + (p.table.keepWithHeaderRows || 0), this.dontBreakRows = p.table.dontBreakRows || !1, this.rowsWithoutPageBreak && v.beginUnbreakableBlock(), y(this.tableNode.table.body), this.drawHorizontalLine(0, v);
                function g() {
                  var b = 0;
                  return p.table.widths.forEach(function(n) {
                    b += n._calcWidth;
                  }), b;
                }
                function S() {
                  var b = [], n = 0, w = 0;
                  b.push({ left: 0, rowSpan: 0 });
                  for (var E = 0, A = x.tableNode.table.body[0].length; E < A; E++) {
                    var O = x.layout.paddingLeft(E, x.tableNode) + x.layout.paddingRight(E, x.tableNode), C = x.layout.vLineWidth(E, x.tableNode);
                    w = O + C + x.tableNode.table.widths[E]._calcWidth, b[b.length - 1].width = w, n += w, b.push({ left: n, rowSpan: 0, width: 0 });
                  }
                  return b;
                }
                function y(b) {
                  for (var n = 0; n < b.length; n++)
                    for (var w = b[n], E = 0; E < w.length; E++) {
                      var A = w[E];
                      if (A.border) {
                        for (var O = A.rowSpan || 1, C = A.colSpan || 1, T = 0; T < O; T++)
                          A.border[0] !== void 0 && T > 0 && I(n + T, E, 0, A.border[0]), A.border[2] !== void 0 && I(n + T, E + C - 1, 2, A.border[2]);
                        for (var P = 0; P < C; P++)
                          A.border[1] !== void 0 && P > 0 && I(n, E + P, 1, A.border[1]), A.border[3] !== void 0 && I(n + O - 1, E + P, 3, A.border[3]);
                      }
                    }
                  function I(F, B, M, z) {
                    var L = b[F][B];
                    L.border = L.border || {}, L.border[M] = z;
                  }
                }
              }, h.prototype.onRowBreak = function(v, p) {
                var m = this;
                return function() {
                  var x = m.rowPaddingTop + (m.headerRows ? 0 : m.topLineWidth);
                  p.context().availableHeight -= m.reservedAtBottom, p.context().moveDown(x);
                };
              }, h.prototype.beginRow = function(v, p) {
                this.topLineWidth = this.layout.hLineWidth(v, this.tableNode), this.rowPaddingTop = this.layout.paddingTop(v, this.tableNode), this.bottomLineWidth = this.layout.hLineWidth(v + 1, this.tableNode), this.rowPaddingBottom = this.layout.paddingBottom(v, this.tableNode), this.rowCallback = this.onRowBreak(v, p), p.tracker.startTracking("pageChanged", this.rowCallback), this.dontBreakRows && p.beginUnbreakableBlock(), this.rowTopY = p.context().y, this.reservedAtBottom = this.bottomLineWidth + this.rowPaddingBottom, p.context().availableHeight -= this.reservedAtBottom, p.context().moveDown(this.rowPaddingTop);
              }, h.prototype.drawHorizontalLine = function(v, p, m) {
                var x = this.layout.hLineWidth(v, this.tableNode);
                if (x) {
                  var g = this.layout.hLineStyle(v, this.tableNode), S;
                  g && g.dash && (S = g.dash);
                  for (var y = x / 2, b = null, n = this.tableNode.table.body, w, E, A, O = 0, C = this.rowSpanData.length; O < C; O++) {
                    var T = this.rowSpanData[O], P = !T.rowSpan, I = null;
                    if (P && O < C - 1) {
                      var F = !1, B = !1, M = !1;
                      v > 0 && (w = n[v - 1][O], B = w.border ? w.border[3] : this.layout.defaultBorder, B && w.borderColor && (I = w.borderColor[3])), v < n.length && (E = n[v][O], F = E.border ? E.border[1] : this.layout.defaultBorder, F && I == null && E.borderColor && (I = E.borderColor[1])), P = F || B;
                    }
                    if (w && w._rowSpanCurrentOffset && (A = n[v - 1 - w._rowSpanCurrentOffset][O], M = A && A.border ? A.border[3] : this.layout.defaultBorder, M && A && A.borderColor && (I = A.borderColor[3])), I == null && (I = i(this.layout.hLineColor) ? this.layout.hLineColor(v, this.tableNode, O) : this.layout.hLineColor), !b && P && (b = { left: T.left, width: 0 }), P) {
                      var z = 0;
                      if (A && A.colSpan && M) {
                        for (; A.colSpan > z; )
                          b.width += this.rowSpanData[O + z++].width || 0;
                        O += z - 1;
                      } else if (w && w.colSpan && B) {
                        for (; w.colSpan > z; )
                          b.width += this.rowSpanData[O + z++].width || 0;
                        O += z - 1;
                      } else if (E && E.colSpan && F) {
                        for (; E.colSpan > z; )
                          b.width += this.rowSpanData[O + z++].width || 0;
                        O += z - 1;
                      } else
                        b.width += this.rowSpanData[O].width || 0;
                    }
                    var L = (m || 0) + y;
                    P && b && b.width && (p.addVector({
                      type: "line",
                      x1: b.left,
                      x2: b.left + b.width,
                      y1: L,
                      y2: L,
                      lineWidth: x,
                      dash: S,
                      lineColor: I
                    }, !1, m), b = null, I = null, w = null, E = null, A = null);
                  }
                  p.context().moveDown(x);
                }
              }, h.prototype.drawVerticalLine = function(v, p, m, x, g, S, y) {
                var b = this.layout.vLineWidth(x, this.tableNode);
                if (b !== 0) {
                  var n = this.layout.vLineStyle(x, this.tableNode), w;
                  n && n.dash && (w = n.dash);
                  var E = this.tableNode.table.body, A, O, C;
                  if (x > 0 && (A = E[S][y], A && A.borderColor && (A.border ? A.border[2] : this.layout.defaultBorder) && (C = A.borderColor[2])), C == null && x < E.length && (O = E[S][x], O && O.borderColor && (O.border ? O.border[0] : this.layout.defaultBorder) && (C = O.borderColor[0])), C == null && A && A._rowSpanCurrentOffset) {
                    var T = E[S - A._rowSpanCurrentOffset][y];
                    T.borderColor && (T.border ? T.border[2] : this.layout.defaultBorder) && (C = T.borderColor[2]);
                  }
                  if (C == null && O && O._rowSpanCurrentOffset) {
                    var P = E[S - O._rowSpanCurrentOffset][x];
                    P.borderColor && (P.border ? P.border[2] : this.layout.defaultBorder) && (C = P.borderColor[2]);
                  }
                  C == null && (C = i(this.layout.vLineColor) ? this.layout.vLineColor(x, this.tableNode, S) : this.layout.vLineColor), g.addVector({
                    type: "line",
                    x1: v + b / 2,
                    x2: v + b / 2,
                    y1: p,
                    y2: m,
                    lineWidth: b,
                    dash: w,
                    lineColor: C
                  }, !1, !0), A = null, O = null, C = null;
                }
              }, h.prototype.endTable = function(v) {
                this.cleanUpRepeatables && v.popFromRepeatables();
              }, h.prototype.endRow = function(v, p, m) {
                var x, g, S = this;
                p.tracker.stopTracking("pageChanged", this.rowCallback), p.context().moveDown(this.layout.paddingBottom(v, this.tableNode)), p.context().availableHeight += this.reservedAtBottom;
                var y = p.context().page, b = p.context().y, n = G(), w = [], E = m && m.length > 0, A = this.tableNode.table.body;
                if (w.push({
                  y0: this.rowTopY,
                  page: E ? m[0].prevPage : y
                }), E)
                  for (g = 0, x = m.length; g < x; g++) {
                    var O = m[g];
                    w[w.length - 1].y1 = O.prevY, w.push({ y0: O.y, page: O.prevPage + 1 });
                  }
                w[w.length - 1].y1 = b;
                for (var C = w[0].y1 - w[0].y0 === this.rowPaddingTop, T = C ? 1 : 0, P = w.length; T < P; T++) {
                  var I = T < w.length - 1, F = T > 0 && !this.headerRows, B = F ? 0 : this.topLineWidth, M = w[T].y0, z = w[T].y1;
                  for (I && (z = z + this.rowPaddingBottom), p.context().page != w[T].page && (p.context().page = w[T].page, this.reservedAtBottom = 0), g = 0, x = n.length; g < x; g++) {
                    var L = !1, J = !1, ft = n[g].index;
                    if (ft < A[v].length) {
                      var Q = A[v][ft];
                      L = Q.border ? Q.border[0] : this.layout.defaultBorder, J = Q.border ? Q.border[2] : this.layout.defaultBorder;
                    }
                    if (ft > 0 && !L) {
                      var Q = A[v][ft - 1];
                      L = Q.border ? Q.border[2] : this.layout.defaultBorder;
                    }
                    if (ft + 1 < A[v].length && !J) {
                      var Q = A[v][ft + 1];
                      J = Q.border ? Q.border[0] : this.layout.defaultBorder;
                    }
                    if (L && this.drawVerticalLine(n[g].x, M - B, z + this.bottomLineWidth, n[g].index, p, v, n[g - 1] ? n[g - 1].index : null), g < x - 1) {
                      var xt = A[v][ft].fillColor, St = A[v][ft].fillOpacity;
                      xt || (xt = i(this.layout.fillColor) ? this.layout.fillColor(v, this.tableNode, ft) : this.layout.fillColor), f(St) || (St = i(this.layout.fillOpacity) ? this.layout.fillOpacity(v, this.tableNode, ft) : this.layout.fillOpacity);
                      var Pt = A[v][ft].overlayPattern, Gt = A[v][ft].overlayOpacity;
                      if (xt || Pt) {
                        var Rt = L ? this.layout.vLineWidth(ft, this.tableNode) : 0, bt;
                        (ft === 0 || ft + 1 == A[v].length) && !J ? bt = this.layout.vLineWidth(ft + 1, this.tableNode) : J ? bt = this.layout.vLineWidth(ft + 1, this.tableNode) / 2 : bt = 0;
                        var Dt = this.dontBreakRows ? n[g].x + Rt : n[g].x + Rt / 2, X = this.dontBreakRows ? M : M - B / 2, gt = n[g + 1].x + bt, st = this.dontBreakRows ? z + this.bottomLineWidth : z + this.bottomLineWidth / 2, rt = gt - Dt, wt = st - X;
                        xt && p.addVector({
                          type: "rect",
                          x: Dt,
                          y: X,
                          w: rt,
                          h: wt,
                          lineWidth: 0,
                          color: xt,
                          fillOpacity: St
                        }, !1, !0, p.context().backgroundLength[p.context().page]), Pt && p.addVector({
                          type: "rect",
                          x: Dt,
                          y: X,
                          w: rt,
                          h: wt,
                          lineWidth: 0,
                          color: Pt,
                          fillOpacity: Gt
                        }, !1, !0);
                      }
                    }
                  }
                  I && this.layout.hLineWhenBroken !== !1 && this.drawHorizontalLine(v + 1, p, z), F && this.layout.hLineWhenBroken !== !1 && this.drawHorizontalLine(v, p, M);
                }
                p.context().page = y, p.context().y = b;
                var Ft = this.tableNode.table.body[v];
                for (g = 0, x = Ft.length; g < x; g++) {
                  if (Ft[g].rowSpan) {
                    if (this.rowSpanData[g].rowSpan = Ft[g].rowSpan, Ft[g].colSpan && Ft[g].colSpan > 1)
                      for (var zt = 1; zt < Ft[g].rowSpan; zt++)
                        this.tableNode.table.body[v + zt][g]._colSpan = Ft[g].colSpan;
                    if (Ft[g].rowSpan && Ft[g].rowSpan > 1)
                      for (var zt = 1; zt < Ft[g].rowSpan; zt++)
                        this.tableNode.table.body[v + zt][g]._rowSpanCurrentOffset = zt;
                  }
                  this.rowSpanData[g].rowSpan > 0 && this.rowSpanData[g].rowSpan--;
                }
                this.drawHorizontalLine(v + 1, p), this.headerRows && v === this.headerRows - 1 && (this.headerRepeatable = p.currentBlockToRepeatable()), this.dontBreakRows && p.tracker.auto(
                  "pageChanged",
                  function() {
                    !S.headerRows && S.layout.hLineWhenBroken !== !1 && S.drawHorizontalLine(v, p);
                  },
                  function() {
                    p.commitUnbreakableBlock();
                  }
                ), this.headerRepeatable && (v === this.rowsWithoutPageBreak - 1 || v === this.tableNode.table.body.length - 1) && (p.commitUnbreakableBlock(), p.pushToRepeatables(this.headerRepeatable), this.cleanUpRepeatables = !0, this.headerRepeatable = null);
                function G() {
                  for (var D = [], Z = 0, et = 0, vt = S.tableNode.table.body[v].length; et < vt; et++) {
                    if (!Z) {
                      D.push({ x: S.rowSpanData[et].left, index: et });
                      var lt = S.tableNode.table.body[v][et];
                      Z = lt._colSpan || lt.colSpan || 0;
                    }
                    Z > 0 && Z--;
                  }
                  return D.push({ x: S.rowSpanData[S.rowSpanData.length - 1].left, index: S.rowSpanData.length - 1 }), D;
                }
              }, u.exports = h;
            }
          ),
          /***/
          84786: (
            /***/
            function(u, l, e) {
              var s = e(91867).isArray, i = e(91867).isPattern, f = e(91867).getPattern;
              function h(x) {
                for (var g = [], S = null, y = 0, b = x.inlines.length; y < b; y++) {
                  var n = x.inlines[y], w = n.decoration;
                  if (!w) {
                    S = null;
                    continue;
                  }
                  s(w) || (w = [w]);
                  for (var E = n.decorationColor || n.color || "black", A = n.decorationStyle || "solid", O = 0, C = w.length; O < C; O++) {
                    var T = w[O];
                    !S || T !== S.decoration || A !== S.decorationStyle || E !== S.decorationColor ? (S = {
                      line: x,
                      decoration: T,
                      decorationColor: E,
                      decorationStyle: A,
                      inlines: [n]
                    }, g.push(S)) : S.inlines.push(n);
                  }
                }
                return g;
              }
              function v(x, g, S, y) {
                function b() {
                  for (var Rt = 0, bt = 0, Dt = x.inlines.length; bt < Dt; bt++) {
                    var X = x.inlines[bt];
                    Rt = X.fontSize > Rt ? bt : Rt;
                  }
                  return x.inlines[Rt];
                }
                function n() {
                  for (var Rt = 0, bt = 0, Dt = x.inlines.length; bt < Dt; bt++) {
                    var X = x.inlines[bt].justifyShift || 0;
                    Rt += x.inlines[bt].width + X;
                  }
                  return Rt;
                }
                var w = x.inlines[0], E = b(), A = n(), O = x.line.getAscenderHeight(), C = E.font.ascender / 1e3 * E.fontSize, T = E.height, P = T - C, I = 0.5 + Math.floor(Math.max(E.fontSize - 8, 0) / 2) * 0.12;
                switch (x.decoration) {
                  case "underline":
                    S += O + P * 0.45;
                    break;
                  case "overline":
                    S += O - C * 0.85;
                    break;
                  case "lineThrough":
                    S += O - C * 0.25;
                    break;
                  default:
                    throw "Unknown decoration : " + x.decoration;
                }
                if (y.save(), x.decorationStyle === "double") {
                  var F = Math.max(0.5, I * 2);
                  y.fillColor(x.decorationColor).rect(g + w.x, S - I / 2, A, I / 2).fill().rect(g + w.x, S + F - I / 2, A, I / 2).fill();
                } else if (x.decorationStyle === "dashed") {
                  var B = Math.ceil(A / 6.8), M = g + w.x;
                  y.rect(M, S, A, I).clip(), y.fillColor(x.decorationColor);
                  for (var z = 0; z < B; z++)
                    y.rect(M, S - I / 2, 3.96, I).fill(), M += 6.8;
                } else if (x.decorationStyle === "dotted") {
                  var L = Math.ceil(A / (I * 3)), J = g + w.x;
                  y.rect(J, S, A, I).clip(), y.fillColor(x.decorationColor);
                  for (var ft = 0; ft < L; ft++)
                    y.rect(J, S - I / 2, I, I).fill(), J += I * 3;
                } else if (x.decorationStyle === "wavy") {
                  var Q = 0.7, xt = 1, St = Math.ceil(A / (Q * 2)) + 1, Pt = g + w.x - 1;
                  y.rect(g + w.x, S - xt, A, S + xt).clip(), y.lineWidth(0.24), y.moveTo(Pt, S);
                  for (var Gt = 0; Gt < St; Gt++)
                    y.bezierCurveTo(Pt + Q, S - xt, Pt + Q * 2, S - xt, Pt + Q * 3, S).bezierCurveTo(Pt + Q * 4, S + xt, Pt + Q * 5, S + xt, Pt + Q * 6, S), Pt += Q * 6;
                  y.stroke(x.decorationColor);
                } else
                  y.fillColor(x.decorationColor).rect(g + w.x, S - I / 2, A, I).fill();
                y.restore();
              }
              function p(x, g, S, y) {
                for (var b = h(x), n = 0, w = b.length; n < w; n++)
                  v(b[n], g, S, y);
              }
              function m(x, g, S, y, b) {
                for (var n = x.getHeight(), w = 0, E = x.inlines.length; w < E; w++) {
                  var A = x.inlines[w];
                  if (A.background) {
                    var O = A.background;
                    i(A.background) && (O = f(A.background, y));
                    var C = A.justifyShift || 0;
                    b.fillColor(O).rect(g + A.x - C, S, A.width + C, n).fill();
                  }
                }
              }
              u.exports = {
                drawBackground: m,
                drawDecorations: p
              };
            }
          ),
          /***/
          11548: (
            /***/
            function(u, l, e) {
              var s = e(91867).isString, i = e(91867).isNumber, f = e(91867).isObject, h = e(91867).isArray, v = e(91867).isUndefined, p = e(19304), m = /^(\s)+/g, x = /(\s)+$/g;
              function g(O) {
                this.fontProvider = O;
              }
              g.prototype.buildInlines = function(O, C) {
                var T = E(this.fontProvider, O, C), P = 0, I = 0, F;
                return T.forEach(function(M) {
                  P = Math.max(P, M.width - M.leadingCut - M.trailingCut), F || (F = { width: 0, leadingCut: M.leadingCut, trailingCut: 0 }), F.width += M.width, F.trailingCut = M.trailingCut, I = Math.max(I, B(F)), M.lineEnd && (F = null);
                }), w({}, C, "noWrap", !1) && (P = I), {
                  items: T,
                  minWidth: P,
                  maxWidth: I
                };
                function B(M) {
                  return Math.max(0, M.width - M.leadingCut - M.trailingCut);
                }
              }, g.prototype.sizeOfString = function(O, C) {
                O = O ? O.toString().replace(/\t/g, "    ") : "";
                var T = w({}, C, "font", "Roboto"), P = w({}, C, "fontSize", 12), I = w({}, C, "fontFeatures", null), F = w({}, C, "bold", !1), B = w({}, C, "italics", !1), M = w({}, C, "lineHeight", 1), z = w({}, C, "characterSpacing", 0), L = this.fontProvider.provideFont(T, F, B);
                return {
                  width: A(O, L, P, z, I),
                  height: L.lineHeight(P) * M,
                  fontSize: P,
                  lineHeight: M,
                  ascender: L.ascender / 1e3 * P,
                  descender: L.descender / 1e3 * P
                };
              }, g.prototype.sizeOfRotatedText = function(O, C, T) {
                var P = C * Math.PI / -180, I = this.sizeOfString(O, T);
                return {
                  width: Math.abs(I.height * Math.sin(P)) + Math.abs(I.width * Math.cos(P)),
                  height: Math.abs(I.width * Math.sin(P)) + Math.abs(I.height * Math.cos(P))
                };
              }, g.prototype.widthOfString = function(O, C, T, P, I) {
                return A(O, C, T, P, I);
              };
              function S(O, C) {
                var T = [];
                if (O = O.replace(/\t/g, "    "), C)
                  return T.push({ text: O }), T;
                for (var P = new p(O), I = 0, F; F = P.nextBreak(); ) {
                  var B = O.slice(I, F.position);
                  F.required || B.match(/\r?\n$|\r$/) ? (B = B.replace(/\r?\n$|\r$/, ""), T.push({ text: B, lineEnd: !0 })) : T.push({ text: B }), I = F.position;
                }
                return T;
              }
              function y(O, C) {
                C = C || {}, O = O || {};
                for (var T in O)
                  T != "text" && O.hasOwnProperty(T) && (C[T] = O[T]);
                return C;
              }
              function b(O, C) {
                function T(Rt) {
                  return Rt.reduce(function(bt, Dt) {
                    var X = h(Dt.text) ? T(Dt.text) : Dt, gt = [].concat(X).some(Array.isArray);
                    return bt.concat(gt ? T(X) : X);
                  }, []);
                }
                function P(Rt, bt, Dt) {
                  if (v(bt[Rt]) || bt[Rt].lineEnd)
                    return null;
                  var X = bt[Rt].text;
                  if (Dt) {
                    var gt = S(n(X), !1);
                    if (v(gt[gt.length - 1]))
                      return null;
                    X = gt[gt.length - 1].text;
                  }
                  return X;
                }
                var I = [];
                h(O) || (O = [O]), O = T(O);
                for (var F = null, B = 0, M = O.length; B < M; B++) {
                  var z = O[B], L = null, J, ft = w(z || {}, C, "noWrap", !1);
                  if (f(z) ? (z._textRef && z._textRef._textNodeRef.text && (z.text = z._textRef._textNodeRef.text), J = S(n(z.text), ft), L = y(z)) : J = S(n(z), ft), F && J.length) {
                    var Q = P(0, J, ft), xt = S(n(F + Q), !1);
                    xt.length === 1 && (I[I.length - 1].noNewLine = !0);
                  }
                  for (var St = 0, Pt = J.length; St < Pt; St++) {
                    var Gt = {
                      text: J[St].text
                    };
                    J[St].lineEnd && (Gt.lineEnd = !0), y(L, Gt), I.push(Gt);
                  }
                  F = null, B + 1 < M && (F = P(J.length - 1, J, ft));
                }
                return I;
              }
              function n(O) {
                return O == null ? "" : i(O) ? O.toString() : s(O) ? O : O.toString();
              }
              function w(O, C, T, P) {
                var I;
                return O[T] !== void 0 && O[T] !== null ? O[T] : C ? (C.auto(O, function() {
                  I = C.getProperty(T);
                }), I ?? P) : P;
              }
              function E(O, C, T) {
                var P = b(C, T);
                if (P.length) {
                  var I = w(P[0], T, "leadingIndent", 0);
                  I && (P[0].leadingCut = -I, P[0].leadingIndent = I);
                }
                return P.forEach(function(F) {
                  var B = w(F, T, "font", "Roboto"), M = w(F, T, "fontSize", 12), z = w(F, T, "fontFeatures", null), L = w(F, T, "bold", !1), J = w(F, T, "italics", !1), ft = w(F, T, "color", "black"), Q = w(F, T, "decoration", null), xt = w(F, T, "decorationColor", null), St = w(F, T, "decorationStyle", null), Pt = w(F, T, "background", null), Gt = w(F, T, "lineHeight", 1), Rt = w(F, T, "characterSpacing", 0), bt = w(F, T, "link", null), Dt = w(F, T, "linkToPage", null), X = w(F, T, "linkToDestination", null), gt = w(F, T, "noWrap", null), st = w(F, T, "preserveLeadingSpaces", !1), rt = w(F, T, "preserveTrailingSpaces", !1), wt = w(F, T, "opacity", 1), Ft = w(F, T, "sup", !1), zt = w(F, T, "sub", !1);
                  (Ft || zt) && F.fontSize === void 0 && (M *= 0.58);
                  var G = O.provideFont(B, L, J);
                  F.width = A(F.text, G, M, Rt, z), F.height = G.lineHeight(M) * Gt, F.leadingCut || (F.leadingCut = 0);
                  var D;
                  !st && (D = F.text.match(m)) && (F.leadingCut += A(D[0], G, M, Rt, z));
                  var Z;
                  !rt && (Z = F.text.match(x)) ? F.trailingCut = A(Z[0], G, M, Rt, z) : F.trailingCut = 0, F.alignment = w(F, T, "alignment", "left"), F.font = G, F.fontSize = M, F.fontFeatures = z, F.characterSpacing = Rt, F.color = ft, F.decoration = Q, F.decorationColor = xt, F.decorationStyle = St, F.background = Pt, F.link = bt, F.linkToPage = Dt, F.linkToDestination = X, F.noWrap = gt, F.opacity = wt, F.sup = Ft, F.sub = zt;
                }), P;
              }
              function A(O, C, T, P, I) {
                return C.widthOfString(O, T, I) + (P || 0) * (O.length - 1);
              }
              u.exports = g;
            }
          ),
          /***/
          2318: (
            /***/
            function(u) {
              function l() {
                this.events = {};
              }
              l.prototype.startTracking = function(e, s) {
                var i = this.events[e] || (this.events[e] = []);
                i.indexOf(s) < 0 && i.push(s);
              }, l.prototype.stopTracking = function(e, s) {
                var i = this.events[e];
                if (i) {
                  var f = i.indexOf(s);
                  f >= 0 && i.splice(f, 1);
                }
              }, l.prototype.emit = function(e) {
                var s = Array.prototype.slice.call(arguments, 1), i = this.events[e];
                i && i.forEach(function(f) {
                  f.apply(this, s);
                });
              }, l.prototype.auto = function(e, s, i) {
                this.startTracking(e, s), i(), this.stopTracking(e, s);
              }, u.exports = l;
            }
          ),
          /***/
          44134: (
            /***/
            function(u, l, e) {
              var s, i, f;
              (function(h, v) {
                i = [], s = v, f = typeof s == "function" ? s.apply(l, i) : s, f !== void 0 && (u.exports = f);
              })(this, function() {
                function h(y, b) {
                  return typeof b > "u" ? b = { autoBom: !1 } : typeof b != "object" && (console.warn("Deprecated: Expected third argument to be a object"), b = { autoBom: !b }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(y.type) ? new Blob(["\uFEFF", y], { type: y.type }) : y;
                }
                function v(y, b, n) {
                  var w = new XMLHttpRequest();
                  w.open("GET", y), w.responseType = "blob", w.onload = function() {
                    S(w.response, b, n);
                  }, w.onerror = function() {
                    console.error("could not download file");
                  }, w.send();
                }
                function p(y) {
                  var b = new XMLHttpRequest();
                  b.open("HEAD", y, !1);
                  try {
                    b.send();
                  } catch {
                  }
                  return 200 <= b.status && 299 >= b.status;
                }
                function m(y) {
                  try {
                    y.dispatchEvent(new MouseEvent("click"));
                  } catch {
                    var b = document.createEvent("MouseEvents");
                    b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), y.dispatchEvent(b);
                  }
                }
                var x = typeof window == "object" && window.window === window ? window : typeof self == "object" && self.self === self ? self : typeof e.g == "object" && e.g.global === e.g ? e.g : void 0, g = x.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), S = x.saveAs || (typeof window != "object" || window !== x ? function() {
                } : typeof HTMLAnchorElement < "u" && "download" in HTMLAnchorElement.prototype && !g ? function(y, b, n) {
                  var w = x.URL || x.webkitURL, E = document.createElement("a");
                  b = b || y.name || "download", E.download = b, E.rel = "noopener", typeof y == "string" ? (E.href = y, E.origin === location.origin ? m(E) : p(E.href) ? v(y, b, n) : m(E, E.target = "_blank")) : (E.href = w.createObjectURL(y), setTimeout(function() {
                    w.revokeObjectURL(E.href);
                  }, 4e4), setTimeout(function() {
                    m(E);
                  }, 0));
                } : "msSaveOrOpenBlob" in navigator ? function(y, b, n) {
                  if (b = b || y.name || "download", typeof y != "string")
                    navigator.msSaveOrOpenBlob(h(y, n), b);
                  else if (p(y))
                    v(y, b, n);
                  else {
                    var w = document.createElement("a");
                    w.href = y, w.target = "_blank", setTimeout(function() {
                      m(w);
                    });
                  }
                } : function(y, b, n, w) {
                  if (w = w || open("", "_blank"), w && (w.document.title = w.document.body.innerText = "downloading..."), typeof y == "string")
                    return v(y, b, n);
                  var E = y.type === "application/octet-stream", A = /constructor/i.test(x.HTMLElement) || x.safari, O = /CriOS\/[\d]+/.test(navigator.userAgent);
                  if ((O || E && A || g) && typeof FileReader < "u") {
                    var C = new FileReader();
                    C.onloadend = function() {
                      var I = C.result;
                      I = O ? I : I.replace(/^data:[^;]*;/, "data:attachment/file;"), w ? w.location.href = I : location = I, w = null;
                    }, C.readAsDataURL(y);
                  } else {
                    var T = x.URL || x.webkitURL, P = T.createObjectURL(y);
                    w ? w.location = P : location.href = P, w = null, setTimeout(function() {
                      T.revokeObjectURL(P);
                    }, 4e4);
                  }
                });
                x.saveAs = S.saveAs = S, u.exports = S;
              });
            }
          ),
          /***/
          60421: (
            /***/
            function(u, l, e) {
              var s = e(50621).Buffer;
              e(65292), e(73844), e(69330), e(5597), e(7585), e(39081), e(41584), e(11765), e(81755), e(94845), e(80055), e(20731), e(45337), e(23913), e(24863), e(18828), e(7283), e(58549), e(18756), e(75174), e(57444), e(37309), e(14032), e(68067), e(61726), e(74516), e(57114), e(76014), e(65578), e(58281), e(6422), e(28264), e(72095), e(75626), e(47969), e(73663), e(29883), e(35471), e(21012), e(88997), e(97464), e(2857), e(94715), e(13624), e(91132), e(62514), e(24597), e(88042), e(4660), e(92451), e(44206), e(66288), e(13250), e(3858), e(84538), e(64793), e(74202), e(52529), e(42437), e(94712);
              var i;
              function f(at, W) {
                for (var $ = 0; $ < W.length; $++) {
                  var R = W[$];
                  R.enumerable = R.enumerable || !1, R.configurable = !0, "value" in R && (R.writable = !0), Object.defineProperty(at, v(R.key), R);
                }
              }
              function h(at, W, $) {
                return W && f(at.prototype, W), $ && f(at, $), Object.defineProperty(at, "prototype", { writable: !1 }), at;
              }
              function v(at) {
                var W = p(at, "string");
                return typeof W == "symbol" ? W : String(W);
              }
              function p(at, W) {
                if (typeof at != "object" || !at)
                  return at;
                var $ = at[Symbol.toPrimitive];
                if ($ !== void 0) {
                  var R = $.call(at, W || "default");
                  if (typeof R != "object")
                    return R;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (W === "string" ? String : Number)(at);
              }
              function m(at, W) {
                at.prototype = Object.create(W.prototype), at.prototype.constructor = at, x(at, W);
              }
              function x(at, W) {
                return x = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(R, k) {
                  return R.__proto__ = k, R;
                }, x(at, W);
              }
              function g(at, W) {
                var $ = typeof Symbol < "u" && at[Symbol.iterator] || at["@@iterator"];
                if ($)
                  return ($ = $.call(at)).next.bind($);
                if (Array.isArray(at) || ($ = S(at)) || W && at && typeof at.length == "number") {
                  $ && (at = $);
                  var R = 0;
                  return function() {
                    return R >= at.length ? { done: !0 } : { done: !1, value: at[R++] };
                  };
                }
                throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }
              function S(at, W) {
                if (at) {
                  if (typeof at == "string")
                    return y(at, W);
                  var $ = Object.prototype.toString.call(at).slice(8, -1);
                  if ($ === "Object" && at.constructor && ($ = at.constructor.name), $ === "Map" || $ === "Set")
                    return Array.from(at);
                  if ($ === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test($))
                    return y(at, W);
                }
              }
              function y(at, W) {
                (W == null || W > at.length) && (W = at.length);
                for (var $ = 0, R = new Array(W); $ < W; $++)
                  R[$] = at[$];
                return R;
              }
              function b(at) {
                return at && typeof at == "object" && "default" in at ? at.default : at;
              }
              var n = b(e(57013)), w = e(76949), E = b(e(45728)), A = b(e(24766)), O = b(e(41209)), C = b(e(91836)), T = b(e(41613)), P = b(e(3483)), I = b(e(34460)), F = e(48181), B = {};
              B.logErrors = !1;
              var M = [];
              B.registerFormat = function(at) {
                M.push(at);
              }, B.openSync = function(at, W) {
                var $ = F.readFileSync(at);
                return B.create($, W);
              }, B.open = function(at, W, $) {
                typeof W == "function" && ($ = W, W = null), F.readFile(at, function(R, k) {
                  if (R)
                    return $(R);
                  try {
                    var H = B.create(k, W);
                  } catch (ot) {
                    return $(ot);
                  }
                  return $(null, H);
                });
              }, B.create = function(at, W) {
                for (var $ = 0; $ < M.length; $++) {
                  var R = M[$];
                  if (R.probe(at)) {
                    var k = new R(new n.DecodeStream(at));
                    return W ? k.getFont(W) : k;
                  }
                }
                throw new Error("Unknown font format");
              }, B.defaultLanguage = "en", B.setDefaultLanguage = function(at) {
                at === void 0 && (at = "en"), B.defaultLanguage = at;
              };
              function z(at, W, $) {
                return W in at ? Object.defineProperty(at, W, {
                  value: $,
                  enumerable: !0,
                  configurable: !0,
                  writable: !0
                }) : at[W] = $, at;
              }
              function L(at, W, $, R, k) {
                var H = {};
                return Object.keys(R).forEach(function(ot) {
                  H[ot] = R[ot];
                }), H.enumerable = !!H.enumerable, H.configurable = !!H.configurable, ("value" in H || H.initializer) && (H.writable = !0), H = $.slice().reverse().reduce(function(ot, ct) {
                  return ct(at, W, ot) || ot;
                }, H), k && H.initializer !== void 0 && (H.value = H.initializer ? H.initializer.call(k) : void 0, H.initializer = void 0), H.initializer === void 0 && (Object.defineProperty(at, W, H), H = null), H;
              }
              function J(at, W, $) {
                if ($.get) {
                  var R = $.get;
                  $.get = function() {
                    var H = R.call(this);
                    return Object.defineProperty(this, W, {
                      value: H
                    }), H;
                  };
                } else if (typeof $.value == "function") {
                  var k = $.value;
                  return {
                    get: function() {
                      var ot = /* @__PURE__ */ new Map();
                      function ct() {
                        for (var ht = arguments.length, ut = new Array(ht), Nt = 0; Nt < ht; Nt++)
                          ut[Nt] = arguments[Nt];
                        var Kt = ut.length > 0 ? ut[0] : "value";
                        if (ot.has(Kt))
                          return ot.get(Kt);
                        var de = k.apply(this, ut);
                        return ot.set(Kt, de), de;
                      }
                      return Object.defineProperty(this, W, {
                        value: ct
                      }), ct;
                    }
                  };
                }
              }
              var ft = new n.Struct({
                firstCode: n.uint16,
                entryCount: n.uint16,
                idDelta: n.int16,
                idRangeOffset: n.uint16
              }), Q = new n.Struct({
                startCharCode: n.uint32,
                endCharCode: n.uint32,
                glyphID: n.uint32
              }), xt = new n.Struct({
                startUnicodeValue: n.uint24,
                additionalCount: n.uint8
              }), St = new n.Struct({
                unicodeValue: n.uint24,
                glyphID: n.uint16
              }), Pt = new n.Array(xt, n.uint32), Gt = new n.Array(St, n.uint32), Rt = new n.Struct({
                varSelector: n.uint24,
                defaultUVS: new n.Pointer(n.uint32, Pt, {
                  type: "parent"
                }),
                nonDefaultUVS: new n.Pointer(n.uint32, Gt, {
                  type: "parent"
                })
              }), bt = new n.VersionedStruct(n.uint16, {
                0: {
                  // Byte encoding
                  length: n.uint16,
                  // Total table length in bytes (set to 262 for format 0)
                  language: n.uint16,
                  // Language code for this encoding subtable, or zero if language-independent
                  codeMap: new n.LazyArray(n.uint8, 256)
                },
                2: {
                  // High-byte mapping (CJK)
                  length: n.uint16,
                  language: n.uint16,
                  subHeaderKeys: new n.Array(n.uint16, 256),
                  subHeaderCount: function(W) {
                    return Math.max.apply(Math, W.subHeaderKeys);
                  },
                  subHeaders: new n.LazyArray(ft, "subHeaderCount"),
                  glyphIndexArray: new n.LazyArray(n.uint16, "subHeaderCount")
                },
                4: {
                  // Segment mapping to delta values
                  length: n.uint16,
                  // Total table length in bytes
                  language: n.uint16,
                  // Language code
                  segCountX2: n.uint16,
                  segCount: function(W) {
                    return W.segCountX2 >> 1;
                  },
                  searchRange: n.uint16,
                  entrySelector: n.uint16,
                  rangeShift: n.uint16,
                  endCode: new n.LazyArray(n.uint16, "segCount"),
                  reservedPad: new n.Reserved(n.uint16),
                  // This value should be zero
                  startCode: new n.LazyArray(n.uint16, "segCount"),
                  idDelta: new n.LazyArray(n.int16, "segCount"),
                  idRangeOffset: new n.LazyArray(n.uint16, "segCount"),
                  glyphIndexArray: new n.LazyArray(n.uint16, function(at) {
                    return (at.length - at._currentOffset) / 2;
                  })
                },
                6: {
                  // Trimmed table
                  length: n.uint16,
                  language: n.uint16,
                  firstCode: n.uint16,
                  entryCount: n.uint16,
                  glyphIndices: new n.LazyArray(n.uint16, "entryCount")
                },
                8: {
                  // mixed 16-bit and 32-bit coverage
                  reserved: new n.Reserved(n.uint16),
                  length: n.uint32,
                  language: n.uint16,
                  is32: new n.LazyArray(n.uint8, 8192),
                  nGroups: n.uint32,
                  groups: new n.LazyArray(Q, "nGroups")
                },
                10: {
                  // Trimmed Array
                  reserved: new n.Reserved(n.uint16),
                  length: n.uint32,
                  language: n.uint32,
                  firstCode: n.uint32,
                  entryCount: n.uint32,
                  glyphIndices: new n.LazyArray(n.uint16, "numChars")
                },
                12: {
                  // Segmented coverage
                  reserved: new n.Reserved(n.uint16),
                  length: n.uint32,
                  language: n.uint32,
                  nGroups: n.uint32,
                  groups: new n.LazyArray(Q, "nGroups")
                },
                13: {
                  // Many-to-one range mappings (same as 12 except for group.startGlyphID)
                  reserved: new n.Reserved(n.uint16),
                  length: n.uint32,
                  language: n.uint32,
                  nGroups: n.uint32,
                  groups: new n.LazyArray(Q, "nGroups")
                },
                14: {
                  // Unicode Variation Sequences
                  length: n.uint32,
                  numRecords: n.uint32,
                  varSelectors: new n.LazyArray(Rt, "numRecords")
                }
              }), Dt = new n.Struct({
                platformID: n.uint16,
                // Platform identifier
                encodingID: n.uint16,
                // Platform-specific encoding identifier
                table: new n.Pointer(n.uint32, bt, {
                  type: "parent",
                  lazy: !0
                })
              }), X = new n.Struct({
                version: n.uint16,
                numSubtables: n.uint16,
                tables: new n.Array(Dt, "numSubtables")
              }), gt = new n.Struct({
                version: n.int32,
                // 0x00010000 (version 1.0)
                revision: n.int32,
                // set by font manufacturer
                checkSumAdjustment: n.uint32,
                magicNumber: n.uint32,
                // set to 0x5F0F3CF5
                flags: n.uint16,
                unitsPerEm: n.uint16,
                // range from 64 to 16384
                created: new n.Array(n.int32, 2),
                modified: new n.Array(n.int32, 2),
                xMin: n.int16,
                // for all glyph bounding boxes
                yMin: n.int16,
                // for all glyph bounding boxes
                xMax: n.int16,
                // for all glyph bounding boxes
                yMax: n.int16,
                // for all glyph bounding boxes
                macStyle: new n.Bitfield(n.uint16, ["bold", "italic", "underline", "outline", "shadow", "condensed", "extended"]),
                lowestRecPPEM: n.uint16,
                // smallest readable size in pixels
                fontDirectionHint: n.int16,
                indexToLocFormat: n.int16,
                // 0 for short offsets, 1 for long
                glyphDataFormat: n.int16
                // 0 for current format
              }), st = new n.Struct({
                version: n.int32,
                ascent: n.int16,
                // Distance from baseline of highest ascender
                descent: n.int16,
                // Distance from baseline of lowest descender
                lineGap: n.int16,
                // Typographic line gap
                advanceWidthMax: n.uint16,
                // Maximum advance width value in 'hmtx' table
                minLeftSideBearing: n.int16,
                // Maximum advance width value in 'hmtx' table
                minRightSideBearing: n.int16,
                // Minimum right sidebearing value
                xMaxExtent: n.int16,
                caretSlopeRise: n.int16,
                // Used to calculate the slope of the cursor (rise/run); 1 for vertical
                caretSlopeRun: n.int16,
                // 0 for vertical
                caretOffset: n.int16,
                // Set to 0 for non-slanted fonts
                reserved: new n.Reserved(n.int16, 4),
                metricDataFormat: n.int16,
                // 0 for current format
                numberOfMetrics: n.uint16
                // Number of advance widths in 'hmtx' table
              }), rt = new n.Struct({
                advance: n.uint16,
                bearing: n.int16
              }), wt = new n.Struct({
                metrics: new n.LazyArray(rt, function(at) {
                  return at.parent.hhea.numberOfMetrics;
                }),
                bearings: new n.LazyArray(n.int16, function(at) {
                  return at.parent.maxp.numGlyphs - at.parent.hhea.numberOfMetrics;
                })
              }), Ft = new n.Struct({
                version: n.int32,
                numGlyphs: n.uint16,
                // The number of glyphs in the font
                maxPoints: n.uint16,
                // Maximum points in a non-composite glyph
                maxContours: n.uint16,
                // Maximum contours in a non-composite glyph
                maxComponentPoints: n.uint16,
                // Maximum points in a composite glyph
                maxComponentContours: n.uint16,
                // Maximum contours in a composite glyph
                maxZones: n.uint16,
                // 1 if instructions do not use the twilight zone, 2 otherwise
                maxTwilightPoints: n.uint16,
                // Maximum points used in Z0
                maxStorage: n.uint16,
                // Number of Storage Area locations
                maxFunctionDefs: n.uint16,
                // Number of FDEFs
                maxInstructionDefs: n.uint16,
                // Number of IDEFs
                maxStackElements: n.uint16,
                // Maximum stack depth
                maxSizeOfInstructions: n.uint16,
                // Maximum byte count for glyph instructions
                maxComponentElements: n.uint16,
                // Maximum number of components referenced at “top level” for any composite glyph
                maxComponentDepth: n.uint16
                // Maximum levels of recursion; 1 for simple components
              });
              function zt(at, W, $) {
                return $ === void 0 && ($ = 0), at === 1 && D[$] ? D[$] : G[at][W];
              }
              var G = [
                // unicode
                ["utf16be", "utf16be", "utf16be", "utf16be", "utf16be", "utf16be"],
                // macintosh
                // Mappings available at http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/
                // 0	Roman                 17	Malayalam
                // 1	Japanese	            18	Sinhalese
                // 2	Traditional Chinese	  19	Burmese
                // 3	Korean	              20	Khmer
                // 4	Arabic	              21	Thai
                // 5	Hebrew	              22	Laotian
                // 6	Greek	                23	Georgian
                // 7	Russian	              24	Armenian
                // 8	RSymbol	              25	Simplified Chinese
                // 9	Devanagari	          26	Tibetan
                // 10	Gurmukhi	            27	Mongolian
                // 11	Gujarati	            28	Geez
                // 12	Oriya	                29	Slavic
                // 13	Bengali	              30	Vietnamese
                // 14	Tamil	                31	Sindhi
                // 15	Telugu	              32	(Uninterpreted)
                // 16	Kannada
                ["macroman", "shift-jis", "big5", "euc-kr", "iso-8859-6", "iso-8859-8", "macgreek", "maccyrillic", "symbol", "Devanagari", "Gurmukhi", "Gujarati", "Oriya", "Bengali", "Tamil", "Telugu", "Kannada", "Malayalam", "Sinhalese", "Burmese", "Khmer", "macthai", "Laotian", "Georgian", "Armenian", "gb-2312-80", "Tibetan", "Mongolian", "Geez", "maccenteuro", "Vietnamese", "Sindhi"],
                // ISO (deprecated)
                ["ascii"],
                // windows
                // Docs here: http://msdn.microsoft.com/en-us/library/system.text.encoding(v=vs.110).aspx
                ["symbol", "utf16be", "shift-jis", "gb18030", "big5", "wansung", "johab", null, null, null, "utf16be"]
              ], D = {
                15: "maciceland",
                17: "macturkish",
                18: "maccroatian",
                24: "maccenteuro",
                25: "maccenteuro",
                26: "maccenteuro",
                27: "maccenteuro",
                28: "maccenteuro",
                30: "maciceland",
                37: "macromania",
                38: "maccenteuro",
                39: "maccenteuro",
                40: "maccenteuro",
                143: "macinuit",
                // Unsupported by iconv-lite
                146: "macgaelic"
                // Unsupported by iconv-lite
              }, Z = [
                // unicode
                [],
                {
                  // macintosh
                  0: "en",
                  30: "fo",
                  60: "ks",
                  90: "rw",
                  1: "fr",
                  31: "fa",
                  61: "ku",
                  91: "rn",
                  2: "de",
                  32: "ru",
                  62: "sd",
                  92: "ny",
                  3: "it",
                  33: "zh",
                  63: "bo",
                  93: "mg",
                  4: "nl",
                  34: "nl-BE",
                  64: "ne",
                  94: "eo",
                  5: "sv",
                  35: "ga",
                  65: "sa",
                  128: "cy",
                  6: "es",
                  36: "sq",
                  66: "mr",
                  129: "eu",
                  7: "da",
                  37: "ro",
                  67: "bn",
                  130: "ca",
                  8: "pt",
                  38: "cz",
                  68: "as",
                  131: "la",
                  9: "no",
                  39: "sk",
                  69: "gu",
                  132: "qu",
                  10: "he",
                  40: "si",
                  70: "pa",
                  133: "gn",
                  11: "ja",
                  41: "yi",
                  71: "or",
                  134: "ay",
                  12: "ar",
                  42: "sr",
                  72: "ml",
                  135: "tt",
                  13: "fi",
                  43: "mk",
                  73: "kn",
                  136: "ug",
                  14: "el",
                  44: "bg",
                  74: "ta",
                  137: "dz",
                  15: "is",
                  45: "uk",
                  75: "te",
                  138: "jv",
                  16: "mt",
                  46: "be",
                  76: "si",
                  139: "su",
                  17: "tr",
                  47: "uz",
                  77: "my",
                  140: "gl",
                  18: "hr",
                  48: "kk",
                  78: "km",
                  141: "af",
                  19: "zh-Hant",
                  49: "az-Cyrl",
                  79: "lo",
                  142: "br",
                  20: "ur",
                  50: "az-Arab",
                  80: "vi",
                  143: "iu",
                  21: "hi",
                  51: "hy",
                  81: "id",
                  144: "gd",
                  22: "th",
                  52: "ka",
                  82: "tl",
                  145: "gv",
                  23: "ko",
                  53: "mo",
                  83: "ms",
                  146: "ga",
                  24: "lt",
                  54: "ky",
                  84: "ms-Arab",
                  147: "to",
                  25: "pl",
                  55: "tg",
                  85: "am",
                  148: "el-polyton",
                  26: "hu",
                  56: "tk",
                  86: "ti",
                  149: "kl",
                  27: "es",
                  57: "mn-CN",
                  87: "om",
                  150: "az",
                  28: "lv",
                  58: "mn",
                  88: "so",
                  151: "nn",
                  29: "se",
                  59: "ps",
                  89: "sw"
                },
                // ISO (deprecated)
                [],
                {
                  // windows                                        
                  1078: "af",
                  16393: "en-IN",
                  1159: "rw",
                  1074: "tn",
                  1052: "sq",
                  6153: "en-IE",
                  1089: "sw",
                  1115: "si",
                  1156: "gsw",
                  8201: "en-JM",
                  1111: "kok",
                  1051: "sk",
                  1118: "am",
                  17417: "en-MY",
                  1042: "ko",
                  1060: "sl",
                  5121: "ar-DZ",
                  5129: "en-NZ",
                  1088: "ky",
                  11274: "es-AR",
                  15361: "ar-BH",
                  13321: "en-PH",
                  1108: "lo",
                  16394: "es-BO",
                  3073: "ar",
                  18441: "en-SG",
                  1062: "lv",
                  13322: "es-CL",
                  2049: "ar-IQ",
                  7177: "en-ZA",
                  1063: "lt",
                  9226: "es-CO",
                  11265: "ar-JO",
                  11273: "en-TT",
                  2094: "dsb",
                  5130: "es-CR",
                  13313: "ar-KW",
                  2057: "en-GB",
                  1134: "lb",
                  7178: "es-DO",
                  12289: "ar-LB",
                  1033: "en",
                  1071: "mk",
                  12298: "es-EC",
                  4097: "ar-LY",
                  12297: "en-ZW",
                  2110: "ms-BN",
                  17418: "es-SV",
                  6145: "ary",
                  1061: "et",
                  1086: "ms",
                  4106: "es-GT",
                  8193: "ar-OM",
                  1080: "fo",
                  1100: "ml",
                  18442: "es-HN",
                  16385: "ar-QA",
                  1124: "fil",
                  1082: "mt",
                  2058: "es-MX",
                  1025: "ar-SA",
                  1035: "fi",
                  1153: "mi",
                  19466: "es-NI",
                  10241: "ar-SY",
                  2060: "fr-BE",
                  1146: "arn",
                  6154: "es-PA",
                  7169: "aeb",
                  3084: "fr-CA",
                  1102: "mr",
                  15370: "es-PY",
                  14337: "ar-AE",
                  1036: "fr",
                  1148: "moh",
                  10250: "es-PE",
                  9217: "ar-YE",
                  5132: "fr-LU",
                  1104: "mn",
                  20490: "es-PR",
                  1067: "hy",
                  6156: "fr-MC",
                  2128: "mn-CN",
                  3082: "es",
                  1101: "as",
                  4108: "fr-CH",
                  1121: "ne",
                  1034: "es",
                  2092: "az-Cyrl",
                  1122: "fy",
                  1044: "nb",
                  21514: "es-US",
                  1068: "az",
                  1110: "gl",
                  2068: "nn",
                  14346: "es-UY",
                  1133: "ba",
                  1079: "ka",
                  1154: "oc",
                  8202: "es-VE",
                  1069: "eu",
                  3079: "de-AT",
                  1096: "or",
                  2077: "sv-FI",
                  1059: "be",
                  1031: "de",
                  1123: "ps",
                  1053: "sv",
                  2117: "bn",
                  5127: "de-LI",
                  1045: "pl",
                  1114: "syr",
                  1093: "bn-IN",
                  4103: "de-LU",
                  1046: "pt",
                  1064: "tg",
                  8218: "bs-Cyrl",
                  2055: "de-CH",
                  2070: "pt-PT",
                  2143: "tzm",
                  5146: "bs",
                  1032: "el",
                  1094: "pa",
                  1097: "ta",
                  1150: "br",
                  1135: "kl",
                  1131: "qu-BO",
                  1092: "tt",
                  1026: "bg",
                  1095: "gu",
                  2155: "qu-EC",
                  1098: "te",
                  1027: "ca",
                  1128: "ha",
                  3179: "qu",
                  1054: "th",
                  3076: "zh-HK",
                  1037: "he",
                  1048: "ro",
                  1105: "bo",
                  5124: "zh-MO",
                  1081: "hi",
                  1047: "rm",
                  1055: "tr",
                  2052: "zh",
                  1038: "hu",
                  1049: "ru",
                  1090: "tk",
                  4100: "zh-SG",
                  1039: "is",
                  9275: "smn",
                  1152: "ug",
                  1028: "zh-TW",
                  1136: "ig",
                  4155: "smj-NO",
                  1058: "uk",
                  1155: "co",
                  1057: "id",
                  5179: "smj",
                  1070: "hsb",
                  1050: "hr",
                  1117: "iu",
                  3131: "se-FI",
                  1056: "ur",
                  4122: "hr-BA",
                  2141: "iu-Latn",
                  1083: "se",
                  2115: "uz-Cyrl",
                  1029: "cs",
                  2108: "ga",
                  2107: "se-SE",
                  1091: "uz",
                  1030: "da",
                  1076: "xh",
                  8251: "sms",
                  1066: "vi",
                  1164: "prs",
                  1077: "zu",
                  6203: "sma-NO",
                  1106: "cy",
                  1125: "dv",
                  1040: "it",
                  7227: "sms",
                  1160: "wo",
                  2067: "nl-BE",
                  2064: "it-CH",
                  1103: "sa",
                  1157: "sah",
                  1043: "nl",
                  1041: "ja",
                  7194: "sr-Cyrl-BA",
                  1144: "ii",
                  3081: "en-AU",
                  1099: "kn",
                  3098: "sr",
                  1130: "yo",
                  10249: "en-BZ",
                  1087: "kk",
                  6170: "sr-Latn-BA",
                  4105: "en-CA",
                  1107: "km",
                  2074: "sr-Latn",
                  9225: "en-029",
                  1158: "quc",
                  1132: "nso"
                }
              ], et = new n.Struct({
                platformID: n.uint16,
                encodingID: n.uint16,
                languageID: n.uint16,
                nameID: n.uint16,
                length: n.uint16,
                string: new n.Pointer(n.uint16, new n.String("length", function(at) {
                  return zt(at.platformID, at.encodingID, at.languageID);
                }), {
                  type: "parent",
                  relativeTo: function(W) {
                    return W.parent.stringOffset;
                  },
                  allowNull: !1
                })
              }), vt = new n.Struct({
                length: n.uint16,
                tag: new n.Pointer(n.uint16, new n.String("length", "utf16be"), {
                  type: "parent",
                  relativeTo: function(W) {
                    return W.stringOffset;
                  }
                })
              }), lt = new n.VersionedStruct(n.uint16, {
                0: {
                  count: n.uint16,
                  stringOffset: n.uint16,
                  records: new n.Array(et, "count")
                },
                1: {
                  count: n.uint16,
                  stringOffset: n.uint16,
                  records: new n.Array(et, "count"),
                  langTagCount: n.uint16,
                  langTags: new n.Array(vt, "langTagCount")
                }
              }), dt = [
                "copyright",
                "fontFamily",
                "fontSubfamily",
                "uniqueSubfamily",
                "fullName",
                "version",
                "postscriptName",
                // Note: A font may have only one PostScript name and that name must be ASCII.
                "trademark",
                "manufacturer",
                "designer",
                "description",
                "vendorURL",
                "designerURL",
                "license",
                "licenseURL",
                null,
                // reserved
                "preferredFamily",
                "preferredSubfamily",
                "compatibleFull",
                "sampleText",
                "postscriptCIDFontName",
                "wwsFamilyName",
                "wwsSubfamilyName"
              ];
              lt.process = function(at) {
                for (var W = {}, $ = g(this.records), R; !(R = $()).done; ) {
                  var k = R.value, H = Z[k.platformID][k.languageID];
                  H == null && this.langTags != null && k.languageID >= 32768 && (H = this.langTags[k.languageID - 32768].tag), H == null && (H = k.platformID + "-" + k.languageID);
                  var ot = k.nameID >= 256 ? "fontFeatures" : dt[k.nameID] || k.nameID;
                  W[ot] == null && (W[ot] = {});
                  var ct = W[ot];
                  k.nameID >= 256 && (ct = ct[k.nameID] || (ct[k.nameID] = {})), (typeof k.string == "string" || typeof ct[H] != "string") && (ct[H] = k.string);
                }
                this.records = W;
              }, lt.preEncode = function() {
                if (!Array.isArray(this.records)) {
                  this.version = 0;
                  var at = [];
                  for (var W in this.records) {
                    var $ = this.records[W];
                    W !== "fontFeatures" && (at.push({
                      platformID: 3,
                      encodingID: 1,
                      languageID: 1033,
                      nameID: dt.indexOf(W),
                      length: s.byteLength($.en, "utf16le"),
                      string: $.en
                    }), W === "postscriptName" && at.push({
                      platformID: 1,
                      encodingID: 0,
                      languageID: 0,
                      nameID: dt.indexOf(W),
                      length: $.en.length,
                      string: $.en
                    }));
                  }
                  this.records = at, this.count = at.length, this.stringOffset = lt.size(this, null, !1);
                }
              };
              var kt = new n.VersionedStruct(n.uint16, {
                header: {
                  xAvgCharWidth: n.int16,
                  // average weighted advance width of lower case letters and space
                  usWeightClass: n.uint16,
                  // visual weight of stroke in glyphs
                  usWidthClass: n.uint16,
                  // relative change from the normal aspect ratio (width to height ratio)
                  fsType: new n.Bitfield(n.uint16, [
                    // Indicates font embedding licensing rights
                    null,
                    "noEmbedding",
                    "viewOnly",
                    "editable",
                    null,
                    null,
                    null,
                    null,
                    "noSubsetting",
                    "bitmapOnly"
                  ]),
                  ySubscriptXSize: n.int16,
                  // recommended horizontal size in pixels for subscripts
                  ySubscriptYSize: n.int16,
                  // recommended vertical size in pixels for subscripts
                  ySubscriptXOffset: n.int16,
                  // recommended horizontal offset for subscripts
                  ySubscriptYOffset: n.int16,
                  // recommended vertical offset form the baseline for subscripts
                  ySuperscriptXSize: n.int16,
                  // recommended horizontal size in pixels for superscripts
                  ySuperscriptYSize: n.int16,
                  // recommended vertical size in pixels for superscripts
                  ySuperscriptXOffset: n.int16,
                  // recommended horizontal offset for superscripts
                  ySuperscriptYOffset: n.int16,
                  // recommended vertical offset from the baseline for superscripts
                  yStrikeoutSize: n.int16,
                  // width of the strikeout stroke
                  yStrikeoutPosition: n.int16,
                  // position of the strikeout stroke relative to the baseline
                  sFamilyClass: n.int16,
                  // classification of font-family design
                  panose: new n.Array(n.uint8, 10),
                  // describe the visual characteristics of a given typeface
                  ulCharRange: new n.Array(n.uint32, 4),
                  vendorID: new n.String(4),
                  // four character identifier for the font vendor
                  fsSelection: new n.Bitfield(n.uint16, [
                    // bit field containing information about the font
                    "italic",
                    "underscore",
                    "negative",
                    "outlined",
                    "strikeout",
                    "bold",
                    "regular",
                    "useTypoMetrics",
                    "wws",
                    "oblique"
                  ]),
                  usFirstCharIndex: n.uint16,
                  // The minimum Unicode index in this font
                  usLastCharIndex: n.uint16
                  // The maximum Unicode index in this font
                },
                // The Apple version of this table ends here, but the Microsoft one continues on...
                0: {},
                1: {
                  typoAscender: n.int16,
                  typoDescender: n.int16,
                  typoLineGap: n.int16,
                  winAscent: n.uint16,
                  winDescent: n.uint16,
                  codePageRange: new n.Array(n.uint32, 2)
                },
                2: {
                  // these should be common with version 1 somehow
                  typoAscender: n.int16,
                  typoDescender: n.int16,
                  typoLineGap: n.int16,
                  winAscent: n.uint16,
                  winDescent: n.uint16,
                  codePageRange: new n.Array(n.uint32, 2),
                  xHeight: n.int16,
                  capHeight: n.int16,
                  defaultChar: n.uint16,
                  breakChar: n.uint16,
                  maxContent: n.uint16
                },
                5: {
                  typoAscender: n.int16,
                  typoDescender: n.int16,
                  typoLineGap: n.int16,
                  winAscent: n.uint16,
                  winDescent: n.uint16,
                  codePageRange: new n.Array(n.uint32, 2),
                  xHeight: n.int16,
                  capHeight: n.int16,
                  defaultChar: n.uint16,
                  breakChar: n.uint16,
                  maxContent: n.uint16,
                  usLowerOpticalPointSize: n.uint16,
                  usUpperOpticalPointSize: n.uint16
                }
              }), jt = kt.versions;
              jt[3] = jt[4] = jt[2];
              var me = new n.VersionedStruct(n.fixed32, {
                header: {
                  // these fields exist at the top of all versions
                  italicAngle: n.fixed32,
                  // Italic angle in counter-clockwise degrees from the vertical.
                  underlinePosition: n.int16,
                  // Suggested distance of the top of the underline from the baseline
                  underlineThickness: n.int16,
                  // Suggested values for the underline thickness
                  isFixedPitch: n.uint32,
                  // Whether the font is monospaced
                  minMemType42: n.uint32,
                  // Minimum memory usage when a TrueType font is downloaded as a Type 42 font
                  maxMemType42: n.uint32,
                  // Maximum memory usage when a TrueType font is downloaded as a Type 42 font
                  minMemType1: n.uint32,
                  // Minimum memory usage when a TrueType font is downloaded as a Type 1 font
                  maxMemType1: n.uint32
                  // Maximum memory usage when a TrueType font is downloaded as a Type 1 font
                },
                1: {},
                // version 1 has no additional fields
                2: {
                  numberOfGlyphs: n.uint16,
                  glyphNameIndex: new n.Array(n.uint16, "numberOfGlyphs"),
                  names: new n.Array(new n.String(n.uint8))
                },
                2.5: {
                  numberOfGlyphs: n.uint16,
                  offsets: new n.Array(n.uint8, "numberOfGlyphs")
                },
                3: {},
                // version 3 has no additional fields
                4: {
                  map: new n.Array(n.uint32, function(at) {
                    return at.parent.maxp.numGlyphs;
                  })
                }
              }), se = new n.Struct({
                controlValues: new n.Array(n.int16)
              }), Bt = new n.Struct({
                instructions: new n.Array(n.uint8)
              }), ge = new n.VersionedStruct("head.indexToLocFormat", {
                0: {
                  offsets: new n.Array(n.uint16)
                },
                1: {
                  offsets: new n.Array(n.uint32)
                }
              });
              ge.process = function() {
                if (this.version === 0)
                  for (var at = 0; at < this.offsets.length; at++)
                    this.offsets[at] <<= 1;
              }, ge.preEncode = function() {
                if (this.version === 0)
                  for (var at = 0; at < this.offsets.length; at++)
                    this.offsets[at] >>>= 1;
              };
              var Re = new n.Struct({
                controlValueProgram: new n.Array(n.uint8)
              }), Te = new n.Array(new n.Buffer()), xe = /* @__PURE__ */ function() {
                function at($) {
                  this.type = $;
                }
                var W = at.prototype;
                return W.getCFFVersion = function(R) {
                  for (; R && !R.hdrSize; )
                    R = R.parent;
                  return R ? R.version : -1;
                }, W.decode = function(R, k) {
                  var H = this.getCFFVersion(k), ot = H >= 2 ? R.readUInt32BE() : R.readUInt16BE();
                  if (ot === 0)
                    return [];
                  var ct = R.readUInt8(), ht;
                  if (ct === 1)
                    ht = n.uint8;
                  else if (ct === 2)
                    ht = n.uint16;
                  else if (ct === 3)
                    ht = n.uint24;
                  else if (ct === 4)
                    ht = n.uint32;
                  else
                    throw new Error("Bad offset size in CFFIndex: ".concat(ct, " ").concat(R.pos));
                  for (var ut = [], Nt = R.pos + (ot + 1) * ct - 1, Kt = ht.decode(R), de = 0; de < ot; de++) {
                    var te = ht.decode(R);
                    if (this.type != null) {
                      var pe = R.pos;
                      R.pos = Nt + Kt, k.length = te - Kt, ut.push(this.type.decode(R, k)), R.pos = pe;
                    } else
                      ut.push({
                        offset: Nt + Kt,
                        length: te - Kt
                      });
                    Kt = te;
                  }
                  return R.pos = Nt + Kt, ut;
                }, W.size = function(R, k) {
                  var H = 2;
                  if (R.length === 0)
                    return H;
                  for (var ot = this.type || new n.Buffer(), ct = 1, ht = 0; ht < R.length; ht++) {
                    var ut = R[ht];
                    ct += ot.size(ut, k);
                  }
                  var Nt;
                  if (ct <= 255)
                    Nt = n.uint8;
                  else if (ct <= 65535)
                    Nt = n.uint16;
                  else if (ct <= 16777215)
                    Nt = n.uint24;
                  else if (ct <= 4294967295)
                    Nt = n.uint32;
                  else
                    throw new Error("Bad offset in CFFIndex");
                  return H += 1 + Nt.size() * (R.length + 1), H += ct - 1, H;
                }, W.encode = function(R, k, H) {
                  if (R.writeUInt16BE(k.length), k.length !== 0) {
                    for (var ot = this.type || new n.Buffer(), ct = [], ht = 1, ut = g(k), Nt; !(Nt = ut()).done; ) {
                      var Kt = Nt.value, de = ot.size(Kt, H);
                      ct.push(de), ht += de;
                    }
                    var te;
                    if (ht <= 255)
                      te = n.uint8;
                    else if (ht <= 65535)
                      te = n.uint16;
                    else if (ht <= 16777215)
                      te = n.uint24;
                    else if (ht <= 4294967295)
                      te = n.uint32;
                    else
                      throw new Error("Bad offset in CFFIndex");
                    R.writeUInt8(te.size()), ht = 1, te.encode(R, ht);
                    for (var pe = 0, Ee = ct; pe < Ee.length; pe++) {
                      var Le = Ee[pe];
                      ht += Le, te.encode(R, ht);
                    }
                    for (var $e = g(k), wr; !(wr = $e()).done; ) {
                      var or = wr.value;
                      ot.encode(R, or, H);
                    }
                  }
                }, at;
              }(), Fe = 15, Zt = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", ".", "E", "E-", null, "-"], qt = {
                ".": 10,
                E: 11,
                "E-": 12,
                "-": 14
              }, ve = /* @__PURE__ */ function() {
                function at() {
                }
                return at.decode = function($, R) {
                  if (32 <= R && R <= 246)
                    return R - 139;
                  if (247 <= R && R <= 250)
                    return (R - 247) * 256 + $.readUInt8() + 108;
                  if (251 <= R && R <= 254)
                    return -(R - 251) * 256 - $.readUInt8() - 108;
                  if (R === 28)
                    return $.readInt16BE();
                  if (R === 29)
                    return $.readInt32BE();
                  if (R === 30) {
                    for (var k = ""; ; ) {
                      var H = $.readUInt8(), ot = H >> 4;
                      if (ot === Fe)
                        break;
                      k += Zt[ot];
                      var ct = H & 15;
                      if (ct === Fe)
                        break;
                      k += Zt[ct];
                    }
                    return parseFloat(k);
                  }
                  return null;
                }, at.size = function($) {
                  if ($.forceLarge && ($ = 32768), ($ | 0) !== $) {
                    var R = "" + $;
                    return 1 + Math.ceil((R.length + 1) / 2);
                  } else
                    return -107 <= $ && $ <= 107 ? 1 : 108 <= $ && $ <= 1131 || -1131 <= $ && $ <= -108 ? 2 : -32768 <= $ && $ <= 32767 ? 3 : 5;
                }, at.encode = function($, R) {
                  var k = Number(R);
                  if (R.forceLarge)
                    return $.writeUInt8(29), $.writeInt32BE(k);
                  if ((k | 0) !== k) {
                    $.writeUInt8(30);
                    for (var H = "" + k, ot = 0; ot < H.length; ot += 2) {
                      var ct = H[ot], ht = qt[ct] || +ct;
                      if (ot === H.length - 1)
                        var ut = Fe;
                      else
                        var Nt = H[ot + 1], ut = qt[Nt] || +Nt;
                      $.writeUInt8(ht << 4 | ut & 15);
                    }
                    if (ut !== Fe)
                      return $.writeUInt8(Fe << 4);
                  } else
                    return -107 <= k && k <= 107 ? $.writeUInt8(k + 139) : 108 <= k && k <= 1131 ? (k -= 108, $.writeUInt8((k >> 8) + 247), $.writeUInt8(k & 255)) : -1131 <= k && k <= -108 ? (k = -k - 108, $.writeUInt8((k >> 8) + 251), $.writeUInt8(k & 255)) : -32768 <= k && k <= 32767 ? ($.writeUInt8(28), $.writeInt16BE(k)) : ($.writeUInt8(29), $.writeInt32BE(k));
                }, at;
              }(), Se = /* @__PURE__ */ function() {
                function at($) {
                  $ === void 0 && ($ = []), this.ops = $, this.fields = {};
                  for (var R = g($), k; !(k = R()).done; ) {
                    var H = k.value, ot = Array.isArray(H[0]) ? H[0][0] << 8 | H[0][1] : H[0];
                    this.fields[ot] = H;
                  }
                }
                var W = at.prototype;
                return W.decodeOperands = function(R, k, H, ot) {
                  var ct = this;
                  if (Array.isArray(R))
                    return ot.map(function(ht, ut) {
                      return ct.decodeOperands(R[ut], k, H, [ht]);
                    });
                  if (R.decode != null)
                    return R.decode(k, H, ot);
                  switch (R) {
                    case "number":
                    case "offset":
                    case "sid":
                      return ot[0];
                    case "boolean":
                      return !!ot[0];
                    default:
                      return ot;
                  }
                }, W.encodeOperands = function(R, k, H, ot) {
                  var ct = this;
                  return Array.isArray(R) ? ot.map(function(ht, ut) {
                    return ct.encodeOperands(R[ut], k, H, ht)[0];
                  }) : R.encode != null ? R.encode(k, ot, H) : typeof ot == "number" ? [ot] : typeof ot == "boolean" ? [+ot] : Array.isArray(ot) ? ot : [ot];
                }, W.decode = function(R, k) {
                  var H = R.pos + k.length, ot = {}, ct = [];
                  Object.defineProperties(ot, {
                    parent: {
                      value: k
                    },
                    _startOffset: {
                      value: R.pos
                    }
                  });
                  for (var ht in this.fields) {
                    var ut = this.fields[ht];
                    ot[ut[1]] = ut[3];
                  }
                  for (; R.pos < H; ) {
                    var Nt = R.readUInt8();
                    if (Nt < 28) {
                      Nt === 12 && (Nt = Nt << 8 | R.readUInt8());
                      var Kt = this.fields[Nt];
                      if (!Kt)
                        throw new Error("Unknown operator ".concat(Nt));
                      var de = this.decodeOperands(Kt[2], R, ot, ct);
                      de != null && (de instanceof w.PropertyDescriptor ? Object.defineProperty(ot, Kt[1], de) : ot[Kt[1]] = de), ct = [];
                    } else
                      ct.push(ve.decode(R, Nt));
                  }
                  return ot;
                }, W.size = function(R, k, H) {
                  H === void 0 && (H = !0);
                  var ot = {
                    parent: k,
                    val: R,
                    pointerSize: 0,
                    startOffset: k.startOffset || 0
                  }, ct = 0;
                  for (var ht in this.fields) {
                    var ut = this.fields[ht], Nt = R[ut[1]];
                    if (!(Nt == null || E(Nt, ut[3]))) {
                      for (var Kt = this.encodeOperands(ut[2], null, ot, Nt), de = g(Kt), te; !(te = de()).done; ) {
                        var pe = te.value;
                        ct += ve.size(pe);
                      }
                      var Ee = Array.isArray(ut[0]) ? ut[0] : [ut[0]];
                      ct += Ee.length;
                    }
                  }
                  return H && (ct += ot.pointerSize), ct;
                }, W.encode = function(R, k, H) {
                  var ot = {
                    pointers: [],
                    startOffset: R.pos,
                    parent: H,
                    val: k,
                    pointerSize: 0
                  };
                  ot.pointerOffset = R.pos + this.size(k, ot, !1);
                  for (var ct = g(this.ops), ht; !(ht = ct()).done; ) {
                    var ut = ht.value, Nt = k[ut[1]];
                    if (!(Nt == null || E(Nt, ut[3]))) {
                      for (var Kt = this.encodeOperands(ut[2], R, ot, Nt), de = g(Kt), te; !(te = de()).done; ) {
                        var pe = te.value;
                        ve.encode(R, pe);
                      }
                      for (var Ee = Array.isArray(ut[0]) ? ut[0] : [ut[0]], Le = g(Ee), $e; !($e = Le()).done; ) {
                        var wr = $e.value;
                        R.writeUInt8(wr);
                      }
                    }
                  }
                  for (var or = 0; or < ot.pointers.length; ) {
                    var Pr = ot.pointers[or++];
                    Pr.type.encode(R, Pr.val, Pr.parent);
                  }
                }, at;
              }(), Pe = /* @__PURE__ */ function(at) {
                m(W, at);
                function W(R, k) {
                  return k === void 0 && (k = {}), k.type == null && (k.type = "global"), at.call(this, null, R, k) || this;
                }
                var $ = W.prototype;
                return $.decode = function(k, H, ot) {
                  return this.offsetType = {
                    decode: function() {
                      return ot[0];
                    }
                  }, at.prototype.decode.call(this, k, H, ot);
                }, $.encode = function(k, H, ot) {
                  if (!k)
                    return this.offsetType = {
                      size: function() {
                        return 0;
                      }
                    }, this.size(H, ot), [new Be(0)];
                  var ct = null;
                  return this.offsetType = {
                    encode: function(ut, Nt) {
                      return ct = Nt;
                    }
                  }, at.prototype.encode.call(this, k, H, ot), [new Be(ct)];
                }, W;
              }(n.Pointer), Be = /* @__PURE__ */ function() {
                function at($) {
                  this.val = $, this.forceLarge = !0;
                }
                var W = at.prototype;
                return W.valueOf = function() {
                  return this.val;
                }, at;
              }(), De = /* @__PURE__ */ function() {
                function at() {
                }
                return at.decode = function($, R, k) {
                  for (var H = k.pop(); k.length > H; )
                    k.pop();
                }, at;
              }(), It = new Se([
                // key       name                    type                                          default
                [6, "BlueValues", "delta", null],
                [7, "OtherBlues", "delta", null],
                [8, "FamilyBlues", "delta", null],
                [9, "FamilyOtherBlues", "delta", null],
                [[12, 9], "BlueScale", "number", 0.039625],
                [[12, 10], "BlueShift", "number", 7],
                [[12, 11], "BlueFuzz", "number", 1],
                [10, "StdHW", "number", null],
                [11, "StdVW", "number", null],
                [[12, 12], "StemSnapH", "delta", null],
                [[12, 13], "StemSnapV", "delta", null],
                [[12, 14], "ForceBold", "boolean", !1],
                [[12, 17], "LanguageGroup", "number", 0],
                [[12, 18], "ExpansionFactor", "number", 0.06],
                [[12, 19], "initialRandomSeed", "number", 0],
                [20, "defaultWidthX", "number", 0],
                [21, "nominalWidthX", "number", 0],
                [22, "vsindex", "number", 0],
                [23, "blend", De, null],
                [19, "Subrs", new Pe(new xe(), {
                  type: "local"
                }), null]
              ]), he = [".notdef", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quoteright", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "quoteleft", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "exclamdown", "cent", "sterling", "fraction", "yen", "florin", "section", "currency", "quotesingle", "quotedblleft", "guillemotleft", "guilsinglleft", "guilsinglright", "fi", "fl", "endash", "dagger", "daggerdbl", "periodcentered", "paragraph", "bullet", "quotesinglbase", "quotedblbase", "quotedblright", "guillemotright", "ellipsis", "perthousand", "questiondown", "grave", "acute", "circumflex", "tilde", "macron", "breve", "dotaccent", "dieresis", "ring", "cedilla", "hungarumlaut", "ogonek", "caron", "emdash", "AE", "ordfeminine", "Lslash", "Oslash", "OE", "ordmasculine", "ae", "dotlessi", "lslash", "oslash", "oe", "germandbls", "onesuperior", "logicalnot", "mu", "trademark", "Eth", "onehalf", "plusminus", "Thorn", "onequarter", "divide", "brokenbar", "degree", "thorn", "threequarters", "twosuperior", "registered", "minus", "eth", "multiply", "threesuperior", "copyright", "Aacute", "Acircumflex", "Adieresis", "Agrave", "Aring", "Atilde", "Ccedilla", "Eacute", "Ecircumflex", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Ntilde", "Oacute", "Ocircumflex", "Odieresis", "Ograve", "Otilde", "Scaron", "Uacute", "Ucircumflex", "Udieresis", "Ugrave", "Yacute", "Ydieresis", "Zcaron", "aacute", "acircumflex", "adieresis", "agrave", "aring", "atilde", "ccedilla", "eacute", "ecircumflex", "edieresis", "egrave", "iacute", "icircumflex", "idieresis", "igrave", "ntilde", "oacute", "ocircumflex", "odieresis", "ograve", "otilde", "scaron", "uacute", "ucircumflex", "udieresis", "ugrave", "yacute", "ydieresis", "zcaron", "exclamsmall", "Hungarumlautsmall", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "commasuperior", "threequartersemdash", "periodsuperior", "questionsmall", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "isuperior", "lsuperior", "msuperior", "nsuperior", "osuperior", "rsuperior", "ssuperior", "tsuperior", "ff", "ffi", "ffl", "parenleftinferior", "parenrightinferior", "Circumflexsmall", "hyphensuperior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "exclamdownsmall", "centoldstyle", "Lslashsmall", "Scaronsmall", "Zcaronsmall", "Dieresissmall", "Brevesmall", "Caronsmall", "Dotaccentsmall", "Macronsmall", "figuredash", "hypheninferior", "Ogoneksmall", "Ringsmall", "Cedillasmall", "questiondownsmall", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "zerosuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior", "Agravesmall", "Aacutesmall", "Acircumflexsmall", "Atildesmall", "Adieresissmall", "Aringsmall", "AEsmall", "Ccedillasmall", "Egravesmall", "Eacutesmall", "Ecircumflexsmall", "Edieresissmall", "Igravesmall", "Iacutesmall", "Icircumflexsmall", "Idieresissmall", "Ethsmall", "Ntildesmall", "Ogravesmall", "Oacutesmall", "Ocircumflexsmall", "Otildesmall", "Odieresissmall", "OEsmall", "Oslashsmall", "Ugravesmall", "Uacutesmall", "Ucircumflexsmall", "Udieresissmall", "Yacutesmall", "Thornsmall", "Ydieresissmall", "001.000", "001.001", "001.002", "001.003", "Black", "Bold", "Book", "Light", "Medium", "Regular", "Roman", "Semibold"], nt = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quoteright", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "quoteleft", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "exclamdown", "cent", "sterling", "fraction", "yen", "florin", "section", "currency", "quotesingle", "quotedblleft", "guillemotleft", "guilsinglleft", "guilsinglright", "fi", "fl", "", "endash", "dagger", "daggerdbl", "periodcentered", "", "paragraph", "bullet", "quotesinglbase", "quotedblbase", "quotedblright", "guillemotright", "ellipsis", "perthousand", "", "questiondown", "", "grave", "acute", "circumflex", "tilde", "macron", "breve", "dotaccent", "dieresis", "", "ring", "cedilla", "", "hungarumlaut", "ogonek", "caron", "emdash", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "AE", "", "ordfeminine", "", "", "", "", "Lslash", "Oslash", "OE", "ordmasculine", "", "", "", "", "", "ae", "", "", "", "dotlessi", "", "", "lslash", "oslash", "oe", "germandbls"], j = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclamsmall", "Hungarumlautsmall", "", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "commasuperior", "threequartersemdash", "periodsuperior", "questionsmall", "", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "", "", "isuperior", "", "", "lsuperior", "msuperior", "nsuperior", "osuperior", "", "", "rsuperior", "ssuperior", "tsuperior", "", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "", "parenrightinferior", "Circumflexsmall", "hyphensuperior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "exclamdownsmall", "centoldstyle", "Lslashsmall", "", "", "Scaronsmall", "Zcaronsmall", "Dieresissmall", "Brevesmall", "Caronsmall", "", "Dotaccentsmall", "", "", "Macronsmall", "", "", "figuredash", "hypheninferior", "", "", "Ogoneksmall", "Ringsmall", "Cedillasmall", "", "", "", "onequarter", "onehalf", "threequarters", "questiondownsmall", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "", "", "zerosuperior", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior", "Agravesmall", "Aacutesmall", "Acircumflexsmall", "Atildesmall", "Adieresissmall", "Aringsmall", "AEsmall", "Ccedillasmall", "Egravesmall", "Eacutesmall", "Ecircumflexsmall", "Edieresissmall", "Igravesmall", "Iacutesmall", "Icircumflexsmall", "Idieresissmall", "Ethsmall", "Ntildesmall", "Ogravesmall", "Oacutesmall", "Ocircumflexsmall", "Otildesmall", "Odieresissmall", "OEsmall", "Oslashsmall", "Ugravesmall", "Uacutesmall", "Ucircumflexsmall", "Udieresissmall", "Yacutesmall", "Thornsmall", "Ydieresissmall"], V = [".notdef", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quoteright", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "quoteleft", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "exclamdown", "cent", "sterling", "fraction", "yen", "florin", "section", "currency", "quotesingle", "quotedblleft", "guillemotleft", "guilsinglleft", "guilsinglright", "fi", "fl", "endash", "dagger", "daggerdbl", "periodcentered", "paragraph", "bullet", "quotesinglbase", "quotedblbase", "quotedblright", "guillemotright", "ellipsis", "perthousand", "questiondown", "grave", "acute", "circumflex", "tilde", "macron", "breve", "dotaccent", "dieresis", "ring", "cedilla", "hungarumlaut", "ogonek", "caron", "emdash", "AE", "ordfeminine", "Lslash", "Oslash", "OE", "ordmasculine", "ae", "dotlessi", "lslash", "oslash", "oe", "germandbls", "onesuperior", "logicalnot", "mu", "trademark", "Eth", "onehalf", "plusminus", "Thorn", "onequarter", "divide", "brokenbar", "degree", "thorn", "threequarters", "twosuperior", "registered", "minus", "eth", "multiply", "threesuperior", "copyright", "Aacute", "Acircumflex", "Adieresis", "Agrave", "Aring", "Atilde", "Ccedilla", "Eacute", "Ecircumflex", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Ntilde", "Oacute", "Ocircumflex", "Odieresis", "Ograve", "Otilde", "Scaron", "Uacute", "Ucircumflex", "Udieresis", "Ugrave", "Yacute", "Ydieresis", "Zcaron", "aacute", "acircumflex", "adieresis", "agrave", "aring", "atilde", "ccedilla", "eacute", "ecircumflex", "edieresis", "egrave", "iacute", "icircumflex", "idieresis", "igrave", "ntilde", "oacute", "ocircumflex", "odieresis", "ograve", "otilde", "scaron", "uacute", "ucircumflex", "udieresis", "ugrave", "yacute", "ydieresis", "zcaron"], yt = [".notdef", "space", "exclamsmall", "Hungarumlautsmall", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "commasuperior", "threequartersemdash", "periodsuperior", "questionsmall", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "isuperior", "lsuperior", "msuperior", "nsuperior", "osuperior", "rsuperior", "ssuperior", "tsuperior", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "parenrightinferior", "Circumflexsmall", "hyphensuperior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "exclamdownsmall", "centoldstyle", "Lslashsmall", "Scaronsmall", "Zcaronsmall", "Dieresissmall", "Brevesmall", "Caronsmall", "Dotaccentsmall", "Macronsmall", "figuredash", "hypheninferior", "Ogoneksmall", "Ringsmall", "Cedillasmall", "onequarter", "onehalf", "threequarters", "questiondownsmall", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "zerosuperior", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior", "Agravesmall", "Aacutesmall", "Acircumflexsmall", "Atildesmall", "Adieresissmall", "Aringsmall", "AEsmall", "Ccedillasmall", "Egravesmall", "Eacutesmall", "Ecircumflexsmall", "Edieresissmall", "Igravesmall", "Iacutesmall", "Icircumflexsmall", "Idieresissmall", "Ethsmall", "Ntildesmall", "Ogravesmall", "Oacutesmall", "Ocircumflexsmall", "Otildesmall", "Odieresissmall", "OEsmall", "Oslashsmall", "Ugravesmall", "Uacutesmall", "Ucircumflexsmall", "Udieresissmall", "Yacutesmall", "Thornsmall", "Ydieresissmall"], it = [".notdef", "space", "dollaroldstyle", "dollarsuperior", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "commasuperior", "threequartersemdash", "periodsuperior", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "isuperior", "lsuperior", "msuperior", "nsuperior", "osuperior", "rsuperior", "ssuperior", "tsuperior", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "parenrightinferior", "hyphensuperior", "colonmonetary", "onefitted", "rupiah", "centoldstyle", "figuredash", "hypheninferior", "onequarter", "onehalf", "threequarters", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "zerosuperior", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior"], _t = new n.Struct({
                reserved: new n.Reserved(n.uint16),
                reqFeatureIndex: n.uint16,
                featureCount: n.uint16,
                featureIndexes: new n.Array(n.uint16, "featureCount")
              }), ne = new n.Struct({
                tag: new n.String(4),
                langSys: new n.Pointer(n.uint16, _t, {
                  type: "parent"
                })
              }), Y = new n.Struct({
                defaultLangSys: new n.Pointer(n.uint16, _t),
                count: n.uint16,
                langSysRecords: new n.Array(ne, "count")
              }), Jt = new n.Struct({
                tag: new n.String(4),
                script: new n.Pointer(n.uint16, Y, {
                  type: "parent"
                })
              }), ie = new n.Array(Jt, n.uint16), Tt = new n.Struct({
                featureParams: n.uint16,
                // pointer
                lookupCount: n.uint16,
                lookupListIndexes: new n.Array(n.uint16, "lookupCount")
              }), Xt = new n.Struct({
                tag: new n.String(4),
                feature: new n.Pointer(n.uint16, Tt, {
                  type: "parent"
                })
              }), ue = new n.Array(Xt, n.uint16), Ve = new n.Struct({
                markAttachmentType: n.uint8,
                flags: new n.Bitfield(n.uint8, ["rightToLeft", "ignoreBaseGlyphs", "ignoreLigatures", "ignoreMarks", "useMarkFilteringSet"])
              });
              function ke(at) {
                var W = new n.Struct({
                  lookupType: n.uint16,
                  flags: Ve,
                  subTableCount: n.uint16,
                  subTables: new n.Array(new n.Pointer(n.uint16, at), "subTableCount"),
                  markFilteringSet: new n.Optional(n.uint16, function($) {
                    return $.flags.flags.useMarkFilteringSet;
                  })
                });
                return new n.LazyArray(new n.Pointer(n.uint16, W), n.uint16);
              }
              var Xe = new n.Struct({
                start: n.uint16,
                end: n.uint16,
                startCoverageIndex: n.uint16
              }), je = new n.VersionedStruct(n.uint16, {
                1: {
                  glyphCount: n.uint16,
                  glyphs: new n.Array(n.uint16, "glyphCount")
                },
                2: {
                  rangeCount: n.uint16,
                  rangeRecords: new n.Array(Xe, "rangeCount")
                }
              }), Wr = new n.Struct({
                start: n.uint16,
                end: n.uint16,
                class: n.uint16
              }), vr = new n.VersionedStruct(n.uint16, {
                1: {
                  // Class array
                  startGlyph: n.uint16,
                  glyphCount: n.uint16,
                  classValueArray: new n.Array(n.uint16, "glyphCount")
                },
                2: {
                  // Class ranges
                  classRangeCount: n.uint16,
                  classRangeRecord: new n.Array(Wr, "classRangeCount")
                }
              }), nr = new n.Struct({
                a: n.uint16,
                // startSize for hinting Device, outerIndex for VariationIndex
                b: n.uint16,
                // endSize for Device, innerIndex for VariationIndex
                deltaFormat: n.uint16
              }), Fr = new n.Struct({
                sequenceIndex: n.uint16,
                lookupListIndex: n.uint16
              }), Jr = new n.Struct({
                glyphCount: n.uint16,
                lookupCount: n.uint16,
                input: new n.Array(n.uint16, function(at) {
                  return at.glyphCount - 1;
                }),
                lookupRecords: new n.Array(Fr, "lookupCount")
              }), dn = new n.Array(new n.Pointer(n.uint16, Jr), n.uint16), kn = new n.Struct({
                glyphCount: n.uint16,
                lookupCount: n.uint16,
                classes: new n.Array(n.uint16, function(at) {
                  return at.glyphCount - 1;
                }),
                lookupRecords: new n.Array(Fr, "lookupCount")
              }), Yn = new n.Array(new n.Pointer(n.uint16, kn), n.uint16), yr = new n.VersionedStruct(n.uint16, {
                1: {
                  // Simple context
                  coverage: new n.Pointer(n.uint16, je),
                  ruleSetCount: n.uint16,
                  ruleSets: new n.Array(new n.Pointer(n.uint16, dn), "ruleSetCount")
                },
                2: {
                  // Class-based context
                  coverage: new n.Pointer(n.uint16, je),
                  classDef: new n.Pointer(n.uint16, vr),
                  classSetCnt: n.uint16,
                  classSet: new n.Array(new n.Pointer(n.uint16, Yn), "classSetCnt")
                },
                3: {
                  glyphCount: n.uint16,
                  lookupCount: n.uint16,
                  coverages: new n.Array(new n.Pointer(n.uint16, je), "glyphCount"),
                  lookupRecords: new n.Array(Fr, "lookupCount")
                }
              }), Tn = new n.Struct({
                backtrackGlyphCount: n.uint16,
                backtrack: new n.Array(n.uint16, "backtrackGlyphCount"),
                inputGlyphCount: n.uint16,
                input: new n.Array(n.uint16, function(at) {
                  return at.inputGlyphCount - 1;
                }),
                lookaheadGlyphCount: n.uint16,
                lookahead: new n.Array(n.uint16, "lookaheadGlyphCount"),
                lookupCount: n.uint16,
                lookupRecords: new n.Array(Fr, "lookupCount")
              }), qr = new n.Array(new n.Pointer(n.uint16, Tn), n.uint16), gn = new n.VersionedStruct(n.uint16, {
                1: {
                  // Simple context glyph substitution
                  coverage: new n.Pointer(n.uint16, je),
                  chainCount: n.uint16,
                  chainRuleSets: new n.Array(new n.Pointer(n.uint16, qr), "chainCount")
                },
                2: {
                  // Class-based chaining context
                  coverage: new n.Pointer(n.uint16, je),
                  backtrackClassDef: new n.Pointer(n.uint16, vr),
                  inputClassDef: new n.Pointer(n.uint16, vr),
                  lookaheadClassDef: new n.Pointer(n.uint16, vr),
                  chainCount: n.uint16,
                  chainClassSet: new n.Array(new n.Pointer(n.uint16, qr), "chainCount")
                },
                3: {
                  // Coverage-based chaining context
                  backtrackGlyphCount: n.uint16,
                  backtrackCoverage: new n.Array(new n.Pointer(n.uint16, je), "backtrackGlyphCount"),
                  inputGlyphCount: n.uint16,
                  inputCoverage: new n.Array(new n.Pointer(n.uint16, je), "inputGlyphCount"),
                  lookaheadGlyphCount: n.uint16,
                  lookaheadCoverage: new n.Array(new n.Pointer(n.uint16, je), "lookaheadGlyphCount"),
                  lookupCount: n.uint16,
                  lookupRecords: new n.Array(Fr, "lookupCount")
                }
              }), un = new n.Fixed(16, "BE", 14), wi = new n.Struct({
                startCoord: un,
                peakCoord: un,
                endCoord: un
              }), Si = new n.Struct({
                axisCount: n.uint16,
                regionCount: n.uint16,
                variationRegions: new n.Array(new n.Array(wi, "axisCount"), "regionCount")
              }), Me = new n.Struct({
                shortDeltas: new n.Array(n.int16, function(at) {
                  return at.parent.shortDeltaCount;
                }),
                regionDeltas: new n.Array(n.int8, function(at) {
                  return at.parent.regionIndexCount - at.parent.shortDeltaCount;
                }),
                deltas: function(W) {
                  return W.shortDeltas.concat(W.regionDeltas);
                }
              }), Ze = new n.Struct({
                itemCount: n.uint16,
                shortDeltaCount: n.uint16,
                regionIndexCount: n.uint16,
                regionIndexes: new n.Array(n.uint16, "regionIndexCount"),
                deltaSets: new n.Array(Me, "itemCount")
              }), qe = new n.Struct({
                format: n.uint16,
                variationRegionList: new n.Pointer(n.uint32, Si),
                variationDataCount: n.uint16,
                itemVariationData: new n.Array(new n.Pointer(n.uint32, Ze), "variationDataCount")
              }), gr = new n.VersionedStruct(n.uint16, {
                1: (i = {
                  axisIndex: n.uint16
                }, i.axisIndex = n.uint16, i.filterRangeMinValue = un, i.filterRangeMaxValue = un, i)
              }), Wn = new n.Struct({
                conditionCount: n.uint16,
                conditionTable: new n.Array(new n.Pointer(n.uint32, gr), "conditionCount")
              }), sr = new n.Struct({
                featureIndex: n.uint16,
                alternateFeatureTable: new n.Pointer(n.uint32, Tt, {
                  type: "parent"
                })
              }), Oi = new n.Struct({
                version: n.fixed32,
                substitutionCount: n.uint16,
                substitutions: new n.Array(sr, "substitutionCount")
              }), Yi = new n.Struct({
                conditionSet: new n.Pointer(n.uint32, Wn, {
                  type: "parent"
                }),
                featureTableSubstitution: new n.Pointer(n.uint32, Oi, {
                  type: "parent"
                })
              }), vi = new n.Struct({
                majorVersion: n.uint16,
                minorVersion: n.uint16,
                featureVariationRecordCount: n.uint32,
                featureVariationRecords: new n.Array(Yi, "featureVariationRecordCount")
              }), Ct = /* @__PURE__ */ function() {
                function at($, R) {
                  this.predefinedOps = $, this.type = R;
                }
                var W = at.prototype;
                return W.decode = function(R, k, H) {
                  return this.predefinedOps[H[0]] ? this.predefinedOps[H[0]] : this.type.decode(R, k, H);
                }, W.size = function(R, k) {
                  return this.type.size(R, k);
                }, W.encode = function(R, k, H) {
                  var ot = this.predefinedOps.indexOf(k);
                  return ot !== -1 ? ot : this.type.encode(R, k, H);
                }, at;
              }(), $t = /* @__PURE__ */ function(at) {
                m(W, at);
                function W() {
                  return at.call(this, "UInt8") || this;
                }
                var $ = W.prototype;
                return $.decode = function(k) {
                  return n.uint8.decode(k) & 127;
                }, W;
              }(n.Number), Mt = new n.Struct({
                first: n.uint16,
                nLeft: n.uint8
              }), oe = new n.Struct({
                first: n.uint16,
                nLeft: n.uint16
              }), Lt = new n.VersionedStruct(new $t(), {
                0: {
                  nCodes: n.uint8,
                  codes: new n.Array(n.uint8, "nCodes")
                },
                1: {
                  nRanges: n.uint8,
                  ranges: new n.Array(Mt, "nRanges")
                }
                // TODO: supplement?
              }), Ut = new Ct([nt, j], new Pe(Lt, {
                lazy: !0
              })), Vt = /* @__PURE__ */ function(at) {
                m(W, at);
                function W() {
                  return at.apply(this, arguments) || this;
                }
                var $ = W.prototype;
                return $.decode = function(k, H) {
                  for (var ot = w.resolveLength(this.length, k, H), ct = 0, ht = []; ct < ot; ) {
                    var ut = this.type.decode(k, H);
                    ut.offset = ct, ct += ut.nLeft + 1, ht.push(ut);
                  }
                  return ht;
                }, W;
              }(n.Array), Yt = new n.VersionedStruct(n.uint8, {
                0: {
                  glyphs: new n.Array(n.uint16, function(at) {
                    return at.parent.CharStrings.length - 1;
                  })
                },
                1: {
                  ranges: new Vt(Mt, function(at) {
                    return at.parent.CharStrings.length - 1;
                  })
                },
                2: {
                  ranges: new Vt(oe, function(at) {
                    return at.parent.CharStrings.length - 1;
                  })
                }
              }), re = new Ct([V, yt, it], new Pe(Yt, {
                lazy: !0
              })), Ht = new n.Struct({
                first: n.uint16,
                fd: n.uint8
              }), fe = new n.Struct({
                first: n.uint32,
                fd: n.uint16
              }), Qt = new n.VersionedStruct(n.uint8, {
                0: {
                  fds: new n.Array(n.uint8, function(at) {
                    return at.parent.CharStrings.length;
                  })
                },
                3: {
                  nRanges: n.uint16,
                  ranges: new n.Array(Ht, "nRanges"),
                  sentinel: n.uint16
                },
                4: {
                  nRanges: n.uint32,
                  ranges: new n.Array(fe, "nRanges"),
                  sentinel: n.uint32
                }
              }), Ce = new Pe(It), ze = /* @__PURE__ */ function() {
                function at() {
                }
                var W = at.prototype;
                return W.decode = function(R, k, H) {
                  return k.length = H[0], Ce.decode(R, k, [H[1]]);
                }, W.size = function(R, k) {
                  return [It.size(R, k, !1), Ce.size(R, k)[0]];
                }, W.encode = function(R, k, H) {
                  return [It.size(k, H, !1), Ce.encode(R, k, H)[0]];
                }, at;
              }(), He = new Se([
                // key       name                   type(s)                                 default
                [18, "Private", new ze(), null],
                [[12, 38], "FontName", "sid", null],
                [[12, 7], "FontMatrix", "array", [1e-3, 0, 0, 1e-3, 0, 0]],
                [[12, 5], "PaintType", "number", 0]
              ]), Je = new Se([
                // key       name                   type(s)                                 default
                [[12, 30], "ROS", ["sid", "sid", "number"], null],
                [0, "version", "sid", null],
                [1, "Notice", "sid", null],
                [[12, 0], "Copyright", "sid", null],
                [2, "FullName", "sid", null],
                [3, "FamilyName", "sid", null],
                [4, "Weight", "sid", null],
                [[12, 1], "isFixedPitch", "boolean", !1],
                [[12, 2], "ItalicAngle", "number", 0],
                [[12, 3], "UnderlinePosition", "number", -100],
                [[12, 4], "UnderlineThickness", "number", 50],
                [[12, 5], "PaintType", "number", 0],
                [[12, 6], "CharstringType", "number", 2],
                [[12, 7], "FontMatrix", "array", [1e-3, 0, 0, 1e-3, 0, 0]],
                [13, "UniqueID", "number", null],
                [5, "FontBBox", "array", [0, 0, 0, 0]],
                [[12, 8], "StrokeWidth", "number", 0],
                [14, "XUID", "array", null],
                [15, "charset", re, V],
                [16, "Encoding", Ut, nt],
                [17, "CharStrings", new Pe(new xe()), null],
                [18, "Private", new ze(), null],
                [[12, 20], "SyntheticBase", "number", null],
                [[12, 21], "PostScript", "sid", null],
                [[12, 22], "BaseFontName", "sid", null],
                [[12, 23], "BaseFontBlend", "delta", null],
                // CID font specific
                [[12, 31], "CIDFontVersion", "number", 0],
                [[12, 32], "CIDFontRevision", "number", 0],
                [[12, 33], "CIDFontType", "number", 0],
                [[12, 34], "CIDCount", "number", 8720],
                [[12, 35], "UIDBase", "number", null],
                [[12, 37], "FDSelect", new Pe(Qt), null],
                [[12, 36], "FDArray", new Pe(new xe(He)), null],
                [[12, 38], "FontName", "sid", null]
              ]), ar = new n.Struct({
                length: n.uint16,
                itemVariationStore: qe
              }), mr = new Se([[[12, 7], "FontMatrix", "array", [1e-3, 0, 0, 1e-3, 0, 0]], [17, "CharStrings", new Pe(new xe()), null], [[12, 37], "FDSelect", new Pe(Qt), null], [[12, 36], "FDArray", new Pe(new xe(He)), null], [24, "vstore", new Pe(ar), null], [25, "maxstack", "number", 193]]), we = new n.VersionedStruct(n.fixed16, {
                1: {
                  hdrSize: n.uint8,
                  offSize: n.uint8,
                  nameIndex: new xe(new n.String("length")),
                  topDictIndex: new xe(Je),
                  stringIndex: new xe(new n.String("length")),
                  globalSubrIndex: new xe()
                },
                2: {
                  hdrSize: n.uint8,
                  length: n.uint16,
                  topDict: mr,
                  globalSubrIndex: new xe()
                }
              }), We = /* @__PURE__ */ function() {
                function at($) {
                  this.stream = $, this.decode();
                }
                at.decode = function(R) {
                  return new at(R);
                };
                var W = at.prototype;
                return W.decode = function() {
                  this.stream.pos;
                  var R = we.decode(this.stream);
                  for (var k in R) {
                    var H = R[k];
                    this[k] = H;
                  }
                  if (this.version < 2) {
                    if (this.topDictIndex.length !== 1)
                      throw new Error("Only a single font is allowed in CFF");
                    this.topDict = this.topDictIndex[0];
                  }
                  return this.isCIDFont = this.topDict.ROS != null, this;
                }, W.string = function(R) {
                  return this.version >= 2 ? null : R < he.length ? he[R] : this.stringIndex[R - he.length];
                }, W.getCharString = function(R) {
                  return this.stream.pos = this.topDict.CharStrings[R].offset, this.stream.readBuffer(this.topDict.CharStrings[R].length);
                }, W.getGlyphName = function(R) {
                  if (this.version >= 2 || this.isCIDFont)
                    return null;
                  var k = this.topDict.charset;
                  if (Array.isArray(k))
                    return k[R];
                  if (R === 0)
                    return ".notdef";
                  switch (R -= 1, k.version) {
                    case 0:
                      return this.string(k.glyphs[R]);
                    case 1:
                    case 2:
                      for (var H = 0; H < k.ranges.length; H++) {
                        var ot = k.ranges[H];
                        if (ot.offset <= R && R <= ot.offset + ot.nLeft)
                          return this.string(ot.first + (R - ot.offset));
                      }
                      break;
                  }
                  return null;
                }, W.fdForGlyph = function(R) {
                  if (!this.topDict.FDSelect)
                    return null;
                  switch (this.topDict.FDSelect.version) {
                    case 0:
                      return this.topDict.FDSelect.fds[R];
                    case 3:
                    case 4:
                      for (var k = this.topDict.FDSelect.ranges, H = 0, ot = k.length - 1; H <= ot; ) {
                        var ct = H + ot >> 1;
                        if (R < k[ct].first)
                          ot = ct - 1;
                        else if (ct < ot && R >= k[ct + 1].first)
                          H = ct + 1;
                        else
                          return k[ct].fd;
                      }
                    default:
                      throw new Error("Unknown FDSelect version: ".concat(this.topDict.FDSelect.version));
                  }
                }, W.privateDictForGlyph = function(R) {
                  if (this.topDict.FDSelect) {
                    var k = this.fdForGlyph(R);
                    return this.topDict.FDArray[k] ? this.topDict.FDArray[k].Private : null;
                  }
                  return this.version < 2 ? this.topDict.Private : this.topDict.FDArray[0].Private;
                }, h(at, [{
                  key: "postscriptName",
                  get: function() {
                    return this.version < 2 ? this.nameIndex[0] : null;
                  }
                }, {
                  key: "fullName",
                  get: function() {
                    return this.string(this.topDict.FullName);
                  }
                }, {
                  key: "familyName",
                  get: function() {
                    return this.string(this.topDict.FamilyName);
                  }
                }]), at;
              }(), fr = new n.Struct({
                glyphIndex: n.uint16,
                vertOriginY: n.int16
              }), Ke = new n.Struct({
                majorVersion: n.uint16,
                minorVersion: n.uint16,
                defaultVertOriginY: n.int16,
                numVertOriginYMetrics: n.uint16,
                metrics: new n.Array(fr, "numVertOriginYMetrics")
              }), pr = new n.Struct({
                height: n.uint8,
                width: n.uint8,
                horiBearingX: n.int8,
                horiBearingY: n.int8,
                horiAdvance: n.uint8,
                vertBearingX: n.int8,
                vertBearingY: n.int8,
                vertAdvance: n.uint8
              }), tr = new n.Struct({
                height: n.uint8,
                width: n.uint8,
                bearingX: n.int8,
                bearingY: n.int8,
                advance: n.uint8
              }), Er = new n.Struct({
                glyph: n.uint16,
                xOffset: n.int8,
                yOffset: n.int8
              }), xr = function() {
              }, Gr = function() {
              };
              new n.VersionedStruct("version", {
                1: {
                  metrics: tr,
                  data: xr
                },
                2: {
                  metrics: tr,
                  data: Gr
                },
                // format 3 is deprecated
                // format 4 is not supported by Microsoft
                5: {
                  data: Gr
                },
                6: {
                  metrics: pr,
                  data: xr
                },
                7: {
                  metrics: pr,
                  data: Gr
                },
                8: {
                  metrics: tr,
                  pad: new n.Reserved(n.uint8),
                  numComponents: n.uint16,
                  components: new n.Array(Er, "numComponents")
                },
                9: {
                  metrics: pr,
                  pad: new n.Reserved(n.uint8),
                  numComponents: n.uint16,
                  components: new n.Array(Er, "numComponents")
                },
                17: {
                  metrics: tr,
                  dataLen: n.uint32,
                  data: new n.Buffer("dataLen")
                },
                18: {
                  metrics: pr,
                  dataLen: n.uint32,
                  data: new n.Buffer("dataLen")
                },
                19: {
                  dataLen: n.uint32,
                  data: new n.Buffer("dataLen")
                }
              });
              var tn = new n.Struct({
                ascender: n.int8,
                descender: n.int8,
                widthMax: n.uint8,
                caretSlopeNumerator: n.int8,
                caretSlopeDenominator: n.int8,
                caretOffset: n.int8,
                minOriginSB: n.int8,
                minAdvanceSB: n.int8,
                maxBeforeBL: n.int8,
                minAfterBL: n.int8,
                pad: new n.Reserved(n.int8, 2)
              }), Qr = new n.Struct({
                glyphCode: n.uint16,
                offset: n.uint16
              }), _r = new n.VersionedStruct(n.uint16, {
                header: {
                  imageFormat: n.uint16,
                  imageDataOffset: n.uint32
                },
                1: {
                  offsetArray: new n.Array(n.uint32, function(at) {
                    return at.parent.lastGlyphIndex - at.parent.firstGlyphIndex + 1;
                  })
                },
                2: {
                  imageSize: n.uint32,
                  bigMetrics: pr
                },
                3: {
                  offsetArray: new n.Array(n.uint16, function(at) {
                    return at.parent.lastGlyphIndex - at.parent.firstGlyphIndex + 1;
                  })
                },
                4: {
                  numGlyphs: n.uint32,
                  glyphArray: new n.Array(Qr, function(at) {
                    return at.numGlyphs + 1;
                  })
                },
                5: {
                  imageSize: n.uint32,
                  bigMetrics: pr,
                  numGlyphs: n.uint32,
                  glyphCodeArray: new n.Array(n.uint16, "numGlyphs")
                }
              }), Yr = new n.Struct({
                firstGlyphIndex: n.uint16,
                lastGlyphIndex: n.uint16,
                subtable: new n.Pointer(n.uint32, _r)
              }), Rr = new n.Struct({
                indexSubTableArray: new n.Pointer(n.uint32, new n.Array(Yr, 1), {
                  type: "parent"
                }),
                indexTablesSize: n.uint32,
                numberOfIndexSubTables: n.uint32,
                colorRef: n.uint32,
                hori: tn,
                vert: tn,
                startGlyphIndex: n.uint16,
                endGlyphIndex: n.uint16,
                ppemX: n.uint8,
                ppemY: n.uint8,
                bitDepth: n.uint8,
                flags: new n.Bitfield(n.uint8, ["horizontal", "vertical"])
              }), qn = new n.Struct({
                version: n.uint32,
                // 0x00020000
                numSizes: n.uint32,
                sizes: new n.Array(Rr, "numSizes")
              }), Sn = new n.Struct({
                ppem: n.uint16,
                resolution: n.uint16,
                imageOffsets: new n.Array(new n.Pointer(n.uint32, "void"), function(at) {
                  return at.parent.parent.maxp.numGlyphs + 1;
                })
              }), $r = new n.Struct({
                version: n.uint16,
                flags: new n.Bitfield(n.uint16, ["renderOutlines"]),
                numImgTables: n.uint32,
                imageTables: new n.Array(new n.Pointer(n.uint32, Sn), "numImgTables")
              }), ln = new n.Struct({
                gid: n.uint16,
                // Glyph ID of layer glyph (must be in z-order from bottom to top).
                paletteIndex: n.uint16
                // Index value to use in the appropriate palette. This value must
              }), pn = new n.Struct({
                gid: n.uint16,
                // Glyph ID of reference glyph. This glyph is for reference only
                // and is not rendered for color.
                firstLayerIndex: n.uint16,
                // Index (from beginning of the Layer Records) to the layer record.
                // There will be numLayers consecutive entries for this base glyph.
                numLayers: n.uint16
              }), Nn = new n.Struct({
                version: n.uint16,
                numBaseGlyphRecords: n.uint16,
                baseGlyphRecord: new n.Pointer(n.uint32, new n.Array(pn, "numBaseGlyphRecords")),
                layerRecords: new n.Pointer(n.uint32, new n.Array(ln, "numLayerRecords"), {
                  lazy: !0
                }),
                numLayerRecords: n.uint16
              }), Rn = new n.Struct({
                blue: n.uint8,
                green: n.uint8,
                red: n.uint8,
                alpha: n.uint8
              }), Na = new n.VersionedStruct(n.uint16, {
                header: {
                  numPaletteEntries: n.uint16,
                  numPalettes: n.uint16,
                  numColorRecords: n.uint16,
                  colorRecords: new n.Pointer(n.uint32, new n.Array(Rn, "numColorRecords")),
                  colorRecordIndices: new n.Array(n.uint16, "numPalettes")
                },
                0: {},
                1: {
                  offsetPaletteTypeArray: new n.Pointer(n.uint32, new n.Array(n.uint32, "numPalettes")),
                  offsetPaletteLabelArray: new n.Pointer(n.uint32, new n.Array(n.uint16, "numPalettes")),
                  offsetPaletteEntryLabelArray: new n.Pointer(n.uint32, new n.Array(n.uint16, "numPaletteEntries"))
                }
              }), zi = new n.VersionedStruct(n.uint16, {
                1: {
                  // Design units only
                  coordinate: n.int16
                  // X or Y value, in design units
                },
                2: {
                  // Design units plus contour point
                  coordinate: n.int16,
                  // X or Y value, in design units
                  referenceGlyph: n.uint16,
                  // GlyphID of control glyph
                  baseCoordPoint: n.uint16
                  // Index of contour point on the referenceGlyph
                },
                3: {
                  // Design units plus Device table
                  coordinate: n.int16,
                  // X or Y value, in design units
                  deviceTable: new n.Pointer(n.uint16, nr)
                  // Device table for X or Y value
                }
              }), La = new n.Struct({
                defaultIndex: n.uint16,
                // Index of default baseline for this script-same index in the BaseTagList
                baseCoordCount: n.uint16,
                baseCoords: new n.Array(new n.Pointer(n.uint16, zi), "baseCoordCount")
              }), Ua = new n.Struct({
                tag: new n.String(4),
                // 4-byte feature identification tag-must match FeatureTag in FeatureList
                minCoord: new n.Pointer(n.uint16, zi, {
                  type: "parent"
                }),
                // May be NULL
                maxCoord: new n.Pointer(n.uint16, zi, {
                  type: "parent"
                })
                // May be NULL
              }), va = new n.Struct({
                minCoord: new n.Pointer(n.uint16, zi),
                // May be NULL
                maxCoord: new n.Pointer(n.uint16, zi),
                // May be NULL
                featMinMaxCount: n.uint16,
                // May be 0
                featMinMaxRecords: new n.Array(Ua, "featMinMaxCount")
                // In alphabetical order
              }), Gi = new n.Struct({
                tag: new n.String(4),
                // 4-byte language system identification tag
                minMax: new n.Pointer(n.uint16, va, {
                  type: "parent"
                })
              }), ga = new n.Struct({
                baseValues: new n.Pointer(n.uint16, La),
                // May be NULL
                defaultMinMax: new n.Pointer(n.uint16, va),
                // May be NULL
                baseLangSysCount: n.uint16,
                // May be 0
                baseLangSysRecords: new n.Array(Gi, "baseLangSysCount")
                // in alphabetical order by BaseLangSysTag
              }), Zi = new n.Struct({
                tag: new n.String(4),
                // 4-byte script identification tag
                script: new n.Pointer(n.uint16, ga, {
                  type: "parent"
                })
              }), si = new n.Array(Zi, n.uint16), Et = new n.Array(new n.String(4), n.uint16), _ = new n.Struct({
                baseTagList: new n.Pointer(n.uint16, Et),
                // May be NULL
                baseScriptList: new n.Pointer(n.uint16, si)
              }), U = new n.VersionedStruct(n.uint32, {
                header: {
                  horizAxis: new n.Pointer(n.uint16, _),
                  // May be NULL
                  vertAxis: new n.Pointer(n.uint16, _)
                  // May be NULL
                },
                65536: {},
                65537: {
                  itemVariationStore: new n.Pointer(n.uint32, qe)
                }
              }), tt = new n.Array(n.uint16, n.uint16), K = new n.Struct({
                coverage: new n.Pointer(n.uint16, je),
                glyphCount: n.uint16,
                attachPoints: new n.Array(new n.Pointer(n.uint16, tt), "glyphCount")
              }), mt = new n.VersionedStruct(n.uint16, {
                1: {
                  // Design units only
                  coordinate: n.int16
                },
                2: {
                  // Contour point
                  caretValuePoint: n.uint16
                },
                3: {
                  // Design units plus Device table
                  coordinate: n.int16,
                  deviceTable: new n.Pointer(n.uint16, nr)
                }
              }), At = new n.Array(new n.Pointer(n.uint16, mt), n.uint16), ee = new n.Struct({
                coverage: new n.Pointer(n.uint16, je),
                ligGlyphCount: n.uint16,
                ligGlyphs: new n.Array(new n.Pointer(n.uint16, At), "ligGlyphCount")
              }), ae = new n.Struct({
                markSetTableFormat: n.uint16,
                markSetCount: n.uint16,
                coverage: new n.Array(new n.Pointer(n.uint32, je), "markSetCount")
              }), ye = new n.VersionedStruct(n.uint32, {
                header: {
                  glyphClassDef: new n.Pointer(n.uint16, vr),
                  attachList: new n.Pointer(n.uint16, K),
                  ligCaretList: new n.Pointer(n.uint16, ee),
                  markAttachClassDef: new n.Pointer(n.uint16, vr)
                },
                65536: {},
                65538: {
                  markGlyphSetsDef: new n.Pointer(n.uint16, ae)
                },
                65539: {
                  markGlyphSetsDef: new n.Pointer(n.uint16, ae),
                  itemVariationStore: new n.Pointer(n.uint32, qe)
                }
              }), Ae = new n.Bitfield(n.uint16, ["xPlacement", "yPlacement", "xAdvance", "yAdvance", "xPlaDevice", "yPlaDevice", "xAdvDevice", "yAdvDevice"]), Oe = {
                xPlacement: n.int16,
                yPlacement: n.int16,
                xAdvance: n.int16,
                yAdvance: n.int16,
                xPlaDevice: new n.Pointer(n.uint16, nr, {
                  type: "global",
                  relativeTo: function(W) {
                    return W.rel;
                  }
                }),
                yPlaDevice: new n.Pointer(n.uint16, nr, {
                  type: "global",
                  relativeTo: function(W) {
                    return W.rel;
                  }
                }),
                xAdvDevice: new n.Pointer(n.uint16, nr, {
                  type: "global",
                  relativeTo: function(W) {
                    return W.rel;
                  }
                }),
                yAdvDevice: new n.Pointer(n.uint16, nr, {
                  type: "global",
                  relativeTo: function(W) {
                    return W.rel;
                  }
                })
              }, Ie = /* @__PURE__ */ function() {
                function at($) {
                  $ === void 0 && ($ = "valueFormat"), this.key = $;
                }
                var W = at.prototype;
                return W.buildStruct = function(R) {
                  for (var k = R; !k[this.key] && k.parent; )
                    k = k.parent;
                  if (k[this.key]) {
                    var H = {};
                    H.rel = function() {
                      return k._startOffset;
                    };
                    var ot = k[this.key];
                    for (var ct in ot)
                      ot[ct] && (H[ct] = Oe[ct]);
                    return new n.Struct(H);
                  }
                }, W.size = function(R, k) {
                  return this.buildStruct(k).size(R, k);
                }, W.decode = function(R, k) {
                  var H = this.buildStruct(k).decode(R, k);
                  return delete H.rel, H;
                }, at;
              }(), Ne = new n.Struct({
                secondGlyph: n.uint16,
                value1: new Ie("valueFormat1"),
                value2: new Ie("valueFormat2")
              }), Qe = new n.Array(Ne, n.uint16), rr = new n.Struct({
                value1: new Ie("valueFormat1"),
                value2: new Ie("valueFormat2")
              }), cr = new n.VersionedStruct(n.uint16, {
                1: {
                  // Design units only
                  xCoordinate: n.int16,
                  yCoordinate: n.int16
                },
                2: {
                  // Design units plus contour point
                  xCoordinate: n.int16,
                  yCoordinate: n.int16,
                  anchorPoint: n.uint16
                },
                3: {
                  // Design units plus Device tables
                  xCoordinate: n.int16,
                  yCoordinate: n.int16,
                  xDeviceTable: new n.Pointer(n.uint16, nr),
                  yDeviceTable: new n.Pointer(n.uint16, nr)
                }
              }), N = new n.Struct({
                entryAnchor: new n.Pointer(n.uint16, cr, {
                  type: "parent"
                }),
                exitAnchor: new n.Pointer(n.uint16, cr, {
                  type: "parent"
                })
              }), q = new n.Struct({
                class: n.uint16,
                markAnchor: new n.Pointer(n.uint16, cr, {
                  type: "parent"
                })
              }), pt = new n.Array(q, n.uint16), Ot = new n.Array(new n.Pointer(n.uint16, cr), function(at) {
                return at.parent.classCount;
              }), Wt = new n.Array(Ot, n.uint16), le = new n.Array(new n.Pointer(n.uint16, cr), function(at) {
                return at.parent.parent.classCount;
              }), ce = new n.Array(le, n.uint16), be = new n.Array(new n.Pointer(n.uint16, ce), n.uint16), Ge = new n.VersionedStruct("lookupType", {
                1: new n.VersionedStruct(n.uint16, {
                  // Single Adjustment
                  1: {
                    // Single positioning value
                    coverage: new n.Pointer(n.uint16, je),
                    valueFormat: Ae,
                    value: new Ie()
                  },
                  2: {
                    coverage: new n.Pointer(n.uint16, je),
                    valueFormat: Ae,
                    valueCount: n.uint16,
                    values: new n.LazyArray(new Ie(), "valueCount")
                  }
                }),
                2: new n.VersionedStruct(n.uint16, {
                  // Pair Adjustment Positioning
                  1: {
                    // Adjustments for glyph pairs
                    coverage: new n.Pointer(n.uint16, je),
                    valueFormat1: Ae,
                    valueFormat2: Ae,
                    pairSetCount: n.uint16,
                    pairSets: new n.LazyArray(new n.Pointer(n.uint16, Qe), "pairSetCount")
                  },
                  2: {
                    // Class pair adjustment
                    coverage: new n.Pointer(n.uint16, je),
                    valueFormat1: Ae,
                    valueFormat2: Ae,
                    classDef1: new n.Pointer(n.uint16, vr),
                    classDef2: new n.Pointer(n.uint16, vr),
                    class1Count: n.uint16,
                    class2Count: n.uint16,
                    classRecords: new n.LazyArray(new n.LazyArray(rr, "class2Count"), "class1Count")
                  }
                }),
                3: {
                  // Cursive Attachment Positioning
                  format: n.uint16,
                  coverage: new n.Pointer(n.uint16, je),
                  entryExitCount: n.uint16,
                  entryExitRecords: new n.Array(N, "entryExitCount")
                },
                4: {
                  // MarkToBase Attachment Positioning
                  format: n.uint16,
                  markCoverage: new n.Pointer(n.uint16, je),
                  baseCoverage: new n.Pointer(n.uint16, je),
                  classCount: n.uint16,
                  markArray: new n.Pointer(n.uint16, pt),
                  baseArray: new n.Pointer(n.uint16, Wt)
                },
                5: {
                  // MarkToLigature Attachment Positioning
                  format: n.uint16,
                  markCoverage: new n.Pointer(n.uint16, je),
                  ligatureCoverage: new n.Pointer(n.uint16, je),
                  classCount: n.uint16,
                  markArray: new n.Pointer(n.uint16, pt),
                  ligatureArray: new n.Pointer(n.uint16, be)
                },
                6: {
                  // MarkToMark Attachment Positioning
                  format: n.uint16,
                  mark1Coverage: new n.Pointer(n.uint16, je),
                  mark2Coverage: new n.Pointer(n.uint16, je),
                  classCount: n.uint16,
                  mark1Array: new n.Pointer(n.uint16, pt),
                  mark2Array: new n.Pointer(n.uint16, Wt)
                },
                7: yr,
                // Contextual positioning
                8: gn,
                // Chaining contextual positioning
                9: {
                  // Extension Positioning
                  posFormat: n.uint16,
                  lookupType: n.uint16,
                  // cannot also be 9
                  extension: new n.Pointer(n.uint32, Ge)
                }
              });
              Ge.versions[9].extension.type = Ge;
              var er = new n.VersionedStruct(n.uint32, {
                header: {
                  scriptList: new n.Pointer(n.uint16, ie),
                  featureList: new n.Pointer(n.uint16, ue),
                  lookupList: new n.Pointer(n.uint16, new ke(Ge))
                },
                65536: {},
                65537: {
                  featureVariations: new n.Pointer(n.uint32, vi)
                }
              }), br = new n.Array(n.uint16, n.uint16), Nr = br, hr = new n.Struct({
                glyph: n.uint16,
                compCount: n.uint16,
                components: new n.Array(n.uint16, function(at) {
                  return at.compCount - 1;
                })
              }), ir = new n.Array(new n.Pointer(n.uint16, hr), n.uint16), ur = new n.VersionedStruct("lookupType", {
                1: new n.VersionedStruct(n.uint16, {
                  // Single Substitution
                  1: {
                    coverage: new n.Pointer(n.uint16, je),
                    deltaGlyphID: n.int16
                  },
                  2: {
                    coverage: new n.Pointer(n.uint16, je),
                    glyphCount: n.uint16,
                    substitute: new n.LazyArray(n.uint16, "glyphCount")
                  }
                }),
                2: {
                  // Multiple Substitution
                  substFormat: n.uint16,
                  coverage: new n.Pointer(n.uint16, je),
                  count: n.uint16,
                  sequences: new n.LazyArray(new n.Pointer(n.uint16, br), "count")
                },
                3: {
                  // Alternate Substitution
                  substFormat: n.uint16,
                  coverage: new n.Pointer(n.uint16, je),
                  count: n.uint16,
                  alternateSet: new n.LazyArray(new n.Pointer(n.uint16, Nr), "count")
                },
                4: {
                  // Ligature Substitution
                  substFormat: n.uint16,
                  coverage: new n.Pointer(n.uint16, je),
                  count: n.uint16,
                  ligatureSets: new n.LazyArray(new n.Pointer(n.uint16, ir), "count")
                },
                5: yr,
                // Contextual Substitution
                6: gn,
                // Chaining Contextual Substitution
                7: {
                  // Extension Substitution
                  substFormat: n.uint16,
                  lookupType: n.uint16,
                  // cannot also be 7
                  extension: new n.Pointer(n.uint32, ur)
                },
                8: {
                  // Reverse Chaining Contextual Single Substitution
                  substFormat: n.uint16,
                  coverage: new n.Pointer(n.uint16, je),
                  backtrackCoverage: new n.Array(new n.Pointer(n.uint16, je), "backtrackGlyphCount"),
                  lookaheadGlyphCount: n.uint16,
                  lookaheadCoverage: new n.Array(new n.Pointer(n.uint16, je), "lookaheadGlyphCount"),
                  glyphCount: n.uint16,
                  substitutes: new n.Array(n.uint16, "glyphCount")
                }
              });
              ur.versions[7].extension.type = ur;
              var rn = new n.VersionedStruct(n.uint32, {
                header: {
                  scriptList: new n.Pointer(n.uint16, ie),
                  featureList: new n.Pointer(n.uint16, ue),
                  lookupList: new n.Pointer(n.uint16, new ke(ur))
                },
                65536: {},
                65537: {
                  featureVariations: new n.Pointer(n.uint32, vi)
                }
              }), Pn = new n.Array(n.uint16, n.uint16), li = new n.Struct({
                shrinkageEnableGSUB: new n.Pointer(n.uint16, Pn),
                shrinkageDisableGSUB: new n.Pointer(n.uint16, Pn),
                shrinkageEnableGPOS: new n.Pointer(n.uint16, Pn),
                shrinkageDisableGPOS: new n.Pointer(n.uint16, Pn),
                shrinkageJstfMax: new n.Pointer(n.uint16, new ke(Ge)),
                extensionEnableGSUB: new n.Pointer(n.uint16, Pn),
                extensionDisableGSUB: new n.Pointer(n.uint16, Pn),
                extensionEnableGPOS: new n.Pointer(n.uint16, Pn),
                extensionDisableGPOS: new n.Pointer(n.uint16, Pn),
                extensionJstfMax: new n.Pointer(n.uint16, new ke(Ge))
              }), ii = new n.Array(new n.Pointer(n.uint16, li), n.uint16), fi = new n.Struct({
                tag: new n.String(4),
                jstfLangSys: new n.Pointer(n.uint16, ii)
              }), Vi = new n.Struct({
                extenderGlyphs: new n.Pointer(n.uint16, new n.Array(n.uint16, n.uint16)),
                // array of glyphs to extend line length
                defaultLangSys: new n.Pointer(n.uint16, ii),
                langSysCount: n.uint16,
                langSysRecords: new n.Array(fi, "langSysCount")
              }), gi = new n.Struct({
                tag: new n.String(4),
                script: new n.Pointer(n.uint16, Vi, {
                  type: "parent"
                })
              }), Hi = new n.Struct({
                version: n.uint32,
                // should be 0x00010000
                scriptCount: n.uint16,
                scriptList: new n.Array(gi, "scriptCount")
              }), Gn = /* @__PURE__ */ function() {
                function at($) {
                  this._size = $;
                }
                var W = at.prototype;
                return W.decode = function(R, k) {
                  switch (this.size(0, k)) {
                    case 1:
                      return R.readUInt8();
                    case 2:
                      return R.readUInt16BE();
                    case 3:
                      return R.readUInt24BE();
                    case 4:
                      return R.readUInt32BE();
                  }
                }, W.size = function(R, k) {
                  return w.resolveLength(this._size, null, k);
                }, at;
              }(), Is = new n.Struct({
                entry: new Gn(function(at) {
                  return ((at.parent.entryFormat & 48) >> 4) + 1;
                }),
                outerIndex: function(W) {
                  return W.entry >> (W.parent.entryFormat & 15) + 1;
                },
                innerIndex: function(W) {
                  return W.entry & (1 << (W.parent.entryFormat & 15) + 1) - 1;
                }
              }), Ki = new n.Struct({
                entryFormat: n.uint16,
                mapCount: n.uint16,
                mapData: new n.Array(Is, "mapCount")
              }), Rs = new n.Struct({
                majorVersion: n.uint16,
                minorVersion: n.uint16,
                itemVariationStore: new n.Pointer(n.uint32, qe),
                advanceWidthMapping: new n.Pointer(n.uint32, Ki),
                LSBMapping: new n.Pointer(n.uint32, Ki),
                RSBMapping: new n.Pointer(n.uint32, Ki)
              }), pa = new n.Struct({
                format: n.uint32,
                length: n.uint32,
                offset: n.uint32
              }), tu = new n.Struct({
                reserved: new n.Reserved(n.uint16, 2),
                cbSignature: n.uint32,
                // Length (in bytes) of the PKCS#7 packet in pbSignature
                signature: new n.Buffer("cbSignature")
              }), eu = new n.Struct({
                ulVersion: n.uint32,
                // Version number of the DSIG table (0x00000001)
                usNumSigs: n.uint16,
                // Number of signatures in the table
                usFlag: n.uint16,
                // Permission flags
                signatures: new n.Array(pa, "usNumSigs"),
                signatureBlocks: new n.Array(tu, "usNumSigs")
              }), j2 = new n.Struct({
                rangeMaxPPEM: n.uint16,
                // Upper limit of range, in ppem
                rangeGaspBehavior: new n.Bitfield(n.uint16, [
                  // Flags describing desired rasterizer behavior
                  "grayscale",
                  "gridfit",
                  "symmetricSmoothing",
                  "symmetricGridfit"
                  // only in version 1, for ClearType
                ])
              }), X2 = new n.Struct({
                version: n.uint16,
                // set to 0
                numRanges: n.uint16,
                gaspRanges: new n.Array(j2, "numRanges")
                // Sorted by ppem
              }), Y2 = new n.Struct({
                pixelSize: n.uint8,
                maximumWidth: n.uint8,
                widths: new n.Array(n.uint8, function(at) {
                  return at.parent.parent.maxp.numGlyphs;
                })
              }), Z2 = new n.Struct({
                version: n.uint16,
                numRecords: n.int16,
                sizeDeviceRecord: n.int32,
                records: new n.Array(Y2, "numRecords")
              }), K2 = new n.Struct({
                left: n.uint16,
                right: n.uint16,
                value: n.int16
              }), wc = new n.Struct({
                firstGlyph: n.uint16,
                nGlyphs: n.uint16,
                offsets: new n.Array(n.uint16, "nGlyphs"),
                max: function(W) {
                  return W.offsets.length && Math.max.apply(Math, W.offsets);
                }
              }), J2 = new n.Struct({
                off: function(W) {
                  return W._startOffset - W.parent.parent._startOffset;
                },
                len: function(W) {
                  return ((W.parent.leftTable.max - W.off) / W.parent.rowWidth + 1) * (W.parent.rowWidth / 2);
                },
                values: new n.LazyArray(n.int16, "len")
              }), Sc = new n.VersionedStruct("format", {
                0: {
                  nPairs: n.uint16,
                  searchRange: n.uint16,
                  entrySelector: n.uint16,
                  rangeShift: n.uint16,
                  pairs: new n.Array(K2, "nPairs")
                },
                2: {
                  rowWidth: n.uint16,
                  leftTable: new n.Pointer(n.uint16, wc, {
                    type: "parent"
                  }),
                  rightTable: new n.Pointer(n.uint16, wc, {
                    type: "parent"
                  }),
                  array: new n.Pointer(n.uint16, J2, {
                    type: "parent"
                  })
                },
                3: {
                  glyphCount: n.uint16,
                  kernValueCount: n.uint8,
                  leftClassCount: n.uint8,
                  rightClassCount: n.uint8,
                  flags: n.uint8,
                  kernValue: new n.Array(n.int16, "kernValueCount"),
                  leftClass: new n.Array(n.uint8, "glyphCount"),
                  rightClass: new n.Array(n.uint8, "glyphCount"),
                  kernIndex: new n.Array(n.uint8, function(at) {
                    return at.leftClassCount * at.rightClassCount;
                  })
                }
              }), Ec = new n.VersionedStruct("version", {
                0: {
                  // Microsoft uses this format
                  subVersion: n.uint16,
                  // Microsoft has an extra sub-table version number
                  length: n.uint16,
                  // Length of the subtable, in bytes
                  format: n.uint8,
                  // Format of subtable
                  coverage: new n.Bitfield(n.uint8, [
                    "horizontal",
                    // 1 if table has horizontal data, 0 if vertical
                    "minimum",
                    // If set to 1, the table has minimum values. If set to 0, the table has kerning values.
                    "crossStream",
                    // If set to 1, kerning is perpendicular to the flow of the text
                    "override"
                    // If set to 1 the value in this table replaces the accumulated value
                  ]),
                  subtable: Sc,
                  padding: new n.Reserved(n.uint8, function(at) {
                    return at.length - at._currentOffset;
                  })
                },
                1: {
                  // Apple uses this format
                  length: n.uint32,
                  coverage: new n.Bitfield(n.uint8, [
                    null,
                    null,
                    null,
                    null,
                    null,
                    "variation",
                    // Set if table has variation kerning values
                    "crossStream",
                    // Set if table has cross-stream kerning values
                    "vertical"
                    // Set if table has vertical kerning values
                  ]),
                  format: n.uint8,
                  tupleIndex: n.uint16,
                  subtable: Sc,
                  padding: new n.Reserved(n.uint8, function(at) {
                    return at.length - at._currentOffset;
                  })
                }
              }), Q2 = new n.VersionedStruct(n.uint16, {
                0: {
                  // Microsoft Version
                  nTables: n.uint16,
                  tables: new n.Array(Ec, "nTables")
                },
                1: {
                  // Apple Version
                  reserved: new n.Reserved(n.uint16),
                  // the other half of the version number
                  nTables: n.uint32,
                  tables: new n.Array(Ec, "nTables")
                }
              }), $2 = new n.Struct({
                version: n.uint16,
                numGlyphs: n.uint16,
                yPels: new n.Array(n.uint8, "numGlyphs")
              }), q2 = new n.Struct({
                version: n.uint16,
                fontNumber: n.uint32,
                pitch: n.uint16,
                xHeight: n.uint16,
                style: n.uint16,
                typeFamily: n.uint16,
                capHeight: n.uint16,
                symbolSet: n.uint16,
                typeface: new n.String(16),
                characterComplement: new n.String(8),
                fileName: new n.String(6),
                strokeWeight: new n.String(1),
                widthType: new n.String(1),
                serifStyle: n.uint8,
                reserved: new n.Reserved(n.uint8)
              }), tp = new n.Struct({
                bCharSet: n.uint8,
                // Character set
                xRatio: n.uint8,
                // Value to use for x-Ratio
                yStartRatio: n.uint8,
                // Starting y-Ratio value
                yEndRatio: n.uint8
                // Ending y-Ratio value
              }), ep = new n.Struct({
                yPelHeight: n.uint16,
                // yPelHeight to which values apply
                yMax: n.int16,
                // Maximum value (in pels) for this yPelHeight
                yMin: n.int16
                // Minimum value (in pels) for this yPelHeight
              }), rp = new n.Struct({
                recs: n.uint16,
                // Number of height records in this group
                startsz: n.uint8,
                // Starting yPelHeight
                endsz: n.uint8,
                // Ending yPelHeight
                entries: new n.Array(ep, "recs")
                // The VDMX records
              }), np = new n.Struct({
                version: n.uint16,
                // Version number (0 or 1)
                numRecs: n.uint16,
                // Number of VDMX groups present
                numRatios: n.uint16,
                // Number of aspect ratio groupings
                ratioRanges: new n.Array(tp, "numRatios"),
                // Ratio ranges
                offsets: new n.Array(n.uint16, "numRatios"),
                // Offset to the VDMX group for this ratio range
                groups: new n.Array(rp, "numRecs")
                // The actual VDMX groupings
              }), ip = new n.Struct({
                version: n.uint16,
                // Version number of the Vertical Header Table
                ascent: n.int16,
                // The vertical typographic ascender for this font
                descent: n.int16,
                // The vertical typographic descender for this font
                lineGap: n.int16,
                // The vertical typographic line gap for this font
                advanceHeightMax: n.int16,
                // The maximum advance height measurement found in the font
                minTopSideBearing: n.int16,
                // The minimum top side bearing measurement found in the font
                minBottomSideBearing: n.int16,
                // The minimum bottom side bearing measurement found in the font
                yMaxExtent: n.int16,
                caretSlopeRise: n.int16,
                // Caret slope (rise/run)
                caretSlopeRun: n.int16,
                caretOffset: n.int16,
                // Set value equal to 0 for nonslanted fonts
                reserved: new n.Reserved(n.int16, 4),
                metricDataFormat: n.int16,
                // Set to 0
                numberOfMetrics: n.uint16
                // Number of advance heights in the Vertical Metrics table
              }), ap = new n.Struct({
                advance: n.uint16,
                // The advance height of the glyph
                bearing: n.int16
                // The top sidebearing of the glyph
              }), op = new n.Struct({
                metrics: new n.LazyArray(ap, function(at) {
                  return at.parent.vhea.numberOfMetrics;
                }),
                bearings: new n.LazyArray(n.int16, function(at) {
                  return at.parent.maxp.numGlyphs - at.parent.vhea.numberOfMetrics;
                })
              }), Ac = new n.Fixed(16, "BE", 14), sp = new n.Struct({
                fromCoord: Ac,
                toCoord: Ac
              }), lp = new n.Struct({
                pairCount: n.uint16,
                correspondence: new n.Array(sp, "pairCount")
              }), fp = new n.Struct({
                version: n.fixed32,
                axisCount: n.uint32,
                segment: new n.Array(lp, "axisCount")
              }), up = /* @__PURE__ */ function() {
                function at($, R, k) {
                  this.type = $, this.stream = R, this.parent = k, this.base = this.stream.pos, this._items = [];
                }
                var W = at.prototype;
                return W.getItem = function(R) {
                  if (this._items[R] == null) {
                    var k = this.stream.pos;
                    this.stream.pos = this.base + this.type.size(null, this.parent) * R, this._items[R] = this.type.decode(this.stream, this.parent), this.stream.pos = k;
                  }
                  return this._items[R];
                }, W.inspect = function() {
                  return "[UnboundedArray ".concat(this.type.constructor.name, "]");
                }, at;
              }(), ia = /* @__PURE__ */ function(at) {
                m(W, at);
                function W(R) {
                  return at.call(this, R, 0) || this;
                }
                var $ = W.prototype;
                return $.decode = function(k, H) {
                  return new up(this.type, k, H);
                }, W;
              }(n.Array), za = function(W) {
                W === void 0 && (W = n.uint16);
                var $ = /* @__PURE__ */ function() {
                  function ct(ut) {
                    this.type = ut;
                  }
                  var ht = ct.prototype;
                  return ht.decode = function(Nt, Kt) {
                    return Kt = Kt.parent.parent, this.type.decode(Nt, Kt);
                  }, ht.size = function(Nt, Kt) {
                    return Kt = Kt.parent.parent, this.type.size(Nt, Kt);
                  }, ht.encode = function(Nt, Kt, de) {
                    return de = de.parent.parent, this.type.encode(Nt, Kt, de);
                  }, ct;
                }();
                W = new $(W);
                var R = new n.Struct({
                  unitSize: n.uint16,
                  nUnits: n.uint16,
                  searchRange: n.uint16,
                  entrySelector: n.uint16,
                  rangeShift: n.uint16
                }), k = new n.Struct({
                  lastGlyph: n.uint16,
                  firstGlyph: n.uint16,
                  value: W
                }), H = new n.Struct({
                  lastGlyph: n.uint16,
                  firstGlyph: n.uint16,
                  values: new n.Pointer(n.uint16, new n.Array(W, function(ct) {
                    return ct.lastGlyph - ct.firstGlyph + 1;
                  }), {
                    type: "parent"
                  })
                }), ot = new n.Struct({
                  glyph: n.uint16,
                  value: W
                });
                return new n.VersionedStruct(n.uint16, {
                  0: {
                    values: new ia(W)
                    // length == number of glyphs maybe?
                  },
                  2: {
                    binarySearchHeader: R,
                    segments: new n.Array(k, function(ct) {
                      return ct.binarySearchHeader.nUnits;
                    })
                  },
                  4: {
                    binarySearchHeader: R,
                    segments: new n.Array(H, function(ct) {
                      return ct.binarySearchHeader.nUnits;
                    })
                  },
                  6: {
                    binarySearchHeader: R,
                    segments: new n.Array(ot, function(ct) {
                      return ct.binarySearchHeader.nUnits;
                    })
                  },
                  8: {
                    firstGlyph: n.uint16,
                    count: n.uint16,
                    values: new n.Array(W, "count")
                  }
                });
              };
              function B0(at, W) {
                at === void 0 && (at = {}), W === void 0 && (W = n.uint16);
                var $ = Object.assign({
                  newState: n.uint16,
                  flags: n.uint16
                }, at), R = new n.Struct($), k = new ia(new n.Array(n.uint16, function(ot) {
                  return ot.nClasses;
                })), H = new n.Struct({
                  nClasses: n.uint32,
                  classTable: new n.Pointer(n.uint32, new za(W)),
                  stateArray: new n.Pointer(n.uint32, k),
                  entryTable: new n.Pointer(n.uint32, new ia(R))
                });
                return H;
              }
              function hp(at, W) {
                at === void 0 && (at = {}), W === void 0 && (W = n.uint16);
                var $ = new n.Struct({
                  version: function() {
                    return 8;
                  },
                  // simulate LookupTable
                  firstGlyph: n.uint16,
                  values: new n.Array(n.uint8, n.uint16)
                }), R = Object.assign({
                  newStateOffset: n.uint16,
                  // convert offset to stateArray index
                  newState: function(ht) {
                    return (ht.newStateOffset - (ht.parent.stateArray.base - ht.parent._startOffset)) / ht.parent.nClasses;
                  },
                  flags: n.uint16
                }, at), k = new n.Struct(R), H = new ia(new n.Array(n.uint8, function(ct) {
                  return ct.nClasses;
                })), ot = new n.Struct({
                  nClasses: n.uint16,
                  classTable: new n.Pointer(n.uint16, $),
                  stateArray: new n.Pointer(n.uint16, H),
                  entryTable: new n.Pointer(n.uint16, new ia(k))
                });
                return ot;
              }
              var cp = new n.VersionedStruct("format", {
                0: {
                  // Distance-based, no mapping
                  deltas: new n.Array(n.int16, 32)
                },
                1: {
                  // Distance-based, with mapping
                  deltas: new n.Array(n.int16, 32),
                  mappingData: new za(n.uint16)
                },
                2: {
                  // Control point-based, no mapping
                  standardGlyph: n.uint16,
                  controlPoints: new n.Array(n.uint16, 32)
                },
                3: {
                  // Control point-based, with mapping
                  standardGlyph: n.uint16,
                  controlPoints: new n.Array(n.uint16, 32),
                  mappingData: new za(n.uint16)
                }
              }), dp = new n.Struct({
                version: n.fixed32,
                format: n.uint16,
                defaultBaseline: n.uint16,
                subtable: cp
              }), vp = new n.Struct({
                setting: n.uint16,
                nameIndex: n.int16,
                name: function(W) {
                  return W.parent.parent.parent.name.records.fontFeatures[W.nameIndex];
                }
              }), gp = new n.Struct({
                feature: n.uint16,
                nSettings: n.uint16,
                settingTable: new n.Pointer(n.uint32, new n.Array(vp, "nSettings"), {
                  type: "parent"
                }),
                featureFlags: new n.Bitfield(n.uint8, [null, null, null, null, null, null, "hasDefault", "exclusive"]),
                defaultSetting: n.uint8,
                nameIndex: n.int16,
                name: function(W) {
                  return W.parent.parent.name.records.fontFeatures[W.nameIndex];
                }
              }), pp = new n.Struct({
                version: n.fixed32,
                featureNameCount: n.uint16,
                reserved1: new n.Reserved(n.uint16),
                reserved2: new n.Reserved(n.uint32),
                featureNames: new n.Array(gp, "featureNameCount")
              }), yp = new n.Struct({
                axisTag: new n.String(4),
                minValue: n.fixed32,
                defaultValue: n.fixed32,
                maxValue: n.fixed32,
                flags: n.uint16,
                nameID: n.uint16,
                name: function(W) {
                  return W.parent.parent.name.records.fontFeatures[W.nameID];
                }
              }), mp = new n.Struct({
                nameID: n.uint16,
                name: function(W) {
                  return W.parent.parent.name.records.fontFeatures[W.nameID];
                },
                flags: n.uint16,
                coord: new n.Array(n.fixed32, function(at) {
                  return at.parent.axisCount;
                }),
                postscriptNameID: new n.Optional(n.uint16, function(at) {
                  return at.parent.instanceSize - at._currentOffset > 0;
                })
              }), xp = new n.Struct({
                version: n.fixed32,
                offsetToData: n.uint16,
                countSizePairs: n.uint16,
                axisCount: n.uint16,
                axisSize: n.uint16,
                instanceCount: n.uint16,
                instanceSize: n.uint16,
                axis: new n.Array(yp, "axisCount"),
                instance: new n.Array(mp, "instanceCount")
              }), bp = new n.Fixed(16, "BE", 14), wp = /* @__PURE__ */ function() {
                function at() {
                }
                return at.decode = function($, R) {
                  return R.flags ? $.readUInt32BE() : $.readUInt16BE() * 2;
                }, at;
              }(), Sp = new n.Struct({
                version: n.uint16,
                reserved: new n.Reserved(n.uint16),
                axisCount: n.uint16,
                globalCoordCount: n.uint16,
                globalCoords: new n.Pointer(n.uint32, new n.Array(new n.Array(bp, "axisCount"), "globalCoordCount")),
                glyphCount: n.uint16,
                flags: n.uint16,
                offsetToData: n.uint32,
                offsets: new n.Array(new n.Pointer(wp, "void", {
                  relativeTo: function(W) {
                    return W.offsetToData;
                  },
                  allowNull: !1
                }), function(at) {
                  return at.glyphCount + 1;
                })
              }), Ep = new n.Struct({
                length: n.uint16,
                coverage: n.uint16,
                subFeatureFlags: n.uint32,
                stateTable: new hp()
              }), Ap = new n.Struct({
                justClass: n.uint32,
                beforeGrowLimit: n.fixed32,
                beforeShrinkLimit: n.fixed32,
                afterGrowLimit: n.fixed32,
                afterShrinkLimit: n.fixed32,
                growFlags: n.uint16,
                shrinkFlags: n.uint16
              }), Cp = new n.Array(Ap, n.uint32), Tp = new n.VersionedStruct("actionType", {
                0: {
                  // Decomposition action
                  lowerLimit: n.fixed32,
                  upperLimit: n.fixed32,
                  order: n.uint16,
                  glyphs: new n.Array(n.uint16, n.uint16)
                },
                1: {
                  // Unconditional add glyph action
                  addGlyph: n.uint16
                },
                2: {
                  // Conditional add glyph action
                  substThreshold: n.fixed32,
                  addGlyph: n.uint16,
                  substGlyph: n.uint16
                },
                3: {},
                // Stretch glyph action (no data, not supported by CoreText)
                4: {
                  // Ductile glyph action (not supported by CoreText)
                  variationAxis: n.uint32,
                  minimumLimit: n.fixed32,
                  noStretchValue: n.fixed32,
                  maximumLimit: n.fixed32
                },
                5: {
                  // Repeated add glyph action
                  flags: n.uint16,
                  glyph: n.uint16
                }
              }), Pp = new n.Struct({
                actionClass: n.uint16,
                actionType: n.uint16,
                actionLength: n.uint32,
                actionData: Tp,
                padding: new n.Reserved(n.uint8, function(at) {
                  return at.actionLength - at._currentOffset;
                })
              }), Op = new n.Array(Pp, n.uint32), Fp = new n.Struct({
                lookupTable: new za(new n.Pointer(n.uint16, Op))
              }), Cc = new n.Struct({
                classTable: new n.Pointer(n.uint16, Ep, {
                  type: "parent"
                }),
                wdcOffset: n.uint16,
                postCompensationTable: new n.Pointer(n.uint16, Fp, {
                  type: "parent"
                }),
                widthDeltaClusters: new za(new n.Pointer(n.uint16, Cp, {
                  type: "parent",
                  relativeTo: function(W) {
                    return W.wdcOffset;
                  }
                }))
              }), Ip = new n.Struct({
                version: n.uint32,
                format: n.uint16,
                horizontal: new n.Pointer(n.uint16, Cc),
                vertical: new n.Pointer(n.uint16, Cc)
              }), Rp = {
                action: n.uint16
              }, Dp = {
                markIndex: n.uint16,
                currentIndex: n.uint16
              }, Mp = {
                currentInsertIndex: n.uint16,
                markedInsertIndex: n.uint16
              }, Bp = new n.Struct({
                items: new ia(new n.Pointer(n.uint32, new za()))
              }), kp = new n.VersionedStruct("type", {
                0: {
                  // Indic Rearrangement Subtable
                  stateTable: new B0()
                },
                1: {
                  // Contextual Glyph Substitution Subtable
                  stateTable: new B0(Dp),
                  substitutionTable: new n.Pointer(n.uint32, Bp)
                },
                2: {
                  // Ligature subtable
                  stateTable: new B0(Rp),
                  ligatureActions: new n.Pointer(n.uint32, new ia(n.uint32)),
                  components: new n.Pointer(n.uint32, new ia(n.uint16)),
                  ligatureList: new n.Pointer(n.uint32, new ia(n.uint16))
                },
                4: {
                  // Non-contextual Glyph Substitution Subtable
                  lookupTable: new za()
                },
                5: {
                  // Glyph Insertion Subtable
                  stateTable: new B0(Mp),
                  insertionActions: new n.Pointer(n.uint32, new ia(n.uint16))
                }
              }), Np = new n.Struct({
                length: n.uint32,
                coverage: n.uint24,
                type: n.uint8,
                subFeatureFlags: n.uint32,
                table: kp,
                padding: new n.Reserved(n.uint8, function(at) {
                  return at.length - at._currentOffset;
                })
              }), Lp = new n.Struct({
                featureType: n.uint16,
                featureSetting: n.uint16,
                enableFlags: n.uint32,
                disableFlags: n.uint32
              }), Up = new n.Struct({
                defaultFlags: n.uint32,
                chainLength: n.uint32,
                nFeatureEntries: n.uint32,
                nSubtables: n.uint32,
                features: new n.Array(Lp, "nFeatureEntries"),
                subtables: new n.Array(Np, "nSubtables")
              }), zp = new n.Struct({
                version: n.uint16,
                unused: new n.Reserved(n.uint16),
                nChains: n.uint32,
                chains: new n.Array(Up, "nChains")
              }), Gp = new n.Struct({
                left: n.int16,
                top: n.int16,
                right: n.int16,
                bottom: n.int16
              }), Vp = new n.Struct({
                version: n.fixed32,
                format: n.uint16,
                lookupTable: new za(Gp)
              }), Ar = {};
              Ar.cmap = X, Ar.head = gt, Ar.hhea = st, Ar.hmtx = wt, Ar.maxp = Ft, Ar.name = lt, Ar["OS/2"] = kt, Ar.post = me, Ar.fpgm = Bt, Ar.loca = ge, Ar.prep = Re, Ar["cvt "] = se, Ar.glyf = Te, Ar["CFF "] = We, Ar.CFF2 = We, Ar.VORG = Ke, Ar.EBLC = qn, Ar.CBLC = Ar.EBLC, Ar.sbix = $r, Ar.COLR = Nn, Ar.CPAL = Na, Ar.BASE = U, Ar.GDEF = ye, Ar.GPOS = er, Ar.GSUB = rn, Ar.JSTF = Hi, Ar.HVAR = Rs, Ar.DSIG = eu, Ar.gasp = X2, Ar.hdmx = Z2, Ar.kern = Q2, Ar.LTSH = $2, Ar.PCLT = q2, Ar.VDMX = np, Ar.vhea = ip, Ar.vmtx = op, Ar.avar = fp, Ar.bsln = dp, Ar.feat = pp, Ar.fvar = xp, Ar.gvar = Sp, Ar.just = Ip, Ar.morx = zp, Ar.opbd = Vp;
              var Hp = new n.Struct({
                tag: new n.String(4),
                checkSum: n.uint32,
                offset: new n.Pointer(n.uint32, "void", {
                  type: "global"
                }),
                length: n.uint32
              }), k0 = new n.Struct({
                tag: new n.String(4),
                numTables: n.uint16,
                searchRange: n.uint16,
                entrySelector: n.uint16,
                rangeShift: n.uint16,
                tables: new n.Array(Hp, "numTables")
              });
              k0.process = function() {
                for (var at = {}, W = g(this.tables), $; !($ = W()).done; ) {
                  var R = $.value;
                  at[R.tag] = R;
                }
                this.tables = at;
              }, k0.preEncode = function(at) {
                var W = [];
                for (var $ in this.tables) {
                  var R = this.tables[$];
                  R && W.push({
                    tag: $,
                    checkSum: 0,
                    offset: new n.VoidPointer(Ar[$], R),
                    length: Ar[$].size(R)
                  });
                }
                this.tag = "true", this.numTables = W.length, this.tables = W;
                var k = Math.floor(Math.log(this.numTables) / Math.LN2), H = Math.pow(2, k);
                this.searchRange = H * 16, this.entrySelector = Math.log(H) / Math.LN2, this.rangeShift = this.numTables * 16 - this.searchRange;
              };
              function N0(at, W) {
                for (var $ = 0, R = at.length - 1; $ <= R; ) {
                  var k = $ + R >> 1, H = W(at[k]);
                  if (H < 0)
                    R = k - 1;
                  else if (H > 0)
                    $ = k + 1;
                  else
                    return k;
                }
                return -1;
              }
              function jo(at, W) {
                for (var $ = []; at < W; )
                  $.push(at++);
                return $;
              }
              var Ga;
              try {
                var ru = e(54171);
              } catch {
              }
              var Wp = (Ga = /* @__PURE__ */ function() {
                function at($) {
                  if (this.encoding = null, this.cmap = this.findSubtable($, [
                    // 32-bit subtables
                    [3, 10],
                    [0, 6],
                    [0, 4],
                    // 16-bit subtables
                    [3, 1],
                    [0, 3],
                    [0, 2],
                    [0, 1],
                    [0, 0]
                  ]), !this.cmap && ru)
                    for (var R = g($.tables), k; !(k = R()).done; ) {
                      var H = k.value, ot = zt(H.platformID, H.encodingID, H.table.language - 1);
                      ru.encodingExists(ot) && (this.cmap = H.table, this.encoding = ot);
                    }
                  if (!this.cmap)
                    throw new Error("Could not find a supported cmap table");
                  this.uvs = this.findSubtable($, [[0, 5]]), this.uvs && this.uvs.version !== 14 && (this.uvs = null);
                }
                var W = at.prototype;
                return W.findSubtable = function(R, k) {
                  for (var H = g(k), ot; !(ot = H()).done; )
                    for (var ct = ot.value, ht = ct[0], ut = ct[1], Nt = g(R.tables), Kt; !(Kt = Nt()).done; ) {
                      var de = Kt.value;
                      if (de.platformID === ht && de.encodingID === ut)
                        return de.table;
                    }
                  return null;
                }, W.lookup = function(R, k) {
                  if (this.encoding) {
                    var H = ru.encode(String.fromCodePoint(R), this.encoding);
                    R = 0;
                    for (var ot = 0; ot < H.length; ot++)
                      R = R << 8 | H[ot];
                  } else if (k) {
                    var ct = this.getVariationSelector(R, k);
                    if (ct)
                      return ct;
                  }
                  var ht = this.cmap;
                  switch (ht.version) {
                    case 0:
                      return ht.codeMap.get(R) || 0;
                    case 4: {
                      for (var ut = 0, Nt = ht.segCount - 1; ut <= Nt; ) {
                        var Kt = ut + Nt >> 1;
                        if (R < ht.startCode.get(Kt))
                          Nt = Kt - 1;
                        else if (R > ht.endCode.get(Kt))
                          ut = Kt + 1;
                        else {
                          var de = ht.idRangeOffset.get(Kt), te = void 0;
                          if (de === 0)
                            te = R + ht.idDelta.get(Kt);
                          else {
                            var pe = de / 2 + (R - ht.startCode.get(Kt)) - (ht.segCount - Kt);
                            te = ht.glyphIndexArray.get(pe) || 0, te !== 0 && (te += ht.idDelta.get(Kt));
                          }
                          return te & 65535;
                        }
                      }
                      return 0;
                    }
                    case 8:
                      throw new Error("TODO: cmap format 8");
                    case 6:
                    case 10:
                      return ht.glyphIndices.get(R - ht.firstCode) || 0;
                    case 12:
                    case 13: {
                      for (var Ee = 0, Le = ht.nGroups - 1; Ee <= Le; ) {
                        var $e = Ee + Le >> 1, wr = ht.groups.get($e);
                        if (R < wr.startCharCode)
                          Le = $e - 1;
                        else if (R > wr.endCharCode)
                          Ee = $e + 1;
                        else
                          return ht.version === 12 ? wr.glyphID + (R - wr.startCharCode) : wr.glyphID;
                      }
                      return 0;
                    }
                    case 14:
                      throw new Error("TODO: cmap format 14");
                    default:
                      throw new Error("Unknown cmap format ".concat(ht.version));
                  }
                }, W.getVariationSelector = function(R, k) {
                  if (!this.uvs)
                    return 0;
                  var H = this.uvs.varSelectors.toArray(), ot = N0(H, function(ht) {
                    return k - ht.varSelector;
                  }), ct = H[ot];
                  return ot !== -1 && ct.defaultUVS && (ot = N0(ct.defaultUVS, function(ht) {
                    return R < ht.startUnicodeValue ? -1 : R > ht.startUnicodeValue + ht.additionalCount ? 1 : 0;
                  })), ot !== -1 && ct.nonDefaultUVS && (ot = N0(ct.nonDefaultUVS, function(ht) {
                    return R - ht.unicodeValue;
                  }), ot !== -1) ? ct.nonDefaultUVS[ot].glyphID : 0;
                }, W.getCharacterSet = function() {
                  var R = this.cmap;
                  switch (R.version) {
                    case 0:
                      return jo(0, R.codeMap.length);
                    case 4: {
                      for (var k = [], H = R.endCode.toArray(), ot = 0; ot < H.length; ot++) {
                        var ct = H[ot] + 1, ht = R.startCode.get(ot);
                        k.push.apply(k, jo(ht, ct));
                      }
                      return k;
                    }
                    case 8:
                      throw new Error("TODO: cmap format 8");
                    case 6:
                    case 10:
                      return jo(R.firstCode, R.firstCode + R.glyphIndices.length);
                    case 12:
                    case 13: {
                      for (var ut = [], Nt = g(R.groups.toArray()), Kt; !(Kt = Nt()).done; ) {
                        var de = Kt.value;
                        ut.push.apply(ut, jo(de.startCharCode, de.endCharCode + 1));
                      }
                      return ut;
                    }
                    case 14:
                      throw new Error("TODO: cmap format 14");
                    default:
                      throw new Error("Unknown cmap format ".concat(R.version));
                  }
                }, W.codePointsForGlyph = function(R) {
                  var k = this.cmap;
                  switch (k.version) {
                    case 0: {
                      for (var H = [], ot = 0; ot < 256; ot++)
                        k.codeMap.get(ot) === R && H.push(ot);
                      return H;
                    }
                    case 4: {
                      for (var ct = [], ht = 0; ht < k.segCount; ht++)
                        for (var ut = k.endCode.get(ht), Nt = k.startCode.get(ht), Kt = k.idRangeOffset.get(ht), de = k.idDelta.get(ht), te = Nt; te <= ut; te++) {
                          var pe = 0;
                          if (Kt === 0)
                            pe = te + de;
                          else {
                            var Ee = Kt / 2 + (te - Nt) - (k.segCount - ht);
                            pe = k.glyphIndexArray.get(Ee) || 0, pe !== 0 && (pe += de);
                          }
                          pe === R && ct.push(te);
                        }
                      return ct;
                    }
                    case 12: {
                      for (var Le = [], $e = g(k.groups.toArray()), wr; !(wr = $e()).done; ) {
                        var or = wr.value;
                        R >= or.glyphID && R <= or.glyphID + (or.endCharCode - or.startCharCode) && Le.push(or.startCharCode + (R - or.glyphID));
                      }
                      return Le;
                    }
                    case 13: {
                      for (var Pr = [], Cr = g(k.groups.toArray()), Dr; !(Dr = Cr()).done; ) {
                        var Lr = Dr.value;
                        R === Lr.glyphID && Pr.push.apply(Pr, jo(Lr.startCharCode, Lr.endCharCode + 1));
                      }
                      return Pr;
                    }
                    default:
                      throw new Error("Unknown cmap format ".concat(k.version));
                  }
                }, at;
              }(), L(Ga.prototype, "getCharacterSet", [J], Object.getOwnPropertyDescriptor(Ga.prototype, "getCharacterSet"), Ga.prototype), L(Ga.prototype, "codePointsForGlyph", [J], Object.getOwnPropertyDescriptor(Ga.prototype, "codePointsForGlyph"), Ga.prototype), Ga), _p = /* @__PURE__ */ function() {
                function at($) {
                  this.kern = $.kern;
                }
                var W = at.prototype;
                return W.process = function(R, k) {
                  for (var H = 0; H < R.length - 1; H++) {
                    var ot = R[H].id, ct = R[H + 1].id;
                    k[H].xAdvance += this.getKerning(ot, ct);
                  }
                }, W.getKerning = function(R, k) {
                  for (var H = 0, ot = g(this.kern.tables), ct; !(ct = ot()).done; ) {
                    var ht = ct.value;
                    if (!ht.coverage.crossStream) {
                      switch (ht.version) {
                        case 0:
                          if (!ht.coverage.horizontal)
                            continue;
                          break;
                        case 1:
                          if (ht.coverage.vertical || ht.coverage.variation)
                            continue;
                          break;
                        default:
                          throw new Error("Unsupported kerning table version ".concat(ht.version));
                      }
                      var ut = 0, Nt = ht.subtable;
                      switch (ht.format) {
                        case 0:
                          var Kt = N0(Nt.pairs, function(Ee) {
                            return R - Ee.left || k - Ee.right;
                          });
                          Kt >= 0 && (ut = Nt.pairs[Kt].value);
                          break;
                        case 2:
                          var de = 0, te = 0;
                          R >= Nt.leftTable.firstGlyph && R < Nt.leftTable.firstGlyph + Nt.leftTable.nGlyphs ? de = Nt.leftTable.offsets[R - Nt.leftTable.firstGlyph] : de = Nt.array.off, k >= Nt.rightTable.firstGlyph && k < Nt.rightTable.firstGlyph + Nt.rightTable.nGlyphs && (te = Nt.rightTable.offsets[k - Nt.rightTable.firstGlyph]);
                          var pe = (de + te - Nt.array.off) / 2;
                          ut = Nt.array.values.get(pe);
                          break;
                        case 3:
                          if (R >= Nt.glyphCount || k >= Nt.glyphCount)
                            return 0;
                          ut = Nt.kernValue[Nt.kernIndex[Nt.leftClass[R] * Nt.rightClassCount + Nt.rightClass[k]]];
                          break;
                        default:
                          throw new Error("Unsupported kerning sub-table format ".concat(ht.format));
                      }
                      ht.coverage.override ? H = ut : H += ut;
                    }
                  }
                  return H;
                }, at;
              }(), jp = /* @__PURE__ */ function() {
                function at($) {
                  this.font = $;
                }
                var W = at.prototype;
                return W.positionGlyphs = function(R, k) {
                  for (var H = 0, ot = 0, ct = 0; ct < R.length; ct++) {
                    var ht = R[ct];
                    ht.isMark ? ot = ct : (H !== ot && this.positionCluster(R, k, H, ot), H = ot = ct);
                  }
                  return H !== ot && this.positionCluster(R, k, H, ot), k;
                }, W.positionCluster = function(R, k, H, ot) {
                  var ct = R[H], ht = ct.cbox.copy();
                  ct.codePoints.length > 1 && (ht.minX += (ct.codePoints.length - 1) * ht.width / ct.codePoints.length);
                  for (var ut = -k[H].xAdvance, Nt = 0, Kt = this.font.unitsPerEm / 16, de = H + 1; de <= ot; de++) {
                    var te = R[de], pe = te.cbox, Ee = k[de], Le = this.getCombiningClass(te.codePoints[0]);
                    if (Le !== "Not_Reordered") {
                      switch (Ee.xOffset = Ee.yOffset = 0, Le) {
                        case "Double_Above":
                        case "Double_Below":
                          Ee.xOffset += ht.minX - pe.width / 2 - pe.minX;
                          break;
                        case "Attached_Below_Left":
                        case "Below_Left":
                        case "Above_Left":
                          Ee.xOffset += ht.minX - pe.minX;
                          break;
                        case "Attached_Above_Right":
                        case "Below_Right":
                        case "Above_Right":
                          Ee.xOffset += ht.maxX - pe.width - pe.minX;
                          break;
                        default:
                          Ee.xOffset += ht.minX + (ht.width - pe.width) / 2 - pe.minX;
                      }
                      switch (Le) {
                        case "Double_Below":
                        case "Below_Left":
                        case "Below":
                        case "Below_Right":
                        case "Attached_Below_Left":
                        case "Attached_Below":
                          (Le === "Attached_Below_Left" || Le === "Attached_Below") && (ht.minY += Kt), Ee.yOffset = -ht.minY - pe.maxY, ht.minY += pe.height;
                          break;
                        case "Double_Above":
                        case "Above_Left":
                        case "Above":
                        case "Above_Right":
                        case "Attached_Above":
                        case "Attached_Above_Right":
                          (Le === "Attached_Above" || Le === "Attached_Above_Right") && (ht.maxY += Kt), Ee.yOffset = ht.maxY - pe.minY, ht.maxY += pe.height;
                          break;
                      }
                      Ee.xAdvance = Ee.yAdvance = 0, Ee.xOffset += ut, Ee.yOffset += Nt;
                    } else
                      ut -= Ee.xAdvance, Nt -= Ee.yAdvance;
                  }
                }, W.getCombiningClass = function(R) {
                  var k = A.getCombiningClass(R);
                  if ((R & -256) === 3584) {
                    if (k === "Not_Reordered")
                      switch (R) {
                        case 3633:
                        case 3636:
                        case 3637:
                        case 3638:
                        case 3639:
                        case 3655:
                        case 3660:
                        case 3645:
                        case 3662:
                          return "Above_Right";
                        case 3761:
                        case 3764:
                        case 3765:
                        case 3766:
                        case 3767:
                        case 3771:
                        case 3788:
                        case 3789:
                          return "Above";
                        case 3772:
                          return "Below";
                      }
                    else if (R === 3642)
                      return "Below_Right";
                  }
                  switch (k) {
                    case "CCC10":
                    case "CCC11":
                    case "CCC12":
                    case "CCC13":
                    case "CCC14":
                    case "CCC15":
                    case "CCC16":
                    case "CCC17":
                    case "CCC18":
                    case "CCC20":
                    case "CCC22":
                      return "Below";
                    case "CCC23":
                      return "Attached_Above";
                    case "CCC24":
                      return "Above_Right";
                    case "CCC25":
                    case "CCC19":
                      return "Above_Left";
                    case "CCC26":
                      return "Above";
                    case "CCC21":
                      break;
                    case "CCC27":
                    case "CCC28":
                    case "CCC30":
                    case "CCC31":
                    case "CCC33":
                    case "CCC34":
                    case "CCC35":
                    case "CCC36":
                      return "Above";
                    case "CCC29":
                    case "CCC32":
                      return "Below";
                    case "CCC103":
                      return "Below_Right";
                    case "CCC107":
                      return "Above_Right";
                    case "CCC118":
                      return "Below";
                    case "CCC122":
                      return "Above";
                    case "CCC129":
                    case "CCC132":
                      return "Below";
                    case "CCC130":
                      return "Above";
                  }
                  return k;
                }, at;
              }(), Xo = /* @__PURE__ */ function() {
                function at($, R, k, H) {
                  $ === void 0 && ($ = 1 / 0), R === void 0 && (R = 1 / 0), k === void 0 && (k = -1 / 0), H === void 0 && (H = -1 / 0), this.minX = $, this.minY = R, this.maxX = k, this.maxY = H;
                }
                var W = at.prototype;
                return W.addPoint = function(R, k) {
                  Math.abs(R) !== 1 / 0 && (R < this.minX && (this.minX = R), R > this.maxX && (this.maxX = R)), Math.abs(k) !== 1 / 0 && (k < this.minY && (this.minY = k), k > this.maxY && (this.maxY = k));
                }, W.copy = function() {
                  return new at(this.minX, this.minY, this.maxX, this.maxY);
                }, h(at, [{
                  key: "width",
                  get: function() {
                    return this.maxX - this.minX;
                  }
                  /**
                   * The height of the bounding box
                   * @type {number}
                   */
                }, {
                  key: "height",
                  get: function() {
                    return this.maxY - this.minY;
                  }
                }]), at;
              }(), Yo = {
                Caucasian_Albanian: "aghb",
                Arabic: "arab",
                Imperial_Aramaic: "armi",
                Armenian: "armn",
                Avestan: "avst",
                Balinese: "bali",
                Bamum: "bamu",
                Bassa_Vah: "bass",
                Batak: "batk",
                Bengali: ["bng2", "beng"],
                Bopomofo: "bopo",
                Brahmi: "brah",
                Braille: "brai",
                Buginese: "bugi",
                Buhid: "buhd",
                Chakma: "cakm",
                Canadian_Aboriginal: "cans",
                Carian: "cari",
                Cham: "cham",
                Cherokee: "cher",
                Coptic: "copt",
                Cypriot: "cprt",
                Cyrillic: "cyrl",
                Devanagari: ["dev2", "deva"],
                Deseret: "dsrt",
                Duployan: "dupl",
                Egyptian_Hieroglyphs: "egyp",
                Elbasan: "elba",
                Ethiopic: "ethi",
                Georgian: "geor",
                Glagolitic: "glag",
                Gothic: "goth",
                Grantha: "gran",
                Greek: "grek",
                Gujarati: ["gjr2", "gujr"],
                Gurmukhi: ["gur2", "guru"],
                Hangul: "hang",
                Han: "hani",
                Hanunoo: "hano",
                Hebrew: "hebr",
                Hiragana: "hira",
                Pahawh_Hmong: "hmng",
                Katakana_Or_Hiragana: "hrkt",
                Old_Italic: "ital",
                Javanese: "java",
                Kayah_Li: "kali",
                Katakana: "kana",
                Kharoshthi: "khar",
                Khmer: "khmr",
                Khojki: "khoj",
                Kannada: ["knd2", "knda"],
                Kaithi: "kthi",
                Tai_Tham: "lana",
                Lao: "lao ",
                Latin: "latn",
                Lepcha: "lepc",
                Limbu: "limb",
                Linear_A: "lina",
                Linear_B: "linb",
                Lisu: "lisu",
                Lycian: "lyci",
                Lydian: "lydi",
                Mahajani: "mahj",
                Mandaic: "mand",
                Manichaean: "mani",
                Mende_Kikakui: "mend",
                Meroitic_Cursive: "merc",
                Meroitic_Hieroglyphs: "mero",
                Malayalam: ["mlm2", "mlym"],
                Modi: "modi",
                Mongolian: "mong",
                Mro: "mroo",
                Meetei_Mayek: "mtei",
                Myanmar: ["mym2", "mymr"],
                Old_North_Arabian: "narb",
                Nabataean: "nbat",
                Nko: "nko ",
                Ogham: "ogam",
                Ol_Chiki: "olck",
                Old_Turkic: "orkh",
                Oriya: ["ory2", "orya"],
                Osmanya: "osma",
                Palmyrene: "palm",
                Pau_Cin_Hau: "pauc",
                Old_Permic: "perm",
                Phags_Pa: "phag",
                Inscriptional_Pahlavi: "phli",
                Psalter_Pahlavi: "phlp",
                Phoenician: "phnx",
                Miao: "plrd",
                Inscriptional_Parthian: "prti",
                Rejang: "rjng",
                Runic: "runr",
                Samaritan: "samr",
                Old_South_Arabian: "sarb",
                Saurashtra: "saur",
                Shavian: "shaw",
                Sharada: "shrd",
                Siddham: "sidd",
                Khudawadi: "sind",
                Sinhala: "sinh",
                Sora_Sompeng: "sora",
                Sundanese: "sund",
                Syloti_Nagri: "sylo",
                Syriac: "syrc",
                Tagbanwa: "tagb",
                Takri: "takr",
                Tai_Le: "tale",
                New_Tai_Lue: "talu",
                Tamil: ["tml2", "taml"],
                Tai_Viet: "tavt",
                Telugu: ["tel2", "telu"],
                Tifinagh: "tfng",
                Tagalog: "tglg",
                Thaana: "thaa",
                Thai: "thai",
                Tibetan: "tibt",
                Tirhuta: "tirh",
                Ugaritic: "ugar",
                Vai: "vai ",
                Warang_Citi: "wara",
                Old_Persian: "xpeo",
                Cuneiform: "xsux",
                Yi: "yi  ",
                Inherited: "zinh",
                Common: "zyyy",
                Unknown: "zzzz"
              }, nu = {};
              for (var iu in Yo) {
                var au = Yo[iu];
                if (Array.isArray(au))
                  for (var Xp = g(au), Tc; !(Tc = Xp()).done; ) {
                    var Yp = Tc.value;
                    nu[Yp] = iu;
                  }
                else
                  nu[au] = iu;
              }
              function Zp(at) {
                return nu[at];
              }
              function Kp(at) {
                for (var W = at.length, $ = 0; $ < W; ) {
                  var R = at.charCodeAt($++);
                  if (55296 <= R && R <= 56319 && $ < W) {
                    var k = at.charCodeAt($);
                    56320 <= k && k <= 57343 && ($++, R = ((R & 1023) << 10) + (k & 1023) + 65536);
                  }
                  var H = A.getScript(R);
                  if (H !== "Common" && H !== "Inherited" && H !== "Unknown")
                    return Yo[H];
                }
                return Yo.Unknown;
              }
              function Jp(at) {
                for (var W = 0; W < at.length; W++) {
                  var $ = at[W], R = A.getScript($);
                  if (R !== "Common" && R !== "Inherited" && R !== "Unknown")
                    return Yo[R];
                }
                return Yo.Unknown;
              }
              var Qp = {
                arab: !0,
                // Arabic
                hebr: !0,
                // Hebrew
                syrc: !0,
                // Syriac
                thaa: !0,
                // Thaana
                cprt: !0,
                // Cypriot Syllabary
                khar: !0,
                // Kharosthi
                phnx: !0,
                // Phoenician
                "nko ": !0,
                // N'Ko
                lydi: !0,
                // Lydian
                avst: !0,
                // Avestan
                armi: !0,
                // Imperial Aramaic
                phli: !0,
                // Inscriptional Pahlavi
                prti: !0,
                // Inscriptional Parthian
                sarb: !0,
                // Old South Arabian
                orkh: !0,
                // Old Turkic, Orkhon Runic
                samr: !0,
                // Samaritan
                mand: !0,
                // Mandaic, Mandaean
                merc: !0,
                // Meroitic Cursive
                mero: !0,
                // Meroitic Hieroglyphs
                // Unicode 7.0 (not listed on http://www.microsoft.com/typography/otspec/scripttags.htm)
                mani: !0,
                // Manichaean
                mend: !0,
                // Mende Kikakui
                nbat: !0,
                // Nabataean
                narb: !0,
                // Old North Arabian
                palm: !0,
                // Palmyrene
                phlp: !0
                // Psalter Pahlavi
              };
              function Pc(at) {
                return Qp[at] ? "rtl" : "ltr";
              }
              for (var $p = /* @__PURE__ */ function() {
                function at(W, $, R, k, H) {
                  if (this.glyphs = W, this.positions = null, this.script = R, this.language = k || null, this.direction = H || Pc(R), this.features = {}, Array.isArray($))
                    for (var ot = g($), ct; !(ct = ot()).done; ) {
                      var ht = ct.value;
                      this.features[ht] = !0;
                    }
                  else
                    typeof $ == "object" && (this.features = $);
                }
                return h(at, [{
                  key: "advanceWidth",
                  get: function() {
                    for (var $ = 0, R = g(this.positions), k; !(k = R()).done; ) {
                      var H = k.value;
                      $ += H.xAdvance;
                    }
                    return $;
                  }
                  /**
                   * The total advance height of the run.
                   * @type {number}
                   */
                }, {
                  key: "advanceHeight",
                  get: function() {
                    for (var $ = 0, R = g(this.positions), k; !(k = R()).done; ) {
                      var H = k.value;
                      $ += H.yAdvance;
                    }
                    return $;
                  }
                  /**
                   * The bounding box containing all glyphs in the run.
                   * @type {BBox}
                   */
                }, {
                  key: "bbox",
                  get: function() {
                    for (var $ = new Xo(), R = 0, k = 0, H = 0; H < this.glyphs.length; H++) {
                      var ot = this.glyphs[H], ct = this.positions[H], ht = ot.bbox;
                      $.addPoint(ht.minX + R + ct.xOffset, ht.minY + k + ct.yOffset), $.addPoint(ht.maxX + R + ct.xOffset, ht.maxY + k + ct.yOffset), R += ct.xAdvance, k += ct.yAdvance;
                    }
                    return $;
                  }
                }]), at;
              }(), qp = function(W, $, R, k) {
                W === void 0 && (W = 0), $ === void 0 && ($ = 0), R === void 0 && (R = 0), k === void 0 && (k = 0), this.xAdvance = W, this.yAdvance = $, this.xOffset = R, this.yOffset = k;
              }, lo = {
                allTypographicFeatures: {
                  code: 0,
                  exclusive: !1,
                  allTypeFeatures: 0
                },
                ligatures: {
                  code: 1,
                  exclusive: !1,
                  requiredLigatures: 0,
                  commonLigatures: 2,
                  rareLigatures: 4,
                  // logos: 6
                  rebusPictures: 8,
                  diphthongLigatures: 10,
                  squaredLigatures: 12,
                  abbrevSquaredLigatures: 14,
                  symbolLigatures: 16,
                  contextualLigatures: 18,
                  historicalLigatures: 20
                },
                cursiveConnection: {
                  code: 2,
                  exclusive: !0,
                  unconnected: 0,
                  partiallyConnected: 1,
                  cursive: 2
                },
                letterCase: {
                  code: 3,
                  exclusive: !0
                },
                // upperAndLowerCase: 0          # deprecated
                // allCaps: 1                    # deprecated
                // allLowerCase: 2               # deprecated
                // smallCaps: 3                  # deprecated
                // initialCaps: 4                # deprecated
                // initialCapsAndSmallCaps: 5    # deprecated
                verticalSubstitution: {
                  code: 4,
                  exclusive: !1,
                  substituteVerticalForms: 0
                },
                linguisticRearrangement: {
                  code: 5,
                  exclusive: !1,
                  linguisticRearrangement: 0
                },
                numberSpacing: {
                  code: 6,
                  exclusive: !0,
                  monospacedNumbers: 0,
                  proportionalNumbers: 1,
                  thirdWidthNumbers: 2,
                  quarterWidthNumbers: 3
                },
                smartSwash: {
                  code: 8,
                  exclusive: !1,
                  wordInitialSwashes: 0,
                  wordFinalSwashes: 2,
                  // lineInitialSwashes: 4
                  // lineFinalSwashes: 6
                  nonFinalSwashes: 8
                },
                diacritics: {
                  code: 9,
                  exclusive: !0,
                  showDiacritics: 0,
                  hideDiacritics: 1,
                  decomposeDiacritics: 2
                },
                verticalPosition: {
                  code: 10,
                  exclusive: !0,
                  normalPosition: 0,
                  superiors: 1,
                  inferiors: 2,
                  ordinals: 3,
                  scientificInferiors: 4
                },
                fractions: {
                  code: 11,
                  exclusive: !0,
                  noFractions: 0,
                  verticalFractions: 1,
                  diagonalFractions: 2
                },
                overlappingCharacters: {
                  code: 13,
                  exclusive: !1,
                  preventOverlap: 0
                },
                typographicExtras: {
                  code: 14,
                  exclusive: !1,
                  // hyphensToEmDash: 0
                  // hyphenToEnDash: 2
                  slashedZero: 4
                },
                // formInterrobang: 6
                // smartQuotes: 8
                // periodsToEllipsis: 10
                mathematicalExtras: {
                  code: 15,
                  exclusive: !1,
                  // hyphenToMinus: 0
                  // asteristoMultiply: 2
                  // slashToDivide: 4
                  // inequalityLigatures: 6
                  // exponents: 8
                  mathematicalGreek: 10
                },
                ornamentSets: {
                  code: 16,
                  exclusive: !0,
                  noOrnaments: 0,
                  dingbats: 1,
                  piCharacters: 2,
                  fleurons: 3,
                  decorativeBorders: 4,
                  internationalSymbols: 5,
                  mathSymbols: 6
                },
                characterAlternatives: {
                  code: 17,
                  exclusive: !0,
                  noAlternates: 0
                },
                // user defined options
                designComplexity: {
                  code: 18,
                  exclusive: !0,
                  designLevel1: 0,
                  designLevel2: 1,
                  designLevel3: 2,
                  designLevel4: 3,
                  designLevel5: 4
                },
                styleOptions: {
                  code: 19,
                  exclusive: !0,
                  noStyleOptions: 0,
                  displayText: 1,
                  engravedText: 2,
                  illuminatedCaps: 3,
                  titlingCaps: 4,
                  tallCaps: 5
                },
                characterShape: {
                  code: 20,
                  exclusive: !0,
                  traditionalCharacters: 0,
                  simplifiedCharacters: 1,
                  JIS1978Characters: 2,
                  JIS1983Characters: 3,
                  JIS1990Characters: 4,
                  traditionalAltOne: 5,
                  traditionalAltTwo: 6,
                  traditionalAltThree: 7,
                  traditionalAltFour: 8,
                  traditionalAltFive: 9,
                  expertCharacters: 10,
                  JIS2004Characters: 11,
                  hojoCharacters: 12,
                  NLCCharacters: 13,
                  traditionalNamesCharacters: 14
                },
                numberCase: {
                  code: 21,
                  exclusive: !0,
                  lowerCaseNumbers: 0,
                  upperCaseNumbers: 1
                },
                textSpacing: {
                  code: 22,
                  exclusive: !0,
                  proportionalText: 0,
                  monospacedText: 1,
                  halfWidthText: 2,
                  thirdWidthText: 3,
                  quarterWidthText: 4,
                  altProportionalText: 5,
                  altHalfWidthText: 6
                },
                transliteration: {
                  code: 23,
                  exclusive: !0,
                  noTransliteration: 0
                },
                // hanjaToHangul: 1
                // hiraganaToKatakana: 2
                // katakanaToHiragana: 3
                // kanaToRomanization: 4
                // romanizationToHiragana: 5
                // romanizationToKatakana: 6
                // hanjaToHangulAltOne: 7
                // hanjaToHangulAltTwo: 8
                // hanjaToHangulAltThree: 9
                annotation: {
                  code: 24,
                  exclusive: !0,
                  noAnnotation: 0,
                  boxAnnotation: 1,
                  roundedBoxAnnotation: 2,
                  circleAnnotation: 3,
                  invertedCircleAnnotation: 4,
                  parenthesisAnnotation: 5,
                  periodAnnotation: 6,
                  romanNumeralAnnotation: 7,
                  diamondAnnotation: 8,
                  invertedBoxAnnotation: 9,
                  invertedRoundedBoxAnnotation: 10
                },
                kanaSpacing: {
                  code: 25,
                  exclusive: !0,
                  fullWidthKana: 0,
                  proportionalKana: 1
                },
                ideographicSpacing: {
                  code: 26,
                  exclusive: !0,
                  fullWidthIdeographs: 0,
                  proportionalIdeographs: 1,
                  halfWidthIdeographs: 2
                },
                unicodeDecomposition: {
                  code: 27,
                  exclusive: !1,
                  canonicalComposition: 0,
                  compatibilityComposition: 2,
                  transcodingComposition: 4
                },
                rubyKana: {
                  code: 28,
                  exclusive: !1,
                  // noRubyKana: 0     # deprecated - use rubyKanaOff instead
                  // rubyKana: 1     # deprecated - use rubyKanaOn instead
                  rubyKana: 2
                },
                CJKSymbolAlternatives: {
                  code: 29,
                  exclusive: !0,
                  noCJKSymbolAlternatives: 0,
                  CJKSymbolAltOne: 1,
                  CJKSymbolAltTwo: 2,
                  CJKSymbolAltThree: 3,
                  CJKSymbolAltFour: 4,
                  CJKSymbolAltFive: 5
                },
                ideographicAlternatives: {
                  code: 30,
                  exclusive: !0,
                  noIdeographicAlternatives: 0,
                  ideographicAltOne: 1,
                  ideographicAltTwo: 2,
                  ideographicAltThree: 3,
                  ideographicAltFour: 4,
                  ideographicAltFive: 5
                },
                CJKVerticalRomanPlacement: {
                  code: 31,
                  exclusive: !0,
                  CJKVerticalRomanCentered: 0,
                  CJKVerticalRomanHBaseline: 1
                },
                italicCJKRoman: {
                  code: 32,
                  exclusive: !1,
                  // noCJKItalicRoman: 0     # deprecated - use CJKItalicRomanOff instead
                  // CJKItalicRoman: 1     # deprecated - use CJKItalicRomanOn instead
                  CJKItalicRoman: 2
                },
                caseSensitiveLayout: {
                  code: 33,
                  exclusive: !1,
                  caseSensitiveLayout: 0,
                  caseSensitiveSpacing: 2
                },
                alternateKana: {
                  code: 34,
                  exclusive: !1,
                  alternateHorizKana: 0,
                  alternateVertKana: 2
                },
                stylisticAlternatives: {
                  code: 35,
                  exclusive: !1,
                  noStylisticAlternates: 0,
                  stylisticAltOne: 2,
                  stylisticAltTwo: 4,
                  stylisticAltThree: 6,
                  stylisticAltFour: 8,
                  stylisticAltFive: 10,
                  stylisticAltSix: 12,
                  stylisticAltSeven: 14,
                  stylisticAltEight: 16,
                  stylisticAltNine: 18,
                  stylisticAltTen: 20,
                  stylisticAltEleven: 22,
                  stylisticAltTwelve: 24,
                  stylisticAltThirteen: 26,
                  stylisticAltFourteen: 28,
                  stylisticAltFifteen: 30,
                  stylisticAltSixteen: 32,
                  stylisticAltSeventeen: 34,
                  stylisticAltEighteen: 36,
                  stylisticAltNineteen: 38,
                  stylisticAltTwenty: 40
                },
                contextualAlternates: {
                  code: 36,
                  exclusive: !1,
                  contextualAlternates: 0,
                  swashAlternates: 2,
                  contextualSwashAlternates: 4
                },
                lowerCase: {
                  code: 37,
                  exclusive: !0,
                  defaultLowerCase: 0,
                  lowerCaseSmallCaps: 1,
                  lowerCasePetiteCaps: 2
                },
                upperCase: {
                  code: 38,
                  exclusive: !0,
                  defaultUpperCase: 0,
                  upperCaseSmallCaps: 1,
                  upperCasePetiteCaps: 2
                },
                languageTag: {
                  // indices into ltag table
                  code: 39,
                  exclusive: !0
                },
                CJKRomanSpacing: {
                  code: 103,
                  exclusive: !0,
                  halfWidthCJKRoman: 0,
                  proportionalCJKRoman: 1,
                  defaultCJKRoman: 2,
                  fullWidthCJKRoman: 3
                }
              }, Ye = function(W, $) {
                return [lo[W].code, lo[W][$]];
              }, L0 = {
                rlig: Ye("ligatures", "requiredLigatures"),
                clig: Ye("ligatures", "contextualLigatures"),
                dlig: Ye("ligatures", "rareLigatures"),
                hlig: Ye("ligatures", "historicalLigatures"),
                liga: Ye("ligatures", "commonLigatures"),
                hist: Ye("ligatures", "historicalLigatures"),
                // ??
                smcp: Ye("lowerCase", "lowerCaseSmallCaps"),
                pcap: Ye("lowerCase", "lowerCasePetiteCaps"),
                frac: Ye("fractions", "diagonalFractions"),
                dnom: Ye("fractions", "diagonalFractions"),
                // ??
                numr: Ye("fractions", "diagonalFractions"),
                // ??
                afrc: Ye("fractions", "verticalFractions"),
                // aalt
                // abvf, abvm, abvs, akhn, blwf, blwm, blws, cfar, cjct, cpsp, falt, isol, jalt, ljmo, mset?
                // ltra, ltrm, nukt, pref, pres, pstf, psts, rand, rkrf, rphf, rtla, rtlm, size, tjmo, tnum?
                // unic, vatu, vhal, vjmo, vpal, vrt2
                // dist -> trak table?
                // kern, vkrn -> kern table
                // lfbd + opbd + rtbd -> opbd table?
                // mark, mkmk -> acnt table?
                // locl -> languageTag + ltag table
                case: Ye("caseSensitiveLayout", "caseSensitiveLayout"),
                // also caseSensitiveSpacing
                ccmp: Ye("unicodeDecomposition", "canonicalComposition"),
                // compatibilityComposition?
                cpct: Ye("CJKVerticalRomanPlacement", "CJKVerticalRomanCentered"),
                // guess..., probably not given below
                valt: Ye("CJKVerticalRomanPlacement", "CJKVerticalRomanCentered"),
                swsh: Ye("contextualAlternates", "swashAlternates"),
                cswh: Ye("contextualAlternates", "contextualSwashAlternates"),
                curs: Ye("cursiveConnection", "cursive"),
                // ??
                c2pc: Ye("upperCase", "upperCasePetiteCaps"),
                c2sc: Ye("upperCase", "upperCaseSmallCaps"),
                init: Ye("smartSwash", "wordInitialSwashes"),
                // ??
                fin2: Ye("smartSwash", "wordFinalSwashes"),
                // ??
                medi: Ye("smartSwash", "nonFinalSwashes"),
                // ??
                med2: Ye("smartSwash", "nonFinalSwashes"),
                // ??
                fin3: Ye("smartSwash", "wordFinalSwashes"),
                // ??
                fina: Ye("smartSwash", "wordFinalSwashes"),
                // ??
                pkna: Ye("kanaSpacing", "proportionalKana"),
                half: Ye("textSpacing", "halfWidthText"),
                // also HalfWidthCJKRoman, HalfWidthIdeographs?
                halt: Ye("textSpacing", "altHalfWidthText"),
                hkna: Ye("alternateKana", "alternateHorizKana"),
                vkna: Ye("alternateKana", "alternateVertKana"),
                // hngl: feature 'transliteration', 'hanjaToHangulSelector' # deprecated
                ital: Ye("italicCJKRoman", "CJKItalicRoman"),
                lnum: Ye("numberCase", "upperCaseNumbers"),
                onum: Ye("numberCase", "lowerCaseNumbers"),
                mgrk: Ye("mathematicalExtras", "mathematicalGreek"),
                // nalt: not enough info. what type of annotation?
                // ornm: ditto, which ornament style?
                calt: Ye("contextualAlternates", "contextualAlternates"),
                // or more?
                vrt2: Ye("verticalSubstitution", "substituteVerticalForms"),
                // oh... below?
                vert: Ye("verticalSubstitution", "substituteVerticalForms"),
                tnum: Ye("numberSpacing", "monospacedNumbers"),
                pnum: Ye("numberSpacing", "proportionalNumbers"),
                sups: Ye("verticalPosition", "superiors"),
                subs: Ye("verticalPosition", "inferiors"),
                ordn: Ye("verticalPosition", "ordinals"),
                pwid: Ye("textSpacing", "proportionalText"),
                hwid: Ye("textSpacing", "halfWidthText"),
                qwid: Ye("textSpacing", "quarterWidthText"),
                // also QuarterWidthNumbers?
                twid: Ye("textSpacing", "thirdWidthText"),
                // also ThirdWidthNumbers?
                fwid: Ye("textSpacing", "proportionalText"),
                //??
                palt: Ye("textSpacing", "altProportionalText"),
                trad: Ye("characterShape", "traditionalCharacters"),
                smpl: Ye("characterShape", "simplifiedCharacters"),
                jp78: Ye("characterShape", "JIS1978Characters"),
                jp83: Ye("characterShape", "JIS1983Characters"),
                jp90: Ye("characterShape", "JIS1990Characters"),
                jp04: Ye("characterShape", "JIS2004Characters"),
                expt: Ye("characterShape", "expertCharacters"),
                hojo: Ye("characterShape", "hojoCharacters"),
                nlck: Ye("characterShape", "NLCCharacters"),
                tnam: Ye("characterShape", "traditionalNamesCharacters"),
                ruby: Ye("rubyKana", "rubyKana"),
                titl: Ye("styleOptions", "titlingCaps"),
                zero: Ye("typographicExtras", "slashedZero"),
                ss01: Ye("stylisticAlternatives", "stylisticAltOne"),
                ss02: Ye("stylisticAlternatives", "stylisticAltTwo"),
                ss03: Ye("stylisticAlternatives", "stylisticAltThree"),
                ss04: Ye("stylisticAlternatives", "stylisticAltFour"),
                ss05: Ye("stylisticAlternatives", "stylisticAltFive"),
                ss06: Ye("stylisticAlternatives", "stylisticAltSix"),
                ss07: Ye("stylisticAlternatives", "stylisticAltSeven"),
                ss08: Ye("stylisticAlternatives", "stylisticAltEight"),
                ss09: Ye("stylisticAlternatives", "stylisticAltNine"),
                ss10: Ye("stylisticAlternatives", "stylisticAltTen"),
                ss11: Ye("stylisticAlternatives", "stylisticAltEleven"),
                ss12: Ye("stylisticAlternatives", "stylisticAltTwelve"),
                ss13: Ye("stylisticAlternatives", "stylisticAltThirteen"),
                ss14: Ye("stylisticAlternatives", "stylisticAltFourteen"),
                ss15: Ye("stylisticAlternatives", "stylisticAltFifteen"),
                ss16: Ye("stylisticAlternatives", "stylisticAltSixteen"),
                ss17: Ye("stylisticAlternatives", "stylisticAltSeventeen"),
                ss18: Ye("stylisticAlternatives", "stylisticAltEighteen"),
                ss19: Ye("stylisticAlternatives", "stylisticAltNineteen"),
                ss20: Ye("stylisticAlternatives", "stylisticAltTwenty")
              }, U0 = 1; U0 <= 99; U0++)
                L0["cv".concat("00".concat(U0).slice(-2))] = [lo.characterAlternatives.code, U0];
              var fo = {};
              for (var Oc in L0) {
                var z0 = L0[Oc];
                fo[z0[0]] == null && (fo[z0[0]] = {}), fo[z0[0]][z0[1]] = Oc;
              }
              function ty(at) {
                var W = {};
                for (var $ in at) {
                  var R = void 0;
                  (R = L0[$]) && (W[R[0]] == null && (W[R[0]] = {}), W[R[0]][R[1]] = at[$]);
                }
                return W;
              }
              function Fc(at) {
                var W = at[0], $ = at[1];
                if (isNaN(W))
                  var R = lo[W] && lo[W].code;
                else
                  var R = W;
                if (isNaN($))
                  var k = lo[W] && lo[W][$];
                else
                  var k = $;
                return [R, k];
              }
              function ey(at) {
                var W = {};
                if (Array.isArray(at))
                  for (var $ = 0; $ < at.length; $++) {
                    var R = void 0, k = Fc(at[$]);
                    (R = fo[k[0]] && fo[k[0]][k[1]]) && (W[R] = !0);
                  }
                else if (typeof at == "object")
                  for (var H in at) {
                    var ot = at[H];
                    for (var ct in ot) {
                      var ht = void 0, ut = Fc([H, ct]);
                      ot[ct] && (ht = fo[ut[0]] && fo[ut[0]][ut[1]]) && (W[ht] = !0);
                    }
                  }
                return Object.keys(W);
              }
              var Ds, G0 = (Ds = /* @__PURE__ */ function() {
                function at($) {
                  this.table = $;
                }
                var W = at.prototype;
                return W.lookup = function(R) {
                  switch (this.table.version) {
                    case 0:
                      return this.table.values.getItem(R);
                    case 2:
                    case 4: {
                      for (var k = 0, H = this.table.binarySearchHeader.nUnits - 1; k <= H; ) {
                        var ot = k + H >> 1, ct = this.table.segments[ot];
                        if (ct.firstGlyph === 65535)
                          return null;
                        if (R < ct.firstGlyph)
                          H = ot - 1;
                        else if (R > ct.lastGlyph)
                          k = ot + 1;
                        else
                          return this.table.version === 2 ? ct.value : ct.values[R - ct.firstGlyph];
                      }
                      return null;
                    }
                    case 6: {
                      for (var ht = 0, ut = this.table.binarySearchHeader.nUnits - 1; ht <= ut; ) {
                        var ot = ht + ut >> 1, ct = this.table.segments[ot];
                        if (ct.glyph === 65535)
                          return null;
                        if (R < ct.glyph)
                          ut = ot - 1;
                        else if (R > ct.glyph)
                          ht = ot + 1;
                        else
                          return ct.value;
                      }
                      return null;
                    }
                    case 8:
                      return this.table.values[R - this.table.firstGlyph];
                    default:
                      throw new Error("Unknown lookup table format: ".concat(this.table.version));
                  }
                }, W.glyphsForValue = function(R) {
                  var k = [];
                  switch (this.table.version) {
                    case 2:
                    case 4: {
                      for (var H = g(this.table.segments), ot; !(ot = H()).done; ) {
                        var ct = ot.value;
                        if (this.table.version === 2 && ct.value === R)
                          k.push.apply(k, jo(ct.firstGlyph, ct.lastGlyph + 1));
                        else
                          for (var ht = 0; ht < ct.values.length; ht++)
                            ct.values[ht] === R && k.push(ct.firstGlyph + ht);
                      }
                      break;
                    }
                    case 6: {
                      for (var ut = g(this.table.segments), Nt; !(Nt = ut()).done; ) {
                        var Kt = Nt.value;
                        Kt.value === R && k.push(Kt.glyph);
                      }
                      break;
                    }
                    case 8: {
                      for (var de = 0; de < this.table.values.length; de++)
                        this.table.values[de] === R && k.push(this.table.firstGlyph + de);
                      break;
                    }
                    default:
                      throw new Error("Unknown lookup table format: ".concat(this.table.version));
                  }
                  return k;
                }, at;
              }(), L(Ds.prototype, "glyphsForValue", [J], Object.getOwnPropertyDescriptor(Ds.prototype, "glyphsForValue"), Ds.prototype), Ds), ry = 0, Ic = 0, Rc = 1, Dc = 2, ny = 16384, iy = /* @__PURE__ */ function() {
                function at($) {
                  this.stateTable = $, this.lookupTable = new G0($.classTable);
                }
                var W = at.prototype;
                return W.process = function(R, k, H) {
                  for (var ot = ry, ct = k ? R.length - 1 : 0, ht = k ? -1 : 1; ht === 1 && ct <= R.length || ht === -1 && ct >= -1; ) {
                    var ut = null, Nt = Rc, Kt = !0;
                    ct === R.length || ct === -1 ? Nt = Ic : (ut = R[ct], ut.id === 65535 ? Nt = Dc : (Nt = this.lookupTable.lookup(ut.id), Nt == null && (Nt = Rc)));
                    var de = this.stateTable.stateArray.getItem(ot), te = de[Nt], pe = this.stateTable.entryTable.getItem(te);
                    Nt !== Ic && Nt !== Dc && (H(ut, pe, ct), Kt = !(pe.flags & ny)), ot = pe.newState, Kt && (ct += ht);
                  }
                  return R;
                }, W.traverse = function(R, k, H) {
                  if (k === void 0 && (k = 0), H === void 0 && (H = /* @__PURE__ */ new Set()), !H.has(k)) {
                    H.add(k);
                    for (var ot = this.stateTable, ct = ot.nClasses, ht = ot.stateArray, ut = ot.entryTable, Nt = ht.getItem(k), Kt = 4; Kt < ct; Kt++)
                      for (var de = Nt[Kt], te = ut.getItem(de), pe = g(this.lookupTable.glyphsForValue(Kt)), Ee; !(Ee = pe()).done; ) {
                        var Le = Ee.value;
                        R.enter && R.enter(Le, te), te.newState !== 0 && this.traverse(R, te.newState, H), R.exit && R.exit(Le, te);
                      }
                  }
                }, at;
              }(), Ms, ay = 32768, oy = 8192, sy = 15, Mc = 32768, ly = 32768, fy = 8192, uy = 2147483648, hy = 1073741824, cy = 1073741823, Bc = 4194304, dy = 2048, vy = 1024, gy = 992, py = 31, yy = (Ms = /* @__PURE__ */ function() {
                function at($) {
                  this.processIndicRearragement = this.processIndicRearragement.bind(this), this.processContextualSubstitution = this.processContextualSubstitution.bind(this), this.processLigature = this.processLigature.bind(this), this.processNoncontextualSubstitutions = this.processNoncontextualSubstitutions.bind(this), this.processGlyphInsertion = this.processGlyphInsertion.bind(this), this.font = $, this.morx = $.morx, this.inputCache = null;
                }
                var W = at.prototype;
                return W.process = function(R, k) {
                  k === void 0 && (k = {});
                  for (var H = g(this.morx.chains), ot; !(ot = H()).done; ) {
                    for (var ct = ot.value, ht = ct.defaultFlags, ut = g(ct.features), Nt; !(Nt = ut()).done; ) {
                      var Kt = Nt.value, de = void 0;
                      (de = k[Kt.featureType]) && (de[Kt.featureSetting] ? (ht &= Kt.disableFlags, ht |= Kt.enableFlags) : de[Kt.featureSetting] === !1 && (ht |= ~Kt.disableFlags, ht &= ~Kt.enableFlags));
                    }
                    for (var te = g(ct.subtables), pe; !(pe = te()).done; ) {
                      var Ee = pe.value;
                      Ee.subFeatureFlags & ht && this.processSubtable(Ee, R);
                    }
                  }
                  for (var Le = R.length - 1; Le >= 0; )
                    R[Le].id === 65535 && R.splice(Le, 1), Le--;
                  return R;
                }, W.processSubtable = function(R, k) {
                  if (this.subtable = R, this.glyphs = k, this.subtable.type === 4) {
                    this.processNoncontextualSubstitutions(this.subtable, this.glyphs);
                    return;
                  }
                  this.ligatureStack = [], this.markedGlyph = null, this.firstGlyph = null, this.lastGlyph = null, this.markedIndex = null;
                  var H = this.getStateMachine(R), ot = this.getProcessor(), ct = !!(this.subtable.coverage & Bc);
                  return H.process(this.glyphs, ct, ot);
                }, W.getStateMachine = function(R) {
                  return new iy(R.table.stateTable);
                }, W.getProcessor = function() {
                  switch (this.subtable.type) {
                    case 0:
                      return this.processIndicRearragement;
                    case 1:
                      return this.processContextualSubstitution;
                    case 2:
                      return this.processLigature;
                    case 4:
                      return this.processNoncontextualSubstitutions;
                    case 5:
                      return this.processGlyphInsertion;
                    default:
                      throw new Error("Invalid morx subtable type: ".concat(this.subtable.type));
                  }
                }, W.processIndicRearragement = function(R, k, H) {
                  k.flags & ay && (this.firstGlyph = H), k.flags & oy && (this.lastGlyph = H), my(this.glyphs, k.flags & sy, this.firstGlyph, this.lastGlyph);
                }, W.processContextualSubstitution = function(R, k, H) {
                  var ot = this.subtable.table.substitutionTable.items;
                  if (k.markIndex !== 65535) {
                    var ct = ot.getItem(k.markIndex), ht = new G0(ct);
                    R = this.glyphs[this.markedGlyph];
                    var ut = ht.lookup(R.id);
                    ut && (this.glyphs[this.markedGlyph] = this.font.getGlyph(ut, R.codePoints));
                  }
                  if (k.currentIndex !== 65535) {
                    var Nt = ot.getItem(k.currentIndex), Kt = new G0(Nt);
                    R = this.glyphs[H];
                    var ut = Kt.lookup(R.id);
                    ut && (this.glyphs[H] = this.font.getGlyph(ut, R.codePoints));
                  }
                  k.flags & Mc && (this.markedGlyph = H);
                }, W.processLigature = function(R, k, H) {
                  if (k.flags & ly && this.ligatureStack.push(H), k.flags & fy) {
                    for (var ot, ct = this.subtable.table.ligatureActions, ht = this.subtable.table.components, ut = this.subtable.table.ligatureList, Nt = k.action, Kt = !1, de = 0, te = [], pe = []; !Kt; ) {
                      var Ee, Le = this.ligatureStack.pop();
                      (Ee = te).unshift.apply(Ee, this.glyphs[Le].codePoints);
                      var $e = ct.getItem(Nt++);
                      Kt = !!($e & uy);
                      var wr = !!($e & hy), or = ($e & cy) << 2 >> 2;
                      or += this.glyphs[Le].id;
                      var Pr = ht.getItem(or);
                      if (de += Pr, Kt || wr) {
                        var Cr = ut.getItem(de);
                        this.glyphs[Le] = this.font.getGlyph(Cr, te), pe.push(Le), de = 0, te = [];
                      } else
                        this.glyphs[Le] = this.font.getGlyph(65535);
                    }
                    (ot = this.ligatureStack).push.apply(ot, pe);
                  }
                }, W.processNoncontextualSubstitutions = function(R, k, H) {
                  var ot = new G0(R.table.lookupTable);
                  for (H = 0; H < k.length; H++) {
                    var ct = k[H];
                    if (ct.id !== 65535) {
                      var ht = ot.lookup(ct.id);
                      ht && (k[H] = this.font.getGlyph(ht, ct.codePoints));
                    }
                  }
                }, W._insertGlyphs = function(R, k, H, ot) {
                  for (var ct, ht = []; H--; ) {
                    var ut = this.subtable.table.insertionActions.getItem(k++);
                    ht.push(this.font.getGlyph(ut));
                  }
                  ot || R++, (ct = this.glyphs).splice.apply(ct, [R, 0].concat(ht));
                }, W.processGlyphInsertion = function(R, k, H) {
                  if (k.flags & Mc && (this.markedIndex = H), k.markedInsertIndex !== 65535) {
                    var ot = (k.flags & py) >>> 5, ct = !!(k.flags & vy);
                    this._insertGlyphs(this.markedIndex, k.markedInsertIndex, ot, ct);
                  }
                  if (k.currentInsertIndex !== 65535) {
                    var ht = (k.flags & gy) >>> 5, ut = !!(k.flags & dy);
                    this._insertGlyphs(H, k.currentInsertIndex, ht, ut);
                  }
                }, W.getSupportedFeatures = function() {
                  for (var R = [], k = g(this.morx.chains), H; !(H = k()).done; )
                    for (var ot = H.value, ct = g(ot.features), ht; !(ht = ct()).done; ) {
                      var ut = ht.value;
                      R.push([ut.featureType, ut.featureSetting]);
                    }
                  return R;
                }, W.generateInputs = function(R) {
                  return this.inputCache || this.generateInputCache(), this.inputCache[R] || [];
                }, W.generateInputCache = function() {
                  this.inputCache = {};
                  for (var R = g(this.morx.chains), k; !(k = R()).done; )
                    for (var H = k.value, ot = H.defaultFlags, ct = g(H.subtables), ht; !(ht = ct()).done; ) {
                      var ut = ht.value;
                      ut.subFeatureFlags & ot && this.generateInputsForSubtable(ut);
                    }
                }, W.generateInputsForSubtable = function(R) {
                  var k = this;
                  if (R.type === 2) {
                    var H = !!(R.coverage & Bc);
                    if (H)
                      throw new Error("Reverse subtable, not supported.");
                    this.subtable = R, this.ligatureStack = [];
                    var ot = this.getStateMachine(R), ct = this.getProcessor(), ht = [], ut = [];
                    this.glyphs = [], ot.traverse({
                      enter: function(Kt, de) {
                        var te = k.glyphs;
                        ut.push({
                          glyphs: te.slice(),
                          ligatureStack: k.ligatureStack.slice()
                        });
                        var pe = k.font.getGlyph(Kt);
                        ht.push(pe), te.push(ht[ht.length - 1]), ct(te[te.length - 1], de, te.length - 1);
                        for (var Ee = 0, Le = 0, $e = 0; $e < te.length && Ee <= 1; $e++)
                          te[$e].id !== 65535 && (Ee++, Le = te[$e].id);
                        if (Ee === 1) {
                          var wr = ht.map(function(Pr) {
                            return Pr.id;
                          }), or = k.inputCache[Le];
                          or ? or.push(wr) : k.inputCache[Le] = [wr];
                        }
                      },
                      exit: function() {
                        var Kt = ut.pop();
                        k.glyphs = Kt.glyphs, k.ligatureStack = Kt.ligatureStack, ht.pop();
                      }
                    });
                  }
                }, at;
              }(), L(Ms.prototype, "getStateMachine", [J], Object.getOwnPropertyDescriptor(Ms.prototype, "getStateMachine"), Ms.prototype), Ms);
              function Ei(at, W, $, R, k) {
                R === void 0 && (R = !1), k === void 0 && (k = !1);
                var H = at.splice($[0] - ($[1] - 1), $[1]);
                k && H.reverse();
                var ot = at.splice.apply(at, [W[0], W[1]].concat(H));
                return R && ot.reverse(), at.splice.apply(at, [$[0] - (W[1] - 1), 0].concat(ot)), at;
              }
              function my(at, W, $, R) {
                switch (W) {
                  case 0:
                    return at;
                  case 1:
                    return Ei(at, [$, 1], [R, 0]);
                  case 2:
                    return Ei(at, [$, 0], [R, 1]);
                  case 3:
                    return Ei(at, [$, 1], [R, 1]);
                  case 4:
                    return Ei(at, [$, 2], [R, 0]);
                  case 5:
                    return Ei(at, [$, 2], [R, 0], !0, !1);
                  case 6:
                    return Ei(at, [$, 0], [R, 2]);
                  case 7:
                    return Ei(at, [$, 0], [R, 2], !1, !0);
                  case 8:
                    return Ei(at, [$, 1], [R, 2]);
                  case 9:
                    return Ei(at, [$, 1], [R, 2], !1, !0);
                  case 10:
                    return Ei(at, [$, 2], [R, 1]);
                  case 11:
                    return Ei(at, [$, 2], [R, 1], !0, !1);
                  case 12:
                    return Ei(at, [$, 2], [R, 2]);
                  case 13:
                    return Ei(at, [$, 2], [R, 2], !0, !1);
                  case 14:
                    return Ei(at, [$, 2], [R, 2], !1, !0);
                  case 15:
                    return Ei(at, [$, 2], [R, 2], !0, !0);
                  default:
                    throw new Error("Unknown verb: ".concat(W));
                }
              }
              var xy = /* @__PURE__ */ function() {
                function at($) {
                  this.font = $, this.morxProcessor = new yy($), this.fallbackPosition = !1;
                }
                var W = at.prototype;
                return W.substitute = function(R) {
                  R.direction === "rtl" && R.glyphs.reverse(), this.morxProcessor.process(R.glyphs, ty(R.features));
                }, W.getAvailableFeatures = function(R, k) {
                  return ey(this.morxProcessor.getSupportedFeatures());
                }, W.stringsForGlyph = function(R) {
                  for (var k = this.morxProcessor.generateInputs(R), H = /* @__PURE__ */ new Set(), ot = g(k), ct; !(ct = ot()).done; ) {
                    var ht = ct.value;
                    this._addStrings(ht, 0, H, "");
                  }
                  return H;
                }, W._addStrings = function(R, k, H, ot) {
                  for (var ct = this.font._cmapProcessor.codePointsForGlyph(R[k]), ht = g(ct), ut; !(ut = ht()).done; ) {
                    var Nt = ut.value, Kt = ot + String.fromCodePoint(Nt);
                    k < R.length - 1 ? this._addStrings(R, k + 1, H, Kt) : H.add(Kt);
                  }
                }, at;
              }(), by = /* @__PURE__ */ function() {
                function at($, R, k) {
                  this.font = $, this.script = R, this.direction = k, this.stages = [], this.globalFeatures = {}, this.allFeatures = {};
                }
                var W = at.prototype;
                return W._addFeatures = function(R, k) {
                  for (var H = this.stages.length - 1, ot = this.stages[H], ct = g(R), ht; !(ht = ct()).done; ) {
                    var ut = ht.value;
                    this.allFeatures[ut] == null && (ot.push(ut), this.allFeatures[ut] = H, k && (this.globalFeatures[ut] = !0));
                  }
                }, W.add = function(R, k) {
                  if (k === void 0 && (k = !0), this.stages.length === 0 && this.stages.push([]), typeof R == "string" && (R = [R]), Array.isArray(R))
                    this._addFeatures(R, k);
                  else if (typeof R == "object")
                    this._addFeatures(R.global || [], !0), this._addFeatures(R.local || [], !1);
                  else
                    throw new Error("Unsupported argument to ShapingPlan#add");
                }, W.addStage = function(R, k) {
                  typeof R == "function" ? this.stages.push(R, []) : (this.stages.push([]), this.add(R, k));
                }, W.setFeatureOverrides = function(R) {
                  if (Array.isArray(R))
                    this.add(R);
                  else if (typeof R == "object") {
                    for (var k in R)
                      if (R[k])
                        this.add(k);
                      else if (this.allFeatures[k] != null) {
                        var H = this.stages[this.allFeatures[k]];
                        H.splice(H.indexOf(k), 1), delete this.allFeatures[k], delete this.globalFeatures[k];
                      }
                  }
                }, W.assignGlobalFeatures = function(R) {
                  for (var k = g(R), H; !(H = k()).done; ) {
                    var ot = H.value;
                    for (var ct in this.globalFeatures)
                      ot.features[ct] = !0;
                  }
                }, W.process = function(R, k, H) {
                  for (var ot = g(this.stages), ct; !(ct = ot()).done; ) {
                    var ht = ct.value;
                    typeof ht == "function" ? H || ht(this.font, k, this) : ht.length > 0 && R.applyFeatures(ht, k, H);
                  }
                }, at;
              }(), wy = ["rvrn"], Sy = ["ccmp", "locl", "rlig", "mark", "mkmk"], Ey = ["frac", "numr", "dnom"], Ay = ["calt", "clig", "liga", "rclt", "curs", "kern"], Cy = {
                ltr: ["ltra", "ltrm"],
                rtl: ["rtla", "rtlm"]
              }, Va = /* @__PURE__ */ function() {
                function at() {
                }
                return at.plan = function($, R, k) {
                  this.planPreprocessing($), this.planFeatures($), this.planPostprocessing($, k), $.assignGlobalFeatures(R), this.assignFeatures($, R);
                }, at.planPreprocessing = function($) {
                  $.add({
                    global: [].concat(wy, Cy[$.direction]),
                    local: Ey
                  });
                }, at.planFeatures = function($) {
                }, at.planPostprocessing = function($, R) {
                  $.add([].concat(Sy, Ay)), $.setFeatureOverrides(R);
                }, at.assignFeatures = function($, R) {
                  for (var k = 0; k < R.length; k++) {
                    var H = R[k];
                    if (H.codePoints[0] === 8260) {
                      for (var ot = k, ct = k + 1; ot > 0 && A.isDigit(R[ot - 1].codePoints[0]); )
                        R[ot - 1].features.numr = !0, R[ot - 1].features.frac = !0, ot--;
                      for (; ct < R.length && A.isDigit(R[ct].codePoints[0]); )
                        R[ct].features.dnom = !0, R[ct].features.frac = !0, ct++;
                      H.features.frac = !0, k = ct - 1;
                    }
                  }
                }, at;
              }();
              z(Va, "zeroMarkWidths", "AFTER_GPOS");
              var Ty = new O(s("APABAAAAAAAAOAAAAf0BAv7tmi1MxDAUx7vtvjhAgcDgkEgEAnmXEBIMCYaEcygEiqBQ4FAkCE4ikUgMiiBJSAgSiUQSDMn9L9eSl6bddddug9t7yS/trevre+3r27pcNxZiG+yCfdCVv/9LeQxOwRm4AJegD27ALbgD9+ABPJF+z+BN/h7yDj5k/VOWX6SdmU5+wLWknggxDxaS8u0qiiX4uiz9XamQ3wzDMAzDMAzDMAzDVI/h959V/v7BMAzDMAzDMLlyNTNiMSdewVxbiA44B4/guz1qW58VYlMI0WsJ0W+N6kXw0spvPtdwhtkwnGM6uLaV4Xyzg3v3PM9DPfQ/sOg4xPWjipy31P8LTqbU304c/cLCUmWJLNB2Uz2U1KTeRKNmKHVMfbJC+/0loTZRH/W5cvEvBJPMbREkWt3FD1NcqXZBSpuE2Ad0PBehPtNrPtIEdYP+hiRt/V1jIiE69X4NT/uVZI3PUHE9bm5M7ePGdZWy951v7Nn6j8v1WWKP3mt6ttnsigx6VN7Vc0VomSSGqW2mGNP1muZPl7LfjNUaKNFtDGVf2fvE9O7VlBS5j333c5p/eeoOqcs1R/hIqDWLJ7TTlksirVT1SI7l8k4Yp+g3jafGcrU1RM6l9th80XOpnlN97bDNY4i4s61B0Si/ipa0uHMl6zqEjlFfCZm/TM8KmzQDjmuTAQ==", "base64")), kc = ["isol", "fina", "fin2", "fin3", "medi", "med2", "init"], ou = {
                Non_Joining: 0,
                Left_Joining: 1,
                Right_Joining: 2,
                Dual_Joining: 3,
                Join_Causing: 3,
                ALAPH: 4,
                "DALATH RISH": 5,
                Transparent: 6
              }, En = "isol", Ha = "fina", su = "fin2", Py = "fin3", V0 = "medi", H0 = "med2", W0 = "init", Zr = null, Oy = [
                //   Non_Joining,        Left_Joining,       Right_Joining,     Dual_Joining,           ALAPH,            DALATH RISH
                // State 0: prev was U,  not willing to join.
                [[Zr, Zr, 0], [Zr, En, 2], [Zr, En, 1], [Zr, En, 2], [Zr, En, 1], [Zr, En, 6]],
                // State 1: prev was R or ISOL/ALAPH,  not willing to join.
                [[Zr, Zr, 0], [Zr, En, 2], [Zr, En, 1], [Zr, En, 2], [Zr, su, 5], [Zr, En, 6]],
                // State 2: prev was D/L in ISOL form,  willing to join.
                [[Zr, Zr, 0], [Zr, En, 2], [W0, Ha, 1], [W0, Ha, 3], [W0, Ha, 4], [W0, Ha, 6]],
                // State 3: prev was D in FINA form,  willing to join.
                [[Zr, Zr, 0], [Zr, En, 2], [V0, Ha, 1], [V0, Ha, 3], [V0, Ha, 4], [V0, Ha, 6]],
                // State 4: prev was FINA ALAPH,  not willing to join.
                [[Zr, Zr, 0], [Zr, En, 2], [H0, En, 1], [H0, En, 2], [H0, su, 5], [H0, En, 6]],
                // State 5: prev was FIN2/FIN3 ALAPH,  not willing to join.
                [[Zr, Zr, 0], [Zr, En, 2], [En, En, 1], [En, En, 2], [En, su, 5], [En, En, 6]],
                // State 6: prev was DALATH/RISH,  not willing to join.
                [[Zr, Zr, 0], [Zr, En, 2], [Zr, En, 1], [Zr, En, 2], [Zr, Py, 5], [Zr, En, 6]]
              ], Wa = /* @__PURE__ */ function(at) {
                m(W, at);
                function W() {
                  return at.apply(this, arguments) || this;
                }
                return W.planFeatures = function(R) {
                  R.add(["ccmp", "locl"]);
                  for (var k = 0; k < kc.length; k++) {
                    var H = kc[k];
                    R.addStage(H, !1);
                  }
                  R.addStage("mset");
                }, W.assignFeatures = function(R, k) {
                  at.assignFeatures.call(this, R, k);
                  for (var H = -1, ot = 0, ct = [], ht = 0; ht < k.length; ht++) {
                    var ut = void 0, Nt = void 0, Kt = k[ht], de = Fy(Kt.codePoints[0]);
                    if (de === ou.Transparent) {
                      ct[ht] = Zr;
                      continue;
                    }
                    var te = Oy[ot][de];
                    Nt = te[0], ut = te[1], ot = te[2], Nt !== Zr && H !== -1 && (ct[H] = Nt), ct[ht] = ut, H = ht;
                  }
                  for (var pe = 0; pe < k.length; pe++) {
                    var Ee = void 0, Kt = k[pe];
                    (Ee = ct[pe]) && (Kt.features[Ee] = !0);
                  }
                }, W;
              }(Va);
              function Fy(at) {
                var W = Ty.get(at);
                if (W)
                  return W - 1;
                var $ = A.getCategory(at);
                return $ === "Mn" || $ === "Me" || $ === "Cf" ? ou.Transparent : ou.Non_Joining;
              }
              var Iy = /* @__PURE__ */ function() {
                function at($, R) {
                  this.glyphs = $, this.reset(R);
                }
                var W = at.prototype;
                return W.reset = function(R, k) {
                  R === void 0 && (R = {}), k === void 0 && (k = 0), this.options = R, this.flags = R.flags || {}, this.markAttachmentType = R.markAttachmentType || 0, this.index = k;
                }, W.shouldIgnore = function(R) {
                  return this.flags.ignoreMarks && R.isMark || this.flags.ignoreBaseGlyphs && R.isBase || this.flags.ignoreLigatures && R.isLigature || this.markAttachmentType && R.isMark && R.markAttachmentType !== this.markAttachmentType;
                }, W.move = function(R) {
                  for (this.index += R; 0 <= this.index && this.index < this.glyphs.length && this.shouldIgnore(this.glyphs[this.index]); )
                    this.index += R;
                  return 0 > this.index || this.index >= this.glyphs.length ? null : this.glyphs[this.index];
                }, W.next = function() {
                  return this.move(1);
                }, W.prev = function() {
                  return this.move(-1);
                }, W.peek = function(R) {
                  R === void 0 && (R = 1);
                  var k = this.index, H = this.increment(R);
                  return this.index = k, H;
                }, W.peekIndex = function(R) {
                  R === void 0 && (R = 1);
                  var k = this.index;
                  this.increment(R);
                  var H = this.index;
                  return this.index = k, H;
                }, W.increment = function(R) {
                  R === void 0 && (R = 1);
                  var k = R < 0 ? -1 : 1;
                  for (R = Math.abs(R); R--; )
                    this.move(k);
                  return this.glyphs[this.index];
                }, h(at, [{
                  key: "cur",
                  get: function() {
                    return this.glyphs[this.index] || null;
                  }
                }]), at;
              }(), Ry = ["DFLT", "dflt", "latn"], _0 = /* @__PURE__ */ function() {
                function at($, R) {
                  this.font = $, this.table = R, this.script = null, this.scriptTag = null, this.language = null, this.languageTag = null, this.features = {}, this.lookups = {}, this.variationsIndex = $._variationProcessor ? this.findVariationsIndex($._variationProcessor.normalizedCoords) : -1, this.selectScript(), this.glyphs = [], this.positions = [], this.ligatureID = 1, this.currentFeature = null;
                }
                var W = at.prototype;
                return W.findScript = function(R) {
                  if (this.table.scriptList == null)
                    return null;
                  Array.isArray(R) || (R = [R]);
                  for (var k = g(R), H; !(H = k()).done; )
                    for (var ot = H.value, ct = g(this.table.scriptList), ht; !(ht = ct()).done; ) {
                      var ut = ht.value;
                      if (ut.tag === ot)
                        return ut;
                    }
                  return null;
                }, W.selectScript = function(R, k, H) {
                  var ot = !1, ct;
                  if (!this.script || R !== this.scriptTag) {
                    if (ct = this.findScript(R), ct || (ct = this.findScript(Ry)), !ct)
                      return this.scriptTag;
                    this.scriptTag = ct.tag, this.script = ct.script, this.language = null, this.languageTag = null, ot = !0;
                  }
                  if ((!H || H !== this.direction) && (this.direction = H || Pc(R)), k && k.length < 4 && (k += " ".repeat(4 - k.length)), !k || k !== this.languageTag) {
                    this.language = null;
                    for (var ht = g(this.script.langSysRecords), ut; !(ut = ht()).done; ) {
                      var Nt = ut.value;
                      if (Nt.tag === k) {
                        this.language = Nt.langSys, this.languageTag = Nt.tag;
                        break;
                      }
                    }
                    this.language || (this.language = this.script.defaultLangSys, this.languageTag = null), ot = !0;
                  }
                  if (ot && (this.features = {}, this.language))
                    for (var Kt = g(this.language.featureIndexes), de; !(de = Kt()).done; ) {
                      var te = de.value, pe = this.table.featureList[te], Ee = this.substituteFeatureForVariations(te);
                      this.features[pe.tag] = Ee || pe.feature;
                    }
                  return this.scriptTag;
                }, W.lookupsForFeatures = function(R, k) {
                  R === void 0 && (R = []);
                  for (var H = [], ot = g(R), ct; !(ct = ot()).done; ) {
                    var ht = ct.value, ut = this.features[ht];
                    if (ut)
                      for (var Nt = g(ut.lookupListIndexes), Kt; !(Kt = Nt()).done; ) {
                        var de = Kt.value;
                        k && k.indexOf(de) !== -1 || H.push({
                          feature: ht,
                          index: de,
                          lookup: this.table.lookupList.get(de)
                        });
                      }
                  }
                  return H.sort(function(te, pe) {
                    return te.index - pe.index;
                  }), H;
                }, W.substituteFeatureForVariations = function(R) {
                  if (this.variationsIndex === -1)
                    return null;
                  for (var k = this.table.featureVariations.featureVariationRecords[this.variationsIndex], H = k.featureTableSubstitution.substitutions, ot = g(H), ct; !(ct = ot()).done; ) {
                    var ht = ct.value;
                    if (ht.featureIndex === R)
                      return ht.alternateFeatureTable;
                  }
                  return null;
                }, W.findVariationsIndex = function(R) {
                  var k = this.table.featureVariations;
                  if (!k)
                    return -1;
                  for (var H = k.featureVariationRecords, ot = 0; ot < H.length; ot++) {
                    var ct = H[ot].conditionSet.conditionTable;
                    if (this.variationConditionsMatch(ct, R))
                      return ot;
                  }
                  return -1;
                }, W.variationConditionsMatch = function(R, k) {
                  return R.every(function(H) {
                    var ot = H.axisIndex < k.length ? k[H.axisIndex] : 0;
                    return H.filterRangeMinValue <= ot && ot <= H.filterRangeMaxValue;
                  });
                }, W.applyFeatures = function(R, k, H) {
                  var ot = this.lookupsForFeatures(R);
                  this.applyLookups(ot, k, H);
                }, W.applyLookups = function(R, k, H) {
                  this.glyphs = k, this.positions = H, this.glyphIterator = new Iy(k);
                  for (var ot = g(R), ct; !(ct = ot()).done; ) {
                    var ht = ct.value, ut = ht.feature, Nt = ht.lookup;
                    for (this.currentFeature = ut, this.glyphIterator.reset(Nt.flags); this.glyphIterator.index < k.length; ) {
                      if (!(ut in this.glyphIterator.cur.features)) {
                        this.glyphIterator.next();
                        continue;
                      }
                      for (var Kt = g(Nt.subTables), de; !(de = Kt()).done; ) {
                        var te = de.value, pe = this.applyLookup(Nt.lookupType, te);
                        if (pe)
                          break;
                      }
                      this.glyphIterator.next();
                    }
                  }
                }, W.applyLookup = function(R, k) {
                  throw new Error("applyLookup must be implemented by subclasses");
                }, W.applyLookupList = function(R) {
                  for (var k = this.glyphIterator.options, H = this.glyphIterator.index, ot = g(R), ct; !(ct = ot()).done; ) {
                    var ht = ct.value;
                    this.glyphIterator.reset(k, H), this.glyphIterator.increment(ht.sequenceIndex);
                    var ut = this.table.lookupList.get(ht.lookupListIndex);
                    this.glyphIterator.reset(ut.flags, this.glyphIterator.index);
                    for (var Nt = g(ut.subTables), Kt; !(Kt = Nt()).done; ) {
                      var de = Kt.value;
                      if (this.applyLookup(ut.lookupType, de))
                        break;
                    }
                  }
                  return this.glyphIterator.reset(k, H), !0;
                }, W.coverageIndex = function(R, k) {
                  switch (k == null && (k = this.glyphIterator.cur.id), R.version) {
                    case 1:
                      return R.glyphs.indexOf(k);
                    case 2:
                      for (var H = g(R.rangeRecords), ot; !(ot = H()).done; ) {
                        var ct = ot.value;
                        if (ct.start <= k && k <= ct.end)
                          return ct.startCoverageIndex + k - ct.start;
                      }
                      break;
                  }
                  return -1;
                }, W.match = function(R, k, H, ot) {
                  for (var ct = this.glyphIterator.index, ht = this.glyphIterator.increment(R), ut = 0; ut < k.length && ht && H(k[ut], ht); )
                    ot && ot.push(this.glyphIterator.index), ut++, ht = this.glyphIterator.next();
                  return this.glyphIterator.index = ct, ut < k.length ? !1 : ot || !0;
                }, W.sequenceMatches = function(R, k) {
                  return this.match(R, k, function(H, ot) {
                    return H === ot.id;
                  });
                }, W.sequenceMatchIndices = function(R, k) {
                  var H = this;
                  return this.match(R, k, function(ot, ct) {
                    return H.currentFeature in ct.features ? ot === ct.id : !1;
                  }, []);
                }, W.coverageSequenceMatches = function(R, k) {
                  var H = this;
                  return this.match(R, k, function(ot, ct) {
                    return H.coverageIndex(ot, ct.id) >= 0;
                  });
                }, W.getClassID = function(R, k) {
                  switch (k.version) {
                    case 1:
                      var H = R - k.startGlyph;
                      if (H >= 0 && H < k.classValueArray.length)
                        return k.classValueArray[H];
                      break;
                    case 2:
                      for (var ot = g(k.classRangeRecord), ct; !(ct = ot()).done; ) {
                        var ht = ct.value;
                        if (ht.start <= R && R <= ht.end)
                          return ht.class;
                      }
                      break;
                  }
                  return 0;
                }, W.classSequenceMatches = function(R, k, H) {
                  var ot = this;
                  return this.match(R, k, function(ct, ht) {
                    return ct === ot.getClassID(ht.id, H);
                  });
                }, W.applyContext = function(R) {
                  switch (R.version) {
                    case 1:
                      var k = this.coverageIndex(R.coverage);
                      if (k === -1)
                        return !1;
                      for (var H = R.ruleSets[k], ot = g(H), ct; !(ct = ot()).done; ) {
                        var ht = ct.value;
                        if (this.sequenceMatches(1, ht.input))
                          return this.applyLookupList(ht.lookupRecords);
                      }
                      break;
                    case 2:
                      if (this.coverageIndex(R.coverage) === -1 || (k = this.getClassID(this.glyphIterator.cur.id, R.classDef), k === -1))
                        return !1;
                      H = R.classSet[k];
                      for (var ut = g(H), Nt; !(Nt = ut()).done; ) {
                        var Kt = Nt.value;
                        if (this.classSequenceMatches(1, Kt.classes, R.classDef))
                          return this.applyLookupList(Kt.lookupRecords);
                      }
                      break;
                    case 3:
                      if (this.coverageSequenceMatches(0, R.coverages))
                        return this.applyLookupList(R.lookupRecords);
                      break;
                  }
                  return !1;
                }, W.applyChainingContext = function(R) {
                  switch (R.version) {
                    case 1:
                      var k = this.coverageIndex(R.coverage);
                      if (k === -1)
                        return !1;
                      for (var H = R.chainRuleSets[k], ot = g(H), ct; !(ct = ot()).done; ) {
                        var ht = ct.value;
                        if (this.sequenceMatches(-ht.backtrack.length, ht.backtrack) && this.sequenceMatches(1, ht.input) && this.sequenceMatches(1 + ht.input.length, ht.lookahead))
                          return this.applyLookupList(ht.lookupRecords);
                      }
                      break;
                    case 2:
                      if (this.coverageIndex(R.coverage) === -1)
                        return !1;
                      k = this.getClassID(this.glyphIterator.cur.id, R.inputClassDef);
                      var ut = R.chainClassSet[k];
                      if (!ut)
                        return !1;
                      for (var Nt = g(ut), Kt; !(Kt = Nt()).done; ) {
                        var de = Kt.value;
                        if (this.classSequenceMatches(-de.backtrack.length, de.backtrack, R.backtrackClassDef) && this.classSequenceMatches(1, de.input, R.inputClassDef) && this.classSequenceMatches(1 + de.input.length, de.lookahead, R.lookaheadClassDef))
                          return this.applyLookupList(de.lookupRecords);
                      }
                      break;
                    case 3:
                      if (this.coverageSequenceMatches(-R.backtrackGlyphCount, R.backtrackCoverage) && this.coverageSequenceMatches(0, R.inputCoverage) && this.coverageSequenceMatches(R.inputGlyphCount, R.lookaheadCoverage))
                        return this.applyLookupList(R.lookupRecords);
                      break;
                  }
                  return !1;
                }, at;
              }(), ya = /* @__PURE__ */ function() {
                function at($, R, k, H) {
                  if (k === void 0 && (k = []), this._font = $, this.codePoints = k, this.id = R, this.features = {}, Array.isArray(H))
                    for (var ot = 0; ot < H.length; ot++) {
                      var ct = H[ot];
                      this.features[ct] = !0;
                    }
                  else
                    typeof H == "object" && Object.assign(this.features, H);
                  this.ligatureID = null, this.ligatureComponent = null, this.isLigated = !1, this.cursiveAttachment = null, this.markAttachment = null, this.shaperInfo = null, this.substituted = !1, this.isMultiplied = !1;
                }
                var W = at.prototype;
                return W.copy = function() {
                  return new at(this._font, this.id, this.codePoints, this.features);
                }, h(at, [{
                  key: "id",
                  get: function() {
                    return this._id;
                  },
                  set: function(R) {
                    this._id = R, this.substituted = !0;
                    var k = this._font.GDEF;
                    if (k && k.glyphClassDef) {
                      var H = _0.prototype.getClassID(R, k.glyphClassDef);
                      this.isBase = H === 1, this.isLigature = H === 2, this.isMark = H === 3, this.markAttachmentType = k.markAttachClassDef ? _0.prototype.getClassID(R, k.markAttachClassDef) : 0;
                    } else
                      this.isMark = this.codePoints.length > 0 && this.codePoints.every(A.isMark), this.isBase = !this.isMark, this.isLigature = this.codePoints.length > 1, this.markAttachmentType = 0;
                  }
                }]), at;
              }(), Nc = /* @__PURE__ */ function(at) {
                m(W, at);
                function W() {
                  return at.apply(this, arguments) || this;
                }
                return W.planFeatures = function(R) {
                  R.add(["ljmo", "vjmo", "tjmo"], !1);
                }, W.assignFeatures = function(R, k) {
                  for (var H = 0, ot = 0; ot < k.length; ) {
                    var ct = void 0, ht = k[ot], ut = ht.codePoints[0], Nt = J0(ut), Kt = Ky[H][Nt];
                    switch (ct = Kt[0], H = Kt[1], ct) {
                      case ma:
                        R.font.hasGlyphForCodePoint(ut) || (ot = Gc(k, ot, R.font));
                        break;
                      case fu:
                        ot = Jy(k, ot, R.font);
                        break;
                      case uu:
                        $y(k, ot, R.font);
                        break;
                      case hu:
                        ot = qy(k, ot, R.font);
                        break;
                    }
                    ot++;
                  }
                }, W;
              }(Va);
              z(Nc, "zeroMarkWidths", "NONE");
              var Zo = 44032, Lc = 55204, Dy = Lc - Zo + 1, j0 = 4352, X0 = 4449, uo = 4519, My = 19, Y0 = 21, Bs = 28, By = j0 + My - 1, ky = X0 + Y0 - 1, Ny = uo + Bs - 1, Uc = 9676, Ly = function(W) {
                return 4352 <= W && W <= 4447 || 43360 <= W && W <= 43388;
              }, Uy = function(W) {
                return 4448 <= W && W <= 4519 || 55216 <= W && W <= 55238;
              }, zy = function(W) {
                return 4520 <= W && W <= 4607 || 55243 <= W && W <= 55291;
              }, Gy = function(W) {
                return 12334 <= W && W <= 12335;
              }, Vy = function(W) {
                return Zo <= W && W <= Lc;
              }, Hy = function(W) {
                return W - Zo < Dy && (W - Zo) % Bs === 0;
              }, Wy = function(W) {
                return j0 <= W && W <= By;
              }, _y = function(W) {
                return X0 <= W && W <= ky;
              }, jy = function(W) {
                return 1 <= W && W <= Ny;
              }, Xy = 0, Yy = 1, Z0 = 2, lu = 3, K0 = 4, zc = 5, Zy = 6;
              function J0(at) {
                return Ly(at) ? Yy : Uy(at) ? Z0 : zy(at) ? lu : Hy(at) ? K0 : Vy(at) ? zc : Gy(at) ? Zy : Xy;
              }
              var Fi = 0, ma = 1, fu = 2, uu = 4, hu = 5, Ky = [
                //       X                 L                 V                T                  LV                LVT               M
                // State 0: start state
                [[Fi, 0], [Fi, 1], [Fi, 0], [Fi, 0], [ma, 2], [ma, 3], [hu, 0]],
                // State 1: <L>
                [[Fi, 0], [Fi, 1], [fu, 2], [Fi, 0], [ma, 2], [ma, 3], [hu, 0]],
                // State 2: <L,V> or <LV>
                [[Fi, 0], [Fi, 1], [Fi, 0], [fu, 3], [ma, 2], [ma, 3], [uu, 0]],
                // State 3: <L,V,T> or <LVT>
                [[Fi, 0], [Fi, 1], [Fi, 0], [Fi, 0], [ma, 2], [ma, 3], [uu, 0]]
              ];
              function ks(at, W, $) {
                return new ya(at, at.glyphForCodePoint(W).id, [W], $);
              }
              function Gc(at, W, $) {
                var R = at[W], k = R.codePoints[0], H = k - Zo, ot = uo + H % Bs;
                H = H / Bs | 0;
                var ct = j0 + H / Y0 | 0, ht = X0 + H % Y0;
                if (!$.hasGlyphForCodePoint(ct) || !$.hasGlyphForCodePoint(ht) || ot !== uo && !$.hasGlyphForCodePoint(ot))
                  return W;
                var ut = ks($, ct, R.features);
                ut.features.ljmo = !0;
                var Nt = ks($, ht, R.features);
                Nt.features.vjmo = !0;
                var Kt = [ut, Nt];
                if (ot > uo) {
                  var de = ks($, ot, R.features);
                  de.features.tjmo = !0, Kt.push(de);
                }
                return at.splice.apply(at, [W, 1].concat(Kt)), W + Kt.length - 1;
              }
              function Jy(at, W, $) {
                var R = at[W], k = at[W].codePoints[0], H = J0(k), ot = at[W - 1].codePoints[0], ct = J0(ot), ht, ut, Nt, Kt;
                if (ct === K0 && H === lu)
                  ht = ot, Kt = R;
                else {
                  H === Z0 ? (ut = at[W - 1], Nt = R) : (ut = at[W - 2], Nt = at[W - 1], Kt = R);
                  var de = ut.codePoints[0], te = Nt.codePoints[0];
                  Wy(de) && _y(te) && (ht = Zo + ((de - j0) * Y0 + (te - X0)) * Bs);
                }
                var pe = Kt && Kt.codePoints[0] || uo;
                if (ht != null && (pe === uo || jy(pe))) {
                  var Ee = ht + (pe - uo);
                  if ($.hasGlyphForCodePoint(Ee)) {
                    var Le = ct === Z0 ? 3 : 2;
                    return at.splice(W - Le + 1, Le, ks($, Ee, R.features)), W - Le + 1;
                  }
                }
                return ut && (ut.features.ljmo = !0), Nt && (Nt.features.vjmo = !0), Kt && (Kt.features.tjmo = !0), ct === K0 ? (Gc(at, W - 1, $), W + 1) : W;
              }
              function Qy(at) {
                switch (J0(at)) {
                  case K0:
                  case zc:
                    return 1;
                  case Z0:
                    return 2;
                  case lu:
                    return 3;
                }
              }
              function $y(at, W, $) {
                var R = at[W], k = at[W].codePoints[0];
                if ($.glyphForCodePoint(k).advanceWidth !== 0) {
                  var H = at[W - 1].codePoints[0], ot = Qy(H);
                  return at.splice(W, 1), at.splice(W - ot, 0, R);
                }
              }
              function qy(at, W, $) {
                var R = at[W], k = at[W].codePoints[0];
                if ($.hasGlyphForCodePoint(Uc)) {
                  var H = ks($, Uc, R.features), ot = $.glyphForCodePoint(k).advanceWidth === 0 ? W : W + 1;
                  at.splice(ot, 0, H), W++;
                }
                return W;
              }
              var tm = [[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 2, 3, 4, 5, 6, 7, 8, 9, 0, 10, 11, 11, 12, 13, 14, 15, 16, 17], [0, 0, 0, 18, 19, 20, 21, 22, 23, 0, 24, 0, 0, 25, 26, 0, 0, 27, 0], [0, 0, 0, 28, 29, 30, 31, 32, 33, 0, 34, 0, 0, 35, 36, 0, 0, 37, 0], [0, 0, 0, 38, 5, 7, 7, 8, 9, 0, 10, 0, 0, 0, 13, 0, 0, 16, 0], [0, 39, 0, 0, 0, 40, 41, 0, 9, 0, 10, 0, 0, 0, 42, 0, 39, 0, 0], [0, 0, 0, 0, 43, 44, 44, 8, 9, 0, 0, 0, 0, 12, 43, 0, 0, 0, 0], [0, 0, 0, 0, 43, 44, 44, 8, 9, 0, 0, 0, 0, 0, 43, 0, 0, 0, 0], [0, 0, 0, 45, 46, 47, 48, 49, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 50, 0, 0, 51, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 52, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 53, 54, 55, 56, 57, 58, 0, 59, 0, 0, 60, 61, 0, 0, 62, 0], [0, 0, 0, 4, 5, 7, 7, 8, 9, 0, 10, 0, 0, 0, 13, 0, 0, 16, 0], [0, 63, 64, 0, 0, 40, 41, 0, 9, 0, 10, 0, 0, 0, 42, 0, 63, 0, 0], [0, 2, 3, 4, 5, 6, 7, 8, 9, 0, 10, 11, 11, 12, 13, 0, 2, 16, 0], [0, 0, 0, 18, 65, 20, 21, 22, 23, 0, 24, 0, 0, 25, 26, 0, 0, 27, 0], [0, 0, 0, 0, 66, 67, 67, 8, 9, 0, 10, 0, 0, 0, 68, 0, 0, 0, 0], [0, 0, 0, 69, 0, 70, 70, 0, 71, 0, 72, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 73, 19, 74, 74, 22, 23, 0, 24, 0, 0, 0, 26, 0, 0, 27, 0], [0, 75, 0, 0, 0, 76, 77, 0, 23, 0, 24, 0, 0, 0, 78, 0, 75, 0, 0], [0, 0, 0, 0, 79, 80, 80, 22, 23, 0, 0, 0, 0, 25, 79, 0, 0, 0, 0], [0, 0, 0, 18, 19, 20, 74, 22, 23, 0, 24, 0, 0, 25, 26, 0, 0, 27, 0], [0, 0, 0, 81, 82, 83, 84, 85, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 86, 0, 0, 87, 0, 24, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 88, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 18, 19, 74, 74, 22, 23, 0, 24, 0, 0, 0, 26, 0, 0, 27, 0], [0, 89, 90, 0, 0, 76, 77, 0, 23, 0, 24, 0, 0, 0, 78, 0, 89, 0, 0], [0, 0, 0, 0, 91, 92, 92, 22, 23, 0, 24, 0, 0, 0, 93, 0, 0, 0, 0], [0, 0, 0, 94, 29, 95, 31, 32, 33, 0, 34, 0, 0, 0, 36, 0, 0, 37, 0], [0, 96, 0, 0, 0, 97, 98, 0, 33, 0, 34, 0, 0, 0, 99, 0, 96, 0, 0], [0, 0, 0, 0, 100, 101, 101, 32, 33, 0, 0, 0, 0, 35, 100, 0, 0, 0, 0], [0, 0, 0, 0, 100, 101, 101, 32, 33, 0, 0, 0, 0, 0, 100, 0, 0, 0, 0], [0, 0, 0, 102, 103, 104, 105, 106, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 107, 0, 0, 108, 0, 34, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 109, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 28, 29, 95, 31, 32, 33, 0, 34, 0, 0, 0, 36, 0, 0, 37, 0], [0, 110, 111, 0, 0, 97, 98, 0, 33, 0, 34, 0, 0, 0, 99, 0, 110, 0, 0], [0, 0, 0, 0, 112, 113, 113, 32, 33, 0, 34, 0, 0, 0, 114, 0, 0, 0, 0], [0, 0, 0, 0, 5, 7, 7, 8, 9, 0, 10, 0, 0, 0, 13, 0, 0, 16, 0], [0, 0, 0, 115, 116, 117, 118, 8, 9, 0, 10, 0, 0, 119, 120, 0, 0, 16, 0], [0, 0, 0, 0, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 39, 0, 122, 0, 123, 123, 8, 9, 0, 10, 0, 0, 0, 42, 0, 39, 0, 0], [0, 124, 64, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 124, 0, 0], [0, 39, 0, 0, 0, 121, 125, 0, 9, 0, 10, 0, 0, 0, 42, 0, 39, 0, 0], [0, 0, 0, 0, 0, 126, 126, 8, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 46, 47, 48, 49, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 47, 47, 49, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 127, 127, 49, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 128, 127, 127, 49, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 129, 130, 131, 132, 133, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 50, 0, 0, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 134, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 135, 54, 56, 56, 57, 58, 0, 59, 0, 0, 0, 61, 0, 0, 62, 0], [0, 136, 0, 0, 0, 137, 138, 0, 58, 0, 59, 0, 0, 0, 139, 0, 136, 0, 0], [0, 0, 0, 0, 140, 141, 141, 57, 58, 0, 0, 0, 0, 60, 140, 0, 0, 0, 0], [0, 0, 0, 0, 140, 141, 141, 57, 58, 0, 0, 0, 0, 0, 140, 0, 0, 0, 0], [0, 0, 0, 142, 143, 144, 145, 146, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 147, 0, 0, 148, 0, 59, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 149, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 53, 54, 56, 56, 57, 58, 0, 59, 0, 0, 0, 61, 0, 0, 62, 0], [0, 150, 151, 0, 0, 137, 138, 0, 58, 0, 59, 0, 0, 0, 139, 0, 150, 0, 0], [0, 0, 0, 0, 152, 153, 153, 57, 58, 0, 59, 0, 0, 0, 154, 0, 0, 0, 0], [0, 0, 0, 155, 116, 156, 157, 8, 9, 0, 10, 0, 0, 158, 120, 0, 0, 16, 0], [0, 0, 0, 0, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0], [0, 75, 3, 4, 5, 159, 160, 8, 161, 0, 162, 0, 11, 12, 163, 0, 75, 16, 0], [0, 0, 0, 0, 0, 40, 164, 0, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 165, 44, 44, 8, 9, 0, 0, 0, 0, 0, 165, 0, 0, 0, 0], [0, 124, 64, 0, 0, 40, 164, 0, 9, 0, 10, 0, 0, 0, 42, 0, 124, 0, 0], [0, 0, 0, 0, 0, 70, 70, 0, 71, 0, 72, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 71, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 166, 0, 0, 167, 0, 72, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 168, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 19, 74, 74, 22, 23, 0, 24, 0, 0, 0, 26, 0, 0, 27, 0], [0, 0, 0, 0, 79, 80, 80, 22, 23, 0, 0, 0, 0, 0, 79, 0, 0, 0, 0], [0, 0, 0, 169, 170, 171, 172, 22, 23, 0, 24, 0, 0, 173, 174, 0, 0, 27, 0], [0, 0, 0, 0, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 75, 0, 176, 0, 177, 177, 22, 23, 0, 24, 0, 0, 0, 78, 0, 75, 0, 0], [0, 178, 90, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 178, 0, 0], [0, 75, 0, 0, 0, 175, 179, 0, 23, 0, 24, 0, 0, 0, 78, 0, 75, 0, 0], [0, 0, 0, 0, 0, 180, 180, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 82, 83, 84, 85, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 83, 83, 85, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 181, 181, 85, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 182, 181, 181, 85, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 183, 184, 185, 186, 187, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 24, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 86, 0, 0, 0, 0, 24, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 188, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 189, 170, 190, 191, 22, 23, 0, 24, 0, 0, 192, 174, 0, 0, 27, 0], [0, 0, 0, 0, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 76, 193, 0, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 194, 80, 80, 22, 23, 0, 0, 0, 0, 0, 194, 0, 0, 0, 0], [0, 178, 90, 0, 0, 76, 193, 0, 23, 0, 24, 0, 0, 0, 78, 0, 178, 0, 0], [0, 0, 0, 0, 29, 95, 31, 32, 33, 0, 34, 0, 0, 0, 36, 0, 0, 37, 0], [0, 0, 0, 0, 100, 101, 101, 32, 33, 0, 0, 0, 0, 0, 100, 0, 0, 0, 0], [0, 0, 0, 195, 196, 197, 198, 32, 33, 0, 34, 0, 0, 199, 200, 0, 0, 37, 0], [0, 0, 0, 0, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 96, 0, 202, 0, 203, 203, 32, 33, 0, 34, 0, 0, 0, 99, 0, 96, 0, 0], [0, 204, 111, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 204, 0, 0], [0, 96, 0, 0, 0, 201, 205, 0, 33, 0, 34, 0, 0, 0, 99, 0, 96, 0, 0], [0, 0, 0, 0, 0, 206, 206, 32, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 103, 104, 105, 106, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 104, 104, 106, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 207, 207, 106, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 208, 207, 207, 106, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 209, 210, 211, 212, 213, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 34, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 107, 0, 0, 0, 0, 34, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 214, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 215, 196, 216, 217, 32, 33, 0, 34, 0, 0, 218, 200, 0, 0, 37, 0], [0, 0, 0, 0, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 97, 219, 0, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 220, 101, 101, 32, 33, 0, 0, 0, 0, 0, 220, 0, 0, 0, 0], [0, 204, 111, 0, 0, 97, 219, 0, 33, 0, 34, 0, 0, 0, 99, 0, 204, 0, 0], [0, 0, 0, 221, 116, 222, 222, 8, 9, 0, 10, 0, 0, 0, 120, 0, 0, 16, 0], [0, 223, 0, 0, 0, 40, 224, 0, 9, 0, 10, 0, 0, 0, 42, 0, 223, 0, 0], [0, 0, 0, 0, 225, 44, 44, 8, 9, 0, 0, 0, 0, 119, 225, 0, 0, 0, 0], [0, 0, 0, 115, 116, 117, 222, 8, 9, 0, 10, 0, 0, 119, 120, 0, 0, 16, 0], [0, 0, 0, 115, 116, 222, 222, 8, 9, 0, 10, 0, 0, 0, 120, 0, 0, 16, 0], [0, 226, 64, 0, 0, 40, 224, 0, 9, 0, 10, 0, 0, 0, 42, 0, 226, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 39, 0, 0, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 39, 0, 0], [0, 0, 0, 0, 0, 44, 44, 8, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 227, 0, 228, 229, 0, 9, 0, 10, 0, 0, 230, 0, 0, 0, 0, 0], [0, 39, 0, 122, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 39, 0, 0], [0, 0, 0, 0, 0, 0, 0, 8, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 231, 231, 49, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 232, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 130, 131, 132, 133, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 131, 131, 133, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 233, 233, 133, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 234, 233, 233, 133, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 235, 236, 237, 238, 239, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 54, 56, 56, 57, 58, 0, 59, 0, 0, 0, 61, 0, 0, 62, 0], [0, 0, 0, 240, 241, 242, 243, 57, 58, 0, 59, 0, 0, 244, 245, 0, 0, 62, 0], [0, 0, 0, 0, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 136, 0, 247, 0, 248, 248, 57, 58, 0, 59, 0, 0, 0, 139, 0, 136, 0, 0], [0, 249, 151, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 249, 0, 0], [0, 136, 0, 0, 0, 246, 250, 0, 58, 0, 59, 0, 0, 0, 139, 0, 136, 0, 0], [0, 0, 0, 0, 0, 251, 251, 57, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 143, 144, 145, 146, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 144, 144, 146, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 252, 252, 146, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 253, 252, 252, 146, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 254, 255, 256, 257, 258, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 59, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 147, 0, 0, 0, 0, 59, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 259, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 260, 241, 261, 262, 57, 58, 0, 59, 0, 0, 263, 245, 0, 0, 62, 0], [0, 0, 0, 0, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 137, 264, 0, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 265, 141, 141, 57, 58, 0, 0, 0, 0, 0, 265, 0, 0, 0, 0], [0, 249, 151, 0, 0, 137, 264, 0, 58, 0, 59, 0, 0, 0, 139, 0, 249, 0, 0], [0, 0, 0, 221, 116, 222, 222, 8, 9, 0, 10, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 225, 44, 44, 8, 9, 0, 0, 0, 0, 158, 225, 0, 0, 0, 0], [0, 0, 0, 155, 116, 156, 222, 8, 9, 0, 10, 0, 0, 158, 120, 0, 0, 16, 0], [0, 0, 0, 155, 116, 222, 222, 8, 9, 0, 10, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 43, 266, 266, 8, 161, 0, 24, 0, 0, 12, 267, 0, 0, 0, 0], [0, 75, 0, 176, 43, 268, 268, 269, 161, 0, 24, 0, 0, 0, 267, 0, 75, 0, 0], [0, 0, 0, 0, 0, 270, 0, 0, 271, 0, 162, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 272, 0, 0, 0, 0, 0, 0, 0, 0], [0, 273, 274, 0, 0, 40, 41, 0, 9, 0, 10, 0, 0, 0, 42, 0, 273, 0, 0], [0, 0, 0, 40, 0, 123, 123, 8, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 121, 275, 0, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 72, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 166, 0, 0, 0, 0, 72, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 276, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 277, 170, 278, 278, 22, 23, 0, 24, 0, 0, 0, 174, 0, 0, 27, 0], [0, 279, 0, 0, 0, 76, 280, 0, 23, 0, 24, 0, 0, 0, 78, 0, 279, 0, 0], [0, 0, 0, 0, 281, 80, 80, 22, 23, 0, 0, 0, 0, 173, 281, 0, 0, 0, 0], [0, 0, 0, 169, 170, 171, 278, 22, 23, 0, 24, 0, 0, 173, 174, 0, 0, 27, 0], [0, 0, 0, 169, 170, 278, 278, 22, 23, 0, 24, 0, 0, 0, 174, 0, 0, 27, 0], [0, 282, 90, 0, 0, 76, 280, 0, 23, 0, 24, 0, 0, 0, 78, 0, 282, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 75, 0, 0, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 75, 0, 0], [0, 0, 0, 0, 0, 80, 80, 22, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 283, 0, 284, 285, 0, 23, 0, 24, 0, 0, 286, 0, 0, 0, 0, 0], [0, 75, 0, 176, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 75, 0, 0], [0, 0, 0, 0, 0, 0, 0, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 287, 287, 85, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 288, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 184, 185, 186, 187, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 185, 185, 187, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 289, 289, 187, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 290, 289, 289, 187, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 291, 292, 293, 294, 295, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 277, 170, 278, 278, 22, 23, 0, 24, 0, 0, 0, 174, 0, 0, 27, 0], [0, 0, 0, 0, 281, 80, 80, 22, 23, 0, 0, 0, 0, 192, 281, 0, 0, 0, 0], [0, 0, 0, 189, 170, 190, 278, 22, 23, 0, 24, 0, 0, 192, 174, 0, 0, 27, 0], [0, 0, 0, 189, 170, 278, 278, 22, 23, 0, 24, 0, 0, 0, 174, 0, 0, 27, 0], [0, 0, 0, 76, 0, 177, 177, 22, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 175, 296, 0, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 297, 196, 298, 298, 32, 33, 0, 34, 0, 0, 0, 200, 0, 0, 37, 0], [0, 299, 0, 0, 0, 97, 300, 0, 33, 0, 34, 0, 0, 0, 99, 0, 299, 0, 0], [0, 0, 0, 0, 301, 101, 101, 32, 33, 0, 0, 0, 0, 199, 301, 0, 0, 0, 0], [0, 0, 0, 195, 196, 197, 298, 32, 33, 0, 34, 0, 0, 199, 200, 0, 0, 37, 0], [0, 0, 0, 195, 196, 298, 298, 32, 33, 0, 34, 0, 0, 0, 200, 0, 0, 37, 0], [0, 302, 111, 0, 0, 97, 300, 0, 33, 0, 34, 0, 0, 0, 99, 0, 302, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 96, 0, 0, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 96, 0, 0], [0, 0, 0, 0, 0, 101, 101, 32, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 303, 0, 304, 305, 0, 33, 0, 34, 0, 0, 306, 0, 0, 0, 0, 0], [0, 96, 0, 202, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 96, 0, 0], [0, 0, 0, 0, 0, 0, 0, 32, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 307, 307, 106, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 308, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 210, 211, 212, 213, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 211, 211, 213, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 309, 309, 213, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 310, 309, 309, 213, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 311, 312, 313, 314, 315, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 297, 196, 298, 298, 32, 33, 0, 34, 0, 0, 0, 200, 0, 0, 37, 0], [0, 0, 0, 0, 301, 101, 101, 32, 33, 0, 0, 0, 0, 218, 301, 0, 0, 0, 0], [0, 0, 0, 215, 196, 216, 298, 32, 33, 0, 34, 0, 0, 218, 200, 0, 0, 37, 0], [0, 0, 0, 215, 196, 298, 298, 32, 33, 0, 34, 0, 0, 0, 200, 0, 0, 37, 0], [0, 0, 0, 97, 0, 203, 203, 32, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 201, 316, 0, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 116, 222, 222, 8, 9, 0, 10, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 225, 44, 44, 8, 9, 0, 0, 0, 0, 0, 225, 0, 0, 0, 0], [0, 0, 0, 317, 318, 319, 320, 8, 9, 0, 10, 0, 0, 321, 322, 0, 0, 16, 0], [0, 223, 0, 323, 0, 123, 123, 8, 9, 0, 10, 0, 0, 0, 42, 0, 223, 0, 0], [0, 223, 0, 0, 0, 121, 324, 0, 9, 0, 10, 0, 0, 0, 42, 0, 223, 0, 0], [0, 0, 0, 325, 318, 326, 327, 8, 9, 0, 10, 0, 0, 328, 322, 0, 0, 16, 0], [0, 0, 0, 64, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 9, 0, 0, 0, 0, 230, 0, 0, 0, 0, 0], [0, 0, 0, 227, 0, 228, 121, 0, 9, 0, 10, 0, 0, 230, 0, 0, 0, 0, 0], [0, 0, 0, 227, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 49, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 46, 0, 0], [0, 0, 0, 0, 0, 329, 329, 133, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 330, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 236, 237, 238, 239, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 237, 237, 239, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 331, 331, 239, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 332, 331, 331, 239, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 333, 40, 121, 334, 0, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 335, 241, 336, 336, 57, 58, 0, 59, 0, 0, 0, 245, 0, 0, 62, 0], [0, 337, 0, 0, 0, 137, 338, 0, 58, 0, 59, 0, 0, 0, 139, 0, 337, 0, 0], [0, 0, 0, 0, 339, 141, 141, 57, 58, 0, 0, 0, 0, 244, 339, 0, 0, 0, 0], [0, 0, 0, 240, 241, 242, 336, 57, 58, 0, 59, 0, 0, 244, 245, 0, 0, 62, 0], [0, 0, 0, 240, 241, 336, 336, 57, 58, 0, 59, 0, 0, 0, 245, 0, 0, 62, 0], [0, 340, 151, 0, 0, 137, 338, 0, 58, 0, 59, 0, 0, 0, 139, 0, 340, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 136, 0, 0, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 136, 0, 0], [0, 0, 0, 0, 0, 141, 141, 57, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 341, 0, 342, 343, 0, 58, 0, 59, 0, 0, 344, 0, 0, 0, 0, 0], [0, 136, 0, 247, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 136, 0, 0], [0, 0, 0, 0, 0, 0, 0, 57, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 345, 345, 146, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 346, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 255, 256, 257, 258, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 256, 256, 258, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 347, 347, 258, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 348, 347, 347, 258, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 349, 350, 351, 352, 353, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 335, 241, 336, 336, 57, 58, 0, 59, 0, 0, 0, 245, 0, 0, 62, 0], [0, 0, 0, 0, 339, 141, 141, 57, 58, 0, 0, 0, 0, 263, 339, 0, 0, 0, 0], [0, 0, 0, 260, 241, 261, 336, 57, 58, 0, 59, 0, 0, 263, 245, 0, 0, 62, 0], [0, 0, 0, 260, 241, 336, 336, 57, 58, 0, 59, 0, 0, 0, 245, 0, 0, 62, 0], [0, 0, 0, 137, 0, 248, 248, 57, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 246, 354, 0, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 126, 126, 8, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 355, 90, 0, 0, 121, 125, 0, 9, 0, 10, 0, 0, 0, 42, 0, 355, 0, 0], [0, 0, 0, 0, 0, 356, 356, 269, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 357, 358, 359, 360, 361, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 162, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 270, 0, 0, 0, 0, 162, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 363, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 364, 116, 365, 366, 8, 161, 0, 162, 0, 0, 367, 120, 0, 0, 16, 0], [0, 0, 0, 0, 0, 368, 368, 0, 161, 0, 162, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 40, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 170, 278, 278, 22, 23, 0, 24, 0, 0, 0, 174, 0, 0, 27, 0], [0, 0, 0, 0, 281, 80, 80, 22, 23, 0, 0, 0, 0, 0, 281, 0, 0, 0, 0], [0, 0, 0, 369, 370, 371, 372, 22, 23, 0, 24, 0, 0, 373, 374, 0, 0, 27, 0], [0, 279, 0, 375, 0, 177, 177, 22, 23, 0, 24, 0, 0, 0, 78, 0, 279, 0, 0], [0, 279, 0, 0, 0, 175, 376, 0, 23, 0, 24, 0, 0, 0, 78, 0, 279, 0, 0], [0, 0, 0, 377, 370, 378, 379, 22, 23, 0, 24, 0, 0, 380, 374, 0, 0, 27, 0], [0, 0, 0, 90, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 23, 0, 0, 0, 0, 286, 0, 0, 0, 0, 0], [0, 0, 0, 283, 0, 284, 175, 0, 23, 0, 24, 0, 0, 286, 0, 0, 0, 0, 0], [0, 0, 0, 283, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 85, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 82, 0, 0], [0, 0, 0, 0, 0, 381, 381, 187, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 382, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 292, 293, 294, 295, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 293, 293, 295, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 383, 383, 295, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 384, 383, 383, 295, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 385, 76, 175, 386, 0, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 76, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 196, 298, 298, 32, 33, 0, 34, 0, 0, 0, 200, 0, 0, 37, 0], [0, 0, 0, 0, 301, 101, 101, 32, 33, 0, 0, 0, 0, 0, 301, 0, 0, 0, 0], [0, 0, 0, 387, 388, 389, 390, 32, 33, 0, 34, 0, 0, 391, 392, 0, 0, 37, 0], [0, 299, 0, 393, 0, 203, 203, 32, 33, 0, 34, 0, 0, 0, 99, 0, 299, 0, 0], [0, 299, 0, 0, 0, 201, 394, 0, 33, 0, 34, 0, 0, 0, 99, 0, 299, 0, 0], [0, 0, 0, 395, 388, 396, 397, 32, 33, 0, 34, 0, 0, 398, 392, 0, 0, 37, 0], [0, 0, 0, 111, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 33, 0, 0, 0, 0, 306, 0, 0, 0, 0, 0], [0, 0, 0, 303, 0, 304, 201, 0, 33, 0, 34, 0, 0, 306, 0, 0, 0, 0, 0], [0, 0, 0, 303, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 106, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 103, 0, 0], [0, 0, 0, 0, 0, 399, 399, 213, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 400, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 312, 313, 314, 315, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 313, 313, 315, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 401, 401, 315, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 402, 401, 401, 315, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 403, 97, 201, 404, 0, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 97, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 405, 318, 406, 406, 8, 9, 0, 10, 0, 0, 0, 322, 0, 0, 16, 0], [0, 407, 0, 0, 0, 40, 408, 0, 9, 0, 10, 0, 0, 0, 42, 0, 407, 0, 0], [0, 0, 0, 0, 409, 44, 44, 8, 9, 0, 0, 0, 0, 321, 409, 0, 0, 0, 0], [0, 0, 0, 317, 318, 319, 406, 8, 9, 0, 10, 0, 0, 321, 322, 0, 0, 16, 0], [0, 0, 0, 317, 318, 406, 406, 8, 9, 0, 10, 0, 0, 0, 322, 0, 0, 16, 0], [0, 410, 64, 0, 0, 40, 408, 0, 9, 0, 10, 0, 0, 0, 42, 0, 410, 0, 0], [0, 223, 0, 0, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 223, 0, 0], [0, 223, 0, 323, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 223, 0, 0], [0, 0, 0, 405, 318, 406, 406, 8, 9, 0, 10, 0, 0, 0, 322, 0, 0, 16, 0], [0, 0, 0, 0, 409, 44, 44, 8, 9, 0, 0, 0, 0, 328, 409, 0, 0, 0, 0], [0, 0, 0, 325, 318, 326, 406, 8, 9, 0, 10, 0, 0, 328, 322, 0, 0, 16, 0], [0, 0, 0, 325, 318, 406, 406, 8, 9, 0, 10, 0, 0, 0, 322, 0, 0, 16, 0], [0, 0, 0, 0, 0, 0, 0, 133, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 130, 0, 0], [0, 0, 0, 0, 0, 411, 411, 239, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 412, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 40, 121, 334, 0, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 413, 0, 0, 0, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 241, 336, 336, 57, 58, 0, 59, 0, 0, 0, 245, 0, 0, 62, 0], [0, 0, 0, 0, 339, 141, 141, 57, 58, 0, 0, 0, 0, 0, 339, 0, 0, 0, 0], [0, 0, 0, 414, 415, 416, 417, 57, 58, 0, 59, 0, 0, 418, 419, 0, 0, 62, 0], [0, 337, 0, 420, 0, 248, 248, 57, 58, 0, 59, 0, 0, 0, 139, 0, 337, 0, 0], [0, 337, 0, 0, 0, 246, 421, 0, 58, 0, 59, 0, 0, 0, 139, 0, 337, 0, 0], [0, 0, 0, 422, 415, 423, 424, 57, 58, 0, 59, 0, 0, 425, 419, 0, 0, 62, 0], [0, 0, 0, 151, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 58, 0, 0, 0, 0, 344, 0, 0, 0, 0, 0], [0, 0, 0, 341, 0, 342, 246, 0, 58, 0, 59, 0, 0, 344, 0, 0, 0, 0, 0], [0, 0, 0, 341, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 146, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 143, 0, 0], [0, 0, 0, 0, 0, 426, 426, 258, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 427, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 350, 351, 352, 353, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 351, 351, 353, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 428, 428, 353, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 429, 428, 428, 353, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 430, 137, 246, 431, 0, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 137, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 432, 116, 433, 434, 8, 161, 0, 162, 0, 0, 435, 120, 0, 0, 16, 0], [0, 0, 0, 0, 0, 180, 180, 269, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 358, 359, 360, 361, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 359, 359, 361, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 436, 436, 361, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 437, 436, 436, 361, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 438, 439, 440, 441, 442, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 443, 274, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 443, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 444, 116, 445, 445, 8, 161, 0, 162, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 225, 44, 44, 8, 161, 0, 0, 0, 0, 367, 225, 0, 0, 0, 0], [0, 0, 0, 364, 116, 365, 445, 8, 161, 0, 162, 0, 0, 367, 120, 0, 0, 16, 0], [0, 0, 0, 364, 116, 445, 445, 8, 161, 0, 162, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 0, 0, 0, 0, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 446, 370, 447, 447, 22, 23, 0, 24, 0, 0, 0, 374, 0, 0, 27, 0], [0, 448, 0, 0, 0, 76, 449, 0, 23, 0, 24, 0, 0, 0, 78, 0, 448, 0, 0], [0, 0, 0, 0, 450, 80, 80, 22, 23, 0, 0, 0, 0, 373, 450, 0, 0, 0, 0], [0, 0, 0, 369, 370, 371, 447, 22, 23, 0, 24, 0, 0, 373, 374, 0, 0, 27, 0], [0, 0, 0, 369, 370, 447, 447, 22, 23, 0, 24, 0, 0, 0, 374, 0, 0, 27, 0], [0, 451, 90, 0, 0, 76, 449, 0, 23, 0, 24, 0, 0, 0, 78, 0, 451, 0, 0], [0, 279, 0, 0, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 279, 0, 0], [0, 279, 0, 375, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 279, 0, 0], [0, 0, 0, 446, 370, 447, 447, 22, 23, 0, 24, 0, 0, 0, 374, 0, 0, 27, 0], [0, 0, 0, 0, 450, 80, 80, 22, 23, 0, 0, 0, 0, 380, 450, 0, 0, 0, 0], [0, 0, 0, 377, 370, 378, 447, 22, 23, 0, 24, 0, 0, 380, 374, 0, 0, 27, 0], [0, 0, 0, 377, 370, 447, 447, 22, 23, 0, 24, 0, 0, 0, 374, 0, 0, 27, 0], [0, 0, 0, 0, 0, 0, 0, 187, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 184, 0, 0], [0, 0, 0, 0, 0, 452, 452, 295, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 453, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 76, 175, 386, 0, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 454, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 455, 388, 456, 456, 32, 33, 0, 34, 0, 0, 0, 392, 0, 0, 37, 0], [0, 457, 0, 0, 0, 97, 458, 0, 33, 0, 34, 0, 0, 0, 99, 0, 457, 0, 0], [0, 0, 0, 0, 459, 101, 101, 32, 33, 0, 0, 0, 0, 391, 459, 0, 0, 0, 0], [0, 0, 0, 387, 388, 389, 456, 32, 33, 0, 34, 0, 0, 391, 392, 0, 0, 37, 0], [0, 0, 0, 387, 388, 456, 456, 32, 33, 0, 34, 0, 0, 0, 392, 0, 0, 37, 0], [0, 460, 111, 0, 0, 97, 458, 0, 33, 0, 34, 0, 0, 0, 99, 0, 460, 0, 0], [0, 299, 0, 0, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 299, 0, 0], [0, 299, 0, 393, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 299, 0, 0], [0, 0, 0, 455, 388, 456, 456, 32, 33, 0, 34, 0, 0, 0, 392, 0, 0, 37, 0], [0, 0, 0, 0, 459, 101, 101, 32, 33, 0, 0, 0, 0, 398, 459, 0, 0, 0, 0], [0, 0, 0, 395, 388, 396, 456, 32, 33, 0, 34, 0, 0, 398, 392, 0, 0, 37, 0], [0, 0, 0, 395, 388, 456, 456, 32, 33, 0, 34, 0, 0, 0, 392, 0, 0, 37, 0], [0, 0, 0, 0, 0, 0, 0, 213, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 210, 0, 0], [0, 0, 0, 0, 0, 461, 461, 315, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 462, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 97, 201, 404, 0, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 463, 0, 0, 0, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 318, 406, 406, 8, 9, 0, 10, 0, 0, 0, 322, 0, 0, 16, 0], [0, 0, 0, 0, 409, 44, 44, 8, 9, 0, 0, 0, 0, 0, 409, 0, 0, 0, 0], [0, 0, 0, 464, 465, 466, 467, 8, 9, 0, 10, 0, 0, 468, 469, 0, 0, 16, 0], [0, 407, 0, 470, 0, 123, 123, 8, 9, 0, 10, 0, 0, 0, 42, 0, 407, 0, 0], [0, 407, 0, 0, 0, 121, 471, 0, 9, 0, 10, 0, 0, 0, 42, 0, 407, 0, 0], [0, 0, 0, 472, 465, 473, 474, 8, 9, 0, 10, 0, 0, 475, 469, 0, 0, 16, 0], [0, 0, 0, 0, 0, 0, 0, 239, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 236, 0, 0], [0, 0, 0, 0, 0, 0, 476, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 477, 415, 478, 478, 57, 58, 0, 59, 0, 0, 0, 419, 0, 0, 62, 0], [0, 479, 0, 0, 0, 137, 480, 0, 58, 0, 59, 0, 0, 0, 139, 0, 479, 0, 0], [0, 0, 0, 0, 481, 141, 141, 57, 58, 0, 0, 0, 0, 418, 481, 0, 0, 0, 0], [0, 0, 0, 414, 415, 416, 478, 57, 58, 0, 59, 0, 0, 418, 419, 0, 0, 62, 0], [0, 0, 0, 414, 415, 478, 478, 57, 58, 0, 59, 0, 0, 0, 419, 0, 0, 62, 0], [0, 482, 151, 0, 0, 137, 480, 0, 58, 0, 59, 0, 0, 0, 139, 0, 482, 0, 0], [0, 337, 0, 0, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 337, 0, 0], [0, 337, 0, 420, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 337, 0, 0], [0, 0, 0, 477, 415, 478, 478, 57, 58, 0, 59, 0, 0, 0, 419, 0, 0, 62, 0], [0, 0, 0, 0, 481, 141, 141, 57, 58, 0, 0, 0, 0, 425, 481, 0, 0, 0, 0], [0, 0, 0, 422, 415, 423, 478, 57, 58, 0, 59, 0, 0, 425, 419, 0, 0, 62, 0], [0, 0, 0, 422, 415, 478, 478, 57, 58, 0, 59, 0, 0, 0, 419, 0, 0, 62, 0], [0, 0, 0, 0, 0, 0, 0, 258, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 255, 0, 0], [0, 0, 0, 0, 0, 483, 483, 353, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 484, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 137, 246, 431, 0, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 485, 0, 0, 0, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 444, 116, 445, 445, 8, 161, 0, 162, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 225, 44, 44, 8, 161, 0, 0, 0, 0, 435, 225, 0, 0, 0, 0], [0, 0, 0, 432, 116, 433, 445, 8, 161, 0, 162, 0, 0, 435, 120, 0, 0, 16, 0], [0, 0, 0, 432, 116, 445, 445, 8, 161, 0, 162, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 0, 486, 486, 361, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 487, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 439, 440, 441, 442, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 440, 440, 442, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 488, 488, 442, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 489, 488, 488, 442, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 490, 491, 492, 493, 494, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 495, 0, 496, 497, 0, 161, 0, 162, 0, 0, 498, 0, 0, 0, 0, 0], [0, 0, 0, 0, 116, 445, 445, 8, 161, 0, 162, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 225, 44, 44, 8, 161, 0, 0, 0, 0, 0, 225, 0, 0, 0, 0], [0, 0, 0, 0, 370, 447, 447, 22, 23, 0, 24, 0, 0, 0, 374, 0, 0, 27, 0], [0, 0, 0, 0, 450, 80, 80, 22, 23, 0, 0, 0, 0, 0, 450, 0, 0, 0, 0], [0, 0, 0, 499, 500, 501, 502, 22, 23, 0, 24, 0, 0, 503, 504, 0, 0, 27, 0], [0, 448, 0, 505, 0, 177, 177, 22, 23, 0, 24, 0, 0, 0, 78, 0, 448, 0, 0], [0, 448, 0, 0, 0, 175, 506, 0, 23, 0, 24, 0, 0, 0, 78, 0, 448, 0, 0], [0, 0, 0, 507, 500, 508, 509, 22, 23, 0, 24, 0, 0, 510, 504, 0, 0, 27, 0], [0, 0, 0, 0, 0, 0, 0, 295, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 292, 0, 0], [0, 0, 0, 0, 0, 0, 511, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 388, 456, 456, 32, 33, 0, 34, 0, 0, 0, 392, 0, 0, 37, 0], [0, 0, 0, 0, 459, 101, 101, 32, 33, 0, 0, 0, 0, 0, 459, 0, 0, 0, 0], [0, 0, 0, 512, 513, 514, 515, 32, 33, 0, 34, 0, 0, 516, 517, 0, 0, 37, 0], [0, 457, 0, 518, 0, 203, 203, 32, 33, 0, 34, 0, 0, 0, 99, 0, 457, 0, 0], [0, 457, 0, 0, 0, 201, 519, 0, 33, 0, 34, 0, 0, 0, 99, 0, 457, 0, 0], [0, 0, 0, 520, 513, 521, 522, 32, 33, 0, 34, 0, 0, 523, 517, 0, 0, 37, 0], [0, 0, 0, 0, 0, 0, 0, 315, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 312, 0, 0], [0, 0, 0, 0, 0, 0, 524, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 525, 465, 526, 526, 8, 9, 0, 10, 0, 0, 0, 469, 0, 0, 16, 0], [0, 527, 0, 0, 0, 40, 528, 0, 9, 0, 10, 0, 0, 0, 42, 0, 527, 0, 0], [0, 0, 0, 0, 529, 44, 44, 8, 9, 0, 0, 0, 0, 468, 529, 0, 0, 0, 0], [0, 0, 0, 464, 465, 466, 526, 8, 9, 0, 10, 0, 0, 468, 469, 0, 0, 16, 0], [0, 0, 0, 464, 465, 526, 526, 8, 9, 0, 10, 0, 0, 0, 469, 0, 0, 16, 0], [0, 530, 64, 0, 0, 40, 528, 0, 9, 0, 10, 0, 0, 0, 42, 0, 530, 0, 0], [0, 407, 0, 0, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 407, 0, 0], [0, 407, 0, 470, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 407, 0, 0], [0, 0, 0, 525, 465, 526, 526, 8, 9, 0, 10, 0, 0, 0, 469, 0, 0, 16, 0], [0, 0, 0, 0, 529, 44, 44, 8, 9, 0, 0, 0, 0, 475, 529, 0, 0, 0, 0], [0, 0, 0, 472, 465, 473, 526, 8, 9, 0, 10, 0, 0, 475, 469, 0, 0, 16, 0], [0, 0, 0, 472, 465, 526, 526, 8, 9, 0, 10, 0, 0, 0, 469, 0, 0, 16, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 40, 0, 0], [0, 0, 0, 0, 415, 478, 478, 57, 58, 0, 59, 0, 0, 0, 419, 0, 0, 62, 0], [0, 0, 0, 0, 481, 141, 141, 57, 58, 0, 0, 0, 0, 0, 481, 0, 0, 0, 0], [0, 0, 0, 531, 532, 533, 534, 57, 58, 0, 59, 0, 0, 535, 536, 0, 0, 62, 0], [0, 479, 0, 537, 0, 248, 248, 57, 58, 0, 59, 0, 0, 0, 139, 0, 479, 0, 0], [0, 479, 0, 0, 0, 246, 538, 0, 58, 0, 59, 0, 0, 0, 139, 0, 479, 0, 0], [0, 0, 0, 539, 532, 540, 541, 57, 58, 0, 59, 0, 0, 542, 536, 0, 0, 62, 0], [0, 0, 0, 0, 0, 0, 0, 353, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 350, 0, 0], [0, 0, 0, 0, 0, 0, 543, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 361, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 358, 0, 0], [0, 0, 0, 0, 0, 544, 544, 442, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 545, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 491, 492, 493, 494, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 492, 492, 494, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 546, 546, 494, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 547, 546, 546, 494, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 548, 549, 368, 550, 0, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 274, 0, 368, 368, 0, 161, 0, 162, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 161, 0, 0, 0, 0, 498, 0, 0, 0, 0, 0], [0, 0, 0, 495, 0, 496, 368, 0, 161, 0, 162, 0, 0, 498, 0, 0, 0, 0, 0], [0, 0, 0, 495, 0, 368, 368, 0, 161, 0, 162, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 551, 500, 552, 552, 22, 23, 0, 24, 0, 0, 0, 504, 0, 0, 27, 0], [0, 553, 0, 0, 0, 76, 554, 0, 23, 0, 24, 0, 0, 0, 78, 0, 553, 0, 0], [0, 0, 0, 0, 555, 80, 80, 22, 23, 0, 0, 0, 0, 503, 555, 0, 0, 0, 0], [0, 0, 0, 499, 500, 501, 552, 22, 23, 0, 24, 0, 0, 503, 504, 0, 0, 27, 0], [0, 0, 0, 499, 500, 552, 552, 22, 23, 0, 24, 0, 0, 0, 504, 0, 0, 27, 0], [0, 556, 90, 0, 0, 76, 554, 0, 23, 0, 24, 0, 0, 0, 78, 0, 556, 0, 0], [0, 448, 0, 0, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 448, 0, 0], [0, 448, 0, 505, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 448, 0, 0], [0, 0, 0, 551, 500, 552, 552, 22, 23, 0, 24, 0, 0, 0, 504, 0, 0, 27, 0], [0, 0, 0, 0, 555, 80, 80, 22, 23, 0, 0, 0, 0, 510, 555, 0, 0, 0, 0], [0, 0, 0, 507, 500, 508, 552, 22, 23, 0, 24, 0, 0, 510, 504, 0, 0, 27, 0], [0, 0, 0, 507, 500, 552, 552, 22, 23, 0, 24, 0, 0, 0, 504, 0, 0, 27, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 76, 0, 0], [0, 0, 0, 557, 513, 558, 558, 32, 33, 0, 34, 0, 0, 0, 517, 0, 0, 37, 0], [0, 559, 0, 0, 0, 97, 560, 0, 33, 0, 34, 0, 0, 0, 99, 0, 559, 0, 0], [0, 0, 0, 0, 561, 101, 101, 32, 33, 0, 0, 0, 0, 516, 561, 0, 0, 0, 0], [0, 0, 0, 512, 513, 514, 558, 32, 33, 0, 34, 0, 0, 516, 517, 0, 0, 37, 0], [0, 0, 0, 512, 513, 558, 558, 32, 33, 0, 34, 0, 0, 0, 517, 0, 0, 37, 0], [0, 562, 111, 0, 0, 97, 560, 0, 33, 0, 34, 0, 0, 0, 99, 0, 562, 0, 0], [0, 457, 0, 0, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 457, 0, 0], [0, 457, 0, 518, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 457, 0, 0], [0, 0, 0, 557, 513, 558, 558, 32, 33, 0, 34, 0, 0, 0, 517, 0, 0, 37, 0], [0, 0, 0, 0, 561, 101, 101, 32, 33, 0, 0, 0, 0, 523, 561, 0, 0, 0, 0], [0, 0, 0, 520, 513, 521, 558, 32, 33, 0, 34, 0, 0, 523, 517, 0, 0, 37, 0], [0, 0, 0, 520, 513, 558, 558, 32, 33, 0, 34, 0, 0, 0, 517, 0, 0, 37, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 97, 0, 0], [0, 0, 0, 0, 465, 526, 526, 8, 9, 0, 10, 0, 0, 0, 469, 0, 0, 16, 0], [0, 0, 0, 0, 529, 44, 44, 8, 9, 0, 0, 0, 0, 0, 529, 0, 0, 0, 0], [0, 0, 0, 563, 66, 564, 565, 8, 9, 0, 10, 0, 0, 566, 68, 0, 0, 16, 0], [0, 527, 0, 567, 0, 123, 123, 8, 9, 0, 10, 0, 0, 0, 42, 0, 527, 0, 0], [0, 527, 0, 0, 0, 121, 568, 0, 9, 0, 10, 0, 0, 0, 42, 0, 527, 0, 0], [0, 0, 0, 569, 66, 570, 571, 8, 9, 0, 10, 0, 0, 572, 68, 0, 0, 16, 0], [0, 0, 0, 573, 532, 574, 574, 57, 58, 0, 59, 0, 0, 0, 536, 0, 0, 62, 0], [0, 575, 0, 0, 0, 137, 576, 0, 58, 0, 59, 0, 0, 0, 139, 0, 575, 0, 0], [0, 0, 0, 0, 577, 141, 141, 57, 58, 0, 0, 0, 0, 535, 577, 0, 0, 0, 0], [0, 0, 0, 531, 532, 533, 574, 57, 58, 0, 59, 0, 0, 535, 536, 0, 0, 62, 0], [0, 0, 0, 531, 532, 574, 574, 57, 58, 0, 59, 0, 0, 0, 536, 0, 0, 62, 0], [0, 578, 151, 0, 0, 137, 576, 0, 58, 0, 59, 0, 0, 0, 139, 0, 578, 0, 0], [0, 479, 0, 0, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 479, 0, 0], [0, 479, 0, 537, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 479, 0, 0], [0, 0, 0, 573, 532, 574, 574, 57, 58, 0, 59, 0, 0, 0, 536, 0, 0, 62, 0], [0, 0, 0, 0, 577, 141, 141, 57, 58, 0, 0, 0, 0, 542, 577, 0, 0, 0, 0], [0, 0, 0, 539, 532, 540, 574, 57, 58, 0, 59, 0, 0, 542, 536, 0, 0, 62, 0], [0, 0, 0, 539, 532, 574, 574, 57, 58, 0, 59, 0, 0, 0, 536, 0, 0, 62, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 137, 0, 0], [0, 0, 0, 0, 0, 0, 0, 442, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 439, 0, 0], [0, 0, 0, 0, 0, 579, 579, 494, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 580, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 549, 368, 550, 0, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 368, 368, 0, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 581, 0, 0, 0, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 500, 552, 552, 22, 23, 0, 24, 0, 0, 0, 504, 0, 0, 27, 0], [0, 0, 0, 0, 555, 80, 80, 22, 23, 0, 0, 0, 0, 0, 555, 0, 0, 0, 0], [0, 0, 0, 582, 91, 583, 584, 22, 23, 0, 24, 0, 0, 585, 93, 0, 0, 27, 0], [0, 553, 0, 586, 0, 177, 177, 22, 23, 0, 24, 0, 0, 0, 78, 0, 553, 0, 0], [0, 553, 0, 0, 0, 175, 587, 0, 23, 0, 24, 0, 0, 0, 78, 0, 553, 0, 0], [0, 0, 0, 588, 91, 589, 590, 22, 23, 0, 24, 0, 0, 591, 93, 0, 0, 27, 0], [0, 0, 0, 0, 513, 558, 558, 32, 33, 0, 34, 0, 0, 0, 517, 0, 0, 37, 0], [0, 0, 0, 0, 561, 101, 101, 32, 33, 0, 0, 0, 0, 0, 561, 0, 0, 0, 0], [0, 0, 0, 592, 112, 593, 594, 32, 33, 0, 34, 0, 0, 595, 114, 0, 0, 37, 0], [0, 559, 0, 596, 0, 203, 203, 32, 33, 0, 34, 0, 0, 0, 99, 0, 559, 0, 0], [0, 559, 0, 0, 0, 201, 597, 0, 33, 0, 34, 0, 0, 0, 99, 0, 559, 0, 0], [0, 0, 0, 598, 112, 599, 600, 32, 33, 0, 34, 0, 0, 601, 114, 0, 0, 37, 0], [0, 0, 0, 602, 66, 67, 67, 8, 9, 0, 10, 0, 0, 0, 68, 0, 0, 16, 0], [0, 0, 0, 0, 165, 44, 44, 8, 9, 0, 0, 0, 0, 566, 165, 0, 0, 0, 0], [0, 0, 0, 563, 66, 564, 67, 8, 9, 0, 10, 0, 0, 566, 68, 0, 0, 16, 0], [0, 0, 0, 563, 66, 67, 67, 8, 9, 0, 10, 0, 0, 0, 68, 0, 0, 16, 0], [0, 527, 0, 0, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 527, 0, 0], [0, 527, 0, 567, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 527, 0, 0], [0, 0, 0, 602, 66, 67, 67, 8, 9, 0, 10, 0, 0, 0, 68, 0, 0, 16, 0], [0, 0, 0, 0, 165, 44, 44, 8, 9, 0, 0, 0, 0, 572, 165, 0, 0, 0, 0], [0, 0, 0, 569, 66, 570, 67, 8, 9, 0, 10, 0, 0, 572, 68, 0, 0, 16, 0], [0, 0, 0, 569, 66, 67, 67, 8, 9, 0, 10, 0, 0, 0, 68, 0, 0, 16, 0], [0, 0, 0, 0, 532, 574, 574, 57, 58, 0, 59, 0, 0, 0, 536, 0, 0, 62, 0], [0, 0, 0, 0, 577, 141, 141, 57, 58, 0, 0, 0, 0, 0, 577, 0, 0, 0, 0], [0, 0, 0, 603, 152, 604, 605, 57, 58, 0, 59, 0, 0, 606, 154, 0, 0, 62, 0], [0, 575, 0, 607, 0, 248, 248, 57, 58, 0, 59, 0, 0, 0, 139, 0, 575, 0, 0], [0, 575, 0, 0, 0, 246, 608, 0, 58, 0, 59, 0, 0, 0, 139, 0, 575, 0, 0], [0, 0, 0, 609, 152, 610, 611, 57, 58, 0, 59, 0, 0, 612, 154, 0, 0, 62, 0], [0, 0, 0, 0, 0, 0, 0, 494, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 491, 0, 0], [0, 0, 0, 0, 0, 0, 613, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 614, 91, 92, 92, 22, 23, 0, 24, 0, 0, 0, 93, 0, 0, 27, 0], [0, 0, 0, 0, 194, 80, 80, 22, 23, 0, 0, 0, 0, 585, 194, 0, 0, 0, 0], [0, 0, 0, 582, 91, 583, 92, 22, 23, 0, 24, 0, 0, 585, 93, 0, 0, 27, 0], [0, 0, 0, 582, 91, 92, 92, 22, 23, 0, 24, 0, 0, 0, 93, 0, 0, 27, 0], [0, 553, 0, 0, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 553, 0, 0], [0, 553, 0, 586, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 553, 0, 0], [0, 0, 0, 614, 91, 92, 92, 22, 23, 0, 24, 0, 0, 0, 93, 0, 0, 27, 0], [0, 0, 0, 0, 194, 80, 80, 22, 23, 0, 0, 0, 0, 591, 194, 0, 0, 0, 0], [0, 0, 0, 588, 91, 589, 92, 22, 23, 0, 24, 0, 0, 591, 93, 0, 0, 27, 0], [0, 0, 0, 588, 91, 92, 92, 22, 23, 0, 24, 0, 0, 0, 93, 0, 0, 27, 0], [0, 0, 0, 615, 112, 113, 113, 32, 33, 0, 34, 0, 0, 0, 114, 0, 0, 37, 0], [0, 0, 0, 0, 220, 101, 101, 32, 33, 0, 0, 0, 0, 595, 220, 0, 0, 0, 0], [0, 0, 0, 592, 112, 593, 113, 32, 33, 0, 34, 0, 0, 595, 114, 0, 0, 37, 0], [0, 0, 0, 592, 112, 113, 113, 32, 33, 0, 34, 0, 0, 0, 114, 0, 0, 37, 0], [0, 559, 0, 0, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 559, 0, 0], [0, 559, 0, 596, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 559, 0, 0], [0, 0, 0, 615, 112, 113, 113, 32, 33, 0, 34, 0, 0, 0, 114, 0, 0, 37, 0], [0, 0, 0, 0, 220, 101, 101, 32, 33, 0, 0, 0, 0, 601, 220, 0, 0, 0, 0], [0, 0, 0, 598, 112, 599, 113, 32, 33, 0, 34, 0, 0, 601, 114, 0, 0, 37, 0], [0, 0, 0, 598, 112, 113, 113, 32, 33, 0, 34, 0, 0, 0, 114, 0, 0, 37, 0], [0, 0, 0, 0, 66, 67, 67, 8, 9, 0, 10, 0, 0, 0, 68, 0, 0, 16, 0], [0, 0, 0, 616, 152, 153, 153, 57, 58, 0, 59, 0, 0, 0, 154, 0, 0, 62, 0], [0, 0, 0, 0, 265, 141, 141, 57, 58, 0, 0, 0, 0, 606, 265, 0, 0, 0, 0], [0, 0, 0, 603, 152, 604, 153, 57, 58, 0, 59, 0, 0, 606, 154, 0, 0, 62, 0], [0, 0, 0, 603, 152, 153, 153, 57, 58, 0, 59, 0, 0, 0, 154, 0, 0, 62, 0], [0, 575, 0, 0, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 575, 0, 0], [0, 575, 0, 607, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 575, 0, 0], [0, 0, 0, 616, 152, 153, 153, 57, 58, 0, 59, 0, 0, 0, 154, 0, 0, 62, 0], [0, 0, 0, 0, 265, 141, 141, 57, 58, 0, 0, 0, 0, 612, 265, 0, 0, 0, 0], [0, 0, 0, 609, 152, 610, 153, 57, 58, 0, 59, 0, 0, 612, 154, 0, 0, 62, 0], [0, 0, 0, 609, 152, 153, 153, 57, 58, 0, 59, 0, 0, 0, 154, 0, 0, 62, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 549, 0, 0], [0, 0, 0, 0, 91, 92, 92, 22, 23, 0, 24, 0, 0, 0, 93, 0, 0, 27, 0], [0, 0, 0, 0, 112, 113, 113, 32, 33, 0, 34, 0, 0, 0, 114, 0, 0, 37, 0], [0, 0, 0, 0, 152, 153, 153, 57, 58, 0, 59, 0, 0, 0, 154, 0, 0, 62, 0]], em = [!1, !0, !0, !0, !0, !0, !1, !1, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !1, !0, !0, !0, !0, !0, !0, !0, !0, !0, !1, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !1, !0, !1, !0, !0, !1, !1, !0, !0, !0, !0, !0, !0, !1, !1, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !1, !0, !0, !1, !0, !0, !0, !1, !0, !0, !0, !1, !0, !1, !0, !0, !1, !1, !0, !0, !0, !0, !0, !0, !0, !1, !0, !0, !1, !0, !0, !0, !1, !0, !1, !0, !0, !1, !1, !0, !0, !0, !0, !0, !0, !0, !1, !0, !0, !0, !1, !0, !0, !0, !1, !0, !1, !0, !0, !1, !1, !1, !0, !0, !1, !1, !0, !0, !0, !0, !0, !0, !1, !0, !1, !0, !0, !1, !1, !0, !0, !0, !0, !0, !0, !0, !1, !0, !0, !1, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !1, !0, !0, !0, !1, !0, !1, !0, !0, !1, !1, !1, !0, !0, !1, !1, !0, !0, !0, !1, !0, !0, !0, !0, !0, !0, !1, !0, !0, !0, !1, !0, !1, !0, !0, !1, !1, !1, !0, !0, !1, !1, !0, !0, !0, !1, !0, !0, !0, !0, !0, !1, !0, !0, !0, !0, !0, !1, !0, !0, !1, !1, !1, !1, !0, !0, !1, !1, !0, !0, !0, !1, !0, !0, !0, !1, !0, !1, !0, !0, !1, !1, !1, !0, !0, !1, !1, !0, !0, !0, !1, !0, !0, !0, !0, !1, !0, !1, !0, !0, !0, !0, !0, !0, !0, !0, !0, !1, !0, !0, !0, !0, !0, !1, !0, !0, !1, !1, !1, !1, !0, !0, !1, !1, !0, !0, !0, !1, !0, !0, !0, !0, !0, !1, !0, !0, !1, !1, !1, !1, !0, !0, !1, !1, !0, !0, !0, !0, !1, !0, !0, !0, !0, !0, !0, !1, !0, !0, !1, !1, !1, !1, !0, !1, !0, !1, !0, !0, !0, !0, !0, !1, !0, !0, !1, !1, !1, !1, !0, !0, !1, !1, !0, !0, !0, !1, !0, !0, !1, !1, !0, !1, !0, !0, !1, !0, !0, !1, !0, !0, !1, !0, !0, !0, !0, !0, !0, !1, !0, !0, !1, !1, !1, !1, !0, !1, !0, !0, !1, !0, !0, !0, !0, !0, !0, !1, !0, !0, !1, !1, !1, !1, !0, !1, !0, !1, !0, !0, !0, !0, !1, !1, !1, !0, !0, !1, !0, !0, !0, !0, !0, !0, !1, !0, !0, !1, !1, !1, !1, !0, !1, !0, !1, !0, !0, !1, !1, !0, !0, !1, !1, !0, !0, !0, !1, !0, !1, !0, !0, !0, !0, !1, !1, !1, !0, !1, !0, !0, !0, !0, !1, !1, !1, !0, !0, !1, !0, !0, !0, !0, !0, !0, !1, !0, !0, !1, !0, !1, !0, !0, !0, !0, !1, !1, !1, !1, !1, !1, !1, !0, !0, !1, !1, !0, !0, !1, !0, !0, !0, !0, !1, !0, !0, !0, !0, !0, !0, !1, !0, !0, !1, !0, !0, !1, !0, !0, !0, !0, !0, !0, !1, !0, !0, !1, !0, !1, !0, !0, !0, !0, !0, !0, !1, !0, !0, !0, !0, !0, !0, !1, !0, !0, !1, !1, !1, !1, !1, !0, !0, !1, !0, !1, !0, !0, !0, !0, !0, !1, !0, !0, !0, !0, !0, !1, !0, !0, !0, !0, !0, !1, !0, !0, !0, !1, !0, !0, !0, !0, !1, !1, !1, !0, !1, !0, !0, !0, !0, !0, !1, !0, !0, !0, !1, !0, !0, !0, !0, !0, !1, !0, !0, !0, !0, !1, !0, !0, !0, !0, !0, !1, !0, !0, !1, !0, !0, !0], rm = [[], ["broken_cluster"], ["consonant_syllable"], ["vowel_syllable"], ["broken_cluster"], ["broken_cluster"], [], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["standalone_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["consonant_syllable"], ["broken_cluster"], ["symbol_cluster"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], [], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["broken_cluster"], ["broken_cluster"], ["consonant_syllable", "broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["symbol_cluster"], [], ["symbol_cluster"], ["symbol_cluster"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], [], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], [], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], [], [], [], ["broken_cluster"], ["broken_cluster"], [], [], ["broken_cluster"], ["broken_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], [], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["symbol_cluster"], ["symbol_cluster"], ["symbol_cluster"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], [], [], [], ["consonant_syllable"], ["consonant_syllable"], [], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], [], [], [], ["vowel_syllable"], ["vowel_syllable"], [], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], [], [], [], [], ["broken_cluster"], ["broken_cluster"], [], [], ["broken_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], [], [], [], ["standalone_cluster"], ["standalone_cluster"], [], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["broken_cluster"], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], ["broken_cluster"], ["symbol_cluster"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], [], [], [], [], ["consonant_syllable"], ["consonant_syllable"], [], [], ["consonant_syllable"], ["consonant_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], [], [], [], [], ["vowel_syllable"], ["vowel_syllable"], [], [], ["vowel_syllable"], ["vowel_syllable"], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], [], [], [], [], ["broken_cluster"], [], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], [], [], [], [], ["standalone_cluster"], ["standalone_cluster"], [], [], ["standalone_cluster"], ["standalone_cluster"], ["consonant_syllable", "broken_cluster"], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], [], [], ["consonant_syllable", "broken_cluster"], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], [], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], [], [], [], [], ["consonant_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], [], [], [], [], ["vowel_syllable"], [], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], [], [], [], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], [], [], [], [], ["standalone_cluster"], [], ["consonant_syllable", "broken_cluster"], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], [], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], [], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], [], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], [], [], [], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], [], [], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], [], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], [], [], [], [], [], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], [], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], [], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], [], [], [], [], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], [], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], [], [], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["broken_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], [], ["consonant_syllable"], ["vowel_syllable"], ["standalone_cluster"]], nm = {
                stateTable: tm,
                accepting: em,
                tags: rm
              }, im = ["O", "IND", "S", "GB", "B", "FM", "CGJ", "VMAbv", "VMPst", "VAbv", "VPst", "CMBlw", "VPre", "VBlw", "H", "VMBlw", "CMAbv", "MBlw", "CS", "R", "SUB", "MPst", "MPre", "FAbv", "FPst", "FBlw", "null", "SMAbv", "SMBlw", "VMPre", "ZWNJ", "ZWJ", "WJ", "M", "VS", "N", "HN", "MAbv"], am = {
                2507: [2503, 2494],
                2508: [2503, 2519],
                2888: [2887, 2902],
                2891: [2887, 2878],
                2892: [2887, 2903],
                3018: [3014, 3006],
                3019: [3015, 3006],
                3020: [3014, 3031],
                3144: [3142, 3158],
                3264: [3263, 3285],
                3271: [3270, 3285],
                3272: [3270, 3286],
                3274: [3270, 3266],
                3275: [3270, 3266, 3285],
                3402: [3398, 3390],
                3403: [3399, 3390],
                3404: [3398, 3415],
                3546: [3545, 3530],
                3548: [3545, 3535],
                3549: [3545, 3535, 3530],
                3550: [3545, 3551],
                3635: [3661, 3634],
                3763: [3789, 3762],
                3955: [3953, 3954],
                3957: [3953, 3956],
                3958: [4018, 3968],
                3959: [4018, 3953, 3968],
                3960: [4019, 3968],
                3961: [4019, 3953, 3968],
                3969: [3953, 3968],
                6971: [6970, 6965],
                6973: [6972, 6965],
                6976: [6974, 6965],
                6977: [6975, 6965],
                6979: [6978, 6965],
                69934: [69937, 69927],
                69935: [69938, 69927],
                70475: [70471, 70462],
                70476: [70471, 70487],
                70843: [70841, 70842],
                70844: [70841, 70832],
                70846: [70841, 70845],
                71098: [71096, 71087],
                71099: [71097, 71087]
              }, om = [[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [2, 2, 3, 4, 4, 5, 0, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 0, 17, 18, 11, 19, 20, 21, 22, 0, 0, 0, 23, 0, 0, 2, 0, 0, 24, 0, 25], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 26, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 27, 28, 0, 0, 0, 0, 0, 27, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 0, 0, 41, 35, 42, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 39, 0, 0, 47], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 0, 0, 0, 0, 0, 0, 14, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 0, 7, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 0, 0, 12, 0, 14, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 0, 9, 0, 0, 0, 0, 14, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 10, 11, 12, 13, 14, 0, 16, 0, 0, 18, 11, 19, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 25], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 0, 11, 12, 0, 14, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 0, 9, 0, 0, 12, 0, 14, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 18, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 0, 7, 0, 0, 0, 0, 0, 0, 14, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 0, 0, 18, 11, 19, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 25], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 0, 11, 12, 0, 14, 0, 0, 0, 0, 0, 11, 0, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 4, 4, 5, 0, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 0, 0, 18, 11, 19, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 25], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 48, 11, 12, 13, 14, 48, 16, 0, 0, 18, 11, 19, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 49, 0, 0, 25], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 0, 11, 12, 0, 14, 0, 16, 0, 0, 0, 11, 0, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 25], [0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 21, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 21, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 0, 0, 0, 0, 0, 0, 14, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 50, 0, 51, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 0, 11, 12, 0, 14, 0, 16, 0, 0, 0, 11, 0, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 27, 28, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 28, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 0, 0, 0, 0, 0, 0, 38, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 0, 31, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 0, 0, 36, 0, 38, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 0, 33, 0, 0, 0, 0, 38, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 34, 35, 36, 37, 38, 0, 40, 0, 0, 41, 35, 42, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0, 47], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 0, 35, 36, 0, 38, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 0, 33, 0, 0, 36, 0, 38, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 41, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 0, 31, 0, 0, 0, 0, 0, 0, 38, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 0, 0, 41, 35, 42, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0, 47], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 0, 35, 36, 0, 38, 0, 0, 0, 0, 0, 35, 0, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 52, 35, 36, 37, 38, 52, 40, 0, 0, 41, 35, 42, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 53, 0, 0, 47], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 0, 35, 36, 0, 38, 0, 40, 0, 0, 0, 35, 0, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0, 47], [0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 44, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 44, 45, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 0, 0, 0, 0, 0, 0, 38, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 0, 35, 36, 0, 38, 0, 40, 0, 0, 0, 35, 0, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 48, 11, 12, 13, 14, 0, 16, 0, 0, 18, 11, 19, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 25], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 48, 11, 12, 13, 14, 48, 16, 0, 0, 18, 11, 19, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 25], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 51, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 54, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 52, 35, 36, 37, 38, 0, 40, 0, 0, 41, 35, 42, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0, 47], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 52, 35, 36, 37, 38, 52, 40, 0, 0, 41, 35, 42, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0, 47], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 50, 0, 51, 0]], sm = [!1, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !1, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0, !0], lm = [[], ["broken_cluster"], ["independent_cluster"], ["symbol_cluster"], ["standard_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["numeral_cluster"], ["broken_cluster"], ["independent_cluster"], ["symbol_cluster"], ["symbol_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["virama_terminated_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["broken_cluster"], ["broken_cluster"], ["numeral_cluster"], ["number_joiner_terminated_cluster"], ["standard_cluster"], ["standard_cluster"], ["numeral_cluster"]], Q0 = {
                categories: im,
                decompositions: am,
                stateTable: om,
                accepting: sm,
                tags: lm
              }, Vr = {
                X: 1,
                C: 2,
                V: 4,
                N: 8,
                H: 16,
                ZWNJ: 32,
                ZWJ: 64,
                M: 128,
                SM: 256,
                VD: 512,
                A: 1024,
                Placeholder: 2048,
                Dotted_Circle: 4096,
                RS: 8192,
                // Register Shifter, used in Khmer OT spec.
                Coeng: 16384,
                // Khmer-style Virama.
                Repha: 32768,
                // Atomically-encoded logical or visual repha.
                Ra: 65536,
                CM: 1 << 17,
                // Consonant-Medial.
                Symbol: 1 << 18
                // Avagraha, etc that take marks (SM,A,VD).
              }, Sr = {
                Start: 1,
                Ra_To_Become_Reph: 2,
                Pre_M: 4,
                Pre_C: 8,
                Base_C: 16,
                After_Main: 32,
                Above_C: 64,
                Before_Sub: 128,
                Below_C: 256,
                After_Sub: 512,
                Before_Post: 1024,
                Post_C: 2048,
                After_Post: 4096,
                Final_C: 8192,
                SMVD: 16384,
                End: 32768
              }, fm = Vr.C | Vr.Ra | Vr.CM | Vr.V | Vr.Placeholder | Vr.Dotted_Circle, Vc = Vr.ZWJ | Vr.ZWNJ, Ns = Vr.H | Vr.Coeng, Hc = {
                Default: {
                  hasOldSpec: !1,
                  virama: 0,
                  basePos: "Last",
                  rephPos: Sr.Before_Post,
                  rephMode: "Implicit",
                  blwfMode: "Pre_And_Post"
                },
                Devanagari: {
                  hasOldSpec: !0,
                  virama: 2381,
                  basePos: "Last",
                  rephPos: Sr.Before_Post,
                  rephMode: "Implicit",
                  blwfMode: "Pre_And_Post"
                },
                Bengali: {
                  hasOldSpec: !0,
                  virama: 2509,
                  basePos: "Last",
                  rephPos: Sr.After_Sub,
                  rephMode: "Implicit",
                  blwfMode: "Pre_And_Post"
                },
                Gurmukhi: {
                  hasOldSpec: !0,
                  virama: 2637,
                  basePos: "Last",
                  rephPos: Sr.Before_Sub,
                  rephMode: "Implicit",
                  blwfMode: "Pre_And_Post"
                },
                Gujarati: {
                  hasOldSpec: !0,
                  virama: 2765,
                  basePos: "Last",
                  rephPos: Sr.Before_Post,
                  rephMode: "Implicit",
                  blwfMode: "Pre_And_Post"
                },
                Oriya: {
                  hasOldSpec: !0,
                  virama: 2893,
                  basePos: "Last",
                  rephPos: Sr.After_Main,
                  rephMode: "Implicit",
                  blwfMode: "Pre_And_Post"
                },
                Tamil: {
                  hasOldSpec: !0,
                  virama: 3021,
                  basePos: "Last",
                  rephPos: Sr.After_Post,
                  rephMode: "Implicit",
                  blwfMode: "Pre_And_Post"
                },
                Telugu: {
                  hasOldSpec: !0,
                  virama: 3149,
                  basePos: "Last",
                  rephPos: Sr.After_Post,
                  rephMode: "Explicit",
                  blwfMode: "Post_Only"
                },
                Kannada: {
                  hasOldSpec: !0,
                  virama: 3277,
                  basePos: "Last",
                  rephPos: Sr.After_Post,
                  rephMode: "Implicit",
                  blwfMode: "Post_Only"
                },
                Malayalam: {
                  hasOldSpec: !0,
                  virama: 3405,
                  basePos: "Last",
                  rephPos: Sr.After_Main,
                  rephMode: "Log_Repha",
                  blwfMode: "Pre_And_Post"
                },
                // Handled by UniversalShaper
                // Sinhala: {
                //   hasOldSpec: false,
                //   virama: 0x0DCA,
                //   basePos: 'Last_Sinhala',
                //   rephPos: POSITIONS.After_Main,
                //   rephMode: 'Explicit',
                //   blwfMode: 'Pre_And_Post'
                // },
                Khmer: {
                  hasOldSpec: !1,
                  virama: 6098,
                  basePos: "First",
                  rephPos: Sr.Ra_To_Become_Reph,
                  rephMode: "Vis_Repha",
                  blwfMode: "Pre_And_Post"
                }
              }, um = {
                // Khmer
                6078: [6081, 6078],
                6079: [6081, 6079],
                6080: [6081, 6080],
                6084: [6081, 6084],
                6085: [6081, 6085]
              }, hm = Q0.decompositions, Wc = new O(s("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", "base64")), cm = new C(nm), Zn = /* @__PURE__ */ function(at) {
                m(W, at);
                function W() {
                  return at.apply(this, arguments) || this;
                }
                return W.planFeatures = function(R) {
                  R.addStage(dm), R.addStage(["locl", "ccmp"]), R.addStage(gm), R.addStage("nukt"), R.addStage("akhn"), R.addStage("rphf", !1), R.addStage("rkrf"), R.addStage("pref", !1), R.addStage("blwf", !1), R.addStage("abvf", !1), R.addStage("half", !1), R.addStage("pstf", !1), R.addStage("vatu"), R.addStage("cjct"), R.addStage("cfar", !1), R.addStage(pm), R.addStage({
                    local: ["init"],
                    global: ["pres", "abvs", "blws", "psts", "haln", "dist", "abvm", "blwm", "calt", "clig"]
                  }), R.unicodeScript = Zp(R.script), R.indicConfig = Hc[R.unicodeScript] || Hc.Default, R.isOldSpec = R.indicConfig.hasOldSpec && R.script[R.script.length - 1] !== "2";
                }, W.assignFeatures = function(R, k) {
                  for (var H = function(ht) {
                    var ut = k[ht].codePoints[0], Nt = um[ut] || hm[ut];
                    if (Nt) {
                      var Kt = Nt.map(function(de) {
                        var te = R.font.glyphForCodePoint(de);
                        return new ya(R.font, te.id, [de], k[ht].features);
                      });
                      k.splice.apply(k, [ht, 1].concat(Kt));
                    }
                  }, ot = k.length - 1; ot >= 0; ot--)
                    H(ot);
                }, W;
              }(Va);
              z(Zn, "zeroMarkWidths", "NONE");
              function cu(at) {
                return Wc.get(at.codePoints[0]) >> 8;
              }
              function _c(at) {
                return 1 << (Wc.get(at.codePoints[0]) & 255);
              }
              var $0 = function(W, $, R, k) {
                this.category = W, this.position = $, this.syllableType = R, this.syllable = k;
              };
              function dm(at, W) {
                for (var $ = 0, R = 0, k = g(cm.match(W.map(cu))), H; !(H = k()).done; ) {
                  var ot = H.value, ct = ot[0], ht = ot[1], ut = ot[2];
                  if (ct > R) {
                    ++$;
                    for (var Nt = R; Nt < ct; Nt++)
                      W[Nt].shaperInfo = new $0(Vr.X, Sr.End, "non_indic_cluster", $);
                  }
                  ++$;
                  for (var Kt = ct; Kt <= ht; Kt++)
                    W[Kt].shaperInfo = new $0(1 << cu(W[Kt]), _c(W[Kt]), ut[0], $);
                  R = ht + 1;
                }
                if (R < W.length) {
                  ++$;
                  for (var de = R; de < W.length; de++)
                    W[de].shaperInfo = new $0(Vr.X, Sr.End, "non_indic_cluster", $);
                }
              }
              function ho(at) {
                return at.shaperInfo.category & fm;
              }
              function aa(at) {
                return at.shaperInfo.category & Vc;
              }
              function xa(at) {
                return at.shaperInfo.category & Ns;
              }
              function ba(at, W) {
                for (var $ = g(at), R; !(R = $()).done; ) {
                  var k, H = R.value;
                  H.features = (k = {}, k[W] = !0, k);
                }
                var ot = at[0]._font._layoutEngine.engine.GSUBProcessor;
                return ot.applyFeatures([W], at), at.length === 1;
              }
              function vm(at, W, $) {
                var R = [$, W, $];
                return ba(R.slice(0, 2), "blwf") || ba(R.slice(1, 3), "blwf") ? Sr.Below_C : ba(R.slice(0, 2), "pstf") || ba(R.slice(1, 3), "pstf") || ba(R.slice(0, 2), "pref") || ba(R.slice(1, 3), "pref") ? Sr.Post_C : Sr.Base_C;
              }
              function gm(at, W, $) {
                var R = $.indicConfig, k = at._layoutEngine.engine.GSUBProcessor.features, H = at.glyphForCodePoint(9676).id, ot = at.glyphForCodePoint(R.virama).id;
                if (ot)
                  for (var ct = new ya(at, ot, [R.virama]), ht = 0; ht < W.length; ht++)
                    W[ht].shaperInfo.position === Sr.Base_C && (W[ht].shaperInfo.position = vm(at, W[ht].copy(), ct));
                for (var ut = 0, Nt = q0(W, 0); ut < W.length; ut = Nt, Nt = q0(W, ut)) {
                  var Kt = W[ut].shaperInfo;
                  Kt.category;
                  var de = Kt.syllableType;
                  if (!(de === "symbol_cluster" || de === "non_indic_cluster")) {
                    if (de === "broken_cluster" && H) {
                      var te = new ya(at, H, [9676]);
                      te.shaperInfo = new $0(1 << cu(te), _c(te), W[ut].shaperInfo.syllableType, W[ut].shaperInfo.syllable);
                      for (var pe = ut; pe < Nt && W[pe].shaperInfo.category === Vr.Repha; )
                        pe++;
                      W.splice(pe++, 0, te), Nt++;
                    }
                    var Ee = Nt, Le = ut, $e = !1;
                    if (R.rephPos !== Sr.Ra_To_Become_Reph && k.rphf && ut + 3 <= Nt && (R.rephMode === "Implicit" && !aa(W[ut + 2]) || R.rephMode === "Explicit" && W[ut + 2].shaperInfo.category === Vr.ZWJ)) {
                      var wr = [W[ut].copy(), W[ut + 1].copy(), W[ut + 2].copy()];
                      if (ba(wr.slice(0, 2), "rphf") || R.rephMode === "Explicit" && ba(wr, "rphf")) {
                        for (Le += 2; Le < Nt && aa(W[Le]); )
                          Le++;
                        Ee = ut, $e = !0;
                      }
                    } else if (R.rephMode === "Log_Repha" && W[ut].shaperInfo.category === Vr.Repha) {
                      for (Le++; Le < Nt && aa(W[Le]); )
                        Le++;
                      Ee = ut, $e = !0;
                    }
                    switch (R.basePos) {
                      case "Last": {
                        var or = Nt, Pr = !1;
                        do {
                          var Cr = W[--or].shaperInfo;
                          if (ho(W[or])) {
                            if (Cr.position !== Sr.Below_C && (Cr.position !== Sr.Post_C || Pr)) {
                              Ee = or;
                              break;
                            }
                            Cr.position === Sr.Below_C && (Pr = !0), Ee = or;
                          } else if (ut < or && Cr.category === Vr.ZWJ && W[or - 1].shaperInfo.category === Vr.H)
                            break;
                        } while (or > Le);
                        break;
                      }
                      case "First": {
                        Ee = ut;
                        for (var Dr = Ee + 1; Dr < Nt; Dr++)
                          ho(W[Dr]) && (W[Dr].shaperInfo.position = Sr.Below_C);
                      }
                    }
                    $e && Ee === ut && Le - Ee <= 2 && ($e = !1);
                    for (var Lr = ut; Lr < Ee; Lr++) {
                      var yn = W[Lr].shaperInfo;
                      yn.position = Math.min(Sr.Pre_C, yn.position);
                    }
                    Ee < Nt && (W[Ee].shaperInfo.position = Sr.Base_C);
                    for (var On = Ee + 1; On < Nt; On++)
                      if (W[On].shaperInfo.category === Vr.M) {
                        for (var hn = On + 1; hn < Nt; hn++)
                          if (ho(W[hn])) {
                            W[hn].shaperInfo.position = Sr.Final_C;
                            break;
                          }
                        break;
                      }
                    if ($e && (W[ut].shaperInfo.position = Sr.Ra_To_Become_Reph), $.isOldSpec) {
                      for (var Mr = $.unicodeScript !== "Malayalam", nn = Ee + 1; nn < Nt; nn++)
                        if (W[nn].shaperInfo.category === Vr.H) {
                          var vn = void 0;
                          for (vn = Nt - 1; vn > nn && !(ho(W[vn]) || Mr && W[vn].shaperInfo.category === Vr.H); vn--)
                            ;
                          if (W[vn].shaperInfo.category !== Vr.H && vn > nn) {
                            var _n = W[nn];
                            W.splice.apply(W, [nn, 0].concat(W.splice(nn + 1, vn - nn))), W[vn] = _n;
                          }
                          break;
                        }
                    }
                    for (var kr = Sr.Start, an = ut; an < Nt; an++) {
                      var mn = W[an].shaperInfo;
                      if (mn.category & (Vc | Vr.N | Vr.RS | Vr.CM | Ns & mn.category)) {
                        if (mn.position = kr, mn.category === Vr.H && mn.position === Sr.Pre_M) {
                          for (var Ur = an; Ur > ut; Ur--)
                            if (W[Ur - 1].shaperInfo.position !== Sr.Pre_M) {
                              mn.position = W[Ur - 1].shaperInfo.position;
                              break;
                            }
                        }
                      } else
                        mn.position !== Sr.SMVD && (kr = mn.position);
                    }
                    for (var Un = Ee, ti = Ee + 1; ti < Nt; ti++)
                      if (ho(W[ti])) {
                        for (var pi = Un + 1; pi < ti; pi++)
                          W[pi].shaperInfo.position < Sr.SMVD && (W[pi].shaperInfo.position = W[ti].shaperInfo.position);
                        Un = ti;
                      } else
                        W[ti].shaperInfo.category === Vr.M && (Un = ti);
                    var Ai = W.slice(ut, Nt);
                    Ai.sort(function(Ji, gu) {
                      return Ji.shaperInfo.position - gu.shaperInfo.position;
                    }), W.splice.apply(W, [ut, Ai.length].concat(Ai));
                    for (var yi = ut; yi < Nt; yi++)
                      if (W[yi].shaperInfo.position === Sr.Base_C) {
                        Ee = yi;
                        break;
                      }
                    for (var Ii = ut; Ii < Nt && W[Ii].shaperInfo.position === Sr.Ra_To_Become_Reph; Ii++)
                      W[Ii].features.rphf = !0;
                    for (var Ri = !$.isOldSpec && R.blwfMode === "Pre_And_Post", ui = ut; ui < Ee; ui++)
                      W[ui].features.half = !0, Ri && (W[ui].features.blwf = !0);
                    for (var Jn = Ee + 1; Jn < Nt; Jn++)
                      W[Jn].features.abvf = !0, W[Jn].features.pstf = !0, W[Jn].features.blwf = !0;
                    if ($.isOldSpec && $.unicodeScript === "Devanagari")
                      for (var Ci = ut; Ci + 1 < Ee; Ci++)
                        W[Ci].shaperInfo.category === Vr.Ra && W[Ci + 1].shaperInfo.category === Vr.H && (Ci + 1 === Ee || W[Ci + 2].shaperInfo.category === Vr.ZWJ) && (W[Ci].features.blwf = !0, W[Ci + 1].features.blwf = !0);
                    var on = 2;
                    if (k.pref && Ee + on < Nt)
                      for (var jr = Ee + 1; jr + on - 1 < Nt; jr++) {
                        var An = [W[jr].copy(), W[jr + 1].copy()];
                        if (ba(An, "pref")) {
                          for (var xn = 0; xn < on; xn++)
                            W[jr++].features.pref = !0;
                          if (k.cfar)
                            for (; jr < Nt; jr++)
                              W[jr].features.cfar = !0;
                          break;
                        }
                      }
                    for (var sn = ut + 1; sn < Nt; sn++)
                      if (aa(W[sn])) {
                        var hi = W[sn].shaperInfo.category === Vr.ZWNJ, Ko = sn;
                        do
                          Ko--, hi && delete W[Ko].features.half;
                        while (Ko > ut && !ho(W[Ko]));
                      }
                  }
                }
              }
              function pm(at, W, $) {
                for (var R = $.indicConfig, k = at._layoutEngine.engine.GSUBProcessor.features, H = 0, ot = q0(W, 0); H < W.length; H = ot, ot = q0(W, H)) {
                  for (var ct = !!k.pref, ht = H; ht < ot; ht++)
                    if (W[ht].shaperInfo.position >= Sr.Base_C) {
                      if (ct && ht + 1 < ot) {
                        for (var ut = ht + 1; ut < ot; ut++)
                          if (W[ut].features.pref) {
                            if (!(W[ut].substituted && W[ut].isLigated && !W[ut].isMultiplied)) {
                              for (ht = ut; ht < ot && xa(W[ht]); )
                                ht++;
                              W[ht].shaperInfo.position = Sr.BASE_C, ct = !1;
                            }
                            break;
                          }
                      }
                      if ($.unicodeScript === "Malayalam")
                        for (var Nt = ht + 1; Nt < ot; Nt++) {
                          for (; Nt < ot && aa(W[Nt]); )
                            Nt++;
                          if (Nt === ot || !xa(W[Nt]))
                            break;
                          for (Nt++; Nt < ot && aa(W[Nt]); )
                            Nt++;
                          Nt < ot && ho(W[Nt]) && W[Nt].shaperInfo.position === Sr.Below_C && (ht = Nt, W[ht].shaperInfo.position = Sr.Base_C);
                        }
                      H < ht && W[ht].shaperInfo.position > Sr.Base_C && ht--;
                      break;
                    }
                  if (ht === ot && H < ht && W[ht - 1].shaperInfo.category === Vr.ZWJ && ht--, ht < ot)
                    for (; H < ht && W[ht].shaperInfo.category & (Vr.N | Ns); )
                      ht--;
                  if (H + 1 < ot && H < ht) {
                    var Kt = ht === ot ? ht - 2 : ht - 1;
                    if ($.unicodeScript !== "Malayalam" && $.unicodeScript !== "Tamil") {
                      for (; Kt > H && !(W[Kt].shaperInfo.category & (Vr.M | Ns)); )
                        Kt--;
                      xa(W[Kt]) && W[Kt].shaperInfo.position !== Sr.Pre_M ? Kt + 1 < ot && aa(W[Kt + 1]) && Kt++ : Kt = H;
                    }
                    if (H < Kt && W[Kt].shaperInfo.position !== Sr.Pre_M) {
                      for (var de = Kt; de > H; de--)
                        if (W[de - 1].shaperInfo.position === Sr.Pre_M) {
                          var te = de - 1;
                          te < ht && ht <= Kt && ht--;
                          var pe = W[te];
                          W.splice.apply(W, [te, 0].concat(W.splice(te + 1, Kt - te))), W[Kt] = pe, Kt--;
                        }
                    }
                  }
                  if (H + 1 < ot && W[H].shaperInfo.position === Sr.Ra_To_Become_Reph && W[H].shaperInfo.category === Vr.Repha !== (W[H].isLigated && !W[H].isMultiplied)) {
                    var Ee = void 0, Le = R.rephPos, $e = !1;
                    if (Le !== Sr.After_Post) {
                      for (Ee = H + 1; Ee < ht && !xa(W[Ee]); )
                        Ee++;
                      if (Ee < ht && xa(W[Ee]) && (Ee + 1 < ht && aa(W[Ee + 1]) && Ee++, $e = !0), !$e && Le === Sr.After_Main) {
                        for (Ee = ht; Ee + 1 < ot && W[Ee + 1].shaperInfo.position <= Sr.After_Main; )
                          Ee++;
                        $e = Ee < ot;
                      }
                      if (!$e && Le === Sr.After_Sub) {
                        for (Ee = ht; Ee + 1 < ot && !(W[Ee + 1].shaperInfo.position & (Sr.Post_C | Sr.After_Post | Sr.SMVD)); )
                          Ee++;
                        $e = Ee < ot;
                      }
                    }
                    if (!$e) {
                      for (Ee = H + 1; Ee < ht && !xa(W[Ee]); )
                        Ee++;
                      Ee < ht && xa(W[Ee]) && (Ee + 1 < ht && aa(W[Ee + 1]) && Ee++, $e = !0);
                    }
                    if (!$e) {
                      for (Ee = ot - 1; Ee > H && W[Ee].shaperInfo.position === Sr.SMVD; )
                        Ee--;
                      if (xa(W[Ee]))
                        for (var wr = ht + 1; wr < Ee; wr++)
                          W[wr].shaperInfo.category === Vr.M && Ee--;
                    }
                    var or = W[H];
                    W.splice.apply(W, [H, 0].concat(W.splice(H + 1, Ee - H))), W[Ee] = or, H < ht && ht <= Ee && ht--;
                  }
                  if (ct && ht + 1 < ot) {
                    for (var Pr = ht + 1; Pr < ot; Pr++)
                      if (W[Pr].features.pref) {
                        if (W[Pr].isLigated && !W[Pr].isMultiplied) {
                          var Cr = ht;
                          if ($.unicodeScript !== "Malayalam" && $.unicodeScript !== "Tamil") {
                            for (; Cr > H && !(W[Cr - 1].shaperInfo.category & (Vr.M | Ns)); )
                              Cr--;
                            if (Cr > H && W[Cr - 1].shaperInfo.category === Vr.M) {
                              for (var Dr = Pr, Lr = ht + 1; Lr < Dr; Lr++)
                                if (W[Lr].shaperInfo.category === Vr.M) {
                                  Cr--;
                                  break;
                                }
                            }
                          }
                          Cr > H && xa(W[Cr - 1]) && Cr < ot && aa(W[Cr]) && Cr++;
                          var yn = Pr, On = W[yn];
                          W.splice.apply(W, [Cr + 1, 0].concat(W.splice(Cr, yn - Cr))), W[Cr] = On, Cr <= ht && ht < yn && ht++;
                        }
                        break;
                      }
                  }
                  W[H].shaperInfo.position === Sr.Pre_M && (!H || !/Cf|Mn/.test(A.getCategory(W[H - 1].codePoints[0]))) && (W[H].features.init = !0);
                }
              }
              function q0(at, W) {
                if (W >= at.length)
                  return W;
                for (var $ = at[W].shaperInfo.syllable; ++W < at.length && at[W].shaperInfo.syllable === $; )
                  ;
                return W;
              }
              var ym = Q0.categories, jc = Q0.decompositions, mm = new O(s("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", "base64")), xm = new C(Q0), Br = /* @__PURE__ */ function(at) {
                m(W, at);
                function W() {
                  return at.apply(this, arguments) || this;
                }
                return W.planFeatures = function(R) {
                  R.addStage(wm), R.addStage(["locl", "ccmp", "nukt", "akhn"]), R.addStage(Yc), R.addStage(["rphf"], !1), R.addStage(Sm), R.addStage(Yc), R.addStage(["pref"]), R.addStage(Em), R.addStage(["rkrf", "abvf", "blwf", "half", "pstf", "vatu", "cjct"]), R.addStage(Am), R.addStage(["abvs", "blws", "pres", "psts", "dist", "abvm", "blwm"]);
                }, W.assignFeatures = function(R, k) {
                  for (var H = function(ht) {
                    var ut = k[ht].codePoints[0];
                    if (jc[ut]) {
                      var Nt = jc[ut].map(function(Kt) {
                        var de = R.font.glyphForCodePoint(Kt);
                        return new ya(R.font, de.id, [Kt], k[ht].features);
                      });
                      k.splice.apply(k, [ht, 1].concat(Nt));
                    }
                  }, ot = k.length - 1; ot >= 0; ot--)
                    H(ot);
                }, W;
              }(Va);
              z(Br, "zeroMarkWidths", "BEFORE_GPOS");
              function Xc(at) {
                return mm.get(at.codePoints[0]);
              }
              var bm = function(W, $, R) {
                this.category = W, this.syllableType = $, this.syllable = R;
              };
              function wm(at, W) {
                for (var $ = 0, R = g(xm.match(W.map(Xc))), k; !(k = R()).done; ) {
                  var H = k.value, ot = H[0], ct = H[1], ht = H[2];
                  ++$;
                  for (var ut = ot; ut <= ct; ut++)
                    W[ut].shaperInfo = new bm(ym[Xc(W[ut])], ht[0], $);
                  for (var Nt = W[ot].shaperInfo.category === "R" ? 1 : Math.min(3, ct - ot), Kt = ot; Kt < ot + Nt; Kt++)
                    W[Kt].features.rphf = !0;
                }
              }
              function Yc(at, W) {
                for (var $ = g(W), R; !(R = $()).done; ) {
                  var k = R.value;
                  k.substituted = !1;
                }
              }
              function Sm(at, W) {
                for (var $ = g(W), R; !(R = $()).done; ) {
                  var k = R.value;
                  k.substituted && k.features.rphf && (k.shaperInfo.category = "R");
                }
              }
              function Em(at, W) {
                for (var $ = g(W), R; !(R = $()).done; ) {
                  var k = R.value;
                  k.substituted && (k.shaperInfo.category = "VPre");
                }
              }
              function Am(at, W) {
                for (var $ = at.glyphForCodePoint(9676).id, R = 0, k = Zc(W, 0); R < W.length; R = k, k = Zc(W, R)) {
                  var H = void 0, ot = void 0, ct = W[R].shaperInfo, ht = ct.syllableType;
                  if (!(ht !== "virama_terminated_cluster" && ht !== "standard_cluster" && ht !== "broken_cluster")) {
                    if (ht === "broken_cluster" && $) {
                      var ut = new ya(at, $, [9676]);
                      for (ut.shaperInfo = ct, H = R; H < k && W[H].shaperInfo.category === "R"; H++)
                        ;
                      W.splice(++H, 0, ut), k++;
                    }
                    if (ct.category === "R" && k - R > 1) {
                      for (H = R + 1; H < k; H++)
                        if (ct = W[H].shaperInfo, Kc(ct) || tl(W[H])) {
                          tl(W[H]) && H--, W.splice.apply(W, [R, 0].concat(W.splice(R + 1, H - R), [W[H]]));
                          break;
                        }
                    }
                    for (H = R, ot = k; H < k; H++)
                      ct = W[H].shaperInfo, Kc(ct) || tl(W[H]) ? ot = tl(W[H]) ? H + 1 : H : (ct.category === "VPre" || ct.category === "VMPre") && ot < H && W.splice.apply(W, [ot, 1, W[H]].concat(W.splice(ot, H - ot)));
                  }
                }
              }
              function Zc(at, W) {
                if (W >= at.length)
                  return W;
                for (var $ = at[W].shaperInfo.syllable; ++W < at.length && at[W].shaperInfo.syllable === $; )
                  ;
                return W;
              }
              function tl(at) {
                return at.shaperInfo.category === "H" && !at.isLigated;
              }
              function Kc(at) {
                return at.category === "B" || at.category === "GB";
              }
              var Cm = {
                arab: Wa,
                // Arabic
                mong: Wa,
                // Mongolian
                syrc: Wa,
                // Syriac
                "nko ": Wa,
                // N'Ko
                phag: Wa,
                // Phags Pa
                mand: Wa,
                // Mandaic
                mani: Wa,
                // Manichaean
                phlp: Wa,
                // Psalter Pahlavi
                hang: Nc,
                // Hangul
                bng2: Zn,
                // Bengali
                beng: Zn,
                // Bengali
                dev2: Zn,
                // Devanagari
                deva: Zn,
                // Devanagari
                gjr2: Zn,
                // Gujarati
                gujr: Zn,
                // Gujarati
                guru: Zn,
                // Gurmukhi
                gur2: Zn,
                // Gurmukhi
                knda: Zn,
                // Kannada
                knd2: Zn,
                // Kannada
                mlm2: Zn,
                // Malayalam
                mlym: Zn,
                // Malayalam
                ory2: Zn,
                // Oriya
                orya: Zn,
                // Oriya
                taml: Zn,
                // Tamil
                tml2: Zn,
                // Tamil
                telu: Zn,
                // Telugu
                tel2: Zn,
                // Telugu
                khmr: Zn,
                // Khmer
                bali: Br,
                // Balinese
                batk: Br,
                // Batak
                brah: Br,
                // Brahmi
                bugi: Br,
                // Buginese
                buhd: Br,
                // Buhid
                cakm: Br,
                // Chakma
                cham: Br,
                // Cham
                dupl: Br,
                // Duployan
                egyp: Br,
                // Egyptian Hieroglyphs
                gran: Br,
                // Grantha
                hano: Br,
                // Hanunoo
                java: Br,
                // Javanese
                kthi: Br,
                // Kaithi
                kali: Br,
                // Kayah Li
                khar: Br,
                // Kharoshthi
                khoj: Br,
                // Khojki
                sind: Br,
                // Khudawadi
                lepc: Br,
                // Lepcha
                limb: Br,
                // Limbu
                mahj: Br,
                // Mahajani
                // mand: UniversalShaper, // Mandaic
                // mani: UniversalShaper, // Manichaean
                mtei: Br,
                // Meitei Mayek
                modi: Br,
                // Modi
                // mong: UniversalShaper, // Mongolian
                // 'nko ': UniversalShaper, // N’Ko
                hmng: Br,
                // Pahawh Hmong
                // phag: UniversalShaper, // Phags-pa
                // phlp: UniversalShaper, // Psalter Pahlavi
                rjng: Br,
                // Rejang
                saur: Br,
                // Saurashtra
                shrd: Br,
                // Sharada
                sidd: Br,
                // Siddham
                sinh: Br,
                // Sinhala
                sund: Br,
                // Sundanese
                sylo: Br,
                // Syloti Nagri
                tglg: Br,
                // Tagalog
                tagb: Br,
                // Tagbanwa
                tale: Br,
                // Tai Le
                lana: Br,
                // Tai Tham
                tavt: Br,
                // Tai Viet
                takr: Br,
                // Takri
                tibt: Br,
                // Tibetan
                tfng: Br,
                // Tifinagh
                tirh: Br,
                // Tirhuta
                latn: Va,
                // Latin
                DFLT: Va
                // Default
              };
              function Tm(at) {
                Array.isArray(at) || (at = [at]);
                for (var W = g(at), $; !($ = W()).done; ) {
                  var R = $.value, k = Cm[R];
                  if (k)
                    return k;
                }
                return Va;
              }
              for (var Pm = /* @__PURE__ */ function(at) {
                m(W, at);
                function W() {
                  return at.apply(this, arguments) || this;
                }
                var $ = W.prototype;
                return $.applyLookup = function(k, H) {
                  var ot = this;
                  switch (k) {
                    case 1: {
                      var ct = this.coverageIndex(H.coverage);
                      if (ct === -1)
                        return !1;
                      var ht = this.glyphIterator.cur;
                      switch (H.version) {
                        case 1:
                          ht.id = ht.id + H.deltaGlyphID & 65535;
                          break;
                        case 2:
                          ht.id = H.substitute.get(ct);
                          break;
                      }
                      return !0;
                    }
                    case 2: {
                      var ut = this.coverageIndex(H.coverage);
                      if (ut !== -1) {
                        var Nt, Kt = H.sequences.get(ut);
                        if (Kt.length === 0)
                          return this.glyphs.splice(this.glyphIterator.index, 1), !0;
                        this.glyphIterator.cur.id = Kt[0], this.glyphIterator.cur.ligatureComponent = 0;
                        var de = this.glyphIterator.cur.features, te = this.glyphIterator.cur, pe = Kt.slice(1).map(function(Ri, ui) {
                          var Jn = new ya(ot.font, Ri, void 0, de);
                          return Jn.shaperInfo = te.shaperInfo, Jn.isLigated = te.isLigated, Jn.ligatureComponent = ui + 1, Jn.substituted = !0, Jn.isMultiplied = !0, Jn;
                        });
                        return (Nt = this.glyphs).splice.apply(Nt, [this.glyphIterator.index + 1, 0].concat(pe)), !0;
                      }
                      return !1;
                    }
                    case 3: {
                      var Ee = this.coverageIndex(H.coverage);
                      if (Ee !== -1) {
                        var Le = 0;
                        return this.glyphIterator.cur.id = H.alternateSet.get(Ee)[Le], !0;
                      }
                      return !1;
                    }
                    case 4: {
                      var $e = this.coverageIndex(H.coverage);
                      if ($e === -1)
                        return !1;
                      for (var wr = g(H.ligatureSets.get($e)), or; !(or = wr()).done; ) {
                        var Pr = or.value, Cr = this.sequenceMatchIndices(1, Pr.components);
                        if (Cr) {
                          for (var Dr = this.glyphIterator.cur, Lr = Dr.codePoints.slice(), yn = g(Cr), On; !(On = yn()).done; ) {
                            var hn, Mr = On.value;
                            (hn = Lr).push.apply(hn, this.glyphs[Mr].codePoints);
                          }
                          var nn = new ya(this.font, Pr.glyph, Lr, Dr.features);
                          nn.shaperInfo = Dr.shaperInfo, nn.isLigated = !0, nn.substituted = !0;
                          for (var vn = Dr.isMark, _n = 0; _n < Cr.length && vn; _n++)
                            vn = this.glyphs[Cr[_n]].isMark;
                          nn.ligatureID = vn ? null : this.ligatureID++;
                          for (var kr = Dr.ligatureID, an = Dr.codePoints.length, mn = an, Ur = this.glyphIterator.index + 1, Un = g(Cr), ti; !(ti = Un()).done; ) {
                            var pi = ti.value;
                            if (vn)
                              Ur = pi;
                            else
                              for (; Ur < pi; ) {
                                var Ai = mn - an + Math.min(this.glyphs[Ur].ligatureComponent || 1, an);
                                this.glyphs[Ur].ligatureID = nn.ligatureID, this.glyphs[Ur].ligatureComponent = Ai, Ur++;
                              }
                            kr = this.glyphs[Ur].ligatureID, an = this.glyphs[Ur].codePoints.length, mn += an, Ur++;
                          }
                          if (kr && !vn)
                            for (var yi = Ur; yi < this.glyphs.length && this.glyphs[yi].ligatureID === kr; yi++) {
                              var Ai = mn - an + Math.min(this.glyphs[yi].ligatureComponent || 1, an);
                              this.glyphs[yi].ligatureComponent = Ai;
                            }
                          for (var Ii = Cr.length - 1; Ii >= 0; Ii--)
                            this.glyphs.splice(Cr[Ii], 1);
                          return this.glyphs[this.glyphIterator.index] = nn, !0;
                        }
                      }
                      return !1;
                    }
                    case 5:
                      return this.applyContext(H);
                    case 6:
                      return this.applyChainingContext(H);
                    case 7:
                      return this.applyLookup(H.lookupType, H.extension);
                    default:
                      throw new Error("GSUB lookupType ".concat(k, " is not supported"));
                  }
                }, W;
              }(_0), Om = /* @__PURE__ */ function(at) {
                m(W, at);
                function W() {
                  return at.apply(this, arguments) || this;
                }
                var $ = W.prototype;
                return $.applyPositionValue = function(k, H) {
                  var ot = this.positions[this.glyphIterator.peekIndex(k)];
                  H.xAdvance != null && (ot.xAdvance += H.xAdvance), H.yAdvance != null && (ot.yAdvance += H.yAdvance), H.xPlacement != null && (ot.xOffset += H.xPlacement), H.yPlacement != null && (ot.yOffset += H.yPlacement);
                  var ct = this.font._variationProcessor, ht = this.font.GDEF && this.font.GDEF.itemVariationStore;
                  ct && ht && (H.xPlaDevice && (ot.xOffset += ct.getDelta(ht, H.xPlaDevice.a, H.xPlaDevice.b)), H.yPlaDevice && (ot.yOffset += ct.getDelta(ht, H.yPlaDevice.a, H.yPlaDevice.b)), H.xAdvDevice && (ot.xAdvance += ct.getDelta(ht, H.xAdvDevice.a, H.xAdvDevice.b)), H.yAdvDevice && (ot.yAdvance += ct.getDelta(ht, H.yAdvDevice.a, H.yAdvDevice.b)));
                }, $.applyLookup = function(k, H) {
                  switch (k) {
                    case 1: {
                      var ot = this.coverageIndex(H.coverage);
                      if (ot === -1)
                        return !1;
                      switch (H.version) {
                        case 1:
                          this.applyPositionValue(0, H.value);
                          break;
                        case 2:
                          this.applyPositionValue(0, H.values.get(ot));
                          break;
                      }
                      return !0;
                    }
                    case 2: {
                      var ct = this.glyphIterator.peek();
                      if (!ct)
                        return !1;
                      var ht = this.coverageIndex(H.coverage);
                      if (ht === -1)
                        return !1;
                      switch (H.version) {
                        case 1:
                          for (var ut = H.pairSets.get(ht), Nt = g(ut), Kt; !(Kt = Nt()).done; ) {
                            var de = Kt.value;
                            if (de.secondGlyph === ct.id)
                              return this.applyPositionValue(0, de.value1), this.applyPositionValue(1, de.value2), !0;
                          }
                          return !1;
                        case 2:
                          var te = this.getClassID(this.glyphIterator.cur.id, H.classDef1), pe = this.getClassID(ct.id, H.classDef2);
                          if (te === -1 || pe === -1)
                            return !1;
                          var Ee = H.classRecords.get(te).get(pe);
                          return this.applyPositionValue(0, Ee.value1), this.applyPositionValue(1, Ee.value2), !0;
                      }
                    }
                    case 3: {
                      var Le = this.glyphIterator.peekIndex(), $e = this.glyphs[Le];
                      if (!$e)
                        return !1;
                      var wr = H.entryExitRecords[this.coverageIndex(H.coverage)];
                      if (!wr || !wr.exitAnchor)
                        return !1;
                      var or = H.entryExitRecords[this.coverageIndex(H.coverage, $e.id)];
                      if (!or || !or.entryAnchor)
                        return !1;
                      var Pr = this.getAnchor(or.entryAnchor), Cr = this.getAnchor(wr.exitAnchor), Dr = this.positions[this.glyphIterator.index], Lr = this.positions[Le];
                      switch (this.direction) {
                        case "ltr":
                          Dr.xAdvance = Cr.x + Dr.xOffset;
                          var yn = Pr.x + Lr.xOffset;
                          Lr.xAdvance -= yn, Lr.xOffset -= yn;
                          break;
                        case "rtl":
                          yn = Cr.x + Dr.xOffset, Dr.xAdvance -= yn, Dr.xOffset -= yn, Lr.xAdvance = Pr.x + Lr.xOffset;
                          break;
                      }
                      return this.glyphIterator.flags.rightToLeft ? (this.glyphIterator.cur.cursiveAttachment = Le, Dr.yOffset = Pr.y - Cr.y) : ($e.cursiveAttachment = this.glyphIterator.index, Dr.yOffset = Cr.y - Pr.y), !0;
                    }
                    case 4: {
                      var On = this.coverageIndex(H.markCoverage);
                      if (On === -1)
                        return !1;
                      for (var hn = this.glyphIterator.index; --hn >= 0 && (this.glyphs[hn].isMark || this.glyphs[hn].ligatureComponent > 0); )
                        ;
                      if (hn < 0)
                        return !1;
                      var Mr = this.coverageIndex(H.baseCoverage, this.glyphs[hn].id);
                      if (Mr === -1)
                        return !1;
                      var nn = H.markArray[On], vn = H.baseArray[Mr][nn.class];
                      return this.applyAnchor(nn, vn, hn), !0;
                    }
                    case 5: {
                      var _n = this.coverageIndex(H.markCoverage);
                      if (_n === -1)
                        return !1;
                      for (var kr = this.glyphIterator.index; --kr >= 0 && this.glyphs[kr].isMark; )
                        ;
                      if (kr < 0)
                        return !1;
                      var an = this.coverageIndex(H.ligatureCoverage, this.glyphs[kr].id);
                      if (an === -1)
                        return !1;
                      var mn = H.ligatureArray[an], Ur = this.glyphIterator.cur, Un = this.glyphs[kr], ti = Un.ligatureID && Un.ligatureID === Ur.ligatureID && Ur.ligatureComponent > 0 ? Math.min(Ur.ligatureComponent, Un.codePoints.length) - 1 : Un.codePoints.length - 1, pi = H.markArray[_n], Ai = mn[ti][pi.class];
                      return this.applyAnchor(pi, Ai, kr), !0;
                    }
                    case 6: {
                      var yi = this.coverageIndex(H.mark1Coverage);
                      if (yi === -1)
                        return !1;
                      var Ii = this.glyphIterator.peekIndex(-1), Ri = this.glyphs[Ii];
                      if (!Ri || !Ri.isMark)
                        return !1;
                      var ui = this.glyphIterator.cur, Jn = !1;
                      if (ui.ligatureID === Ri.ligatureID ? ui.ligatureID ? ui.ligatureComponent === Ri.ligatureComponent && (Jn = !0) : Jn = !0 : (ui.ligatureID && !ui.ligatureComponent || Ri.ligatureID && !Ri.ligatureComponent) && (Jn = !0), !Jn)
                        return !1;
                      var Ci = this.coverageIndex(H.mark2Coverage, Ri.id);
                      if (Ci === -1)
                        return !1;
                      var on = H.mark1Array[yi], jr = H.mark2Array[Ci][on.class];
                      return this.applyAnchor(on, jr, Ii), !0;
                    }
                    case 7:
                      return this.applyContext(H);
                    case 8:
                      return this.applyChainingContext(H);
                    case 9:
                      return this.applyLookup(H.lookupType, H.extension);
                    default:
                      throw new Error("Unsupported GPOS table: ".concat(k));
                  }
                }, $.applyAnchor = function(k, H, ot) {
                  var ct = this.getAnchor(H), ht = this.getAnchor(k.markAnchor);
                  this.positions[ot];
                  var ut = this.positions[this.glyphIterator.index];
                  ut.xOffset = ct.x - ht.x, ut.yOffset = ct.y - ht.y, this.glyphIterator.cur.markAttachment = ot;
                }, $.getAnchor = function(k) {
                  var H = k.xCoordinate, ot = k.yCoordinate, ct = this.font._variationProcessor, ht = this.font.GDEF && this.font.GDEF.itemVariationStore;
                  return ct && ht && (k.xDeviceTable && (H += ct.getDelta(ht, k.xDeviceTable.a, k.xDeviceTable.b)), k.yDeviceTable && (ot += ct.getDelta(ht, k.yDeviceTable.a, k.yDeviceTable.b))), {
                    x: H,
                    y: ot
                  };
                }, $.applyFeatures = function(k, H, ot) {
                  at.prototype.applyFeatures.call(this, k, H, ot);
                  for (var ct = 0; ct < this.glyphs.length; ct++)
                    this.fixCursiveAttachment(ct);
                  this.fixMarkAttachment();
                }, $.fixCursiveAttachment = function(k) {
                  var H = this.glyphs[k];
                  if (H.cursiveAttachment != null) {
                    var ot = H.cursiveAttachment;
                    H.cursiveAttachment = null, this.fixCursiveAttachment(ot), this.positions[k].yOffset += this.positions[ot].yOffset;
                  }
                }, $.fixMarkAttachment = function() {
                  for (var k = 0; k < this.glyphs.length; k++) {
                    var H = this.glyphs[k];
                    if (H.markAttachment != null) {
                      var ot = H.markAttachment;
                      if (this.positions[k].xOffset += this.positions[ot].xOffset, this.positions[k].yOffset += this.positions[ot].yOffset, this.direction === "ltr")
                        for (var ct = ot; ct < k; ct++)
                          this.positions[k].xOffset -= this.positions[ct].xAdvance, this.positions[k].yOffset -= this.positions[ct].yAdvance;
                      else
                        for (var ht = ot + 1; ht < k + 1; ht++)
                          this.positions[k].xOffset += this.positions[ht].xAdvance, this.positions[k].yOffset += this.positions[ht].yAdvance;
                    }
                  }
                }, W;
              }(_0), Fm = /* @__PURE__ */ function() {
                function at($) {
                  this.font = $, this.glyphInfos = null, this.plan = null, this.GSUBProcessor = null, this.GPOSProcessor = null, this.fallbackPosition = !0, $.GSUB && (this.GSUBProcessor = new Pm($, $.GSUB)), $.GPOS && (this.GPOSProcessor = new Om($, $.GPOS));
                }
                var W = at.prototype;
                return W.setup = function(R) {
                  var k = this;
                  this.glyphInfos = R.glyphs.map(function(ct) {
                    return new ya(k.font, ct.id, [].concat(ct.codePoints));
                  });
                  var H = null;
                  this.GPOSProcessor && (H = this.GPOSProcessor.selectScript(R.script, R.language, R.direction)), this.GSUBProcessor && (H = this.GSUBProcessor.selectScript(R.script, R.language, R.direction)), this.shaper = Tm(H), this.plan = new by(this.font, H, R.direction), this.shaper.plan(this.plan, this.glyphInfos, R.features);
                  for (var ot in this.plan.allFeatures)
                    R.features[ot] = !0;
                }, W.substitute = function(R) {
                  var k = this;
                  this.GSUBProcessor && (this.plan.process(this.GSUBProcessor, this.glyphInfos), R.glyphs = this.glyphInfos.map(function(H) {
                    return k.font.getGlyph(H.id, H.codePoints);
                  }));
                }, W.position = function(R) {
                  return this.shaper.zeroMarkWidths === "BEFORE_GPOS" && this.zeroMarkAdvances(R.positions), this.GPOSProcessor && this.plan.process(this.GPOSProcessor, this.glyphInfos, R.positions), this.shaper.zeroMarkWidths === "AFTER_GPOS" && this.zeroMarkAdvances(R.positions), R.direction === "rtl" && (R.glyphs.reverse(), R.positions.reverse()), this.GPOSProcessor && this.GPOSProcessor.features;
                }, W.zeroMarkAdvances = function(R) {
                  for (var k = 0; k < this.glyphInfos.length; k++)
                    this.glyphInfos[k].isMark && (R[k].xAdvance = 0, R[k].yAdvance = 0);
                }, W.cleanup = function() {
                  this.glyphInfos = null, this.plan = null, this.shaper = null;
                }, W.getAvailableFeatures = function(R, k) {
                  var H = [];
                  return this.GSUBProcessor && (this.GSUBProcessor.selectScript(R, k), H.push.apply(H, Object.keys(this.GSUBProcessor.features))), this.GPOSProcessor && (this.GPOSProcessor.selectScript(R, k), H.push.apply(H, Object.keys(this.GPOSProcessor.features))), H;
                }, at;
              }(), Im = /* @__PURE__ */ function() {
                function at($) {
                  this.font = $, this.unicodeLayoutEngine = null, this.kernProcessor = null, this.font.morx ? this.engine = new xy(this.font) : (this.font.GSUB || this.font.GPOS) && (this.engine = new Fm(this.font));
                }
                var W = at.prototype;
                return W.layout = function(R, k, H, ot, ct) {
                  if (typeof k == "string" && (ct = ot, ot = H, H = k, k = []), typeof R == "string") {
                    H == null && (H = Kp(R));
                    var ht = this.font.glyphsForString(R);
                  } else {
                    if (H == null) {
                      for (var ut = [], Nt = g(R), Kt; !(Kt = Nt()).done; ) {
                        var de = Kt.value;
                        ut.push.apply(ut, de.codePoints);
                      }
                      H = Jp(ut);
                    }
                    var ht = R;
                  }
                  var te = new $p(ht, k, H, ot, ct);
                  return ht.length === 0 ? (te.positions = [], te) : (this.engine && this.engine.setup && this.engine.setup(te), this.substitute(te), this.position(te), this.hideDefaultIgnorables(te.glyphs, te.positions), this.engine && this.engine.cleanup && this.engine.cleanup(), te);
                }, W.substitute = function(R) {
                  this.engine && this.engine.substitute && this.engine.substitute(R);
                }, W.position = function(R) {
                  R.positions = R.glyphs.map(function(H) {
                    return new qp(H.advanceWidth);
                  });
                  var k = null;
                  this.engine && this.engine.position && (k = this.engine.position(R)), !k && (!this.engine || this.engine.fallbackPosition) && (this.unicodeLayoutEngine || (this.unicodeLayoutEngine = new jp(this.font)), this.unicodeLayoutEngine.positionGlyphs(R.glyphs, R.positions)), (!k || !k.kern) && R.features.kern !== !1 && this.font.kern && (this.kernProcessor || (this.kernProcessor = new _p(this.font)), this.kernProcessor.process(R.glyphs, R.positions), R.features.kern = !0);
                }, W.hideDefaultIgnorables = function(R, k) {
                  for (var H = this.font.glyphForCodePoint(32), ot = 0; ot < R.length; ot++)
                    this.isDefaultIgnorable(R[ot].codePoints[0]) && (R[ot] = H, k[ot].xAdvance = 0, k[ot].yAdvance = 0);
                }, W.isDefaultIgnorable = function(R) {
                  var k = R >> 16;
                  if (k === 0)
                    switch (R >> 8) {
                      case 0:
                        return R === 173;
                      case 3:
                        return R === 847;
                      case 6:
                        return R === 1564;
                      case 23:
                        return 6068 <= R && R <= 6069;
                      case 24:
                        return 6155 <= R && R <= 6158;
                      case 32:
                        return 8203 <= R && R <= 8207 || 8234 <= R && R <= 8238 || 8288 <= R && R <= 8303;
                      case 254:
                        return 65024 <= R && R <= 65039 || R === 65279;
                      case 255:
                        return 65520 <= R && R <= 65528;
                      default:
                        return !1;
                    }
                  else
                    switch (k) {
                      case 1:
                        return 113824 <= R && R <= 113827 || 119155 <= R && R <= 119162;
                      case 14:
                        return 917504 <= R && R <= 921599;
                      default:
                        return !1;
                    }
                }, W.getAvailableFeatures = function(R, k) {
                  var H = [];
                  return this.engine && H.push.apply(H, this.engine.getAvailableFeatures(R, k)), this.font.kern && H.indexOf("kern") === -1 && H.push("kern"), H;
                }, W.stringsForGlyph = function(R) {
                  for (var k = /* @__PURE__ */ new Set(), H = this.font._cmapProcessor.codePointsForGlyph(R), ot = g(H), ct; !(ct = ot()).done; ) {
                    var ht = ct.value;
                    k.add(String.fromCodePoint(ht));
                  }
                  if (this.engine && this.engine.stringsForGlyph)
                    for (var ut = g(this.engine.stringsForGlyph(R)), Nt; !(Nt = ut()).done; ) {
                      var Kt = Nt.value;
                      k.add(Kt);
                    }
                  return Array.from(k);
                }, at;
              }(), Rm = {
                moveTo: "M",
                lineTo: "L",
                quadraticCurveTo: "Q",
                bezierCurveTo: "C",
                closePath: "Z"
              }, el = /* @__PURE__ */ function() {
                function at() {
                  this.commands = [], this._bbox = null, this._cbox = null;
                }
                var W = at.prototype;
                return W.toFunction = function() {
                  var R = this;
                  return function(k) {
                    R.commands.forEach(function(H) {
                      return k[H.command].apply(k, H.args);
                    });
                  };
                }, W.toSVG = function() {
                  var R = this.commands.map(function(k) {
                    var H = k.args.map(function(ot) {
                      return Math.round(ot * 100) / 100;
                    });
                    return "".concat(Rm[k.command]).concat(H.join(" "));
                  });
                  return R.join("");
                }, W.mapPoints = function(R) {
                  for (var k = new at(), H = g(this.commands), ot; !(ot = H()).done; ) {
                    for (var ct = ot.value, ht = [], ut = 0; ut < ct.args.length; ut += 2) {
                      var Nt = R(ct.args[ut], ct.args[ut + 1]), Kt = Nt[0], de = Nt[1];
                      ht.push(Kt, de);
                    }
                    k[ct.command].apply(k, ht);
                  }
                  return k;
                }, W.transform = function(R, k, H, ot, ct, ht) {
                  return this.mapPoints(function(ut, Nt) {
                    return ut = R * ut + H * Nt + ct, Nt = k * ut + ot * Nt + ht, [ut, Nt];
                  });
                }, W.translate = function(R, k) {
                  return this.transform(1, 0, 0, 1, R, k);
                }, W.rotate = function(R) {
                  var k = Math.cos(R), H = Math.sin(R);
                  return this.transform(k, H, -H, k, 0, 0);
                }, W.scale = function(R, k) {
                  return k === void 0 && (k = R), this.transform(R, 0, 0, k, 0, 0);
                }, h(at, [{
                  key: "cbox",
                  get: function() {
                    if (!this._cbox) {
                      for (var R = new Xo(), k = g(this.commands), H; !(H = k()).done; )
                        for (var ot = H.value, ct = 0; ct < ot.args.length; ct += 2)
                          R.addPoint(ot.args[ct], ot.args[ct + 1]);
                      this._cbox = Object.freeze(R);
                    }
                    return this._cbox;
                  }
                  /**
                   * Gets the exact bounding box of the path by evaluating curve segments.
                   * Slower to compute than the control box, but more accurate.
                   * @type {BBox}
                   */
                }, {
                  key: "bbox",
                  get: function() {
                    if (this._bbox)
                      return this._bbox;
                    for (var R = new Xo(), k = 0, H = 0, ot = function(Un) {
                      return Math.pow(1 - Un, 3) * Lr[Mr] + 3 * Math.pow(1 - Un, 2) * Un * yn[Mr] + 3 * (1 - Un) * Math.pow(Un, 2) * On[Mr] + Math.pow(Un, 3) * hn[Mr];
                    }, ct = g(this.commands), ht; !(ht = ct()).done; ) {
                      var ut = ht.value;
                      switch (ut.command) {
                        case "moveTo":
                        case "lineTo":
                          var Nt = ut.args, Kt = Nt[0], de = Nt[1];
                          R.addPoint(Kt, de), k = Kt, H = de;
                          break;
                        case "quadraticCurveTo":
                        case "bezierCurveTo":
                          if (ut.command === "quadraticCurveTo")
                            var te = ut.args, pe = te[0], Ee = te[1], Le = te[2], $e = te[3], wr = k + 2 / 3 * (pe - k), or = H + 2 / 3 * (Ee - H), Pr = Le + 2 / 3 * (pe - Le), Cr = $e + 2 / 3 * (Ee - $e);
                          else
                            var Dr = ut.args, wr = Dr[0], or = Dr[1], Pr = Dr[2], Cr = Dr[3], Le = Dr[4], $e = Dr[5];
                          R.addPoint(Le, $e);
                          for (var Lr = [k, H], yn = [wr, or], On = [Pr, Cr], hn = [Le, $e], Mr = 0; Mr <= 1; Mr++) {
                            var nn = 6 * Lr[Mr] - 12 * yn[Mr] + 6 * On[Mr], vn = -3 * Lr[Mr] + 9 * yn[Mr] - 9 * On[Mr] + 3 * hn[Mr];
                            if (ut = 3 * yn[Mr] - 3 * Lr[Mr], vn === 0) {
                              if (nn === 0)
                                continue;
                              var _n = -ut / nn;
                              0 < _n && _n < 1 && (Mr === 0 ? R.addPoint(ot(_n), R.maxY) : Mr === 1 && R.addPoint(R.maxX, ot(_n)));
                              continue;
                            }
                            var kr = Math.pow(nn, 2) - 4 * ut * vn;
                            if (!(kr < 0)) {
                              var an = (-nn + Math.sqrt(kr)) / (2 * vn);
                              0 < an && an < 1 && (Mr === 0 ? R.addPoint(ot(an), R.maxY) : Mr === 1 && R.addPoint(R.maxX, ot(an)));
                              var mn = (-nn - Math.sqrt(kr)) / (2 * vn);
                              0 < mn && mn < 1 && (Mr === 0 ? R.addPoint(ot(mn), R.maxY) : Mr === 1 && R.addPoint(R.maxX, ot(mn)));
                            }
                          }
                          k = Le, H = $e;
                          break;
                      }
                    }
                    return this._bbox = Object.freeze(R);
                  }
                }]), at;
              }(), Dm = function(W) {
                el.prototype[W] = function() {
                  this._bbox = this._cbox = null;
                  for (var $ = arguments.length, R = new Array($), k = 0; k < $; k++)
                    R[k] = arguments[k];
                  return this.commands.push({
                    command: W,
                    args: R
                  }), this;
                };
              }, du = 0, Jc = ["moveTo", "lineTo", "quadraticCurveTo", "bezierCurveTo", "closePath"]; du < Jc.length; du++) {
                var Mm = Jc[du];
                Dm(Mm);
              }
              var Ls = [".notdef", ".null", "nonmarkingreturn", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quotesingle", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "grave", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "Adieresis", "Aring", "Ccedilla", "Eacute", "Ntilde", "Odieresis", "Udieresis", "aacute", "agrave", "acircumflex", "adieresis", "atilde", "aring", "ccedilla", "eacute", "egrave", "ecircumflex", "edieresis", "iacute", "igrave", "icircumflex", "idieresis", "ntilde", "oacute", "ograve", "ocircumflex", "odieresis", "otilde", "uacute", "ugrave", "ucircumflex", "udieresis", "dagger", "degree", "cent", "sterling", "section", "bullet", "paragraph", "germandbls", "registered", "copyright", "trademark", "acute", "dieresis", "notequal", "AE", "Oslash", "infinity", "plusminus", "lessequal", "greaterequal", "yen", "mu", "partialdiff", "summation", "product", "pi", "integral", "ordfeminine", "ordmasculine", "Omega", "ae", "oslash", "questiondown", "exclamdown", "logicalnot", "radical", "florin", "approxequal", "Delta", "guillemotleft", "guillemotright", "ellipsis", "nonbreakingspace", "Agrave", "Atilde", "Otilde", "OE", "oe", "endash", "emdash", "quotedblleft", "quotedblright", "quoteleft", "quoteright", "divide", "lozenge", "ydieresis", "Ydieresis", "fraction", "currency", "guilsinglleft", "guilsinglright", "fi", "fl", "daggerdbl", "periodcentered", "quotesinglbase", "quotedblbase", "perthousand", "Acircumflex", "Ecircumflex", "Aacute", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Oacute", "Ocircumflex", "apple", "Ograve", "Uacute", "Ucircumflex", "Ugrave", "dotlessi", "circumflex", "tilde", "macron", "breve", "dotaccent", "ring", "cedilla", "hungarumlaut", "ogonek", "caron", "Lslash", "lslash", "Scaron", "scaron", "Zcaron", "zcaron", "brokenbar", "Eth", "eth", "Yacute", "yacute", "Thorn", "thorn", "minus", "multiply", "onesuperior", "twosuperior", "threesuperior", "onehalf", "onequarter", "threequarters", "franc", "Gbreve", "gbreve", "Idotaccent", "Scedilla", "scedilla", "Cacute", "cacute", "Ccaron", "ccaron", "dcroat"], Kn, rl = (Kn = /* @__PURE__ */ function() {
                function at($, R, k) {
                  this.id = $, this.codePoints = R, this._font = k, this.isMark = this.codePoints.length > 0 && this.codePoints.every(A.isMark), this.isLigature = this.codePoints.length > 1;
                }
                var W = at.prototype;
                return W._getPath = function() {
                  return new el();
                }, W._getCBox = function() {
                  return this.path.cbox;
                }, W._getBBox = function() {
                  return this.path.bbox;
                }, W._getTableMetrics = function(R) {
                  if (this.id < R.metrics.length)
                    return R.metrics.get(this.id);
                  var k = R.metrics.get(R.metrics.length - 1), H = {
                    advance: k ? k.advance : 0,
                    bearing: R.bearings.get(this.id - R.metrics.length) || 0
                  };
                  return H;
                }, W._getMetrics = function(R) {
                  if (this._metrics)
                    return this._metrics;
                  var k = this._getTableMetrics(this._font.hmtx), H = k.advance, ot = k.bearing;
                  if (this._font.vmtx)
                    var ct = this._getTableMetrics(this._font.vmtx), ht = ct.advance, ut = ct.bearing;
                  else {
                    var Nt;
                    if ((typeof R > "u" || R === null) && (R = this.cbox), (Nt = this._font["OS/2"]) && Nt.version > 0)
                      var ht = Math.abs(Nt.typoAscender - Nt.typoDescender), ut = Nt.typoAscender - R.maxY;
                    else
                      var Kt = this._font.hhea, ht = Math.abs(Kt.ascent - Kt.descent), ut = Kt.ascent - R.maxY;
                  }
                  return this._font._variationProcessor && this._font.HVAR && (H += this._font._variationProcessor.getAdvanceAdjustment(this.id, this._font.HVAR)), this._metrics = {
                    advanceWidth: H,
                    advanceHeight: ht,
                    leftBearing: ot,
                    topBearing: ut
                  };
                }, W.getScaledPath = function(R) {
                  var k = 1 / this._font.unitsPerEm * R;
                  return this.path.scale(k);
                }, W._getName = function() {
                  var R = this._font.post;
                  if (!R)
                    return null;
                  switch (R.version) {
                    case 1:
                      return Ls[this.id];
                    case 2:
                      var k = R.glyphNameIndex[this.id];
                      return k < Ls.length ? Ls[k] : R.names[k - Ls.length];
                    case 2.5:
                      return Ls[this.id + R.offsets[this.id]];
                    case 4:
                      return String.fromCharCode(R.map[this.id]);
                  }
                }, W.render = function(R, k) {
                  R.save();
                  var H = 1 / this._font.head.unitsPerEm * k;
                  R.scale(H, H);
                  var ot = this.path.toFunction();
                  ot(R), R.fill(), R.restore();
                }, h(at, [{
                  key: "cbox",
                  get: function() {
                    return this._getCBox();
                  }
                  /**
                   * The glyph’s bounding box, i.e. the rectangle that encloses the
                   * glyph outline as tightly as possible.
                   * @type {BBox}
                   */
                }, {
                  key: "bbox",
                  get: function() {
                    return this._getBBox();
                  }
                  /**
                   * A vector Path object representing the glyph outline.
                   * @type {Path}
                   */
                }, {
                  key: "path",
                  get: function() {
                    return this._getPath();
                  }
                }, {
                  key: "advanceWidth",
                  get: function() {
                    return this._getMetrics().advanceWidth;
                  }
                  /**
                   * The glyph's advance height.
                   * @type {number}
                   */
                }, {
                  key: "advanceHeight",
                  get: function() {
                    return this._getMetrics().advanceHeight;
                  }
                }, {
                  key: "ligatureCaretPositions",
                  get: function() {
                  }
                }, {
                  key: "name",
                  get: function() {
                    return this._getName();
                  }
                }]), at;
              }(), L(Kn.prototype, "cbox", [J], Object.getOwnPropertyDescriptor(Kn.prototype, "cbox"), Kn.prototype), L(Kn.prototype, "bbox", [J], Object.getOwnPropertyDescriptor(Kn.prototype, "bbox"), Kn.prototype), L(Kn.prototype, "path", [J], Object.getOwnPropertyDescriptor(Kn.prototype, "path"), Kn.prototype), L(Kn.prototype, "advanceWidth", [J], Object.getOwnPropertyDescriptor(Kn.prototype, "advanceWidth"), Kn.prototype), L(Kn.prototype, "advanceHeight", [J], Object.getOwnPropertyDescriptor(Kn.prototype, "advanceHeight"), Kn.prototype), L(Kn.prototype, "name", [J], Object.getOwnPropertyDescriptor(Kn.prototype, "name"), Kn.prototype), Kn), Qc = new n.Struct({
                numberOfContours: n.int16,
                // if negative, this is a composite glyph
                xMin: n.int16,
                yMin: n.int16,
                xMax: n.int16,
                yMax: n.int16
              }), Bm = 1, km = 2, Nm = 4, Lm = 8, Um = 16, zm = 32, Gm = 1, Vm = 8, $c = 32, Hm = 64, Wm = 128, _m = 256, wa = /* @__PURE__ */ function() {
                function at($, R, k, H) {
                  k === void 0 && (k = 0), H === void 0 && (H = 0), this.onCurve = $, this.endContour = R, this.x = k, this.y = H;
                }
                var W = at.prototype;
                return W.copy = function() {
                  return new at(this.onCurve, this.endContour, this.x, this.y);
                }, at;
              }(), jm = function(W, $, R) {
                this.glyphID = W, this.dx = $, this.dy = R, this.pos = 0, this.scaleX = this.scaleY = 1, this.scale01 = this.scale10 = 0;
              }, nl = /* @__PURE__ */ function(at) {
                m(W, at);
                function W() {
                  return at.apply(this, arguments) || this;
                }
                var $ = W.prototype;
                return $._getCBox = function(k) {
                  if (this._font._variationProcessor && !k)
                    return this.path.cbox;
                  var H = this._font._getTableStream("glyf");
                  H.pos += this._font.loca.offsets[this.id];
                  var ot = Qc.decode(H), ct = new Xo(ot.xMin, ot.yMin, ot.xMax, ot.yMax);
                  return Object.freeze(ct);
                }, $._parseGlyphCoord = function(k, H, ot, ct) {
                  if (ot) {
                    var ht = k.readUInt8();
                    ct || (ht = -ht), ht += H;
                  } else if (ct)
                    var ht = H;
                  else
                    var ht = H + k.readInt16BE();
                  return ht;
                }, $._decode = function() {
                  var k = this._font.loca.offsets[this.id], H = this._font.loca.offsets[this.id + 1];
                  if (k === H)
                    return null;
                  var ot = this._font._getTableStream("glyf");
                  ot.pos += k;
                  var ct = ot.pos, ht = Qc.decode(ot);
                  return ht.numberOfContours > 0 ? this._decodeSimple(ht, ot) : ht.numberOfContours < 0 && this._decodeComposite(ht, ot, ct), ht;
                }, $._decodeSimple = function(k, H) {
                  k.points = [];
                  var ot = new n.Array(n.uint16, k.numberOfContours).decode(H);
                  k.instructions = new n.Array(n.uint8, n.uint16).decode(H);
                  for (var ct = [], ht = ot[ot.length - 1] + 1; ct.length < ht; ) {
                    var ut = H.readUInt8();
                    if (ct.push(ut), ut & Lm)
                      for (var Nt = H.readUInt8(), Kt = 0; Kt < Nt; Kt++)
                        ct.push(ut);
                  }
                  for (var de = 0; de < ct.length; de++) {
                    var ut = ct[de], te = new wa(!!(ut & Bm), ot.indexOf(de) >= 0, 0, 0);
                    k.points.push(te);
                  }
                  for (var pe = 0, de = 0; de < ct.length; de++) {
                    var ut = ct[de];
                    k.points[de].x = pe = this._parseGlyphCoord(H, pe, ut & km, ut & Um);
                  }
                  for (var Ee = 0, de = 0; de < ct.length; de++) {
                    var ut = ct[de];
                    k.points[de].y = Ee = this._parseGlyphCoord(H, Ee, ut & Nm, ut & zm);
                  }
                  if (this._font._variationProcessor) {
                    var Le = k.points.slice();
                    Le.push.apply(Le, this._getPhantomPoints(k)), this._font._variationProcessor.transformPoints(this.id, Le), k.phantomPoints = Le.slice(-4);
                  }
                }, $._decodeComposite = function(k, H, ot) {
                  ot === void 0 && (ot = 0), k.components = [];
                  for (var ct = !1, ht = $c; ht & $c; ) {
                    ht = H.readUInt16BE();
                    var ut = H.pos - ot, Nt = H.readUInt16BE();
                    if (ct || (ct = (ht & _m) !== 0), ht & Gm)
                      var Kt = H.readInt16BE(), de = H.readInt16BE();
                    else
                      var Kt = H.readInt8(), de = H.readInt8();
                    var te = new jm(Nt, Kt, de);
                    te.pos = ut, ht & Vm ? te.scaleX = te.scaleY = (H.readUInt8() << 24 | H.readUInt8() << 16) / 1073741824 : ht & Hm ? (te.scaleX = (H.readUInt8() << 24 | H.readUInt8() << 16) / 1073741824, te.scaleY = (H.readUInt8() << 24 | H.readUInt8() << 16) / 1073741824) : ht & Wm && (te.scaleX = (H.readUInt8() << 24 | H.readUInt8() << 16) / 1073741824, te.scale01 = (H.readUInt8() << 24 | H.readUInt8() << 16) / 1073741824, te.scale10 = (H.readUInt8() << 24 | H.readUInt8() << 16) / 1073741824, te.scaleY = (H.readUInt8() << 24 | H.readUInt8() << 16) / 1073741824), k.components.push(te);
                  }
                  if (this._font._variationProcessor) {
                    for (var pe = [], Ee = 0; Ee < k.components.length; Ee++) {
                      var te = k.components[Ee];
                      pe.push(new wa(!0, !0, te.dx, te.dy));
                    }
                    pe.push.apply(pe, this._getPhantomPoints(k)), this._font._variationProcessor.transformPoints(this.id, pe), k.phantomPoints = pe.splice(-4, 4);
                    for (var Le = 0; Le < pe.length; Le++) {
                      var $e = pe[Le];
                      k.components[Le].dx = $e.x, k.components[Le].dy = $e.y;
                    }
                  }
                  return ct;
                }, $._getPhantomPoints = function(k) {
                  var H = this._getCBox(!0);
                  this._metrics == null && (this._metrics = rl.prototype._getMetrics.call(this, H));
                  var ot = this._metrics, ct = ot.advanceWidth, ht = ot.advanceHeight, ut = ot.leftBearing, Nt = ot.topBearing;
                  return [new wa(!1, !0, k.xMin - ut, 0), new wa(!1, !0, k.xMin - ut + ct, 0), new wa(!1, !0, 0, k.yMax + Nt), new wa(!1, !0, 0, k.yMax + Nt + ht)];
                }, $._getContours = function() {
                  var k = this._decode();
                  if (!k)
                    return [];
                  var H = [];
                  if (k.numberOfContours < 0)
                    for (var ot = g(k.components), ct; !(ct = ot()).done; )
                      for (var ht = ct.value, ut = this._font.getGlyph(ht.glyphID)._getContours(), Nt = 0; Nt < ut.length; Nt++)
                        for (var Kt = ut[Nt], de = 0; de < Kt.length; de++) {
                          var te = Kt[de], pe = te.x * ht.scaleX + te.y * ht.scale01 + ht.dx, Ee = te.y * ht.scaleY + te.x * ht.scale10 + ht.dy;
                          H.push(new wa(te.onCurve, te.endContour, pe, Ee));
                        }
                  else
                    H = k.points || [];
                  k.phantomPoints && !this._font.directory.tables.HVAR && (this._metrics.advanceWidth = k.phantomPoints[1].x - k.phantomPoints[0].x, this._metrics.advanceHeight = k.phantomPoints[3].y - k.phantomPoints[2].y, this._metrics.leftBearing = k.xMin - k.phantomPoints[0].x, this._metrics.topBearing = k.phantomPoints[2].y - k.yMax);
                  for (var Le = [], $e = [], wr = 0; wr < H.length; wr++) {
                    var or = H[wr];
                    $e.push(or), or.endContour && (Le.push($e), $e = []);
                  }
                  return Le;
                }, $._getMetrics = function() {
                  if (this._metrics)
                    return this._metrics;
                  var k = this._getCBox(!0);
                  return at.prototype._getMetrics.call(this, k), this._font._variationProcessor && !this._font.HVAR && this.path, this._metrics;
                }, $._getPath = function() {
                  for (var k = this._getContours(), H = new el(), ot = 0; ot < k.length; ot++) {
                    var ct = k[ot], ht = ct[0], ut = ct[ct.length - 1], Nt = 0;
                    if (ht.onCurve) {
                      var Kt = null;
                      Nt = 1;
                    } else {
                      ut.onCurve ? ht = ut : ht = new wa(!1, !1, (ht.x + ut.x) / 2, (ht.y + ut.y) / 2);
                      var Kt = ht;
                    }
                    H.moveTo(ht.x, ht.y);
                    for (var de = Nt; de < ct.length; de++) {
                      var te = ct[de], pe = de === 0 ? ht : ct[de - 1];
                      if (pe.onCurve && te.onCurve)
                        H.lineTo(te.x, te.y);
                      else if (pe.onCurve && !te.onCurve)
                        var Kt = te;
                      else if (!pe.onCurve && !te.onCurve) {
                        var Ee = (pe.x + te.x) / 2, Le = (pe.y + te.y) / 2;
                        H.quadraticCurveTo(pe.x, pe.y, Ee, Le);
                        var Kt = te;
                      } else if (!pe.onCurve && te.onCurve) {
                        H.quadraticCurveTo(Kt.x, Kt.y, te.x, te.y);
                        var Kt = null;
                      } else
                        throw new Error("Unknown TTF path state");
                    }
                    Kt && H.quadraticCurveTo(Kt.x, Kt.y, ht.x, ht.y), H.closePath();
                  }
                  return H;
                }, W;
              }(rl), Xm = /* @__PURE__ */ function(at) {
                m(W, at);
                function W() {
                  return at.apply(this, arguments) || this;
                }
                var $ = W.prototype;
                return $._getName = function() {
                  return this._font.CFF2 ? at.prototype._getName.call(this) : this._font["CFF "].getGlyphName(this.id);
                }, $.bias = function(k) {
                  return k.length < 1240 ? 107 : k.length < 33900 ? 1131 : 32768;
                }, $._getPath = function() {
                  var k = this._font.CFF2 || this._font["CFF "], H = k.stream, ot = k.topDict.CharStrings[this.id], ct = ot.offset + ot.length;
                  H.pos = ot.offset;
                  var ht = new el(), ut = [], Nt = [], Kt = null, de = 0, te = 0, pe = 0, Ee, Le, $e = !1;
                  this._usedGsubrs = Ee = {}, this._usedSubrs = Le = {};
                  var wr = k.globalSubrIndex || [], or = this.bias(wr), Pr = k.privateDictForGlyph(this.id) || {}, Cr = Pr.Subrs || [], Dr = this.bias(Cr), Lr = k.topDict.vstore && k.topDict.vstore.itemVariationStore, yn = Pr.vsindex, On = this._font._variationProcessor;
                  function hn() {
                    Kt == null && (Kt = ut.shift() + Pr.nominalWidthX);
                  }
                  function Mr() {
                    return ut.length % 2 !== 0 && hn(), de += ut.length >> 1, ut.length = 0;
                  }
                  function nn(_n, kr) {
                    $e && ht.closePath(), ht.moveTo(_n, kr), $e = !0;
                  }
                  var vn = function _n() {
                    for (; H.pos < ct; ) {
                      var kr = H.readUInt8();
                      if (kr < 32)
                        switch (kr) {
                          case 1:
                          case 3:
                          case 18:
                          case 23:
                            Mr();
                            break;
                          case 4:
                            ut.length > 1 && hn(), pe += ut.shift(), nn(te, pe);
                            break;
                          case 5:
                            for (; ut.length >= 2; )
                              te += ut.shift(), pe += ut.shift(), ht.lineTo(te, pe);
                            break;
                          case 6:
                          case 7:
                            for (var an = kr === 6; ut.length >= 1; )
                              an ? te += ut.shift() : pe += ut.shift(), ht.lineTo(te, pe), an = !an;
                            break;
                          case 8:
                            for (; ut.length > 0; ) {
                              var on = te + ut.shift(), jr = pe + ut.shift(), An = on + ut.shift(), xn = jr + ut.shift();
                              te = An + ut.shift(), pe = xn + ut.shift(), ht.bezierCurveTo(on, jr, An, xn, te, pe);
                            }
                            break;
                          case 10:
                            var mn = ut.pop() + Dr, Ur = Cr[mn];
                            if (Ur) {
                              Le[mn] = !0;
                              var Un = H.pos, ti = ct;
                              H.pos = Ur.offset, ct = Ur.offset + Ur.length, _n(), H.pos = Un, ct = ti;
                            }
                            break;
                          case 11:
                            if (k.version >= 2)
                              break;
                            return;
                          case 14:
                            if (k.version >= 2)
                              break;
                            ut.length > 0 && hn(), $e && (ht.closePath(), $e = !1);
                            break;
                          case 15: {
                            if (k.version < 2)
                              throw new Error("vsindex operator not supported in CFF v1");
                            yn = ut.pop();
                            break;
                          }
                          case 16: {
                            if (k.version < 2)
                              throw new Error("blend operator not supported in CFF v1");
                            if (!On)
                              throw new Error("blend operator in non-variation font");
                            for (var pi = On.getBlendVector(Lr, yn), Ai = ut.pop(), yi = Ai * pi.length, Ii = ut.length - yi, Ri = Ii - Ai, ui = 0; ui < Ai; ui++) {
                              for (var Jn = ut[Ri + ui], Ci = 0; Ci < pi.length; Ci++)
                                Jn += pi[Ci] * ut[Ii++];
                              ut[Ri + ui] = Jn;
                            }
                            for (; yi--; )
                              ut.pop();
                            break;
                          }
                          case 19:
                          case 20:
                            Mr(), H.pos += de + 7 >> 3;
                            break;
                          case 21:
                            ut.length > 2 && hn(), te += ut.shift(), pe += ut.shift(), nn(te, pe);
                            break;
                          case 22:
                            ut.length > 1 && hn(), te += ut.shift(), nn(te, pe);
                            break;
                          case 24:
                            for (; ut.length >= 8; ) {
                              var on = te + ut.shift(), jr = pe + ut.shift(), An = on + ut.shift(), xn = jr + ut.shift();
                              te = An + ut.shift(), pe = xn + ut.shift(), ht.bezierCurveTo(on, jr, An, xn, te, pe);
                            }
                            te += ut.shift(), pe += ut.shift(), ht.lineTo(te, pe);
                            break;
                          case 25:
                            for (; ut.length >= 8; )
                              te += ut.shift(), pe += ut.shift(), ht.lineTo(te, pe);
                            var on = te + ut.shift(), jr = pe + ut.shift(), An = on + ut.shift(), xn = jr + ut.shift();
                            te = An + ut.shift(), pe = xn + ut.shift(), ht.bezierCurveTo(on, jr, An, xn, te, pe);
                            break;
                          case 26:
                            for (ut.length % 2 && (te += ut.shift()); ut.length >= 4; )
                              on = te, jr = pe + ut.shift(), An = on + ut.shift(), xn = jr + ut.shift(), te = An, pe = xn + ut.shift(), ht.bezierCurveTo(on, jr, An, xn, te, pe);
                            break;
                          case 27:
                            for (ut.length % 2 && (pe += ut.shift()); ut.length >= 4; )
                              on = te + ut.shift(), jr = pe, An = on + ut.shift(), xn = jr + ut.shift(), te = An + ut.shift(), pe = xn, ht.bezierCurveTo(on, jr, An, xn, te, pe);
                            break;
                          case 28:
                            ut.push(H.readInt16BE());
                            break;
                          case 29:
                            if (mn = ut.pop() + or, Ur = wr[mn], Ur) {
                              Ee[mn] = !0;
                              var Un = H.pos, ti = ct;
                              H.pos = Ur.offset, ct = Ur.offset + Ur.length, _n(), H.pos = Un, ct = ti;
                            }
                            break;
                          case 30:
                          case 31:
                            for (an = kr === 31; ut.length >= 4; )
                              an ? (on = te + ut.shift(), jr = pe, An = on + ut.shift(), xn = jr + ut.shift(), pe = xn + ut.shift(), te = An + (ut.length === 1 ? ut.shift() : 0)) : (on = te, jr = pe + ut.shift(), An = on + ut.shift(), xn = jr + ut.shift(), te = An + ut.shift(), pe = xn + (ut.length === 1 ? ut.shift() : 0)), ht.bezierCurveTo(on, jr, An, xn, te, pe), an = !an;
                            break;
                          case 12:
                            switch (kr = H.readUInt8(), kr) {
                              case 3:
                                var sn = ut.pop(), hi = ut.pop();
                                ut.push(sn && hi ? 1 : 0);
                                break;
                              case 4:
                                sn = ut.pop(), hi = ut.pop(), ut.push(sn || hi ? 1 : 0);
                                break;
                              case 5:
                                sn = ut.pop(), ut.push(sn ? 0 : 1);
                                break;
                              case 9:
                                sn = ut.pop(), ut.push(Math.abs(sn));
                                break;
                              case 10:
                                sn = ut.pop(), hi = ut.pop(), ut.push(sn + hi);
                                break;
                              case 11:
                                sn = ut.pop(), hi = ut.pop(), ut.push(sn - hi);
                                break;
                              case 12:
                                sn = ut.pop(), hi = ut.pop(), ut.push(sn / hi);
                                break;
                              case 14:
                                sn = ut.pop(), ut.push(-sn);
                                break;
                              case 15:
                                sn = ut.pop(), hi = ut.pop(), ut.push(sn === hi ? 1 : 0);
                                break;
                              case 18:
                                ut.pop();
                                break;
                              case 20:
                                var Ko = ut.pop(), Ji = ut.pop();
                                Nt[Ji] = Ko;
                                break;
                              case 21:
                                Ji = ut.pop(), ut.push(Nt[Ji] || 0);
                                break;
                              case 22:
                                var gu = ut.pop(), M4 = ut.pop(), B4 = ut.pop(), k4 = ut.pop();
                                ut.push(B4 <= k4 ? gu : M4);
                                break;
                              case 23:
                                ut.push(Math.random());
                                break;
                              case 24:
                                sn = ut.pop(), hi = ut.pop(), ut.push(sn * hi);
                                break;
                              case 26:
                                sn = ut.pop(), ut.push(Math.sqrt(sn));
                                break;
                              case 27:
                                sn = ut.pop(), ut.push(sn, sn);
                                break;
                              case 28:
                                sn = ut.pop(), hi = ut.pop(), ut.push(hi, sn);
                                break;
                              case 29:
                                Ji = ut.pop(), Ji < 0 ? Ji = 0 : Ji > ut.length - 1 && (Ji = ut.length - 1), ut.push(ut[Ji]);
                                break;
                              case 30:
                                var il = ut.pop(), Us = ut.pop();
                                if (Us >= 0)
                                  for (; Us > 0; ) {
                                    for (var pu = ut[il - 1], al = il - 2; al >= 0; al--)
                                      ut[al + 1] = ut[al];
                                    ut[0] = pu, Us--;
                                  }
                                else
                                  for (; Us < 0; ) {
                                    for (var pu = ut[0], ol = 0; ol <= il; ol++)
                                      ut[ol] = ut[ol + 1];
                                    ut[il - 1] = pu, Us++;
                                  }
                                break;
                              case 34:
                                on = te + ut.shift(), jr = pe, An = on + ut.shift(), xn = jr + ut.shift();
                                var zs = An + ut.shift(), Gs = xn, Vs = zs + ut.shift(), Hs = Gs, Ws = Vs + ut.shift(), _s = Hs, js = Ws + ut.shift(), Xs = _s;
                                te = js, pe = Xs, ht.bezierCurveTo(on, jr, An, xn, zs, Gs), ht.bezierCurveTo(Vs, Hs, Ws, _s, js, Xs);
                                break;
                              case 35:
                                for (var _a = [], cd = 0; cd <= 5; cd++)
                                  te += ut.shift(), pe += ut.shift(), _a.push(te, pe);
                                ht.bezierCurveTo.apply(ht, _a.slice(0, 6)), ht.bezierCurveTo.apply(ht, _a.slice(6)), ut.shift();
                                break;
                              case 36:
                                on = te + ut.shift(), jr = pe + ut.shift(), An = on + ut.shift(), xn = jr + ut.shift(), zs = An + ut.shift(), Gs = xn, Vs = zs + ut.shift(), Hs = Gs, Ws = Vs + ut.shift(), _s = Hs + ut.shift(), js = Ws + ut.shift(), Xs = _s, te = js, pe = Xs, ht.bezierCurveTo(on, jr, An, xn, zs, Gs), ht.bezierCurveTo(Vs, Hs, Ws, _s, js, Xs);
                                break;
                              case 37:
                                var dd = te, vd = pe;
                                _a = [];
                                for (var gd = 0; gd <= 4; gd++)
                                  te += ut.shift(), pe += ut.shift(), _a.push(te, pe);
                                Math.abs(te - dd) > Math.abs(pe - vd) ? (te += ut.shift(), pe = vd) : (te = dd, pe += ut.shift()), _a.push(te, pe), ht.bezierCurveTo.apply(ht, _a.slice(0, 6)), ht.bezierCurveTo.apply(ht, _a.slice(6));
                                break;
                              default:
                                throw new Error("Unknown op: 12 ".concat(kr));
                            }
                            break;
                          default:
                            throw new Error("Unknown op: ".concat(kr));
                        }
                      else if (kr < 247)
                        ut.push(kr - 139);
                      else if (kr < 251) {
                        var yu = H.readUInt8();
                        ut.push((kr - 247) * 256 + yu + 108);
                      } else if (kr < 255) {
                        var yu = H.readUInt8();
                        ut.push(-(kr - 251) * 256 - yu - 108);
                      } else
                        ut.push(H.readInt32BE() / 65536);
                    }
                  };
                  return vn(), $e && ht.closePath(), ht;
                }, W;
              }(rl), Ym = new n.Struct({
                originX: n.uint16,
                originY: n.uint16,
                type: new n.String(4),
                data: new n.Buffer(function(at) {
                  return at.parent.buflen - at._currentOffset;
                })
              }), Zm = /* @__PURE__ */ function(at) {
                m(W, at);
                function W() {
                  return at.apply(this, arguments) || this;
                }
                var $ = W.prototype;
                return $.getImageForSize = function(k) {
                  for (var H = 0; H < this._font.sbix.imageTables.length; H++) {
                    var ot = this._font.sbix.imageTables[H];
                    if (ot.ppem >= k)
                      break;
                  }
                  var ct = ot.imageOffsets, ht = ct[this.id], ut = ct[this.id + 1];
                  return ht === ut ? null : (this._font.stream.pos = ht, Ym.decode(this._font.stream, {
                    buflen: ut - ht
                  }));
                }, $.render = function(k, H) {
                  var ot = this.getImageForSize(H);
                  if (ot != null) {
                    var ct = H / this._font.unitsPerEm;
                    k.image(ot.data, {
                      height: H,
                      x: ot.originX,
                      y: (this.bbox.minY - ot.originY) * ct
                    });
                  }
                  this._font.sbix.flags.renderOutlines && at.prototype.render.call(this, k, H);
                }, W;
              }(nl), qc = function(W, $) {
                this.glyph = W, this.color = $;
              }, Km = /* @__PURE__ */ function(at) {
                m(W, at);
                function W() {
                  return at.apply(this, arguments) || this;
                }
                var $ = W.prototype;
                return $._getBBox = function() {
                  for (var k = new Xo(), H = 0; H < this.layers.length; H++) {
                    var ot = this.layers[H], ct = ot.glyph.bbox;
                    k.addPoint(ct.minX, ct.minY), k.addPoint(ct.maxX, ct.maxY);
                  }
                  return k;
                }, $.render = function(k, H) {
                  for (var ot = g(this.layers), ct; !(ct = ot()).done; ) {
                    var ht = ct.value, ut = ht.glyph, Nt = ht.color;
                    k.fillColor([Nt.red, Nt.green, Nt.blue], Nt.alpha / 255 * 100), ut.render(k, H);
                  }
                }, h(W, [{
                  key: "layers",
                  get: function() {
                    for (var k = this._font.CPAL, H = this._font.COLR, ot = 0, ct = H.baseGlyphRecord.length - 1; ot <= ct; ) {
                      var ht = ot + ct >> 1, ut = H.baseGlyphRecord[ht];
                      if (this.id < ut.gid)
                        ct = ht - 1;
                      else if (this.id > ut.gid)
                        ot = ht + 1;
                      else {
                        var Nt = ut;
                        break;
                      }
                    }
                    if (Nt == null) {
                      var Kt = this._font._getBaseGlyph(this.id), de = {
                        red: 0,
                        green: 0,
                        blue: 0,
                        alpha: 255
                      };
                      return [new qc(Kt, de)];
                    }
                    for (var te = [], pe = Nt.firstLayerIndex; pe < Nt.firstLayerIndex + Nt.numLayers; pe++) {
                      var ut = H.layerRecords[pe], de = k.colorRecords[ut.paletteIndex], Kt = this._font._getBaseGlyph(ut.gid);
                      te.push(new qc(Kt, de));
                    }
                    return te;
                  }
                }]), W;
              }(rl), Jm = 32768, Qm = 4095, $m = 32768, td = 16384, qm = 8192, ed = 4095, rd = 128, nd = 127, t4 = 128, e4 = 64, r4 = 63, n4 = /* @__PURE__ */ function() {
                function at($, R) {
                  this.font = $, this.normalizedCoords = this.normalizeCoords(R), this.blendVectors = /* @__PURE__ */ new Map();
                }
                var W = at.prototype;
                return W.normalizeCoords = function(R) {
                  for (var k = [], H = 0; H < this.font.fvar.axis.length; H++) {
                    var ot = this.font.fvar.axis[H];
                    R[H] < ot.defaultValue ? k.push((R[H] - ot.defaultValue + Number.EPSILON) / (ot.defaultValue - ot.minValue + Number.EPSILON)) : k.push((R[H] - ot.defaultValue + Number.EPSILON) / (ot.maxValue - ot.defaultValue + Number.EPSILON));
                  }
                  if (this.font.avar)
                    for (var H = 0; H < this.font.avar.segment.length; H++)
                      for (var ct = this.font.avar.segment[H], ht = 0; ht < ct.correspondence.length; ht++) {
                        var ut = ct.correspondence[ht];
                        if (ht >= 1 && k[H] < ut.fromCoord) {
                          var Nt = ct.correspondence[ht - 1];
                          k[H] = ((k[H] - Nt.fromCoord) * (ut.toCoord - Nt.toCoord) + Number.EPSILON) / (ut.fromCoord - Nt.fromCoord + Number.EPSILON) + Nt.toCoord;
                          break;
                        }
                      }
                  return k;
                }, W.transformPoints = function(R, k) {
                  if (!(!this.font.fvar || !this.font.gvar)) {
                    var H = this.font.gvar;
                    if (!(R >= H.glyphCount)) {
                      var ot = H.offsets[R];
                      if (ot !== H.offsets[R + 1]) {
                        var ct = this.font.stream;
                        if (ct.pos = ot, !(ct.pos >= ct.length)) {
                          var ht = ct.readUInt16BE(), ut = ot + ct.readUInt16BE();
                          if (ht & Jm) {
                            var Nt = ct.pos;
                            ct.pos = ut;
                            var Kt = this.decodePoints();
                            ut = ct.pos, ct.pos = Nt;
                          }
                          var de = k.map(function(pi) {
                            return pi.copy();
                          });
                          ht &= Qm;
                          for (var te = 0; te < ht; te++) {
                            var pe = ct.readUInt16BE(), Ee = ct.readUInt16BE();
                            if (Ee & $m)
                              for (var Le = [], $e = 0; $e < H.axisCount; $e++)
                                Le.push(ct.readInt16BE() / 16384);
                            else {
                              if ((Ee & ed) >= H.globalCoordCount)
                                throw new Error("Invalid gvar table");
                              var Le = H.globalCoords[Ee & ed];
                            }
                            if (Ee & td) {
                              for (var wr = [], or = 0; or < H.axisCount; or++)
                                wr.push(ct.readInt16BE() / 16384);
                              for (var Pr = [], Cr = 0; Cr < H.axisCount; Cr++)
                                Pr.push(ct.readInt16BE() / 16384);
                            }
                            var Dr = this.tupleFactor(Ee, Le, wr, Pr);
                            if (Dr === 0) {
                              ut += pe;
                              continue;
                            }
                            var Nt = ct.pos;
                            if (ct.pos = ut, Ee & qm)
                              var Lr = this.decodePoints();
                            else
                              var Lr = Kt;
                            var yn = Lr.length === 0 ? k.length : Lr.length, On = this.decodeDeltas(yn), hn = this.decodeDeltas(yn);
                            if (Lr.length === 0)
                              for (var Mr = 0; Mr < k.length; Mr++) {
                                var nn = k[Mr];
                                nn.x += Math.round(On[Mr] * Dr), nn.y += Math.round(hn[Mr] * Dr);
                              }
                            else {
                              for (var vn = de.map(function(Ai) {
                                return Ai.copy();
                              }), _n = k.map(function() {
                                return !1;
                              }), kr = 0; kr < Lr.length; kr++) {
                                var an = Lr[kr];
                                if (an < k.length) {
                                  var mn = vn[an];
                                  _n[an] = !0, mn.x += Math.round(On[kr] * Dr), mn.y += Math.round(hn[kr] * Dr);
                                }
                              }
                              this.interpolateMissingDeltas(vn, de, _n);
                              for (var Ur = 0; Ur < k.length; Ur++) {
                                var Un = vn[Ur].x - de[Ur].x, ti = vn[Ur].y - de[Ur].y;
                                k[Ur].x += Un, k[Ur].y += ti;
                              }
                            }
                            ut += pe, ct.pos = Nt;
                          }
                        }
                      }
                    }
                  }
                }, W.decodePoints = function() {
                  var R = this.font.stream, k = R.readUInt8();
                  k & rd && (k = (k & nd) << 8 | R.readUInt8());
                  for (var H = new Uint16Array(k), ot = 0, ct = 0; ot < k; )
                    for (var ht = R.readUInt8(), ut = (ht & nd) + 1, Nt = ht & rd ? R.readUInt16 : R.readUInt8, Kt = 0; Kt < ut && ot < k; Kt++)
                      ct += Nt.call(R), H[ot++] = ct;
                  return H;
                }, W.decodeDeltas = function(R) {
                  for (var k = this.font.stream, H = 0, ot = new Int16Array(R); H < R; ) {
                    var ct = k.readUInt8(), ht = (ct & r4) + 1;
                    if (ct & t4)
                      H += ht;
                    else
                      for (var ut = ct & e4 ? k.readInt16BE : k.readInt8, Nt = 0; Nt < ht && H < R; Nt++)
                        ot[H++] = ut.call(k);
                  }
                  return ot;
                }, W.tupleFactor = function(R, k, H, ot) {
                  for (var ct = this.normalizedCoords, ht = this.font.gvar, ut = 1, Nt = 0; Nt < ht.axisCount; Nt++)
                    if (k[Nt] !== 0) {
                      if (ct[Nt] === 0)
                        return 0;
                      if (R & td) {
                        if (ct[Nt] < H[Nt] || ct[Nt] > ot[Nt])
                          return 0;
                        ct[Nt] < k[Nt] ? ut = ut * (ct[Nt] - H[Nt] + Number.EPSILON) / (k[Nt] - H[Nt] + Number.EPSILON) : ut = ut * (ot[Nt] - ct[Nt] + Number.EPSILON) / (ot[Nt] - k[Nt] + Number.EPSILON);
                      } else {
                        if (ct[Nt] < Math.min(0, k[Nt]) || ct[Nt] > Math.max(0, k[Nt]))
                          return 0;
                        ut = (ut * ct[Nt] + Number.EPSILON) / (k[Nt] + Number.EPSILON);
                      }
                    }
                  return ut;
                }, W.interpolateMissingDeltas = function(R, k, H) {
                  if (R.length !== 0)
                    for (var ot = 0; ot < R.length; ) {
                      for (var ct = ot, ht = ot, ut = R[ht]; !ut.endContour; )
                        ut = R[++ht];
                      for (; ot <= ht && !H[ot]; )
                        ot++;
                      if (!(ot > ht)) {
                        var Nt = ot, Kt = ot;
                        for (ot++; ot <= ht; )
                          H[ot] && (this.deltaInterpolate(Kt + 1, ot - 1, Kt, ot, k, R), Kt = ot), ot++;
                        Kt === Nt ? this.deltaShift(ct, ht, Kt, k, R) : (this.deltaInterpolate(Kt + 1, ht, Kt, Nt, k, R), Nt > 0 && this.deltaInterpolate(ct, Nt - 1, Kt, Nt, k, R)), ot = ht + 1;
                      }
                    }
                }, W.deltaInterpolate = function(R, k, H, ot, ct, ht) {
                  if (!(R > k))
                    for (var ut = ["x", "y"], Nt = 0; Nt < ut.length; Nt++) {
                      var Kt = ut[Nt];
                      if (ct[H][Kt] > ct[ot][Kt]) {
                        var de = H;
                        H = ot, ot = de;
                      }
                      var te = ct[H][Kt], pe = ct[ot][Kt], Ee = ht[H][Kt], Le = ht[ot][Kt];
                      if (te !== pe || Ee === Le)
                        for (var $e = te === pe ? 0 : (Le - Ee) / (pe - te), wr = R; wr <= k; wr++) {
                          var or = ct[wr][Kt];
                          or <= te ? or += Ee - te : or >= pe ? or += Le - pe : or = Ee + (or - te) * $e, ht[wr][Kt] = or;
                        }
                    }
                }, W.deltaShift = function(R, k, H, ot, ct) {
                  var ht = ct[H].x - ot[H].x, ut = ct[H].y - ot[H].y;
                  if (!(ht === 0 && ut === 0))
                    for (var Nt = R; Nt <= k; Nt++)
                      Nt !== H && (ct[Nt].x += ht, ct[Nt].y += ut);
                }, W.getAdvanceAdjustment = function(R, k) {
                  var H, ot;
                  if (k.advanceWidthMapping) {
                    var ct = R;
                    ct >= k.advanceWidthMapping.mapCount && (ct = k.advanceWidthMapping.mapCount - 1), k.advanceWidthMapping.entryFormat;
                    var ht = k.advanceWidthMapping.mapData[ct];
                    H = ht.outerIndex, ot = ht.innerIndex;
                  } else
                    H = 0, ot = R;
                  return this.getDelta(k.itemVariationStore, H, ot);
                }, W.getDelta = function(R, k, H) {
                  if (k >= R.itemVariationData.length)
                    return 0;
                  var ot = R.itemVariationData[k];
                  if (H >= ot.deltaSets.length)
                    return 0;
                  for (var ct = ot.deltaSets[H], ht = this.getBlendVector(R, k), ut = 0, Nt = 0; Nt < ot.regionIndexCount; Nt++)
                    ut += ct.deltas[Nt] * ht[Nt];
                  return ut;
                }, W.getBlendVector = function(R, k) {
                  var H = R.itemVariationData[k];
                  if (this.blendVectors.has(H))
                    return this.blendVectors.get(H);
                  for (var ot = this.normalizedCoords, ct = [], ht = 0; ht < H.regionIndexCount; ht++) {
                    for (var ut = 1, Nt = H.regionIndexes[ht], Kt = R.variationRegionList.variationRegions[Nt], de = 0; de < Kt.length; de++) {
                      var te = Kt[de], pe = void 0;
                      te.startCoord > te.peakCoord || te.peakCoord > te.endCoord || te.startCoord < 0 && te.endCoord > 0 && te.peakCoord !== 0 || te.peakCoord === 0 ? pe = 1 : ot[de] < te.startCoord || ot[de] > te.endCoord ? pe = 0 : ot[de] === te.peakCoord ? pe = 1 : ot[de] < te.peakCoord ? pe = (ot[de] - te.startCoord + Number.EPSILON) / (te.peakCoord - te.startCoord + Number.EPSILON) : pe = (te.endCoord - ot[de] + Number.EPSILON) / (te.endCoord - te.peakCoord + Number.EPSILON), ut *= pe;
                    }
                    ct[ht] = ut;
                  }
                  return this.blendVectors.set(H, ct), ct;
                }, at;
              }(), i4 = Promise.resolve(), id = /* @__PURE__ */ function() {
                function at($) {
                  this.font = $, this.glyphs = [], this.mapping = {}, this.includeGlyph(0);
                }
                var W = at.prototype;
                return W.includeGlyph = function(R) {
                  return typeof R == "object" && (R = R.id), this.mapping[R] == null && (this.glyphs.push(R), this.mapping[R] = this.glyphs.length - 1), this.mapping[R];
                }, W.encodeStream = function() {
                  var R = this, k = new n.EncodeStream();
                  return i4.then(function() {
                    return R.encode(k), k.end();
                  }), k;
                }, at;
              }(), a4 = 1, o4 = 2, s4 = 4, l4 = 8, f4 = 16, u4 = 32, ad = /* @__PURE__ */ function() {
                function at() {
                }
                return at.size = function($) {
                  return $ >= 0 && $ <= 255 ? 1 : 2;
                }, at.encode = function($, R) {
                  R >= 0 && R <= 255 ? $.writeUInt8(R) : $.writeInt16BE(R);
                }, at;
              }(), od = new n.Struct({
                numberOfContours: n.int16,
                // if negative, this is a composite glyph
                xMin: n.int16,
                yMin: n.int16,
                xMax: n.int16,
                yMax: n.int16,
                endPtsOfContours: new n.Array(n.uint16, "numberOfContours"),
                instructions: new n.Array(n.uint8, n.uint16),
                flags: new n.Array(n.uint8, 0),
                xPoints: new n.Array(ad, 0),
                yPoints: new n.Array(ad, 0)
              }), h4 = /* @__PURE__ */ function() {
                function at() {
                }
                var W = at.prototype;
                return W.encodeSimple = function(R, k) {
                  k === void 0 && (k = []);
                  for (var H = [], ot = [], ct = [], ht = [], ut = 0, Nt = 0, Kt = 0, de = 0, te = 0, pe = 0; pe < R.commands.length; pe++) {
                    for (var Ee = R.commands[pe], Le = 0; Le < Ee.args.length; Le += 2) {
                      var $e = Ee.args[Le], wr = Ee.args[Le + 1], or = 0;
                      if (Ee.command === "quadraticCurveTo" && Le === 2) {
                        var Pr = R.commands[pe + 1];
                        if (Pr && Pr.command === "quadraticCurveTo") {
                          var Cr = (Nt + Pr.args[0]) / 2, Dr = (Kt + Pr.args[1]) / 2;
                          if ($e === Cr && wr === Dr)
                            continue;
                        }
                      }
                      Ee.command === "quadraticCurveTo" && Le === 0 || (or |= a4), or = this._encodePoint($e, Nt, ot, or, o4, f4), or = this._encodePoint(wr, Kt, ct, or, s4, u4), or === de && ut < 255 ? (ht[ht.length - 1] |= l4, ut++) : (ut > 0 && (ht.push(ut), ut = 0), ht.push(or), de = or), Nt = $e, Kt = wr, te++;
                    }
                    Ee.command === "closePath" && H.push(te - 1);
                  }
                  R.commands.length > 1 && R.commands[R.commands.length - 1].command !== "closePath" && H.push(te - 1);
                  var Lr = R.bbox, yn = {
                    numberOfContours: H.length,
                    xMin: Lr.minX,
                    yMin: Lr.minY,
                    xMax: Lr.maxX,
                    yMax: Lr.maxY,
                    endPtsOfContours: H,
                    instructions: k,
                    flags: ht,
                    xPoints: ot,
                    yPoints: ct
                  }, On = od.size(yn), hn = 4 - On % 4, Mr = new n.EncodeStream(On + hn);
                  return od.encode(Mr, yn), hn !== 0 && Mr.fill(0, hn), Mr.buffer;
                }, W._encodePoint = function(R, k, H, ot, ct, ht) {
                  var ut = R - k;
                  return R === k ? ot |= ht : (-255 <= ut && ut <= 255 && (ot |= ct, ut < 0 ? ut = -ut : ot |= ht), H.push(ut)), ot;
                }, at;
              }(), c4 = /* @__PURE__ */ function(at) {
                m(W, at);
                function W(R) {
                  var k;
                  return k = at.call(this, R) || this, k.glyphEncoder = new h4(), k;
                }
                var $ = W.prototype;
                return $._addGlyph = function(k) {
                  var H = this.font.getGlyph(k), ot = H._decode(), ct = this.font.loca.offsets[k], ht = this.font.loca.offsets[k + 1], ut = this.font._getTableStream("glyf");
                  ut.pos += ct;
                  var Nt = ut.readBuffer(ht - ct);
                  if (ot && ot.numberOfContours < 0) {
                    Nt = s.from(Nt);
                    for (var Kt = g(ot.components), de; !(de = Kt()).done; ) {
                      var te = de.value;
                      k = this.includeGlyph(te.glyphID), Nt.writeUInt16BE(k, te.pos);
                    }
                  } else
                    ot && this.font._variationProcessor && (Nt = this.glyphEncoder.encodeSimple(H.path, ot.instructions));
                  return this.glyf.push(Nt), this.loca.offsets.push(this.offset), this.hmtx.metrics.push({
                    advance: H.advanceWidth,
                    bearing: H._getMetrics().leftBearing
                  }), this.offset += Nt.length, this.glyf.length - 1;
                }, $.encode = function(k) {
                  this.glyf = [], this.offset = 0, this.loca = {
                    offsets: [],
                    version: this.font.loca.version
                  }, this.hmtx = {
                    metrics: [],
                    bearings: []
                  };
                  for (var H = 0; H < this.glyphs.length; )
                    this._addGlyph(this.glyphs[H++]);
                  var ot = T(this.font.maxp);
                  ot.numGlyphs = this.glyf.length, this.loca.offsets.push(this.offset);
                  var ct = T(this.font.head);
                  ct.indexToLocFormat = this.loca.version;
                  var ht = T(this.font.hhea);
                  ht.numberOfMetrics = this.hmtx.metrics.length, k0.encode(k, {
                    tables: {
                      head: ct,
                      hhea: ht,
                      loca: this.loca,
                      maxp: ot,
                      "cvt ": this.font["cvt "],
                      prep: this.font.prep,
                      glyf: this.glyf,
                      hmtx: this.hmtx,
                      fpgm: this.font.fpgm
                      // name: clone @font.name
                      // 'OS/2': clone @font['OS/2']
                      // post: clone @font.post
                      // cmap: cmap
                    }
                  });
                }, W;
              }(id), d4 = /* @__PURE__ */ function(at) {
                m(W, at);
                function W(R) {
                  var k;
                  if (k = at.call(this, R) || this, k.cff = k.font["CFF "], !k.cff)
                    throw new Error("Not a CFF Font");
                  return k;
                }
                var $ = W.prototype;
                return $.subsetCharstrings = function() {
                  this.charstrings = [];
                  for (var k = {}, H = g(this.glyphs), ot; !(ot = H()).done; ) {
                    var ct = ot.value;
                    this.charstrings.push(this.cff.getCharString(ct));
                    var ht = this.font.getGlyph(ct);
                    ht.path;
                    for (var ut in ht._usedGsubrs)
                      k[ut] = !0;
                  }
                  this.gsubrs = this.subsetSubrs(this.cff.globalSubrIndex, k);
                }, $.subsetSubrs = function(k, H) {
                  for (var ot = [], ct = 0; ct < k.length; ct++) {
                    var ht = k[ct];
                    H[ct] ? (this.cff.stream.pos = ht.offset, ot.push(this.cff.stream.readBuffer(ht.length))) : ot.push(s.from([11]));
                  }
                  return ot;
                }, $.subsetFontdict = function(k) {
                  k.FDArray = [], k.FDSelect = {
                    version: 0,
                    fds: []
                  };
                  for (var H = {}, ot = [], ct = {}, ht = g(this.glyphs), ut; !(ut = ht()).done; ) {
                    var Nt = ut.value, Kt = this.cff.fdForGlyph(Nt);
                    if (Kt != null) {
                      H[Kt] || (k.FDArray.push(Object.assign({}, this.cff.topDict.FDArray[Kt])), ot.push({}), ct[Kt] = k.FDArray.length - 1), H[Kt] = !0, k.FDSelect.fds.push(ct[Kt]);
                      var de = this.font.getGlyph(Nt);
                      de.path;
                      for (var te in de._usedSubrs)
                        ot[ct[Kt]][te] = !0;
                    }
                  }
                  for (var pe = 0; pe < k.FDArray.length; pe++) {
                    var Ee = k.FDArray[pe];
                    delete Ee.FontName, Ee.Private && Ee.Private.Subrs && (Ee.Private = Object.assign({}, Ee.Private), Ee.Private.Subrs = this.subsetSubrs(Ee.Private.Subrs, ot[pe]));
                  }
                }, $.createCIDFontdict = function(k) {
                  for (var H = {}, ot = g(this.glyphs), ct; !(ct = ot()).done; ) {
                    var ht = ct.value, ut = this.font.getGlyph(ht);
                    ut.path;
                    for (var Nt in ut._usedSubrs)
                      H[Nt] = !0;
                  }
                  var Kt = Object.assign({}, this.cff.topDict.Private);
                  return this.cff.topDict.Private && this.cff.topDict.Private.Subrs && (Kt.Subrs = this.subsetSubrs(this.cff.topDict.Private.Subrs, H)), k.FDArray = [{
                    Private: Kt
                  }], k.FDSelect = {
                    version: 3,
                    nRanges: 1,
                    ranges: [{
                      first: 0,
                      fd: 0
                    }],
                    sentinel: this.charstrings.length
                  };
                }, $.addString = function(k) {
                  return k ? (this.strings || (this.strings = []), this.strings.push(k), he.length + this.strings.length - 1) : null;
                }, $.encode = function(k) {
                  this.subsetCharstrings();
                  var H = {
                    version: this.charstrings.length > 255 ? 2 : 1,
                    ranges: [{
                      first: 1,
                      nLeft: this.charstrings.length - 2
                    }]
                  }, ot = Object.assign({}, this.cff.topDict);
                  ot.Private = null, ot.charset = H, ot.Encoding = null, ot.CharStrings = this.charstrings;
                  for (var ct = 0, ht = ["version", "Notice", "Copyright", "FullName", "FamilyName", "Weight", "PostScript", "BaseFontName", "FontName"]; ct < ht.length; ct++) {
                    var ut = ht[ct];
                    ot[ut] = this.addString(this.cff.string(ot[ut]));
                  }
                  ot.ROS = [this.addString("Adobe"), this.addString("Identity"), 0], ot.CIDCount = this.charstrings.length, this.cff.isCIDFont ? this.subsetFontdict(ot) : this.createCIDFontdict(ot);
                  var Nt = {
                    version: 1,
                    hdrSize: this.cff.hdrSize,
                    offSize: 4,
                    header: this.cff.header,
                    nameIndex: [this.cff.postscriptName],
                    topDictIndex: [ot],
                    stringIndex: this.strings,
                    globalSubrIndex: this.gsubrs
                  };
                  we.encode(k, Nt);
                }, W;
              }(id), Ln, co = (Ln = /* @__PURE__ */ function() {
                at.probe = function(R) {
                  var k = R.toString("ascii", 0, 4);
                  return k === "true" || k === "OTTO" || k === String.fromCharCode(0, 1, 0, 0);
                };
                function at($, R) {
                  R === void 0 && (R = null), this.defaultLanguage = null, this.stream = $, this.variationCoords = R, this._directoryPos = this.stream.pos, this._tables = {}, this._glyphs = {}, this._decodeDirectory();
                  for (var k in this.directory.tables) {
                    var H = this.directory.tables[k];
                    Ar[k] && H.length > 0 && Object.defineProperty(this, k, {
                      get: this._getTable.bind(this, H)
                    });
                  }
                }
                var W = at.prototype;
                return W.setDefaultLanguage = function(R) {
                  R === void 0 && (R = null), this.defaultLanguage = R;
                }, W._getTable = function(R) {
                  if (!(R.tag in this._tables))
                    try {
                      this._tables[R.tag] = this._decodeTable(R);
                    } catch (k) {
                      B.logErrors && (console.error("Error decoding table ".concat(R.tag)), console.error(k.stack));
                    }
                  return this._tables[R.tag];
                }, W._getTableStream = function(R) {
                  var k = this.directory.tables[R];
                  return k ? (this.stream.pos = k.offset, this.stream) : null;
                }, W._decodeDirectory = function() {
                  return this.directory = k0.decode(this.stream, {
                    _startOffset: 0
                  });
                }, W._decodeTable = function(R) {
                  var k = this.stream.pos, H = this._getTableStream(R.tag), ot = Ar[R.tag].decode(H, this, R.length);
                  return this.stream.pos = k, ot;
                }, W.getName = function(R, k) {
                  k === void 0 && (k = this.defaultLanguage || B.defaultLanguage);
                  var H = this.name && this.name.records[R];
                  return H && (H[k] || H[this.defaultLanguage] || H[B.defaultLanguage] || H.en || H[Object.keys(H)[0]]) || null;
                }, W.hasGlyphForCodePoint = function(R) {
                  return !!this._cmapProcessor.lookup(R);
                }, W.glyphForCodePoint = function(R) {
                  return this.getGlyph(this._cmapProcessor.lookup(R), [R]);
                }, W.glyphsForString = function(R) {
                  for (var k = [], H = R.length, ot = 0, ct = -1, ht = -1; ot <= H; ) {
                    var ut = 0, Nt = 0;
                    if (ot < H) {
                      if (ut = R.charCodeAt(ot++), 55296 <= ut && ut <= 56319 && ot < H) {
                        var Kt = R.charCodeAt(ot);
                        56320 <= Kt && Kt <= 57343 && (ot++, ut = ((ut & 1023) << 10) + (Kt & 1023) + 65536);
                      }
                      Nt = 65024 <= ut && ut <= 65039 || 917760 <= ut && ut <= 917999 ? 1 : 0;
                    } else
                      ot++;
                    ht === 0 && Nt === 1 ? k.push(this.getGlyph(this._cmapProcessor.lookup(ct, ut), [ct, ut])) : ht === 0 && Nt === 0 && k.push(this.glyphForCodePoint(ct)), ct = ut, ht = Nt;
                  }
                  return k;
                }, W.layout = function(R, k, H, ot, ct) {
                  return this._layoutEngine.layout(R, k, H, ot, ct);
                }, W.stringsForGlyph = function(R) {
                  return this._layoutEngine.stringsForGlyph(R);
                }, W.getAvailableFeatures = function(R, k) {
                  return this._layoutEngine.getAvailableFeatures(R, k);
                }, W._getBaseGlyph = function(R, k) {
                  return k === void 0 && (k = []), this._glyphs[R] || (this.directory.tables.glyf ? this._glyphs[R] = new nl(R, k, this) : (this.directory.tables["CFF "] || this.directory.tables.CFF2) && (this._glyphs[R] = new Xm(R, k, this))), this._glyphs[R] || null;
                }, W.getGlyph = function(R, k) {
                  return k === void 0 && (k = []), this._glyphs[R] || (this.directory.tables.sbix ? this._glyphs[R] = new Zm(R, k, this) : this.directory.tables.COLR && this.directory.tables.CPAL ? this._glyphs[R] = new Km(R, k, this) : this._getBaseGlyph(R, k)), this._glyphs[R] || null;
                }, W.createSubset = function() {
                  return this.directory.tables["CFF "] ? new d4(this) : new c4(this);
                }, W.getVariation = function(R) {
                  if (!(this.directory.tables.fvar && (this.directory.tables.gvar && this.directory.tables.glyf || this.directory.tables.CFF2)))
                    throw new Error("Variations require a font with the fvar, gvar and glyf, or CFF2 tables.");
                  if (typeof R == "string" && (R = this.namedVariations[R]), typeof R != "object")
                    throw new Error("Variation settings must be either a variation name or settings object.");
                  var k = this.fvar.axis.map(function(ct, ht) {
                    var ut = ct.axisTag.trim();
                    return ut in R ? Math.max(ct.minValue, Math.min(ct.maxValue, R[ut])) : ct.defaultValue;
                  }), H = new n.DecodeStream(this.stream.buffer);
                  H.pos = this._directoryPos;
                  var ot = new at(H, k);
                  return ot._tables = this._tables, ot;
                }, W.getFont = function(R) {
                  return this.getVariation(R);
                }, h(at, [{
                  key: "postscriptName",
                  get: function() {
                    return this.getName("postscriptName");
                  }
                  /**
                   * The font's full name, e.g. "Helvetica Bold"
                   * @type {string}
                   */
                }, {
                  key: "fullName",
                  get: function() {
                    return this.getName("fullName");
                  }
                  /**
                   * The font's family name, e.g. "Helvetica"
                   * @type {string}
                   */
                }, {
                  key: "familyName",
                  get: function() {
                    return this.getName("fontFamily");
                  }
                  /**
                   * The font's sub-family, e.g. "Bold".
                   * @type {string}
                   */
                }, {
                  key: "subfamilyName",
                  get: function() {
                    return this.getName("fontSubfamily");
                  }
                  /**
                   * The font's copyright information
                   * @type {string}
                   */
                }, {
                  key: "copyright",
                  get: function() {
                    return this.getName("copyright");
                  }
                  /**
                   * The font's version number
                   * @type {string}
                   */
                }, {
                  key: "version",
                  get: function() {
                    return this.getName("version");
                  }
                  /**
                   * The font’s [ascender](https://en.wikipedia.org/wiki/Ascender_(typography))
                   * @type {number}
                   */
                }, {
                  key: "ascent",
                  get: function() {
                    return this.hhea.ascent;
                  }
                  /**
                   * The font’s [descender](https://en.wikipedia.org/wiki/Descender)
                   * @type {number}
                   */
                }, {
                  key: "descent",
                  get: function() {
                    return this.hhea.descent;
                  }
                  /**
                   * The amount of space that should be included between lines
                   * @type {number}
                   */
                }, {
                  key: "lineGap",
                  get: function() {
                    return this.hhea.lineGap;
                  }
                  /**
                   * The offset from the normal underline position that should be used
                   * @type {number}
                   */
                }, {
                  key: "underlinePosition",
                  get: function() {
                    return this.post.underlinePosition;
                  }
                  /**
                   * The weight of the underline that should be used
                   * @type {number}
                   */
                }, {
                  key: "underlineThickness",
                  get: function() {
                    return this.post.underlineThickness;
                  }
                  /**
                   * If this is an italic font, the angle the cursor should be drawn at to match the font design
                   * @type {number}
                   */
                }, {
                  key: "italicAngle",
                  get: function() {
                    return this.post.italicAngle;
                  }
                  /**
                   * The height of capital letters above the baseline.
                   * See [here](https://en.wikipedia.org/wiki/Cap_height) for more details.
                   * @type {number}
                   */
                }, {
                  key: "capHeight",
                  get: function() {
                    var R = this["OS/2"];
                    return R ? R.capHeight : this.ascent;
                  }
                  /**
                   * The height of lower case letters in the font.
                   * See [here](https://en.wikipedia.org/wiki/X-height) for more details.
                   * @type {number}
                   */
                }, {
                  key: "xHeight",
                  get: function() {
                    var R = this["OS/2"];
                    return R ? R.xHeight : 0;
                  }
                  /**
                   * The number of glyphs in the font.
                   * @type {number}
                   */
                }, {
                  key: "numGlyphs",
                  get: function() {
                    return this.maxp.numGlyphs;
                  }
                  /**
                   * The size of the font’s internal coordinate grid
                   * @type {number}
                   */
                }, {
                  key: "unitsPerEm",
                  get: function() {
                    return this.head.unitsPerEm;
                  }
                  /**
                   * The font’s bounding box, i.e. the box that encloses all glyphs in the font.
                   * @type {BBox}
                   */
                }, {
                  key: "bbox",
                  get: function() {
                    return Object.freeze(new Xo(this.head.xMin, this.head.yMin, this.head.xMax, this.head.yMax));
                  }
                }, {
                  key: "_cmapProcessor",
                  get: function() {
                    return new Wp(this.cmap);
                  }
                  /**
                   * An array of all of the unicode code points supported by the font.
                   * @type {number[]}
                   */
                }, {
                  key: "characterSet",
                  get: function() {
                    return this._cmapProcessor.getCharacterSet();
                  }
                }, {
                  key: "_layoutEngine",
                  get: function() {
                    return new Im(this);
                  }
                }, {
                  key: "availableFeatures",
                  get: function() {
                    return this._layoutEngine.getAvailableFeatures();
                  }
                }, {
                  key: "variationAxes",
                  get: function() {
                    var R = {};
                    if (!this.fvar)
                      return R;
                    for (var k = g(this.fvar.axis), H; !(H = k()).done; ) {
                      var ot = H.value;
                      R[ot.axisTag.trim()] = {
                        name: ot.name.en,
                        min: ot.minValue,
                        default: ot.defaultValue,
                        max: ot.maxValue
                      };
                    }
                    return R;
                  }
                  /**
                   * Returns an object describing the named variation instances
                   * that the font designer has specified. Keys are variation names
                   * and values are the variation settings for this instance.
                   *
                   * @type {object}
                   */
                }, {
                  key: "namedVariations",
                  get: function() {
                    var R = {};
                    if (!this.fvar)
                      return R;
                    for (var k = g(this.fvar.instance), H; !(H = k()).done; ) {
                      for (var ot = H.value, ct = {}, ht = 0; ht < this.fvar.axis.length; ht++) {
                        var ut = this.fvar.axis[ht];
                        ct[ut.axisTag.trim()] = ot.coord[ht];
                      }
                      R[ot.name.en] = ct;
                    }
                    return R;
                  }
                }, {
                  key: "_variationProcessor",
                  get: function() {
                    if (!this.fvar)
                      return null;
                    var R = this.variationCoords;
                    return !R && !this.CFF2 ? null : (R || (R = this.fvar.axis.map(function(k) {
                      return k.defaultValue;
                    })), new n4(this, R));
                  }
                }]), at;
              }(), L(Ln.prototype, "bbox", [J], Object.getOwnPropertyDescriptor(Ln.prototype, "bbox"), Ln.prototype), L(Ln.prototype, "_cmapProcessor", [J], Object.getOwnPropertyDescriptor(Ln.prototype, "_cmapProcessor"), Ln.prototype), L(Ln.prototype, "characterSet", [J], Object.getOwnPropertyDescriptor(Ln.prototype, "characterSet"), Ln.prototype), L(Ln.prototype, "_layoutEngine", [J], Object.getOwnPropertyDescriptor(Ln.prototype, "_layoutEngine"), Ln.prototype), L(Ln.prototype, "variationAxes", [J], Object.getOwnPropertyDescriptor(Ln.prototype, "variationAxes"), Ln.prototype), L(Ln.prototype, "namedVariations", [J], Object.getOwnPropertyDescriptor(Ln.prototype, "namedVariations"), Ln.prototype), L(Ln.prototype, "_variationProcessor", [J], Object.getOwnPropertyDescriptor(Ln.prototype, "_variationProcessor"), Ln.prototype), Ln), v4 = new n.Struct({
                tag: new n.String(4),
                offset: new n.Pointer(n.uint32, "void", {
                  type: "global"
                }),
                compLength: n.uint32,
                length: n.uint32,
                origChecksum: n.uint32
              }), sd = new n.Struct({
                tag: new n.String(4),
                // should be 'wOFF'
                flavor: n.uint32,
                length: n.uint32,
                numTables: n.uint16,
                reserved: new n.Reserved(n.uint16),
                totalSfntSize: n.uint32,
                majorVersion: n.uint16,
                minorVersion: n.uint16,
                metaOffset: n.uint32,
                metaLength: n.uint32,
                metaOrigLength: n.uint32,
                privOffset: n.uint32,
                privLength: n.uint32,
                tables: new n.Array(v4, "numTables")
              });
              sd.process = function() {
                for (var at = {}, W = g(this.tables), $; !($ = W()).done; ) {
                  var R = $.value;
                  at[R.tag] = R;
                }
                this.tables = at;
              };
              var g4 = /* @__PURE__ */ function(at) {
                m(W, at);
                function W() {
                  return at.apply(this, arguments) || this;
                }
                W.probe = function(k) {
                  return k.toString("ascii", 0, 4) === "wOFF";
                };
                var $ = W.prototype;
                return $._decodeDirectory = function() {
                  this.directory = sd.decode(this.stream, {
                    _startOffset: 0
                  });
                }, $._getTableStream = function(k) {
                  var H = this.directory.tables[k];
                  if (H)
                    if (this.stream.pos = H.offset, H.compLength < H.length) {
                      this.stream.pos += 2;
                      var ot = s.alloc(H.length), ct = P(this.stream.readBuffer(H.compLength - 2), ot);
                      return new n.DecodeStream(ct);
                    } else
                      return this.stream;
                  return null;
                }, W;
              }(co), p4 = /* @__PURE__ */ function(at) {
                m(W, at);
                function W() {
                  return at.apply(this, arguments) || this;
                }
                var $ = W.prototype;
                return $._decode = function() {
                  return this._font._transformedGlyphs[this.id];
                }, $._getCBox = function() {
                  return this.path.bbox;
                }, W;
              }(nl), ld = {
                decode: function(W) {
                  for (var $ = 0, R = [0, 1, 2, 3, 4], k = 0; k < R.length; k++) {
                    var H = W.readUInt8();
                    if ($ & 3758096384)
                      throw new Error("Overflow");
                    if ($ = $ << 7 | H & 127, !(H & 128))
                      return $;
                  }
                  throw new Error("Bad base 128 number");
                }
              }, y4 = ["cmap", "head", "hhea", "hmtx", "maxp", "name", "OS/2", "post", "cvt ", "fpgm", "glyf", "loca", "prep", "CFF ", "VORG", "EBDT", "EBLC", "gasp", "hdmx", "kern", "LTSH", "PCLT", "VDMX", "vhea", "vmtx", "BASE", "GDEF", "GPOS", "GSUB", "EBSC", "JSTF", "MATH", "CBDT", "CBLC", "COLR", "CPAL", "SVG ", "sbix", "acnt", "avar", "bdat", "bloc", "bsln", "cvar", "fdsc", "feat", "fmtx", "fvar", "gvar", "hsty", "just", "lcar", "mort", "morx", "opbd", "prop", "trak", "Zapf", "Silf", "Glat", "Gloc", "Feat", "Sill"], m4 = new n.Struct({
                flags: n.uint8,
                customTag: new n.Optional(new n.String(4), function(at) {
                  return (at.flags & 63) === 63;
                }),
                tag: function(W) {
                  return W.customTag || y4[W.flags & 63];
                },
                // || (() => { throw new Error(`Bad tag: ${flags & 0x3f}`); })(); },
                length: ld,
                transformVersion: function(W) {
                  return W.flags >>> 6 & 3;
                },
                transformed: function(W) {
                  return W.tag === "glyf" || W.tag === "loca" ? W.transformVersion === 0 : W.transformVersion !== 0;
                },
                transformLength: new n.Optional(ld, function(at) {
                  return at.transformed;
                })
              }), fd = new n.Struct({
                tag: new n.String(4),
                // should be 'wOF2'
                flavor: n.uint32,
                length: n.uint32,
                numTables: n.uint16,
                reserved: new n.Reserved(n.uint16),
                totalSfntSize: n.uint32,
                totalCompressedSize: n.uint32,
                majorVersion: n.uint16,
                minorVersion: n.uint16,
                metaOffset: n.uint32,
                metaLength: n.uint32,
                metaOrigLength: n.uint32,
                privOffset: n.uint32,
                privLength: n.uint32,
                tables: new n.Array(m4, "numTables")
              });
              fd.process = function() {
                for (var at = {}, W = 0; W < this.tables.length; W++) {
                  var $ = this.tables[W];
                  at[$.tag] = $;
                }
                return this.tables = at;
              };
              var x4 = /* @__PURE__ */ function(at) {
                m(W, at);
                function W() {
                  return at.apply(this, arguments) || this;
                }
                W.probe = function(k) {
                  return k.toString("ascii", 0, 4) === "wOF2";
                };
                var $ = W.prototype;
                return $._decodeDirectory = function() {
                  this.directory = fd.decode(this.stream), this._dataPos = this.stream.pos;
                }, $._decompress = function() {
                  if (!this._decompressed) {
                    this.stream.pos = this._dataPos;
                    var k = this.stream.readBuffer(this.directory.totalCompressedSize), H = 0;
                    for (var ot in this.directory.tables) {
                      var ct = this.directory.tables[ot];
                      ct.offset = H, H += ct.transformLength != null ? ct.transformLength : ct.length;
                    }
                    var ht = I(k, H);
                    if (!ht)
                      throw new Error("Error decoding compressed data in WOFF2");
                    this.stream = new n.DecodeStream(s.from(ht)), this._decompressed = !0;
                  }
                }, $._decodeTable = function(k) {
                  return this._decompress(), at.prototype._decodeTable.call(this, k);
                }, $._getBaseGlyph = function(k, H) {
                  if (H === void 0 && (H = []), !this._glyphs[k])
                    return this.directory.tables.glyf && this.directory.tables.glyf.transformed ? (this._transformedGlyphs || this._transformGlyfTable(), this._glyphs[k] = new p4(k, H, this)) : at.prototype._getBaseGlyph.call(this, k, H);
                }, $._transformGlyfTable = function() {
                  this._decompress(), this.stream.pos = this.directory.tables.glyf.offset;
                  for (var k = b4.decode(this.stream), H = [], ot = 0; ot < k.numGlyphs; ot++) {
                    var ct = {}, ht = k.nContours.readInt16BE();
                    if (ct.numberOfContours = ht, ht > 0) {
                      for (var ut = [], Nt = 0, Kt = 0; Kt < ht; Kt++) {
                        var de = vu(k.nPoints);
                        Nt += de, ut.push(Nt);
                      }
                      ct.points = A4(k.flags, k.glyphs, Nt);
                      for (var te = 0; te < ht; te++)
                        ct.points[ut[te] - 1].endContour = !0;
                      vu(k.glyphs);
                    } else if (ht < 0) {
                      var pe = nl.prototype._decodeComposite.call({
                        _font: this
                      }, ct, k.composites);
                      pe && vu(k.glyphs);
                    }
                    H.push(ct);
                  }
                  this._transformedGlyphs = H;
                }, W;
              }(co), vo = /* @__PURE__ */ function() {
                function at($) {
                  this.length = $, this._buf = new n.Buffer($);
                }
                var W = at.prototype;
                return W.decode = function(R, k) {
                  return new n.DecodeStream(this._buf.decode(R, k));
                }, at;
              }(), b4 = new n.Struct({
                version: n.uint32,
                numGlyphs: n.uint16,
                indexFormat: n.uint16,
                nContourStreamSize: n.uint32,
                nPointsStreamSize: n.uint32,
                flagStreamSize: n.uint32,
                glyphStreamSize: n.uint32,
                compositeStreamSize: n.uint32,
                bboxStreamSize: n.uint32,
                instructionStreamSize: n.uint32,
                nContours: new vo("nContourStreamSize"),
                nPoints: new vo("nPointsStreamSize"),
                flags: new vo("flagStreamSize"),
                glyphs: new vo("glyphStreamSize"),
                composites: new vo("compositeStreamSize"),
                bboxes: new vo("bboxStreamSize"),
                instructions: new vo("instructionStreamSize")
              }), w4 = 253, S4 = 254, E4 = 255, ud = 253;
              function vu(at) {
                var W = at.readUInt8();
                return W === w4 ? at.readUInt16BE() : W === E4 ? at.readUInt8() + ud : W === S4 ? at.readUInt8() + ud * 2 : W;
              }
              function oa(at, W) {
                return at & 1 ? W : -W;
              }
              function A4(at, W, $) {
                for (var R, k = R = 0, H = [], ot = 0; ot < $; ot++) {
                  var ct = 0, ht = 0, ut = at.readUInt8(), Nt = !(ut >> 7);
                  if (ut &= 127, ut < 10)
                    ct = 0, ht = oa(ut, ((ut & 14) << 7) + W.readUInt8());
                  else if (ut < 20)
                    ct = oa(ut, ((ut - 10 & 14) << 7) + W.readUInt8()), ht = 0;
                  else if (ut < 84) {
                    var Kt = ut - 20, de = W.readUInt8();
                    ct = oa(ut, 1 + (Kt & 48) + (de >> 4)), ht = oa(ut >> 1, 1 + ((Kt & 12) << 2) + (de & 15));
                  } else if (ut < 120) {
                    var Kt = ut - 84;
                    ct = oa(ut, 1 + (Kt / 12 << 8) + W.readUInt8()), ht = oa(ut >> 1, 1 + (Kt % 12 >> 2 << 8) + W.readUInt8());
                  } else if (ut < 124) {
                    var de = W.readUInt8(), te = W.readUInt8();
                    ct = oa(ut, (de << 4) + (te >> 4)), ht = oa(ut >> 1, ((te & 15) << 8) + W.readUInt8());
                  } else
                    ct = oa(ut, W.readUInt16BE()), ht = oa(ut >> 1, W.readUInt16BE());
                  k += ct, R += ht, H.push(new wa(Nt, !1, k, R));
                }
                return H;
              }
              var C4 = new n.VersionedStruct(n.uint32, {
                65536: {
                  numFonts: n.uint32,
                  offsets: new n.Array(n.uint32, "numFonts")
                },
                131072: {
                  numFonts: n.uint32,
                  offsets: new n.Array(n.uint32, "numFonts"),
                  dsigTag: n.uint32,
                  dsigLength: n.uint32,
                  dsigOffset: n.uint32
                }
              }), T4 = /* @__PURE__ */ function() {
                at.probe = function(R) {
                  return R.toString("ascii", 0, 4) === "ttcf";
                };
                function at($) {
                  if (this.stream = $, $.readString(4) !== "ttcf")
                    throw new Error("Not a TrueType collection");
                  this.header = C4.decode($);
                }
                var W = at.prototype;
                return W.getFont = function(R) {
                  for (var k = g(this.header.offsets), H; !(H = k()).done; ) {
                    var ot = H.value, ct = new n.DecodeStream(this.stream.buffer);
                    ct.pos = ot;
                    var ht = new co(ct);
                    if (ht.postscriptName === R)
                      return ht;
                  }
                  return null;
                }, h(at, [{
                  key: "fonts",
                  get: function() {
                    for (var R = [], k = g(this.header.offsets), H; !(H = k()).done; ) {
                      var ot = H.value, ct = new n.DecodeStream(this.stream.buffer);
                      ct.pos = ot, R.push(new co(ct));
                    }
                    return R;
                  }
                }]), at;
              }(), P4 = new n.String(n.uint8);
              new n.Struct({
                len: n.uint32,
                buf: new n.Buffer("len")
              });
              var O4 = new n.Struct({
                id: n.uint16,
                nameOffset: n.int16,
                attr: n.uint8,
                dataOffset: n.uint24,
                handle: n.uint32
              }), F4 = new n.Struct({
                name: new n.String(4),
                maxTypeIndex: n.uint16,
                refList: new n.Pointer(n.uint16, new n.Array(O4, function(at) {
                  return at.maxTypeIndex + 1;
                }), {
                  type: "parent"
                })
              }), I4 = new n.Struct({
                length: n.uint16,
                types: new n.Array(F4, function(at) {
                  return at.length + 1;
                })
              }), R4 = new n.Struct({
                reserved: new n.Reserved(n.uint8, 24),
                typeList: new n.Pointer(n.uint16, I4),
                nameListOffset: new n.Pointer(n.uint16, "void")
              }), hd = new n.Struct({
                dataOffset: n.uint32,
                map: new n.Pointer(n.uint32, R4),
                dataLength: n.uint32,
                mapLength: n.uint32
              }), D4 = /* @__PURE__ */ function() {
                at.probe = function(R) {
                  var k = new n.DecodeStream(R);
                  try {
                    var H = hd.decode(k);
                  } catch {
                    return !1;
                  }
                  for (var ot = g(H.map.typeList.types), ct; !(ct = ot()).done; ) {
                    var ht = ct.value;
                    if (ht.name === "sfnt")
                      return !0;
                  }
                  return !1;
                };
                function at($) {
                  this.stream = $, this.header = hd.decode(this.stream);
                  for (var R = g(this.header.map.typeList.types), k; !(k = R()).done; ) {
                    for (var H = k.value, ot = g(H.refList), ct; !(ct = ot()).done; ) {
                      var ht = ct.value;
                      ht.nameOffset >= 0 ? (this.stream.pos = ht.nameOffset + this.header.map.nameListOffset, ht.name = P4.decode(this.stream)) : ht.name = null;
                    }
                    H.name === "sfnt" && (this.sfnt = H);
                  }
                }
                var W = at.prototype;
                return W.getFont = function(R) {
                  if (!this.sfnt)
                    return null;
                  for (var k = g(this.sfnt.refList), H; !(H = k()).done; ) {
                    var ot = H.value, ct = this.header.dataOffset + ot.dataOffset + 4, ht = new n.DecodeStream(this.stream.buffer.slice(ct)), ut = new co(ht);
                    if (ut.postscriptName === R)
                      return ut;
                  }
                  return null;
                }, h(at, [{
                  key: "fonts",
                  get: function() {
                    for (var R = [], k = g(this.sfnt.refList), H; !(H = k()).done; ) {
                      var ot = H.value, ct = this.header.dataOffset + ot.dataOffset + 4, ht = new n.DecodeStream(this.stream.buffer.slice(ct));
                      R.push(new co(ht));
                    }
                    return R;
                  }
                }]), at;
              }();
              B.registerFormat(co), B.registerFormat(g4), B.registerFormat(x4), B.registerFormat(T4), B.registerFormat(D4), u.exports = B;
            }
          ),
          /***/
          19304: (
            /***/
            function(u, l, e) {
              var s = e(41209), i = e(32504), f = e(41783), h = f.BK, v = f.CR, p = f.LF, m = f.NL, x = f.SG, g = f.WJ, S = f.SP, y = f.ZWJ, b = f.BA, n = f.HY, w = f.NS, E = f.AI, A = f.AL, O = f.CJ, C = f.HL, T = f.RI, P = f.SA, I = f.XX, F = e(98282), B = F.DI_BRK, M = F.IN_BRK, z = F.CI_BRK, L = F.CP_BRK;
              F.PR_BRK;
              var J = F.pairTable, ft = i.toByteArray("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"), Q = new s(ft), xt = function(bt) {
                switch (bt) {
                  case E:
                    return A;
                  case P:
                  case x:
                  case I:
                    return A;
                  case O:
                    return w;
                  default:
                    return bt;
                }
              }, St = function(bt) {
                switch (bt) {
                  case p:
                  case m:
                    return h;
                  case S:
                    return g;
                  default:
                    return bt;
                }
              }, Pt = function(bt, Dt) {
                Dt === void 0 && (Dt = !1), this.position = bt, this.required = Dt;
              }, Gt = /* @__PURE__ */ function() {
                function Rt(Dt) {
                  this.string = Dt, this.pos = 0, this.lastPos = 0, this.curClass = null, this.nextClass = null, this.LB8a = !1, this.LB21a = !1, this.LB30a = 0;
                }
                var bt = Rt.prototype;
                return bt.nextCodePoint = function() {
                  var X = this.string.charCodeAt(this.pos++), gt = this.string.charCodeAt(this.pos);
                  return 55296 <= X && X <= 56319 && 56320 <= gt && gt <= 57343 ? (this.pos++, (X - 55296) * 1024 + (gt - 56320) + 65536) : X;
                }, bt.nextCharClass = function() {
                  return xt(Q.get(this.nextCodePoint()));
                }, bt.getSimpleBreak = function() {
                  switch (this.nextClass) {
                    case S:
                      return !1;
                    case h:
                    case p:
                    case m:
                      return this.curClass = h, !1;
                    case v:
                      return this.curClass = v, !1;
                  }
                  return null;
                }, bt.getPairTableBreak = function(X) {
                  var gt = !1;
                  switch (J[this.curClass][this.nextClass]) {
                    case B:
                      gt = !0;
                      break;
                    case M:
                      gt = X === S;
                      break;
                    case z:
                      if (gt = X === S, !gt)
                        return gt = !1, gt;
                      break;
                    case L:
                      if (X !== S)
                        return gt;
                      break;
                  }
                  return this.LB8a && (gt = !1), this.LB21a && (this.curClass === n || this.curClass === b) ? (gt = !1, this.LB21a = !1) : this.LB21a = this.curClass === C, this.curClass === T ? (this.LB30a++, this.LB30a == 2 && this.nextClass === T && (gt = !0, this.LB30a = 0)) : this.LB30a = 0, this.curClass = this.nextClass, gt;
                }, bt.nextBreak = function() {
                  if (this.curClass == null) {
                    var X = this.nextCharClass();
                    this.curClass = St(X), this.nextClass = X, this.LB8a = X === y, this.LB30a = 0;
                  }
                  for (; this.pos < this.string.length; ) {
                    this.lastPos = this.pos;
                    var gt = this.nextClass;
                    if (this.nextClass = this.nextCharClass(), this.curClass === h || this.curClass === v && this.nextClass !== p)
                      return this.curClass = St(xt(this.nextClass)), new Pt(this.lastPos, !0);
                    var st = this.getSimpleBreak();
                    if (st === null && (st = this.getPairTableBreak(gt)), this.LB8a = this.nextClass === y, st)
                      return new Pt(this.lastPos);
                  }
                  return this.lastPos < this.string.length ? (this.lastPos = this.string.length, new Pt(this.string.length)) : null;
                }, Rt;
              }();
              u.exports = Gt;
            }
          ),
          /***/
          50477: (
            /***/
            function() {
            }
          ),
          /***/
          16403: (
            /***/
            function() {
            }
          ),
          /***/
          63779: (
            /***/
            function() {
            }
          ),
          /***/
          77199: (
            /***/
            function() {
            }
          ),
          /***/
          10821: (
            /***/
            function(u, l, e) {
              var s = e(10884), i = typeof globalThis > "u" ? e.g : globalThis;
              u.exports = function() {
                for (var h = [], v = 0; v < s.length; v++)
                  typeof i[s[v]] == "function" && (h[h.length] = s[v]);
                return h;
              };
            }
          ),
          /***/
          24766: (
            /***/
            function(u, l, e) {
              var s = e(32504), i = e(41209);
              function f(st) {
                return st && st.__esModule ? st.default : st;
              }
              function h(st) {
                Object.defineProperty(st, "__esModule", { value: !0, configurable: !0 });
              }
              function v(st, rt, wt, Ft) {
                Object.defineProperty(st, rt, { get: wt, set: Ft, enumerable: !0, configurable: !0 });
              }
              h(u.exports), v(u.exports, "getCategory", () => M), v(u.exports, "getCombiningClass", () => z), v(u.exports, "getScript", () => L), v(u.exports, "getEastAsianWidth", () => J), v(u.exports, "getNumericValue", () => ft), v(u.exports, "isAlphabetic", () => Q), v(u.exports, "isDigit", () => xt), v(u.exports, "isPunctuation", () => St), v(u.exports, "isLowerCase", () => Pt), v(u.exports, "isUpperCase", () => Gt), v(u.exports, "isTitleCase", () => Rt), v(u.exports, "isWhiteSpace", () => bt), v(u.exports, "isBaseForm", () => Dt), v(u.exports, "isMark", () => X), v(u.exports, "default", () => gt);
              var p = {};
              p = JSON.parse('{"categories":["Cc","Zs","Po","Sc","Ps","Pe","Sm","Pd","Nd","Lu","Sk","Pc","Ll","So","Lo","Pi","Cf","No","Pf","Lt","Lm","Mn","Me","Mc","Nl","Zl","Zp","Cs","Co"],"combiningClasses":["Not_Reordered","Above","Above_Right","Below","Attached_Above_Right","Attached_Below","Overlay","Iota_Subscript","Double_Below","Double_Above","Below_Right","Above_Left","CCC10","CCC11","CCC12","CCC13","CCC14","CCC15","CCC16","CCC17","CCC18","CCC19","CCC20","CCC21","CCC22","CCC23","CCC24","CCC25","CCC30","CCC31","CCC32","CCC27","CCC28","CCC29","CCC33","CCC34","CCC35","CCC36","Nukta","Virama","CCC84","CCC91","CCC103","CCC107","CCC118","CCC122","CCC129","CCC130","CCC132","Attached_Above","Below_Left","Left","Kana_Voicing","CCC26","Right"],"scripts":["Common","Latin","Bopomofo","Inherited","Greek","Coptic","Cyrillic","Armenian","Hebrew","Arabic","Syriac","Thaana","Nko","Samaritan","Mandaic","Devanagari","Bengali","Gurmukhi","Gujarati","Oriya","Tamil","Telugu","Kannada","Malayalam","Sinhala","Thai","Lao","Tibetan","Myanmar","Georgian","Hangul","Ethiopic","Cherokee","Canadian_Aboriginal","Ogham","Runic","Tagalog","Hanunoo","Buhid","Tagbanwa","Khmer","Mongolian","Limbu","Tai_Le","New_Tai_Lue","Buginese","Tai_Tham","Balinese","Sundanese","Batak","Lepcha","Ol_Chiki","Braille","Glagolitic","Tifinagh","Han","Hiragana","Katakana","Yi","Lisu","Vai","Bamum","Syloti_Nagri","Phags_Pa","Saurashtra","Kayah_Li","Rejang","Javanese","Cham","Tai_Viet","Meetei_Mayek","null","Linear_B","Lycian","Carian","Old_Italic","Gothic","Old_Permic","Ugaritic","Old_Persian","Deseret","Shavian","Osmanya","Osage","Elbasan","Caucasian_Albanian","Linear_A","Cypriot","Imperial_Aramaic","Palmyrene","Nabataean","Hatran","Phoenician","Lydian","Meroitic_Hieroglyphs","Meroitic_Cursive","Kharoshthi","Old_South_Arabian","Old_North_Arabian","Manichaean","Avestan","Inscriptional_Parthian","Inscriptional_Pahlavi","Psalter_Pahlavi","Old_Turkic","Old_Hungarian","Hanifi_Rohingya","Old_Sogdian","Sogdian","Elymaic","Brahmi","Kaithi","Sora_Sompeng","Chakma","Mahajani","Sharada","Khojki","Multani","Khudawadi","Grantha","Newa","Tirhuta","Siddham","Modi","Takri","Ahom","Dogra","Warang_Citi","Nandinagari","Zanabazar_Square","Soyombo","Pau_Cin_Hau","Bhaiksuki","Marchen","Masaram_Gondi","Gunjala_Gondi","Makasar","Cuneiform","Egyptian_Hieroglyphs","Anatolian_Hieroglyphs","Mro","Bassa_Vah","Pahawh_Hmong","Medefaidrin","Miao","Tangut","Nushu","Duployan","SignWriting","Nyiakeng_Puachue_Hmong","Wancho","Mende_Kikakui","Adlam"],"eaw":["N","Na","A","W","H","F"]}');
              const m = new (f(i))(f(s).toByteArray("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")), x = Math.log2 || ((st) => Math.log(st) / Math.LN2), g = (st) => x(st) + 1 | 0, S = g((/* @__PURE__ */ f(p)).categories.length - 1), y = g((/* @__PURE__ */ f(p)).combiningClasses.length - 1), b = g((/* @__PURE__ */ f(p)).scripts.length - 1), n = g((/* @__PURE__ */ f(p)).eaw.length - 1), w = 10, E = y + b + n + w, A = b + n + w, O = n + w, C = w, T = (1 << S) - 1, P = (1 << y) - 1, I = (1 << b) - 1, F = (1 << n) - 1, B = (1 << w) - 1;
              function M(st) {
                const rt = m.get(st);
                return (/* @__PURE__ */ f(p)).categories[rt >> E & T];
              }
              function z(st) {
                const rt = m.get(st);
                return (/* @__PURE__ */ f(p)).combiningClasses[rt >> A & P];
              }
              function L(st) {
                const rt = m.get(st);
                return (/* @__PURE__ */ f(p)).scripts[rt >> O & I];
              }
              function J(st) {
                const rt = m.get(st);
                return (/* @__PURE__ */ f(p)).eaw[rt >> C & F];
              }
              function ft(st) {
                let rt = m.get(st), wt = rt & B;
                if (wt === 0)
                  return null;
                if (wt <= 50)
                  return wt - 1;
                if (wt < 480) {
                  const Ft = (wt >> 4) - 12, zt = (wt & 15) + 1;
                  return Ft / zt;
                } else if (wt < 768) {
                  rt = (wt >> 5) - 14;
                  let Ft = (wt & 31) + 2;
                  for (; Ft > 0; )
                    rt *= 10, Ft--;
                  return rt;
                } else {
                  rt = (wt >> 2) - 191;
                  let Ft = (wt & 3) + 1;
                  for (; Ft > 0; )
                    rt *= 60, Ft--;
                  return rt;
                }
              }
              function Q(st) {
                const rt = M(st);
                return rt === "Lu" || rt === "Ll" || rt === "Lt" || rt === "Lm" || rt === "Lo" || rt === "Nl";
              }
              function xt(st) {
                return M(st) === "Nd";
              }
              function St(st) {
                const rt = M(st);
                return rt === "Pc" || rt === "Pd" || rt === "Pe" || rt === "Pf" || rt === "Pi" || rt === "Po" || rt === "Ps";
              }
              function Pt(st) {
                return M(st) === "Ll";
              }
              function Gt(st) {
                return M(st) === "Lu";
              }
              function Rt(st) {
                return M(st) === "Lt";
              }
              function bt(st) {
                const rt = M(st);
                return rt === "Zs" || rt === "Zl" || rt === "Zp";
              }
              function Dt(st) {
                const rt = M(st);
                return rt === "Nd" || rt === "No" || rt === "Nl" || rt === "Lu" || rt === "Ll" || rt === "Lt" || rt === "Lm" || rt === "Lo" || rt === "Me" || rt === "Mc";
              }
              function X(st) {
                const rt = M(st);
                return rt === "Mn" || rt === "Me" || rt === "Mc";
              }
              var gt = {
                getCategory: M,
                getCombiningClass: z,
                getScript: L,
                getEastAsianWidth: J,
                getNumericValue: ft,
                isAlphabetic: Q,
                isDigit: xt,
                isPunctuation: St,
                isLowerCase: Pt,
                isUpperCase: Gt,
                isTitleCase: Rt,
                isWhiteSpace: bt,
                isBaseForm: Dt,
                isMark: X
              };
            }
          ),
          /***/
          43267: (
            /***/
            function(u) {
              u.exports = /* @__PURE__ */ JSON.parse('[["8740","䏰䰲䘃䖦䕸𧉧䵷䖳𧲱䳢𧳅㮕䜶䝄䱇䱀𤊿𣘗𧍒𦺋𧃒䱗𪍑䝏䗚䲅𧱬䴇䪤䚡𦬣爥𥩔𡩣𣸆𣽡晍囻"],["8767","綕夝𨮹㷴霴𧯯寛𡵞媤㘥𩺰嫑宷峼杮薓𩥅瑡璝㡵𡵓𣚞𦀡㻬"],["87a1","𥣞㫵竼龗𤅡𨤍𣇪𠪊𣉞䌊蒄龖鐯䤰蘓墖靊鈘秐稲晠権袝瑌篅枂稬剏遆㓦珄𥶹瓆鿇垳䤯呌䄱𣚎堘穲𧭥讏䚮𦺈䆁𥶙箮𢒼鿈𢓁𢓉𢓌鿉蔄𣖻䂴鿊䓡𪷿拁灮鿋"],["8840","㇀",4,"𠄌㇅𠃑𠃍㇆㇇𠃋𡿨㇈𠃊㇉㇊㇋㇌𠄎㇍㇎ĀÁǍÀĒÉĚÈŌÓǑÒ࿿Ê̄Ế࿿Ê̌ỀÊāáǎàɑēéěèīíǐìōóǒòūúǔùǖǘǚ"],["88a1","ǜü࿿ê̄ế࿿ê̌ềêɡ⏚⏛"],["8940","𪎩𡅅"],["8943","攊"],["8946","丽滝鵎釟"],["894c","𧜵撑会伨侨兖兴农凤务动医华发变团声处备夲头学实実岚庆总斉柾栄桥济炼电纤纬纺织经统缆缷艺苏药视设询车轧轮"],["89a1","琑糼緍楆竉刧"],["89ab","醌碸酞肼"],["89b0","贋胶𠧧"],["89b5","肟黇䳍鷉鸌䰾𩷶𧀎鸊𪄳㗁"],["89c1","溚舾甙"],["89c5","䤑马骏龙禇𨑬𡷊𠗐𢫦两亁亀亇亿仫伷㑌侽㹈倃傈㑽㒓㒥円夅凛凼刅争剹劐匧㗇厩㕑厰㕓参吣㕭㕲㚁咓咣咴咹哐哯唘唣唨㖘唿㖥㖿嗗㗅"],["8a40","𧶄唥"],["8a43","𠱂𠴕𥄫喐𢳆㧬𠍁蹆𤶸𩓥䁓𨂾睺𢰸㨴䟕𨅝𦧲𤷪擝𠵼𠾴𠳕𡃴撍蹾𠺖𠰋𠽤𢲩𨉖𤓓"],["8a64","𠵆𩩍𨃩䟴𤺧𢳂骲㩧𩗴㿭㔆𥋇𩟔𧣈𢵄鵮頕"],["8a76","䏙𦂥撴哣𢵌𢯊𡁷㧻𡁯"],["8aa1","𦛚𦜖𧦠擪𥁒𠱃蹨𢆡𨭌𠜱"],["8aac","䠋𠆩㿺塳𢶍"],["8ab2","𤗈𠓼𦂗𠽌𠶖啹䂻䎺"],["8abb","䪴𢩦𡂝膪飵𠶜捹㧾𢝵跀嚡摼㹃"],["8ac9","𪘁𠸉𢫏𢳉"],["8ace","𡃈𣧂㦒㨆𨊛㕸𥹉𢃇噒𠼱𢲲𩜠㒼氽𤸻"],["8adf","𧕴𢺋𢈈𪙛𨳍𠹺𠰴𦠜羓𡃏𢠃𢤹㗻𥇣𠺌𠾍𠺪㾓𠼰𠵇𡅏𠹌"],["8af6","𠺫𠮩𠵈𡃀𡄽㿹𢚖搲𠾭"],["8b40","𣏴𧘹𢯎𠵾𠵿𢱑𢱕㨘𠺘𡃇𠼮𪘲𦭐𨳒𨶙𨳊閪哌苄喹"],["8b55","𩻃鰦骶𧝞𢷮煀腭胬尜𦕲脴㞗卟𨂽醶𠻺𠸏𠹷𠻻㗝𤷫㘉𠳖嚯𢞵𡃉𠸐𠹸𡁸𡅈𨈇𡑕𠹹𤹐𢶤婔𡀝𡀞𡃵𡃶垜𠸑"],["8ba1","𧚔𨋍𠾵𠹻𥅾㜃𠾶𡆀𥋘𪊽𤧚𡠺𤅷𨉼墙剨㘚𥜽箲孨䠀䬬鼧䧧鰟鮍𥭴𣄽嗻㗲嚉丨夂𡯁屮靑𠂆乛亻㔾尣彑忄㣺扌攵歺氵氺灬爫丬犭𤣩罒礻糹罓𦉪㓁"],["8bde","𦍋耂肀𦘒𦥑卝衤见𧢲讠贝钅镸长门𨸏韦页风飞饣𩠐鱼鸟黄歯龜丷𠂇阝户钢"],["8c40","倻淾𩱳龦㷉袏𤅎灷峵䬠𥇍㕙𥴰愢𨨲辧釶熑朙玺𣊁𪄇㲋𡦀䬐磤琂冮𨜏䀉橣𪊺䈣蘏𠩯稪𩥇𨫪靕灍匤𢁾鏴盙𨧣龧矝亣俰傼丯众龨吴綋墒壐𡶶庒庙忂𢜒斋"],["8ca1","𣏹椙橃𣱣泿"],["8ca7","爀𤔅玌㻛𤨓嬕璹讃𥲤𥚕窓篬糃繬苸薗龩袐龪躹龫迏蕟駠鈡龬𨶹𡐿䁱䊢娚"],["8cc9","顨杫䉶圽"],["8cce","藖𤥻芿𧄍䲁𦵴嵻𦬕𦾾龭龮宖龯曧繛湗秊㶈䓃𣉖𢞖䎚䔶"],["8ce6","峕𣬚諹屸㴒𣕑嵸龲煗䕘𤃬𡸣䱷㥸㑊𠆤𦱁諌侴𠈹妿腬顖𩣺弻"],["8d40","𠮟"],["8d42","𢇁𨥭䄂䚻𩁹㼇龳𪆵䃸㟖䛷𦱆䅼𨚲𧏿䕭㣔𥒚䕡䔛䶉䱻䵶䗪㿈𤬏㙡䓞䒽䇭崾嵈嵖㷼㠏嶤嶹㠠㠸幂庽弥徃㤈㤔㤿㥍惗愽峥㦉憷憹懏㦸戬抐拥挘㧸嚱"],["8da1","㨃揢揻搇摚㩋擀崕嘡龟㪗斆㪽旿晓㫲暒㬢朖㭂枤栀㭘桊梄㭲㭱㭻椉楃牜楤榟榅㮼槖㯝橥橴橱檂㯬檙㯲檫檵櫔櫶殁毁毪汵沪㳋洂洆洦涁㳯涤涱渕渘温溆𨧀溻滢滚齿滨滩漤漴㵆𣽁澁澾㵪㵵熷岙㶊瀬㶑灐灔灯灿炉𠌥䏁㗱𠻘"],["8e40","𣻗垾𦻓焾𥟠㙎榢𨯩孴穉𥣡𩓙穥穽𥦬窻窰竂竃燑𦒍䇊竚竝竪䇯咲𥰁笋筕笩𥌎𥳾箢筯莜𥮴𦱿篐萡箒箸𥴠㶭𥱥蒒篺簆簵𥳁籄粃𤢂粦晽𤕸糉糇糦籴糳糵糎"],["8ea1","繧䔝𦹄絝𦻖璍綉綫焵綳緒𤁗𦀩緤㴓緵𡟹緥𨍭縝𦄡𦅚繮纒䌫鑬縧罀罁罇礶𦋐駡羗𦍑羣𡙡𠁨䕜𣝦䔃𨌺翺𦒉者耈耝耨耯𪂇𦳃耻耼聡𢜔䦉𦘦𣷣𦛨朥肧𨩈脇脚墰𢛶汿𦒘𤾸擧𡒊舘𡡞橓𤩥𤪕䑺舩𠬍𦩒𣵾俹𡓽蓢荢𦬊𤦧𣔰𡝳𣷸芪椛芳䇛"],["8f40","蕋苐茚𠸖𡞴㛁𣅽𣕚艻苢茘𣺋𦶣𦬅𦮗𣗎㶿茝嗬莅䔋𦶥莬菁菓㑾𦻔橗蕚㒖𦹂𢻯葘𥯤葱㷓䓤檧葊𣲵祘蒨𦮖𦹷𦹃蓞萏莑䒠蒓蓤𥲑䉀𥳀䕃蔴嫲𦺙䔧蕳䔖枿蘖"],["8fa1","𨘥𨘻藁𧂈蘂𡖂𧃍䕫䕪蘨㙈𡢢号𧎚虾蝱𪃸蟮𢰧螱蟚蠏噡虬桖䘏衅衆𧗠𣶹𧗤衞袜䙛袴袵揁装睷𧜏覇覊覦覩覧覼𨨥觧𧤤𧪽誜瞓釾誐𧩙竩𧬺𣾏䜓𧬸煼謌謟𥐰𥕥謿譌譍誩𤩺讐讛誯𡛟䘕衏貛𧵔𧶏貫㜥𧵓賖𧶘𧶽贒贃𡤐賛灜贑𤳉㻐起"],["9040","趩𨀂𡀔𤦊㭼𨆼𧄌竧躭躶軃鋔輙輭𨍥𨐒辥錃𪊟𠩐辳䤪𨧞𨔽𣶻廸𣉢迹𪀔𨚼𨔁𢌥㦀𦻗逷𨔼𧪾遡𨕬𨘋邨𨜓郄𨛦邮都酧㫰醩釄粬𨤳𡺉鈎沟鉁鉢𥖹銹𨫆𣲛𨬌𥗛"],["90a1","𠴱錬鍫𨫡𨯫炏嫃𨫢𨫥䥥鉄𨯬𨰹𨯿鍳鑛躼閅閦鐦閠濶䊹𢙺𨛘𡉼𣸮䧟氜陻隖䅬隣𦻕懚隶磵𨫠隽双䦡𦲸𠉴𦐐𩂯𩃥𤫑𡤕𣌊霱虂霶䨏䔽䖅𤫩灵孁霛靜𩇕靗孊𩇫靟鐥僐𣂷𣂼鞉鞟鞱鞾韀韒韠𥑬韮琜𩐳響韵𩐝𧥺䫑頴頳顋顦㬎𧅵㵑𠘰𤅜"],["9140","𥜆飊颷飈飇䫿𦴧𡛓喰飡飦飬鍸餹𤨩䭲𩡗𩤅駵騌騻騐驘𥜥㛄𩂱𩯕髠髢𩬅髴䰎鬔鬭𨘀倴鬴𦦨㣃𣁽魐魀𩴾婅𡡣鮎𤉋鰂鯿鰌𩹨鷔𩾷𪆒𪆫𪃡𪄣𪇟鵾鶃𪄴鸎梈"],["91a1","鷄𢅛𪆓𪈠𡤻𪈳鴹𪂹𪊴麐麕麞麢䴴麪麯𤍤黁㭠㧥㴝伲㞾𨰫鼂鼈䮖鐤𦶢鼗鼖鼹嚟嚊齅馸𩂋韲葿齢齩竜龎爖䮾𤥵𤦻煷𤧸𤍈𤩑玞𨯚𡣺禟𨥾𨸶鍩鏳𨩄鋬鎁鏋𨥬𤒹爗㻫睲穃烐𤑳𤏸煾𡟯炣𡢾𣖙㻇𡢅𥐯𡟸㜢𡛻𡠹㛡𡝴𡣑𥽋㜣𡛀坛𤨥𡏾𡊨"],["9240","𡏆𡒶蔃𣚦蔃葕𤦔𧅥𣸱𥕜𣻻𧁒䓴𣛮𩦝𦼦柹㜳㰕㷧塬𡤢栐䁗𣜿𤃡𤂋𤄏𦰡哋嚞𦚱嚒𠿟𠮨𠸍鏆𨬓鎜仸儫㠙𤐶亼𠑥𠍿佋侊𥙑婨𠆫𠏋㦙𠌊𠐔㐵伩𠋀𨺳𠉵諚𠈌亘"],["92a1","働儍侢伃𤨎𣺊佂倮偬傁俌俥偘僼兙兛兝兞湶𣖕𣸹𣺿浲𡢄𣺉冨凃𠗠䓝𠒣𠒒𠒑赺𨪜𠜎剙劤𠡳勡鍮䙺熌𤎌𠰠𤦬𡃤槑𠸝瑹㻞璙琔瑖玘䮎𤪼𤂍叐㖄爏𤃉喴𠍅响𠯆圝鉝雴鍦埝垍坿㘾壋媙𨩆𡛺𡝯𡜐娬妸銏婾嫏娒𥥆𡧳𡡡𤊕㛵洅瑃娡𥺃"],["9340","媁𨯗𠐓鏠璌𡌃焅䥲鐈𨧻鎽㞠尞岞幞幈𡦖𡥼𣫮廍孏𡤃𡤄㜁𡢠㛝𡛾㛓脪𨩇𡶺𣑲𨦨弌弎𡤧𡞫婫𡜻孄蘔𧗽衠恾𢡠𢘫忛㺸𢖯𢖾𩂈𦽳懀𠀾𠁆𢘛憙憘恵𢲛𢴇𤛔𩅍"],["93a1","摱𤙥𢭪㨩𢬢𣑐𩣪𢹸挷𪑛撶挱揑𤧣𢵧护𢲡搻敫楲㯴𣂎𣊭𤦉𣊫唍𣋠𡣙𩐿曎𣊉𣆳㫠䆐𥖄𨬢𥖏𡛼𥕛𥐥磮𣄃𡠪𣈴㑤𣈏𣆂𤋉暎𦴤晫䮓昰𧡰𡷫晣𣋒𣋡昞𥡲㣑𣠺𣞼㮙𣞢𣏾瓐㮖枏𤘪梶栞㯄檾㡣𣟕𤒇樳橒櫉欅𡤒攑梘橌㯗橺歗𣿀𣲚鎠鋲𨯪𨫋"],["9440","銉𨀞𨧜鑧涥漋𤧬浧𣽿㶏渄𤀼娽渊塇洤硂焻𤌚𤉶烱牐犇犔𤞏𤜥兹𤪤𠗫瑺𣻸𣙟𤩊𤤗𥿡㼆㺱𤫟𨰣𣼵悧㻳瓌琼鎇琷䒟𦷪䕑疃㽣𤳙𤴆㽘畕癳𪗆㬙瑨𨫌𤦫𤦎㫻"],["94a1","㷍𤩎㻿𤧅𤣳釺圲鍂𨫣𡡤僟𥈡𥇧睸𣈲眎眏睻𤚗𣞁㩞𤣰琸璛㺿𤪺𤫇䃈𤪖𦆮錇𥖁砞碍碈磒珐祙𧝁𥛣䄎禛蒖禥樭𣻺稺秴䅮𡛦䄲鈵秱𠵌𤦌𠊙𣶺𡝮㖗啫㕰㚪𠇔𠰍竢婙𢛵𥪯𥪜娍𠉛磰娪𥯆竾䇹籝籭䈑𥮳𥺼𥺦糍𤧹𡞰粎籼粮檲緜縇緓罎𦉡"],["9540","𦅜𧭈綗𥺂䉪𦭵𠤖柖𠁎𣗏埄𦐒𦏸𤥢翝笧𠠬𥫩𥵃笌𥸎駦虅驣樜𣐿㧢𤧷𦖭騟𦖠蒀𧄧𦳑䓪脷䐂胆脉腂𦞴飃𦩂艢艥𦩑葓𦶧蘐𧈛媆䅿𡡀嬫𡢡嫤𡣘蚠蜨𣶏蠭𧐢娂"],["95a1","衮佅袇袿裦襥襍𥚃襔𧞅𧞄𨯵𨯙𨮜𨧹㺭蒣䛵䛏㟲訽訜𩑈彍鈫𤊄旔焩烄𡡅鵭貟賩𧷜妚矃姰䍮㛔踪躧𤰉輰轊䋴汘澻𢌡䢛潹溋𡟚鯩㚵𤤯邻邗啱䤆醻鐄𨩋䁢𨫼鐧𨰝𨰻蓥訫閙閧閗閖𨴴瑅㻂𤣿𤩂𤏪㻧𣈥随𨻧𨹦𨹥㻌𤧭𤩸𣿮琒瑫㻼靁𩂰"],["9640","桇䨝𩂓𥟟靝鍨𨦉𨰦𨬯𦎾銺嬑譩䤼珹𤈛鞛靱餸𠼦巁𨯅𤪲頟𩓚鋶𩗗釥䓀𨭐𤩧𨭤飜𨩅㼀鈪䤥萔餻饍𧬆㷽馛䭯馪驜𨭥𥣈檏騡嫾騯𩣱䮐𩥈馼䮽䮗鍽塲𡌂堢𤦸"],["96a1","𡓨硄𢜟𣶸棅㵽鑘㤧慐𢞁𢥫愇鱏鱓鱻鰵鰐魿鯏𩸭鮟𪇵𪃾鴡䲮𤄄鸘䲰鴌𪆴𪃭𪃳𩤯鶥蒽𦸒𦿟𦮂藼䔳𦶤𦺄𦷰萠藮𦸀𣟗𦁤秢𣖜𣙀䤭𤧞㵢鏛銾鍈𠊿碹鉷鑍俤㑀遤𥕝砽硔碶硋𡝗𣇉𤥁㚚佲濚濙瀞瀞吔𤆵垻壳垊鴖埗焴㒯𤆬燫𦱀𤾗嬨𡞵𨩉"],["9740","愌嫎娋䊼𤒈㜬䭻𨧼鎻鎸𡣖𠼝葲𦳀𡐓𤋺𢰦𤏁妔𣶷𦝁綨𦅛𦂤𤦹𤦋𨧺鋥珢㻩璴𨭣𡢟㻡𤪳櫘珳珻㻖𤨾𤪔𡟙𤩦𠎧𡐤𤧥瑈𤤖炥𤥶銄珦鍟𠓾錱𨫎𨨖鎆𨯧𥗕䤵𨪂煫"],["97a1","𤥃𠳿嚤𠘚𠯫𠲸唂秄𡟺緾𡛂𤩐𡡒䔮鐁㜊𨫀𤦭妰𡢿𡢃𧒄媡㛢𣵛㚰鉟婹𨪁𡡢鍴㳍𠪴䪖㦊僴㵩㵌𡎜煵䋻𨈘渏𩃤䓫浗𧹏灧沯㳖𣿭𣸭渂漌㵯𠏵畑㚼㓈䚀㻚䡱姄鉮䤾轁𨰜𦯀堒埈㛖𡑒烾𤍢𤩱𢿣𡊰𢎽梹楧𡎘𣓥𧯴𣛟𨪃𣟖𣏺𤲟樚𣚭𦲷萾䓟䓎"],["9840","𦴦𦵑𦲂𦿞漗𧄉茽𡜺菭𦲀𧁓𡟛妉媂𡞳婡婱𡤅𤇼㜭姯𡜼㛇熎鎐暚𤊥婮娫𤊓樫𣻹𧜶𤑛𤋊焝𤉙𨧡侰𦴨峂𤓎𧹍𤎽樌𤉖𡌄炦焳𤏩㶥泟勇𤩏繥姫崯㷳彜𤩝𡟟綤萦"],["98a1","咅𣫺𣌀𠈔坾𠣕𠘙㿥𡾞𪊶瀃𩅛嵰玏糓𨩙𩐠俈翧狍猐𧫴猸猹𥛶獁獈㺩𧬘遬燵𤣲珡臶㻊県㻑沢国琙琞琟㻢㻰㻴㻺瓓㼎㽓畂畭畲疍㽼痈痜㿀癍㿗癴㿜発𤽜熈嘣覀塩䀝睃䀹条䁅㗛瞘䁪䁯属瞾矋売砘点砜䂨砹硇硑硦葈𥔵礳栃礲䄃"],["9940","䄉禑禙辻稆込䅧窑䆲窼艹䇄竏竛䇏両筢筬筻簒簛䉠䉺类粜䊌粸䊔糭输烀𠳏総緔緐緽羮羴犟䎗耠耥笹耮耱联㷌垴炠肷胩䏭脌猪脎脒畠脔䐁㬹腖腙腚"],["99a1","䐓堺腼膄䐥膓䐭膥埯臁臤艔䒏芦艶苊苘苿䒰荗险榊萅烵葤惣蒈䔄蒾蓡蓸蔐蔸蕒䔻蕯蕰藠䕷虲蚒蚲蛯际螋䘆䘗袮裿褤襇覑𧥧訩訸誔誴豑賔賲贜䞘塟跃䟭仮踺嗘坔蹱嗵躰䠷軎転軤軭軲辷迁迊迌逳駄䢭飠鈓䤞鈨鉘鉫銱銮銿"],["9a40","鋣鋫鋳鋴鋽鍃鎄鎭䥅䥑麿鐗匁鐝鐭鐾䥪鑔鑹锭関䦧间阳䧥枠䨤靀䨵鞲韂噔䫤惨颹䬙飱塄餎餙冴餜餷饂饝饢䭰駅䮝騼鬏窃魩鮁鯝鯱鯴䱭鰠㝯𡯂鵉鰺"],["9aa1","黾噐鶓鶽鷀鷼银辶鹻麬麱麽黆铜黢黱黸竈齄𠂔𠊷𠎠椚铃妬𠓗塀铁㞹𠗕𠘕𠙶𡚺块煳𠫂𠫍𠮿呪吆𠯋咞𠯻𠰻𠱓𠱥𠱼惧𠲍噺𠲵𠳝𠳭𠵯𠶲𠷈楕鰯螥𠸄𠸎𠻗𠾐𠼭𠹳尠𠾼帋𡁜𡁏𡁶朞𡁻𡂈𡂖㙇𡂿𡃓𡄯𡄻卤蒭𡋣𡍵𡌶讁𡕷𡘙𡟃𡟇乸炻𡠭𡥪"],["9b40","𡨭𡩅𡰪𡱰𡲬𡻈拃𡻕𡼕熘桕𢁅槩㛈𢉼𢏗𢏺𢜪𢡱𢥏苽𢥧𢦓𢫕覥𢫨辠𢬎鞸𢬿顇骽𢱌"],["9b62","𢲈𢲷𥯨𢴈𢴒𢶷𢶕𢹂𢽴𢿌𣀳𣁦𣌟𣏞徱晈暿𧩹𣕧𣗳爁𤦺矗𣘚𣜖纇𠍆墵朎"],["9ba1","椘𣪧𧙗𥿢𣸑𣺹𧗾𢂚䣐䪸𤄙𨪚𤋮𤌍𤀻𤌴𤎖𤩅𠗊凒𠘑妟𡺨㮾𣳿𤐄𤓖垈𤙴㦛𤜯𨗨𩧉㝢𢇃譞𨭎駖𤠒𤣻𤨕爉𤫀𠱸奥𤺥𤾆𠝹軚𥀬劏圿煱𥊙𥐙𣽊𤪧喼𥑆𥑮𦭒釔㑳𥔿𧘲𥕞䜘𥕢𥕦𥟇𤤿𥡝偦㓻𣏌惞𥤃䝼𨥈𥪮𥮉𥰆𡶐垡煑澶𦄂𧰒遖𦆲𤾚譢𦐂𦑊"],["9c40","嵛𦯷輶𦒄𡤜諪𤧶𦒈𣿯𦔒䯀𦖿𦚵𢜛鑥𥟡憕娧晉侻嚹𤔡𦛼乪𤤴陖涏𦲽㘘襷𦞙𦡮𦐑𦡞營𦣇筂𩃀𠨑𦤦鄄𦤹穅鷰𦧺騦𦨭㙟𦑩𠀡禃𦨴𦭛崬𣔙菏𦮝䛐𦲤画补𦶮墶"],["9ca1","㜜𢖍𧁋𧇍㱔𧊀𧊅銁𢅺𧊋錰𧋦𤧐氹钟𧑐𠻸蠧裵𢤦𨑳𡞱溸𤨪𡠠㦤㚹尐秣䔿暶𩲭𩢤襃𧟌𧡘囖䃟𡘊㦡𣜯𨃨𡏅熭荦𧧝𩆨婧䲷𧂯𨦫𧧽𧨊𧬋𧵦𤅺筃祾𨀉澵𪋟樃𨌘厢𦸇鎿栶靝𨅯𨀣𦦵𡏭𣈯𨁈嶅𨰰𨂃圕頣𨥉嶫𤦈斾槕叒𤪥𣾁㰑朶𨂐𨃴𨄮𡾡𨅏"],["9d40","𨆉𨆯𨈚𨌆𨌯𨎊㗊𨑨𨚪䣺揦𨥖砈鉕𨦸䏲𨧧䏟𨧨𨭆𨯔姸𨰉輋𨿅𩃬筑𩄐𩄼㷷𩅞𤫊运犏嚋𩓧𩗩𩖰𩖸𩜲𩣑𩥉𩥪𩧃𩨨𩬎𩵚𩶛纟𩻸𩼣䲤镇𪊓熢𪋿䶑递𪗋䶜𠲜达嗁"],["9da1","辺𢒰边𤪓䔉繿潖檱仪㓤𨬬𧢝㜺躀𡟵𨀤𨭬𨮙𧨾𦚯㷫𧙕𣲷𥘵𥥖亚𥺁𦉘嚿𠹭踎孭𣺈𤲞揞拐𡟶𡡻攰嘭𥱊吚𥌑㷆𩶘䱽嘢嘞罉𥻘奵𣵀蝰东𠿪𠵉𣚺脗鵞贘瘻鱅癎瞹鍅吲腈苷嘥脲萘肽嗪祢噃吖𠺝㗎嘅嗱曱𨋢㘭甴嗰喺咗啲𠱁𠲖廐𥅈𠹶𢱢"],["9e40","𠺢麫絚嗞𡁵抝靭咔賍燶酶揼掹揾啩𢭃鱲𢺳冚㓟𠶧冧呍唞唓癦踭𦢊疱肶蠄螆裇膶萜𡃁䓬猄𤜆宐茋𦢓噻𢛴𧴯𤆣𧵳𦻐𧊶酰𡇙鈈𣳼𪚩𠺬𠻹牦𡲢䝎𤿂𧿹𠿫䃺"],["9ea1","鱝攟𢶠䣳𤟠𩵼𠿬𠸊恢𧖣𠿭"],["9ead","𦁈𡆇熣纎鵐业丄㕷嬍沲卧㚬㧜卽㚥𤘘墚𤭮舭呋垪𥪕𠥹"],["9ec5","㩒𢑥獴𩺬䴉鯭𣳾𩼰䱛𤾩𩖞𩿞葜𣶶𧊲𦞳𣜠挮紥𣻷𣸬㨪逈勌㹴㙺䗩𠒎癀嫰𠺶硺𧼮墧䂿噼鮋嵴癔𪐴麅䳡痹㟻愙𣃚𤏲"],["9ef5","噝𡊩垧𤥣𩸆刴𧂮㖭汊鵼"],["9f40","籖鬹埞𡝬屓擓𩓐𦌵𧅤蚭𠴨𦴢𤫢𠵱"],["9f4f","凾𡼏嶎霃𡷑麁遌笟鬂峑箣扨挵髿篏鬪籾鬮籂粆鰕篼鬉鼗鰛𤤾齚啳寃俽麘俲剠㸆勑坧偖妷帒韈鶫轜呩鞴饀鞺匬愰"],["9fa1","椬叚鰊鴂䰻陁榀傦畆𡝭駚剳"],["9fae","酙隁酜"],["9fb2","酑𨺗捿𦴣櫊嘑醎畺抅𠏼獏籰𥰡𣳽"],["9fc1","𤤙盖鮝个𠳔莾衂"],["9fc9","届槀僭坺刟巵从氱𠇲伹咜哚劚趂㗾弌㗳"],["9fdb","歒酼龥鮗頮颴骺麨麄煺笔"],["9fe7","毺蠘罸"],["9feb","嘠𪙊蹷齓"],["9ff0","跔蹏鸜踁抂𨍽踨蹵竓𤩷稾磘泪詧瘇"],["a040","𨩚鼦泎蟖痃𪊲硓咢贌狢獱謭猂瓱賫𤪻蘯徺袠䒷"],["a055","𡠻𦸅"],["a058","詾𢔛"],["a05b","惽癧髗鵄鍮鮏蟵"],["a063","蠏賷猬霡鮰㗖犲䰇籑饊𦅙慙䰄麖慽"],["a073","坟慯抦戹拎㩜懢厪𣏵捤栂㗒"],["a0a1","嵗𨯂迚𨸹"],["a0a6","僙𡵆礆匲阸𠼻䁥"],["a0ae","矾"],["a0b0","糂𥼚糚稭聦聣絍甅瓲覔舚朌聢𧒆聛瓰脃眤覉𦟌畓𦻑螩蟎臈螌詉貭譃眫瓸蓚㘵榲趦"],["a0d4","覩瑨涹蟁𤀑瓧㷛煶悤憜㳑煢恷"],["a0e2","罱𨬭牐惩䭾删㰘𣳇𥻗𧙖𥔱𡥄𡋾𩤃𦷜𧂭峁𦆭𨨏𣙷𠃮𦡆𤼎䕢嬟𦍌齐麦𦉫"],["a3c0","␀",31,"␡"],["c6a1","①",9,"⑴",9,"ⅰ",9,"丶丿亅亠冂冖冫勹匸卩厶夊宀巛⼳广廴彐彡攴无疒癶辵隶¨ˆヽヾゝゞ〃仝々〆〇ー［］✽ぁ",23],["c740","す",58,"ァアィイ"],["c7a1","ゥ",81,"А",5,"ЁЖ",4],["c840","Л",26,"ёж",25,"⇧↸↹㇏𠃌乚𠂊刂䒑"],["c8a1","龰冈龱𧘇"],["c8cd","￢￤＇＂㈱№℡゛゜⺀⺄⺆⺇⺈⺊⺌⺍⺕⺜⺝⺥⺧⺪⺬⺮⺶⺼⺾⻆⻊⻌⻍⻏⻖⻗⻞⻣"],["c8f5","ʃɐɛɔɵœøŋʊɪ"],["f9fe","￭"],["fa40","𠕇鋛𠗟𣿅蕌䊵珯况㙉𤥂𨧤鍄𡧛苮𣳈砼杄拟𤤳𨦪𠊠𦮳𡌅侫𢓭倈𦴩𧪄𣘀𤪱𢔓倩𠍾徤𠎀𠍇滛𠐟偽儁㑺儎顬㝃萖𤦤𠒇兠𣎴兪𠯿𢃼𠋥𢔰𠖎𣈳𡦃宂蝽𠖳𣲙冲冸"],["faa1","鴴凉减凑㳜凓𤪦决凢卂凭菍椾𣜭彻刋刦刼劵剗劔効勅簕蕂勠蘍𦬓包𨫞啉滙𣾀𠥔𣿬匳卄𠯢泋𡜦栛珕恊㺪㣌𡛨燝䒢卭却𨚫卾卿𡖖𡘓矦厓𨪛厠厫厮玧𥝲㽙玜叁叅汉义埾叙㪫𠮏叠𣿫𢶣叶𠱷吓灹唫晗浛呭𦭓𠵴啝咏咤䞦𡜍𠻝㶴𠵍"],["fb40","𨦼𢚘啇䳭启琗喆喩嘅𡣗𤀺䕒𤐵暳𡂴嘷曍𣊊暤暭噍噏磱囱鞇叾圀囯园𨭦㘣𡉏坆𤆥汮炋坂㚱𦱾埦𡐖堃𡑔𤍣堦𤯵塜墪㕡壠壜𡈼壻寿坃𪅐𤉸鏓㖡够梦㛃湙"],["fba1","𡘾娤啓𡚒蔅姉𠵎𦲁𦴪𡟜姙𡟻𡞲𦶦浱𡠨𡛕姹𦹅媫婣㛦𤦩婷㜈媖瑥嫓𦾡𢕔㶅𡤑㜲𡚸広勐孶斈孼𧨎䀄䡝𠈄寕慠𡨴𥧌𠖥寳宝䴐尅𡭄尓珎尔𡲥𦬨屉䣝岅峩峯嶋𡷹𡸷崐崘嵆𡺤岺巗苼㠭𤤁𢁉𢅳芇㠶㯂帮檊幵幺𤒼𠳓厦亷廐厨𡝱帉廴𨒂"],["fc40","廹廻㢠廼栾鐛弍𠇁弢㫞䢮𡌺强𦢈𢏐彘𢑱彣鞽𦹮彲鍀𨨶徧嶶㵟𥉐𡽪𧃸𢙨釖𠊞𨨩怱暅𡡷㥣㷇㘹垐𢞴祱㹀悞悤悳𤦂𤦏𧩓璤僡媠慤萤慂慈𦻒憁凴𠙖憇宪𣾷"],["fca1","𢡟懓𨮝𩥝懐㤲𢦀𢣁怣慜攞掋𠄘担𡝰拕𢸍捬𤧟㨗搸揸𡎎𡟼撐澊𢸶頔𤂌𥜝擡擥鑻㩦携㩗敍漖𤨨𤨣斅敭敟𣁾斵𤥀䬷旑䃘𡠩无旣忟𣐀昘𣇷𣇸晄𣆤𣆥晋𠹵晧𥇦晳晴𡸽𣈱𨗴𣇈𥌓矅𢣷馤朂𤎜𤨡㬫槺𣟂杞杧杢𤇍𩃭柗䓩栢湐鈼栁𣏦𦶠桝"],["fd40","𣑯槡樋𨫟楳棃𣗍椁椀㴲㨁𣘼㮀枬楡𨩊䋼椶榘㮡𠏉荣傐槹𣙙𢄪橅𣜃檝㯳枱櫈𩆜㰍欝𠤣惞欵歴𢟍溵𣫛𠎵𡥘㝀吡𣭚毡𣻼毜氷𢒋𤣱𦭑汚舦汹𣶼䓅𣶽𤆤𤤌𤤀"],["fda1","𣳉㛥㳫𠴲鮃𣇹𢒑羏样𦴥𦶡𦷫涖浜湼漄𤥿𤂅𦹲蔳𦽴凇沜渝萮𨬡港𣸯瑓𣾂秌湏媑𣁋濸㜍澝𣸰滺𡒗𤀽䕕鏰潄潜㵎潴𩅰㴻澟𤅄濓𤂑𤅕𤀹𣿰𣾴𤄿凟𤅖𤅗𤅀𦇝灋灾炧炁烌烕烖烟䄄㷨熴熖𤉷焫煅媈煊煮岜𤍥煏鍢𤋁焬𤑚𤨧𤨢熺𨯨炽爎"],["fe40","鑂爕夑鑃爤鍁𥘅爮牀𤥴梽牕牗㹕𣁄栍漽犂猪猫𤠣𨠫䣭𨠄猨献珏玪𠰺𦨮珉瑉𤇢𡛧𤨤昣㛅𤦷𤦍𤧻珷琕椃𤨦琹𠗃㻗瑜𢢭瑠𨺲瑇珤瑶莹瑬㜰瑴鏱樬璂䥓𤪌"],["fea1","𤅟𤩹𨮏孆𨰃𡢞瓈𡦈甎瓩甞𨻙𡩋寗𨺬鎅畍畊畧畮𤾂㼄𤴓疎瑝疞疴瘂瘬癑癏癯癶𦏵皐臯㟸𦤑𦤎皡皥皷盌𦾟葢𥂝𥅽𡸜眞眦着撯𥈠睘𣊬瞯𨥤𨥨𡛁矴砉𡍶𤨒棊碯磇磓隥礮𥗠磗礴碱𧘌辸袄𨬫𦂃𢘜禆褀椂禀𥡗禝𧬹礼禩渪𧄦㺨秆𩄍秔"]]');
            }
          ),
          /***/
          74488: (
            /***/
            function(u) {
              u.exports = /* @__PURE__ */ JSON.parse('[["0","\\u0000",127,"€"],["8140","丂丄丅丆丏丒丗丟丠両丣並丩丮丯丱丳丵丷丼乀乁乂乄乆乊乑乕乗乚乛乢乣乤乥乧乨乪",5,"乲乴",9,"乿",6,"亇亊"],["8180","亐亖亗亙亜亝亞亣亪亯亰亱亴亶亷亸亹亼亽亾仈仌仏仐仒仚仛仜仠仢仦仧仩仭仮仯仱仴仸仹仺仼仾伀伂",6,"伋伌伒",4,"伜伝伡伣伨伩伬伭伮伱伳伵伷伹伻伾",4,"佄佅佇",5,"佒佔佖佡佢佦佨佪佫佭佮佱佲併佷佸佹佺佽侀侁侂侅來侇侊侌侎侐侒侓侕侖侘侙侚侜侞侟価侢"],["8240","侤侫侭侰",4,"侶",8,"俀俁係俆俇俈俉俋俌俍俒",4,"俙俛俠俢俤俥俧俫俬俰俲俴俵俶俷俹俻俼俽俿",11],["8280","個倎倐們倓倕倖倗倛倝倞倠倢倣値倧倫倯",10,"倻倽倿偀偁偂偄偅偆偉偊偋偍偐",4,"偖偗偘偙偛偝",7,"偦",5,"偭",8,"偸偹偺偼偽傁傂傃傄傆傇傉傊傋傌傎",20,"傤傦傪傫傭",4,"傳",6,"傼"],["8340","傽",17,"僐",5,"僗僘僙僛",10,"僨僩僪僫僯僰僱僲僴僶",4,"僼",9,"儈"],["8380","儉儊儌",5,"儓",13,"儢",28,"兂兇兊兌兎兏児兒兓兗兘兙兛兝",4,"兣兤兦內兩兪兯兲兺兾兿冃冄円冇冊冋冎冏冐冑冓冔冘冚冝冞冟冡冣冦",4,"冭冮冴冸冹冺冾冿凁凂凃凅凈凊凍凎凐凒",5],["8440","凘凙凚凜凞凟凢凣凥",5,"凬凮凱凲凴凷凾刄刅刉刋刌刏刐刓刔刕刜刞刟刡刢刣別刦刧刪刬刯刱刲刴刵刼刾剄",5,"剋剎剏剒剓剕剗剘"],["8480","剙剚剛剝剟剠剢剣剤剦剨剫剬剭剮剰剱剳",9,"剾劀劃",4,"劉",6,"劑劒劔",6,"劜劤劥劦劧劮劯劰労",9,"勀勁勂勄勅勆勈勊勌勍勎勏勑勓勔動勗務",5,"勠勡勢勣勥",10,"勱",7,"勻勼勽匁匂匃匄匇匉匊匋匌匎"],["8540","匑匒匓匔匘匛匜匞匟匢匤匥匧匨匩匫匬匭匯",9,"匼匽區卂卄卆卋卌卍卐協単卙卛卝卥卨卪卬卭卲卶卹卻卼卽卾厀厁厃厇厈厊厎厏"],["8580","厐",4,"厖厗厙厛厜厞厠厡厤厧厪厫厬厭厯",6,"厷厸厹厺厼厽厾叀參",4,"収叏叐叒叓叕叚叜叝叞叡叢叧叴叺叾叿吀吂吅吇吋吔吘吙吚吜吢吤吥吪吰吳吶吷吺吽吿呁呂呄呅呇呉呌呍呎呏呑呚呝",4,"呣呥呧呩",7,"呴呹呺呾呿咁咃咅咇咈咉咊咍咑咓咗咘咜咞咟咠咡"],["8640","咢咥咮咰咲咵咶咷咹咺咼咾哃哅哊哋哖哘哛哠",4,"哫哬哯哰哱哴",5,"哻哾唀唂唃唄唅唈唊",4,"唒唓唕",5,"唜唝唞唟唡唥唦"],["8680","唨唩唫唭唲唴唵唶唸唹唺唻唽啀啂啅啇啈啋",4,"啑啒啓啔啗",4,"啝啞啟啠啢啣啨啩啫啯",5,"啹啺啽啿喅喆喌喍喎喐喒喓喕喖喗喚喛喞喠",6,"喨",8,"喲喴営喸喺喼喿",4,"嗆嗇嗈嗊嗋嗎嗏嗐嗕嗗",4,"嗞嗠嗢嗧嗩嗭嗮嗰嗱嗴嗶嗸",4,"嗿嘂嘃嘄嘅"],["8740","嘆嘇嘊嘋嘍嘐",7,"嘙嘚嘜嘝嘠嘡嘢嘥嘦嘨嘩嘪嘫嘮嘯嘰嘳嘵嘷嘸嘺嘼嘽嘾噀",11,"噏",4,"噕噖噚噛噝",4],["8780","噣噥噦噧噭噮噯噰噲噳噴噵噷噸噹噺噽",7,"嚇",6,"嚐嚑嚒嚔",14,"嚤",10,"嚰",6,"嚸嚹嚺嚻嚽",12,"囋",8,"囕囖囘囙囜団囥",5,"囬囮囯囲図囶囷囸囻囼圀圁圂圅圇國",6],["8840","園",9,"圝圞圠圡圢圤圥圦圧圫圱圲圴",4,"圼圽圿坁坃坄坅坆坈坉坋坒",4,"坘坙坢坣坥坧坬坮坰坱坲坴坵坸坹坺坽坾坿垀"],["8880","垁垇垈垉垊垍",4,"垔",6,"垜垝垞垟垥垨垪垬垯垰垱垳垵垶垷垹",8,"埄",6,"埌埍埐埑埓埖埗埛埜埞埡埢埣埥",7,"埮埰埱埲埳埵埶執埻埼埾埿堁堃堄堅堈堉堊堌堎堏堐堒堓堔堖堗堘堚堛堜堝堟堢堣堥",4,"堫",4,"報堲堳場堶",7],["8940","堾",5,"塅",6,"塎塏塐塒塓塕塖塗塙",4,"塟",5,"塦",4,"塭",16,"塿墂墄墆墇墈墊墋墌"],["8980","墍",4,"墔",4,"墛墜墝墠",7,"墪",17,"墽墾墿壀壂壃壄壆",10,"壒壓壔壖",13,"壥",5,"壭壯壱売壴壵壷壸壺",7,"夃夅夆夈",4,"夎夐夑夒夓夗夘夛夝夞夠夡夢夣夦夨夬夰夲夳夵夶夻"],["8a40","夽夾夿奀奃奅奆奊奌奍奐奒奓奙奛",4,"奡奣奤奦",12,"奵奷奺奻奼奾奿妀妅妉妋妌妎妏妐妑妔妕妘妚妛妜妝妟妠妡妢妦"],["8a80","妧妬妭妰妱妳",5,"妺妼妽妿",6,"姇姈姉姌姍姎姏姕姖姙姛姞",4,"姤姦姧姩姪姫姭",11,"姺姼姽姾娀娂娊娋娍娎娏娐娒娔娕娖娗娙娚娛娝娞娡娢娤娦娧娨娪",6,"娳娵娷",4,"娽娾娿婁",4,"婇婈婋",9,"婖婗婘婙婛",5],["8b40","婡婣婤婥婦婨婩婫",8,"婸婹婻婼婽婾媀",17,"媓",6,"媜",13,"媫媬"],["8b80","媭",4,"媴媶媷媹",4,"媿嫀嫃",5,"嫊嫋嫍",4,"嫓嫕嫗嫙嫚嫛嫝嫞嫟嫢嫤嫥嫧嫨嫪嫬",4,"嫲",22,"嬊",11,"嬘",25,"嬳嬵嬶嬸",7,"孁",6],["8c40","孈",7,"孒孖孞孠孡孧孨孫孭孮孯孲孴孶孷學孹孻孼孾孿宂宆宊宍宎宐宑宒宔宖実宧宨宩宬宭宮宯宱宲宷宺宻宼寀寁寃寈寉寊寋寍寎寏"],["8c80","寑寔",8,"寠寢寣實寧審",4,"寯寱",6,"寽対尀専尃尅將專尋尌對導尐尒尓尗尙尛尞尟尠尡尣尦尨尩尪尫尭尮尯尰尲尳尵尶尷屃屄屆屇屌屍屒屓屔屖屗屘屚屛屜屝屟屢層屧",6,"屰屲",6,"屻屼屽屾岀岃",4,"岉岊岋岎岏岒岓岕岝",4,"岤",4],["8d40","岪岮岯岰岲岴岶岹岺岻岼岾峀峂峃峅",5,"峌",5,"峓",5,"峚",6,"峢峣峧峩峫峬峮峯峱",9,"峼",4],["8d80","崁崄崅崈",5,"崏",4,"崕崗崘崙崚崜崝崟",4,"崥崨崪崫崬崯",4,"崵",7,"崿",7,"嵈嵉嵍",10,"嵙嵚嵜嵞",10,"嵪嵭嵮嵰嵱嵲嵳嵵",12,"嶃",21,"嶚嶛嶜嶞嶟嶠"],["8e40","嶡",21,"嶸",12,"巆",6,"巎",12,"巜巟巠巣巤巪巬巭"],["8e80","巰巵巶巸",4,"巿帀帄帇帉帊帋帍帎帒帓帗帞",7,"帨",4,"帯帰帲",4,"帹帺帾帿幀幁幃幆",5,"幍",6,"幖",4,"幜幝幟幠幣",14,"幵幷幹幾庁庂広庅庈庉庌庍庎庒庘庛庝庡庢庣庤庨",4,"庮",4,"庴庺庻庼庽庿",6],["8f40","廆廇廈廋",5,"廔廕廗廘廙廚廜",11,"廩廫",8,"廵廸廹廻廼廽弅弆弇弉弌弍弎弐弒弔弖弙弚弜弝弞弡弢弣弤"],["8f80","弨弫弬弮弰弲",6,"弻弽弾弿彁",14,"彑彔彙彚彛彜彞彟彠彣彥彧彨彫彮彯彲彴彵彶彸彺彽彾彿徃徆徍徎徏徑従徔徖徚徛徝從徟徠徢",5,"復徫徬徯",5,"徶徸徹徺徻徾",4,"忇忈忊忋忎忓忔忕忚忛応忞忟忢忣忥忦忨忩忬忯忰忲忳忴忶忷忹忺忼怇"],["9040","怈怉怋怌怐怑怓怗怘怚怞怟怢怣怤怬怭怮怰",4,"怶",4,"怽怾恀恄",6,"恌恎恏恑恓恔恖恗恘恛恜恞恟恠恡恥恦恮恱恲恴恵恷恾悀"],["9080","悁悂悅悆悇悈悊悋悎悏悐悑悓悕悗悘悙悜悞悡悢悤悥悧悩悪悮悰悳悵悶悷悹悺悽",7,"惇惈惉惌",4,"惒惓惔惖惗惙惛惞惡",4,"惪惱惲惵惷惸惻",4,"愂愃愄愅愇愊愋愌愐",4,"愖愗愘愙愛愜愝愞愡愢愥愨愩愪愬",18,"慀",6],["9140","慇慉態慍慏慐慒慓慔慖",6,"慞慟慠慡慣慤慥慦慩",6,"慱慲慳慴慶慸",18,"憌憍憏",4,"憕"],["9180","憖",6,"憞",8,"憪憫憭",9,"憸",5,"憿懀懁懃",4,"應懌",4,"懓懕",16,"懧",13,"懶",8,"戀",5,"戇戉戓戔戙戜戝戞戠戣戦戧戨戩戫戭戯戰戱戲戵戶戸",4,"扂扄扅扆扊"],["9240","扏扐払扖扗扙扚扜",6,"扤扥扨扱扲扴扵扷扸扺扻扽抁抂抃抅抆抇抈抋",5,"抔抙抜抝択抣抦抧抩抪抭抮抯抰抲抳抴抶抷抸抺抾拀拁"],["9280","拃拋拏拑拕拝拞拠拡拤拪拫拰拲拵拸拹拺拻挀挃挄挅挆挊挋挌挍挏挐挒挓挔挕挗挘挙挜挦挧挩挬挭挮挰挱挳",5,"挻挼挾挿捀捁捄捇捈捊捑捒捓捔捖",7,"捠捤捥捦捨捪捫捬捯捰捲捳捴捵捸捹捼捽捾捿掁掃掄掅掆掋掍掑掓掔掕掗掙",6,"採掤掦掫掯掱掲掵掶掹掻掽掿揀"],["9340","揁揂揃揅揇揈揊揋揌揑揓揔揕揗",6,"揟揢揤",4,"揫揬揮揯揰揱揳揵揷揹揺揻揼揾搃搄搆",4,"損搎搑搒搕",5,"搝搟搢搣搤"],["9380","搥搧搨搩搫搮",5,"搵",4,"搻搼搾摀摂摃摉摋",6,"摓摕摖摗摙",4,"摟",7,"摨摪摫摬摮",9,"摻",6,"撃撆撈",8,"撓撔撗撘撚撛撜撝撟",4,"撥撦撧撨撪撫撯撱撲撳撴撶撹撻撽撾撿擁擃擄擆",6,"擏擑擓擔擕擖擙據"],["9440","擛擜擝擟擠擡擣擥擧",24,"攁",7,"攊",7,"攓",4,"攙",8],["9480","攢攣攤攦",4,"攬攭攰攱攲攳攷攺攼攽敀",4,"敆敇敊敋敍敎敐敒敓敔敗敘敚敜敟敠敡敤敥敧敨敩敪敭敮敯敱敳敵敶數",14,"斈斉斊斍斎斏斒斔斕斖斘斚斝斞斠斢斣斦斨斪斬斮斱",7,"斺斻斾斿旀旂旇旈旉旊旍旐旑旓旔旕旘",7,"旡旣旤旪旫"],["9540","旲旳旴旵旸旹旻",4,"昁昄昅昇昈昉昋昍昐昑昒昖昗昘昚昛昜昞昡昢昣昤昦昩昪昫昬昮昰昲昳昷",4,"昽昿晀時晄",6,"晍晎晐晑晘"],["9580","晙晛晜晝晞晠晢晣晥晧晩",4,"晱晲晳晵晸晹晻晼晽晿暀暁暃暅暆暈暉暊暋暍暎暏暐暒暓暔暕暘",4,"暞",8,"暩",4,"暯",4,"暵暶暷暸暺暻暼暽暿",25,"曚曞",7,"曧曨曪",5,"曱曵曶書曺曻曽朁朂會"],["9640","朄朅朆朇朌朎朏朑朒朓朖朘朙朚朜朞朠",5,"朧朩朮朰朲朳朶朷朸朹朻朼朾朿杁杄杅杇杊杋杍杒杔杕杗",4,"杝杢杣杤杦杧杫杬杮東杴杶"],["9680","杸杹杺杻杽枀枂枃枅枆枈枊枌枍枎枏枑枒枓枔枖枙枛枟枠枡枤枦枩枬枮枱枲枴枹",7,"柂柅",9,"柕柖柗柛柟柡柣柤柦柧柨柪柫柭柮柲柵",7,"柾栁栂栃栄栆栍栐栒栔栕栘",4,"栞栟栠栢",6,"栫",6,"栴栵栶栺栻栿桇桋桍桏桒桖",5],["9740","桜桝桞桟桪桬",7,"桵桸",8,"梂梄梇",7,"梐梑梒梔梕梖梘",9,"梣梤梥梩梪梫梬梮梱梲梴梶梷梸"],["9780","梹",6,"棁棃",5,"棊棌棎棏棐棑棓棔棖棗棙棛",4,"棡棢棤",9,"棯棲棳棴棶棷棸棻棽棾棿椀椂椃椄椆",4,"椌椏椑椓",11,"椡椢椣椥",7,"椮椯椱椲椳椵椶椷椸椺椻椼椾楀楁楃",16,"楕楖楘楙楛楜楟"],["9840","楡楢楤楥楧楨楩楪楬業楯楰楲",4,"楺楻楽楾楿榁榃榅榊榋榌榎",5,"榖榗榙榚榝",9,"榩榪榬榮榯榰榲榳榵榶榸榹榺榼榽"],["9880","榾榿槀槂",7,"構槍槏槑槒槓槕",5,"槜槝槞槡",11,"槮槯槰槱槳",9,"槾樀",9,"樋",11,"標",5,"樠樢",5,"権樫樬樭樮樰樲樳樴樶",6,"樿",4,"橅橆橈",7,"橑",6,"橚"],["9940","橜",4,"橢橣橤橦",10,"橲",6,"橺橻橽橾橿檁檂檃檅",8,"檏檒",4,"檘",7,"檡",5],["9980","檧檨檪檭",114,"欥欦欨",6],["9a40","欯欰欱欳欴欵欶欸欻欼欽欿歀歁歂歄歅歈歊歋歍",11,"歚",7,"歨歩歫",13,"歺歽歾歿殀殅殈"],["9a80","殌殎殏殐殑殔殕殗殘殙殜",4,"殢",7,"殫",7,"殶殸",6,"毀毃毄毆",4,"毌毎毐毑毘毚毜",4,"毢",7,"毬毭毮毰毱毲毴毶毷毸毺毻毼毾",6,"氈",4,"氎氒気氜氝氞氠氣氥氫氬氭氱氳氶氷氹氺氻氼氾氿汃汄汅汈汋",4,"汑汒汓汖汘"],["9b40","汙汚汢汣汥汦汧汫",4,"汱汳汵汷汸決汻汼汿沀沄沇沊沋沍沎沑沒沕沖沗沘沚沜沝沞沠沢沨沬沯沰沴沵沶沷沺泀況泂泃泆泇泈泋泍泎泏泑泒泘"],["9b80","泙泚泜泝泟泤泦泧泩泬泭泲泴泹泿洀洂洃洅洆洈洉洊洍洏洐洑洓洔洕洖洘洜洝洟",5,"洦洨洩洬洭洯洰洴洶洷洸洺洿浀浂浄浉浌浐浕浖浗浘浛浝浟浡浢浤浥浧浨浫浬浭浰浱浲浳浵浶浹浺浻浽",4,"涃涄涆涇涊涋涍涏涐涒涖",4,"涜涢涥涬涭涰涱涳涴涶涷涹",5,"淁淂淃淈淉淊"],["9c40","淍淎淏淐淒淓淔淕淗淚淛淜淟淢淣淥淧淨淩淪淭淯淰淲淴淵淶淸淺淽",7,"渆渇済渉渋渏渒渓渕渘渙減渜渞渟渢渦渧渨渪測渮渰渱渳渵"],["9c80","渶渷渹渻",7,"湅",7,"湏湐湑湒湕湗湙湚湜湝湞湠",10,"湬湭湯",14,"満溁溂溄溇溈溊",4,"溑",6,"溙溚溛溝溞溠溡溣溤溦溨溩溫溬溭溮溰溳溵溸溹溼溾溿滀滃滄滅滆滈滉滊滌滍滎滐滒滖滘滙滛滜滝滣滧滪",5],["9d40","滰滱滲滳滵滶滷滸滺",7,"漃漄漅漇漈漊",4,"漐漑漒漖",9,"漡漢漣漥漦漧漨漬漮漰漲漴漵漷",6,"漿潀潁潂"],["9d80","潃潄潅潈潉潊潌潎",9,"潙潚潛潝潟潠潡潣潤潥潧",5,"潯潰潱潳潵潶潷潹潻潽",6,"澅澆澇澊澋澏",12,"澝澞澟澠澢",4,"澨",10,"澴澵澷澸澺",5,"濁濃",5,"濊",6,"濓",10,"濟濢濣濤濥"],["9e40","濦",7,"濰",32,"瀒",7,"瀜",6,"瀤",6],["9e80","瀫",9,"瀶瀷瀸瀺",17,"灍灎灐",13,"灟",11,"灮灱灲灳灴灷灹灺灻災炁炂炃炄炆炇炈炋炌炍炏炐炑炓炗炘炚炛炞",12,"炰炲炴炵炶為炾炿烄烅烆烇烉烋",12,"烚"],["9f40","烜烝烞烠烡烢烣烥烪烮烰",6,"烸烺烻烼烾",10,"焋",4,"焑焒焔焗焛",10,"焧",7,"焲焳焴"],["9f80","焵焷",13,"煆煇煈煉煋煍煏",12,"煝煟",4,"煥煩",4,"煯煰煱煴煵煶煷煹煻煼煾",5,"熅",4,"熋熌熍熎熐熑熒熓熕熖熗熚",4,"熡",6,"熩熪熫熭",5,"熴熶熷熸熺",8,"燄",9,"燏",4],["a040","燖",9,"燡燢燣燤燦燨",5,"燯",9,"燺",11,"爇",19],["a080","爛爜爞",9,"爩爫爭爮爯爲爳爴爺爼爾牀",6,"牉牊牋牎牏牐牑牓牔牕牗牘牚牜牞牠牣牤牥牨牪牫牬牭牰牱牳牴牶牷牸牻牼牽犂犃犅",4,"犌犎犐犑犓",11,"犠",11,"犮犱犲犳犵犺",6,"狅狆狇狉狊狋狌狏狑狓狔狕狖狘狚狛"],["a1a1","　、。·ˉˇ¨〃々—～‖…‘’“”〔〕〈",7,"〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓"],["a2a1","ⅰ",9],["a2b1","⒈",19,"⑴",19,"①",9],["a2e5","㈠",9],["a2f1","Ⅰ",11],["a3a1","！＂＃￥％",88,"￣"],["a4a1","ぁ",82],["a5a1","ァ",85],["a6a1","Α",16,"Σ",6],["a6c1","α",16,"σ",6],["a6e0","︵︶︹︺︿﹀︽︾﹁﹂﹃﹄"],["a6ee","︻︼︷︸︱"],["a6f4","︳︴"],["a7a1","А",5,"ЁЖ",25],["a7d1","а",5,"ёж",25],["a840","ˊˋ˙–―‥‵℅℉↖↗↘↙∕∟∣≒≦≧⊿═",35,"▁",6],["a880","█",7,"▓▔▕▼▽◢◣◤◥☉⊕〒〝〞"],["a8a1","āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüêɑ"],["a8bd","ńň"],["a8c0","ɡ"],["a8c5","ㄅ",36],["a940","〡",8,"㊣㎎㎏㎜㎝㎞㎡㏄㏎㏑㏒㏕︰￢￤"],["a959","℡㈱"],["a95c","‐"],["a960","ー゛゜ヽヾ〆ゝゞ﹉",9,"﹔﹕﹖﹗﹙",8],["a980","﹢",4,"﹨﹩﹪﹫"],["a996","〇"],["a9a4","─",75],["aa40","狜狝狟狢",5,"狪狫狵狶狹狽狾狿猀猂猄",5,"猋猌猍猏猐猑猒猔猘猙猚猟猠猣猤猦猧猨猭猯猰猲猳猵猶猺猻猼猽獀",8],["aa80","獉獊獋獌獎獏獑獓獔獕獖獘",7,"獡",10,"獮獰獱"],["ab40","獲",11,"獿",4,"玅玆玈玊玌玍玏玐玒玓玔玕玗玘玙玚玜玝玞玠玡玣",5,"玪玬玭玱玴玵玶玸玹玼玽玾玿珁珃",4],["ab80","珋珌珎珒",6,"珚珛珜珝珟珡珢珣珤珦珨珪珫珬珮珯珰珱珳",4],["ac40","珸",10,"琄琇琈琋琌琍琎琑",8,"琜",5,"琣琤琧琩琫琭琯琱琲琷",4,"琽琾琿瑀瑂",11],["ac80","瑎",6,"瑖瑘瑝瑠",12,"瑮瑯瑱",4,"瑸瑹瑺"],["ad40","瑻瑼瑽瑿璂璄璅璆璈璉璊璌璍璏璑",10,"璝璟",7,"璪",15,"璻",12],["ad80","瓈",9,"瓓",8,"瓝瓟瓡瓥瓧",6,"瓰瓱瓲"],["ae40","瓳瓵瓸",6,"甀甁甂甃甅",7,"甎甐甒甔甕甖甗甛甝甞甠",4,"甦甧甪甮甴甶甹甼甽甿畁畂畃畄畆畇畉畊畍畐畑畒畓畕畖畗畘"],["ae80","畝",7,"畧畨畩畫",6,"畳畵當畷畺",4,"疀疁疂疄疅疇"],["af40","疈疉疊疌疍疎疐疓疕疘疛疜疞疢疦",4,"疭疶疷疺疻疿痀痁痆痋痌痎痏痐痑痓痗痙痚痜痝痟痠痡痥痩痬痭痮痯痲痳痵痶痷痸痺痻痽痾瘂瘄瘆瘇"],["af80","瘈瘉瘋瘍瘎瘏瘑瘒瘓瘔瘖瘚瘜瘝瘞瘡瘣瘧瘨瘬瘮瘯瘱瘲瘶瘷瘹瘺瘻瘽癁療癄"],["b040","癅",6,"癎",5,"癕癗",4,"癝癟癠癡癢癤",6,"癬癭癮癰",7,"癹発發癿皀皁皃皅皉皊皌皍皏皐皒皔皕皗皘皚皛"],["b080","皜",7,"皥",8,"皯皰皳皵",9,"盀盁盃啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥"],["b140","盄盇盉盋盌盓盕盙盚盜盝盞盠",4,"盦",7,"盰盳盵盶盷盺盻盽盿眀眂眃眅眆眊県眎",10,"眛眜眝眞眡眣眤眥眧眪眫"],["b180","眬眮眰",4,"眹眻眽眾眿睂睄睅睆睈",7,"睒",7,"睜薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳"],["b240","睝睞睟睠睤睧睩睪睭",11,"睺睻睼瞁瞂瞃瞆",5,"瞏瞐瞓",11,"瞡瞣瞤瞦瞨瞫瞭瞮瞯瞱瞲瞴瞶",4],["b280","瞼瞾矀",12,"矎",8,"矘矙矚矝",4,"矤病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖"],["b340","矦矨矪矯矰矱矲矴矵矷矹矺矻矼砃",5,"砊砋砎砏砐砓砕砙砛砞砠砡砢砤砨砪砫砮砯砱砲砳砵砶砽砿硁硂硃硄硆硈硉硊硋硍硏硑硓硔硘硙硚"],["b380","硛硜硞",11,"硯",7,"硸硹硺硻硽",6,"场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚"],["b440","碄碅碆碈碊碋碏碐碒碔碕碖碙碝碞碠碢碤碦碨",7,"碵碶碷碸確碻碼碽碿磀磂磃磄磆磇磈磌磍磎磏磑磒磓磖磗磘磚",9],["b480","磤磥磦磧磩磪磫磭",4,"磳磵磶磸磹磻",5,"礂礃礄礆",6,"础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮"],["b540","礍",5,"礔",9,"礟",4,"礥",14,"礵",4,"礽礿祂祃祄祅祇祊",8,"祔祕祘祙祡祣"],["b580","祤祦祩祪祫祬祮祰",6,"祹祻",4,"禂禃禆禇禈禉禋禌禍禎禐禑禒怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠"],["b640","禓",6,"禛",11,"禨",10,"禴",4,"禼禿秂秄秅秇秈秊秌秎秏秐秓秔秖秗秙",5,"秠秡秢秥秨秪"],["b680","秬秮秱",6,"秹秺秼秾秿稁稄稅稇稈稉稊稌稏",4,"稕稖稘稙稛稜丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二"],["b740","稝稟稡稢稤",14,"稴稵稶稸稺稾穀",5,"穇",9,"穒",4,"穘",16],["b780","穩",6,"穱穲穳穵穻穼穽穾窂窅窇窉窊窋窌窎窏窐窓窔窙窚窛窞窡窢贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服"],["b840","窣窤窧窩窪窫窮",4,"窴",10,"竀",10,"竌",9,"竗竘竚竛竜竝竡竢竤竧",5,"竮竰竱竲竳"],["b880","竴",4,"竻竼竾笀笁笂笅笇笉笌笍笎笐笒笓笖笗笘笚笜笝笟笡笢笣笧笩笭浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹"],["b940","笯笰笲笴笵笶笷笹笻笽笿",5,"筆筈筊筍筎筓筕筗筙筜筞筟筡筣",10,"筯筰筳筴筶筸筺筼筽筿箁箂箃箄箆",6,"箎箏"],["b980","箑箒箓箖箘箙箚箛箞箟箠箣箤箥箮箯箰箲箳箵箶箷箹",7,"篂篃範埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈"],["ba40","篅篈築篊篋篍篎篏篐篒篔",4,"篛篜篞篟篠篢篣篤篧篨篩篫篬篭篯篰篲",4,"篸篹篺篻篽篿",7,"簈簉簊簍簎簐",5,"簗簘簙"],["ba80","簚",4,"簠",5,"簨簩簫",12,"簹",5,"籂骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖"],["bb40","籃",9,"籎",36,"籵",5,"籾",9],["bb80","粈粊",6,"粓粔粖粙粚粛粠粡粣粦粧粨粩粫粬粭粯粰粴",4,"粺粻弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕"],["bc40","粿糀糂糃糄糆糉糋糎",6,"糘糚糛糝糞糡",6,"糩",5,"糰",7,"糹糺糼",13,"紋",5],["bc80","紑",14,"紡紣紤紥紦紨紩紪紬紭紮細",6,"肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件"],["bd40","紷",54,"絯",7],["bd80","絸",32,"健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸"],["be40","継",12,"綧",6,"綯",42],["be80","線",32,"尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻"],["bf40","緻",62],["bf80","縺縼",4,"繂",4,"繈",21,"俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀"],["c040","繞",35,"纃",23,"纜纝纞"],["c080","纮纴纻纼绖绤绬绹缊缐缞缷缹缻",6,"罃罆",9,"罒罓馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐"],["c140","罖罙罛罜罝罞罠罣",4,"罫罬罭罯罰罳罵罶罷罸罺罻罼罽罿羀羂",7,"羋羍羏",4,"羕",4,"羛羜羠羢羣羥羦羨",6,"羱"],["c180","羳",4,"羺羻羾翀翂翃翄翆翇翈翉翋翍翏",4,"翖翗翙",5,"翢翣痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿"],["c240","翤翧翨翪翫翬翭翯翲翴",6,"翽翾翿耂耇耈耉耊耎耏耑耓耚耛耝耞耟耡耣耤耫",5,"耲耴耹耺耼耾聀聁聄聅聇聈聉聎聏聐聑聓聕聖聗"],["c280","聙聛",13,"聫",5,"聲",11,"隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫"],["c340","聾肁肂肅肈肊肍",5,"肔肕肗肙肞肣肦肧肨肬肰肳肵肶肸肹肻胅胇",4,"胏",6,"胘胟胠胢胣胦胮胵胷胹胻胾胿脀脁脃脄脅脇脈脋"],["c380","脌脕脗脙脛脜脝脟",12,"脭脮脰脳脴脵脷脹",4,"脿谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸"],["c440","腀",5,"腇腉腍腎腏腒腖腗腘腛",4,"腡腢腣腤腦腨腪腫腬腯腲腳腵腶腷腸膁膃",4,"膉膋膌膍膎膐膒",5,"膙膚膞",4,"膤膥"],["c480","膧膩膫",7,"膴",5,"膼膽膾膿臄臅臇臈臉臋臍",6,"摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁"],["c540","臔",14,"臤臥臦臨臩臫臮",4,"臵",5,"臽臿舃與",4,"舎舏舑舓舕",5,"舝舠舤舥舦舧舩舮舲舺舼舽舿"],["c580","艀艁艂艃艅艆艈艊艌艍艎艐",7,"艙艛艜艝艞艠",7,"艩拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗"],["c640","艪艫艬艭艱艵艶艷艸艻艼芀芁芃芅芆芇芉芌芐芓芔芕芖芚芛芞芠芢芣芧芲芵芶芺芻芼芿苀苂苃苅苆苉苐苖苙苚苝苢苧苨苩苪苬苭苮苰苲苳苵苶苸"],["c680","苺苼",4,"茊茋茍茐茒茓茖茘茙茝",9,"茩茪茮茰茲茷茻茽啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐"],["c740","茾茿荁荂荄荅荈荊",4,"荓荕",4,"荝荢荰",6,"荹荺荾",6,"莇莈莊莋莌莍莏莐莑莔莕莖莗莙莚莝莟莡",6,"莬莭莮"],["c780","莯莵莻莾莿菂菃菄菆菈菉菋菍菎菐菑菒菓菕菗菙菚菛菞菢菣菤菦菧菨菫菬菭恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠"],["c840","菮華菳",4,"菺菻菼菾菿萀萂萅萇萈萉萊萐萒",5,"萙萚萛萞",5,"萩",7,"萲",5,"萹萺萻萾",7,"葇葈葉"],["c880","葊",6,"葒",4,"葘葝葞葟葠葢葤",4,"葪葮葯葰葲葴葷葹葻葼取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁"],["c940","葽",4,"蒃蒄蒅蒆蒊蒍蒏",7,"蒘蒚蒛蒝蒞蒟蒠蒢",12,"蒰蒱蒳蒵蒶蒷蒻蒼蒾蓀蓂蓃蓅蓆蓇蓈蓋蓌蓎蓏蓒蓔蓕蓗"],["c980","蓘",4,"蓞蓡蓢蓤蓧",4,"蓭蓮蓯蓱",10,"蓽蓾蔀蔁蔂伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳"],["ca40","蔃",8,"蔍蔎蔏蔐蔒蔔蔕蔖蔘蔙蔛蔜蔝蔞蔠蔢",8,"蔭",9,"蔾",4,"蕄蕅蕆蕇蕋",10],["ca80","蕗蕘蕚蕛蕜蕝蕟",4,"蕥蕦蕧蕩",8,"蕳蕵蕶蕷蕸蕼蕽蕿薀薁省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱"],["cb40","薂薃薆薈",6,"薐",10,"薝",6,"薥薦薧薩薫薬薭薱",5,"薸薺",6,"藂",6,"藊",4,"藑藒"],["cb80","藔藖",5,"藝",6,"藥藦藧藨藪",14,"恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔"],["cc40","藹藺藼藽藾蘀",4,"蘆",10,"蘒蘓蘔蘕蘗",15,"蘨蘪",13,"蘹蘺蘻蘽蘾蘿虀"],["cc80","虁",11,"虒虓處",4,"虛虜虝號虠虡虣",7,"獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃"],["cd40","虭虯虰虲",6,"蚃",6,"蚎",4,"蚔蚖",5,"蚞",4,"蚥蚦蚫蚭蚮蚲蚳蚷蚸蚹蚻",4,"蛁蛂蛃蛅蛈蛌蛍蛒蛓蛕蛖蛗蛚蛜"],["cd80","蛝蛠蛡蛢蛣蛥蛦蛧蛨蛪蛫蛬蛯蛵蛶蛷蛺蛻蛼蛽蛿蜁蜄蜅蜆蜋蜌蜎蜏蜐蜑蜔蜖汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威"],["ce40","蜙蜛蜝蜟蜠蜤蜦蜧蜨蜪蜫蜬蜭蜯蜰蜲蜳蜵蜶蜸蜹蜺蜼蜽蝀",6,"蝊蝋蝍蝏蝐蝑蝒蝔蝕蝖蝘蝚",5,"蝡蝢蝦",7,"蝯蝱蝲蝳蝵"],["ce80","蝷蝸蝹蝺蝿螀螁螄螆螇螉螊螌螎",4,"螔螕螖螘",6,"螠",4,"巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺"],["cf40","螥螦螧螩螪螮螰螱螲螴螶螷螸螹螻螼螾螿蟁",4,"蟇蟈蟉蟌",4,"蟔",6,"蟜蟝蟞蟟蟡蟢蟣蟤蟦蟧蟨蟩蟫蟬蟭蟯",9],["cf80","蟺蟻蟼蟽蟿蠀蠁蠂蠄",5,"蠋",7,"蠔蠗蠘蠙蠚蠜",4,"蠣稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓"],["d040","蠤",13,"蠳",5,"蠺蠻蠽蠾蠿衁衂衃衆",5,"衎",5,"衕衖衘衚",6,"衦衧衪衭衯衱衳衴衵衶衸衹衺"],["d080","衻衼袀袃袆袇袉袊袌袎袏袐袑袓袔袕袗",4,"袝",4,"袣袥",5,"小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄"],["d140","袬袮袯袰袲",4,"袸袹袺袻袽袾袿裀裃裄裇裈裊裋裌裍裏裐裑裓裖裗裚",4,"裠裡裦裧裩",6,"裲裵裶裷裺裻製裿褀褁褃",5],["d180","褉褋",4,"褑褔",4,"褜",4,"褢褣褤褦褧褨褩褬褭褮褯褱褲褳褵褷选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶"],["d240","褸",8,"襂襃襅",24,"襠",5,"襧",19,"襼"],["d280","襽襾覀覂覄覅覇",26,"摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐"],["d340","覢",30,"觃觍觓觔觕觗觘觙觛觝觟觠觡觢觤觧觨觩觪觬觭觮觰觱觲觴",6],["d380","觻",4,"訁",5,"計",21,"印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉"],["d440","訞",31,"訿",8,"詉",21],["d480","詟",25,"詺",6,"浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧"],["d540","誁",7,"誋",7,"誔",46],["d580","諃",32,"铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政"],["d640","諤",34,"謈",27],["d680","謤謥謧",30,"帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑"],["d740","譆",31,"譧",4,"譭",25],["d780","讇",24,"讬讱讻诇诐诪谉谞住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座"],["d840","谸",8,"豂豃豄豅豈豊豋豍",7,"豖豗豘豙豛",5,"豣",6,"豬",6,"豴豵豶豷豻",6,"貃貄貆貇"],["d880","貈貋貍",6,"貕貖貗貙",20,"亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝"],["d940","貮",62],["d980","賭",32,"佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼"],["da40","贎",14,"贠赑赒赗赟赥赨赩赪赬赮赯赱赲赸",8,"趂趃趆趇趈趉趌",4,"趒趓趕",9,"趠趡"],["da80","趢趤",12,"趲趶趷趹趻趽跀跁跂跅跇跈跉跊跍跐跒跓跔凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺"],["db40","跕跘跙跜跠跡跢跥跦跧跩跭跮跰跱跲跴跶跼跾",6,"踆踇踈踋踍踎踐踑踒踓踕",7,"踠踡踤",4,"踫踭踰踲踳踴踶踷踸踻踼踾"],["db80","踿蹃蹅蹆蹌",4,"蹓",5,"蹚",11,"蹧蹨蹪蹫蹮蹱邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝"],["dc40","蹳蹵蹷",4,"蹽蹾躀躂躃躄躆躈",6,"躑躒躓躕",6,"躝躟",11,"躭躮躰躱躳",6,"躻",7],["dc80","軃",10,"軏",21,"堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥"],["dd40","軥",62],["dd80","輤",32,"荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺"],["de40","轅",32,"轪辀辌辒辝辠辡辢辤辥辦辧辪辬辭辮辯農辳辴辵辷辸辺辻込辿迀迃迆"],["de80","迉",4,"迏迒迖迗迚迠迡迣迧迬迯迱迲迴迵迶迺迻迼迾迿逇逈逌逎逓逕逘蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖"],["df40","這逜連逤逥逧",5,"逰",4,"逷逹逺逽逿遀遃遅遆遈",4,"過達違遖遙遚遜",5,"遤遦遧適遪遫遬遯",4,"遶",6,"遾邁"],["df80","還邅邆邇邉邊邌",4,"邒邔邖邘邚邜邞邟邠邤邥邧邨邩邫邭邲邷邼邽邿郀摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼"],["e040","郂郃郆郈郉郋郌郍郒郔郕郖郘郙郚郞郟郠郣郤郥郩郪郬郮郰郱郲郳郵郶郷郹郺郻郼郿鄀鄁鄃鄅",19,"鄚鄛鄜"],["e080","鄝鄟鄠鄡鄤",10,"鄰鄲",6,"鄺",8,"酄唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼"],["e140","酅酇酈酑酓酔酕酖酘酙酛酜酟酠酦酧酨酫酭酳酺酻酼醀",4,"醆醈醊醎醏醓",6,"醜",5,"醤",5,"醫醬醰醱醲醳醶醷醸醹醻"],["e180","醼",10,"釈釋釐釒",9,"針",8,"帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺"],["e240","釦",62],["e280","鈥",32,"狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧",5,"饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂"],["e340","鉆",45,"鉵",16],["e380","銆",7,"銏",24,"恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾"],["e440","銨",5,"銯",24,"鋉",31],["e480","鋩",32,"洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑"],["e540","錊",51,"錿",10],["e580","鍊",31,"鍫濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣"],["e640","鍬",34,"鎐",27],["e680","鎬",29,"鏋鏌鏍妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩"],["e740","鏎",7,"鏗",54],["e780","鐎",32,"纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡",6,"缪缫缬缭缯",4,"缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬"],["e840","鐯",14,"鐿",43,"鑬鑭鑮鑯"],["e880","鑰",20,"钑钖钘铇铏铓铔铚铦铻锜锠琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹"],["e940","锧锳锽镃镈镋镕镚镠镮镴镵長",7,"門",42],["e980","閫",32,"椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋"],["ea40","闌",27,"闬闿阇阓阘阛阞阠阣",6,"阫阬阭阯阰阷阸阹阺阾陁陃陊陎陏陑陒陓陖陗"],["ea80","陘陙陚陜陝陞陠陣陥陦陫陭",4,"陳陸",12,"隇隉隊辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰"],["eb40","隌階隑隒隓隕隖隚際隝",9,"隨",7,"隱隲隴隵隷隸隺隻隿雂雃雈雊雋雐雑雓雔雖",9,"雡",6,"雫"],["eb80","雬雭雮雰雱雲雴雵雸雺電雼雽雿霂霃霅霊霋霌霐霑霒霔霕霗",4,"霝霟霠搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻"],["ec40","霡",8,"霫霬霮霯霱霳",4,"霺霻霼霽霿",18,"靔靕靗靘靚靜靝靟靣靤靦靧靨靪",7],["ec80","靲靵靷",4,"靽",7,"鞆",4,"鞌鞎鞏鞐鞓鞕鞖鞗鞙",4,"臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐"],["ed40","鞞鞟鞡鞢鞤",6,"鞬鞮鞰鞱鞳鞵",46],["ed80","韤韥韨韮",4,"韴韷",23,"怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨"],["ee40","頏",62],["ee80","顎",32,"睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶",4,"钼钽钿铄铈",6,"铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪"],["ef40","顯",5,"颋颎颒颕颙颣風",37,"飏飐飔飖飗飛飜飝飠",4],["ef80","飥飦飩",30,"铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒",4,"锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤",8,"镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔"],["f040","餈",4,"餎餏餑",28,"餯",26],["f080","饊",9,"饖",12,"饤饦饳饸饹饻饾馂馃馉稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨",4,"鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦",6,"鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙"],["f140","馌馎馚",10,"馦馧馩",47],["f180","駙",32,"瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃"],["f240","駺",62],["f280","騹",32,"颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒"],["f340","驚",17,"驲骃骉骍骎骔骕骙骦骩",6,"骲骳骴骵骹骻骽骾骿髃髄髆",4,"髍髎髏髐髒體髕髖髗髙髚髛髜"],["f380","髝髞髠髢髣髤髥髧髨髩髪髬髮髰",8,"髺髼",6,"鬄鬅鬆蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋"],["f440","鬇鬉",5,"鬐鬑鬒鬔",10,"鬠鬡鬢鬤",10,"鬰鬱鬳",7,"鬽鬾鬿魀魆魊魋魌魎魐魒魓魕",5],["f480","魛",32,"簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤"],["f540","魼",62],["f580","鮻",32,"酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜"],["f640","鯜",62],["f680","鰛",32,"觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅",5,"龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞",5,"鲥",4,"鲫鲭鲮鲰",7,"鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋"],["f740","鰼",62],["f780","鱻鱽鱾鲀鲃鲄鲉鲊鲌鲏鲓鲖鲗鲘鲙鲝鲪鲬鲯鲹鲾",4,"鳈鳉鳑鳒鳚鳛鳠鳡鳌",4,"鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄"],["f840","鳣",62],["f880","鴢",32],["f940","鵃",62],["f980","鶂",32],["fa40","鶣",62],["fa80","鷢",32],["fb40","鸃",27,"鸤鸧鸮鸰鸴鸻鸼鹀鹍鹐鹒鹓鹔鹖鹙鹝鹟鹠鹡鹢鹥鹮鹯鹲鹴",9,"麀"],["fb80","麁麃麄麅麆麉麊麌",5,"麔",8,"麞麠",5,"麧麨麩麪"],["fc40","麫",8,"麵麶麷麹麺麼麿",4,"黅黆黇黈黊黋黌黐黒黓黕黖黗黙黚點黡黣黤黦黨黫黬黭黮黰",8,"黺黽黿",6],["fc80","鼆",4,"鼌鼏鼑鼒鼔鼕鼖鼘鼚",5,"鼡鼣",8,"鼭鼮鼰鼱"],["fd40","鼲",4,"鼸鼺鼼鼿",4,"齅",10,"齒",38],["fd80","齹",5,"龁龂龍",11,"龜龝龞龡",4,"郎凉秊裏隣"],["fe40","兀嗀﨎﨏﨑﨓﨔礼﨟蘒﨡﨣﨤﨧﨨﨩"]]');
            }
          ),
          /***/
          21166: (
            /***/
            function(u) {
              u.exports = /* @__PURE__ */ JSON.parse('[["0","\\u0000",127],["8141","갂갃갅갆갋",4,"갘갞갟갡갢갣갥",6,"갮갲갳갴"],["8161","갵갶갷갺갻갽갾갿걁",9,"걌걎",5,"걕"],["8181","걖걗걙걚걛걝",18,"걲걳걵걶걹걻",4,"겂겇겈겍겎겏겑겒겓겕",6,"겞겢",5,"겫겭겮겱",6,"겺겾겿곀곂곃곅곆곇곉곊곋곍",7,"곖곘",7,"곢곣곥곦곩곫곭곮곲곴곷",4,"곾곿괁괂괃괅괇",4,"괎괐괒괓"],["8241","괔괕괖괗괙괚괛괝괞괟괡",7,"괪괫괮",5],["8261","괶괷괹괺괻괽",6,"굆굈굊",5,"굑굒굓굕굖굗"],["8281","굙",7,"굢굤",7,"굮굯굱굲굷굸굹굺굾궀궃",4,"궊궋궍궎궏궑",10,"궞",5,"궥",17,"궸",7,"귂귃귅귆귇귉",6,"귒귔",7,"귝귞귟귡귢귣귥",18],["8341","귺귻귽귾긂",5,"긊긌긎",5,"긕",7],["8361","긝",18,"긲긳긵긶긹긻긼"],["8381","긽긾긿깂깄깇깈깉깋깏깑깒깓깕깗",4,"깞깢깣깤깦깧깪깫깭깮깯깱",6,"깺깾",5,"꺆",5,"꺍",46,"꺿껁껂껃껅",6,"껎껒",5,"껚껛껝",8],["8441","껦껧껩껪껬껮",5,"껵껶껷껹껺껻껽",8],["8461","꼆꼉꼊꼋꼌꼎꼏꼑",18],["8481","꼤",7,"꼮꼯꼱꼳꼵",6,"꼾꽀꽄꽅꽆꽇꽊",5,"꽑",10,"꽞",5,"꽦",18,"꽺",5,"꾁꾂꾃꾅꾆꾇꾉",6,"꾒꾓꾔꾖",5,"꾝",26,"꾺꾻꾽꾾"],["8541","꾿꿁",5,"꿊꿌꿏",4,"꿕",6,"꿝",4],["8561","꿢",5,"꿪",5,"꿲꿳꿵꿶꿷꿹",6,"뀂뀃"],["8581","뀅",6,"뀍뀎뀏뀑뀒뀓뀕",6,"뀞",9,"뀩",26,"끆끇끉끋끍끏끐끑끒끖끘끚끛끜끞",29,"끾끿낁낂낃낅",6,"낎낐낒",5,"낛낝낞낣낤"],["8641","낥낦낧낪낰낲낶낷낹낺낻낽",6,"냆냊",5,"냒"],["8661","냓냕냖냗냙",6,"냡냢냣냤냦",10],["8681","냱",22,"넊넍넎넏넑넔넕넖넗넚넞",4,"넦넧넩넪넫넭",6,"넶넺",5,"녂녃녅녆녇녉",6,"녒녓녖녗녙녚녛녝녞녟녡",22,"녺녻녽녾녿놁놃",4,"놊놌놎놏놐놑놕놖놗놙놚놛놝"],["8741","놞",9,"놩",15],["8761","놹",18,"뇍뇎뇏뇑뇒뇓뇕"],["8781","뇖",5,"뇞뇠",7,"뇪뇫뇭뇮뇯뇱",7,"뇺뇼뇾",5,"눆눇눉눊눍",6,"눖눘눚",5,"눡",18,"눵",6,"눽",26,"뉙뉚뉛뉝뉞뉟뉡",6,"뉪",4],["8841","뉯",4,"뉶",5,"뉽",6,"늆늇늈늊",4],["8861","늏늒늓늕늖늗늛",4,"늢늤늧늨늩늫늭늮늯늱늲늳늵늶늷"],["8881","늸",15,"닊닋닍닎닏닑닓",4,"닚닜닞닟닠닡닣닧닩닪닰닱닲닶닼닽닾댂댃댅댆댇댉",6,"댒댖",5,"댝",54,"덗덙덚덝덠덡덢덣"],["8941","덦덨덪덬덭덯덲덳덵덶덷덹",6,"뎂뎆",5,"뎍"],["8961","뎎뎏뎑뎒뎓뎕",10,"뎢",5,"뎩뎪뎫뎭"],["8981","뎮",21,"돆돇돉돊돍돏돑돒돓돖돘돚돜돞돟돡돢돣돥돦돧돩",18,"돽",18,"됑",6,"됙됚됛됝됞됟됡",6,"됪됬",7,"됵",15],["8a41","둅",10,"둒둓둕둖둗둙",6,"둢둤둦"],["8a61","둧",4,"둭",18,"뒁뒂"],["8a81","뒃",4,"뒉",19,"뒞",5,"뒥뒦뒧뒩뒪뒫뒭",7,"뒶뒸뒺",5,"듁듂듃듅듆듇듉",6,"듑듒듓듔듖",5,"듞듟듡듢듥듧",4,"듮듰듲",5,"듹",26,"딖딗딙딚딝"],["8b41","딞",5,"딦딫",4,"딲딳딵딶딷딹",6,"땂땆"],["8b61","땇땈땉땊땎땏땑땒땓땕",6,"땞땢",8],["8b81","땫",52,"떢떣떥떦떧떩떬떭떮떯떲떶",4,"떾떿뗁뗂뗃뗅",6,"뗎뗒",5,"뗙",18,"뗭",18],["8c41","똀",15,"똒똓똕똖똗똙",4],["8c61","똞",6,"똦",5,"똭",6,"똵",5],["8c81","똻",12,"뙉",26,"뙥뙦뙧뙩",50,"뚞뚟뚡뚢뚣뚥",5,"뚭뚮뚯뚰뚲",16],["8d41","뛃",16,"뛕",8],["8d61","뛞",17,"뛱뛲뛳뛵뛶뛷뛹뛺"],["8d81","뛻",4,"뜂뜃뜄뜆",33,"뜪뜫뜭뜮뜱",6,"뜺뜼",7,"띅띆띇띉띊띋띍",6,"띖",9,"띡띢띣띥띦띧띩",6,"띲띴띶",5,"띾띿랁랂랃랅",6,"랎랓랔랕랚랛랝랞"],["8e41","랟랡",6,"랪랮",5,"랶랷랹",8],["8e61","럂",4,"럈럊",19],["8e81","럞",13,"럮럯럱럲럳럵",6,"럾렂",4,"렊렋렍렎렏렑",6,"렚렜렞",5,"렦렧렩렪렫렭",6,"렶렺",5,"롁롂롃롅",11,"롒롔",7,"롞롟롡롢롣롥",6,"롮롰롲",5,"롹롺롻롽",7],["8f41","뢅",7,"뢎",17],["8f61","뢠",7,"뢩",6,"뢱뢲뢳뢵뢶뢷뢹",4],["8f81","뢾뢿룂룄룆",5,"룍룎룏룑룒룓룕",7,"룞룠룢",5,"룪룫룭룮룯룱",6,"룺룼룾",5,"뤅",18,"뤙",6,"뤡",26,"뤾뤿륁륂륃륅",6,"륍륎륐륒",5],["9041","륚륛륝륞륟륡",6,"륪륬륮",5,"륶륷륹륺륻륽"],["9061","륾",5,"릆릈릋릌릏",15],["9081","릟",12,"릮릯릱릲릳릵",6,"릾맀맂",5,"맊맋맍맓",4,"맚맜맟맠맢맦맧맩맪맫맭",6,"맶맻",4,"먂",5,"먉",11,"먖",33,"먺먻먽먾먿멁멃멄멅멆"],["9141","멇멊멌멏멐멑멒멖멗멙멚멛멝",6,"멦멪",5],["9161","멲멳멵멶멷멹",9,"몆몈몉몊몋몍",5],["9181","몓",20,"몪몭몮몯몱몳",4,"몺몼몾",5,"뫅뫆뫇뫉",14,"뫚",33,"뫽뫾뫿묁묂묃묅",7,"묎묐묒",5,"묙묚묛묝묞묟묡",6],["9241","묨묪묬",7,"묷묹묺묿",4,"뭆뭈뭊뭋뭌뭎뭑뭒"],["9261","뭓뭕뭖뭗뭙",7,"뭢뭤",7,"뭭",4],["9281","뭲",21,"뮉뮊뮋뮍뮎뮏뮑",18,"뮥뮦뮧뮩뮪뮫뮭",6,"뮵뮶뮸",7,"믁믂믃믅믆믇믉",6,"믑믒믔",35,"믺믻믽믾밁"],["9341","밃",4,"밊밎밐밒밓밙밚밠밡밢밣밦밨밪밫밬밮밯밲밳밵"],["9361","밶밷밹",6,"뱂뱆뱇뱈뱊뱋뱎뱏뱑",8],["9381","뱚뱛뱜뱞",37,"벆벇벉벊벍벏",4,"벖벘벛",4,"벢벣벥벦벩",6,"벲벶",5,"벾벿볁볂볃볅",7,"볎볒볓볔볖볗볙볚볛볝",22,"볷볹볺볻볽"],["9441","볾",5,"봆봈봊",5,"봑봒봓봕",8],["9461","봞",5,"봥",6,"봭",12],["9481","봺",5,"뵁",6,"뵊뵋뵍뵎뵏뵑",6,"뵚",9,"뵥뵦뵧뵩",22,"붂붃붅붆붋",4,"붒붔붖붗붘붛붝",6,"붥",10,"붱",6,"붹",24],["9541","뷒뷓뷖뷗뷙뷚뷛뷝",11,"뷪",5,"뷱"],["9561","뷲뷳뷵뷶뷷뷹",6,"븁븂븄븆",5,"븎븏븑븒븓"],["9581","븕",6,"븞븠",35,"빆빇빉빊빋빍빏",4,"빖빘빜빝빞빟빢빣빥빦빧빩빫",4,"빲빶",4,"빾빿뺁뺂뺃뺅",6,"뺎뺒",5,"뺚",13,"뺩",14],["9641","뺸",23,"뻒뻓"],["9661","뻕뻖뻙",6,"뻡뻢뻦",5,"뻭",8],["9681","뻶",10,"뼂",5,"뼊",13,"뼚뼞",33,"뽂뽃뽅뽆뽇뽉",6,"뽒뽓뽔뽖",44],["9741","뾃",16,"뾕",8],["9761","뾞",17,"뾱",7],["9781","뾹",11,"뿆",5,"뿎뿏뿑뿒뿓뿕",6,"뿝뿞뿠뿢",89,"쀽쀾쀿"],["9841","쁀",16,"쁒",5,"쁙쁚쁛"],["9861","쁝쁞쁟쁡",6,"쁪",15],["9881","쁺",21,"삒삓삕삖삗삙",6,"삢삤삦",5,"삮삱삲삷",4,"삾샂샃샄샆샇샊샋샍샎샏샑",6,"샚샞",5,"샦샧샩샪샫샭",6,"샶샸샺",5,"섁섂섃섅섆섇섉",6,"섑섒섓섔섖",5,"섡섢섥섨섩섪섫섮"],["9941","섲섳섴섵섷섺섻섽섾섿셁",6,"셊셎",5,"셖셗"],["9961","셙셚셛셝",6,"셦셪",5,"셱셲셳셵셶셷셹셺셻"],["9981","셼",8,"솆",5,"솏솑솒솓솕솗",4,"솞솠솢솣솤솦솧솪솫솭솮솯솱",11,"솾",5,"쇅쇆쇇쇉쇊쇋쇍",6,"쇕쇖쇙",6,"쇡쇢쇣쇥쇦쇧쇩",6,"쇲쇴",7,"쇾쇿숁숂숃숅",6,"숎숐숒",5,"숚숛숝숞숡숢숣"],["9a41","숤숥숦숧숪숬숮숰숳숵",16],["9a61","쉆쉇쉉",6,"쉒쉓쉕쉖쉗쉙",6,"쉡쉢쉣쉤쉦"],["9a81","쉧",4,"쉮쉯쉱쉲쉳쉵",6,"쉾슀슂",5,"슊",5,"슑",6,"슙슚슜슞",5,"슦슧슩슪슫슮",5,"슶슸슺",33,"싞싟싡싢싥",5,"싮싰싲싳싴싵싷싺싽싾싿쌁",6,"쌊쌋쌎쌏"],["9b41","쌐쌑쌒쌖쌗쌙쌚쌛쌝",6,"쌦쌧쌪",8],["9b61","쌳",17,"썆",7],["9b81","썎",25,"썪썫썭썮썯썱썳",4,"썺썻썾",5,"쎅쎆쎇쎉쎊쎋쎍",50,"쏁",22,"쏚"],["9c41","쏛쏝쏞쏡쏣",4,"쏪쏫쏬쏮",5,"쏶쏷쏹",5],["9c61","쏿",8,"쐉",6,"쐑",9],["9c81","쐛",8,"쐥",6,"쐭쐮쐯쐱쐲쐳쐵",6,"쐾",9,"쑉",26,"쑦쑧쑩쑪쑫쑭",6,"쑶쑷쑸쑺",5,"쒁",18,"쒕",6,"쒝",12],["9d41","쒪",13,"쒹쒺쒻쒽",8],["9d61","쓆",25],["9d81","쓠",8,"쓪",5,"쓲쓳쓵쓶쓷쓹쓻쓼쓽쓾씂",9,"씍씎씏씑씒씓씕",6,"씝",10,"씪씫씭씮씯씱",6,"씺씼씾",5,"앆앇앋앏앐앑앒앖앚앛앜앟앢앣앥앦앧앩",6,"앲앶",5,"앾앿얁얂얃얅얆얈얉얊얋얎얐얒얓얔"],["9e41","얖얙얚얛얝얞얟얡",7,"얪",9,"얶"],["9e61","얷얺얿",4,"엋엍엏엒엓엕엖엗엙",6,"엢엤엦엧"],["9e81","엨엩엪엫엯엱엲엳엵엸엹엺엻옂옃옄옉옊옋옍옎옏옑",6,"옚옝",6,"옦옧옩옪옫옯옱옲옶옸옺옼옽옾옿왂왃왅왆왇왉",6,"왒왖",5,"왞왟왡",10,"왭왮왰왲",5,"왺왻왽왾왿욁",6,"욊욌욎",5,"욖욗욙욚욛욝",6,"욦"],["9f41","욨욪",5,"욲욳욵욶욷욻",4,"웂웄웆",5,"웎"],["9f61","웏웑웒웓웕",6,"웞웟웢",5,"웪웫웭웮웯웱웲"],["9f81","웳",4,"웺웻웼웾",5,"윆윇윉윊윋윍",6,"윖윘윚",5,"윢윣윥윦윧윩",6,"윲윴윶윸윹윺윻윾윿읁읂읃읅",4,"읋읎읐읙읚읛읝읞읟읡",6,"읩읪읬",7,"읶읷읹읺읻읿잀잁잂잆잋잌잍잏잒잓잕잙잛",4,"잢잧",4,"잮잯잱잲잳잵잶잷"],["a041","잸잹잺잻잾쟂",5,"쟊쟋쟍쟏쟑",6,"쟙쟚쟛쟜"],["a061","쟞",5,"쟥쟦쟧쟩쟪쟫쟭",13],["a081","쟻",4,"젂젃젅젆젇젉젋",4,"젒젔젗",4,"젞젟젡젢젣젥",6,"젮젰젲",5,"젹젺젻젽젾젿졁",6,"졊졋졎",5,"졕",26,"졲졳졵졶졷졹졻",4,"좂좄좈좉좊좎",5,"좕",7,"좞좠좢좣좤"],["a141","좥좦좧좩",18,"좾좿죀죁"],["a161","죂죃죅죆죇죉죊죋죍",6,"죖죘죚",5,"죢죣죥"],["a181","죦",14,"죶",5,"죾죿줁줂줃줇",4,"줎　、。·‥…¨〃­―∥＼∼‘’“”〔〕〈",9,"±×÷≠≤≥∞∴°′″℃Å￠￡￥♂♀∠⊥⌒∂∇≡≒§※☆★○●◎◇◆□■△▲▽▼→←↑↓↔〓≪≫√∽∝∵∫∬∈∋⊆⊇⊂⊃∪∩∧∨￢"],["a241","줐줒",5,"줙",18],["a261","줭",6,"줵",18],["a281","쥈",7,"쥒쥓쥕쥖쥗쥙",6,"쥢쥤",7,"쥭쥮쥯⇒⇔∀∃´～ˇ˘˝˚˙¸˛¡¿ː∮∑∏¤℉‰◁◀▷▶♤♠♡♥♧♣⊙◈▣◐◑▒▤▥▨▧▦▩♨☏☎☜☞¶†‡↕↗↙↖↘♭♩♪♬㉿㈜№㏇™㏂㏘℡€®"],["a341","쥱쥲쥳쥵",6,"쥽",10,"즊즋즍즎즏"],["a361","즑",6,"즚즜즞",16],["a381","즯",16,"짂짃짅짆짉짋",4,"짒짔짗짘짛！",58,"￦］",32,"￣"],["a441","짞짟짡짣짥짦짨짩짪짫짮짲",5,"짺짻짽짾짿쨁쨂쨃쨄"],["a461","쨅쨆쨇쨊쨎",5,"쨕쨖쨗쨙",12],["a481","쨦쨧쨨쨪",28,"ㄱ",93],["a541","쩇",4,"쩎쩏쩑쩒쩓쩕",6,"쩞쩢",5,"쩩쩪"],["a561","쩫",17,"쩾",5,"쪅쪆"],["a581","쪇",16,"쪙",14,"ⅰ",9],["a5b0","Ⅰ",9],["a5c1","Α",16,"Σ",6],["a5e1","α",16,"σ",6],["a641","쪨",19,"쪾쪿쫁쫂쫃쫅"],["a661","쫆",5,"쫎쫐쫒쫔쫕쫖쫗쫚",5,"쫡",6],["a681","쫨쫩쫪쫫쫭",6,"쫵",18,"쬉쬊─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂┒┑┚┙┖┕┎┍┞┟┡┢┦┧┩┪┭┮┱┲┵┶┹┺┽┾╀╁╃",7],["a741","쬋",4,"쬑쬒쬓쬕쬖쬗쬙",6,"쬢",7],["a761","쬪",22,"쭂쭃쭄"],["a781","쭅쭆쭇쭊쭋쭍쭎쭏쭑",6,"쭚쭛쭜쭞",5,"쭥",7,"㎕㎖㎗ℓ㎘㏄㎣㎤㎥㎦㎙",9,"㏊㎍㎎㎏㏏㎈㎉㏈㎧㎨㎰",9,"㎀",4,"㎺",5,"㎐",4,"Ω㏀㏁㎊㎋㎌㏖㏅㎭㎮㎯㏛㎩㎪㎫㎬㏝㏐㏓㏃㏉㏜㏆"],["a841","쭭",10,"쭺",14],["a861","쮉",18,"쮝",6],["a881","쮤",19,"쮹",11,"ÆÐªĦ"],["a8a6","Ĳ"],["a8a8","ĿŁØŒºÞŦŊ"],["a8b1","㉠",27,"ⓐ",25,"①",14,"½⅓⅔¼¾⅛⅜⅝⅞"],["a941","쯅",14,"쯕",10],["a961","쯠쯡쯢쯣쯥쯦쯨쯪",18],["a981","쯽",14,"찎찏찑찒찓찕",6,"찞찟찠찣찤æđðħıĳĸŀłøœßþŧŋŉ㈀",27,"⒜",25,"⑴",14,"¹²³⁴ⁿ₁₂₃₄"],["aa41","찥찦찪찫찭찯찱",6,"찺찿",4,"챆챇챉챊챋챍챎"],["aa61","챏",4,"챖챚",5,"챡챢챣챥챧챩",6,"챱챲"],["aa81","챳챴챶",29,"ぁ",82],["ab41","첔첕첖첗첚첛첝첞첟첡",6,"첪첮",5,"첶첷첹"],["ab61","첺첻첽",6,"쳆쳈쳊",5,"쳑쳒쳓쳕",5],["ab81","쳛",8,"쳥",6,"쳭쳮쳯쳱",12,"ァ",85],["ac41","쳾쳿촀촂",5,"촊촋촍촎촏촑",6,"촚촜촞촟촠"],["ac61","촡촢촣촥촦촧촩촪촫촭",11,"촺",4],["ac81","촿",28,"쵝쵞쵟А",5,"ЁЖ",25],["acd1","а",5,"ёж",25],["ad41","쵡쵢쵣쵥",6,"쵮쵰쵲",5,"쵹",7],["ad61","춁",6,"춉",10,"춖춗춙춚춛춝춞춟"],["ad81","춠춡춢춣춦춨춪",5,"춱",18,"췅"],["ae41","췆",5,"췍췎췏췑",16],["ae61","췢",5,"췩췪췫췭췮췯췱",6,"췺췼췾",4],["ae81","츃츅츆츇츉츊츋츍",6,"츕츖츗츘츚",5,"츢츣츥츦츧츩츪츫"],["af41","츬츭츮츯츲츴츶",19],["af61","칊",13,"칚칛칝칞칢",5,"칪칬"],["af81","칮",5,"칶칷칹칺칻칽",6,"캆캈캊",5,"캒캓캕캖캗캙"],["b041","캚",5,"캢캦",5,"캮",12],["b061","캻",5,"컂",19],["b081","컖",13,"컦컧컩컪컭",6,"컶컺",5,"가각간갇갈갉갊감",7,"같",4,"갠갤갬갭갯갰갱갸갹갼걀걋걍걔걘걜거걱건걷걸걺검겁것겄겅겆겉겊겋게겐겔겜겝겟겠겡겨격겪견겯결겸겹겻겼경곁계곈곌곕곗고곡곤곧골곪곬곯곰곱곳공곶과곽관괄괆"],["b141","켂켃켅켆켇켉",6,"켒켔켖",5,"켝켞켟켡켢켣"],["b161","켥",6,"켮켲",5,"켹",11],["b181","콅",14,"콖콗콙콚콛콝",6,"콦콨콪콫콬괌괍괏광괘괜괠괩괬괭괴괵괸괼굄굅굇굉교굔굘굡굣구국군굳굴굵굶굻굼굽굿궁궂궈궉권궐궜궝궤궷귀귁귄귈귐귑귓규균귤그극근귿글긁금급긋긍긔기긱긴긷길긺김깁깃깅깆깊까깍깎깐깔깖깜깝깟깠깡깥깨깩깬깰깸"],["b241","콭콮콯콲콳콵콶콷콹",6,"쾁쾂쾃쾄쾆",5,"쾍"],["b261","쾎",18,"쾢",5,"쾩"],["b281","쾪",5,"쾱",18,"쿅",6,"깹깻깼깽꺄꺅꺌꺼꺽꺾껀껄껌껍껏껐껑께껙껜껨껫껭껴껸껼꼇꼈꼍꼐꼬꼭꼰꼲꼴꼼꼽꼿꽁꽂꽃꽈꽉꽐꽜꽝꽤꽥꽹꾀꾄꾈꾐꾑꾕꾜꾸꾹꾼꿀꿇꿈꿉꿋꿍꿎꿔꿜꿨꿩꿰꿱꿴꿸뀀뀁뀄뀌뀐뀔뀜뀝뀨끄끅끈끊끌끎끓끔끕끗끙"],["b341","쿌",19,"쿢쿣쿥쿦쿧쿩"],["b361","쿪",5,"쿲쿴쿶",5,"쿽쿾쿿퀁퀂퀃퀅",5],["b381","퀋",5,"퀒",5,"퀙",19,"끝끼끽낀낄낌낍낏낑나낙낚난낟날낡낢남납낫",4,"낱낳내낵낸낼냄냅냇냈냉냐냑냔냘냠냥너넉넋넌널넒넓넘넙넛넜넝넣네넥넨넬넴넵넷넸넹녀녁년녈념녑녔녕녘녜녠노녹논놀놂놈놉놋농높놓놔놘놜놨뇌뇐뇔뇜뇝"],["b441","퀮",5,"퀶퀷퀹퀺퀻퀽",6,"큆큈큊",5],["b461","큑큒큓큕큖큗큙",6,"큡",10,"큮큯"],["b481","큱큲큳큵",6,"큾큿킀킂",18,"뇟뇨뇩뇬뇰뇹뇻뇽누눅눈눋눌눔눕눗눙눠눴눼뉘뉜뉠뉨뉩뉴뉵뉼늄늅늉느늑는늘늙늚늠늡늣능늦늪늬늰늴니닉닌닐닒님닙닛닝닢다닥닦단닫",4,"닳담답닷",4,"닿대댁댄댈댐댑댓댔댕댜더덕덖던덛덜덞덟덤덥"],["b541","킕",14,"킦킧킩킪킫킭",5],["b561","킳킶킸킺",5,"탂탃탅탆탇탊",5,"탒탖",4],["b581","탛탞탟탡탢탣탥",6,"탮탲",5,"탹",11,"덧덩덫덮데덱덴델뎀뎁뎃뎄뎅뎌뎐뎔뎠뎡뎨뎬도독돈돋돌돎돐돔돕돗동돛돝돠돤돨돼됐되된될됨됩됫됴두둑둔둘둠둡둣둥둬뒀뒈뒝뒤뒨뒬뒵뒷뒹듀듄듈듐듕드득든듣들듦듬듭듯등듸디딕딘딛딜딤딥딧딨딩딪따딱딴딸"],["b641","턅",7,"턎",17],["b661","턠",15,"턲턳턵턶턷턹턻턼턽턾"],["b681","턿텂텆",5,"텎텏텑텒텓텕",6,"텞텠텢",5,"텩텪텫텭땀땁땃땄땅땋때땍땐땔땜땝땟땠땡떠떡떤떨떪떫떰떱떳떴떵떻떼떽뗀뗄뗌뗍뗏뗐뗑뗘뗬또똑똔똘똥똬똴뙈뙤뙨뚜뚝뚠뚤뚫뚬뚱뛔뛰뛴뛸뜀뜁뜅뜨뜩뜬뜯뜰뜸뜹뜻띄띈띌띔띕띠띤띨띰띱띳띵라락란랄람랍랏랐랑랒랖랗"],["b741","텮",13,"텽",6,"톅톆톇톉톊"],["b761","톋",20,"톢톣톥톦톧"],["b781","톩",6,"톲톴톶톷톸톹톻톽톾톿퇁",14,"래랙랜랠램랩랫랬랭랴략랸럇량러럭런럴럼럽럿렀렁렇레렉렌렐렘렙렛렝려력련렬렴렵렷렸령례롄롑롓로록론롤롬롭롯롱롸롼뢍뢨뢰뢴뢸룀룁룃룅료룐룔룝룟룡루룩룬룰룸룹룻룽뤄뤘뤠뤼뤽륀륄륌륏륑류륙륜률륨륩"],["b841","퇐",7,"퇙",17],["b861","퇫",8,"퇵퇶퇷퇹",13],["b881","툈툊",5,"툑",24,"륫륭르륵른를름릅릇릉릊릍릎리릭린릴림립릿링마막만많",4,"맘맙맛망맞맡맣매맥맨맬맴맵맷맸맹맺먀먁먈먕머먹먼멀멂멈멉멋멍멎멓메멕멘멜멤멥멧멨멩며멱면멸몃몄명몇몌모목몫몬몰몲몸몹못몽뫄뫈뫘뫙뫼"],["b941","툪툫툮툯툱툲툳툵",6,"툾퉀퉂",5,"퉉퉊퉋퉌"],["b961","퉍",14,"퉝",6,"퉥퉦퉧퉨"],["b981","퉩",22,"튂튃튅튆튇튉튊튋튌묀묄묍묏묑묘묜묠묩묫무묵묶문묻물묽묾뭄뭅뭇뭉뭍뭏뭐뭔뭘뭡뭣뭬뮈뮌뮐뮤뮨뮬뮴뮷므믄믈믐믓미믹민믿밀밂밈밉밋밌밍및밑바",4,"받",4,"밤밥밧방밭배백밴밸뱀뱁뱃뱄뱅뱉뱌뱍뱐뱝버벅번벋벌벎범법벗"],["ba41","튍튎튏튒튓튔튖",5,"튝튞튟튡튢튣튥",6,"튭"],["ba61","튮튯튰튲",5,"튺튻튽튾틁틃",4,"틊틌",5],["ba81","틒틓틕틖틗틙틚틛틝",6,"틦",9,"틲틳틵틶틷틹틺벙벚베벡벤벧벨벰벱벳벴벵벼벽변별볍볏볐병볕볘볜보복볶본볼봄봅봇봉봐봔봤봬뵀뵈뵉뵌뵐뵘뵙뵤뵨부북분붇불붉붊붐붑붓붕붙붚붜붤붰붸뷔뷕뷘뷜뷩뷰뷴뷸븀븃븅브븍븐블븜븝븟비빅빈빌빎빔빕빗빙빚빛빠빡빤"],["bb41","틻",4,"팂팄팆",5,"팏팑팒팓팕팗",4,"팞팢팣"],["bb61","팤팦팧팪팫팭팮팯팱",6,"팺팾",5,"퍆퍇퍈퍉"],["bb81","퍊",31,"빨빪빰빱빳빴빵빻빼빽뺀뺄뺌뺍뺏뺐뺑뺘뺙뺨뻐뻑뻔뻗뻘뻠뻣뻤뻥뻬뼁뼈뼉뼘뼙뼛뼜뼝뽀뽁뽄뽈뽐뽑뽕뾔뾰뿅뿌뿍뿐뿔뿜뿟뿡쀼쁑쁘쁜쁠쁨쁩삐삑삔삘삠삡삣삥사삭삯산삳살삵삶삼삽삿샀상샅새색샌샐샘샙샛샜생샤"],["bc41","퍪",17,"퍾퍿펁펂펃펅펆펇"],["bc61","펈펉펊펋펎펒",5,"펚펛펝펞펟펡",6,"펪펬펮"],["bc81","펯",4,"펵펶펷펹펺펻펽",6,"폆폇폊",5,"폑",5,"샥샨샬샴샵샷샹섀섄섈섐섕서",4,"섣설섦섧섬섭섯섰성섶세섹센셀셈셉셋셌셍셔셕션셜셤셥셧셨셩셰셴셸솅소속솎손솔솖솜솝솟송솥솨솩솬솰솽쇄쇈쇌쇔쇗쇘쇠쇤쇨쇰쇱쇳쇼쇽숀숄숌숍숏숑수숙순숟술숨숩숫숭"],["bd41","폗폙",7,"폢폤",7,"폮폯폱폲폳폵폶폷"],["bd61","폸폹폺폻폾퐀퐂",5,"퐉",13],["bd81","퐗",5,"퐞",25,"숯숱숲숴쉈쉐쉑쉔쉘쉠쉥쉬쉭쉰쉴쉼쉽쉿슁슈슉슐슘슛슝스슥슨슬슭슴습슷승시식신싣실싫심십싯싱싶싸싹싻싼쌀쌈쌉쌌쌍쌓쌔쌕쌘쌜쌤쌥쌨쌩썅써썩썬썰썲썸썹썼썽쎄쎈쎌쏀쏘쏙쏜쏟쏠쏢쏨쏩쏭쏴쏵쏸쐈쐐쐤쐬쐰"],["be41","퐸",7,"푁푂푃푅",14],["be61","푔",7,"푝푞푟푡푢푣푥",7,"푮푰푱푲"],["be81","푳",4,"푺푻푽푾풁풃",4,"풊풌풎",5,"풕",8,"쐴쐼쐽쑈쑤쑥쑨쑬쑴쑵쑹쒀쒔쒜쒸쒼쓩쓰쓱쓴쓸쓺쓿씀씁씌씐씔씜씨씩씬씰씸씹씻씽아악안앉않알앍앎앓암압앗았앙앝앞애액앤앨앰앱앳앴앵야약얀얄얇얌얍얏양얕얗얘얜얠얩어억언얹얻얼얽얾엄",6,"엌엎"],["bf41","풞",10,"풪",14],["bf61","풹",18,"퓍퓎퓏퓑퓒퓓퓕"],["bf81","퓖",5,"퓝퓞퓠",7,"퓩퓪퓫퓭퓮퓯퓱",6,"퓹퓺퓼에엑엔엘엠엡엣엥여역엮연열엶엷염",5,"옅옆옇예옌옐옘옙옛옜오옥온올옭옮옰옳옴옵옷옹옻와왁완왈왐왑왓왔왕왜왝왠왬왯왱외왹왼욀욈욉욋욍요욕욘욜욤욥욧용우욱운울욹욺움웁웃웅워웍원월웜웝웠웡웨"],["c041","퓾",5,"픅픆픇픉픊픋픍",6,"픖픘",5],["c061","픞",25],["c081","픸픹픺픻픾픿핁핂핃핅",6,"핎핐핒",5,"핚핛핝핞핟핡핢핣웩웬웰웸웹웽위윅윈윌윔윕윗윙유육윤율윰윱윳융윷으윽은을읊음읍읏응",7,"읜읠읨읫이익인일읽읾잃임입잇있잉잊잎자작잔잖잗잘잚잠잡잣잤장잦재잭잰잴잼잽잿쟀쟁쟈쟉쟌쟎쟐쟘쟝쟤쟨쟬저적전절젊"],["c141","핤핦핧핪핬핮",5,"핶핷핹핺핻핽",6,"햆햊햋"],["c161","햌햍햎햏햑",19,"햦햧"],["c181","햨",31,"점접젓정젖제젝젠젤젬젭젯젱져젼졀졈졉졌졍졔조족존졸졺좀좁좃종좆좇좋좌좍좔좝좟좡좨좼좽죄죈죌죔죕죗죙죠죡죤죵주죽준줄줅줆줌줍줏중줘줬줴쥐쥑쥔쥘쥠쥡쥣쥬쥰쥴쥼즈즉즌즐즘즙즛증지직진짇질짊짐집짓"],["c241","헊헋헍헎헏헑헓",4,"헚헜헞",5,"헦헧헩헪헫헭헮"],["c261","헯",4,"헶헸헺",5,"혂혃혅혆혇혉",6,"혒"],["c281","혖",5,"혝혞혟혡혢혣혥",7,"혮",9,"혺혻징짖짙짚짜짝짠짢짤짧짬짭짯짰짱째짹짼쨀쨈쨉쨋쨌쨍쨔쨘쨩쩌쩍쩐쩔쩜쩝쩟쩠쩡쩨쩽쪄쪘쪼쪽쫀쫄쫌쫍쫏쫑쫓쫘쫙쫠쫬쫴쬈쬐쬔쬘쬠쬡쭁쭈쭉쭌쭐쭘쭙쭝쭤쭸쭹쮜쮸쯔쯤쯧쯩찌찍찐찔찜찝찡찢찧차착찬찮찰참찹찻"],["c341","혽혾혿홁홂홃홄홆홇홊홌홎홏홐홒홓홖홗홙홚홛홝",4],["c361","홢",4,"홨홪",5,"홲홳홵",11],["c381","횁횂횄횆",5,"횎횏횑횒횓횕",7,"횞횠횢",5,"횩횪찼창찾채책챈챌챔챕챗챘챙챠챤챦챨챰챵처척천철첨첩첫첬청체첵첸첼쳄쳅쳇쳉쳐쳔쳤쳬쳰촁초촉촌촐촘촙촛총촤촨촬촹최쵠쵤쵬쵭쵯쵱쵸춈추축춘출춤춥춧충춰췄췌췐취췬췰췸췹췻췽츄츈츌츔츙츠측츤츨츰츱츳층"],["c441","횫횭횮횯횱",7,"횺횼",7,"훆훇훉훊훋"],["c461","훍훎훏훐훒훓훕훖훘훚",5,"훡훢훣훥훦훧훩",4],["c481","훮훯훱훲훳훴훶",5,"훾훿휁휂휃휅",11,"휒휓휔치칙친칟칠칡침칩칫칭카칵칸칼캄캅캇캉캐캑캔캘캠캡캣캤캥캬캭컁커컥컨컫컬컴컵컷컸컹케켁켄켈켐켑켓켕켜켠켤켬켭켯켰켱켸코콕콘콜콤콥콧콩콰콱콴콸쾀쾅쾌쾡쾨쾰쿄쿠쿡쿤쿨쿰쿱쿳쿵쿼퀀퀄퀑퀘퀭퀴퀵퀸퀼"],["c541","휕휖휗휚휛휝휞휟휡",6,"휪휬휮",5,"휶휷휹"],["c561","휺휻휽",6,"흅흆흈흊",5,"흒흓흕흚",4],["c581","흟흢흤흦흧흨흪흫흭흮흯흱흲흳흵",6,"흾흿힀힂",5,"힊힋큄큅큇큉큐큔큘큠크큭큰클큼큽킁키킥킨킬킴킵킷킹타탁탄탈탉탐탑탓탔탕태택탠탤탬탭탯탰탱탸턍터턱턴털턺텀텁텃텄텅테텍텐텔템텝텟텡텨텬텼톄톈토톡톤톨톰톱톳통톺톼퇀퇘퇴퇸툇툉툐투툭툰툴툼툽툿퉁퉈퉜"],["c641","힍힎힏힑",6,"힚힜힞",5],["c6a1","퉤튀튁튄튈튐튑튕튜튠튤튬튱트특튼튿틀틂틈틉틋틔틘틜틤틥티틱틴틸팀팁팃팅파팍팎판팔팖팜팝팟팠팡팥패팩팬팰팸팹팻팼팽퍄퍅퍼퍽펀펄펌펍펏펐펑페펙펜펠펨펩펫펭펴편펼폄폅폈평폐폘폡폣포폭폰폴폼폽폿퐁"],["c7a1","퐈퐝푀푄표푠푤푭푯푸푹푼푿풀풂품풉풋풍풔풩퓌퓐퓔퓜퓟퓨퓬퓰퓸퓻퓽프픈플픔픕픗피픽핀필핌핍핏핑하학한할핥함합핫항해핵핸핼햄햅햇했행햐향허헉헌헐헒험헙헛헝헤헥헨헬헴헵헷헹혀혁현혈혐협혓혔형혜혠"],["c8a1","혤혭호혹혼홀홅홈홉홋홍홑화확환활홧황홰홱홴횃횅회획횐횔횝횟횡효횬횰횹횻후훅훈훌훑훔훗훙훠훤훨훰훵훼훽휀휄휑휘휙휜휠휨휩휫휭휴휵휸휼흄흇흉흐흑흔흖흗흘흙흠흡흣흥흩희흰흴흼흽힁히힉힌힐힘힙힛힝"],["caa1","伽佳假價加可呵哥嘉嫁家暇架枷柯歌珂痂稼苛茄街袈訶賈跏軻迦駕刻却各恪慤殼珏脚覺角閣侃刊墾奸姦干幹懇揀杆柬桿澗癎看磵稈竿簡肝艮艱諫間乫喝曷渴碣竭葛褐蝎鞨勘坎堪嵌感憾戡敢柑橄減甘疳監瞰紺邯鑑鑒龕"],["cba1","匣岬甲胛鉀閘剛堈姜岡崗康强彊慷江畺疆糠絳綱羌腔舡薑襁講鋼降鱇介价個凱塏愷愾慨改槪漑疥皆盖箇芥蓋豈鎧開喀客坑更粳羹醵倨去居巨拒据據擧渠炬祛距踞車遽鉅鋸乾件健巾建愆楗腱虔蹇鍵騫乞傑杰桀儉劍劒檢"],["cca1","瞼鈐黔劫怯迲偈憩揭擊格檄激膈覡隔堅牽犬甄絹繭肩見譴遣鵑抉決潔結缺訣兼慊箝謙鉗鎌京俓倞傾儆勁勍卿坰境庚徑慶憬擎敬景暻更梗涇炅烱璟璥瓊痙硬磬竟競絅經耕耿脛莖警輕逕鏡頃頸驚鯨係啓堺契季屆悸戒桂械"],["cda1","棨溪界癸磎稽系繫繼計誡谿階鷄古叩告呱固姑孤尻庫拷攷故敲暠枯槁沽痼皐睾稿羔考股膏苦苽菰藁蠱袴誥賈辜錮雇顧高鼓哭斛曲梏穀谷鵠困坤崑昆梱棍滾琨袞鯤汨滑骨供公共功孔工恐恭拱控攻珙空蚣貢鞏串寡戈果瓜"],["cea1","科菓誇課跨過鍋顆廓槨藿郭串冠官寬慣棺款灌琯瓘管罐菅觀貫關館刮恝括适侊光匡壙廣曠洸炚狂珖筐胱鑛卦掛罫乖傀塊壞怪愧拐槐魁宏紘肱轟交僑咬喬嬌嶠巧攪敎校橋狡皎矯絞翹膠蕎蛟較轎郊餃驕鮫丘久九仇俱具勾"],["cfa1","區口句咎嘔坵垢寇嶇廐懼拘救枸柩構歐毆毬求溝灸狗玖球瞿矩究絿耉臼舅舊苟衢謳購軀逑邱鉤銶駒驅鳩鷗龜國局菊鞠鞫麴君窘群裙軍郡堀屈掘窟宮弓穹窮芎躬倦券勸卷圈拳捲權淃眷厥獗蕨蹶闕机櫃潰詭軌饋句晷歸貴"],["d0a1","鬼龜叫圭奎揆槻珪硅窺竅糾葵規赳逵閨勻均畇筠菌鈞龜橘克剋劇戟棘極隙僅劤勤懃斤根槿瑾筋芹菫覲謹近饉契今妗擒昑檎琴禁禽芩衾衿襟金錦伋及急扱汲級給亘兢矜肯企伎其冀嗜器圻基埼夔奇妓寄岐崎己幾忌技旗旣"],["d1a1","朞期杞棋棄機欺氣汽沂淇玘琦琪璂璣畸畿碁磯祁祇祈祺箕紀綺羈耆耭肌記譏豈起錡錤飢饑騎騏驥麒緊佶吉拮桔金喫儺喇奈娜懦懶拏拿癩",5,"那樂",4,"諾酪駱亂卵暖欄煖爛蘭難鸞捏捺南嵐枏楠湳濫男藍襤拉"],["d2a1","納臘蠟衲囊娘廊",4,"乃來內奈柰耐冷女年撚秊念恬拈捻寧寗努勞奴弩怒擄櫓爐瑙盧",5,"駑魯",10,"濃籠聾膿農惱牢磊腦賂雷尿壘",7,"嫩訥杻紐勒",5,"能菱陵尼泥匿溺多茶"],["d3a1","丹亶但單團壇彖斷旦檀段湍短端簞緞蛋袒鄲鍛撻澾獺疸達啖坍憺擔曇淡湛潭澹痰聃膽蕁覃談譚錟沓畓答踏遝唐堂塘幢戇撞棠當糖螳黨代垈坮大對岱帶待戴擡玳臺袋貸隊黛宅德悳倒刀到圖堵塗導屠島嶋度徒悼挑掉搗桃"],["d4a1","棹櫂淘渡滔濤燾盜睹禱稻萄覩賭跳蹈逃途道都鍍陶韜毒瀆牘犢獨督禿篤纛讀墩惇敦旽暾沌焞燉豚頓乭突仝冬凍動同憧東桐棟洞潼疼瞳童胴董銅兜斗杜枓痘竇荳讀豆逗頭屯臀芚遁遯鈍得嶝橙燈登等藤謄鄧騰喇懶拏癩羅"],["d5a1","蘿螺裸邏樂洛烙珞絡落諾酪駱丹亂卵欄欒瀾爛蘭鸞剌辣嵐擥攬欖濫籃纜藍襤覽拉臘蠟廊朗浪狼琅瑯螂郞來崍徠萊冷掠略亮倆兩凉梁樑粮粱糧良諒輛量侶儷勵呂廬慮戾旅櫚濾礪藜蠣閭驢驪麗黎力曆歷瀝礫轢靂憐戀攣漣"],["d6a1","煉璉練聯蓮輦連鍊冽列劣洌烈裂廉斂殮濂簾獵令伶囹寧岺嶺怜玲笭羚翎聆逞鈴零靈領齡例澧禮醴隷勞怒撈擄櫓潞瀘爐盧老蘆虜路輅露魯鷺鹵碌祿綠菉錄鹿麓論壟弄朧瀧瓏籠聾儡瀨牢磊賂賚賴雷了僚寮廖料燎療瞭聊蓼"],["d7a1","遼鬧龍壘婁屢樓淚漏瘻累縷蔞褸鏤陋劉旒柳榴流溜瀏琉瑠留瘤硫謬類六戮陸侖倫崙淪綸輪律慄栗率隆勒肋凜凌楞稜綾菱陵俚利厘吏唎履悧李梨浬犁狸理璃異痢籬罹羸莉裏裡里釐離鯉吝潾燐璘藺躪隣鱗麟林淋琳臨霖砬"],["d8a1","立笠粒摩瑪痲碼磨馬魔麻寞幕漠膜莫邈万卍娩巒彎慢挽晩曼滿漫灣瞞萬蔓蠻輓饅鰻唜抹末沫茉襪靺亡妄忘忙望網罔芒茫莽輞邙埋妹媒寐昧枚梅每煤罵買賣邁魅脈貊陌驀麥孟氓猛盲盟萌冪覓免冕勉棉沔眄眠綿緬面麵滅"],["d9a1","蔑冥名命明暝椧溟皿瞑茗蓂螟酩銘鳴袂侮冒募姆帽慕摸摹暮某模母毛牟牡瑁眸矛耗芼茅謀謨貌木沐牧目睦穆鶩歿沒夢朦蒙卯墓妙廟描昴杳渺猫竗苗錨務巫憮懋戊拇撫无楙武毋無珷畝繆舞茂蕪誣貿霧鵡墨默們刎吻問文"],["daa1","汶紊紋聞蚊門雯勿沕物味媚尾嵋彌微未梶楣渼湄眉米美薇謎迷靡黴岷悶愍憫敏旻旼民泯玟珉緡閔密蜜謐剝博拍搏撲朴樸泊珀璞箔粕縛膊舶薄迫雹駁伴半反叛拌搬攀斑槃泮潘班畔瘢盤盼磐磻礬絆般蟠返頒飯勃拔撥渤潑"],["dba1","發跋醱鉢髮魃倣傍坊妨尨幇彷房放方旁昉枋榜滂磅紡肪膀舫芳蒡蚌訪謗邦防龐倍俳北培徘拜排杯湃焙盃背胚裴裵褙賠輩配陪伯佰帛柏栢白百魄幡樊煩燔番磻繁蕃藩飜伐筏罰閥凡帆梵氾汎泛犯範范法琺僻劈壁擘檗璧癖"],["dca1","碧蘗闢霹便卞弁變辨辯邊別瞥鱉鼈丙倂兵屛幷昞昺柄棅炳甁病秉竝輧餠騈保堡報寶普步洑湺潽珤甫菩補褓譜輔伏僕匐卜宓復服福腹茯蔔複覆輹輻馥鰒本乶俸奉封峯峰捧棒烽熢琫縫蓬蜂逢鋒鳳不付俯傅剖副否咐埠夫婦"],["dda1","孚孵富府復扶敷斧浮溥父符簿缶腐腑膚艀芙莩訃負賦賻赴趺部釜阜附駙鳧北分吩噴墳奔奮忿憤扮昐汾焚盆粉糞紛芬賁雰不佛弗彿拂崩朋棚硼繃鵬丕備匕匪卑妃婢庇悲憊扉批斐枇榧比毖毗毘沸泌琵痺砒碑秕秘粃緋翡肥"],["dea1","脾臂菲蜚裨誹譬費鄙非飛鼻嚬嬪彬斌檳殯浜濱瀕牝玭貧賓頻憑氷聘騁乍事些仕伺似使俟僿史司唆嗣四士奢娑寫寺射巳師徙思捨斜斯柶査梭死沙泗渣瀉獅砂社祀祠私篩紗絲肆舍莎蓑蛇裟詐詞謝賜赦辭邪飼駟麝削數朔索"],["dfa1","傘刪山散汕珊産疝算蒜酸霰乷撒殺煞薩三參杉森渗芟蔘衫揷澁鈒颯上傷像償商喪嘗孀尙峠常床庠廂想桑橡湘爽牀狀相祥箱翔裳觴詳象賞霜塞璽賽嗇塞穡索色牲生甥省笙墅壻嶼序庶徐恕抒捿敍暑曙書栖棲犀瑞筮絮緖署"],["e0a1","胥舒薯西誓逝鋤黍鼠夕奭席惜昔晳析汐淅潟石碩蓆釋錫仙僊先善嬋宣扇敾旋渲煽琁瑄璇璿癬禪線繕羨腺膳船蘚蟬詵跣選銑鐥饍鮮卨屑楔泄洩渫舌薛褻設說雪齧剡暹殲纖蟾贍閃陝攝涉燮葉城姓宬性惺成星晟猩珹盛省筬"],["e1a1","聖聲腥誠醒世勢歲洗稅笹細說貰召嘯塑宵小少巢所掃搔昭梳沼消溯瀟炤燒甦疏疎瘙笑篠簫素紹蔬蕭蘇訴逍遡邵銷韶騷俗屬束涑粟續謖贖速孫巽損蓀遜飡率宋悚松淞訟誦送頌刷殺灑碎鎖衰釗修受嗽囚垂壽嫂守岫峀帥愁"],["e2a1","戍手授搜收數樹殊水洙漱燧狩獸琇璲瘦睡秀穗竪粹綏綬繡羞脩茱蒐蓚藪袖誰讐輸遂邃酬銖銹隋隧隨雖需須首髓鬚叔塾夙孰宿淑潚熟琡璹肅菽巡徇循恂旬栒楯橓殉洵淳珣盾瞬筍純脣舜荀蓴蕣詢諄醇錞順馴戌術述鉥崇崧"],["e3a1","嵩瑟膝蝨濕拾習褶襲丞乘僧勝升承昇繩蠅陞侍匙嘶始媤尸屎屍市弑恃施是時枾柴猜矢示翅蒔蓍視試詩諡豕豺埴寔式息拭植殖湜熄篒蝕識軾食飾伸侁信呻娠宸愼新晨燼申神紳腎臣莘薪藎蜃訊身辛辰迅失室實悉審尋心沁"],["e4a1","沈深瀋甚芯諶什十拾雙氏亞俄兒啞娥峨我牙芽莪蛾衙訝阿雅餓鴉鵝堊岳嶽幄惡愕握樂渥鄂鍔顎鰐齷安岸按晏案眼雁鞍顔鮟斡謁軋閼唵岩巖庵暗癌菴闇壓押狎鴨仰央怏昻殃秧鴦厓哀埃崖愛曖涯碍艾隘靄厄扼掖液縊腋額"],["e5a1","櫻罌鶯鸚也倻冶夜惹揶椰爺耶若野弱掠略約若葯蒻藥躍亮佯兩凉壤孃恙揚攘敭暘梁楊樣洋瀁煬痒瘍禳穰糧羊良襄諒讓釀陽量養圄御於漁瘀禦語馭魚齬億憶抑檍臆偃堰彦焉言諺孼蘖俺儼嚴奄掩淹嶪業円予余勵呂女如廬"],["e6a1","旅歟汝濾璵礖礪與艅茹輿轝閭餘驪麗黎亦力域役易曆歷疫繹譯轢逆驛嚥堧姸娟宴年延憐戀捐挻撚椽沇沿涎涓淵演漣烟然煙煉燃燕璉硏硯秊筵緣練縯聯衍軟輦蓮連鉛鍊鳶列劣咽悅涅烈熱裂說閱厭廉念捻染殮炎焰琰艶苒"],["e7a1","簾閻髥鹽曄獵燁葉令囹塋寧嶺嶸影怜映暎楹榮永泳渶潁濚瀛瀯煐營獰玲瑛瑩瓔盈穎纓羚聆英詠迎鈴鍈零霙靈領乂倪例刈叡曳汭濊猊睿穢芮藝蘂禮裔詣譽豫醴銳隸霓預五伍俉傲午吾吳嗚塢墺奧娛寤悟惡懊敖旿晤梧汚澳"],["e8a1","烏熬獒筽蜈誤鰲鼇屋沃獄玉鈺溫瑥瘟穩縕蘊兀壅擁瓮甕癰翁邕雍饔渦瓦窩窪臥蛙蝸訛婉完宛梡椀浣玩琓琬碗緩翫脘腕莞豌阮頑曰往旺枉汪王倭娃歪矮外嵬巍猥畏了僚僥凹堯夭妖姚寥寮尿嶢拗搖撓擾料曜樂橈燎燿瑤療"],["e9a1","窈窯繇繞耀腰蓼蟯要謠遙遼邀饒慾欲浴縟褥辱俑傭冗勇埇墉容庸慂榕涌湧溶熔瑢用甬聳茸蓉踊鎔鏞龍于佑偶優又友右宇寓尤愚憂旴牛玗瑀盂祐禑禹紆羽芋藕虞迂遇郵釪隅雨雩勖彧旭昱栯煜稶郁頊云暈橒殞澐熉耘芸蕓"],["eaa1","運隕雲韻蔚鬱亐熊雄元原員圓園垣媛嫄寃怨愿援沅洹湲源爰猿瑗苑袁轅遠阮院願鴛月越鉞位偉僞危圍委威尉慰暐渭爲瑋緯胃萎葦蔿蝟衛褘謂違韋魏乳侑儒兪劉唯喩孺宥幼幽庾悠惟愈愉揄攸有杻柔柚柳楡楢油洧流游溜"],["eba1","濡猶猷琉瑜由留癒硫紐維臾萸裕誘諛諭踰蹂遊逾遺酉釉鍮類六堉戮毓肉育陸倫允奫尹崙淪潤玧胤贇輪鈗閏律慄栗率聿戎瀜絨融隆垠恩慇殷誾銀隱乙吟淫蔭陰音飮揖泣邑凝應膺鷹依倚儀宜意懿擬椅毅疑矣義艤薏蟻衣誼"],["eca1","議醫二以伊利吏夷姨履已弛彛怡易李梨泥爾珥理異痍痢移罹而耳肄苡荑裏裡貽貳邇里離飴餌匿溺瀷益翊翌翼謚人仁刃印吝咽因姻寅引忍湮燐璘絪茵藺蚓認隣靭靷鱗麟一佚佾壹日溢逸鎰馹任壬妊姙恁林淋稔臨荏賃入卄"],["eda1","立笠粒仍剩孕芿仔刺咨姉姿子字孜恣慈滋炙煮玆瓷疵磁紫者自茨蔗藉諮資雌作勺嚼斫昨灼炸爵綽芍酌雀鵲孱棧殘潺盞岑暫潛箴簪蠶雜丈仗匠場墻壯奬將帳庄張掌暲杖樟檣欌漿牆狀獐璋章粧腸臟臧莊葬蔣薔藏裝贓醬長"],["eea1","障再哉在宰才材栽梓渽滓災縡裁財載齋齎爭箏諍錚佇低儲咀姐底抵杵楮樗沮渚狙猪疽箸紵苧菹著藷詛貯躇這邸雎齟勣吊嫡寂摘敵滴狄炙的積笛籍績翟荻謫賊赤跡蹟迪迹適鏑佃佺傳全典前剪塡塼奠專展廛悛戰栓殿氈澱"],["efa1","煎琠田甸畑癲筌箋箭篆纏詮輾轉鈿銓錢鐫電顚顫餞切截折浙癤竊節絶占岾店漸点粘霑鮎點接摺蝶丁井亭停偵呈姃定幀庭廷征情挺政整旌晶晸柾楨檉正汀淀淨渟湞瀞炡玎珽町睛碇禎程穽精綎艇訂諪貞鄭酊釘鉦鋌錠霆靖"],["f0a1","靜頂鼎制劑啼堤帝弟悌提梯濟祭第臍薺製諸蹄醍除際霽題齊俎兆凋助嘲弔彫措操早晁曺曹朝條棗槽漕潮照燥爪璪眺祖祚租稠窕粗糟組繰肇藻蚤詔調趙躁造遭釣阻雕鳥族簇足鏃存尊卒拙猝倧宗從悰慫棕淙琮種終綜縱腫"],["f1a1","踪踵鍾鐘佐坐左座挫罪主住侏做姝胄呪周嗾奏宙州廚晝朱柱株注洲湊澍炷珠疇籌紂紬綢舟蛛註誅走躊輳週酎酒鑄駐竹粥俊儁准埈寯峻晙樽浚準濬焌畯竣蠢逡遵雋駿茁中仲衆重卽櫛楫汁葺增憎曾拯烝甑症繒蒸證贈之只"],["f2a1","咫地址志持指摯支旨智枝枳止池沚漬知砥祉祗紙肢脂至芝芷蜘誌識贄趾遲直稙稷織職唇嗔塵振搢晉晋桭榛殄津溱珍瑨璡畛疹盡眞瞋秦縉縝臻蔯袗診賑軫辰進鎭陣陳震侄叱姪嫉帙桎瓆疾秩窒膣蛭質跌迭斟朕什執潗緝輯"],["f3a1","鏶集徵懲澄且侘借叉嗟嵯差次此磋箚茶蹉車遮捉搾着窄錯鑿齪撰澯燦璨瓚竄簒纂粲纘讚贊鑽餐饌刹察擦札紮僭參塹慘慙懺斬站讒讖倉倡創唱娼廠彰愴敞昌昶暢槍滄漲猖瘡窓脹艙菖蒼債埰寀寨彩採砦綵菜蔡采釵冊柵策"],["f4a1","責凄妻悽處倜刺剔尺慽戚拓擲斥滌瘠脊蹠陟隻仟千喘天川擅泉淺玔穿舛薦賤踐遷釧闡阡韆凸哲喆徹撤澈綴輟轍鐵僉尖沾添甛瞻簽籤詹諂堞妾帖捷牒疊睫諜貼輒廳晴淸聽菁請靑鯖切剃替涕滯締諦逮遞體初剿哨憔抄招梢"],["f5a1","椒楚樵炒焦硝礁礎秒稍肖艸苕草蕉貂超酢醋醮促囑燭矗蜀觸寸忖村邨叢塚寵悤憁摠總聰蔥銃撮催崔最墜抽推椎楸樞湫皺秋芻萩諏趨追鄒酋醜錐錘鎚雛騶鰍丑畜祝竺筑築縮蓄蹙蹴軸逐春椿瑃出朮黜充忠沖蟲衝衷悴膵萃"],["f6a1","贅取吹嘴娶就炊翠聚脆臭趣醉驟鷲側仄厠惻測層侈値嗤峙幟恥梔治淄熾痔痴癡稚穉緇緻置致蚩輜雉馳齒則勅飭親七柒漆侵寢枕沈浸琛砧針鍼蟄秤稱快他咤唾墮妥惰打拖朶楕舵陀馱駝倬卓啄坼度托拓擢晫柝濁濯琢琸託"],["f7a1","鐸呑嘆坦彈憚歎灘炭綻誕奪脫探眈耽貪塔搭榻宕帑湯糖蕩兌台太怠態殆汰泰笞胎苔跆邰颱宅擇澤撑攄兎吐土討慟桶洞痛筒統通堆槌腿褪退頹偸套妬投透鬪慝特闖坡婆巴把播擺杷波派爬琶破罷芭跛頗判坂板版瓣販辦鈑"],["f8a1","阪八叭捌佩唄悖敗沛浿牌狽稗覇貝彭澎烹膨愎便偏扁片篇編翩遍鞭騙貶坪平枰萍評吠嬖幣廢弊斃肺蔽閉陛佈包匍匏咆哺圃布怖抛抱捕暴泡浦疱砲胞脯苞葡蒲袍褒逋鋪飽鮑幅暴曝瀑爆輻俵剽彪慓杓標漂瓢票表豹飇飄驃"],["f9a1","品稟楓諷豊風馮彼披疲皮被避陂匹弼必泌珌畢疋筆苾馝乏逼下何厦夏廈昰河瑕荷蝦賀遐霞鰕壑學虐謔鶴寒恨悍旱汗漢澣瀚罕翰閑閒限韓割轄函含咸啣喊檻涵緘艦銜陷鹹合哈盒蛤閤闔陜亢伉姮嫦巷恒抗杭桁沆港缸肛航"],["faa1","行降項亥偕咳垓奚孩害懈楷海瀣蟹解該諧邂駭骸劾核倖幸杏荇行享向嚮珦鄕響餉饗香噓墟虛許憲櫶獻軒歇險驗奕爀赫革俔峴弦懸晛泫炫玄玹現眩睍絃絢縣舷衒見賢鉉顯孑穴血頁嫌俠協夾峽挾浹狹脅脇莢鋏頰亨兄刑型"],["fba1","形泂滎瀅灐炯熒珩瑩荊螢衡逈邢鎣馨兮彗惠慧暳蕙蹊醯鞋乎互呼壕壺好岵弧戶扈昊晧毫浩淏湖滸澔濠濩灝狐琥瑚瓠皓祜糊縞胡芦葫蒿虎號蝴護豪鎬頀顥惑或酷婚昏混渾琿魂忽惚笏哄弘汞泓洪烘紅虹訌鴻化和嬅樺火畵"],["fca1","禍禾花華話譁貨靴廓擴攫確碻穫丸喚奐宦幻患換歡晥桓渙煥環紈還驩鰥活滑猾豁闊凰幌徨恍惶愰慌晃晄榥況湟滉潢煌璜皇篁簧荒蝗遑隍黃匯回廻徊恢悔懷晦會檜淮澮灰獪繪膾茴蛔誨賄劃獲宖橫鐄哮嚆孝效斅曉梟涍淆"],["fda1","爻肴酵驍侯候厚后吼喉嗅帿後朽煦珝逅勛勳塤壎焄熏燻薰訓暈薨喧暄煊萱卉喙毁彙徽揮暉煇諱輝麾休携烋畦虧恤譎鷸兇凶匈洶胸黑昕欣炘痕吃屹紇訖欠欽歆吸恰洽翕興僖凞喜噫囍姬嬉希憙憘戱晞曦熙熹熺犧禧稀羲詰"]]');
            }
          ),
          /***/
          72324: (
            /***/
            function(u) {
              u.exports = /* @__PURE__ */ JSON.parse('[["0","\\u0000",127],["a140","　，、。．‧；：？！︰…‥﹐﹑﹒·﹔﹕﹖﹗｜–︱—︳╴︴﹏（）︵︶｛｝︷︸〔〕︹︺【】︻︼《》︽︾〈〉︿﹀「」﹁﹂『』﹃﹄﹙﹚"],["a1a1","﹛﹜﹝﹞‘’“”〝〞‵′＃＆＊※§〃○●△▲◎☆★◇◆□■▽▼㊣℅¯￣＿ˍ﹉﹊﹍﹎﹋﹌﹟﹠﹡＋－×÷±√＜＞＝≦≧≠∞≒≡﹢",4,"～∩∪⊥∠∟⊿㏒㏑∫∮∵∴♀♂⊕⊙↑↓←→↖↗↙↘∥∣／"],["a240","＼∕﹨＄￥〒￠￡％＠℃℉﹩﹪﹫㏕㎜㎝㎞㏎㎡㎎㎏㏄°兙兛兞兝兡兣嗧瓩糎▁",7,"▏▎▍▌▋▊▉┼┴┬┤├▔─│▕┌┐└┘╭"],["a2a1","╮╰╯═╞╪╡◢◣◥◤╱╲╳０",9,"Ⅰ",9,"〡",8,"十卄卅Ａ",25,"ａ",21],["a340","ｗｘｙｚΑ",16,"Σ",6,"α",16,"σ",6,"ㄅ",10],["a3a1","ㄐ",25,"˙ˉˊˇˋ"],["a3e1","€"],["a440","一乙丁七乃九了二人儿入八几刀刁力匕十卜又三下丈上丫丸凡久么也乞于亡兀刃勺千叉口土士夕大女子孑孓寸小尢尸山川工己已巳巾干廾弋弓才"],["a4a1","丑丐不中丰丹之尹予云井互五亢仁什仃仆仇仍今介仄元允內六兮公冗凶分切刈勻勾勿化匹午升卅卞厄友及反壬天夫太夭孔少尤尺屯巴幻廿弔引心戈戶手扎支文斗斤方日曰月木欠止歹毋比毛氏水火爪父爻片牙牛犬王丙"],["a540","世丕且丘主乍乏乎以付仔仕他仗代令仙仞充兄冉冊冬凹出凸刊加功包匆北匝仟半卉卡占卯卮去可古右召叮叩叨叼司叵叫另只史叱台句叭叻四囚外"],["a5a1","央失奴奶孕它尼巨巧左市布平幼弁弘弗必戊打扔扒扑斥旦朮本未末札正母民氐永汁汀氾犯玄玉瓜瓦甘生用甩田由甲申疋白皮皿目矛矢石示禾穴立丞丟乒乓乩亙交亦亥仿伉伙伊伕伍伐休伏仲件任仰仳份企伋光兇兆先全"],["a640","共再冰列刑划刎刖劣匈匡匠印危吉吏同吊吐吁吋各向名合吃后吆吒因回囝圳地在圭圬圯圩夙多夷夸妄奸妃好她如妁字存宇守宅安寺尖屹州帆并年"],["a6a1","式弛忙忖戎戌戍成扣扛托收早旨旬旭曲曳有朽朴朱朵次此死氖汝汗汙江池汐汕污汛汍汎灰牟牝百竹米糸缶羊羽老考而耒耳聿肉肋肌臣自至臼舌舛舟艮色艾虫血行衣西阡串亨位住佇佗佞伴佛何估佐佑伽伺伸佃佔似但佣"],["a740","作你伯低伶余佝佈佚兌克免兵冶冷別判利刪刨劫助努劬匣即卵吝吭吞吾否呎吧呆呃吳呈呂君吩告吹吻吸吮吵吶吠吼呀吱含吟听囪困囤囫坊坑址坍"],["a7a1","均坎圾坐坏圻壯夾妝妒妨妞妣妙妖妍妤妓妊妥孝孜孚孛完宋宏尬局屁尿尾岐岑岔岌巫希序庇床廷弄弟彤形彷役忘忌志忍忱快忸忪戒我抄抗抖技扶抉扭把扼找批扳抒扯折扮投抓抑抆改攻攸旱更束李杏材村杜杖杞杉杆杠"],["a840","杓杗步每求汞沙沁沈沉沅沛汪決沐汰沌汨沖沒汽沃汲汾汴沆汶沍沔沘沂灶灼災灸牢牡牠狄狂玖甬甫男甸皂盯矣私秀禿究系罕肖肓肝肘肛肚育良芒"],["a8a1","芋芍見角言谷豆豕貝赤走足身車辛辰迂迆迅迄巡邑邢邪邦那酉釆里防阮阱阪阬並乖乳事些亞享京佯依侍佳使佬供例來侃佰併侈佩佻侖佾侏侑佺兔兒兕兩具其典冽函刻券刷刺到刮制剁劾劻卒協卓卑卦卷卸卹取叔受味呵"],["a940","咖呸咕咀呻呷咄咒咆呼咐呱呶和咚呢周咋命咎固垃坷坪坩坡坦坤坼夜奉奇奈奄奔妾妻委妹妮姑姆姐姍始姓姊妯妳姒姅孟孤季宗定官宜宙宛尚屈居"],["a9a1","屆岷岡岸岩岫岱岳帘帚帖帕帛帑幸庚店府底庖延弦弧弩往征彿彼忝忠忽念忿怏怔怯怵怖怪怕怡性怩怫怛或戕房戾所承拉拌拄抿拂抹拒招披拓拔拋拈抨抽押拐拙拇拍抵拚抱拘拖拗拆抬拎放斧於旺昔易昌昆昂明昀昏昕昊"],["aa40","昇服朋杭枋枕東果杳杷枇枝林杯杰板枉松析杵枚枓杼杪杲欣武歧歿氓氛泣注泳沱泌泥河沽沾沼波沫法泓沸泄油況沮泗泅泱沿治泡泛泊沬泯泜泖泠"],["aaa1","炕炎炒炊炙爬爭爸版牧物狀狎狙狗狐玩玨玟玫玥甽疝疙疚的盂盲直知矽社祀祁秉秈空穹竺糾罔羌羋者肺肥肢肱股肫肩肴肪肯臥臾舍芳芝芙芭芽芟芹花芬芥芯芸芣芰芾芷虎虱初表軋迎返近邵邸邱邶采金長門阜陀阿阻附"],["ab40","陂隹雨青非亟亭亮信侵侯便俠俑俏保促侶俘俟俊俗侮俐俄係俚俎俞侷兗冒冑冠剎剃削前剌剋則勇勉勃勁匍南卻厚叛咬哀咨哎哉咸咦咳哇哂咽咪品"],["aba1","哄哈咯咫咱咻咩咧咿囿垂型垠垣垢城垮垓奕契奏奎奐姜姘姿姣姨娃姥姪姚姦威姻孩宣宦室客宥封屎屏屍屋峙峒巷帝帥帟幽庠度建弈弭彥很待徊律徇後徉怒思怠急怎怨恍恰恨恢恆恃恬恫恪恤扁拜挖按拼拭持拮拽指拱拷"],["ac40","拯括拾拴挑挂政故斫施既春昭映昧是星昨昱昤曷柿染柱柔某柬架枯柵柩柯柄柑枴柚查枸柏柞柳枰柙柢柝柒歪殃殆段毒毗氟泉洋洲洪流津洌洱洞洗"],["aca1","活洽派洶洛泵洹洧洸洩洮洵洎洫炫為炳炬炯炭炸炮炤爰牲牯牴狩狠狡玷珊玻玲珍珀玳甚甭畏界畎畋疫疤疥疢疣癸皆皇皈盈盆盃盅省盹相眉看盾盼眇矜砂研砌砍祆祉祈祇禹禺科秒秋穿突竿竽籽紂紅紀紉紇約紆缸美羿耄"],["ad40","耐耍耑耶胖胥胚胃胄背胡胛胎胞胤胝致舢苧范茅苣苛苦茄若茂茉苒苗英茁苜苔苑苞苓苟苯茆虐虹虻虺衍衫要觔計訂訃貞負赴赳趴軍軌述迦迢迪迥"],["ada1","迭迫迤迨郊郎郁郃酋酊重閂限陋陌降面革韋韭音頁風飛食首香乘亳倌倍倣俯倦倥俸倩倖倆值借倚倒們俺倀倔倨俱倡個候倘俳修倭倪俾倫倉兼冤冥冢凍凌准凋剖剜剔剛剝匪卿原厝叟哨唐唁唷哼哥哲唆哺唔哩哭員唉哮哪"],["ae40","哦唧唇哽唏圃圄埂埔埋埃堉夏套奘奚娑娘娜娟娛娓姬娠娣娩娥娌娉孫屘宰害家宴宮宵容宸射屑展屐峭峽峻峪峨峰島崁峴差席師庫庭座弱徒徑徐恙"],["aea1","恣恥恐恕恭恩息悄悟悚悍悔悌悅悖扇拳挈拿捎挾振捕捂捆捏捉挺捐挽挪挫挨捍捌效敉料旁旅時晉晏晃晒晌晅晁書朔朕朗校核案框桓根桂桔栩梳栗桌桑栽柴桐桀格桃株桅栓栘桁殊殉殷氣氧氨氦氤泰浪涕消涇浦浸海浙涓"],["af40","浬涉浮浚浴浩涌涊浹涅浥涔烊烘烤烙烈烏爹特狼狹狽狸狷玆班琉珮珠珪珞畔畝畜畚留疾病症疲疳疽疼疹痂疸皋皰益盍盎眩真眠眨矩砰砧砸砝破砷"],["afa1","砥砭砠砟砲祕祐祠祟祖神祝祗祚秤秣秧租秦秩秘窄窈站笆笑粉紡紗紋紊素索純紐紕級紜納紙紛缺罟羔翅翁耆耘耕耙耗耽耿胱脂胰脅胭胴脆胸胳脈能脊胼胯臭臬舀舐航舫舨般芻茫荒荔荊茸荐草茵茴荏茲茹茶茗荀茱茨荃"],["b040","虔蚊蚪蚓蚤蚩蚌蚣蚜衰衷袁袂衽衹記訐討訌訕訊託訓訖訏訑豈豺豹財貢起躬軒軔軏辱送逆迷退迺迴逃追逅迸邕郡郝郢酒配酌釘針釗釜釙閃院陣陡"],["b0a1","陛陝除陘陞隻飢馬骨高鬥鬲鬼乾偺偽停假偃偌做偉健偶偎偕偵側偷偏倏偯偭兜冕凰剪副勒務勘動匐匏匙匿區匾參曼商啪啦啄啞啡啃啊唱啖問啕唯啤唸售啜唬啣唳啁啗圈國圉域堅堊堆埠埤基堂堵執培夠奢娶婁婉婦婪婀"],["b140","娼婢婚婆婊孰寇寅寄寂宿密尉專將屠屜屝崇崆崎崛崖崢崑崩崔崙崤崧崗巢常帶帳帷康庸庶庵庾張強彗彬彩彫得徙從徘御徠徜恿患悉悠您惋悴惦悽"],["b1a1","情悻悵惜悼惘惕惆惟悸惚惇戚戛扈掠控捲掖探接捷捧掘措捱掩掉掃掛捫推掄授掙採掬排掏掀捻捩捨捺敝敖救教敗啟敏敘敕敔斜斛斬族旋旌旎晝晚晤晨晦晞曹勗望梁梯梢梓梵桿桶梱梧梗械梃棄梭梆梅梔條梨梟梡梂欲殺"],["b240","毫毬氫涎涼淳淙液淡淌淤添淺清淇淋涯淑涮淞淹涸混淵淅淒渚涵淚淫淘淪深淮淨淆淄涪淬涿淦烹焉焊烽烯爽牽犁猜猛猖猓猙率琅琊球理現琍瓠瓶"],["b2a1","瓷甜產略畦畢異疏痔痕疵痊痍皎盔盒盛眷眾眼眶眸眺硫硃硎祥票祭移窒窕笠笨笛第符笙笞笮粒粗粕絆絃統紮紹紼絀細紳組累終紲紱缽羞羚翌翎習耜聊聆脯脖脣脫脩脰脤舂舵舷舶船莎莞莘荸莢莖莽莫莒莊莓莉莠荷荻荼"],["b340","莆莧處彪蛇蛀蚶蛄蚵蛆蛋蚱蚯蛉術袞袈被袒袖袍袋覓規訪訝訣訥許設訟訛訢豉豚販責貫貨貪貧赧赦趾趺軛軟這逍通逗連速逝逐逕逞造透逢逖逛途"],["b3a1","部郭都酗野釵釦釣釧釭釩閉陪陵陳陸陰陴陶陷陬雀雪雩章竟頂頃魚鳥鹵鹿麥麻傢傍傅備傑傀傖傘傚最凱割剴創剩勞勝勛博厥啻喀喧啼喊喝喘喂喜喪喔喇喋喃喳單喟唾喲喚喻喬喱啾喉喫喙圍堯堪場堤堰報堡堝堠壹壺奠"],["b440","婷媚婿媒媛媧孳孱寒富寓寐尊尋就嵌嵐崴嵇巽幅帽幀幃幾廊廁廂廄弼彭復循徨惑惡悲悶惠愜愣惺愕惰惻惴慨惱愎惶愉愀愒戟扉掣掌描揀揩揉揆揍"],["b4a1","插揣提握揖揭揮捶援揪換摒揚揹敞敦敢散斑斐斯普晰晴晶景暑智晾晷曾替期朝棺棕棠棘棗椅棟棵森棧棹棒棲棣棋棍植椒椎棉棚楮棻款欺欽殘殖殼毯氮氯氬港游湔渡渲湧湊渠渥渣減湛湘渤湖湮渭渦湯渴湍渺測湃渝渾滋"],["b540","溉渙湎湣湄湲湩湟焙焚焦焰無然煮焜牌犄犀猶猥猴猩琺琪琳琢琥琵琶琴琯琛琦琨甥甦畫番痢痛痣痙痘痞痠登發皖皓皴盜睏短硝硬硯稍稈程稅稀窘"],["b5a1","窗窖童竣等策筆筐筒答筍筋筏筑粟粥絞結絨絕紫絮絲絡給絢絰絳善翔翕耋聒肅腕腔腋腑腎脹腆脾腌腓腴舒舜菩萃菸萍菠菅萋菁華菱菴著萊菰萌菌菽菲菊萸萎萄菜萇菔菟虛蛟蛙蛭蛔蛛蛤蛐蛞街裁裂袱覃視註詠評詞証詁"],["b640","詔詛詐詆訴診訶詖象貂貯貼貳貽賁費賀貴買貶貿貸越超趁跎距跋跚跑跌跛跆軻軸軼辜逮逵週逸進逶鄂郵鄉郾酣酥量鈔鈕鈣鈉鈞鈍鈐鈇鈑閔閏開閑"],["b6a1","間閒閎隊階隋陽隅隆隍陲隄雁雅雄集雇雯雲韌項順須飧飪飯飩飲飭馮馭黃黍黑亂傭債傲傳僅傾催傷傻傯僇剿剷剽募勦勤勢勣匯嗟嗨嗓嗦嗎嗜嗇嗑嗣嗤嗯嗚嗡嗅嗆嗥嗉園圓塞塑塘塗塚塔填塌塭塊塢塒塋奧嫁嫉嫌媾媽媼"],["b740","媳嫂媲嵩嵯幌幹廉廈弒彙徬微愚意慈感想愛惹愁愈慎慌慄慍愾愴愧愍愆愷戡戢搓搾搞搪搭搽搬搏搜搔損搶搖搗搆敬斟新暗暉暇暈暖暄暘暍會榔業"],["b7a1","楚楷楠楔極椰概楊楨楫楞楓楹榆楝楣楛歇歲毀殿毓毽溢溯滓溶滂源溝滇滅溥溘溼溺溫滑準溜滄滔溪溧溴煎煙煩煤煉照煜煬煦煌煥煞煆煨煖爺牒猷獅猿猾瑯瑚瑕瑟瑞瑁琿瑙瑛瑜當畸瘀痰瘁痲痱痺痿痴痳盞盟睛睫睦睞督"],["b840","睹睪睬睜睥睨睢矮碎碰碗碘碌碉硼碑碓硿祺祿禁萬禽稜稚稠稔稟稞窟窠筷節筠筮筧粱粳粵經絹綑綁綏絛置罩罪署義羨群聖聘肆肄腱腰腸腥腮腳腫"],["b8a1","腹腺腦舅艇蒂葷落萱葵葦葫葉葬葛萼萵葡董葩葭葆虞虜號蛹蜓蜈蜇蜀蛾蛻蜂蜃蜆蜊衙裟裔裙補裘裝裡裊裕裒覜解詫該詳試詩詰誇詼詣誠話誅詭詢詮詬詹詻訾詨豢貊貉賊資賈賄貲賃賂賅跡跟跨路跳跺跪跤跦躲較載軾輊"],["b940","辟農運遊道遂達逼違遐遇遏過遍遑逾遁鄒鄗酬酪酩釉鈷鉗鈸鈽鉀鈾鉛鉋鉤鉑鈴鉉鉍鉅鈹鈿鉚閘隘隔隕雍雋雉雊雷電雹零靖靴靶預頑頓頊頒頌飼飴"],["b9a1","飽飾馳馱馴髡鳩麂鼎鼓鼠僧僮僥僖僭僚僕像僑僱僎僩兢凳劃劂匱厭嗾嘀嘛嘗嗽嘔嘆嘉嘍嘎嗷嘖嘟嘈嘐嗶團圖塵塾境墓墊塹墅塽壽夥夢夤奪奩嫡嫦嫩嫗嫖嫘嫣孵寞寧寡寥實寨寢寤察對屢嶄嶇幛幣幕幗幔廓廖弊彆彰徹慇"],["ba40","愿態慷慢慣慟慚慘慵截撇摘摔撤摸摟摺摑摧搴摭摻敲斡旗旖暢暨暝榜榨榕槁榮槓構榛榷榻榫榴槐槍榭槌榦槃榣歉歌氳漳演滾漓滴漩漾漠漬漏漂漢"],["baa1","滿滯漆漱漸漲漣漕漫漯澈漪滬漁滲滌滷熔熙煽熊熄熒爾犒犖獄獐瑤瑣瑪瑰瑭甄疑瘧瘍瘋瘉瘓盡監瞄睽睿睡磁碟碧碳碩碣禎福禍種稱窪窩竭端管箕箋筵算箝箔箏箸箇箄粹粽精綻綰綜綽綾綠緊綴網綱綺綢綿綵綸維緒緇綬"],["bb40","罰翠翡翟聞聚肇腐膀膏膈膊腿膂臧臺與舔舞艋蓉蒿蓆蓄蒙蒞蒲蒜蓋蒸蓀蓓蒐蒼蓑蓊蜿蜜蜻蜢蜥蜴蜘蝕蜷蜩裳褂裴裹裸製裨褚裯誦誌語誣認誡誓誤"],["bba1","說誥誨誘誑誚誧豪貍貌賓賑賒赫趙趕跼輔輒輕輓辣遠遘遜遣遙遞遢遝遛鄙鄘鄞酵酸酷酴鉸銀銅銘銖鉻銓銜銨鉼銑閡閨閩閣閥閤隙障際雌雒需靼鞅韶頗領颯颱餃餅餌餉駁骯骰髦魁魂鳴鳶鳳麼鼻齊億儀僻僵價儂儈儉儅凜"],["bc40","劇劈劉劍劊勰厲嘮嘻嘹嘲嘿嘴嘩噓噎噗噴嘶嘯嘰墀墟增墳墜墮墩墦奭嬉嫻嬋嫵嬌嬈寮寬審寫層履嶝嶔幢幟幡廢廚廟廝廣廠彈影德徵慶慧慮慝慕憂"],["bca1","慼慰慫慾憧憐憫憎憬憚憤憔憮戮摩摯摹撞撲撈撐撰撥撓撕撩撒撮播撫撚撬撙撢撳敵敷數暮暫暴暱樣樟槨樁樞標槽模樓樊槳樂樅槭樑歐歎殤毅毆漿潼澄潑潦潔澆潭潛潸潮澎潺潰潤澗潘滕潯潠潟熟熬熱熨牖犛獎獗瑩璋璃"],["bd40","瑾璀畿瘠瘩瘟瘤瘦瘡瘢皚皺盤瞎瞇瞌瞑瞋磋磅確磊碾磕碼磐稿稼穀稽稷稻窯窮箭箱範箴篆篇篁箠篌糊締練緯緻緘緬緝編緣線緞緩綞緙緲緹罵罷羯"],["bda1","翩耦膛膜膝膠膚膘蔗蔽蔚蓮蔬蔭蔓蔑蔣蔡蔔蓬蔥蓿蔆螂蝴蝶蝠蝦蝸蝨蝙蝗蝌蝓衛衝褐複褒褓褕褊誼諒談諄誕請諸課諉諂調誰論諍誶誹諛豌豎豬賠賞賦賤賬賭賢賣賜質賡赭趟趣踫踐踝踢踏踩踟踡踞躺輝輛輟輩輦輪輜輞"],["be40","輥適遮遨遭遷鄰鄭鄧鄱醇醉醋醃鋅銻銷鋪銬鋤鋁銳銼鋒鋇鋰銲閭閱霄霆震霉靠鞍鞋鞏頡頫頜颳養餓餒餘駝駐駟駛駑駕駒駙骷髮髯鬧魅魄魷魯鴆鴉"],["bea1","鴃麩麾黎墨齒儒儘儔儐儕冀冪凝劑劓勳噙噫噹噩噤噸噪器噥噱噯噬噢噶壁墾壇壅奮嬝嬴學寰導彊憲憑憩憊懍憶憾懊懈戰擅擁擋撻撼據擄擇擂操撿擒擔撾整曆曉暹曄曇暸樽樸樺橙橫橘樹橄橢橡橋橇樵機橈歙歷氅濂澱澡"],["bf40","濃澤濁澧澳激澹澶澦澠澴熾燉燐燒燈燕熹燎燙燜燃燄獨璜璣璘璟璞瓢甌甍瘴瘸瘺盧盥瞠瞞瞟瞥磨磚磬磧禦積穎穆穌穋窺篙簑築篤篛篡篩篦糕糖縊"],["bfa1","縑縈縛縣縞縝縉縐罹羲翰翱翮耨膳膩膨臻興艘艙蕊蕙蕈蕨蕩蕃蕉蕭蕪蕞螃螟螞螢融衡褪褲褥褫褡親覦諦諺諫諱謀諜諧諮諾謁謂諷諭諳諶諼豫豭貓賴蹄踱踴蹂踹踵輻輯輸輳辨辦遵遴選遲遼遺鄴醒錠錶鋸錳錯錢鋼錫錄錚"],["c040","錐錦錡錕錮錙閻隧隨險雕霎霑霖霍霓霏靛靜靦鞘頰頸頻頷頭頹頤餐館餞餛餡餚駭駢駱骸骼髻髭鬨鮑鴕鴣鴦鴨鴒鴛默黔龍龜優償儡儲勵嚎嚀嚐嚅嚇"],["c0a1","嚏壕壓壑壎嬰嬪嬤孺尷屨嶼嶺嶽嶸幫彌徽應懂懇懦懋戲戴擎擊擘擠擰擦擬擱擢擭斂斃曙曖檀檔檄檢檜櫛檣橾檗檐檠歜殮毚氈濘濱濟濠濛濤濫濯澀濬濡濩濕濮濰燧營燮燦燥燭燬燴燠爵牆獰獲璩環璦璨癆療癌盪瞳瞪瞰瞬"],["c140","瞧瞭矯磷磺磴磯礁禧禪穗窿簇簍篾篷簌篠糠糜糞糢糟糙糝縮績繆縷縲繃縫總縱繅繁縴縹繈縵縿縯罄翳翼聱聲聰聯聳臆臃膺臂臀膿膽臉膾臨舉艱薪"],["c1a1","薄蕾薜薑薔薯薛薇薨薊虧蟀蟑螳蟒蟆螫螻螺蟈蟋褻褶襄褸褽覬謎謗謙講謊謠謝謄謐豁谿豳賺賽購賸賻趨蹉蹋蹈蹊轄輾轂轅輿避遽還邁邂邀鄹醣醞醜鍍鎂錨鍵鍊鍥鍋錘鍾鍬鍛鍰鍚鍔闊闋闌闈闆隱隸雖霜霞鞠韓顆颶餵騁"],["c240","駿鮮鮫鮪鮭鴻鴿麋黏點黜黝黛鼾齋叢嚕嚮壙壘嬸彝懣戳擴擲擾攆擺擻擷斷曜朦檳檬櫃檻檸櫂檮檯歟歸殯瀉瀋濾瀆濺瀑瀏燻燼燾燸獷獵璧璿甕癖癘"],["c2a1","癒瞽瞿瞻瞼礎禮穡穢穠竄竅簫簧簪簞簣簡糧織繕繞繚繡繒繙罈翹翻職聶臍臏舊藏薩藍藐藉薰薺薹薦蟯蟬蟲蟠覆覲觴謨謹謬謫豐贅蹙蹣蹦蹤蹟蹕軀轉轍邇邃邈醫醬釐鎔鎊鎖鎢鎳鎮鎬鎰鎘鎚鎗闔闖闐闕離雜雙雛雞霤鞣鞦"],["c340","鞭韹額顏題顎顓颺餾餿餽餮馥騎髁鬃鬆魏魎魍鯊鯉鯽鯈鯀鵑鵝鵠黠鼕鼬儳嚥壞壟壢寵龐廬懲懷懶懵攀攏曠曝櫥櫝櫚櫓瀛瀟瀨瀚瀝瀕瀘爆爍牘犢獸"],["c3a1","獺璽瓊瓣疇疆癟癡矇礙禱穫穩簾簿簸簽簷籀繫繭繹繩繪羅繳羶羹羸臘藩藝藪藕藤藥藷蟻蠅蠍蟹蟾襠襟襖襞譁譜識證譚譎譏譆譙贈贊蹼蹲躇蹶蹬蹺蹴轔轎辭邊邋醱醮鏡鏑鏟鏃鏈鏜鏝鏖鏢鏍鏘鏤鏗鏨關隴難霪霧靡韜韻類"],["c440","願顛颼饅饉騖騙鬍鯨鯧鯖鯛鶉鵡鵲鵪鵬麒麗麓麴勸嚨嚷嚶嚴嚼壤孀孃孽寶巉懸懺攘攔攙曦朧櫬瀾瀰瀲爐獻瓏癢癥礦礪礬礫竇競籌籃籍糯糰辮繽繼"],["c4a1","纂罌耀臚艦藻藹蘑藺蘆蘋蘇蘊蠔蠕襤覺觸議譬警譯譟譫贏贍躉躁躅躂醴釋鐘鐃鏽闡霰飄饒饑馨騫騰騷騵鰓鰍鹹麵黨鼯齟齣齡儷儸囁囀囂夔屬巍懼懾攝攜斕曩櫻欄櫺殲灌爛犧瓖瓔癩矓籐纏續羼蘗蘭蘚蠣蠢蠡蠟襪襬覽譴"],["c540","護譽贓躊躍躋轟辯醺鐮鐳鐵鐺鐸鐲鐫闢霸霹露響顧顥饗驅驃驀騾髏魔魑鰭鰥鶯鶴鷂鶸麝黯鼙齜齦齧儼儻囈囊囉孿巔巒彎懿攤權歡灑灘玀瓤疊癮癬"],["c5a1","禳籠籟聾聽臟襲襯觼讀贖贗躑躓轡酈鑄鑑鑒霽霾韃韁顫饕驕驍髒鬚鱉鰱鰾鰻鷓鷗鼴齬齪龔囌巖戀攣攫攪曬欐瓚竊籤籣籥纓纖纔臢蘸蘿蠱變邐邏鑣鑠鑤靨顯饜驚驛驗髓體髑鱔鱗鱖鷥麟黴囑壩攬灞癱癲矗罐羈蠶蠹衢讓讒"],["c640","讖艷贛釀鑪靂靈靄韆顰驟鬢魘鱟鷹鷺鹼鹽鼇齷齲廳欖灣籬籮蠻觀躡釁鑲鑰顱饞髖鬣黌灤矚讚鑷韉驢驥纜讜躪釅鑽鑾鑼鱷鱸黷豔鑿鸚爨驪鬱鸛鸞籲"],["c940","乂乜凵匚厂万丌乇亍囗兀屮彳丏冇与丮亓仂仉仈冘勼卬厹圠夃夬尐巿旡殳毌气爿丱丼仨仜仩仡仝仚刌匜卌圢圣夗夯宁宄尒尻屴屳帄庀庂忉戉扐氕"],["c9a1","氶汃氿氻犮犰玊禸肊阞伎优伬仵伔仱伀价伈伝伂伅伢伓伄仴伒冱刓刉刐劦匢匟卍厊吇囡囟圮圪圴夼妀奼妅奻奾奷奿孖尕尥屼屺屻屾巟幵庄异弚彴忕忔忏扜扞扤扡扦扢扙扠扚扥旯旮朾朹朸朻机朿朼朳氘汆汒汜汏汊汔汋"],["ca40","汌灱牞犴犵玎甪癿穵网艸艼芀艽艿虍襾邙邗邘邛邔阢阤阠阣佖伻佢佉体佤伾佧佒佟佁佘伭伳伿佡冏冹刜刞刡劭劮匉卣卲厎厏吰吷吪呔呅吙吜吥吘"],["caa1","吽呏呁吨吤呇囮囧囥坁坅坌坉坋坒夆奀妦妘妠妗妎妢妐妏妧妡宎宒尨尪岍岏岈岋岉岒岊岆岓岕巠帊帎庋庉庌庈庍弅弝彸彶忒忑忐忭忨忮忳忡忤忣忺忯忷忻怀忴戺抃抌抎抏抔抇扱扻扺扰抁抈扷扽扲扴攷旰旴旳旲旵杅杇"],["cb40","杙杕杌杈杝杍杚杋毐氙氚汸汧汫沄沋沏汱汯汩沚汭沇沕沜汦汳汥汻沎灴灺牣犿犽狃狆狁犺狅玕玗玓玔玒町甹疔疕皁礽耴肕肙肐肒肜芐芏芅芎芑芓"],["cba1","芊芃芄豸迉辿邟邡邥邞邧邠阰阨阯阭丳侘佼侅佽侀侇佶佴侉侄佷佌侗佪侚佹侁佸侐侜侔侞侒侂侕佫佮冞冼冾刵刲刳剆刱劼匊匋匼厒厔咇呿咁咑咂咈呫呺呾呥呬呴呦咍呯呡呠咘呣呧呤囷囹坯坲坭坫坱坰坶垀坵坻坳坴坢"],["cc40","坨坽夌奅妵妺姏姎妲姌姁妶妼姃姖妱妽姀姈妴姇孢孥宓宕屄屇岮岤岠岵岯岨岬岟岣岭岢岪岧岝岥岶岰岦帗帔帙弨弢弣弤彔徂彾彽忞忥怭怦怙怲怋"],["cca1","怴怊怗怳怚怞怬怢怍怐怮怓怑怌怉怜戔戽抭抴拑抾抪抶拊抮抳抯抻抩抰抸攽斨斻昉旼昄昒昈旻昃昋昍昅旽昑昐曶朊枅杬枎枒杶杻枘枆构杴枍枌杺枟枑枙枃杽极杸杹枔欥殀歾毞氝沓泬泫泮泙沶泔沭泧沷泐泂沺泃泆泭泲"],["cd40","泒泝沴沊沝沀泞泀洰泍泇沰泹泏泩泑炔炘炅炓炆炄炑炖炂炚炃牪狖狋狘狉狜狒狔狚狌狑玤玡玭玦玢玠玬玝瓝瓨甿畀甾疌疘皯盳盱盰盵矸矼矹矻矺"],["cda1","矷祂礿秅穸穻竻籵糽耵肏肮肣肸肵肭舠芠苀芫芚芘芛芵芧芮芼芞芺芴芨芡芩苂芤苃芶芢虰虯虭虮豖迒迋迓迍迖迕迗邲邴邯邳邰阹阽阼阺陃俍俅俓侲俉俋俁俔俜俙侻侳俛俇俖侺俀侹俬剄剉勀勂匽卼厗厖厙厘咺咡咭咥哏"],["ce40","哃茍咷咮哖咶哅哆咠呰咼咢咾呲哞咰垵垞垟垤垌垗垝垛垔垘垏垙垥垚垕壴复奓姡姞姮娀姱姝姺姽姼姶姤姲姷姛姩姳姵姠姾姴姭宨屌峐峘峌峗峋峛"],["cea1","峞峚峉峇峊峖峓峔峏峈峆峎峟峸巹帡帢帣帠帤庰庤庢庛庣庥弇弮彖徆怷怹恔恲恞恅恓恇恉恛恌恀恂恟怤恄恘恦恮扂扃拏挍挋拵挎挃拫拹挏挌拸拶挀挓挔拺挕拻拰敁敃斪斿昶昡昲昵昜昦昢昳昫昺昝昴昹昮朏朐柁柲柈枺"],["cf40","柜枻柸柘柀枷柅柫柤柟枵柍枳柷柶柮柣柂枹柎柧柰枲柼柆柭柌枮柦柛柺柉柊柃柪柋欨殂殄殶毖毘毠氠氡洨洴洭洟洼洿洒洊泚洳洄洙洺洚洑洀洝浂"],["cfa1","洁洘洷洃洏浀洇洠洬洈洢洉洐炷炟炾炱炰炡炴炵炩牁牉牊牬牰牳牮狊狤狨狫狟狪狦狣玅珌珂珈珅玹玶玵玴珫玿珇玾珃珆玸珋瓬瓮甮畇畈疧疪癹盄眈眃眄眅眊盷盻盺矧矨砆砑砒砅砐砏砎砉砃砓祊祌祋祅祄秕种秏秖秎窀"],["d040","穾竑笀笁籺籸籹籿粀粁紃紈紁罘羑羍羾耇耎耏耔耷胘胇胠胑胈胂胐胅胣胙胜胊胕胉胏胗胦胍臿舡芔苙苾苹茇苨茀苕茺苫苖苴苬苡苲苵茌苻苶苰苪"],["d0a1","苤苠苺苳苭虷虴虼虳衁衎衧衪衩觓訄訇赲迣迡迮迠郱邽邿郕郅邾郇郋郈釔釓陔陏陑陓陊陎倞倅倇倓倢倰倛俵俴倳倷倬俶俷倗倜倠倧倵倯倱倎党冔冓凊凄凅凈凎剡剚剒剞剟剕剢勍匎厞唦哢唗唒哧哳哤唚哿唄唈哫唑唅哱"],["d140","唊哻哷哸哠唎唃唋圁圂埌堲埕埒垺埆垽垼垸垶垿埇埐垹埁夎奊娙娖娭娮娕娏娗娊娞娳孬宧宭宬尃屖屔峬峿峮峱峷崀峹帩帨庨庮庪庬弳弰彧恝恚恧"],["d1a1","恁悢悈悀悒悁悝悃悕悛悗悇悜悎戙扆拲挐捖挬捄捅挶捃揤挹捋捊挼挩捁挴捘捔捙挭捇挳捚捑挸捗捀捈敊敆旆旃旄旂晊晟晇晑朒朓栟栚桉栲栳栻桋桏栖栱栜栵栫栭栯桎桄栴栝栒栔栦栨栮桍栺栥栠欬欯欭欱欴歭肂殈毦毤"],["d240","毨毣毢毧氥浺浣浤浶洍浡涒浘浢浭浯涑涍淯浿涆浞浧浠涗浰浼浟涂涘洯浨涋浾涀涄洖涃浻浽浵涐烜烓烑烝烋缹烢烗烒烞烠烔烍烅烆烇烚烎烡牂牸"],["d2a1","牷牶猀狺狴狾狶狳狻猁珓珙珥珖玼珧珣珩珜珒珛珔珝珚珗珘珨瓞瓟瓴瓵甡畛畟疰痁疻痄痀疿疶疺皊盉眝眛眐眓眒眣眑眕眙眚眢眧砣砬砢砵砯砨砮砫砡砩砳砪砱祔祛祏祜祓祒祑秫秬秠秮秭秪秜秞秝窆窉窅窋窌窊窇竘笐"],["d340","笄笓笅笏笈笊笎笉笒粄粑粊粌粈粍粅紞紝紑紎紘紖紓紟紒紏紌罜罡罞罠罝罛羖羒翃翂翀耖耾耹胺胲胹胵脁胻脀舁舯舥茳茭荄茙荑茥荖茿荁茦茜茢"],["d3a1","荂荎茛茪茈茼荍茖茤茠茷茯茩荇荅荌荓茞茬荋茧荈虓虒蚢蚨蚖蚍蚑蚞蚇蚗蚆蚋蚚蚅蚥蚙蚡蚧蚕蚘蚎蚝蚐蚔衃衄衭衵衶衲袀衱衿衯袃衾衴衼訒豇豗豻貤貣赶赸趵趷趶軑軓迾迵适迿迻逄迼迶郖郠郙郚郣郟郥郘郛郗郜郤酐"],["d440","酎酏釕釢釚陜陟隼飣髟鬯乿偰偪偡偞偠偓偋偝偲偈偍偁偛偊偢倕偅偟偩偫偣偤偆偀偮偳偗偑凐剫剭剬剮勖勓匭厜啵啶唼啍啐唴唪啑啢唶唵唰啒啅"],["d4a1","唌唲啥啎唹啈唭唻啀啋圊圇埻堔埢埶埜埴堀埭埽堈埸堋埳埏堇埮埣埲埥埬埡堎埼堐埧堁堌埱埩埰堍堄奜婠婘婕婧婞娸娵婭婐婟婥婬婓婤婗婃婝婒婄婛婈媎娾婍娹婌婰婩婇婑婖婂婜孲孮寁寀屙崞崋崝崚崠崌崨崍崦崥崏"],["d540","崰崒崣崟崮帾帴庱庴庹庲庳弶弸徛徖徟悊悐悆悾悰悺惓惔惏惤惙惝惈悱惛悷惊悿惃惍惀挲捥掊掂捽掽掞掭掝掗掫掎捯掇掐据掯捵掜捭掮捼掤挻掟"],["d5a1","捸掅掁掑掍捰敓旍晥晡晛晙晜晢朘桹梇梐梜桭桮梮梫楖桯梣梬梩桵桴梲梏桷梒桼桫桲梪梀桱桾梛梖梋梠梉梤桸桻梑梌梊桽欶欳欷欸殑殏殍殎殌氪淀涫涴涳湴涬淩淢涷淶淔渀淈淠淟淖涾淥淜淝淛淴淊涽淭淰涺淕淂淏淉"],["d640","淐淲淓淽淗淍淣涻烺焍烷焗烴焌烰焄烳焐烼烿焆焓焀烸烶焋焂焎牾牻牼牿猝猗猇猑猘猊猈狿猏猞玈珶珸珵琄琁珽琇琀珺珼珿琌琋珴琈畤畣痎痒痏"],["d6a1","痋痌痑痐皏皉盓眹眯眭眱眲眴眳眽眥眻眵硈硒硉硍硊硌砦硅硐祤祧祩祪祣祫祡离秺秸秶秷窏窔窐笵筇笴笥笰笢笤笳笘笪笝笱笫笭笯笲笸笚笣粔粘粖粣紵紽紸紶紺絅紬紩絁絇紾紿絊紻紨罣羕羜羝羛翊翋翍翐翑翇翏翉耟"],["d740","耞耛聇聃聈脘脥脙脛脭脟脬脞脡脕脧脝脢舑舸舳舺舴舲艴莐莣莨莍荺荳莤荴莏莁莕莙荵莔莩荽莃莌莝莛莪莋荾莥莯莈莗莰荿莦莇莮荶莚虙虖蚿蚷"],["d7a1","蛂蛁蛅蚺蚰蛈蚹蚳蚸蛌蚴蚻蚼蛃蚽蚾衒袉袕袨袢袪袚袑袡袟袘袧袙袛袗袤袬袌袓袎覂觖觙觕訰訧訬訞谹谻豜豝豽貥赽赻赹趼跂趹趿跁軘軞軝軜軗軠軡逤逋逑逜逌逡郯郪郰郴郲郳郔郫郬郩酖酘酚酓酕釬釴釱釳釸釤釹釪"],["d840","釫釷釨釮镺閆閈陼陭陫陱陯隿靪頄飥馗傛傕傔傞傋傣傃傌傎傝偨傜傒傂傇兟凔匒匑厤厧喑喨喥喭啷噅喢喓喈喏喵喁喣喒喤啽喌喦啿喕喡喎圌堩堷"],["d8a1","堙堞堧堣堨埵塈堥堜堛堳堿堶堮堹堸堭堬堻奡媯媔媟婺媢媞婸媦婼媥媬媕媮娷媄媊媗媃媋媩婻婽媌媜媏媓媝寪寍寋寔寑寊寎尌尰崷嵃嵫嵁嵋崿崵嵑嵎嵕崳崺嵒崽崱嵙嵂崹嵉崸崼崲崶嵀嵅幄幁彘徦徥徫惉悹惌惢惎惄愔"],["d940","惲愊愖愅惵愓惸惼惾惁愃愘愝愐惿愄愋扊掔掱掰揎揥揨揯揃撝揳揊揠揶揕揲揵摡揟掾揝揜揄揘揓揂揇揌揋揈揰揗揙攲敧敪敤敜敨敥斌斝斞斮旐旒"],["d9a1","晼晬晻暀晱晹晪晲朁椌棓椄棜椪棬棪棱椏棖棷棫棤棶椓椐棳棡椇棌椈楰梴椑棯棆椔棸棐棽棼棨椋椊椗棎棈棝棞棦棴棑椆棔棩椕椥棇欹欻欿欼殔殗殙殕殽毰毲毳氰淼湆湇渟湉溈渼渽湅湢渫渿湁湝湳渜渳湋湀湑渻渃渮湞"],["da40","湨湜湡渱渨湠湱湫渹渢渰湓湥渧湸湤湷湕湹湒湦渵渶湚焠焞焯烻焮焱焣焥焢焲焟焨焺焛牋牚犈犉犆犅犋猒猋猰猢猱猳猧猲猭猦猣猵猌琮琬琰琫琖"],["daa1","琚琡琭琱琤琣琝琩琠琲瓻甯畯畬痧痚痡痦痝痟痤痗皕皒盚睆睇睄睍睅睊睎睋睌矞矬硠硤硥硜硭硱硪确硰硩硨硞硢祴祳祲祰稂稊稃稌稄窙竦竤筊笻筄筈筌筎筀筘筅粢粞粨粡絘絯絣絓絖絧絪絏絭絜絫絒絔絩絑絟絎缾缿罥"],["db40","罦羢羠羡翗聑聏聐胾胔腃腊腒腏腇脽腍脺臦臮臷臸臹舄舼舽舿艵茻菏菹萣菀菨萒菧菤菼菶萐菆菈菫菣莿萁菝菥菘菿菡菋菎菖菵菉萉萏菞萑萆菂菳"],["dba1","菕菺菇菑菪萓菃菬菮菄菻菗菢萛菛菾蛘蛢蛦蛓蛣蛚蛪蛝蛫蛜蛬蛩蛗蛨蛑衈衖衕袺裗袹袸裀袾袶袼袷袽袲褁裉覕覘覗觝觚觛詎詍訹詙詀詗詘詄詅詒詈詑詊詌詏豟貁貀貺貾貰貹貵趄趀趉跘跓跍跇跖跜跏跕跙跈跗跅軯軷軺"],["dc40","軹軦軮軥軵軧軨軶軫軱軬軴軩逭逴逯鄆鄬鄄郿郼鄈郹郻鄁鄀鄇鄅鄃酡酤酟酢酠鈁鈊鈥鈃鈚鈦鈏鈌鈀鈒釿釽鈆鈄鈧鈂鈜鈤鈙鈗鈅鈖镻閍閌閐隇陾隈"],["dca1","隉隃隀雂雈雃雱雰靬靰靮頇颩飫鳦黹亃亄亶傽傿僆傮僄僊傴僈僂傰僁傺傱僋僉傶傸凗剺剸剻剼嗃嗛嗌嗐嗋嗊嗝嗀嗔嗄嗩喿嗒喍嗏嗕嗢嗖嗈嗲嗍嗙嗂圔塓塨塤塏塍塉塯塕塎塝塙塥塛堽塣塱壼嫇嫄嫋媺媸媱媵媰媿嫈媻嫆"],["dd40","媷嫀嫊媴媶嫍媹媐寖寘寙尟尳嵱嵣嵊嵥嵲嵬嵞嵨嵧嵢巰幏幎幊幍幋廅廌廆廋廇彀徯徭惷慉慊愫慅愶愲愮慆愯慏愩慀戠酨戣戥戤揅揱揫搐搒搉搠搤"],["dda1","搳摃搟搕搘搹搷搢搣搌搦搰搨摁搵搯搊搚摀搥搧搋揧搛搮搡搎敯斒旓暆暌暕暐暋暊暙暔晸朠楦楟椸楎楢楱椿楅楪椹楂楗楙楺楈楉椵楬椳椽楥棰楸椴楩楀楯楄楶楘楁楴楌椻楋椷楜楏楑椲楒椯楻椼歆歅歃歂歈歁殛嗀毻毼"],["de40","毹毷毸溛滖滈溏滀溟溓溔溠溱溹滆滒溽滁溞滉溷溰滍溦滏溲溾滃滜滘溙溒溎溍溤溡溿溳滐滊溗溮溣煇煔煒煣煠煁煝煢煲煸煪煡煂煘煃煋煰煟煐煓"],["dea1","煄煍煚牏犍犌犑犐犎猼獂猻猺獀獊獉瑄瑊瑋瑒瑑瑗瑀瑏瑐瑎瑂瑆瑍瑔瓡瓿瓾瓽甝畹畷榃痯瘏瘃痷痾痼痹痸瘐痻痶痭痵痽皙皵盝睕睟睠睒睖睚睩睧睔睙睭矠碇碚碔碏碄碕碅碆碡碃硹碙碀碖硻祼禂祽祹稑稘稙稒稗稕稢稓"],["df40","稛稐窣窢窞竫筦筤筭筴筩筲筥筳筱筰筡筸筶筣粲粴粯綈綆綀綍絿綅絺綎絻綃絼綌綔綄絽綒罭罫罧罨罬羦羥羧翛翜耡腤腠腷腜腩腛腢腲朡腞腶腧腯"],["dfa1","腄腡舝艉艄艀艂艅蓱萿葖葶葹蒏蒍葥葑葀蒆葧萰葍葽葚葙葴葳葝蔇葞萷萺萴葺葃葸萲葅萩菙葋萯葂萭葟葰萹葎葌葒葯蓅蒎萻葇萶萳葨葾葄萫葠葔葮葐蜋蜄蛷蜌蛺蛖蛵蝍蛸蜎蜉蜁蛶蜍蜅裖裋裍裎裞裛裚裌裐覅覛觟觥觤"],["e040","觡觠觢觜触詶誆詿詡訿詷誂誄詵誃誁詴詺谼豋豊豥豤豦貆貄貅賌赨赩趑趌趎趏趍趓趔趐趒跰跠跬跱跮跐跩跣跢跧跲跫跴輆軿輁輀輅輇輈輂輋遒逿"],["e0a1","遄遉逽鄐鄍鄏鄑鄖鄔鄋鄎酮酯鉈鉒鈰鈺鉦鈳鉥鉞銃鈮鉊鉆鉭鉬鉏鉠鉧鉯鈶鉡鉰鈱鉔鉣鉐鉲鉎鉓鉌鉖鈲閟閜閞閛隒隓隑隗雎雺雽雸雵靳靷靸靲頏頍頎颬飶飹馯馲馰馵骭骫魛鳪鳭鳧麀黽僦僔僗僨僳僛僪僝僤僓僬僰僯僣僠"],["e140","凘劀劁勩勫匰厬嘧嘕嘌嘒嗼嘏嘜嘁嘓嘂嗺嘝嘄嗿嗹墉塼墐墘墆墁塿塴墋塺墇墑墎塶墂墈塻墔墏壾奫嫜嫮嫥嫕嫪嫚嫭嫫嫳嫢嫠嫛嫬嫞嫝嫙嫨嫟孷寠"],["e1a1","寣屣嶂嶀嵽嶆嵺嶁嵷嶊嶉嶈嵾嵼嶍嵹嵿幘幙幓廘廑廗廎廜廕廙廒廔彄彃彯徶愬愨慁慞慱慳慒慓慲慬憀慴慔慺慛慥愻慪慡慖戩戧戫搫摍摛摝摴摶摲摳摽摵摦撦摎撂摞摜摋摓摠摐摿搿摬摫摙摥摷敳斠暡暠暟朅朄朢榱榶槉"],["e240","榠槎榖榰榬榼榑榙榎榧榍榩榾榯榿槄榽榤槔榹槊榚槏榳榓榪榡榞槙榗榐槂榵榥槆歊歍歋殞殟殠毃毄毾滎滵滱漃漥滸漷滻漮漉潎漙漚漧漘漻漒滭漊"],["e2a1","漶潳滹滮漭潀漰漼漵滫漇漎潃漅滽滶漹漜滼漺漟漍漞漈漡熇熐熉熀熅熂熏煻熆熁熗牄牓犗犕犓獃獍獑獌瑢瑳瑱瑵瑲瑧瑮甀甂甃畽疐瘖瘈瘌瘕瘑瘊瘔皸瞁睼瞅瞂睮瞀睯睾瞃碲碪碴碭碨硾碫碞碥碠碬碢碤禘禊禋禖禕禔禓"],["e340","禗禈禒禐稫穊稰稯稨稦窨窫窬竮箈箜箊箑箐箖箍箌箛箎箅箘劄箙箤箂粻粿粼粺綧綷緂綣綪緁緀緅綝緎緄緆緋緌綯綹綖綼綟綦綮綩綡緉罳翢翣翥翞"],["e3a1","耤聝聜膉膆膃膇膍膌膋舕蒗蒤蒡蒟蒺蓎蓂蒬蒮蒫蒹蒴蓁蓍蒪蒚蒱蓐蒝蒧蒻蒢蒔蓇蓌蒛蒩蒯蒨蓖蒘蒶蓏蒠蓗蓔蓒蓛蒰蒑虡蜳蜣蜨蝫蝀蜮蜞蜡蜙蜛蝃蜬蝁蜾蝆蜠蜲蜪蜭蜼蜒蜺蜱蜵蝂蜦蜧蜸蜤蜚蜰蜑裷裧裱裲裺裾裮裼裶裻"],["e440","裰裬裫覝覡覟覞觩觫觨誫誙誋誒誏誖谽豨豩賕賏賗趖踉踂跿踍跽踊踃踇踆踅跾踀踄輐輑輎輍鄣鄜鄠鄢鄟鄝鄚鄤鄡鄛酺酲酹酳銥銤鉶銛鉺銠銔銪銍"],["e4a1","銦銚銫鉹銗鉿銣鋮銎銂銕銢鉽銈銡銊銆銌銙銧鉾銇銩銝銋鈭隞隡雿靘靽靺靾鞃鞀鞂靻鞄鞁靿韎韍頖颭颮餂餀餇馝馜駃馹馻馺駂馽駇骱髣髧鬾鬿魠魡魟鳱鳲鳵麧僿儃儰僸儆儇僶僾儋儌僽儊劋劌勱勯噈噂噌嘵噁噊噉噆噘"],["e540","噚噀嘳嘽嘬嘾嘸嘪嘺圚墫墝墱墠墣墯墬墥墡壿嫿嫴嫽嫷嫶嬃嫸嬂嫹嬁嬇嬅嬏屧嶙嶗嶟嶒嶢嶓嶕嶠嶜嶡嶚嶞幩幝幠幜緳廛廞廡彉徲憋憃慹憱憰憢憉"],["e5a1","憛憓憯憭憟憒憪憡憍慦憳戭摮摰撖撠撅撗撜撏撋撊撌撣撟摨撱撘敶敺敹敻斲斳暵暰暩暲暷暪暯樀樆樗槥槸樕槱槤樠槿槬槢樛樝槾樧槲槮樔槷槧橀樈槦槻樍槼槫樉樄樘樥樏槶樦樇槴樖歑殥殣殢殦氁氀毿氂潁漦潾澇濆澒"],["e640","澍澉澌潢潏澅潚澖潶潬澂潕潲潒潐潗澔澓潝漀潡潫潽潧澐潓澋潩潿澕潣潷潪潻熲熯熛熰熠熚熩熵熝熥熞熤熡熪熜熧熳犘犚獘獒獞獟獠獝獛獡獚獙"],["e6a1","獢璇璉璊璆璁瑽璅璈瑼瑹甈甇畾瘥瘞瘙瘝瘜瘣瘚瘨瘛皜皝皞皛瞍瞏瞉瞈磍碻磏磌磑磎磔磈磃磄磉禚禡禠禜禢禛歶稹窲窴窳箷篋箾箬篎箯箹篊箵糅糈糌糋緷緛緪緧緗緡縃緺緦緶緱緰緮緟罶羬羰羭翭翫翪翬翦翨聤聧膣膟"],["e740","膞膕膢膙膗舖艏艓艒艐艎艑蔤蔻蔏蔀蔩蔎蔉蔍蔟蔊蔧蔜蓻蔫蓺蔈蔌蓴蔪蓲蔕蓷蓫蓳蓼蔒蓪蓩蔖蓾蔨蔝蔮蔂蓽蔞蓶蔱蔦蓧蓨蓰蓯蓹蔘蔠蔰蔋蔙蔯虢"],["e7a1","蝖蝣蝤蝷蟡蝳蝘蝔蝛蝒蝡蝚蝑蝞蝭蝪蝐蝎蝟蝝蝯蝬蝺蝮蝜蝥蝏蝻蝵蝢蝧蝩衚褅褌褔褋褗褘褙褆褖褑褎褉覢覤覣觭觰觬諏諆誸諓諑諔諕誻諗誾諀諅諘諃誺誽諙谾豍貏賥賟賙賨賚賝賧趠趜趡趛踠踣踥踤踮踕踛踖踑踙踦踧"],["e840","踔踒踘踓踜踗踚輬輤輘輚輠輣輖輗遳遰遯遧遫鄯鄫鄩鄪鄲鄦鄮醅醆醊醁醂醄醀鋐鋃鋄鋀鋙銶鋏鋱鋟鋘鋩鋗鋝鋌鋯鋂鋨鋊鋈鋎鋦鋍鋕鋉鋠鋞鋧鋑鋓"],["e8a1","銵鋡鋆銴镼閬閫閮閰隤隢雓霅霈霂靚鞊鞎鞈韐韏頞頝頦頩頨頠頛頧颲餈飺餑餔餖餗餕駜駍駏駓駔駎駉駖駘駋駗駌骳髬髫髳髲髱魆魃魧魴魱魦魶魵魰魨魤魬鳼鳺鳽鳿鳷鴇鴀鳹鳻鴈鴅鴄麃黓鼏鼐儜儓儗儚儑凞匴叡噰噠噮"],["e940","噳噦噣噭噲噞噷圜圛壈墽壉墿墺壂墼壆嬗嬙嬛嬡嬔嬓嬐嬖嬨嬚嬠嬞寯嶬嶱嶩嶧嶵嶰嶮嶪嶨嶲嶭嶯嶴幧幨幦幯廩廧廦廨廥彋徼憝憨憖懅憴懆懁懌憺"],["e9a1","憿憸憌擗擖擐擏擉撽撉擃擛擳擙攳敿敼斢曈暾曀曊曋曏暽暻暺曌朣樴橦橉橧樲橨樾橝橭橶橛橑樨橚樻樿橁橪橤橐橏橔橯橩橠樼橞橖橕橍橎橆歕歔歖殧殪殫毈毇氄氃氆澭濋澣濇澼濎濈潞濄澽澞濊澨瀄澥澮澺澬澪濏澿澸"],["ea40","澢濉澫濍澯澲澰燅燂熿熸燖燀燁燋燔燊燇燏熽燘熼燆燚燛犝犞獩獦獧獬獥獫獪瑿璚璠璔璒璕璡甋疀瘯瘭瘱瘽瘳瘼瘵瘲瘰皻盦瞚瞝瞡瞜瞛瞢瞣瞕瞙"],["eaa1","瞗磝磩磥磪磞磣磛磡磢磭磟磠禤穄穈穇窶窸窵窱窷篞篣篧篝篕篥篚篨篹篔篪篢篜篫篘篟糒糔糗糐糑縒縡縗縌縟縠縓縎縜縕縚縢縋縏縖縍縔縥縤罃罻罼罺羱翯耪耩聬膱膦膮膹膵膫膰膬膴膲膷膧臲艕艖艗蕖蕅蕫蕍蕓蕡蕘"],["eb40","蕀蕆蕤蕁蕢蕄蕑蕇蕣蔾蕛蕱蕎蕮蕵蕕蕧蕠薌蕦蕝蕔蕥蕬虣虥虤螛螏螗螓螒螈螁螖螘蝹螇螣螅螐螑螝螄螔螜螚螉褞褦褰褭褮褧褱褢褩褣褯褬褟觱諠"],["eba1","諢諲諴諵諝謔諤諟諰諈諞諡諨諿諯諻貑貒貐賵賮賱賰賳赬赮趥趧踳踾踸蹀蹅踶踼踽蹁踰踿躽輶輮輵輲輹輷輴遶遹遻邆郺鄳鄵鄶醓醐醑醍醏錧錞錈錟錆錏鍺錸錼錛錣錒錁鍆錭錎錍鋋錝鋺錥錓鋹鋷錴錂錤鋿錩錹錵錪錔錌"],["ec40","錋鋾錉錀鋻錖閼闍閾閹閺閶閿閵閽隩雔霋霒霐鞙鞗鞔韰韸頵頯頲餤餟餧餩馞駮駬駥駤駰駣駪駩駧骹骿骴骻髶髺髹髷鬳鮀鮅鮇魼魾魻鮂鮓鮒鮐魺鮕"],["eca1","魽鮈鴥鴗鴠鴞鴔鴩鴝鴘鴢鴐鴙鴟麈麆麇麮麭黕黖黺鼒鼽儦儥儢儤儠儩勴嚓嚌嚍嚆嚄嚃噾嚂噿嚁壖壔壏壒嬭嬥嬲嬣嬬嬧嬦嬯嬮孻寱寲嶷幬幪徾徻懃憵憼懧懠懥懤懨懞擯擩擣擫擤擨斁斀斶旚曒檍檖檁檥檉檟檛檡檞檇檓檎"],["ed40","檕檃檨檤檑橿檦檚檅檌檒歛殭氉濌澩濴濔濣濜濭濧濦濞濲濝濢濨燡燱燨燲燤燰燢獳獮獯璗璲璫璐璪璭璱璥璯甐甑甒甏疄癃癈癉癇皤盩瞵瞫瞲瞷瞶"],["eda1","瞴瞱瞨矰磳磽礂磻磼磲礅磹磾礄禫禨穜穛穖穘穔穚窾竀竁簅簏篲簀篿篻簎篴簋篳簂簉簃簁篸篽簆篰篱簐簊糨縭縼繂縳顈縸縪繉繀繇縩繌縰縻縶繄縺罅罿罾罽翴翲耬膻臄臌臊臅臇膼臩艛艚艜薃薀薏薧薕薠薋薣蕻薤薚薞"],["ee40","蕷蕼薉薡蕺蕸蕗薎薖薆薍薙薝薁薢薂薈薅蕹蕶薘薐薟虨螾螪螭蟅螰螬螹螵螼螮蟉蟃蟂蟌螷螯蟄蟊螴螶螿螸螽蟞螲褵褳褼褾襁襒褷襂覭覯覮觲觳謞"],["eea1","謘謖謑謅謋謢謏謒謕謇謍謈謆謜謓謚豏豰豲豱豯貕貔賹赯蹎蹍蹓蹐蹌蹇轃轀邅遾鄸醚醢醛醙醟醡醝醠鎡鎃鎯鍤鍖鍇鍼鍘鍜鍶鍉鍐鍑鍠鍭鎏鍌鍪鍹鍗鍕鍒鍏鍱鍷鍻鍡鍞鍣鍧鎀鍎鍙闇闀闉闃闅閷隮隰隬霠霟霘霝霙鞚鞡鞜"],["ef40","鞞鞝韕韔韱顁顄顊顉顅顃餥餫餬餪餳餲餯餭餱餰馘馣馡騂駺駴駷駹駸駶駻駽駾駼騃骾髾髽鬁髼魈鮚鮨鮞鮛鮦鮡鮥鮤鮆鮢鮠鮯鴳鵁鵧鴶鴮鴯鴱鴸鴰"],["efa1","鵅鵂鵃鴾鴷鵀鴽翵鴭麊麉麍麰黈黚黻黿鼤鼣鼢齔龠儱儭儮嚘嚜嚗嚚嚝嚙奰嬼屩屪巀幭幮懘懟懭懮懱懪懰懫懖懩擿攄擽擸攁攃擼斔旛曚曛曘櫅檹檽櫡櫆檺檶檷櫇檴檭歞毉氋瀇瀌瀍瀁瀅瀔瀎濿瀀濻瀦濼濷瀊爁燿燹爃燽獶"],["f040","璸瓀璵瓁璾璶璻瓂甔甓癜癤癙癐癓癗癚皦皽盬矂瞺磿礌礓礔礉礐礒礑禭禬穟簜簩簙簠簟簭簝簦簨簢簥簰繜繐繖繣繘繢繟繑繠繗繓羵羳翷翸聵臑臒"],["f0a1","臐艟艞薴藆藀藃藂薳薵薽藇藄薿藋藎藈藅薱薶藒蘤薸薷薾虩蟧蟦蟢蟛蟫蟪蟥蟟蟳蟤蟔蟜蟓蟭蟘蟣螤蟗蟙蠁蟴蟨蟝襓襋襏襌襆襐襑襉謪謧謣謳謰謵譇謯謼謾謱謥謷謦謶謮謤謻謽謺豂豵貙貘貗賾贄贂贀蹜蹢蹠蹗蹖蹞蹥蹧"],["f140","蹛蹚蹡蹝蹩蹔轆轇轈轋鄨鄺鄻鄾醨醥醧醯醪鎵鎌鎒鎷鎛鎝鎉鎧鎎鎪鎞鎦鎕鎈鎙鎟鎍鎱鎑鎲鎤鎨鎴鎣鎥闒闓闑隳雗雚巂雟雘雝霣霢霥鞬鞮鞨鞫鞤鞪"],["f1a1","鞢鞥韗韙韖韘韺顐顑顒颸饁餼餺騏騋騉騍騄騑騊騅騇騆髀髜鬈鬄鬅鬩鬵魊魌魋鯇鯆鯃鮿鯁鮵鮸鯓鮶鯄鮹鮽鵜鵓鵏鵊鵛鵋鵙鵖鵌鵗鵒鵔鵟鵘鵚麎麌黟鼁鼀鼖鼥鼫鼪鼩鼨齌齕儴儵劖勷厴嚫嚭嚦嚧嚪嚬壚壝壛夒嬽嬾嬿巃幰"],["f240","徿懻攇攐攍攉攌攎斄旞旝曞櫧櫠櫌櫑櫙櫋櫟櫜櫐櫫櫏櫍櫞歠殰氌瀙瀧瀠瀖瀫瀡瀢瀣瀩瀗瀤瀜瀪爌爊爇爂爅犥犦犤犣犡瓋瓅璷瓃甖癠矉矊矄矱礝礛"],["f2a1","礡礜礗礞禰穧穨簳簼簹簬簻糬糪繶繵繸繰繷繯繺繲繴繨罋罊羃羆羷翽翾聸臗臕艤艡艣藫藱藭藙藡藨藚藗藬藲藸藘藟藣藜藑藰藦藯藞藢蠀蟺蠃蟶蟷蠉蠌蠋蠆蟼蠈蟿蠊蠂襢襚襛襗襡襜襘襝襙覈覷覶觶譐譈譊譀譓譖譔譋譕"],["f340","譑譂譒譗豃豷豶貚贆贇贉趬趪趭趫蹭蹸蹳蹪蹯蹻軂轒轑轏轐轓辴酀鄿醰醭鏞鏇鏏鏂鏚鏐鏹鏬鏌鏙鎩鏦鏊鏔鏮鏣鏕鏄鏎鏀鏒鏧镽闚闛雡霩霫霬霨霦"],["f3a1","鞳鞷鞶韝韞韟顜顙顝顗颿颽颻颾饈饇饃馦馧騚騕騥騝騤騛騢騠騧騣騞騜騔髂鬋鬊鬎鬌鬷鯪鯫鯠鯞鯤鯦鯢鯰鯔鯗鯬鯜鯙鯥鯕鯡鯚鵷鶁鶊鶄鶈鵱鶀鵸鶆鶋鶌鵽鵫鵴鵵鵰鵩鶅鵳鵻鶂鵯鵹鵿鶇鵨麔麑黀黼鼭齀齁齍齖齗齘匷嚲"],["f440","嚵嚳壣孅巆巇廮廯忀忁懹攗攖攕攓旟曨曣曤櫳櫰櫪櫨櫹櫱櫮櫯瀼瀵瀯瀷瀴瀱灂瀸瀿瀺瀹灀瀻瀳灁爓爔犨獽獼璺皫皪皾盭矌矎矏矍矲礥礣礧礨礤礩"],["f4a1","禲穮穬穭竷籉籈籊籇籅糮繻繾纁纀羺翿聹臛臙舋艨艩蘢藿蘁藾蘛蘀藶蘄蘉蘅蘌藽蠙蠐蠑蠗蠓蠖襣襦覹觷譠譪譝譨譣譥譧譭趮躆躈躄轙轖轗轕轘轚邍酃酁醷醵醲醳鐋鐓鏻鐠鐏鐔鏾鐕鐐鐨鐙鐍鏵鐀鏷鐇鐎鐖鐒鏺鐉鏸鐊鏿"],["f540","鏼鐌鏶鐑鐆闞闠闟霮霯鞹鞻韽韾顠顢顣顟飁飂饐饎饙饌饋饓騲騴騱騬騪騶騩騮騸騭髇髊髆鬐鬒鬑鰋鰈鯷鰅鰒鯸鱀鰇鰎鰆鰗鰔鰉鶟鶙鶤鶝鶒鶘鶐鶛"],["f5a1","鶠鶔鶜鶪鶗鶡鶚鶢鶨鶞鶣鶿鶩鶖鶦鶧麙麛麚黥黤黧黦鼰鼮齛齠齞齝齙龑儺儹劘劗囃嚽嚾孈孇巋巏廱懽攛欂櫼欃櫸欀灃灄灊灈灉灅灆爝爚爙獾甗癪矐礭礱礯籔籓糲纊纇纈纋纆纍罍羻耰臝蘘蘪蘦蘟蘣蘜蘙蘧蘮蘡蘠蘩蘞蘥"],["f640","蠩蠝蠛蠠蠤蠜蠫衊襭襩襮襫觺譹譸譅譺譻贐贔趯躎躌轞轛轝酆酄酅醹鐿鐻鐶鐩鐽鐼鐰鐹鐪鐷鐬鑀鐱闥闤闣霵霺鞿韡顤飉飆飀饘饖騹騽驆驄驂驁騺"],["f6a1","騿髍鬕鬗鬘鬖鬺魒鰫鰝鰜鰬鰣鰨鰩鰤鰡鶷鶶鶼鷁鷇鷊鷏鶾鷅鷃鶻鶵鷎鶹鶺鶬鷈鶱鶭鷌鶳鷍鶲鹺麜黫黮黭鼛鼘鼚鼱齎齥齤龒亹囆囅囋奱孋孌巕巑廲攡攠攦攢欋欈欉氍灕灖灗灒爞爟犩獿瓘瓕瓙瓗癭皭礵禴穰穱籗籜籙籛籚"],["f740","糴糱纑罏羇臞艫蘴蘵蘳蘬蘲蘶蠬蠨蠦蠪蠥襱覿覾觻譾讄讂讆讅譿贕躕躔躚躒躐躖躗轠轢酇鑌鑐鑊鑋鑏鑇鑅鑈鑉鑆霿韣顪顩飋饔饛驎驓驔驌驏驈驊"],["f7a1","驉驒驐髐鬙鬫鬻魖魕鱆鱈鰿鱄鰹鰳鱁鰼鰷鰴鰲鰽鰶鷛鷒鷞鷚鷋鷐鷜鷑鷟鷩鷙鷘鷖鷵鷕鷝麶黰鼵鼳鼲齂齫龕龢儽劙壨壧奲孍巘蠯彏戁戃戄攩攥斖曫欑欒欏毊灛灚爢玂玁玃癰矔籧籦纕艬蘺虀蘹蘼蘱蘻蘾蠰蠲蠮蠳襶襴襳觾"],["f840","讌讎讋讈豅贙躘轤轣醼鑢鑕鑝鑗鑞韄韅頀驖驙鬞鬟鬠鱒鱘鱐鱊鱍鱋鱕鱙鱌鱎鷻鷷鷯鷣鷫鷸鷤鷶鷡鷮鷦鷲鷰鷢鷬鷴鷳鷨鷭黂黐黲黳鼆鼜鼸鼷鼶齃齏"],["f8a1","齱齰齮齯囓囍孎屭攭曭曮欓灟灡灝灠爣瓛瓥矕礸禷禶籪纗羉艭虃蠸蠷蠵衋讔讕躞躟躠躝醾醽釂鑫鑨鑩雥靆靃靇韇韥驞髕魙鱣鱧鱦鱢鱞鱠鸂鷾鸇鸃鸆鸅鸀鸁鸉鷿鷽鸄麠鼞齆齴齵齶囔攮斸欘欙欗欚灢爦犪矘矙礹籩籫糶纚"],["f940","纘纛纙臠臡虆虇虈襹襺襼襻觿讘讙躥躤躣鑮鑭鑯鑱鑳靉顲饟鱨鱮鱭鸋鸍鸐鸏鸒鸑麡黵鼉齇齸齻齺齹圞灦籯蠼趲躦釃鑴鑸鑶鑵驠鱴鱳鱱鱵鸔鸓黶鼊"],["f9a1","龤灨灥糷虪蠾蠽蠿讞貜躩軉靋顳顴飌饡馫驤驦驧鬤鸕鸗齈戇欞爧虌躨钂钀钁驩驨鬮鸙爩虋讟钃鱹麷癵驫鱺鸝灩灪麤齾齉龘碁銹裏墻恒粧嫺╔╦╗╠╬╣╚╩╝╒╤╕╞╪╡╘╧╛╓╥╖╟╫╢╙╨╜║═╭╮╰╯▓"]]');
            }
          ),
          /***/
          56406: (
            /***/
            function(u) {
              u.exports = /* @__PURE__ */ JSON.parse('[["0","\\u0000",127],["8ea1","｡",62],["a1a1","　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈",9,"＋－±×÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇"],["a2a1","◆□■△▲▽▼※〒→←↑↓〓"],["a2ba","∈∋⊆⊇⊂⊃∪∩"],["a2ca","∧∨￢⇒⇔∀∃"],["a2dc","∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬"],["a2f2","Å‰♯♭♪†‡¶"],["a2fe","◯"],["a3b0","０",9],["a3c1","Ａ",25],["a3e1","ａ",25],["a4a1","ぁ",82],["a5a1","ァ",85],["a6a1","Α",16,"Σ",6],["a6c1","α",16,"σ",6],["a7a1","А",5,"ЁЖ",25],["a7d1","а",5,"ёж",25],["a8a1","─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂"],["ada1","①",19,"Ⅰ",9],["adc0","㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡"],["addf","㍻〝〟№㏍℡㊤",4,"㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪"],["b0a1","亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭"],["b1a1","院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応"],["b2a1","押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改"],["b3a1","魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱"],["b4a1","粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄"],["b5a1","機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京"],["b6a1","供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈"],["b7a1","掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲"],["b8a1","検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向"],["b9a1","后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込"],["baa1","此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷"],["bba1","察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時"],["bca1","次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周"],["bda1","宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償"],["bea1","勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾"],["bfa1","拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾"],["c0a1","澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線"],["c1a1","繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎"],["c2a1","臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只"],["c3a1","叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵"],["c4a1","帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓"],["c5a1","邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到"],["c6a1","董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入"],["c7a1","如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦"],["c8a1","函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美"],["c9a1","鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服"],["caa1","福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋"],["cba1","法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満"],["cca1","漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒"],["cda1","諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃"],["cea1","痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯"],["cfa1","蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕"],["d0a1","弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲"],["d1a1","僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨"],["d2a1","辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨"],["d3a1","咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉"],["d4a1","圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩"],["d5a1","奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓"],["d6a1","屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏"],["d7a1","廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚"],["d8a1","悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛"],["d9a1","戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼"],["daa1","據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼"],["dba1","曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍"],["dca1","棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣"],["dda1","檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾"],["dea1","沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌"],["dfa1","漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼"],["e0a1","燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱"],["e1a1","瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰"],["e2a1","癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬"],["e3a1","磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐"],["e4a1","筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆"],["e5a1","紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺"],["e6a1","罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋"],["e7a1","隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙"],["e8a1","茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈"],["e9a1","蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙"],["eaa1","蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞"],["eba1","襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫"],["eca1","譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊"],["eda1","蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸"],["eea1","遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮"],["efa1","錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞"],["f0a1","陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰"],["f1a1","顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷"],["f2a1","髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈"],["f3a1","鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠"],["f4a1","堯槇遙瑤凜熙"],["f9a1","纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德"],["faa1","忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱"],["fba1","犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚"],["fca1","釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑"],["fcf1","ⅰ",9,"￢￤＇＂"],["8fa2af","˘ˇ¸˙˝¯˛˚～΄΅"],["8fa2c2","¡¦¿"],["8fa2eb","ºª©®™¤№"],["8fa6e1","ΆΈΉΊΪ"],["8fa6e7","Ό"],["8fa6e9","ΎΫ"],["8fa6ec","Ώ"],["8fa6f1","άέήίϊΐόςύϋΰώ"],["8fa7c2","Ђ",10,"ЎЏ"],["8fa7f2","ђ",10,"ўџ"],["8fa9a1","ÆĐ"],["8fa9a4","Ħ"],["8fa9a6","Ĳ"],["8fa9a8","ŁĿ"],["8fa9ab","ŊØŒ"],["8fa9af","ŦÞ"],["8fa9c1","æđðħıĳĸłŀŉŋøœßŧþ"],["8faaa1","ÁÀÄÂĂǍĀĄÅÃĆĈČÇĊĎÉÈËÊĚĖĒĘ"],["8faaba","ĜĞĢĠĤÍÌÏÎǏİĪĮĨĴĶĹĽĻŃŇŅÑÓÒÖÔǑŐŌÕŔŘŖŚŜŠŞŤŢÚÙÜÛŬǓŰŪŲŮŨǗǛǙǕŴÝŸŶŹŽŻ"],["8faba1","áàäâăǎāąåãćĉčçċďéèëêěėēęǵĝğ"],["8fabbd","ġĥíìïîǐ"],["8fabc5","īįĩĵķĺľļńňņñóòöôǒőōõŕřŗśŝšşťţúùüûŭǔűūųůũǘǜǚǖŵýÿŷźžż"],["8fb0a1","丂丄丅丌丒丟丣两丨丫丮丯丰丵乀乁乄乇乑乚乜乣乨乩乴乵乹乿亍亖亗亝亯亹仃仐仚仛仠仡仢仨仯仱仳仵份仾仿伀伂伃伈伋伌伒伕伖众伙伮伱你伳伵伷伹伻伾佀佂佈佉佋佌佒佔佖佘佟佣佪佬佮佱佷佸佹佺佽佾侁侂侄"],["8fb1a1","侅侉侊侌侎侐侒侓侔侗侙侚侞侟侲侷侹侻侼侽侾俀俁俅俆俈俉俋俌俍俏俒俜俠俢俰俲俼俽俿倀倁倄倇倊倌倎倐倓倗倘倛倜倝倞倢倧倮倰倲倳倵偀偁偂偅偆偊偌偎偑偒偓偗偙偟偠偢偣偦偧偪偭偰偱倻傁傃傄傆傊傎傏傐"],["8fb2a1","傒傓傔傖傛傜傞",4,"傪傯傰傹傺傽僀僃僄僇僌僎僐僓僔僘僜僝僟僢僤僦僨僩僯僱僶僺僾儃儆儇儈儋儌儍儎僲儐儗儙儛儜儝儞儣儧儨儬儭儯儱儳儴儵儸儹兂兊兏兓兕兗兘兟兤兦兾冃冄冋冎冘冝冡冣冭冸冺冼冾冿凂"],["8fb3a1","凈减凑凒凓凕凘凞凢凥凮凲凳凴凷刁刂刅划刓刕刖刘刢刨刱刲刵刼剅剉剕剗剘剚剜剟剠剡剦剮剷剸剹劀劂劅劊劌劓劕劖劗劘劚劜劤劥劦劧劯劰劶劷劸劺劻劽勀勄勆勈勌勏勑勔勖勛勜勡勥勨勩勪勬勰勱勴勶勷匀匃匊匋"],["8fb4a1","匌匑匓匘匛匜匞匟匥匧匨匩匫匬匭匰匲匵匼匽匾卂卌卋卙卛卡卣卥卬卭卲卹卾厃厇厈厎厓厔厙厝厡厤厪厫厯厲厴厵厷厸厺厽叀叅叏叒叓叕叚叝叞叠另叧叵吂吓吚吡吧吨吪启吱吴吵呃呄呇呍呏呞呢呤呦呧呩呫呭呮呴呿"],["8fb5a1","咁咃咅咈咉咍咑咕咖咜咟咡咦咧咩咪咭咮咱咷咹咺咻咿哆哊响哎哠哪哬哯哶哼哾哿唀唁唅唈唉唌唍唎唕唪唫唲唵唶唻唼唽啁啇啉啊啍啐啑啘啚啛啞啠啡啤啦啿喁喂喆喈喎喏喑喒喓喔喗喣喤喭喲喿嗁嗃嗆嗉嗋嗌嗎嗑嗒"],["8fb6a1","嗓嗗嗘嗛嗞嗢嗩嗶嗿嘅嘈嘊嘍",5,"嘙嘬嘰嘳嘵嘷嘹嘻嘼嘽嘿噀噁噃噄噆噉噋噍噏噔噞噠噡噢噣噦噩噭噯噱噲噵嚄嚅嚈嚋嚌嚕嚙嚚嚝嚞嚟嚦嚧嚨嚩嚫嚬嚭嚱嚳嚷嚾囅囉囊囋囏囐囌囍囙囜囝囟囡囤",4,"囱囫园"],["8fb7a1","囶囷圁圂圇圊圌圑圕圚圛圝圠圢圣圤圥圩圪圬圮圯圳圴圽圾圿坅坆坌坍坒坢坥坧坨坫坭",4,"坳坴坵坷坹坺坻坼坾垁垃垌垔垗垙垚垜垝垞垟垡垕垧垨垩垬垸垽埇埈埌埏埕埝埞埤埦埧埩埭埰埵埶埸埽埾埿堃堄堈堉埡"],["8fb8a1","堌堍堛堞堟堠堦堧堭堲堹堿塉塌塍塏塐塕塟塡塤塧塨塸塼塿墀墁墇墈墉墊墌墍墏墐墔墖墝墠墡墢墦墩墱墲壄墼壂壈壍壎壐壒壔壖壚壝壡壢壩壳夅夆夋夌夒夓夔虁夝夡夣夤夨夯夰夳夵夶夿奃奆奒奓奙奛奝奞奟奡奣奫奭"],["8fb9a1","奯奲奵奶她奻奼妋妌妎妒妕妗妟妤妧妭妮妯妰妳妷妺妼姁姃姄姈姊姍姒姝姞姟姣姤姧姮姯姱姲姴姷娀娄娌娍娎娒娓娞娣娤娧娨娪娭娰婄婅婇婈婌婐婕婞婣婥婧婭婷婺婻婾媋媐媓媖媙媜媞媟媠媢媧媬媱媲媳媵媸媺媻媿"],["8fbaa1","嫄嫆嫈嫏嫚嫜嫠嫥嫪嫮嫵嫶嫽嬀嬁嬈嬗嬴嬙嬛嬝嬡嬥嬭嬸孁孋孌孒孖孞孨孮孯孼孽孾孿宁宄宆宊宎宐宑宓宔宖宨宩宬宭宯宱宲宷宺宼寀寁寍寏寖",4,"寠寯寱寴寽尌尗尞尟尣尦尩尫尬尮尰尲尵尶屙屚屜屢屣屧屨屩"],["8fbba1","屭屰屴屵屺屻屼屽岇岈岊岏岒岝岟岠岢岣岦岪岲岴岵岺峉峋峒峝峗峮峱峲峴崁崆崍崒崫崣崤崦崧崱崴崹崽崿嵂嵃嵆嵈嵕嵑嵙嵊嵟嵠嵡嵢嵤嵪嵭嵰嵹嵺嵾嵿嶁嶃嶈嶊嶒嶓嶔嶕嶙嶛嶟嶠嶧嶫嶰嶴嶸嶹巃巇巋巐巎巘巙巠巤"],["8fbca1","巩巸巹帀帇帍帒帔帕帘帟帠帮帨帲帵帾幋幐幉幑幖幘幛幜幞幨幪",4,"幰庀庋庎庢庤庥庨庪庬庱庳庽庾庿廆廌廋廎廑廒廔廕廜廞廥廫异弆弇弈弎弙弜弝弡弢弣弤弨弫弬弮弰弴弶弻弽弿彀彄彅彇彍彐彔彘彛彠彣彤彧"],["8fbda1","彯彲彴彵彸彺彽彾徉徍徏徖徜徝徢徧徫徤徬徯徰徱徸忄忇忈忉忋忐",4,"忞忡忢忨忩忪忬忭忮忯忲忳忶忺忼怇怊怍怓怔怗怘怚怟怤怭怳怵恀恇恈恉恌恑恔恖恗恝恡恧恱恾恿悂悆悈悊悎悑悓悕悘悝悞悢悤悥您悰悱悷"],["8fbea1","悻悾惂惄惈惉惊惋惎惏惔惕惙惛惝惞惢惥惲惵惸惼惽愂愇愊愌愐",4,"愖愗愙愜愞愢愪愫愰愱愵愶愷愹慁慅慆慉慞慠慬慲慸慻慼慿憀憁憃憄憋憍憒憓憗憘憜憝憟憠憥憨憪憭憸憹憼懀懁懂懎懏懕懜懝懞懟懡懢懧懩懥"],["8fbfa1","懬懭懯戁戃戄戇戓戕戜戠戢戣戧戩戫戹戽扂扃扄扆扌扐扑扒扔扖扚扜扤扭扯扳扺扽抍抎抏抐抦抨抳抶抷抺抾抿拄拎拕拖拚拪拲拴拼拽挃挄挊挋挍挐挓挖挘挩挪挭挵挶挹挼捁捂捃捄捆捊捋捎捒捓捔捘捛捥捦捬捭捱捴捵"],["8fc0a1","捸捼捽捿掂掄掇掊掐掔掕掙掚掞掤掦掭掮掯掽揁揅揈揎揑揓揔揕揜揠揥揪揬揲揳揵揸揹搉搊搐搒搔搘搞搠搢搤搥搩搪搯搰搵搽搿摋摏摑摒摓摔摚摛摜摝摟摠摡摣摭摳摴摻摽撅撇撏撐撑撘撙撛撝撟撡撣撦撨撬撳撽撾撿"],["8fc1a1","擄擉擊擋擌擎擐擑擕擗擤擥擩擪擭擰擵擷擻擿攁攄攈攉攊攏攓攔攖攙攛攞攟攢攦攩攮攱攺攼攽敃敇敉敐敒敔敟敠敧敫敺敽斁斅斊斒斕斘斝斠斣斦斮斲斳斴斿旂旈旉旎旐旔旖旘旟旰旲旴旵旹旾旿昀昄昈昉昍昑昒昕昖昝"],["8fc2a1","昞昡昢昣昤昦昩昪昫昬昮昰昱昳昹昷晀晅晆晊晌晑晎晗晘晙晛晜晠晡曻晪晫晬晾晳晵晿晷晸晹晻暀晼暋暌暍暐暒暙暚暛暜暟暠暤暭暱暲暵暻暿曀曂曃曈曌曎曏曔曛曟曨曫曬曮曺朅朇朎朓朙朜朠朢朳朾杅杇杈杌杔杕杝"],["8fc3a1","杦杬杮杴杶杻极构枎枏枑枓枖枘枙枛枰枱枲枵枻枼枽柹柀柂柃柅柈柉柒柗柙柜柡柦柰柲柶柷桒栔栙栝栟栨栧栬栭栯栰栱栳栻栿桄桅桊桌桕桗桘桛桫桮",4,"桵桹桺桻桼梂梄梆梈梖梘梚梜梡梣梥梩梪梮梲梻棅棈棌棏"],["8fc4a1","棐棑棓棖棙棜棝棥棨棪棫棬棭棰棱棵棶棻棼棽椆椉椊椐椑椓椖椗椱椳椵椸椻楂楅楉楎楗楛楣楤楥楦楨楩楬楰楱楲楺楻楿榀榍榒榖榘榡榥榦榨榫榭榯榷榸榺榼槅槈槑槖槗槢槥槮槯槱槳槵槾樀樁樃樏樑樕樚樝樠樤樨樰樲"],["8fc5a1","樴樷樻樾樿橅橆橉橊橎橐橑橒橕橖橛橤橧橪橱橳橾檁檃檆檇檉檋檑檛檝檞檟檥檫檯檰檱檴檽檾檿櫆櫉櫈櫌櫐櫔櫕櫖櫜櫝櫤櫧櫬櫰櫱櫲櫼櫽欂欃欆欇欉欏欐欑欗欛欞欤欨欫欬欯欵欶欻欿歆歊歍歒歖歘歝歠歧歫歮歰歵歽"],["8fc6a1","歾殂殅殗殛殟殠殢殣殨殩殬殭殮殰殸殹殽殾毃毄毉毌毖毚毡毣毦毧毮毱毷毹毿氂氄氅氉氍氎氐氒氙氟氦氧氨氬氮氳氵氶氺氻氿汊汋汍汏汒汔汙汛汜汫汭汯汴汶汸汹汻沅沆沇沉沔沕沗沘沜沟沰沲沴泂泆泍泏泐泑泒泔泖"],["8fc7a1","泚泜泠泧泩泫泬泮泲泴洄洇洊洎洏洑洓洚洦洧洨汧洮洯洱洹洼洿浗浞浟浡浥浧浯浰浼涂涇涑涒涔涖涗涘涪涬涴涷涹涽涿淄淈淊淎淏淖淛淝淟淠淢淥淩淯淰淴淶淼渀渄渞渢渧渲渶渹渻渼湄湅湈湉湋湏湑湒湓湔湗湜湝湞"],["8fc8a1","湢湣湨湳湻湽溍溓溙溠溧溭溮溱溳溻溿滀滁滃滇滈滊滍滎滏滫滭滮滹滻滽漄漈漊漌漍漖漘漚漛漦漩漪漯漰漳漶漻漼漭潏潑潒潓潗潙潚潝潞潡潢潨潬潽潾澃澇澈澋澌澍澐澒澓澔澖澚澟澠澥澦澧澨澮澯澰澵澶澼濅濇濈濊"],["8fc9a1","濚濞濨濩濰濵濹濼濽瀀瀅瀆瀇瀍瀗瀠瀣瀯瀴瀷瀹瀼灃灄灈灉灊灋灔灕灝灞灎灤灥灬灮灵灶灾炁炅炆炔",4,"炛炤炫炰炱炴炷烊烑烓烔烕烖烘烜烤烺焃",4,"焋焌焏焞焠焫焭焯焰焱焸煁煅煆煇煊煋煐煒煗煚煜煞煠"],["8fcaa1","煨煹熀熅熇熌熒熚熛熠熢熯熰熲熳熺熿燀燁燄燋燌燓燖燙燚燜燸燾爀爇爈爉爓爗爚爝爟爤爫爯爴爸爹牁牂牃牅牎牏牐牓牕牖牚牜牞牠牣牨牫牮牯牱牷牸牻牼牿犄犉犍犎犓犛犨犭犮犱犴犾狁狇狉狌狕狖狘狟狥狳狴狺狻"],["8fcba1","狾猂猄猅猇猋猍猒猓猘猙猞猢猤猧猨猬猱猲猵猺猻猽獃獍獐獒獖獘獝獞獟獠獦獧獩獫獬獮獯獱獷獹獼玀玁玃玅玆玎玐玓玕玗玘玜玞玟玠玢玥玦玪玫玭玵玷玹玼玽玿珅珆珉珋珌珏珒珓珖珙珝珡珣珦珧珩珴珵珷珹珺珻珽"],["8fcca1","珿琀琁琄琇琊琑琚琛琤琦琨",9,"琹瑀瑃瑄瑆瑇瑋瑍瑑瑒瑗瑝瑢瑦瑧瑨瑫瑭瑮瑱瑲璀璁璅璆璇璉璏璐璑璒璘璙璚璜璟璠璡璣璦璨璩璪璫璮璯璱璲璵璹璻璿瓈瓉瓌瓐瓓瓘瓚瓛瓞瓟瓤瓨瓪瓫瓯瓴瓺瓻瓼瓿甆"],["8fcda1","甒甖甗甠甡甤甧甩甪甯甶甹甽甾甿畀畃畇畈畎畐畒畗畞畟畡畯畱畹",5,"疁疅疐疒疓疕疙疜疢疤疴疺疿痀痁痄痆痌痎痏痗痜痟痠痡痤痧痬痮痯痱痹瘀瘂瘃瘄瘇瘈瘊瘌瘏瘒瘓瘕瘖瘙瘛瘜瘝瘞瘣瘥瘦瘩瘭瘲瘳瘵瘸瘹"],["8fcea1","瘺瘼癊癀癁癃癄癅癉癋癕癙癟癤癥癭癮癯癱癴皁皅皌皍皕皛皜皝皟皠皢",6,"皪皭皽盁盅盉盋盌盎盔盙盠盦盨盬盰盱盶盹盼眀眆眊眎眒眔眕眗眙眚眜眢眨眭眮眯眴眵眶眹眽眾睂睅睆睊睍睎睏睒睖睗睜睞睟睠睢"],["8fcfa1","睤睧睪睬睰睲睳睴睺睽瞀瞄瞌瞍瞔瞕瞖瞚瞟瞢瞧瞪瞮瞯瞱瞵瞾矃矉矑矒矕矙矞矟矠矤矦矪矬矰矱矴矸矻砅砆砉砍砎砑砝砡砢砣砭砮砰砵砷硃硄硇硈硌硎硒硜硞硠硡硣硤硨硪确硺硾碊碏碔碘碡碝碞碟碤碨碬碭碰碱碲碳"],["8fd0a1","碻碽碿磇磈磉磌磎磒磓磕磖磤磛磟磠磡磦磪磲磳礀磶磷磺磻磿礆礌礐礚礜礞礟礠礥礧礩礭礱礴礵礻礽礿祄祅祆祊祋祏祑祔祘祛祜祧祩祫祲祹祻祼祾禋禌禑禓禔禕禖禘禛禜禡禨禩禫禯禱禴禸离秂秄秇秈秊秏秔秖秚秝秞"],["8fd1a1","秠秢秥秪秫秭秱秸秼稂稃稇稉稊稌稑稕稛稞稡稧稫稭稯稰稴稵稸稹稺穄穅穇穈穌穕穖穙穜穝穟穠穥穧穪穭穵穸穾窀窂窅窆窊窋窐窑窔窞窠窣窬窳窵窹窻窼竆竉竌竎竑竛竨竩竫竬竱竴竻竽竾笇笔笟笣笧笩笪笫笭笮笯笰"],["8fd2a1","笱笴笽笿筀筁筇筎筕筠筤筦筩筪筭筯筲筳筷箄箉箎箐箑箖箛箞箠箥箬箯箰箲箵箶箺箻箼箽篂篅篈篊篔篖篗篙篚篛篨篪篲篴篵篸篹篺篼篾簁簂簃簄簆簉簋簌簎簏簙簛簠簥簦簨簬簱簳簴簶簹簺籆籊籕籑籒籓籙",5],["8fd3a1","籡籣籧籩籭籮籰籲籹籼籽粆粇粏粔粞粠粦粰粶粷粺粻粼粿糄糇糈糉糍糏糓糔糕糗糙糚糝糦糩糫糵紃紇紈紉紏紑紒紓紖紝紞紣紦紪紭紱紼紽紾絀絁絇絈絍絑絓絗絙絚絜絝絥絧絪絰絸絺絻絿綁綂綃綅綆綈綋綌綍綑綖綗綝"],["8fd4a1","綞綦綧綪綳綶綷綹緂",4,"緌緍緎緗緙縀緢緥緦緪緫緭緱緵緶緹緺縈縐縑縕縗縜縝縠縧縨縬縭縯縳縶縿繄繅繇繎繐繒繘繟繡繢繥繫繮繯繳繸繾纁纆纇纊纍纑纕纘纚纝纞缼缻缽缾缿罃罄罇罏罒罓罛罜罝罡罣罤罥罦罭"],["8fd5a1","罱罽罾罿羀羋羍羏羐羑羖羗羜羡羢羦羪羭羴羼羿翀翃翈翎翏翛翟翣翥翨翬翮翯翲翺翽翾翿耇耈耊耍耎耏耑耓耔耖耝耞耟耠耤耦耬耮耰耴耵耷耹耺耼耾聀聄聠聤聦聭聱聵肁肈肎肜肞肦肧肫肸肹胈胍胏胒胔胕胗胘胠胭胮"],["8fd6a1","胰胲胳胶胹胺胾脃脋脖脗脘脜脞脠脤脧脬脰脵脺脼腅腇腊腌腒腗腠腡腧腨腩腭腯腷膁膐膄膅膆膋膎膖膘膛膞膢膮膲膴膻臋臃臅臊臎臏臕臗臛臝臞臡臤臫臬臰臱臲臵臶臸臹臽臿舀舃舏舓舔舙舚舝舡舢舨舲舴舺艃艄艅艆"],["8fd7a1","艋艎艏艑艖艜艠艣艧艭艴艻艽艿芀芁芃芄芇芉芊芎芑芔芖芘芚芛芠芡芣芤芧芨芩芪芮芰芲芴芷芺芼芾芿苆苐苕苚苠苢苤苨苪苭苯苶苷苽苾茀茁茇茈茊茋荔茛茝茞茟茡茢茬茭茮茰茳茷茺茼茽荂荃荄荇荍荎荑荕荖荗荰荸"],["8fd8a1","荽荿莀莂莄莆莍莒莔莕莘莙莛莜莝莦莧莩莬莾莿菀菇菉菏菐菑菔菝荓菨菪菶菸菹菼萁萆萊萏萑萕萙莭萯萹葅葇葈葊葍葏葑葒葖葘葙葚葜葠葤葥葧葪葰葳葴葶葸葼葽蒁蒅蒒蒓蒕蒞蒦蒨蒩蒪蒯蒱蒴蒺蒽蒾蓀蓂蓇蓈蓌蓏蓓"],["8fd9a1","蓜蓧蓪蓯蓰蓱蓲蓷蔲蓺蓻蓽蔂蔃蔇蔌蔎蔐蔜蔞蔢蔣蔤蔥蔧蔪蔫蔯蔳蔴蔶蔿蕆蕏",4,"蕖蕙蕜",6,"蕤蕫蕯蕹蕺蕻蕽蕿薁薅薆薉薋薌薏薓薘薝薟薠薢薥薧薴薶薷薸薼薽薾薿藂藇藊藋藎薭藘藚藟藠藦藨藭藳藶藼"],["8fdaa1","藿蘀蘄蘅蘍蘎蘐蘑蘒蘘蘙蘛蘞蘡蘧蘩蘶蘸蘺蘼蘽虀虂虆虒虓虖虗虘虙虝虠",4,"虩虬虯虵虶虷虺蚍蚑蚖蚘蚚蚜蚡蚦蚧蚨蚭蚱蚳蚴蚵蚷蚸蚹蚿蛀蛁蛃蛅蛑蛒蛕蛗蛚蛜蛠蛣蛥蛧蚈蛺蛼蛽蜄蜅蜇蜋蜎蜏蜐蜓蜔蜙蜞蜟蜡蜣"],["8fdba1","蜨蜮蜯蜱蜲蜹蜺蜼蜽蜾蝀蝃蝅蝍蝘蝝蝡蝤蝥蝯蝱蝲蝻螃",6,"螋螌螐螓螕螗螘螙螞螠螣螧螬螭螮螱螵螾螿蟁蟈蟉蟊蟎蟕蟖蟙蟚蟜蟟蟢蟣蟤蟪蟫蟭蟱蟳蟸蟺蟿蠁蠃蠆蠉蠊蠋蠐蠙蠒蠓蠔蠘蠚蠛蠜蠞蠟蠨蠭蠮蠰蠲蠵"],["8fdca1","蠺蠼衁衃衅衈衉衊衋衎衑衕衖衘衚衜衟衠衤衩衱衹衻袀袘袚袛袜袟袠袨袪袺袽袾裀裊",4,"裑裒裓裛裞裧裯裰裱裵裷褁褆褍褎褏褕褖褘褙褚褜褠褦褧褨褰褱褲褵褹褺褾襀襂襅襆襉襏襒襗襚襛襜襡襢襣襫襮襰襳襵襺"],["8fdda1","襻襼襽覉覍覐覔覕覛覜覟覠覥覰覴覵覶覷覼觔",4,"觥觩觫觭觱觳觶觹觽觿訄訅訇訏訑訒訔訕訞訠訢訤訦訫訬訯訵訷訽訾詀詃詅詇詉詍詎詓詖詗詘詜詝詡詥詧詵詶詷詹詺詻詾詿誀誃誆誋誏誐誒誖誗誙誟誧誩誮誯誳"],["8fdea1","誶誷誻誾諃諆諈諉諊諑諓諔諕諗諝諟諬諰諴諵諶諼諿謅謆謋謑謜謞謟謊謭謰謷謼譂",4,"譈譒譓譔譙譍譞譣譭譶譸譹譼譾讁讄讅讋讍讏讔讕讜讞讟谸谹谽谾豅豇豉豋豏豑豓豔豗豘豛豝豙豣豤豦豨豩豭豳豵豶豻豾貆"],["8fdfa1","貇貋貐貒貓貙貛貜貤貹貺賅賆賉賋賏賖賕賙賝賡賨賬賯賰賲賵賷賸賾賿贁贃贉贒贗贛赥赩赬赮赿趂趄趈趍趐趑趕趞趟趠趦趫趬趯趲趵趷趹趻跀跅跆跇跈跊跎跑跔跕跗跙跤跥跧跬跰趼跱跲跴跽踁踄踅踆踋踑踔踖踠踡踢"],["8fe0a1","踣踦踧踱踳踶踷踸踹踽蹀蹁蹋蹍蹎蹏蹔蹛蹜蹝蹞蹡蹢蹩蹬蹭蹯蹰蹱蹹蹺蹻躂躃躉躐躒躕躚躛躝躞躢躧躩躭躮躳躵躺躻軀軁軃軄軇軏軑軔軜軨軮軰軱軷軹軺軭輀輂輇輈輏輐輖輗輘輞輠輡輣輥輧輨輬輭輮輴輵輶輷輺轀轁"],["8fe1a1","轃轇轏轑",4,"轘轝轞轥辝辠辡辤辥辦辵辶辸达迀迁迆迊迋迍运迒迓迕迠迣迤迨迮迱迵迶迻迾适逄逈逌逘逛逨逩逯逪逬逭逳逴逷逿遃遄遌遛遝遢遦遧遬遰遴遹邅邈邋邌邎邐邕邗邘邙邛邠邡邢邥邰邲邳邴邶邽郌邾郃"],["8fe2a1","郄郅郇郈郕郗郘郙郜郝郟郥郒郶郫郯郰郴郾郿鄀鄄鄅鄆鄈鄍鄐鄔鄖鄗鄘鄚鄜鄞鄠鄥鄢鄣鄧鄩鄮鄯鄱鄴鄶鄷鄹鄺鄼鄽酃酇酈酏酓酗酙酚酛酡酤酧酭酴酹酺酻醁醃醅醆醊醎醑醓醔醕醘醞醡醦醨醬醭醮醰醱醲醳醶醻醼醽醿"],["8fe3a1","釂釃釅釓釔釗釙釚釞釤釥釩釪釬",5,"釷釹釻釽鈀鈁鈄鈅鈆鈇鈉鈊鈌鈐鈒鈓鈖鈘鈜鈝鈣鈤鈥鈦鈨鈮鈯鈰鈳鈵鈶鈸鈹鈺鈼鈾鉀鉂鉃鉆鉇鉊鉍鉎鉏鉑鉘鉙鉜鉝鉠鉡鉥鉧鉨鉩鉮鉯鉰鉵",4,"鉻鉼鉽鉿銈銉銊銍銎銒銗"],["8fe4a1","銙銟銠銤銥銧銨銫銯銲銶銸銺銻銼銽銿",4,"鋅鋆鋇鋈鋋鋌鋍鋎鋐鋓鋕鋗鋘鋙鋜鋝鋟鋠鋡鋣鋥鋧鋨鋬鋮鋰鋹鋻鋿錀錂錈錍錑錔錕錜錝錞錟錡錤錥錧錩錪錳錴錶錷鍇鍈鍉鍐鍑鍒鍕鍗鍘鍚鍞鍤鍥鍧鍩鍪鍭鍯鍰鍱鍳鍴鍶"],["8fe5a1","鍺鍽鍿鎀鎁鎂鎈鎊鎋鎍鎏鎒鎕鎘鎛鎞鎡鎣鎤鎦鎨鎫鎴鎵鎶鎺鎩鏁鏄鏅鏆鏇鏉",4,"鏓鏙鏜鏞鏟鏢鏦鏧鏹鏷鏸鏺鏻鏽鐁鐂鐄鐈鐉鐍鐎鐏鐕鐖鐗鐟鐮鐯鐱鐲鐳鐴鐻鐿鐽鑃鑅鑈鑊鑌鑕鑙鑜鑟鑡鑣鑨鑫鑭鑮鑯鑱鑲钄钃镸镹"],["8fe6a1","镾閄閈閌閍閎閝閞閟閡閦閩閫閬閴閶閺閽閿闆闈闉闋闐闑闒闓闙闚闝闞闟闠闤闦阝阞阢阤阥阦阬阱阳阷阸阹阺阼阽陁陒陔陖陗陘陡陮陴陻陼陾陿隁隂隃隄隉隑隖隚隝隟隤隥隦隩隮隯隳隺雊雒嶲雘雚雝雞雟雩雯雱雺霂"],["8fe7a1","霃霅霉霚霛霝霡霢霣霨霱霳靁靃靊靎靏靕靗靘靚靛靣靧靪靮靳靶靷靸靻靽靿鞀鞉鞕鞖鞗鞙鞚鞞鞟鞢鞬鞮鞱鞲鞵鞶鞸鞹鞺鞼鞾鞿韁韄韅韇韉韊韌韍韎韐韑韔韗韘韙韝韞韠韛韡韤韯韱韴韷韸韺頇頊頙頍頎頔頖頜頞頠頣頦"],["8fe8a1","頫頮頯頰頲頳頵頥頾顄顇顊顑顒顓顖顗顙顚顢顣顥顦顪顬颫颭颮颰颴颷颸颺颻颿飂飅飈飌飡飣飥飦飧飪飳飶餂餇餈餑餕餖餗餚餛餜餟餢餦餧餫餱",4,"餹餺餻餼饀饁饆饇饈饍饎饔饘饙饛饜饞饟饠馛馝馟馦馰馱馲馵"],["8fe9a1","馹馺馽馿駃駉駓駔駙駚駜駞駧駪駫駬駰駴駵駹駽駾騂騃騄騋騌騐騑騖騞騠騢騣騤騧騭騮騳騵騶騸驇驁驄驊驋驌驎驑驔驖驝骪骬骮骯骲骴骵骶骹骻骾骿髁髃髆髈髎髐髒髕髖髗髛髜髠髤髥髧髩髬髲髳髵髹髺髽髿",4],["8feaa1","鬄鬅鬈鬉鬋鬌鬍鬎鬐鬒鬖鬙鬛鬜鬠鬦鬫鬭鬳鬴鬵鬷鬹鬺鬽魈魋魌魕魖魗魛魞魡魣魥魦魨魪",4,"魳魵魷魸魹魿鮀鮄鮅鮆鮇鮉鮊鮋鮍鮏鮐鮔鮚鮝鮞鮦鮧鮩鮬鮰鮱鮲鮷鮸鮻鮼鮾鮿鯁鯇鯈鯎鯐鯗鯘鯝鯟鯥鯧鯪鯫鯯鯳鯷鯸"],["8feba1","鯹鯺鯽鯿鰀鰂鰋鰏鰑鰖鰘鰙鰚鰜鰞鰢鰣鰦",4,"鰱鰵鰶鰷鰽鱁鱃鱄鱅鱉鱊鱎鱏鱐鱓鱔鱖鱘鱛鱝鱞鱟鱣鱩鱪鱜鱫鱨鱮鱰鱲鱵鱷鱻鳦鳲鳷鳹鴋鴂鴑鴗鴘鴜鴝鴞鴯鴰鴲鴳鴴鴺鴼鵅鴽鵂鵃鵇鵊鵓鵔鵟鵣鵢鵥鵩鵪鵫鵰鵶鵷鵻"],["8feca1","鵼鵾鶃鶄鶆鶊鶍鶎鶒鶓鶕鶖鶗鶘鶡鶪鶬鶮鶱鶵鶹鶼鶿鷃鷇鷉鷊鷔鷕鷖鷗鷚鷞鷟鷠鷥鷧鷩鷫鷮鷰鷳鷴鷾鸊鸂鸇鸎鸐鸑鸒鸕鸖鸙鸜鸝鹺鹻鹼麀麂麃麄麅麇麎麏麖麘麛麞麤麨麬麮麯麰麳麴麵黆黈黋黕黟黤黧黬黭黮黰黱黲黵"],["8feda1","黸黿鼂鼃鼉鼏鼐鼑鼒鼔鼖鼗鼙鼚鼛鼟鼢鼦鼪鼫鼯鼱鼲鼴鼷鼹鼺鼼鼽鼿齁齃",4,"齓齕齖齗齘齚齝齞齨齩齭",4,"齳齵齺齽龏龐龑龒龔龖龗龞龡龢龣龥"]]');
            }
          ),
          /***/
          99129: (
            /***/
            function(u) {
              u.exports = /* @__PURE__ */ JSON.parse('{"uChars":[128,165,169,178,184,216,226,235,238,244,248,251,253,258,276,284,300,325,329,334,364,463,465,467,469,471,473,475,477,506,594,610,712,716,730,930,938,962,970,1026,1104,1106,8209,8215,8218,8222,8231,8241,8244,8246,8252,8365,8452,8454,8458,8471,8482,8556,8570,8596,8602,8713,8720,8722,8726,8731,8737,8740,8742,8748,8751,8760,8766,8777,8781,8787,8802,8808,8816,8854,8858,8870,8896,8979,9322,9372,9548,9588,9616,9622,9634,9652,9662,9672,9676,9680,9702,9735,9738,9793,9795,11906,11909,11913,11917,11928,11944,11947,11951,11956,11960,11964,11979,12284,12292,12312,12319,12330,12351,12436,12447,12535,12543,12586,12842,12850,12964,13200,13215,13218,13253,13263,13267,13270,13384,13428,13727,13839,13851,14617,14703,14801,14816,14964,15183,15471,15585,16471,16736,17208,17325,17330,17374,17623,17997,18018,18212,18218,18301,18318,18760,18811,18814,18820,18823,18844,18848,18872,19576,19620,19738,19887,40870,59244,59336,59367,59413,59417,59423,59431,59437,59443,59452,59460,59478,59493,63789,63866,63894,63976,63986,64016,64018,64021,64025,64034,64037,64042,65074,65093,65107,65112,65127,65132,65375,65510,65536],"gbChars":[0,36,38,45,50,81,89,95,96,100,103,104,105,109,126,133,148,172,175,179,208,306,307,308,309,310,311,312,313,341,428,443,544,545,558,741,742,749,750,805,819,820,7922,7924,7925,7927,7934,7943,7944,7945,7950,8062,8148,8149,8152,8164,8174,8236,8240,8262,8264,8374,8380,8381,8384,8388,8390,8392,8393,8394,8396,8401,8406,8416,8419,8424,8437,8439,8445,8482,8485,8496,8521,8603,8936,8946,9046,9050,9063,9066,9076,9092,9100,9108,9111,9113,9131,9162,9164,9218,9219,11329,11331,11334,11336,11346,11361,11363,11366,11370,11372,11375,11389,11682,11686,11687,11692,11694,11714,11716,11723,11725,11730,11736,11982,11989,12102,12336,12348,12350,12384,12393,12395,12397,12510,12553,12851,12962,12973,13738,13823,13919,13933,14080,14298,14585,14698,15583,15847,16318,16434,16438,16481,16729,17102,17122,17315,17320,17402,17418,17859,17909,17911,17915,17916,17936,17939,17961,18664,18703,18814,18962,19043,33469,33470,33471,33484,33485,33490,33497,33501,33505,33513,33520,33536,33550,37845,37921,37948,38029,38038,38064,38065,38066,38069,38075,38076,38078,39108,39109,39113,39114,39115,39116,39265,39394,189000]}');
            }
          ),
          /***/
          55914: (
            /***/
            function(u) {
              u.exports = /* @__PURE__ */ JSON.parse('[["a140","",62],["a180","",32],["a240","",62],["a280","",32],["a2ab","",5],["a2e3","€"],["a2ef",""],["a2fd",""],["a340","",62],["a380","",31,"　"],["a440","",62],["a480","",32],["a4f4","",10],["a540","",62],["a580","",32],["a5f7","",7],["a640","",62],["a680","",32],["a6b9","",7],["a6d9","",6],["a6ec",""],["a6f3",""],["a6f6","",8],["a740","",62],["a780","",32],["a7c2","",14],["a7f2","",12],["a896","",10],["a8bc","ḿ"],["a8bf","ǹ"],["a8c1",""],["a8ea","",20],["a958",""],["a95b",""],["a95d",""],["a989","〾⿰",11],["a997","",12],["a9f0","",14],["aaa1","",93],["aba1","",93],["aca1","",93],["ada1","",93],["aea1","",93],["afa1","",93],["d7fa","",4],["f8a1","",93],["f9a1","",93],["faa1","",93],["fba1","",93],["fca1","",93],["fda1","",93],["fe50","⺁⺄㑳㑇⺈⺋㖞㘚㘎⺌⺗㥮㤘㧏㧟㩳㧐㭎㱮㳠⺧⺪䁖䅟⺮䌷⺳⺶⺷䎱䎬⺻䏝䓖䙡䙌"],["fe80","䜣䜩䝼䞍⻊䥇䥺䥽䦂䦃䦅䦆䦟䦛䦷䦶䲣䲟䲠䲡䱷䲢䴓",6,"䶮",93],["8135f437",""]]');
            }
          ),
          /***/
          40679: (
            /***/
            function(u) {
              u.exports = /* @__PURE__ */ JSON.parse('[["0","\\u0000",128],["a1","｡",62],["8140","　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈",9,"＋－±×"],["8180","÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓"],["81b8","∈∋⊆⊇⊂⊃∪∩"],["81c8","∧∨￢⇒⇔∀∃"],["81da","∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬"],["81f0","Å‰♯♭♪†‡¶"],["81fc","◯"],["824f","０",9],["8260","Ａ",25],["8281","ａ",25],["829f","ぁ",82],["8340","ァ",62],["8380","ム",22],["839f","Α",16,"Σ",6],["83bf","α",16,"σ",6],["8440","А",5,"ЁЖ",25],["8470","а",5,"ёж",7],["8480","о",17],["849f","─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂"],["8740","①",19,"Ⅰ",9],["875f","㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡"],["877e","㍻"],["8780","〝〟№㏍℡㊤",4,"㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪"],["889f","亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭"],["8940","院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円"],["8980","園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改"],["8a40","魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫"],["8a80","橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄"],["8b40","機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救"],["8b80","朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈"],["8c40","掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨"],["8c80","劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向"],["8d40","后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降"],["8d80","項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷"],["8e40","察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止"],["8e80","死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周"],["8f40","宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳"],["8f80","準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾"],["9040","拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨"],["9080","逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線"],["9140","繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻"],["9180","操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只"],["9240","叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄"],["9280","逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓"],["9340","邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬"],["9380","凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入"],["9440","如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅"],["9480","楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美"],["9540","鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷"],["9580","斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋"],["9640","法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆"],["9680","摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒"],["9740","諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲"],["9780","沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯"],["9840","蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕"],["989f","弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲"],["9940","僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭"],["9980","凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨"],["9a40","咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸"],["9a80","噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩"],["9b40","奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀"],["9b80","它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏"],["9c40","廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠"],["9c80","怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛"],["9d40","戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫"],["9d80","捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼"],["9e40","曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎"],["9e80","梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣"],["9f40","檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯"],["9f80","麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌"],["e040","漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝"],["e080","烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱"],["e140","瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿"],["e180","痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬"],["e240","磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰"],["e280","窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆"],["e340","紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷"],["e380","縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋"],["e440","隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤"],["e480","艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈"],["e540","蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬"],["e580","蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞"],["e640","襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧"],["e680","諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊"],["e740","蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜"],["e780","轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮"],["e840","錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙"],["e880","閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰"],["e940","顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃"],["e980","騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈"],["ea40","鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯"],["ea80","黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠堯槇遙瑤凜熙"],["ed40","纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏"],["ed80","塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱"],["ee40","犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙"],["ee80","蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑"],["eeef","ⅰ",9,"￢￤＇＂"],["f040","",62],["f080","",124],["f140","",62],["f180","",124],["f240","",62],["f280","",124],["f340","",62],["f380","",124],["f440","",62],["f480","",124],["f540","",62],["f580","",124],["f640","",62],["f680","",124],["f740","",62],["f780","",124],["f840","",62],["f880","",124],["f940",""],["fa40","ⅰ",9,"Ⅰ",9,"￢￤＇＂㈱№℡∵纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊"],["fa80","兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯"],["fb40","涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神"],["fb80","祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙"],["fc40","髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑"]]');
            }
          )
          /******/
        }, o = {};
        function c(u) {
          var l = o[u];
          if (l !== void 0)
            return l.exports;
          var e = o[u] = {
            /******/
            id: u,
            /******/
            loaded: !1,
            /******/
            exports: {}
            /******/
          };
          return r[u].call(e.exports, e, e.exports, c), e.loaded = !0, e.exports;
        }
        (function() {
          c.g = function() {
            if (typeof globalThis == "object")
              return globalThis;
            try {
              return this || new Function("return this")();
            } catch {
              if (typeof window == "object")
                return window;
            }
          }();
        })(), function() {
          c.nmd = function(u) {
            return u.paths = [], u.children || (u.children = []), u;
          };
        }();
        var d = c(36164);
        return d;
      }()
    );
  });
})(H2);
var FA = H2.exports;
function IA(a, t) {
  return new Promise((r, o) => {
    try {
      FA.createPdf(a, void 0, t).getDataUrl((d) => {
        r(d);
      });
    } catch (c) {
      o(c);
    }
  });
}
const RA = "aktivisda-library", DA = "1.2.0", MA = "module", BA = "dev@aktivisda.earth", kA = "aktivisda.earth", NA = {
  url: "https://framagit.org/aktivisda/aktivisda",
  type: "git",
  directory: "aktivisda-library"
}, LA = "dist/index.d.ts", UA = "./dist/aktivisda-library.js", zA = "./dist/aktivisda-library.js", GA = {
  ".": {
    types: "./dist/index.d.ts",
    browser: "./dist/aktivisda-library.js",
    import: "./dist/aktivisda-library.js",
    default: "./dist/aktivisda-library.js"
  },
  "./dist/index.d.ts": "./dist/index.d.ts",
  "./package.json": "./package.json"
}, VA = {
  dev: "vite",
  build: "tsc --p ./tsconfig-build.json && vite build && echo Last build:$(date)",
  preview: "vite preview",
  test: "vitest --mode headless",
  "test:ui": "vitest --ui --coverage --mode headless --coverage.enabled=true --coverage.reporter=html",
  "test:coverage": "vitest run --coverage --mode headless",
  "test:report": "vitest run --coverage --mode headless --reporter junit --outputFile=report.xml",
  "serve:assets": "cd tests/assets;http-server . -p 5050 --cors 'Access-Control-Allow-Origin *'",
  docs: "typedoc"
}, HA = {
  "@types/lodash.get": "^4.4.9",
  "@types/lodash.set": "^4.3.9",
  "@types/pako": "^2.0.1",
  "@types/pdfmake": "^0.2.7",
  "@types/qrcode": "^1.5.2",
  "@vitest/coverage-v8": "^1.2.2",
  canvas: "^2.11.2",
  jimp: "^0.22.10",
  jsdom: "^22.1.0",
  "looks-same": "^8.2.4",
  "pdf-img-convert": "^1.2.1",
  typedoc: "^0.25.4",
  "typedoc-plugin-markdown": "^3.17.1",
  typescript: "^5.0.2",
  vite: "^4.4.5",
  "vite-plugin-dts": "^3.6.0",
  vitest: "^1.2.2"
}, WA = {
  "@neslinesli93/mozjpeg-wasm": "^2.0.1",
  "@vitest/ui": "^1.5.0",
  ajv: "^8.12.0",
  "async-mutex": "^0.4.0",
  canvg: "^4.0.1",
  konva: "^9.2.3",
  "lodash.get": "^4.4.2",
  "lodash.set": "^4.3.2",
  "lz-string": "^1.5.0",
  pako: "^2.1.0",
  pdfmake: "^0.2.10",
  qrcode: "^1.5.3",
  uuid: "^9.0.1",
  uuidv4: "^6.2.13"
}, wv = {
  name: RA,
  version: DA,
  type: MA,
  email: BA,
  url: kA,
  repository: NA,
  types: LA,
  main: UA,
  module: zA,
  exports: GA,
  scripts: VA,
  devDependencies: HA,
  dependencies: WA
};
function _A(a) {
  return (t) => {
    const r = t.data;
    let o = t.width, c = t.height, d = o / a, u = c / a;
    for (let l = 0; l < d; ++l)
      for (let e = 0; e < u; ++e) {
        let s = l * a, i = s + a, f = e * a, h = f + a, v = 0, p = 0, m = 0, x = 0;
        for (let g = s; g < i; g += 1)
          if (!(g >= o))
            for (let S = f; S < h; S += 1) {
              if (S >= c)
                continue;
              let y = (o * S + g) * 4;
              r[y + 3] != 0 && (v += r[y + 0], m += r[y + 1], p += r[y + 2], x++);
            }
        v = v / x, m = m / x, p = p / x;
        for (let g = s; g < i; g += 1)
          if (!(g >= o))
            for (let S = f; S < h; S += 1) {
              if (S >= c)
                continue;
              let y = (o * S + g) * 4;
              r[y + 3] != 0 && (r[y + 0] = v, r[y + 1] = m, r[y + 2] = p);
            }
      }
  };
}
class jA extends Zl {
  constructor(r, o) {
    super(r, o);
    _e(this, "position");
    _e(this, "color");
    _e(this, "fillImage");
    _e(this, "konvaShape");
    _e(this, "_recomputePosition");
    _e(this, "_recomputeImage");
    _e(this, "_inPromise");
    _e(this, "draw");
    _e(this, "documentSize");
    _e(this, "shapeType");
    _e(this, "shapeOptions");
    _e(this, "fillType");
    _e(this, "fillOptions");
    // TODO
    _e(this, "photo");
    this.position = { x: 0, y: 0 }, this.color = "", this.documentSize = { width: 0, height: 0 }, this._recomputePosition = !1, this._recomputeImage = !1, this.draw = !1, this._inPromise = !1, this.shapeType = void 0, this.shapeOptions = {}, this.fillType = void 0, this.fillOptions = {};
  }
  static randomOptions() {
    console.error("BROKEN, todo: reactive me");
  }
  toJson() {
    return {
      id: this.id(),
      type: "shape",
      zIndex: this.zIndex(),
      position: this.position,
      shape: {
        type: this.shapeType,
        options: this.shapeOptions
      },
      fill: {
        type: this.fillType,
        options: this.fillOptions
      },
      i18n: this.options.i18n,
      rules: this.options.rules
    };
  }
  async toPdf() {
  }
  // TODO: use same code everywhere?
  select() {
    this.konvaElement && (this.konvaTransformer || (this.konvaTransformer = new xi.Transformer({
      resizeEnabled: !0,
      rotateEnabled: !0,
      enabledAnchors: ["top-left", "top-right", "bottom-left", "bottom-right"],
      boundBoxFunc: function(r, o) {
        return o.width = Math.max(1, o.width), o;
      },
      keepRatio: !0
    })), this.konvaTransformer.nodes([this.konvaElement]), this.vida.registerTransformer(this.konvaTransformer), this.konvaElement.setDraggable(!0), this.vida.draw());
  }
  unselect() {
    this.konvaTransformer && this.konvaTransformer.detach();
  }
  destroy() {
    this.konvaElement && this.konvaElement.destroy();
  }
  // TODO scale
  internalUpdate(r, o) {
    return console.assert(r.type === void 0 || r.type === "shape"), new Promise((c) => {
      var e, s, i, f;
      if (this._inPromise) {
        c();
        return;
      }
      if (this._inPromise = !0, this.konvaElement || (this.konvaElement = new xi.Group(), this.konvaElement.on("pointerclick", (h) => {
        h.cancelBubble = !0, !this.vida.isSelected(this.id()) && this.vida.selectComponent(this.id());
      }), this.konvaElement.on("dragend", (h) => {
        h.cancelBubble = !0, this.vida.stage.listening(!1), this.vida.layer.listening(!1), this.adjustPosition().then(() => {
          this.konvaElement.on("pointermove", () => {
          }), this.vida.stage.listening(!0), this.vida.layer.listening(!0);
        });
      }), this.konvaElement.on("transformend", (h) => {
        h.cancelBubble = !0, this.vida.stage.listening(!1), this.vida.layer.listening(!1), this.adjustSizeAndAngle().then(() => {
          this.vida.stage.listening(!0), this.vida.layer.listening(!0);
        }), h.cancelBubble = !0;
      }), this.konvaShape = new xi.Shape(), this.konvaElement.add(this.konvaShape), this.vida.registerComponent(this.konvaElement)), this.konvaElement.listening(!1), r.shape !== void 0 && r.shape.type !== void 0 && r.shape.type !== this.shapeType || r.shape !== void 0 && this.shapeType === "circle" && ((e = r.shape.options) == null ? void 0 : e.radius) !== this.shapeOptions.radius) {
        (s = r.shape) != null && s.type && (this.shapeType = r.shape.type), (f = (i = r.shape) == null ? void 0 : i.options) != null && f.radius && (this.shapeOptions.radius = r.shape.options.radius);
        let h = this.shapeOptions.radius;
        this.konvaShape.setAttrs({
          sceneFunc: (v, p) => {
            v.beginPath(), v.ellipse(
              p.getAttr("width") / 2,
              p.getAttr("height") / 2,
              p.getAttr("width") / 2,
              p.getAttr("height") / 2,
              Math.PI / 4,
              0,
              2 * Math.PI
            ), v.closePath();
          },
          width: 2 * h,
          height: 2 * h,
          x: -h,
          y: -h
        }), this.konvaElement.scale({ x: 1, y: 1 }), this.konvaShape.cache(), this._recomputeImage = !0;
      }
      const u = o && (o.width !== void 0 && this.documentSize.width !== o.width || o.height !== void 0 && this.documentSize.height !== o.height), l = this.position === void 0 || r.position !== void 0 && (r.position.x !== void 0 && this.position.x !== r.position.x || r.position.y !== void 0 && this.position.y !== r.position.y);
      if (this._recomputePosition || l || u) {
        this._recomputePosition = !1, o && o.width && (this.documentSize.width = o.width), o && o.height && (this.documentSize.height = o.height), r.position && (r.position.x && (this.position.x = r.position.x), r.position.y && (this.position.y = r.position.y));
        const { x: h, y: v } = Eo(this.position, this.documentSize);
        this.konvaElement.setAttrs({
          x: h,
          y: v
        }), this._recomputeImage = !0;
      }
      if (this.konvaTransformer !== void 0 && this.konvaTransformer.forceUpdate(), this.zIndex() !== this.konvaElement.zIndex() && (this.konvaElement.zIndex(this.zIndex()), this.draw = !0), r.fill !== void 0 && r.fill.type !== void 0 && r.fill.type !== this.fillType && (this.fillType = r.fill.type, this._recomputeImage = !0), r.fill !== void 0 && r.fill.options !== void 0 && r.fill.options.size !== this.fillOptions.size && (this.fillOptions.size = r.fill.options.size, this._recomputeImage = !0), this._recomputeImage) {
        console.assert(this.fillType === "blur"), this._recomputeImage = !1, this.recomputeImage().then(() => {
          this.internalUpdate(r, this.documentSize).then(() => c());
        });
        return;
      }
      this.vida.layer.listening(!0), this.konvaElement.listening(!0), this.draw ? (this.draw = !1, this._inPromise = !1, c(), this.vida.draw()) : (this._inPromise = !1, c());
    });
  }
  recomputeImage() {
    return new Promise((r) => {
      this.vida._exportingLayerMutex.acquire(), this.vida.layer.setAttrs({
        clipFunc: (e) => {
          e.beginPath(), e.ellipse(
            this.konvaElement.x(),
            this.konvaElement.y(),
            this.konvaShape.width() / 2,
            this.konvaShape.height() / 2,
            Math.PI / 4,
            0,
            2 * Math.PI
          ), e.closePath();
        }
      });
      const o = this.konvaElement.absolutePosition();
      let c = this.shapeOptions.radius, d = 2 * c * this.vida.stage.scale().x;
      const u = this.vida.stage.find(".blurred");
      u.map((e) => e.hide());
      const l = this.vida.stage.toDataURL({
        mimeType: "image/png",
        x: o.x - d / 2,
        y: o.y - d / 2,
        width: d,
        height: d
      });
      u.map((e) => e.show()), this.vida.layer.setAttrs({ clipFunc: void 0 }), this.vida._exportingLayerMutex.release(), this.fillImage !== void 0 && (this.fillImage.destroy(), this.fillImage = void 0), this.photo = document.createElement("img"), this.photo.onload = () => {
        this.fillImage = new xi.Image({
          name: "blurred",
          height: 2 * c,
          width: 2 * c,
          x: -c,
          y: -c,
          zIndex: 1e3,
          draggable: !1,
          image: this.photo
        }), this.konvaElement.add(this.fillImage), this.fillImage.cache();
        const e = Math.ceil(2 * c * this.fillOptions.size);
        this.fillImage.filters([_A(e)]), this.draw = !0, this._inPromise = !1, r();
      }, this.photo.src = l;
    });
  }
  adjustPosition() {
    return new Promise((r) => {
      if (!this.konvaElement) {
        r();
        return;
      }
      this.update(
        {
          position: Rl({ x: this.konvaElement.x(), y: this.konvaElement.y() }, this.documentSize)
        },
        this.documentSize
      ).then(() => r()), this.vida.onComponentUpdated(this.id());
    });
  }
  adjustSizeAndAngle() {
    return new Promise((r) => {
      if (!this.konvaElement) {
        r();
        return;
      }
      console.assert(Math.abs(this.konvaElement.scaleX() - this.konvaElement.scaleY()) < 1e-3), console.assert(this.shapeType === "circle"), this.update(
        {
          position: Rl({ x: this.konvaElement.x(), y: this.konvaElement.y() }, this.documentSize),
          shape: { options: { radius: this.shapeOptions.radius * this.konvaElement.scaleX() } }
        },
        this.vida.documentParams()
      ).then(() => r()), this.vida.onComponentUpdated(this.id());
    });
  }
}
const XA = new Error("request for lock canceled");
var YA = function(a, t, r, o) {
  function c(d) {
    return d instanceof r ? d : new r(function(u) {
      u(d);
    });
  }
  return new (r || (r = Promise))(function(d, u) {
    function l(i) {
      try {
        s(o.next(i));
      } catch (f) {
        u(f);
      }
    }
    function e(i) {
      try {
        s(o.throw(i));
      } catch (f) {
        u(f);
      }
    }
    function s(i) {
      i.done ? d(i.value) : c(i.value).then(l, e);
    }
    s((o = o.apply(a, t || [])).next());
  });
};
class ZA {
  constructor(t, r = XA) {
    this._value = t, this._cancelError = r, this._weightedQueues = [], this._weightedWaiters = [];
  }
  acquire(t = 1) {
    if (t <= 0)
      throw new Error(`invalid weight ${t}: must be positive`);
    return new Promise((r, o) => {
      this._weightedQueues[t - 1] || (this._weightedQueues[t - 1] = []), this._weightedQueues[t - 1].push({ resolve: r, reject: o }), this._dispatch();
    });
  }
  runExclusive(t, r = 1) {
    return YA(this, void 0, void 0, function* () {
      const [o, c] = yield this.acquire(r);
      try {
        return yield t(o);
      } finally {
        c();
      }
    });
  }
  waitForUnlock(t = 1) {
    if (t <= 0)
      throw new Error(`invalid weight ${t}: must be positive`);
    return new Promise((r) => {
      this._weightedWaiters[t - 1] || (this._weightedWaiters[t - 1] = []), this._weightedWaiters[t - 1].push(r), this._dispatch();
    });
  }
  isLocked() {
    return this._value <= 0;
  }
  getValue() {
    return this._value;
  }
  setValue(t) {
    this._value = t, this._dispatch();
  }
  release(t = 1) {
    if (t <= 0)
      throw new Error(`invalid weight ${t}: must be positive`);
    this._value += t, this._dispatch();
  }
  cancel() {
    this._weightedQueues.forEach((t) => t.forEach((r) => r.reject(this._cancelError))), this._weightedQueues = [];
  }
  _dispatch() {
    var t;
    for (let r = this._value; r > 0; r--) {
      const o = (t = this._weightedQueues[r - 1]) === null || t === void 0 ? void 0 : t.shift();
      if (!o)
        continue;
      const c = this._value, d = r;
      this._value -= r, r = this._value + 1, o.resolve([c, this._newReleaser(d)]);
    }
    this._drainUnlockWaiters();
  }
  _newReleaser(t) {
    let r = !1;
    return () => {
      r || (r = !0, this.release(t));
    };
  }
  _drainUnlockWaiters() {
    for (let t = this._value; t > 0; t--)
      this._weightedWaiters[t - 1] && (this._weightedWaiters[t - 1].forEach((r) => r()), this._weightedWaiters[t - 1] = []);
  }
}
var KA = function(a, t, r, o) {
  function c(d) {
    return d instanceof r ? d : new r(function(u) {
      u(d);
    });
  }
  return new (r || (r = Promise))(function(d, u) {
    function l(i) {
      try {
        s(o.next(i));
      } catch (f) {
        u(f);
      }
    }
    function e(i) {
      try {
        s(o.throw(i));
      } catch (f) {
        u(f);
      }
    }
    function s(i) {
      i.done ? d(i.value) : c(i.value).then(l, e);
    }
    s((o = o.apply(a, t || [])).next());
  });
};
class JA {
  constructor(t) {
    this._semaphore = new ZA(1, t);
  }
  acquire() {
    return KA(this, void 0, void 0, function* () {
      const [, t] = yield this._semaphore.acquire();
      return t;
    });
  }
  runExclusive(t) {
    return this._semaphore.runExclusive(() => t());
  }
  isLocked() {
    return this._semaphore.isLocked();
  }
  waitForUnlock() {
    return this._semaphore.waitForUnlock();
  }
  release() {
    this._semaphore.isLocked() && this._semaphore.release();
  }
  cancel() {
    return this._semaphore.cancel();
  }
}
function QA(a) {
  console.info("> migrate to 0.9.1");
  for (let t = 0; t < a.components.length; ++t)
    a.components[t].type === "text" && (a.components[t].background = {
      enabled: !1,
      color: "#ffffff",
      padding: 3
    });
  return a.version = "0.9.1", a;
}
function $A(a) {
  console.info("> migrate to 1.0.12");
  for (let t = 0; t < a.components.length; ++t)
    a.components[t].type === "svg" && (a.components[t].type = "image", a.components[t].image = a.components[t].symbol, a.components[t].image.type = "internalsvg", a.components[t].symbol = void 0);
  return a.version = "1.0.12", a;
}
function qA(a) {
  return console.info("> migrate to 1.0.14"), a.document.background.type = "internalsvg", a.version = "1.0.14", a;
}
function tC(a) {
  console.info("> migrate to 1.0.18");
  for (let t = 0; t < a.components.length; ++t)
    a.components[t].type === "text" && (a.components[t].background.distortion = [
      [-1, 1],
      [1, 1],
      [1, -1],
      [-1, -1]
    ], a.components[t].background.angleDistortion = 0);
  return a.version = "1.0.18", a;
}
function eC(a) {
  console.info("> migrate to 1.1.0"), a.document.i18n == null && (a.document.i18n = {
    defaultLocale: "fr",
    displayedLocale: "fr"
  });
  for (let t = 0; t < a.components.length; ++t)
    a.components[t].i18n = { fr: {} }, a.components[t].rules = {}, a.components[t].type === "text" && (a.components[t].background.enabled === !1 ? a.components[t].background.mode = "disabled" : a.components[t].background.angleDistortion ? a.components[t].background.mode = "distorted" : a.components[t].background.mode = "normal", a.components[t].background.radius = 0, delete a.components[t].background.enabled, a.components[t].shadow = {
      color: Pv(0.4, a.components[t].color),
      enabled: !1,
      offsetX: 0,
      offsetY: 0
    });
  return a.version = "1.1.0", a;
}
const Sv = {
  "0.9.1": QA,
  "1.0.12": $A,
  "1.0.14": qA,
  "1.0.18": tC,
  "1.1.0": eC
};
function W2(a) {
  const t = a.split(".");
  if (t.length != 3)
    throw new jn(`Invalid version ${a}. It should be like 1.0.0`);
  const r = t[0], o = t[1], c = t[2];
  if (isNaN(r) || isNaN(o) || isNaN(c))
    throw new jn(`Invalid version ${a}. It should be like 1.0.0`);
  return { major: parseInt(r), minor: parseInt(o), patch: parseInt(c) };
}
function rC(a) {
  if (a.version === void 0)
    throw new jn("Invalid template. It should contain a version field");
  return W2(a.version);
}
function nC(a) {
  let { major: t, minor: r, patch: o } = rC(a);
  for (const c in Sv) {
    const d = W2(c);
    t > d.major || t === d.major && (r > d.minor || r == d.minor && o >= d.patch) || (a = Sv[c](a), t = d.major, r = d.minor, o = d.patch);
  }
  return a;
}
class _2 {
  constructor(t) {
    _e(this, "document");
    _e(this, "components");
    _e(this, "background");
    _e(this, "documentSize");
    _e(this, "version");
    _e(this, "_selectedComponent");
    _e(this, "gallery");
    _e(this, "layer");
    _e(this, "stage");
    _e(this, "_exportingLayerMutex");
    const r = document.getElementById(t);
    if (r === null)
      throw new jn(`Please provid a valid HTML canvas. No element found with id: ${t}`);
    const { width: o, height: c } = this.stageDimension(r);
    this.layer = new xi.Layer({ draggable: !0 }), this._exportingLayerMutex = new JA(), this.stage = new xi.Stage({
      container: t,
      width: o,
      height: c
    });
    const d = this;
    this.layer.on("pointerclick", function() {
      const l = d.layer.getRelativePointerPosition();
      if (l == null)
        return;
      const { x: e, y: s } = Rl({ x: l.x, y: l.y }, d.documentSize);
      d.onClick(e, s);
    }), this.stage.add(this.layer), this.layer.draw();
    const u = mu();
    this.background = new PA(this, u), this.document = {
      width: void 0,
      height: void 0,
      id: u,
      i18n: {
        defaultLocale: "fr",
        displayedLocale: void 0,
        editingLocale: void 0
      }
    }, this.components = [], this._selectedComponent = void 0, this.version = wv.version, this.documentSize = { width: 1, height: 1 };
  }
  setGallery(t) {
    this.gallery = t;
  }
  stageDimension(t) {
    const r = t.parentElement;
    return r === null || r.nodeName === "BODY" || r.clientWidth === 0 || r.clientHeight === 0 ? { width: t.width, height: t.height } : {
      width: r.clientWidth,
      height: r.clientHeight
    };
  }
  selectedComponent() {
    return this._selectedComponent;
  }
  selectComponent(t) {
    this._selectedComponent && t === this._selectedComponent || (this._selectedComponent && this._selectedComponent !== this.document.id && this._findComponent(this._selectedComponent).unselect(), this._selectedComponent = t, this.onSelect(t), !(!t || t === this.document.id) && this._findComponent(t).select());
  }
  isSelected(t) {
    return this._selectedComponent && t === this._selectedComponent;
  }
  documentParams() {
    return this.document;
  }
  componentsKeys() {
    return this.components.map((t) => t.id());
  }
  componentExists(t) {
    return t === this.document.id ? !0 : this._findComponent(t) !== void 0;
  }
  componentParams(t) {
    return t === this.document.id ? this.documentParams() : this._findComponent(t).toJson();
  }
  componentAllowedActions(t) {
    return this._findComponent(t).allowedActions();
  }
  toJson() {
    const t = {
      version: this.version,
      document: this.document,
      components: this.components.map((r) => r.toJson())
    };
    return kh(t), t;
  }
  /**
   * Create a representation of the current vida that can be
   * used by pdfmake to create a pdf representation of the
   * vida.
   * Should be used through toPdfDataUrl in utils/pdf.ts
   *
   * @returns a pdf representation
   */
  async _toPdfDescription() {
    let t = "ok";
    const r = [], o = await this.background.toPdf();
    console.assert(o !== void 0), r.push({ zIndex: -1, content: o.content }), o.status === "unsupported_option" && (t = "unsupported_option");
    const c = await this.components.map(async (u) => {
      const l = await u.toPdf();
      if (l !== void 0)
        for (const e of l.content)
          r.push({ zIndex: u.zIndex(), content: e }), e.status === "unsupported_option" && (t = "unsupported_option");
    });
    return await Promise.all(c), r.sort((u, l) => u.zIndex - l.zIndex), {
      description: {
        compress: !1,
        pageSize: {
          width: oi(this.document.width),
          height: oi(this.document.height)
        },
        pageMargins: [0, 0, 0, 0],
        // sort components by zindex ??
        content: r.map((u) => u.content)
      },
      status: t
    };
  }
  /**
   * Export the vida image to a dataUrl pdf
   * using pdfmake.
   */
  toPdf(t) {
    return new Promise((r, o) => {
      this._toPdfDescription().then((c) => {
        c.status !== "ok" && o(), IA(c.description, t).then((d) => {
          r(d);
        }).catch((d) => o(d));
      });
    });
  }
  /**
   * Export the vida image to a dataUrl image in the given
   * MimeType (currently only support image/png and image/jpeg)
   *
   * Image is also compressed locally using JpegOptim or Oxipng.
   * Uncompressed image is returned in case of error.
   *
   * This is done internaly by creating a new Html5CanvasElement
   *
   */
  toImage(t) {
    return new Promise((r, o) => {
      let { width: c, height: d } = this.documentParams();
      const u = document.createElement("canvas");
      u.id = "temporary-canvas", u.width = c, u.height = d, document.body.appendChild(u);
      const l = new _2("temporary-canvas");
      this.gallery !== void 0 && l.setGallery(this.gallery), l.loadJson(this.toJson()).then(() => {
        const e = l.stage.toDataURL({ mimeType: t, quality: 1 });
        document.body.removeChild(u), u.remove(), l.destroy(), e3(e, t, 75).then((s) => {
          const i = s.resultData, f = new Blob([i], { type: t }), h = URL.createObjectURL(f);
          r(h);
        }).catch((s) => {
          console.error(`Compressed image failed: ${s}`), r(e);
        });
      }).catch((e) => o(e));
    });
  }
  toLink() {
    const t = {}, r = s3(this.toJson());
    if (r.length < 1e3)
      t.template = r;
    else {
      const o = g3.compressToBase64(r);
      t.b64Template = o;
    }
    return h3(t);
  }
  randomInit() {
    return this.version = wv.version, new Promise((t) => {
      this.background.randomInit("internalsvg", this.document).then(() => this.updateDocument({ width: 1950, height: 800 }).then(() => t()));
    });
  }
  /**
   * Initialize vida with all the data from template.
   * Reset everything.
   * @method
   * @name Vida.Vida#loadJson
   * @param {Template} template
   * @returns Promise<void>. Resolved once everything is setup
   * @example
   * const template = JSON.parse(...); // Load the template representation
   * const vida = new Vida(canvasId);
   * await vida.loadJson(); // or use vida.loadJson().then(() => ...);
   */
  loadJson(t) {
    this.components = [];
    const r = nC(t);
    return this.version = r.version, new Promise((o, c) => {
      const d = [];
      console.assert(r.document.width !== void 0 && r.document.height !== void 0), this.document.width = Math.max(1, r.document.width), this.document.height = Math.max(1, r.document.height), d.push(this.updateDocument(r.document)), r.components.sort((u, l) => u.zIndex > l.zIndex ? 1 : -1);
      for (const u of r.components)
        u.type === "shape" && u.fill.type === "blur" || d.push(this.setupComponent(u));
      Promise.all(d).then(() => {
        const u = [];
        for (const l of r.components)
          l.type !== "shape" || l.fill.type !== "blur" || u.push(this.setupComponent(l));
        Promise.all(u).then(() => {
          o();
        });
      }).catch((u) => {
        console.error(u), c(u);
      });
    });
  }
  zoom(t = null) {
    return t === null && (t = Math.min(this.layer.width() / this.document.width, this.layer.height() / this.document.height), t *= 0.95), this.stage.scale({ x: t, y: t }), this.layer.x((this.layer.width() / t - this.document.width) / 2), this.layer.y((this.layer.height() / t - this.document.height) / 2), this.draw(), t;
  }
  handleResize() {
    if (!this.stage)
      return;
    const r = this.stage.container().parentElement;
    if (r === null)
      return;
    const o = r.clientHeight, c = r.clientWidth;
    this.stage.setAttrs({ width: c, height: o }), this.zoom();
  }
  updateDocument(t) {
    return t.width !== void 0 && (t.width = Math.max(1, t.width)), t.height !== void 0 && (t.height = Math.max(1, t.height)), new Promise((r) => {
      Fn(this.document, t, void 0), t.i18n !== void 0 && t.i18n.editingLocale === null && (this.document.i18n.editingLocale = null), t.width && (this.documentSize.width = t.width), t.height && (this.documentSize.height = t.height);
      const o = [], c = {};
      if (Fn(c, t, void 0), o.push(
        new Promise((d) => {
          this.background.update(c, this.document).then(() => {
            d();
          });
        })
      ), t.width !== void 0 || t.height !== void 0 || t.i18n !== void 0 && (t.i18n.editingLocale !== void 0 || t.i18n.displayedLocale))
        for (const d of this.components)
          o.push(d.update({}, this.document));
      Promise.all(o).then(() => r());
    });
  }
  updateComponent(t, r) {
    const o = this._findComponent(t);
    if (o) {
      if (r.zIndex !== void 0) {
        let c = r.zIndex;
        c < o.zIndex() ? c -= 0.1 : c += 0.1, this.components = this.components.sort((d, u) => (d.id() == t ? c : d.zIndex()) > (u.id() == t ? c : u.zIndex()) ? 1 : -1), this.rearrangeZIndices(), delete r.zIndex;
      }
      return o.update(r, this.document);
    }
  }
  canUndo(t) {
    const r = this._findComponent(t);
    return r ? r.canUndo() : !1;
  }
  canRedo(t) {
    const r = this._findComponent(t);
    return r ? r.canRedo() : !1;
  }
  undoComponent(t) {
    const r = this._findComponent(t);
    if (r)
      return r.undo();
  }
  redoComponent(t) {
    const r = this._findComponent(t);
    if (r)
      return r.redo();
  }
  removeComponent(t) {
    const r = this._findComponent(t);
    if (!r)
      return;
    r.remove();
    const o = this.components.indexOf(r);
    this.components.splice(o, 1), t === this._selectedComponent && (this._selectedComponent = void 0);
  }
  createComponent(t) {
    return t.id === void 0 && (t.id = mu()), t.zIndex = this.components.length === 0 ? 1 : Math.max.apply(
      Math,
      this.components.map((r) => r.toJson().zIndex)
    ) + 1, this.setupComponent(t);
  }
  createRandomComponent(t) {
    return new Promise((r) => {
      let o, c = mu();
      switch (t) {
        case "text":
        case "textchoice":
        case "emoji": {
          o = new Hl(this, c, t), this.components.push(o);
          break;
        }
        case "qrcode":
        case "internalsvg":
        case "internalphoto": {
          o = new Mh(this, c), this.components.push(o);
          break;
        }
        default:
          throw Error("Not implemented");
      }
      o.randomInit(t, this.documentSize).then(() => {
        r(c);
      });
    });
  }
  setupComponent(t) {
    if (t.id === void 0)
      throw new Error("invalid component params (id required)");
    switch (t.type) {
      case "text":
      case "textchoice":
      case "emoji": {
        const r = new Hl(this, t.id, t.type);
        return this.components.push(r), r.update(t, this.document);
      }
      case "image": {
        const r = new Mh(this, t.id);
        return this.components.push(r), r.update(t, this.document);
      }
      case "shape": {
        const r = new jA(this, t.id);
        return this.components.push(r), r.update(t, this.document);
      }
      default:
        throw new jn("Unknown componentParams.type");
    }
  }
  nbComponents() {
    return this.components.length;
  }
  computeAvailableLocales() {
    return this.components.reduce(
      (t, r) => (Object.keys(r.toJson().i18n).map((o) => t.add(o)), t),
      /* @__PURE__ */ new Set([this.document.i18n.defaultLocale])
    );
  }
  registerComponent(t) {
    this.components.sort((r, o) => r.zIndex() > o.zIndex() ? 1 : -1), this.layer.add(t);
  }
  registerTransformer(t) {
    this.layer.add(t);
  }
  rearrangeZIndices() {
    this.background.sendBackward();
    let t = 1;
    for (const r of this.components)
      r.update({ zIndex: t }, {}), ++t;
    this.background.bringClipperForward();
  }
  draw() {
    this.layer.draw();
  }
  destroy() {
    this.background.destroy();
    for (let t of this.components)
      t.destroy();
    this.components = [];
  }
  onComponentUpdated(t) {
    console.assert(!1, "onComponentUpdated should be overriden");
  }
  onSelect(t) {
    console.assert(!1, "onSelect should be overriden by the calling code");
  }
  onClick(t, r) {
    console.assert(!1, "onClick should be overriden by the calling code");
  }
  _findComponent(t) {
    return this.components.find((r) => r.id() == t);
  }
}
export {
  U1 as QrcodeVidaSubComponent,
  _2 as Vida,
  dh as colorSvgString,
  e3 as compressImage,
  sC as computeCoverSize,
  CA as computeRandomDistortedSquare,
  d3 as extractBestTranslation,
  aC as extractColors,
  oC as extractDimensions,
  mu as generateId,
  s3 as jsonToURI,
  Pg as loadSvg,
  ns as overrideValues,
  Pv as pSBC,
  v1 as prepareColors,
  h3 as stringifyQuery,
  vh as svgToDom
};
